import { gql } from '@apollo/client';
import type * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client/react';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Any: { input: unknown; output: unknown };
  DateTime: { input: string; output: string };
  Highlights: { input: unknown; output: unknown };
  JSON: { input: Record<string, unknown>; output: Record<string, unknown> };
  Long: { input: number; output: number };
  URL: { input: string; output: string };
  UUID: { input: string; output: string };
  UnsignedByte: { input: number; output: number };
  citext: { input: string; output: string };
  date: { input: string; output: string };
  datetime: { input: string; output: string };
  datetime2: { input: string; output: string };
  float8: { input: number; output: number };
  interval: { input: string; output: string };
  jsonb: { input: string; output: string };
  smallint: { input: any; output: any };
  timestamp: { input: string; output: string };
  timestamptz: { input: string; output: string };
  uniqueidentifier: { input: string; output: string };
  uuid: { input: string; output: string };
  varbinary: { input: string; output: string };
};

export type AddBucketError = PlanIdRequiredError;

export type AddBucketInput = {
  input: BucketInput;
};

export type AddBucketPayload = {
  bucket?: Maybe<Bucket>;
  errors?: Maybe<Array<AddBucketError>>;
};

export type AddTaskError = PlanIdRequiredError;

export type AddTaskInput = {
  input: TaskInput;
};

export type AddTaskPayload = {
  errors?: Maybe<Array<AddTaskError>>;
  task?: Maybe<Task>;
};

export type AlterationResponse = {
  additionalData?: Maybe<Array<KeyValuePairOfNullableStringAndNullableObject>>;
  oDataType?: Maybe<Scalars['String']['output']>;
  originalQueryString?: Maybe<Scalars['String']['output']>;
  queryAlteration?: Maybe<SearchAlteration>;
  queryAlterationType?: Maybe<SearchAlterationType>;
};

export type AlteredQueryToken = {
  additionalData?: Maybe<Array<KeyValuePairOfNullableStringAndNullableObject>>;
  length?: Maybe<Scalars['Int']['output']>;
  oDataType?: Maybe<Scalars['String']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  suggestion?: Maybe<Scalars['String']['output']>;
};

export type Attachment = {
  additionalData?: Maybe<Array<KeyValuePairOfNullableStringAndNullableObject>>;
  contentType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isInline?: Maybe<Scalars['Boolean']['output']>;
  lastModifiedDateTime?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oDataType?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
};

export type AuthorizationResult = {
  allowedRoles?: Maybe<Array<Scalars['String']['output']>>;
  employeeId?: Maybe<Scalars['String']['output']>;
  groupIds?: Maybe<Array<Scalars['String']['output']>>;
  moduleId?: Maybe<Scalars['String']['output']>;
  moduleName: Scalars['String']['output'];
  mpId?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  userEntraId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type AutoRedeemPolicy = {
  adminConsentedForUsersIntoTenantIds: Array<Scalars['String']['output']>;
  noAADConsentForUsersFromTenantsIds: Array<Scalars['String']['output']>;
};

export type B2BManagementPolicy = {
  autoRedeemPolicy?: Maybe<AutoRedeemPolicy>;
  invitationsAllowedAndBlockedDomainsPolicy?: Maybe<InvitationsPolicy>;
  previewPolicy?: Maybe<PreviewPolicy>;
};

/** this is a table that will sync with [mlf].[mlv_GetAllPersonBDC] */
export type Bcs_Personnel = {
  ADSystemID: Scalars['citext']['output'];
  Aboutme?: Maybe<Scalars['String']['output']>;
  AssistantADSystemID?: Maybe<Scalars['String']['output']>;
  AssistantEmail?: Maybe<Scalars['String']['output']>;
  AssistantGroups?: Maybe<Scalars['String']['output']>;
  AssistantGroupsIn?: Maybe<Scalars['String']['output']>;
  AssistantImageUrlLarge?: Maybe<Scalars['String']['output']>;
  AssistantImageUrlMedium?: Maybe<Scalars['String']['output']>;
  AssistantImageUrlSmall?: Maybe<Scalars['String']['output']>;
  AssistantLawsonSystemID?: Maybe<Scalars['Int']['output']>;
  AssistantMorganNetPageUrlSpo?: Maybe<Scalars['String']['output']>;
  AssistantName?: Maybe<Scalars['String']['output']>;
  AssistantNameWithTerm?: Maybe<Scalars['String']['output']>;
  AssistantOfficeUrlSpo?: Maybe<Scalars['String']['output']>;
  AssistantPhone?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  AssistantTo: Array<Bcs_Personnel>;
  /** An aggregate relationship */
  AssistantTo_aggregate: Bcs_Personnel_Aggregate;
  BarAdmissions?: Maybe<Scalars['String']['output']>;
  BarAdmissionsDisplay?: Maybe<Scalars['String']['output']>;
  BioAlias?: Maybe<Scalars['String']['output']>;
  Biography?: Maybe<Scalars['String']['output']>;
  BoardMemberships?: Maybe<Scalars['String']['output']>;
  BusinessChemistryPrimary?: Maybe<Scalars['String']['output']>;
  BusinessChemistrySecondary?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeMailBoxNumber?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeMailGroup?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeMailGroupCode?: Maybe<Scalars['String']['output']>;
  CareerDisplay?: Maybe<Scalars['String']['output']>;
  CellPhone?: Maybe<Scalars['String']['output']>;
  Clerkships?: Maybe<Scalars['String']['output']>;
  ClientMgmt?: Maybe<Scalars['String']['output']>;
  Community?: Maybe<Scalars['String']['output']>;
  CourtAdmissions?: Maybe<Scalars['String']['output']>;
  DirectWorkPhone?: Maybe<Scalars['String']['output']>;
  DisplayName?: Maybe<Scalars['String']['output']>;
  DisplayTitle?: Maybe<Scalars['String']['output']>;
  EC1HomePhone?: Maybe<Scalars['String']['output']>;
  EC1Name?: Maybe<Scalars['String']['output']>;
  EC1WorkPhone?: Maybe<Scalars['String']['output']>;
  EC2HomePhone?: Maybe<Scalars['String']['output']>;
  EC2Name?: Maybe<Scalars['String']['output']>;
  EC2WorkPhone?: Maybe<Scalars['String']['output']>;
  EducationDisplay?: Maybe<Scalars['String']['output']>;
  EducationRefiner?: Maybe<Scalars['String']['output']>;
  EliteSystemID?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  FirstUpOfficeChannels: Array<Firstup_Channels>;
  FirstUpPracticeGroupChannels: Array<Firstup_Channels>;
  FullName?: Maybe<Scalars['String']['output']>;
  HideCellPhone?: Maybe<Scalars['Boolean']['output']>;
  HideEducationYear?: Maybe<Scalars['Boolean']['output']>;
  HideHomeAddress?: Maybe<Scalars['Boolean']['output']>;
  HideHomePhone?: Maybe<Scalars['Boolean']['output']>;
  HidePersonalInformation?: Maybe<Scalars['Int']['output']>;
  HideSpouse?: Maybe<Scalars['Boolean']['output']>;
  HomeAddress?: Maybe<Scalars['String']['output']>;
  HomePhone?: Maybe<Scalars['String']['output']>;
  ImageUrlLarge?: Maybe<Scalars['String']['output']>;
  ImageUrlMedium?: Maybe<Scalars['String']['output']>;
  ImageUrlSmall?: Maybe<Scalars['String']['output']>;
  JobCode?: Maybe<Scalars['String']['output']>;
  KeyClients?: Maybe<Scalars['String']['output']>;
  Languages?: Maybe<Scalars['String']['output']>;
  LanguagesDisplay?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  LawsonSystemID?: Maybe<Scalars['Int']['output']>;
  MSGraphUser?: Maybe<User>;
  Managers?: Maybe<Scalars['String']['output']>;
  MarsPersonID?: Maybe<Scalars['Int']['output']>;
  MarsSystemID?: Maybe<Scalars['String']['output']>;
  MiddleName?: Maybe<Scalars['String']['output']>;
  MorganNetPageUrlSpo?: Maybe<Scalars['String']['output']>;
  OfficeName?: Maybe<Scalars['String']['output']>;
  OfficeSystemID?: Maybe<Scalars['String']['output']>;
  OfficeUrlSpo?: Maybe<Scalars['String']['output']>;
  OtherWork?: Maybe<Scalars['String']['output']>;
  PeopleDisplayNamePreferred?: Maybe<Scalars['String']['output']>;
  PeopleLocation?: Maybe<Scalars['String']['output']>;
  PeopleOfficeAddress?: Maybe<Scalars['String']['output']>;
  PersonalPronouns?: Maybe<Scalars['String']['output']>;
  PhoneExtension?: Maybe<Scalars['String']['output']>;
  PracticeGrpCode?: Maybe<Scalars['String']['output']>;
  PracticeGrpName?: Maybe<Scalars['String']['output']>;
  PracticeGrpRollupCode?: Maybe<Scalars['String']['output']>;
  PracticeGrpRollupName?: Maybe<Scalars['String']['output']>;
  PracticeGrpRollupUrlSpo?: Maybe<Scalars['String']['output']>;
  PracticeGrpUrlSpo?: Maybe<Scalars['String']['output']>;
  Roles?: Maybe<Scalars['String']['output']>;
  RolesNameArea?: Maybe<Scalars['String']['output']>;
  SecondOfficeName?: Maybe<Scalars['String']['output']>;
  SecondOfficeUrlSpo?: Maybe<Scalars['String']['output']>;
  SecondaryPracticeGrpCode?: Maybe<Scalars['String']['output']>;
  SecondaryPracticeGrpRollupName?: Maybe<Scalars['String']['output']>;
  SecondaryPracticeGrpRollupUrlSpo?: Maybe<Scalars['String']['output']>;
  SecondaryPracticeGrpUrlSpo?: Maybe<Scalars['String']['output']>;
  SecretaryFor?: Maybe<Scalars['String']['output']>;
  Skills?: Maybe<Scalars['String']['output']>;
  SpecialtyAreas?: Maybe<Scalars['String']['output']>;
  Spouse?: Maybe<Scalars['String']['output']>;
  Staff?: Maybe<Scalars['String']['output']>;
  WorkEmail: Scalars['citext']['output'];
  WorkPhoneExtension?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** this is a table that will sync with [mlf].[mlv_GetAllPersonBDC] */
export type Bcs_PersonnelAssistantToArgs = {
  distinct_on?: InputMaybe<Array<Bcs_Personnel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bcs_Personnel_Order_By>>;
  where?: InputMaybe<Bcs_Personnel_Bool_Exp>;
};

/** this is a table that will sync with [mlf].[mlv_GetAllPersonBDC] */
export type Bcs_PersonnelAssistantTo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bcs_Personnel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bcs_Personnel_Order_By>>;
  where?: InputMaybe<Bcs_Personnel_Bool_Exp>;
};

/** this is a table that will sync with [mlf].[mlv_GetAllPersonBDC] */
export type Bcs_PersonnelFirstUpOfficeChannelsArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Channels_Order_By>>;
  where?: InputMaybe<Firstup_Channels_Bool_Exp>;
};

/** this is a table that will sync with [mlf].[mlv_GetAllPersonBDC] */
export type Bcs_PersonnelFirstUpPracticeGroupChannelsArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Channels_Order_By>>;
  where?: InputMaybe<Firstup_Channels_Bool_Exp>;
};

/** aggregated selection of "BCS.Personnel" */
export type Bcs_Personnel_Aggregate = {
  aggregate?: Maybe<Bcs_Personnel_Aggregate_Fields>;
  nodes: Array<Bcs_Personnel>;
};

export type Bcs_Personnel_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Bcs_Personnel_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Bcs_Personnel_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Bcs_Personnel_Aggregate_Bool_Exp_Count>;
};

export type Bcs_Personnel_Aggregate_Bool_Exp_Bool_And = {
  arguments: Bcs_Personnel_Select_Column_Bcs_Personnel_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Bcs_Personnel_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Bcs_Personnel_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Bcs_Personnel_Select_Column_Bcs_Personnel_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Bcs_Personnel_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Bcs_Personnel_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Bcs_Personnel_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Bcs_Personnel_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "BCS.Personnel" */
export type Bcs_Personnel_Aggregate_Fields = {
  avg?: Maybe<Bcs_Personnel_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Bcs_Personnel_Max_Fields>;
  min?: Maybe<Bcs_Personnel_Min_Fields>;
  stddev?: Maybe<Bcs_Personnel_Stddev_Fields>;
  stddev_pop?: Maybe<Bcs_Personnel_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bcs_Personnel_Stddev_Samp_Fields>;
  sum?: Maybe<Bcs_Personnel_Sum_Fields>;
  var_pop?: Maybe<Bcs_Personnel_Var_Pop_Fields>;
  var_samp?: Maybe<Bcs_Personnel_Var_Samp_Fields>;
  variance?: Maybe<Bcs_Personnel_Variance_Fields>;
};

/** aggregate fields of "BCS.Personnel" */
export type Bcs_Personnel_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bcs_Personnel_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "BCS.Personnel" */
export type Bcs_Personnel_Aggregate_Order_By = {
  avg?: InputMaybe<Bcs_Personnel_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Bcs_Personnel_Max_Order_By>;
  min?: InputMaybe<Bcs_Personnel_Min_Order_By>;
  stddev?: InputMaybe<Bcs_Personnel_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Bcs_Personnel_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Bcs_Personnel_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Bcs_Personnel_Sum_Order_By>;
  var_pop?: InputMaybe<Bcs_Personnel_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Bcs_Personnel_Var_Samp_Order_By>;
  variance?: InputMaybe<Bcs_Personnel_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Bcs_Personnel_Avg_Fields = {
  AssistantLawsonSystemID?: Maybe<Scalars['Float']['output']>;
  HidePersonalInformation?: Maybe<Scalars['Float']['output']>;
  LawsonSystemID?: Maybe<Scalars['Float']['output']>;
  MarsPersonID?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "BCS.Personnel" */
export type Bcs_Personnel_Avg_Order_By = {
  AssistantLawsonSystemID?: InputMaybe<Order_By>;
  HidePersonalInformation?: InputMaybe<Order_By>;
  LawsonSystemID?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "BCS.Personnel". All fields are combined with a logical 'AND'. */
export type Bcs_Personnel_Bool_Exp = {
  ADSystemID?: InputMaybe<Citext_Comparison_Exp>;
  Aboutme?: InputMaybe<String_Comparison_Exp>;
  AssistantADSystemID?: InputMaybe<String_Comparison_Exp>;
  AssistantEmail?: InputMaybe<String_Comparison_Exp>;
  AssistantGroups?: InputMaybe<String_Comparison_Exp>;
  AssistantGroupsIn?: InputMaybe<String_Comparison_Exp>;
  AssistantImageUrlLarge?: InputMaybe<String_Comparison_Exp>;
  AssistantImageUrlMedium?: InputMaybe<String_Comparison_Exp>;
  AssistantImageUrlSmall?: InputMaybe<String_Comparison_Exp>;
  AssistantLawsonSystemID?: InputMaybe<Int_Comparison_Exp>;
  AssistantMorganNetPageUrlSpo?: InputMaybe<String_Comparison_Exp>;
  AssistantName?: InputMaybe<String_Comparison_Exp>;
  AssistantNameWithTerm?: InputMaybe<String_Comparison_Exp>;
  AssistantOfficeUrlSpo?: InputMaybe<String_Comparison_Exp>;
  AssistantPhone?: InputMaybe<String_Comparison_Exp>;
  AssistantTo?: InputMaybe<Bcs_Personnel_Bool_Exp>;
  AssistantTo_aggregate?: InputMaybe<Bcs_Personnel_Aggregate_Bool_Exp>;
  BarAdmissions?: InputMaybe<String_Comparison_Exp>;
  BarAdmissionsDisplay?: InputMaybe<String_Comparison_Exp>;
  BioAlias?: InputMaybe<String_Comparison_Exp>;
  Biography?: InputMaybe<String_Comparison_Exp>;
  BoardMemberships?: InputMaybe<String_Comparison_Exp>;
  BusinessChemistryPrimary?: InputMaybe<String_Comparison_Exp>;
  BusinessChemistrySecondary?: InputMaybe<String_Comparison_Exp>;
  BusinessPrimaryOfficeMailBoxNumber?: InputMaybe<String_Comparison_Exp>;
  BusinessPrimaryOfficeMailGroup?: InputMaybe<String_Comparison_Exp>;
  BusinessPrimaryOfficeMailGroupCode?: InputMaybe<String_Comparison_Exp>;
  CareerDisplay?: InputMaybe<String_Comparison_Exp>;
  CellPhone?: InputMaybe<String_Comparison_Exp>;
  Clerkships?: InputMaybe<String_Comparison_Exp>;
  ClientMgmt?: InputMaybe<String_Comparison_Exp>;
  Community?: InputMaybe<String_Comparison_Exp>;
  CourtAdmissions?: InputMaybe<String_Comparison_Exp>;
  DirectWorkPhone?: InputMaybe<String_Comparison_Exp>;
  DisplayName?: InputMaybe<String_Comparison_Exp>;
  DisplayTitle?: InputMaybe<String_Comparison_Exp>;
  EC1HomePhone?: InputMaybe<String_Comparison_Exp>;
  EC1Name?: InputMaybe<String_Comparison_Exp>;
  EC1WorkPhone?: InputMaybe<String_Comparison_Exp>;
  EC2HomePhone?: InputMaybe<String_Comparison_Exp>;
  EC2Name?: InputMaybe<String_Comparison_Exp>;
  EC2WorkPhone?: InputMaybe<String_Comparison_Exp>;
  EducationDisplay?: InputMaybe<String_Comparison_Exp>;
  EducationRefiner?: InputMaybe<String_Comparison_Exp>;
  EliteSystemID?: InputMaybe<String_Comparison_Exp>;
  FirstName?: InputMaybe<String_Comparison_Exp>;
  FullName?: InputMaybe<String_Comparison_Exp>;
  HideCellPhone?: InputMaybe<Boolean_Comparison_Exp>;
  HideEducationYear?: InputMaybe<Boolean_Comparison_Exp>;
  HideHomeAddress?: InputMaybe<Boolean_Comparison_Exp>;
  HideHomePhone?: InputMaybe<Boolean_Comparison_Exp>;
  HidePersonalInformation?: InputMaybe<Int_Comparison_Exp>;
  HideSpouse?: InputMaybe<Boolean_Comparison_Exp>;
  HomeAddress?: InputMaybe<String_Comparison_Exp>;
  HomePhone?: InputMaybe<String_Comparison_Exp>;
  ImageUrlLarge?: InputMaybe<String_Comparison_Exp>;
  ImageUrlMedium?: InputMaybe<String_Comparison_Exp>;
  ImageUrlSmall?: InputMaybe<String_Comparison_Exp>;
  JobCode?: InputMaybe<String_Comparison_Exp>;
  KeyClients?: InputMaybe<String_Comparison_Exp>;
  Languages?: InputMaybe<String_Comparison_Exp>;
  LanguagesDisplay?: InputMaybe<String_Comparison_Exp>;
  LastName?: InputMaybe<String_Comparison_Exp>;
  LawsonSystemID?: InputMaybe<Int_Comparison_Exp>;
  Managers?: InputMaybe<String_Comparison_Exp>;
  MarsPersonID?: InputMaybe<Int_Comparison_Exp>;
  MarsSystemID?: InputMaybe<String_Comparison_Exp>;
  MiddleName?: InputMaybe<String_Comparison_Exp>;
  MorganNetPageUrlSpo?: InputMaybe<String_Comparison_Exp>;
  OfficeName?: InputMaybe<String_Comparison_Exp>;
  OfficeSystemID?: InputMaybe<String_Comparison_Exp>;
  OfficeUrlSpo?: InputMaybe<String_Comparison_Exp>;
  OtherWork?: InputMaybe<String_Comparison_Exp>;
  PeopleDisplayNamePreferred?: InputMaybe<String_Comparison_Exp>;
  PeopleLocation?: InputMaybe<String_Comparison_Exp>;
  PeopleOfficeAddress?: InputMaybe<String_Comparison_Exp>;
  PersonalPronouns?: InputMaybe<String_Comparison_Exp>;
  PhoneExtension?: InputMaybe<String_Comparison_Exp>;
  PracticeGrpCode?: InputMaybe<String_Comparison_Exp>;
  PracticeGrpName?: InputMaybe<String_Comparison_Exp>;
  PracticeGrpRollupCode?: InputMaybe<String_Comparison_Exp>;
  PracticeGrpRollupName?: InputMaybe<String_Comparison_Exp>;
  PracticeGrpRollupUrlSpo?: InputMaybe<String_Comparison_Exp>;
  PracticeGrpUrlSpo?: InputMaybe<String_Comparison_Exp>;
  Roles?: InputMaybe<String_Comparison_Exp>;
  RolesNameArea?: InputMaybe<String_Comparison_Exp>;
  SecondOfficeName?: InputMaybe<String_Comparison_Exp>;
  SecondOfficeUrlSpo?: InputMaybe<String_Comparison_Exp>;
  SecondaryPracticeGrpCode?: InputMaybe<String_Comparison_Exp>;
  SecondaryPracticeGrpRollupName?: InputMaybe<String_Comparison_Exp>;
  SecondaryPracticeGrpRollupUrlSpo?: InputMaybe<String_Comparison_Exp>;
  SecondaryPracticeGrpUrlSpo?: InputMaybe<String_Comparison_Exp>;
  SecretaryFor?: InputMaybe<String_Comparison_Exp>;
  Skills?: InputMaybe<String_Comparison_Exp>;
  SpecialtyAreas?: InputMaybe<String_Comparison_Exp>;
  Spouse?: InputMaybe<String_Comparison_Exp>;
  Staff?: InputMaybe<String_Comparison_Exp>;
  WorkEmail?: InputMaybe<Citext_Comparison_Exp>;
  WorkPhoneExtension?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Bcs_Personnel_Bool_Exp>>;
  _not?: InputMaybe<Bcs_Personnel_Bool_Exp>;
  _or?: InputMaybe<Array<Bcs_Personnel_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Bcs_Personnel_Max_Fields = {
  ADSystemID?: Maybe<Scalars['citext']['output']>;
  Aboutme?: Maybe<Scalars['String']['output']>;
  AssistantADSystemID?: Maybe<Scalars['String']['output']>;
  AssistantEmail?: Maybe<Scalars['String']['output']>;
  AssistantGroups?: Maybe<Scalars['String']['output']>;
  AssistantGroupsIn?: Maybe<Scalars['String']['output']>;
  AssistantImageUrlLarge?: Maybe<Scalars['String']['output']>;
  AssistantImageUrlMedium?: Maybe<Scalars['String']['output']>;
  AssistantImageUrlSmall?: Maybe<Scalars['String']['output']>;
  AssistantLawsonSystemID?: Maybe<Scalars['Int']['output']>;
  AssistantMorganNetPageUrlSpo?: Maybe<Scalars['String']['output']>;
  AssistantName?: Maybe<Scalars['String']['output']>;
  AssistantNameWithTerm?: Maybe<Scalars['String']['output']>;
  AssistantOfficeUrlSpo?: Maybe<Scalars['String']['output']>;
  AssistantPhone?: Maybe<Scalars['String']['output']>;
  BarAdmissions?: Maybe<Scalars['String']['output']>;
  BarAdmissionsDisplay?: Maybe<Scalars['String']['output']>;
  BioAlias?: Maybe<Scalars['String']['output']>;
  Biography?: Maybe<Scalars['String']['output']>;
  BoardMemberships?: Maybe<Scalars['String']['output']>;
  BusinessChemistryPrimary?: Maybe<Scalars['String']['output']>;
  BusinessChemistrySecondary?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeMailBoxNumber?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeMailGroup?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeMailGroupCode?: Maybe<Scalars['String']['output']>;
  CareerDisplay?: Maybe<Scalars['String']['output']>;
  CellPhone?: Maybe<Scalars['String']['output']>;
  Clerkships?: Maybe<Scalars['String']['output']>;
  ClientMgmt?: Maybe<Scalars['String']['output']>;
  Community?: Maybe<Scalars['String']['output']>;
  CourtAdmissions?: Maybe<Scalars['String']['output']>;
  DirectWorkPhone?: Maybe<Scalars['String']['output']>;
  DisplayName?: Maybe<Scalars['String']['output']>;
  DisplayTitle?: Maybe<Scalars['String']['output']>;
  EC1HomePhone?: Maybe<Scalars['String']['output']>;
  EC1Name?: Maybe<Scalars['String']['output']>;
  EC1WorkPhone?: Maybe<Scalars['String']['output']>;
  EC2HomePhone?: Maybe<Scalars['String']['output']>;
  EC2Name?: Maybe<Scalars['String']['output']>;
  EC2WorkPhone?: Maybe<Scalars['String']['output']>;
  EducationDisplay?: Maybe<Scalars['String']['output']>;
  EducationRefiner?: Maybe<Scalars['String']['output']>;
  EliteSystemID?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  FullName?: Maybe<Scalars['String']['output']>;
  HidePersonalInformation?: Maybe<Scalars['Int']['output']>;
  HomeAddress?: Maybe<Scalars['String']['output']>;
  HomePhone?: Maybe<Scalars['String']['output']>;
  ImageUrlLarge?: Maybe<Scalars['String']['output']>;
  ImageUrlMedium?: Maybe<Scalars['String']['output']>;
  ImageUrlSmall?: Maybe<Scalars['String']['output']>;
  JobCode?: Maybe<Scalars['String']['output']>;
  KeyClients?: Maybe<Scalars['String']['output']>;
  Languages?: Maybe<Scalars['String']['output']>;
  LanguagesDisplay?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  LawsonSystemID?: Maybe<Scalars['Int']['output']>;
  Managers?: Maybe<Scalars['String']['output']>;
  MarsPersonID?: Maybe<Scalars['Int']['output']>;
  MarsSystemID?: Maybe<Scalars['String']['output']>;
  MiddleName?: Maybe<Scalars['String']['output']>;
  MorganNetPageUrlSpo?: Maybe<Scalars['String']['output']>;
  OfficeName?: Maybe<Scalars['String']['output']>;
  OfficeSystemID?: Maybe<Scalars['String']['output']>;
  OfficeUrlSpo?: Maybe<Scalars['String']['output']>;
  OtherWork?: Maybe<Scalars['String']['output']>;
  PeopleDisplayNamePreferred?: Maybe<Scalars['String']['output']>;
  PeopleLocation?: Maybe<Scalars['String']['output']>;
  PeopleOfficeAddress?: Maybe<Scalars['String']['output']>;
  PersonalPronouns?: Maybe<Scalars['String']['output']>;
  PhoneExtension?: Maybe<Scalars['String']['output']>;
  PracticeGrpCode?: Maybe<Scalars['String']['output']>;
  PracticeGrpName?: Maybe<Scalars['String']['output']>;
  PracticeGrpRollupCode?: Maybe<Scalars['String']['output']>;
  PracticeGrpRollupName?: Maybe<Scalars['String']['output']>;
  PracticeGrpRollupUrlSpo?: Maybe<Scalars['String']['output']>;
  PracticeGrpUrlSpo?: Maybe<Scalars['String']['output']>;
  Roles?: Maybe<Scalars['String']['output']>;
  RolesNameArea?: Maybe<Scalars['String']['output']>;
  SecondOfficeName?: Maybe<Scalars['String']['output']>;
  SecondOfficeUrlSpo?: Maybe<Scalars['String']['output']>;
  SecondaryPracticeGrpCode?: Maybe<Scalars['String']['output']>;
  SecondaryPracticeGrpRollupName?: Maybe<Scalars['String']['output']>;
  SecondaryPracticeGrpRollupUrlSpo?: Maybe<Scalars['String']['output']>;
  SecondaryPracticeGrpUrlSpo?: Maybe<Scalars['String']['output']>;
  SecretaryFor?: Maybe<Scalars['String']['output']>;
  Skills?: Maybe<Scalars['String']['output']>;
  SpecialtyAreas?: Maybe<Scalars['String']['output']>;
  Spouse?: Maybe<Scalars['String']['output']>;
  Staff?: Maybe<Scalars['String']['output']>;
  WorkEmail?: Maybe<Scalars['citext']['output']>;
  WorkPhoneExtension?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "BCS.Personnel" */
export type Bcs_Personnel_Max_Order_By = {
  ADSystemID?: InputMaybe<Order_By>;
  Aboutme?: InputMaybe<Order_By>;
  AssistantADSystemID?: InputMaybe<Order_By>;
  AssistantEmail?: InputMaybe<Order_By>;
  AssistantGroups?: InputMaybe<Order_By>;
  AssistantGroupsIn?: InputMaybe<Order_By>;
  AssistantImageUrlLarge?: InputMaybe<Order_By>;
  AssistantImageUrlMedium?: InputMaybe<Order_By>;
  AssistantImageUrlSmall?: InputMaybe<Order_By>;
  AssistantLawsonSystemID?: InputMaybe<Order_By>;
  AssistantMorganNetPageUrlSpo?: InputMaybe<Order_By>;
  AssistantName?: InputMaybe<Order_By>;
  AssistantNameWithTerm?: InputMaybe<Order_By>;
  AssistantOfficeUrlSpo?: InputMaybe<Order_By>;
  AssistantPhone?: InputMaybe<Order_By>;
  BarAdmissions?: InputMaybe<Order_By>;
  BarAdmissionsDisplay?: InputMaybe<Order_By>;
  BioAlias?: InputMaybe<Order_By>;
  Biography?: InputMaybe<Order_By>;
  BoardMemberships?: InputMaybe<Order_By>;
  BusinessChemistryPrimary?: InputMaybe<Order_By>;
  BusinessChemistrySecondary?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeMailBoxNumber?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeMailGroup?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeMailGroupCode?: InputMaybe<Order_By>;
  CareerDisplay?: InputMaybe<Order_By>;
  CellPhone?: InputMaybe<Order_By>;
  Clerkships?: InputMaybe<Order_By>;
  ClientMgmt?: InputMaybe<Order_By>;
  Community?: InputMaybe<Order_By>;
  CourtAdmissions?: InputMaybe<Order_By>;
  DirectWorkPhone?: InputMaybe<Order_By>;
  DisplayName?: InputMaybe<Order_By>;
  DisplayTitle?: InputMaybe<Order_By>;
  EC1HomePhone?: InputMaybe<Order_By>;
  EC1Name?: InputMaybe<Order_By>;
  EC1WorkPhone?: InputMaybe<Order_By>;
  EC2HomePhone?: InputMaybe<Order_By>;
  EC2Name?: InputMaybe<Order_By>;
  EC2WorkPhone?: InputMaybe<Order_By>;
  EducationDisplay?: InputMaybe<Order_By>;
  EducationRefiner?: InputMaybe<Order_By>;
  EliteSystemID?: InputMaybe<Order_By>;
  FirstName?: InputMaybe<Order_By>;
  FullName?: InputMaybe<Order_By>;
  HidePersonalInformation?: InputMaybe<Order_By>;
  HomeAddress?: InputMaybe<Order_By>;
  HomePhone?: InputMaybe<Order_By>;
  ImageUrlLarge?: InputMaybe<Order_By>;
  ImageUrlMedium?: InputMaybe<Order_By>;
  ImageUrlSmall?: InputMaybe<Order_By>;
  JobCode?: InputMaybe<Order_By>;
  KeyClients?: InputMaybe<Order_By>;
  Languages?: InputMaybe<Order_By>;
  LanguagesDisplay?: InputMaybe<Order_By>;
  LastName?: InputMaybe<Order_By>;
  LawsonSystemID?: InputMaybe<Order_By>;
  Managers?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
  MarsSystemID?: InputMaybe<Order_By>;
  MiddleName?: InputMaybe<Order_By>;
  MorganNetPageUrlSpo?: InputMaybe<Order_By>;
  OfficeName?: InputMaybe<Order_By>;
  OfficeSystemID?: InputMaybe<Order_By>;
  OfficeUrlSpo?: InputMaybe<Order_By>;
  OtherWork?: InputMaybe<Order_By>;
  PeopleDisplayNamePreferred?: InputMaybe<Order_By>;
  PeopleLocation?: InputMaybe<Order_By>;
  PeopleOfficeAddress?: InputMaybe<Order_By>;
  PersonalPronouns?: InputMaybe<Order_By>;
  PhoneExtension?: InputMaybe<Order_By>;
  PracticeGrpCode?: InputMaybe<Order_By>;
  PracticeGrpName?: InputMaybe<Order_By>;
  PracticeGrpRollupCode?: InputMaybe<Order_By>;
  PracticeGrpRollupName?: InputMaybe<Order_By>;
  PracticeGrpRollupUrlSpo?: InputMaybe<Order_By>;
  PracticeGrpUrlSpo?: InputMaybe<Order_By>;
  Roles?: InputMaybe<Order_By>;
  RolesNameArea?: InputMaybe<Order_By>;
  SecondOfficeName?: InputMaybe<Order_By>;
  SecondOfficeUrlSpo?: InputMaybe<Order_By>;
  SecondaryPracticeGrpCode?: InputMaybe<Order_By>;
  SecondaryPracticeGrpRollupName?: InputMaybe<Order_By>;
  SecondaryPracticeGrpRollupUrlSpo?: InputMaybe<Order_By>;
  SecondaryPracticeGrpUrlSpo?: InputMaybe<Order_By>;
  SecretaryFor?: InputMaybe<Order_By>;
  Skills?: InputMaybe<Order_By>;
  SpecialtyAreas?: InputMaybe<Order_By>;
  Spouse?: InputMaybe<Order_By>;
  Staff?: InputMaybe<Order_By>;
  WorkEmail?: InputMaybe<Order_By>;
  WorkPhoneExtension?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Bcs_Personnel_Min_Fields = {
  ADSystemID?: Maybe<Scalars['citext']['output']>;
  Aboutme?: Maybe<Scalars['String']['output']>;
  AssistantADSystemID?: Maybe<Scalars['String']['output']>;
  AssistantEmail?: Maybe<Scalars['String']['output']>;
  AssistantGroups?: Maybe<Scalars['String']['output']>;
  AssistantGroupsIn?: Maybe<Scalars['String']['output']>;
  AssistantImageUrlLarge?: Maybe<Scalars['String']['output']>;
  AssistantImageUrlMedium?: Maybe<Scalars['String']['output']>;
  AssistantImageUrlSmall?: Maybe<Scalars['String']['output']>;
  AssistantLawsonSystemID?: Maybe<Scalars['Int']['output']>;
  AssistantMorganNetPageUrlSpo?: Maybe<Scalars['String']['output']>;
  AssistantName?: Maybe<Scalars['String']['output']>;
  AssistantNameWithTerm?: Maybe<Scalars['String']['output']>;
  AssistantOfficeUrlSpo?: Maybe<Scalars['String']['output']>;
  AssistantPhone?: Maybe<Scalars['String']['output']>;
  BarAdmissions?: Maybe<Scalars['String']['output']>;
  BarAdmissionsDisplay?: Maybe<Scalars['String']['output']>;
  BioAlias?: Maybe<Scalars['String']['output']>;
  Biography?: Maybe<Scalars['String']['output']>;
  BoardMemberships?: Maybe<Scalars['String']['output']>;
  BusinessChemistryPrimary?: Maybe<Scalars['String']['output']>;
  BusinessChemistrySecondary?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeMailBoxNumber?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeMailGroup?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeMailGroupCode?: Maybe<Scalars['String']['output']>;
  CareerDisplay?: Maybe<Scalars['String']['output']>;
  CellPhone?: Maybe<Scalars['String']['output']>;
  Clerkships?: Maybe<Scalars['String']['output']>;
  ClientMgmt?: Maybe<Scalars['String']['output']>;
  Community?: Maybe<Scalars['String']['output']>;
  CourtAdmissions?: Maybe<Scalars['String']['output']>;
  DirectWorkPhone?: Maybe<Scalars['String']['output']>;
  DisplayName?: Maybe<Scalars['String']['output']>;
  DisplayTitle?: Maybe<Scalars['String']['output']>;
  EC1HomePhone?: Maybe<Scalars['String']['output']>;
  EC1Name?: Maybe<Scalars['String']['output']>;
  EC1WorkPhone?: Maybe<Scalars['String']['output']>;
  EC2HomePhone?: Maybe<Scalars['String']['output']>;
  EC2Name?: Maybe<Scalars['String']['output']>;
  EC2WorkPhone?: Maybe<Scalars['String']['output']>;
  EducationDisplay?: Maybe<Scalars['String']['output']>;
  EducationRefiner?: Maybe<Scalars['String']['output']>;
  EliteSystemID?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  FullName?: Maybe<Scalars['String']['output']>;
  HidePersonalInformation?: Maybe<Scalars['Int']['output']>;
  HomeAddress?: Maybe<Scalars['String']['output']>;
  HomePhone?: Maybe<Scalars['String']['output']>;
  ImageUrlLarge?: Maybe<Scalars['String']['output']>;
  ImageUrlMedium?: Maybe<Scalars['String']['output']>;
  ImageUrlSmall?: Maybe<Scalars['String']['output']>;
  JobCode?: Maybe<Scalars['String']['output']>;
  KeyClients?: Maybe<Scalars['String']['output']>;
  Languages?: Maybe<Scalars['String']['output']>;
  LanguagesDisplay?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  LawsonSystemID?: Maybe<Scalars['Int']['output']>;
  Managers?: Maybe<Scalars['String']['output']>;
  MarsPersonID?: Maybe<Scalars['Int']['output']>;
  MarsSystemID?: Maybe<Scalars['String']['output']>;
  MiddleName?: Maybe<Scalars['String']['output']>;
  MorganNetPageUrlSpo?: Maybe<Scalars['String']['output']>;
  OfficeName?: Maybe<Scalars['String']['output']>;
  OfficeSystemID?: Maybe<Scalars['String']['output']>;
  OfficeUrlSpo?: Maybe<Scalars['String']['output']>;
  OtherWork?: Maybe<Scalars['String']['output']>;
  PeopleDisplayNamePreferred?: Maybe<Scalars['String']['output']>;
  PeopleLocation?: Maybe<Scalars['String']['output']>;
  PeopleOfficeAddress?: Maybe<Scalars['String']['output']>;
  PersonalPronouns?: Maybe<Scalars['String']['output']>;
  PhoneExtension?: Maybe<Scalars['String']['output']>;
  PracticeGrpCode?: Maybe<Scalars['String']['output']>;
  PracticeGrpName?: Maybe<Scalars['String']['output']>;
  PracticeGrpRollupCode?: Maybe<Scalars['String']['output']>;
  PracticeGrpRollupName?: Maybe<Scalars['String']['output']>;
  PracticeGrpRollupUrlSpo?: Maybe<Scalars['String']['output']>;
  PracticeGrpUrlSpo?: Maybe<Scalars['String']['output']>;
  Roles?: Maybe<Scalars['String']['output']>;
  RolesNameArea?: Maybe<Scalars['String']['output']>;
  SecondOfficeName?: Maybe<Scalars['String']['output']>;
  SecondOfficeUrlSpo?: Maybe<Scalars['String']['output']>;
  SecondaryPracticeGrpCode?: Maybe<Scalars['String']['output']>;
  SecondaryPracticeGrpRollupName?: Maybe<Scalars['String']['output']>;
  SecondaryPracticeGrpRollupUrlSpo?: Maybe<Scalars['String']['output']>;
  SecondaryPracticeGrpUrlSpo?: Maybe<Scalars['String']['output']>;
  SecretaryFor?: Maybe<Scalars['String']['output']>;
  Skills?: Maybe<Scalars['String']['output']>;
  SpecialtyAreas?: Maybe<Scalars['String']['output']>;
  Spouse?: Maybe<Scalars['String']['output']>;
  Staff?: Maybe<Scalars['String']['output']>;
  WorkEmail?: Maybe<Scalars['citext']['output']>;
  WorkPhoneExtension?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "BCS.Personnel" */
export type Bcs_Personnel_Min_Order_By = {
  ADSystemID?: InputMaybe<Order_By>;
  Aboutme?: InputMaybe<Order_By>;
  AssistantADSystemID?: InputMaybe<Order_By>;
  AssistantEmail?: InputMaybe<Order_By>;
  AssistantGroups?: InputMaybe<Order_By>;
  AssistantGroupsIn?: InputMaybe<Order_By>;
  AssistantImageUrlLarge?: InputMaybe<Order_By>;
  AssistantImageUrlMedium?: InputMaybe<Order_By>;
  AssistantImageUrlSmall?: InputMaybe<Order_By>;
  AssistantLawsonSystemID?: InputMaybe<Order_By>;
  AssistantMorganNetPageUrlSpo?: InputMaybe<Order_By>;
  AssistantName?: InputMaybe<Order_By>;
  AssistantNameWithTerm?: InputMaybe<Order_By>;
  AssistantOfficeUrlSpo?: InputMaybe<Order_By>;
  AssistantPhone?: InputMaybe<Order_By>;
  BarAdmissions?: InputMaybe<Order_By>;
  BarAdmissionsDisplay?: InputMaybe<Order_By>;
  BioAlias?: InputMaybe<Order_By>;
  Biography?: InputMaybe<Order_By>;
  BoardMemberships?: InputMaybe<Order_By>;
  BusinessChemistryPrimary?: InputMaybe<Order_By>;
  BusinessChemistrySecondary?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeMailBoxNumber?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeMailGroup?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeMailGroupCode?: InputMaybe<Order_By>;
  CareerDisplay?: InputMaybe<Order_By>;
  CellPhone?: InputMaybe<Order_By>;
  Clerkships?: InputMaybe<Order_By>;
  ClientMgmt?: InputMaybe<Order_By>;
  Community?: InputMaybe<Order_By>;
  CourtAdmissions?: InputMaybe<Order_By>;
  DirectWorkPhone?: InputMaybe<Order_By>;
  DisplayName?: InputMaybe<Order_By>;
  DisplayTitle?: InputMaybe<Order_By>;
  EC1HomePhone?: InputMaybe<Order_By>;
  EC1Name?: InputMaybe<Order_By>;
  EC1WorkPhone?: InputMaybe<Order_By>;
  EC2HomePhone?: InputMaybe<Order_By>;
  EC2Name?: InputMaybe<Order_By>;
  EC2WorkPhone?: InputMaybe<Order_By>;
  EducationDisplay?: InputMaybe<Order_By>;
  EducationRefiner?: InputMaybe<Order_By>;
  EliteSystemID?: InputMaybe<Order_By>;
  FirstName?: InputMaybe<Order_By>;
  FullName?: InputMaybe<Order_By>;
  HidePersonalInformation?: InputMaybe<Order_By>;
  HomeAddress?: InputMaybe<Order_By>;
  HomePhone?: InputMaybe<Order_By>;
  ImageUrlLarge?: InputMaybe<Order_By>;
  ImageUrlMedium?: InputMaybe<Order_By>;
  ImageUrlSmall?: InputMaybe<Order_By>;
  JobCode?: InputMaybe<Order_By>;
  KeyClients?: InputMaybe<Order_By>;
  Languages?: InputMaybe<Order_By>;
  LanguagesDisplay?: InputMaybe<Order_By>;
  LastName?: InputMaybe<Order_By>;
  LawsonSystemID?: InputMaybe<Order_By>;
  Managers?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
  MarsSystemID?: InputMaybe<Order_By>;
  MiddleName?: InputMaybe<Order_By>;
  MorganNetPageUrlSpo?: InputMaybe<Order_By>;
  OfficeName?: InputMaybe<Order_By>;
  OfficeSystemID?: InputMaybe<Order_By>;
  OfficeUrlSpo?: InputMaybe<Order_By>;
  OtherWork?: InputMaybe<Order_By>;
  PeopleDisplayNamePreferred?: InputMaybe<Order_By>;
  PeopleLocation?: InputMaybe<Order_By>;
  PeopleOfficeAddress?: InputMaybe<Order_By>;
  PersonalPronouns?: InputMaybe<Order_By>;
  PhoneExtension?: InputMaybe<Order_By>;
  PracticeGrpCode?: InputMaybe<Order_By>;
  PracticeGrpName?: InputMaybe<Order_By>;
  PracticeGrpRollupCode?: InputMaybe<Order_By>;
  PracticeGrpRollupName?: InputMaybe<Order_By>;
  PracticeGrpRollupUrlSpo?: InputMaybe<Order_By>;
  PracticeGrpUrlSpo?: InputMaybe<Order_By>;
  Roles?: InputMaybe<Order_By>;
  RolesNameArea?: InputMaybe<Order_By>;
  SecondOfficeName?: InputMaybe<Order_By>;
  SecondOfficeUrlSpo?: InputMaybe<Order_By>;
  SecondaryPracticeGrpCode?: InputMaybe<Order_By>;
  SecondaryPracticeGrpRollupName?: InputMaybe<Order_By>;
  SecondaryPracticeGrpRollupUrlSpo?: InputMaybe<Order_By>;
  SecondaryPracticeGrpUrlSpo?: InputMaybe<Order_By>;
  SecretaryFor?: InputMaybe<Order_By>;
  Skills?: InputMaybe<Order_By>;
  SpecialtyAreas?: InputMaybe<Order_By>;
  Spouse?: InputMaybe<Order_By>;
  Staff?: InputMaybe<Order_By>;
  WorkEmail?: InputMaybe<Order_By>;
  WorkPhoneExtension?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "BCS.Personnel" */
export type Bcs_Personnel_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Bcs_Personnel>;
};

/** Ordering options when selecting data from "BCS.Personnel". */
export type Bcs_Personnel_Order_By = {
  ADSystemID?: InputMaybe<Order_By>;
  Aboutme?: InputMaybe<Order_By>;
  AssistantADSystemID?: InputMaybe<Order_By>;
  AssistantEmail?: InputMaybe<Order_By>;
  AssistantGroups?: InputMaybe<Order_By>;
  AssistantGroupsIn?: InputMaybe<Order_By>;
  AssistantImageUrlLarge?: InputMaybe<Order_By>;
  AssistantImageUrlMedium?: InputMaybe<Order_By>;
  AssistantImageUrlSmall?: InputMaybe<Order_By>;
  AssistantLawsonSystemID?: InputMaybe<Order_By>;
  AssistantMorganNetPageUrlSpo?: InputMaybe<Order_By>;
  AssistantName?: InputMaybe<Order_By>;
  AssistantNameWithTerm?: InputMaybe<Order_By>;
  AssistantOfficeUrlSpo?: InputMaybe<Order_By>;
  AssistantPhone?: InputMaybe<Order_By>;
  AssistantTo_aggregate?: InputMaybe<Bcs_Personnel_Aggregate_Order_By>;
  BarAdmissions?: InputMaybe<Order_By>;
  BarAdmissionsDisplay?: InputMaybe<Order_By>;
  BioAlias?: InputMaybe<Order_By>;
  Biography?: InputMaybe<Order_By>;
  BoardMemberships?: InputMaybe<Order_By>;
  BusinessChemistryPrimary?: InputMaybe<Order_By>;
  BusinessChemistrySecondary?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeMailBoxNumber?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeMailGroup?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeMailGroupCode?: InputMaybe<Order_By>;
  CareerDisplay?: InputMaybe<Order_By>;
  CellPhone?: InputMaybe<Order_By>;
  Clerkships?: InputMaybe<Order_By>;
  ClientMgmt?: InputMaybe<Order_By>;
  Community?: InputMaybe<Order_By>;
  CourtAdmissions?: InputMaybe<Order_By>;
  DirectWorkPhone?: InputMaybe<Order_By>;
  DisplayName?: InputMaybe<Order_By>;
  DisplayTitle?: InputMaybe<Order_By>;
  EC1HomePhone?: InputMaybe<Order_By>;
  EC1Name?: InputMaybe<Order_By>;
  EC1WorkPhone?: InputMaybe<Order_By>;
  EC2HomePhone?: InputMaybe<Order_By>;
  EC2Name?: InputMaybe<Order_By>;
  EC2WorkPhone?: InputMaybe<Order_By>;
  EducationDisplay?: InputMaybe<Order_By>;
  EducationRefiner?: InputMaybe<Order_By>;
  EliteSystemID?: InputMaybe<Order_By>;
  FirstName?: InputMaybe<Order_By>;
  FullName?: InputMaybe<Order_By>;
  HideCellPhone?: InputMaybe<Order_By>;
  HideEducationYear?: InputMaybe<Order_By>;
  HideHomeAddress?: InputMaybe<Order_By>;
  HideHomePhone?: InputMaybe<Order_By>;
  HidePersonalInformation?: InputMaybe<Order_By>;
  HideSpouse?: InputMaybe<Order_By>;
  HomeAddress?: InputMaybe<Order_By>;
  HomePhone?: InputMaybe<Order_By>;
  ImageUrlLarge?: InputMaybe<Order_By>;
  ImageUrlMedium?: InputMaybe<Order_By>;
  ImageUrlSmall?: InputMaybe<Order_By>;
  JobCode?: InputMaybe<Order_By>;
  KeyClients?: InputMaybe<Order_By>;
  Languages?: InputMaybe<Order_By>;
  LanguagesDisplay?: InputMaybe<Order_By>;
  LastName?: InputMaybe<Order_By>;
  LawsonSystemID?: InputMaybe<Order_By>;
  Managers?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
  MarsSystemID?: InputMaybe<Order_By>;
  MiddleName?: InputMaybe<Order_By>;
  MorganNetPageUrlSpo?: InputMaybe<Order_By>;
  OfficeName?: InputMaybe<Order_By>;
  OfficeSystemID?: InputMaybe<Order_By>;
  OfficeUrlSpo?: InputMaybe<Order_By>;
  OtherWork?: InputMaybe<Order_By>;
  PeopleDisplayNamePreferred?: InputMaybe<Order_By>;
  PeopleLocation?: InputMaybe<Order_By>;
  PeopleOfficeAddress?: InputMaybe<Order_By>;
  PersonalPronouns?: InputMaybe<Order_By>;
  PhoneExtension?: InputMaybe<Order_By>;
  PracticeGrpCode?: InputMaybe<Order_By>;
  PracticeGrpName?: InputMaybe<Order_By>;
  PracticeGrpRollupCode?: InputMaybe<Order_By>;
  PracticeGrpRollupName?: InputMaybe<Order_By>;
  PracticeGrpRollupUrlSpo?: InputMaybe<Order_By>;
  PracticeGrpUrlSpo?: InputMaybe<Order_By>;
  Roles?: InputMaybe<Order_By>;
  RolesNameArea?: InputMaybe<Order_By>;
  SecondOfficeName?: InputMaybe<Order_By>;
  SecondOfficeUrlSpo?: InputMaybe<Order_By>;
  SecondaryPracticeGrpCode?: InputMaybe<Order_By>;
  SecondaryPracticeGrpRollupName?: InputMaybe<Order_By>;
  SecondaryPracticeGrpRollupUrlSpo?: InputMaybe<Order_By>;
  SecondaryPracticeGrpUrlSpo?: InputMaybe<Order_By>;
  SecretaryFor?: InputMaybe<Order_By>;
  Skills?: InputMaybe<Order_By>;
  SpecialtyAreas?: InputMaybe<Order_By>;
  Spouse?: InputMaybe<Order_By>;
  Staff?: InputMaybe<Order_By>;
  WorkEmail?: InputMaybe<Order_By>;
  WorkPhoneExtension?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: BCS.Personnel */
export type Bcs_Personnel_Pk_Columns_Input = {
  ADSystemID: Scalars['citext']['input'];
};

/** select columns of table "BCS.Personnel" */
export enum Bcs_Personnel_Select_Column {
  /** column name */
  ADSystemID = 'ADSystemID',
  /** column name */
  Aboutme = 'Aboutme',
  /** column name */
  AssistantADSystemID = 'AssistantADSystemID',
  /** column name */
  AssistantEmail = 'AssistantEmail',
  /** column name */
  AssistantGroups = 'AssistantGroups',
  /** column name */
  AssistantGroupsIn = 'AssistantGroupsIn',
  /** column name */
  AssistantImageUrlLarge = 'AssistantImageUrlLarge',
  /** column name */
  AssistantImageUrlMedium = 'AssistantImageUrlMedium',
  /** column name */
  AssistantImageUrlSmall = 'AssistantImageUrlSmall',
  /** column name */
  AssistantLawsonSystemID = 'AssistantLawsonSystemID',
  /** column name */
  AssistantMorganNetPageUrlSpo = 'AssistantMorganNetPageUrlSpo',
  /** column name */
  AssistantName = 'AssistantName',
  /** column name */
  AssistantNameWithTerm = 'AssistantNameWithTerm',
  /** column name */
  AssistantOfficeUrlSpo = 'AssistantOfficeUrlSpo',
  /** column name */
  AssistantPhone = 'AssistantPhone',
  /** column name */
  BarAdmissions = 'BarAdmissions',
  /** column name */
  BarAdmissionsDisplay = 'BarAdmissionsDisplay',
  /** column name */
  BioAlias = 'BioAlias',
  /** column name */
  Biography = 'Biography',
  /** column name */
  BoardMemberships = 'BoardMemberships',
  /** column name */
  BusinessChemistryPrimary = 'BusinessChemistryPrimary',
  /** column name */
  BusinessChemistrySecondary = 'BusinessChemistrySecondary',
  /** column name */
  BusinessPrimaryOfficeMailBoxNumber = 'BusinessPrimaryOfficeMailBoxNumber',
  /** column name */
  BusinessPrimaryOfficeMailGroup = 'BusinessPrimaryOfficeMailGroup',
  /** column name */
  BusinessPrimaryOfficeMailGroupCode = 'BusinessPrimaryOfficeMailGroupCode',
  /** column name */
  CareerDisplay = 'CareerDisplay',
  /** column name */
  CellPhone = 'CellPhone',
  /** column name */
  Clerkships = 'Clerkships',
  /** column name */
  ClientMgmt = 'ClientMgmt',
  /** column name */
  Community = 'Community',
  /** column name */
  CourtAdmissions = 'CourtAdmissions',
  /** column name */
  DirectWorkPhone = 'DirectWorkPhone',
  /** column name */
  DisplayName = 'DisplayName',
  /** column name */
  DisplayTitle = 'DisplayTitle',
  /** column name */
  EC1HomePhone = 'EC1HomePhone',
  /** column name */
  EC1Name = 'EC1Name',
  /** column name */
  EC1WorkPhone = 'EC1WorkPhone',
  /** column name */
  EC2HomePhone = 'EC2HomePhone',
  /** column name */
  EC2Name = 'EC2Name',
  /** column name */
  EC2WorkPhone = 'EC2WorkPhone',
  /** column name */
  EducationDisplay = 'EducationDisplay',
  /** column name */
  EducationRefiner = 'EducationRefiner',
  /** column name */
  EliteSystemID = 'EliteSystemID',
  /** column name */
  FirstName = 'FirstName',
  /** column name */
  FullName = 'FullName',
  /** column name */
  HideCellPhone = 'HideCellPhone',
  /** column name */
  HideEducationYear = 'HideEducationYear',
  /** column name */
  HideHomeAddress = 'HideHomeAddress',
  /** column name */
  HideHomePhone = 'HideHomePhone',
  /** column name */
  HidePersonalInformation = 'HidePersonalInformation',
  /** column name */
  HideSpouse = 'HideSpouse',
  /** column name */
  HomeAddress = 'HomeAddress',
  /** column name */
  HomePhone = 'HomePhone',
  /** column name */
  ImageUrlLarge = 'ImageUrlLarge',
  /** column name */
  ImageUrlMedium = 'ImageUrlMedium',
  /** column name */
  ImageUrlSmall = 'ImageUrlSmall',
  /** column name */
  JobCode = 'JobCode',
  /** column name */
  KeyClients = 'KeyClients',
  /** column name */
  Languages = 'Languages',
  /** column name */
  LanguagesDisplay = 'LanguagesDisplay',
  /** column name */
  LastName = 'LastName',
  /** column name */
  LawsonSystemID = 'LawsonSystemID',
  /** column name */
  Managers = 'Managers',
  /** column name */
  MarsPersonID = 'MarsPersonID',
  /** column name */
  MarsSystemID = 'MarsSystemID',
  /** column name */
  MiddleName = 'MiddleName',
  /** column name */
  MorganNetPageUrlSpo = 'MorganNetPageUrlSpo',
  /** column name */
  OfficeName = 'OfficeName',
  /** column name */
  OfficeSystemID = 'OfficeSystemID',
  /** column name */
  OfficeUrlSpo = 'OfficeUrlSpo',
  /** column name */
  OtherWork = 'OtherWork',
  /** column name */
  PeopleDisplayNamePreferred = 'PeopleDisplayNamePreferred',
  /** column name */
  PeopleLocation = 'PeopleLocation',
  /** column name */
  PeopleOfficeAddress = 'PeopleOfficeAddress',
  /** column name */
  PersonalPronouns = 'PersonalPronouns',
  /** column name */
  PhoneExtension = 'PhoneExtension',
  /** column name */
  PracticeGrpCode = 'PracticeGrpCode',
  /** column name */
  PracticeGrpName = 'PracticeGrpName',
  /** column name */
  PracticeGrpRollupCode = 'PracticeGrpRollupCode',
  /** column name */
  PracticeGrpRollupName = 'PracticeGrpRollupName',
  /** column name */
  PracticeGrpRollupUrlSpo = 'PracticeGrpRollupUrlSpo',
  /** column name */
  PracticeGrpUrlSpo = 'PracticeGrpUrlSpo',
  /** column name */
  Roles = 'Roles',
  /** column name */
  RolesNameArea = 'RolesNameArea',
  /** column name */
  SecondOfficeName = 'SecondOfficeName',
  /** column name */
  SecondOfficeUrlSpo = 'SecondOfficeUrlSpo',
  /** column name */
  SecondaryPracticeGrpCode = 'SecondaryPracticeGrpCode',
  /** column name */
  SecondaryPracticeGrpRollupName = 'SecondaryPracticeGrpRollupName',
  /** column name */
  SecondaryPracticeGrpRollupUrlSpo = 'SecondaryPracticeGrpRollupUrlSpo',
  /** column name */
  SecondaryPracticeGrpUrlSpo = 'SecondaryPracticeGrpUrlSpo',
  /** column name */
  SecretaryFor = 'SecretaryFor',
  /** column name */
  Skills = 'Skills',
  /** column name */
  SpecialtyAreas = 'SpecialtyAreas',
  /** column name */
  Spouse = 'Spouse',
  /** column name */
  Staff = 'Staff',
  /** column name */
  WorkEmail = 'WorkEmail',
  /** column name */
  WorkPhoneExtension = 'WorkPhoneExtension',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Updated_at = 'updated_at',
}

/** select "BCS_Personnel_aggregate_bool_exp_bool_and_arguments_columns" columns of table "BCS.Personnel" */
export enum Bcs_Personnel_Select_Column_Bcs_Personnel_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HideCellPhone = 'HideCellPhone',
  /** column name */
  HideEducationYear = 'HideEducationYear',
  /** column name */
  HideHomeAddress = 'HideHomeAddress',
  /** column name */
  HideHomePhone = 'HideHomePhone',
  /** column name */
  HideSpouse = 'HideSpouse',
}

/** select "BCS_Personnel_aggregate_bool_exp_bool_or_arguments_columns" columns of table "BCS.Personnel" */
export enum Bcs_Personnel_Select_Column_Bcs_Personnel_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HideCellPhone = 'HideCellPhone',
  /** column name */
  HideEducationYear = 'HideEducationYear',
  /** column name */
  HideHomeAddress = 'HideHomeAddress',
  /** column name */
  HideHomePhone = 'HideHomePhone',
  /** column name */
  HideSpouse = 'HideSpouse',
}

/** input type for updating data in table "BCS.Personnel" */
export type Bcs_Personnel_Set_Input = {
  BoardMemberships?: InputMaybe<Scalars['String']['input']>;
  Clerkships?: InputMaybe<Scalars['String']['input']>;
  Community?: InputMaybe<Scalars['String']['input']>;
  CourtAdmissions?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Bcs_Personnel_Stddev_Fields = {
  AssistantLawsonSystemID?: Maybe<Scalars['Float']['output']>;
  HidePersonalInformation?: Maybe<Scalars['Float']['output']>;
  LawsonSystemID?: Maybe<Scalars['Float']['output']>;
  MarsPersonID?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "BCS.Personnel" */
export type Bcs_Personnel_Stddev_Order_By = {
  AssistantLawsonSystemID?: InputMaybe<Order_By>;
  HidePersonalInformation?: InputMaybe<Order_By>;
  LawsonSystemID?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Bcs_Personnel_Stddev_Pop_Fields = {
  AssistantLawsonSystemID?: Maybe<Scalars['Float']['output']>;
  HidePersonalInformation?: Maybe<Scalars['Float']['output']>;
  LawsonSystemID?: Maybe<Scalars['Float']['output']>;
  MarsPersonID?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "BCS.Personnel" */
export type Bcs_Personnel_Stddev_Pop_Order_By = {
  AssistantLawsonSystemID?: InputMaybe<Order_By>;
  HidePersonalInformation?: InputMaybe<Order_By>;
  LawsonSystemID?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Bcs_Personnel_Stddev_Samp_Fields = {
  AssistantLawsonSystemID?: Maybe<Scalars['Float']['output']>;
  HidePersonalInformation?: Maybe<Scalars['Float']['output']>;
  LawsonSystemID?: Maybe<Scalars['Float']['output']>;
  MarsPersonID?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "BCS.Personnel" */
export type Bcs_Personnel_Stddev_Samp_Order_By = {
  AssistantLawsonSystemID?: InputMaybe<Order_By>;
  HidePersonalInformation?: InputMaybe<Order_By>;
  LawsonSystemID?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "BCS_Personnel" */
export type Bcs_Personnel_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bcs_Personnel_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bcs_Personnel_Stream_Cursor_Value_Input = {
  ADSystemID?: InputMaybe<Scalars['citext']['input']>;
  Aboutme?: InputMaybe<Scalars['String']['input']>;
  AssistantADSystemID?: InputMaybe<Scalars['String']['input']>;
  AssistantEmail?: InputMaybe<Scalars['String']['input']>;
  AssistantGroups?: InputMaybe<Scalars['String']['input']>;
  AssistantGroupsIn?: InputMaybe<Scalars['String']['input']>;
  AssistantImageUrlLarge?: InputMaybe<Scalars['String']['input']>;
  AssistantImageUrlMedium?: InputMaybe<Scalars['String']['input']>;
  AssistantImageUrlSmall?: InputMaybe<Scalars['String']['input']>;
  AssistantLawsonSystemID?: InputMaybe<Scalars['Int']['input']>;
  AssistantMorganNetPageUrlSpo?: InputMaybe<Scalars['String']['input']>;
  AssistantName?: InputMaybe<Scalars['String']['input']>;
  AssistantNameWithTerm?: InputMaybe<Scalars['String']['input']>;
  AssistantOfficeUrlSpo?: InputMaybe<Scalars['String']['input']>;
  AssistantPhone?: InputMaybe<Scalars['String']['input']>;
  BarAdmissions?: InputMaybe<Scalars['String']['input']>;
  BarAdmissionsDisplay?: InputMaybe<Scalars['String']['input']>;
  BioAlias?: InputMaybe<Scalars['String']['input']>;
  Biography?: InputMaybe<Scalars['String']['input']>;
  BoardMemberships?: InputMaybe<Scalars['String']['input']>;
  BusinessChemistryPrimary?: InputMaybe<Scalars['String']['input']>;
  BusinessChemistrySecondary?: InputMaybe<Scalars['String']['input']>;
  BusinessPrimaryOfficeMailBoxNumber?: InputMaybe<Scalars['String']['input']>;
  BusinessPrimaryOfficeMailGroup?: InputMaybe<Scalars['String']['input']>;
  BusinessPrimaryOfficeMailGroupCode?: InputMaybe<Scalars['String']['input']>;
  CareerDisplay?: InputMaybe<Scalars['String']['input']>;
  CellPhone?: InputMaybe<Scalars['String']['input']>;
  Clerkships?: InputMaybe<Scalars['String']['input']>;
  ClientMgmt?: InputMaybe<Scalars['String']['input']>;
  Community?: InputMaybe<Scalars['String']['input']>;
  CourtAdmissions?: InputMaybe<Scalars['String']['input']>;
  DirectWorkPhone?: InputMaybe<Scalars['String']['input']>;
  DisplayName?: InputMaybe<Scalars['String']['input']>;
  DisplayTitle?: InputMaybe<Scalars['String']['input']>;
  EC1HomePhone?: InputMaybe<Scalars['String']['input']>;
  EC1Name?: InputMaybe<Scalars['String']['input']>;
  EC1WorkPhone?: InputMaybe<Scalars['String']['input']>;
  EC2HomePhone?: InputMaybe<Scalars['String']['input']>;
  EC2Name?: InputMaybe<Scalars['String']['input']>;
  EC2WorkPhone?: InputMaybe<Scalars['String']['input']>;
  EducationDisplay?: InputMaybe<Scalars['String']['input']>;
  EducationRefiner?: InputMaybe<Scalars['String']['input']>;
  EliteSystemID?: InputMaybe<Scalars['String']['input']>;
  FirstName?: InputMaybe<Scalars['String']['input']>;
  FullName?: InputMaybe<Scalars['String']['input']>;
  HideCellPhone?: InputMaybe<Scalars['Boolean']['input']>;
  HideEducationYear?: InputMaybe<Scalars['Boolean']['input']>;
  HideHomeAddress?: InputMaybe<Scalars['Boolean']['input']>;
  HideHomePhone?: InputMaybe<Scalars['Boolean']['input']>;
  HidePersonalInformation?: InputMaybe<Scalars['Int']['input']>;
  HideSpouse?: InputMaybe<Scalars['Boolean']['input']>;
  HomeAddress?: InputMaybe<Scalars['String']['input']>;
  HomePhone?: InputMaybe<Scalars['String']['input']>;
  ImageUrlLarge?: InputMaybe<Scalars['String']['input']>;
  ImageUrlMedium?: InputMaybe<Scalars['String']['input']>;
  ImageUrlSmall?: InputMaybe<Scalars['String']['input']>;
  JobCode?: InputMaybe<Scalars['String']['input']>;
  KeyClients?: InputMaybe<Scalars['String']['input']>;
  Languages?: InputMaybe<Scalars['String']['input']>;
  LanguagesDisplay?: InputMaybe<Scalars['String']['input']>;
  LastName?: InputMaybe<Scalars['String']['input']>;
  LawsonSystemID?: InputMaybe<Scalars['Int']['input']>;
  Managers?: InputMaybe<Scalars['String']['input']>;
  MarsPersonID?: InputMaybe<Scalars['Int']['input']>;
  MarsSystemID?: InputMaybe<Scalars['String']['input']>;
  MiddleName?: InputMaybe<Scalars['String']['input']>;
  MorganNetPageUrlSpo?: InputMaybe<Scalars['String']['input']>;
  OfficeName?: InputMaybe<Scalars['String']['input']>;
  OfficeSystemID?: InputMaybe<Scalars['String']['input']>;
  OfficeUrlSpo?: InputMaybe<Scalars['String']['input']>;
  OtherWork?: InputMaybe<Scalars['String']['input']>;
  PeopleDisplayNamePreferred?: InputMaybe<Scalars['String']['input']>;
  PeopleLocation?: InputMaybe<Scalars['String']['input']>;
  PeopleOfficeAddress?: InputMaybe<Scalars['String']['input']>;
  PersonalPronouns?: InputMaybe<Scalars['String']['input']>;
  PhoneExtension?: InputMaybe<Scalars['String']['input']>;
  PracticeGrpCode?: InputMaybe<Scalars['String']['input']>;
  PracticeGrpName?: InputMaybe<Scalars['String']['input']>;
  PracticeGrpRollupCode?: InputMaybe<Scalars['String']['input']>;
  PracticeGrpRollupName?: InputMaybe<Scalars['String']['input']>;
  PracticeGrpRollupUrlSpo?: InputMaybe<Scalars['String']['input']>;
  PracticeGrpUrlSpo?: InputMaybe<Scalars['String']['input']>;
  Roles?: InputMaybe<Scalars['String']['input']>;
  RolesNameArea?: InputMaybe<Scalars['String']['input']>;
  SecondOfficeName?: InputMaybe<Scalars['String']['input']>;
  SecondOfficeUrlSpo?: InputMaybe<Scalars['String']['input']>;
  SecondaryPracticeGrpCode?: InputMaybe<Scalars['String']['input']>;
  SecondaryPracticeGrpRollupName?: InputMaybe<Scalars['String']['input']>;
  SecondaryPracticeGrpRollupUrlSpo?: InputMaybe<Scalars['String']['input']>;
  SecondaryPracticeGrpUrlSpo?: InputMaybe<Scalars['String']['input']>;
  SecretaryFor?: InputMaybe<Scalars['String']['input']>;
  Skills?: InputMaybe<Scalars['String']['input']>;
  SpecialtyAreas?: InputMaybe<Scalars['String']['input']>;
  Spouse?: InputMaybe<Scalars['String']['input']>;
  Staff?: InputMaybe<Scalars['String']['input']>;
  WorkEmail?: InputMaybe<Scalars['citext']['input']>;
  WorkPhoneExtension?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Bcs_Personnel_Sum_Fields = {
  AssistantLawsonSystemID?: Maybe<Scalars['Int']['output']>;
  HidePersonalInformation?: Maybe<Scalars['Int']['output']>;
  LawsonSystemID?: Maybe<Scalars['Int']['output']>;
  MarsPersonID?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "BCS.Personnel" */
export type Bcs_Personnel_Sum_Order_By = {
  AssistantLawsonSystemID?: InputMaybe<Order_By>;
  HidePersonalInformation?: InputMaybe<Order_By>;
  LawsonSystemID?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
};

export type Bcs_Personnel_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bcs_Personnel_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bcs_Personnel_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Bcs_Personnel_Var_Pop_Fields = {
  AssistantLawsonSystemID?: Maybe<Scalars['Float']['output']>;
  HidePersonalInformation?: Maybe<Scalars['Float']['output']>;
  LawsonSystemID?: Maybe<Scalars['Float']['output']>;
  MarsPersonID?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "BCS.Personnel" */
export type Bcs_Personnel_Var_Pop_Order_By = {
  AssistantLawsonSystemID?: InputMaybe<Order_By>;
  HidePersonalInformation?: InputMaybe<Order_By>;
  LawsonSystemID?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Bcs_Personnel_Var_Samp_Fields = {
  AssistantLawsonSystemID?: Maybe<Scalars['Float']['output']>;
  HidePersonalInformation?: Maybe<Scalars['Float']['output']>;
  LawsonSystemID?: Maybe<Scalars['Float']['output']>;
  MarsPersonID?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "BCS.Personnel" */
export type Bcs_Personnel_Var_Samp_Order_By = {
  AssistantLawsonSystemID?: InputMaybe<Order_By>;
  HidePersonalInformation?: InputMaybe<Order_By>;
  LawsonSystemID?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Bcs_Personnel_Variance_Fields = {
  AssistantLawsonSystemID?: Maybe<Scalars['Float']['output']>;
  HidePersonalInformation?: Maybe<Scalars['Float']['output']>;
  LawsonSystemID?: Maybe<Scalars['Float']['output']>;
  MarsPersonID?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "BCS.Personnel" */
export type Bcs_Personnel_Variance_Order_By = {
  AssistantLawsonSystemID?: InputMaybe<Order_By>;
  HidePersonalInformation?: InputMaybe<Order_By>;
  LawsonSystemID?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
};

export enum BodyType {
  HTML = 'HTML',
  TEXT = 'TEXT',
}

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type Bucket = {
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderHint?: Maybe<Scalars['String']['output']>;
  plan: Plan;
  planId?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<TasksConnection>;
};

export type BucketTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TaskSortInput>>;
  where?: InputMaybe<TaskFilterInput>;
};

export enum BucketAggregationSortProperty {
  COUNT = 'COUNT',
  KEY_AS_NUMBER = 'KEY_AS_NUMBER',
  KEY_AS_STRING = 'KEY_AS_STRING',
  UNKNOWN_FUTURE_VALUE = 'UNKNOWN_FUTURE_VALUE',
}

export type BucketFilterInput = {
  and?: InputMaybe<Array<BucketFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BucketFilterInput>>;
  orderHint?: InputMaybe<StringOperationFilterInput>;
  planId?: InputMaybe<StringOperationFilterInput>;
};

export type BucketInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderHint?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
};

export type BucketSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  orderHint?: InputMaybe<SortEnumType>;
  planId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BucketsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<BucketsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Bucket>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BucketsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Bucket;
};

export enum CalendarType {
  CHINESE_LUNAR = 'CHINESE_LUNAR',
  GREGORIAN = 'GREGORIAN',
  GREGORIAN_ARABIC = 'GREGORIAN_ARABIC',
  GREGORIAN_ME_FRENCH = 'GREGORIAN_ME_FRENCH',
  GREGORIAN_XLIT_ENGLISH = 'GREGORIAN_XLIT_ENGLISH',
  GREGORIAN_XLIT_FRENCH = 'GREGORIAN_XLIT_FRENCH',
  HEBREW = 'HEBREW',
  HIJRI = 'HIJRI',
  JAPAN = 'JAPAN',
  KOREA = 'KOREA',
  KOREA_JAPAN_LUNAR = 'KOREA_JAPAN_LUNAR',
  NONE = 'NONE',
  SAKA_ERA = 'SAKA_ERA',
  TAIWAN = 'TAIWAN',
  THAI = 'THAI',
}

export type CalendarTypeOperationFilterInput = {
  eq?: InputMaybe<CalendarType>;
  in?: InputMaybe<Array<CalendarType>>;
  neq?: InputMaybe<CalendarType>;
  nin?: InputMaybe<Array<CalendarType>>;
};

export type CategoryDescriptions = {
  category1?: Maybe<Scalars['String']['output']>;
  category2?: Maybe<Scalars['String']['output']>;
  category3?: Maybe<Scalars['String']['output']>;
  category4?: Maybe<Scalars['String']['output']>;
  category5?: Maybe<Scalars['String']['output']>;
  category6?: Maybe<Scalars['String']['output']>;
  category7?: Maybe<Scalars['String']['output']>;
  category8?: Maybe<Scalars['String']['output']>;
  category9?: Maybe<Scalars['String']['output']>;
  category10?: Maybe<Scalars['String']['output']>;
  category11?: Maybe<Scalars['String']['output']>;
  category12?: Maybe<Scalars['String']['output']>;
  category13?: Maybe<Scalars['String']['output']>;
  category14?: Maybe<Scalars['String']['output']>;
  category15?: Maybe<Scalars['String']['output']>;
  category16?: Maybe<Scalars['String']['output']>;
  category17?: Maybe<Scalars['String']['output']>;
  category18?: Maybe<Scalars['String']['output']>;
  category19?: Maybe<Scalars['String']['output']>;
  category20?: Maybe<Scalars['String']['output']>;
  category21?: Maybe<Scalars['String']['output']>;
  category22?: Maybe<Scalars['String']['output']>;
  category23?: Maybe<Scalars['String']['output']>;
  category24?: Maybe<Scalars['String']['output']>;
  category25?: Maybe<Scalars['String']['output']>;
};

export type CategoryDescriptionsFilterInput = {
  and?: InputMaybe<Array<CategoryDescriptionsFilterInput>>;
  category1?: InputMaybe<StringOperationFilterInput>;
  category2?: InputMaybe<StringOperationFilterInput>;
  category3?: InputMaybe<StringOperationFilterInput>;
  category4?: InputMaybe<StringOperationFilterInput>;
  category5?: InputMaybe<StringOperationFilterInput>;
  category6?: InputMaybe<StringOperationFilterInput>;
  category7?: InputMaybe<StringOperationFilterInput>;
  category8?: InputMaybe<StringOperationFilterInput>;
  category9?: InputMaybe<StringOperationFilterInput>;
  category10?: InputMaybe<StringOperationFilterInput>;
  category11?: InputMaybe<StringOperationFilterInput>;
  category12?: InputMaybe<StringOperationFilterInput>;
  category13?: InputMaybe<StringOperationFilterInput>;
  category14?: InputMaybe<StringOperationFilterInput>;
  category15?: InputMaybe<StringOperationFilterInput>;
  category16?: InputMaybe<StringOperationFilterInput>;
  category17?: InputMaybe<StringOperationFilterInput>;
  category18?: InputMaybe<StringOperationFilterInput>;
  category19?: InputMaybe<StringOperationFilterInput>;
  category20?: InputMaybe<StringOperationFilterInput>;
  category21?: InputMaybe<StringOperationFilterInput>;
  category22?: InputMaybe<StringOperationFilterInput>;
  category23?: InputMaybe<StringOperationFilterInput>;
  category24?: InputMaybe<StringOperationFilterInput>;
  category25?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CategoryDescriptionsFilterInput>>;
};

export type CategoryDescriptionsInput = {
  category1?: InputMaybe<Scalars['String']['input']>;
  category2?: InputMaybe<Scalars['String']['input']>;
  category3?: InputMaybe<Scalars['String']['input']>;
  category4?: InputMaybe<Scalars['String']['input']>;
  category5?: InputMaybe<Scalars['String']['input']>;
  category6?: InputMaybe<Scalars['String']['input']>;
  category7?: InputMaybe<Scalars['String']['input']>;
  category8?: InputMaybe<Scalars['String']['input']>;
  category9?: InputMaybe<Scalars['String']['input']>;
  category10?: InputMaybe<Scalars['String']['input']>;
  category11?: InputMaybe<Scalars['String']['input']>;
  category12?: InputMaybe<Scalars['String']['input']>;
  category13?: InputMaybe<Scalars['String']['input']>;
  category14?: InputMaybe<Scalars['String']['input']>;
  category15?: InputMaybe<Scalars['String']['input']>;
  category16?: InputMaybe<Scalars['String']['input']>;
  category17?: InputMaybe<Scalars['String']['input']>;
  category18?: InputMaybe<Scalars['String']['input']>;
  category19?: InputMaybe<Scalars['String']['input']>;
  category20?: InputMaybe<Scalars['String']['input']>;
  category21?: InputMaybe<Scalars['String']['input']>;
  category22?: InputMaybe<Scalars['String']['input']>;
  category23?: InputMaybe<Scalars['String']['input']>;
  category24?: InputMaybe<Scalars['String']['input']>;
  category25?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryDescriptionsSortInput = {
  category1?: InputMaybe<SortEnumType>;
  category2?: InputMaybe<SortEnumType>;
  category3?: InputMaybe<SortEnumType>;
  category4?: InputMaybe<SortEnumType>;
  category5?: InputMaybe<SortEnumType>;
  category6?: InputMaybe<SortEnumType>;
  category7?: InputMaybe<SortEnumType>;
  category8?: InputMaybe<SortEnumType>;
  category9?: InputMaybe<SortEnumType>;
  category10?: InputMaybe<SortEnumType>;
  category11?: InputMaybe<SortEnumType>;
  category12?: InputMaybe<SortEnumType>;
  category13?: InputMaybe<SortEnumType>;
  category14?: InputMaybe<SortEnumType>;
  category15?: InputMaybe<SortEnumType>;
  category16?: InputMaybe<SortEnumType>;
  category17?: InputMaybe<SortEnumType>;
  category18?: InputMaybe<SortEnumType>;
  category19?: InputMaybe<SortEnumType>;
  category20?: InputMaybe<SortEnumType>;
  category21?: InputMaybe<SortEnumType>;
  category22?: InputMaybe<SortEnumType>;
  category23?: InputMaybe<SortEnumType>;
  category24?: InputMaybe<SortEnumType>;
  category25?: InputMaybe<SortEnumType>;
};

export enum CheckOutType {
  NONE = 'NONE',
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE',
}

export type CheckOutTypeOperationFilterInput = {
  eq?: InputMaybe<CheckOutType>;
  in?: InputMaybe<Array<CheckOutType>>;
  neq?: InputMaybe<CheckOutType>;
  nin?: InputMaybe<Array<CheckOutType>>;
};

export type ChecklistItem = {
  isChecked: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<IdentitySet>;
  lastModifiedDateTime?: Maybe<Scalars['DateTime']['output']>;
  orderHint?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ChecklistItemFilterInput = {
  and?: InputMaybe<Array<ChecklistItemFilterInput>>;
  isChecked?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<IdentitySetFilterInput>;
  lastModifiedDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ChecklistItemFilterInput>>;
  orderHint?: InputMaybe<StringOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
};

export type ChecklistItemInput = {
  isChecked: Scalars['Boolean']['input'];
  orderHint?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export enum ChoiceFormatType {
  DROPDOWN = 'DROPDOWN',
  RADIO_BUTTONS = 'RADIO_BUTTONS',
}

export type ChoiceFormatTypeOperationFilterInput = {
  eq?: InputMaybe<ChoiceFormatType>;
  in?: InputMaybe<Array<ChoiceFormatType>>;
  neq?: InputMaybe<ChoiceFormatType>;
  nin?: InputMaybe<Array<ChoiceFormatType>>;
};

export enum CommentsDisabledScope {
  ITEM = 'ITEM',
  NONE = 'NONE',
  SITE = 'SITE',
  TENANT = 'TENANT',
  WEB = 'WEB',
}

export type CommentsDisabledScopeOperationFilterInput = {
  eq?: InputMaybe<CommentsDisabledScope>;
  in?: InputMaybe<Array<CommentsDisabledScope>>;
  neq?: InputMaybe<CommentsDisabledScope>;
  nin?: InputMaybe<Array<CommentsDisabledScope>>;
};

export type Container = {
  additionalData?: Maybe<Array<KeyValuePairOfNullableStringAndNullableObject>>;
  containerId: Scalars['String']['output'];
  oDataType?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PlannerContainerType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ContainerFilterInput = {
  additionalData?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndObjectFilterInput>;
  and?: InputMaybe<Array<ContainerFilterInput>>;
  containerId?: InputMaybe<StringOperationFilterInput>;
  oDataType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ContainerFilterInput>>;
  type?: InputMaybe<NullableOfPlannerContainerTypeOperationFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
};

export type ContainerSortInput = {
  containerId?: InputMaybe<SortEnumType>;
  oDataType?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
};

export type ConversationLookupInput = {
  conversationThreadId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
};

export type ConversationThread = {
  additionalData?: Maybe<Array<KeyValuePairOfNullableStringAndNullableObject>>;
  ccRecipients?: Maybe<Array<Maybe<Recipient>>>;
  hasAttachments?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  lastDeliveredDateTime?: Maybe<Scalars['DateTime']['output']>;
  oDataType?: Maybe<Scalars['String']['output']>;
  posts?: Maybe<Array<Maybe<Post>>>;
  postsNextLink?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  toRecipients?: Maybe<Array<Maybe<Recipient>>>;
  topic?: Maybe<Scalars['String']['output']>;
  uniqueSenders?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ConversationsLookupInput = {
  conversationThreadIds: Array<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
};

export type CreateGuestUserInvitationInput = {
  invitation: UserInviteInput;
};

export type CreateGuestUserInvitationPayload = {
  invitation?: Maybe<Invitation>;
};

export type CreateListItemInput = {
  /** The unique identifier (GUID) or the title of the SharePoint list that is being retrieved. */
  listIdOrTitle: Scalars['String']['input'];
  /** The URL of the SharePoint site. */
  siteUrl: Scalars['URL']['input'];
  /** JSON data representing the properties and values of the new list item. */
  values: Scalars['JSON']['input'];
};

export type CreateListItemPayload = {
  iListItem?: Maybe<IListItem>;
};

export enum CustomizedPageStatus {
  CUSTOMIZED = 'CUSTOMIZED',
  NONE = 'NONE',
  UNCUSTOMIZED = 'UNCUSTOMIZED',
}

export type CustomizedPageStatusOperationFilterInput = {
  eq?: InputMaybe<CustomizedPageStatus>;
  in?: InputMaybe<Array<CustomizedPageStatus>>;
  neq?: InputMaybe<CustomizedPageStatus>;
  nin?: InputMaybe<Array<CustomizedPageStatus>>;
};

export enum DateTimeFieldFormatType {
  DATE_ONLY = 'DATE_ONLY',
  DATE_TIME = 'DATE_TIME',
}

export type DateTimeFieldFormatTypeOperationFilterInput = {
  eq?: InputMaybe<DateTimeFieldFormatType>;
  in?: InputMaybe<Array<DateTimeFieldFormatType>>;
  neq?: InputMaybe<DateTimeFieldFormatType>;
  nin?: InputMaybe<Array<DateTimeFieldFormatType>>;
};

export enum DateTimeFieldFriendlyFormatType {
  DISABLED = 'DISABLED',
  RELATIVE = 'RELATIVE',
  UNSPECIFIED = 'UNSPECIFIED',
}

export type DateTimeFieldFriendlyFormatTypeOperationFilterInput = {
  eq?: InputMaybe<DateTimeFieldFriendlyFormatType>;
  in?: InputMaybe<Array<DateTimeFieldFriendlyFormatType>>;
  neq?: InputMaybe<DateTimeFieldFriendlyFormatType>;
  nin?: InputMaybe<Array<DateTimeFieldFriendlyFormatType>>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateTimeTimeZone = {
  additionalData?: Maybe<Array<KeyValuePairOfNullableStringAndNullableObject>>;
  dateTime?: Maybe<Scalars['String']['output']>;
  oDataType?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type DateTimeTimeZoneFilterInput = {
  additionalData?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndObjectFilterInput>;
  and?: InputMaybe<Array<DateTimeTimeZoneFilterInput>>;
  dateTime?: InputMaybe<StringOperationFilterInput>;
  oDataType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DateTimeTimeZoneFilterInput>>;
  timeZone?: InputMaybe<StringOperationFilterInput>;
};

export type DateTimeTimeZoneSortInput = {
  dateTime?: InputMaybe<SortEnumType>;
  oDataType?: InputMaybe<SortEnumType>;
  timeZone?: InputMaybe<SortEnumType>;
};

export type DeleteBucketError = IdRequiredError;

export type DeleteBucketInput = {
  id: Scalars['String']['input'];
};

export type DeleteBucketPayload = {
  deletePayload?: Maybe<DeletePayload>;
  errors?: Maybe<Array<DeleteBucketError>>;
};

export type DeleteListItemInput = {
  /** The unique identifier (GUID) or the title of the SharePoint list that is being retrieved. */
  listIdOrTitle: Scalars['String']['input'];
  /** The unique identifier of the list item to be deleted. */
  listItemId: Scalars['Int']['input'];
  /** The URL of the SharePoint site. */
  siteUrl: Scalars['URL']['input'];
};

export type DeleteListItemPayload = {
  int?: Maybe<Scalars['Int']['output']>;
};

export type DeletePayload = {
  id?: Maybe<Scalars['String']['output']>;
};

export type DeleteTaskError = IdRequiredError;

export type DeleteTaskInput = {
  id: Scalars['String']['input'];
};

export type DeleteTaskPayload = {
  deletePayload?: Maybe<DeletePayload>;
  errors?: Maybe<Array<DeleteTaskError>>;
};

export enum DraftVisibilityType {
  APPROVER = 'APPROVER',
  AUTHOR = 'AUTHOR',
  READER = 'READER',
}

export type DraftVisibilityTypeOperationFilterInput = {
  eq?: InputMaybe<DraftVisibilityType>;
  in?: InputMaybe<Array<DraftVisibilityType>>;
  neq?: InputMaybe<DraftVisibilityType>;
  nin?: InputMaybe<Array<DraftVisibilityType>>;
};

export type EmailAddress = {
  additionalData?: Maybe<Array<KeyValuePairOfNullableStringAndNullableObject>>;
  address?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oDataType?: Maybe<Scalars['String']['output']>;
};

export type EmailAddressFilterInput = {
  additionalData?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndObjectFilterInput>;
  address?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<EmailAddressFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  oDataType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EmailAddressFilterInput>>;
};

export type EmailAddressSortInput = {
  address?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  oDataType?: InputMaybe<SortEnumType>;
};

export type Error = {
  message: Scalars['String']['output'];
};

export enum EventReceiverSynchronization {
  ASYNCHRONOUS = 'ASYNCHRONOUS',
  DEFAULT_SYNCHRONIZATION = 'DEFAULT_SYNCHRONIZATION',
  SYNCHRONOUS = 'SYNCHRONOUS',
}

export type EventReceiverSynchronizationOperationFilterInput = {
  eq?: InputMaybe<EventReceiverSynchronization>;
  in?: InputMaybe<Array<EventReceiverSynchronization>>;
  neq?: InputMaybe<EventReceiverSynchronization>;
  nin?: InputMaybe<Array<EventReceiverSynchronization>>;
};

export enum EventReceiverType {
  APP_INSTALLED = 'APP_INSTALLED',
  APP_UNINSTALLING = 'APP_UNINSTALLING',
  APP_UPGRADED = 'APP_UPGRADED',
  CONTEXT_EVENT = 'CONTEXT_EVENT',
  EMAIL_RECEIVED = 'EMAIL_RECEIVED',
  ENTITY_INSTANCE_ADDED = 'ENTITY_INSTANCE_ADDED',
  ENTITY_INSTANCE_DELETED = 'ENTITY_INSTANCE_DELETED',
  ENTITY_INSTANCE_UPDATED = 'ENTITY_INSTANCE_UPDATED',
  FIELD_ADDED = 'FIELD_ADDED',
  FIELD_ADDING = 'FIELD_ADDING',
  FIELD_DELETED = 'FIELD_DELETED',
  FIELD_DELETING = 'FIELD_DELETING',
  FIELD_UPDATED = 'FIELD_UPDATED',
  FIELD_UPDATING = 'FIELD_UPDATING',
  GROUP_ADDED = 'GROUP_ADDED',
  GROUP_ADDING = 'GROUP_ADDING',
  GROUP_DELETED = 'GROUP_DELETED',
  GROUP_DELETING = 'GROUP_DELETING',
  GROUP_UPDATED = 'GROUP_UPDATED',
  GROUP_UPDATING = 'GROUP_UPDATING',
  GROUP_USER_ADDED = 'GROUP_USER_ADDED',
  GROUP_USER_ADDING = 'GROUP_USER_ADDING',
  GROUP_USER_DELETED = 'GROUP_USER_DELETED',
  GROUP_USER_DELETING = 'GROUP_USER_DELETING',
  INHERITANCE_BREAKING = 'INHERITANCE_BREAKING',
  INHERITANCE_BROKEN = 'INHERITANCE_BROKEN',
  INHERITANCE_RESET = 'INHERITANCE_RESET',
  INHERITANCE_RESETTING = 'INHERITANCE_RESETTING',
  INVALID_RECEIVER = 'INVALID_RECEIVER',
  ITEM_ADDED = 'ITEM_ADDED',
  ITEM_ADDING = 'ITEM_ADDING',
  ITEM_ATTACHMENT_ADDED = 'ITEM_ATTACHMENT_ADDED',
  ITEM_ATTACHMENT_ADDING = 'ITEM_ATTACHMENT_ADDING',
  ITEM_ATTACHMENT_DELETED = 'ITEM_ATTACHMENT_DELETED',
  ITEM_ATTACHMENT_DELETING = 'ITEM_ATTACHMENT_DELETING',
  ITEM_CHECKED_IN = 'ITEM_CHECKED_IN',
  ITEM_CHECKED_OUT = 'ITEM_CHECKED_OUT',
  ITEM_CHECKING_IN = 'ITEM_CHECKING_IN',
  ITEM_CHECKING_OUT = 'ITEM_CHECKING_OUT',
  ITEM_DELETED = 'ITEM_DELETED',
  ITEM_DELETING = 'ITEM_DELETING',
  ITEM_FILE_CONVERTED = 'ITEM_FILE_CONVERTED',
  ITEM_FILE_MOVED = 'ITEM_FILE_MOVED',
  ITEM_FILE_MOVING = 'ITEM_FILE_MOVING',
  ITEM_UNCHECKED_OUT = 'ITEM_UNCHECKED_OUT',
  ITEM_UNCHECKING_OUT = 'ITEM_UNCHECKING_OUT',
  ITEM_UPDATED = 'ITEM_UPDATED',
  ITEM_UPDATING = 'ITEM_UPDATING',
  ITEM_VERSION_DELETED = 'ITEM_VERSION_DELETED',
  ITEM_VERSION_DELETING = 'ITEM_VERSION_DELETING',
  LIST_ADDED = 'LIST_ADDED',
  LIST_ADDING = 'LIST_ADDING',
  LIST_DELETED = 'LIST_DELETED',
  LIST_DELETING = 'LIST_DELETING',
  ROLE_ASSIGNMENT_ADDED = 'ROLE_ASSIGNMENT_ADDED',
  ROLE_ASSIGNMENT_ADDING = 'ROLE_ASSIGNMENT_ADDING',
  ROLE_ASSIGNMENT_DELETED = 'ROLE_ASSIGNMENT_DELETED',
  ROLE_ASSIGNMENT_DELETING = 'ROLE_ASSIGNMENT_DELETING',
  ROLE_DEFINITION_ADDED = 'ROLE_DEFINITION_ADDED',
  ROLE_DEFINITION_ADDING = 'ROLE_DEFINITION_ADDING',
  ROLE_DEFINITION_DELETED = 'ROLE_DEFINITION_DELETED',
  ROLE_DEFINITION_DELETING = 'ROLE_DEFINITION_DELETING',
  ROLE_DEFINITION_UPDATED = 'ROLE_DEFINITION_UPDATED',
  ROLE_DEFINITION_UPDATING = 'ROLE_DEFINITION_UPDATING',
  SITE_DELETED = 'SITE_DELETED',
  SITE_DELETING = 'SITE_DELETING',
  WEB_ADDING = 'WEB_ADDING',
  WEB_DELETED = 'WEB_DELETED',
  WEB_DELETING = 'WEB_DELETING',
  WEB_MOVED = 'WEB_MOVED',
  WEB_MOVING = 'WEB_MOVING',
  WEB_PROVISIONED = 'WEB_PROVISIONED',
  WORKFLOW_COMPLETED = 'WORKFLOW_COMPLETED',
  WORKFLOW_POSTPONED = 'WORKFLOW_POSTPONED',
  WORKFLOW_STARTED = 'WORKFLOW_STARTED',
  WORKFLOW_STARTING = 'WORKFLOW_STARTING',
}

export type EventReceiverTypeOperationFilterInput = {
  eq?: InputMaybe<EventReceiverType>;
  in?: InputMaybe<Array<EventReceiverType>>;
  neq?: InputMaybe<EventReceiverType>;
  nin?: InputMaybe<Array<EventReceiverType>>;
};

export type Extension = {
  additionalData?: Maybe<Array<KeyValuePairOfNullableStringAndNullableObject>>;
  id?: Maybe<Scalars['String']['output']>;
  oDataType?: Maybe<Scalars['String']['output']>;
};

export type ExternalReference = {
  additionalData?: Maybe<Array<KeyValuePairOfNullableStringAndNullableObject>>;
  alias?: Maybe<Scalars['String']['output']>;
  lastModifiedBy?: Maybe<IdentitySet>;
  lastModifiedDateTime?: Maybe<Scalars['DateTime']['output']>;
  oDataType?: Maybe<Scalars['String']['output']>;
  previewPriority?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ExternalReferenceFilterInput = {
  additionalData?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndObjectFilterInput>;
  alias?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ExternalReferenceFilterInput>>;
  lastModifiedBy?: InputMaybe<IdentitySetFilterInput>;
  lastModifiedDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  oDataType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ExternalReferenceFilterInput>>;
  previewPriority?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type ExternalReferenceInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type FavoritePlansConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<FavoritePlansEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Plan>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FavoritePlansEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Plan;
};

export enum FieldIndexStatus {
  DISABLING = 'DISABLING',
  ENABLING = 'ENABLING',
  INDEXED = 'INDEXED',
  NONE = 'NONE',
}

export type FieldIndexStatusOperationFilterInput = {
  eq?: InputMaybe<FieldIndexStatus>;
  in?: InputMaybe<Array<FieldIndexStatus>>;
  neq?: InputMaybe<FieldIndexStatus>;
  nin?: InputMaybe<Array<FieldIndexStatus>>;
};

export enum FieldType {
  ALL_DAY_EVENT = 'ALL_DAY_EVENT',
  ATTACHMENTS = 'ATTACHMENTS',
  BOOLEAN = 'BOOLEAN',
  CALCULATED = 'CALCULATED',
  CHOICE = 'CHOICE',
  COMPUTED = 'COMPUTED',
  CONTENT_TYPE_ID = 'CONTENT_TYPE_ID',
  COUNTER = 'COUNTER',
  CROSS_PROJECT_LINK = 'CROSS_PROJECT_LINK',
  CURRENCY = 'CURRENCY',
  DATE_TIME = 'DATE_TIME',
  ERROR = 'ERROR',
  FILE = 'FILE',
  GRID_CHOICE = 'GRID_CHOICE',
  GUID = 'GUID',
  INTEGER = 'INTEGER',
  INVALID = 'INVALID',
  LOOKUP = 'LOOKUP',
  MAX_ITEMS = 'MAX_ITEMS',
  MOD_STAT = 'MOD_STAT',
  MULTI_CHOICE = 'MULTI_CHOICE',
  NOTE = 'NOTE',
  NUMBER = 'NUMBER',
  PAGE_SEPARATOR = 'PAGE_SEPARATOR',
  RECURRENCE = 'RECURRENCE',
  TEXT = 'TEXT',
  THREADING = 'THREADING',
  THREAD_INDEX = 'THREAD_INDEX',
  URL = 'URL',
  USER = 'USER',
  WORKFLOW_EVENT_TYPE = 'WORKFLOW_EVENT_TYPE',
  WORKFLOW_STATUS = 'WORKFLOW_STATUS',
}

export type FieldTypeOperationFilterInput = {
  eq?: InputMaybe<FieldType>;
  in?: InputMaybe<Array<FieldType>>;
  neq?: InputMaybe<FieldType>;
  nin?: InputMaybe<Array<FieldType>>;
};

export enum FieldUserSelectionMode {
  PEOPLE_AND_GROUPS = 'PEOPLE_AND_GROUPS',
  PEOPLE_ONLY = 'PEOPLE_ONLY',
}

export type FieldUserSelectionModeOperationFilterInput = {
  eq?: InputMaybe<FieldUserSelectionMode>;
  in?: InputMaybe<Array<FieldUserSelectionMode>>;
  neq?: InputMaybe<FieldUserSelectionMode>;
  nin?: InputMaybe<Array<FieldUserSelectionMode>>;
};

export type FilePreview = {
  getUrl?: Maybe<Scalars['String']['output']>;
  postParameters?: Maybe<Scalars['String']['output']>;
  postUrl?: Maybe<Scalars['String']['output']>;
};

export enum FileSystemObjectType {
  FILE = 'FILE',
  FOLDER = 'FOLDER',
  INVALID = 'INVALID',
  WEB = 'WEB',
}

export type FileSystemObjectTypeOperationFilterInput = {
  eq?: InputMaybe<FileSystemObjectType>;
  in?: InputMaybe<Array<FileSystemObjectType>>;
  neq?: InputMaybe<FileSystemObjectType>;
  nin?: InputMaybe<Array<FileSystemObjectType>>;
};

export type FloatOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']['input']>;
  _gt?: InputMaybe<Scalars['Float']['input']>;
  _gte?: InputMaybe<Scalars['Float']['input']>;
  _in?: InputMaybe<Array<Scalars['Float']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Float']['input']>;
  _lte?: InputMaybe<Scalars['Float']['input']>;
  _neq?: InputMaybe<Scalars['Float']['input']>;
  _nin?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FollowupFlag = {
  additionalData?: Maybe<Array<KeyValuePairOfNullableStringAndNullableObject>>;
  completedDateTime?: Maybe<DateTimeTimeZone>;
  dueDateTime?: Maybe<DateTimeTimeZone>;
  flagStatus?: Maybe<FollowupFlagStatus>;
  oDataType?: Maybe<Scalars['String']['output']>;
  startDateTime?: Maybe<DateTimeTimeZone>;
};

export type FollowupFlagFilterInput = {
  additionalData?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndObjectFilterInput>;
  and?: InputMaybe<Array<FollowupFlagFilterInput>>;
  completedDateTime?: InputMaybe<DateTimeTimeZoneFilterInput>;
  dueDateTime?: InputMaybe<DateTimeTimeZoneFilterInput>;
  flagStatus?: InputMaybe<NullableOfFollowupFlagStatusOperationFilterInput>;
  oDataType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FollowupFlagFilterInput>>;
  startDateTime?: InputMaybe<DateTimeTimeZoneFilterInput>;
};

export type FollowupFlagSortInput = {
  completedDateTime?: InputMaybe<DateTimeTimeZoneSortInput>;
  dueDateTime?: InputMaybe<DateTimeTimeZoneSortInput>;
  flagStatus?: InputMaybe<SortEnumType>;
  oDataType?: InputMaybe<SortEnumType>;
  startDateTime?: InputMaybe<DateTimeTimeZoneSortInput>;
};

export enum FollowupFlagStatus {
  COMPLETE = 'COMPLETE',
  FLAGGED = 'FLAGGED',
  NOT_FLAGGED = 'NOT_FLAGGED',
}

export enum FooterLayoutType {
  EXTENDED = 'EXTENDED',
  SIMPLE = 'SIMPLE',
  STACKED = 'STACKED',
}

export enum FooterVariantThemeType {
  NEUTRAL = 'NEUTRAL',
  NONE = 'NONE',
  SOFT = 'SOFT',
  STRONG = 'STRONG',
}

/**
 * One facet field returned by the search — its index field name and the list of value buckets.
 * Maps from a single entry in @search.facets in the Azure AI Search response.
 * Example: Name = "Category", Values = [{ Value = "Budget", Count = 13 }, ...].
 */
export type GraphFacet = {
  /** The index field name the facet was computed for (e.g. "Category", "Tags"). */
  name: Scalars['String']['output'];
  /** The value buckets for this facet, each with a label and document count. */
  values: Array<GraphFacetValue>;
};

/** GraphQL facet value DTO. */
export type GraphFacetValue = {
  /** Gets or sets the number of documents with the facet value. */
  count: Scalars['Long']['output'];
  /** Gets or sets the facet value. */
  value: Scalars['String']['output'];
};

/**
 * GraphQL document DTO returned by resolvers.
 * Schema-agnostic: works unchanged for any Azure AI Search index
 * (ml-personnel, ml-matters, ml-legal, ml-documents, etc.).
 */
export type GraphSearchDocument = {
  /**
   * Gets or sets the 1-based absolute cursor position of this document within the
   * full result set. Equals the numeric value of the edge cursor for this item.
   * Useful for tracking which page position a document occupies without parsing
   * pageInfo.startCursor / endCursor.
   * null when the document was fetched by key (no cursor context).
   */
  cursorNumber?: Maybe<Scalars['Int']['output']>;
  /**
   * Gets or sets all document fields as a dynamic JSON object (Any scalar).
   * Mirrors SearchResult<AzureSearchDocument>.Document — contains every
   * field the index returns regardless of the index schema (EmployeeId,
   * ETLLastModifiedDate, NameFull, nested objects, arrays, etc.).
   */
  document?: Maybe<Scalars['Any']['output']>;
  /**
   * Gets or sets the highlight snippets from @search.highlights.
   * Null unless SearchInput.HighlightFields was provided AND the search
   * term appears in one of the requested fields.
   */
  highlights?: Maybe<Scalars['Highlights']['output']>;
  /**
   * Gets or sets the BM25 relevance score from @search.score.
   * Maps directly from SearchResult<AzureSearchDocument>.Score.
   * Present on search results; null for key-lookup operations.
   */
  score?: Maybe<Scalars['Float']['output']>;
};

/** GraphQL DTO representing a single Azure AI Search index. */
export type GraphSearchIndex = {
  /** The name of the Azure AI Search index. */
  name: Scalars['String']['output'];
};

export type Group = {
  classification?: Maybe<Scalars['String']['output']>;
  createdDateTime: Scalars['DateTime']['output'];
  deletedDateTime: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  expirationDateTime: Scalars['DateTime']['output'];
  groupType: GroupType;
  groupTypes?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Scalars['String']['output']>;
  isAssignableToRole: Scalars['Boolean']['output'];
  mail?: Maybe<Scalars['String']['output']>;
  mailEnabled: Scalars['Boolean']['output'];
  mailNickname?: Maybe<Scalars['String']['output']>;
  members?: Maybe<MembersConnection>;
  membershipRule?: Maybe<Scalars['String']['output']>;
  membershipRuleProcessingState?: Maybe<Scalars['String']['output']>;
  onPremisesDomainName?: Maybe<Scalars['String']['output']>;
  onPremisesLastSyncDateTime: Scalars['DateTime']['output'];
  onPremisesNetBiosName?: Maybe<Scalars['String']['output']>;
  onPremisesSamAccountName?: Maybe<Scalars['String']['output']>;
  onPremisesSecurityIdentifier?: Maybe<Scalars['String']['output']>;
  onPremisesSyncEnabled: Scalars['Boolean']['output'];
  plans?: Maybe<PlansConnection>;
  preferredDataLocation?: Maybe<Scalars['String']['output']>;
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  proxyAddresses?: Maybe<Array<Scalars['String']['output']>>;
  renewedDateTime: Scalars['DateTime']['output'];
  securityEnabled: Scalars['Boolean']['output'];
  securityIdentifier?: Maybe<Scalars['String']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

export type GroupMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserSortInput>>;
  where?: InputMaybe<UserFilterInput>;
};

export type GroupPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PlanSortInput>>;
  where?: InputMaybe<PlanFilterInput>;
};

export enum GroupType {
  DISTRIBUTION = 'DISTRIBUTION',
  MAIL_ENABLED_SECURITY = 'MAIL_ENABLED_SECURITY',
  MICROSOFT365 = 'MICROSOFT365',
  SECURITY = 'SECURITY',
}

/** A connection to a list of items. */
export type GroupsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<GroupsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Group>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type GroupsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Group;
};

export enum HeaderLayoutType {
  COMPACT = 'COMPACT',
  EXTENDED = 'EXTENDED',
  MINIMAL = 'MINIMAL',
  NONE = 'NONE',
  STANDARD = 'STANDARD',
}

/** List item attachment. Attachment object represents a file or document linked to a specific list item. Attachments allow users to associate additional files, such as images, documents, or multimedia, with a list item. */
export type IAttachment = {
  /** Returns the name of the attachment. */
  fileName?: Maybe<Scalars['String']['output']>;
  /** Returns the name of the attachment as path. */
  fileNameAsPath?: Maybe<Scalars['String']['output']>;
  /** Returns the server relative URL of the attachment as path. */
  serverRelativePath?: Maybe<Scalars['String']['output']>;
  /** Returns the Server relative URL of the attachment. */
  serverRelativeUrl?: Maybe<Scalars['String']['output']>;
};

export type IAttachmentFilterInput = {
  and?: InputMaybe<Array<IAttachmentFilterInput>>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  fileNameAsPath?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IAttachmentFilterInput>>;
  serverRelativePath?: InputMaybe<StringOperationFilterInput>;
  serverRelativeUrl?: InputMaybe<StringOperationFilterInput>;
};

export type IBasePermissionsFilterInput = {
  and?: InputMaybe<Array<IBasePermissionsFilterInput>>;
  high?: InputMaybe<LongOperationFilterInput>;
  low?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<IBasePermissionsFilterInput>>;
};

/** Represents a comment associated with a document, list item, or other content within a SharePoint site. Comments are essential for facilitating communication and collaboration among users working with SharePoint documents and data. */
export type IComment = {
  /** Returns the comment author. */
  author?: Maybe<ISharePointSharingPrincipal>;
  /** Returns the comment's creation date.. */
  createdDate: Scalars['DateTime']['output'];
  /** Returns the comment id. */
  id?: Maybe<Scalars['String']['output']>;
  /** Returns the flag that indicates whether the user in the current context liked the comment. */
  isLikedByUser: Scalars['Boolean']['output'];
  /** Returns a boolean value indicating whether a Comment is a reply to another comment. */
  isReply: Scalars['Boolean']['output'];
  /** Returns the comment item id. */
  itemId: Scalars['Int']['output'];
  /** Returns the number of likes for the Comment. */
  likeCount: Scalars['Int']['output'];
  /** Returns the comment list id. */
  listId: Scalars['UUID']['output'];
  /** Returns the list of users who are at mentioned in this comment. */
  mentions: Array<ICommentLikeUserEntity>;
  /** Returns the comment's parent ID (0 if not a reply). */
  parentId?: Maybe<Scalars['String']['output']>;
  /** Returns the replies to the comment. */
  replies: Array<IComment>;
  /** Returns the number of replies to the comment. */
  replyCount: Scalars['Int']['output'];
  /** Returns the comment text. */
  text?: Maybe<Scalars['String']['output']>;
};

/** Represents a user entity associated with comments and likes within a SharePoint environment. It encapsulates user-related information, such as user ID, display name, or user profile details, connected to comments and likes made on SharePoint documents, list items, or other collaborative content.. */
export type ICommentLikeUserEntity = {
  /** Returns the user's numerical ID. */
  id: Scalars['Int']['output'];
  /** Returns the user's loginName. */
  loginName?: Maybe<Scalars['String']['output']>;
  /** Returns the user's email. */
  mail?: Maybe<Scalars['String']['output']>;
  /** Returns the user's name. */
  name?: Maybe<Scalars['String']['output']>;
};

export type ICommentLikeUserEntityFilterInput = {
  and?: InputMaybe<Array<ICommentLikeUserEntityFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  loginName?: InputMaybe<StringOperationFilterInput>;
  mail?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ICommentLikeUserEntityFilterInput>>;
};

/** Content types define the metadata, behavior, and document template for items in SharePoint lists or document libraries. Each content type encapsulates a set of columns or fields, enabling users to categorize, organize, and manage various types of content effectively. */
export type IContentType = {
  /** Returns the Client Form Custom Formatter of the Content Type. */
  clientFormCustomFormatter?: Maybe<Scalars['String']['output']>;
  /** Returns the description of the Content Type. */
  description?: Maybe<Scalars['String']['output']>;
  /** Returns the Display Form template name of the Content Type. */
  displayFormTemplateName?: Maybe<Scalars['String']['output']>;
  /** Returns the Display Form URL of the Content Type. */
  displayFormUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the Document Template of the Content Type. */
  documentTemplate?: Maybe<Scalars['String']['output']>;
  /** Returns the DocumentTemplate URL of the Content Type. */
  documentTemplateUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the Edit Form template name of the Content Type. */
  editFormTemplateName?: Maybe<Scalars['String']['output']>;
  /** Returns the Mobile Edit Form URL of the Content Type. */
  editFormUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the group of the Content Type. */
  group?: Maybe<Scalars['String']['output']>;
  /** Returns a bollean value indicating whether the Content Type is hidden. */
  hidden: Scalars['Boolean']['output'];
  /** Returns the unique ID of the Content Type as object. */
  id?: Maybe<Scalars['String']['output']>;
  /** Returns the JS Link of the Content Type. */
  jsLink?: Maybe<Scalars['String']['output']>;
  /** Returns the Mobile Display Form URL of the Content Type. */
  mobileDisplayFormUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the Mobile Edit Form URL of the Content Type. */
  mobileEditFormUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the Mobile New Form URL of the Content Type. */
  mobileNewFormUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the name of the Content Type. */
  name?: Maybe<Scalars['String']['output']>;
  /** Returns the New Form template's name of the Content Type. */
  newFormTemplateName?: Maybe<Scalars['String']['output']>;
  /** Returns the New Form URL of the Content Type. */
  newFormUrl?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean value indicating whether the Content Type is read only. */
  readOnly: Scalars['Boolean']['output'];
  /** Returns a string value indicating the Schema XML of the Content Type. */
  schemaXml?: Maybe<Scalars['String']['output']>;
  /** Returns a string value of the Schema XML with resource tokens of the Content Type. */
  schemaXmlWithResourceTokens?: Maybe<Scalars['String']['output']>;
  /** Returns the scope of the Content Type. */
  scope?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean value indicating whether the Content Type is sealed. */
  sealed: Scalars['Boolean']['output'];
  /** Returns the unique ID of the Content Type as string. */
  stringId?: Maybe<Scalars['String']['output']>;
};

export type IContentTypeFilterInput = {
  and?: InputMaybe<Array<IContentTypeFilterInput>>;
  clientFormCustomFormatter?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  displayFormClientSideComponentId?: InputMaybe<StringOperationFilterInput>;
  displayFormClientSideComponentProperties?: InputMaybe<StringOperationFilterInput>;
  displayFormTemplateName?: InputMaybe<StringOperationFilterInput>;
  displayFormUrl?: InputMaybe<StringOperationFilterInput>;
  documentTemplate?: InputMaybe<StringOperationFilterInput>;
  documentTemplateUrl?: InputMaybe<StringOperationFilterInput>;
  editFormClientSideComponentId?: InputMaybe<StringOperationFilterInput>;
  editFormClientSideComponentProperties?: InputMaybe<StringOperationFilterInput>;
  editFormTemplateName?: InputMaybe<StringOperationFilterInput>;
  editFormUrl?: InputMaybe<StringOperationFilterInput>;
  fieldLinks?: InputMaybe<ListFilterInputTypeOfIFieldLinkFilterInput>;
  fields?: InputMaybe<ListFilterInputTypeOfIFieldFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  hidden?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  jsLink?: InputMaybe<StringOperationFilterInput>;
  mobileDisplayFormUrl?: InputMaybe<StringOperationFilterInput>;
  mobileEditFormUrl?: InputMaybe<StringOperationFilterInput>;
  mobileNewFormUrl?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  newFormClientSideComponentId?: InputMaybe<StringOperationFilterInput>;
  newFormClientSideComponentProperties?: InputMaybe<StringOperationFilterInput>;
  newFormTemplateName?: InputMaybe<StringOperationFilterInput>;
  newFormUrl?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IContentTypeFilterInput>>;
  readOnly?: InputMaybe<BooleanOperationFilterInput>;
  schemaXml?: InputMaybe<StringOperationFilterInput>;
  schemaXmlWithResourceTokens?: InputMaybe<StringOperationFilterInput>;
  scope?: InputMaybe<StringOperationFilterInput>;
  sealed?: InputMaybe<BooleanOperationFilterInput>;
  stringId?: InputMaybe<StringOperationFilterInput>;
};

export type IContentTypeIdCollectionFilterInput = {
  and?: InputMaybe<Array<IContentTypeIdCollectionFilterInput>>;
  or?: InputMaybe<Array<IContentTypeIdCollectionFilterInput>>;
};

export type IEffectiveInformationRightsManagementSettingsFilterInput = {
  allowPrint?: InputMaybe<BooleanOperationFilterInput>;
  allowScript?: InputMaybe<BooleanOperationFilterInput>;
  allowWriteCopy?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<IEffectiveInformationRightsManagementSettingsFilterInput>>;
  disableDocumentBrowserView?: InputMaybe<BooleanOperationFilterInput>;
  documentAccessExpireDays?: InputMaybe<IntOperationFilterInput>;
  documentLibraryProtectionExpireDate?: InputMaybe<DateTimeOperationFilterInput>;
  enableDocumentAccessExpire?: InputMaybe<BooleanOperationFilterInput>;
  enableDocumentBrowserPublishingView?: InputMaybe<BooleanOperationFilterInput>;
  enableGroupProtection?: InputMaybe<BooleanOperationFilterInput>;
  enableLicenseCacheExpire?: InputMaybe<BooleanOperationFilterInput>;
  groupName?: InputMaybe<StringOperationFilterInput>;
  irmEnabled?: InputMaybe<BooleanOperationFilterInput>;
  licenseCacheExpireDays?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<IEffectiveInformationRightsManagementSettingsFilterInput>>;
  policyDescription?: InputMaybe<StringOperationFilterInput>;
  policyTitle?: InputMaybe<StringOperationFilterInput>;
  settingSource?: InputMaybe<SpEffectiveInformationRightsManagementSettingsSourceOperationFilterInput>;
  templateId?: InputMaybe<StringOperationFilterInput>;
};

export type IEventReceiverDefinitionFilterInput = {
  and?: InputMaybe<Array<IEventReceiverDefinitionFilterInput>>;
  eventType?: InputMaybe<EventReceiverTypeOperationFilterInput>;
  or?: InputMaybe<Array<IEventReceiverDefinitionFilterInput>>;
  receiverAssembly?: InputMaybe<StringOperationFilterInput>;
  receiverClass?: InputMaybe<StringOperationFilterInput>;
  receiverId?: InputMaybe<UuidOperationFilterInput>;
  receiverName?: InputMaybe<StringOperationFilterInput>;
  receiverUrl?: InputMaybe<StringOperationFilterInput>;
  sequenceNumber?: InputMaybe<IntOperationFilterInput>;
  synchronization?: InputMaybe<EventReceiverSynchronizationOperationFilterInput>;
};

/** Represents a set of functionalities or components that can be activated or deactivated at various levels within a SharePoint site collection. Features enable users to extend the capabilities of SharePoint Online by adding new functionalities, templates, workflows, or web parts. */
export type IFeature = {
  /** Returns the ID of the Feature. */
  definitionId: Scalars['UUID']['output'];
  /** Returns the name of the feature. */
  displayName?: Maybe<Scalars['String']['output']>;
};

/** Represents a specific data type or property within a list or document library. Fields define the type of information that can be stored in a SharePoint list item or document. These fields can include various data types, such as text, numbers, dates, choices, or even complex data structures */
export type IField = {
  /** Returns whether to allow display of the user name */
  allowDisplay: RelationshipDeleteBehaviorType;
  /** Returns a boolean flag indicating whether a hyperlink is allowed as a value of the field. */
  allowHyperlink?: Maybe<Scalars['Boolean']['output']>;
  /** Returns whether or not multiple values are allowed */
  allowMultipleValues: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether all changes to the value of the field are displayed in list forms. */
  appendOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Returns a boolean flag indicating whether the field is auto-indexed. */
  autoIndexed: Scalars['Boolean']['output'];
  /** Returns a boolean flag that specifies whether or not the field can be deleted. */
  canBeDeleted: Scalars['Boolean']['output'];
  /** Returns the choices of a choice field */
  choices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Returns the client side component Id associated with the field. */
  clientSideComponentId: Scalars['UUID']['output'];
  /** Returns the properties of the client side component associated with the field. */
  clientSideComponentProperties?: Maybe<Scalars['String']['output']>;
  /** Returns the validation formula. */
  clientValidationFormula?: Maybe<Scalars['String']['output']>;
  /** Returns the client validation message of the field. */
  clientValidationMessage?: Maybe<Scalars['String']['output']>;
  /** Returns the Locale Id of the currency. */
  currencyLocaleId?: Maybe<Scalars['Int']['output']>;
  /** Returns the custom formatter of the field. */
  customFormatter?: Maybe<Scalars['String']['output']>;
  /** Returns the date format valid for DateTime and Calculated fields. */
  dateFormat?: Maybe<DateTimeFieldFormatType>;
  /** Returns the type of calendar */
  dateTimeCalendarType: CalendarType;
  /** Returns the default formula for a calculated field. */
  defaultFormula?: Maybe<Scalars['String']['output']>;
  /** Returns the default value of the field. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Returns the dependent lookup internal names for a field */
  dependentLookupInternalNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Returns the description of the field. */
  description?: Maybe<Scalars['String']['output']>;
  /** Returns the direction of the reading order for the field. A string that contains LTR if the reading order is left-to-right, RTL if it is right-to-left or none. */
  direction?: Maybe<Scalars['String']['output']>;
  /** Returns the display format of the field. CAUTION: This is an integer value, as the display format enum may change based on the field type. */
  displayFormat?: Maybe<Scalars['Int']['output']>;
  /** Determines whether to display the choice field as radio buttons or as a drop-down list. */
  editFormat?: Maybe<ChoiceFormatType>;
  /** Returns whether the lookup should be enabled for computed fields */
  enableLookup: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the field enforces unique values. */
  enforceUniqueValues: Scalars['Boolean']['output'];
  /** Returns the name of the entity property for the list item entity that uses this field. */
  entityPropertyName?: Maybe<Scalars['String']['output']>;
  /** Extracts and returns the formula associated with a SharePoint field. */
  fieldFormula: Scalars['String']['output'];
  /** Returns the type of the field. */
  fieldTypeKind: FieldType;
  /** Returns whether the user can fill in their own choice */
  fillInChoice: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the field can be filtered. */
  filterable: Scalars['Boolean']['output'];
  /** Returns the formula of a calculated field as string */
  formula?: Maybe<Scalars['String']['output']>;
  /** Returns the friendly format type of a date time field */
  friendlyDisplayFormat: DateTimeFieldFriendlyFormatType;
  /** Returns a boolean flag indicating whether the field derives from a base field type. */
  fromBaseType: Scalars['Boolean']['output'];
  /** Returns the group of the field. */
  group?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean flag indicating whether the field is displayed in the list. */
  hidden: Scalars['Boolean']['output'];
  /** Provides the id of the field. */
  id: Scalars['UUID']['output'];
  /** Describes whether a field is indexed, and whether the data in the index is complete. */
  indexStatus: FieldIndexStatus;
  /** Returns a boolean flag indicating whether the field is indexed. */
  indexed: Scalars['Boolean']['output'];
  /** Specifies the internal name of the field. */
  internalName?: Maybe<Scalars['String']['output']>;
  /** Returns whether the lookup field is dependent */
  isDependentLookup: Scalars['Boolean']['output'];
  /** Returns whether the lookup field is discoverable from the List being looked up to */
  isRelationship: Scalars['Boolean']['output'];
  /** Returns the name of an external JS file containing any client rendering logic for fields of this type. */
  jsLink?: Maybe<Scalars['String']['output']>;
  /** Returns the name of the Field used as the lookup values */
  lookupField?: Maybe<Scalars['String']['output']>;
  /** Returns the GUID of the List that contains the Field to use as the lookup values */
  lookupList?: Maybe<Scalars['String']['output']>;
  /** Returns the id of the Site that contains the List which contains the Field used as the lookup values */
  lookupWebId: Scalars['UUID']['output'];
  /** Returns the mappings of a choice field */
  mappings?: Maybe<Scalars['String']['output']>;
  /** Returns the maximum number of characters that can be typed in the field. */
  maxLength?: Maybe<Scalars['Int']['output']>;
  /** Returns the maximum value of a number field */
  maximumValue: Scalars['Float']['output'];
  /** Returns the minimum value of a number field */
  minimumValue: Scalars['Float']['output'];
  /** Returns an integer value that specifies the number of lines of text to display for the field. */
  numberOfLines?: Maybe<Scalars['Int']['output']>;
  /** Returns the type of a calculated field */
  outputType: FieldType;
  /** Returns whether to display the presence of the user */
  presence: RelationshipDeleteBehaviorType;
  /** Returns the GUID of the primary lookup field if this is a dependent lookup field. */
  primaryFieldId?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean flag indicating whether values in the field can be modified. */
  readOnlyField: Scalars['Boolean']['output'];
  /** Specifies the behavior of the lookup field */
  relationshipDeleteBehavior: RelationshipDeleteBehaviorType;
  /** Returns a boolean flag indicating whether the field is required. */
  required: Scalars['Boolean']['output'];
  /** Return a boolean flag indicating whether the field supports a subset of rich formatting. */
  restrictedMode?: Maybe<Scalars['Boolean']['output']>;
  /** Returns a boolean flag indicating whether the field supports rich formatting. */
  richText?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies the schema that defines the field. */
  schemaXml?: Maybe<Scalars['String']['output']>;
  /** Specifies the ServerRelativeUrl of the of the web site folder in which the field belongs to. */
  scope?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean flag indicating whether the field can be changed or deleted. */
  sealed: Scalars['Boolean']['output'];
  /** Returns the Id of the group to which the users to select belong to */
  selectionGroup: RelationshipDeleteBehaviorType;
  /** Returns the selection mode of the user field */
  selectionMode: RelationshipDeleteBehaviorType;
  /** Returns a boolean flag indicating whether the field should be shown as a percentage, valid for Number and Calculated fields. */
  showAsPercentage?: Maybe<Scalars['Boolean']['output']>;
  /** Represents status to determine whether filters pane will show the field. */
  showInFiltersPane: ShowInFiltersPaneStatus;
  /** Returns a boolean flag indicating whether the field can be sorted. */
  sortable: Scalars['Boolean']['output'];
  /** Returns the static name of the field. */
  staticName?: Maybe<Scalars['String']['output']>;
  /** Returns the title of the field. */
  title?: Maybe<Scalars['String']['output']>;
  /** Returns the FieldTypeKind of the field as a string value. */
  typeAsString?: Maybe<Scalars['String']['output']>;
  /** Returns the display name for FieldTypeKind of the field. */
  typeDisplayName?: Maybe<Scalars['String']['output']>;
  /** Returns the description of the FieldTypeKind of the field. */
  typeShortDescription?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean flag indicating whether the field supports unlimited length in document libraries. */
  unlimitedLengthInDocumentLibrary?: Maybe<Scalars['Boolean']['output']>;
  /** Returns the formula referred by the field and gets evaluated when a list item is added or updated in the list. */
  validationFormula?: Maybe<Scalars['String']['output']>;
  /** Returns the message to display if validation formula fails for the field when a list item is added or updated in the list. */
  validationMessage?: Maybe<Scalars['String']['output']>;
};

export type IFieldFilterInput = {
  allowDisplay?: InputMaybe<BooleanOperationFilterInput>;
  allowHyperlink?: InputMaybe<BooleanOperationFilterInput>;
  allowMultipleValues?: InputMaybe<BooleanOperationFilterInput>;
  anchorId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<IFieldFilterInput>>;
  appendOnly?: InputMaybe<BooleanOperationFilterInput>;
  autoIndexed?: InputMaybe<BooleanOperationFilterInput>;
  canBeDeleted?: InputMaybe<BooleanOperationFilterInput>;
  choices?: InputMaybe<ListStringOperationFilterInput>;
  clientSideComponentId?: InputMaybe<UuidOperationFilterInput>;
  clientSideComponentProperties?: InputMaybe<StringOperationFilterInput>;
  clientValidationFormula?: InputMaybe<StringOperationFilterInput>;
  clientValidationMessage?: InputMaybe<StringOperationFilterInput>;
  createValuesInEditForm?: InputMaybe<BooleanOperationFilterInput>;
  currencyLocaleId?: InputMaybe<IntOperationFilterInput>;
  customFormatter?: InputMaybe<StringOperationFilterInput>;
  dateFormat?: InputMaybe<DateTimeFieldFormatTypeOperationFilterInput>;
  dateTimeCalendarType?: InputMaybe<CalendarTypeOperationFilterInput>;
  defaultFormula?: InputMaybe<StringOperationFilterInput>;
  dependentLookupInternalNames?: InputMaybe<ListStringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  direction?: InputMaybe<StringOperationFilterInput>;
  displayFormat?: InputMaybe<IntOperationFilterInput>;
  editFormat?: InputMaybe<ChoiceFormatTypeOperationFilterInput>;
  enableLookup?: InputMaybe<BooleanOperationFilterInput>;
  enforceUniqueValues?: InputMaybe<BooleanOperationFilterInput>;
  entityPropertyName?: InputMaybe<StringOperationFilterInput>;
  fieldTypeKind?: InputMaybe<FieldTypeOperationFilterInput>;
  fillInChoice?: InputMaybe<BooleanOperationFilterInput>;
  filterable?: InputMaybe<BooleanOperationFilterInput>;
  formula?: InputMaybe<StringOperationFilterInput>;
  friendlyDisplayFormat?: InputMaybe<DateTimeFieldFriendlyFormatTypeOperationFilterInput>;
  fromBaseType?: InputMaybe<BooleanOperationFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  hidden?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  indexStatus?: InputMaybe<FieldIndexStatusOperationFilterInput>;
  indexed?: InputMaybe<BooleanOperationFilterInput>;
  internalName?: InputMaybe<StringOperationFilterInput>;
  isAnchorValid?: InputMaybe<BooleanOperationFilterInput>;
  isDependentLookup?: InputMaybe<BooleanOperationFilterInput>;
  isKeyword?: InputMaybe<BooleanOperationFilterInput>;
  isPathRendered?: InputMaybe<BooleanOperationFilterInput>;
  isRelationship?: InputMaybe<BooleanOperationFilterInput>;
  isTermSetValid?: InputMaybe<BooleanOperationFilterInput>;
  jsLink?: InputMaybe<StringOperationFilterInput>;
  lookupField?: InputMaybe<StringOperationFilterInput>;
  lookupList?: InputMaybe<StringOperationFilterInput>;
  lookupWebId?: InputMaybe<UuidOperationFilterInput>;
  mappings?: InputMaybe<StringOperationFilterInput>;
  maxLength?: InputMaybe<IntOperationFilterInput>;
  maximumValue?: InputMaybe<FloatOperationFilterInput>;
  minimumValue?: InputMaybe<FloatOperationFilterInput>;
  numberOfLines?: InputMaybe<IntOperationFilterInput>;
  open?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<IFieldFilterInput>>;
  outputType?: InputMaybe<FieldTypeOperationFilterInput>;
  presence?: InputMaybe<BooleanOperationFilterInput>;
  primaryFieldId?: InputMaybe<StringOperationFilterInput>;
  readOnlyField?: InputMaybe<BooleanOperationFilterInput>;
  relationshipDeleteBehavior?: InputMaybe<RelationshipDeleteBehaviorTypeOperationFilterInput>;
  required?: InputMaybe<BooleanOperationFilterInput>;
  restrictedMode?: InputMaybe<BooleanOperationFilterInput>;
  richText?: InputMaybe<BooleanOperationFilterInput>;
  schemaXml?: InputMaybe<StringOperationFilterInput>;
  scope?: InputMaybe<StringOperationFilterInput>;
  sealed?: InputMaybe<BooleanOperationFilterInput>;
  selectionGroup?: InputMaybe<IntOperationFilterInput>;
  selectionMode?: InputMaybe<FieldUserSelectionModeOperationFilterInput>;
  showAsPercentage?: InputMaybe<BooleanOperationFilterInput>;
  showInFiltersPane?: InputMaybe<ShowInFiltersPaneStatusOperationFilterInput>;
  sortable?: InputMaybe<BooleanOperationFilterInput>;
  sspId?: InputMaybe<UuidOperationFilterInput>;
  staticName?: InputMaybe<StringOperationFilterInput>;
  targetTemplate?: InputMaybe<StringOperationFilterInput>;
  termSetId?: InputMaybe<UuidOperationFilterInput>;
  textField?: InputMaybe<UuidOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  typeAsString?: InputMaybe<StringOperationFilterInput>;
  typeDisplayName?: InputMaybe<StringOperationFilterInput>;
  typeShortDescription?: InputMaybe<StringOperationFilterInput>;
  unlimitedLengthInDocumentLibrary?: InputMaybe<BooleanOperationFilterInput>;
  userCreated?: InputMaybe<BooleanOperationFilterInput>;
  validationFormula?: InputMaybe<StringOperationFilterInput>;
  validationMessage?: InputMaybe<StringOperationFilterInput>;
};

export type IFieldLinkFilterInput = {
  and?: InputMaybe<Array<IFieldLinkFilterInput>>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  fieldInternalName?: InputMaybe<StringOperationFilterInput>;
  hidden?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IFieldLinkFilterInput>>;
  readOnly?: InputMaybe<BooleanOperationFilterInput>;
  required?: InputMaybe<BooleanOperationFilterInput>;
  showInDisplayForm?: InputMaybe<BooleanOperationFilterInput>;
};

export type IFieldStringValuesFilterInput = {
  and?: InputMaybe<Array<IFieldStringValuesFilterInput>>;
  or?: InputMaybe<Array<IFieldStringValuesFilterInput>>;
};

/** Represents a digital document or file stored within a document library. These files can include documents, spreadsheets, presentations, images, and other types of electronic data. SharePoint Online's File objects are central to document management, enabling users to store, organize, version, and collaborate on files securely within the SharePoint environment. */
export type IFile = {
  /** Returns the comment that was specified when the document was checked into the document library */
  checkInComment?: Maybe<Scalars['String']['output']>;
  /** Enumeration that describes the different checkout states of a file, independent of the lock state of the file. */
  checkOutType: CheckOutType;
  /** Returns internal version of content, used to validate document equality for read purposes. */
  contentTag?: Maybe<Scalars['String']['output']>;
  /** Enumeration that describes the customization status of the file. */
  customizedPageStatus: CustomizedPageStatus;
  /** Returns a string value that specifies the ETag value. */
  eTag?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean value indicating whether this file has alternate streams with content. */
  hasAlternateContentStreams: Scalars['Boolean']['output'];
  /** Returns a boolean value indicating whether Irm is enabled on the file. */
  irmEnabled: Scalars['Boolean']['output'];
  /** Returns the size of the file. */
  length: Scalars['Long']['output'];
  /** Returns a value indicating the publishing Level of the file (published or draft) */
  level: PublishedStatus;
  /** Returns the linking URI of the file. */
  linkingUri?: Maybe<Scalars['String']['output']>;
  /** Returns the linking URL of the file. */
  linkingUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the id of the list containing the file. */
  listId: Scalars['UUID']['output'];
  /** Returns an integer indicating the major version of the file. */
  majorVersion: Scalars['Int']['output'];
  /** Returns an integer indicating the minor version of the file. */
  minorVersion: Scalars['Int']['output'];
  /** Returns the name of the file including the extension. */
  name?: Maybe<Scalars['String']['output']>;
  /** Returns the list page render type of the file. */
  pageRenderType: ListPageRenderType;
  /** Returns the preview of the file. */
  preview: FilePreview;
  /** Returns the properties of the file as JSON key-value pair. */
  properties: Array<StringJsonKeyValuePair>;
  /** Returns the URL which opens the document in Office Web Apps. */
  serverRedirectedUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the relative URL of the file based on the URL for the server. */
  serverRelativeUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the Id of the Site collection in which the file is stored. */
  siteId: Scalars['UUID']['output'];
  /** Returns a DateTime value indicating when the file was created. */
  timeCreated: Scalars['DateTime']['output'];
  /** Returns a DateTime value indicating when the file was last modified. */
  timeLastModified: Scalars['DateTime']['output'];
  /** Returns the display name of the file. */
  title?: Maybe<Scalars['String']['output']>;
  /** Returns an integer value indicating the implementation-specific version identifier of the file. */
  uiVersion: Scalars['Int']['output'];
  /** Returns a string value indicating the implementation-specific version identifier of the file. */
  uiVersionLabel?: Maybe<Scalars['String']['output']>;
  /** Returns the unique Id of the file. */
  uniqueId: Scalars['UUID']['output'];
  /** Returns the Graph Drive ID of the drive to which the file belongs. */
  vroomDriveID?: Maybe<Scalars['String']['output']>;
  /** Returns the Graph DriveItem ID of the file. */
  vroomItemID?: Maybe<Scalars['String']['output']>;
  /** Returns the Id of the site in which the file is stored. */
  webId: Scalars['UUID']['output'];
};

/** Represents a digital document or file stored within a document library. These files can include documents, spreadsheets, presentations, images, and other types of electronic data. SharePoint Online's File objects are central to document management, enabling users to store, organize, version, and collaborate on files securely within the SharePoint environment. */
export type IFilePreviewArgs = {
  previewOptions?: InputMaybe<PreviewOptionsInput>;
};

export type IFileFilterInput = {
  and?: InputMaybe<Array<IFileFilterInput>>;
  author?: InputMaybe<ISharePointUserFilterInput>;
  checkInComment?: InputMaybe<StringOperationFilterInput>;
  checkOutType?: InputMaybe<CheckOutTypeOperationFilterInput>;
  checkedOutByUser?: InputMaybe<ISharePointUserFilterInput>;
  contentTag?: InputMaybe<StringOperationFilterInput>;
  customizedPageStatus?: InputMaybe<CustomizedPageStatusOperationFilterInput>;
  eTag?: InputMaybe<StringOperationFilterInput>;
  effectiveInformationRightsManagementSettings?: InputMaybe<IEffectiveInformationRightsManagementSettingsFilterInput>;
  hasAlternateContentStreams?: InputMaybe<BooleanOperationFilterInput>;
  informationRightsManagementSettings?: InputMaybe<IInformationRightsManagementFileSettingsFilterInput>;
  irmEnabled?: InputMaybe<BooleanOperationFilterInput>;
  length?: InputMaybe<LongOperationFilterInput>;
  level?: InputMaybe<PublishedStatusOperationFilterInput>;
  linkingUri?: InputMaybe<StringOperationFilterInput>;
  linkingUrl?: InputMaybe<StringOperationFilterInput>;
  listId?: InputMaybe<UuidOperationFilterInput>;
  listItemAllFields?: InputMaybe<IListItemFilterInput>;
  lockedByUser?: InputMaybe<ISharePointUserFilterInput>;
  majorVersion?: InputMaybe<IntOperationFilterInput>;
  minorVersion?: InputMaybe<IntOperationFilterInput>;
  modifiedBy?: InputMaybe<ISharePointUserFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IFileFilterInput>>;
  pageRenderType?: InputMaybe<ListPageRenderTypeOperationFilterInput>;
  properties?: InputMaybe<IPropertyValuesFilterInput>;
  serverRedirectedUrl?: InputMaybe<StringOperationFilterInput>;
  serverRelativeUrl?: InputMaybe<StringOperationFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  timeCreated?: InputMaybe<DateTimeOperationFilterInput>;
  timeLastModified?: InputMaybe<DateTimeOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  uiVersion?: InputMaybe<IntOperationFilterInput>;
  uiVersionLabel?: InputMaybe<StringOperationFilterInput>;
  uniqueId?: InputMaybe<UuidOperationFilterInput>;
  versionEvents?: InputMaybe<IFileVersionEventCollectionFilterInput>;
  versions?: InputMaybe<ListFilterInputTypeOfIFileVersionFilterInput>;
  vroomDriveID?: InputMaybe<StringOperationFilterInput>;
  vroomItemID?: InputMaybe<StringOperationFilterInput>;
  webId?: InputMaybe<UuidOperationFilterInput>;
};

/** Represents a specific version of a file stored within a document library. SharePoint Online automatically maintains version history for documents, enabling users to track changes, revert to previous versions, and collaborate effectively on shared files. */
export type IFileVersion = {
  /** Returns the check-in comment. */
  checkInComment?: Maybe<Scalars['String']['output']>;
  /** Returns a DateTime value indicating the creation date and time for the file version. */
  created: Scalars['DateTime']['output'];
  /** Returns the internal identifier for the file version. */
  id: Scalars['Int']['output'];
  /** Returns a boolean value indicating whether the file version is the current version. */
  isCurrentVersion: Scalars['Boolean']['output'];
  /** Returns the size of this version of the file. */
  size: Scalars['Long']['output'];
  /** Returns the relative URL of the file version based on the URL for the site or subsite. */
  url?: Maybe<Scalars['String']['output']>;
  /** Returns the implementation specific identifier of the file. */
  versionLabel?: Maybe<Scalars['String']['output']>;
};

export type IFileVersionEventCollectionFilterInput = {
  and?: InputMaybe<Array<IFileVersionEventCollectionFilterInput>>;
  or?: InputMaybe<Array<IFileVersionEventCollectionFilterInput>>;
};

export type IFileVersionFilterInput = {
  and?: InputMaybe<Array<IFileVersionFilterInput>>;
  checkInComment?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<ISharePointUserFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isCurrentVersion?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<IFileVersionFilterInput>>;
  size?: InputMaybe<LongOperationFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
  versionLabel?: InputMaybe<StringOperationFilterInput>;
};

/** Serves as a virtual container within a document library, allowing users to organize and group related files and documents. Folders provide an intuitive way to structure and manage content, enabling users to categorize files based on projects, departments, topics, or any other relevant criteria. */
export type IFolder = {
  /** Returns a boolean value indicating whether the folder exists. */
  exists: Scalars['Boolean']['output'];
  /** Represents a file in a SharePoint Web site that can be a Web Part Page, an item in a document library, or a file in a folder. */
  files: Array<IFile>;
  /** Returns a collection of subfolders within a specific folder in SharePoint, leveraging its unique identifier as the parent reference. */
  folders: Array<IFolder>;
  /** Returns a boolean value indicating whether the folder is enabled for WOPI default action. */
  isWOPIEnabled: Scalars['Boolean']['output'];
  /** Returns an integer that specifies the count of items in the list folder. */
  itemCount: Scalars['Int']['output'];
  /** Returns detailed information about a specific list item within a folder in SharePoint, encompassing all available fields and properties. */
  listItemAllFields?: Maybe<IListItem>;
  /** Returns the name of the folder. */
  name?: Maybe<Scalars['String']['output']>;
  /** Returns the parent folder of a specific folder in SharePoint, utilizing the unique identifier of the folder as a reference. */
  parentFolder?: Maybe<IFolder>;
  /** Returns a string that identifies the application in which the folder was created. */
  progID?: Maybe<Scalars['String']['output']>;
  /** Returns the properties associated with a specific folder in a SharePoint environment as JSON key-value pairs. */
  properties: Array<StringJsonKeyValuePair>;
  /** Returns the server-relative URL of the list folder. */
  serverRelativeUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the creation time of the folder. */
  timeCreated: Scalars['DateTime']['output'];
  /** Returns the last modification time of the folder. */
  timeLastModified: Scalars['DateTime']['output'];
  /** Returns the unique Id of the folder. */
  uniqueId: Scalars['UUID']['output'];
};

export type IFolderFilterInput = {
  and?: InputMaybe<Array<IFolderFilterInput>>;
  contentTypeOrder?: InputMaybe<IContentTypeIdCollectionFilterInput>;
  exists?: InputMaybe<BooleanOperationFilterInput>;
  files?: InputMaybe<ListFilterInputTypeOfIFileFilterInput>;
  folders?: InputMaybe<ListFilterInputTypeOfIFolderFilterInput>;
  isWOPIEnabled?: InputMaybe<BooleanOperationFilterInput>;
  itemCount?: InputMaybe<IntOperationFilterInput>;
  listItemAllFields?: InputMaybe<IListItemFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IFolderFilterInput>>;
  parentFolder?: InputMaybe<IFolderFilterInput>;
  progID?: InputMaybe<StringOperationFilterInput>;
  properties?: InputMaybe<IPropertyValuesFilterInput>;
  serverRelativeUrl?: InputMaybe<StringOperationFilterInput>;
  storageMetrics?: InputMaybe<IStorageMetricsFilterInput>;
  timeCreated?: InputMaybe<DateTimeOperationFilterInput>;
  timeLastModified?: InputMaybe<DateTimeOperationFilterInput>;
  uniqueContentTypeOrder?: InputMaybe<IContentTypeIdCollectionFilterInput>;
  uniqueId?: InputMaybe<UuidOperationFilterInput>;
  welcomePage?: InputMaybe<StringOperationFilterInput>;
};

export type IInformationRightsManagementFileSettingsFilterInput = {
  allowPrint?: InputMaybe<BooleanOperationFilterInput>;
  allowScript?: InputMaybe<BooleanOperationFilterInput>;
  allowWriteCopy?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<IInformationRightsManagementFileSettingsFilterInput>>;
  disableDocumentBrowserView?: InputMaybe<BooleanOperationFilterInput>;
  documentAccessExpireDays?: InputMaybe<IntOperationFilterInput>;
  enableDocumentAccessExpire?: InputMaybe<BooleanOperationFilterInput>;
  enableDocumentBrowserPublishingView?: InputMaybe<BooleanOperationFilterInput>;
  enableGroupProtection?: InputMaybe<BooleanOperationFilterInput>;
  enableLicenseCacheExpire?: InputMaybe<BooleanOperationFilterInput>;
  groupName?: InputMaybe<StringOperationFilterInput>;
  irmEnabled?: InputMaybe<BooleanOperationFilterInput>;
  licenseCacheExpireDays?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<IInformationRightsManagementFileSettingsFilterInput>>;
  policyDescription?: InputMaybe<StringOperationFilterInput>;
  policyTitle?: InputMaybe<StringOperationFilterInput>;
  templateId?: InputMaybe<StringOperationFilterInput>;
};

export type IInformationRightsManagementSettingsFilterInput = {
  allowPrint?: InputMaybe<BooleanOperationFilterInput>;
  allowScript?: InputMaybe<BooleanOperationFilterInput>;
  allowWriteCopy?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<IInformationRightsManagementSettingsFilterInput>>;
  disableDocumentBrowserView?: InputMaybe<BooleanOperationFilterInput>;
  documentAccessExpireDays?: InputMaybe<IntOperationFilterInput>;
  documentLibraryProtectionExpireDate?: InputMaybe<DateTimeOperationFilterInput>;
  enableDocumentAccessExpire?: InputMaybe<BooleanOperationFilterInput>;
  enableDocumentBrowserPublishingView?: InputMaybe<BooleanOperationFilterInput>;
  enableGroupProtection?: InputMaybe<BooleanOperationFilterInput>;
  enableLicenseCacheExpire?: InputMaybe<BooleanOperationFilterInput>;
  groupName?: InputMaybe<StringOperationFilterInput>;
  licenseCacheExpireDays?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<IInformationRightsManagementSettingsFilterInput>>;
  policyDescription?: InputMaybe<StringOperationFilterInput>;
  policyTitle?: InputMaybe<StringOperationFilterInput>;
  templateId?: InputMaybe<StringOperationFilterInput>;
};

/** Represents information related to users who have liked a specific item within a SharePoint environment. It encapsulates details about users who have expressed approval or interest by liking a document, list item, or other collaborative content. */
export type ILikedByInformation = {
  /** Returns a boolean flag indicating whether this list item is liked. */
  isLikedByUser: Scalars['Boolean']['output'];
  /** Returns the number of likes the list item got. */
  likeCount?: Maybe<Scalars['String']['output']>;
};

export type ILikedByInformationFilterInput = {
  and?: InputMaybe<Array<ILikedByInformationFilterInput>>;
  isLikedByUser?: InputMaybe<BooleanOperationFilterInput>;
  likeCount?: InputMaybe<StringOperationFilterInput>;
  likedBy?: InputMaybe<ListFilterInputTypeOfICommentLikeUserEntityFilterInput>;
  or?: InputMaybe<Array<ILikedByInformationFilterInput>>;
};

/** Represents a structured collection of data, organized into rows and columns, similar to a database table. Lists serve as fundamental containers for storing information such as documents, tasks, contacts, or any other type of data. Each list item within a SharePoint Online List has a predefined set of fields or properties, defining the type of data it can store, such as text, numbers, dates, and more. */
export type IList = {
  /** Returns a collection of content types associated with a specific SharePoint list. */
  contentTypes: Array<IContentType>;
  /** Returns a boolean value indicating whether content types are enabled. */
  contentTypesEnabled: Scalars['Boolean']['output'];
  /** Returns the date and time that the list was created. */
  created: Scalars['DateTime']['output'];
  /** Returns a string value indicating the location of the default display form for the list. */
  defaultDisplayFormUrl?: Maybe<Scalars['String']['output']>;
  /** Returns a string value indicating the URL of the edit form to use for list items in the list. */
  defaultEditFormUrl?: Maybe<Scalars['String']['output']>;
  /** Returns a string value indicating the location of the default new form for the list. */
  defaultNewFormUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the URL of the default view of this list. */
  defaultViewUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the description of the list. */
  description?: Maybe<Scalars['String']['output']>;
  /** Enumeration that describes the reading order of the list. */
  direction: ListReadingDirection;
  /** Returns the unique identifier associated with the document template used for creating new items in the list. */
  documentTemplate?: Maybe<Scalars['String']['output']>;
  /** Returns the DraftVersionVisibility for the list. */
  draftVersionVisibility: DraftVisibilityType;
  /** Returns a boolean value indicating whether attachments are enabled. Defaults to true. */
  enableAttachments: Scalars['Boolean']['output'];
  /** Returns a boolean value indicating whether folder is enabled. Defaults to true. */
  enableFolderCreation: Scalars['Boolean']['output'];
  /** Returns a boolean value indicating whether minor versioning is enabled on the list. */
  enableMinorVersions: Scalars['Boolean']['output'];
  /** Returns a boolean value indicating whether moderation/content approval is enabled on the list. */
  enableModeration: Scalars['Boolean']['output'];
  /** Returns a goolean value indicating whether versioning is enabled on the list. */
  enableVersioning: Scalars['Boolean']['output'];
  /** Returns a collection of SharePoint fields asynchronously associated with a given list. */
  fields: Array<IField>;
  /** Returns a boolean value indicating whether to force checkout of documents in the library. */
  forceCheckout: Scalars['Boolean']['output'];
  /** Returns a boolean value indicating whether to hide the list. */
  hidden: Scalars['Boolean']['output'];
  /** The Unique ID of the List object. */
  id: Scalars['UUID']['output'];
  /** Defines a value that specifies the URI for the icon of the list, optional attribute. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Defines if IRM is enabled for this list. */
  irmEnabled: Scalars['Boolean']['output'];
  /** Defines if IRM Expire property, optional attribute. */
  irmExpire: Scalars['Boolean']['output'];
  /** Defines the IRM Reject property, optional attribute. */
  irmReject: Scalars['Boolean']['output'];
  /** Returns a boolean value indicating a flag that a client application can use to determine whether to display the list, optional attribute. */
  isApplicationList: Scalars['Boolean']['output'];
  /** Returns a boolean value indicating whether the list is a gallery, such list templates, Web Parts, or Master Pages. */
  isCatalog: Scalars['Boolean']['output'];
  /** Returns a boolean value indicating whether this library is the default document library of the site. */
  isDefaultDocumentLibrary?: Maybe<Scalars['Boolean']['output']>;
  /** Returns a boolean value indicating whether the document library is a private list with restricted permissions, such as for Solutions. */
  isPrivate: Scalars['Boolean']['output'];
  /** Returns a boolean value indicating whether this library is the "site asset" library. */
  isSiteAssetsLibrary?: Maybe<Scalars['Boolean']['output']>;
  /** Returns a boolean value indicating whether the list is system list that does not contain end user data and created by system account. */
  isSystemList?: Maybe<Scalars['Boolean']['output']>;
  /** Returns the number of items in the library. */
  itemCount: Scalars['Int']['output'];
  /** Returns a connection if list items. */
  items?: Maybe<ItemsConnection>;
  /** Returns a DateTime indicating when an item in the list was last deleted. If no item has yet been deleted from the list, the list creation time is returned. */
  lastItemDeletedDate: Scalars['DateTime']['output'];
  /** Returns a DateTime indicating when an item, field, or property of the list was last modified. If no item has been created in the list, the list creation time is returned. */
  lastItemModifiedDate: Scalars['DateTime']['output'];
  /** Returns an item of the list was last modified by a non-system update. A non-system update is a change to a list item that is visible to users. If no item has been created in the list, the list creation time is returned. */
  lastItemUserModifiedDate: Scalars['DateTime']['output'];
  /** Enumeration that describes how a list is presented (modern or classic). */
  listExperience: ListExperience;
  /** Returns the entity needed when updating list items. */
  listItemEntityTypeFullName?: Maybe<Scalars['String']['output']>;
  /** Returns an integer value indicating the Maximum Version Limit for verisioning, just in case it is enabled on the list. */
  maxVersionLimit: Scalars['Int']['output'];
  /** Returns an integer value indicating the Minor Version Limit for versioning, just in case it is enabled on the list. */
  minorVersionLimit: Scalars['Int']['output'];
  /** Defines if the current list or library has to be included in crawling, optional attribute. */
  noCrawl: Scalars['Boolean']['output'];
  /** Returns a boolean a value indicating whether the new list is displayed on the Quick Launch of the site. */
  onQuickLaunch?: Maybe<Scalars['Boolean']['output']>;
  /** Defines the Read Security property, optional attribute. */
  readSecurity?: Maybe<Scalars['Int']['output']>;
  /** Returns the root folder of a SharePoint list specified by its unique identifier. */
  rootFolder: IFolder;
  /** Returns the Guid for template feature. */
  templateFeatureId: Scalars['UUID']['output'];
  /** Returns a value that specifies the list server template of the new list. */
  templateType: ListTemplateType;
  /** Returns the list title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Defines a value that specifies the data validation criteria for a list item, optional attribute. */
  validationFormula?: Maybe<Scalars['String']['output']>;
  /** Defines a value that specifies the error message returned when data validation fails for a list item, optional attribute. */
  validationMessage?: Maybe<Scalars['String']['output']>;
  /** Returns a collection of views associated with a specific SharePoint list identified by its unique identifier */
  views: Array<IView>;
  /** Defines the Write Security property, optional attribute. */
  writeSecurity?: Maybe<Scalars['Int']['output']>;
};

/** Represents a structured collection of data, organized into rows and columns, similar to a database table. Lists serve as fundamental containers for storing information such as documents, tasks, contacts, or any other type of data. Each list item within a SharePoint Online List has a predefined set of fields or properties, defining the type of data it can store, such as text, numbers, dates, and more. */
export type IListItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  camlQuery?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IListFilterInput = {
  and?: InputMaybe<Array<IListFilterInput>>;
  contentTypes?: InputMaybe<ListFilterInputTypeOfIContentTypeFilterInput>;
  contentTypesEnabled?: InputMaybe<BooleanOperationFilterInput>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  defaultDisplayFormUrl?: InputMaybe<StringOperationFilterInput>;
  defaultEditFormUrl?: InputMaybe<StringOperationFilterInput>;
  defaultItemOpenInBrowser?: InputMaybe<BooleanOperationFilterInput>;
  defaultNewFormUrl?: InputMaybe<StringOperationFilterInput>;
  defaultViewUrl?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  direction?: InputMaybe<ListReadingDirectionOperationFilterInput>;
  documentTemplate?: InputMaybe<StringOperationFilterInput>;
  draftVersionVisibility?: InputMaybe<DraftVisibilityTypeOperationFilterInput>;
  enableAttachments?: InputMaybe<BooleanOperationFilterInput>;
  enableFolderCreation?: InputMaybe<BooleanOperationFilterInput>;
  enableMinorVersions?: InputMaybe<BooleanOperationFilterInput>;
  enableModeration?: InputMaybe<BooleanOperationFilterInput>;
  enableVersioning?: InputMaybe<BooleanOperationFilterInput>;
  eventReceivers?: InputMaybe<ListFilterInputTypeOfIEventReceiverDefinitionFilterInput>;
  fieldDefaults?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndStringFilterInput>;
  fields?: InputMaybe<ListFilterInputTypeOfIFieldFilterInput>;
  forceCheckout?: InputMaybe<BooleanOperationFilterInput>;
  hidden?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  imageUrl?: InputMaybe<StringOperationFilterInput>;
  informationRightsManagementSettings?: InputMaybe<IInformationRightsManagementSettingsFilterInput>;
  irmEnabled?: InputMaybe<BooleanOperationFilterInput>;
  irmExpire?: InputMaybe<BooleanOperationFilterInput>;
  irmReject?: InputMaybe<BooleanOperationFilterInput>;
  isApplicationList?: InputMaybe<BooleanOperationFilterInput>;
  isCatalog?: InputMaybe<BooleanOperationFilterInput>;
  isDefaultDocumentLibrary?: InputMaybe<BooleanOperationFilterInput>;
  isPrivate?: InputMaybe<BooleanOperationFilterInput>;
  isSiteAssetsLibrary?: InputMaybe<BooleanOperationFilterInput>;
  isSystemList?: InputMaybe<BooleanOperationFilterInput>;
  itemCount?: InputMaybe<IntOperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfIListItemFilterInput>;
  lastItemDeletedDate?: InputMaybe<DateTimeOperationFilterInput>;
  lastItemModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  lastItemUserModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  listExperience?: InputMaybe<ListExperienceOperationFilterInput>;
  listItemEntityTypeFullName?: InputMaybe<StringOperationFilterInput>;
  maxVersionLimit?: InputMaybe<IntOperationFilterInput>;
  minorVersionLimit?: InputMaybe<IntOperationFilterInput>;
  noCrawl?: InputMaybe<BooleanOperationFilterInput>;
  onQuickLaunch?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<IListFilterInput>>;
  readSecurity?: InputMaybe<IntOperationFilterInput>;
  rootFolder?: InputMaybe<IFolderFilterInput>;
  templateFeatureId?: InputMaybe<UuidOperationFilterInput>;
  templateType?: InputMaybe<ListTemplateTypeOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  userCustomActions?: InputMaybe<ListFilterInputTypeOfIUserCustomActionFilterInput>;
  validationFormula?: InputMaybe<StringOperationFilterInput>;
  validationMessage?: InputMaybe<StringOperationFilterInput>;
  views?: InputMaybe<ListFilterInputTypeOfIViewFilterInput>;
  webhooks?: InputMaybe<ListFilterInputTypeOfIListSubscriptionFilterInput>;
  writeSecurity?: InputMaybe<IntOperationFilterInput>;
};

/** List item is a fundamental data unit within a SharePoint list or library. It represents an individual entry containing various fields of information, such as text, numbers, dates, attachments, and more. List items are organized in SharePoint lists, allowing users to store, manage, and collaborate on structured data. Each list item can have unique properties and metadata, making it a versatile way to store and retrieve data in SharePoint.  */
export type IListItem = {
  /** Returns a collection of attachment files associated with a specific SharePoint list item */
  attachmentFiles: Array<IAttachment>;
  /** Returns a boolean value indicating whether comments are disabled for the list item. */
  commentsDisabled: Scalars['Boolean']['output'];
  /** Returns the scope for which comments are disabled. */
  commentsDisabledScope: CommentsDisabledScope;
  /** Returns the content type of the list item. */
  contentType?: Maybe<IContentType>;
  /** Returns a collection of JSON key-value pairs representing the HTML content of list item field value. */
  fieldValuesAsHtml: Array<StringJsonKeyValuePair>;
  /** Returns a collection of JSON key-value pairs, where each pair corresponds to a field value represented as strings, forming a structured collection of data in a key-value format. */
  fieldValuesAsText: Array<StringJsonKeyValuePair>;
  /** Returns a collection of JSON key-value pairs, where each pair contains formatted values intended for display within an edit form. */
  fieldValuesForEdit: Array<StringJsonKeyValuePair>;
  /** Returns a specific file associated with a SharePoint list item which provides access to file-specific properties, content, and metadata. */
  file?: Maybe<IFile>;
  /** Enumeration that describes whether the list item is a file or a list folder. */
  fileSystemObjectType: FileSystemObjectType;
  /** Returns a specific folder associated with a SharePoint list item. */
  folder?: Maybe<IFolder>;
  /** Returns the Id of the list item. */
  id: Scalars['Int']['output'];
  /** Defines if and who liked a list item. */
  likedByInformation?: Maybe<ILikedByInformation>;
  /** Returns the parent list that contains the list item. */
  parentList?: Maybe<IList>;
  /** Transforms and returns the property values associated with a specific SharePoint list item into a collection of JSON key-value pairs. */
  properties: Array<StringJsonKeyValuePair>;
  /** Returns the URI used to render the WOPI (Web Application Open Platform Interface) frame. */
  serverRedirectedEmbedUri?: Maybe<Scalars['String']['output']>;
  /** Returns the URL used to render the WOPI (Web Application Open Platform Interface) frame. */
  serverRedirectedEmbedUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the Title of the list item. */
  title?: Maybe<Scalars['String']['output']>;
  /** Returns the unique identifier of the list item. */
  uniqueId: Scalars['UUID']['output'];
  /** Returns the values associated with a specific SharePoint list item and formats them into a collection of JSON key-value pairs. */
  values: Array<StringJsonKeyValuePair>;
  /** Returns a collection of versions associated with a specific SharePoint list item. */
  versions: Array<IListItemVersion>;
};

export type IListItemFilterInput = {
  and?: InputMaybe<Array<IListItemFilterInput>>;
  attachmentFiles?: InputMaybe<ListFilterInputTypeOfIAttachmentFilterInput>;
  commentsDisabled?: InputMaybe<BooleanOperationFilterInput>;
  commentsDisabledScope?: InputMaybe<CommentsDisabledScopeOperationFilterInput>;
  contentType?: InputMaybe<IContentTypeFilterInput>;
  fieldValuesAsHtml?: InputMaybe<IFieldStringValuesFilterInput>;
  fieldValuesAsText?: InputMaybe<IFieldStringValuesFilterInput>;
  fieldValuesForEdit?: InputMaybe<IFieldStringValuesFilterInput>;
  file?: InputMaybe<IFileFilterInput>;
  fileSystemObjectType?: InputMaybe<FileSystemObjectTypeOperationFilterInput>;
  folder?: InputMaybe<IFolderFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  likedByInformation?: InputMaybe<ILikedByInformationFilterInput>;
  or?: InputMaybe<Array<IListItemFilterInput>>;
  parentList?: InputMaybe<IListFilterInput>;
  properties?: InputMaybe<IPropertyValuesFilterInput>;
  serverRedirectedEmbedUri?: InputMaybe<StringOperationFilterInput>;
  serverRedirectedEmbedUrl?: InputMaybe<StringOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  uniqueId?: InputMaybe<UuidOperationFilterInput>;
  versions?: InputMaybe<ListFilterInputTypeOfIListItemVersionFilterInput>;
};

/** Represents a specific version of a list item, capturing the state of the item at a particular point in time. SharePoint Online automatically maintains version history for list items, allowing users to track changes, review revisions, and restore previous versions if necessary. */
export type IListItemVersion = {
  /** Returns a DatimeTime value that specifies the creation date and time for the list item version. */
  created: Scalars['DateTime']['output'];
  /** Returns the user that created this version. */
  createdBy?: Maybe<ISharePointUser>;
  /** Returns the list item version. */
  fileVersion?: Maybe<IFileVersion>;
  /** Returns the internal identifier for the list item version. */
  id: Scalars['Int']['output'];
  /** Returns a boolean flag indicating whether the list item version is the current version. */
  isCurrentVersion: Scalars['Boolean']['output'];
  /** Returns a string value that specifies the implementation specific identifier of the file. */
  versionLabel?: Maybe<Scalars['String']['output']>;
};

export type IListItemVersionFilterInput = {
  and?: InputMaybe<Array<IListItemVersionFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<ISharePointUserFilterInput>;
  fields?: InputMaybe<ListFilterInputTypeOfIFieldFilterInput>;
  fileVersion?: InputMaybe<IFileVersionFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isCurrentVersion?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<IListItemVersionFilterInput>>;
  versionLabel?: InputMaybe<StringOperationFilterInput>;
};

export type IListSubscriptionFilterInput = {
  and?: InputMaybe<Array<IListSubscriptionFilterInput>>;
  clientState?: InputMaybe<StringOperationFilterInput>;
  expirationDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  notificationUrl?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IListSubscriptionFilterInput>>;
  resource?: InputMaybe<StringOperationFilterInput>;
};

export type IPropertyValuesFilterInput = {
  and?: InputMaybe<Array<IPropertyValuesFilterInput>>;
  or?: InputMaybe<Array<IPropertyValuesFilterInput>>;
};

/** Represents an item that has been deleted from a SharePoint site but is still retrievable from the recycle bin. SharePoint Online automatically moves deleted items to the recycle bin, allowing users to recover accidentally deleted content or permanently remove items from the site. */
export type IRecycleBinItem = {
  /** Returns the e-mail address of the user who created the recycle bin item. */
  authorEmail?: Maybe<Scalars['String']['output']>;
  /** Returns the name of the user who created the recycle bin item. */
  authorName?: Maybe<Scalars['String']['output']>;
  /** Returns the e-mail address of the user who deleted the recycle bin item. */
  deletedByEmail?: Maybe<Scalars['String']['output']>;
  /** Returns the name of the user who deleted the recycle bin item. */
  deletedByName?: Maybe<Scalars['String']['output']>;
  /** Returns a DateTime value that specifies when the Recycle Bin item was moved to the Recycle Bin. */
  deletedDate: Scalars['DateTime']['output'];
  /** Returns a string value that specifies when the Recycle Bin item was moved to the Recycle Bin formatted in the local date. */
  deletedDateLocalFormatted?: Maybe<Scalars['String']['output']>;
  /** Returns the site relative URL of the list or folder that originally contained the Recycle Bin item. */
  dirName?: Maybe<Scalars['String']['output']>;
  /** Returns the identifier of the Recycle Bin item. */
  id: Scalars['UUID']['output'];
  /** Returns the Recycle Bin stage of the Recycle Bin item. */
  itemState: RecycleBinItemState;
  /** Returns the type of the Recycle Bin item. */
  itemType: RecycleBinItemType;
  /** Returns the leaf name of the Recycle Bin item. */
  leafName?: Maybe<Scalars['String']['output']>;
  /** Returns title of the Recycle Bin item. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Represents a specific group created within a SharePoint site, comprising a set of users who share common access permissions and collaborative privileges. SharePoint Online allows administrators and site owners to create custom groups, each with defined roles and levels of access, ensuring secure and organized collaboration within the platform. */
export type ISharePointGroup = {
  /** Returns a boolean flag indicating whether it allows members to edit group members. */
  allowMembersEditMembership: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether it allow requests to join or leave the group. */
  allowRequestToJoinLeave: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether it automatically accept requests to join or leave the group. */
  autoAcceptRequestToJoinLeave: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating that the current user can edit the group members. */
  canCurrentUserEditMembership: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating that the current user can manage the group. */
  canCurrentUserManageGroup: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating that the current user can view the group membership. */
  canCurrentUserViewMembership: Scalars['Boolean']['output'];
  /** Returns the group description. Note that HTML tags will be stripped and that the max length of the description will be limited to 511 characters. */
  description?: Maybe<Scalars['String']['output']>;
  /** Returns the member identifier for the principal (user/group). */
  id: Scalars['Int']['output'];
  /** Returns a boolean flag indicating whether the member should be hidden in the UI. */
  isHiddenInUi: Scalars['Boolean']['output'];
  /** Returns the login name of the principal (user/group). */
  loginName: Scalars['String']['output'];
  /** Returns a boolean flag indicating that only members can see other group members. */
  onlyAllowMembersViewMembership: Scalars['Boolean']['output'];
  /** Returns the group owner title. */
  ownerTitle?: Maybe<Scalars['String']['output']>;
  /** Returns a value containing the type of the principal. */
  principalType: PrincipalType;
  /** Returns the email configuration for operations related to joining or leaving the group. */
  requestToJoinLeaveEmailSetting?: Maybe<Scalars['String']['output']>;
  /** Returns the name of the principal (user/group). */
  title: Scalars['String']['output'];
  /** Returns a collection of SharePoint users. */
  users: Array<ISharePointUser>;
};

export type ISharePointGroupFilterInput = {
  allowMembersEditMembership?: InputMaybe<BooleanOperationFilterInput>;
  allowRequestToJoinLeave?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ISharePointGroupFilterInput>>;
  autoAcceptRequestToJoinLeave?: InputMaybe<BooleanOperationFilterInput>;
  canCurrentUserEditMembership?: InputMaybe<BooleanOperationFilterInput>;
  canCurrentUserManageGroup?: InputMaybe<BooleanOperationFilterInput>;
  canCurrentUserViewMembership?: InputMaybe<BooleanOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  onlyAllowMembersViewMembership?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ISharePointGroupFilterInput>>;
  ownerTitle?: InputMaybe<StringOperationFilterInput>;
  requestToJoinLeaveEmailSetting?: InputMaybe<StringOperationFilterInput>;
  users?: InputMaybe<ListFilterInputTypeOfISharePointUserFilterInput>;
};

/** Represents a user, group, or entity with whom specific content in SharePoint can be shared. SharePoint Online utilizes this object to manage permissions and control access to documents, folders, lists, or entire sites within a SharePoint environment. */
export type ISharePointSharingPrincipal = {
  /** Returns a string value indicating when the sharing principal expires. */
  expiration?: Maybe<Scalars['String']['output']>;
  /** Returns the member identifier for the user or group. */
  id: Scalars['Int']['output'];
  /** Returns a boolean flag indicating if the user is still active. */
  isActive: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating if the user is an external user. */
  isExternal: Scalars['Boolean']['output'];
  /** Returns the job title of the user. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** Returns the login name of the user. */
  loginName?: Maybe<Scalars['String']['output']>;
  /** Returns the E-mail address of the user. */
  mail?: Maybe<Scalars['String']['output']>;
  /** Returns the name of the user. */
  name?: Maybe<Scalars['String']['output']>;
  /** Returns the type of the principal. */
  principalType: PrincipalType;
  /** Returns the user principle name (UPN) of the user. */
  userPrincipalName?: Maybe<Scalars['String']['output']>;
};

/** Represents an individual user within a SharePoint site or organization. It encapsulates important user-related information such as user ID, display name, email address, and group memberships. */
export type ISharePointUser = {
  /** A date/time string for which the format conforms to the ISO8601 time format YYYY - MM - DDTHH:MM:SSZ and which represents the time and date of expiry for the user. Note: A null value indicates no expiry. */
  expiration?: Maybe<Scalars['String']['output']>;
  /** Returns the member identifier for the principal (user/group). */
  id: Scalars['Int']['output'];
  /** Returns a boolean flag indicating whether the user is a guest user authenticated via an e-mail address. */
  isEmailAuthenticationGuestUser: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the user is a guest user shared by e-mail. */
  isShareByEmailGuestUser: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the user is a site collection administrator. */
  isSiteAdmin: Scalars['Boolean']['output'];
  /** Returns the E-mail address of the user. */
  mail?: Maybe<Scalars['String']['output']>;
  /** Returns the user principle name (UPN) of the user. */
  userPrincipalName?: Maybe<Scalars['String']['output']>;
};

export type ISharePointUserFilterInput = {
  aadObjectId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ISharePointUserFilterInput>>;
  department?: InputMaybe<StringOperationFilterInput>;
  expiration?: InputMaybe<StringOperationFilterInput>;
  groups?: InputMaybe<ListFilterInputTypeOfISharePointGroupFilterInput>;
  isEmailAuthenticationGuestUser?: InputMaybe<BooleanOperationFilterInput>;
  isShareByEmailGuestUser?: InputMaybe<BooleanOperationFilterInput>;
  isSiteAdmin?: InputMaybe<BooleanOperationFilterInput>;
  mail?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ISharePointUserFilterInput>>;
  userPrincipalName?: InputMaybe<StringOperationFilterInput>;
};

/** Represents a specific site within a SharePoint environment, serving as a digital workspace for collaboration, content management, and communication. Sites can take various forms, including team sites, communication sites, and hub sites, each tailored for different collaboration needs. */
export type ISite = {
  /** Gets a value that specifies whether the creation of declarative workflows is allowed on this site collection. */
  allowCreateDeclarativeWorkflow: Scalars['Boolean']['output'];
  /** Gets a value that specifies whether a designer can be used on this site collection. */
  allowDesigner: Scalars['Boolean']['output'];
  /** Gets a value that specifies whether external embedding wrapper is allowed on this site collection. (0: Don't allow embedding any external domains; 1: Only allow embedding external domains from allow-embed-domains-list; 2: Allow embedding any external domains). */
  allowExternalEmbeddingWrapper: Scalars['Int']['output'];
  /** Gets a value that specifies whether master page editing is allowed on this site collection. */
  allowMasterPageEditing: Scalars['Boolean']['output'];
  /** Gets a value that specifies whether this site collection can be reverted to its base template. */
  allowRevertFromTemplate: Scalars['Boolean']['output'];
  /** Gets a value that specifies whether it is allowed to save declarative workflows as template on this site collection. */
  allowSaveDeclarativeWorkflowAsTemplate: Scalars['Boolean']['output'];
  /** Gets a value that specifies whether it is allowed to save and publish declarative workflows on this site collection. */
  allowSavePublishDeclarativeWorkflow: Scalars['Boolean']['output'];
  /** This is the number of days of audit log data to retain. If unset and audit trimming is enabled, the retention defaults default configured schedule for trimming. */
  auditLogTrimmingRetention: Scalars['Int']['output'];
  /** Gets a value if syncing hub site permissions to this associated site is allowed. */
  canSyncHubSitePermissions: Scalars['Boolean']['output'];
  /** Gets the ID of the Modern Group associated with this site. */
  channelGroupId: Scalars['UUID']['output'];
  /** The Classification of the Site object. */
  classification?: Maybe<Scalars['String']['output']>;
  /** Gets a value that specifies whether the comments on site pages are disabled on this site collection. */
  commentsOnSitePagesDisabled: Scalars['Boolean']['output'];
  /** Gets the value whether or not to disable app views for all child webs. True means app views are disabled throughout the site collection; False otherwise. */
  disableAppViews: Scalars['Boolean']['output'];
  /** Gets the value whether or not to disable company sharing links for all child webs. True means companywide sharing links are disabled throughout the site collection, regardless of the settings on the root or child webs. False means each web can individually decide whether to turn on or off companywide sharing links. */
  disableCompanyWideSharingLinks: Scalars['Boolean']['output'];
  /** Gets the value whether or not to disable Flows for all child webs. True means Flows are disabled throughout the site collection; False otherwise. */
  disableFlows: Scalars['Boolean']['output'];
  /** Gets a boolean value that specifies whether users will be greeted with a notification bar telling them that the site can be shared with external users. True - notification bar is enabled; False - otherwise. */
  externalSharingTipsEnabled: Scalars['Boolean']['output'];
  /** Property that indicates the default number of days an external user will expire in. 0 if the policy is disabled or unavailable, otherwise the number of days. */
  externalUserExpirationInDays: Scalars['Int']['output'];
  /** Returns a collection of SharePoint features. */
  features: Array<IFeature>;
  /** Returns the Geo Location hosting this site collection. */
  geoLocation?: Maybe<Scalars['String']['output']>;
  /** The unique ID of the associated Microsoft 365 Group (if any). */
  groupId: Scalars['UUID']['output'];
  /** Gets the ID of the HubSite this site is associated with. */
  hubSiteId: Scalars['UUID']['output'];
  /** The Unique ID of the Site object. */
  id: Scalars['UUID']['output'];
  /** Returns whether or not this site is a HubSite. Hub sites can be associated with one or more sites. */
  isHubSite: Scalars['Boolean']['output'];
  /** Returns a site list. */
  listByIdOrTitle: IList;
  /** Returns a collection of site lists. */
  lists?: Maybe<ListsConnection>;
  /** Gets the comment that is used in locking a site collection. */
  lockIssue?: Maybe<Scalars['String']['output']>;
  /** Maximum items that will not be throttled per operation. */
  maxItemsPerThrottledOperation: Scalars['Int']['output'];
  /** Gets a bool value that specifies whether the site collection is read-only, locked, and unavailable for write access. */
  readOnly: Scalars['Boolean']['output'];
  /** Gets the ID of the Modern Group related to this site. */
  relatedGroupId: Scalars['UUID']['output'];
  /** Returns the top-level site of the site collection. */
  rootWeb: IWeb;
  /** Whether suite nav search box is shown on modern and classic pages. */
  searchBoxInNavBar: SearchBoxInNavBar;
  /** Search placeholder text for search box in navbar - overrides default placeholder text if set. */
  searchBoxPlaceholderText?: Maybe<Scalars['String']['output']>;
  /** Gets the Information Protection Label Id for an individual site collection. */
  sensitivityLabel?: Maybe<Scalars['String']['output']>;
  /** Gets the Information Protection Label Id for an individual site collection. */
  sensitivityLabelId: Scalars['UUID']['output'];
  /** Gets the server-relative URL of the root Web site in the site collection. */
  serverRelativeUrl?: Maybe<Scalars['String']['output']>;
  /** ShareByEmailEnabled when true means that user's will be able to grant permissions to guests for resources within the site collection. */
  shareByEmailEnabled: Scalars['Boolean']['output'];
  /** Property that indicates whether users will be able to share links to documents that can be accessed without logging in. */
  shareByLinkEnabled: Scalars['Boolean']['output'];
  /** Gets a value that specifies whether guest users should be displayed as suggestions in people picker on this site collection. */
  showPeoplePickerSuggestionsForGuestUsers: Scalars['Boolean']['output'];
  /** Defines whether social bar is disabled on Site Pages in this site collection. */
  socialBarOnSitePagesDisabled: Scalars['Boolean']['output'];
  /** Gets a value that specifies the status bar link on this site collection. */
  statusBarLink?: Maybe<Scalars['String']['output']>;
  /** Gets a value that specifies the text of the status bar on this site collection. */
  statusBarText?: Maybe<Scalars['String']['output']>;
  /** Gets a value that indicates whether thicket support is disabled on this site collection. */
  thicketSupportDisabled: Scalars['Boolean']['output'];
  /** When this flag is set for the site, the audit events are trimmed periodically. */
  trimAuditLog: Scalars['Boolean']['output'];
  /** The URL of the Site object. */
  url?: Maybe<Scalars['URL']['output']>;
  /** Returns a collection of User Custom Actions. */
  userCustomActions: Array<IUserCustomAction>;
};

/** Represents a specific site within a SharePoint environment, serving as a digital workspace for collaboration, content management, and communication. Sites can take various forms, including team sites, communication sites, and hub sites, each tailored for different collaboration needs. */
export type ISiteListByIdOrTitleArgs = {
  listIdOrTitle: Scalars['String']['input'];
};

/** Represents a specific site within a SharePoint environment, serving as a digital workspace for collaboration, content management, and communication. Sites can take various forms, including team sites, communication sites, and hub sites, each tailored for different collaboration needs. */
export type ISiteListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ListTypeSortInput>>;
  where?: InputMaybe<IListFilterInput>;
};

export type IStorageMetricsFilterInput = {
  and?: InputMaybe<Array<IStorageMetricsFilterInput>>;
  lastModified?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<IStorageMetricsFilterInput>>;
  totalFileCount?: InputMaybe<LongOperationFilterInput>;
  totalFileStreamSize?: InputMaybe<LongOperationFilterInput>;
  totalSize?: InputMaybe<LongOperationFilterInput>;
};

/** Represents a custom action associated with a specific user or group within a SharePoint site. Custom actions allow users to extend SharePoint Online's functionality by adding personalized buttons, menu items, or links to SharePoint interfaces. These actions can be triggered by users, enhancing the user experience and enabling custom interactions. */
export type IUserCustomAction = {
  /** Returns the unique identifier of the associated client side component. */
  clientSideComponentId: Scalars['UUID']['output'];
  /** Returns the JSON formatted properties of the associated client side component. */
  clientSideComponentProperties?: Maybe<Scalars['String']['output']>;
  /** Returns a string value that specifies an implementation-specific XML fragment determining the user interface properties of the custom action. */
  commandUIExtension?: Maybe<Scalars['String']['output']>;
  /** Returns the description of the custom action. */
  description?: Maybe<Scalars['String']['output']>;
  /** Returns a string value that specifies an implementation-specific value determining the position of the custom action on the page. */
  group?: Maybe<Scalars['String']['output']>;
  /** This property is only used when an application customizer is created and preallocated placeholders are specified. It is optional. If non-empty, the string must contain a JSON object with one or two properties for the height amount needed to be preallocated. */
  hostProperties?: Maybe<Scalars['String']['output']>;
  /** Returns the identifier of the custom action. */
  id: Scalars['UUID']['output'];
  /** Returns the URL of the image associated with the custom action. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the location of the custom action. */
  location?: Maybe<Scalars['String']['output']>;
  /** Returns the name of the custom action. */
  name?: Maybe<Scalars['String']['output']>;
  /** Returns the identifier of the object associated with the custom action. */
  registrationId?: Maybe<Scalars['String']['output']>;
  /** Returns the type of object associated with the custom action. */
  registrationType: UserCustomActionRegistrationType;
  /** Returns the scope of the custom action. */
  scope: UserCustomActionScope;
  /** Returns the value that specifies the ECMAScript to be executed when the custom action is performed. */
  scriptBlock?: Maybe<Scalars['String']['output']>;
  /** Returns a string value specifying the URI of a file containing the ECMAScript to execute on the page. */
  scriptSrc?: Maybe<Scalars['String']['output']>;
  /** Returns an integer that specifies an implementation-specific value determining the order of the custom action appearing on the page. */
  sequence: Scalars['Int']['output'];
  /** Returns the display title of the custom action. */
  title?: Maybe<Scalars['String']['output']>;
  /** Returns the URL, URI, or ECMAScript (JScript, JavaScript) function associated with the action. */
  url?: Maybe<Scalars['String']['output']>;
  /** Returns the version of the user custom action. */
  versionOfUserCustomAction?: Maybe<Scalars['String']['output']>;
};

export type IUserCustomActionFilterInput = {
  and?: InputMaybe<Array<IUserCustomActionFilterInput>>;
  clientSideComponentId?: InputMaybe<UuidOperationFilterInput>;
  clientSideComponentProperties?: InputMaybe<StringOperationFilterInput>;
  commandUIExtension?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  hostProperties?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  imageUrl?: InputMaybe<StringOperationFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IUserCustomActionFilterInput>>;
  registrationId?: InputMaybe<StringOperationFilterInput>;
  registrationType?: InputMaybe<UserCustomActionRegistrationTypeOperationFilterInput>;
  rights?: InputMaybe<IBasePermissionsFilterInput>;
  scope?: InputMaybe<UserCustomActionScopeOperationFilterInput>;
  scriptBlock?: InputMaybe<StringOperationFilterInput>;
  scriptSrc?: InputMaybe<StringOperationFilterInput>;
  sequence?: InputMaybe<IntOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
  versionOfUserCustomAction?: InputMaybe<StringOperationFilterInput>;
};

/** Represents a customized way to display and interact with the data stored within a list or library. Views allow users to define which columns to display, filter, sort, and format the content based on specific criteria, providing tailored perspectives on the information. */
export type IView = {
  /** Specifies the aggregations displayed by the list view. */
  aggregations?: Maybe<Scalars['String']['output']>;
  /** Specifies whether the aggregations are shown in the list view. */
  aggregationsStatus?: Maybe<Scalars['String']['output']>;
  /** Returns the Associated Content Type Id. */
  associatedContentTypeId?: Maybe<Scalars['String']['output']>;
  /** Returns the the base view identifier of the list view. */
  baseViewId?: Maybe<Scalars['String']['output']>;
  /** Returns the Calendar View Styles. */
  calendarViewStyles?: Maybe<Scalars['String']['output']>;
  /** Returns the Column Width. */
  columnWidth?: Maybe<Scalars['String']['output']>;
  /** Returns the Custom Formatter. */
  customFormatter?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean value indicating whether the view is the default view. */
  defaultView: Scalars['Boolean']['output'];
  /** Returns a boolean value indicating whether the view is the default view for the associated content type. */
  defaultViewForContentType: Scalars['Boolean']['output'];
  /** Returns a boolean value indicating whether the view was modified in an HTML editor. */
  editorModified: Scalars['Boolean']['output'];
  /** Specifies the definitions for column and row formatting that are used in a datasheet view. */
  formats?: Maybe<Scalars['String']['output']>;
  /** An attribute of the view, specifies the quick edit layout. */
  gridLayout?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean value indicating wheter the view is hidden. */
  hidden: Scalars['Boolean']['output'];
  /** Returns the Html Schema Xml. */
  htmlSchemaXml?: Maybe<Scalars['String']['output']>;
  /** Returns the Id of the view. */
  id: Scalars['UUID']['output'];
  /** Returns the server relative or absolute URL of the Image for the List View. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean value indicating if the Root Folder is included in the List View. */
  includeRootFolder: Scalars['Boolean']['output'];
  /** This attribute of the view specifies the JavaScript files used within the view. */
  jsLink?: Maybe<Scalars['String']['output']>;
  /** Returns the List View Xml. */
  listViewXml?: Maybe<Scalars['String']['output']>;
  /** Specifies the view method for the list view. */
  method?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean value indicating whether the list view is the default for a mobile device. */
  mobileDefaultView: Scalars['Boolean']['output'];
  /** Returns a boolean value indicating whether the list view applies to a mobile device. */
  mobileView: Scalars['Boolean']['output'];
  /** A string that indicates the Content Approval type for the list view. */
  moderationType?: Maybe<Scalars['String']['output']>;
  /** An attribute of the view, indicates what documents/templates are visible in "New" menu of a document library. */
  newDocumentTemplates?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean value indicating whether users can reorder items through the user interface. */
  orderedView: Scalars['Boolean']['output'];
  /** Returns the reason why the page is rendered in classic UX, or Modern if the page is in Modern UX. */
  pageRenderType: ListPageRenderType;
  /** Returns a boolean value indicating whether the list view supports displaying items across multiple pages. */
  paged: Scalars['Boolean']['output'];
  /** Returns a boolean value indicating whether the view is a personal view or a public view. */
  personalView: Scalars['Boolean']['output'];
  /** Returns a boolean value indicating if the view is read-only. */
  readOnlyView: Scalars['Boolean']['output'];
  /** Returns a boolean value indicating whether this view requires client integration. */
  requiresClientIntegration: Scalars['Boolean']['output'];
  /** Returns the limit for the number of items that the list view will return per page. */
  rowLimit: Scalars['Int']['output'];
  /** Returns the recursive scope for the list view of a document library. */
  scope: ViewScope;
  /** Returns the server relative URL of the list view page. */
  serverRelativeUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the identifier of the view style for the list view. */
  styleId?: Maybe<Scalars['String']['output']>;
  /** Returns the TabularView attribute in the View Schema XML. */
  tabularView: Scalars['Boolean']['output'];
  /** Returns a boolean value indicating whether the view is threaded. */
  threaded: Scalars['Boolean']['output'];
  /** Returns the Display Name of the List View. */
  title?: Maybe<Scalars['String']['output']>;
  /** Specifies the toolbar (CAML) for the list view. */
  toolbar?: Maybe<Scalars['String']['output']>;
  /** Returns the name of the toolbar template that is used for the list view toolbar. */
  toolbarTemplateName?: Maybe<Scalars['String']['output']>;
  /** Returns the view data for the list view. */
  viewData?: Maybe<Scalars['String']['output']>;
  /** Specifies the list joins that will be used by the list view. */
  viewJoins?: Maybe<Scalars['String']['output']>;
  /** Returns the projected fields that will be used by the list view. */
  viewProjectedFields?: Maybe<Scalars['String']['output']>;
  /** Returns the CAML query that will be used by the list view. */
  viewQuery?: Maybe<Scalars['String']['output']>;
  /** Returns the type of the view. */
  viewType: ViewType;
  /** Modern List View Types. */
  viewType2: ViewType2;
};

export type IViewFieldCollectionFilterInput = {
  and?: InputMaybe<Array<IViewFieldCollectionFilterInput>>;
  items?: InputMaybe<ListStringOperationFilterInput>;
  or?: InputMaybe<Array<IViewFieldCollectionFilterInput>>;
  schemaXml?: InputMaybe<StringOperationFilterInput>;
};

export type IViewFilterInput = {
  aggregations?: InputMaybe<StringOperationFilterInput>;
  aggregationsStatus?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<IViewFilterInput>>;
  associatedContentTypeId?: InputMaybe<StringOperationFilterInput>;
  baseViewId?: InputMaybe<StringOperationFilterInput>;
  calendarViewStyles?: InputMaybe<StringOperationFilterInput>;
  columnWidth?: InputMaybe<StringOperationFilterInput>;
  customFormatter?: InputMaybe<StringOperationFilterInput>;
  defaultView?: InputMaybe<BooleanOperationFilterInput>;
  defaultViewForContentType?: InputMaybe<BooleanOperationFilterInput>;
  editorModified?: InputMaybe<BooleanOperationFilterInput>;
  formats?: InputMaybe<StringOperationFilterInput>;
  gridLayout?: InputMaybe<StringOperationFilterInput>;
  hidden?: InputMaybe<BooleanOperationFilterInput>;
  htmlSchemaXml?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  imageUrl?: InputMaybe<StringOperationFilterInput>;
  includeRootFolder?: InputMaybe<BooleanOperationFilterInput>;
  jsLink?: InputMaybe<StringOperationFilterInput>;
  listViewXml?: InputMaybe<StringOperationFilterInput>;
  method?: InputMaybe<StringOperationFilterInput>;
  mobileDefaultView?: InputMaybe<BooleanOperationFilterInput>;
  mobileView?: InputMaybe<BooleanOperationFilterInput>;
  moderationType?: InputMaybe<StringOperationFilterInput>;
  newDocumentTemplates?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IViewFilterInput>>;
  orderedView?: InputMaybe<BooleanOperationFilterInput>;
  pageRenderType?: InputMaybe<ListPageRenderTypeOperationFilterInput>;
  paged?: InputMaybe<BooleanOperationFilterInput>;
  personalView?: InputMaybe<BooleanOperationFilterInput>;
  readOnlyView?: InputMaybe<BooleanOperationFilterInput>;
  requiresClientIntegration?: InputMaybe<BooleanOperationFilterInput>;
  rowLimit?: InputMaybe<IntOperationFilterInput>;
  scope?: InputMaybe<ViewScopeOperationFilterInput>;
  serverRelativeUrl?: InputMaybe<StringOperationFilterInput>;
  styleId?: InputMaybe<StringOperationFilterInput>;
  tabularView?: InputMaybe<BooleanOperationFilterInput>;
  threaded?: InputMaybe<BooleanOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  toolbar?: InputMaybe<StringOperationFilterInput>;
  toolbarTemplateName?: InputMaybe<StringOperationFilterInput>;
  viewData?: InputMaybe<StringOperationFilterInput>;
  viewFields?: InputMaybe<IViewFieldCollectionFilterInput>;
  viewJoins?: InputMaybe<StringOperationFilterInput>;
  viewProjectedFields?: InputMaybe<StringOperationFilterInput>;
  viewQuery?: InputMaybe<StringOperationFilterInput>;
  viewType?: InputMaybe<ViewTypeOperationFilterInput>;
  viewType2?: InputMaybe<ViewType2OperationFilterInput>;
};

/** Represents an individual subsite or a specific area within a SharePoint site collection. It serves as a self-contained space for organizing content, lists, libraries, and other resources, providing a focused environment for collaboration and data management. */
export type IWeb = {
  /** Returns the URL of the access request list to the current site. */
  accessRequestListUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the description of the access request to this site. */
  accessRequestSiteDescription?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean flag indicating whether the automatic ASPX page indexed is allowed. */
  allowAutomaticASPXPageIndexing: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the current user is allowed to create declarative workflow on this site. */
  allowCreateDeclarativeWorkflowForCurrentUser: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the current user is allowed to use a designer application to customize this site. */
  allowDesignerForCurrentUser: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the current user is allowed to edit the master page. */
  allowMasterPageEditingForCurrentUser: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the current user is allowed to revert the site to a default site template. */
  allowRevertFromTemplateForCurrentUser: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the site allows RSS feeds. */
  allowRssFeeds: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the current user is allowed to save declarative workflows as template. */
  allowSaveDeclarativeWorkflowAsTemplateForCurrentUser: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the current user is allowed to publish a declarative workflow. */
  allowSavePublishDeclarativeWorkflowForCurrentUser: Scalars['Boolean']['output'];
  /** Returns the URL for an alternate cascading style sheet (CSS) to use in the website. */
  alternateCssUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the instance Id of the App Instance that this website represents. */
  appInstanceId: Scalars['UUID']['output'];
  /** Returns the associated SharePoint member group. */
  associatedMemberGroup?: Maybe<ISharePointGroup>;
  /** Returns the associated SharePoint owner group. */
  associatedOwnerGroup?: Maybe<ISharePointGroup>;
  /** Returns the associated SharePoint visitor group. */
  associatedVisitorGroup?: Maybe<ISharePointGroup>;
  /** Return a boolean flag indicating whether the comments on site pages are disabled or not. */
  commentsOnSitePagesDisabled: Scalars['Boolean']['output'];
  /** Returns a boolean flag that specifies whether the site contains highly confidential information. */
  containsConfidentialInfo: Scalars['Boolean']['output'];
  /** Returns a DateTime value specifying when the site was created. */
  created: Scalars['DateTime']['output'];
  /** Returns the custom MasterPage Url of the Site, optional attribute. */
  customMasterUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the id of the default new page template. */
  defaultNewPageTemplateId: Scalars['UUID']['output'];
  /** Return the description of the Site, optional attribute. */
  description?: Maybe<Scalars['String']['output']>;
  /** Returns the design package Id of this site. */
  designPackageId: Scalars['UUID']['output'];
  /** Return a boolean flag indicating whether to disable PowerApps for the current web. */
  disableAppViews: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether to disable flows for the current web. */
  disableFlows: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the recommended items are disabled on this site. */
  disableRecommendedItems: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the Document Library Callout's WAC previewers are enabled or not. */
  documentLibraryCalloutOfficeWebAppPreviewersDisabled: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the Web site should use Minimal Download Strategy. */
  enableMinimalDownload: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether to exclude the web from offline client. */
  excludeFromOfflineClient: Scalars['Boolean']['output'];
  /** Returns the value of the footer emphasis. */
  footerEmphasis: FooterVariantThemeType;
  /** Returns a boolean flag indicating whether the footer is enabled on the site. */
  footerEnabled: Scalars['Boolean']['output'];
  /** Returns the value of the footer layout. */
  footerLayout: FooterLayoutType;
  /** Returns the value of the header emphasis. */
  headerEmphasis: VariantThemeType;
  /** Returns the value of the header layout. */
  headerLayout: HeaderLayoutType;
  /** Returns a boolean flag indicating whether the title in header is hidden on the site. */
  hideTitleInHeader: Scalars['Boolean']['output'];
  /** Return a boolean flag indicating whether to enable the Horizontal QuickLaunch for the current web. */
  horizontalQuickLaunch: Scalars['Boolean']['output'];
  /** Returns the unique ID of the Web object. */
  id: Scalars['UUID']['output'];
  /** Returns a boolean flag indicating whether the homepage is modernized. */
  isHomepageModernized: Scalars['Boolean']['output'];
  /** Defines whether to enable Multilingual capabilities for the current web. */
  isMultilingual: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the provisioning is complete. */
  isProvisioningComplete: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the link to revert homepage is hidden. */
  isRevertHomepageLinkHidden: Scalars['Boolean']['output'];
  /** Returns the LCID for the language that is used on the site. */
  language: Scalars['Int']['output'];
  /** Returns a DateTime that specifies when an item was last modified in the site. */
  lastItemModifiedDate: Scalars['DateTime']['output'];
  /** Returns a DateTime that specifies when an item was last modified by user in the site. */
  lastItemUserModifiedDate: Scalars['DateTime']['output'];
  /** Returns the logo alignment of the site. */
  logoAlignment: LogoAlignment;
  /** Returns the URL of the master page that is used for the website. */
  masterUrl?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean flag indicating whether the megamenu is enabled on the site. */
  megaMenuEnabled: Scalars['Boolean']['output'];
  /** Return a boolean flag indicating whether members can share content from the current web. */
  membersCanShare: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the audience targeting is enabled on the navigation of the site. */
  navAudienceTargetingEnabled: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the Next steps pane should open automatically as a first run experience when someone visits the site. Note: You can only enable the experience for sites created on or after January 1, 2020. */
  nextStepsFirstRunEnabled: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the site has to be crawled or not. */
  noCrawl: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the tenant is allowed to send push notifications in OneDrive for Business. */
  notificationsInOneDriveForBusinessEnabled: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the tenant is allowed to send push notifications in SharePoint. */
  notificationsInSharePointEnabled: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the object cache is enabled on the site. */
  objectCacheEnabled: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether to OverwriteTranslationsOnChange on change for the current web. */
  overwriteTranslationsOnChange: Scalars['Boolean']['output'];
  /** Returns a boolean flag indicating whether the tenant administrator has chosen to disable the Preview Features. Default is true. */
  previewFeaturesEnabled: Scalars['Boolean']['output'];
  /** Returns the primary color of the site. */
  primaryColor?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean flag indicating whether the QuickLaunch for the site is enabled. */
  quickLaunchEnabled: Scalars['Boolean']['output'];
  /** Returns the recycle bin of the website. */
  recycleBin?: Maybe<Array<Maybe<IRecycleBinItem>>>;
  /** Returns a boolean flag indicating whether the Recycle Bin is enabled. */
  recycleBinEnabled: Scalars['Boolean']['output'];
  /** Returns the email address to which any access request will be sent. */
  requestAccessEmail?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean flag indicating whether the Web site can be saved as a site template. */
  saveSiteAsTemplateEnabled: Scalars['Boolean']['output'];
  /** Define if the suitebar search box should show or not */
  searchBoxInNavBar: SearchBoxInNavBar;
  /** Returns the search placeholder text for search box in navbar - overrides default placeholder text if set, returns null if not set. */
  searchBoxPlaceholderText?: Maybe<Scalars['String']['output']>;
  /** Defines the SearchScope for the site. */
  searchScope: SearchScope;
  /** Returns the server relative URL of the current site. */
  serverRelativeUrl?: Maybe<Scalars['String']['output']>;
  /** Returns a collection of all groups that belong to the site collection. */
  siteGroups: Array<ISharePointGroup>;
  /** Returns the description of the Web site logo. */
  siteLogoDescription?: Maybe<Scalars['String']['output']>;
  /** Returns the server-relative URL of the Web site logo. */
  siteLogoUrl?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean flag indicating whether the RSS feeds are enabled on the site. */
  syndicationEnabled: Scalars['Boolean']['output'];
  /** Returns a value specifying how tenant admin members can share. */
  tenantAdminMembersCanShare: SharingState;
  /** Returns a JSON serialized ThemeData for the current web. */
  themeData?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean flag indicating whether third party MDM (Mobile Device Management) is enabled on the site. */
  thirdPartyMdmEnabled: Scalars['Boolean']['output'];
  /** Returns the title of the Site, optional attribute. */
  title?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean flag indicating whether the tree view is enabled on the site. */
  treeViewEnabled: Scalars['Boolean']['output'];
  /** Returns the URL of the Web object. */
  url?: Maybe<Scalars['URL']['output']>;
  /** Determines whether the default access request needs to be used. */
  useAccessRequestDefault: Scalars['Boolean']['output'];
  /** Returns the name of the site definition or site template that was used to create the site. */
  webTemplate?: Maybe<Scalars['String']['output']>;
  /** Returns the web template configuration of the site. */
  webTemplateConfiguration?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean flag indicating whether the web templates experience should open automatically as a first run experience after the site was created. */
  webTemplatesGalleryFirstRunEnabled: Scalars['Boolean']['output'];
  /** Returns a string that contains the site-relative URL to which users are redirected when web is browsed (typically the site's home page). */
  welcomePage?: Maybe<Scalars['String']['output']>;
};

export type IdRequiredError = Error & {
  message: Scalars['String']['output'];
};

export type Identity = {
  additionalData?: Maybe<Array<KeyValuePairOfNullableStringAndNullableObject>>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  oDataType?: Maybe<Scalars['String']['output']>;
};

export type IdentityFilterInput = {
  additionalData?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndObjectFilterInput>;
  and?: InputMaybe<Array<IdentityFilterInput>>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  oDataType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IdentityFilterInput>>;
};

export type IdentitySet = {
  additionalData?: Maybe<Array<KeyValuePairOfNullableStringAndNullableObject>>;
  application?: Maybe<Identity>;
  device?: Maybe<Identity>;
  oDataType?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Identity>;
};

export type IdentitySetFilterInput = {
  additionalData?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndObjectFilterInput>;
  and?: InputMaybe<Array<IdentitySetFilterInput>>;
  application?: InputMaybe<IdentityFilterInput>;
  device?: InputMaybe<IdentityFilterInput>;
  oDataType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IdentitySetFilterInput>>;
  user?: InputMaybe<IdentityFilterInput>;
};

export type IdentitySetSortInput = {
  application?: InputMaybe<IdentitySortInput>;
  device?: InputMaybe<IdentitySortInput>;
  oDataType?: InputMaybe<SortEnumType>;
  user?: InputMaybe<IdentitySortInput>;
};

export type IdentitySortInput = {
  displayName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  oDataType?: InputMaybe<SortEnumType>;
};

export enum Importance {
  HIGH = 'HIGH',
  LOW = 'LOW',
  NORMAL = 'NORMAL',
}

export enum InferenceClassificationType {
  FOCUSED = 'FOCUSED',
  OTHER = 'OTHER',
}

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Invitation = {
  id: Scalars['ID']['output'];
  inviteRedeemUrl?: Maybe<Scalars['String']['output']>;
  inviteRedirectUrl?: Maybe<Scalars['String']['output']>;
  invitedUser?: Maybe<MsUser>;
  invitedUserDisplayName?: Maybe<Scalars['String']['output']>;
  invitedUserEmailAddress?: Maybe<Scalars['String']['output']>;
  invitedUserType?: Maybe<Scalars['String']['output']>;
  resetRedemption?: Maybe<Scalars['Boolean']['output']>;
  sendInvitationMessage?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type InvitationsPolicy = {
  allowedDomains: Array<Scalars['String']['output']>;
  blockedDomains: Array<Scalars['String']['output']>;
};

export type ItemBody = {
  additionalData?: Maybe<Array<KeyValuePairOfNullableStringAndNullableObject>>;
  content?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<BodyType>;
  oDataType?: Maybe<Scalars['String']['output']>;
};

export type ItemBodyFilterInput = {
  additionalData?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndObjectFilterInput>;
  and?: InputMaybe<Array<ItemBodyFilterInput>>;
  content?: InputMaybe<StringOperationFilterInput>;
  contentType?: InputMaybe<NullableOfBodyTypeOperationFilterInput>;
  oDataType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ItemBodyFilterInput>>;
};

export type ItemBodySortInput = {
  content?: InputMaybe<SortEnumType>;
  contentType?: InputMaybe<SortEnumType>;
  oDataType?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ItemsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<ItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<IListItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ItemsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IListItem>;
};

export type KeyValuePairOfInt32AndIEnumerableOfIComment = {
  key: Scalars['Int']['output'];
  value: Array<IComment>;
};

export type KeyValuePairOfNullableStringAndNullableObject = {
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Any']['output']>;
};

export type KeyValuePairOfStringAndBoolean = {
  key: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type KeyValuePairOfStringAndBooleanFilterInput = {
  and?: InputMaybe<Array<KeyValuePairOfStringAndBooleanFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KeyValuePairOfStringAndBooleanFilterInput>>;
  value?: InputMaybe<BooleanOperationFilterInput>;
};

export type KeyValuePairOfStringAndBooleanInput = {
  key: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export type KeyValuePairOfStringAndChecklistItem = {
  key: Scalars['String']['output'];
  value: ChecklistItem;
};

export type KeyValuePairOfStringAndChecklistItemFilterInput = {
  and?: InputMaybe<Array<KeyValuePairOfStringAndChecklistItemFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KeyValuePairOfStringAndChecklistItemFilterInput>>;
  value?: InputMaybe<ChecklistItemFilterInput>;
};

export type KeyValuePairOfStringAndExternalReference = {
  key: Scalars['String']['output'];
  value: ExternalReference;
};

export type KeyValuePairOfStringAndExternalReferenceFilterInput = {
  and?: InputMaybe<Array<KeyValuePairOfStringAndExternalReferenceFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KeyValuePairOfStringAndExternalReferenceFilterInput>>;
  value?: InputMaybe<ExternalReferenceFilterInput>;
};

export type KeyValuePairOfStringAndNullableChecklistItemInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<ChecklistItemInput>;
};

export type KeyValuePairOfStringAndNullableExternalReferenceInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<ExternalReferenceInput>;
};

export type KeyValuePairOfStringAndObjectFilterInput = {
  and?: InputMaybe<Array<KeyValuePairOfStringAndObjectFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KeyValuePairOfStringAndObjectFilterInput>>;
};

export type KeyValuePairOfStringAndStringFilterInput = {
  and?: InputMaybe<Array<KeyValuePairOfStringAndStringFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KeyValuePairOfStringAndStringFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export enum ListExperience {
  AUTO = 'AUTO',
  CLASSIC_EXPERIENCE = 'CLASSIC_EXPERIENCE',
  NEW_EXPERIENCE = 'NEW_EXPERIENCE',
}

export type ListExperienceOperationFilterInput = {
  eq?: InputMaybe<ListExperience>;
  in?: InputMaybe<Array<ListExperience>>;
  neq?: InputMaybe<ListExperience>;
  nin?: InputMaybe<Array<ListExperience>>;
};

export type ListFilterInputTypeOfIAttachmentFilterInput = {
  all?: InputMaybe<IAttachmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IAttachmentFilterInput>;
  some?: InputMaybe<IAttachmentFilterInput>;
};

export type ListFilterInputTypeOfICommentLikeUserEntityFilterInput = {
  all?: InputMaybe<ICommentLikeUserEntityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ICommentLikeUserEntityFilterInput>;
  some?: InputMaybe<ICommentLikeUserEntityFilterInput>;
};

export type ListFilterInputTypeOfIContentTypeFilterInput = {
  all?: InputMaybe<IContentTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IContentTypeFilterInput>;
  some?: InputMaybe<IContentTypeFilterInput>;
};

export type ListFilterInputTypeOfIEventReceiverDefinitionFilterInput = {
  all?: InputMaybe<IEventReceiverDefinitionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IEventReceiverDefinitionFilterInput>;
  some?: InputMaybe<IEventReceiverDefinitionFilterInput>;
};

export type ListFilterInputTypeOfIFieldFilterInput = {
  all?: InputMaybe<IFieldFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IFieldFilterInput>;
  some?: InputMaybe<IFieldFilterInput>;
};

export type ListFilterInputTypeOfIFieldLinkFilterInput = {
  all?: InputMaybe<IFieldLinkFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IFieldLinkFilterInput>;
  some?: InputMaybe<IFieldLinkFilterInput>;
};

export type ListFilterInputTypeOfIFileFilterInput = {
  all?: InputMaybe<IFileFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IFileFilterInput>;
  some?: InputMaybe<IFileFilterInput>;
};

export type ListFilterInputTypeOfIFileVersionFilterInput = {
  all?: InputMaybe<IFileVersionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IFileVersionFilterInput>;
  some?: InputMaybe<IFileVersionFilterInput>;
};

export type ListFilterInputTypeOfIFolderFilterInput = {
  all?: InputMaybe<IFolderFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IFolderFilterInput>;
  some?: InputMaybe<IFolderFilterInput>;
};

export type ListFilterInputTypeOfIListItemFilterInput = {
  all?: InputMaybe<IListItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IListItemFilterInput>;
  some?: InputMaybe<IListItemFilterInput>;
};

export type ListFilterInputTypeOfIListItemVersionFilterInput = {
  all?: InputMaybe<IListItemVersionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IListItemVersionFilterInput>;
  some?: InputMaybe<IListItemVersionFilterInput>;
};

export type ListFilterInputTypeOfIListSubscriptionFilterInput = {
  all?: InputMaybe<IListSubscriptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IListSubscriptionFilterInput>;
  some?: InputMaybe<IListSubscriptionFilterInput>;
};

export type ListFilterInputTypeOfISharePointGroupFilterInput = {
  all?: InputMaybe<ISharePointGroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ISharePointGroupFilterInput>;
  some?: InputMaybe<ISharePointGroupFilterInput>;
};

export type ListFilterInputTypeOfISharePointUserFilterInput = {
  all?: InputMaybe<ISharePointUserFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ISharePointUserFilterInput>;
  some?: InputMaybe<ISharePointUserFilterInput>;
};

export type ListFilterInputTypeOfIUserCustomActionFilterInput = {
  all?: InputMaybe<IUserCustomActionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IUserCustomActionFilterInput>;
  some?: InputMaybe<IUserCustomActionFilterInput>;
};

export type ListFilterInputTypeOfIViewFilterInput = {
  all?: InputMaybe<IViewFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IViewFilterInput>;
  some?: InputMaybe<IViewFilterInput>;
};

export type ListFilterInputTypeOfKeyValuePairOfStringAndBooleanFilterInput = {
  all?: InputMaybe<KeyValuePairOfStringAndBooleanFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KeyValuePairOfStringAndBooleanFilterInput>;
  some?: InputMaybe<KeyValuePairOfStringAndBooleanFilterInput>;
};

export type ListFilterInputTypeOfKeyValuePairOfStringAndChecklistItemFilterInput = {
  all?: InputMaybe<KeyValuePairOfStringAndChecklistItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KeyValuePairOfStringAndChecklistItemFilterInput>;
  some?: InputMaybe<KeyValuePairOfStringAndChecklistItemFilterInput>;
};

export type ListFilterInputTypeOfKeyValuePairOfStringAndExternalReferenceFilterInput = {
  all?: InputMaybe<KeyValuePairOfStringAndExternalReferenceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KeyValuePairOfStringAndExternalReferenceFilterInput>;
  some?: InputMaybe<KeyValuePairOfStringAndExternalReferenceFilterInput>;
};

export type ListFilterInputTypeOfKeyValuePairOfStringAndObjectFilterInput = {
  all?: InputMaybe<KeyValuePairOfStringAndObjectFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KeyValuePairOfStringAndObjectFilterInput>;
  some?: InputMaybe<KeyValuePairOfStringAndObjectFilterInput>;
};

export type ListFilterInputTypeOfKeyValuePairOfStringAndStringFilterInput = {
  all?: InputMaybe<KeyValuePairOfStringAndStringFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KeyValuePairOfStringAndStringFilterInput>;
  some?: InputMaybe<KeyValuePairOfStringAndStringFilterInput>;
};

export type ListFilterInputTypeOfRecipientFilterInput = {
  all?: InputMaybe<RecipientFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RecipientFilterInput>;
  some?: InputMaybe<RecipientFilterInput>;
};

/** A connection to a list of items. */
export type ListItemsByCamlQueryConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<ListItemsByCamlQueryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<IListItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ListItemsByCamlQueryEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IListItem>;
};

export enum ListPageRenderType {
  ANONYMOUS_USER = 'ANONYMOUS_USER',
  CUSTOMIZED_FORM = 'CUSTOMIZED_FORM',
  CUSTOMIZED_PAGE = 'CUSTOMIZED_PAGE',
  DOC_LIB_NEW_FORM = 'DOC_LIB_NEW_FORM',
  DROP_OFF_LIBRARY = 'DROP_OFF_LIBRARY',
  HAS_BUSINESS_DATA_FIELD = 'HAS_BUSINESS_DATA_FIELD',
  HAS_CUSTOM_ACTION_WITH_CODE = 'HAS_CUSTOM_ACTION_WITH_CODE',
  HAS_GEOLOCATION_FIELD = 'HAS_GEOLOCATION_FIELD',
  HAS_METADATA_NAV_FEATURE = 'HAS_METADATA_NAV_FEATURE',
  HAS_PUBLISHINGFIELD = 'HAS_PUBLISHINGFIELD',
  HAS_TASK_OUTCOME_FIELD = 'HAS_TASK_OUTCOME_FIELD',
  INVALID_CONTRO_MODE_IN_FORM = 'INVALID_CONTRO_MODE_IN_FORM',
  INVALID_FIELD_TYPE_IN_FORM = 'INVALID_FIELD_TYPE_IN_FORM',
  IS_UNGHOSTED = 'IS_UNGHOSTED',
  JS_LINK_CUSTOMIZATION = 'JS_LINK_CUSTOMIZATION',
  LIST_SETTING_OFF = 'LIST_SETTING_OFF',
  LIST_TEMPLATE_NOT_SUPPORTED = 'LIST_TEMPLATE_NOT_SUPPORTED',
  LIST_TYPE_NO_SUPPORT_FOR_MODERN_MODE = 'LIST_TYPE_NO_SUPPORT_FOR_MODERN_MODE',
  MODERN = 'MODERN',
  MULTIPE_WE_PART = 'MULTIPE_WE_PART',
  NO_SP_LIST = 'NO_SP_LIST',
  SITE_SETTING_OFF = 'SITE_SETTING_OFF',
  SPECIAL_VIEW_TYPE = 'SPECIAL_VIEW_TYPE',
  TENANT_SETTING_OFF = 'TENANT_SETTING_OFF',
  UNDEFINED = 'UNDEFINED',
  UNSUPPORTED_FIELD_TYPE_IN_FORM = 'UNSUPPORTED_FIELD_TYPE_IN_FORM',
  WEB_SETTING_OFF = 'WEB_SETTING_OFF',
  WIKI_PAGE = 'WIKI_PAGE',
  XSL_LINK_CUSTOMIZATION = 'XSL_LINK_CUSTOMIZATION',
}

export type ListPageRenderTypeOperationFilterInput = {
  eq?: InputMaybe<ListPageRenderType>;
  in?: InputMaybe<Array<ListPageRenderType>>;
  neq?: InputMaybe<ListPageRenderType>;
  nin?: InputMaybe<Array<ListPageRenderType>>;
};

export enum ListReadingDirection {
  LTR = 'LTR',
  NONE = 'NONE',
  RTL = 'RTL',
}

export type ListReadingDirectionOperationFilterInput = {
  eq?: InputMaybe<ListReadingDirection>;
  in?: InputMaybe<Array<ListReadingDirection>>;
  neq?: InputMaybe<ListReadingDirection>;
  nin?: InputMaybe<Array<ListReadingDirection>>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export enum ListTemplateType {
  ACCESS_APP = 'ACCESS_APP',
  ACCESS_REQUEST = 'ACCESS_REQUEST',
  ACC_SRV_M_SYS_ASO = 'ACC_SRV_M_SYS_ASO',
  ACC_SRV_U_SYS_APP_LOG = 'ACC_SRV_U_SYS_APP_LOG',
  ADMIN_TASKS = 'ADMIN_TASKS',
  AGENDA = 'AGENDA',
  ALCHEMY_APPROVAL_WORKFLOW = 'ALCHEMY_APPROVAL_WORKFLOW',
  ALCHEMY_MOBILE_FORM = 'ALCHEMY_MOBILE_FORM',
  ANNOUNCEMENTS = 'ANNOUNCEMENTS',
  APP_DATA_CATALOG = 'APP_DATA_CATALOG',
  APP_FILES_CATALOG = 'APP_FILES_CATALOG',
  APP_REQUESTS_LIST = 'APP_REQUESTS_LIST',
  ASSET_LIBRARY = 'ASSET_LIBRARY',
  BI_CENTER_DASHBOARDS_LIBRARY = 'BI_CENTER_DASHBOARDS_LIBRARY',
  CALL_TRACK = 'CALL_TRACK',
  CATEGORIES = 'CATEGORIES',
  CATEGORIES_LIST = 'CATEGORIES_LIST',
  CIRCULATION = 'CIRCULATION',
  COMMENTS = 'COMMENTS',
  CONTACTS = 'CONTACTS',
  CONTENT_CENTER_EXPLANATION = 'CONTENT_CENTER_EXPLANATION',
  CONTENT_CENTER_MODEL_LIBRARY = 'CONTENT_CENTER_MODEL_LIBRARY',
  CONTENT_CENTER_MODEL_USAGE = 'CONTENT_CENTER_MODEL_USAGE',
  CONTENT_CENTER_PRIME_LIBRARY = 'CONTENT_CENTER_PRIME_LIBRARY',
  CONTENT_CENTER_SAMPLE_LIBRARY = 'CONTENT_CENTER_SAMPLE_LIBRARY',
  CORPORATE_CATALOG = 'CORPORATE_CATALOG',
  CORPORATE_CATALOG_TENANT_WIDE_EXTENSIONS = 'CORPORATE_CATALOG_TENANT_WIDE_EXTENSIONS',
  CUSTOM_GRID = 'CUSTOM_GRID',
  DATA_CONNECTION_LIBRARY = 'DATA_CONNECTION_LIBRARY',
  DATA_SOURCES = 'DATA_SOURCES',
  DECISION = 'DECISION',
  DESIGN_CATALOG = 'DESIGN_CATALOG',
  DEVELOPER_SITE_DRAFT_APPS = 'DEVELOPER_SITE_DRAFT_APPS',
  DISCUSSION_BOARD = 'DISCUSSION_BOARD',
  DOCUMENT_LIBRARY = 'DOCUMENT_LIBRARY',
  EVENTS = 'EVENTS',
  EXTERNAL_LIST = 'EXTERNAL_LIST',
  E_DISCOVERY_CUSTODIANS = 'E_DISCOVERY_CUSTODIANS',
  E_DISCOVERY_CUSTOM_QUERIES = 'E_DISCOVERY_CUSTOM_QUERIES',
  E_DISCOVERY_EXPORTS = 'E_DISCOVERY_EXPORTS',
  E_DISCOVERY_SOURCES = 'E_DISCOVERY_SOURCES',
  E_DISCOVERY_SOURCE_GROUPS = 'E_DISCOVERY_SOURCE_GROUPS',
  E_DISCOVERY_SOURCE_INSTANCES = 'E_DISCOVERY_SOURCE_INSTANCES',
  FACILITY = 'FACILITY',
  FORMULAS_TABLE = 'FORMULAS_TABLE',
  GANTT_TASKS = 'GANTT_TASKS',
  GENERIC_LIST = 'GENERIC_LIST',
  HASHTAG_STORE = 'HASHTAG_STORE',
  HEALTH_REPORTS = 'HEALTH_REPORTS',
  HEALTH_RULES = 'HEALTH_RULES',
  HELP_LIBRARY = 'HELP_LIBRARY',
  HOLIDAYS = 'HOLIDAYS',
  HOME_PAGE_LIBRARY = 'HOME_PAGE_LIBRARY',
  IME_DIC = 'IME_DIC',
  INVALID_TYPE = 'INVALID_TYPE',
  IN_PLACE_RECORDS = 'IN_PLACE_RECORDS',
  ISSUE_TRACKING = 'ISSUE_TRACKING',
  ITEM_REFERENCE_COLLECTION = 'ITEM_REFERENCE_COLLECTION',
  ITEM_REFERENCE_REFERENCE = 'ITEM_REFERENCE_REFERENCE',
  ITEM_REFERENCE_REFERENCE_COLLECTION = 'ITEM_REFERENCE_REFERENCE_COLLECTION',
  LINKS = 'LINKS',
  LIST_TEMPLATE_CATALOG = 'LIST_TEMPLATE_CATALOG',
  MAINTENANCE_LOGS = 'MAINTENANCE_LOGS',
  MASTER_PAGE_CATALOG = 'MASTER_PAGE_CATALOG',
  MEETINGS = 'MEETINGS',
  MEETING_OBJECTIVE = 'MEETING_OBJECTIVE',
  MEETING_USER = 'MEETING_USER',
  MEMBERSHIP_LIST = 'MEMBERSHIP_LIST',
  MY_SITE_DOCUMENT_LIBRARY = 'MY_SITE_DOCUMENT_LIBRARY',
  MY_SITE_MICRO_BLOG_LIST = 'MY_SITE_MICRO_BLOG_LIST',
  NO_CODE_PUBLIC = 'NO_CODE_PUBLIC',
  NO_CODE_WORKFLOWS = 'NO_CODE_WORKFLOWS',
  NO_LIST_TEMPLATE = 'NO_LIST_TEMPLATE',
  OFFICE_EXTENSION_CATALOG = 'OFFICE_EXTENSION_CATALOG',
  PICTURE_LIBRARY = 'PICTURE_LIBRARY',
  POSTS = 'POSTS',
  PROMOTED_LINKS = 'PROMOTED_LINKS',
  PUBLISHING_PAGES_LIBRARY = 'PUBLISHING_PAGES_LIBRARY',
  RECIPES_TABLE = 'RECIPES_TABLE',
  REPORT_LIST_TEMPLATE = 'REPORT_LIST_TEMPLATE',
  SHARING_LINKS = 'SHARING_LINKS',
  SITE_COLLECTION_APP_CATALOG = 'SITE_COLLECTION_APP_CATALOG',
  SOLUTION_CATALOG = 'SOLUTION_CATALOG',
  SURVEY = 'SURVEY',
  TASKS = 'TASKS',
  TASKS_WITH_TIMELINE_AND_HIERARCHY = 'TASKS_WITH_TIMELINE_AND_HIERARCHY',
  TEXT_BOX = 'TEXT_BOX',
  THEME_CATALOG = 'THEME_CATALOG',
  THINGS_TO_BRING = 'THINGS_TO_BRING',
  TIMECARD = 'TIMECARD',
  USER_INFORMATION = 'USER_INFORMATION',
  VISIO_PROCESS_REPOSITORY_LIST = 'VISIO_PROCESS_REPOSITORY_LIST',
  WEB_PAGE_LIBRARY = 'WEB_PAGE_LIBRARY',
  WEB_PART_CATALOG = 'WEB_PART_CATALOG',
  WEB_TEMPLATE_CATALOG = 'WEB_TEMPLATE_CATALOG',
  WEB_TEMPLATE_EXTENSIONS_LIST = 'WEB_TEMPLATE_EXTENSIONS_LIST',
  WHEREABOUTS = 'WHEREABOUTS',
  WORKFLOW_HISTORY = 'WORKFLOW_HISTORY',
  WORKFLOW_PROCESS = 'WORKFLOW_PROCESS',
  XML_FORM = 'XML_FORM',
}

export type ListTemplateTypeOperationFilterInput = {
  eq?: InputMaybe<ListTemplateType>;
  in?: InputMaybe<Array<ListTemplateType>>;
  neq?: InputMaybe<ListTemplateType>;
  nin?: InputMaybe<Array<ListTemplateType>>;
};

export type ListTypeSortInput = {
  description?: InputMaybe<SortEnumType>;
  kind?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  scope?: InputMaybe<SortEnumType>;
  syntaxNode?: InputMaybe<ObjectTypeDefinitionNodeSortInput>;
};

export type ListUnsignedByteOperationFilterInput = {
  all?: InputMaybe<UnsignedByteOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UnsignedByteOperationFilterInput>;
  some?: InputMaybe<UnsignedByteOperationFilterInput>;
};

/** A connection to a list of items. */
export type ListsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<ListsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<IList>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ListsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IList>;
};

export type LocationSortInput = {
  column?: InputMaybe<SortEnumType>;
  end?: InputMaybe<SortEnumType>;
  line?: InputMaybe<SortEnumType>;
  start?: InputMaybe<SortEnumType>;
};

export enum LogoAlignment {
  LEFT = 'LEFT',
  MIDDLE = 'MIDDLE',
  RIGHT = 'RIGHT',
}

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  neq?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
};

export type MsUser = {
  accountEnabled?: Maybe<Scalars['Boolean']['output']>;
  businessPhones?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdDateTime?: Maybe<Scalars['DateTime']['output']>;
  creationType?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastPasswordChangeDateTime?: Maybe<Scalars['DateTime']['output']>;
  mail: Scalars['String']['output'];
  mobilePhone?: Maybe<Scalars['String']['output']>;
  officeLocation?: Maybe<Scalars['String']['output']>;
  onPremisesDistinguishedName?: Maybe<Scalars['String']['output']>;
  onPremisesDomainName?: Maybe<Scalars['String']['output']>;
  onPremisesImmutableId?: Maybe<Scalars['String']['output']>;
  onPremisesSamAccountName?: Maybe<Scalars['String']['output']>;
  onPremisesSecurityIdentifier?: Maybe<Scalars['String']['output']>;
  onPremisesUserPrincipalName?: Maybe<Scalars['String']['output']>;
  passwordPolicies?: Maybe<Scalars['String']['output']>;
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  userPrincipalName: Scalars['String']['output'];
  userType?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type MembersConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<MembersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MembersEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: User;
};

export type Mention = {
  additionalData?: Maybe<Array<KeyValuePairOfNullableStringAndNullableObject>>;
  application?: Maybe<Scalars['String']['output']>;
  clientReference?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<EmailAddress>;
  createdDateTime?: Maybe<Scalars['DateTime']['output']>;
  deepLink?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mentionText?: Maybe<Scalars['String']['output']>;
  mentioned?: Maybe<EmailAddress>;
  oDataType?: Maybe<Scalars['String']['output']>;
  serverCreatedDateTime?: Maybe<Scalars['DateTime']['output']>;
};

export type Message = {
  body?: Maybe<ItemBody>;
  bodyPreview: Scalars['String']['output'];
  changeKey?: Maybe<Scalars['String']['output']>;
  conversationId: Scalars['String']['output'];
  conversationIndex?: Maybe<Array<Scalars['UnsignedByte']['output']>>;
  createdDateTime?: Maybe<Scalars['DateTime']['output']>;
  flag?: Maybe<FollowupFlag>;
  from?: Maybe<Recipient>;
  hasAttachments?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  importance?: Maybe<Importance>;
  inferenceClassification?: Maybe<InferenceClassificationType>;
  internetMessageId: Scalars['String']['output'];
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  isRead?: Maybe<Scalars['Boolean']['output']>;
  lastModifiedDateTime?: Maybe<Scalars['DateTime']['output']>;
  parentFolderId: Scalars['String']['output'];
  receivedDateTime?: Maybe<Scalars['DateTime']['output']>;
  sender?: Maybe<Recipient>;
  sentDateTime?: Maybe<Scalars['DateTime']['output']>;
  subject: Scalars['String']['output'];
  toRecipients?: Maybe<Array<Recipient>>;
  webLink: Scalars['String']['output'];
};

export type MessageFilterInput = {
  and?: InputMaybe<Array<MessageFilterInput>>;
  body?: InputMaybe<ItemBodyFilterInput>;
  bodyPreview?: InputMaybe<StringOperationFilterInput>;
  changeKey?: InputMaybe<StringOperationFilterInput>;
  conversationId?: InputMaybe<StringOperationFilterInput>;
  conversationIndex?: InputMaybe<ListUnsignedByteOperationFilterInput>;
  createdDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  flag?: InputMaybe<FollowupFlagFilterInput>;
  from?: InputMaybe<RecipientFilterInput>;
  hasAttachments?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  importance?: InputMaybe<NullableOfImportanceOperationFilterInput>;
  inferenceClassification?: InputMaybe<NullableOfInferenceClassificationTypeOperationFilterInput>;
  internetMessageId?: InputMaybe<StringOperationFilterInput>;
  isDraft?: InputMaybe<BooleanOperationFilterInput>;
  isRead?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<MessageFilterInput>>;
  parentFolderId?: InputMaybe<StringOperationFilterInput>;
  receivedDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  sender?: InputMaybe<RecipientFilterInput>;
  sentDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  subject?: InputMaybe<StringOperationFilterInput>;
  toRecipients?: InputMaybe<ListFilterInputTypeOfRecipientFilterInput>;
  webLink?: InputMaybe<StringOperationFilterInput>;
};

export type MessageSortInput = {
  body?: InputMaybe<ItemBodySortInput>;
  bodyPreview?: InputMaybe<SortEnumType>;
  changeKey?: InputMaybe<SortEnumType>;
  conversationId?: InputMaybe<SortEnumType>;
  createdDateTime?: InputMaybe<SortEnumType>;
  flag?: InputMaybe<FollowupFlagSortInput>;
  from?: InputMaybe<RecipientSortInput>;
  hasAttachments?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  importance?: InputMaybe<SortEnumType>;
  inferenceClassification?: InputMaybe<SortEnumType>;
  internetMessageId?: InputMaybe<SortEnumType>;
  isDraft?: InputMaybe<SortEnumType>;
  isRead?: InputMaybe<SortEnumType>;
  lastModifiedDateTime?: InputMaybe<SortEnumType>;
  parentFolderId?: InputMaybe<SortEnumType>;
  receivedDateTime?: InputMaybe<SortEnumType>;
  sender?: InputMaybe<RecipientSortInput>;
  sentDateTime?: InputMaybe<SortEnumType>;
  subject?: InputMaybe<SortEnumType>;
  webLink?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type MessagesConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<MessagesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Message>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MessagesEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Message;
};

/** GraphQL input type for autocomplete parameters. */
export type MlgSearchAutocompleteInput = {
  /** Gets or sets the name of the Azure AI Search index to query. Required. */
  indexName: Scalars['String']['input'];
  /** The partial search text to autocomplete. */
  searchText: Scalars['String']['input'];
  /** Maximum number of suggestions to return. Default: 10. */
  size?: Scalars['Int']['input'];
  /** The name of the suggester to use. Uses default if not specified. */
  suggesterName?: InputMaybe<Scalars['String']['input']>;
};

/** GraphQL enum for search mode. */
export enum MlgSearchModeOption {
  ALL = 'ALL',
  ANY = 'ANY',
}

/** GraphQL input type for search query parameters. */
export type MlgSearchQueryInput = {
  /** Facets to include for filtering (e.g., ['category', 'author']). */
  facets?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter expression using OData syntax (e.g., 'category eq "News"'). */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Fields to highlight in search results. */
  highlightFields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The Azure AI Search index to query. Leave empty to use the default index configured on the server. */
  indexName: Scalars['String']['input'];
  /** Fields to order by (e.g., ['lastModified desc', 'title asc']). */
  orderBy?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The query type: SIMPLE, FULL (Lucene), or SEMANTIC. */
  queryType?: InputMaybe<MlgSearchQueryTypeOption>;
  /** Fields to search within. If not specified, all searchable fields are used. */
  searchFields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The search mode: ANY (match any term) or ALL (match all terms). */
  searchMode?: InputMaybe<MlgSearchModeOption>;
  /** The search query text. Use '*' for all documents. */
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Fields to include in the response. If not specified, all fields are returned. */
  select?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** GraphQL enum for query type. */
export enum MlgSearchQueryTypeOption {
  FULL = 'FULL',
  SEMANTIC = 'SEMANTIC',
  SIMPLE = 'SIMPLE',
}

/** GraphQL input type for suggest parameters. */
export type MlgSearchSuggestInput = {
  /** The Azure AI Search index to query */
  indexName: Scalars['String']['input'];
  /** The partial search text for suggestions. */
  searchText: Scalars['String']['input'];
  /** Fields to select in suggestions. */
  select?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Maximum number of suggestions to return. Default: 10. */
  size?: Scalars['Int']['input'];
  /** The name of the suggester to use. Uses default if not specified. */
  suggesterName?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type Mlg_Search_QueryConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Mlg_Search_QueryEdge>>;
  /** Facet aggregations returned by Azure AI Search. Populated when facets are specified in the search input (e.g. ["Category", "Tags"]). */
  facets: Array<GraphFacet>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<GraphSearchDocument>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Mlg_Search_QueryEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GraphSearchDocument>;
};

export type MultiValueLegacyExtendedProperty = {
  additionalData?: Maybe<Array<KeyValuePairOfNullableStringAndNullableObject>>;
  id?: Maybe<Scalars['String']['output']>;
  oDataType?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type NameNodeSortInput = {
  kind?: InputMaybe<SortEnumType>;
  location?: InputMaybe<LocationSortInput>;
  value?: InputMaybe<SortEnumType>;
};

export type NullableOfBodyTypeOperationFilterInput = {
  eq?: InputMaybe<BodyType>;
  in?: InputMaybe<Array<InputMaybe<BodyType>>>;
  neq?: InputMaybe<BodyType>;
  nin?: InputMaybe<Array<InputMaybe<BodyType>>>;
};

export type NullableOfFollowupFlagStatusOperationFilterInput = {
  eq?: InputMaybe<FollowupFlagStatus>;
  in?: InputMaybe<Array<InputMaybe<FollowupFlagStatus>>>;
  neq?: InputMaybe<FollowupFlagStatus>;
  nin?: InputMaybe<Array<InputMaybe<FollowupFlagStatus>>>;
};

export type NullableOfImportanceOperationFilterInput = {
  eq?: InputMaybe<Importance>;
  in?: InputMaybe<Array<InputMaybe<Importance>>>;
  neq?: InputMaybe<Importance>;
  nin?: InputMaybe<Array<InputMaybe<Importance>>>;
};

export type NullableOfInferenceClassificationTypeOperationFilterInput = {
  eq?: InputMaybe<InferenceClassificationType>;
  in?: InputMaybe<Array<InputMaybe<InferenceClassificationType>>>;
  neq?: InputMaybe<InferenceClassificationType>;
  nin?: InputMaybe<Array<InputMaybe<InferenceClassificationType>>>;
};

export type NullableOfPlannerContainerTypeOperationFilterInput = {
  eq?: InputMaybe<PlannerContainerType>;
  in?: InputMaybe<Array<InputMaybe<PlannerContainerType>>>;
  neq?: InputMaybe<PlannerContainerType>;
  nin?: InputMaybe<Array<InputMaybe<PlannerContainerType>>>;
};

export type ObjectTypeDefinitionNodeSortInput = {
  description?: InputMaybe<StringValueNodeSortInput>;
  kind?: InputMaybe<SortEnumType>;
  location?: InputMaybe<LocationSortInput>;
  name?: InputMaybe<NameNodeSortInput>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Plan = {
  buckets?: Maybe<BucketsConnection>;
  container?: Maybe<Container>;
  createdBy?: Maybe<IdentitySet>;
  createdDateTime: Scalars['DateTime']['output'];
  details?: Maybe<PlanDetails>;
  group: Group;
  id?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<TasksConnection>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PlanBucketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BucketSortInput>>;
  where?: InputMaybe<BucketFilterInput>;
};

export type PlanTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TaskSortInput>>;
  where?: InputMaybe<TaskFilterInput>;
};

export type PlanDetails = {
  categoryDescriptions?: Maybe<CategoryDescriptions>;
  id?: Maybe<Scalars['String']['output']>;
  /** Key: the id of the group or user, Value: if true, the plan is shared with this entity */
  sharedWith?: Maybe<Array<KeyValuePairOfStringAndBoolean>>;
};

export type PlanDetailsFilterInput = {
  and?: InputMaybe<Array<PlanDetailsFilterInput>>;
  categoryDescriptions?: InputMaybe<CategoryDescriptionsFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PlanDetailsFilterInput>>;
  /** Key: the id of the group or user, Value: if true, the plan is shared with this entity */
  sharedWith?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndBooleanFilterInput>;
};

export type PlanDetailsInput = {
  categoryDescriptions?: InputMaybe<CategoryDescriptionsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** Key: the id of the group or user, Value: if true, the plan is shared with this entity */
  sharedWith?: InputMaybe<Array<KeyValuePairOfStringAndBooleanInput>>;
};

export type PlanDetailsSortInput = {
  categoryDescriptions?: InputMaybe<CategoryDescriptionsSortInput>;
  id?: InputMaybe<SortEnumType>;
};

export type PlanFilterInput = {
  and?: InputMaybe<Array<PlanFilterInput>>;
  container?: InputMaybe<ContainerFilterInput>;
  createdBy?: InputMaybe<IdentitySetFilterInput>;
  createdDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  details?: InputMaybe<PlanDetailsFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PlanFilterInput>>;
  title?: InputMaybe<StringOperationFilterInput>;
};

export type PlanIdRequiredError = Error & {
  message: Scalars['String']['output'];
};

export type PlanInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PlanSortInput = {
  container?: InputMaybe<ContainerSortInput>;
  createdBy?: InputMaybe<IdentitySetSortInput>;
  createdDateTime?: InputMaybe<SortEnumType>;
  details?: InputMaybe<PlanDetailsSortInput>;
  id?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
};

export enum PlannerContainerType {
  GROUP = 'GROUP',
  ROSTER = 'ROSTER',
  UNKNOWN_FUTURE_VALUE = 'UNKNOWN_FUTURE_VALUE',
}

/** A connection to a list of items. */
export type PlansConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<PlansEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Plan>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlansEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Plan;
};

export type Policy = {
  b2BManagementPolicy?: Maybe<B2BManagementPolicy>;
};

export type Post = {
  additionalData?: Maybe<Array<KeyValuePairOfNullableStringAndNullableObject>>;
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  attachmentsNextLink?: Maybe<Scalars['String']['output']>;
  body?: Maybe<ItemBody>;
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  changeKey?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  conversationThreadId?: Maybe<Scalars['String']['output']>;
  createdDateTime?: Maybe<Scalars['DateTime']['output']>;
  extensions?: Maybe<Array<Maybe<Extension>>>;
  extensionsNextLink?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Recipient>;
  hasAttachments?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  importance?: Maybe<Importance>;
  inReplyTo?: Maybe<Post>;
  lastModifiedDateTime?: Maybe<Scalars['DateTime']['output']>;
  mentions?: Maybe<Array<Maybe<Mention>>>;
  mentionsNextLink?: Maybe<Scalars['String']['output']>;
  multiValueExtendedProperties?: Maybe<Array<Maybe<MultiValueLegacyExtendedProperty>>>;
  multiValueExtendedPropertiesNextLink?: Maybe<Scalars['String']['output']>;
  newParticipants?: Maybe<Array<Maybe<Recipient>>>;
  oDataType?: Maybe<Scalars['String']['output']>;
  receivedDateTime?: Maybe<Scalars['DateTime']['output']>;
  sender?: Maybe<Recipient>;
  singleValueExtendedProperties?: Maybe<Array<Maybe<SingleValueLegacyExtendedProperty>>>;
  singleValueExtendedPropertiesNextLink?: Maybe<Scalars['String']['output']>;
};

export type PreviewOptionsInput = {
  page?: InputMaybe<Scalars['String']['input']>;
  zoom: Scalars['Int']['input'];
};

export type PreviewPolicy = {
  features: Array<Scalars['String']['output']>;
};

export enum PrincipalType {
  ALL = 'ALL',
  DISTRIBUTION_LIST = 'DISTRIBUTION_LIST',
  NONE = 'NONE',
  SECURITY_GROUP = 'SECURITY_GROUP',
  SHARE_POINT_GROUP = 'SHARE_POINT_GROUP',
  USER = 'USER',
}

export enum PublishedStatus {
  CHECKOUT = 'CHECKOUT',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

export type PublishedStatusOperationFilterInput = {
  eq?: InputMaybe<PublishedStatus>;
  in?: InputMaybe<Array<PublishedStatus>>;
  neq?: InputMaybe<PublishedStatus>;
  nin?: InputMaybe<Array<PublishedStatus>>;
};

/** A connection to a list of items. */
export type RecentPlansConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<RecentPlansEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Plan>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RecentPlansEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Plan;
};

export type Recipient = {
  additionalData?: Maybe<Array<KeyValuePairOfNullableStringAndNullableObject>>;
  emailAddress?: Maybe<EmailAddress>;
  oDataType?: Maybe<Scalars['String']['output']>;
};

export type RecipientFilterInput = {
  additionalData?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndObjectFilterInput>;
  and?: InputMaybe<Array<RecipientFilterInput>>;
  emailAddress?: InputMaybe<EmailAddressFilterInput>;
  oDataType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RecipientFilterInput>>;
};

export type RecipientSortInput = {
  emailAddress?: InputMaybe<EmailAddressSortInput>;
  oDataType?: InputMaybe<SortEnumType>;
};

export enum RecycleBinItemState {
  FIRST_STAGE_RECYCLE_BIN = 'FIRST_STAGE_RECYCLE_BIN',
  NONE = 'NONE',
  SECOND_STAGE_RECYCLE_BIN = 'SECOND_STAGE_RECYCLE_BIN',
}

export enum RecycleBinItemType {
  APP = 'APP',
  ATTACHMENT = 'ATTACHMENT',
  CASCADE_PARENT = 'CASCADE_PARENT',
  FILE = 'FILE',
  FILE_VERSION = 'FILE_VERSION',
  FOLDER = 'FOLDER',
  FOLDER_WITH_LISTS = 'FOLDER_WITH_LISTS',
  LIST = 'LIST',
  LIST_ITEM = 'LIST_ITEM',
  LIST_ITEM_VERSION = 'LIST_ITEM_VERSION',
  NONE = 'NONE',
  WEB = 'WEB',
}

export enum RelationshipDeleteBehaviorType {
  CASCADE = 'CASCADE',
  NONE = 'NONE',
  RESTRICT = 'RESTRICT',
}

export type RelationshipDeleteBehaviorTypeOperationFilterInput = {
  eq?: InputMaybe<RelationshipDeleteBehaviorType>;
  in?: InputMaybe<Array<RelationshipDeleteBehaviorType>>;
  neq?: InputMaybe<RelationshipDeleteBehaviorType>;
  nin?: InputMaybe<Array<RelationshipDeleteBehaviorType>>;
};

export enum SpEffectiveInformationRightsManagementSettingsSource {
  FILE = 'FILE',
  LIST = 'LIST',
  NONE = 'NONE',
  RULE = 'RULE',
}

export type SpEffectiveInformationRightsManagementSettingsSourceOperationFilterInput = {
  eq?: InputMaybe<SpEffectiveInformationRightsManagementSettingsSource>;
  in?: InputMaybe<Array<SpEffectiveInformationRightsManagementSettingsSource>>;
  neq?: InputMaybe<SpEffectiveInformationRightsManagementSettingsSource>;
  nin?: InputMaybe<Array<SpEffectiveInformationRightsManagementSettingsSource>>;
};

export type SearchAggregation = {
  aggregationAdditionalData?: Maybe<Scalars['Any']['output']>;
  buckets?: Maybe<Array<Maybe<SearchBucket>>>;
  field?: Maybe<Scalars['String']['output']>;
};

export type SearchAggregationOptionInput = {
  bucketDefinition?: InputMaybe<SearchBucketAggregationDefinitionInput>;
  field?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Int']['input'];
};

export type SearchAlteration = {
  additionalData?: Maybe<Array<KeyValuePairOfNullableStringAndNullableObject>>;
  alteredHighlightedQueryString?: Maybe<Scalars['String']['output']>;
  alteredQueryString?: Maybe<Scalars['String']['output']>;
  alteredQueryTokens?: Maybe<Array<Maybe<AlteredQueryToken>>>;
  oDataType?: Maybe<Scalars['String']['output']>;
};

export type SearchAlterationOptionsInput = {
  enableModification?: InputMaybe<Scalars['Boolean']['input']>;
  enableSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SearchAlterationType {
  MODIFICATION = 'MODIFICATION',
  SUGGESTION = 'SUGGESTION',
  UNKNOWN_FUTURE_VALUE = 'UNKNOWN_FUTURE_VALUE',
}

export enum SearchBoxInNavBar {
  ALL_PAGES = 'ALL_PAGES',
  HIDDEN = 'HIDDEN',
  INHERIT = 'INHERIT',
  MODERN_ONLY = 'MODERN_ONLY',
}

export type SearchBucket = {
  aggregationFilterToken?: Maybe<Scalars['String']['output']>;
  bucketAdditionalData?: Maybe<Scalars['Any']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type SearchBucketAggregationDefinitionInput = {
  isDescending?: InputMaybe<Scalars['Boolean']['input']>;
  minimumCount?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<BucketAggregationSortProperty>;
};

/** A connection to a list of items. */
export type SearchConnection = {
  additionalData?: Maybe<Scalars['Any']['output']>;
  aggregations?: Maybe<Array<SearchAggregation>>;
  /** A list of edges. */
  edges?: Maybe<Array<SearchEdge>>;
  moreResultsAvailable: Scalars['Boolean']['output'];
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SearchResponseHit>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  queryAlterationResponse?: Maybe<AlterationResponse>;
  searchTerms?: Maybe<Array<Scalars['String']['output']>>;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SearchEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SearchResponseHit;
};

export enum SearchEntityType {
  ACRONYM = 'ACRONYM',
  BOOKMARK = 'BOOKMARK',
  CHAT_MESSAGE = 'CHAT_MESSAGE',
  DRIVE = 'DRIVE',
  DRIVE_ITEM = 'DRIVE_ITEM',
  EVENT = 'EVENT',
  LIST = 'LIST',
  LIST_ITEM = 'LIST_ITEM',
  MESSAGE = 'MESSAGE',
  SITE = 'SITE',
}

export type SearchInput = {
  aggregation?: InputMaybe<Array<SearchAggregationOptionInput>>;
  aggregationFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  query: SearchQueryInput;
  queryAlterationOptions?: InputMaybe<SearchAlterationOptionsInput>;
  searchEntity?: InputMaybe<Array<SearchEntityType>>;
  sortProperties?: InputMaybe<Array<SearchSortPropertyInput>>;
  trimDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchQueryInput = {
  queryString: Scalars['String']['input'];
  queryTemplate?: InputMaybe<Scalars['String']['input']>;
};

/** Provides various options and parameters for conducting search operations */
export type SearchQueryOptionsInput = {
  /** The type of client that issued the query (Optional: defaults to "ContentSearchRegular"). */
  clientType?: InputMaybe<Scalars['String']['input']>;
  /** A string that contains the text for the search query. */
  queryText?: InputMaybe<Scalars['String']['input']>;
  /** Represents a set of properties that can be used to further refine search results; allows users to filter and narrow down the results based on specific metadata, custom fields, or attributes associated with the content stored in SharePoint. Syntax: refineProperties: ["DepartmentId", "Author"] */
  refineProperties?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Provides a way to fine-tune search results based on specific metadata, properties, or custom fields, enhancing search precision. Syntax: refinementFilters: ["contentclass:equals("STS_Site")"] */
  refinementFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Is an identifier (GUID) of the result source to be used to run the query. Result source specifies the location of the search results and it allows you to define where the search query should be executed and what content sources should be included in the search results. */
  resultSourceId?: InputMaybe<Scalars['String']['input']>;
  /** The managed properties to return in the search results. Search will retrieve all properties if not specified. To return a managed property, set the property's retrievable flag to true in the search schema. Syntax: selectProperties: ["Id", "Title"] */
  selectProperties: Array<Scalars['String']['input']>;
  /** The list of properties by which the search results are ordered. Syntax: sortProperties: [{property: "RefinableString00" sort:  ASCENDING }] */
  sortProperties?: InputMaybe<Array<SortOptionInput>>;
  /** Trim duplicate search results */
  trimDuplicates: Scalars['Boolean']['input'];
};

export type SearchResponseHit = {
  additionalData?: Maybe<Scalars['Any']['output']>;
  contentSource?: Maybe<Scalars['String']['output']>;
  hitId?: Maybe<Scalars['String']['output']>;
  oDataType?: Maybe<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  resource?: Maybe<Scalars['Any']['output']>;
  resultTemplateId?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

/** Represents a collection of search result rows obtained from a search query. Each row encapsulates specific information about a document, list item, or other content matching the search criteria. */
export type SearchResultRows = {
  /** Returns the search result managed properties as key-value pair. */
  managedProperties?: Maybe<Array<StringJsonKeyValuePair>>;
  /** Returns the search result row ID. */
  rowId: Scalars['Int']['output'];
  /** Returns the Search result title. */
  title?: Maybe<Scalars['String']['output']>;
};

export enum SearchScope {
  DEFAULT_SCOPE = 'DEFAULT_SCOPE',
  HUB = 'HUB',
  SITE = 'SITE',
  TENANT = 'TENANT',
}

export type SearchSortPropertyInput = {
  isDescending?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum SharingState {
  OFF = 'OFF',
  ON = 'ON',
  UNSPECIFIED = 'UNSPECIFIED',
}

export enum ShowInFiltersPaneStatus {
  AUTO = 'AUTO',
  PINNED = 'PINNED',
  REMOVED = 'REMOVED',
}

export type ShowInFiltersPaneStatusOperationFilterInput = {
  eq?: InputMaybe<ShowInFiltersPaneStatus>;
  in?: InputMaybe<Array<ShowInFiltersPaneStatus>>;
  neq?: InputMaybe<ShowInFiltersPaneStatus>;
  nin?: InputMaybe<Array<ShowInFiltersPaneStatus>>;
};

export type SingleValueLegacyExtendedProperty = {
  additionalData?: Maybe<Array<KeyValuePairOfNullableStringAndNullableObject>>;
  id?: Maybe<Scalars['String']['output']>;
  oDataType?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum SortDirection {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
}

export enum SortEnumType {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type SortOptionInput = {
  property?: InputMaybe<Scalars['String']['input']>;
  sort: SortDirection;
};

/** A connection to a list of items. */
export type SpSearchConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<SpSearchEdge>>;
  /** Returns a time in milliseconds the search query took server side. */
  elapsedTime: Scalars['Int']['output'];
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SearchResultRows>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Returns a collection of refinement results as key-value pairs. */
  refinementResults?: Maybe<Array<StringJsonKeyValuePair>>;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
  /** Returns the total rows, including duplicates, that match the provided query. */
  totalRowsIncludingDuplicates: Scalars['Long']['output'];
};

/** An edge in a connection. */
export type SpSearchEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SearchResultRows;
};

/** This provides a convenient and type-safe solution for efficiently storing, manipulating, and handling key-value pairs within dynamic or unknown JSON structures. */
export type StringJsonKeyValuePair = {
  /** Represents the key or identifier of the key-value pair. It is of type string and provides a unique reference to the associated JSON value. */
  key: Scalars['String']['output'];
  /** Represents the JSON value associated with the corresponding key. It is of type JsonElement and allows for flexible storage and manipulation of various data types within a JSON context. */
  value: Scalars['JSON']['output'];
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringValueNodeSortInput = {
  block?: InputMaybe<SortEnumType>;
  kind?: InputMaybe<SortEnumType>;
  location?: InputMaybe<LocationSortInput>;
  value?: InputMaybe<SortEnumType>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type Task = {
  activeChecklistItemCount: Scalars['Int']['output'];
  appliedCategories: Array<KeyValuePairOfStringAndBoolean>;
  assigneePriority?: Maybe<Scalars['String']['output']>;
  assignments: Array<KeyValuePairOfStringAndBoolean>;
  bucket?: Maybe<Bucket>;
  bucketId?: Maybe<Scalars['String']['output']>;
  checklistItemCount: Scalars['Int']['output'];
  completedBy?: Maybe<IdentitySet>;
  completedDateTime?: Maybe<Scalars['DateTime']['output']>;
  conversationThreadId?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<IdentitySet>;
  createdDateTime?: Maybe<Scalars['DateTime']['output']>;
  details?: Maybe<TaskDetails>;
  dueDateTime?: Maybe<Scalars['DateTime']['output']>;
  hasDescription: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['String']['output']>;
  orderHint?: Maybe<Scalars['String']['output']>;
  percentComplete: Scalars['Int']['output'];
  plan: Plan;
  planId?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  referenceCount: Scalars['Int']['output'];
  startDateTime?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TaskDetails = {
  checklist?: Maybe<Array<KeyValuePairOfStringAndChecklistItem>>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  previewType?: Maybe<Scalars['String']['output']>;
  references?: Maybe<Array<KeyValuePairOfStringAndExternalReference>>;
};

export type TaskDetailsFilterInput = {
  and?: InputMaybe<Array<TaskDetailsFilterInput>>;
  checklist?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndChecklistItemFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TaskDetailsFilterInput>>;
  previewType?: InputMaybe<StringOperationFilterInput>;
  references?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndExternalReferenceFilterInput>;
};

export type TaskDetailsInput = {
  /** Add, edit, or delete checklist items. To edit, pass the checklist item ID as the key and the ChecklistItemInput as value. To add, pass a random GUID as the key. To delete, pass the checklist ID as the key, and make sure the title of the item is blank */
  checklist?: InputMaybe<Array<KeyValuePairOfStringAndNullableChecklistItemInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  previewType?: InputMaybe<Scalars['String']['input']>;
  references?: InputMaybe<Array<KeyValuePairOfStringAndNullableExternalReferenceInput>>;
};

export type TaskDetailsSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  previewType?: InputMaybe<SortEnumType>;
};

export type TaskFilterInput = {
  activeChecklistItemCount?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<TaskFilterInput>>;
  appliedCategories?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndBooleanFilterInput>;
  assigneePriority?: InputMaybe<StringOperationFilterInput>;
  assignments?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndBooleanFilterInput>;
  bucketId?: InputMaybe<StringOperationFilterInput>;
  checklistItemCount?: InputMaybe<IntOperationFilterInput>;
  completedBy?: InputMaybe<IdentitySetFilterInput>;
  completedDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  conversationThreadId?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<IdentitySetFilterInput>;
  createdDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  details?: InputMaybe<TaskDetailsFilterInput>;
  dueDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  hasDescription?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TaskFilterInput>>;
  orderHint?: InputMaybe<StringOperationFilterInput>;
  percentComplete?: InputMaybe<IntOperationFilterInput>;
  planId?: InputMaybe<StringOperationFilterInput>;
  priority?: InputMaybe<IntOperationFilterInput>;
  referenceCount?: InputMaybe<IntOperationFilterInput>;
  startDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
};

export type TaskInput = {
  appliedCategories?: InputMaybe<Array<KeyValuePairOfStringAndBooleanInput>>;
  assigneePriority?: InputMaybe<Scalars['String']['input']>;
  assignments?: InputMaybe<Array<KeyValuePairOfStringAndBooleanInput>>;
  bucketId?: InputMaybe<Scalars['String']['input']>;
  dueDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderHint?: InputMaybe<Scalars['String']['input']>;
  percentComplete?: InputMaybe<Scalars['Int']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  startDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TaskSortInput = {
  activeChecklistItemCount?: InputMaybe<SortEnumType>;
  assigneePriority?: InputMaybe<SortEnumType>;
  bucketId?: InputMaybe<SortEnumType>;
  checklistItemCount?: InputMaybe<SortEnumType>;
  completedBy?: InputMaybe<IdentitySetSortInput>;
  completedDateTime?: InputMaybe<SortEnumType>;
  conversationThreadId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<IdentitySetSortInput>;
  createdDateTime?: InputMaybe<SortEnumType>;
  details?: InputMaybe<TaskDetailsSortInput>;
  dueDateTime?: InputMaybe<SortEnumType>;
  hasDescription?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  orderHint?: InputMaybe<SortEnumType>;
  percentComplete?: InputMaybe<SortEnumType>;
  planId?: InputMaybe<SortEnumType>;
  priority?: InputMaybe<SortEnumType>;
  referenceCount?: InputMaybe<SortEnumType>;
  startDateTime?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type TasksConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<TasksEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Task>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TasksEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Task;
};

export type UnsignedByteOperationFilterInput = {
  eq?: InputMaybe<Scalars['UnsignedByte']['input']>;
  gt?: InputMaybe<Scalars['UnsignedByte']['input']>;
  gte?: InputMaybe<Scalars['UnsignedByte']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedByte']['input']>>>;
  lt?: InputMaybe<Scalars['UnsignedByte']['input']>;
  lte?: InputMaybe<Scalars['UnsignedByte']['input']>;
  neq?: InputMaybe<Scalars['UnsignedByte']['input']>;
  ngt?: InputMaybe<Scalars['UnsignedByte']['input']>;
  ngte?: InputMaybe<Scalars['UnsignedByte']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UnsignedByte']['input']>>>;
  nlt?: InputMaybe<Scalars['UnsignedByte']['input']>;
  nlte?: InputMaybe<Scalars['UnsignedByte']['input']>;
};

export type UpdateBucketError = IdRequiredError;

export type UpdateBucketInput = {
  input: BucketInput;
};

export type UpdateBucketPayload = {
  bucket?: Maybe<Bucket>;
  errors?: Maybe<Array<UpdateBucketError>>;
};

export type UpdateListItemInput = {
  /** The unique identifier (GUID) or the title of the SharePoint list that is being retrieved. */
  listIdOrTitle: Scalars['String']['input'];
  /** The unique identifier of the list item to be updated. */
  listItemId: Scalars['Int']['input'];
  /** The URL of the SharePoint site. */
  siteUrl: Scalars['URL']['input'];
  /** JSON data representing the properties and values of the new list item. */
  values: Scalars['JSON']['input'];
};

export type UpdateListItemPayload = {
  iListItem?: Maybe<IListItem>;
};

export type UpdatePlanDetailsError = IdRequiredError;

export type UpdatePlanDetailsInput = {
  input: PlanDetailsInput;
};

export type UpdatePlanDetailsPayload = {
  errors?: Maybe<Array<UpdatePlanDetailsError>>;
  planDetails?: Maybe<PlanDetails>;
};

export type UpdatePlanError = IdRequiredError;

export type UpdatePlanInput = {
  input: PlanInput;
};

export type UpdatePlanPayload = {
  errors?: Maybe<Array<UpdatePlanError>>;
  plan?: Maybe<Plan>;
};

export type UpdateTaskDetailsError = IdRequiredError;

export type UpdateTaskDetailsInput = {
  input: TaskDetailsInput;
};

export type UpdateTaskDetailsPayload = {
  errors?: Maybe<Array<UpdateTaskDetailsError>>;
  taskDetails?: Maybe<TaskDetails>;
};

export type UpdateTaskError = IdRequiredError;

export type UpdateTaskInput = {
  input: TaskInput;
};

export type UpdateTaskPayload = {
  errors?: Maybe<Array<UpdateTaskError>>;
  task?: Maybe<Task>;
};

export type UpdateUserError = IdRequiredError;

export type UpdateUserInput = {
  input: UserInput;
};

export type UpdateUserPayload = {
  errors?: Maybe<Array<UpdateUserError>>;
  user?: Maybe<User>;
};

export type User = {
  MLPersonnelInfo?: Maybe<Mlfsl_Personnel>;
  businessPhones?: Maybe<Array<Scalars['String']['output']>>;
  checkMemberGroups: Array<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  favoritePlans?: Maybe<FavoritePlansConnection>;
  givenName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<GroupsConnection>;
  id?: Maybe<Scalars['String']['output']>;
  images: UserImages;
  jobTitle?: Maybe<Scalars['String']['output']>;
  mail?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<MessagesConnection>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  officeLocation?: Maybe<Scalars['String']['output']>;
  plans?: Maybe<PlansConnection>;
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  recentPlans?: Maybe<RecentPlansConnection>;
  surname?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<TasksConnection>;
  userPrincipalName?: Maybe<Scalars['String']['output']>;
};

export type UserCheckMemberGroupsArgs = {
  groupIds: Array<Scalars['String']['input']>;
};

export type UserFavoritePlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PlanSortInput>>;
  where?: InputMaybe<PlanFilterInput>;
};

export type UserGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type UserMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MessageSortInput>>;
  where?: InputMaybe<MessageFilterInput>;
};

export type UserPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PlanSortInput>>;
  where?: InputMaybe<PlanFilterInput>;
};

export type UserRecentPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PlanSortInput>>;
  where?: InputMaybe<PlanFilterInput>;
};

export type UserTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TaskSortInput>>;
  where?: InputMaybe<TaskFilterInput>;
};

export enum UserCustomActionRegistrationType {
  CONTENT_TYPE = 'CONTENT_TYPE',
  FILE_TYPE = 'FILE_TYPE',
  LIST = 'LIST',
  NONE = 'NONE',
  PROG_ID = 'PROG_ID',
}

export type UserCustomActionRegistrationTypeOperationFilterInput = {
  eq?: InputMaybe<UserCustomActionRegistrationType>;
  in?: InputMaybe<Array<UserCustomActionRegistrationType>>;
  neq?: InputMaybe<UserCustomActionRegistrationType>;
  nin?: InputMaybe<Array<UserCustomActionRegistrationType>>;
};

export enum UserCustomActionScope {
  LIST = 'LIST',
  SITE = 'SITE',
  UNKNOWN = 'UNKNOWN',
  WEB = 'WEB',
}

export type UserCustomActionScopeOperationFilterInput = {
  eq?: InputMaybe<UserCustomActionScope>;
  in?: InputMaybe<Array<UserCustomActionScope>>;
  neq?: InputMaybe<UserCustomActionScope>;
  nin?: InputMaybe<Array<UserCustomActionScope>>;
};

export type UserFilterInput = {
  and?: InputMaybe<Array<UserFilterInput>>;
  businessPhones?: InputMaybe<ListStringOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  givenName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  jobTitle?: InputMaybe<StringOperationFilterInput>;
  mail?: InputMaybe<StringOperationFilterInput>;
  mobilePhone?: InputMaybe<StringOperationFilterInput>;
  officeLocation?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserFilterInput>>;
  preferredLanguage?: InputMaybe<StringOperationFilterInput>;
  surname?: InputMaybe<StringOperationFilterInput>;
  userPrincipalName?: InputMaybe<StringOperationFilterInput>;
};

export type UserImages = {
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
};

export type UserInput = {
  favoritePlans?: InputMaybe<Array<KeyValuePairOfStringAndBooleanInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type UserInviteInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  inviteRedirectUrl: Scalars['String']['input'];
  invitedUserEmailAddress: Scalars['String']['input'];
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type UserSortInput = {
  displayName?: InputMaybe<SortEnumType>;
  givenName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  jobTitle?: InputMaybe<SortEnumType>;
  mail?: InputMaybe<SortEnumType>;
  mobilePhone?: InputMaybe<SortEnumType>;
  officeLocation?: InputMaybe<SortEnumType>;
  preferredLanguage?: InputMaybe<SortEnumType>;
  surname?: InputMaybe<SortEnumType>;
  userPrincipalName?: InputMaybe<SortEnumType>;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

export enum VariantThemeType {
  NEUTRAL = 'NEUTRAL',
  NONE = 'NONE',
  SOFT = 'SOFT',
  STRONG = 'STRONG',
}

export enum ViewScope {
  DEFAULT = 'DEFAULT',
  FILES_ONLY = 'FILES_ONLY',
  RECURSIVE = 'RECURSIVE',
  RECURSIVE_ALL = 'RECURSIVE_ALL',
}

export type ViewScopeOperationFilterInput = {
  eq?: InputMaybe<ViewScope>;
  in?: InputMaybe<Array<ViewScope>>;
  neq?: InputMaybe<ViewScope>;
  nin?: InputMaybe<Array<ViewScope>>;
};

export enum ViewType {
  CALENDAR = 'CALENDAR',
  CHART = 'CHART',
  GANTT = 'GANTT',
  GRID = 'GRID',
  HTML = 'HTML',
  NONE = 'NONE',
  RECURRENCE = 'RECURRENCE',
}

export enum ViewType2 {
  COMPACTLIST = 'COMPACTLIST',
  KANBAN = 'KANBAN',
  MODERNCALENDAR = 'MODERNCALENDAR',
  NONE = 'NONE',
  TILES = 'TILES',
}

export type ViewType2OperationFilterInput = {
  eq?: InputMaybe<ViewType2>;
  in?: InputMaybe<Array<ViewType2>>;
  neq?: InputMaybe<ViewType2>;
  nin?: InputMaybe<Array<ViewType2>>;
};

export type ViewTypeOperationFilterInput = {
  eq?: InputMaybe<ViewType>;
  in?: InputMaybe<Array<ViewType>>;
  neq?: InputMaybe<ViewType>;
  nin?: InputMaybe<Array<ViewType>>;
};

/** Tracks external guest accounts added to Microsoft Entra. */
export type B2b_External_Accounts = {
  company_organization_name: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  last_name: Scalars['String']['output'];
  /** An object relationship */
  request: B2b_Requests;
  request_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** order by aggregate values of table "b2b.external_accounts" */
export type B2b_External_Accounts_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<B2b_External_Accounts_Max_Order_By>;
  min?: InputMaybe<B2b_External_Accounts_Min_Order_By>;
};

/** input type for inserting array relation for remote table "b2b.external_accounts" */
export type B2b_External_Accounts_Arr_Rel_Insert_Input = {
  data: Array<B2b_External_Accounts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<B2b_External_Accounts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "b2b.external_accounts". All fields are combined with a logical 'AND'. */
export type B2b_External_Accounts_Bool_Exp = {
  _and?: InputMaybe<Array<B2b_External_Accounts_Bool_Exp>>;
  _not?: InputMaybe<B2b_External_Accounts_Bool_Exp>;
  _or?: InputMaybe<Array<B2b_External_Accounts_Bool_Exp>>;
  company_organization_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  request?: InputMaybe<B2b_Requests_Bool_Exp>;
  request_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "b2b.external_accounts" */
export enum B2b_External_Accounts_Constraint {
  /** unique or primary key constraint on columns "id" */
  External_accounts_pkey = 'external_accounts_pkey',
}

/** input type for inserting data into table "b2b.external_accounts" */
export type B2b_External_Accounts_Insert_Input = {
  company_organization_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<B2b_Requests_Obj_Rel_Insert_Input>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "b2b.external_accounts" */
export type B2b_External_Accounts_Max_Order_By = {
  company_organization_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "b2b.external_accounts" */
export type B2b_External_Accounts_Min_Order_By = {
  company_organization_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "b2b.external_accounts" */
export type B2b_External_Accounts_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<B2b_External_Accounts>;
};

/** on_conflict condition type for table "b2b.external_accounts" */
export type B2b_External_Accounts_On_Conflict = {
  constraint: B2b_External_Accounts_Constraint;
  update_columns?: Array<B2b_External_Accounts_Update_Column>;
  where?: InputMaybe<B2b_External_Accounts_Bool_Exp>;
};

/** Ordering options when selecting data from "b2b.external_accounts". */
export type B2b_External_Accounts_Order_By = {
  company_organization_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  request?: InputMaybe<B2b_Requests_Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: b2b.external_accounts */
export type B2b_External_Accounts_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "b2b.external_accounts" */
export enum B2b_External_Accounts_Select_Column {
  /** column name */
  Company_organization_name = 'company_organization_name',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Email = 'email',
  /** column name */
  First_name = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  Last_name = 'last_name',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "b2b.external_accounts" */
export type B2b_External_Accounts_Set_Input = {
  company_organization_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "b2b_external_accounts" */
export type B2b_External_Accounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: B2b_External_Accounts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type B2b_External_Accounts_Stream_Cursor_Value_Input = {
  company_organization_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "b2b.external_accounts" */
export enum B2b_External_Accounts_Update_Column {
  /** column name */
  Company_organization_name = 'company_organization_name',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Email = 'email',
  /** column name */
  First_name = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  Last_name = 'last_name',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

export type B2b_External_Accounts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<B2b_External_Accounts_Set_Input>;
  /** filter the rows which have to be updated */
  where: B2b_External_Accounts_Bool_Exp;
};

/** columns and relationships of "b2b.logs" */
export type B2b_Logs = {
  approval_status?: Maybe<Scalars['String']['output']>;
  approver?: Maybe<Mlfsl_Personnel>;
  approver_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  event_description: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  request: B2b_Requests;
  request_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** columns and relationships of "b2b.logs" */
export type B2b_LogsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "b2b.logs" */
export type B2b_Logs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<B2b_Logs_Max_Order_By>;
  min?: InputMaybe<B2b_Logs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "b2b.logs" */
export type B2b_Logs_Arr_Rel_Insert_Input = {
  data: Array<B2b_Logs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<B2b_Logs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "b2b.logs". All fields are combined with a logical 'AND'. */
export type B2b_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<B2b_Logs_Bool_Exp>>;
  _not?: InputMaybe<B2b_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<B2b_Logs_Bool_Exp>>;
  approval_status?: InputMaybe<String_Comparison_Exp>;
  approver_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  event_description?: InputMaybe<String_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  request?: InputMaybe<B2b_Requests_Bool_Exp>;
  request_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "b2b.logs" */
export enum B2b_Logs_Constraint {
  /** unique or primary key constraint on columns "id" */
  Logs_pkey = 'logs_pkey',
}

/** input type for inserting data into table "b2b.logs" */
export type B2b_Logs_Insert_Input = {
  approval_status?: InputMaybe<Scalars['String']['input']>;
  approver_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  event_description?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  request?: InputMaybe<B2b_Requests_Obj_Rel_Insert_Input>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "b2b.logs" */
export type B2b_Logs_Max_Order_By = {
  approval_status?: InputMaybe<Order_By>;
  approver_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  event_description?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "b2b.logs" */
export type B2b_Logs_Min_Order_By = {
  approval_status?: InputMaybe<Order_By>;
  approver_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  event_description?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "b2b.logs" */
export type B2b_Logs_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<B2b_Logs>;
};

/** on_conflict condition type for table "b2b.logs" */
export type B2b_Logs_On_Conflict = {
  constraint: B2b_Logs_Constraint;
  update_columns?: Array<B2b_Logs_Update_Column>;
  where?: InputMaybe<B2b_Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "b2b.logs". */
export type B2b_Logs_Order_By = {
  approval_status?: InputMaybe<Order_By>;
  approver_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  event_description?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  request?: InputMaybe<B2b_Requests_Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** select columns of table "b2b.logs" */
export enum B2b_Logs_Select_Column {
  /** column name */
  Approval_status = 'approval_status',
  /** column name */
  Approver_id = 'approver_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Event_description = 'event_description',
  /** column name */
  Event_type = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** Streaming cursor of the table "b2b_logs" */
export type B2b_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: B2b_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type B2b_Logs_Stream_Cursor_Value_Input = {
  approval_status?: InputMaybe<Scalars['String']['input']>;
  approver_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  event_description?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** placeholder for update columns of table "b2b.logs" (current role has no relevant permissions) */
export enum B2b_Logs_Update_Column {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER',
}

/** Maintains a list of internal ML employees who sponsor external accounts. */
export type B2b_Ml_Sponsor_References = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  request: B2b_Requests;
  request_id: Scalars['uuid']['output'];
  sponsor?: Maybe<Mlfsl_Personnel>;
  sponsor_ad_id: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** order by aggregate values of table "b2b.ml_sponsor_references" */
export type B2b_Ml_Sponsor_References_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<B2b_Ml_Sponsor_References_Max_Order_By>;
  min?: InputMaybe<B2b_Ml_Sponsor_References_Min_Order_By>;
};

/** input type for inserting array relation for remote table "b2b.ml_sponsor_references" */
export type B2b_Ml_Sponsor_References_Arr_Rel_Insert_Input = {
  data: Array<B2b_Ml_Sponsor_References_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<B2b_Ml_Sponsor_References_On_Conflict>;
};

/** Boolean expression to filter rows from the table "b2b.ml_sponsor_references". All fields are combined with a logical 'AND'. */
export type B2b_Ml_Sponsor_References_Bool_Exp = {
  _and?: InputMaybe<Array<B2b_Ml_Sponsor_References_Bool_Exp>>;
  _not?: InputMaybe<B2b_Ml_Sponsor_References_Bool_Exp>;
  _or?: InputMaybe<Array<B2b_Ml_Sponsor_References_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  request?: InputMaybe<B2b_Requests_Bool_Exp>;
  request_id?: InputMaybe<Uuid_Comparison_Exp>;
  sponsor_ad_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "b2b.ml_sponsor_references" */
export enum B2b_Ml_Sponsor_References_Constraint {
  /** unique or primary key constraint on columns "id" */
  Ml_sponsor_references_pkey = 'ml_sponsor_references_pkey',
}

/** input type for inserting data into table "b2b.ml_sponsor_references" */
export type B2b_Ml_Sponsor_References_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request?: InputMaybe<B2b_Requests_Obj_Rel_Insert_Input>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  sponsor_ad_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "b2b.ml_sponsor_references" */
export type B2b_Ml_Sponsor_References_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  sponsor_ad_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "b2b.ml_sponsor_references" */
export type B2b_Ml_Sponsor_References_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  sponsor_ad_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "b2b.ml_sponsor_references" */
export type B2b_Ml_Sponsor_References_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<B2b_Ml_Sponsor_References>;
};

/** on_conflict condition type for table "b2b.ml_sponsor_references" */
export type B2b_Ml_Sponsor_References_On_Conflict = {
  constraint: B2b_Ml_Sponsor_References_Constraint;
  update_columns?: Array<B2b_Ml_Sponsor_References_Update_Column>;
  where?: InputMaybe<B2b_Ml_Sponsor_References_Bool_Exp>;
};

/** Ordering options when selecting data from "b2b.ml_sponsor_references". */
export type B2b_Ml_Sponsor_References_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request?: InputMaybe<B2b_Requests_Order_By>;
  request_id?: InputMaybe<Order_By>;
  sponsor_ad_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: b2b.ml_sponsor_references */
export type B2b_Ml_Sponsor_References_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "b2b.ml_sponsor_references" */
export enum B2b_Ml_Sponsor_References_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Sponsor_ad_id = 'sponsor_ad_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "b2b.ml_sponsor_references" */
export type B2b_Ml_Sponsor_References_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  sponsor_ad_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "b2b_ml_sponsor_references" */
export type B2b_Ml_Sponsor_References_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: B2b_Ml_Sponsor_References_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type B2b_Ml_Sponsor_References_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  sponsor_ad_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "b2b.ml_sponsor_references" */
export enum B2b_Ml_Sponsor_References_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Sponsor_ad_id = 'sponsor_ad_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

export type B2b_Ml_Sponsor_References_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<B2b_Ml_Sponsor_References_Set_Input>;
  /** filter the rows which have to be updated */
  where: B2b_Ml_Sponsor_References_Bool_Exp;
};

/** columns and relationships of "b2b.request_status" */
export type B2b_Request_Status = {
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  requests: Array<B2b_Requests>;
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "b2b.request_status" */
export type B2b_Request_StatusRequestsArgs = {
  distinct_on?: InputMaybe<Array<B2b_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<B2b_Requests_Order_By>>;
  where?: InputMaybe<B2b_Requests_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "b2b.request_status". All fields are combined with a logical 'AND'. */
export type B2b_Request_Status_Bool_Exp = {
  _and?: InputMaybe<Array<B2b_Request_Status_Bool_Exp>>;
  _not?: InputMaybe<B2b_Request_Status_Bool_Exp>;
  _or?: InputMaybe<Array<B2b_Request_Status_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  requests?: InputMaybe<B2b_Requests_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "b2b.request_status". */
export type B2b_Request_Status_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  requests_aggregate?: InputMaybe<B2b_Requests_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "b2b.request_status" */
export enum B2b_Request_Status_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Updated_at = 'updated_at',
}

/** Streaming cursor of the table "b2b_request_status" */
export type B2b_Request_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: B2b_Request_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type B2b_Request_Status_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Stores details of account requests, including requestor information, requested account details, and timestamps. */
export type B2b_Requests = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  description: Scalars['String']['output'];
  /** An array relationship */
  external_accounts: Array<B2b_External_Accounts>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  logs: Array<B2b_Logs>;
  /** An array relationship */
  ml_sponsor_references: Array<B2b_Ml_Sponsor_References>;
  redirect_url: Scalars['String']['output'];
  request_id: Scalars['Int']['output'];
  /** An object relationship */
  request_status: B2b_Request_Status;
  /** An array relationship */
  resource_owner_references: Array<B2b_Resource_Owner_References>;
  send_invitation_to: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** Stores details of account requests, including requestor information, requested account details, and timestamps. */
export type B2b_RequestsExternal_AccountsArgs = {
  distinct_on?: InputMaybe<Array<B2b_External_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<B2b_External_Accounts_Order_By>>;
  where?: InputMaybe<B2b_External_Accounts_Bool_Exp>;
};

/** Stores details of account requests, including requestor information, requested account details, and timestamps. */
export type B2b_RequestsLogsArgs = {
  distinct_on?: InputMaybe<Array<B2b_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<B2b_Logs_Order_By>>;
  where?: InputMaybe<B2b_Logs_Bool_Exp>;
};

/** Stores details of account requests, including requestor information, requested account details, and timestamps. */
export type B2b_RequestsMl_Sponsor_ReferencesArgs = {
  distinct_on?: InputMaybe<Array<B2b_Ml_Sponsor_References_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<B2b_Ml_Sponsor_References_Order_By>>;
  where?: InputMaybe<B2b_Ml_Sponsor_References_Bool_Exp>;
};

/** Stores details of account requests, including requestor information, requested account details, and timestamps. */
export type B2b_RequestsResource_Owner_ReferencesArgs = {
  distinct_on?: InputMaybe<Array<B2b_Resource_Owner_References_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<B2b_Resource_Owner_References_Order_By>>;
  where?: InputMaybe<B2b_Resource_Owner_References_Bool_Exp>;
};

/** order by aggregate values of table "b2b.requests" */
export type B2b_Requests_Aggregate_Order_By = {
  avg?: InputMaybe<B2b_Requests_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<B2b_Requests_Max_Order_By>;
  min?: InputMaybe<B2b_Requests_Min_Order_By>;
  stddev?: InputMaybe<B2b_Requests_Stddev_Order_By>;
  stddev_pop?: InputMaybe<B2b_Requests_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<B2b_Requests_Stddev_Samp_Order_By>;
  sum?: InputMaybe<B2b_Requests_Sum_Order_By>;
  var_pop?: InputMaybe<B2b_Requests_Var_Pop_Order_By>;
  var_samp?: InputMaybe<B2b_Requests_Var_Samp_Order_By>;
  variance?: InputMaybe<B2b_Requests_Variance_Order_By>;
};

/** order by avg() on columns of table "b2b.requests" */
export type B2b_Requests_Avg_Order_By = {
  request_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "b2b.requests". All fields are combined with a logical 'AND'. */
export type B2b_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<B2b_Requests_Bool_Exp>>;
  _not?: InputMaybe<B2b_Requests_Bool_Exp>;
  _or?: InputMaybe<Array<B2b_Requests_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  external_accounts?: InputMaybe<B2b_External_Accounts_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  logs?: InputMaybe<B2b_Logs_Bool_Exp>;
  ml_sponsor_references?: InputMaybe<B2b_Ml_Sponsor_References_Bool_Exp>;
  redirect_url?: InputMaybe<String_Comparison_Exp>;
  request_id?: InputMaybe<Int_Comparison_Exp>;
  request_status?: InputMaybe<B2b_Request_Status_Bool_Exp>;
  resource_owner_references?: InputMaybe<B2b_Resource_Owner_References_Bool_Exp>;
  send_invitation_to?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "b2b.requests" */
export enum B2b_Requests_Constraint {
  /** unique or primary key constraint on columns "id" */
  Requests_pkey = 'requests_pkey',
}

/** input type for incrementing numeric columns in table "b2b.requests" */
export type B2b_Requests_Inc_Input = {
  request_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "b2b.requests" */
export type B2b_Requests_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_accounts?: InputMaybe<B2b_External_Accounts_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logs?: InputMaybe<B2b_Logs_Arr_Rel_Insert_Input>;
  ml_sponsor_references?: InputMaybe<B2b_Ml_Sponsor_References_Arr_Rel_Insert_Input>;
  redirect_url?: InputMaybe<Scalars['String']['input']>;
  request_id?: InputMaybe<Scalars['Int']['input']>;
  resource_owner_references?: InputMaybe<B2b_Resource_Owner_References_Arr_Rel_Insert_Input>;
  send_invitation_to?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "b2b.requests" */
export type B2b_Requests_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  redirect_url?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  send_invitation_to?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "b2b.requests" */
export type B2b_Requests_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  redirect_url?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  send_invitation_to?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "b2b.requests" */
export type B2b_Requests_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<B2b_Requests>;
};

/** input type for inserting object relation for remote table "b2b.requests" */
export type B2b_Requests_Obj_Rel_Insert_Input = {
  data: B2b_Requests_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<B2b_Requests_On_Conflict>;
};

/** on_conflict condition type for table "b2b.requests" */
export type B2b_Requests_On_Conflict = {
  constraint: B2b_Requests_Constraint;
  update_columns?: Array<B2b_Requests_Update_Column>;
  where?: InputMaybe<B2b_Requests_Bool_Exp>;
};

/** Ordering options when selecting data from "b2b.requests". */
export type B2b_Requests_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  external_accounts_aggregate?: InputMaybe<B2b_External_Accounts_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  logs_aggregate?: InputMaybe<B2b_Logs_Aggregate_Order_By>;
  ml_sponsor_references_aggregate?: InputMaybe<B2b_Ml_Sponsor_References_Aggregate_Order_By>;
  redirect_url?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  request_status?: InputMaybe<B2b_Request_Status_Order_By>;
  resource_owner_references_aggregate?: InputMaybe<B2b_Resource_Owner_References_Aggregate_Order_By>;
  send_invitation_to?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: b2b.requests */
export type B2b_Requests_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "b2b.requests" */
export enum B2b_Requests_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Redirect_url = 'redirect_url',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Send_invitation_to = 'send_invitation_to',
  /** column name */
  Status = 'status',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "b2b.requests" */
export type B2b_Requests_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  redirect_url?: InputMaybe<Scalars['String']['input']>;
  request_id?: InputMaybe<Scalars['Int']['input']>;
  send_invitation_to?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "b2b.requests" */
export type B2b_Requests_Stddev_Order_By = {
  request_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "b2b.requests" */
export type B2b_Requests_Stddev_Pop_Order_By = {
  request_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "b2b.requests" */
export type B2b_Requests_Stddev_Samp_Order_By = {
  request_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "b2b_requests" */
export type B2b_Requests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: B2b_Requests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type B2b_Requests_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  redirect_url?: InputMaybe<Scalars['String']['input']>;
  request_id?: InputMaybe<Scalars['Int']['input']>;
  send_invitation_to?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "b2b.requests" */
export type B2b_Requests_Sum_Order_By = {
  request_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** update columns of table "b2b.requests" */
export enum B2b_Requests_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Redirect_url = 'redirect_url',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Send_invitation_to = 'send_invitation_to',
  /** column name */
  Status = 'status',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

export type B2b_Requests_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<B2b_Requests_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<B2b_Requests_Set_Input>;
  /** filter the rows which have to be updated */
  where: B2b_Requests_Bool_Exp;
};

/** order by var_pop() on columns of table "b2b.requests" */
export type B2b_Requests_Var_Pop_Order_By = {
  request_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "b2b.requests" */
export type B2b_Requests_Var_Samp_Order_By = {
  request_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "b2b.requests" */
export type B2b_Requests_Variance_Order_By = {
  request_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** Mapping table that links a request to the owner(s) of the resource being requested. */
export type B2b_Resource_Owner_References = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  request: B2b_Requests;
  request_id: Scalars['uuid']['output'];
  resource_owner?: Maybe<Mlfsl_Personnel>;
  resource_owner_ad_id: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** order by aggregate values of table "b2b.resource_owner_references" */
export type B2b_Resource_Owner_References_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<B2b_Resource_Owner_References_Max_Order_By>;
  min?: InputMaybe<B2b_Resource_Owner_References_Min_Order_By>;
};

/** input type for inserting array relation for remote table "b2b.resource_owner_references" */
export type B2b_Resource_Owner_References_Arr_Rel_Insert_Input = {
  data: Array<B2b_Resource_Owner_References_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<B2b_Resource_Owner_References_On_Conflict>;
};

/** Boolean expression to filter rows from the table "b2b.resource_owner_references". All fields are combined with a logical 'AND'. */
export type B2b_Resource_Owner_References_Bool_Exp = {
  _and?: InputMaybe<Array<B2b_Resource_Owner_References_Bool_Exp>>;
  _not?: InputMaybe<B2b_Resource_Owner_References_Bool_Exp>;
  _or?: InputMaybe<Array<B2b_Resource_Owner_References_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  request?: InputMaybe<B2b_Requests_Bool_Exp>;
  request_id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_owner_ad_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "b2b.resource_owner_references" */
export enum B2b_Resource_Owner_References_Constraint {
  /** unique or primary key constraint on columns "id" */
  Resource_owner_references_pkey = 'resource_owner_references_pkey',
}

/** input type for inserting data into table "b2b.resource_owner_references" */
export type B2b_Resource_Owner_References_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request?: InputMaybe<B2b_Requests_Obj_Rel_Insert_Input>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_owner_ad_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "b2b.resource_owner_references" */
export type B2b_Resource_Owner_References_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  resource_owner_ad_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "b2b.resource_owner_references" */
export type B2b_Resource_Owner_References_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  resource_owner_ad_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "b2b.resource_owner_references" */
export type B2b_Resource_Owner_References_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<B2b_Resource_Owner_References>;
};

/** on_conflict condition type for table "b2b.resource_owner_references" */
export type B2b_Resource_Owner_References_On_Conflict = {
  constraint: B2b_Resource_Owner_References_Constraint;
  update_columns?: Array<B2b_Resource_Owner_References_Update_Column>;
  where?: InputMaybe<B2b_Resource_Owner_References_Bool_Exp>;
};

/** Ordering options when selecting data from "b2b.resource_owner_references". */
export type B2b_Resource_Owner_References_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request?: InputMaybe<B2b_Requests_Order_By>;
  request_id?: InputMaybe<Order_By>;
  resource_owner_ad_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: b2b.resource_owner_references */
export type B2b_Resource_Owner_References_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "b2b.resource_owner_references" */
export enum B2b_Resource_Owner_References_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Resource_owner_ad_id = 'resource_owner_ad_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "b2b.resource_owner_references" */
export type B2b_Resource_Owner_References_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_owner_ad_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "b2b_resource_owner_references" */
export type B2b_Resource_Owner_References_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: B2b_Resource_Owner_References_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type B2b_Resource_Owner_References_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  resource_owner_ad_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "b2b.resource_owner_references" */
export enum B2b_Resource_Owner_References_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Resource_owner_ad_id = 'resource_owner_ad_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

export type B2b_Resource_Owner_References_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<B2b_Resource_Owner_References_Set_Input>;
  /** filter the rows which have to be updated */
  where: B2b_Resource_Owner_References_Bool_Exp;
};

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type Citext_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['citext']['input']>>;
  _eq?: InputMaybe<Array<Scalars['citext']['input']>>;
  _gt?: InputMaybe<Array<Scalars['citext']['input']>>;
  _gte?: InputMaybe<Array<Scalars['citext']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['citext']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['citext']['input']>>;
  _lte?: InputMaybe<Array<Scalars['citext']['input']>>;
  _neq?: InputMaybe<Array<Scalars['citext']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['citext']['input']>>>;
};

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type Citext_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['citext']['input']>;
  _gt?: InputMaybe<Scalars['citext']['input']>;
  _gte?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['citext']['input']>;
  _in?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['citext']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['citext']['input']>;
  _lt?: InputMaybe<Scalars['citext']['input']>;
  _lte?: InputMaybe<Scalars['citext']['input']>;
  _neq?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['citext']['input']>;
  _nin?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['citext']['input']>;
};

/** columns and relationships of "cle.cle_attachments" */
export type Cle_Cle_Attachments = {
  /** An object relationship */
  cle_request: Cle_Cle_Requests;
  content_type?: Maybe<Scalars['String']['output']>;
  field_name: Scalars['String']['output'];
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  reconciled_at?: Maybe<Scalars['timestamptz']['output']>;
  request_id: Scalars['uuid']['output'];
  storage_url?: Maybe<Scalars['String']['output']>;
  uploaded_at: Scalars['timestamp']['output'];
};

/** aggregated selection of "cle.cle_attachments" */
export type Cle_Cle_Attachments_Aggregate = {
  aggregate?: Maybe<Cle_Cle_Attachments_Aggregate_Fields>;
  nodes: Array<Cle_Cle_Attachments>;
};

export type Cle_Cle_Attachments_Aggregate_Bool_Exp = {
  count?: InputMaybe<Cle_Cle_Attachments_Aggregate_Bool_Exp_Count>;
};

export type Cle_Cle_Attachments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cle_Cle_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cle_Cle_Attachments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cle.cle_attachments" */
export type Cle_Cle_Attachments_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Cle_Cle_Attachments_Max_Fields>;
  min?: Maybe<Cle_Cle_Attachments_Min_Fields>;
};

/** aggregate fields of "cle.cle_attachments" */
export type Cle_Cle_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cle_Cle_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cle.cle_attachments" */
export type Cle_Cle_Attachments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cle_Cle_Attachments_Max_Order_By>;
  min?: InputMaybe<Cle_Cle_Attachments_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "cle.cle_attachments". All fields are combined with a logical 'AND'. */
export type Cle_Cle_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Cle_Cle_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Cle_Cle_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Cle_Cle_Attachments_Bool_Exp>>;
  cle_request?: InputMaybe<Cle_Cle_Requests_Bool_Exp>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  field_name?: InputMaybe<String_Comparison_Exp>;
  filename?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  reconciled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  request_id?: InputMaybe<Uuid_Comparison_Exp>;
  storage_url?: InputMaybe<String_Comparison_Exp>;
  uploaded_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** aggregate max on columns */
export type Cle_Cle_Attachments_Max_Fields = {
  content_type?: Maybe<Scalars['String']['output']>;
  field_name?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  reconciled_at?: Maybe<Scalars['timestamptz']['output']>;
  request_id?: Maybe<Scalars['uuid']['output']>;
  storage_url?: Maybe<Scalars['String']['output']>;
  uploaded_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "cle.cle_attachments" */
export type Cle_Cle_Attachments_Max_Order_By = {
  content_type?: InputMaybe<Order_By>;
  field_name?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reconciled_at?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  storage_url?: InputMaybe<Order_By>;
  uploaded_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cle_Cle_Attachments_Min_Fields = {
  content_type?: Maybe<Scalars['String']['output']>;
  field_name?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  reconciled_at?: Maybe<Scalars['timestamptz']['output']>;
  request_id?: Maybe<Scalars['uuid']['output']>;
  storage_url?: Maybe<Scalars['String']['output']>;
  uploaded_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "cle.cle_attachments" */
export type Cle_Cle_Attachments_Min_Order_By = {
  content_type?: InputMaybe<Order_By>;
  field_name?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reconciled_at?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  storage_url?: InputMaybe<Order_By>;
  uploaded_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "cle.cle_attachments". */
export type Cle_Cle_Attachments_Order_By = {
  cle_request?: InputMaybe<Cle_Cle_Requests_Order_By>;
  content_type?: InputMaybe<Order_By>;
  field_name?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reconciled_at?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  storage_url?: InputMaybe<Order_By>;
  uploaded_at?: InputMaybe<Order_By>;
};

/** select columns of table "cle.cle_attachments" */
export enum Cle_Cle_Attachments_Select_Column {
  /** column name */
  Content_type = 'content_type',
  /** column name */
  Field_name = 'field_name',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  Reconciled_at = 'reconciled_at',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Storage_url = 'storage_url',
  /** column name */
  Uploaded_at = 'uploaded_at',
}

/** Streaming cursor of the table "cle_cle_attachments" */
export type Cle_Cle_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cle_Cle_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cle_Cle_Attachments_Stream_Cursor_Value_Input = {
  content_type?: InputMaybe<Scalars['String']['input']>;
  field_name?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  reconciled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  storage_url?: InputMaybe<Scalars['String']['input']>;
  uploaded_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** columns and relationships of "cle.cle_requests" */
export type Cle_Cle_Requests = {
  attorney_contact?: Maybe<Scalars['String']['output']>;
  ca_credit?: Maybe<Scalars['String']['output']>;
  ca_status?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  cle_attachments: Array<Cle_Cle_Attachments>;
  /** An aggregate relationship */
  cle_attachments_aggregate: Cle_Cle_Attachments_Aggregate;
  client_matter_number?: Maybe<Scalars['String']['output']>;
  co_sponsor_name?: Maybe<Scalars['String']['output']>;
  co_sposored?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['timestamptz']['output'];
  ct_credit?: Maybe<Scalars['String']['output']>;
  ct_status?: Maybe<Scalars['String']['output']>;
  data: Scalars['jsonb']['output'];
  event_date?: Maybe<Scalars['date']['output']>;
  event_name?: Maybe<Scalars['String']['output']>;
  exported_at?: Maybe<Scalars['timestamptz']['output']>;
  fl_credit?: Maybe<Scalars['String']['output']>;
  fl_status?: Maybe<Scalars['String']['output']>;
  form_status?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  il_credit?: Maybe<Scalars['String']['output']>;
  il_status?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  mlfsl_matter?: Maybe<Mlfsl_Matter>;
  mlfsl_practice_group?: Maybe<Mlfsl_Practicegroup>;
  nj_credit?: Maybe<Scalars['String']['output']>;
  nj_status?: Maybe<Scalars['String']['output']>;
  ny_credit?: Maybe<Scalars['String']['output']>;
  ny_status?: Maybe<Scalars['String']['output']>;
  pa_credit?: Maybe<Scalars['String']['output']>;
  pa_status?: Maybe<Scalars['String']['output']>;
  practice_group_code?: Maybe<Scalars['String']['output']>;
  program_contact?: Maybe<Scalars['String']['output']>;
  source_item_key?: Maybe<Scalars['String']['output']>;
  source_xml_name?: Maybe<Scalars['String']['output']>;
  states_requested: Array<Scalars['String']['output']>;
  submitted_by?: Maybe<Scalars['String']['output']>;
  tx_credit?: Maybe<Scalars['String']['output']>;
  tx_status?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  va_credit?: Maybe<Scalars['String']['output']>;
  va_status?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "cle.cle_requests" */
export type Cle_Cle_RequestsCle_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Cle_Cle_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cle_Cle_Attachments_Order_By>>;
  where?: InputMaybe<Cle_Cle_Attachments_Bool_Exp>;
};

/** columns and relationships of "cle.cle_requests" */
export type Cle_Cle_RequestsCle_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cle_Cle_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cle_Cle_Attachments_Order_By>>;
  where?: InputMaybe<Cle_Cle_Attachments_Bool_Exp>;
};

/** columns and relationships of "cle.cle_requests" */
export type Cle_Cle_RequestsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cle.cle_requests" */
export type Cle_Cle_Requests_Aggregate = {
  aggregate?: Maybe<Cle_Cle_Requests_Aggregate_Fields>;
  nodes: Array<Cle_Cle_Requests>;
};

/** aggregate fields of "cle.cle_requests" */
export type Cle_Cle_Requests_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Cle_Cle_Requests_Max_Fields>;
  min?: Maybe<Cle_Cle_Requests_Min_Fields>;
};

/** aggregate fields of "cle.cle_requests" */
export type Cle_Cle_Requests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cle_Cle_Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "cle.cle_requests". All fields are combined with a logical 'AND'. */
export type Cle_Cle_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<Cle_Cle_Requests_Bool_Exp>>;
  _not?: InputMaybe<Cle_Cle_Requests_Bool_Exp>;
  _or?: InputMaybe<Array<Cle_Cle_Requests_Bool_Exp>>;
  attorney_contact?: InputMaybe<String_Comparison_Exp>;
  ca_credit?: InputMaybe<String_Comparison_Exp>;
  ca_status?: InputMaybe<String_Comparison_Exp>;
  cle_attachments?: InputMaybe<Cle_Cle_Attachments_Bool_Exp>;
  cle_attachments_aggregate?: InputMaybe<Cle_Cle_Attachments_Aggregate_Bool_Exp>;
  client_matter_number?: InputMaybe<String_Comparison_Exp>;
  co_sponsor_name?: InputMaybe<String_Comparison_Exp>;
  co_sposored?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ct_credit?: InputMaybe<String_Comparison_Exp>;
  ct_status?: InputMaybe<String_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  event_date?: InputMaybe<Date_Comparison_Exp>;
  event_name?: InputMaybe<String_Comparison_Exp>;
  exported_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fl_credit?: InputMaybe<String_Comparison_Exp>;
  fl_status?: InputMaybe<String_Comparison_Exp>;
  form_status?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  il_credit?: InputMaybe<String_Comparison_Exp>;
  il_status?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  nj_credit?: InputMaybe<String_Comparison_Exp>;
  nj_status?: InputMaybe<String_Comparison_Exp>;
  ny_credit?: InputMaybe<String_Comparison_Exp>;
  ny_status?: InputMaybe<String_Comparison_Exp>;
  pa_credit?: InputMaybe<String_Comparison_Exp>;
  pa_status?: InputMaybe<String_Comparison_Exp>;
  practice_group_code?: InputMaybe<String_Comparison_Exp>;
  program_contact?: InputMaybe<String_Comparison_Exp>;
  source_item_key?: InputMaybe<String_Comparison_Exp>;
  source_xml_name?: InputMaybe<String_Comparison_Exp>;
  states_requested?: InputMaybe<String_Array_Comparison_Exp>;
  submitted_by?: InputMaybe<String_Comparison_Exp>;
  tx_credit?: InputMaybe<String_Comparison_Exp>;
  tx_status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  va_credit?: InputMaybe<String_Comparison_Exp>;
  va_status?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Cle_Cle_Requests_Max_Fields = {
  attorney_contact?: Maybe<Scalars['String']['output']>;
  ca_credit?: Maybe<Scalars['String']['output']>;
  ca_status?: Maybe<Scalars['String']['output']>;
  client_matter_number?: Maybe<Scalars['String']['output']>;
  co_sponsor_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  ct_credit?: Maybe<Scalars['String']['output']>;
  ct_status?: Maybe<Scalars['String']['output']>;
  event_date?: Maybe<Scalars['date']['output']>;
  event_name?: Maybe<Scalars['String']['output']>;
  exported_at?: Maybe<Scalars['timestamptz']['output']>;
  fl_credit?: Maybe<Scalars['String']['output']>;
  fl_status?: Maybe<Scalars['String']['output']>;
  form_status?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  il_credit?: Maybe<Scalars['String']['output']>;
  il_status?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  nj_credit?: Maybe<Scalars['String']['output']>;
  nj_status?: Maybe<Scalars['String']['output']>;
  ny_credit?: Maybe<Scalars['String']['output']>;
  ny_status?: Maybe<Scalars['String']['output']>;
  pa_credit?: Maybe<Scalars['String']['output']>;
  pa_status?: Maybe<Scalars['String']['output']>;
  practice_group_code?: Maybe<Scalars['String']['output']>;
  program_contact?: Maybe<Scalars['String']['output']>;
  source_item_key?: Maybe<Scalars['String']['output']>;
  source_xml_name?: Maybe<Scalars['String']['output']>;
  states_requested?: Maybe<Array<Scalars['String']['output']>>;
  submitted_by?: Maybe<Scalars['String']['output']>;
  tx_credit?: Maybe<Scalars['String']['output']>;
  tx_status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  va_credit?: Maybe<Scalars['String']['output']>;
  va_status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Cle_Cle_Requests_Min_Fields = {
  attorney_contact?: Maybe<Scalars['String']['output']>;
  ca_credit?: Maybe<Scalars['String']['output']>;
  ca_status?: Maybe<Scalars['String']['output']>;
  client_matter_number?: Maybe<Scalars['String']['output']>;
  co_sponsor_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  ct_credit?: Maybe<Scalars['String']['output']>;
  ct_status?: Maybe<Scalars['String']['output']>;
  event_date?: Maybe<Scalars['date']['output']>;
  event_name?: Maybe<Scalars['String']['output']>;
  exported_at?: Maybe<Scalars['timestamptz']['output']>;
  fl_credit?: Maybe<Scalars['String']['output']>;
  fl_status?: Maybe<Scalars['String']['output']>;
  form_status?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  il_credit?: Maybe<Scalars['String']['output']>;
  il_status?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  nj_credit?: Maybe<Scalars['String']['output']>;
  nj_status?: Maybe<Scalars['String']['output']>;
  ny_credit?: Maybe<Scalars['String']['output']>;
  ny_status?: Maybe<Scalars['String']['output']>;
  pa_credit?: Maybe<Scalars['String']['output']>;
  pa_status?: Maybe<Scalars['String']['output']>;
  practice_group_code?: Maybe<Scalars['String']['output']>;
  program_contact?: Maybe<Scalars['String']['output']>;
  source_item_key?: Maybe<Scalars['String']['output']>;
  source_xml_name?: Maybe<Scalars['String']['output']>;
  states_requested?: Maybe<Array<Scalars['String']['output']>>;
  submitted_by?: Maybe<Scalars['String']['output']>;
  tx_credit?: Maybe<Scalars['String']['output']>;
  tx_status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  va_credit?: Maybe<Scalars['String']['output']>;
  va_status?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "cle.cle_requests". */
export type Cle_Cle_Requests_Order_By = {
  attorney_contact?: InputMaybe<Order_By>;
  ca_credit?: InputMaybe<Order_By>;
  ca_status?: InputMaybe<Order_By>;
  cle_attachments_aggregate?: InputMaybe<Cle_Cle_Attachments_Aggregate_Order_By>;
  client_matter_number?: InputMaybe<Order_By>;
  co_sponsor_name?: InputMaybe<Order_By>;
  co_sposored?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  ct_credit?: InputMaybe<Order_By>;
  ct_status?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  event_date?: InputMaybe<Order_By>;
  event_name?: InputMaybe<Order_By>;
  exported_at?: InputMaybe<Order_By>;
  fl_credit?: InputMaybe<Order_By>;
  fl_status?: InputMaybe<Order_By>;
  form_status?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  il_credit?: InputMaybe<Order_By>;
  il_status?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  nj_credit?: InputMaybe<Order_By>;
  nj_status?: InputMaybe<Order_By>;
  ny_credit?: InputMaybe<Order_By>;
  ny_status?: InputMaybe<Order_By>;
  pa_credit?: InputMaybe<Order_By>;
  pa_status?: InputMaybe<Order_By>;
  practice_group_code?: InputMaybe<Order_By>;
  program_contact?: InputMaybe<Order_By>;
  source_item_key?: InputMaybe<Order_By>;
  source_xml_name?: InputMaybe<Order_By>;
  states_requested?: InputMaybe<Order_By>;
  submitted_by?: InputMaybe<Order_By>;
  tx_credit?: InputMaybe<Order_By>;
  tx_status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  va_credit?: InputMaybe<Order_By>;
  va_status?: InputMaybe<Order_By>;
};

/** select columns of table "cle.cle_requests" */
export enum Cle_Cle_Requests_Select_Column {
  /** column name */
  Attorney_contact = 'attorney_contact',
  /** column name */
  Ca_credit = 'ca_credit',
  /** column name */
  Ca_status = 'ca_status',
  /** column name */
  Client_matter_number = 'client_matter_number',
  /** column name */
  Co_sponsor_name = 'co_sponsor_name',
  /** column name */
  Co_sposored = 'co_sposored',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Ct_credit = 'ct_credit',
  /** column name */
  Ct_status = 'ct_status',
  /** column name */
  Data = 'data',
  /** column name */
  Event_date = 'event_date',
  /** column name */
  Event_name = 'event_name',
  /** column name */
  Exported_at = 'exported_at',
  /** column name */
  Fl_credit = 'fl_credit',
  /** column name */
  Fl_status = 'fl_status',
  /** column name */
  Form_status = 'form_status',
  /** column name */
  Id = 'id',
  /** column name */
  Il_credit = 'il_credit',
  /** column name */
  Il_status = 'il_status',
  /** column name */
  Location = 'location',
  /** column name */
  Nj_credit = 'nj_credit',
  /** column name */
  Nj_status = 'nj_status',
  /** column name */
  Ny_credit = 'ny_credit',
  /** column name */
  Ny_status = 'ny_status',
  /** column name */
  Pa_credit = 'pa_credit',
  /** column name */
  Pa_status = 'pa_status',
  /** column name */
  Practice_group_code = 'practice_group_code',
  /** column name */
  Program_contact = 'program_contact',
  /** column name */
  Source_item_key = 'source_item_key',
  /** column name */
  Source_xml_name = 'source_xml_name',
  /** column name */
  States_requested = 'states_requested',
  /** column name */
  Submitted_by = 'submitted_by',
  /** column name */
  Tx_credit = 'tx_credit',
  /** column name */
  Tx_status = 'tx_status',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Va_credit = 'va_credit',
  /** column name */
  Va_status = 'va_status',
}

/** Streaming cursor of the table "cle_cle_requests" */
export type Cle_Cle_Requests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cle_Cle_Requests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cle_Cle_Requests_Stream_Cursor_Value_Input = {
  attorney_contact?: InputMaybe<Scalars['String']['input']>;
  ca_credit?: InputMaybe<Scalars['String']['input']>;
  ca_status?: InputMaybe<Scalars['String']['input']>;
  client_matter_number?: InputMaybe<Scalars['String']['input']>;
  co_sponsor_name?: InputMaybe<Scalars['String']['input']>;
  co_sposored?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  ct_credit?: InputMaybe<Scalars['String']['input']>;
  ct_status?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  event_date?: InputMaybe<Scalars['date']['input']>;
  event_name?: InputMaybe<Scalars['String']['input']>;
  exported_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fl_credit?: InputMaybe<Scalars['String']['input']>;
  fl_status?: InputMaybe<Scalars['String']['input']>;
  form_status?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  il_credit?: InputMaybe<Scalars['String']['input']>;
  il_status?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  nj_credit?: InputMaybe<Scalars['String']['input']>;
  nj_status?: InputMaybe<Scalars['String']['input']>;
  ny_credit?: InputMaybe<Scalars['String']['input']>;
  ny_status?: InputMaybe<Scalars['String']['input']>;
  pa_credit?: InputMaybe<Scalars['String']['input']>;
  pa_status?: InputMaybe<Scalars['String']['input']>;
  practice_group_code?: InputMaybe<Scalars['String']['input']>;
  program_contact?: InputMaybe<Scalars['String']['input']>;
  source_item_key?: InputMaybe<Scalars['String']['input']>;
  source_xml_name?: InputMaybe<Scalars['String']['input']>;
  states_requested?: InputMaybe<Array<Scalars['String']['input']>>;
  submitted_by?: InputMaybe<Scalars['String']['input']>;
  tx_credit?: InputMaybe<Scalars['String']['input']>;
  tx_status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  va_credit?: InputMaybe<Scalars['String']['input']>;
  va_status?: InputMaybe<Scalars['String']['input']>;
};

/** Stores client comments and notes associated with an engagement record */
export type Clm_Engagement_Client_Comments = {
  comments: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  /** An object relationship */
  engagement_record: Clm_Engagement_Records;
  engagement_records_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** order by aggregate values of table "clm.engagement_client_comments" */
export type Clm_Engagement_Client_Comments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Clm_Engagement_Client_Comments_Max_Order_By>;
  min?: InputMaybe<Clm_Engagement_Client_Comments_Min_Order_By>;
};

/** input type for inserting array relation for remote table "clm.engagement_client_comments" */
export type Clm_Engagement_Client_Comments_Arr_Rel_Insert_Input = {
  data: Array<Clm_Engagement_Client_Comments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Clm_Engagement_Client_Comments_On_Conflict>;
};

/** Boolean expression to filter rows from the table "clm.engagement_client_comments". All fields are combined with a logical 'AND'. */
export type Clm_Engagement_Client_Comments_Bool_Exp = {
  _and?: InputMaybe<Array<Clm_Engagement_Client_Comments_Bool_Exp>>;
  _not?: InputMaybe<Clm_Engagement_Client_Comments_Bool_Exp>;
  _or?: InputMaybe<Array<Clm_Engagement_Client_Comments_Bool_Exp>>;
  comments?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  engagement_record?: InputMaybe<Clm_Engagement_Records_Bool_Exp>;
  engagement_records_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "clm.engagement_client_comments" */
export enum Clm_Engagement_Client_Comments_Constraint {
  /** unique or primary key constraint on columns "id" */
  Engagement_client_comments_pkey = 'engagement_client_comments_pkey',
}

/** input type for inserting data into table "clm.engagement_client_comments" */
export type Clm_Engagement_Client_Comments_Insert_Input = {
  comments?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  engagement_record?: InputMaybe<Clm_Engagement_Records_Obj_Rel_Insert_Input>;
  engagement_records_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "clm.engagement_client_comments" */
export type Clm_Engagement_Client_Comments_Max_Order_By = {
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  engagement_records_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "clm.engagement_client_comments" */
export type Clm_Engagement_Client_Comments_Min_Order_By = {
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  engagement_records_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "clm.engagement_client_comments" */
export type Clm_Engagement_Client_Comments_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Clm_Engagement_Client_Comments>;
};

/** on_conflict condition type for table "clm.engagement_client_comments" */
export type Clm_Engagement_Client_Comments_On_Conflict = {
  constraint: Clm_Engagement_Client_Comments_Constraint;
  update_columns?: Array<Clm_Engagement_Client_Comments_Update_Column>;
  where?: InputMaybe<Clm_Engagement_Client_Comments_Bool_Exp>;
};

/** Ordering options when selecting data from "clm.engagement_client_comments". */
export type Clm_Engagement_Client_Comments_Order_By = {
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  engagement_record?: InputMaybe<Clm_Engagement_Records_Order_By>;
  engagement_records_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: clm.engagement_client_comments */
export type Clm_Engagement_Client_Comments_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "clm.engagement_client_comments" */
export enum Clm_Engagement_Client_Comments_Select_Column {
  /** column name */
  Comments = 'comments',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Engagement_records_id = 'engagement_records_id',
  /** column name */
  Id = 'id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "clm.engagement_client_comments" */
export type Clm_Engagement_Client_Comments_Set_Input = {
  comments?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  engagement_records_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "clm_engagement_client_comments" */
export type Clm_Engagement_Client_Comments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Clm_Engagement_Client_Comments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Clm_Engagement_Client_Comments_Stream_Cursor_Value_Input = {
  comments?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  engagement_records_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "clm.engagement_client_comments" */
export enum Clm_Engagement_Client_Comments_Update_Column {
  /** column name */
  Comments = 'comments',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Engagement_records_id = 'engagement_records_id',
  /** column name */
  Id = 'id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

export type Clm_Engagement_Client_Comments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Clm_Engagement_Client_Comments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Clm_Engagement_Client_Comments_Bool_Exp;
};

/** Stores associations between engagement records and iManage documents, including the iManage document identifier, document URL, and audit metadata for creation and updates */
export type Clm_Engagement_Imanage_Documents = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  doc_id: Scalars['String']['output'];
  /** An object relationship */
  engagement_record: Clm_Engagement_Records;
  engagement_records_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** aggregated selection of "clm.engagement_imanage_documents" */
export type Clm_Engagement_Imanage_Documents_Aggregate = {
  aggregate?: Maybe<Clm_Engagement_Imanage_Documents_Aggregate_Fields>;
  nodes: Array<Clm_Engagement_Imanage_Documents>;
};

export type Clm_Engagement_Imanage_Documents_Aggregate_Bool_Exp = {
  count?: InputMaybe<Clm_Engagement_Imanage_Documents_Aggregate_Bool_Exp_Count>;
};

export type Clm_Engagement_Imanage_Documents_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Clm_Engagement_Imanage_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Clm_Engagement_Imanage_Documents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "clm.engagement_imanage_documents" */
export type Clm_Engagement_Imanage_Documents_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Clm_Engagement_Imanage_Documents_Max_Fields>;
  min?: Maybe<Clm_Engagement_Imanage_Documents_Min_Fields>;
};

/** aggregate fields of "clm.engagement_imanage_documents" */
export type Clm_Engagement_Imanage_Documents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Clm_Engagement_Imanage_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "clm.engagement_imanage_documents" */
export type Clm_Engagement_Imanage_Documents_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Clm_Engagement_Imanage_Documents_Max_Order_By>;
  min?: InputMaybe<Clm_Engagement_Imanage_Documents_Min_Order_By>;
};

/** input type for inserting array relation for remote table "clm.engagement_imanage_documents" */
export type Clm_Engagement_Imanage_Documents_Arr_Rel_Insert_Input = {
  data: Array<Clm_Engagement_Imanage_Documents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Clm_Engagement_Imanage_Documents_On_Conflict>;
};

/** Boolean expression to filter rows from the table "clm.engagement_imanage_documents". All fields are combined with a logical 'AND'. */
export type Clm_Engagement_Imanage_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Clm_Engagement_Imanage_Documents_Bool_Exp>>;
  _not?: InputMaybe<Clm_Engagement_Imanage_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Clm_Engagement_Imanage_Documents_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  doc_id?: InputMaybe<String_Comparison_Exp>;
  engagement_record?: InputMaybe<Clm_Engagement_Records_Bool_Exp>;
  engagement_records_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "clm.engagement_imanage_documents" */
export enum Clm_Engagement_Imanage_Documents_Constraint {
  /** unique or primary key constraint on columns "id" */
  Engagement_imanage_documents_pkey = 'engagement_imanage_documents_pkey',
}

/** input type for inserting data into table "clm.engagement_imanage_documents" */
export type Clm_Engagement_Imanage_Documents_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  doc_id?: InputMaybe<Scalars['String']['input']>;
  engagement_record?: InputMaybe<Clm_Engagement_Records_Obj_Rel_Insert_Input>;
  engagement_records_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Clm_Engagement_Imanage_Documents_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  doc_id?: Maybe<Scalars['String']['output']>;
  engagement_records_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "clm.engagement_imanage_documents" */
export type Clm_Engagement_Imanage_Documents_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  engagement_records_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Clm_Engagement_Imanage_Documents_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  doc_id?: Maybe<Scalars['String']['output']>;
  engagement_records_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "clm.engagement_imanage_documents" */
export type Clm_Engagement_Imanage_Documents_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  engagement_records_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "clm.engagement_imanage_documents" */
export type Clm_Engagement_Imanage_Documents_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Clm_Engagement_Imanage_Documents>;
};

/** on_conflict condition type for table "clm.engagement_imanage_documents" */
export type Clm_Engagement_Imanage_Documents_On_Conflict = {
  constraint: Clm_Engagement_Imanage_Documents_Constraint;
  update_columns?: Array<Clm_Engagement_Imanage_Documents_Update_Column>;
  where?: InputMaybe<Clm_Engagement_Imanage_Documents_Bool_Exp>;
};

/** Ordering options when selecting data from "clm.engagement_imanage_documents". */
export type Clm_Engagement_Imanage_Documents_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  engagement_record?: InputMaybe<Clm_Engagement_Records_Order_By>;
  engagement_records_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: clm.engagement_imanage_documents */
export type Clm_Engagement_Imanage_Documents_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "clm.engagement_imanage_documents" */
export enum Clm_Engagement_Imanage_Documents_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Doc_id = 'doc_id',
  /** column name */
  Engagement_records_id = 'engagement_records_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "clm.engagement_imanage_documents" */
export type Clm_Engagement_Imanage_Documents_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  doc_id?: InputMaybe<Scalars['String']['input']>;
  engagement_records_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "clm_engagement_imanage_documents" */
export type Clm_Engagement_Imanage_Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Clm_Engagement_Imanage_Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Clm_Engagement_Imanage_Documents_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  doc_id?: InputMaybe<Scalars['String']['input']>;
  engagement_records_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "clm.engagement_imanage_documents" */
export enum Clm_Engagement_Imanage_Documents_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Doc_id = 'doc_id',
  /** column name */
  Engagement_records_id = 'engagement_records_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

export type Clm_Engagement_Imanage_Documents_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Clm_Engagement_Imanage_Documents_Set_Input>;
  /** filter the rows which have to be updated */
  where: Clm_Engagement_Imanage_Documents_Bool_Exp;
};

/** Stores the full history of engagement‑letter lifecycle events, including creation, execution status, and administrative notes */
export type Clm_Engagement_Records = {
  client_number: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  /** An array relationship */
  engagement_client_comments: Array<Clm_Engagement_Client_Comments>;
  /** An array relationship */
  engagement_imanage_documents: Array<Clm_Engagement_Imanage_Documents>;
  /** An aggregate relationship */
  engagement_imanage_documents_aggregate: Clm_Engagement_Imanage_Documents_Aggregate;
  id: Scalars['uuid']['output'];
  mlfsl_client?: Maybe<Mlfsl_Client>;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** Stores the full history of engagement‑letter lifecycle events, including creation, execution status, and administrative notes */
export type Clm_Engagement_RecordsEngagement_Client_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Clm_Engagement_Client_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Engagement_Client_Comments_Order_By>>;
  where?: InputMaybe<Clm_Engagement_Client_Comments_Bool_Exp>;
};

/** Stores the full history of engagement‑letter lifecycle events, including creation, execution status, and administrative notes */
export type Clm_Engagement_RecordsEngagement_Imanage_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Clm_Engagement_Imanage_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Engagement_Imanage_Documents_Order_By>>;
  where?: InputMaybe<Clm_Engagement_Imanage_Documents_Bool_Exp>;
};

/** Stores the full history of engagement‑letter lifecycle events, including creation, execution status, and administrative notes */
export type Clm_Engagement_RecordsEngagement_Imanage_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clm_Engagement_Imanage_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Engagement_Imanage_Documents_Order_By>>;
  where?: InputMaybe<Clm_Engagement_Imanage_Documents_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "clm.engagement_records". All fields are combined with a logical 'AND'. */
export type Clm_Engagement_Records_Bool_Exp = {
  _and?: InputMaybe<Array<Clm_Engagement_Records_Bool_Exp>>;
  _not?: InputMaybe<Clm_Engagement_Records_Bool_Exp>;
  _or?: InputMaybe<Array<Clm_Engagement_Records_Bool_Exp>>;
  client_number?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  engagement_client_comments?: InputMaybe<Clm_Engagement_Client_Comments_Bool_Exp>;
  engagement_imanage_documents?: InputMaybe<Clm_Engagement_Imanage_Documents_Bool_Exp>;
  engagement_imanage_documents_aggregate?: InputMaybe<Clm_Engagement_Imanage_Documents_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "clm.engagement_records" */
export enum Clm_Engagement_Records_Constraint {
  /** unique or primary key constraint on columns "client_number" */
  Engagement_records_client_number_key = 'engagement_records_client_number_key',
  /** unique or primary key constraint on columns "id" */
  Engagement_records_pkey = 'engagement_records_pkey',
}

/** input type for inserting data into table "clm.engagement_records" */
export type Clm_Engagement_Records_Insert_Input = {
  client_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  engagement_client_comments?: InputMaybe<Clm_Engagement_Client_Comments_Arr_Rel_Insert_Input>;
  engagement_imanage_documents?: InputMaybe<Clm_Engagement_Imanage_Documents_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "clm.engagement_records" */
export type Clm_Engagement_Records_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Clm_Engagement_Records>;
};

/** input type for inserting object relation for remote table "clm.engagement_records" */
export type Clm_Engagement_Records_Obj_Rel_Insert_Input = {
  data: Clm_Engagement_Records_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Clm_Engagement_Records_On_Conflict>;
};

/** on_conflict condition type for table "clm.engagement_records" */
export type Clm_Engagement_Records_On_Conflict = {
  constraint: Clm_Engagement_Records_Constraint;
  update_columns?: Array<Clm_Engagement_Records_Update_Column>;
  where?: InputMaybe<Clm_Engagement_Records_Bool_Exp>;
};

/** Ordering options when selecting data from "clm.engagement_records". */
export type Clm_Engagement_Records_Order_By = {
  client_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  engagement_client_comments_aggregate?: InputMaybe<Clm_Engagement_Client_Comments_Aggregate_Order_By>;
  engagement_imanage_documents_aggregate?: InputMaybe<Clm_Engagement_Imanage_Documents_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: clm.engagement_records */
export type Clm_Engagement_Records_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "clm.engagement_records" */
export enum Clm_Engagement_Records_Select_Column {
  /** column name */
  Client_number = 'client_number',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "clm.engagement_records" */
export type Clm_Engagement_Records_Set_Input = {
  client_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "clm_engagement_records" */
export type Clm_Engagement_Records_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Clm_Engagement_Records_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Clm_Engagement_Records_Stream_Cursor_Value_Input = {
  client_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "clm.engagement_records" */
export enum Clm_Engagement_Records_Update_Column {
  /** column name */
  Client_number = 'client_number',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

export type Clm_Engagement_Records_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Clm_Engagement_Records_Set_Input>;
  /** filter the rows which have to be updated */
  where: Clm_Engagement_Records_Bool_Exp;
};

/** columns and relationships of "clm.views" */
export type Clm_Views = {
  columns?: Maybe<Scalars['jsonb']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  description?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  is_private: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  source: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** columns and relationships of "clm.views" */
export type Clm_ViewsColumnsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "clm.views" */
export type Clm_ViewsFiltersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Clm_Views_Append_Input = {
  columns?: InputMaybe<Scalars['jsonb']['input']>;
  filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "clm.views". All fields are combined with a logical 'AND'. */
export type Clm_Views_Bool_Exp = {
  _and?: InputMaybe<Array<Clm_Views_Bool_Exp>>;
  _not?: InputMaybe<Clm_Views_Bool_Exp>;
  _or?: InputMaybe<Array<Clm_Views_Bool_Exp>>;
  columns?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  filters?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_private?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "clm.views" */
export enum Clm_Views_Constraint {
  /** unique or primary key constraint on columns "id" */
  Views_pkey = 'views_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Clm_Views_Delete_At_Path_Input = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Clm_Views_Delete_Elem_Input = {
  columns?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Clm_Views_Delete_Key_Input = {
  columns?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "clm.views" */
export type Clm_Views_Insert_Input = {
  columns?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_private?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "clm.views" */
export type Clm_Views_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Clm_Views>;
};

/** on_conflict condition type for table "clm.views" */
export type Clm_Views_On_Conflict = {
  constraint: Clm_Views_Constraint;
  update_columns?: Array<Clm_Views_Update_Column>;
  where?: InputMaybe<Clm_Views_Bool_Exp>;
};

/** Ordering options when selecting data from "clm.views". */
export type Clm_Views_Order_By = {
  columns?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  filters?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_private?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: clm.views */
export type Clm_Views_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Clm_Views_Prepend_Input = {
  columns?: InputMaybe<Scalars['jsonb']['input']>;
  filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "clm.views" */
export enum Clm_Views_Select_Column {
  /** column name */
  Columns = 'columns',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Filters = 'filters',
  /** column name */
  Id = 'id',
  /** column name */
  Is_private = 'is_private',
  /** column name */
  Name = 'name',
  /** column name */
  Source = 'source',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "clm.views" */
export type Clm_Views_Set_Input = {
  columns?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_private?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "clm_views" */
export type Clm_Views_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Clm_Views_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Clm_Views_Stream_Cursor_Value_Input = {
  columns?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_private?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "clm.views" */
export enum Clm_Views_Update_Column {
  /** column name */
  Columns = 'columns',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Filters = 'filters',
  /** column name */
  Id = 'id',
  /** column name */
  Is_private = 'is_private',
  /** column name */
  Name = 'name',
  /** column name */
  Source = 'source',
  /** column name */
  Updated_at = 'updated_at',
}

export type Clm_Views_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Clm_Views_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Clm_Views_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Clm_Views_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Clm_Views_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Clm_Views_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Clm_Views_Set_Input>;
  /** filter the rows which have to be updated */
  where: Clm_Views_Bool_Exp;
};

/** Stores associations between waiver records and iManage documents, including the iManage document identifier, document URL, and audit metadata for creation and updates */
export type Clm_Waiver_Imanage_Documents = {
  created_at: Scalars['timestamptz']['output'];
  doc_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  waiver_record: Clm_Waiver_Records;
  waiver_records_id: Scalars['uuid']['output'];
};

/** aggregated selection of "clm.waiver_imanage_documents" */
export type Clm_Waiver_Imanage_Documents_Aggregate = {
  aggregate?: Maybe<Clm_Waiver_Imanage_Documents_Aggregate_Fields>;
  nodes: Array<Clm_Waiver_Imanage_Documents>;
};

export type Clm_Waiver_Imanage_Documents_Aggregate_Bool_Exp = {
  count?: InputMaybe<Clm_Waiver_Imanage_Documents_Aggregate_Bool_Exp_Count>;
};

export type Clm_Waiver_Imanage_Documents_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Clm_Waiver_Imanage_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Clm_Waiver_Imanage_Documents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "clm.waiver_imanage_documents" */
export type Clm_Waiver_Imanage_Documents_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Clm_Waiver_Imanage_Documents_Max_Fields>;
  min?: Maybe<Clm_Waiver_Imanage_Documents_Min_Fields>;
};

/** aggregate fields of "clm.waiver_imanage_documents" */
export type Clm_Waiver_Imanage_Documents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Clm_Waiver_Imanage_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "clm.waiver_imanage_documents" */
export type Clm_Waiver_Imanage_Documents_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Clm_Waiver_Imanage_Documents_Max_Order_By>;
  min?: InputMaybe<Clm_Waiver_Imanage_Documents_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "clm.waiver_imanage_documents". All fields are combined with a logical 'AND'. */
export type Clm_Waiver_Imanage_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Clm_Waiver_Imanage_Documents_Bool_Exp>>;
  _not?: InputMaybe<Clm_Waiver_Imanage_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Clm_Waiver_Imanage_Documents_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  doc_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  waiver_record?: InputMaybe<Clm_Waiver_Records_Bool_Exp>;
  waiver_records_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Clm_Waiver_Imanage_Documents_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  doc_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  waiver_records_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "clm.waiver_imanage_documents" */
export type Clm_Waiver_Imanage_Documents_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  waiver_records_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Clm_Waiver_Imanage_Documents_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  doc_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  waiver_records_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "clm.waiver_imanage_documents" */
export type Clm_Waiver_Imanage_Documents_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  waiver_records_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "clm.waiver_imanage_documents". */
export type Clm_Waiver_Imanage_Documents_Order_By = {
  created_at?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  waiver_record?: InputMaybe<Clm_Waiver_Records_Order_By>;
  waiver_records_id?: InputMaybe<Order_By>;
};

/** select columns of table "clm.waiver_imanage_documents" */
export enum Clm_Waiver_Imanage_Documents_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Doc_id = 'doc_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Waiver_records_id = 'waiver_records_id',
}

/** Streaming cursor of the table "clm_waiver_imanage_documents" */
export type Clm_Waiver_Imanage_Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Clm_Waiver_Imanage_Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Clm_Waiver_Imanage_Documents_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  doc_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  waiver_records_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "clm.waiver_records" */
export type Clm_Waiver_Records = {
  adverse_client_name?: Maybe<Scalars['String']['output']>;
  adverse_contact_signer?: Maybe<Scalars['String']['output']>;
  adverse_letter_date?: Maybe<Scalars['timestamptz']['output']>;
  adverse_mlb_attorney_on_letter?: Maybe<Mlfsl_Personnel>;
  adverse_mlb_attorney_on_letter_id?: Maybe<Scalars['String']['output']>;
  adverse_mlb_attorney_on_letter_name?: Maybe<Scalars['String']['output']>;
  client_contact?: Maybe<Scalars['String']['output']>;
  client_letter_date?: Maybe<Scalars['timestamptz']['output']>;
  client_number?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_user?: Maybe<Mlfsl_Personnel>;
  id: Scalars['uuid']['output'];
  letter_pending?: Maybe<Scalars['String']['output']>;
  matter_number?: Maybe<Scalars['String']['output']>;
  mlb_attorney_on_client_letter?: Maybe<Mlfsl_Personnel>;
  mlb_attorney_on_client_letter_id?: Maybe<Scalars['String']['output']>;
  mlb_attorney_on_client_letter_name?: Maybe<Scalars['String']['output']>;
  mlfsl_client?: Maybe<Mlfsl_Client>;
  mlfsl_matter?: Maybe<Mlfsl_Matter>;
  multiple_waivers?: Maybe<Scalars['String']['output']>;
  no_executed_letter_available_of_file?: Maybe<Scalars['String']['output']>;
  no_written_letter_on_file?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_by_user?: Maybe<Mlfsl_Personnel>;
  /** An array relationship */
  waiver_imanage_documents: Array<Clm_Waiver_Imanage_Documents>;
  /** An aggregate relationship */
  waiver_imanage_documents_aggregate: Clm_Waiver_Imanage_Documents_Aggregate;
};

/** columns and relationships of "clm.waiver_records" */
export type Clm_Waiver_RecordsWaiver_Imanage_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Clm_Waiver_Imanage_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Waiver_Imanage_Documents_Order_By>>;
  where?: InputMaybe<Clm_Waiver_Imanage_Documents_Bool_Exp>;
};

/** columns and relationships of "clm.waiver_records" */
export type Clm_Waiver_RecordsWaiver_Imanage_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clm_Waiver_Imanage_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Waiver_Imanage_Documents_Order_By>>;
  where?: InputMaybe<Clm_Waiver_Imanage_Documents_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "clm.waiver_records". All fields are combined with a logical 'AND'. */
export type Clm_Waiver_Records_Bool_Exp = {
  _and?: InputMaybe<Array<Clm_Waiver_Records_Bool_Exp>>;
  _not?: InputMaybe<Clm_Waiver_Records_Bool_Exp>;
  _or?: InputMaybe<Array<Clm_Waiver_Records_Bool_Exp>>;
  adverse_client_name?: InputMaybe<String_Comparison_Exp>;
  adverse_contact_signer?: InputMaybe<String_Comparison_Exp>;
  adverse_letter_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  adverse_mlb_attorney_on_letter_id?: InputMaybe<String_Comparison_Exp>;
  adverse_mlb_attorney_on_letter_name?: InputMaybe<String_Comparison_Exp>;
  client_contact?: InputMaybe<String_Comparison_Exp>;
  client_letter_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  client_number?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  letter_pending?: InputMaybe<String_Comparison_Exp>;
  matter_number?: InputMaybe<String_Comparison_Exp>;
  mlb_attorney_on_client_letter_id?: InputMaybe<String_Comparison_Exp>;
  mlb_attorney_on_client_letter_name?: InputMaybe<String_Comparison_Exp>;
  multiple_waivers?: InputMaybe<String_Comparison_Exp>;
  no_executed_letter_available_of_file?: InputMaybe<String_Comparison_Exp>;
  no_written_letter_on_file?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  waiver_imanage_documents?: InputMaybe<Clm_Waiver_Imanage_Documents_Bool_Exp>;
  waiver_imanage_documents_aggregate?: InputMaybe<Clm_Waiver_Imanage_Documents_Aggregate_Bool_Exp>;
};

/** Ordering options when selecting data from "clm.waiver_records". */
export type Clm_Waiver_Records_Order_By = {
  adverse_client_name?: InputMaybe<Order_By>;
  adverse_contact_signer?: InputMaybe<Order_By>;
  adverse_letter_date?: InputMaybe<Order_By>;
  adverse_mlb_attorney_on_letter_id?: InputMaybe<Order_By>;
  adverse_mlb_attorney_on_letter_name?: InputMaybe<Order_By>;
  client_contact?: InputMaybe<Order_By>;
  client_letter_date?: InputMaybe<Order_By>;
  client_number?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  letter_pending?: InputMaybe<Order_By>;
  matter_number?: InputMaybe<Order_By>;
  mlb_attorney_on_client_letter_id?: InputMaybe<Order_By>;
  mlb_attorney_on_client_letter_name?: InputMaybe<Order_By>;
  multiple_waivers?: InputMaybe<Order_By>;
  no_executed_letter_available_of_file?: InputMaybe<Order_By>;
  no_written_letter_on_file?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  waiver_imanage_documents_aggregate?: InputMaybe<Clm_Waiver_Imanage_Documents_Aggregate_Order_By>;
};

/** select columns of table "clm.waiver_records" */
export enum Clm_Waiver_Records_Select_Column {
  /** column name */
  Adverse_client_name = 'adverse_client_name',
  /** column name */
  Adverse_contact_signer = 'adverse_contact_signer',
  /** column name */
  Adverse_letter_date = 'adverse_letter_date',
  /** column name */
  Adverse_mlb_attorney_on_letter_id = 'adverse_mlb_attorney_on_letter_id',
  /** column name */
  Adverse_mlb_attorney_on_letter_name = 'adverse_mlb_attorney_on_letter_name',
  /** column name */
  Client_contact = 'client_contact',
  /** column name */
  Client_letter_date = 'client_letter_date',
  /** column name */
  Client_number = 'client_number',
  /** column name */
  Comments = 'comments',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Letter_pending = 'letter_pending',
  /** column name */
  Matter_number = 'matter_number',
  /** column name */
  Mlb_attorney_on_client_letter_id = 'mlb_attorney_on_client_letter_id',
  /** column name */
  Mlb_attorney_on_client_letter_name = 'mlb_attorney_on_client_letter_name',
  /** column name */
  Multiple_waivers = 'multiple_waivers',
  /** column name */
  No_executed_letter_available_of_file = 'no_executed_letter_available_of_file',
  /** column name */
  No_written_letter_on_file = 'no_written_letter_on_file',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** Streaming cursor of the table "clm_waiver_records" */
export type Clm_Waiver_Records_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Clm_Waiver_Records_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Clm_Waiver_Records_Stream_Cursor_Value_Input = {
  adverse_client_name?: InputMaybe<Scalars['String']['input']>;
  adverse_contact_signer?: InputMaybe<Scalars['String']['input']>;
  adverse_letter_date?: InputMaybe<Scalars['timestamptz']['input']>;
  adverse_mlb_attorney_on_letter_id?: InputMaybe<Scalars['String']['input']>;
  adverse_mlb_attorney_on_letter_name?: InputMaybe<Scalars['String']['input']>;
  client_contact?: InputMaybe<Scalars['String']['input']>;
  client_letter_date?: InputMaybe<Scalars['timestamptz']['input']>;
  client_number?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  letter_pending?: InputMaybe<Scalars['String']['input']>;
  matter_number?: InputMaybe<Scalars['String']['input']>;
  mlb_attorney_on_client_letter_id?: InputMaybe<Scalars['String']['input']>;
  mlb_attorney_on_client_letter_name?: InputMaybe<Scalars['String']['input']>;
  multiple_waivers?: InputMaybe<Scalars['String']['input']>;
  no_executed_letter_available_of_file?: InputMaybe<Scalars['String']['input']>;
  no_written_letter_on_file?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  ASC = 'ASC',
  /** descending ordering of the cursor */
  DESC = 'DESC',
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** Boolean expression to compare columns of type "datetime2". All fields are combined with logical 'AND'. */
export type Datetime2_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['datetime2']['input']>;
  _gt?: InputMaybe<Scalars['datetime2']['input']>;
  _gte?: InputMaybe<Scalars['datetime2']['input']>;
  _in?: InputMaybe<Array<Scalars['datetime2']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['datetime2']['input']>;
  _lte?: InputMaybe<Scalars['datetime2']['input']>;
  _neq?: InputMaybe<Scalars['datetime2']['input']>;
  _nin?: InputMaybe<Array<Scalars['datetime2']['input']>>;
};

/** Boolean expression to compare columns of type "datetime". All fields are combined with logical 'AND'. */
export type Datetime_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['datetime']['input']>;
  _gt?: InputMaybe<Scalars['datetime']['input']>;
  _gte?: InputMaybe<Scalars['datetime']['input']>;
  _in?: InputMaybe<Array<Scalars['datetime']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['datetime']['input']>;
  _lte?: InputMaybe<Scalars['datetime']['input']>;
  _neq?: InputMaybe<Scalars['datetime']['input']>;
  _nin?: InputMaybe<Array<Scalars['datetime']['input']>>;
};

/** Stores reusable email templates used by File Disposition projects */
export type Fd_Email_Templates = {
  body: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  projects: Array<Fd_Projects>;
  subject: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** Stores reusable email templates used by File Disposition projects */
export type Fd_Email_TemplatesProjectsArgs = {
  distinct_on?: InputMaybe<Array<Fd_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Projects_Order_By>>;
  where?: InputMaybe<Fd_Projects_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "fd.email_templates". All fields are combined with a logical 'AND'. */
export type Fd_Email_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Fd_Email_Templates_Bool_Exp>>;
  _not?: InputMaybe<Fd_Email_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Fd_Email_Templates_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  projects?: InputMaybe<Fd_Projects_Bool_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "fd.email_templates" */
export enum Fd_Email_Templates_Constraint {
  /** unique or primary key constraint on columns "key" */
  Email_templates_key_key = 'email_templates_key_key',
  /** unique or primary key constraint on columns "id" */
  Email_templates_pkey = 'email_templates_pkey',
}

/** input type for inserting data into table "fd.email_templates" */
export type Fd_Email_Templates_Insert_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Fd_Projects_Arr_Rel_Insert_Input>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "fd.email_templates" */
export type Fd_Email_Templates_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Fd_Email_Templates>;
};

/** input type for inserting object relation for remote table "fd.email_templates" */
export type Fd_Email_Templates_Obj_Rel_Insert_Input = {
  data: Fd_Email_Templates_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Fd_Email_Templates_On_Conflict>;
};

/** on_conflict condition type for table "fd.email_templates" */
export type Fd_Email_Templates_On_Conflict = {
  constraint: Fd_Email_Templates_Constraint;
  update_columns?: Array<Fd_Email_Templates_Update_Column>;
  where?: InputMaybe<Fd_Email_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "fd.email_templates". */
export type Fd_Email_Templates_Order_By = {
  body?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projects_aggregate?: InputMaybe<Fd_Projects_Aggregate_Order_By>;
  subject?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fd.email_templates */
export type Fd_Email_Templates_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "fd.email_templates" */
export enum Fd_Email_Templates_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Is_active = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  Subject = 'subject',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "fd.email_templates" */
export type Fd_Email_Templates_Set_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "fd_email_templates" */
export type Fd_Email_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fd_Email_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fd_Email_Templates_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "fd.email_templates" */
export enum Fd_Email_Templates_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Is_active = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  Subject = 'subject',
  /** column name */
  Updated_at = 'updated_at',
}

export type Fd_Email_Templates_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fd_Email_Templates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fd_Email_Templates_Bool_Exp;
};

/** Stores matters excluded from File Disposition processing and the reason for exclusion. */
export type Fd_Exempt_Matters = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  exclusion_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_exempt: Scalars['Boolean']['output'];
  matter_id: Scalars['String']['output'];
  mlfsl_matter?: Maybe<Mlfsl_Matter>;
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** Boolean expression to filter rows from the table "fd.exempt_matters". All fields are combined with a logical 'AND'. */
export type Fd_Exempt_Matters_Bool_Exp = {
  _and?: InputMaybe<Array<Fd_Exempt_Matters_Bool_Exp>>;
  _not?: InputMaybe<Fd_Exempt_Matters_Bool_Exp>;
  _or?: InputMaybe<Array<Fd_Exempt_Matters_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  exclusion_reason?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_exempt?: InputMaybe<Boolean_Comparison_Exp>;
  matter_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "fd.exempt_matters" */
export enum Fd_Exempt_Matters_Constraint {
  /** unique or primary key constraint on columns "matter_id" */
  Exempt_matters_matter_id_key = 'exempt_matters_matter_id_key',
  /** unique or primary key constraint on columns "id" */
  Exempt_matters_pkey = 'exempt_matters_pkey',
}

/** input type for inserting data into table "fd.exempt_matters" */
export type Fd_Exempt_Matters_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  exclusion_reason?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_exempt?: InputMaybe<Scalars['Boolean']['input']>;
  matter_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "fd.exempt_matters" */
export type Fd_Exempt_Matters_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Fd_Exempt_Matters>;
};

/** on_conflict condition type for table "fd.exempt_matters" */
export type Fd_Exempt_Matters_On_Conflict = {
  constraint: Fd_Exempt_Matters_Constraint;
  update_columns?: Array<Fd_Exempt_Matters_Update_Column>;
  where?: InputMaybe<Fd_Exempt_Matters_Bool_Exp>;
};

/** Ordering options when selecting data from "fd.exempt_matters". */
export type Fd_Exempt_Matters_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  exclusion_reason?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_exempt?: InputMaybe<Order_By>;
  matter_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fd.exempt_matters */
export type Fd_Exempt_Matters_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "fd.exempt_matters" */
export enum Fd_Exempt_Matters_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Exclusion_reason = 'exclusion_reason',
  /** column name */
  Id = 'id',
  /** column name */
  Is_exempt = 'is_exempt',
  /** column name */
  Matter_id = 'matter_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "fd.exempt_matters" */
export type Fd_Exempt_Matters_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  exclusion_reason?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_exempt?: InputMaybe<Scalars['Boolean']['input']>;
  matter_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "fd_exempt_matters" */
export type Fd_Exempt_Matters_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fd_Exempt_Matters_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fd_Exempt_Matters_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  exclusion_reason?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_exempt?: InputMaybe<Scalars['Boolean']['input']>;
  matter_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "fd.exempt_matters" */
export enum Fd_Exempt_Matters_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Exclusion_reason = 'exclusion_reason',
  /** column name */
  Id = 'id',
  /** column name */
  Is_exempt = 'is_exempt',
  /** column name */
  Matter_id = 'matter_id',
  /** column name */
  Updated_at = 'updated_at',
}

export type Fd_Exempt_Matters_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fd_Exempt_Matters_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fd_Exempt_Matters_Bool_Exp;
};

/** Stores reusable instruction templates used by File Disposition projects. */
export type Fd_Instruction_Templates = {
  body: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  projects: Array<Fd_Projects>;
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** Stores reusable instruction templates used by File Disposition projects. */
export type Fd_Instruction_TemplatesProjectsArgs = {
  distinct_on?: InputMaybe<Array<Fd_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Projects_Order_By>>;
  where?: InputMaybe<Fd_Projects_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "fd.instruction_templates". All fields are combined with a logical 'AND'. */
export type Fd_Instruction_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Fd_Instruction_Templates_Bool_Exp>>;
  _not?: InputMaybe<Fd_Instruction_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Fd_Instruction_Templates_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  projects?: InputMaybe<Fd_Projects_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "fd.instruction_templates" */
export enum Fd_Instruction_Templates_Constraint {
  /** unique or primary key constraint on columns "key" */
  Instruction_templates_key_key = 'instruction_templates_key_key',
  /** unique or primary key constraint on columns "id" */
  Instruction_templates_pkey = 'instruction_templates_pkey',
}

/** input type for inserting data into table "fd.instruction_templates" */
export type Fd_Instruction_Templates_Insert_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Fd_Projects_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "fd.instruction_templates" */
export type Fd_Instruction_Templates_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Fd_Instruction_Templates>;
};

/** input type for inserting object relation for remote table "fd.instruction_templates" */
export type Fd_Instruction_Templates_Obj_Rel_Insert_Input = {
  data: Fd_Instruction_Templates_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Fd_Instruction_Templates_On_Conflict>;
};

/** on_conflict condition type for table "fd.instruction_templates" */
export type Fd_Instruction_Templates_On_Conflict = {
  constraint: Fd_Instruction_Templates_Constraint;
  update_columns?: Array<Fd_Instruction_Templates_Update_Column>;
  where?: InputMaybe<Fd_Instruction_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "fd.instruction_templates". */
export type Fd_Instruction_Templates_Order_By = {
  body?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projects_aggregate?: InputMaybe<Fd_Projects_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fd.instruction_templates */
export type Fd_Instruction_Templates_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "fd.instruction_templates" */
export enum Fd_Instruction_Templates_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Is_active = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "fd.instruction_templates" */
export type Fd_Instruction_Templates_Set_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "fd_instruction_templates" */
export type Fd_Instruction_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fd_Instruction_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fd_Instruction_Templates_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "fd.instruction_templates" */
export enum Fd_Instruction_Templates_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Is_active = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  Updated_at = 'updated_at',
}

export type Fd_Instruction_Templates_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fd_Instruction_Templates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fd_Instruction_Templates_Bool_Exp;
};

/** Stores the selected File Disposition response, notes, and lock state for an enterprise matter. */
export type Fd_Matters_Responses = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  id: Scalars['uuid']['output'];
  is_locked: Scalars['Boolean']['output'];
  matter_id: Scalars['String']['output'];
  mlfsl_matter?: Maybe<Mlfsl_Matter>;
  notes?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  project: Fd_Projects;
  project_id: Scalars['uuid']['output'];
  /** An object relationship */
  response: Fd_Responses;
  response_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** order by aggregate values of table "fd.matters_responses" */
export type Fd_Matters_Responses_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fd_Matters_Responses_Max_Order_By>;
  min?: InputMaybe<Fd_Matters_Responses_Min_Order_By>;
};

/** input type for inserting array relation for remote table "fd.matters_responses" */
export type Fd_Matters_Responses_Arr_Rel_Insert_Input = {
  data: Array<Fd_Matters_Responses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Fd_Matters_Responses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "fd.matters_responses". All fields are combined with a logical 'AND'. */
export type Fd_Matters_Responses_Bool_Exp = {
  _and?: InputMaybe<Array<Fd_Matters_Responses_Bool_Exp>>;
  _not?: InputMaybe<Fd_Matters_Responses_Bool_Exp>;
  _or?: InputMaybe<Array<Fd_Matters_Responses_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_locked?: InputMaybe<Boolean_Comparison_Exp>;
  matter_id?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Fd_Projects_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  response?: InputMaybe<Fd_Responses_Bool_Exp>;
  response_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "fd.matters_responses" */
export enum Fd_Matters_Responses_Constraint {
  /** unique or primary key constraint on columns "id" */
  Matters_responses_pkey = 'matters_responses_pkey',
}

/** input type for inserting data into table "fd.matters_responses" */
export type Fd_Matters_Responses_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_locked?: InputMaybe<Scalars['Boolean']['input']>;
  matter_id?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Fd_Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Fd_Responses_Obj_Rel_Insert_Input>;
  response_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "fd.matters_responses" */
export type Fd_Matters_Responses_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  matter_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  response_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "fd.matters_responses" */
export type Fd_Matters_Responses_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  matter_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  response_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "fd.matters_responses" */
export type Fd_Matters_Responses_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Fd_Matters_Responses>;
};

/** on_conflict condition type for table "fd.matters_responses" */
export type Fd_Matters_Responses_On_Conflict = {
  constraint: Fd_Matters_Responses_Constraint;
  update_columns?: Array<Fd_Matters_Responses_Update_Column>;
  where?: InputMaybe<Fd_Matters_Responses_Bool_Exp>;
};

/** Ordering options when selecting data from "fd.matters_responses". */
export type Fd_Matters_Responses_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_locked?: InputMaybe<Order_By>;
  matter_id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  project?: InputMaybe<Fd_Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Fd_Responses_Order_By>;
  response_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fd.matters_responses */
export type Fd_Matters_Responses_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "fd.matters_responses" */
export enum Fd_Matters_Responses_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Is_locked = 'is_locked',
  /** column name */
  Matter_id = 'matter_id',
  /** column name */
  Notes = 'notes',
  /** column name */
  Project_id = 'project_id',
  /** column name */
  Response_id = 'response_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "fd.matters_responses" */
export type Fd_Matters_Responses_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_locked?: InputMaybe<Scalars['Boolean']['input']>;
  matter_id?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  response_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "fd_matters_responses" */
export type Fd_Matters_Responses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fd_Matters_Responses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fd_Matters_Responses_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_locked?: InputMaybe<Scalars['Boolean']['input']>;
  matter_id?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  response_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "fd.matters_responses" */
export enum Fd_Matters_Responses_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Is_locked = 'is_locked',
  /** column name */
  Matter_id = 'matter_id',
  /** column name */
  Notes = 'notes',
  /** column name */
  Project_id = 'project_id',
  /** column name */
  Response_id = 'response_id',
  /** column name */
  Updated_at = 'updated_at',
}

export type Fd_Matters_Responses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fd_Matters_Responses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fd_Matters_Responses_Bool_Exp;
};

/** Stores ML users who are granted access to a File Disposition project. */
export type Fd_Project_Access = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  project: Fd_Projects;
  project_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
  user?: Maybe<Mlfsl_Personnel>;
  user_id: Scalars['String']['output'];
};

/** order by aggregate values of table "fd.project_access" */
export type Fd_Project_Access_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fd_Project_Access_Max_Order_By>;
  min?: InputMaybe<Fd_Project_Access_Min_Order_By>;
};

/** input type for inserting array relation for remote table "fd.project_access" */
export type Fd_Project_Access_Arr_Rel_Insert_Input = {
  data: Array<Fd_Project_Access_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Fd_Project_Access_On_Conflict>;
};

/** Boolean expression to filter rows from the table "fd.project_access". All fields are combined with a logical 'AND'. */
export type Fd_Project_Access_Bool_Exp = {
  _and?: InputMaybe<Array<Fd_Project_Access_Bool_Exp>>;
  _not?: InputMaybe<Fd_Project_Access_Bool_Exp>;
  _or?: InputMaybe<Array<Fd_Project_Access_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  project?: InputMaybe<Fd_Projects_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "fd.project_access" */
export enum Fd_Project_Access_Constraint {
  /** unique or primary key constraint on columns "id" */
  Project_access_pkey = 'project_access_pkey',
}

/** input type for inserting data into table "fd.project_access" */
export type Fd_Project_Access_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  project?: InputMaybe<Fd_Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "fd.project_access" */
export type Fd_Project_Access_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "fd.project_access" */
export type Fd_Project_Access_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "fd.project_access" */
export type Fd_Project_Access_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Fd_Project_Access>;
};

/** on_conflict condition type for table "fd.project_access" */
export type Fd_Project_Access_On_Conflict = {
  constraint: Fd_Project_Access_Constraint;
  update_columns?: Array<Fd_Project_Access_Update_Column>;
  where?: InputMaybe<Fd_Project_Access_Bool_Exp>;
};

/** Ordering options when selecting data from "fd.project_access". */
export type Fd_Project_Access_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project?: InputMaybe<Fd_Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fd.project_access */
export type Fd_Project_Access_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "fd.project_access" */
export enum Fd_Project_Access_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Project_id = 'project_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
  /** column name */
  User_id = 'user_id',
}

/** input type for updating data in table "fd.project_access" */
export type Fd_Project_Access_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "fd_project_access" */
export type Fd_Project_Access_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fd_Project_Access_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fd_Project_Access_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "fd.project_access" */
export enum Fd_Project_Access_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Project_id = 'project_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  User_id = 'user_id',
}

export type Fd_Project_Access_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fd_Project_Access_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fd_Project_Access_Bool_Exp;
};

/** Format: FD-26-000001 */
export type Fd_Project_Number_Counter = {
  created_at: Scalars['timestamptz']['output'];
  last_number: Scalars['Int']['output'];
  project_year: Scalars['smallint']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "fd.project_number_counter". All fields are combined with a logical 'AND'. */
export type Fd_Project_Number_Counter_Bool_Exp = {
  _and?: InputMaybe<Array<Fd_Project_Number_Counter_Bool_Exp>>;
  _not?: InputMaybe<Fd_Project_Number_Counter_Bool_Exp>;
  _or?: InputMaybe<Array<Fd_Project_Number_Counter_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_number?: InputMaybe<Int_Comparison_Exp>;
  project_year?: InputMaybe<Smallint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "fd.project_number_counter" */
export enum Fd_Project_Number_Counter_Constraint {
  /** unique or primary key constraint on columns "project_year" */
  Project_number_counter_pkey = 'project_number_counter_pkey',
}

/** input type for incrementing numeric columns in table "fd.project_number_counter" */
export type Fd_Project_Number_Counter_Inc_Input = {
  last_number?: InputMaybe<Scalars['Int']['input']>;
  project_year?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "fd.project_number_counter" */
export type Fd_Project_Number_Counter_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_number?: InputMaybe<Scalars['Int']['input']>;
  project_year?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "fd.project_number_counter" */
export type Fd_Project_Number_Counter_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Fd_Project_Number_Counter>;
};

/** on_conflict condition type for table "fd.project_number_counter" */
export type Fd_Project_Number_Counter_On_Conflict = {
  constraint: Fd_Project_Number_Counter_Constraint;
  update_columns?: Array<Fd_Project_Number_Counter_Update_Column>;
  where?: InputMaybe<Fd_Project_Number_Counter_Bool_Exp>;
};

/** Ordering options when selecting data from "fd.project_number_counter". */
export type Fd_Project_Number_Counter_Order_By = {
  created_at?: InputMaybe<Order_By>;
  last_number?: InputMaybe<Order_By>;
  project_year?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fd.project_number_counter */
export type Fd_Project_Number_Counter_Pk_Columns_Input = {
  project_year: Scalars['smallint']['input'];
};

/** select columns of table "fd.project_number_counter" */
export enum Fd_Project_Number_Counter_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Last_number = 'last_number',
  /** column name */
  Project_year = 'project_year',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "fd.project_number_counter" */
export type Fd_Project_Number_Counter_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_number?: InputMaybe<Scalars['Int']['input']>;
  project_year?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "fd_project_number_counter" */
export type Fd_Project_Number_Counter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fd_Project_Number_Counter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fd_Project_Number_Counter_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_number?: InputMaybe<Scalars['Int']['input']>;
  project_year?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "fd.project_number_counter" */
export enum Fd_Project_Number_Counter_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Last_number = 'last_number',
  /** column name */
  Project_year = 'project_year',
  /** column name */
  Updated_at = 'updated_at',
}

export type Fd_Project_Number_Counter_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fd_Project_Number_Counter_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fd_Project_Number_Counter_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fd_Project_Number_Counter_Bool_Exp;
};

/** Stores File Disposition project configuration, publishing state, template references, filters, and aggregate counts. */
export type Fd_Projects = {
  client_count: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  discription?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  email_template?: Maybe<Fd_Email_Templates>;
  email_template_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  instruction_template: Fd_Instruction_Templates;
  instruction_template_id: Scalars['uuid']['output'];
  is_published: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  matter_count: Scalars['Int']['output'];
  matter_filters?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  matters_responses: Array<Fd_Matters_Responses>;
  name: Scalars['String']['output'];
  /** An array relationship */
  project_accesses: Array<Fd_Project_Access>;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  published_mode: Scalars['String']['output'];
  response_count: Scalars['Int']['output'];
  /** An array relationship */
  response_in_projects: Array<Fd_Response_In_Projects>;
  site_name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** Stores File Disposition project configuration, publishing state, template references, filters, and aggregate counts. */
export type Fd_ProjectsMatter_FiltersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Stores File Disposition project configuration, publishing state, template references, filters, and aggregate counts. */
export type Fd_ProjectsMatters_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Fd_Matters_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Matters_Responses_Order_By>>;
  where?: InputMaybe<Fd_Matters_Responses_Bool_Exp>;
};

/** Stores File Disposition project configuration, publishing state, template references, filters, and aggregate counts. */
export type Fd_ProjectsProject_AccessesArgs = {
  distinct_on?: InputMaybe<Array<Fd_Project_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Project_Access_Order_By>>;
  where?: InputMaybe<Fd_Project_Access_Bool_Exp>;
};

/** Stores File Disposition project configuration, publishing state, template references, filters, and aggregate counts. */
export type Fd_ProjectsResponse_In_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Fd_Response_In_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Response_In_Projects_Order_By>>;
  where?: InputMaybe<Fd_Response_In_Projects_Bool_Exp>;
};

/** order by aggregate values of table "fd.projects" */
export type Fd_Projects_Aggregate_Order_By = {
  avg?: InputMaybe<Fd_Projects_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fd_Projects_Max_Order_By>;
  min?: InputMaybe<Fd_Projects_Min_Order_By>;
  stddev?: InputMaybe<Fd_Projects_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fd_Projects_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fd_Projects_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fd_Projects_Sum_Order_By>;
  var_pop?: InputMaybe<Fd_Projects_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fd_Projects_Var_Samp_Order_By>;
  variance?: InputMaybe<Fd_Projects_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Fd_Projects_Append_Input = {
  matter_filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "fd.projects" */
export type Fd_Projects_Arr_Rel_Insert_Input = {
  data: Array<Fd_Projects_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Fd_Projects_On_Conflict>;
};

/** order by avg() on columns of table "fd.projects" */
export type Fd_Projects_Avg_Order_By = {
  client_count?: InputMaybe<Order_By>;
  matter_count?: InputMaybe<Order_By>;
  response_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "fd.projects". All fields are combined with a logical 'AND'. */
export type Fd_Projects_Bool_Exp = {
  _and?: InputMaybe<Array<Fd_Projects_Bool_Exp>>;
  _not?: InputMaybe<Fd_Projects_Bool_Exp>;
  _or?: InputMaybe<Array<Fd_Projects_Bool_Exp>>;
  client_count?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  discription?: InputMaybe<String_Comparison_Exp>;
  email_template?: InputMaybe<Fd_Email_Templates_Bool_Exp>;
  email_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  instruction_template?: InputMaybe<Fd_Instruction_Templates_Bool_Exp>;
  instruction_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_published?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  matter_count?: InputMaybe<Int_Comparison_Exp>;
  matter_filters?: InputMaybe<Jsonb_Comparison_Exp>;
  matters_responses?: InputMaybe<Fd_Matters_Responses_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  project_accesses?: InputMaybe<Fd_Project_Access_Bool_Exp>;
  published_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  published_mode?: InputMaybe<String_Comparison_Exp>;
  response_count?: InputMaybe<Int_Comparison_Exp>;
  response_in_projects?: InputMaybe<Fd_Response_In_Projects_Bool_Exp>;
  site_name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "fd.projects" */
export enum Fd_Projects_Constraint {
  /** unique or primary key constraint on columns "key" */
  Projects_key_key = 'projects_key_key',
  /** unique or primary key constraint on columns "id" */
  Projects_pkey = 'projects_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Fd_Projects_Delete_At_Path_Input = {
  matter_filters?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Fd_Projects_Delete_Elem_Input = {
  matter_filters?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Fd_Projects_Delete_Key_Input = {
  matter_filters?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "fd.projects" */
export type Fd_Projects_Inc_Input = {
  client_count?: InputMaybe<Scalars['Int']['input']>;
  matter_count?: InputMaybe<Scalars['Int']['input']>;
  response_count?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "fd.projects" */
export type Fd_Projects_Insert_Input = {
  client_count?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  discription?: InputMaybe<Scalars['String']['input']>;
  email_template?: InputMaybe<Fd_Email_Templates_Obj_Rel_Insert_Input>;
  email_template_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instruction_template?: InputMaybe<Fd_Instruction_Templates_Obj_Rel_Insert_Input>;
  instruction_template_id?: InputMaybe<Scalars['uuid']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  matter_count?: InputMaybe<Scalars['Int']['input']>;
  matter_filters?: InputMaybe<Scalars['jsonb']['input']>;
  matters_responses?: InputMaybe<Fd_Matters_Responses_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  project_accesses?: InputMaybe<Fd_Project_Access_Arr_Rel_Insert_Input>;
  published_at?: InputMaybe<Scalars['timestamptz']['input']>;
  published_mode?: InputMaybe<Scalars['String']['input']>;
  response_count?: InputMaybe<Scalars['Int']['input']>;
  response_in_projects?: InputMaybe<Fd_Response_In_Projects_Arr_Rel_Insert_Input>;
  site_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "fd.projects" */
export type Fd_Projects_Max_Order_By = {
  client_count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  discription?: InputMaybe<Order_By>;
  email_template_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instruction_template_id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  matter_count?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  published_at?: InputMaybe<Order_By>;
  published_mode?: InputMaybe<Order_By>;
  response_count?: InputMaybe<Order_By>;
  site_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "fd.projects" */
export type Fd_Projects_Min_Order_By = {
  client_count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  discription?: InputMaybe<Order_By>;
  email_template_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instruction_template_id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  matter_count?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  published_at?: InputMaybe<Order_By>;
  published_mode?: InputMaybe<Order_By>;
  response_count?: InputMaybe<Order_By>;
  site_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "fd.projects" */
export type Fd_Projects_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Fd_Projects>;
};

/** input type for inserting object relation for remote table "fd.projects" */
export type Fd_Projects_Obj_Rel_Insert_Input = {
  data: Fd_Projects_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Fd_Projects_On_Conflict>;
};

/** on_conflict condition type for table "fd.projects" */
export type Fd_Projects_On_Conflict = {
  constraint: Fd_Projects_Constraint;
  update_columns?: Array<Fd_Projects_Update_Column>;
  where?: InputMaybe<Fd_Projects_Bool_Exp>;
};

/** Ordering options when selecting data from "fd.projects". */
export type Fd_Projects_Order_By = {
  client_count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  discription?: InputMaybe<Order_By>;
  email_template?: InputMaybe<Fd_Email_Templates_Order_By>;
  email_template_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instruction_template?: InputMaybe<Fd_Instruction_Templates_Order_By>;
  instruction_template_id?: InputMaybe<Order_By>;
  is_published?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  matter_count?: InputMaybe<Order_By>;
  matter_filters?: InputMaybe<Order_By>;
  matters_responses_aggregate?: InputMaybe<Fd_Matters_Responses_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  project_accesses_aggregate?: InputMaybe<Fd_Project_Access_Aggregate_Order_By>;
  published_at?: InputMaybe<Order_By>;
  published_mode?: InputMaybe<Order_By>;
  response_count?: InputMaybe<Order_By>;
  response_in_projects_aggregate?: InputMaybe<Fd_Response_In_Projects_Aggregate_Order_By>;
  site_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fd.projects */
export type Fd_Projects_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Fd_Projects_Prepend_Input = {
  matter_filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "fd.projects" */
export enum Fd_Projects_Select_Column {
  /** column name */
  Client_count = 'client_count',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Discription = 'discription',
  /** column name */
  Email_template_id = 'email_template_id',
  /** column name */
  Id = 'id',
  /** column name */
  Instruction_template_id = 'instruction_template_id',
  /** column name */
  Is_published = 'is_published',
  /** column name */
  Key = 'key',
  /** column name */
  Matter_count = 'matter_count',
  /** column name */
  Matter_filters = 'matter_filters',
  /** column name */
  Name = 'name',
  /** column name */
  Published_at = 'published_at',
  /** column name */
  Published_mode = 'published_mode',
  /** column name */
  Response_count = 'response_count',
  /** column name */
  Site_name = 'site_name',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "fd.projects" */
export type Fd_Projects_Set_Input = {
  client_count?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  discription?: InputMaybe<Scalars['String']['input']>;
  email_template_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instruction_template_id?: InputMaybe<Scalars['uuid']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  matter_count?: InputMaybe<Scalars['Int']['input']>;
  matter_filters?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  published_at?: InputMaybe<Scalars['timestamptz']['input']>;
  published_mode?: InputMaybe<Scalars['String']['input']>;
  response_count?: InputMaybe<Scalars['Int']['input']>;
  site_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "fd.projects" */
export type Fd_Projects_Stddev_Order_By = {
  client_count?: InputMaybe<Order_By>;
  matter_count?: InputMaybe<Order_By>;
  response_count?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "fd.projects" */
export type Fd_Projects_Stddev_Pop_Order_By = {
  client_count?: InputMaybe<Order_By>;
  matter_count?: InputMaybe<Order_By>;
  response_count?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "fd.projects" */
export type Fd_Projects_Stddev_Samp_Order_By = {
  client_count?: InputMaybe<Order_By>;
  matter_count?: InputMaybe<Order_By>;
  response_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "fd_projects" */
export type Fd_Projects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fd_Projects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fd_Projects_Stream_Cursor_Value_Input = {
  client_count?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  discription?: InputMaybe<Scalars['String']['input']>;
  email_template_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instruction_template_id?: InputMaybe<Scalars['uuid']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  matter_count?: InputMaybe<Scalars['Int']['input']>;
  matter_filters?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  published_at?: InputMaybe<Scalars['timestamptz']['input']>;
  published_mode?: InputMaybe<Scalars['String']['input']>;
  response_count?: InputMaybe<Scalars['Int']['input']>;
  site_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "fd.projects" */
export type Fd_Projects_Sum_Order_By = {
  client_count?: InputMaybe<Order_By>;
  matter_count?: InputMaybe<Order_By>;
  response_count?: InputMaybe<Order_By>;
};

/** update columns of table "fd.projects" */
export enum Fd_Projects_Update_Column {
  /** column name */
  Client_count = 'client_count',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Discription = 'discription',
  /** column name */
  Email_template_id = 'email_template_id',
  /** column name */
  Id = 'id',
  /** column name */
  Instruction_template_id = 'instruction_template_id',
  /** column name */
  Is_published = 'is_published',
  /** column name */
  Key = 'key',
  /** column name */
  Matter_count = 'matter_count',
  /** column name */
  Matter_filters = 'matter_filters',
  /** column name */
  Name = 'name',
  /** column name */
  Published_at = 'published_at',
  /** column name */
  Published_mode = 'published_mode',
  /** column name */
  Response_count = 'response_count',
  /** column name */
  Site_name = 'site_name',
  /** column name */
  Updated_at = 'updated_at',
}

export type Fd_Projects_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Fd_Projects_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Fd_Projects_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Fd_Projects_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Fd_Projects_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fd_Projects_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Fd_Projects_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fd_Projects_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fd_Projects_Bool_Exp;
};

/** order by var_pop() on columns of table "fd.projects" */
export type Fd_Projects_Var_Pop_Order_By = {
  client_count?: InputMaybe<Order_By>;
  matter_count?: InputMaybe<Order_By>;
  response_count?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "fd.projects" */
export type Fd_Projects_Var_Samp_Order_By = {
  client_count?: InputMaybe<Order_By>;
  matter_count?: InputMaybe<Order_By>;
  response_count?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "fd.projects" */
export type Fd_Projects_Variance_Order_By = {
  client_count?: InputMaybe<Order_By>;
  matter_count?: InputMaybe<Order_By>;
  response_count?: InputMaybe<Order_By>;
};

/** Associates reusable response options with the File Disposition projects where they are available. */
export type Fd_Response_In_Projects = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  project: Fd_Projects;
  project_id: Scalars['uuid']['output'];
  /** An object relationship */
  response: Fd_Responses;
  response_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** order by aggregate values of table "fd.response_in_projects" */
export type Fd_Response_In_Projects_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fd_Response_In_Projects_Max_Order_By>;
  min?: InputMaybe<Fd_Response_In_Projects_Min_Order_By>;
};

/** input type for inserting array relation for remote table "fd.response_in_projects" */
export type Fd_Response_In_Projects_Arr_Rel_Insert_Input = {
  data: Array<Fd_Response_In_Projects_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Fd_Response_In_Projects_On_Conflict>;
};

/** Boolean expression to filter rows from the table "fd.response_in_projects". All fields are combined with a logical 'AND'. */
export type Fd_Response_In_Projects_Bool_Exp = {
  _and?: InputMaybe<Array<Fd_Response_In_Projects_Bool_Exp>>;
  _not?: InputMaybe<Fd_Response_In_Projects_Bool_Exp>;
  _or?: InputMaybe<Array<Fd_Response_In_Projects_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  project?: InputMaybe<Fd_Projects_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  response?: InputMaybe<Fd_Responses_Bool_Exp>;
  response_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "fd.response_in_projects" */
export enum Fd_Response_In_Projects_Constraint {
  /** unique or primary key constraint on columns "id" */
  Response_in_projects_pkey = 'response_in_projects_pkey',
}

/** input type for inserting data into table "fd.response_in_projects" */
export type Fd_Response_In_Projects_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  project?: InputMaybe<Fd_Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Fd_Responses_Obj_Rel_Insert_Input>;
  response_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "fd.response_in_projects" */
export type Fd_Response_In_Projects_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  response_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "fd.response_in_projects" */
export type Fd_Response_In_Projects_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  response_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "fd.response_in_projects" */
export type Fd_Response_In_Projects_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Fd_Response_In_Projects>;
};

/** on_conflict condition type for table "fd.response_in_projects" */
export type Fd_Response_In_Projects_On_Conflict = {
  constraint: Fd_Response_In_Projects_Constraint;
  update_columns?: Array<Fd_Response_In_Projects_Update_Column>;
  where?: InputMaybe<Fd_Response_In_Projects_Bool_Exp>;
};

/** Ordering options when selecting data from "fd.response_in_projects". */
export type Fd_Response_In_Projects_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project?: InputMaybe<Fd_Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Fd_Responses_Order_By>;
  response_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fd.response_in_projects */
export type Fd_Response_In_Projects_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "fd.response_in_projects" */
export enum Fd_Response_In_Projects_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Project_id = 'project_id',
  /** column name */
  Response_id = 'response_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "fd.response_in_projects" */
export type Fd_Response_In_Projects_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  response_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "fd_response_in_projects" */
export type Fd_Response_In_Projects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fd_Response_In_Projects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fd_Response_In_Projects_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['uuid']['input']>;
  response_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "fd.response_in_projects" */
export enum Fd_Response_In_Projects_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Project_id = 'project_id',
  /** column name */
  Response_id = 'response_id',
  /** column name */
  Updated_at = 'updated_at',
}

export type Fd_Response_In_Projects_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fd_Response_In_Projects_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fd_Response_In_Projects_Bool_Exp;
};

/** Stores reusable File Disposition response options. */
export type Fd_Responses = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  discription?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  /** An array relationship */
  matters_responses: Array<Fd_Matters_Responses>;
  name: Scalars['String']['output'];
  /** An array relationship */
  response_in_projects: Array<Fd_Response_In_Projects>;
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** Stores reusable File Disposition response options. */
export type Fd_ResponsesMatters_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Fd_Matters_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Matters_Responses_Order_By>>;
  where?: InputMaybe<Fd_Matters_Responses_Bool_Exp>;
};

/** Stores reusable File Disposition response options. */
export type Fd_ResponsesResponse_In_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Fd_Response_In_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Response_In_Projects_Order_By>>;
  where?: InputMaybe<Fd_Response_In_Projects_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "fd.responses". All fields are combined with a logical 'AND'. */
export type Fd_Responses_Bool_Exp = {
  _and?: InputMaybe<Array<Fd_Responses_Bool_Exp>>;
  _not?: InputMaybe<Fd_Responses_Bool_Exp>;
  _or?: InputMaybe<Array<Fd_Responses_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  discription?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  matters_responses?: InputMaybe<Fd_Matters_Responses_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  response_in_projects?: InputMaybe<Fd_Response_In_Projects_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "fd.responses" */
export enum Fd_Responses_Constraint {
  /** unique or primary key constraint on columns "name" */
  Responses_name_key = 'responses_name_key',
  /** unique or primary key constraint on columns "id" */
  Responses_pkey = 'responses_pkey',
}

/** input type for inserting data into table "fd.responses" */
export type Fd_Responses_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  discription?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  matters_responses?: InputMaybe<Fd_Matters_Responses_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  response_in_projects?: InputMaybe<Fd_Response_In_Projects_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "fd.responses" */
export type Fd_Responses_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Fd_Responses>;
};

/** input type for inserting object relation for remote table "fd.responses" */
export type Fd_Responses_Obj_Rel_Insert_Input = {
  data: Fd_Responses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Fd_Responses_On_Conflict>;
};

/** on_conflict condition type for table "fd.responses" */
export type Fd_Responses_On_Conflict = {
  constraint: Fd_Responses_Constraint;
  update_columns?: Array<Fd_Responses_Update_Column>;
  where?: InputMaybe<Fd_Responses_Bool_Exp>;
};

/** Ordering options when selecting data from "fd.responses". */
export type Fd_Responses_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  discription?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  matters_responses_aggregate?: InputMaybe<Fd_Matters_Responses_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  response_in_projects_aggregate?: InputMaybe<Fd_Response_In_Projects_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fd.responses */
export type Fd_Responses_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "fd.responses" */
export enum Fd_Responses_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Discription = 'discription',
  /** column name */
  Id = 'id',
  /** column name */
  Is_active = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "fd.responses" */
export type Fd_Responses_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  discription?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "fd_responses" */
export type Fd_Responses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fd_Responses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fd_Responses_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  discription?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "fd.responses" */
export enum Fd_Responses_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Discription = 'discription',
  /** column name */
  Id = 'id',
  /** column name */
  Is_active = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Updated_at = 'updated_at',
}

export type Fd_Responses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fd_Responses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fd_Responses_Bool_Exp;
};

/** a list of topics */
export type Firstup_Channels = {
  PersonnelInOffice: Array<Mlfsl_Personnel>;
  PersonnelInOffice_aggregate: Mlfsl_Personnel_Aggregate;
  auto_follow?: Maybe<Scalars['Boolean']['output']>;
  auto_publish?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  content_in_channels: Array<Firstup_Content_In_Channels>;
  /** An aggregate relationship */
  content_in_channels_aggregate: Firstup_Content_In_Channels_Aggregate;
  contributor_count?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description: Scalars['String']['output'];
  follower_count?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  practice_grp_rollup_code?: Maybe<Scalars['String']['output']>;
  practicegroup?: Maybe<Mlfsl_Practicegroup>;
  primary_office_key?: Maybe<Scalars['String']['output']>;
  promoted?: Maybe<Scalars['Boolean']['output']>;
  recommended?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  targeted?: Maybe<Scalars['Boolean']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_submittable?: Maybe<Scalars['Boolean']['output']>;
};

/** a list of topics */
export type Firstup_ChannelsPersonnelInOfficeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
};

/** a list of topics */
export type Firstup_ChannelsPersonnelInOffice_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
};

/** a list of topics */
export type Firstup_ChannelsContent_In_ChannelsArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Content_In_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Content_In_Channels_Order_By>>;
  where?: InputMaybe<Firstup_Content_In_Channels_Bool_Exp>;
};

/** a list of topics */
export type Firstup_ChannelsContent_In_Channels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Content_In_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Content_In_Channels_Order_By>>;
  where?: InputMaybe<Firstup_Content_In_Channels_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "firstup.channels". All fields are combined with a logical 'AND'. */
export type Firstup_Channels_Bool_Exp = {
  _and?: InputMaybe<Array<Firstup_Channels_Bool_Exp>>;
  _not?: InputMaybe<Firstup_Channels_Bool_Exp>;
  _or?: InputMaybe<Array<Firstup_Channels_Bool_Exp>>;
  auto_follow?: InputMaybe<Boolean_Comparison_Exp>;
  auto_publish?: InputMaybe<Boolean_Comparison_Exp>;
  content_in_channels?: InputMaybe<Firstup_Content_In_Channels_Bool_Exp>;
  content_in_channels_aggregate?: InputMaybe<Firstup_Content_In_Channels_Aggregate_Bool_Exp>;
  contributor_count?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  follower_count?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  practice_grp_rollup_code?: InputMaybe<String_Comparison_Exp>;
  primary_office_key?: InputMaybe<String_Comparison_Exp>;
  promoted?: InputMaybe<Boolean_Comparison_Exp>;
  recommended?: InputMaybe<Boolean_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  targeted?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_submittable?: InputMaybe<Boolean_Comparison_Exp>;
};

/** Ordering options when selecting data from "firstup.channels". */
export type Firstup_Channels_Order_By = {
  auto_follow?: InputMaybe<Order_By>;
  auto_publish?: InputMaybe<Order_By>;
  content_in_channels_aggregate?: InputMaybe<Firstup_Content_In_Channels_Aggregate_Order_By>;
  contributor_count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  follower_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  practice_grp_rollup_code?: InputMaybe<Order_By>;
  primary_office_key?: InputMaybe<Order_By>;
  promoted?: InputMaybe<Order_By>;
  recommended?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  targeted?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_submittable?: InputMaybe<Order_By>;
};

/** select columns of table "firstup.channels" */
export enum Firstup_Channels_Select_Column {
  /** column name */
  Auto_follow = 'auto_follow',
  /** column name */
  Auto_publish = 'auto_publish',
  /** column name */
  Contributor_count = 'contributor_count',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Follower_count = 'follower_count',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Practice_grp_rollup_code = 'practice_grp_rollup_code',
  /** column name */
  Primary_office_key = 'primary_office_key',
  /** column name */
  Promoted = 'promoted',
  /** column name */
  Recommended = 'recommended',
  /** column name */
  State = 'state',
  /** column name */
  Targeted = 'targeted',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  User_submittable = 'user_submittable',
}

/** Streaming cursor of the table "firstup_channels" */
export type Firstup_Channels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Firstup_Channels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Firstup_Channels_Stream_Cursor_Value_Input = {
  auto_follow?: InputMaybe<Scalars['Boolean']['input']>;
  auto_publish?: InputMaybe<Scalars['Boolean']['input']>;
  contributor_count?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  follower_count?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  practice_grp_rollup_code?: InputMaybe<Scalars['String']['input']>;
  primary_office_key?: InputMaybe<Scalars['String']['input']>;
  promoted?: InputMaybe<Scalars['Boolean']['input']>;
  recommended?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  targeted?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_submittable?: InputMaybe<Scalars['Boolean']['input']>;
};

/** List of a content from firstup */
export type Firstup_Content = {
  accent_color?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  comment_count?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  content_in_channels: Array<Firstup_Content_In_Channels>;
  /** An aggregate relationship */
  content_in_channels_aggregate: Firstup_Content_In_Channels_Aggregate;
  content_type?: Maybe<Scalars['String']['output']>;
  cover_image_alt?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  featured_label?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images_in_contents: Array<Firstup_Images_In_Content>;
  /** An aggregate relationship */
  images_in_contents_aggregate: Firstup_Images_In_Content_Aggregate;
  is_commentable?: Maybe<Scalars['Boolean']['output']>;
  is_translatable?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Scalars['String']['output']>>;
  /** An array relationship */
  people_in_contents: Array<Firstup_People_In_Content>;
  /** An aggregate relationship */
  people_in_contents_aggregate: Firstup_People_In_Content_Aggregate;
  permalink_url?: Maybe<Scalars['String']['output']>;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  shareable_url?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uuid: Scalars['uuid']['output'];
  /** An array relationship */
  videos_in_contents: Array<Firstup_Videos_In_Content>;
  /** An aggregate relationship */
  videos_in_contents_aggregate: Firstup_Videos_In_Content_Aggregate;
  visibility?: Maybe<Scalars['String']['output']>;
};

/** List of a content from firstup */
export type Firstup_ContentContent_In_ChannelsArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Content_In_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Content_In_Channels_Order_By>>;
  where?: InputMaybe<Firstup_Content_In_Channels_Bool_Exp>;
};

/** List of a content from firstup */
export type Firstup_ContentContent_In_Channels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Content_In_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Content_In_Channels_Order_By>>;
  where?: InputMaybe<Firstup_Content_In_Channels_Bool_Exp>;
};

/** List of a content from firstup */
export type Firstup_ContentImages_In_ContentsArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Images_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Images_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_Images_In_Content_Bool_Exp>;
};

/** List of a content from firstup */
export type Firstup_ContentImages_In_Contents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Images_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Images_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_Images_In_Content_Bool_Exp>;
};

/** List of a content from firstup */
export type Firstup_ContentPeople_In_ContentsArgs = {
  distinct_on?: InputMaybe<Array<Firstup_People_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_People_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_People_In_Content_Bool_Exp>;
};

/** List of a content from firstup */
export type Firstup_ContentPeople_In_Contents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_People_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_People_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_People_In_Content_Bool_Exp>;
};

/** List of a content from firstup */
export type Firstup_ContentVideos_In_ContentsArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Videos_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Videos_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_Videos_In_Content_Bool_Exp>;
};

/** List of a content from firstup */
export type Firstup_ContentVideos_In_Contents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Videos_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Videos_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_Videos_In_Content_Bool_Exp>;
};

/** aggregated selection of "firstup.content" */
export type Firstup_Content_Aggregate = {
  aggregate?: Maybe<Firstup_Content_Aggregate_Fields>;
  nodes: Array<Firstup_Content>;
};

/** aggregate fields of "firstup.content" */
export type Firstup_Content_Aggregate_Fields = {
  avg?: Maybe<Firstup_Content_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Firstup_Content_Max_Fields>;
  min?: Maybe<Firstup_Content_Min_Fields>;
  stddev?: Maybe<Firstup_Content_Stddev_Fields>;
  stddev_pop?: Maybe<Firstup_Content_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Firstup_Content_Stddev_Samp_Fields>;
  sum?: Maybe<Firstup_Content_Sum_Fields>;
  var_pop?: Maybe<Firstup_Content_Var_Pop_Fields>;
  var_samp?: Maybe<Firstup_Content_Var_Samp_Fields>;
  variance?: Maybe<Firstup_Content_Variance_Fields>;
};

/** aggregate fields of "firstup.content" */
export type Firstup_Content_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Firstup_Content_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Firstup_Content_Avg_Fields = {
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "firstup.content". All fields are combined with a logical 'AND'. */
export type Firstup_Content_Bool_Exp = {
  _and?: InputMaybe<Array<Firstup_Content_Bool_Exp>>;
  _not?: InputMaybe<Firstup_Content_Bool_Exp>;
  _or?: InputMaybe<Array<Firstup_Content_Bool_Exp>>;
  accent_color?: InputMaybe<String_Comparison_Exp>;
  body?: InputMaybe<String_Comparison_Exp>;
  comment_count?: InputMaybe<Int_Comparison_Exp>;
  content_in_channels?: InputMaybe<Firstup_Content_In_Channels_Bool_Exp>;
  content_in_channels_aggregate?: InputMaybe<Firstup_Content_In_Channels_Aggregate_Bool_Exp>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  cover_image_alt?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  featured?: InputMaybe<Boolean_Comparison_Exp>;
  featured_label?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images_in_contents?: InputMaybe<Firstup_Images_In_Content_Bool_Exp>;
  images_in_contents_aggregate?: InputMaybe<Firstup_Images_In_Content_Aggregate_Bool_Exp>;
  is_commentable?: InputMaybe<Boolean_Comparison_Exp>;
  is_translatable?: InputMaybe<Boolean_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  links?: InputMaybe<String_Array_Comparison_Exp>;
  people_in_contents?: InputMaybe<Firstup_People_In_Content_Bool_Exp>;
  people_in_contents_aggregate?: InputMaybe<Firstup_People_In_Content_Aggregate_Bool_Exp>;
  permalink_url?: InputMaybe<String_Comparison_Exp>;
  published_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  shareable_url?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  summary?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  videos_in_contents?: InputMaybe<Firstup_Videos_In_Content_Bool_Exp>;
  videos_in_contents_aggregate?: InputMaybe<Firstup_Videos_In_Content_Aggregate_Bool_Exp>;
  visibility?: InputMaybe<String_Comparison_Exp>;
};

/** joint object to link topics and content  */
export type Firstup_Content_In_Channels = {
  /** An object relationship */
  channel: Firstup_Channels;
  channel_id: Scalars['Int']['output'];
  /** An object relationship */
  content: Firstup_Content;
  content_id: Scalars['Int']['output'];
};

/** aggregated selection of "firstup.content_in_channels" */
export type Firstup_Content_In_Channels_Aggregate = {
  aggregate?: Maybe<Firstup_Content_In_Channels_Aggregate_Fields>;
  nodes: Array<Firstup_Content_In_Channels>;
};

export type Firstup_Content_In_Channels_Aggregate_Bool_Exp = {
  count?: InputMaybe<Firstup_Content_In_Channels_Aggregate_Bool_Exp_Count>;
};

export type Firstup_Content_In_Channels_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Firstup_Content_In_Channels_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Firstup_Content_In_Channels_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "firstup.content_in_channels" */
export type Firstup_Content_In_Channels_Aggregate_Fields = {
  avg?: Maybe<Firstup_Content_In_Channels_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Firstup_Content_In_Channels_Max_Fields>;
  min?: Maybe<Firstup_Content_In_Channels_Min_Fields>;
  stddev?: Maybe<Firstup_Content_In_Channels_Stddev_Fields>;
  stddev_pop?: Maybe<Firstup_Content_In_Channels_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Firstup_Content_In_Channels_Stddev_Samp_Fields>;
  sum?: Maybe<Firstup_Content_In_Channels_Sum_Fields>;
  var_pop?: Maybe<Firstup_Content_In_Channels_Var_Pop_Fields>;
  var_samp?: Maybe<Firstup_Content_In_Channels_Var_Samp_Fields>;
  variance?: Maybe<Firstup_Content_In_Channels_Variance_Fields>;
};

/** aggregate fields of "firstup.content_in_channels" */
export type Firstup_Content_In_Channels_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Firstup_Content_In_Channels_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "firstup.content_in_channels" */
export type Firstup_Content_In_Channels_Aggregate_Order_By = {
  avg?: InputMaybe<Firstup_Content_In_Channels_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Firstup_Content_In_Channels_Max_Order_By>;
  min?: InputMaybe<Firstup_Content_In_Channels_Min_Order_By>;
  stddev?: InputMaybe<Firstup_Content_In_Channels_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Firstup_Content_In_Channels_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Firstup_Content_In_Channels_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Firstup_Content_In_Channels_Sum_Order_By>;
  var_pop?: InputMaybe<Firstup_Content_In_Channels_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Firstup_Content_In_Channels_Var_Samp_Order_By>;
  variance?: InputMaybe<Firstup_Content_In_Channels_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Firstup_Content_In_Channels_Avg_Fields = {
  channel_id?: Maybe<Scalars['Float']['output']>;
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "firstup.content_in_channels" */
export type Firstup_Content_In_Channels_Avg_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  content_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "firstup.content_in_channels". All fields are combined with a logical 'AND'. */
export type Firstup_Content_In_Channels_Bool_Exp = {
  _and?: InputMaybe<Array<Firstup_Content_In_Channels_Bool_Exp>>;
  _not?: InputMaybe<Firstup_Content_In_Channels_Bool_Exp>;
  _or?: InputMaybe<Array<Firstup_Content_In_Channels_Bool_Exp>>;
  channel?: InputMaybe<Firstup_Channels_Bool_Exp>;
  channel_id?: InputMaybe<Int_Comparison_Exp>;
  content?: InputMaybe<Firstup_Content_Bool_Exp>;
  content_id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Firstup_Content_In_Channels_Max_Fields = {
  channel_id?: Maybe<Scalars['Int']['output']>;
  content_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "firstup.content_in_channels" */
export type Firstup_Content_In_Channels_Max_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  content_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Firstup_Content_In_Channels_Min_Fields = {
  channel_id?: Maybe<Scalars['Int']['output']>;
  content_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "firstup.content_in_channels" */
export type Firstup_Content_In_Channels_Min_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  content_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "firstup.content_in_channels". */
export type Firstup_Content_In_Channels_Order_By = {
  channel?: InputMaybe<Firstup_Channels_Order_By>;
  channel_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Firstup_Content_Order_By>;
  content_id?: InputMaybe<Order_By>;
};

/** select columns of table "firstup.content_in_channels" */
export enum Firstup_Content_In_Channels_Select_Column {
  /** column name */
  Channel_id = 'channel_id',
  /** column name */
  Content_id = 'content_id',
}

/** aggregate stddev on columns */
export type Firstup_Content_In_Channels_Stddev_Fields = {
  channel_id?: Maybe<Scalars['Float']['output']>;
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "firstup.content_in_channels" */
export type Firstup_Content_In_Channels_Stddev_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  content_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Firstup_Content_In_Channels_Stddev_Pop_Fields = {
  channel_id?: Maybe<Scalars['Float']['output']>;
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "firstup.content_in_channels" */
export type Firstup_Content_In_Channels_Stddev_Pop_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  content_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Firstup_Content_In_Channels_Stddev_Samp_Fields = {
  channel_id?: Maybe<Scalars['Float']['output']>;
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "firstup.content_in_channels" */
export type Firstup_Content_In_Channels_Stddev_Samp_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  content_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "firstup_content_in_channels" */
export type Firstup_Content_In_Channels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Firstup_Content_In_Channels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Firstup_Content_In_Channels_Stream_Cursor_Value_Input = {
  channel_id?: InputMaybe<Scalars['Int']['input']>;
  content_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Firstup_Content_In_Channels_Sum_Fields = {
  channel_id?: Maybe<Scalars['Int']['output']>;
  content_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "firstup.content_in_channels" */
export type Firstup_Content_In_Channels_Sum_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  content_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Firstup_Content_In_Channels_Var_Pop_Fields = {
  channel_id?: Maybe<Scalars['Float']['output']>;
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "firstup.content_in_channels" */
export type Firstup_Content_In_Channels_Var_Pop_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  content_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Firstup_Content_In_Channels_Var_Samp_Fields = {
  channel_id?: Maybe<Scalars['Float']['output']>;
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "firstup.content_in_channels" */
export type Firstup_Content_In_Channels_Var_Samp_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  content_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Firstup_Content_In_Channels_Variance_Fields = {
  channel_id?: Maybe<Scalars['Float']['output']>;
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "firstup.content_in_channels" */
export type Firstup_Content_In_Channels_Variance_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  content_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Firstup_Content_Max_Fields = {
  accent_color?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  comment_count?: Maybe<Scalars['Int']['output']>;
  content_type?: Maybe<Scalars['String']['output']>;
  cover_image_alt?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  featured_label?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Scalars['String']['output']>>;
  permalink_url?: Maybe<Scalars['String']['output']>;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  shareable_url?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Firstup_Content_Min_Fields = {
  accent_color?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  comment_count?: Maybe<Scalars['Int']['output']>;
  content_type?: Maybe<Scalars['String']['output']>;
  cover_image_alt?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  featured_label?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Scalars['String']['output']>>;
  permalink_url?: Maybe<Scalars['String']['output']>;
  published_at?: Maybe<Scalars['timestamptz']['output']>;
  shareable_url?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "firstup.content". */
export type Firstup_Content_Order_By = {
  accent_color?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  comment_count?: InputMaybe<Order_By>;
  content_in_channels_aggregate?: InputMaybe<Firstup_Content_In_Channels_Aggregate_Order_By>;
  content_type?: InputMaybe<Order_By>;
  cover_image_alt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  featured?: InputMaybe<Order_By>;
  featured_label?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_in_contents_aggregate?: InputMaybe<Firstup_Images_In_Content_Aggregate_Order_By>;
  is_commentable?: InputMaybe<Order_By>;
  is_translatable?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  links?: InputMaybe<Order_By>;
  people_in_contents_aggregate?: InputMaybe<Firstup_People_In_Content_Aggregate_Order_By>;
  permalink_url?: InputMaybe<Order_By>;
  published_at?: InputMaybe<Order_By>;
  shareable_url?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  summary?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  videos_in_contents_aggregate?: InputMaybe<Firstup_Videos_In_Content_Aggregate_Order_By>;
  visibility?: InputMaybe<Order_By>;
};

/** select columns of table "firstup.content" */
export enum Firstup_Content_Select_Column {
  /** column name */
  Accent_color = 'accent_color',
  /** column name */
  Body = 'body',
  /** column name */
  Comment_count = 'comment_count',
  /** column name */
  Content_type = 'content_type',
  /** column name */
  Cover_image_alt = 'cover_image_alt',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Featured = 'featured',
  /** column name */
  Featured_label = 'featured_label',
  /** column name */
  Id = 'id',
  /** column name */
  Is_commentable = 'is_commentable',
  /** column name */
  Is_translatable = 'is_translatable',
  /** column name */
  Language = 'language',
  /** column name */
  Links = 'links',
  /** column name */
  Permalink_url = 'permalink_url',
  /** column name */
  Published_at = 'published_at',
  /** column name */
  Shareable_url = 'shareable_url',
  /** column name */
  State = 'state',
  /** column name */
  Summary = 'summary',
  /** column name */
  Title = 'title',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Visibility = 'visibility',
}

/** aggregate stddev on columns */
export type Firstup_Content_Stddev_Fields = {
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Firstup_Content_Stddev_Pop_Fields = {
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Firstup_Content_Stddev_Samp_Fields = {
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "firstup_content" */
export type Firstup_Content_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Firstup_Content_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Firstup_Content_Stream_Cursor_Value_Input = {
  accent_color?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  comment_count?: InputMaybe<Scalars['Int']['input']>;
  content_type?: InputMaybe<Scalars['String']['input']>;
  cover_image_alt?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  featured_label?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_commentable?: InputMaybe<Scalars['Boolean']['input']>;
  is_translatable?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<Scalars['String']['input']>>;
  permalink_url?: InputMaybe<Scalars['String']['input']>;
  published_at?: InputMaybe<Scalars['timestamptz']['input']>;
  shareable_url?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Firstup_Content_Sum_Fields = {
  comment_count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Firstup_Content_Var_Pop_Fields = {
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Firstup_Content_Var_Samp_Fields = {
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Firstup_Content_Variance_Fields = {
  comment_count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** images that are used in a content  */
export type Firstup_Images = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image_url: Scalars['String']['output'];
  /** An array relationship */
  images_in_contents: Array<Firstup_Images_In_Content>;
  /** An aggregate relationship */
  images_in_contents_aggregate: Firstup_Images_In_Content_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** images that are used in a content  */
export type Firstup_ImagesImages_In_ContentsArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Images_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Images_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_Images_In_Content_Bool_Exp>;
};

/** images that are used in a content  */
export type Firstup_ImagesImages_In_Contents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Images_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Images_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_Images_In_Content_Bool_Exp>;
};

/** aggregated selection of "firstup.images" */
export type Firstup_Images_Aggregate = {
  aggregate?: Maybe<Firstup_Images_Aggregate_Fields>;
  nodes: Array<Firstup_Images>;
};

/** aggregate fields of "firstup.images" */
export type Firstup_Images_Aggregate_Fields = {
  avg?: Maybe<Firstup_Images_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Firstup_Images_Max_Fields>;
  min?: Maybe<Firstup_Images_Min_Fields>;
  stddev?: Maybe<Firstup_Images_Stddev_Fields>;
  stddev_pop?: Maybe<Firstup_Images_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Firstup_Images_Stddev_Samp_Fields>;
  sum?: Maybe<Firstup_Images_Sum_Fields>;
  var_pop?: Maybe<Firstup_Images_Var_Pop_Fields>;
  var_samp?: Maybe<Firstup_Images_Var_Samp_Fields>;
  variance?: Maybe<Firstup_Images_Variance_Fields>;
};

/** aggregate fields of "firstup.images" */
export type Firstup_Images_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Firstup_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Firstup_Images_Avg_Fields = {
  height?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "firstup.images". All fields are combined with a logical 'AND'. */
export type Firstup_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Firstup_Images_Bool_Exp>>;
  _not?: InputMaybe<Firstup_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Firstup_Images_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  height?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  images_in_contents?: InputMaybe<Firstup_Images_In_Content_Bool_Exp>;
  images_in_contents_aggregate?: InputMaybe<Firstup_Images_In_Content_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  width?: InputMaybe<Int_Comparison_Exp>;
};

/** a joint object that the link images to a content */
export type Firstup_Images_In_Content = {
  /** An object relationship */
  content: Firstup_Content;
  content_id: Scalars['Int']['output'];
  /** An object relationship */
  image: Firstup_Images;
  image_url: Scalars['String']['output'];
};

/** aggregated selection of "firstup.images_in_content" */
export type Firstup_Images_In_Content_Aggregate = {
  aggregate?: Maybe<Firstup_Images_In_Content_Aggregate_Fields>;
  nodes: Array<Firstup_Images_In_Content>;
};

export type Firstup_Images_In_Content_Aggregate_Bool_Exp = {
  count?: InputMaybe<Firstup_Images_In_Content_Aggregate_Bool_Exp_Count>;
};

export type Firstup_Images_In_Content_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Firstup_Images_In_Content_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Firstup_Images_In_Content_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "firstup.images_in_content" */
export type Firstup_Images_In_Content_Aggregate_Fields = {
  avg?: Maybe<Firstup_Images_In_Content_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Firstup_Images_In_Content_Max_Fields>;
  min?: Maybe<Firstup_Images_In_Content_Min_Fields>;
  stddev?: Maybe<Firstup_Images_In_Content_Stddev_Fields>;
  stddev_pop?: Maybe<Firstup_Images_In_Content_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Firstup_Images_In_Content_Stddev_Samp_Fields>;
  sum?: Maybe<Firstup_Images_In_Content_Sum_Fields>;
  var_pop?: Maybe<Firstup_Images_In_Content_Var_Pop_Fields>;
  var_samp?: Maybe<Firstup_Images_In_Content_Var_Samp_Fields>;
  variance?: Maybe<Firstup_Images_In_Content_Variance_Fields>;
};

/** aggregate fields of "firstup.images_in_content" */
export type Firstup_Images_In_Content_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Firstup_Images_In_Content_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "firstup.images_in_content" */
export type Firstup_Images_In_Content_Aggregate_Order_By = {
  avg?: InputMaybe<Firstup_Images_In_Content_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Firstup_Images_In_Content_Max_Order_By>;
  min?: InputMaybe<Firstup_Images_In_Content_Min_Order_By>;
  stddev?: InputMaybe<Firstup_Images_In_Content_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Firstup_Images_In_Content_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Firstup_Images_In_Content_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Firstup_Images_In_Content_Sum_Order_By>;
  var_pop?: InputMaybe<Firstup_Images_In_Content_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Firstup_Images_In_Content_Var_Samp_Order_By>;
  variance?: InputMaybe<Firstup_Images_In_Content_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Firstup_Images_In_Content_Avg_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "firstup.images_in_content" */
export type Firstup_Images_In_Content_Avg_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "firstup.images_in_content". All fields are combined with a logical 'AND'. */
export type Firstup_Images_In_Content_Bool_Exp = {
  _and?: InputMaybe<Array<Firstup_Images_In_Content_Bool_Exp>>;
  _not?: InputMaybe<Firstup_Images_In_Content_Bool_Exp>;
  _or?: InputMaybe<Array<Firstup_Images_In_Content_Bool_Exp>>;
  content?: InputMaybe<Firstup_Content_Bool_Exp>;
  content_id?: InputMaybe<Int_Comparison_Exp>;
  image?: InputMaybe<Firstup_Images_Bool_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Firstup_Images_In_Content_Max_Fields = {
  content_id?: Maybe<Scalars['Int']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "firstup.images_in_content" */
export type Firstup_Images_In_Content_Max_Order_By = {
  content_id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Firstup_Images_In_Content_Min_Fields = {
  content_id?: Maybe<Scalars['Int']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "firstup.images_in_content" */
export type Firstup_Images_In_Content_Min_Order_By = {
  content_id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "firstup.images_in_content". */
export type Firstup_Images_In_Content_Order_By = {
  content?: InputMaybe<Firstup_Content_Order_By>;
  content_id?: InputMaybe<Order_By>;
  image?: InputMaybe<Firstup_Images_Order_By>;
  image_url?: InputMaybe<Order_By>;
};

/** select columns of table "firstup.images_in_content" */
export enum Firstup_Images_In_Content_Select_Column {
  /** column name */
  Content_id = 'content_id',
  /** column name */
  Image_url = 'image_url',
}

/** aggregate stddev on columns */
export type Firstup_Images_In_Content_Stddev_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "firstup.images_in_content" */
export type Firstup_Images_In_Content_Stddev_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Firstup_Images_In_Content_Stddev_Pop_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "firstup.images_in_content" */
export type Firstup_Images_In_Content_Stddev_Pop_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Firstup_Images_In_Content_Stddev_Samp_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "firstup.images_in_content" */
export type Firstup_Images_In_Content_Stddev_Samp_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "firstup_images_in_content" */
export type Firstup_Images_In_Content_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Firstup_Images_In_Content_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Firstup_Images_In_Content_Stream_Cursor_Value_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Firstup_Images_In_Content_Sum_Fields = {
  content_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "firstup.images_in_content" */
export type Firstup_Images_In_Content_Sum_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Firstup_Images_In_Content_Var_Pop_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "firstup.images_in_content" */
export type Firstup_Images_In_Content_Var_Pop_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Firstup_Images_In_Content_Var_Samp_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "firstup.images_in_content" */
export type Firstup_Images_In_Content_Var_Samp_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Firstup_Images_In_Content_Variance_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "firstup.images_in_content" */
export type Firstup_Images_In_Content_Variance_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Firstup_Images_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Firstup_Images_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "firstup.images". */
export type Firstup_Images_Order_By = {
  created_at?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  images_in_contents_aggregate?: InputMaybe<Firstup_Images_In_Content_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** select columns of table "firstup.images" */
export enum Firstup_Images_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Height = 'height',
  /** column name */
  Id = 'id',
  /** column name */
  Image_url = 'image_url',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Width = 'width',
}

/** aggregate stddev on columns */
export type Firstup_Images_Stddev_Fields = {
  height?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Firstup_Images_Stddev_Pop_Fields = {
  height?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Firstup_Images_Stddev_Samp_Fields = {
  height?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "firstup_images" */
export type Firstup_Images_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Firstup_Images_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Firstup_Images_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Firstup_Images_Sum_Fields = {
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Firstup_Images_Var_Pop_Fields = {
  height?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Firstup_Images_Var_Samp_Fields = {
  height?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Firstup_Images_Variance_Fields = {
  height?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

/** joint object that link people in content  */
export type Firstup_People_In_Content = {
  /** An object relationship */
  content: Firstup_Content;
  content_id: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  people_in_content_Personnel?: Maybe<Mlfsl_Personnel>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_email: Scalars['String']['output'];
};

/** aggregated selection of "firstup.people_in_content" */
export type Firstup_People_In_Content_Aggregate = {
  aggregate?: Maybe<Firstup_People_In_Content_Aggregate_Fields>;
  nodes: Array<Firstup_People_In_Content>;
};

export type Firstup_People_In_Content_Aggregate_Bool_Exp = {
  count?: InputMaybe<Firstup_People_In_Content_Aggregate_Bool_Exp_Count>;
};

export type Firstup_People_In_Content_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Firstup_People_In_Content_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Firstup_People_In_Content_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "firstup.people_in_content" */
export type Firstup_People_In_Content_Aggregate_Fields = {
  avg?: Maybe<Firstup_People_In_Content_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Firstup_People_In_Content_Max_Fields>;
  min?: Maybe<Firstup_People_In_Content_Min_Fields>;
  stddev?: Maybe<Firstup_People_In_Content_Stddev_Fields>;
  stddev_pop?: Maybe<Firstup_People_In_Content_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Firstup_People_In_Content_Stddev_Samp_Fields>;
  sum?: Maybe<Firstup_People_In_Content_Sum_Fields>;
  var_pop?: Maybe<Firstup_People_In_Content_Var_Pop_Fields>;
  var_samp?: Maybe<Firstup_People_In_Content_Var_Samp_Fields>;
  variance?: Maybe<Firstup_People_In_Content_Variance_Fields>;
};

/** aggregate fields of "firstup.people_in_content" */
export type Firstup_People_In_Content_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Firstup_People_In_Content_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "firstup.people_in_content" */
export type Firstup_People_In_Content_Aggregate_Order_By = {
  avg?: InputMaybe<Firstup_People_In_Content_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Firstup_People_In_Content_Max_Order_By>;
  min?: InputMaybe<Firstup_People_In_Content_Min_Order_By>;
  stddev?: InputMaybe<Firstup_People_In_Content_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Firstup_People_In_Content_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Firstup_People_In_Content_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Firstup_People_In_Content_Sum_Order_By>;
  var_pop?: InputMaybe<Firstup_People_In_Content_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Firstup_People_In_Content_Var_Samp_Order_By>;
  variance?: InputMaybe<Firstup_People_In_Content_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Firstup_People_In_Content_Avg_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "firstup.people_in_content" */
export type Firstup_People_In_Content_Avg_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "firstup.people_in_content". All fields are combined with a logical 'AND'. */
export type Firstup_People_In_Content_Bool_Exp = {
  _and?: InputMaybe<Array<Firstup_People_In_Content_Bool_Exp>>;
  _not?: InputMaybe<Firstup_People_In_Content_Bool_Exp>;
  _or?: InputMaybe<Array<Firstup_People_In_Content_Bool_Exp>>;
  content?: InputMaybe<Firstup_Content_Bool_Exp>;
  content_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_email?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Firstup_People_In_Content_Max_Fields = {
  content_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "firstup.people_in_content" */
export type Firstup_People_In_Content_Max_Order_By = {
  content_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_email?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Firstup_People_In_Content_Min_Fields = {
  content_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "firstup.people_in_content" */
export type Firstup_People_In_Content_Min_Order_By = {
  content_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_email?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "firstup.people_in_content". */
export type Firstup_People_In_Content_Order_By = {
  content?: InputMaybe<Firstup_Content_Order_By>;
  content_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_email?: InputMaybe<Order_By>;
};

/** select columns of table "firstup.people_in_content" */
export enum Firstup_People_In_Content_Select_Column {
  /** column name */
  Content_id = 'content_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  User_email = 'user_email',
}

/** aggregate stddev on columns */
export type Firstup_People_In_Content_Stddev_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "firstup.people_in_content" */
export type Firstup_People_In_Content_Stddev_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Firstup_People_In_Content_Stddev_Pop_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "firstup.people_in_content" */
export type Firstup_People_In_Content_Stddev_Pop_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Firstup_People_In_Content_Stddev_Samp_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "firstup.people_in_content" */
export type Firstup_People_In_Content_Stddev_Samp_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "firstup_people_in_content" */
export type Firstup_People_In_Content_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Firstup_People_In_Content_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Firstup_People_In_Content_Stream_Cursor_Value_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Firstup_People_In_Content_Sum_Fields = {
  content_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "firstup.people_in_content" */
export type Firstup_People_In_Content_Sum_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Firstup_People_In_Content_Var_Pop_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "firstup.people_in_content" */
export type Firstup_People_In_Content_Var_Pop_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Firstup_People_In_Content_Var_Samp_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "firstup.people_in_content" */
export type Firstup_People_In_Content_Var_Samp_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Firstup_People_In_Content_Variance_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "firstup.people_in_content" */
export type Firstup_People_In_Content_Variance_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** list of videos that are used in contents */
export type Firstup_Videos = {
  caption?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  embed_html?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  link_url: Scalars['String']['output'];
  preview_image_url?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uuid: Scalars['uuid']['output'];
  /** An array relationship */
  videos_in_contents: Array<Firstup_Videos_In_Content>;
  /** An aggregate relationship */
  videos_in_contents_aggregate: Firstup_Videos_In_Content_Aggregate;
};

/** list of videos that are used in contents */
export type Firstup_VideosVideos_In_ContentsArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Videos_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Videos_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_Videos_In_Content_Bool_Exp>;
};

/** list of videos that are used in contents */
export type Firstup_VideosVideos_In_Contents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Videos_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Videos_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_Videos_In_Content_Bool_Exp>;
};

/** aggregated selection of "firstup.videos" */
export type Firstup_Videos_Aggregate = {
  aggregate?: Maybe<Firstup_Videos_Aggregate_Fields>;
  nodes: Array<Firstup_Videos>;
};

/** aggregate fields of "firstup.videos" */
export type Firstup_Videos_Aggregate_Fields = {
  avg?: Maybe<Firstup_Videos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Firstup_Videos_Max_Fields>;
  min?: Maybe<Firstup_Videos_Min_Fields>;
  stddev?: Maybe<Firstup_Videos_Stddev_Fields>;
  stddev_pop?: Maybe<Firstup_Videos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Firstup_Videos_Stddev_Samp_Fields>;
  sum?: Maybe<Firstup_Videos_Sum_Fields>;
  var_pop?: Maybe<Firstup_Videos_Var_Pop_Fields>;
  var_samp?: Maybe<Firstup_Videos_Var_Samp_Fields>;
  variance?: Maybe<Firstup_Videos_Variance_Fields>;
};

/** aggregate fields of "firstup.videos" */
export type Firstup_Videos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Firstup_Videos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Firstup_Videos_Avg_Fields = {
  duration?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "firstup.videos". All fields are combined with a logical 'AND'. */
export type Firstup_Videos_Bool_Exp = {
  _and?: InputMaybe<Array<Firstup_Videos_Bool_Exp>>;
  _not?: InputMaybe<Firstup_Videos_Bool_Exp>;
  _or?: InputMaybe<Array<Firstup_Videos_Bool_Exp>>;
  caption?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  duration?: InputMaybe<Int_Comparison_Exp>;
  embed_html?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  link_url?: InputMaybe<String_Comparison_Exp>;
  preview_image_url?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  videos_in_contents?: InputMaybe<Firstup_Videos_In_Content_Bool_Exp>;
  videos_in_contents_aggregate?: InputMaybe<Firstup_Videos_In_Content_Aggregate_Bool_Exp>;
};

/** join object that link a video to a content */
export type Firstup_Videos_In_Content = {
  /** An object relationship */
  content: Firstup_Content;
  content_id: Scalars['Int']['output'];
  /** An object relationship */
  video: Firstup_Videos;
  video_url: Scalars['String']['output'];
};

/** aggregated selection of "firstup.videos_in_content" */
export type Firstup_Videos_In_Content_Aggregate = {
  aggregate?: Maybe<Firstup_Videos_In_Content_Aggregate_Fields>;
  nodes: Array<Firstup_Videos_In_Content>;
};

export type Firstup_Videos_In_Content_Aggregate_Bool_Exp = {
  count?: InputMaybe<Firstup_Videos_In_Content_Aggregate_Bool_Exp_Count>;
};

export type Firstup_Videos_In_Content_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Firstup_Videos_In_Content_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Firstup_Videos_In_Content_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "firstup.videos_in_content" */
export type Firstup_Videos_In_Content_Aggregate_Fields = {
  avg?: Maybe<Firstup_Videos_In_Content_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Firstup_Videos_In_Content_Max_Fields>;
  min?: Maybe<Firstup_Videos_In_Content_Min_Fields>;
  stddev?: Maybe<Firstup_Videos_In_Content_Stddev_Fields>;
  stddev_pop?: Maybe<Firstup_Videos_In_Content_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Firstup_Videos_In_Content_Stddev_Samp_Fields>;
  sum?: Maybe<Firstup_Videos_In_Content_Sum_Fields>;
  var_pop?: Maybe<Firstup_Videos_In_Content_Var_Pop_Fields>;
  var_samp?: Maybe<Firstup_Videos_In_Content_Var_Samp_Fields>;
  variance?: Maybe<Firstup_Videos_In_Content_Variance_Fields>;
};

/** aggregate fields of "firstup.videos_in_content" */
export type Firstup_Videos_In_Content_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Firstup_Videos_In_Content_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "firstup.videos_in_content" */
export type Firstup_Videos_In_Content_Aggregate_Order_By = {
  avg?: InputMaybe<Firstup_Videos_In_Content_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Firstup_Videos_In_Content_Max_Order_By>;
  min?: InputMaybe<Firstup_Videos_In_Content_Min_Order_By>;
  stddev?: InputMaybe<Firstup_Videos_In_Content_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Firstup_Videos_In_Content_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Firstup_Videos_In_Content_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Firstup_Videos_In_Content_Sum_Order_By>;
  var_pop?: InputMaybe<Firstup_Videos_In_Content_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Firstup_Videos_In_Content_Var_Samp_Order_By>;
  variance?: InputMaybe<Firstup_Videos_In_Content_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Firstup_Videos_In_Content_Avg_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "firstup.videos_in_content" */
export type Firstup_Videos_In_Content_Avg_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "firstup.videos_in_content". All fields are combined with a logical 'AND'. */
export type Firstup_Videos_In_Content_Bool_Exp = {
  _and?: InputMaybe<Array<Firstup_Videos_In_Content_Bool_Exp>>;
  _not?: InputMaybe<Firstup_Videos_In_Content_Bool_Exp>;
  _or?: InputMaybe<Array<Firstup_Videos_In_Content_Bool_Exp>>;
  content?: InputMaybe<Firstup_Content_Bool_Exp>;
  content_id?: InputMaybe<Int_Comparison_Exp>;
  video?: InputMaybe<Firstup_Videos_Bool_Exp>;
  video_url?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Firstup_Videos_In_Content_Max_Fields = {
  content_id?: Maybe<Scalars['Int']['output']>;
  video_url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "firstup.videos_in_content" */
export type Firstup_Videos_In_Content_Max_Order_By = {
  content_id?: InputMaybe<Order_By>;
  video_url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Firstup_Videos_In_Content_Min_Fields = {
  content_id?: Maybe<Scalars['Int']['output']>;
  video_url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "firstup.videos_in_content" */
export type Firstup_Videos_In_Content_Min_Order_By = {
  content_id?: InputMaybe<Order_By>;
  video_url?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "firstup.videos_in_content". */
export type Firstup_Videos_In_Content_Order_By = {
  content?: InputMaybe<Firstup_Content_Order_By>;
  content_id?: InputMaybe<Order_By>;
  video?: InputMaybe<Firstup_Videos_Order_By>;
  video_url?: InputMaybe<Order_By>;
};

/** select columns of table "firstup.videos_in_content" */
export enum Firstup_Videos_In_Content_Select_Column {
  /** column name */
  Content_id = 'content_id',
  /** column name */
  Video_url = 'video_url',
}

/** aggregate stddev on columns */
export type Firstup_Videos_In_Content_Stddev_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "firstup.videos_in_content" */
export type Firstup_Videos_In_Content_Stddev_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Firstup_Videos_In_Content_Stddev_Pop_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "firstup.videos_in_content" */
export type Firstup_Videos_In_Content_Stddev_Pop_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Firstup_Videos_In_Content_Stddev_Samp_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "firstup.videos_in_content" */
export type Firstup_Videos_In_Content_Stddev_Samp_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "firstup_videos_in_content" */
export type Firstup_Videos_In_Content_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Firstup_Videos_In_Content_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Firstup_Videos_In_Content_Stream_Cursor_Value_Input = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  video_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Firstup_Videos_In_Content_Sum_Fields = {
  content_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "firstup.videos_in_content" */
export type Firstup_Videos_In_Content_Sum_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Firstup_Videos_In_Content_Var_Pop_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "firstup.videos_in_content" */
export type Firstup_Videos_In_Content_Var_Pop_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Firstup_Videos_In_Content_Var_Samp_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "firstup.videos_in_content" */
export type Firstup_Videos_In_Content_Var_Samp_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Firstup_Videos_In_Content_Variance_Fields = {
  content_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "firstup.videos_in_content" */
export type Firstup_Videos_In_Content_Variance_Order_By = {
  content_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Firstup_Videos_Max_Fields = {
  caption?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  embed_html?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  link_url?: Maybe<Scalars['String']['output']>;
  preview_image_url?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Firstup_Videos_Min_Fields = {
  caption?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  embed_html?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  link_url?: Maybe<Scalars['String']['output']>;
  preview_image_url?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "firstup.videos". */
export type Firstup_Videos_Order_By = {
  caption?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  embed_html?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link_url?: InputMaybe<Order_By>;
  preview_image_url?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  videos_in_contents_aggregate?: InputMaybe<Firstup_Videos_In_Content_Aggregate_Order_By>;
};

/** select columns of table "firstup.videos" */
export enum Firstup_Videos_Select_Column {
  /** column name */
  Caption = 'caption',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  Embed_html = 'embed_html',
  /** column name */
  Id = 'id',
  /** column name */
  Link_url = 'link_url',
  /** column name */
  Preview_image_url = 'preview_image_url',
  /** column name */
  State = 'state',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Uuid = 'uuid',
}

/** aggregate stddev on columns */
export type Firstup_Videos_Stddev_Fields = {
  duration?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Firstup_Videos_Stddev_Pop_Fields = {
  duration?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Firstup_Videos_Stddev_Samp_Fields = {
  duration?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "firstup_videos" */
export type Firstup_Videos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Firstup_Videos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Firstup_Videos_Stream_Cursor_Value_Input = {
  caption?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  embed_html?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  link_url?: InputMaybe<Scalars['String']['input']>;
  preview_image_url?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Firstup_Videos_Sum_Fields = {
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Firstup_Videos_Var_Pop_Fields = {
  duration?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Firstup_Videos_Var_Samp_Fields = {
  duration?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Firstup_Videos_Variance_Fields = {
  duration?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** Main transfer request record created when a user leaves the firm and data transfer work is requested. Tracks the request origin, destination, received date, and overall status. */
export type Ftp_Request = {
  client_number?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  date_received: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  mlfsl_client?: Maybe<Mlfsl_Client>;
  other?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  request_details: Array<Ftp_Request_Detail>;
  /** An array relationship */
  request_external_accesses: Array<Ftp_Request_External_Access>;
  /** An array relationship */
  request_external_notes: Array<Ftp_Request_External_Note>;
  request_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  request_internal_notes: Array<Ftp_Request_Internal_Note>;
  /** An array relationship */
  request_participants: Array<Ftp_Request_Participant>;
  status: Scalars['String']['output'];
  transfer_reason?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** Main transfer request record created when a user leaves the firm and data transfer work is requested. Tracks the request origin, destination, received date, and overall status. */
export type Ftp_RequestRequest_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_Detail_Order_By>>;
  where?: InputMaybe<Ftp_Request_Detail_Bool_Exp>;
};

/** Main transfer request record created when a user leaves the firm and data transfer work is requested. Tracks the request origin, destination, received date, and overall status. */
export type Ftp_RequestRequest_External_AccessesArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_External_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_External_Access_Order_By>>;
  where?: InputMaybe<Ftp_Request_External_Access_Bool_Exp>;
};

/** Main transfer request record created when a user leaves the firm and data transfer work is requested. Tracks the request origin, destination, received date, and overall status. */
export type Ftp_RequestRequest_External_NotesArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_External_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_External_Note_Order_By>>;
  where?: InputMaybe<Ftp_Request_External_Note_Bool_Exp>;
};

/** Main transfer request record created when a user leaves the firm and data transfer work is requested. Tracks the request origin, destination, received date, and overall status. */
export type Ftp_RequestRequest_Internal_NotesArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_Internal_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_Internal_Note_Order_By>>;
  where?: InputMaybe<Ftp_Request_Internal_Note_Bool_Exp>;
};

/** Main transfer request record created when a user leaves the firm and data transfer work is requested. Tracks the request origin, destination, received date, and overall status. */
export type Ftp_RequestRequest_ParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_Participant_Order_By>>;
  where?: InputMaybe<Ftp_Request_Participant_Bool_Exp>;
};

/** aggregated selection of "ftp.request" */
export type Ftp_Request_Aggregate = {
  aggregate?: Maybe<Ftp_Request_Aggregate_Fields>;
  nodes: Array<Ftp_Request>;
};

/** aggregate fields of "ftp.request" */
export type Ftp_Request_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Ftp_Request_Max_Fields>;
  min?: Maybe<Ftp_Request_Min_Fields>;
};

/** aggregate fields of "ftp.request" */
export type Ftp_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ftp_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "ftp.request". All fields are combined with a logical 'AND'. */
export type Ftp_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Ftp_Request_Bool_Exp>>;
  _not?: InputMaybe<Ftp_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Ftp_Request_Bool_Exp>>;
  client_number?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  date_received?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  other?: InputMaybe<String_Comparison_Exp>;
  request_details?: InputMaybe<Ftp_Request_Detail_Bool_Exp>;
  request_external_accesses?: InputMaybe<Ftp_Request_External_Access_Bool_Exp>;
  request_external_notes?: InputMaybe<Ftp_Request_External_Note_Bool_Exp>;
  request_id?: InputMaybe<String_Comparison_Exp>;
  request_internal_notes?: InputMaybe<Ftp_Request_Internal_Note_Bool_Exp>;
  request_participants?: InputMaybe<Ftp_Request_Participant_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  transfer_reason?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ftp.request" */
export enum Ftp_Request_Constraint {
  /** unique or primary key constraint on columns "id" */
  Request_pkey = 'request_pkey',
  /** unique or primary key constraint on columns "request_id" */
  Request_request_id_key = 'request_request_id_key',
}

/** Matter-level transfer work items under a request source. Tracks the specific matter or other types, transfer content, priority, workflow status, delays, review/cull activity, sending method, and completion dates. */
export type Ftp_Request_Detail = {
  block_reason?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  delivery_method?: Maybe<Scalars['String']['output']>;
  downloaded_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  is_blocked: Scalars['Boolean']['output'];
  is_priority: Scalars['Boolean']['output'];
  matter_number?: Maybe<Scalars['String']['output']>;
  mlfsl_matter?: Maybe<Mlfsl_Matter>;
  other?: Maybe<Scalars['String']['output']>;
  other_content?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  request: Ftp_Request;
  request_id: Scalars['uuid']['output'];
  review_completed_at?: Maybe<Scalars['timestamptz']['output']>;
  review_notes?: Maybe<Scalars['String']['output']>;
  sent_at?: Maybe<Scalars['timestamptz']['output']>;
  started_at?: Maybe<Scalars['timestamptz']['output']>;
  status: Scalars['String']['output'];
  transfer_reason?: Maybe<Scalars['String']['output']>;
  transferred_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** order by aggregate values of table "ftp.request_detail" */
export type Ftp_Request_Detail_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ftp_Request_Detail_Max_Order_By>;
  min?: InputMaybe<Ftp_Request_Detail_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ftp.request_detail" */
export type Ftp_Request_Detail_Arr_Rel_Insert_Input = {
  data: Array<Ftp_Request_Detail_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ftp_Request_Detail_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ftp.request_detail". All fields are combined with a logical 'AND'. */
export type Ftp_Request_Detail_Bool_Exp = {
  _and?: InputMaybe<Array<Ftp_Request_Detail_Bool_Exp>>;
  _not?: InputMaybe<Ftp_Request_Detail_Bool_Exp>;
  _or?: InputMaybe<Array<Ftp_Request_Detail_Bool_Exp>>;
  block_reason?: InputMaybe<String_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  delivery_method?: InputMaybe<String_Comparison_Exp>;
  downloaded_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_blocked?: InputMaybe<Boolean_Comparison_Exp>;
  is_priority?: InputMaybe<Boolean_Comparison_Exp>;
  matter_number?: InputMaybe<String_Comparison_Exp>;
  other?: InputMaybe<String_Comparison_Exp>;
  other_content?: InputMaybe<String_Comparison_Exp>;
  request?: InputMaybe<Ftp_Request_Bool_Exp>;
  request_id?: InputMaybe<Uuid_Comparison_Exp>;
  review_completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  review_notes?: InputMaybe<String_Comparison_Exp>;
  sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  started_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  transfer_reason?: InputMaybe<String_Comparison_Exp>;
  transferred_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ftp.request_detail" */
export enum Ftp_Request_Detail_Constraint {
  /** unique or primary key constraint on columns "id" */
  Request_detail_pkey = 'request_detail_pkey',
}

/** input type for inserting data into table "ftp.request_detail" */
export type Ftp_Request_Detail_Insert_Input = {
  block_reason?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delivery_method?: InputMaybe<Scalars['String']['input']>;
  downloaded_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_blocked?: InputMaybe<Scalars['Boolean']['input']>;
  is_priority?: InputMaybe<Scalars['Boolean']['input']>;
  matter_number?: InputMaybe<Scalars['String']['input']>;
  other?: InputMaybe<Scalars['String']['input']>;
  other_content?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<Ftp_Request_Obj_Rel_Insert_Input>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  review_completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  review_notes?: InputMaybe<Scalars['String']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  transfer_reason?: InputMaybe<Scalars['String']['input']>;
  transferred_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "ftp.request_detail" */
export type Ftp_Request_Detail_Max_Order_By = {
  block_reason?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  delivery_method?: InputMaybe<Order_By>;
  downloaded_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  matter_number?: InputMaybe<Order_By>;
  other?: InputMaybe<Order_By>;
  other_content?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  review_completed_at?: InputMaybe<Order_By>;
  review_notes?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  transfer_reason?: InputMaybe<Order_By>;
  transferred_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ftp.request_detail" */
export type Ftp_Request_Detail_Min_Order_By = {
  block_reason?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  delivery_method?: InputMaybe<Order_By>;
  downloaded_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  matter_number?: InputMaybe<Order_By>;
  other?: InputMaybe<Order_By>;
  other_content?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  review_completed_at?: InputMaybe<Order_By>;
  review_notes?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  transfer_reason?: InputMaybe<Order_By>;
  transferred_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ftp.request_detail" */
export type Ftp_Request_Detail_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ftp_Request_Detail>;
};

/** on_conflict condition type for table "ftp.request_detail" */
export type Ftp_Request_Detail_On_Conflict = {
  constraint: Ftp_Request_Detail_Constraint;
  update_columns?: Array<Ftp_Request_Detail_Update_Column>;
  where?: InputMaybe<Ftp_Request_Detail_Bool_Exp>;
};

/** Ordering options when selecting data from "ftp.request_detail". */
export type Ftp_Request_Detail_Order_By = {
  block_reason?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  delivery_method?: InputMaybe<Order_By>;
  downloaded_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_blocked?: InputMaybe<Order_By>;
  is_priority?: InputMaybe<Order_By>;
  matter_number?: InputMaybe<Order_By>;
  other?: InputMaybe<Order_By>;
  other_content?: InputMaybe<Order_By>;
  request?: InputMaybe<Ftp_Request_Order_By>;
  request_id?: InputMaybe<Order_By>;
  review_completed_at?: InputMaybe<Order_By>;
  review_notes?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  transfer_reason?: InputMaybe<Order_By>;
  transferred_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ftp.request_detail */
export type Ftp_Request_Detail_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ftp.request_detail" */
export enum Ftp_Request_Detail_Select_Column {
  /** column name */
  Block_reason = 'block_reason',
  /** column name */
  Content = 'content',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Delivery_method = 'delivery_method',
  /** column name */
  Downloaded_at = 'downloaded_at',
  /** column name */
  Id = 'id',
  /** column name */
  Is_blocked = 'is_blocked',
  /** column name */
  Is_priority = 'is_priority',
  /** column name */
  Matter_number = 'matter_number',
  /** column name */
  Other = 'other',
  /** column name */
  Other_content = 'other_content',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Review_completed_at = 'review_completed_at',
  /** column name */
  Review_notes = 'review_notes',
  /** column name */
  Sent_at = 'sent_at',
  /** column name */
  Started_at = 'started_at',
  /** column name */
  Status = 'status',
  /** column name */
  Transfer_reason = 'transfer_reason',
  /** column name */
  Transferred_at = 'transferred_at',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "ftp.request_detail" */
export type Ftp_Request_Detail_Set_Input = {
  block_reason?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  delivery_method?: InputMaybe<Scalars['String']['input']>;
  downloaded_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_blocked?: InputMaybe<Scalars['Boolean']['input']>;
  is_priority?: InputMaybe<Scalars['Boolean']['input']>;
  matter_number?: InputMaybe<Scalars['String']['input']>;
  other?: InputMaybe<Scalars['String']['input']>;
  other_content?: InputMaybe<Scalars['String']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  review_completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  review_notes?: InputMaybe<Scalars['String']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  transfer_reason?: InputMaybe<Scalars['String']['input']>;
  transferred_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "ftp_request_detail" */
export type Ftp_Request_Detail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ftp_Request_Detail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ftp_Request_Detail_Stream_Cursor_Value_Input = {
  block_reason?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  delivery_method?: InputMaybe<Scalars['String']['input']>;
  downloaded_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_blocked?: InputMaybe<Scalars['Boolean']['input']>;
  is_priority?: InputMaybe<Scalars['Boolean']['input']>;
  matter_number?: InputMaybe<Scalars['String']['input']>;
  other?: InputMaybe<Scalars['String']['input']>;
  other_content?: InputMaybe<Scalars['String']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  review_completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  review_notes?: InputMaybe<Scalars['String']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  transfer_reason?: InputMaybe<Scalars['String']['input']>;
  transferred_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "ftp.request_detail" */
export enum Ftp_Request_Detail_Update_Column {
  /** column name */
  Block_reason = 'block_reason',
  /** column name */
  Content = 'content',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Delivery_method = 'delivery_method',
  /** column name */
  Downloaded_at = 'downloaded_at',
  /** column name */
  Id = 'id',
  /** column name */
  Is_blocked = 'is_blocked',
  /** column name */
  Is_priority = 'is_priority',
  /** column name */
  Matter_number = 'matter_number',
  /** column name */
  Other = 'other',
  /** column name */
  Other_content = 'other_content',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Review_completed_at = 'review_completed_at',
  /** column name */
  Review_notes = 'review_notes',
  /** column name */
  Sent_at = 'sent_at',
  /** column name */
  Started_at = 'started_at',
  /** column name */
  Status = 'status',
  /** column name */
  Transfer_reason = 'transfer_reason',
  /** column name */
  Transferred_at = 'transferred_at',
  /** column name */
  Updated_at = 'updated_at',
}

export type Ftp_Request_Detail_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ftp_Request_Detail_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ftp_Request_Detail_Bool_Exp;
};

/** Stores external users who have been invited or granted access to a transfer request. Tracks invitation status, access level, expiration, and audit details. */
export type Ftp_Request_External_Access = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  external_user?: Maybe<MsUser>;
  external_user_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  request: Ftp_Request;
  request_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** order by aggregate values of table "ftp.request_external_access" */
export type Ftp_Request_External_Access_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ftp_Request_External_Access_Max_Order_By>;
  min?: InputMaybe<Ftp_Request_External_Access_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ftp.request_external_access" */
export type Ftp_Request_External_Access_Arr_Rel_Insert_Input = {
  data: Array<Ftp_Request_External_Access_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ftp_Request_External_Access_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ftp.request_external_access". All fields are combined with a logical 'AND'. */
export type Ftp_Request_External_Access_Bool_Exp = {
  _and?: InputMaybe<Array<Ftp_Request_External_Access_Bool_Exp>>;
  _not?: InputMaybe<Ftp_Request_External_Access_Bool_Exp>;
  _or?: InputMaybe<Array<Ftp_Request_External_Access_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  external_user_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  request?: InputMaybe<Ftp_Request_Bool_Exp>;
  request_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ftp.request_external_access" */
export enum Ftp_Request_External_Access_Constraint {
  /** unique or primary key constraint on columns "id" */
  Request_external_access_pkey = 'request_external_access_pkey',
}

/** input type for inserting data into table "ftp.request_external_access" */
export type Ftp_Request_External_Access_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_user_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request?: InputMaybe<Ftp_Request_Obj_Rel_Insert_Input>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "ftp.request_external_access" */
export type Ftp_Request_External_Access_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  external_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ftp.request_external_access" */
export type Ftp_Request_External_Access_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  external_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ftp.request_external_access" */
export type Ftp_Request_External_Access_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ftp_Request_External_Access>;
};

/** on_conflict condition type for table "ftp.request_external_access" */
export type Ftp_Request_External_Access_On_Conflict = {
  constraint: Ftp_Request_External_Access_Constraint;
  update_columns?: Array<Ftp_Request_External_Access_Update_Column>;
  where?: InputMaybe<Ftp_Request_External_Access_Bool_Exp>;
};

/** Ordering options when selecting data from "ftp.request_external_access". */
export type Ftp_Request_External_Access_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  external_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request?: InputMaybe<Ftp_Request_Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ftp.request_external_access */
export type Ftp_Request_External_Access_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ftp.request_external_access" */
export enum Ftp_Request_External_Access_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  External_user_id = 'external_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "ftp.request_external_access" */
export type Ftp_Request_External_Access_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  external_user_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "ftp_request_external_access" */
export type Ftp_Request_External_Access_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ftp_Request_External_Access_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ftp_Request_External_Access_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  external_user_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "ftp.request_external_access" */
export enum Ftp_Request_External_Access_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  External_user_id = 'external_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Updated_at = 'updated_at',
}

export type Ftp_Request_External_Access_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ftp_Request_External_Access_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ftp_Request_External_Access_Bool_Exp;
};

/** Notes created by authorized external users participating in a transfer request. These notes capture comments, questions, or updates submitted by external collaborators. */
export type Ftp_Request_External_Note = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<MsUser>;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  request: Ftp_Request;
  request_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<MsUser>;
};

/** order by aggregate values of table "ftp.request_external_note" */
export type Ftp_Request_External_Note_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ftp_Request_External_Note_Max_Order_By>;
  min?: InputMaybe<Ftp_Request_External_Note_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ftp.request_external_note" */
export type Ftp_Request_External_Note_Arr_Rel_Insert_Input = {
  data: Array<Ftp_Request_External_Note_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ftp_Request_External_Note_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ftp.request_external_note". All fields are combined with a logical 'AND'. */
export type Ftp_Request_External_Note_Bool_Exp = {
  _and?: InputMaybe<Array<Ftp_Request_External_Note_Bool_Exp>>;
  _not?: InputMaybe<Ftp_Request_External_Note_Bool_Exp>;
  _or?: InputMaybe<Array<Ftp_Request_External_Note_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  request?: InputMaybe<Ftp_Request_Bool_Exp>;
  request_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ftp.request_external_note" */
export enum Ftp_Request_External_Note_Constraint {
  /** unique or primary key constraint on columns "id" */
  Request_external_note_pkey = 'request_external_note_pkey',
}

/** input type for inserting data into table "ftp.request_external_note" */
export type Ftp_Request_External_Note_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request?: InputMaybe<Ftp_Request_Obj_Rel_Insert_Input>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "ftp.request_external_note" */
export type Ftp_Request_External_Note_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ftp.request_external_note" */
export type Ftp_Request_External_Note_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ftp.request_external_note" */
export type Ftp_Request_External_Note_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ftp_Request_External_Note>;
};

/** on_conflict condition type for table "ftp.request_external_note" */
export type Ftp_Request_External_Note_On_Conflict = {
  constraint: Ftp_Request_External_Note_Constraint;
  update_columns?: Array<Ftp_Request_External_Note_Update_Column>;
  where?: InputMaybe<Ftp_Request_External_Note_Bool_Exp>;
};

/** Ordering options when selecting data from "ftp.request_external_note". */
export type Ftp_Request_External_Note_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request?: InputMaybe<Ftp_Request_Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ftp.request_external_note */
export type Ftp_Request_External_Note_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ftp.request_external_note" */
export enum Ftp_Request_External_Note_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "ftp.request_external_note" */
export type Ftp_Request_External_Note_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "ftp_request_external_note" */
export type Ftp_Request_External_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ftp_Request_External_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ftp_Request_External_Note_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "ftp.request_external_note" */
export enum Ftp_Request_External_Note_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Updated_at = 'updated_at',
}

export type Ftp_Request_External_Note_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ftp_Request_External_Note_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ftp_Request_External_Note_Bool_Exp;
};

/** input type for inserting data into table "ftp.request" */
export type Ftp_Request_Insert_Input = {
  client_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date_received?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  other?: InputMaybe<Scalars['String']['input']>;
  request_details?: InputMaybe<Ftp_Request_Detail_Arr_Rel_Insert_Input>;
  request_external_accesses?: InputMaybe<Ftp_Request_External_Access_Arr_Rel_Insert_Input>;
  request_external_notes?: InputMaybe<Ftp_Request_External_Note_Arr_Rel_Insert_Input>;
  request_id?: InputMaybe<Scalars['String']['input']>;
  request_internal_notes?: InputMaybe<Ftp_Request_Internal_Note_Arr_Rel_Insert_Input>;
  request_participants?: InputMaybe<Ftp_Request_Participant_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
  transfer_reason?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Notes created by internal users as part of processing a transfer request. These notes are intended for internal collaboration and workflow management. */
export type Ftp_Request_Internal_Note = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  request: Ftp_Request;
  request_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** order by aggregate values of table "ftp.request_internal_note" */
export type Ftp_Request_Internal_Note_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ftp_Request_Internal_Note_Max_Order_By>;
  min?: InputMaybe<Ftp_Request_Internal_Note_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ftp.request_internal_note" */
export type Ftp_Request_Internal_Note_Arr_Rel_Insert_Input = {
  data: Array<Ftp_Request_Internal_Note_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ftp_Request_Internal_Note_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ftp.request_internal_note". All fields are combined with a logical 'AND'. */
export type Ftp_Request_Internal_Note_Bool_Exp = {
  _and?: InputMaybe<Array<Ftp_Request_Internal_Note_Bool_Exp>>;
  _not?: InputMaybe<Ftp_Request_Internal_Note_Bool_Exp>;
  _or?: InputMaybe<Array<Ftp_Request_Internal_Note_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  request?: InputMaybe<Ftp_Request_Bool_Exp>;
  request_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ftp.request_internal_note" */
export enum Ftp_Request_Internal_Note_Constraint {
  /** unique or primary key constraint on columns "id" */
  Request_internal_note_pkey = 'request_internal_note_pkey',
}

/** input type for inserting data into table "ftp.request_internal_note" */
export type Ftp_Request_Internal_Note_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request?: InputMaybe<Ftp_Request_Obj_Rel_Insert_Input>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "ftp.request_internal_note" */
export type Ftp_Request_Internal_Note_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ftp.request_internal_note" */
export type Ftp_Request_Internal_Note_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ftp.request_internal_note" */
export type Ftp_Request_Internal_Note_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ftp_Request_Internal_Note>;
};

/** on_conflict condition type for table "ftp.request_internal_note" */
export type Ftp_Request_Internal_Note_On_Conflict = {
  constraint: Ftp_Request_Internal_Note_Constraint;
  update_columns?: Array<Ftp_Request_Internal_Note_Update_Column>;
  where?: InputMaybe<Ftp_Request_Internal_Note_Bool_Exp>;
};

/** Ordering options when selecting data from "ftp.request_internal_note". */
export type Ftp_Request_Internal_Note_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request?: InputMaybe<Ftp_Request_Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ftp.request_internal_note */
export type Ftp_Request_Internal_Note_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ftp.request_internal_note" */
export enum Ftp_Request_Internal_Note_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "ftp.request_internal_note" */
export type Ftp_Request_Internal_Note_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "ftp_request_internal_note" */
export type Ftp_Request_Internal_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ftp_Request_Internal_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ftp_Request_Internal_Note_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "ftp.request_internal_note" */
export enum Ftp_Request_Internal_Note_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Updated_at = 'updated_at',
}

export type Ftp_Request_Internal_Note_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ftp_Request_Internal_Note_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ftp_Request_Internal_Note_Bool_Exp;
};

/** aggregate max on columns */
export type Ftp_Request_Max_Fields = {
  client_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  date_received?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  other?: Maybe<Scalars['String']['output']>;
  request_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transfer_reason?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Ftp_Request_Min_Fields = {
  client_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  date_received?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  other?: Maybe<Scalars['String']['output']>;
  request_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transfer_reason?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "ftp.request" */
export type Ftp_Request_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ftp_Request>;
};

/** Format: FTP-26-000001 */
export type Ftp_Request_Number_Counter = {
  created_at: Scalars['timestamptz']['output'];
  last_number: Scalars['Int']['output'];
  request_year: Scalars['smallint']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "ftp.request_number_counter". All fields are combined with a logical 'AND'. */
export type Ftp_Request_Number_Counter_Bool_Exp = {
  _and?: InputMaybe<Array<Ftp_Request_Number_Counter_Bool_Exp>>;
  _not?: InputMaybe<Ftp_Request_Number_Counter_Bool_Exp>;
  _or?: InputMaybe<Array<Ftp_Request_Number_Counter_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_number?: InputMaybe<Int_Comparison_Exp>;
  request_year?: InputMaybe<Smallint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ftp.request_number_counter" */
export enum Ftp_Request_Number_Counter_Constraint {
  /** unique or primary key constraint on columns "request_year" */
  Request_number_counter_pkey = 'request_number_counter_pkey',
}

/** input type for incrementing numeric columns in table "ftp.request_number_counter" */
export type Ftp_Request_Number_Counter_Inc_Input = {
  last_number?: InputMaybe<Scalars['Int']['input']>;
  request_year?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "ftp.request_number_counter" */
export type Ftp_Request_Number_Counter_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_number?: InputMaybe<Scalars['Int']['input']>;
  request_year?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "ftp.request_number_counter" */
export type Ftp_Request_Number_Counter_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ftp_Request_Number_Counter>;
};

/** on_conflict condition type for table "ftp.request_number_counter" */
export type Ftp_Request_Number_Counter_On_Conflict = {
  constraint: Ftp_Request_Number_Counter_Constraint;
  update_columns?: Array<Ftp_Request_Number_Counter_Update_Column>;
  where?: InputMaybe<Ftp_Request_Number_Counter_Bool_Exp>;
};

/** Ordering options when selecting data from "ftp.request_number_counter". */
export type Ftp_Request_Number_Counter_Order_By = {
  created_at?: InputMaybe<Order_By>;
  last_number?: InputMaybe<Order_By>;
  request_year?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ftp.request_number_counter */
export type Ftp_Request_Number_Counter_Pk_Columns_Input = {
  request_year: Scalars['smallint']['input'];
};

/** select columns of table "ftp.request_number_counter" */
export enum Ftp_Request_Number_Counter_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Last_number = 'last_number',
  /** column name */
  Request_year = 'request_year',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "ftp.request_number_counter" */
export type Ftp_Request_Number_Counter_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_number?: InputMaybe<Scalars['Int']['input']>;
  request_year?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "ftp_request_number_counter" */
export type Ftp_Request_Number_Counter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ftp_Request_Number_Counter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ftp_Request_Number_Counter_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_number?: InputMaybe<Scalars['Int']['input']>;
  request_year?: InputMaybe<Scalars['smallint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "ftp.request_number_counter" */
export enum Ftp_Request_Number_Counter_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Last_number = 'last_number',
  /** column name */
  Request_year = 'request_year',
  /** column name */
  Updated_at = 'updated_at',
}

export type Ftp_Request_Number_Counter_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ftp_Request_Number_Counter_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ftp_Request_Number_Counter_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ftp_Request_Number_Counter_Bool_Exp;
};

/** input type for inserting object relation for remote table "ftp.request" */
export type Ftp_Request_Obj_Rel_Insert_Input = {
  data: Ftp_Request_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ftp_Request_On_Conflict>;
};

/** on_conflict condition type for table "ftp.request" */
export type Ftp_Request_On_Conflict = {
  constraint: Ftp_Request_Constraint;
  update_columns?: Array<Ftp_Request_Update_Column>;
  where?: InputMaybe<Ftp_Request_Bool_Exp>;
};

/** Ordering options when selecting data from "ftp.request". */
export type Ftp_Request_Order_By = {
  client_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  date_received?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  other?: InputMaybe<Order_By>;
  request_details_aggregate?: InputMaybe<Ftp_Request_Detail_Aggregate_Order_By>;
  request_external_accesses_aggregate?: InputMaybe<Ftp_Request_External_Access_Aggregate_Order_By>;
  request_external_notes_aggregate?: InputMaybe<Ftp_Request_External_Note_Aggregate_Order_By>;
  request_id?: InputMaybe<Order_By>;
  request_internal_notes_aggregate?: InputMaybe<Ftp_Request_Internal_Note_Aggregate_Order_By>;
  request_participants_aggregate?: InputMaybe<Ftp_Request_Participant_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  transfer_reason?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** Stores all people, firms, or organizations involved in a transfer request. Participants may represent the departing user, requesting party, receiving firm, client contact, or another external organization. */
export type Ftp_Request_Participant = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  departed_user?: Maybe<Mlfsl_Personnel>;
  departed_user_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  other?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  request: Ftp_Request;
  request_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** order by aggregate values of table "ftp.request_participant" */
export type Ftp_Request_Participant_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ftp_Request_Participant_Max_Order_By>;
  min?: InputMaybe<Ftp_Request_Participant_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ftp.request_participant" */
export type Ftp_Request_Participant_Arr_Rel_Insert_Input = {
  data: Array<Ftp_Request_Participant_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ftp_Request_Participant_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ftp.request_participant". All fields are combined with a logical 'AND'. */
export type Ftp_Request_Participant_Bool_Exp = {
  _and?: InputMaybe<Array<Ftp_Request_Participant_Bool_Exp>>;
  _not?: InputMaybe<Ftp_Request_Participant_Bool_Exp>;
  _or?: InputMaybe<Array<Ftp_Request_Participant_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  departed_user_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  other?: InputMaybe<String_Comparison_Exp>;
  request?: InputMaybe<Ftp_Request_Bool_Exp>;
  request_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ftp.request_participant" */
export enum Ftp_Request_Participant_Constraint {
  /** unique or primary key constraint on columns "id" */
  Request_participant_pkey = 'request_participant_pkey',
}

/** input type for inserting data into table "ftp.request_participant" */
export type Ftp_Request_Participant_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  departed_user_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  other?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<Ftp_Request_Obj_Rel_Insert_Input>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "ftp.request_participant" */
export type Ftp_Request_Participant_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  departed_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  other?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ftp.request_participant" */
export type Ftp_Request_Participant_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  departed_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  other?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ftp.request_participant" */
export type Ftp_Request_Participant_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ftp_Request_Participant>;
};

/** on_conflict condition type for table "ftp.request_participant" */
export type Ftp_Request_Participant_On_Conflict = {
  constraint: Ftp_Request_Participant_Constraint;
  update_columns?: Array<Ftp_Request_Participant_Update_Column>;
  where?: InputMaybe<Ftp_Request_Participant_Bool_Exp>;
};

/** Ordering options when selecting data from "ftp.request_participant". */
export type Ftp_Request_Participant_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  departed_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  other?: InputMaybe<Order_By>;
  request?: InputMaybe<Ftp_Request_Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ftp.request_participant */
export type Ftp_Request_Participant_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ftp.request_participant" */
export enum Ftp_Request_Participant_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Departed_user_id = 'departed_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Other = 'other',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "ftp.request_participant" */
export type Ftp_Request_Participant_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  departed_user_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  other?: InputMaybe<Scalars['String']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "ftp_request_participant" */
export type Ftp_Request_Participant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ftp_Request_Participant_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ftp_Request_Participant_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  departed_user_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  other?: InputMaybe<Scalars['String']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "ftp.request_participant" */
export enum Ftp_Request_Participant_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Departed_user_id = 'departed_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Other = 'other',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Updated_at = 'updated_at',
}

export type Ftp_Request_Participant_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ftp_Request_Participant_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ftp_Request_Participant_Bool_Exp;
};

/** primary key columns input for table: ftp.request */
export type Ftp_Request_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ftp.request" */
export enum Ftp_Request_Select_Column {
  /** column name */
  Client_number = 'client_number',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Date_received = 'date_received',
  /** column name */
  Id = 'id',
  /** column name */
  Other = 'other',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Status = 'status',
  /** column name */
  Transfer_reason = 'transfer_reason',
  /** column name */
  Type = 'type',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "ftp.request" */
export type Ftp_Request_Set_Input = {
  client_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  date_received?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  other?: InputMaybe<Scalars['String']['input']>;
  request_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  transfer_reason?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "ftp_request" */
export type Ftp_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ftp_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ftp_Request_Stream_Cursor_Value_Input = {
  client_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  date_received?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  other?: InputMaybe<Scalars['String']['input']>;
  request_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  transfer_reason?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "ftp.request" */
export enum Ftp_Request_Update_Column {
  /** column name */
  Client_number = 'client_number',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Date_received = 'date_received',
  /** column name */
  Id = 'id',
  /** column name */
  Other = 'other',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Status = 'status',
  /** column name */
  Transfer_reason = 'transfer_reason',
  /** column name */
  Type = 'type',
  /** column name */
  Updated_at = 'updated_at',
}

export type Ftp_Request_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ftp_Request_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ftp_Request_Bool_Exp;
};

/** columns and relationships of "gec.audience" */
export type Gec_Audience = {
  /** An array relationship */
  audience_in_events: Array<Gec_Audience_In_Event>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "gec.audience" */
export type Gec_AudienceAudience_In_EventsArgs = {
  distinct_on?: InputMaybe<Array<Gec_Audience_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Audience_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Audience_In_Event_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "gec.audience". All fields are combined with a logical 'AND'. */
export type Gec_Audience_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Audience_Bool_Exp>>;
  _not?: InputMaybe<Gec_Audience_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Audience_Bool_Exp>>;
  audience_in_events?: InputMaybe<Gec_Audience_In_Event_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "gec.audience_in_event" */
export type Gec_Audience_In_Event = {
  /** An object relationship */
  audience: Gec_Audience;
  audience_id: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  event: Gec_Events;
  event_id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "gec.audience_in_event" */
export type Gec_Audience_In_Event_Aggregate_Order_By = {
  avg?: InputMaybe<Gec_Audience_In_Event_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gec_Audience_In_Event_Max_Order_By>;
  min?: InputMaybe<Gec_Audience_In_Event_Min_Order_By>;
  stddev?: InputMaybe<Gec_Audience_In_Event_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Gec_Audience_In_Event_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Gec_Audience_In_Event_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Gec_Audience_In_Event_Sum_Order_By>;
  var_pop?: InputMaybe<Gec_Audience_In_Event_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Gec_Audience_In_Event_Var_Samp_Order_By>;
  variance?: InputMaybe<Gec_Audience_In_Event_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "gec.audience_in_event" */
export type Gec_Audience_In_Event_Arr_Rel_Insert_Input = {
  data: Array<Gec_Audience_In_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gec_Audience_In_Event_On_Conflict>;
};

/** order by avg() on columns of table "gec.audience_in_event" */
export type Gec_Audience_In_Event_Avg_Order_By = {
  audience_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "gec.audience_in_event". All fields are combined with a logical 'AND'. */
export type Gec_Audience_In_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Audience_In_Event_Bool_Exp>>;
  _not?: InputMaybe<Gec_Audience_In_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Audience_In_Event_Bool_Exp>>;
  audience?: InputMaybe<Gec_Audience_Bool_Exp>;
  audience_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Gec_Events_Bool_Exp>;
  event_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "gec.audience_in_event" */
export enum Gec_Audience_In_Event_Constraint {
  /** unique or primary key constraint on columns "event_id", "audience_id" */
  Audience_in_event_pkey = 'audience_in_event_pkey',
}

/** input type for incrementing numeric columns in table "gec.audience_in_event" */
export type Gec_Audience_In_Event_Inc_Input = {
  audience_id?: InputMaybe<Scalars['Int']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "gec.audience_in_event" */
export type Gec_Audience_In_Event_Insert_Input = {
  audience_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Gec_Events_Obj_Rel_Insert_Input>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "gec.audience_in_event" */
export type Gec_Audience_In_Event_Max_Order_By = {
  audience_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "gec.audience_in_event" */
export type Gec_Audience_In_Event_Min_Order_By = {
  audience_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gec.audience_in_event" */
export type Gec_Audience_In_Event_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gec_Audience_In_Event>;
};

/** on_conflict condition type for table "gec.audience_in_event" */
export type Gec_Audience_In_Event_On_Conflict = {
  constraint: Gec_Audience_In_Event_Constraint;
  update_columns?: Array<Gec_Audience_In_Event_Update_Column>;
  where?: InputMaybe<Gec_Audience_In_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "gec.audience_in_event". */
export type Gec_Audience_In_Event_Order_By = {
  audience?: InputMaybe<Gec_Audience_Order_By>;
  audience_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event?: InputMaybe<Gec_Events_Order_By>;
  event_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gec.audience_in_event */
export type Gec_Audience_In_Event_Pk_Columns_Input = {
  audience_id: Scalars['Int']['input'];
  event_id: Scalars['Int']['input'];
};

/** select columns of table "gec.audience_in_event" */
export enum Gec_Audience_In_Event_Select_Column {
  /** column name */
  Audience_id = 'audience_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "gec.audience_in_event" */
export type Gec_Audience_In_Event_Set_Input = {
  audience_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "gec.audience_in_event" */
export type Gec_Audience_In_Event_Stddev_Order_By = {
  audience_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "gec.audience_in_event" */
export type Gec_Audience_In_Event_Stddev_Pop_Order_By = {
  audience_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "gec.audience_in_event" */
export type Gec_Audience_In_Event_Stddev_Samp_Order_By = {
  audience_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "gec_audience_in_event" */
export type Gec_Audience_In_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Audience_In_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Audience_In_Event_Stream_Cursor_Value_Input = {
  audience_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "gec.audience_in_event" */
export type Gec_Audience_In_Event_Sum_Order_By = {
  audience_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** update columns of table "gec.audience_in_event" */
export enum Gec_Audience_In_Event_Update_Column {
  /** column name */
  Audience_id = 'audience_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Updated_at = 'updated_at',
}

export type Gec_Audience_In_Event_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gec_Audience_In_Event_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gec_Audience_In_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gec_Audience_In_Event_Bool_Exp;
};

/** order by var_pop() on columns of table "gec.audience_in_event" */
export type Gec_Audience_In_Event_Var_Pop_Order_By = {
  audience_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "gec.audience_in_event" */
export type Gec_Audience_In_Event_Var_Samp_Order_By = {
  audience_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "gec.audience_in_event" */
export type Gec_Audience_In_Event_Variance_Order_By = {
  audience_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "gec.audience". */
export type Gec_Audience_Order_By = {
  audience_in_events_aggregate?: InputMaybe<Gec_Audience_In_Event_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "gec.audience" */
export enum Gec_Audience_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Updated_at = 'updated_at',
}

/** Streaming cursor of the table "gec_audience" */
export type Gec_Audience_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Audience_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Audience_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "gec.contact_in_event" */
export type Gec_Contact_In_Event = {
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  event: Gec_Events;
  event_id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user?: Maybe<Mlfsl_Personnel>;
  user_id: Scalars['String']['output'];
};

/** order by aggregate values of table "gec.contact_in_event" */
export type Gec_Contact_In_Event_Aggregate_Order_By = {
  avg?: InputMaybe<Gec_Contact_In_Event_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gec_Contact_In_Event_Max_Order_By>;
  min?: InputMaybe<Gec_Contact_In_Event_Min_Order_By>;
  stddev?: InputMaybe<Gec_Contact_In_Event_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Gec_Contact_In_Event_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Gec_Contact_In_Event_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Gec_Contact_In_Event_Sum_Order_By>;
  var_pop?: InputMaybe<Gec_Contact_In_Event_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Gec_Contact_In_Event_Var_Samp_Order_By>;
  variance?: InputMaybe<Gec_Contact_In_Event_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "gec.contact_in_event" */
export type Gec_Contact_In_Event_Arr_Rel_Insert_Input = {
  data: Array<Gec_Contact_In_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gec_Contact_In_Event_On_Conflict>;
};

/** order by avg() on columns of table "gec.contact_in_event" */
export type Gec_Contact_In_Event_Avg_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "gec.contact_in_event". All fields are combined with a logical 'AND'. */
export type Gec_Contact_In_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Contact_In_Event_Bool_Exp>>;
  _not?: InputMaybe<Gec_Contact_In_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Contact_In_Event_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Gec_Events_Bool_Exp>;
  event_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "gec.contact_in_event" */
export enum Gec_Contact_In_Event_Constraint {
  /** unique or primary key constraint on columns "user_id", "event_id" */
  Contact_in_event_event_id_user_id_key = 'contact_in_event_event_id_user_id_key',
  /** unique or primary key constraint on columns "user_id", "event_id" */
  Contact_in_event_pkey = 'contact_in_event_pkey',
}

/** input type for incrementing numeric columns in table "gec.contact_in_event" */
export type Gec_Contact_In_Event_Inc_Input = {
  event_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "gec.contact_in_event" */
export type Gec_Contact_In_Event_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Gec_Events_Obj_Rel_Insert_Input>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "gec.contact_in_event" */
export type Gec_Contact_In_Event_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "gec.contact_in_event" */
export type Gec_Contact_In_Event_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gec.contact_in_event" */
export type Gec_Contact_In_Event_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gec_Contact_In_Event>;
};

/** on_conflict condition type for table "gec.contact_in_event" */
export type Gec_Contact_In_Event_On_Conflict = {
  constraint: Gec_Contact_In_Event_Constraint;
  update_columns?: Array<Gec_Contact_In_Event_Update_Column>;
  where?: InputMaybe<Gec_Contact_In_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "gec.contact_in_event". */
export type Gec_Contact_In_Event_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event?: InputMaybe<Gec_Events_Order_By>;
  event_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gec.contact_in_event */
export type Gec_Contact_In_Event_Pk_Columns_Input = {
  event_id: Scalars['Int']['input'];
  user_id: Scalars['String']['input'];
};

/** select columns of table "gec.contact_in_event" */
export enum Gec_Contact_In_Event_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  User_id = 'user_id',
}

/** input type for updating data in table "gec.contact_in_event" */
export type Gec_Contact_In_Event_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "gec.contact_in_event" */
export type Gec_Contact_In_Event_Stddev_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "gec.contact_in_event" */
export type Gec_Contact_In_Event_Stddev_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "gec.contact_in_event" */
export type Gec_Contact_In_Event_Stddev_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "gec_contact_in_event" */
export type Gec_Contact_In_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Contact_In_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Contact_In_Event_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "gec.contact_in_event" */
export type Gec_Contact_In_Event_Sum_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** update columns of table "gec.contact_in_event" */
export enum Gec_Contact_In_Event_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  User_id = 'user_id',
}

export type Gec_Contact_In_Event_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gec_Contact_In_Event_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gec_Contact_In_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gec_Contact_In_Event_Bool_Exp;
};

/** order by var_pop() on columns of table "gec.contact_in_event" */
export type Gec_Contact_In_Event_Var_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "gec.contact_in_event" */
export type Gec_Contact_In_Event_Var_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "gec.contact_in_event" */
export type Gec_Contact_In_Event_Variance_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "gec.departments" */
export type Gec_Departments = {
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  departments_in_event: Array<Gec_Departments_In_Event>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "gec.departments" */
export type Gec_DepartmentsDepartments_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Departments_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Departments_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Departments_In_Event_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "gec.departments". All fields are combined with a logical 'AND'. */
export type Gec_Departments_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Departments_Bool_Exp>>;
  _not?: InputMaybe<Gec_Departments_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Departments_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  departments_in_event?: InputMaybe<Gec_Departments_In_Event_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "gec.departments_in_event" */
export type Gec_Departments_In_Event = {
  created_at: Scalars['timestamptz']['output'];
  department_id: Scalars['Int']['output'];
  /** An object relationship */
  departments: Gec_Departments;
  event_id: Scalars['Int']['output'];
  /** An object relationship */
  events: Gec_Events;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "gec.departments_in_event" */
export type Gec_Departments_In_Event_Aggregate_Order_By = {
  avg?: InputMaybe<Gec_Departments_In_Event_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gec_Departments_In_Event_Max_Order_By>;
  min?: InputMaybe<Gec_Departments_In_Event_Min_Order_By>;
  stddev?: InputMaybe<Gec_Departments_In_Event_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Gec_Departments_In_Event_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Gec_Departments_In_Event_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Gec_Departments_In_Event_Sum_Order_By>;
  var_pop?: InputMaybe<Gec_Departments_In_Event_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Gec_Departments_In_Event_Var_Samp_Order_By>;
  variance?: InputMaybe<Gec_Departments_In_Event_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "gec.departments_in_event" */
export type Gec_Departments_In_Event_Arr_Rel_Insert_Input = {
  data: Array<Gec_Departments_In_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gec_Departments_In_Event_On_Conflict>;
};

/** order by avg() on columns of table "gec.departments_in_event" */
export type Gec_Departments_In_Event_Avg_Order_By = {
  department_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "gec.departments_in_event". All fields are combined with a logical 'AND'. */
export type Gec_Departments_In_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Departments_In_Event_Bool_Exp>>;
  _not?: InputMaybe<Gec_Departments_In_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Departments_In_Event_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  department_id?: InputMaybe<Int_Comparison_Exp>;
  departments?: InputMaybe<Gec_Departments_Bool_Exp>;
  event_id?: InputMaybe<Int_Comparison_Exp>;
  events?: InputMaybe<Gec_Events_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "gec.departments_in_event" */
export enum Gec_Departments_In_Event_Constraint {
  /** unique or primary key constraint on columns "department_id", "event_id" */
  Departments_in_event_pkey = 'departments_in_event_pkey',
}

/** input type for incrementing numeric columns in table "gec.departments_in_event" */
export type Gec_Departments_In_Event_Inc_Input = {
  department_id?: InputMaybe<Scalars['Int']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "gec.departments_in_event" */
export type Gec_Departments_In_Event_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  department_id?: InputMaybe<Scalars['Int']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  events?: InputMaybe<Gec_Events_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "gec.departments_in_event" */
export type Gec_Departments_In_Event_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "gec.departments_in_event" */
export type Gec_Departments_In_Event_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gec.departments_in_event" */
export type Gec_Departments_In_Event_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gec_Departments_In_Event>;
};

/** on_conflict condition type for table "gec.departments_in_event" */
export type Gec_Departments_In_Event_On_Conflict = {
  constraint: Gec_Departments_In_Event_Constraint;
  update_columns?: Array<Gec_Departments_In_Event_Update_Column>;
  where?: InputMaybe<Gec_Departments_In_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "gec.departments_in_event". */
export type Gec_Departments_In_Event_Order_By = {
  created_at?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  departments?: InputMaybe<Gec_Departments_Order_By>;
  event_id?: InputMaybe<Order_By>;
  events?: InputMaybe<Gec_Events_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gec.departments_in_event */
export type Gec_Departments_In_Event_Pk_Columns_Input = {
  department_id: Scalars['Int']['input'];
  event_id: Scalars['Int']['input'];
};

/** select columns of table "gec.departments_in_event" */
export enum Gec_Departments_In_Event_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Department_id = 'department_id',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "gec.departments_in_event" */
export type Gec_Departments_In_Event_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  department_id?: InputMaybe<Scalars['Int']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "gec.departments_in_event" */
export type Gec_Departments_In_Event_Stddev_Order_By = {
  department_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "gec.departments_in_event" */
export type Gec_Departments_In_Event_Stddev_Pop_Order_By = {
  department_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "gec.departments_in_event" */
export type Gec_Departments_In_Event_Stddev_Samp_Order_By = {
  department_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "gec_departments_in_event" */
export type Gec_Departments_In_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Departments_In_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Departments_In_Event_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  department_id?: InputMaybe<Scalars['Int']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "gec.departments_in_event" */
export type Gec_Departments_In_Event_Sum_Order_By = {
  department_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** update columns of table "gec.departments_in_event" */
export enum Gec_Departments_In_Event_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Department_id = 'department_id',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Updated_at = 'updated_at',
}

export type Gec_Departments_In_Event_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gec_Departments_In_Event_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gec_Departments_In_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gec_Departments_In_Event_Bool_Exp;
};

/** order by var_pop() on columns of table "gec.departments_in_event" */
export type Gec_Departments_In_Event_Var_Pop_Order_By = {
  department_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "gec.departments_in_event" */
export type Gec_Departments_In_Event_Var_Samp_Order_By = {
  department_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "gec.departments_in_event" */
export type Gec_Departments_In_Event_Variance_Order_By = {
  department_id?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "gec.departments". */
export type Gec_Departments_Order_By = {
  created_at?: InputMaybe<Order_By>;
  departments_in_event_aggregate?: InputMaybe<Gec_Departments_In_Event_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "gec.departments" */
export enum Gec_Departments_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Updated_at = 'updated_at',
}

/** Streaming cursor of the table "gec_departments" */
export type Gec_Departments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Departments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Departments_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "gec.event_exception" */
export type Gec_Event_Exception = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  /** An object relationship */
  event: Gec_Events;
  event_id: Scalars['Int']['output'];
  exception_date: Scalars['timestamp']['output'];
  exception_date_utc: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
};

/** order by aggregate values of table "gec.event_exception" */
export type Gec_Event_Exception_Aggregate_Order_By = {
  avg?: InputMaybe<Gec_Event_Exception_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gec_Event_Exception_Max_Order_By>;
  min?: InputMaybe<Gec_Event_Exception_Min_Order_By>;
  stddev?: InputMaybe<Gec_Event_Exception_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Gec_Event_Exception_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Gec_Event_Exception_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Gec_Event_Exception_Sum_Order_By>;
  var_pop?: InputMaybe<Gec_Event_Exception_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Gec_Event_Exception_Var_Samp_Order_By>;
  variance?: InputMaybe<Gec_Event_Exception_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "gec.event_exception" */
export type Gec_Event_Exception_Arr_Rel_Insert_Input = {
  data: Array<Gec_Event_Exception_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gec_Event_Exception_On_Conflict>;
};

/** order by avg() on columns of table "gec.event_exception" */
export type Gec_Event_Exception_Avg_Order_By = {
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "gec.event_exception". All fields are combined with a logical 'AND'. */
export type Gec_Event_Exception_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Event_Exception_Bool_Exp>>;
  _not?: InputMaybe<Gec_Event_Exception_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Event_Exception_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  event?: InputMaybe<Gec_Events_Bool_Exp>;
  event_id?: InputMaybe<Int_Comparison_Exp>;
  exception_date?: InputMaybe<Timestamp_Comparison_Exp>;
  exception_date_utc?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "gec.event_exception" */
export enum Gec_Event_Exception_Constraint {
  /** unique or primary key constraint on columns "id" */
  Event_exception_pkey = 'event_exception_pkey',
}

/** input type for incrementing numeric columns in table "gec.event_exception" */
export type Gec_Event_Exception_Inc_Input = {
  event_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "gec.event_exception" */
export type Gec_Event_Exception_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Gec_Events_Obj_Rel_Insert_Input>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  exception_date?: InputMaybe<Scalars['timestamp']['input']>;
  exception_date_utc?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "gec.event_exception" */
export type Gec_Event_Exception_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  exception_date?: InputMaybe<Order_By>;
  exception_date_utc?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "gec.event_exception" */
export type Gec_Event_Exception_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  exception_date?: InputMaybe<Order_By>;
  exception_date_utc?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gec.event_exception" */
export type Gec_Event_Exception_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gec_Event_Exception>;
};

/** on_conflict condition type for table "gec.event_exception" */
export type Gec_Event_Exception_On_Conflict = {
  constraint: Gec_Event_Exception_Constraint;
  update_columns?: Array<Gec_Event_Exception_Update_Column>;
  where?: InputMaybe<Gec_Event_Exception_Bool_Exp>;
};

/** Ordering options when selecting data from "gec.event_exception". */
export type Gec_Event_Exception_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  event?: InputMaybe<Gec_Events_Order_By>;
  event_id?: InputMaybe<Order_By>;
  exception_date?: InputMaybe<Order_By>;
  exception_date_utc?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gec.event_exception */
export type Gec_Event_Exception_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "gec.event_exception" */
export enum Gec_Event_Exception_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Exception_date = 'exception_date',
  /** column name */
  Exception_date_utc = 'exception_date_utc',
  /** column name */
  Id = 'id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "gec.event_exception" */
export type Gec_Event_Exception_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  exception_date?: InputMaybe<Scalars['timestamp']['input']>;
  exception_date_utc?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "gec.event_exception" */
export type Gec_Event_Exception_Stddev_Order_By = {
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "gec.event_exception" */
export type Gec_Event_Exception_Stddev_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "gec.event_exception" */
export type Gec_Event_Exception_Stddev_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "gec_event_exception" */
export type Gec_Event_Exception_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Event_Exception_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Event_Exception_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  exception_date?: InputMaybe<Scalars['timestamp']['input']>;
  exception_date_utc?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "gec.event_exception" */
export type Gec_Event_Exception_Sum_Order_By = {
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "gec.event_exception" */
export enum Gec_Event_Exception_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Exception_date = 'exception_date',
  /** column name */
  Exception_date_utc = 'exception_date_utc',
  /** column name */
  Id = 'id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

export type Gec_Event_Exception_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gec_Event_Exception_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gec_Event_Exception_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gec_Event_Exception_Bool_Exp;
};

/** order by var_pop() on columns of table "gec.event_exception" */
export type Gec_Event_Exception_Var_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "gec.event_exception" */
export type Gec_Event_Exception_Var_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "gec.event_exception" */
export type Gec_Event_Exception_Variance_Order_By = {
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "gec.event_format" */
export type Gec_Event_Format = {
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  events: Array<Gec_Events>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "gec.event_format" */
export type Gec_Event_FormatEventsArgs = {
  distinct_on?: InputMaybe<Array<Gec_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Events_Order_By>>;
  where?: InputMaybe<Gec_Events_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "gec.event_format". All fields are combined with a logical 'AND'. */
export type Gec_Event_Format_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Event_Format_Bool_Exp>>;
  _not?: InputMaybe<Gec_Event_Format_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Event_Format_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  events?: InputMaybe<Gec_Events_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "gec.event_format". */
export type Gec_Event_Format_Order_By = {
  created_at?: InputMaybe<Order_By>;
  events_aggregate?: InputMaybe<Gec_Events_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "gec.event_format" */
export enum Gec_Event_Format_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Updated_at = 'updated_at',
}

/** Streaming cursor of the table "gec_event_format" */
export type Gec_Event_Format_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Event_Format_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Event_Format_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "gec.event_type" */
export type Gec_Event_Type = {
  color?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  event_type: Scalars['String']['output'];
  /** An array relationship */
  events: Array<Gec_Events>;
  hosting_type?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "gec.event_type" */
export type Gec_Event_TypeEventsArgs = {
  distinct_on?: InputMaybe<Array<Gec_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Events_Order_By>>;
  where?: InputMaybe<Gec_Events_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "gec.event_type". All fields are combined with a logical 'AND'. */
export type Gec_Event_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Event_Type_Bool_Exp>>;
  _not?: InputMaybe<Gec_Event_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Event_Type_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  events?: InputMaybe<Gec_Events_Bool_Exp>;
  hosting_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "gec.event_type". */
export type Gec_Event_Type_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  events_aggregate?: InputMaybe<Gec_Events_Aggregate_Order_By>;
  hosting_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "gec.event_type" */
export enum Gec_Event_Type_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_type = 'event_type',
  /** column name */
  Hosting_type = 'hosting_type',
  /** column name */
  Id = 'id',
  /** column name */
  Updated_at = 'updated_at',
}

/** Streaming cursor of the table "gec_event_type" */
export type Gec_Event_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Event_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Event_Type_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  hosting_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "gec.events" */
export type Gec_Events = {
  /** An array relationship */
  audience_in_events: Array<Gec_Audience_In_Event>;
  /** An array relationship */
  contact_in_events: Array<Gec_Contact_In_Event>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  custom_hosting_group?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  departments_in_event: Array<Gec_Departments_In_Event>;
  duration?: Maybe<Scalars['Int']['output']>;
  end_date_time?: Maybe<Scalars['timestamp']['output']>;
  end_date_time_utc?: Maybe<Scalars['timestamptz']['output']>;
  event_details?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  event_exceptions: Array<Gec_Event_Exception>;
  /** An object relationship */
  event_format?: Maybe<Gec_Event_Format>;
  event_format_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  event_type?: Maybe<Gec_Event_Type>;
  event_type_id: Scalars['Int']['output'];
  event_type_other?: Maybe<Scalars['String']['output']>;
  external_office?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  firm_initiatives_in_event: Array<Gec_Firm_Initiatives_In_Event>;
  hosting_group_other?: Maybe<Scalars['String']['output']>;
  hosting_type?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  industries_in_event: Array<Gec_Industries_In_Event>;
  is_all_day: Scalars['Boolean']['output'];
  is_cle: Scalars['Boolean']['output'];
  is_client_event_or_celebration: Scalars['Boolean']['output'];
  is_invite_only: Scalars['Boolean']['output'];
  is_recurring: Scalars['Boolean']['output'];
  /** An array relationship */
  office_visibility_in_events: Array<Gec_Office_Visibility_In_Event>;
  /** An array relationship */
  offices_in_events: Array<Gec_Offices_In_Event>;
  /** An array relationship */
  outside_speakers: Array<Gec_Outside_Speakers>;
  /** An array relationship */
  practice_groups_in_event: Array<Gec_Practice_Groups_In_Event>;
  recurrence_pattern?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  speaker_in_events: Array<Gec_Speaker_In_Event>;
  /** An array relationship */
  sponsoring_attorney_in_events: Array<Gec_Sponsoring_Attorney_In_Event>;
  sponsoring_orgnization?: Maybe<Scalars['String']['output']>;
  start_date_time: Scalars['timestamp']['output'];
  start_date_time_utc: Scalars['timestamptz']['output'];
  time_zone?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_by_user?: Maybe<Mlfsl_Personnel>;
  uuid: Scalars['uuid']['output'];
};

/** columns and relationships of "gec.events" */
export type Gec_EventsAudience_In_EventsArgs = {
  distinct_on?: InputMaybe<Array<Gec_Audience_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Audience_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Audience_In_Event_Bool_Exp>;
};

/** columns and relationships of "gec.events" */
export type Gec_EventsContact_In_EventsArgs = {
  distinct_on?: InputMaybe<Array<Gec_Contact_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Contact_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Contact_In_Event_Bool_Exp>;
};

/** columns and relationships of "gec.events" */
export type Gec_EventsDepartments_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Departments_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Departments_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Departments_In_Event_Bool_Exp>;
};

/** columns and relationships of "gec.events" */
export type Gec_EventsEvent_ExceptionsArgs = {
  distinct_on?: InputMaybe<Array<Gec_Event_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Event_Exception_Order_By>>;
  where?: InputMaybe<Gec_Event_Exception_Bool_Exp>;
};

/** columns and relationships of "gec.events" */
export type Gec_EventsFirm_Initiatives_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Firm_Initiatives_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Firm_Initiatives_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Firm_Initiatives_In_Event_Bool_Exp>;
};

/** columns and relationships of "gec.events" */
export type Gec_EventsIndustries_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Industries_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Industries_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Industries_In_Event_Bool_Exp>;
};

/** columns and relationships of "gec.events" */
export type Gec_EventsOffice_Visibility_In_EventsArgs = {
  distinct_on?: InputMaybe<Array<Gec_Office_Visibility_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Office_Visibility_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Office_Visibility_In_Event_Bool_Exp>;
};

/** columns and relationships of "gec.events" */
export type Gec_EventsOffices_In_EventsArgs = {
  distinct_on?: InputMaybe<Array<Gec_Offices_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Offices_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Offices_In_Event_Bool_Exp>;
};

/** columns and relationships of "gec.events" */
export type Gec_EventsOutside_SpeakersArgs = {
  distinct_on?: InputMaybe<Array<Gec_Outside_Speakers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Outside_Speakers_Order_By>>;
  where?: InputMaybe<Gec_Outside_Speakers_Bool_Exp>;
};

/** columns and relationships of "gec.events" */
export type Gec_EventsPractice_Groups_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Practice_Groups_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Practice_Groups_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Practice_Groups_In_Event_Bool_Exp>;
};

/** columns and relationships of "gec.events" */
export type Gec_EventsSpeaker_In_EventsArgs = {
  distinct_on?: InputMaybe<Array<Gec_Speaker_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Speaker_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Speaker_In_Event_Bool_Exp>;
};

/** columns and relationships of "gec.events" */
export type Gec_EventsSponsoring_Attorney_In_EventsArgs = {
  distinct_on?: InputMaybe<Array<Gec_Sponsoring_Attorney_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Sponsoring_Attorney_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Bool_Exp>;
};

/** order by aggregate values of table "gec.events" */
export type Gec_Events_Aggregate_Order_By = {
  avg?: InputMaybe<Gec_Events_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gec_Events_Max_Order_By>;
  min?: InputMaybe<Gec_Events_Min_Order_By>;
  stddev?: InputMaybe<Gec_Events_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Gec_Events_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Gec_Events_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Gec_Events_Sum_Order_By>;
  var_pop?: InputMaybe<Gec_Events_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Gec_Events_Var_Samp_Order_By>;
  variance?: InputMaybe<Gec_Events_Variance_Order_By>;
};

/** order by avg() on columns of table "gec.events" */
export type Gec_Events_Avg_Order_By = {
  duration?: InputMaybe<Order_By>;
  event_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "gec.events". All fields are combined with a logical 'AND'. */
export type Gec_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Events_Bool_Exp>>;
  _not?: InputMaybe<Gec_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Events_Bool_Exp>>;
  audience_in_events?: InputMaybe<Gec_Audience_In_Event_Bool_Exp>;
  contact_in_events?: InputMaybe<Gec_Contact_In_Event_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  custom_hosting_group?: InputMaybe<String_Comparison_Exp>;
  departments_in_event?: InputMaybe<Gec_Departments_In_Event_Bool_Exp>;
  duration?: InputMaybe<Int_Comparison_Exp>;
  end_date_time?: InputMaybe<Timestamp_Comparison_Exp>;
  end_date_time_utc?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_details?: InputMaybe<String_Comparison_Exp>;
  event_exceptions?: InputMaybe<Gec_Event_Exception_Bool_Exp>;
  event_format?: InputMaybe<Gec_Event_Format_Bool_Exp>;
  event_format_id?: InputMaybe<Uuid_Comparison_Exp>;
  event_type?: InputMaybe<Gec_Event_Type_Bool_Exp>;
  event_type_id?: InputMaybe<Int_Comparison_Exp>;
  event_type_other?: InputMaybe<String_Comparison_Exp>;
  external_office?: InputMaybe<String_Comparison_Exp>;
  firm_initiatives_in_event?: InputMaybe<Gec_Firm_Initiatives_In_Event_Bool_Exp>;
  hosting_group_other?: InputMaybe<String_Comparison_Exp>;
  hosting_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  industries_in_event?: InputMaybe<Gec_Industries_In_Event_Bool_Exp>;
  is_all_day?: InputMaybe<Boolean_Comparison_Exp>;
  is_cle?: InputMaybe<Boolean_Comparison_Exp>;
  is_client_event_or_celebration?: InputMaybe<Boolean_Comparison_Exp>;
  is_invite_only?: InputMaybe<Boolean_Comparison_Exp>;
  is_recurring?: InputMaybe<Boolean_Comparison_Exp>;
  office_visibility_in_events?: InputMaybe<Gec_Office_Visibility_In_Event_Bool_Exp>;
  offices_in_events?: InputMaybe<Gec_Offices_In_Event_Bool_Exp>;
  outside_speakers?: InputMaybe<Gec_Outside_Speakers_Bool_Exp>;
  practice_groups_in_event?: InputMaybe<Gec_Practice_Groups_In_Event_Bool_Exp>;
  recurrence_pattern?: InputMaybe<String_Comparison_Exp>;
  speaker_in_events?: InputMaybe<Gec_Speaker_In_Event_Bool_Exp>;
  sponsoring_attorney_in_events?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Bool_Exp>;
  sponsoring_orgnization?: InputMaybe<String_Comparison_Exp>;
  start_date_time?: InputMaybe<Timestamp_Comparison_Exp>;
  start_date_time_utc?: InputMaybe<Timestamptz_Comparison_Exp>;
  time_zone?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "gec.events" */
export enum Gec_Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  Events_pkey = 'events_pkey',
}

/** input type for incrementing numeric columns in table "gec.events" */
export type Gec_Events_Inc_Input = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  event_type_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "gec.events" */
export type Gec_Events_Insert_Input = {
  audience_in_events?: InputMaybe<Gec_Audience_In_Event_Arr_Rel_Insert_Input>;
  contact_in_events?: InputMaybe<Gec_Contact_In_Event_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  custom_hosting_group?: InputMaybe<Scalars['String']['input']>;
  departments_in_event?: InputMaybe<Gec_Departments_In_Event_Arr_Rel_Insert_Input>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  end_date_time?: InputMaybe<Scalars['timestamp']['input']>;
  end_date_time_utc?: InputMaybe<Scalars['timestamptz']['input']>;
  event_details?: InputMaybe<Scalars['String']['input']>;
  event_exceptions?: InputMaybe<Gec_Event_Exception_Arr_Rel_Insert_Input>;
  event_format_id?: InputMaybe<Scalars['uuid']['input']>;
  event_type_id?: InputMaybe<Scalars['Int']['input']>;
  event_type_other?: InputMaybe<Scalars['String']['input']>;
  external_office?: InputMaybe<Scalars['String']['input']>;
  firm_initiatives_in_event?: InputMaybe<Gec_Firm_Initiatives_In_Event_Arr_Rel_Insert_Input>;
  hosting_group_other?: InputMaybe<Scalars['String']['input']>;
  hosting_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  industries_in_event?: InputMaybe<Gec_Industries_In_Event_Arr_Rel_Insert_Input>;
  is_all_day?: InputMaybe<Scalars['Boolean']['input']>;
  is_cle?: InputMaybe<Scalars['Boolean']['input']>;
  is_client_event_or_celebration?: InputMaybe<Scalars['Boolean']['input']>;
  is_invite_only?: InputMaybe<Scalars['Boolean']['input']>;
  is_recurring?: InputMaybe<Scalars['Boolean']['input']>;
  office_visibility_in_events?: InputMaybe<Gec_Office_Visibility_In_Event_Arr_Rel_Insert_Input>;
  offices_in_events?: InputMaybe<Gec_Offices_In_Event_Arr_Rel_Insert_Input>;
  outside_speakers?: InputMaybe<Gec_Outside_Speakers_Arr_Rel_Insert_Input>;
  practice_groups_in_event?: InputMaybe<Gec_Practice_Groups_In_Event_Arr_Rel_Insert_Input>;
  recurrence_pattern?: InputMaybe<Scalars['String']['input']>;
  speaker_in_events?: InputMaybe<Gec_Speaker_In_Event_Arr_Rel_Insert_Input>;
  sponsoring_attorney_in_events?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Arr_Rel_Insert_Input>;
  sponsoring_orgnization?: InputMaybe<Scalars['String']['input']>;
  start_date_time?: InputMaybe<Scalars['timestamp']['input']>;
  start_date_time_utc?: InputMaybe<Scalars['timestamptz']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "gec.events" */
export type Gec_Events_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  custom_hosting_group?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  end_date_time?: InputMaybe<Order_By>;
  end_date_time_utc?: InputMaybe<Order_By>;
  event_details?: InputMaybe<Order_By>;
  event_format_id?: InputMaybe<Order_By>;
  event_type_id?: InputMaybe<Order_By>;
  event_type_other?: InputMaybe<Order_By>;
  external_office?: InputMaybe<Order_By>;
  hosting_group_other?: InputMaybe<Order_By>;
  hosting_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  recurrence_pattern?: InputMaybe<Order_By>;
  sponsoring_orgnization?: InputMaybe<Order_By>;
  start_date_time?: InputMaybe<Order_By>;
  start_date_time_utc?: InputMaybe<Order_By>;
  time_zone?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "gec.events" */
export type Gec_Events_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  custom_hosting_group?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  end_date_time?: InputMaybe<Order_By>;
  end_date_time_utc?: InputMaybe<Order_By>;
  event_details?: InputMaybe<Order_By>;
  event_format_id?: InputMaybe<Order_By>;
  event_type_id?: InputMaybe<Order_By>;
  event_type_other?: InputMaybe<Order_By>;
  external_office?: InputMaybe<Order_By>;
  hosting_group_other?: InputMaybe<Order_By>;
  hosting_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  recurrence_pattern?: InputMaybe<Order_By>;
  sponsoring_orgnization?: InputMaybe<Order_By>;
  start_date_time?: InputMaybe<Order_By>;
  start_date_time_utc?: InputMaybe<Order_By>;
  time_zone?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gec.events" */
export type Gec_Events_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gec_Events>;
};

/** input type for inserting object relation for remote table "gec.events" */
export type Gec_Events_Obj_Rel_Insert_Input = {
  data: Gec_Events_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Gec_Events_On_Conflict>;
};

/** on_conflict condition type for table "gec.events" */
export type Gec_Events_On_Conflict = {
  constraint: Gec_Events_Constraint;
  update_columns?: Array<Gec_Events_Update_Column>;
  where?: InputMaybe<Gec_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "gec.events". */
export type Gec_Events_Order_By = {
  audience_in_events_aggregate?: InputMaybe<Gec_Audience_In_Event_Aggregate_Order_By>;
  contact_in_events_aggregate?: InputMaybe<Gec_Contact_In_Event_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  custom_hosting_group?: InputMaybe<Order_By>;
  departments_in_event_aggregate?: InputMaybe<Gec_Departments_In_Event_Aggregate_Order_By>;
  duration?: InputMaybe<Order_By>;
  end_date_time?: InputMaybe<Order_By>;
  end_date_time_utc?: InputMaybe<Order_By>;
  event_details?: InputMaybe<Order_By>;
  event_exceptions_aggregate?: InputMaybe<Gec_Event_Exception_Aggregate_Order_By>;
  event_format?: InputMaybe<Gec_Event_Format_Order_By>;
  event_format_id?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Gec_Event_Type_Order_By>;
  event_type_id?: InputMaybe<Order_By>;
  event_type_other?: InputMaybe<Order_By>;
  external_office?: InputMaybe<Order_By>;
  firm_initiatives_in_event_aggregate?: InputMaybe<Gec_Firm_Initiatives_In_Event_Aggregate_Order_By>;
  hosting_group_other?: InputMaybe<Order_By>;
  hosting_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  industries_in_event_aggregate?: InputMaybe<Gec_Industries_In_Event_Aggregate_Order_By>;
  is_all_day?: InputMaybe<Order_By>;
  is_cle?: InputMaybe<Order_By>;
  is_client_event_or_celebration?: InputMaybe<Order_By>;
  is_invite_only?: InputMaybe<Order_By>;
  is_recurring?: InputMaybe<Order_By>;
  office_visibility_in_events_aggregate?: InputMaybe<Gec_Office_Visibility_In_Event_Aggregate_Order_By>;
  offices_in_events_aggregate?: InputMaybe<Gec_Offices_In_Event_Aggregate_Order_By>;
  outside_speakers_aggregate?: InputMaybe<Gec_Outside_Speakers_Aggregate_Order_By>;
  practice_groups_in_event_aggregate?: InputMaybe<Gec_Practice_Groups_In_Event_Aggregate_Order_By>;
  recurrence_pattern?: InputMaybe<Order_By>;
  speaker_in_events_aggregate?: InputMaybe<Gec_Speaker_In_Event_Aggregate_Order_By>;
  sponsoring_attorney_in_events_aggregate?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Aggregate_Order_By>;
  sponsoring_orgnization?: InputMaybe<Order_By>;
  start_date_time?: InputMaybe<Order_By>;
  start_date_time_utc?: InputMaybe<Order_By>;
  time_zone?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gec.events */
export type Gec_Events_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "gec.events" */
export enum Gec_Events_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Custom_hosting_group = 'custom_hosting_group',
  /** column name */
  Duration = 'duration',
  /** column name */
  End_date_time = 'end_date_time',
  /** column name */
  End_date_time_utc = 'end_date_time_utc',
  /** column name */
  Event_details = 'event_details',
  /** column name */
  Event_format_id = 'event_format_id',
  /** column name */
  Event_type_id = 'event_type_id',
  /** column name */
  Event_type_other = 'event_type_other',
  /** column name */
  External_office = 'external_office',
  /** column name */
  Hosting_group_other = 'hosting_group_other',
  /** column name */
  Hosting_type = 'hosting_type',
  /** column name */
  Id = 'id',
  /** column name */
  Is_all_day = 'is_all_day',
  /** column name */
  Is_cle = 'is_cle',
  /** column name */
  Is_client_event_or_celebration = 'is_client_event_or_celebration',
  /** column name */
  Is_invite_only = 'is_invite_only',
  /** column name */
  Is_recurring = 'is_recurring',
  /** column name */
  Recurrence_pattern = 'recurrence_pattern',
  /** column name */
  Sponsoring_orgnization = 'sponsoring_orgnization',
  /** column name */
  Start_date_time = 'start_date_time',
  /** column name */
  Start_date_time_utc = 'start_date_time_utc',
  /** column name */
  Time_zone = 'time_zone',
  /** column name */
  Title = 'title',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
  /** column name */
  Uuid = 'uuid',
}

/** input type for updating data in table "gec.events" */
export type Gec_Events_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  custom_hosting_group?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  end_date_time?: InputMaybe<Scalars['timestamp']['input']>;
  end_date_time_utc?: InputMaybe<Scalars['timestamptz']['input']>;
  event_details?: InputMaybe<Scalars['String']['input']>;
  event_format_id?: InputMaybe<Scalars['uuid']['input']>;
  event_type_id?: InputMaybe<Scalars['Int']['input']>;
  event_type_other?: InputMaybe<Scalars['String']['input']>;
  external_office?: InputMaybe<Scalars['String']['input']>;
  hosting_group_other?: InputMaybe<Scalars['String']['input']>;
  hosting_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_all_day?: InputMaybe<Scalars['Boolean']['input']>;
  is_cle?: InputMaybe<Scalars['Boolean']['input']>;
  is_client_event_or_celebration?: InputMaybe<Scalars['Boolean']['input']>;
  is_invite_only?: InputMaybe<Scalars['Boolean']['input']>;
  is_recurring?: InputMaybe<Scalars['Boolean']['input']>;
  recurrence_pattern?: InputMaybe<Scalars['String']['input']>;
  sponsoring_orgnization?: InputMaybe<Scalars['String']['input']>;
  start_date_time?: InputMaybe<Scalars['timestamp']['input']>;
  start_date_time_utc?: InputMaybe<Scalars['timestamptz']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by stddev() on columns of table "gec.events" */
export type Gec_Events_Stddev_Order_By = {
  duration?: InputMaybe<Order_By>;
  event_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "gec.events" */
export type Gec_Events_Stddev_Pop_Order_By = {
  duration?: InputMaybe<Order_By>;
  event_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "gec.events" */
export type Gec_Events_Stddev_Samp_Order_By = {
  duration?: InputMaybe<Order_By>;
  event_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "gec_events" */
export type Gec_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Events_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  custom_hosting_group?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  end_date_time?: InputMaybe<Scalars['timestamp']['input']>;
  end_date_time_utc?: InputMaybe<Scalars['timestamptz']['input']>;
  event_details?: InputMaybe<Scalars['String']['input']>;
  event_format_id?: InputMaybe<Scalars['uuid']['input']>;
  event_type_id?: InputMaybe<Scalars['Int']['input']>;
  event_type_other?: InputMaybe<Scalars['String']['input']>;
  external_office?: InputMaybe<Scalars['String']['input']>;
  hosting_group_other?: InputMaybe<Scalars['String']['input']>;
  hosting_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_all_day?: InputMaybe<Scalars['Boolean']['input']>;
  is_cle?: InputMaybe<Scalars['Boolean']['input']>;
  is_client_event_or_celebration?: InputMaybe<Scalars['Boolean']['input']>;
  is_invite_only?: InputMaybe<Scalars['Boolean']['input']>;
  is_recurring?: InputMaybe<Scalars['Boolean']['input']>;
  recurrence_pattern?: InputMaybe<Scalars['String']['input']>;
  sponsoring_orgnization?: InputMaybe<Scalars['String']['input']>;
  start_date_time?: InputMaybe<Scalars['timestamp']['input']>;
  start_date_time_utc?: InputMaybe<Scalars['timestamptz']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "gec.events" */
export type Gec_Events_Sum_Order_By = {
  duration?: InputMaybe<Order_By>;
  event_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "gec.events" */
export enum Gec_Events_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Custom_hosting_group = 'custom_hosting_group',
  /** column name */
  Duration = 'duration',
  /** column name */
  End_date_time = 'end_date_time',
  /** column name */
  End_date_time_utc = 'end_date_time_utc',
  /** column name */
  Event_details = 'event_details',
  /** column name */
  Event_format_id = 'event_format_id',
  /** column name */
  Event_type_id = 'event_type_id',
  /** column name */
  Event_type_other = 'event_type_other',
  /** column name */
  External_office = 'external_office',
  /** column name */
  Hosting_group_other = 'hosting_group_other',
  /** column name */
  Hosting_type = 'hosting_type',
  /** column name */
  Id = 'id',
  /** column name */
  Is_all_day = 'is_all_day',
  /** column name */
  Is_cle = 'is_cle',
  /** column name */
  Is_client_event_or_celebration = 'is_client_event_or_celebration',
  /** column name */
  Is_invite_only = 'is_invite_only',
  /** column name */
  Is_recurring = 'is_recurring',
  /** column name */
  Recurrence_pattern = 'recurrence_pattern',
  /** column name */
  Sponsoring_orgnization = 'sponsoring_orgnization',
  /** column name */
  Start_date_time = 'start_date_time',
  /** column name */
  Start_date_time_utc = 'start_date_time_utc',
  /** column name */
  Time_zone = 'time_zone',
  /** column name */
  Title = 'title',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
  /** column name */
  Uuid = 'uuid',
}

export type Gec_Events_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gec_Events_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gec_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gec_Events_Bool_Exp;
};

/** order by var_pop() on columns of table "gec.events" */
export type Gec_Events_Var_Pop_Order_By = {
  duration?: InputMaybe<Order_By>;
  event_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "gec.events" */
export type Gec_Events_Var_Samp_Order_By = {
  duration?: InputMaybe<Order_By>;
  event_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "gec.events" */
export type Gec_Events_Variance_Order_By = {
  duration?: InputMaybe<Order_By>;
  event_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "gec.firm_initiatives" */
export type Gec_Firm_Initiatives = {
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  firm_initiatives_in_event: Array<Gec_Firm_Initiatives_In_Event>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "gec.firm_initiatives" */
export type Gec_Firm_InitiativesFirm_Initiatives_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Firm_Initiatives_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Firm_Initiatives_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Firm_Initiatives_In_Event_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "gec.firm_initiatives". All fields are combined with a logical 'AND'. */
export type Gec_Firm_Initiatives_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Firm_Initiatives_Bool_Exp>>;
  _not?: InputMaybe<Gec_Firm_Initiatives_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Firm_Initiatives_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  firm_initiatives_in_event?: InputMaybe<Gec_Firm_Initiatives_In_Event_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "gec.firm_initiatives_in_event" */
export type Gec_Firm_Initiatives_In_Event = {
  created_at: Scalars['timestamptz']['output'];
  event_id: Scalars['Int']['output'];
  /** An object relationship */
  events: Gec_Events;
  firm_initiative_id: Scalars['Int']['output'];
  /** An object relationship */
  firm_initiatives: Gec_Firm_Initiatives;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "gec.firm_initiatives_in_event" */
export type Gec_Firm_Initiatives_In_Event_Aggregate_Order_By = {
  avg?: InputMaybe<Gec_Firm_Initiatives_In_Event_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gec_Firm_Initiatives_In_Event_Max_Order_By>;
  min?: InputMaybe<Gec_Firm_Initiatives_In_Event_Min_Order_By>;
  stddev?: InputMaybe<Gec_Firm_Initiatives_In_Event_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Gec_Firm_Initiatives_In_Event_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Gec_Firm_Initiatives_In_Event_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Gec_Firm_Initiatives_In_Event_Sum_Order_By>;
  var_pop?: InputMaybe<Gec_Firm_Initiatives_In_Event_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Gec_Firm_Initiatives_In_Event_Var_Samp_Order_By>;
  variance?: InputMaybe<Gec_Firm_Initiatives_In_Event_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "gec.firm_initiatives_in_event" */
export type Gec_Firm_Initiatives_In_Event_Arr_Rel_Insert_Input = {
  data: Array<Gec_Firm_Initiatives_In_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gec_Firm_Initiatives_In_Event_On_Conflict>;
};

/** order by avg() on columns of table "gec.firm_initiatives_in_event" */
export type Gec_Firm_Initiatives_In_Event_Avg_Order_By = {
  event_id?: InputMaybe<Order_By>;
  firm_initiative_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "gec.firm_initiatives_in_event". All fields are combined with a logical 'AND'. */
export type Gec_Firm_Initiatives_In_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Firm_Initiatives_In_Event_Bool_Exp>>;
  _not?: InputMaybe<Gec_Firm_Initiatives_In_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Firm_Initiatives_In_Event_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_id?: InputMaybe<Int_Comparison_Exp>;
  events?: InputMaybe<Gec_Events_Bool_Exp>;
  firm_initiative_id?: InputMaybe<Int_Comparison_Exp>;
  firm_initiatives?: InputMaybe<Gec_Firm_Initiatives_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "gec.firm_initiatives_in_event" */
export enum Gec_Firm_Initiatives_In_Event_Constraint {
  /** unique or primary key constraint on columns "firm_initiative_id", "event_id" */
  Firm_initiatives_in_event_pkey = 'firm_initiatives_in_event_pkey',
}

/** input type for incrementing numeric columns in table "gec.firm_initiatives_in_event" */
export type Gec_Firm_Initiatives_In_Event_Inc_Input = {
  event_id?: InputMaybe<Scalars['Int']['input']>;
  firm_initiative_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "gec.firm_initiatives_in_event" */
export type Gec_Firm_Initiatives_In_Event_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  events?: InputMaybe<Gec_Events_Obj_Rel_Insert_Input>;
  firm_initiative_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "gec.firm_initiatives_in_event" */
export type Gec_Firm_Initiatives_In_Event_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  firm_initiative_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "gec.firm_initiatives_in_event" */
export type Gec_Firm_Initiatives_In_Event_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  firm_initiative_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gec.firm_initiatives_in_event" */
export type Gec_Firm_Initiatives_In_Event_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gec_Firm_Initiatives_In_Event>;
};

/** on_conflict condition type for table "gec.firm_initiatives_in_event" */
export type Gec_Firm_Initiatives_In_Event_On_Conflict = {
  constraint: Gec_Firm_Initiatives_In_Event_Constraint;
  update_columns?: Array<Gec_Firm_Initiatives_In_Event_Update_Column>;
  where?: InputMaybe<Gec_Firm_Initiatives_In_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "gec.firm_initiatives_in_event". */
export type Gec_Firm_Initiatives_In_Event_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  events?: InputMaybe<Gec_Events_Order_By>;
  firm_initiative_id?: InputMaybe<Order_By>;
  firm_initiatives?: InputMaybe<Gec_Firm_Initiatives_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gec.firm_initiatives_in_event */
export type Gec_Firm_Initiatives_In_Event_Pk_Columns_Input = {
  event_id: Scalars['Int']['input'];
  firm_initiative_id: Scalars['Int']['input'];
};

/** select columns of table "gec.firm_initiatives_in_event" */
export enum Gec_Firm_Initiatives_In_Event_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Firm_initiative_id = 'firm_initiative_id',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "gec.firm_initiatives_in_event" */
export type Gec_Firm_Initiatives_In_Event_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  firm_initiative_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "gec.firm_initiatives_in_event" */
export type Gec_Firm_Initiatives_In_Event_Stddev_Order_By = {
  event_id?: InputMaybe<Order_By>;
  firm_initiative_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "gec.firm_initiatives_in_event" */
export type Gec_Firm_Initiatives_In_Event_Stddev_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
  firm_initiative_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "gec.firm_initiatives_in_event" */
export type Gec_Firm_Initiatives_In_Event_Stddev_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
  firm_initiative_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "gec_firm_initiatives_in_event" */
export type Gec_Firm_Initiatives_In_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Firm_Initiatives_In_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Firm_Initiatives_In_Event_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  firm_initiative_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "gec.firm_initiatives_in_event" */
export type Gec_Firm_Initiatives_In_Event_Sum_Order_By = {
  event_id?: InputMaybe<Order_By>;
  firm_initiative_id?: InputMaybe<Order_By>;
};

/** update columns of table "gec.firm_initiatives_in_event" */
export enum Gec_Firm_Initiatives_In_Event_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Firm_initiative_id = 'firm_initiative_id',
  /** column name */
  Updated_at = 'updated_at',
}

export type Gec_Firm_Initiatives_In_Event_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gec_Firm_Initiatives_In_Event_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gec_Firm_Initiatives_In_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gec_Firm_Initiatives_In_Event_Bool_Exp;
};

/** order by var_pop() on columns of table "gec.firm_initiatives_in_event" */
export type Gec_Firm_Initiatives_In_Event_Var_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
  firm_initiative_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "gec.firm_initiatives_in_event" */
export type Gec_Firm_Initiatives_In_Event_Var_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
  firm_initiative_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "gec.firm_initiatives_in_event" */
export type Gec_Firm_Initiatives_In_Event_Variance_Order_By = {
  event_id?: InputMaybe<Order_By>;
  firm_initiative_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "gec.firm_initiatives". */
export type Gec_Firm_Initiatives_Order_By = {
  created_at?: InputMaybe<Order_By>;
  firm_initiatives_in_event_aggregate?: InputMaybe<Gec_Firm_Initiatives_In_Event_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "gec.firm_initiatives" */
export enum Gec_Firm_Initiatives_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Updated_at = 'updated_at',
}

/** Streaming cursor of the table "gec_firm_initiatives" */
export type Gec_Firm_Initiatives_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Firm_Initiatives_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Firm_Initiatives_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "gec.industries" */
export type Gec_Industries = {
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An array relationship */
  industries_in_event: Array<Gec_Industries_In_Event>;
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "gec.industries" */
export type Gec_IndustriesIndustries_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Industries_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Industries_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Industries_In_Event_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "gec.industries". All fields are combined with a logical 'AND'. */
export type Gec_Industries_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Industries_Bool_Exp>>;
  _not?: InputMaybe<Gec_Industries_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Industries_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  industries_in_event?: InputMaybe<Gec_Industries_In_Event_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "gec.industries_in_event" */
export type Gec_Industries_In_Event = {
  created_at: Scalars['timestamptz']['output'];
  event_id: Scalars['Int']['output'];
  /** An object relationship */
  events: Gec_Events;
  /** An object relationship */
  industries: Gec_Industries;
  industry_id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "gec.industries_in_event" */
export type Gec_Industries_In_Event_Aggregate_Order_By = {
  avg?: InputMaybe<Gec_Industries_In_Event_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gec_Industries_In_Event_Max_Order_By>;
  min?: InputMaybe<Gec_Industries_In_Event_Min_Order_By>;
  stddev?: InputMaybe<Gec_Industries_In_Event_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Gec_Industries_In_Event_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Gec_Industries_In_Event_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Gec_Industries_In_Event_Sum_Order_By>;
  var_pop?: InputMaybe<Gec_Industries_In_Event_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Gec_Industries_In_Event_Var_Samp_Order_By>;
  variance?: InputMaybe<Gec_Industries_In_Event_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "gec.industries_in_event" */
export type Gec_Industries_In_Event_Arr_Rel_Insert_Input = {
  data: Array<Gec_Industries_In_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gec_Industries_In_Event_On_Conflict>;
};

/** order by avg() on columns of table "gec.industries_in_event" */
export type Gec_Industries_In_Event_Avg_Order_By = {
  event_id?: InputMaybe<Order_By>;
  industry_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "gec.industries_in_event". All fields are combined with a logical 'AND'. */
export type Gec_Industries_In_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Industries_In_Event_Bool_Exp>>;
  _not?: InputMaybe<Gec_Industries_In_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Industries_In_Event_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_id?: InputMaybe<Int_Comparison_Exp>;
  events?: InputMaybe<Gec_Events_Bool_Exp>;
  industries?: InputMaybe<Gec_Industries_Bool_Exp>;
  industry_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "gec.industries_in_event" */
export enum Gec_Industries_In_Event_Constraint {
  /** unique or primary key constraint on columns "event_id", "industry_id" */
  Industries_in_event_pkey = 'industries_in_event_pkey',
}

/** input type for incrementing numeric columns in table "gec.industries_in_event" */
export type Gec_Industries_In_Event_Inc_Input = {
  event_id?: InputMaybe<Scalars['Int']['input']>;
  industry_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "gec.industries_in_event" */
export type Gec_Industries_In_Event_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  events?: InputMaybe<Gec_Events_Obj_Rel_Insert_Input>;
  industry_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "gec.industries_in_event" */
export type Gec_Industries_In_Event_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  industry_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "gec.industries_in_event" */
export type Gec_Industries_In_Event_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  industry_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gec.industries_in_event" */
export type Gec_Industries_In_Event_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gec_Industries_In_Event>;
};

/** on_conflict condition type for table "gec.industries_in_event" */
export type Gec_Industries_In_Event_On_Conflict = {
  constraint: Gec_Industries_In_Event_Constraint;
  update_columns?: Array<Gec_Industries_In_Event_Update_Column>;
  where?: InputMaybe<Gec_Industries_In_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "gec.industries_in_event". */
export type Gec_Industries_In_Event_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  events?: InputMaybe<Gec_Events_Order_By>;
  industries?: InputMaybe<Gec_Industries_Order_By>;
  industry_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gec.industries_in_event */
export type Gec_Industries_In_Event_Pk_Columns_Input = {
  event_id: Scalars['Int']['input'];
  industry_id: Scalars['Int']['input'];
};

/** select columns of table "gec.industries_in_event" */
export enum Gec_Industries_In_Event_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Industry_id = 'industry_id',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "gec.industries_in_event" */
export type Gec_Industries_In_Event_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  industry_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "gec.industries_in_event" */
export type Gec_Industries_In_Event_Stddev_Order_By = {
  event_id?: InputMaybe<Order_By>;
  industry_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "gec.industries_in_event" */
export type Gec_Industries_In_Event_Stddev_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
  industry_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "gec.industries_in_event" */
export type Gec_Industries_In_Event_Stddev_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
  industry_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "gec_industries_in_event" */
export type Gec_Industries_In_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Industries_In_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Industries_In_Event_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  industry_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "gec.industries_in_event" */
export type Gec_Industries_In_Event_Sum_Order_By = {
  event_id?: InputMaybe<Order_By>;
  industry_id?: InputMaybe<Order_By>;
};

/** update columns of table "gec.industries_in_event" */
export enum Gec_Industries_In_Event_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Industry_id = 'industry_id',
  /** column name */
  Updated_at = 'updated_at',
}

export type Gec_Industries_In_Event_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gec_Industries_In_Event_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gec_Industries_In_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gec_Industries_In_Event_Bool_Exp;
};

/** order by var_pop() on columns of table "gec.industries_in_event" */
export type Gec_Industries_In_Event_Var_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
  industry_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "gec.industries_in_event" */
export type Gec_Industries_In_Event_Var_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
  industry_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "gec.industries_in_event" */
export type Gec_Industries_In_Event_Variance_Order_By = {
  event_id?: InputMaybe<Order_By>;
  industry_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "gec.industries". */
export type Gec_Industries_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  industries_in_event_aggregate?: InputMaybe<Gec_Industries_In_Event_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "gec.industries" */
export enum Gec_Industries_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Updated_at = 'updated_at',
}

/** Streaming cursor of the table "gec_industries" */
export type Gec_Industries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Industries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Industries_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "gec.office_visibility_in_event" */
export type Gec_Office_Visibility_In_Event = {
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  event?: Maybe<Gec_Events>;
  event_id: Scalars['Int']['output'];
  /** An object relationship */
  office?: Maybe<Gec_Offices>;
  office_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "gec.office_visibility_in_event" */
export type Gec_Office_Visibility_In_Event_Aggregate_Order_By = {
  avg?: InputMaybe<Gec_Office_Visibility_In_Event_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gec_Office_Visibility_In_Event_Max_Order_By>;
  min?: InputMaybe<Gec_Office_Visibility_In_Event_Min_Order_By>;
  stddev?: InputMaybe<Gec_Office_Visibility_In_Event_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Gec_Office_Visibility_In_Event_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Gec_Office_Visibility_In_Event_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Gec_Office_Visibility_In_Event_Sum_Order_By>;
  var_pop?: InputMaybe<Gec_Office_Visibility_In_Event_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Gec_Office_Visibility_In_Event_Var_Samp_Order_By>;
  variance?: InputMaybe<Gec_Office_Visibility_In_Event_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "gec.office_visibility_in_event" */
export type Gec_Office_Visibility_In_Event_Arr_Rel_Insert_Input = {
  data: Array<Gec_Office_Visibility_In_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gec_Office_Visibility_In_Event_On_Conflict>;
};

/** order by avg() on columns of table "gec.office_visibility_in_event" */
export type Gec_Office_Visibility_In_Event_Avg_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "gec.office_visibility_in_event". All fields are combined with a logical 'AND'. */
export type Gec_Office_Visibility_In_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Office_Visibility_In_Event_Bool_Exp>>;
  _not?: InputMaybe<Gec_Office_Visibility_In_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Office_Visibility_In_Event_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Gec_Events_Bool_Exp>;
  event_id?: InputMaybe<Int_Comparison_Exp>;
  office?: InputMaybe<Gec_Offices_Bool_Exp>;
  office_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "gec.office_visibility_in_event" */
export enum Gec_Office_Visibility_In_Event_Constraint {
  /** unique or primary key constraint on columns "event_id", "office_id" */
  Office_visibility_in_event_pkey = 'office_visibility_in_event_pkey',
}

/** input type for incrementing numeric columns in table "gec.office_visibility_in_event" */
export type Gec_Office_Visibility_In_Event_Inc_Input = {
  event_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "gec.office_visibility_in_event" */
export type Gec_Office_Visibility_In_Event_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Gec_Events_Obj_Rel_Insert_Input>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  office_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "gec.office_visibility_in_event" */
export type Gec_Office_Visibility_In_Event_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  office_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "gec.office_visibility_in_event" */
export type Gec_Office_Visibility_In_Event_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  office_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gec.office_visibility_in_event" */
export type Gec_Office_Visibility_In_Event_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gec_Office_Visibility_In_Event>;
};

/** on_conflict condition type for table "gec.office_visibility_in_event" */
export type Gec_Office_Visibility_In_Event_On_Conflict = {
  constraint: Gec_Office_Visibility_In_Event_Constraint;
  update_columns?: Array<Gec_Office_Visibility_In_Event_Update_Column>;
  where?: InputMaybe<Gec_Office_Visibility_In_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "gec.office_visibility_in_event". */
export type Gec_Office_Visibility_In_Event_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event?: InputMaybe<Gec_Events_Order_By>;
  event_id?: InputMaybe<Order_By>;
  office?: InputMaybe<Gec_Offices_Order_By>;
  office_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gec.office_visibility_in_event */
export type Gec_Office_Visibility_In_Event_Pk_Columns_Input = {
  event_id: Scalars['Int']['input'];
  office_id: Scalars['uuid']['input'];
};

/** select columns of table "gec.office_visibility_in_event" */
export enum Gec_Office_Visibility_In_Event_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Office_id = 'office_id',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "gec.office_visibility_in_event" */
export type Gec_Office_Visibility_In_Event_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  office_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "gec.office_visibility_in_event" */
export type Gec_Office_Visibility_In_Event_Stddev_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "gec.office_visibility_in_event" */
export type Gec_Office_Visibility_In_Event_Stddev_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "gec.office_visibility_in_event" */
export type Gec_Office_Visibility_In_Event_Stddev_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "gec_office_visibility_in_event" */
export type Gec_Office_Visibility_In_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Office_Visibility_In_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Office_Visibility_In_Event_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  office_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "gec.office_visibility_in_event" */
export type Gec_Office_Visibility_In_Event_Sum_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** update columns of table "gec.office_visibility_in_event" */
export enum Gec_Office_Visibility_In_Event_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Office_id = 'office_id',
  /** column name */
  Updated_at = 'updated_at',
}

export type Gec_Office_Visibility_In_Event_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gec_Office_Visibility_In_Event_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gec_Office_Visibility_In_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gec_Office_Visibility_In_Event_Bool_Exp;
};

/** order by var_pop() on columns of table "gec.office_visibility_in_event" */
export type Gec_Office_Visibility_In_Event_Var_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "gec.office_visibility_in_event" */
export type Gec_Office_Visibility_In_Event_Var_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "gec.office_visibility_in_event" */
export type Gec_Office_Visibility_In_Event_Variance_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "gec.offices" */
export type Gec_Offices = {
  address?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  office_code: Scalars['String']['output'];
  /** An array relationship */
  office_visibility_in_events: Array<Gec_Office_Visibility_In_Event>;
  /** An array relationship */
  offices_in_events: Array<Gec_Offices_In_Event>;
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "gec.offices" */
export type Gec_OfficesOffice_Visibility_In_EventsArgs = {
  distinct_on?: InputMaybe<Array<Gec_Office_Visibility_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Office_Visibility_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Office_Visibility_In_Event_Bool_Exp>;
};

/** columns and relationships of "gec.offices" */
export type Gec_OfficesOffices_In_EventsArgs = {
  distinct_on?: InputMaybe<Array<Gec_Offices_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Offices_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Offices_In_Event_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "gec.offices". All fields are combined with a logical 'AND'. */
export type Gec_Offices_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Offices_Bool_Exp>>;
  _not?: InputMaybe<Gec_Offices_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Offices_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  office_code?: InputMaybe<String_Comparison_Exp>;
  office_visibility_in_events?: InputMaybe<Gec_Office_Visibility_In_Event_Bool_Exp>;
  offices_in_events?: InputMaybe<Gec_Offices_In_Event_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "gec.offices_in_event" */
export type Gec_Offices_In_Event = {
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  event: Gec_Events;
  event_id: Scalars['Int']['output'];
  /** An object relationship */
  office: Gec_Offices;
  office_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "gec.offices_in_event" */
export type Gec_Offices_In_Event_Aggregate_Order_By = {
  avg?: InputMaybe<Gec_Offices_In_Event_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gec_Offices_In_Event_Max_Order_By>;
  min?: InputMaybe<Gec_Offices_In_Event_Min_Order_By>;
  stddev?: InputMaybe<Gec_Offices_In_Event_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Gec_Offices_In_Event_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Gec_Offices_In_Event_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Gec_Offices_In_Event_Sum_Order_By>;
  var_pop?: InputMaybe<Gec_Offices_In_Event_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Gec_Offices_In_Event_Var_Samp_Order_By>;
  variance?: InputMaybe<Gec_Offices_In_Event_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "gec.offices_in_event" */
export type Gec_Offices_In_Event_Arr_Rel_Insert_Input = {
  data: Array<Gec_Offices_In_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gec_Offices_In_Event_On_Conflict>;
};

/** order by avg() on columns of table "gec.offices_in_event" */
export type Gec_Offices_In_Event_Avg_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "gec.offices_in_event". All fields are combined with a logical 'AND'. */
export type Gec_Offices_In_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Offices_In_Event_Bool_Exp>>;
  _not?: InputMaybe<Gec_Offices_In_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Offices_In_Event_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Gec_Events_Bool_Exp>;
  event_id?: InputMaybe<Int_Comparison_Exp>;
  office?: InputMaybe<Gec_Offices_Bool_Exp>;
  office_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "gec.offices_in_event" */
export enum Gec_Offices_In_Event_Constraint {
  /** unique or primary key constraint on columns "event_id", "office_id" */
  Offices_in_event_pkey = 'offices_in_event_pkey',
}

/** input type for incrementing numeric columns in table "gec.offices_in_event" */
export type Gec_Offices_In_Event_Inc_Input = {
  event_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "gec.offices_in_event" */
export type Gec_Offices_In_Event_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Gec_Events_Obj_Rel_Insert_Input>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  office_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "gec.offices_in_event" */
export type Gec_Offices_In_Event_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  office_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "gec.offices_in_event" */
export type Gec_Offices_In_Event_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  office_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gec.offices_in_event" */
export type Gec_Offices_In_Event_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gec_Offices_In_Event>;
};

/** on_conflict condition type for table "gec.offices_in_event" */
export type Gec_Offices_In_Event_On_Conflict = {
  constraint: Gec_Offices_In_Event_Constraint;
  update_columns?: Array<Gec_Offices_In_Event_Update_Column>;
  where?: InputMaybe<Gec_Offices_In_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "gec.offices_in_event". */
export type Gec_Offices_In_Event_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event?: InputMaybe<Gec_Events_Order_By>;
  event_id?: InputMaybe<Order_By>;
  office?: InputMaybe<Gec_Offices_Order_By>;
  office_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gec.offices_in_event */
export type Gec_Offices_In_Event_Pk_Columns_Input = {
  event_id: Scalars['Int']['input'];
  office_id: Scalars['uuid']['input'];
};

/** select columns of table "gec.offices_in_event" */
export enum Gec_Offices_In_Event_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Office_id = 'office_id',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "gec.offices_in_event" */
export type Gec_Offices_In_Event_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  office_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "gec.offices_in_event" */
export type Gec_Offices_In_Event_Stddev_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "gec.offices_in_event" */
export type Gec_Offices_In_Event_Stddev_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "gec.offices_in_event" */
export type Gec_Offices_In_Event_Stddev_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "gec_offices_in_event" */
export type Gec_Offices_In_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Offices_In_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Offices_In_Event_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  office_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "gec.offices_in_event" */
export type Gec_Offices_In_Event_Sum_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** update columns of table "gec.offices_in_event" */
export enum Gec_Offices_In_Event_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Office_id = 'office_id',
  /** column name */
  Updated_at = 'updated_at',
}

export type Gec_Offices_In_Event_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gec_Offices_In_Event_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gec_Offices_In_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gec_Offices_In_Event_Bool_Exp;
};

/** order by var_pop() on columns of table "gec.offices_in_event" */
export type Gec_Offices_In_Event_Var_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "gec.offices_in_event" */
export type Gec_Offices_In_Event_Var_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "gec.offices_in_event" */
export type Gec_Offices_In_Event_Variance_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "gec.offices". */
export type Gec_Offices_Order_By = {
  address?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  office_code?: InputMaybe<Order_By>;
  office_visibility_in_events_aggregate?: InputMaybe<Gec_Office_Visibility_In_Event_Aggregate_Order_By>;
  offices_in_events_aggregate?: InputMaybe<Gec_Offices_In_Event_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "gec.offices" */
export enum Gec_Offices_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Office_code = 'office_code',
  /** column name */
  Updated_at = 'updated_at',
}

/** Streaming cursor of the table "gec_offices" */
export type Gec_Offices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Offices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Offices_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  office_code?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** This table stores information about external speakers invited to events. */
export type Gec_Outside_Speakers = {
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  event: Gec_Events;
  event_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "gec.outside_speakers" */
export type Gec_Outside_Speakers_Aggregate_Order_By = {
  avg?: InputMaybe<Gec_Outside_Speakers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gec_Outside_Speakers_Max_Order_By>;
  min?: InputMaybe<Gec_Outside_Speakers_Min_Order_By>;
  stddev?: InputMaybe<Gec_Outside_Speakers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Gec_Outside_Speakers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Gec_Outside_Speakers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Gec_Outside_Speakers_Sum_Order_By>;
  var_pop?: InputMaybe<Gec_Outside_Speakers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Gec_Outside_Speakers_Var_Samp_Order_By>;
  variance?: InputMaybe<Gec_Outside_Speakers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "gec.outside_speakers" */
export type Gec_Outside_Speakers_Arr_Rel_Insert_Input = {
  data: Array<Gec_Outside_Speakers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gec_Outside_Speakers_On_Conflict>;
};

/** order by avg() on columns of table "gec.outside_speakers" */
export type Gec_Outside_Speakers_Avg_Order_By = {
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "gec.outside_speakers". All fields are combined with a logical 'AND'. */
export type Gec_Outside_Speakers_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Outside_Speakers_Bool_Exp>>;
  _not?: InputMaybe<Gec_Outside_Speakers_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Outside_Speakers_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Gec_Events_Bool_Exp>;
  event_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "gec.outside_speakers" */
export enum Gec_Outside_Speakers_Constraint {
  /** unique or primary key constraint on columns "id" */
  Outside_speakers_pkey = 'outside_speakers_pkey',
}

/** input type for incrementing numeric columns in table "gec.outside_speakers" */
export type Gec_Outside_Speakers_Inc_Input = {
  event_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "gec.outside_speakers" */
export type Gec_Outside_Speakers_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Gec_Events_Obj_Rel_Insert_Input>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "gec.outside_speakers" */
export type Gec_Outside_Speakers_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "gec.outside_speakers" */
export type Gec_Outside_Speakers_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gec.outside_speakers" */
export type Gec_Outside_Speakers_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gec_Outside_Speakers>;
};

/** on_conflict condition type for table "gec.outside_speakers" */
export type Gec_Outside_Speakers_On_Conflict = {
  constraint: Gec_Outside_Speakers_Constraint;
  update_columns?: Array<Gec_Outside_Speakers_Update_Column>;
  where?: InputMaybe<Gec_Outside_Speakers_Bool_Exp>;
};

/** Ordering options when selecting data from "gec.outside_speakers". */
export type Gec_Outside_Speakers_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event?: InputMaybe<Gec_Events_Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gec.outside_speakers */
export type Gec_Outside_Speakers_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "gec.outside_speakers" */
export enum Gec_Outside_Speakers_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Organization = 'organization',
  /** column name */
  Title = 'title',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "gec.outside_speakers" */
export type Gec_Outside_Speakers_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "gec.outside_speakers" */
export type Gec_Outside_Speakers_Stddev_Order_By = {
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "gec.outside_speakers" */
export type Gec_Outside_Speakers_Stddev_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "gec.outside_speakers" */
export type Gec_Outside_Speakers_Stddev_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "gec_outside_speakers" */
export type Gec_Outside_Speakers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Outside_Speakers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Outside_Speakers_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "gec.outside_speakers" */
export type Gec_Outside_Speakers_Sum_Order_By = {
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "gec.outside_speakers" */
export enum Gec_Outside_Speakers_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Organization = 'organization',
  /** column name */
  Title = 'title',
  /** column name */
  Updated_at = 'updated_at',
}

export type Gec_Outside_Speakers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gec_Outside_Speakers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gec_Outside_Speakers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gec_Outside_Speakers_Bool_Exp;
};

/** order by var_pop() on columns of table "gec.outside_speakers" */
export type Gec_Outside_Speakers_Var_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "gec.outside_speakers" */
export type Gec_Outside_Speakers_Var_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "gec.outside_speakers" */
export type Gec_Outside_Speakers_Variance_Order_By = {
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "gec.practice_groups_in_event" */
export type Gec_Practice_Groups_In_Event = {
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  event: Gec_Events;
  event_id: Scalars['Int']['output'];
  practice_group_id: Scalars['Int']['output'];
  /** An object relationship */
  practice_groups: Gec_Practice_Groups_Rollup;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "gec.practice_groups_in_event" */
export type Gec_Practice_Groups_In_Event_Aggregate_Order_By = {
  avg?: InputMaybe<Gec_Practice_Groups_In_Event_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gec_Practice_Groups_In_Event_Max_Order_By>;
  min?: InputMaybe<Gec_Practice_Groups_In_Event_Min_Order_By>;
  stddev?: InputMaybe<Gec_Practice_Groups_In_Event_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Gec_Practice_Groups_In_Event_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Gec_Practice_Groups_In_Event_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Gec_Practice_Groups_In_Event_Sum_Order_By>;
  var_pop?: InputMaybe<Gec_Practice_Groups_In_Event_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Gec_Practice_Groups_In_Event_Var_Samp_Order_By>;
  variance?: InputMaybe<Gec_Practice_Groups_In_Event_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "gec.practice_groups_in_event" */
export type Gec_Practice_Groups_In_Event_Arr_Rel_Insert_Input = {
  data: Array<Gec_Practice_Groups_In_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gec_Practice_Groups_In_Event_On_Conflict>;
};

/** order by avg() on columns of table "gec.practice_groups_in_event" */
export type Gec_Practice_Groups_In_Event_Avg_Order_By = {
  event_id?: InputMaybe<Order_By>;
  practice_group_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "gec.practice_groups_in_event". All fields are combined with a logical 'AND'. */
export type Gec_Practice_Groups_In_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Practice_Groups_In_Event_Bool_Exp>>;
  _not?: InputMaybe<Gec_Practice_Groups_In_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Practice_Groups_In_Event_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Gec_Events_Bool_Exp>;
  event_id?: InputMaybe<Int_Comparison_Exp>;
  practice_group_id?: InputMaybe<Int_Comparison_Exp>;
  practice_groups?: InputMaybe<Gec_Practice_Groups_Rollup_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "gec.practice_groups_in_event" */
export enum Gec_Practice_Groups_In_Event_Constraint {
  /** unique or primary key constraint on columns "event_id", "practice_group_id" */
  Practice_groups_in_event_pkey = 'practice_groups_in_event_pkey',
}

/** input type for incrementing numeric columns in table "gec.practice_groups_in_event" */
export type Gec_Practice_Groups_In_Event_Inc_Input = {
  event_id?: InputMaybe<Scalars['Int']['input']>;
  practice_group_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "gec.practice_groups_in_event" */
export type Gec_Practice_Groups_In_Event_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Gec_Events_Obj_Rel_Insert_Input>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  practice_group_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "gec.practice_groups_in_event" */
export type Gec_Practice_Groups_In_Event_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  practice_group_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "gec.practice_groups_in_event" */
export type Gec_Practice_Groups_In_Event_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  practice_group_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gec.practice_groups_in_event" */
export type Gec_Practice_Groups_In_Event_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gec_Practice_Groups_In_Event>;
};

/** on_conflict condition type for table "gec.practice_groups_in_event" */
export type Gec_Practice_Groups_In_Event_On_Conflict = {
  constraint: Gec_Practice_Groups_In_Event_Constraint;
  update_columns?: Array<Gec_Practice_Groups_In_Event_Update_Column>;
  where?: InputMaybe<Gec_Practice_Groups_In_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "gec.practice_groups_in_event". */
export type Gec_Practice_Groups_In_Event_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event?: InputMaybe<Gec_Events_Order_By>;
  event_id?: InputMaybe<Order_By>;
  practice_group_id?: InputMaybe<Order_By>;
  practice_groups?: InputMaybe<Gec_Practice_Groups_Rollup_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gec.practice_groups_in_event */
export type Gec_Practice_Groups_In_Event_Pk_Columns_Input = {
  event_id: Scalars['Int']['input'];
  practice_group_id: Scalars['Int']['input'];
};

/** select columns of table "gec.practice_groups_in_event" */
export enum Gec_Practice_Groups_In_Event_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Practice_group_id = 'practice_group_id',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "gec.practice_groups_in_event" */
export type Gec_Practice_Groups_In_Event_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  practice_group_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "gec.practice_groups_in_event" */
export type Gec_Practice_Groups_In_Event_Stddev_Order_By = {
  event_id?: InputMaybe<Order_By>;
  practice_group_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "gec.practice_groups_in_event" */
export type Gec_Practice_Groups_In_Event_Stddev_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
  practice_group_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "gec.practice_groups_in_event" */
export type Gec_Practice_Groups_In_Event_Stddev_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
  practice_group_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "gec_practice_groups_in_event" */
export type Gec_Practice_Groups_In_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Practice_Groups_In_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Practice_Groups_In_Event_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  practice_group_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "gec.practice_groups_in_event" */
export type Gec_Practice_Groups_In_Event_Sum_Order_By = {
  event_id?: InputMaybe<Order_By>;
  practice_group_id?: InputMaybe<Order_By>;
};

/** update columns of table "gec.practice_groups_in_event" */
export enum Gec_Practice_Groups_In_Event_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Practice_group_id = 'practice_group_id',
  /** column name */
  Updated_at = 'updated_at',
}

export type Gec_Practice_Groups_In_Event_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gec_Practice_Groups_In_Event_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gec_Practice_Groups_In_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gec_Practice_Groups_In_Event_Bool_Exp;
};

/** order by var_pop() on columns of table "gec.practice_groups_in_event" */
export type Gec_Practice_Groups_In_Event_Var_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
  practice_group_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "gec.practice_groups_in_event" */
export type Gec_Practice_Groups_In_Event_Var_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
  practice_group_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "gec.practice_groups_in_event" */
export type Gec_Practice_Groups_In_Event_Variance_Order_By = {
  event_id?: InputMaybe<Order_By>;
  practice_group_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "gec.practice_groups_rollup" */
export type Gec_Practice_Groups_Rollup = {
  abbreviation: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  group_code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  practice_groups_in_event: Array<Gec_Practice_Groups_In_Event>;
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "gec.practice_groups_rollup" */
export type Gec_Practice_Groups_RollupPractice_Groups_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Practice_Groups_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Practice_Groups_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Practice_Groups_In_Event_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "gec.practice_groups_rollup". All fields are combined with a logical 'AND'. */
export type Gec_Practice_Groups_Rollup_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Practice_Groups_Rollup_Bool_Exp>>;
  _not?: InputMaybe<Gec_Practice_Groups_Rollup_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Practice_Groups_Rollup_Bool_Exp>>;
  abbreviation?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  group_code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  practice_groups_in_event?: InputMaybe<Gec_Practice_Groups_In_Event_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "gec.practice_groups_rollup". */
export type Gec_Practice_Groups_Rollup_Order_By = {
  abbreviation?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  group_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  practice_groups_in_event_aggregate?: InputMaybe<Gec_Practice_Groups_In_Event_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "gec.practice_groups_rollup" */
export enum Gec_Practice_Groups_Rollup_Select_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Group_code = 'group_code',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Updated_at = 'updated_at',
}

/** Streaming cursor of the table "gec_practice_groups_rollup" */
export type Gec_Practice_Groups_Rollup_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Practice_Groups_Rollup_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Practice_Groups_Rollup_Stream_Cursor_Value_Input = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "gec.speaker_in_event" */
export type Gec_Speaker_In_Event = {
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  event: Gec_Events;
  event_id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user?: Maybe<Mlfsl_Personnel>;
  user_id: Scalars['String']['output'];
};

/** order by aggregate values of table "gec.speaker_in_event" */
export type Gec_Speaker_In_Event_Aggregate_Order_By = {
  avg?: InputMaybe<Gec_Speaker_In_Event_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gec_Speaker_In_Event_Max_Order_By>;
  min?: InputMaybe<Gec_Speaker_In_Event_Min_Order_By>;
  stddev?: InputMaybe<Gec_Speaker_In_Event_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Gec_Speaker_In_Event_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Gec_Speaker_In_Event_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Gec_Speaker_In_Event_Sum_Order_By>;
  var_pop?: InputMaybe<Gec_Speaker_In_Event_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Gec_Speaker_In_Event_Var_Samp_Order_By>;
  variance?: InputMaybe<Gec_Speaker_In_Event_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "gec.speaker_in_event" */
export type Gec_Speaker_In_Event_Arr_Rel_Insert_Input = {
  data: Array<Gec_Speaker_In_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gec_Speaker_In_Event_On_Conflict>;
};

/** order by avg() on columns of table "gec.speaker_in_event" */
export type Gec_Speaker_In_Event_Avg_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "gec.speaker_in_event". All fields are combined with a logical 'AND'. */
export type Gec_Speaker_In_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Speaker_In_Event_Bool_Exp>>;
  _not?: InputMaybe<Gec_Speaker_In_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Speaker_In_Event_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Gec_Events_Bool_Exp>;
  event_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "gec.speaker_in_event" */
export enum Gec_Speaker_In_Event_Constraint {
  /** unique or primary key constraint on columns "user_id", "event_id" */
  Speaker_in_event_event_id_user_id_key = 'speaker_in_event_event_id_user_id_key',
  /** unique or primary key constraint on columns "user_id", "event_id" */
  Speaker_in_event_pkey = 'speaker_in_event_pkey',
}

/** input type for incrementing numeric columns in table "gec.speaker_in_event" */
export type Gec_Speaker_In_Event_Inc_Input = {
  event_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "gec.speaker_in_event" */
export type Gec_Speaker_In_Event_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Gec_Events_Obj_Rel_Insert_Input>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "gec.speaker_in_event" */
export type Gec_Speaker_In_Event_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "gec.speaker_in_event" */
export type Gec_Speaker_In_Event_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gec.speaker_in_event" */
export type Gec_Speaker_In_Event_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gec_Speaker_In_Event>;
};

/** on_conflict condition type for table "gec.speaker_in_event" */
export type Gec_Speaker_In_Event_On_Conflict = {
  constraint: Gec_Speaker_In_Event_Constraint;
  update_columns?: Array<Gec_Speaker_In_Event_Update_Column>;
  where?: InputMaybe<Gec_Speaker_In_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "gec.speaker_in_event". */
export type Gec_Speaker_In_Event_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event?: InputMaybe<Gec_Events_Order_By>;
  event_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gec.speaker_in_event */
export type Gec_Speaker_In_Event_Pk_Columns_Input = {
  event_id: Scalars['Int']['input'];
  user_id: Scalars['String']['input'];
};

/** select columns of table "gec.speaker_in_event" */
export enum Gec_Speaker_In_Event_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  User_id = 'user_id',
}

/** input type for updating data in table "gec.speaker_in_event" */
export type Gec_Speaker_In_Event_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "gec.speaker_in_event" */
export type Gec_Speaker_In_Event_Stddev_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "gec.speaker_in_event" */
export type Gec_Speaker_In_Event_Stddev_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "gec.speaker_in_event" */
export type Gec_Speaker_In_Event_Stddev_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "gec_speaker_in_event" */
export type Gec_Speaker_In_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Speaker_In_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Speaker_In_Event_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "gec.speaker_in_event" */
export type Gec_Speaker_In_Event_Sum_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** update columns of table "gec.speaker_in_event" */
export enum Gec_Speaker_In_Event_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  User_id = 'user_id',
}

export type Gec_Speaker_In_Event_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gec_Speaker_In_Event_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gec_Speaker_In_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gec_Speaker_In_Event_Bool_Exp;
};

/** order by var_pop() on columns of table "gec.speaker_in_event" */
export type Gec_Speaker_In_Event_Var_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "gec.speaker_in_event" */
export type Gec_Speaker_In_Event_Var_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "gec.speaker_in_event" */
export type Gec_Speaker_In_Event_Variance_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "gec.sponsoring_attorney_in_event" */
export type Gec_Sponsoring_Attorney_In_Event = {
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  event: Gec_Events;
  event_id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user?: Maybe<Mlfsl_Personnel>;
  user_id: Scalars['String']['output'];
};

/** order by aggregate values of table "gec.sponsoring_attorney_in_event" */
export type Gec_Sponsoring_Attorney_In_Event_Aggregate_Order_By = {
  avg?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Max_Order_By>;
  min?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Min_Order_By>;
  stddev?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Sum_Order_By>;
  var_pop?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Var_Samp_Order_By>;
  variance?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "gec.sponsoring_attorney_in_event" */
export type Gec_Sponsoring_Attorney_In_Event_Arr_Rel_Insert_Input = {
  data: Array<Gec_Sponsoring_Attorney_In_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_On_Conflict>;
};

/** order by avg() on columns of table "gec.sponsoring_attorney_in_event" */
export type Gec_Sponsoring_Attorney_In_Event_Avg_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "gec.sponsoring_attorney_in_event". All fields are combined with a logical 'AND'. */
export type Gec_Sponsoring_Attorney_In_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Gec_Sponsoring_Attorney_In_Event_Bool_Exp>>;
  _not?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Gec_Sponsoring_Attorney_In_Event_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Gec_Events_Bool_Exp>;
  event_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "gec.sponsoring_attorney_in_event" */
export enum Gec_Sponsoring_Attorney_In_Event_Constraint {
  /** unique or primary key constraint on columns "user_id", "event_id" */
  Sponsoring_attorney_in_event_event_id_user_id_key = 'sponsoring_attorney_in_event_event_id_user_id_key',
  /** unique or primary key constraint on columns "user_id", "event_id" */
  Sponsoring_attorney_in_event_pkey = 'sponsoring_attorney_in_event_pkey',
}

/** input type for incrementing numeric columns in table "gec.sponsoring_attorney_in_event" */
export type Gec_Sponsoring_Attorney_In_Event_Inc_Input = {
  event_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "gec.sponsoring_attorney_in_event" */
export type Gec_Sponsoring_Attorney_In_Event_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Gec_Events_Obj_Rel_Insert_Input>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "gec.sponsoring_attorney_in_event" */
export type Gec_Sponsoring_Attorney_In_Event_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "gec.sponsoring_attorney_in_event" */
export type Gec_Sponsoring_Attorney_In_Event_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gec.sponsoring_attorney_in_event" */
export type Gec_Sponsoring_Attorney_In_Event_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gec_Sponsoring_Attorney_In_Event>;
};

/** on_conflict condition type for table "gec.sponsoring_attorney_in_event" */
export type Gec_Sponsoring_Attorney_In_Event_On_Conflict = {
  constraint: Gec_Sponsoring_Attorney_In_Event_Constraint;
  update_columns?: Array<Gec_Sponsoring_Attorney_In_Event_Update_Column>;
  where?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "gec.sponsoring_attorney_in_event". */
export type Gec_Sponsoring_Attorney_In_Event_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event?: InputMaybe<Gec_Events_Order_By>;
  event_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gec.sponsoring_attorney_in_event */
export type Gec_Sponsoring_Attorney_In_Event_Pk_Columns_Input = {
  event_id: Scalars['Int']['input'];
  user_id: Scalars['String']['input'];
};

/** select columns of table "gec.sponsoring_attorney_in_event" */
export enum Gec_Sponsoring_Attorney_In_Event_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  User_id = 'user_id',
}

/** input type for updating data in table "gec.sponsoring_attorney_in_event" */
export type Gec_Sponsoring_Attorney_In_Event_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "gec.sponsoring_attorney_in_event" */
export type Gec_Sponsoring_Attorney_In_Event_Stddev_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "gec.sponsoring_attorney_in_event" */
export type Gec_Sponsoring_Attorney_In_Event_Stddev_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "gec.sponsoring_attorney_in_event" */
export type Gec_Sponsoring_Attorney_In_Event_Stddev_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "gec_sponsoring_attorney_in_event" */
export type Gec_Sponsoring_Attorney_In_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gec_Sponsoring_Attorney_In_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gec_Sponsoring_Attorney_In_Event_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "gec.sponsoring_attorney_in_event" */
export type Gec_Sponsoring_Attorney_In_Event_Sum_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** update columns of table "gec.sponsoring_attorney_in_event" */
export enum Gec_Sponsoring_Attorney_In_Event_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  User_id = 'user_id',
}

export type Gec_Sponsoring_Attorney_In_Event_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gec_Sponsoring_Attorney_In_Event_Bool_Exp;
};

/** order by var_pop() on columns of table "gec.sponsoring_attorney_in_event" */
export type Gec_Sponsoring_Attorney_In_Event_Var_Pop_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "gec.sponsoring_attorney_in_event" */
export type Gec_Sponsoring_Attorney_In_Event_Var_Samp_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "gec.sponsoring_attorney_in_event" */
export type Gec_Sponsoring_Attorney_In_Event_Variance_Order_By = {
  event_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "interval". All fields are combined with logical 'AND'. */
export type Interval_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['interval']['input']>;
  _gt?: InputMaybe<Scalars['interval']['input']>;
  _gte?: InputMaybe<Scalars['interval']['input']>;
  _in?: InputMaybe<Array<Scalars['interval']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['interval']['input']>;
  _lte?: InputMaybe<Scalars['interval']['input']>;
  _neq?: InputMaybe<Scalars['interval']['input']>;
  _nin?: InputMaybe<Array<Scalars['interval']['input']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the jsonpath return any item for the specified JSON value */
  _jsonb_path_exists?: InputMaybe<Scalars['String']['input']>;
  /** does the jsonpath predicate check return true for the specified JSON value */
  _jsonb_path_match?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "repl.Groups" */
export type Mlfsl_Ad_Group = {
  ADFormatSID?: Maybe<Scalars['String']['output']>;
  ADGroupId: Scalars['Int']['output'];
  AcctName?: Maybe<Scalars['String']['output']>;
  CN?: Maybe<Scalars['String']['output']>;
  ChangedDate?: Maybe<Scalars['datetime']['output']>;
  ContainsNoMembers?: Maybe<Scalars['Boolean']['output']>;
  CreatedDate?: Maybe<Scalars['datetime']['output']>;
  DistName?: Maybe<Scalars['String']['output']>;
  DomainKey: Scalars['Int']['output'];
  EMail?: Maybe<Scalars['String']['output']>;
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  FullDomainName?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  Join: Array<Mlfsl_Ad_Join>;
  /** An aggregate relationship */
  Join_aggregate: Mlfsl_Ad_Join_Aggregate;
  Login?: Maybe<Scalars['String']['output']>;
  Mgr?: Maybe<Scalars['String']['output']>;
  ModifyTimeStamp?: Maybe<Scalars['datetime']['output']>;
  ObjectGUID?: Maybe<Scalars['uniqueidentifier']['output']>;
  RowChecksum?: Maybe<Scalars['Int']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isDistributionGroup: Scalars['Boolean']['output'];
  isSecurityGroup: Scalars['Boolean']['output'];
  mnet_ad_group_link?: Maybe<Mnet_Ad_Group_Link>;
  sid?: Maybe<Scalars['varbinary']['output']>;
  sidText?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "repl.Groups" */
export type Mlfsl_Ad_GroupJoinArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Ad_Join_Order_By>>;
  where?: InputMaybe<Mlfsl_Ad_Join_Bool_Exp>;
};

/** columns and relationships of "repl.Groups" */
export type Mlfsl_Ad_GroupJoin_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Ad_Join_Order_By>>;
  where?: InputMaybe<Mlfsl_Ad_Join_Bool_Exp>;
};

/** aggregated selection of "repl.Groups" */
export type Mlfsl_Ad_Group_Aggregate = {
  aggregate?: Maybe<Mlfsl_Ad_Group_Aggregate_Fields>;
  nodes: Array<Mlfsl_Ad_Group>;
};

/** aggregate fields of "repl.Groups" */
export type Mlfsl_Ad_Group_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Ad_Group_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Ad_Group_Max_Fields>;
  min?: Maybe<Mlfsl_Ad_Group_Min_Fields>;
  stddev?: Maybe<Mlfsl_Ad_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Ad_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Ad_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Ad_Group_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Ad_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Ad_Group_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Ad_Group_Variance_Fields>;
};

/** aggregate fields of "repl.Groups" */
export type Mlfsl_Ad_Group_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Ad_Group_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mlfsl_Ad_Group_Avg_Fields = {
  ADGroupId?: Maybe<Scalars['Float']['output']>;
  DomainKey?: Maybe<Scalars['Float']['output']>;
  RowChecksum?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "repl.Groups". All fields are combined with a logical 'AND'. */
export type Mlfsl_Ad_Group_Bool_Exp = {
  ADFormatSID?: InputMaybe<String_Mssql_Comparison_Exp>;
  ADGroupId?: InputMaybe<Int_Mssql_Comparison_Exp>;
  AcctName?: InputMaybe<String_Mssql_Comparison_Exp>;
  CN?: InputMaybe<String_Mssql_Comparison_Exp>;
  ChangedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  ContainsNoMembers?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  CreatedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  DistName?: InputMaybe<String_Mssql_Comparison_Exp>;
  DomainKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EMail?: InputMaybe<String_Mssql_Comparison_Exp>;
  EtlCreatedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  EtlModifiedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  FullDomainName?: InputMaybe<String_Mssql_Comparison_Exp>;
  Join?: InputMaybe<Mlfsl_Ad_Join_Bool_Exp>;
  Login?: InputMaybe<String_Mssql_Comparison_Exp>;
  Mgr?: InputMaybe<String_Mssql_Comparison_Exp>;
  ModifyTimeStamp?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  ObjectGUID?: InputMaybe<Uniqueidentifier_Mssql_Comparison_Exp>;
  RowChecksum?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Ad_Group_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Ad_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Ad_Group_Bool_Exp>>;
  isDeleted?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  isDistributionGroup?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  isSecurityGroup?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  sid?: InputMaybe<Varbinary_Mssql_Comparison_Exp>;
  sidText?: InputMaybe<String_Mssql_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mlfsl_Ad_Group_Max_Fields = {
  ADFormatSID?: Maybe<Scalars['String']['output']>;
  ADGroupId?: Maybe<Scalars['Int']['output']>;
  AcctName?: Maybe<Scalars['String']['output']>;
  CN?: Maybe<Scalars['String']['output']>;
  ChangedDate?: Maybe<Scalars['datetime']['output']>;
  CreatedDate?: Maybe<Scalars['datetime']['output']>;
  DistName?: Maybe<Scalars['String']['output']>;
  DomainKey?: Maybe<Scalars['Int']['output']>;
  EMail?: Maybe<Scalars['String']['output']>;
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  FullDomainName?: Maybe<Scalars['String']['output']>;
  Login?: Maybe<Scalars['String']['output']>;
  Mgr?: Maybe<Scalars['String']['output']>;
  ModifyTimeStamp?: Maybe<Scalars['datetime']['output']>;
  RowChecksum?: Maybe<Scalars['Int']['output']>;
  sidText?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mlfsl_Ad_Group_Min_Fields = {
  ADFormatSID?: Maybe<Scalars['String']['output']>;
  ADGroupId?: Maybe<Scalars['Int']['output']>;
  AcctName?: Maybe<Scalars['String']['output']>;
  CN?: Maybe<Scalars['String']['output']>;
  ChangedDate?: Maybe<Scalars['datetime']['output']>;
  CreatedDate?: Maybe<Scalars['datetime']['output']>;
  DistName?: Maybe<Scalars['String']['output']>;
  DomainKey?: Maybe<Scalars['Int']['output']>;
  EMail?: Maybe<Scalars['String']['output']>;
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  FullDomainName?: Maybe<Scalars['String']['output']>;
  Login?: Maybe<Scalars['String']['output']>;
  Mgr?: Maybe<Scalars['String']['output']>;
  ModifyTimeStamp?: Maybe<Scalars['datetime']['output']>;
  RowChecksum?: Maybe<Scalars['Int']['output']>;
  sidText?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "repl.Groups". */
export type Mlfsl_Ad_Group_Order_By = {
  ADFormatSID?: InputMaybe<Order_By>;
  ADGroupId?: InputMaybe<Order_By>;
  AcctName?: InputMaybe<Order_By>;
  CN?: InputMaybe<Order_By>;
  ChangedDate?: InputMaybe<Order_By>;
  ContainsNoMembers?: InputMaybe<Order_By>;
  CreatedDate?: InputMaybe<Order_By>;
  DistName?: InputMaybe<Order_By>;
  DomainKey?: InputMaybe<Order_By>;
  EMail?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  FullDomainName?: InputMaybe<Order_By>;
  Join_aggregate?: InputMaybe<Mlfsl_Ad_Join_Aggregate_Order_By>;
  Login?: InputMaybe<Order_By>;
  Mgr?: InputMaybe<Order_By>;
  ModifyTimeStamp?: InputMaybe<Order_By>;
  ObjectGUID?: InputMaybe<Order_By>;
  RowChecksum?: InputMaybe<Order_By>;
  isDeleted?: InputMaybe<Order_By>;
  isDistributionGroup?: InputMaybe<Order_By>;
  isSecurityGroup?: InputMaybe<Order_By>;
  sid?: InputMaybe<Order_By>;
  sidText?: InputMaybe<Order_By>;
};

/** select columns of table "repl.Groups" */
export enum Mlfsl_Ad_Group_Select_Column {
  /** column name */
  ADFormatSID = 'ADFormatSID',
  /** column name */
  ADGroupId = 'ADGroupId',
  /** column name */
  AcctName = 'AcctName',
  /** column name */
  CN = 'CN',
  /** column name */
  ChangedDate = 'ChangedDate',
  /** column name */
  ContainsNoMembers = 'ContainsNoMembers',
  /** column name */
  CreatedDate = 'CreatedDate',
  /** column name */
  DistName = 'DistName',
  /** column name */
  DomainKey = 'DomainKey',
  /** column name */
  EMail = 'EMail',
  /** column name */
  EtlCreatedDate = 'EtlCreatedDate',
  /** column name */
  EtlModifiedDate = 'EtlModifiedDate',
  /** column name */
  FullDomainName = 'FullDomainName',
  /** column name */
  Login = 'Login',
  /** column name */
  Mgr = 'Mgr',
  /** column name */
  ModifyTimeStamp = 'ModifyTimeStamp',
  /** column name */
  ObjectGUID = 'ObjectGUID',
  /** column name */
  RowChecksum = 'RowChecksum',
  /** column name */
  IsDeleted = 'isDeleted',
  /** column name */
  IsDistributionGroup = 'isDistributionGroup',
  /** column name */
  IsSecurityGroup = 'isSecurityGroup',
  /** column name */
  Sid = 'sid',
  /** column name */
  SidText = 'sidText',
}

/** aggregate stddev on columns */
export type Mlfsl_Ad_Group_Stddev_Fields = {
  ADGroupId?: Maybe<Scalars['Float']['output']>;
  DomainKey?: Maybe<Scalars['Float']['output']>;
  RowChecksum?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Ad_Group_Stddev_Pop_Fields = {
  ADGroupId?: Maybe<Scalars['Float']['output']>;
  DomainKey?: Maybe<Scalars['Float']['output']>;
  RowChecksum?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Ad_Group_Stddev_Samp_Fields = {
  ADGroupId?: Maybe<Scalars['Float']['output']>;
  DomainKey?: Maybe<Scalars['Float']['output']>;
  RowChecksum?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Mlfsl_Ad_Group_Sum_Fields = {
  ADGroupId?: Maybe<Scalars['Int']['output']>;
  DomainKey?: Maybe<Scalars['Int']['output']>;
  RowChecksum?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Ad_Group_Var_Pop_Fields = {
  ADGroupId?: Maybe<Scalars['Float']['output']>;
  DomainKey?: Maybe<Scalars['Float']['output']>;
  RowChecksum?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Ad_Group_Var_Samp_Fields = {
  ADGroupId?: Maybe<Scalars['Float']['output']>;
  DomainKey?: Maybe<Scalars['Float']['output']>;
  RowChecksum?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mlfsl_Ad_Group_Variance_Fields = {
  ADGroupId?: Maybe<Scalars['Float']['output']>;
  DomainKey?: Maybe<Scalars['Float']['output']>;
  RowChecksum?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "repl.Joins" */
export type Mlfsl_Ad_Join = {
  DomainName?: Maybe<Scalars['String']['output']>;
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  /** An object relationship */
  Group?: Maybe<Mlfsl_Ad_Group>;
  GroupObjectGUID?: Maybe<Scalars['uniqueidentifier']['output']>;
  GroupsamAccountName?: Maybe<Scalars['String']['output']>;
  JoinsRowKey: Scalars['Int']['output'];
  /** An object relationship */
  Login?: Maybe<Mlfsl_Ad_Login>;
  UserFullName?: Maybe<Scalars['String']['output']>;
  UserLogin?: Maybe<Scalars['String']['output']>;
  UserObjectGUID?: Maybe<Scalars['uniqueidentifier']['output']>;
  isDistributionGroup: Scalars['Boolean']['output'];
  isSecurityGroup: Scalars['Boolean']['output'];
  nestedGroupLevel?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "repl.Joins" */
export type Mlfsl_Ad_Join_Aggregate = {
  aggregate?: Maybe<Mlfsl_Ad_Join_Aggregate_Fields>;
  nodes: Array<Mlfsl_Ad_Join>;
};

/** aggregate fields of "repl.Joins" */
export type Mlfsl_Ad_Join_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Ad_Join_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Ad_Join_Max_Fields>;
  min?: Maybe<Mlfsl_Ad_Join_Min_Fields>;
  stddev?: Maybe<Mlfsl_Ad_Join_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Ad_Join_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Ad_Join_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Ad_Join_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Ad_Join_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Ad_Join_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Ad_Join_Variance_Fields>;
};

/** aggregate fields of "repl.Joins" */
export type Mlfsl_Ad_Join_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Ad_Join_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "repl.Joins" */
export type Mlfsl_Ad_Join_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Ad_Join_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Ad_Join_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Ad_Join_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Ad_Join_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Ad_Join_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Ad_Join_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Ad_Join_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Ad_Join_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Ad_Join_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Ad_Join_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Mlfsl_Ad_Join_Avg_Fields = {
  JoinsRowKey?: Maybe<Scalars['Float']['output']>;
  nestedGroupLevel?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "repl.Joins" */
export type Mlfsl_Ad_Join_Avg_Order_By = {
  JoinsRowKey?: InputMaybe<Order_By>;
  nestedGroupLevel?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "repl.Joins". All fields are combined with a logical 'AND'. */
export type Mlfsl_Ad_Join_Bool_Exp = {
  DomainName?: InputMaybe<String_Mssql_Comparison_Exp>;
  EtlCreatedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  EtlModifiedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  Group?: InputMaybe<Mlfsl_Ad_Group_Bool_Exp>;
  GroupObjectGUID?: InputMaybe<Uniqueidentifier_Mssql_Comparison_Exp>;
  GroupsamAccountName?: InputMaybe<String_Mssql_Comparison_Exp>;
  JoinsRowKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  Login?: InputMaybe<Mlfsl_Ad_Login_Bool_Exp>;
  UserFullName?: InputMaybe<String_Mssql_Comparison_Exp>;
  UserLogin?: InputMaybe<String_Mssql_Comparison_Exp>;
  UserObjectGUID?: InputMaybe<Uniqueidentifier_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Ad_Join_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Ad_Join_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Ad_Join_Bool_Exp>>;
  isDistributionGroup?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  isSecurityGroup?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  nestedGroupLevel?: InputMaybe<Int_Mssql_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mlfsl_Ad_Join_Max_Fields = {
  DomainName?: Maybe<Scalars['String']['output']>;
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  GroupsamAccountName?: Maybe<Scalars['String']['output']>;
  JoinsRowKey?: Maybe<Scalars['Int']['output']>;
  UserFullName?: Maybe<Scalars['String']['output']>;
  UserLogin?: Maybe<Scalars['String']['output']>;
  nestedGroupLevel?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "repl.Joins" */
export type Mlfsl_Ad_Join_Max_Order_By = {
  DomainName?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  GroupsamAccountName?: InputMaybe<Order_By>;
  JoinsRowKey?: InputMaybe<Order_By>;
  UserFullName?: InputMaybe<Order_By>;
  UserLogin?: InputMaybe<Order_By>;
  nestedGroupLevel?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mlfsl_Ad_Join_Min_Fields = {
  DomainName?: Maybe<Scalars['String']['output']>;
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  GroupsamAccountName?: Maybe<Scalars['String']['output']>;
  JoinsRowKey?: Maybe<Scalars['Int']['output']>;
  UserFullName?: Maybe<Scalars['String']['output']>;
  UserLogin?: Maybe<Scalars['String']['output']>;
  nestedGroupLevel?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "repl.Joins" */
export type Mlfsl_Ad_Join_Min_Order_By = {
  DomainName?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  GroupsamAccountName?: InputMaybe<Order_By>;
  JoinsRowKey?: InputMaybe<Order_By>;
  UserFullName?: InputMaybe<Order_By>;
  UserLogin?: InputMaybe<Order_By>;
  nestedGroupLevel?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "repl.Joins". */
export type Mlfsl_Ad_Join_Order_By = {
  DomainName?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  Group?: InputMaybe<Mlfsl_Ad_Group_Order_By>;
  GroupObjectGUID?: InputMaybe<Order_By>;
  GroupsamAccountName?: InputMaybe<Order_By>;
  JoinsRowKey?: InputMaybe<Order_By>;
  Login?: InputMaybe<Mlfsl_Ad_Login_Order_By>;
  UserFullName?: InputMaybe<Order_By>;
  UserLogin?: InputMaybe<Order_By>;
  UserObjectGUID?: InputMaybe<Order_By>;
  isDistributionGroup?: InputMaybe<Order_By>;
  isSecurityGroup?: InputMaybe<Order_By>;
  nestedGroupLevel?: InputMaybe<Order_By>;
};

/** select columns of table "repl.Joins" */
export enum Mlfsl_Ad_Join_Select_Column {
  /** column name */
  DomainName = 'DomainName',
  /** column name */
  EtlCreatedDate = 'EtlCreatedDate',
  /** column name */
  EtlModifiedDate = 'EtlModifiedDate',
  /** column name */
  GroupObjectGUID = 'GroupObjectGUID',
  /** column name */
  GroupsamAccountName = 'GroupsamAccountName',
  /** column name */
  JoinsRowKey = 'JoinsRowKey',
  /** column name */
  UserFullName = 'UserFullName',
  /** column name */
  UserLogin = 'UserLogin',
  /** column name */
  UserObjectGUID = 'UserObjectGUID',
  /** column name */
  IsDistributionGroup = 'isDistributionGroup',
  /** column name */
  IsSecurityGroup = 'isSecurityGroup',
  /** column name */
  NestedGroupLevel = 'nestedGroupLevel',
}

/** aggregate stddev on columns */
export type Mlfsl_Ad_Join_Stddev_Fields = {
  JoinsRowKey?: Maybe<Scalars['Float']['output']>;
  nestedGroupLevel?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "repl.Joins" */
export type Mlfsl_Ad_Join_Stddev_Order_By = {
  JoinsRowKey?: InputMaybe<Order_By>;
  nestedGroupLevel?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Ad_Join_Stddev_Pop_Fields = {
  JoinsRowKey?: Maybe<Scalars['Float']['output']>;
  nestedGroupLevel?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "repl.Joins" */
export type Mlfsl_Ad_Join_Stddev_Pop_Order_By = {
  JoinsRowKey?: InputMaybe<Order_By>;
  nestedGroupLevel?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Ad_Join_Stddev_Samp_Fields = {
  JoinsRowKey?: Maybe<Scalars['Float']['output']>;
  nestedGroupLevel?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "repl.Joins" */
export type Mlfsl_Ad_Join_Stddev_Samp_Order_By = {
  JoinsRowKey?: InputMaybe<Order_By>;
  nestedGroupLevel?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Mlfsl_Ad_Join_Sum_Fields = {
  JoinsRowKey?: Maybe<Scalars['Int']['output']>;
  nestedGroupLevel?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "repl.Joins" */
export type Mlfsl_Ad_Join_Sum_Order_By = {
  JoinsRowKey?: InputMaybe<Order_By>;
  nestedGroupLevel?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Ad_Join_Var_Pop_Fields = {
  JoinsRowKey?: Maybe<Scalars['Float']['output']>;
  nestedGroupLevel?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "repl.Joins" */
export type Mlfsl_Ad_Join_Var_Pop_Order_By = {
  JoinsRowKey?: InputMaybe<Order_By>;
  nestedGroupLevel?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Ad_Join_Var_Samp_Fields = {
  JoinsRowKey?: Maybe<Scalars['Float']['output']>;
  nestedGroupLevel?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "repl.Joins" */
export type Mlfsl_Ad_Join_Var_Samp_Order_By = {
  JoinsRowKey?: InputMaybe<Order_By>;
  nestedGroupLevel?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mlfsl_Ad_Join_Variance_Fields = {
  JoinsRowKey?: Maybe<Scalars['Float']['output']>;
  nestedGroupLevel?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "repl.Joins" */
export type Mlfsl_Ad_Join_Variance_Order_By = {
  JoinsRowKey?: InputMaybe<Order_By>;
  nestedGroupLevel?: InputMaybe<Order_By>;
};

/** columns and relationships of "repl.Logins" */
export type Mlfsl_Ad_Login = {
  ADFormatSID?: Maybe<Scalars['String']['output']>;
  AcctCtrl?: Maybe<Scalars['String']['output']>;
  AdLoginId: Scalars['Int']['output'];
  CN?: Maybe<Scalars['String']['output']>;
  ChangedDate?: Maybe<Scalars['datetime']['output']>;
  CreatedDate?: Maybe<Scalars['datetime']['output']>;
  Dept?: Maybe<Scalars['String']['output']>;
  DistName?: Maybe<Scalars['String']['output']>;
  DomainKey?: Maybe<Scalars['Int']['output']>;
  EMail?: Maybe<Scalars['String']['output']>;
  EmployeeID?: Maybe<Scalars['String']['output']>;
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  FullDomainName?: Maybe<Scalars['String']['output']>;
  FullDomainUserName?: Maybe<Scalars['String']['output']>;
  FullName?: Maybe<Scalars['String']['output']>;
  HomeDb?: Maybe<Scalars['String']['output']>;
  Info?: Maybe<Scalars['String']['output']>;
  Initials?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  Join: Array<Mlfsl_Ad_Join>;
  /** An aggregate relationship */
  Join_aggregate: Mlfsl_Ad_Join_Aggregate;
  LastLogoff?: Maybe<Scalars['datetime2']['output']>;
  LastLogon?: Maybe<Scalars['datetime2']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  Login?: Maybe<Scalars['String']['output']>;
  Mgr?: Maybe<Scalars['String']['output']>;
  ModifyTimeStamp?: Maybe<Scalars['datetime']['output']>;
  ObjectGUID?: Maybe<Scalars['uniqueidentifier']['output']>;
  /** An object relationship */
  Person?: Maybe<Mlfsl_Personnel>;
  Phone?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  businessCategory?: Maybe<Scalars['String']['output']>;
  homeDirectory?: Maybe<Scalars['String']['output']>;
  isAccountEnabled?: Maybe<Scalars['Boolean']['output']>;
  objectCategory?: Maybe<Scalars['String']['output']>;
  objectClass?: Maybe<Scalars['String']['output']>;
  sid?: Maybe<Scalars['varbinary']['output']>;
};

/** columns and relationships of "repl.Logins" */
export type Mlfsl_Ad_LoginJoinArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Ad_Join_Order_By>>;
  where?: InputMaybe<Mlfsl_Ad_Join_Bool_Exp>;
};

/** columns and relationships of "repl.Logins" */
export type Mlfsl_Ad_LoginJoin_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Ad_Join_Order_By>>;
  where?: InputMaybe<Mlfsl_Ad_Join_Bool_Exp>;
};

/** aggregated selection of "repl.Logins" */
export type Mlfsl_Ad_Login_Aggregate = {
  aggregate?: Maybe<Mlfsl_Ad_Login_Aggregate_Fields>;
  nodes: Array<Mlfsl_Ad_Login>;
};

/** aggregate fields of "repl.Logins" */
export type Mlfsl_Ad_Login_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Ad_Login_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Ad_Login_Max_Fields>;
  min?: Maybe<Mlfsl_Ad_Login_Min_Fields>;
  stddev?: Maybe<Mlfsl_Ad_Login_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Ad_Login_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Ad_Login_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Ad_Login_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Ad_Login_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Ad_Login_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Ad_Login_Variance_Fields>;
};

/** aggregate fields of "repl.Logins" */
export type Mlfsl_Ad_Login_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Ad_Login_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mlfsl_Ad_Login_Avg_Fields = {
  AdLoginId?: Maybe<Scalars['Float']['output']>;
  DomainKey?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "repl.Logins". All fields are combined with a logical 'AND'. */
export type Mlfsl_Ad_Login_Bool_Exp = {
  ADFormatSID?: InputMaybe<String_Mssql_Comparison_Exp>;
  AcctCtrl?: InputMaybe<String_Mssql_Comparison_Exp>;
  AdLoginId?: InputMaybe<Int_Mssql_Comparison_Exp>;
  CN?: InputMaybe<String_Mssql_Comparison_Exp>;
  ChangedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  CreatedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  Dept?: InputMaybe<String_Mssql_Comparison_Exp>;
  DistName?: InputMaybe<String_Mssql_Comparison_Exp>;
  DomainKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EMail?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmployeeID?: InputMaybe<String_Mssql_Comparison_Exp>;
  EtlCreatedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  EtlModifiedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  FirstName?: InputMaybe<String_Mssql_Comparison_Exp>;
  FullDomainName?: InputMaybe<String_Mssql_Comparison_Exp>;
  FullDomainUserName?: InputMaybe<String_Mssql_Comparison_Exp>;
  FullName?: InputMaybe<String_Mssql_Comparison_Exp>;
  HomeDb?: InputMaybe<String_Mssql_Comparison_Exp>;
  Info?: InputMaybe<String_Mssql_Comparison_Exp>;
  Initials?: InputMaybe<String_Mssql_Comparison_Exp>;
  Join?: InputMaybe<Mlfsl_Ad_Join_Bool_Exp>;
  LastLogoff?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  LastLogon?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  LastName?: InputMaybe<String_Mssql_Comparison_Exp>;
  Login?: InputMaybe<String_Mssql_Comparison_Exp>;
  Mgr?: InputMaybe<String_Mssql_Comparison_Exp>;
  ModifyTimeStamp?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  ObjectGUID?: InputMaybe<Uniqueidentifier_Mssql_Comparison_Exp>;
  Person?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
  Phone?: InputMaybe<String_Mssql_Comparison_Exp>;
  Title?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Ad_Login_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Ad_Login_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Ad_Login_Bool_Exp>>;
  businessCategory?: InputMaybe<String_Mssql_Comparison_Exp>;
  homeDirectory?: InputMaybe<String_Mssql_Comparison_Exp>;
  isAccountEnabled?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  objectCategory?: InputMaybe<String_Mssql_Comparison_Exp>;
  objectClass?: InputMaybe<String_Mssql_Comparison_Exp>;
  sid?: InputMaybe<Varbinary_Mssql_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mlfsl_Ad_Login_Max_Fields = {
  ADFormatSID?: Maybe<Scalars['String']['output']>;
  AcctCtrl?: Maybe<Scalars['String']['output']>;
  AdLoginId?: Maybe<Scalars['Int']['output']>;
  CN?: Maybe<Scalars['String']['output']>;
  ChangedDate?: Maybe<Scalars['datetime']['output']>;
  CreatedDate?: Maybe<Scalars['datetime']['output']>;
  Dept?: Maybe<Scalars['String']['output']>;
  DistName?: Maybe<Scalars['String']['output']>;
  DomainKey?: Maybe<Scalars['Int']['output']>;
  EMail?: Maybe<Scalars['String']['output']>;
  EmployeeID?: Maybe<Scalars['String']['output']>;
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  FullDomainName?: Maybe<Scalars['String']['output']>;
  FullDomainUserName?: Maybe<Scalars['String']['output']>;
  FullName?: Maybe<Scalars['String']['output']>;
  HomeDb?: Maybe<Scalars['String']['output']>;
  Info?: Maybe<Scalars['String']['output']>;
  Initials?: Maybe<Scalars['String']['output']>;
  LastLogoff?: Maybe<Scalars['datetime2']['output']>;
  LastLogon?: Maybe<Scalars['datetime2']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  Login?: Maybe<Scalars['String']['output']>;
  Mgr?: Maybe<Scalars['String']['output']>;
  ModifyTimeStamp?: Maybe<Scalars['datetime']['output']>;
  Phone?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  businessCategory?: Maybe<Scalars['String']['output']>;
  homeDirectory?: Maybe<Scalars['String']['output']>;
  objectCategory?: Maybe<Scalars['String']['output']>;
  objectClass?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mlfsl_Ad_Login_Min_Fields = {
  ADFormatSID?: Maybe<Scalars['String']['output']>;
  AcctCtrl?: Maybe<Scalars['String']['output']>;
  AdLoginId?: Maybe<Scalars['Int']['output']>;
  CN?: Maybe<Scalars['String']['output']>;
  ChangedDate?: Maybe<Scalars['datetime']['output']>;
  CreatedDate?: Maybe<Scalars['datetime']['output']>;
  Dept?: Maybe<Scalars['String']['output']>;
  DistName?: Maybe<Scalars['String']['output']>;
  DomainKey?: Maybe<Scalars['Int']['output']>;
  EMail?: Maybe<Scalars['String']['output']>;
  EmployeeID?: Maybe<Scalars['String']['output']>;
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  FullDomainName?: Maybe<Scalars['String']['output']>;
  FullDomainUserName?: Maybe<Scalars['String']['output']>;
  FullName?: Maybe<Scalars['String']['output']>;
  HomeDb?: Maybe<Scalars['String']['output']>;
  Info?: Maybe<Scalars['String']['output']>;
  Initials?: Maybe<Scalars['String']['output']>;
  LastLogoff?: Maybe<Scalars['datetime2']['output']>;
  LastLogon?: Maybe<Scalars['datetime2']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  Login?: Maybe<Scalars['String']['output']>;
  Mgr?: Maybe<Scalars['String']['output']>;
  ModifyTimeStamp?: Maybe<Scalars['datetime']['output']>;
  Phone?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  businessCategory?: Maybe<Scalars['String']['output']>;
  homeDirectory?: Maybe<Scalars['String']['output']>;
  objectCategory?: Maybe<Scalars['String']['output']>;
  objectClass?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "repl.Logins". */
export type Mlfsl_Ad_Login_Order_By = {
  ADFormatSID?: InputMaybe<Order_By>;
  AcctCtrl?: InputMaybe<Order_By>;
  AdLoginId?: InputMaybe<Order_By>;
  CN?: InputMaybe<Order_By>;
  ChangedDate?: InputMaybe<Order_By>;
  CreatedDate?: InputMaybe<Order_By>;
  Dept?: InputMaybe<Order_By>;
  DistName?: InputMaybe<Order_By>;
  DomainKey?: InputMaybe<Order_By>;
  EMail?: InputMaybe<Order_By>;
  EmployeeID?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  FirstName?: InputMaybe<Order_By>;
  FullDomainName?: InputMaybe<Order_By>;
  FullDomainUserName?: InputMaybe<Order_By>;
  FullName?: InputMaybe<Order_By>;
  HomeDb?: InputMaybe<Order_By>;
  Info?: InputMaybe<Order_By>;
  Initials?: InputMaybe<Order_By>;
  Join_aggregate?: InputMaybe<Mlfsl_Ad_Join_Aggregate_Order_By>;
  LastLogoff?: InputMaybe<Order_By>;
  LastLogon?: InputMaybe<Order_By>;
  LastName?: InputMaybe<Order_By>;
  Login?: InputMaybe<Order_By>;
  Mgr?: InputMaybe<Order_By>;
  ModifyTimeStamp?: InputMaybe<Order_By>;
  ObjectGUID?: InputMaybe<Order_By>;
  Person?: InputMaybe<Mlfsl_Personnel_Order_By>;
  Phone?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  businessCategory?: InputMaybe<Order_By>;
  homeDirectory?: InputMaybe<Order_By>;
  isAccountEnabled?: InputMaybe<Order_By>;
  objectCategory?: InputMaybe<Order_By>;
  objectClass?: InputMaybe<Order_By>;
  sid?: InputMaybe<Order_By>;
};

/** select columns of table "repl.Logins" */
export enum Mlfsl_Ad_Login_Select_Column {
  /** column name */
  ADFormatSID = 'ADFormatSID',
  /** column name */
  AcctCtrl = 'AcctCtrl',
  /** column name */
  AdLoginId = 'AdLoginId',
  /** column name */
  CN = 'CN',
  /** column name */
  ChangedDate = 'ChangedDate',
  /** column name */
  CreatedDate = 'CreatedDate',
  /** column name */
  Dept = 'Dept',
  /** column name */
  DistName = 'DistName',
  /** column name */
  DomainKey = 'DomainKey',
  /** column name */
  EMail = 'EMail',
  /** column name */
  EmployeeID = 'EmployeeID',
  /** column name */
  EtlCreatedDate = 'EtlCreatedDate',
  /** column name */
  EtlModifiedDate = 'EtlModifiedDate',
  /** column name */
  FirstName = 'FirstName',
  /** column name */
  FullDomainName = 'FullDomainName',
  /** column name */
  FullDomainUserName = 'FullDomainUserName',
  /** column name */
  FullName = 'FullName',
  /** column name */
  HomeDb = 'HomeDb',
  /** column name */
  Info = 'Info',
  /** column name */
  Initials = 'Initials',
  /** column name */
  LastLogoff = 'LastLogoff',
  /** column name */
  LastLogon = 'LastLogon',
  /** column name */
  LastName = 'LastName',
  /** column name */
  Login = 'Login',
  /** column name */
  Mgr = 'Mgr',
  /** column name */
  ModifyTimeStamp = 'ModifyTimeStamp',
  /** column name */
  ObjectGUID = 'ObjectGUID',
  /** column name */
  Phone = 'Phone',
  /** column name */
  Title = 'Title',
  /** column name */
  BusinessCategory = 'businessCategory',
  /** column name */
  HomeDirectory = 'homeDirectory',
  /** column name */
  IsAccountEnabled = 'isAccountEnabled',
  /** column name */
  ObjectCategory = 'objectCategory',
  /** column name */
  ObjectClass = 'objectClass',
  /** column name */
  Sid = 'sid',
}

/** aggregate stddev on columns */
export type Mlfsl_Ad_Login_Stddev_Fields = {
  AdLoginId?: Maybe<Scalars['Float']['output']>;
  DomainKey?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Ad_Login_Stddev_Pop_Fields = {
  AdLoginId?: Maybe<Scalars['Float']['output']>;
  DomainKey?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Ad_Login_Stddev_Samp_Fields = {
  AdLoginId?: Maybe<Scalars['Float']['output']>;
  DomainKey?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Mlfsl_Ad_Login_Sum_Fields = {
  AdLoginId?: Maybe<Scalars['Int']['output']>;
  DomainKey?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Ad_Login_Var_Pop_Fields = {
  AdLoginId?: Maybe<Scalars['Float']['output']>;
  DomainKey?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Ad_Login_Var_Samp_Fields = {
  AdLoginId?: Maybe<Scalars['Float']['output']>;
  DomainKey?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mlfsl_Ad_Login_Variance_Fields = {
  AdLoginId?: Maybe<Scalars['Float']['output']>;
  DomainKey?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "repl.DimClientNow" */
export type Mlfsl_Client = {
  AdministrativeFlag?: Maybe<Scalars['String']['output']>;
  ClientAddress1?: Maybe<Scalars['String']['output']>;
  ClientAddress2?: Maybe<Scalars['String']['output']>;
  ClientAddress3?: Maybe<Scalars['String']['output']>;
  ClientAddress4?: Maybe<Scalars['String']['output']>;
  ClientAddress5?: Maybe<Scalars['String']['output']>;
  ClientAddress6?: Maybe<Scalars['String']['output']>;
  ClientArrangementCode?: Maybe<Scalars['String']['output']>;
  ClientArrangementCodeDescription?: Maybe<Scalars['String']['output']>;
  ClientCity?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  ClientClosedDate?: Maybe<Mlfsl_Date>;
  ClientContact?: Maybe<Scalars['String']['output']>;
  ClientCountry?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  ClientDisplayDescription?: Maybe<Mlfsl_Client_Display_Description>;
  ClientGUID?: Maybe<Scalars['uniqueidentifier']['output']>;
  ClientIndex?: Maybe<Scalars['Int']['output']>;
  ClientName1?: Maybe<Scalars['String']['output']>;
  ClientName2?: Maybe<Scalars['String']['output']>;
  ClientNameDisplay?: Maybe<Scalars['String']['output']>;
  ClientNumber: Scalars['String']['output'];
  ClientNumberGroupCodeInd?: Maybe<Scalars['Boolean']['output']>;
  ClientNumberIwov?: Maybe<Scalars['String']['output']>;
  ClientNumberNoGroupCode?: Maybe<Scalars['String']['output']>;
  ClientNumberWithDash?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  ClientOpenDate?: Maybe<Mlfsl_Date>;
  ClientPhoneNumber?: Maybe<Scalars['String']['output']>;
  ClientPricingNarrative?: Maybe<Scalars['String']['output']>;
  ClientReferredBy?: Maybe<Scalars['String']['output']>;
  ClientSortName?: Maybe<Scalars['String']['output']>;
  ClientSourceAbbreviation?: Maybe<Scalars['String']['output']>;
  ClientSourceName?: Maybe<Scalars['String']['output']>;
  ClientSourceNumber?: Maybe<Scalars['String']['output']>;
  ClientState?: Maybe<Scalars['String']['output']>;
  ClientStatusCode?: Maybe<Scalars['String']['output']>;
  ClientStatusCodeActive?: Maybe<Scalars['String']['output']>;
  ClientStatusDescription?: Maybe<Scalars['String']['output']>;
  ClientZipCode?: Maybe<Scalars['String']['output']>;
  Confidential?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  ConflictsAttorney?: Maybe<Mlfsl_Personnel>;
  ConflictsAttorneyTKID?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  CoordinatingResponsibleAttorney?: Maybe<Mlfsl_Personnel>;
  CoordinatingResponsibleAttorneyTKID?: Maybe<Scalars['String']['output']>;
  DateClientClosed?: Maybe<Scalars['Int']['output']>;
  DateClientOpen?: Maybe<Scalars['Int']['output']>;
  DeletedRecordIndicator: Scalars['String']['output'];
  DimClientNowKey: Scalars['Int']['output'];
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  ETLSoftInsertIndicator?: Maybe<Scalars['String']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
  EtlCreatedDate: Scalars['datetime']['output'];
  EtlModifiedDate: Scalars['datetime']['output'];
  IndustryDescription?: Maybe<Scalars['String']['output']>;
  InventoryExceptionCode?: Maybe<Scalars['String']['output']>;
  InventoryExceptionDescription?: Maybe<Scalars['String']['output']>;
  IsClientAllianceProgram?: Maybe<Scalars['Int']['output']>;
  LocationCode?: Maybe<Scalars['String']['output']>;
  MatterStop?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  Matters: Array<Mlfsl_Matter>;
  /** An aggregate relationship */
  Matters_aggregate: Mlfsl_Matter_Aggregate;
  /** An object relationship */
  MorganNetClientPage_ClientInfo?: Maybe<Mlfsl_Morgannet_ClientPage_ClientInfo>;
  /** An object relationship */
  RelatedClient?: Maybe<Mlfsl_Related_Client>;
  RelatedClientName?: Maybe<Scalars['String']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  ResponsibleAttorney?: Maybe<Mlfsl_Personnel>;
  ResponsibleAttorneyTkId?: Maybe<Scalars['String']['output']>;
  SecureAlliManageMatterWorkspacesFlag?: Maybe<Scalars['String']['output']>;
  SegmentDescription?: Maybe<Scalars['String']['output']>;
  SicCodeAndDescription?: Maybe<Scalars['String']['output']>;
  SicDescription?: Maybe<Scalars['String']['output']>;
  SicTypeCode?: Maybe<Scalars['String']['output']>;
  WallBuilderEntityId?: Maybe<Scalars['Int']['output']>;
  client_intel_settings?: Maybe<Mnet_Client_Intel_Settings>;
  clientbadge_client: Array<Mnet_Clientbadge_Client>;
  clientbadge_client_aggregate: Mnet_Clientbadge_Client_Aggregate;
  clientbadge_client_exclusion: Array<Mnet_Clientbadge_Client_Exclusion>;
  clientbadge_client_exclusion_aggregate: Mnet_Clientbadge_Client_Exclusion_Aggregate;
  cmap_clm_engagement_record?: Maybe<Clm_Engagement_Records>;
  /** An array relationship */
  mlfsl_finance_hours_clientofficetimeframes: Array<Mlfsl_Finance_Hours_Clientofficetimeframe>;
  /** An array relationship */
  mlfsl_finance_hours_clientpgtimeframes: Array<Mlfsl_Finance_Hours_Clientpgtimeframe>;
  /** An array relationship */
  mlfsl_finance_hours_clienttimeframes: Array<Mlfsl_Finance_Hours_Clienttimeframe>;
  /** An aggregate relationship */
  mlfsl_finance_hours_clienttimeframes_aggregate: Mlfsl_Finance_Hours_Clienttimeframe_Aggregate;
  /** An array relationship */
  mlfsl_finance_hours_clienttimekeepertimeframes: Array<Mlfsl_Finance_Hours_Clienttimekeepertimeframe>;
  /** An aggregate relationship */
  mlfsl_finance_hours_clienttimekeepertimeframes_aggregate: Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Aggregate;
  /** An array relationship */
  mlfsl_finance_hours_matterofficetimeframes: Array<Mlfsl_Finance_Hours_Matterofficetimeframe>;
  /** An array relationship */
  mlfsl_finance_hours_matterpgtimeframes: Array<Mlfsl_Finance_Hours_Matterpgtimeframe>;
  /** An array relationship */
  mlfsl_finance_hours_mattertimeframecompares: Array<Mlfsl_Finance_Hours_Mattertimeframecompare>;
  /** An array relationship */
  mlfsl_finance_hours_mattertimeframes: Array<Mlfsl_Finance_Hours_Mattertimeframe>;
  /** An aggregate relationship */
  mlfsl_finance_hours_mattertimeframes_aggregate: Mlfsl_Finance_Hours_Mattertimeframe_Aggregate;
  /** An object relationship */
  mlfsl_mlv_finance_hours_client?: Maybe<Mlfsl_Mlv_Finance_Hours_Client>;
};

/** columns and relationships of "repl.DimClientNow" */
export type Mlfsl_ClientMattersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Matter_Order_By>>;
  where?: InputMaybe<Mlfsl_Matter_Bool_Exp>;
};

/** columns and relationships of "repl.DimClientNow" */
export type Mlfsl_ClientMatters_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Matter_Order_By>>;
  where?: InputMaybe<Mlfsl_Matter_Bool_Exp>;
};

/** columns and relationships of "repl.DimClientNow" */
export type Mlfsl_ClientClientbadge_ClientArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Client_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Client_Bool_Exp>;
};

/** columns and relationships of "repl.DimClientNow" */
export type Mlfsl_ClientClientbadge_Client_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Client_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Client_Bool_Exp>;
};

/** columns and relationships of "repl.DimClientNow" */
export type Mlfsl_ClientClientbadge_Client_ExclusionArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Client_Exclusion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Client_Exclusion_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Client_Exclusion_Bool_Exp>;
};

/** columns and relationships of "repl.DimClientNow" */
export type Mlfsl_ClientClientbadge_Client_Exclusion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Client_Exclusion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Client_Exclusion_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Client_Exclusion_Bool_Exp>;
};

/** columns and relationships of "repl.DimClientNow" */
export type Mlfsl_ClientMlfsl_Finance_Hours_ClientofficetimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clientofficetimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clientofficetimeframe_Bool_Exp>;
};

/** columns and relationships of "repl.DimClientNow" */
export type Mlfsl_ClientMlfsl_Finance_Hours_ClientpgtimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clientpgtimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clientpgtimeframe_Bool_Exp>;
};

/** columns and relationships of "repl.DimClientNow" */
export type Mlfsl_ClientMlfsl_Finance_Hours_ClienttimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clienttimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Bool_Exp>;
};

/** columns and relationships of "repl.DimClientNow" */
export type Mlfsl_ClientMlfsl_Finance_Hours_Clienttimeframes_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clienttimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Bool_Exp>;
};

/** columns and relationships of "repl.DimClientNow" */
export type Mlfsl_ClientMlfsl_Finance_Hours_ClienttimekeepertimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Bool_Exp>;
};

/** columns and relationships of "repl.DimClientNow" */
export type Mlfsl_ClientMlfsl_Finance_Hours_Clienttimekeepertimeframes_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Bool_Exp>;
};

/** columns and relationships of "repl.DimClientNow" */
export type Mlfsl_ClientMlfsl_Finance_Hours_MatterofficetimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Matterofficetimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Bool_Exp>;
};

/** columns and relationships of "repl.DimClientNow" */
export type Mlfsl_ClientMlfsl_Finance_Hours_MatterpgtimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Matterpgtimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Bool_Exp>;
};

/** columns and relationships of "repl.DimClientNow" */
export type Mlfsl_ClientMlfsl_Finance_Hours_MattertimeframecomparesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimeframecompare_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Bool_Exp>;
};

/** columns and relationships of "repl.DimClientNow" */
export type Mlfsl_ClientMlfsl_Finance_Hours_MattertimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp>;
};

/** columns and relationships of "repl.DimClientNow" */
export type Mlfsl_ClientMlfsl_Finance_Hours_Mattertimeframes_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp>;
};

/** aggregated selection of "repl.DimClientNow" */
export type Mlfsl_Client_Aggregate = {
  aggregate?: Maybe<Mlfsl_Client_Aggregate_Fields>;
  nodes: Array<Mlfsl_Client>;
};

/** aggregate fields of "repl.DimClientNow" */
export type Mlfsl_Client_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Client_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Client_Max_Fields>;
  min?: Maybe<Mlfsl_Client_Min_Fields>;
  stddev?: Maybe<Mlfsl_Client_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Client_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Client_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Client_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Client_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Client_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Client_Variance_Fields>;
};

/** aggregate fields of "repl.DimClientNow" */
export type Mlfsl_Client_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Client_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "repl.DimClientNow" */
export type Mlfsl_Client_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Client_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Client_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Client_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Client_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Client_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Client_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Client_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Client_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Client_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Client_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Mlfsl_Client_Avg_Fields = {
  ClientIndex?: Maybe<Scalars['Float']['output']>;
  DateClientClosed?: Maybe<Scalars['Float']['output']>;
  DateClientOpen?: Maybe<Scalars['Float']['output']>;
  DimClientNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  IsClientAllianceProgram?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "repl.DimClientNow" */
export type Mlfsl_Client_Avg_Order_By = {
  ClientIndex?: InputMaybe<Order_By>;
  DateClientClosed?: InputMaybe<Order_By>;
  DateClientOpen?: InputMaybe<Order_By>;
  DimClientNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  IsClientAllianceProgram?: InputMaybe<Order_By>;
  WallBuilderEntityId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "repl.DimClientNow". All fields are combined with a logical 'AND'. */
export type Mlfsl_Client_Bool_Exp = {
  AdministrativeFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientAddress1?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientAddress2?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientAddress3?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientAddress4?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientAddress5?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientAddress6?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientArrangementCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientArrangementCodeDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientCity?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientClosedDate?: InputMaybe<Mlfsl_Date_Bool_Exp>;
  ClientContact?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientCountry?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientDisplayDescription?: InputMaybe<Mlfsl_Client_Display_Description_Bool_Exp>;
  ClientGUID?: InputMaybe<Uniqueidentifier_Mssql_Comparison_Exp>;
  ClientIndex?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ClientName1?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientName2?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientNameDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientNumberGroupCodeInd?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  ClientNumberIwov?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientNumberNoGroupCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientNumberWithDash?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientOpenDate?: InputMaybe<Mlfsl_Date_Bool_Exp>;
  ClientPhoneNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientPricingNarrative?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientReferredBy?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientSortName?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientSourceAbbreviation?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientSourceName?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientSourceNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientState?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientStatusCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientStatusCodeActive?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientStatusDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientZipCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  Confidential?: InputMaybe<String_Mssql_Comparison_Exp>;
  ConflictsAttorney?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
  ConflictsAttorneyTKID?: InputMaybe<String_Mssql_Comparison_Exp>;
  CoordinatingResponsibleAttorney?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
  CoordinatingResponsibleAttorneyTKID?: InputMaybe<String_Mssql_Comparison_Exp>;
  DateClientClosed?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DateClientOpen?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DeletedRecordIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  DimClientNowKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLBatchKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLSoftInsertIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  EtlChecksum?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EtlCreatedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  EtlModifiedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  IndustryDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  InventoryExceptionCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  InventoryExceptionDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  IsClientAllianceProgram?: InputMaybe<Int_Mssql_Comparison_Exp>;
  LocationCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterStop?: InputMaybe<String_Mssql_Comparison_Exp>;
  Matters?: InputMaybe<Mlfsl_Matter_Bool_Exp>;
  MorganNetClientPage_ClientInfo?: InputMaybe<Mlfsl_Morgannet_ClientPage_ClientInfo_Bool_Exp>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Bool_Exp>;
  RelatedClientName?: InputMaybe<String_Mssql_Comparison_Exp>;
  RelatedClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  ResponsibleAttorney?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
  ResponsibleAttorneyTkId?: InputMaybe<String_Mssql_Comparison_Exp>;
  SecureAlliManageMatterWorkspacesFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  SegmentDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  SicCodeAndDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  SicDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  SicTypeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  WallBuilderEntityId?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Client_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Client_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Client_Bool_Exp>>;
  mlfsl_finance_hours_clientofficetimeframes?: InputMaybe<Mlfsl_Finance_Hours_Clientofficetimeframe_Bool_Exp>;
  mlfsl_finance_hours_clientpgtimeframes?: InputMaybe<Mlfsl_Finance_Hours_Clientpgtimeframe_Bool_Exp>;
  mlfsl_finance_hours_clienttimeframes?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Bool_Exp>;
  mlfsl_finance_hours_clienttimekeepertimeframes?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Bool_Exp>;
  mlfsl_finance_hours_matterofficetimeframes?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Bool_Exp>;
  mlfsl_finance_hours_matterpgtimeframes?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Bool_Exp>;
  mlfsl_finance_hours_mattertimeframecompares?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Bool_Exp>;
  mlfsl_finance_hours_mattertimeframes?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp>;
  mlfsl_mlv_finance_hours_client?: InputMaybe<Mlfsl_Mlv_Finance_Hours_Client_Bool_Exp>;
};

/** columns and relationships of "MLG.Client_DisplayDescription" */
export type Mlfsl_Client_Display_Description = {
  /** An object relationship */
  Client?: Maybe<Mlfsl_Client>;
  ID: Scalars['String']['output'];
  locationforum?: Maybe<Scalars['String']['output']>;
  narrative?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "MLG.Client_DisplayDescription". All fields are combined with a logical 'AND'. */
export type Mlfsl_Client_Display_Description_Bool_Exp = {
  Client?: InputMaybe<Mlfsl_Client_Bool_Exp>;
  ID?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Client_Display_Description_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Client_Display_Description_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Client_Display_Description_Bool_Exp>>;
  locationforum?: InputMaybe<String_Mssql_Comparison_Exp>;
  narrative?: InputMaybe<String_Mssql_Comparison_Exp>;
};

/** Ordering options when selecting data from "MLG.Client_DisplayDescription". */
export type Mlfsl_Client_Display_Description_Order_By = {
  Client?: InputMaybe<Mlfsl_Client_Order_By>;
  ID?: InputMaybe<Order_By>;
  locationforum?: InputMaybe<Order_By>;
  narrative?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Mlfsl_Client_Max_Fields = {
  AdministrativeFlag?: Maybe<Scalars['String']['output']>;
  ClientAddress1?: Maybe<Scalars['String']['output']>;
  ClientAddress2?: Maybe<Scalars['String']['output']>;
  ClientAddress3?: Maybe<Scalars['String']['output']>;
  ClientAddress4?: Maybe<Scalars['String']['output']>;
  ClientAddress5?: Maybe<Scalars['String']['output']>;
  ClientAddress6?: Maybe<Scalars['String']['output']>;
  ClientArrangementCode?: Maybe<Scalars['String']['output']>;
  ClientArrangementCodeDescription?: Maybe<Scalars['String']['output']>;
  ClientCity?: Maybe<Scalars['String']['output']>;
  ClientContact?: Maybe<Scalars['String']['output']>;
  ClientCountry?: Maybe<Scalars['String']['output']>;
  ClientIndex?: Maybe<Scalars['Int']['output']>;
  ClientName1?: Maybe<Scalars['String']['output']>;
  ClientName2?: Maybe<Scalars['String']['output']>;
  ClientNameDisplay?: Maybe<Scalars['String']['output']>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  ClientNumberIwov?: Maybe<Scalars['String']['output']>;
  ClientNumberNoGroupCode?: Maybe<Scalars['String']['output']>;
  ClientNumberWithDash?: Maybe<Scalars['String']['output']>;
  ClientPhoneNumber?: Maybe<Scalars['String']['output']>;
  ClientPricingNarrative?: Maybe<Scalars['String']['output']>;
  ClientReferredBy?: Maybe<Scalars['String']['output']>;
  ClientSortName?: Maybe<Scalars['String']['output']>;
  ClientSourceAbbreviation?: Maybe<Scalars['String']['output']>;
  ClientSourceName?: Maybe<Scalars['String']['output']>;
  ClientSourceNumber?: Maybe<Scalars['String']['output']>;
  ClientState?: Maybe<Scalars['String']['output']>;
  ClientStatusCode?: Maybe<Scalars['String']['output']>;
  ClientStatusCodeActive?: Maybe<Scalars['String']['output']>;
  ClientStatusDescription?: Maybe<Scalars['String']['output']>;
  ClientZipCode?: Maybe<Scalars['String']['output']>;
  Confidential?: Maybe<Scalars['String']['output']>;
  ConflictsAttorneyTKID?: Maybe<Scalars['String']['output']>;
  CoordinatingResponsibleAttorneyTKID?: Maybe<Scalars['String']['output']>;
  DateClientClosed?: Maybe<Scalars['Int']['output']>;
  DateClientOpen?: Maybe<Scalars['Int']['output']>;
  DeletedRecordIndicator?: Maybe<Scalars['String']['output']>;
  DimClientNowKey?: Maybe<Scalars['Int']['output']>;
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  ETLSoftInsertIndicator?: Maybe<Scalars['String']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  IndustryDescription?: Maybe<Scalars['String']['output']>;
  InventoryExceptionCode?: Maybe<Scalars['String']['output']>;
  InventoryExceptionDescription?: Maybe<Scalars['String']['output']>;
  IsClientAllianceProgram?: Maybe<Scalars['Int']['output']>;
  LocationCode?: Maybe<Scalars['String']['output']>;
  MatterStop?: Maybe<Scalars['String']['output']>;
  RelatedClientName?: Maybe<Scalars['String']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorneyTkId?: Maybe<Scalars['String']['output']>;
  SecureAlliManageMatterWorkspacesFlag?: Maybe<Scalars['String']['output']>;
  SegmentDescription?: Maybe<Scalars['String']['output']>;
  SicCodeAndDescription?: Maybe<Scalars['String']['output']>;
  SicDescription?: Maybe<Scalars['String']['output']>;
  SicTypeCode?: Maybe<Scalars['String']['output']>;
  WallBuilderEntityId?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "repl.DimClientNow" */
export type Mlfsl_Client_Max_Order_By = {
  AdministrativeFlag?: InputMaybe<Order_By>;
  ClientAddress1?: InputMaybe<Order_By>;
  ClientAddress2?: InputMaybe<Order_By>;
  ClientAddress3?: InputMaybe<Order_By>;
  ClientAddress4?: InputMaybe<Order_By>;
  ClientAddress5?: InputMaybe<Order_By>;
  ClientAddress6?: InputMaybe<Order_By>;
  ClientArrangementCode?: InputMaybe<Order_By>;
  ClientArrangementCodeDescription?: InputMaybe<Order_By>;
  ClientCity?: InputMaybe<Order_By>;
  ClientContact?: InputMaybe<Order_By>;
  ClientCountry?: InputMaybe<Order_By>;
  ClientIndex?: InputMaybe<Order_By>;
  ClientName1?: InputMaybe<Order_By>;
  ClientName2?: InputMaybe<Order_By>;
  ClientNameDisplay?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  ClientNumberIwov?: InputMaybe<Order_By>;
  ClientNumberNoGroupCode?: InputMaybe<Order_By>;
  ClientNumberWithDash?: InputMaybe<Order_By>;
  ClientPhoneNumber?: InputMaybe<Order_By>;
  ClientPricingNarrative?: InputMaybe<Order_By>;
  ClientReferredBy?: InputMaybe<Order_By>;
  ClientSortName?: InputMaybe<Order_By>;
  ClientSourceAbbreviation?: InputMaybe<Order_By>;
  ClientSourceName?: InputMaybe<Order_By>;
  ClientSourceNumber?: InputMaybe<Order_By>;
  ClientState?: InputMaybe<Order_By>;
  ClientStatusCode?: InputMaybe<Order_By>;
  ClientStatusCodeActive?: InputMaybe<Order_By>;
  ClientStatusDescription?: InputMaybe<Order_By>;
  ClientZipCode?: InputMaybe<Order_By>;
  Confidential?: InputMaybe<Order_By>;
  ConflictsAttorneyTKID?: InputMaybe<Order_By>;
  CoordinatingResponsibleAttorneyTKID?: InputMaybe<Order_By>;
  DateClientClosed?: InputMaybe<Order_By>;
  DateClientOpen?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DimClientNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLSoftInsertIndicator?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  IndustryDescription?: InputMaybe<Order_By>;
  InventoryExceptionCode?: InputMaybe<Order_By>;
  InventoryExceptionDescription?: InputMaybe<Order_By>;
  IsClientAllianceProgram?: InputMaybe<Order_By>;
  LocationCode?: InputMaybe<Order_By>;
  MatterStop?: InputMaybe<Order_By>;
  RelatedClientName?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  ResponsibleAttorneyTkId?: InputMaybe<Order_By>;
  SecureAlliManageMatterWorkspacesFlag?: InputMaybe<Order_By>;
  SegmentDescription?: InputMaybe<Order_By>;
  SicCodeAndDescription?: InputMaybe<Order_By>;
  SicDescription?: InputMaybe<Order_By>;
  SicTypeCode?: InputMaybe<Order_By>;
  WallBuilderEntityId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mlfsl_Client_Min_Fields = {
  AdministrativeFlag?: Maybe<Scalars['String']['output']>;
  ClientAddress1?: Maybe<Scalars['String']['output']>;
  ClientAddress2?: Maybe<Scalars['String']['output']>;
  ClientAddress3?: Maybe<Scalars['String']['output']>;
  ClientAddress4?: Maybe<Scalars['String']['output']>;
  ClientAddress5?: Maybe<Scalars['String']['output']>;
  ClientAddress6?: Maybe<Scalars['String']['output']>;
  ClientArrangementCode?: Maybe<Scalars['String']['output']>;
  ClientArrangementCodeDescription?: Maybe<Scalars['String']['output']>;
  ClientCity?: Maybe<Scalars['String']['output']>;
  ClientContact?: Maybe<Scalars['String']['output']>;
  ClientCountry?: Maybe<Scalars['String']['output']>;
  ClientIndex?: Maybe<Scalars['Int']['output']>;
  ClientName1?: Maybe<Scalars['String']['output']>;
  ClientName2?: Maybe<Scalars['String']['output']>;
  ClientNameDisplay?: Maybe<Scalars['String']['output']>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  ClientNumberIwov?: Maybe<Scalars['String']['output']>;
  ClientNumberNoGroupCode?: Maybe<Scalars['String']['output']>;
  ClientNumberWithDash?: Maybe<Scalars['String']['output']>;
  ClientPhoneNumber?: Maybe<Scalars['String']['output']>;
  ClientPricingNarrative?: Maybe<Scalars['String']['output']>;
  ClientReferredBy?: Maybe<Scalars['String']['output']>;
  ClientSortName?: Maybe<Scalars['String']['output']>;
  ClientSourceAbbreviation?: Maybe<Scalars['String']['output']>;
  ClientSourceName?: Maybe<Scalars['String']['output']>;
  ClientSourceNumber?: Maybe<Scalars['String']['output']>;
  ClientState?: Maybe<Scalars['String']['output']>;
  ClientStatusCode?: Maybe<Scalars['String']['output']>;
  ClientStatusCodeActive?: Maybe<Scalars['String']['output']>;
  ClientStatusDescription?: Maybe<Scalars['String']['output']>;
  ClientZipCode?: Maybe<Scalars['String']['output']>;
  Confidential?: Maybe<Scalars['String']['output']>;
  ConflictsAttorneyTKID?: Maybe<Scalars['String']['output']>;
  CoordinatingResponsibleAttorneyTKID?: Maybe<Scalars['String']['output']>;
  DateClientClosed?: Maybe<Scalars['Int']['output']>;
  DateClientOpen?: Maybe<Scalars['Int']['output']>;
  DeletedRecordIndicator?: Maybe<Scalars['String']['output']>;
  DimClientNowKey?: Maybe<Scalars['Int']['output']>;
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  ETLSoftInsertIndicator?: Maybe<Scalars['String']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  IndustryDescription?: Maybe<Scalars['String']['output']>;
  InventoryExceptionCode?: Maybe<Scalars['String']['output']>;
  InventoryExceptionDescription?: Maybe<Scalars['String']['output']>;
  IsClientAllianceProgram?: Maybe<Scalars['Int']['output']>;
  LocationCode?: Maybe<Scalars['String']['output']>;
  MatterStop?: Maybe<Scalars['String']['output']>;
  RelatedClientName?: Maybe<Scalars['String']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorneyTkId?: Maybe<Scalars['String']['output']>;
  SecureAlliManageMatterWorkspacesFlag?: Maybe<Scalars['String']['output']>;
  SegmentDescription?: Maybe<Scalars['String']['output']>;
  SicCodeAndDescription?: Maybe<Scalars['String']['output']>;
  SicDescription?: Maybe<Scalars['String']['output']>;
  SicTypeCode?: Maybe<Scalars['String']['output']>;
  WallBuilderEntityId?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "repl.DimClientNow" */
export type Mlfsl_Client_Min_Order_By = {
  AdministrativeFlag?: InputMaybe<Order_By>;
  ClientAddress1?: InputMaybe<Order_By>;
  ClientAddress2?: InputMaybe<Order_By>;
  ClientAddress3?: InputMaybe<Order_By>;
  ClientAddress4?: InputMaybe<Order_By>;
  ClientAddress5?: InputMaybe<Order_By>;
  ClientAddress6?: InputMaybe<Order_By>;
  ClientArrangementCode?: InputMaybe<Order_By>;
  ClientArrangementCodeDescription?: InputMaybe<Order_By>;
  ClientCity?: InputMaybe<Order_By>;
  ClientContact?: InputMaybe<Order_By>;
  ClientCountry?: InputMaybe<Order_By>;
  ClientIndex?: InputMaybe<Order_By>;
  ClientName1?: InputMaybe<Order_By>;
  ClientName2?: InputMaybe<Order_By>;
  ClientNameDisplay?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  ClientNumberIwov?: InputMaybe<Order_By>;
  ClientNumberNoGroupCode?: InputMaybe<Order_By>;
  ClientNumberWithDash?: InputMaybe<Order_By>;
  ClientPhoneNumber?: InputMaybe<Order_By>;
  ClientPricingNarrative?: InputMaybe<Order_By>;
  ClientReferredBy?: InputMaybe<Order_By>;
  ClientSortName?: InputMaybe<Order_By>;
  ClientSourceAbbreviation?: InputMaybe<Order_By>;
  ClientSourceName?: InputMaybe<Order_By>;
  ClientSourceNumber?: InputMaybe<Order_By>;
  ClientState?: InputMaybe<Order_By>;
  ClientStatusCode?: InputMaybe<Order_By>;
  ClientStatusCodeActive?: InputMaybe<Order_By>;
  ClientStatusDescription?: InputMaybe<Order_By>;
  ClientZipCode?: InputMaybe<Order_By>;
  Confidential?: InputMaybe<Order_By>;
  ConflictsAttorneyTKID?: InputMaybe<Order_By>;
  CoordinatingResponsibleAttorneyTKID?: InputMaybe<Order_By>;
  DateClientClosed?: InputMaybe<Order_By>;
  DateClientOpen?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DimClientNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLSoftInsertIndicator?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  IndustryDescription?: InputMaybe<Order_By>;
  InventoryExceptionCode?: InputMaybe<Order_By>;
  InventoryExceptionDescription?: InputMaybe<Order_By>;
  IsClientAllianceProgram?: InputMaybe<Order_By>;
  LocationCode?: InputMaybe<Order_By>;
  MatterStop?: InputMaybe<Order_By>;
  RelatedClientName?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  ResponsibleAttorneyTkId?: InputMaybe<Order_By>;
  SecureAlliManageMatterWorkspacesFlag?: InputMaybe<Order_By>;
  SegmentDescription?: InputMaybe<Order_By>;
  SicCodeAndDescription?: InputMaybe<Order_By>;
  SicDescription?: InputMaybe<Order_By>;
  SicTypeCode?: InputMaybe<Order_By>;
  WallBuilderEntityId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "repl.DimClientNow". */
export type Mlfsl_Client_Order_By = {
  AdministrativeFlag?: InputMaybe<Order_By>;
  ClientAddress1?: InputMaybe<Order_By>;
  ClientAddress2?: InputMaybe<Order_By>;
  ClientAddress3?: InputMaybe<Order_By>;
  ClientAddress4?: InputMaybe<Order_By>;
  ClientAddress5?: InputMaybe<Order_By>;
  ClientAddress6?: InputMaybe<Order_By>;
  ClientArrangementCode?: InputMaybe<Order_By>;
  ClientArrangementCodeDescription?: InputMaybe<Order_By>;
  ClientCity?: InputMaybe<Order_By>;
  ClientClosedDate?: InputMaybe<Mlfsl_Date_Order_By>;
  ClientContact?: InputMaybe<Order_By>;
  ClientCountry?: InputMaybe<Order_By>;
  ClientDisplayDescription?: InputMaybe<Mlfsl_Client_Display_Description_Order_By>;
  ClientGUID?: InputMaybe<Order_By>;
  ClientIndex?: InputMaybe<Order_By>;
  ClientName1?: InputMaybe<Order_By>;
  ClientName2?: InputMaybe<Order_By>;
  ClientNameDisplay?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  ClientNumberGroupCodeInd?: InputMaybe<Order_By>;
  ClientNumberIwov?: InputMaybe<Order_By>;
  ClientNumberNoGroupCode?: InputMaybe<Order_By>;
  ClientNumberWithDash?: InputMaybe<Order_By>;
  ClientOpenDate?: InputMaybe<Mlfsl_Date_Order_By>;
  ClientPhoneNumber?: InputMaybe<Order_By>;
  ClientPricingNarrative?: InputMaybe<Order_By>;
  ClientReferredBy?: InputMaybe<Order_By>;
  ClientSortName?: InputMaybe<Order_By>;
  ClientSourceAbbreviation?: InputMaybe<Order_By>;
  ClientSourceName?: InputMaybe<Order_By>;
  ClientSourceNumber?: InputMaybe<Order_By>;
  ClientState?: InputMaybe<Order_By>;
  ClientStatusCode?: InputMaybe<Order_By>;
  ClientStatusCodeActive?: InputMaybe<Order_By>;
  ClientStatusDescription?: InputMaybe<Order_By>;
  ClientZipCode?: InputMaybe<Order_By>;
  Confidential?: InputMaybe<Order_By>;
  ConflictsAttorney?: InputMaybe<Mlfsl_Personnel_Order_By>;
  ConflictsAttorneyTKID?: InputMaybe<Order_By>;
  CoordinatingResponsibleAttorney?: InputMaybe<Mlfsl_Personnel_Order_By>;
  CoordinatingResponsibleAttorneyTKID?: InputMaybe<Order_By>;
  DateClientClosed?: InputMaybe<Order_By>;
  DateClientOpen?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DimClientNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLSoftInsertIndicator?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  IndustryDescription?: InputMaybe<Order_By>;
  InventoryExceptionCode?: InputMaybe<Order_By>;
  InventoryExceptionDescription?: InputMaybe<Order_By>;
  IsClientAllianceProgram?: InputMaybe<Order_By>;
  LocationCode?: InputMaybe<Order_By>;
  MatterStop?: InputMaybe<Order_By>;
  Matters_aggregate?: InputMaybe<Mlfsl_Matter_Aggregate_Order_By>;
  MorganNetClientPage_ClientInfo?: InputMaybe<Mlfsl_Morgannet_ClientPage_ClientInfo_Order_By>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Order_By>;
  RelatedClientName?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  ResponsibleAttorney?: InputMaybe<Mlfsl_Personnel_Order_By>;
  ResponsibleAttorneyTkId?: InputMaybe<Order_By>;
  SecureAlliManageMatterWorkspacesFlag?: InputMaybe<Order_By>;
  SegmentDescription?: InputMaybe<Order_By>;
  SicCodeAndDescription?: InputMaybe<Order_By>;
  SicDescription?: InputMaybe<Order_By>;
  SicTypeCode?: InputMaybe<Order_By>;
  WallBuilderEntityId?: InputMaybe<Order_By>;
  mlfsl_finance_hours_clientofficetimeframes_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Clientofficetimeframe_Aggregate_Order_By>;
  mlfsl_finance_hours_clientpgtimeframes_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Clientpgtimeframe_Aggregate_Order_By>;
  mlfsl_finance_hours_clienttimeframes_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Aggregate_Order_By>;
  mlfsl_finance_hours_clienttimekeepertimeframes_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Aggregate_Order_By>;
  mlfsl_finance_hours_matterofficetimeframes_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Aggregate_Order_By>;
  mlfsl_finance_hours_matterpgtimeframes_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Aggregate_Order_By>;
  mlfsl_finance_hours_mattertimeframecompares_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Aggregate_Order_By>;
  mlfsl_finance_hours_mattertimeframes_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Aggregate_Order_By>;
  mlfsl_mlv_finance_hours_client?: InputMaybe<Mlfsl_Mlv_Finance_Hours_Client_Order_By>;
};

/** select columns of table "repl.DimClientNow" */
export enum Mlfsl_Client_Select_Column {
  /** column name */
  AdministrativeFlag = 'AdministrativeFlag',
  /** column name */
  ClientAddress1 = 'ClientAddress1',
  /** column name */
  ClientAddress2 = 'ClientAddress2',
  /** column name */
  ClientAddress3 = 'ClientAddress3',
  /** column name */
  ClientAddress4 = 'ClientAddress4',
  /** column name */
  ClientAddress5 = 'ClientAddress5',
  /** column name */
  ClientAddress6 = 'ClientAddress6',
  /** column name */
  ClientArrangementCode = 'ClientArrangementCode',
  /** column name */
  ClientArrangementCodeDescription = 'ClientArrangementCodeDescription',
  /** column name */
  ClientCity = 'ClientCity',
  /** column name */
  ClientContact = 'ClientContact',
  /** column name */
  ClientCountry = 'ClientCountry',
  /** column name */
  ClientGUID = 'ClientGUID',
  /** column name */
  ClientIndex = 'ClientIndex',
  /** column name */
  ClientName1 = 'ClientName1',
  /** column name */
  ClientName2 = 'ClientName2',
  /** column name */
  ClientNameDisplay = 'ClientNameDisplay',
  /** column name */
  ClientNumber = 'ClientNumber',
  /** column name */
  ClientNumberGroupCodeInd = 'ClientNumberGroupCodeInd',
  /** column name */
  ClientNumberIwov = 'ClientNumberIwov',
  /** column name */
  ClientNumberNoGroupCode = 'ClientNumberNoGroupCode',
  /** column name */
  ClientNumberWithDash = 'ClientNumberWithDash',
  /** column name */
  ClientPhoneNumber = 'ClientPhoneNumber',
  /** column name */
  ClientPricingNarrative = 'ClientPricingNarrative',
  /** column name */
  ClientReferredBy = 'ClientReferredBy',
  /** column name */
  ClientSortName = 'ClientSortName',
  /** column name */
  ClientSourceAbbreviation = 'ClientSourceAbbreviation',
  /** column name */
  ClientSourceName = 'ClientSourceName',
  /** column name */
  ClientSourceNumber = 'ClientSourceNumber',
  /** column name */
  ClientState = 'ClientState',
  /** column name */
  ClientStatusCode = 'ClientStatusCode',
  /** column name */
  ClientStatusCodeActive = 'ClientStatusCodeActive',
  /** column name */
  ClientStatusDescription = 'ClientStatusDescription',
  /** column name */
  ClientZipCode = 'ClientZipCode',
  /** column name */
  Confidential = 'Confidential',
  /** column name */
  ConflictsAttorneyTKID = 'ConflictsAttorneyTKID',
  /** column name */
  CoordinatingResponsibleAttorneyTKID = 'CoordinatingResponsibleAttorneyTKID',
  /** column name */
  DateClientClosed = 'DateClientClosed',
  /** column name */
  DateClientOpen = 'DateClientOpen',
  /** column name */
  DeletedRecordIndicator = 'DeletedRecordIndicator',
  /** column name */
  DimClientNowKey = 'DimClientNowKey',
  /** column name */
  ETLBatchKey = 'ETLBatchKey',
  /** column name */
  ETLSoftInsertIndicator = 'ETLSoftInsertIndicator',
  /** column name */
  EtlChecksum = 'EtlChecksum',
  /** column name */
  EtlCreatedDate = 'EtlCreatedDate',
  /** column name */
  EtlModifiedDate = 'EtlModifiedDate',
  /** column name */
  IndustryDescription = 'IndustryDescription',
  /** column name */
  InventoryExceptionCode = 'InventoryExceptionCode',
  /** column name */
  InventoryExceptionDescription = 'InventoryExceptionDescription',
  /** column name */
  IsClientAllianceProgram = 'IsClientAllianceProgram',
  /** column name */
  LocationCode = 'LocationCode',
  /** column name */
  MatterStop = 'MatterStop',
  /** column name */
  RelatedClientName = 'RelatedClientName',
  /** column name */
  RelatedClientNumber = 'RelatedClientNumber',
  /** column name */
  ResponsibleAttorneyTkId = 'ResponsibleAttorneyTkId',
  /** column name */
  SecureAlliManageMatterWorkspacesFlag = 'SecureAlliManageMatterWorkspacesFlag',
  /** column name */
  SegmentDescription = 'SegmentDescription',
  /** column name */
  SicCodeAndDescription = 'SicCodeAndDescription',
  /** column name */
  SicDescription = 'SicDescription',
  /** column name */
  SicTypeCode = 'SicTypeCode',
  /** column name */
  WallBuilderEntityId = 'WallBuilderEntityId',
}

/** aggregate stddev on columns */
export type Mlfsl_Client_Stddev_Fields = {
  ClientIndex?: Maybe<Scalars['Float']['output']>;
  DateClientClosed?: Maybe<Scalars['Float']['output']>;
  DateClientOpen?: Maybe<Scalars['Float']['output']>;
  DimClientNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  IsClientAllianceProgram?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "repl.DimClientNow" */
export type Mlfsl_Client_Stddev_Order_By = {
  ClientIndex?: InputMaybe<Order_By>;
  DateClientClosed?: InputMaybe<Order_By>;
  DateClientOpen?: InputMaybe<Order_By>;
  DimClientNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  IsClientAllianceProgram?: InputMaybe<Order_By>;
  WallBuilderEntityId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Client_Stddev_Pop_Fields = {
  ClientIndex?: Maybe<Scalars['Float']['output']>;
  DateClientClosed?: Maybe<Scalars['Float']['output']>;
  DateClientOpen?: Maybe<Scalars['Float']['output']>;
  DimClientNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  IsClientAllianceProgram?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "repl.DimClientNow" */
export type Mlfsl_Client_Stddev_Pop_Order_By = {
  ClientIndex?: InputMaybe<Order_By>;
  DateClientClosed?: InputMaybe<Order_By>;
  DateClientOpen?: InputMaybe<Order_By>;
  DimClientNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  IsClientAllianceProgram?: InputMaybe<Order_By>;
  WallBuilderEntityId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Client_Stddev_Samp_Fields = {
  ClientIndex?: Maybe<Scalars['Float']['output']>;
  DateClientClosed?: Maybe<Scalars['Float']['output']>;
  DateClientOpen?: Maybe<Scalars['Float']['output']>;
  DimClientNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  IsClientAllianceProgram?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "repl.DimClientNow" */
export type Mlfsl_Client_Stddev_Samp_Order_By = {
  ClientIndex?: InputMaybe<Order_By>;
  DateClientClosed?: InputMaybe<Order_By>;
  DateClientOpen?: InputMaybe<Order_By>;
  DimClientNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  IsClientAllianceProgram?: InputMaybe<Order_By>;
  WallBuilderEntityId?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Mlfsl_Client_Sum_Fields = {
  ClientIndex?: Maybe<Scalars['Int']['output']>;
  DateClientClosed?: Maybe<Scalars['Int']['output']>;
  DateClientOpen?: Maybe<Scalars['Int']['output']>;
  DimClientNowKey?: Maybe<Scalars['Int']['output']>;
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
  IsClientAllianceProgram?: Maybe<Scalars['Int']['output']>;
  WallBuilderEntityId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "repl.DimClientNow" */
export type Mlfsl_Client_Sum_Order_By = {
  ClientIndex?: InputMaybe<Order_By>;
  DateClientClosed?: InputMaybe<Order_By>;
  DateClientOpen?: InputMaybe<Order_By>;
  DimClientNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  IsClientAllianceProgram?: InputMaybe<Order_By>;
  WallBuilderEntityId?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Client_Var_Pop_Fields = {
  ClientIndex?: Maybe<Scalars['Float']['output']>;
  DateClientClosed?: Maybe<Scalars['Float']['output']>;
  DateClientOpen?: Maybe<Scalars['Float']['output']>;
  DimClientNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  IsClientAllianceProgram?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "repl.DimClientNow" */
export type Mlfsl_Client_Var_Pop_Order_By = {
  ClientIndex?: InputMaybe<Order_By>;
  DateClientClosed?: InputMaybe<Order_By>;
  DateClientOpen?: InputMaybe<Order_By>;
  DimClientNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  IsClientAllianceProgram?: InputMaybe<Order_By>;
  WallBuilderEntityId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Client_Var_Samp_Fields = {
  ClientIndex?: Maybe<Scalars['Float']['output']>;
  DateClientClosed?: Maybe<Scalars['Float']['output']>;
  DateClientOpen?: Maybe<Scalars['Float']['output']>;
  DimClientNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  IsClientAllianceProgram?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "repl.DimClientNow" */
export type Mlfsl_Client_Var_Samp_Order_By = {
  ClientIndex?: InputMaybe<Order_By>;
  DateClientClosed?: InputMaybe<Order_By>;
  DateClientOpen?: InputMaybe<Order_By>;
  DimClientNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  IsClientAllianceProgram?: InputMaybe<Order_By>;
  WallBuilderEntityId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mlfsl_Client_Variance_Fields = {
  ClientIndex?: Maybe<Scalars['Float']['output']>;
  DateClientClosed?: Maybe<Scalars['Float']['output']>;
  DateClientOpen?: Maybe<Scalars['Float']['output']>;
  DimClientNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  IsClientAllianceProgram?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "repl.DimClientNow" */
export type Mlfsl_Client_Variance_Order_By = {
  ClientIndex?: InputMaybe<Order_By>;
  DateClientClosed?: InputMaybe<Order_By>;
  DateClientOpen?: InputMaybe<Order_By>;
  DimClientNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  IsClientAllianceProgram?: InputMaybe<Order_By>;
  WallBuilderEntityId?: InputMaybe<Order_By>;
};

/** columns and relationships of "repl.DimDate" */
export type Mlfsl_Date = {
  CalendarDate?: Maybe<Scalars['date']['output']>;
  CalendarQuarter: Scalars['Int']['output'];
  CalendarYear: Scalars['Int']['output'];
  CalendarYearMonth: Scalars['String']['output'];
  CalendarYearQuarter: Scalars['String']['output'];
  CurrentMonthEndDate: Scalars['datetime']['output'];
  DateName: Scalars['String']['output'];
  DayNameOfWeek: Scalars['String']['output'];
  DayOfMonth: Scalars['Int']['output'];
  DayOfWeek: Scalars['Int']['output'];
  DayOfYear: Scalars['Int']['output'];
  DimDatekey: Scalars['Int']['output'];
  FiscalMonthOfYear?: Maybe<Scalars['Int']['output']>;
  FiscalQuarter?: Maybe<Scalars['Int']['output']>;
  FiscalYear?: Maybe<Scalars['Int']['output']>;
  FiscalYearMonth?: Maybe<Scalars['String']['output']>;
  FiscalYearQuarter?: Maybe<Scalars['String']['output']>;
  FullDate: Scalars['datetime']['output'];
  HolidayBelgiumIndicator?: Maybe<Scalars['String']['output']>;
  HolidayBritainIndicator?: Maybe<Scalars['String']['output']>;
  HolidayChinaIndicator?: Maybe<Scalars['String']['output']>;
  HolidayFranceIndicator?: Maybe<Scalars['String']['output']>;
  HolidayGermanyIndicator?: Maybe<Scalars['String']['output']>;
  HolidayJapanIndicator?: Maybe<Scalars['String']['output']>;
  HolidayUSIndicator?: Maybe<Scalars['String']['output']>;
  IsLastDayOfMonth: Scalars['String']['output'];
  MonthName: Scalars['String']['output'];
  MonthOfYear: Scalars['Int']['output'];
  NextMonthEndDate: Scalars['datetime']['output'];
  PriorMonthEndDate: Scalars['datetime']['output'];
  WeekOfYear: Scalars['Int']['output'];
  WeekdayWeekend: Scalars['String']['output'];
};

/** aggregated selection of "repl.DimDate" */
export type Mlfsl_Date_Aggregate = {
  aggregate?: Maybe<Mlfsl_Date_Aggregate_Fields>;
  nodes: Array<Mlfsl_Date>;
};

/** aggregate fields of "repl.DimDate" */
export type Mlfsl_Date_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Date_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Date_Max_Fields>;
  min?: Maybe<Mlfsl_Date_Min_Fields>;
  stddev?: Maybe<Mlfsl_Date_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Date_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Date_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Date_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Date_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Date_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Date_Variance_Fields>;
};

/** aggregate fields of "repl.DimDate" */
export type Mlfsl_Date_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Date_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mlfsl_Date_Avg_Fields = {
  CalendarQuarter?: Maybe<Scalars['Float']['output']>;
  CalendarYear?: Maybe<Scalars['Float']['output']>;
  DayOfMonth?: Maybe<Scalars['Float']['output']>;
  DayOfWeek?: Maybe<Scalars['Float']['output']>;
  DayOfYear?: Maybe<Scalars['Float']['output']>;
  DimDatekey?: Maybe<Scalars['Float']['output']>;
  FiscalMonthOfYear?: Maybe<Scalars['Float']['output']>;
  FiscalQuarter?: Maybe<Scalars['Float']['output']>;
  FiscalYear?: Maybe<Scalars['Float']['output']>;
  MonthOfYear?: Maybe<Scalars['Float']['output']>;
  WeekOfYear?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "repl.DimDate". All fields are combined with a logical 'AND'. */
export type Mlfsl_Date_Bool_Exp = {
  CalendarDate?: InputMaybe<Date_Mssql_Comparison_Exp>;
  CalendarQuarter?: InputMaybe<Int_Mssql_Comparison_Exp>;
  CalendarYear?: InputMaybe<Int_Mssql_Comparison_Exp>;
  CalendarYearMonth?: InputMaybe<String_Mssql_Comparison_Exp>;
  CalendarYearQuarter?: InputMaybe<String_Mssql_Comparison_Exp>;
  CurrentMonthEndDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  DateName?: InputMaybe<String_Mssql_Comparison_Exp>;
  DayNameOfWeek?: InputMaybe<String_Mssql_Comparison_Exp>;
  DayOfMonth?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DayOfWeek?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DayOfYear?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DimDatekey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  FiscalMonthOfYear?: InputMaybe<Int_Mssql_Comparison_Exp>;
  FiscalQuarter?: InputMaybe<Int_Mssql_Comparison_Exp>;
  FiscalYear?: InputMaybe<Int_Mssql_Comparison_Exp>;
  FiscalYearMonth?: InputMaybe<String_Mssql_Comparison_Exp>;
  FiscalYearQuarter?: InputMaybe<String_Mssql_Comparison_Exp>;
  FullDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  HolidayBelgiumIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  HolidayBritainIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  HolidayChinaIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  HolidayFranceIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  HolidayGermanyIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  HolidayJapanIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  HolidayUSIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  IsLastDayOfMonth?: InputMaybe<String_Mssql_Comparison_Exp>;
  MonthName?: InputMaybe<String_Mssql_Comparison_Exp>;
  MonthOfYear?: InputMaybe<Int_Mssql_Comparison_Exp>;
  NextMonthEndDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  PriorMonthEndDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  WeekOfYear?: InputMaybe<Int_Mssql_Comparison_Exp>;
  WeekdayWeekend?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Date_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Date_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Date_Bool_Exp>>;
};

/** aggregate max on columns */
export type Mlfsl_Date_Max_Fields = {
  CalendarDate?: Maybe<Scalars['date']['output']>;
  CalendarQuarter?: Maybe<Scalars['Int']['output']>;
  CalendarYear?: Maybe<Scalars['Int']['output']>;
  CalendarYearMonth?: Maybe<Scalars['String']['output']>;
  CalendarYearQuarter?: Maybe<Scalars['String']['output']>;
  CurrentMonthEndDate?: Maybe<Scalars['datetime']['output']>;
  DateName?: Maybe<Scalars['String']['output']>;
  DayNameOfWeek?: Maybe<Scalars['String']['output']>;
  DayOfMonth?: Maybe<Scalars['Int']['output']>;
  DayOfWeek?: Maybe<Scalars['Int']['output']>;
  DayOfYear?: Maybe<Scalars['Int']['output']>;
  DimDatekey?: Maybe<Scalars['Int']['output']>;
  FiscalMonthOfYear?: Maybe<Scalars['Int']['output']>;
  FiscalQuarter?: Maybe<Scalars['Int']['output']>;
  FiscalYear?: Maybe<Scalars['Int']['output']>;
  FiscalYearMonth?: Maybe<Scalars['String']['output']>;
  FiscalYearQuarter?: Maybe<Scalars['String']['output']>;
  FullDate?: Maybe<Scalars['datetime']['output']>;
  HolidayBelgiumIndicator?: Maybe<Scalars['String']['output']>;
  HolidayBritainIndicator?: Maybe<Scalars['String']['output']>;
  HolidayChinaIndicator?: Maybe<Scalars['String']['output']>;
  HolidayFranceIndicator?: Maybe<Scalars['String']['output']>;
  HolidayGermanyIndicator?: Maybe<Scalars['String']['output']>;
  HolidayJapanIndicator?: Maybe<Scalars['String']['output']>;
  HolidayUSIndicator?: Maybe<Scalars['String']['output']>;
  IsLastDayOfMonth?: Maybe<Scalars['String']['output']>;
  MonthName?: Maybe<Scalars['String']['output']>;
  MonthOfYear?: Maybe<Scalars['Int']['output']>;
  NextMonthEndDate?: Maybe<Scalars['datetime']['output']>;
  PriorMonthEndDate?: Maybe<Scalars['datetime']['output']>;
  WeekOfYear?: Maybe<Scalars['Int']['output']>;
  WeekdayWeekend?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mlfsl_Date_Min_Fields = {
  CalendarDate?: Maybe<Scalars['date']['output']>;
  CalendarQuarter?: Maybe<Scalars['Int']['output']>;
  CalendarYear?: Maybe<Scalars['Int']['output']>;
  CalendarYearMonth?: Maybe<Scalars['String']['output']>;
  CalendarYearQuarter?: Maybe<Scalars['String']['output']>;
  CurrentMonthEndDate?: Maybe<Scalars['datetime']['output']>;
  DateName?: Maybe<Scalars['String']['output']>;
  DayNameOfWeek?: Maybe<Scalars['String']['output']>;
  DayOfMonth?: Maybe<Scalars['Int']['output']>;
  DayOfWeek?: Maybe<Scalars['Int']['output']>;
  DayOfYear?: Maybe<Scalars['Int']['output']>;
  DimDatekey?: Maybe<Scalars['Int']['output']>;
  FiscalMonthOfYear?: Maybe<Scalars['Int']['output']>;
  FiscalQuarter?: Maybe<Scalars['Int']['output']>;
  FiscalYear?: Maybe<Scalars['Int']['output']>;
  FiscalYearMonth?: Maybe<Scalars['String']['output']>;
  FiscalYearQuarter?: Maybe<Scalars['String']['output']>;
  FullDate?: Maybe<Scalars['datetime']['output']>;
  HolidayBelgiumIndicator?: Maybe<Scalars['String']['output']>;
  HolidayBritainIndicator?: Maybe<Scalars['String']['output']>;
  HolidayChinaIndicator?: Maybe<Scalars['String']['output']>;
  HolidayFranceIndicator?: Maybe<Scalars['String']['output']>;
  HolidayGermanyIndicator?: Maybe<Scalars['String']['output']>;
  HolidayJapanIndicator?: Maybe<Scalars['String']['output']>;
  HolidayUSIndicator?: Maybe<Scalars['String']['output']>;
  IsLastDayOfMonth?: Maybe<Scalars['String']['output']>;
  MonthName?: Maybe<Scalars['String']['output']>;
  MonthOfYear?: Maybe<Scalars['Int']['output']>;
  NextMonthEndDate?: Maybe<Scalars['datetime']['output']>;
  PriorMonthEndDate?: Maybe<Scalars['datetime']['output']>;
  WeekOfYear?: Maybe<Scalars['Int']['output']>;
  WeekdayWeekend?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "repl.DimDate". */
export type Mlfsl_Date_Order_By = {
  CalendarDate?: InputMaybe<Order_By>;
  CalendarQuarter?: InputMaybe<Order_By>;
  CalendarYear?: InputMaybe<Order_By>;
  CalendarYearMonth?: InputMaybe<Order_By>;
  CalendarYearQuarter?: InputMaybe<Order_By>;
  CurrentMonthEndDate?: InputMaybe<Order_By>;
  DateName?: InputMaybe<Order_By>;
  DayNameOfWeek?: InputMaybe<Order_By>;
  DayOfMonth?: InputMaybe<Order_By>;
  DayOfWeek?: InputMaybe<Order_By>;
  DayOfYear?: InputMaybe<Order_By>;
  DimDatekey?: InputMaybe<Order_By>;
  FiscalMonthOfYear?: InputMaybe<Order_By>;
  FiscalQuarter?: InputMaybe<Order_By>;
  FiscalYear?: InputMaybe<Order_By>;
  FiscalYearMonth?: InputMaybe<Order_By>;
  FiscalYearQuarter?: InputMaybe<Order_By>;
  FullDate?: InputMaybe<Order_By>;
  HolidayBelgiumIndicator?: InputMaybe<Order_By>;
  HolidayBritainIndicator?: InputMaybe<Order_By>;
  HolidayChinaIndicator?: InputMaybe<Order_By>;
  HolidayFranceIndicator?: InputMaybe<Order_By>;
  HolidayGermanyIndicator?: InputMaybe<Order_By>;
  HolidayJapanIndicator?: InputMaybe<Order_By>;
  HolidayUSIndicator?: InputMaybe<Order_By>;
  IsLastDayOfMonth?: InputMaybe<Order_By>;
  MonthName?: InputMaybe<Order_By>;
  MonthOfYear?: InputMaybe<Order_By>;
  NextMonthEndDate?: InputMaybe<Order_By>;
  PriorMonthEndDate?: InputMaybe<Order_By>;
  WeekOfYear?: InputMaybe<Order_By>;
  WeekdayWeekend?: InputMaybe<Order_By>;
};

/** select columns of table "repl.DimDate" */
export enum Mlfsl_Date_Select_Column {
  /** column name */
  CalendarDate = 'CalendarDate',
  /** column name */
  CalendarQuarter = 'CalendarQuarter',
  /** column name */
  CalendarYear = 'CalendarYear',
  /** column name */
  CalendarYearMonth = 'CalendarYearMonth',
  /** column name */
  CalendarYearQuarter = 'CalendarYearQuarter',
  /** column name */
  CurrentMonthEndDate = 'CurrentMonthEndDate',
  /** column name */
  DateName = 'DateName',
  /** column name */
  DayNameOfWeek = 'DayNameOfWeek',
  /** column name */
  DayOfMonth = 'DayOfMonth',
  /** column name */
  DayOfWeek = 'DayOfWeek',
  /** column name */
  DayOfYear = 'DayOfYear',
  /** column name */
  DimDatekey = 'DimDatekey',
  /** column name */
  FiscalMonthOfYear = 'FiscalMonthOfYear',
  /** column name */
  FiscalQuarter = 'FiscalQuarter',
  /** column name */
  FiscalYear = 'FiscalYear',
  /** column name */
  FiscalYearMonth = 'FiscalYearMonth',
  /** column name */
  FiscalYearQuarter = 'FiscalYearQuarter',
  /** column name */
  FullDate = 'FullDate',
  /** column name */
  HolidayBelgiumIndicator = 'HolidayBelgiumIndicator',
  /** column name */
  HolidayBritainIndicator = 'HolidayBritainIndicator',
  /** column name */
  HolidayChinaIndicator = 'HolidayChinaIndicator',
  /** column name */
  HolidayFranceIndicator = 'HolidayFranceIndicator',
  /** column name */
  HolidayGermanyIndicator = 'HolidayGermanyIndicator',
  /** column name */
  HolidayJapanIndicator = 'HolidayJapanIndicator',
  /** column name */
  HolidayUSIndicator = 'HolidayUSIndicator',
  /** column name */
  IsLastDayOfMonth = 'IsLastDayOfMonth',
  /** column name */
  MonthName = 'MonthName',
  /** column name */
  MonthOfYear = 'MonthOfYear',
  /** column name */
  NextMonthEndDate = 'NextMonthEndDate',
  /** column name */
  PriorMonthEndDate = 'PriorMonthEndDate',
  /** column name */
  WeekOfYear = 'WeekOfYear',
  /** column name */
  WeekdayWeekend = 'WeekdayWeekend',
}

/** aggregate stddev on columns */
export type Mlfsl_Date_Stddev_Fields = {
  CalendarQuarter?: Maybe<Scalars['Float']['output']>;
  CalendarYear?: Maybe<Scalars['Float']['output']>;
  DayOfMonth?: Maybe<Scalars['Float']['output']>;
  DayOfWeek?: Maybe<Scalars['Float']['output']>;
  DayOfYear?: Maybe<Scalars['Float']['output']>;
  DimDatekey?: Maybe<Scalars['Float']['output']>;
  FiscalMonthOfYear?: Maybe<Scalars['Float']['output']>;
  FiscalQuarter?: Maybe<Scalars['Float']['output']>;
  FiscalYear?: Maybe<Scalars['Float']['output']>;
  MonthOfYear?: Maybe<Scalars['Float']['output']>;
  WeekOfYear?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Date_Stddev_Pop_Fields = {
  CalendarQuarter?: Maybe<Scalars['Float']['output']>;
  CalendarYear?: Maybe<Scalars['Float']['output']>;
  DayOfMonth?: Maybe<Scalars['Float']['output']>;
  DayOfWeek?: Maybe<Scalars['Float']['output']>;
  DayOfYear?: Maybe<Scalars['Float']['output']>;
  DimDatekey?: Maybe<Scalars['Float']['output']>;
  FiscalMonthOfYear?: Maybe<Scalars['Float']['output']>;
  FiscalQuarter?: Maybe<Scalars['Float']['output']>;
  FiscalYear?: Maybe<Scalars['Float']['output']>;
  MonthOfYear?: Maybe<Scalars['Float']['output']>;
  WeekOfYear?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Date_Stddev_Samp_Fields = {
  CalendarQuarter?: Maybe<Scalars['Float']['output']>;
  CalendarYear?: Maybe<Scalars['Float']['output']>;
  DayOfMonth?: Maybe<Scalars['Float']['output']>;
  DayOfWeek?: Maybe<Scalars['Float']['output']>;
  DayOfYear?: Maybe<Scalars['Float']['output']>;
  DimDatekey?: Maybe<Scalars['Float']['output']>;
  FiscalMonthOfYear?: Maybe<Scalars['Float']['output']>;
  FiscalQuarter?: Maybe<Scalars['Float']['output']>;
  FiscalYear?: Maybe<Scalars['Float']['output']>;
  MonthOfYear?: Maybe<Scalars['Float']['output']>;
  WeekOfYear?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Mlfsl_Date_Sum_Fields = {
  CalendarQuarter?: Maybe<Scalars['Int']['output']>;
  CalendarYear?: Maybe<Scalars['Int']['output']>;
  DayOfMonth?: Maybe<Scalars['Int']['output']>;
  DayOfWeek?: Maybe<Scalars['Int']['output']>;
  DayOfYear?: Maybe<Scalars['Int']['output']>;
  DimDatekey?: Maybe<Scalars['Int']['output']>;
  FiscalMonthOfYear?: Maybe<Scalars['Int']['output']>;
  FiscalQuarter?: Maybe<Scalars['Int']['output']>;
  FiscalYear?: Maybe<Scalars['Int']['output']>;
  MonthOfYear?: Maybe<Scalars['Int']['output']>;
  WeekOfYear?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Date_Var_Pop_Fields = {
  CalendarQuarter?: Maybe<Scalars['Float']['output']>;
  CalendarYear?: Maybe<Scalars['Float']['output']>;
  DayOfMonth?: Maybe<Scalars['Float']['output']>;
  DayOfWeek?: Maybe<Scalars['Float']['output']>;
  DayOfYear?: Maybe<Scalars['Float']['output']>;
  DimDatekey?: Maybe<Scalars['Float']['output']>;
  FiscalMonthOfYear?: Maybe<Scalars['Float']['output']>;
  FiscalQuarter?: Maybe<Scalars['Float']['output']>;
  FiscalYear?: Maybe<Scalars['Float']['output']>;
  MonthOfYear?: Maybe<Scalars['Float']['output']>;
  WeekOfYear?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Date_Var_Samp_Fields = {
  CalendarQuarter?: Maybe<Scalars['Float']['output']>;
  CalendarYear?: Maybe<Scalars['Float']['output']>;
  DayOfMonth?: Maybe<Scalars['Float']['output']>;
  DayOfWeek?: Maybe<Scalars['Float']['output']>;
  DayOfYear?: Maybe<Scalars['Float']['output']>;
  DimDatekey?: Maybe<Scalars['Float']['output']>;
  FiscalMonthOfYear?: Maybe<Scalars['Float']['output']>;
  FiscalQuarter?: Maybe<Scalars['Float']['output']>;
  FiscalYear?: Maybe<Scalars['Float']['output']>;
  MonthOfYear?: Maybe<Scalars['Float']['output']>;
  WeekOfYear?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mlfsl_Date_Variance_Fields = {
  CalendarQuarter?: Maybe<Scalars['Float']['output']>;
  CalendarYear?: Maybe<Scalars['Float']['output']>;
  DayOfMonth?: Maybe<Scalars['Float']['output']>;
  DayOfWeek?: Maybe<Scalars['Float']['output']>;
  DayOfYear?: Maybe<Scalars['Float']['output']>;
  DimDatekey?: Maybe<Scalars['Float']['output']>;
  FiscalMonthOfYear?: Maybe<Scalars['Float']['output']>;
  FiscalQuarter?: Maybe<Scalars['Float']['output']>;
  FiscalYear?: Maybe<Scalars['Float']['output']>;
  MonthOfYear?: Maybe<Scalars['Float']['output']>;
  WeekOfYear?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "MNET.Finance_Hours_Client" */
export type Mlfsl_Finance_Hours_Client = {
  ClientName?: Maybe<Scalars['String']['output']>;
  ClientNumber: Scalars['String']['output'];
  ClientStatusCategory?: Maybe<Scalars['String']['output']>;
  ClientStatusDescription?: Maybe<Scalars['String']['output']>;
  ClosedMatterCount: Scalars['Int']['output'];
  DaysSinceLastPayment?: Maybe<Scalars['Int']['output']>;
  LastPaymentDate?: Maybe<Scalars['datetime']['output']>;
  MatterCount: Scalars['Int']['output'];
  OpenMatterCount: Scalars['Int']['output'];
  /** An object relationship */
  RelatedClient?: Maybe<Mlfsl_Related_Client>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_ActiveDirectoryLogin?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_Email?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_EmployeeId?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_OfficeEliteLocationCode?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_OfficeNameDisplay?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_mnet_Office_detail?: Maybe<Mnet_Office_Detail>;
  ResponsibleAttorney_mnet_practice_group_detail?: Maybe<Mnet_Practice_Group_Detail>;
  TimeKeeperCount: Scalars['Int']['output'];
  /** An object relationship */
  mlfsl_client?: Maybe<Mlfsl_Client>;
};

/** aggregated selection of "MNET.Finance_Hours_Client" */
export type Mlfsl_Finance_Hours_Client_Aggregate = {
  aggregate?: Maybe<Mlfsl_Finance_Hours_Client_Aggregate_Fields>;
  nodes: Array<Mlfsl_Finance_Hours_Client>;
};

/** aggregate fields of "MNET.Finance_Hours_Client" */
export type Mlfsl_Finance_Hours_Client_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Finance_Hours_Client_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Finance_Hours_Client_Max_Fields>;
  min?: Maybe<Mlfsl_Finance_Hours_Client_Min_Fields>;
  stddev?: Maybe<Mlfsl_Finance_Hours_Client_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Finance_Hours_Client_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Finance_Hours_Client_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Finance_Hours_Client_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Finance_Hours_Client_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Finance_Hours_Client_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Finance_Hours_Client_Variance_Fields>;
};

/** aggregate fields of "MNET.Finance_Hours_Client" */
export type Mlfsl_Finance_Hours_Client_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Finance_Hours_Client_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mlfsl_Finance_Hours_Client_Avg_Fields = {
  ClosedMatterCount?: Maybe<Scalars['Float']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  MatterCount?: Maybe<Scalars['Float']['output']>;
  OpenMatterCount?: Maybe<Scalars['Float']['output']>;
  TimeKeeperCount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_Client". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Client_Bool_Exp = {
  ClientName?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientStatusCategory?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientStatusDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClosedMatterCount?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DaysSinceLastPayment?: InputMaybe<Int_Mssql_Comparison_Exp>;
  LastPaymentDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  MatterCount?: InputMaybe<Int_Mssql_Comparison_Exp>;
  OpenMatterCount?: InputMaybe<Int_Mssql_Comparison_Exp>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Bool_Exp>;
  RelatedClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  ResponsibleAttorney_ActiveDirectoryLogin?: InputMaybe<String_Mssql_Comparison_Exp>;
  ResponsibleAttorney_Email?: InputMaybe<String_Mssql_Comparison_Exp>;
  ResponsibleAttorney_EmployeeId?: InputMaybe<String_Mssql_Comparison_Exp>;
  ResponsibleAttorney_NamePreferredDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  ResponsibleAttorney_OfficeEliteLocationCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ResponsibleAttorney_OfficeNameDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  ResponsibleAttorney_PracticeGroupCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ResponsibleAttorney_PracticeGroupName?: InputMaybe<String_Mssql_Comparison_Exp>;
  TimeKeeperCount?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Finance_Hours_Client_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Finance_Hours_Client_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Finance_Hours_Client_Bool_Exp>>;
  mlfsl_client?: InputMaybe<Mlfsl_Client_Bool_Exp>;
};

/** aggregate max on columns */
export type Mlfsl_Finance_Hours_Client_Max_Fields = {
  ClientName?: Maybe<Scalars['String']['output']>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  ClientStatusCategory?: Maybe<Scalars['String']['output']>;
  ClientStatusDescription?: Maybe<Scalars['String']['output']>;
  ClosedMatterCount?: Maybe<Scalars['Int']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Int']['output']>;
  LastPaymentDate?: Maybe<Scalars['datetime']['output']>;
  MatterCount?: Maybe<Scalars['Int']['output']>;
  OpenMatterCount?: Maybe<Scalars['Int']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_ActiveDirectoryLogin?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_Email?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_EmployeeId?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_OfficeEliteLocationCode?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_OfficeNameDisplay?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  TimeKeeperCount?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Mlfsl_Finance_Hours_Client_Min_Fields = {
  ClientName?: Maybe<Scalars['String']['output']>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  ClientStatusCategory?: Maybe<Scalars['String']['output']>;
  ClientStatusDescription?: Maybe<Scalars['String']['output']>;
  ClosedMatterCount?: Maybe<Scalars['Int']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Int']['output']>;
  LastPaymentDate?: Maybe<Scalars['datetime']['output']>;
  MatterCount?: Maybe<Scalars['Int']['output']>;
  OpenMatterCount?: Maybe<Scalars['Int']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_ActiveDirectoryLogin?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_Email?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_EmployeeId?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_OfficeEliteLocationCode?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_OfficeNameDisplay?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  TimeKeeperCount?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "MNET.Finance_Hours_Client". */
export type Mlfsl_Finance_Hours_Client_Order_By = {
  ClientName?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  ClientStatusCategory?: InputMaybe<Order_By>;
  ClientStatusDescription?: InputMaybe<Order_By>;
  ClosedMatterCount?: InputMaybe<Order_By>;
  DaysSinceLastPayment?: InputMaybe<Order_By>;
  LastPaymentDate?: InputMaybe<Order_By>;
  MatterCount?: InputMaybe<Order_By>;
  OpenMatterCount?: InputMaybe<Order_By>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  ResponsibleAttorney_ActiveDirectoryLogin?: InputMaybe<Order_By>;
  ResponsibleAttorney_Email?: InputMaybe<Order_By>;
  ResponsibleAttorney_EmployeeId?: InputMaybe<Order_By>;
  ResponsibleAttorney_NamePreferredDisplay?: InputMaybe<Order_By>;
  ResponsibleAttorney_OfficeEliteLocationCode?: InputMaybe<Order_By>;
  ResponsibleAttorney_OfficeNameDisplay?: InputMaybe<Order_By>;
  ResponsibleAttorney_PracticeGroupCode?: InputMaybe<Order_By>;
  ResponsibleAttorney_PracticeGroupName?: InputMaybe<Order_By>;
  TimeKeeperCount?: InputMaybe<Order_By>;
  mlfsl_client?: InputMaybe<Mlfsl_Client_Order_By>;
};

/** select columns of table "MNET.Finance_Hours_Client" */
export enum Mlfsl_Finance_Hours_Client_Select_Column {
  /** column name */
  ClientName = 'ClientName',
  /** column name */
  ClientNumber = 'ClientNumber',
  /** column name */
  ClientStatusCategory = 'ClientStatusCategory',
  /** column name */
  ClientStatusDescription = 'ClientStatusDescription',
  /** column name */
  ClosedMatterCount = 'ClosedMatterCount',
  /** column name */
  DaysSinceLastPayment = 'DaysSinceLastPayment',
  /** column name */
  LastPaymentDate = 'LastPaymentDate',
  /** column name */
  MatterCount = 'MatterCount',
  /** column name */
  OpenMatterCount = 'OpenMatterCount',
  /** column name */
  RelatedClientNumber = 'RelatedClientNumber',
  /** column name */
  ResponsibleAttorney_ActiveDirectoryLogin = 'ResponsibleAttorney_ActiveDirectoryLogin',
  /** column name */
  ResponsibleAttorney_Email = 'ResponsibleAttorney_Email',
  /** column name */
  ResponsibleAttorney_EmployeeId = 'ResponsibleAttorney_EmployeeId',
  /** column name */
  ResponsibleAttorney_NamePreferredDisplay = 'ResponsibleAttorney_NamePreferredDisplay',
  /** column name */
  ResponsibleAttorney_OfficeEliteLocationCode = 'ResponsibleAttorney_OfficeEliteLocationCode',
  /** column name */
  ResponsibleAttorney_OfficeNameDisplay = 'ResponsibleAttorney_OfficeNameDisplay',
  /** column name */
  ResponsibleAttorney_PracticeGroupCode = 'ResponsibleAttorney_PracticeGroupCode',
  /** column name */
  ResponsibleAttorney_PracticeGroupName = 'ResponsibleAttorney_PracticeGroupName',
  /** column name */
  TimeKeeperCount = 'TimeKeeperCount',
}

/** aggregate stddev on columns */
export type Mlfsl_Finance_Hours_Client_Stddev_Fields = {
  ClosedMatterCount?: Maybe<Scalars['Float']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  MatterCount?: Maybe<Scalars['Float']['output']>;
  OpenMatterCount?: Maybe<Scalars['Float']['output']>;
  TimeKeeperCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Finance_Hours_Client_Stddev_Pop_Fields = {
  ClosedMatterCount?: Maybe<Scalars['Float']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  MatterCount?: Maybe<Scalars['Float']['output']>;
  OpenMatterCount?: Maybe<Scalars['Float']['output']>;
  TimeKeeperCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Finance_Hours_Client_Stddev_Samp_Fields = {
  ClosedMatterCount?: Maybe<Scalars['Float']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  MatterCount?: Maybe<Scalars['Float']['output']>;
  OpenMatterCount?: Maybe<Scalars['Float']['output']>;
  TimeKeeperCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Mlfsl_Finance_Hours_Client_Sum_Fields = {
  ClosedMatterCount?: Maybe<Scalars['Int']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Int']['output']>;
  MatterCount?: Maybe<Scalars['Int']['output']>;
  OpenMatterCount?: Maybe<Scalars['Int']['output']>;
  TimeKeeperCount?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Finance_Hours_Client_Var_Pop_Fields = {
  ClosedMatterCount?: Maybe<Scalars['Float']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  MatterCount?: Maybe<Scalars['Float']['output']>;
  OpenMatterCount?: Maybe<Scalars['Float']['output']>;
  TimeKeeperCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Finance_Hours_Client_Var_Samp_Fields = {
  ClosedMatterCount?: Maybe<Scalars['Float']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  MatterCount?: Maybe<Scalars['Float']['output']>;
  OpenMatterCount?: Maybe<Scalars['Float']['output']>;
  TimeKeeperCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mlfsl_Finance_Hours_Client_Variance_Fields = {
  ClosedMatterCount?: Maybe<Scalars['Float']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  MatterCount?: Maybe<Scalars['Float']['output']>;
  OpenMatterCount?: Maybe<Scalars['Float']['output']>;
  TimeKeeperCount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe = {
  /** An object relationship */
  Client?: Maybe<Mlfsl_Client>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientNumber: Scalars['String']['output'];
  HistoricalTKOfficeforCount: Scalars['String']['output'];
  /** An object relationship */
  RelatedClient?: Maybe<Mlfsl_Related_Client>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  Timeframe: Scalars['String']['output'];
  historical_tk_mnet_office_detail?: Maybe<Mnet_Office_Detail>;
};

/** order by aggregate values of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Finance_Hours_Clientofficetimeframe_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Finance_Hours_Clientofficetimeframe_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Finance_Hours_Clientofficetimeframe_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Finance_Hours_Clientofficetimeframe_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Finance_Hours_Clientofficetimeframe_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Finance_Hours_Clientofficetimeframe_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Finance_Hours_Clientofficetimeframe_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Finance_Hours_Clientofficetimeframe_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Finance_Hours_Clientofficetimeframe_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Finance_Hours_Clientofficetimeframe_Variance_Order_By>;
};

/** order by avg() on columns of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Avg_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_ClientOfficeTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Bool_Exp = {
  Client?: InputMaybe<Mlfsl_Client_Bool_Exp>;
  ClientBillableHours?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  HistoricalTKOfficeforCount?: InputMaybe<String_Mssql_Comparison_Exp>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Bool_Exp>;
  RelatedClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  Timeframe?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Finance_Hours_Clientofficetimeframe_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Finance_Hours_Clientofficetimeframe_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Finance_Hours_Clientofficetimeframe_Bool_Exp>>;
};

/** order by max() on columns of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Max_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  HistoricalTKOfficeforCount?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Min_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  HistoricalTKOfficeforCount?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "MNET.Finance_Hours_ClientOfficeTimeframe". */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Order_By = {
  Client?: InputMaybe<Mlfsl_Client_Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  HistoricalTKOfficeforCount?: InputMaybe<Order_By>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Stddev_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Stddev_Pop_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Stddev_Samp_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Sum_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Var_Pop_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Var_Samp_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "MNET.Finance_Hours_ClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Clientofficetimeframe_Variance_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** columns and relationships of "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe = {
  /** An object relationship */
  Client?: Maybe<Mlfsl_Client>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientNumber: Scalars['String']['output'];
  HistoricalTKPGforCount: Scalars['String']['output'];
  PracticeGroupName: Scalars['String']['output'];
  /** An object relationship */
  RelatedClient?: Maybe<Mlfsl_Related_Client>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  Timeframe: Scalars['String']['output'];
  historical_tk_mnet_practice_group_detail?: Maybe<Mnet_Practice_Group_Detail>;
};

/** order by aggregate values of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Finance_Hours_Clientpgtimeframe_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Finance_Hours_Clientpgtimeframe_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Finance_Hours_Clientpgtimeframe_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Finance_Hours_Clientpgtimeframe_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Finance_Hours_Clientpgtimeframe_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Finance_Hours_Clientpgtimeframe_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Finance_Hours_Clientpgtimeframe_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Finance_Hours_Clientpgtimeframe_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Finance_Hours_Clientpgtimeframe_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Finance_Hours_Clientpgtimeframe_Variance_Order_By>;
};

/** order by avg() on columns of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Avg_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_ClientPGTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Bool_Exp = {
  Client?: InputMaybe<Mlfsl_Client_Bool_Exp>;
  ClientBillableHours?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  HistoricalTKPGforCount?: InputMaybe<String_Mssql_Comparison_Exp>;
  PracticeGroupName?: InputMaybe<String_Mssql_Comparison_Exp>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Bool_Exp>;
  RelatedClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  Timeframe?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Finance_Hours_Clientpgtimeframe_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Finance_Hours_Clientpgtimeframe_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Finance_Hours_Clientpgtimeframe_Bool_Exp>>;
};

/** order by max() on columns of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Max_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  HistoricalTKPGforCount?: InputMaybe<Order_By>;
  PracticeGroupName?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Min_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  HistoricalTKPGforCount?: InputMaybe<Order_By>;
  PracticeGroupName?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "MNET.Finance_Hours_ClientPGTimeframe". */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Order_By = {
  Client?: InputMaybe<Mlfsl_Client_Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  HistoricalTKPGforCount?: InputMaybe<Order_By>;
  PracticeGroupName?: InputMaybe<Order_By>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Stddev_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Stddev_Pop_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Stddev_Samp_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Sum_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Var_Pop_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Var_Samp_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "MNET.Finance_Hours_ClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Clientpgtimeframe_Variance_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** columns and relationships of "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe = {
  BilledAmount: Scalars['Float']['output'];
  /** An object relationship */
  Client?: Maybe<Mlfsl_Client>;
  ClientBillableHours: Scalars['Float']['output'];
  ClientName: Scalars['String']['output'];
  ClientNumber: Scalars['String']['output'];
  ClientStatusCategory?: Maybe<Scalars['String']['output']>;
  ClientStatusDescription?: Maybe<Scalars['String']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Int']['output']>;
  LastPaymentDate?: Maybe<Scalars['datetime']['output']>;
  OfficesServingClient?: Maybe<Scalars['Int']['output']>;
  PartnersServingClient?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  RelatedClient?: Maybe<Mlfsl_Related_Client>;
  RelatedClientBillableHoursPercent: Scalars['Float']['output'];
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_ActiveDirectoryLogin?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_Email?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_EmployeeId?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_OfficeEliteLocationCode?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_OfficeNameDisplay?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_mnet_Office_detail?: Maybe<Mnet_Office_Detail>;
  ResponsibleAttorney_mnet_practice_group_detail?: Maybe<Mnet_Practice_Group_Detail>;
  TimeChargesBooked: Scalars['Float']['output'];
  Timeframe: Scalars['String']['output'];
};

/** aggregated selection of "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Aggregate = {
  aggregate?: Maybe<Mlfsl_Finance_Hours_Clienttimeframe_Aggregate_Fields>;
  nodes: Array<Mlfsl_Finance_Hours_Clienttimeframe>;
};

/** aggregate fields of "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Finance_Hours_Clienttimeframe_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Finance_Hours_Clienttimeframe_Max_Fields>;
  min?: Maybe<Mlfsl_Finance_Hours_Clienttimeframe_Min_Fields>;
  stddev?: Maybe<Mlfsl_Finance_Hours_Clienttimeframe_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Finance_Hours_Clienttimeframe_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Finance_Hours_Clienttimeframe_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Finance_Hours_Clienttimeframe_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Finance_Hours_Clienttimeframe_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Finance_Hours_Clienttimeframe_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Finance_Hours_Clienttimeframe_Variance_Fields>;
};

/** aggregate fields of "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Mlfsl_Finance_Hours_Clienttimeframe_Avg_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  OfficesServingClient?: Maybe<Scalars['Float']['output']>;
  PartnersServingClient?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Avg_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  DaysSinceLastPayment?: InputMaybe<Order_By>;
  OfficesServingClient?: InputMaybe<Order_By>;
  PartnersServingClient?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_ClientTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Clienttimeframe_Bool_Exp = {
  BilledAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  Client?: InputMaybe<Mlfsl_Client_Bool_Exp>;
  ClientBillableHours?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ClientName?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientStatusCategory?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientStatusDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  DaysSinceLastPayment?: InputMaybe<Int_Mssql_Comparison_Exp>;
  LastPaymentDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  OfficesServingClient?: InputMaybe<Int_Mssql_Comparison_Exp>;
  PartnersServingClient?: InputMaybe<Int_Mssql_Comparison_Exp>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Bool_Exp>;
  RelatedClientBillableHoursPercent?: InputMaybe<Float_Mssql_Comparison_Exp>;
  RelatedClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  ResponsibleAttorney_ActiveDirectoryLogin?: InputMaybe<String_Mssql_Comparison_Exp>;
  ResponsibleAttorney_Email?: InputMaybe<String_Mssql_Comparison_Exp>;
  ResponsibleAttorney_EmployeeId?: InputMaybe<String_Mssql_Comparison_Exp>;
  ResponsibleAttorney_NamePreferredDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  ResponsibleAttorney_OfficeEliteLocationCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ResponsibleAttorney_OfficeNameDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  ResponsibleAttorney_PracticeGroupCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ResponsibleAttorney_PracticeGroupName?: InputMaybe<String_Mssql_Comparison_Exp>;
  TimeChargesBooked?: InputMaybe<Float_Mssql_Comparison_Exp>;
  Timeframe?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Finance_Hours_Clienttimeframe_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Finance_Hours_Clienttimeframe_Bool_Exp>>;
};

/** aggregate max on columns */
export type Mlfsl_Finance_Hours_Clienttimeframe_Max_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientName?: Maybe<Scalars['String']['output']>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  ClientStatusCategory?: Maybe<Scalars['String']['output']>;
  ClientStatusDescription?: Maybe<Scalars['String']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Int']['output']>;
  LastPaymentDate?: Maybe<Scalars['datetime']['output']>;
  OfficesServingClient?: Maybe<Scalars['Int']['output']>;
  PartnersServingClient?: Maybe<Scalars['Int']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_ActiveDirectoryLogin?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_Email?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_EmployeeId?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_OfficeEliteLocationCode?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_OfficeNameDisplay?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
  Timeframe?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Max_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientName?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  ClientStatusCategory?: InputMaybe<Order_By>;
  ClientStatusDescription?: InputMaybe<Order_By>;
  DaysSinceLastPayment?: InputMaybe<Order_By>;
  LastPaymentDate?: InputMaybe<Order_By>;
  OfficesServingClient?: InputMaybe<Order_By>;
  PartnersServingClient?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  ResponsibleAttorney_ActiveDirectoryLogin?: InputMaybe<Order_By>;
  ResponsibleAttorney_Email?: InputMaybe<Order_By>;
  ResponsibleAttorney_EmployeeId?: InputMaybe<Order_By>;
  ResponsibleAttorney_NamePreferredDisplay?: InputMaybe<Order_By>;
  ResponsibleAttorney_OfficeEliteLocationCode?: InputMaybe<Order_By>;
  ResponsibleAttorney_OfficeNameDisplay?: InputMaybe<Order_By>;
  ResponsibleAttorney_PracticeGroupCode?: InputMaybe<Order_By>;
  ResponsibleAttorney_PracticeGroupName?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mlfsl_Finance_Hours_Clienttimeframe_Min_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientName?: Maybe<Scalars['String']['output']>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  ClientStatusCategory?: Maybe<Scalars['String']['output']>;
  ClientStatusDescription?: Maybe<Scalars['String']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Int']['output']>;
  LastPaymentDate?: Maybe<Scalars['datetime']['output']>;
  OfficesServingClient?: Maybe<Scalars['Int']['output']>;
  PartnersServingClient?: Maybe<Scalars['Int']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_ActiveDirectoryLogin?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_Email?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_EmployeeId?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_OfficeEliteLocationCode?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_OfficeNameDisplay?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  ResponsibleAttorney_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
  Timeframe?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Min_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientName?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  ClientStatusCategory?: InputMaybe<Order_By>;
  ClientStatusDescription?: InputMaybe<Order_By>;
  DaysSinceLastPayment?: InputMaybe<Order_By>;
  LastPaymentDate?: InputMaybe<Order_By>;
  OfficesServingClient?: InputMaybe<Order_By>;
  PartnersServingClient?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  ResponsibleAttorney_ActiveDirectoryLogin?: InputMaybe<Order_By>;
  ResponsibleAttorney_Email?: InputMaybe<Order_By>;
  ResponsibleAttorney_EmployeeId?: InputMaybe<Order_By>;
  ResponsibleAttorney_NamePreferredDisplay?: InputMaybe<Order_By>;
  ResponsibleAttorney_OfficeEliteLocationCode?: InputMaybe<Order_By>;
  ResponsibleAttorney_OfficeNameDisplay?: InputMaybe<Order_By>;
  ResponsibleAttorney_PracticeGroupCode?: InputMaybe<Order_By>;
  ResponsibleAttorney_PracticeGroupName?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "MNET.Finance_Hours_ClientTimeframe". */
export type Mlfsl_Finance_Hours_Clienttimeframe_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  Client?: InputMaybe<Mlfsl_Client_Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientName?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  ClientStatusCategory?: InputMaybe<Order_By>;
  ClientStatusDescription?: InputMaybe<Order_By>;
  DaysSinceLastPayment?: InputMaybe<Order_By>;
  LastPaymentDate?: InputMaybe<Order_By>;
  OfficesServingClient?: InputMaybe<Order_By>;
  PartnersServingClient?: InputMaybe<Order_By>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  ResponsibleAttorney_ActiveDirectoryLogin?: InputMaybe<Order_By>;
  ResponsibleAttorney_Email?: InputMaybe<Order_By>;
  ResponsibleAttorney_EmployeeId?: InputMaybe<Order_By>;
  ResponsibleAttorney_NamePreferredDisplay?: InputMaybe<Order_By>;
  ResponsibleAttorney_OfficeEliteLocationCode?: InputMaybe<Order_By>;
  ResponsibleAttorney_OfficeNameDisplay?: InputMaybe<Order_By>;
  ResponsibleAttorney_PracticeGroupCode?: InputMaybe<Order_By>;
  ResponsibleAttorney_PracticeGroupName?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** select columns of table "MNET.Finance_Hours_ClientTimeframe" */
export enum Mlfsl_Finance_Hours_Clienttimeframe_Select_Column {
  /** column name */
  BilledAmount = 'BilledAmount',
  /** column name */
  ClientBillableHours = 'ClientBillableHours',
  /** column name */
  ClientName = 'ClientName',
  /** column name */
  ClientNumber = 'ClientNumber',
  /** column name */
  ClientStatusCategory = 'ClientStatusCategory',
  /** column name */
  ClientStatusDescription = 'ClientStatusDescription',
  /** column name */
  DaysSinceLastPayment = 'DaysSinceLastPayment',
  /** column name */
  LastPaymentDate = 'LastPaymentDate',
  /** column name */
  OfficesServingClient = 'OfficesServingClient',
  /** column name */
  PartnersServingClient = 'PartnersServingClient',
  /** column name */
  RelatedClientBillableHoursPercent = 'RelatedClientBillableHoursPercent',
  /** column name */
  RelatedClientNumber = 'RelatedClientNumber',
  /** column name */
  ResponsibleAttorney_ActiveDirectoryLogin = 'ResponsibleAttorney_ActiveDirectoryLogin',
  /** column name */
  ResponsibleAttorney_Email = 'ResponsibleAttorney_Email',
  /** column name */
  ResponsibleAttorney_EmployeeId = 'ResponsibleAttorney_EmployeeId',
  /** column name */
  ResponsibleAttorney_NamePreferredDisplay = 'ResponsibleAttorney_NamePreferredDisplay',
  /** column name */
  ResponsibleAttorney_OfficeEliteLocationCode = 'ResponsibleAttorney_OfficeEliteLocationCode',
  /** column name */
  ResponsibleAttorney_OfficeNameDisplay = 'ResponsibleAttorney_OfficeNameDisplay',
  /** column name */
  ResponsibleAttorney_PracticeGroupCode = 'ResponsibleAttorney_PracticeGroupCode',
  /** column name */
  ResponsibleAttorney_PracticeGroupName = 'ResponsibleAttorney_PracticeGroupName',
  /** column name */
  TimeChargesBooked = 'TimeChargesBooked',
  /** column name */
  Timeframe = 'Timeframe',
}

/** aggregate stddev on columns */
export type Mlfsl_Finance_Hours_Clienttimeframe_Stddev_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  OfficesServingClient?: Maybe<Scalars['Float']['output']>;
  PartnersServingClient?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Stddev_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  DaysSinceLastPayment?: InputMaybe<Order_By>;
  OfficesServingClient?: InputMaybe<Order_By>;
  PartnersServingClient?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Finance_Hours_Clienttimeframe_Stddev_Pop_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  OfficesServingClient?: Maybe<Scalars['Float']['output']>;
  PartnersServingClient?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Stddev_Pop_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  DaysSinceLastPayment?: InputMaybe<Order_By>;
  OfficesServingClient?: InputMaybe<Order_By>;
  PartnersServingClient?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Finance_Hours_Clienttimeframe_Stddev_Samp_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  OfficesServingClient?: Maybe<Scalars['Float']['output']>;
  PartnersServingClient?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Stddev_Samp_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  DaysSinceLastPayment?: InputMaybe<Order_By>;
  OfficesServingClient?: InputMaybe<Order_By>;
  PartnersServingClient?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Mlfsl_Finance_Hours_Clienttimeframe_Sum_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Int']['output']>;
  OfficesServingClient?: Maybe<Scalars['Int']['output']>;
  PartnersServingClient?: Maybe<Scalars['Int']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Sum_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  DaysSinceLastPayment?: InputMaybe<Order_By>;
  OfficesServingClient?: InputMaybe<Order_By>;
  PartnersServingClient?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Finance_Hours_Clienttimeframe_Var_Pop_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  OfficesServingClient?: Maybe<Scalars['Float']['output']>;
  PartnersServingClient?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Var_Pop_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  DaysSinceLastPayment?: InputMaybe<Order_By>;
  OfficesServingClient?: InputMaybe<Order_By>;
  PartnersServingClient?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Finance_Hours_Clienttimeframe_Var_Samp_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  OfficesServingClient?: Maybe<Scalars['Float']['output']>;
  PartnersServingClient?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Var_Samp_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  DaysSinceLastPayment?: InputMaybe<Order_By>;
  OfficesServingClient?: InputMaybe<Order_By>;
  PartnersServingClient?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mlfsl_Finance_Hours_Clienttimeframe_Variance_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  OfficesServingClient?: Maybe<Scalars['Float']['output']>;
  PartnersServingClient?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "MNET.Finance_Hours_ClientTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimeframe_Variance_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  DaysSinceLastPayment?: InputMaybe<Order_By>;
  OfficesServingClient?: InputMaybe<Order_By>;
  PartnersServingClient?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
};

/** columns and relationships of "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe = {
  /** An object relationship */
  Client?: Maybe<Mlfsl_Client>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent: Scalars['Float']['output'];
  ClientNumber: Scalars['String']['output'];
  /** An object relationship */
  RelatedClient?: Maybe<Mlfsl_Related_Client>;
  RelatedClientBillableHoursPercent: Scalars['Float']['output'];
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  Timeframe: Scalars['String']['output'];
  /** An object relationship */
  Timekeeper?: Maybe<Mlfsl_Personnel>;
  TkprNumber: Scalars['String']['output'];
  Tkpr_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  Tkpr_OfficeEliteLocationCode?: Maybe<Scalars['String']['output']>;
  Tkpr_OfficeNameDisplay?: Maybe<Scalars['String']['output']>;
  Tkpr_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  Tkpr_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  Tkpr_Role?: Maybe<Scalars['String']['output']>;
  Tkpr_RoleSort?: Maybe<Scalars['String']['output']>;
  Tkpr_SecondaryPracticeGroupCode?: Maybe<Scalars['String']['output']>;
  Tkpr_SecondaryPracticeGroupName?: Maybe<Scalars['String']['output']>;
  Tkpr_Secondary_mnet_practice_group_detail?: Maybe<Mnet_Practice_Group_Detail>;
  Tkpr_TitleDisplay?: Maybe<Scalars['String']['output']>;
  Tkpr_mnet_office_detail?: Maybe<Mnet_Office_Detail>;
  Tkpr_mnet_practice_group_detail?: Maybe<Mnet_Practice_Group_Detail>;
};

/** aggregated selection of "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Aggregate = {
  aggregate?: Maybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Aggregate_Fields>;
  nodes: Array<Mlfsl_Finance_Hours_Clienttimekeepertimeframe>;
};

/** aggregate fields of "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Max_Fields>;
  min?: Maybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Min_Fields>;
  stddev?: Maybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Variance_Fields>;
};

/** aggregate fields of "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Avg_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Avg_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_ClientTimekeeperTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Bool_Exp = {
  Client?: InputMaybe<Mlfsl_Client_Bool_Exp>;
  ClientBillableHours?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ClientBillableHoursPercent?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Bool_Exp>;
  RelatedClientBillableHoursPercent?: InputMaybe<Float_Mssql_Comparison_Exp>;
  RelatedClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  Timeframe?: InputMaybe<String_Mssql_Comparison_Exp>;
  Timekeeper?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
  TkprNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_NamePreferredDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_OfficeEliteLocationCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_OfficeNameDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_PracticeGroupCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_PracticeGroupName?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_Role?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_RoleSort?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_SecondaryPracticeGroupCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_SecondaryPracticeGroupName?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_TitleDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Bool_Exp>>;
};

/** aggregate max on columns */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Max_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  Timeframe?: Maybe<Scalars['String']['output']>;
  TkprNumber?: Maybe<Scalars['String']['output']>;
  Tkpr_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  Tkpr_OfficeEliteLocationCode?: Maybe<Scalars['String']['output']>;
  Tkpr_OfficeNameDisplay?: Maybe<Scalars['String']['output']>;
  Tkpr_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  Tkpr_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  Tkpr_Role?: Maybe<Scalars['String']['output']>;
  Tkpr_RoleSort?: Maybe<Scalars['String']['output']>;
  Tkpr_SecondaryPracticeGroupCode?: Maybe<Scalars['String']['output']>;
  Tkpr_SecondaryPracticeGroupName?: Maybe<Scalars['String']['output']>;
  Tkpr_TitleDisplay?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Max_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
  TkprNumber?: InputMaybe<Order_By>;
  Tkpr_NamePreferredDisplay?: InputMaybe<Order_By>;
  Tkpr_OfficeEliteLocationCode?: InputMaybe<Order_By>;
  Tkpr_OfficeNameDisplay?: InputMaybe<Order_By>;
  Tkpr_PracticeGroupCode?: InputMaybe<Order_By>;
  Tkpr_PracticeGroupName?: InputMaybe<Order_By>;
  Tkpr_Role?: InputMaybe<Order_By>;
  Tkpr_RoleSort?: InputMaybe<Order_By>;
  Tkpr_SecondaryPracticeGroupCode?: InputMaybe<Order_By>;
  Tkpr_SecondaryPracticeGroupName?: InputMaybe<Order_By>;
  Tkpr_TitleDisplay?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Min_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  Timeframe?: Maybe<Scalars['String']['output']>;
  TkprNumber?: Maybe<Scalars['String']['output']>;
  Tkpr_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  Tkpr_OfficeEliteLocationCode?: Maybe<Scalars['String']['output']>;
  Tkpr_OfficeNameDisplay?: Maybe<Scalars['String']['output']>;
  Tkpr_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  Tkpr_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  Tkpr_Role?: Maybe<Scalars['String']['output']>;
  Tkpr_RoleSort?: Maybe<Scalars['String']['output']>;
  Tkpr_SecondaryPracticeGroupCode?: Maybe<Scalars['String']['output']>;
  Tkpr_SecondaryPracticeGroupName?: Maybe<Scalars['String']['output']>;
  Tkpr_TitleDisplay?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Min_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
  TkprNumber?: InputMaybe<Order_By>;
  Tkpr_NamePreferredDisplay?: InputMaybe<Order_By>;
  Tkpr_OfficeEliteLocationCode?: InputMaybe<Order_By>;
  Tkpr_OfficeNameDisplay?: InputMaybe<Order_By>;
  Tkpr_PracticeGroupCode?: InputMaybe<Order_By>;
  Tkpr_PracticeGroupName?: InputMaybe<Order_By>;
  Tkpr_Role?: InputMaybe<Order_By>;
  Tkpr_RoleSort?: InputMaybe<Order_By>;
  Tkpr_SecondaryPracticeGroupCode?: InputMaybe<Order_By>;
  Tkpr_SecondaryPracticeGroupName?: InputMaybe<Order_By>;
  Tkpr_TitleDisplay?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "MNET.Finance_Hours_ClientTimekeeperTimeframe". */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Order_By = {
  Client?: InputMaybe<Mlfsl_Client_Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
  Timekeeper?: InputMaybe<Mlfsl_Personnel_Order_By>;
  TkprNumber?: InputMaybe<Order_By>;
  Tkpr_NamePreferredDisplay?: InputMaybe<Order_By>;
  Tkpr_OfficeEliteLocationCode?: InputMaybe<Order_By>;
  Tkpr_OfficeNameDisplay?: InputMaybe<Order_By>;
  Tkpr_PracticeGroupCode?: InputMaybe<Order_By>;
  Tkpr_PracticeGroupName?: InputMaybe<Order_By>;
  Tkpr_Role?: InputMaybe<Order_By>;
  Tkpr_RoleSort?: InputMaybe<Order_By>;
  Tkpr_SecondaryPracticeGroupCode?: InputMaybe<Order_By>;
  Tkpr_SecondaryPracticeGroupName?: InputMaybe<Order_By>;
  Tkpr_TitleDisplay?: InputMaybe<Order_By>;
};

/** select columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export enum Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Select_Column {
  /** column name */
  ClientBillableHours = 'ClientBillableHours',
  /** column name */
  ClientBillableHoursPercent = 'ClientBillableHoursPercent',
  /** column name */
  ClientNumber = 'ClientNumber',
  /** column name */
  RelatedClientBillableHoursPercent = 'RelatedClientBillableHoursPercent',
  /** column name */
  RelatedClientNumber = 'RelatedClientNumber',
  /** column name */
  Timeframe = 'Timeframe',
  /** column name */
  TkprNumber = 'TkprNumber',
  /** column name */
  Tkpr_NamePreferredDisplay = 'Tkpr_NamePreferredDisplay',
  /** column name */
  Tkpr_OfficeEliteLocationCode = 'Tkpr_OfficeEliteLocationCode',
  /** column name */
  Tkpr_OfficeNameDisplay = 'Tkpr_OfficeNameDisplay',
  /** column name */
  Tkpr_PracticeGroupCode = 'Tkpr_PracticeGroupCode',
  /** column name */
  Tkpr_PracticeGroupName = 'Tkpr_PracticeGroupName',
  /** column name */
  Tkpr_Role = 'Tkpr_Role',
  /** column name */
  Tkpr_RoleSort = 'Tkpr_RoleSort',
  /** column name */
  Tkpr_SecondaryPracticeGroupCode = 'Tkpr_SecondaryPracticeGroupCode',
  /** column name */
  Tkpr_SecondaryPracticeGroupName = 'Tkpr_SecondaryPracticeGroupName',
  /** column name */
  Tkpr_TitleDisplay = 'Tkpr_TitleDisplay',
}

/** aggregate stddev on columns */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Stddev_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Stddev_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Stddev_Pop_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Stddev_Pop_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Stddev_Samp_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Stddev_Samp_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Sum_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Sum_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Var_Pop_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Var_Pop_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Var_Samp_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Var_Samp_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Variance_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Variance_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** columns and relationships of "MNET.Finance_Hours_Matter" */
export type Mlfsl_Finance_Hours_Matter = {
  AttorneyInCharge_ActiveDirectoryLogin?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_Email?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_EmployeeId?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_mnet_practice_group_detail?: Maybe<Mnet_Practice_Group_Detail>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  MatterIndustryCode?: Maybe<Scalars['String']['output']>;
  MatterIndustryCodeDescription?: Maybe<Scalars['String']['output']>;
  MatterName?: Maybe<Scalars['String']['output']>;
  MatterNumber: Scalars['String']['output'];
  MatterPracticeCode?: Maybe<Scalars['String']['output']>;
  MatterPracticeCodeDescription?: Maybe<Scalars['String']['output']>;
  MatterStatusCategory?: Maybe<Scalars['String']['output']>;
  MatterStatusCode?: Maybe<Scalars['String']['output']>;
  MatterStatusDescription?: Maybe<Scalars['String']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  TimeKeeperCount: Scalars['Int']['output'];
  /** An object relationship */
  mlfsl_client?: Maybe<Mlfsl_Client>;
  /** An object relationship */
  mlfsl_matter?: Maybe<Mlfsl_Matter>;
  /** An object relationship */
  mlfsl_related_client?: Maybe<Mlfsl_Related_Client>;
};

/** aggregated selection of "MNET.Finance_Hours_Matter" */
export type Mlfsl_Finance_Hours_Matter_Aggregate = {
  aggregate?: Maybe<Mlfsl_Finance_Hours_Matter_Aggregate_Fields>;
  nodes: Array<Mlfsl_Finance_Hours_Matter>;
};

/** aggregate fields of "MNET.Finance_Hours_Matter" */
export type Mlfsl_Finance_Hours_Matter_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Finance_Hours_Matter_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Finance_Hours_Matter_Max_Fields>;
  min?: Maybe<Mlfsl_Finance_Hours_Matter_Min_Fields>;
  stddev?: Maybe<Mlfsl_Finance_Hours_Matter_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Finance_Hours_Matter_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Finance_Hours_Matter_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Finance_Hours_Matter_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Finance_Hours_Matter_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Finance_Hours_Matter_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Finance_Hours_Matter_Variance_Fields>;
};

/** aggregate fields of "MNET.Finance_Hours_Matter" */
export type Mlfsl_Finance_Hours_Matter_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Finance_Hours_Matter_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mlfsl_Finance_Hours_Matter_Avg_Fields = {
  TimeKeeperCount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_Matter". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Matter_Bool_Exp = {
  AttorneyInCharge_ActiveDirectoryLogin?: InputMaybe<String_Mssql_Comparison_Exp>;
  AttorneyInCharge_Email?: InputMaybe<String_Mssql_Comparison_Exp>;
  AttorneyInCharge_EmployeeId?: InputMaybe<String_Mssql_Comparison_Exp>;
  AttorneyInCharge_NamePreferredDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  AttorneyInCharge_PracticeGroupCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  AttorneyInCharge_PracticeGroupName?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterIndustryCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterIndustryCodeDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterName?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterPracticeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterPracticeCodeDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterStatusCategory?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterStatusCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterStatusDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  RelatedClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  TimeKeeperCount?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Finance_Hours_Matter_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Finance_Hours_Matter_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Finance_Hours_Matter_Bool_Exp>>;
  mlfsl_client?: InputMaybe<Mlfsl_Client_Bool_Exp>;
  mlfsl_matter?: InputMaybe<Mlfsl_Matter_Bool_Exp>;
  mlfsl_related_client?: InputMaybe<Mlfsl_Related_Client_Bool_Exp>;
};

/** aggregate max on columns */
export type Mlfsl_Finance_Hours_Matter_Max_Fields = {
  AttorneyInCharge_ActiveDirectoryLogin?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_Email?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_EmployeeId?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  MatterIndustryCode?: Maybe<Scalars['String']['output']>;
  MatterIndustryCodeDescription?: Maybe<Scalars['String']['output']>;
  MatterName?: Maybe<Scalars['String']['output']>;
  MatterNumber?: Maybe<Scalars['String']['output']>;
  MatterPracticeCode?: Maybe<Scalars['String']['output']>;
  MatterPracticeCodeDescription?: Maybe<Scalars['String']['output']>;
  MatterStatusCategory?: Maybe<Scalars['String']['output']>;
  MatterStatusCode?: Maybe<Scalars['String']['output']>;
  MatterStatusDescription?: Maybe<Scalars['String']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  TimeKeeperCount?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Mlfsl_Finance_Hours_Matter_Min_Fields = {
  AttorneyInCharge_ActiveDirectoryLogin?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_Email?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_EmployeeId?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  MatterIndustryCode?: Maybe<Scalars['String']['output']>;
  MatterIndustryCodeDescription?: Maybe<Scalars['String']['output']>;
  MatterName?: Maybe<Scalars['String']['output']>;
  MatterNumber?: Maybe<Scalars['String']['output']>;
  MatterPracticeCode?: Maybe<Scalars['String']['output']>;
  MatterPracticeCodeDescription?: Maybe<Scalars['String']['output']>;
  MatterStatusCategory?: Maybe<Scalars['String']['output']>;
  MatterStatusCode?: Maybe<Scalars['String']['output']>;
  MatterStatusDescription?: Maybe<Scalars['String']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  TimeKeeperCount?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "MNET.Finance_Hours_Matter". */
export type Mlfsl_Finance_Hours_Matter_Order_By = {
  AttorneyInCharge_ActiveDirectoryLogin?: InputMaybe<Order_By>;
  AttorneyInCharge_Email?: InputMaybe<Order_By>;
  AttorneyInCharge_EmployeeId?: InputMaybe<Order_By>;
  AttorneyInCharge_NamePreferredDisplay?: InputMaybe<Order_By>;
  AttorneyInCharge_PracticeGroupCode?: InputMaybe<Order_By>;
  AttorneyInCharge_PracticeGroupName?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  MatterIndustryCode?: InputMaybe<Order_By>;
  MatterIndustryCodeDescription?: InputMaybe<Order_By>;
  MatterName?: InputMaybe<Order_By>;
  MatterNumber?: InputMaybe<Order_By>;
  MatterPracticeCode?: InputMaybe<Order_By>;
  MatterPracticeCodeDescription?: InputMaybe<Order_By>;
  MatterStatusCategory?: InputMaybe<Order_By>;
  MatterStatusCode?: InputMaybe<Order_By>;
  MatterStatusDescription?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  TimeKeeperCount?: InputMaybe<Order_By>;
  mlfsl_client?: InputMaybe<Mlfsl_Client_Order_By>;
  mlfsl_matter?: InputMaybe<Mlfsl_Matter_Order_By>;
  mlfsl_related_client?: InputMaybe<Mlfsl_Related_Client_Order_By>;
};

/** select columns of table "MNET.Finance_Hours_Matter" */
export enum Mlfsl_Finance_Hours_Matter_Select_Column {
  /** column name */
  AttorneyInCharge_ActiveDirectoryLogin = 'AttorneyInCharge_ActiveDirectoryLogin',
  /** column name */
  AttorneyInCharge_Email = 'AttorneyInCharge_Email',
  /** column name */
  AttorneyInCharge_EmployeeId = 'AttorneyInCharge_EmployeeId',
  /** column name */
  AttorneyInCharge_NamePreferredDisplay = 'AttorneyInCharge_NamePreferredDisplay',
  /** column name */
  AttorneyInCharge_PracticeGroupCode = 'AttorneyInCharge_PracticeGroupCode',
  /** column name */
  AttorneyInCharge_PracticeGroupName = 'AttorneyInCharge_PracticeGroupName',
  /** column name */
  ClientNumber = 'ClientNumber',
  /** column name */
  MatterIndustryCode = 'MatterIndustryCode',
  /** column name */
  MatterIndustryCodeDescription = 'MatterIndustryCodeDescription',
  /** column name */
  MatterName = 'MatterName',
  /** column name */
  MatterNumber = 'MatterNumber',
  /** column name */
  MatterPracticeCode = 'MatterPracticeCode',
  /** column name */
  MatterPracticeCodeDescription = 'MatterPracticeCodeDescription',
  /** column name */
  MatterStatusCategory = 'MatterStatusCategory',
  /** column name */
  MatterStatusCode = 'MatterStatusCode',
  /** column name */
  MatterStatusDescription = 'MatterStatusDescription',
  /** column name */
  RelatedClientNumber = 'RelatedClientNumber',
  /** column name */
  TimeKeeperCount = 'TimeKeeperCount',
}

/** aggregate stddev on columns */
export type Mlfsl_Finance_Hours_Matter_Stddev_Fields = {
  TimeKeeperCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Finance_Hours_Matter_Stddev_Pop_Fields = {
  TimeKeeperCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Finance_Hours_Matter_Stddev_Samp_Fields = {
  TimeKeeperCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Mlfsl_Finance_Hours_Matter_Sum_Fields = {
  TimeKeeperCount?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Finance_Hours_Matter_Var_Pop_Fields = {
  TimeKeeperCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Finance_Hours_Matter_Var_Samp_Fields = {
  TimeKeeperCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mlfsl_Finance_Hours_Matter_Variance_Fields = {
  TimeKeeperCount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe = {
  /** An object relationship */
  Client?: Maybe<Mlfsl_Client>;
  ClientBillableHours: Scalars['Float']['output'];
  ClientNumber: Scalars['String']['output'];
  HistoricalTKOfficeforCount: Scalars['String']['output'];
  Matter: Scalars['String']['output'];
  /** An object relationship */
  RelatedClient?: Maybe<Mlfsl_Related_Client>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  Timeframe: Scalars['String']['output'];
  historical_tk_mnet_office_detail?: Maybe<Mnet_Office_Detail>;
  /** An object relationship */
  mlfsl_matter?: Maybe<Mlfsl_Matter>;
};

/** order by aggregate values of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Variance_Order_By>;
};

/** order by avg() on columns of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Avg_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_MatterOfficeTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Bool_Exp = {
  Client?: InputMaybe<Mlfsl_Client_Bool_Exp>;
  ClientBillableHours?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  HistoricalTKOfficeforCount?: InputMaybe<String_Mssql_Comparison_Exp>;
  Matter?: InputMaybe<String_Mssql_Comparison_Exp>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Bool_Exp>;
  RelatedClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  Timeframe?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Finance_Hours_Matterofficetimeframe_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Finance_Hours_Matterofficetimeframe_Bool_Exp>>;
  mlfsl_matter?: InputMaybe<Mlfsl_Matter_Bool_Exp>;
};

/** order by max() on columns of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Max_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  HistoricalTKOfficeforCount?: InputMaybe<Order_By>;
  Matter?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Min_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  HistoricalTKOfficeforCount?: InputMaybe<Order_By>;
  Matter?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "MNET.Finance_Hours_MatterOfficeTimeframe". */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Order_By = {
  Client?: InputMaybe<Mlfsl_Client_Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  HistoricalTKOfficeforCount?: InputMaybe<Order_By>;
  Matter?: InputMaybe<Order_By>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
  mlfsl_matter?: InputMaybe<Mlfsl_Matter_Order_By>;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Stddev_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Stddev_Pop_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Stddev_Samp_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Sum_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Var_Pop_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Var_Samp_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "MNET.Finance_Hours_MatterOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Matterofficetimeframe_Variance_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** columns and relationships of "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe = {
  /** An object relationship */
  Client?: Maybe<Mlfsl_Client>;
  ClientBillableHours: Scalars['Float']['output'];
  ClientNumber: Scalars['String']['output'];
  HistoricalTKPGforCount: Scalars['String']['output'];
  Matter: Scalars['String']['output'];
  PracticeGroupName: Scalars['String']['output'];
  /** An object relationship */
  RelatedClient?: Maybe<Mlfsl_Related_Client>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  Timeframe: Scalars['String']['output'];
  historical_tk_mnet_practice_group_detail?: Maybe<Mnet_Practice_Group_Detail>;
  /** An object relationship */
  mlfsl_matter?: Maybe<Mlfsl_Matter>;
};

/** order by aggregate values of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Variance_Order_By>;
};

/** order by avg() on columns of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Avg_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_MatterPGTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Bool_Exp = {
  Client?: InputMaybe<Mlfsl_Client_Bool_Exp>;
  ClientBillableHours?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  HistoricalTKPGforCount?: InputMaybe<String_Mssql_Comparison_Exp>;
  Matter?: InputMaybe<String_Mssql_Comparison_Exp>;
  PracticeGroupName?: InputMaybe<String_Mssql_Comparison_Exp>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Bool_Exp>;
  RelatedClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  Timeframe?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Finance_Hours_Matterpgtimeframe_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Finance_Hours_Matterpgtimeframe_Bool_Exp>>;
  mlfsl_matter?: InputMaybe<Mlfsl_Matter_Bool_Exp>;
};

/** order by max() on columns of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Max_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  HistoricalTKPGforCount?: InputMaybe<Order_By>;
  Matter?: InputMaybe<Order_By>;
  PracticeGroupName?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Min_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  HistoricalTKPGforCount?: InputMaybe<Order_By>;
  Matter?: InputMaybe<Order_By>;
  PracticeGroupName?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "MNET.Finance_Hours_MatterPGTimeframe". */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Order_By = {
  Client?: InputMaybe<Mlfsl_Client_Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  HistoricalTKPGforCount?: InputMaybe<Order_By>;
  Matter?: InputMaybe<Order_By>;
  PracticeGroupName?: InputMaybe<Order_By>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
  mlfsl_matter?: InputMaybe<Mlfsl_Matter_Order_By>;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Stddev_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Stddev_Pop_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Stddev_Samp_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Sum_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Var_Pop_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Var_Samp_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "MNET.Finance_Hours_MatterPGTimeframe" */
export type Mlfsl_Finance_Hours_Matterpgtimeframe_Variance_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** columns and relationships of "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe = {
  AttorneyInCharge_ActiveDirectoryLogin?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_Email?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_EmployeeId?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_mnet_practice_group_detail?: Maybe<Mnet_Practice_Group_Detail>;
  BilledAmount: Scalars['Float']['output'];
  /** An object relationship */
  Client?: Maybe<Mlfsl_Client>;
  ClientBillableHours: Scalars['Float']['output'];
  ClientBillableHoursPercent: Scalars['Float']['output'];
  ClientNumber: Scalars['String']['output'];
  Matter: Scalars['String']['output'];
  MatterIndustryCode?: Maybe<Scalars['String']['output']>;
  MatterIndustryCodeDescription?: Maybe<Scalars['String']['output']>;
  MatterName?: Maybe<Scalars['String']['output']>;
  MatterPracticeCode: Scalars['String']['output'];
  MatterPracticeCodeDescription?: Maybe<Scalars['String']['output']>;
  MatterStatusCategory?: Maybe<Scalars['String']['output']>;
  MatterStatusCode: Scalars['String']['output'];
  MatterStatusDescription?: Maybe<Scalars['String']['output']>;
  OfficesServingMatter?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  RelatedClient?: Maybe<Mlfsl_Related_Client>;
  RelatedClientBillableHoursPercent: Scalars['Float']['output'];
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  TimeChargesBooked: Scalars['Float']['output'];
  Timeframe: Scalars['String']['output'];
  TimekeepersServingMatter?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  mlfsl_matter?: Maybe<Mlfsl_Matter>;
};

/** aggregated selection of "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Aggregate = {
  aggregate?: Maybe<Mlfsl_Finance_Hours_Mattertimeframe_Aggregate_Fields>;
  nodes: Array<Mlfsl_Finance_Hours_Mattertimeframe>;
};

/** aggregate fields of "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Finance_Hours_Mattertimeframe_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Finance_Hours_Mattertimeframe_Max_Fields>;
  min?: Maybe<Mlfsl_Finance_Hours_Mattertimeframe_Min_Fields>;
  stddev?: Maybe<Mlfsl_Finance_Hours_Mattertimeframe_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Finance_Hours_Mattertimeframe_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Finance_Hours_Mattertimeframe_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Finance_Hours_Mattertimeframe_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Finance_Hours_Mattertimeframe_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Finance_Hours_Mattertimeframe_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Finance_Hours_Mattertimeframe_Variance_Fields>;
};

/** aggregate fields of "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Mlfsl_Finance_Hours_Mattertimeframe_Avg_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  OfficesServingMatter?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
  TimekeepersServingMatter?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Avg_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  OfficesServingMatter?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
  TimekeepersServingMatter?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_MatterTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp = {
  AttorneyInCharge_ActiveDirectoryLogin?: InputMaybe<String_Mssql_Comparison_Exp>;
  AttorneyInCharge_Email?: InputMaybe<String_Mssql_Comparison_Exp>;
  AttorneyInCharge_EmployeeId?: InputMaybe<String_Mssql_Comparison_Exp>;
  AttorneyInCharge_NamePreferredDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  AttorneyInCharge_PracticeGroupCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  AttorneyInCharge_PracticeGroupName?: InputMaybe<String_Mssql_Comparison_Exp>;
  BilledAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  Client?: InputMaybe<Mlfsl_Client_Bool_Exp>;
  ClientBillableHours?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ClientBillableHoursPercent?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  Matter?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterIndustryCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterIndustryCodeDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterName?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterPracticeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterPracticeCodeDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterStatusCategory?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterStatusCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterStatusDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficesServingMatter?: InputMaybe<Int_Mssql_Comparison_Exp>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Bool_Exp>;
  RelatedClientBillableHoursPercent?: InputMaybe<Float_Mssql_Comparison_Exp>;
  RelatedClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  TimeChargesBooked?: InputMaybe<Float_Mssql_Comparison_Exp>;
  Timeframe?: InputMaybe<String_Mssql_Comparison_Exp>;
  TimekeepersServingMatter?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp>>;
  mlfsl_matter?: InputMaybe<Mlfsl_Matter_Bool_Exp>;
};

/** aggregate max on columns */
export type Mlfsl_Finance_Hours_Mattertimeframe_Max_Fields = {
  AttorneyInCharge_ActiveDirectoryLogin?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_Email?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_EmployeeId?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  Matter?: Maybe<Scalars['String']['output']>;
  MatterIndustryCode?: Maybe<Scalars['String']['output']>;
  MatterIndustryCodeDescription?: Maybe<Scalars['String']['output']>;
  MatterName?: Maybe<Scalars['String']['output']>;
  MatterPracticeCode?: Maybe<Scalars['String']['output']>;
  MatterPracticeCodeDescription?: Maybe<Scalars['String']['output']>;
  MatterStatusCategory?: Maybe<Scalars['String']['output']>;
  MatterStatusCode?: Maybe<Scalars['String']['output']>;
  MatterStatusDescription?: Maybe<Scalars['String']['output']>;
  OfficesServingMatter?: Maybe<Scalars['Int']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
  Timeframe?: Maybe<Scalars['String']['output']>;
  TimekeepersServingMatter?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Max_Order_By = {
  AttorneyInCharge_ActiveDirectoryLogin?: InputMaybe<Order_By>;
  AttorneyInCharge_Email?: InputMaybe<Order_By>;
  AttorneyInCharge_EmployeeId?: InputMaybe<Order_By>;
  AttorneyInCharge_NamePreferredDisplay?: InputMaybe<Order_By>;
  AttorneyInCharge_PracticeGroupCode?: InputMaybe<Order_By>;
  AttorneyInCharge_PracticeGroupName?: InputMaybe<Order_By>;
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  Matter?: InputMaybe<Order_By>;
  MatterIndustryCode?: InputMaybe<Order_By>;
  MatterIndustryCodeDescription?: InputMaybe<Order_By>;
  MatterName?: InputMaybe<Order_By>;
  MatterPracticeCode?: InputMaybe<Order_By>;
  MatterPracticeCodeDescription?: InputMaybe<Order_By>;
  MatterStatusCategory?: InputMaybe<Order_By>;
  MatterStatusCode?: InputMaybe<Order_By>;
  MatterStatusDescription?: InputMaybe<Order_By>;
  OfficesServingMatter?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
  TimekeepersServingMatter?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mlfsl_Finance_Hours_Mattertimeframe_Min_Fields = {
  AttorneyInCharge_ActiveDirectoryLogin?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_Email?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_EmployeeId?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  AttorneyInCharge_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  Matter?: Maybe<Scalars['String']['output']>;
  MatterIndustryCode?: Maybe<Scalars['String']['output']>;
  MatterIndustryCodeDescription?: Maybe<Scalars['String']['output']>;
  MatterName?: Maybe<Scalars['String']['output']>;
  MatterPracticeCode?: Maybe<Scalars['String']['output']>;
  MatterPracticeCodeDescription?: Maybe<Scalars['String']['output']>;
  MatterStatusCategory?: Maybe<Scalars['String']['output']>;
  MatterStatusCode?: Maybe<Scalars['String']['output']>;
  MatterStatusDescription?: Maybe<Scalars['String']['output']>;
  OfficesServingMatter?: Maybe<Scalars['Int']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
  Timeframe?: Maybe<Scalars['String']['output']>;
  TimekeepersServingMatter?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Min_Order_By = {
  AttorneyInCharge_ActiveDirectoryLogin?: InputMaybe<Order_By>;
  AttorneyInCharge_Email?: InputMaybe<Order_By>;
  AttorneyInCharge_EmployeeId?: InputMaybe<Order_By>;
  AttorneyInCharge_NamePreferredDisplay?: InputMaybe<Order_By>;
  AttorneyInCharge_PracticeGroupCode?: InputMaybe<Order_By>;
  AttorneyInCharge_PracticeGroupName?: InputMaybe<Order_By>;
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  Matter?: InputMaybe<Order_By>;
  MatterIndustryCode?: InputMaybe<Order_By>;
  MatterIndustryCodeDescription?: InputMaybe<Order_By>;
  MatterName?: InputMaybe<Order_By>;
  MatterPracticeCode?: InputMaybe<Order_By>;
  MatterPracticeCodeDescription?: InputMaybe<Order_By>;
  MatterStatusCategory?: InputMaybe<Order_By>;
  MatterStatusCode?: InputMaybe<Order_By>;
  MatterStatusDescription?: InputMaybe<Order_By>;
  OfficesServingMatter?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
  TimekeepersServingMatter?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "MNET.Finance_Hours_MatterTimeframe". */
export type Mlfsl_Finance_Hours_Mattertimeframe_Order_By = {
  AttorneyInCharge_ActiveDirectoryLogin?: InputMaybe<Order_By>;
  AttorneyInCharge_Email?: InputMaybe<Order_By>;
  AttorneyInCharge_EmployeeId?: InputMaybe<Order_By>;
  AttorneyInCharge_NamePreferredDisplay?: InputMaybe<Order_By>;
  AttorneyInCharge_PracticeGroupCode?: InputMaybe<Order_By>;
  AttorneyInCharge_PracticeGroupName?: InputMaybe<Order_By>;
  BilledAmount?: InputMaybe<Order_By>;
  Client?: InputMaybe<Mlfsl_Client_Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  Matter?: InputMaybe<Order_By>;
  MatterIndustryCode?: InputMaybe<Order_By>;
  MatterIndustryCodeDescription?: InputMaybe<Order_By>;
  MatterName?: InputMaybe<Order_By>;
  MatterPracticeCode?: InputMaybe<Order_By>;
  MatterPracticeCodeDescription?: InputMaybe<Order_By>;
  MatterStatusCategory?: InputMaybe<Order_By>;
  MatterStatusCode?: InputMaybe<Order_By>;
  MatterStatusDescription?: InputMaybe<Order_By>;
  OfficesServingMatter?: InputMaybe<Order_By>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
  TimekeepersServingMatter?: InputMaybe<Order_By>;
  mlfsl_matter?: InputMaybe<Mlfsl_Matter_Order_By>;
};

/** select columns of table "MNET.Finance_Hours_MatterTimeframe" */
export enum Mlfsl_Finance_Hours_Mattertimeframe_Select_Column {
  /** column name */
  AttorneyInCharge_ActiveDirectoryLogin = 'AttorneyInCharge_ActiveDirectoryLogin',
  /** column name */
  AttorneyInCharge_Email = 'AttorneyInCharge_Email',
  /** column name */
  AttorneyInCharge_EmployeeId = 'AttorneyInCharge_EmployeeId',
  /** column name */
  AttorneyInCharge_NamePreferredDisplay = 'AttorneyInCharge_NamePreferredDisplay',
  /** column name */
  AttorneyInCharge_PracticeGroupCode = 'AttorneyInCharge_PracticeGroupCode',
  /** column name */
  AttorneyInCharge_PracticeGroupName = 'AttorneyInCharge_PracticeGroupName',
  /** column name */
  BilledAmount = 'BilledAmount',
  /** column name */
  ClientBillableHours = 'ClientBillableHours',
  /** column name */
  ClientBillableHoursPercent = 'ClientBillableHoursPercent',
  /** column name */
  ClientNumber = 'ClientNumber',
  /** column name */
  Matter = 'Matter',
  /** column name */
  MatterIndustryCode = 'MatterIndustryCode',
  /** column name */
  MatterIndustryCodeDescription = 'MatterIndustryCodeDescription',
  /** column name */
  MatterName = 'MatterName',
  /** column name */
  MatterPracticeCode = 'MatterPracticeCode',
  /** column name */
  MatterPracticeCodeDescription = 'MatterPracticeCodeDescription',
  /** column name */
  MatterStatusCategory = 'MatterStatusCategory',
  /** column name */
  MatterStatusCode = 'MatterStatusCode',
  /** column name */
  MatterStatusDescription = 'MatterStatusDescription',
  /** column name */
  OfficesServingMatter = 'OfficesServingMatter',
  /** column name */
  RelatedClientBillableHoursPercent = 'RelatedClientBillableHoursPercent',
  /** column name */
  RelatedClientNumber = 'RelatedClientNumber',
  /** column name */
  TimeChargesBooked = 'TimeChargesBooked',
  /** column name */
  Timeframe = 'Timeframe',
  /** column name */
  TimekeepersServingMatter = 'TimekeepersServingMatter',
}

/** aggregate stddev on columns */
export type Mlfsl_Finance_Hours_Mattertimeframe_Stddev_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  OfficesServingMatter?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
  TimekeepersServingMatter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Stddev_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  OfficesServingMatter?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
  TimekeepersServingMatter?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Finance_Hours_Mattertimeframe_Stddev_Pop_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  OfficesServingMatter?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
  TimekeepersServingMatter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Stddev_Pop_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  OfficesServingMatter?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
  TimekeepersServingMatter?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Finance_Hours_Mattertimeframe_Stddev_Samp_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  OfficesServingMatter?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
  TimekeepersServingMatter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Stddev_Samp_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  OfficesServingMatter?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
  TimekeepersServingMatter?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Mlfsl_Finance_Hours_Mattertimeframe_Sum_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  OfficesServingMatter?: Maybe<Scalars['Int']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
  TimekeepersServingMatter?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Sum_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  OfficesServingMatter?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
  TimekeepersServingMatter?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Finance_Hours_Mattertimeframe_Var_Pop_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  OfficesServingMatter?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
  TimekeepersServingMatter?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Var_Pop_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  OfficesServingMatter?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
  TimekeepersServingMatter?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Finance_Hours_Mattertimeframe_Var_Samp_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  OfficesServingMatter?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
  TimekeepersServingMatter?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Var_Samp_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  OfficesServingMatter?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
  TimekeepersServingMatter?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mlfsl_Finance_Hours_Mattertimeframe_Variance_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  OfficesServingMatter?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
  TimekeepersServingMatter?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "MNET.Finance_Hours_MatterTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimeframe_Variance_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  OfficesServingMatter?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
  TimekeepersServingMatter?: InputMaybe<Order_By>;
};

/** columns and relationships of "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare = {
  /** An object relationship */
  Client?: Maybe<Mlfsl_Client>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  ClientNumber: Scalars['String']['output'];
  CompareClientBillableHours?: Maybe<Scalars['Float']['output']>;
  CompareTimeframe: Scalars['String']['output'];
  DifferenceClientBillableHours?: Maybe<Scalars['Float']['output']>;
  DifferenceClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  Matter: Scalars['String']['output'];
  MatterName?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  RelatedClient?: Maybe<Mlfsl_Related_Client>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  Timeframe: Scalars['String']['output'];
  /** An object relationship */
  mlfsl_matter?: Maybe<Mlfsl_Matter>;
};

/** order by aggregate values of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Variance_Order_By>;
};

/** order by avg() on columns of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Avg_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  CompareClientBillableHours?: InputMaybe<Order_By>;
  DifferenceClientBillableHours?: InputMaybe<Order_By>;
  DifferenceClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_MatterTimeframeCompare". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Bool_Exp = {
  Client?: InputMaybe<Mlfsl_Client_Bool_Exp>;
  ClientBillableHours?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ClientBillableHoursPercent?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  CompareClientBillableHours?: InputMaybe<Float_Mssql_Comparison_Exp>;
  CompareTimeframe?: InputMaybe<String_Mssql_Comparison_Exp>;
  DifferenceClientBillableHours?: InputMaybe<Float_Mssql_Comparison_Exp>;
  DifferenceClientBillableHoursPercent?: InputMaybe<Float_Mssql_Comparison_Exp>;
  Matter?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterName?: InputMaybe<String_Mssql_Comparison_Exp>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Bool_Exp>;
  RelatedClientBillableHoursPercent?: InputMaybe<Float_Mssql_Comparison_Exp>;
  RelatedClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  Timeframe?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimeframecompare_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimeframecompare_Bool_Exp>>;
  mlfsl_matter?: InputMaybe<Mlfsl_Matter_Bool_Exp>;
};

/** order by max() on columns of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Max_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  CompareClientBillableHours?: InputMaybe<Order_By>;
  CompareTimeframe?: InputMaybe<Order_By>;
  DifferenceClientBillableHours?: InputMaybe<Order_By>;
  DifferenceClientBillableHoursPercent?: InputMaybe<Order_By>;
  Matter?: InputMaybe<Order_By>;
  MatterName?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Min_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  CompareClientBillableHours?: InputMaybe<Order_By>;
  CompareTimeframe?: InputMaybe<Order_By>;
  DifferenceClientBillableHours?: InputMaybe<Order_By>;
  DifferenceClientBillableHoursPercent?: InputMaybe<Order_By>;
  Matter?: InputMaybe<Order_By>;
  MatterName?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "MNET.Finance_Hours_MatterTimeframeCompare". */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Order_By = {
  Client?: InputMaybe<Mlfsl_Client_Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  CompareClientBillableHours?: InputMaybe<Order_By>;
  CompareTimeframe?: InputMaybe<Order_By>;
  DifferenceClientBillableHours?: InputMaybe<Order_By>;
  DifferenceClientBillableHoursPercent?: InputMaybe<Order_By>;
  Matter?: InputMaybe<Order_By>;
  MatterName?: InputMaybe<Order_By>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
  mlfsl_matter?: InputMaybe<Mlfsl_Matter_Order_By>;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Stddev_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  CompareClientBillableHours?: InputMaybe<Order_By>;
  DifferenceClientBillableHours?: InputMaybe<Order_By>;
  DifferenceClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Stddev_Pop_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  CompareClientBillableHours?: InputMaybe<Order_By>;
  DifferenceClientBillableHours?: InputMaybe<Order_By>;
  DifferenceClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Stddev_Samp_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  CompareClientBillableHours?: InputMaybe<Order_By>;
  DifferenceClientBillableHours?: InputMaybe<Order_By>;
  DifferenceClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Sum_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  CompareClientBillableHours?: InputMaybe<Order_By>;
  DifferenceClientBillableHours?: InputMaybe<Order_By>;
  DifferenceClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Var_Pop_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  CompareClientBillableHours?: InputMaybe<Order_By>;
  DifferenceClientBillableHours?: InputMaybe<Order_By>;
  DifferenceClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Var_Samp_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  CompareClientBillableHours?: InputMaybe<Order_By>;
  DifferenceClientBillableHours?: InputMaybe<Order_By>;
  DifferenceClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "MNET.Finance_Hours_MatterTimeframeCompare" */
export type Mlfsl_Finance_Hours_Mattertimeframecompare_Variance_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  CompareClientBillableHours?: InputMaybe<Order_By>;
  DifferenceClientBillableHours?: InputMaybe<Order_By>;
  DifferenceClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** columns and relationships of "MNET.Finance_Hours_MatterTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe = {
  ClientBillableHours: Scalars['Float']['output'];
  ClientBillableHoursPercent: Scalars['Float']['output'];
  ClientNumber: Scalars['String']['output'];
  Matter: Scalars['String']['output'];
  MatterBillableHoursPercent: Scalars['Float']['output'];
  RelatedClientBillableHoursPercent: Scalars['Float']['output'];
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  Timeframe: Scalars['String']['output'];
  /** An object relationship */
  Timekeeper?: Maybe<Mlfsl_Personnel>;
  TkprNumber: Scalars['String']['output'];
  Tkpr_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  Tkpr_OfficeEliteLocationCode?: Maybe<Scalars['String']['output']>;
  Tkpr_OfficeNameDisplay?: Maybe<Scalars['String']['output']>;
  Tkpr_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  Tkpr_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  Tkpr_Role?: Maybe<Scalars['String']['output']>;
  Tkpr_RoleSort?: Maybe<Scalars['String']['output']>;
  Tkpr_SecondaryPracticeGroupCode?: Maybe<Scalars['String']['output']>;
  Tkpr_SecondaryPracticeGroupName?: Maybe<Scalars['String']['output']>;
  Tkpr_TitleDisplay?: Maybe<Scalars['String']['output']>;
  mnet_office_detail?: Maybe<Mnet_Office_Detail>;
  mnet_practice_group_detail?: Maybe<Mnet_Practice_Group_Detail>;
  mnet_secondary_practice_group_detail?: Maybe<Mnet_Practice_Group_Detail>;
};

/** aggregated selection of "MNET.Finance_Hours_MatterTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Aggregate = {
  aggregate?: Maybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Aggregate_Fields>;
  nodes: Array<Mlfsl_Finance_Hours_Mattertimekeepertimeframe>;
};

/** aggregate fields of "MNET.Finance_Hours_MatterTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Max_Fields>;
  min?: Maybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Min_Fields>;
  stddev?: Maybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Variance_Fields>;
};

/** aggregate fields of "MNET.Finance_Hours_MatterTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "MNET.Finance_Hours_MatterTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Avg_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  MatterBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "MNET.Finance_Hours_MatterTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Avg_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  MatterBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_MatterTimekeeperTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Bool_Exp = {
  ClientBillableHours?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ClientBillableHoursPercent?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  Matter?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterBillableHoursPercent?: InputMaybe<Float_Mssql_Comparison_Exp>;
  RelatedClientBillableHoursPercent?: InputMaybe<Float_Mssql_Comparison_Exp>;
  RelatedClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  Timeframe?: InputMaybe<String_Mssql_Comparison_Exp>;
  Timekeeper?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
  TkprNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_NamePreferredDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_OfficeEliteLocationCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_OfficeNameDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_PracticeGroupCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_PracticeGroupName?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_Role?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_RoleSort?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_SecondaryPracticeGroupCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_SecondaryPracticeGroupName?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_TitleDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Bool_Exp>>;
};

/** aggregate max on columns */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Max_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  Matter?: Maybe<Scalars['String']['output']>;
  MatterBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  Timeframe?: Maybe<Scalars['String']['output']>;
  TkprNumber?: Maybe<Scalars['String']['output']>;
  Tkpr_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  Tkpr_OfficeEliteLocationCode?: Maybe<Scalars['String']['output']>;
  Tkpr_OfficeNameDisplay?: Maybe<Scalars['String']['output']>;
  Tkpr_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  Tkpr_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  Tkpr_Role?: Maybe<Scalars['String']['output']>;
  Tkpr_RoleSort?: Maybe<Scalars['String']['output']>;
  Tkpr_SecondaryPracticeGroupCode?: Maybe<Scalars['String']['output']>;
  Tkpr_SecondaryPracticeGroupName?: Maybe<Scalars['String']['output']>;
  Tkpr_TitleDisplay?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "MNET.Finance_Hours_MatterTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Max_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  Matter?: InputMaybe<Order_By>;
  MatterBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
  TkprNumber?: InputMaybe<Order_By>;
  Tkpr_NamePreferredDisplay?: InputMaybe<Order_By>;
  Tkpr_OfficeEliteLocationCode?: InputMaybe<Order_By>;
  Tkpr_OfficeNameDisplay?: InputMaybe<Order_By>;
  Tkpr_PracticeGroupCode?: InputMaybe<Order_By>;
  Tkpr_PracticeGroupName?: InputMaybe<Order_By>;
  Tkpr_Role?: InputMaybe<Order_By>;
  Tkpr_RoleSort?: InputMaybe<Order_By>;
  Tkpr_SecondaryPracticeGroupCode?: InputMaybe<Order_By>;
  Tkpr_SecondaryPracticeGroupName?: InputMaybe<Order_By>;
  Tkpr_TitleDisplay?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Min_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  Matter?: Maybe<Scalars['String']['output']>;
  MatterBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  Timeframe?: Maybe<Scalars['String']['output']>;
  TkprNumber?: Maybe<Scalars['String']['output']>;
  Tkpr_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  Tkpr_OfficeEliteLocationCode?: Maybe<Scalars['String']['output']>;
  Tkpr_OfficeNameDisplay?: Maybe<Scalars['String']['output']>;
  Tkpr_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  Tkpr_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  Tkpr_Role?: Maybe<Scalars['String']['output']>;
  Tkpr_RoleSort?: Maybe<Scalars['String']['output']>;
  Tkpr_SecondaryPracticeGroupCode?: Maybe<Scalars['String']['output']>;
  Tkpr_SecondaryPracticeGroupName?: Maybe<Scalars['String']['output']>;
  Tkpr_TitleDisplay?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "MNET.Finance_Hours_MatterTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Min_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  Matter?: InputMaybe<Order_By>;
  MatterBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
  TkprNumber?: InputMaybe<Order_By>;
  Tkpr_NamePreferredDisplay?: InputMaybe<Order_By>;
  Tkpr_OfficeEliteLocationCode?: InputMaybe<Order_By>;
  Tkpr_OfficeNameDisplay?: InputMaybe<Order_By>;
  Tkpr_PracticeGroupCode?: InputMaybe<Order_By>;
  Tkpr_PracticeGroupName?: InputMaybe<Order_By>;
  Tkpr_Role?: InputMaybe<Order_By>;
  Tkpr_RoleSort?: InputMaybe<Order_By>;
  Tkpr_SecondaryPracticeGroupCode?: InputMaybe<Order_By>;
  Tkpr_SecondaryPracticeGroupName?: InputMaybe<Order_By>;
  Tkpr_TitleDisplay?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "MNET.Finance_Hours_MatterTimekeeperTimeframe". */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  Matter?: InputMaybe<Order_By>;
  MatterBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
  Timekeeper?: InputMaybe<Mlfsl_Personnel_Order_By>;
  TkprNumber?: InputMaybe<Order_By>;
  Tkpr_NamePreferredDisplay?: InputMaybe<Order_By>;
  Tkpr_OfficeEliteLocationCode?: InputMaybe<Order_By>;
  Tkpr_OfficeNameDisplay?: InputMaybe<Order_By>;
  Tkpr_PracticeGroupCode?: InputMaybe<Order_By>;
  Tkpr_PracticeGroupName?: InputMaybe<Order_By>;
  Tkpr_Role?: InputMaybe<Order_By>;
  Tkpr_RoleSort?: InputMaybe<Order_By>;
  Tkpr_SecondaryPracticeGroupCode?: InputMaybe<Order_By>;
  Tkpr_SecondaryPracticeGroupName?: InputMaybe<Order_By>;
  Tkpr_TitleDisplay?: InputMaybe<Order_By>;
};

/** select columns of table "MNET.Finance_Hours_MatterTimekeeperTimeframe" */
export enum Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Select_Column {
  /** column name */
  ClientBillableHours = 'ClientBillableHours',
  /** column name */
  ClientBillableHoursPercent = 'ClientBillableHoursPercent',
  /** column name */
  ClientNumber = 'ClientNumber',
  /** column name */
  Matter = 'Matter',
  /** column name */
  MatterBillableHoursPercent = 'MatterBillableHoursPercent',
  /** column name */
  RelatedClientBillableHoursPercent = 'RelatedClientBillableHoursPercent',
  /** column name */
  RelatedClientNumber = 'RelatedClientNumber',
  /** column name */
  Timeframe = 'Timeframe',
  /** column name */
  TkprNumber = 'TkprNumber',
  /** column name */
  Tkpr_NamePreferredDisplay = 'Tkpr_NamePreferredDisplay',
  /** column name */
  Tkpr_OfficeEliteLocationCode = 'Tkpr_OfficeEliteLocationCode',
  /** column name */
  Tkpr_OfficeNameDisplay = 'Tkpr_OfficeNameDisplay',
  /** column name */
  Tkpr_PracticeGroupCode = 'Tkpr_PracticeGroupCode',
  /** column name */
  Tkpr_PracticeGroupName = 'Tkpr_PracticeGroupName',
  /** column name */
  Tkpr_Role = 'Tkpr_Role',
  /** column name */
  Tkpr_RoleSort = 'Tkpr_RoleSort',
  /** column name */
  Tkpr_SecondaryPracticeGroupCode = 'Tkpr_SecondaryPracticeGroupCode',
  /** column name */
  Tkpr_SecondaryPracticeGroupName = 'Tkpr_SecondaryPracticeGroupName',
  /** column name */
  Tkpr_TitleDisplay = 'Tkpr_TitleDisplay',
}

/** aggregate stddev on columns */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Stddev_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  MatterBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_MatterTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Stddev_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  MatterBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Stddev_Pop_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  MatterBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_MatterTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Stddev_Pop_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  MatterBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Stddev_Samp_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  MatterBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_MatterTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Stddev_Samp_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  MatterBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Sum_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  MatterBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "MNET.Finance_Hours_MatterTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Sum_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  MatterBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Var_Pop_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  MatterBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_MatterTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Var_Pop_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  MatterBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Var_Samp_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  MatterBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_MatterTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Var_Samp_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  MatterBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Variance_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  ClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  MatterBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "MNET.Finance_Hours_MatterTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Variance_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  ClientBillableHoursPercent?: InputMaybe<Order_By>;
  MatterBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** columns and relationships of "MNET.Finance_Hours_RelatedClient" */
export type Mlfsl_Finance_Hours_Relatedclient = {
  ActiveClientCount: Scalars['Int']['output'];
  ClientCount: Scalars['Int']['output'];
  InactiveClientCount: Scalars['Int']['output'];
  MatterCount: Scalars['Int']['output'];
  RelatedClientNumber: Scalars['String']['output'];
  TimeKeeperCount: Scalars['Int']['output'];
  /** An object relationship */
  mlfsl_relatedclient?: Maybe<Mlfsl_Related_Client>;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_RelatedClient". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Relatedclient_Bool_Exp = {
  ActiveClientCount?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ClientCount?: InputMaybe<Int_Mssql_Comparison_Exp>;
  InactiveClientCount?: InputMaybe<Int_Mssql_Comparison_Exp>;
  MatterCount?: InputMaybe<Int_Mssql_Comparison_Exp>;
  RelatedClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  TimeKeeperCount?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclient_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Finance_Hours_Relatedclient_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclient_Bool_Exp>>;
  mlfsl_relatedclient?: InputMaybe<Mlfsl_Related_Client_Bool_Exp>;
};

/** Ordering options when selecting data from "MNET.Finance_Hours_RelatedClient". */
export type Mlfsl_Finance_Hours_Relatedclient_Order_By = {
  ActiveClientCount?: InputMaybe<Order_By>;
  ClientCount?: InputMaybe<Order_By>;
  InactiveClientCount?: InputMaybe<Order_By>;
  MatterCount?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  TimeKeeperCount?: InputMaybe<Order_By>;
  mlfsl_relatedclient?: InputMaybe<Mlfsl_Related_Client_Order_By>;
};

/** columns and relationships of "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe = {
  ClientBillableHours: Scalars['Float']['output'];
  HistoricalTKOfficeforCount: Scalars['String']['output'];
  /** An object relationship */
  RelatedClient?: Maybe<Mlfsl_Related_Client>;
  RelatedClientNumber: Scalars['String']['output'];
  Timeframe: Scalars['String']['output'];
  historical_tk_mnet_office_detail?: Maybe<Mnet_Office_Detail>;
};

/** order by aggregate values of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Variance_Order_By>;
};

/** order by avg() on columns of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Avg_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_RelatedClientOfficeTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Bool_Exp = {
  ClientBillableHours?: InputMaybe<Float_Mssql_Comparison_Exp>;
  HistoricalTKOfficeforCount?: InputMaybe<String_Mssql_Comparison_Exp>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Bool_Exp>;
  RelatedClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  Timeframe?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Bool_Exp>>;
};

/** order by max() on columns of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Max_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  HistoricalTKOfficeforCount?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Min_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  HistoricalTKOfficeforCount?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "MNET.Finance_Hours_RelatedClientOfficeTimeframe". */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  HistoricalTKOfficeforCount?: InputMaybe<Order_By>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Stddev_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Stddev_Pop_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Stddev_Samp_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Sum_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Var_Pop_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Var_Samp_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Variance_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** columns and relationships of "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe = {
  ClientBillableHours: Scalars['Float']['output'];
  HistoricalTKPGforCount: Scalars['String']['output'];
  PracticeGroupName: Scalars['String']['output'];
  /** An object relationship */
  RelatedClient?: Maybe<Mlfsl_Related_Client>;
  RelatedClientNumber: Scalars['String']['output'];
  Timeframe: Scalars['String']['output'];
  historical_tk_mnet_practice_group_detail?: Maybe<Mnet_Practice_Group_Detail>;
};

/** order by aggregate values of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Variance_Order_By>;
};

/** order by avg() on columns of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Avg_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_RelatedClientPGTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Bool_Exp = {
  ClientBillableHours?: InputMaybe<Float_Mssql_Comparison_Exp>;
  HistoricalTKPGforCount?: InputMaybe<String_Mssql_Comparison_Exp>;
  PracticeGroupName?: InputMaybe<String_Mssql_Comparison_Exp>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Bool_Exp>;
  RelatedClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  Timeframe?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Bool_Exp>>;
};

/** order by max() on columns of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Max_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  HistoricalTKPGforCount?: InputMaybe<Order_By>;
  PracticeGroupName?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Min_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  HistoricalTKPGforCount?: InputMaybe<Order_By>;
  PracticeGroupName?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "MNET.Finance_Hours_RelatedClientPGTimeframe". */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  HistoricalTKPGforCount?: InputMaybe<Order_By>;
  PracticeGroupName?: InputMaybe<Order_By>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Stddev_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Stddev_Pop_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Stddev_Samp_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Sum_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Var_Pop_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Var_Samp_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "MNET.Finance_Hours_RelatedClientPGTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Variance_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
};

/** columns and relationships of "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe = {
  BilledAmount: Scalars['Float']['output'];
  ClientBillableHours: Scalars['Float']['output'];
  OfficesServingRelatedClient?: Maybe<Scalars['Int']['output']>;
  PartnersServingRelatedClient?: Maybe<Scalars['Int']['output']>;
  RelatedClientNumber: Scalars['String']['output'];
  TimeChargesBooked: Scalars['Float']['output'];
  Timeframe: Scalars['String']['output'];
};

/** aggregated selection of "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Aggregate = {
  aggregate?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Aggregate_Fields>;
  nodes: Array<Mlfsl_Finance_Hours_Relatedclienttimeframe>;
};

/** aggregate fields of "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Max_Fields>;
  min?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Min_Fields>;
  stddev?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Variance_Fields>;
};

/** aggregate fields of "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Avg_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  OfficesServingRelatedClient?: Maybe<Scalars['Float']['output']>;
  PartnersServingRelatedClient?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Avg_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  OfficesServingRelatedClient?: InputMaybe<Order_By>;
  PartnersServingRelatedClient?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_RelatedClientTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Bool_Exp = {
  BilledAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ClientBillableHours?: InputMaybe<Float_Mssql_Comparison_Exp>;
  OfficesServingRelatedClient?: InputMaybe<Int_Mssql_Comparison_Exp>;
  PartnersServingRelatedClient?: InputMaybe<Int_Mssql_Comparison_Exp>;
  RelatedClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  TimeChargesBooked?: InputMaybe<Float_Mssql_Comparison_Exp>;
  Timeframe?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclienttimeframe_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclienttimeframe_Bool_Exp>>;
};

/** aggregate max on columns */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Max_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  OfficesServingRelatedClient?: Maybe<Scalars['Int']['output']>;
  PartnersServingRelatedClient?: Maybe<Scalars['Int']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
  Timeframe?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Max_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  OfficesServingRelatedClient?: InputMaybe<Order_By>;
  PartnersServingRelatedClient?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Min_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  OfficesServingRelatedClient?: Maybe<Scalars['Int']['output']>;
  PartnersServingRelatedClient?: Maybe<Scalars['Int']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
  Timeframe?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Min_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  OfficesServingRelatedClient?: InputMaybe<Order_By>;
  PartnersServingRelatedClient?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "MNET.Finance_Hours_RelatedClientTimeframe". */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  OfficesServingRelatedClient?: InputMaybe<Order_By>;
  PartnersServingRelatedClient?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
};

/** select columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export enum Mlfsl_Finance_Hours_Relatedclienttimeframe_Select_Column {
  /** column name */
  BilledAmount = 'BilledAmount',
  /** column name */
  ClientBillableHours = 'ClientBillableHours',
  /** column name */
  OfficesServingRelatedClient = 'OfficesServingRelatedClient',
  /** column name */
  PartnersServingRelatedClient = 'PartnersServingRelatedClient',
  /** column name */
  RelatedClientNumber = 'RelatedClientNumber',
  /** column name */
  TimeChargesBooked = 'TimeChargesBooked',
  /** column name */
  Timeframe = 'Timeframe',
}

/** aggregate stddev on columns */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Stddev_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  OfficesServingRelatedClient?: Maybe<Scalars['Float']['output']>;
  PartnersServingRelatedClient?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Stddev_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  OfficesServingRelatedClient?: InputMaybe<Order_By>;
  PartnersServingRelatedClient?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Stddev_Pop_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  OfficesServingRelatedClient?: Maybe<Scalars['Float']['output']>;
  PartnersServingRelatedClient?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Stddev_Pop_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  OfficesServingRelatedClient?: InputMaybe<Order_By>;
  PartnersServingRelatedClient?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Stddev_Samp_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  OfficesServingRelatedClient?: Maybe<Scalars['Float']['output']>;
  PartnersServingRelatedClient?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Stddev_Samp_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  OfficesServingRelatedClient?: InputMaybe<Order_By>;
  PartnersServingRelatedClient?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Sum_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  OfficesServingRelatedClient?: Maybe<Scalars['Int']['output']>;
  PartnersServingRelatedClient?: Maybe<Scalars['Int']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Sum_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  OfficesServingRelatedClient?: InputMaybe<Order_By>;
  PartnersServingRelatedClient?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Var_Pop_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  OfficesServingRelatedClient?: Maybe<Scalars['Float']['output']>;
  PartnersServingRelatedClient?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Var_Pop_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  OfficesServingRelatedClient?: InputMaybe<Order_By>;
  PartnersServingRelatedClient?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Var_Samp_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  OfficesServingRelatedClient?: Maybe<Scalars['Float']['output']>;
  PartnersServingRelatedClient?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Var_Samp_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  OfficesServingRelatedClient?: InputMaybe<Order_By>;
  PartnersServingRelatedClient?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Variance_Fields = {
  BilledAmount?: Maybe<Scalars['Float']['output']>;
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  OfficesServingRelatedClient?: Maybe<Scalars['Float']['output']>;
  PartnersServingRelatedClient?: Maybe<Scalars['Float']['output']>;
  TimeChargesBooked?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "MNET.Finance_Hours_RelatedClientTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimeframe_Variance_Order_By = {
  BilledAmount?: InputMaybe<Order_By>;
  ClientBillableHours?: InputMaybe<Order_By>;
  OfficesServingRelatedClient?: InputMaybe<Order_By>;
  PartnersServingRelatedClient?: InputMaybe<Order_By>;
  TimeChargesBooked?: InputMaybe<Order_By>;
};

/** columns and relationships of "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe = {
  ClientBillableHours: Scalars['Float']['output'];
  /** An object relationship */
  RelatedClient?: Maybe<Mlfsl_Related_Client>;
  RelatedClientBillableHoursPercent: Scalars['Float']['output'];
  RelatedClientNumber: Scalars['String']['output'];
  Timeframe: Scalars['String']['output'];
  /** An object relationship */
  Timekeeper?: Maybe<Mlfsl_Personnel>;
  TkprNumber: Scalars['String']['output'];
  Tkpr_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  Tkpr_OfficeEliteLocationCode?: Maybe<Scalars['String']['output']>;
  Tkpr_OfficeNameDisplay?: Maybe<Scalars['String']['output']>;
  Tkpr_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  Tkpr_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  Tkpr_Role?: Maybe<Scalars['String']['output']>;
  Tkpr_RoleSort?: Maybe<Scalars['String']['output']>;
  Tkpr_SecondaryPracticeGroupCode?: Maybe<Scalars['String']['output']>;
  Tkpr_SecondaryPracticeGroupName?: Maybe<Scalars['String']['output']>;
  Tkpr_Secondary_mnet_practice_group_detail?: Maybe<Mnet_Practice_Group_Detail>;
  Tkpr_TitleDisplay?: Maybe<Scalars['String']['output']>;
  Tkpr_mnet_office_detail?: Maybe<Mnet_Office_Detail>;
  Tkpr_mnet_practice_group_detail?: Maybe<Mnet_Practice_Group_Detail>;
};

/** aggregated selection of "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Aggregate = {
  aggregate?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Aggregate_Fields>;
  nodes: Array<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe>;
};

/** aggregate fields of "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Max_Fields>;
  min?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Min_Fields>;
  stddev?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Variance_Fields>;
};

/** aggregate fields of "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Avg_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Avg_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe". All fields are combined with a logical 'AND'. */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Bool_Exp = {
  ClientBillableHours?: InputMaybe<Float_Mssql_Comparison_Exp>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Bool_Exp>;
  RelatedClientBillableHoursPercent?: InputMaybe<Float_Mssql_Comparison_Exp>;
  RelatedClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  Timeframe?: InputMaybe<String_Mssql_Comparison_Exp>;
  Timekeeper?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
  TkprNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_NamePreferredDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_OfficeEliteLocationCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_OfficeNameDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_PracticeGroupCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_PracticeGroupName?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_Role?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_RoleSort?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_SecondaryPracticeGroupCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_SecondaryPracticeGroupName?: InputMaybe<String_Mssql_Comparison_Exp>;
  Tkpr_TitleDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Bool_Exp>>;
};

/** aggregate max on columns */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Max_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  Timeframe?: Maybe<Scalars['String']['output']>;
  TkprNumber?: Maybe<Scalars['String']['output']>;
  Tkpr_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  Tkpr_OfficeEliteLocationCode?: Maybe<Scalars['String']['output']>;
  Tkpr_OfficeNameDisplay?: Maybe<Scalars['String']['output']>;
  Tkpr_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  Tkpr_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  Tkpr_Role?: Maybe<Scalars['String']['output']>;
  Tkpr_RoleSort?: Maybe<Scalars['String']['output']>;
  Tkpr_SecondaryPracticeGroupCode?: Maybe<Scalars['String']['output']>;
  Tkpr_SecondaryPracticeGroupName?: Maybe<Scalars['String']['output']>;
  Tkpr_TitleDisplay?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Max_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
  TkprNumber?: InputMaybe<Order_By>;
  Tkpr_NamePreferredDisplay?: InputMaybe<Order_By>;
  Tkpr_OfficeEliteLocationCode?: InputMaybe<Order_By>;
  Tkpr_OfficeNameDisplay?: InputMaybe<Order_By>;
  Tkpr_PracticeGroupCode?: InputMaybe<Order_By>;
  Tkpr_PracticeGroupName?: InputMaybe<Order_By>;
  Tkpr_Role?: InputMaybe<Order_By>;
  Tkpr_RoleSort?: InputMaybe<Order_By>;
  Tkpr_SecondaryPracticeGroupCode?: InputMaybe<Order_By>;
  Tkpr_SecondaryPracticeGroupName?: InputMaybe<Order_By>;
  Tkpr_TitleDisplay?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Min_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  Timeframe?: Maybe<Scalars['String']['output']>;
  TkprNumber?: Maybe<Scalars['String']['output']>;
  Tkpr_NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  Tkpr_OfficeEliteLocationCode?: Maybe<Scalars['String']['output']>;
  Tkpr_OfficeNameDisplay?: Maybe<Scalars['String']['output']>;
  Tkpr_PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  Tkpr_PracticeGroupName?: Maybe<Scalars['String']['output']>;
  Tkpr_Role?: Maybe<Scalars['String']['output']>;
  Tkpr_RoleSort?: Maybe<Scalars['String']['output']>;
  Tkpr_SecondaryPracticeGroupCode?: Maybe<Scalars['String']['output']>;
  Tkpr_SecondaryPracticeGroupName?: Maybe<Scalars['String']['output']>;
  Tkpr_TitleDisplay?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Min_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
  TkprNumber?: InputMaybe<Order_By>;
  Tkpr_NamePreferredDisplay?: InputMaybe<Order_By>;
  Tkpr_OfficeEliteLocationCode?: InputMaybe<Order_By>;
  Tkpr_OfficeNameDisplay?: InputMaybe<Order_By>;
  Tkpr_PracticeGroupCode?: InputMaybe<Order_By>;
  Tkpr_PracticeGroupName?: InputMaybe<Order_By>;
  Tkpr_Role?: InputMaybe<Order_By>;
  Tkpr_RoleSort?: InputMaybe<Order_By>;
  Tkpr_SecondaryPracticeGroupCode?: InputMaybe<Order_By>;
  Tkpr_SecondaryPracticeGroupName?: InputMaybe<Order_By>;
  Tkpr_TitleDisplay?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe". */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
  Timekeeper?: InputMaybe<Mlfsl_Personnel_Order_By>;
  TkprNumber?: InputMaybe<Order_By>;
  Tkpr_NamePreferredDisplay?: InputMaybe<Order_By>;
  Tkpr_OfficeEliteLocationCode?: InputMaybe<Order_By>;
  Tkpr_OfficeNameDisplay?: InputMaybe<Order_By>;
  Tkpr_PracticeGroupCode?: InputMaybe<Order_By>;
  Tkpr_PracticeGroupName?: InputMaybe<Order_By>;
  Tkpr_Role?: InputMaybe<Order_By>;
  Tkpr_RoleSort?: InputMaybe<Order_By>;
  Tkpr_SecondaryPracticeGroupCode?: InputMaybe<Order_By>;
  Tkpr_SecondaryPracticeGroupName?: InputMaybe<Order_By>;
  Tkpr_TitleDisplay?: InputMaybe<Order_By>;
};

/** select columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export enum Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Select_Column {
  /** column name */
  ClientBillableHours = 'ClientBillableHours',
  /** column name */
  RelatedClientBillableHoursPercent = 'RelatedClientBillableHoursPercent',
  /** column name */
  RelatedClientNumber = 'RelatedClientNumber',
  /** column name */
  Timeframe = 'Timeframe',
  /** column name */
  TkprNumber = 'TkprNumber',
  /** column name */
  Tkpr_NamePreferredDisplay = 'Tkpr_NamePreferredDisplay',
  /** column name */
  Tkpr_OfficeEliteLocationCode = 'Tkpr_OfficeEliteLocationCode',
  /** column name */
  Tkpr_OfficeNameDisplay = 'Tkpr_OfficeNameDisplay',
  /** column name */
  Tkpr_PracticeGroupCode = 'Tkpr_PracticeGroupCode',
  /** column name */
  Tkpr_PracticeGroupName = 'Tkpr_PracticeGroupName',
  /** column name */
  Tkpr_Role = 'Tkpr_Role',
  /** column name */
  Tkpr_RoleSort = 'Tkpr_RoleSort',
  /** column name */
  Tkpr_SecondaryPracticeGroupCode = 'Tkpr_SecondaryPracticeGroupCode',
  /** column name */
  Tkpr_SecondaryPracticeGroupName = 'Tkpr_SecondaryPracticeGroupName',
  /** column name */
  Tkpr_TitleDisplay = 'Tkpr_TitleDisplay',
}

/** aggregate stddev on columns */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Stddev_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Stddev_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Stddev_Pop_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Stddev_Pop_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Stddev_Samp_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Stddev_Samp_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Sum_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Sum_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Var_Pop_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Var_Pop_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Var_Samp_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Var_Samp_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Variance_Fields = {
  ClientBillableHours?: Maybe<Scalars['Float']['output']>;
  RelatedClientBillableHoursPercent?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
export type Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Variance_Order_By = {
  ClientBillableHours?: InputMaybe<Order_By>;
  RelatedClientBillableHoursPercent?: InputMaybe<Order_By>;
};

/** columns and relationships of "repl.DimMatterNow" */
export type Mlfsl_Matter = {
  ABACode?: Maybe<Scalars['String']['output']>;
  ABADescription?: Maybe<Scalars['String']['output']>;
  AMLID?: Maybe<Scalars['Int']['output']>;
  AdministrativeFlag?: Maybe<Scalars['String']['output']>;
  AmlClearanceDate?: Maybe<Scalars['datetime']['output']>;
  /** An object relationship */
  AttorneyInCharge?: Maybe<Mlfsl_Personnel>;
  AttorneyInChargeOriginalPracticeGroup?: Maybe<Scalars['String']['output']>;
  AttorneyInChargeTkId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  BillingAttorney?: Maybe<Mlfsl_Personnel>;
  BillingAttorneyTkId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  BillingCoordinator?: Maybe<Mlfsl_Personnel>;
  BillingCoordinatorSource?: Maybe<Scalars['String']['output']>;
  BillingCoordinatorTkID?: Maybe<Scalars['String']['output']>;
  BillingInstructions?: Maybe<Scalars['String']['output']>;
  ClassActionIndicator?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  Client?: Maybe<Mlfsl_Client>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  ClientReferenceNumber?: Maybe<Scalars['String']['output']>;
  DAC6ComplianceIndicator?: Maybe<Scalars['String']['output']>;
  DateMatterClosed?: Maybe<Scalars['Int']['output']>;
  DateMatterOpen?: Maybe<Scalars['Int']['output']>;
  DeletedRecordIndicator: Scalars['String']['output'];
  DimMatterNowKey: Scalars['Int']['output'];
  DiscoveryStatusCode?: Maybe<Scalars['String']['output']>;
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  ETLSoftInsertIndicator?: Maybe<Scalars['String']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
  EtlCreatedDate: Scalars['datetime']['output'];
  EtlModifiedDate: Scalars['datetime']['output'];
  FoundationMatter?: Maybe<Mnet_Foundation_Matter>;
  InventoryExceptionCode?: Maybe<Scalars['String']['output']>;
  InventoryExceptionDescription?: Maybe<Scalars['String']['output']>;
  LastTimeCardDate?: Maybe<Scalars['datetime']['output']>;
  Matter: Scalars['String']['output'];
  MatterAddress1?: Maybe<Scalars['String']['output']>;
  MatterAddress2?: Maybe<Scalars['String']['output']>;
  MatterAddress3?: Maybe<Scalars['String']['output']>;
  MatterAddress4?: Maybe<Scalars['String']['output']>;
  MatterAddress5?: Maybe<Scalars['String']['output']>;
  MatterAddress6?: Maybe<Scalars['String']['output']>;
  MatterArrangementCode?: Maybe<Scalars['String']['output']>;
  MatterArrangementDescription?: Maybe<Scalars['String']['output']>;
  MatterBillableStatusCode?: Maybe<Scalars['String']['output']>;
  MatterBillableStatusDescription?: Maybe<Scalars['String']['output']>;
  MatterBillableStatusIndicator?: Maybe<Scalars['Int']['output']>;
  MatterBillableStatusType?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  MatterClosedDate?: Maybe<Mlfsl_Date>;
  MatterConfidentialIndicator?: Maybe<Scalars['String']['output']>;
  MatterContact?: Maybe<Scalars['String']['output']>;
  MatterCurrencyCode?: Maybe<Scalars['String']['output']>;
  MatterCurrencyCodeChromeRiver?: Maybe<Scalars['String']['output']>;
  MatterCurrencyDescription?: Maybe<Scalars['String']['output']>;
  MatterDescription1?: Maybe<Scalars['String']['output']>;
  MatterDescription2?: Maybe<Scalars['String']['output']>;
  MatterDescription3?: Maybe<Scalars['String']['output']>;
  MatterDescriptionFull?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  MatterDisplayDescription?: Maybe<Mlfsl_Matter_Display_Description>;
  MatterExclusionIndicator?: Maybe<Scalars['String']['output']>;
  MatterGUID?: Maybe<Scalars['uniqueidentifier']['output']>;
  MatterHoldDate?: Maybe<Scalars['datetime']['output']>;
  MatterHoldEndDate?: Maybe<Scalars['date']['output']>;
  MatterHoldStartDate?: Maybe<Scalars['date']['output']>;
  MatterIndex?: Maybe<Scalars['Int']['output']>;
  MatterIndustryCode?: Maybe<Scalars['String']['output']>;
  MatterIndustryCodeDescription?: Maybe<Scalars['String']['output']>;
  MatterLocation?: Maybe<Scalars['String']['output']>;
  MatterName?: Maybe<Scalars['String']['output']>;
  MatterNarrative?: Maybe<Scalars['String']['output']>;
  MatterNumber?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  MatterOpenDate?: Maybe<Mlfsl_Date>;
  MatterPracticeCode?: Maybe<Scalars['String']['output']>;
  MatterPracticeCodeDescription?: Maybe<Scalars['String']['output']>;
  MatterPracticeCodeZeroPadded?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  MatterPracticeGroup?: Maybe<Mlfsl_Practicegroup>;
  MatterPrivateIndicator?: Maybe<Scalars['String']['output']>;
  MatterRateCode?: Maybe<Scalars['String']['output']>;
  MatterSourceAbbreviation?: Maybe<Scalars['String']['output']>;
  MatterSourceName?: Maybe<Scalars['String']['output']>;
  MatterSourceNumber?: Maybe<Scalars['String']['output']>;
  MatterStatusCode?: Maybe<Scalars['String']['output']>;
  MatterStatusDescription?: Maybe<Scalars['String']['output']>;
  MatterStatusOpenIndicator?: Maybe<Scalars['Int']['output']>;
  ParallexID?: Maybe<Scalars['String']['output']>;
  ProBonoIndicator?: Maybe<Scalars['String']['output']>;
  TimeDistributionIndicator?: Maybe<Scalars['String']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  mlfsl_finance_hours_matterofficetimeframes: Array<Mlfsl_Finance_Hours_Matterofficetimeframe>;
  /** An array relationship */
  mlfsl_finance_hours_matterpgtimeframes: Array<Mlfsl_Finance_Hours_Matterpgtimeframe>;
  /** An array relationship */
  mlfsl_finance_hours_mattertimeframecompares: Array<Mlfsl_Finance_Hours_Mattertimeframecompare>;
  /** An array relationship */
  mlfsl_finance_hours_mattertimeframes: Array<Mlfsl_Finance_Hours_Mattertimeframe>;
  /** An aggregate relationship */
  mlfsl_finance_hours_mattertimeframes_aggregate: Mlfsl_Finance_Hours_Mattertimeframe_Aggregate;
  /** An array relationship */
  mlfsl_finance_hours_mattertimekeepertimeframe: Array<Mlfsl_Finance_Hours_Mattertimekeepertimeframe>;
  /** An aggregate relationship */
  mlfsl_finance_hours_mattertimekeepertimeframe_aggregate: Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Aggregate;
  /** An object relationship */
  mlfsl_mlv_finance_hours_matter?: Maybe<Mlfsl_Mlv_Finance_Hours_Matter>;
};

/** columns and relationships of "repl.DimMatterNow" */
export type Mlfsl_MatterMlfsl_Finance_Hours_MatterofficetimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Matterofficetimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Bool_Exp>;
};

/** columns and relationships of "repl.DimMatterNow" */
export type Mlfsl_MatterMlfsl_Finance_Hours_MatterpgtimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Matterpgtimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Bool_Exp>;
};

/** columns and relationships of "repl.DimMatterNow" */
export type Mlfsl_MatterMlfsl_Finance_Hours_MattertimeframecomparesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimeframecompare_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Bool_Exp>;
};

/** columns and relationships of "repl.DimMatterNow" */
export type Mlfsl_MatterMlfsl_Finance_Hours_MattertimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp>;
};

/** columns and relationships of "repl.DimMatterNow" */
export type Mlfsl_MatterMlfsl_Finance_Hours_Mattertimeframes_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp>;
};

/** columns and relationships of "repl.DimMatterNow" */
export type Mlfsl_MatterMlfsl_Finance_Hours_MattertimekeepertimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Bool_Exp>;
};

/** columns and relationships of "repl.DimMatterNow" */
export type Mlfsl_MatterMlfsl_Finance_Hours_Mattertimekeepertimeframe_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Bool_Exp>;
};

/** aggregated selection of "repl.DimMatterNow" */
export type Mlfsl_Matter_Aggregate = {
  aggregate?: Maybe<Mlfsl_Matter_Aggregate_Fields>;
  nodes: Array<Mlfsl_Matter>;
};

/** aggregate fields of "repl.DimMatterNow" */
export type Mlfsl_Matter_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Matter_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Matter_Max_Fields>;
  min?: Maybe<Mlfsl_Matter_Min_Fields>;
  stddev?: Maybe<Mlfsl_Matter_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Matter_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Matter_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Matter_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Matter_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Matter_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Matter_Variance_Fields>;
};

/** aggregate fields of "repl.DimMatterNow" */
export type Mlfsl_Matter_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Matter_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Matter_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Matter_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Matter_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Matter_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Matter_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Matter_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Matter_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Matter_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Matter_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Matter_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Mlfsl_Matter_Avg_Fields = {
  AMLID?: Maybe<Scalars['Float']['output']>;
  DateMatterClosed?: Maybe<Scalars['Float']['output']>;
  DateMatterOpen?: Maybe<Scalars['Float']['output']>;
  DimMatterNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  MatterBillableStatusIndicator?: Maybe<Scalars['Float']['output']>;
  MatterIndex?: Maybe<Scalars['Float']['output']>;
  MatterStatusOpenIndicator?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Avg_Order_By = {
  AMLID?: InputMaybe<Order_By>;
  DateMatterClosed?: InputMaybe<Order_By>;
  DateMatterOpen?: InputMaybe<Order_By>;
  DimMatterNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  MatterBillableStatusIndicator?: InputMaybe<Order_By>;
  MatterIndex?: InputMaybe<Order_By>;
  MatterStatusOpenIndicator?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "repl.DimMatterNow". All fields are combined with a logical 'AND'. */
export type Mlfsl_Matter_Bool_Exp = {
  ABACode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ABADescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  AMLID?: InputMaybe<Int_Mssql_Comparison_Exp>;
  AdministrativeFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  AmlClearanceDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  AttorneyInCharge?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
  AttorneyInChargeOriginalPracticeGroup?: InputMaybe<String_Mssql_Comparison_Exp>;
  AttorneyInChargeTkId?: InputMaybe<String_Mssql_Comparison_Exp>;
  BillingAttorney?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
  BillingAttorneyTkId?: InputMaybe<String_Mssql_Comparison_Exp>;
  BillingCoordinator?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
  BillingCoordinatorSource?: InputMaybe<String_Mssql_Comparison_Exp>;
  BillingCoordinatorTkID?: InputMaybe<String_Mssql_Comparison_Exp>;
  BillingInstructions?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClassActionIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  Client?: InputMaybe<Mlfsl_Client_Bool_Exp>;
  ClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientReferenceNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  DAC6ComplianceIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  DateMatterClosed?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DateMatterOpen?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DeletedRecordIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  DimMatterNowKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DiscoveryStatusCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ETLBatchKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLSoftInsertIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  EtlChecksum?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EtlCreatedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  EtlModifiedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  InventoryExceptionCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  InventoryExceptionDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  LastTimeCardDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  Matter?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterAddress1?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterAddress2?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterAddress3?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterAddress4?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterAddress5?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterAddress6?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterArrangementCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterArrangementDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterBillableStatusCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterBillableStatusDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterBillableStatusIndicator?: InputMaybe<Int_Mssql_Comparison_Exp>;
  MatterBillableStatusType?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterClosedDate?: InputMaybe<Mlfsl_Date_Bool_Exp>;
  MatterConfidentialIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterContact?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterCurrencyCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterCurrencyCodeChromeRiver?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterCurrencyDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterDescription1?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterDescription2?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterDescription3?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterDescriptionFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterDisplayDescription?: InputMaybe<Mlfsl_Matter_Display_Description_Bool_Exp>;
  MatterExclusionIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterGUID?: InputMaybe<Uniqueidentifier_Mssql_Comparison_Exp>;
  MatterHoldDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  MatterHoldEndDate?: InputMaybe<Date_Mssql_Comparison_Exp>;
  MatterHoldStartDate?: InputMaybe<Date_Mssql_Comparison_Exp>;
  MatterIndex?: InputMaybe<Int_Mssql_Comparison_Exp>;
  MatterIndustryCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterIndustryCodeDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterLocation?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterName?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterNarrative?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterOpenDate?: InputMaybe<Mlfsl_Date_Bool_Exp>;
  MatterPracticeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterPracticeCodeDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterPracticeCodeZeroPadded?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterPracticeGroup?: InputMaybe<Mlfsl_Practicegroup_Bool_Exp>;
  MatterPrivateIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterRateCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterSourceAbbreviation?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterSourceName?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterSourceNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterStatusCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterStatusDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterStatusOpenIndicator?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ParallexID?: InputMaybe<String_Mssql_Comparison_Exp>;
  ProBonoIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  TimeDistributionIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  WallBuilderEntityID?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Matter_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Matter_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Matter_Bool_Exp>>;
  mlfsl_finance_hours_matterofficetimeframes?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Bool_Exp>;
  mlfsl_finance_hours_matterpgtimeframes?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Bool_Exp>;
  mlfsl_finance_hours_mattertimeframecompares?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Bool_Exp>;
  mlfsl_finance_hours_mattertimeframes?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp>;
  mlfsl_finance_hours_mattertimekeepertimeframe?: InputMaybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Bool_Exp>;
  mlfsl_mlv_finance_hours_matter?: InputMaybe<Mlfsl_Mlv_Finance_Hours_Matter_Bool_Exp>;
};

/** columns and relationships of "MLG.Matter_DisplayDescription" */
export type Mlfsl_Matter_Display_Description = {
  ID: Scalars['String']['output'];
  /** An object relationship */
  Matter?: Maybe<Mlfsl_Matter>;
  locationforum?: Maybe<Scalars['String']['output']>;
  narrative?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "MLG.Matter_DisplayDescription". All fields are combined with a logical 'AND'. */
export type Mlfsl_Matter_Display_Description_Bool_Exp = {
  ID?: InputMaybe<String_Mssql_Comparison_Exp>;
  Matter?: InputMaybe<Mlfsl_Matter_Bool_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Matter_Display_Description_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Matter_Display_Description_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Matter_Display_Description_Bool_Exp>>;
  locationforum?: InputMaybe<String_Mssql_Comparison_Exp>;
  narrative?: InputMaybe<String_Mssql_Comparison_Exp>;
};

/** Ordering options when selecting data from "MLG.Matter_DisplayDescription". */
export type Mlfsl_Matter_Display_Description_Order_By = {
  ID?: InputMaybe<Order_By>;
  Matter?: InputMaybe<Mlfsl_Matter_Order_By>;
  locationforum?: InputMaybe<Order_By>;
  narrative?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Mlfsl_Matter_Max_Fields = {
  ABACode?: Maybe<Scalars['String']['output']>;
  ABADescription?: Maybe<Scalars['String']['output']>;
  AMLID?: Maybe<Scalars['Int']['output']>;
  AdministrativeFlag?: Maybe<Scalars['String']['output']>;
  AmlClearanceDate?: Maybe<Scalars['datetime']['output']>;
  AttorneyInChargeOriginalPracticeGroup?: Maybe<Scalars['String']['output']>;
  AttorneyInChargeTkId?: Maybe<Scalars['String']['output']>;
  BillingAttorneyTkId?: Maybe<Scalars['String']['output']>;
  BillingCoordinatorSource?: Maybe<Scalars['String']['output']>;
  BillingCoordinatorTkID?: Maybe<Scalars['String']['output']>;
  BillingInstructions?: Maybe<Scalars['String']['output']>;
  ClassActionIndicator?: Maybe<Scalars['String']['output']>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  ClientReferenceNumber?: Maybe<Scalars['String']['output']>;
  DAC6ComplianceIndicator?: Maybe<Scalars['String']['output']>;
  DateMatterClosed?: Maybe<Scalars['Int']['output']>;
  DateMatterOpen?: Maybe<Scalars['Int']['output']>;
  DeletedRecordIndicator?: Maybe<Scalars['String']['output']>;
  DimMatterNowKey?: Maybe<Scalars['Int']['output']>;
  DiscoveryStatusCode?: Maybe<Scalars['String']['output']>;
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  ETLSoftInsertIndicator?: Maybe<Scalars['String']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  InventoryExceptionCode?: Maybe<Scalars['String']['output']>;
  InventoryExceptionDescription?: Maybe<Scalars['String']['output']>;
  LastTimeCardDate?: Maybe<Scalars['datetime']['output']>;
  Matter?: Maybe<Scalars['String']['output']>;
  MatterAddress1?: Maybe<Scalars['String']['output']>;
  MatterAddress2?: Maybe<Scalars['String']['output']>;
  MatterAddress3?: Maybe<Scalars['String']['output']>;
  MatterAddress4?: Maybe<Scalars['String']['output']>;
  MatterAddress5?: Maybe<Scalars['String']['output']>;
  MatterAddress6?: Maybe<Scalars['String']['output']>;
  MatterArrangementCode?: Maybe<Scalars['String']['output']>;
  MatterArrangementDescription?: Maybe<Scalars['String']['output']>;
  MatterBillableStatusCode?: Maybe<Scalars['String']['output']>;
  MatterBillableStatusDescription?: Maybe<Scalars['String']['output']>;
  MatterBillableStatusIndicator?: Maybe<Scalars['Int']['output']>;
  MatterBillableStatusType?: Maybe<Scalars['String']['output']>;
  MatterConfidentialIndicator?: Maybe<Scalars['String']['output']>;
  MatterContact?: Maybe<Scalars['String']['output']>;
  MatterCurrencyCode?: Maybe<Scalars['String']['output']>;
  MatterCurrencyCodeChromeRiver?: Maybe<Scalars['String']['output']>;
  MatterCurrencyDescription?: Maybe<Scalars['String']['output']>;
  MatterDescription1?: Maybe<Scalars['String']['output']>;
  MatterDescription2?: Maybe<Scalars['String']['output']>;
  MatterDescription3?: Maybe<Scalars['String']['output']>;
  MatterDescriptionFull?: Maybe<Scalars['String']['output']>;
  MatterExclusionIndicator?: Maybe<Scalars['String']['output']>;
  MatterHoldDate?: Maybe<Scalars['datetime']['output']>;
  MatterHoldEndDate?: Maybe<Scalars['date']['output']>;
  MatterHoldStartDate?: Maybe<Scalars['date']['output']>;
  MatterIndex?: Maybe<Scalars['Int']['output']>;
  MatterIndustryCode?: Maybe<Scalars['String']['output']>;
  MatterIndustryCodeDescription?: Maybe<Scalars['String']['output']>;
  MatterLocation?: Maybe<Scalars['String']['output']>;
  MatterName?: Maybe<Scalars['String']['output']>;
  MatterNarrative?: Maybe<Scalars['String']['output']>;
  MatterNumber?: Maybe<Scalars['String']['output']>;
  MatterPracticeCode?: Maybe<Scalars['String']['output']>;
  MatterPracticeCodeDescription?: Maybe<Scalars['String']['output']>;
  MatterPracticeCodeZeroPadded?: Maybe<Scalars['String']['output']>;
  MatterPrivateIndicator?: Maybe<Scalars['String']['output']>;
  MatterRateCode?: Maybe<Scalars['String']['output']>;
  MatterSourceAbbreviation?: Maybe<Scalars['String']['output']>;
  MatterSourceName?: Maybe<Scalars['String']['output']>;
  MatterSourceNumber?: Maybe<Scalars['String']['output']>;
  MatterStatusCode?: Maybe<Scalars['String']['output']>;
  MatterStatusDescription?: Maybe<Scalars['String']['output']>;
  MatterStatusOpenIndicator?: Maybe<Scalars['Int']['output']>;
  ParallexID?: Maybe<Scalars['String']['output']>;
  ProBonoIndicator?: Maybe<Scalars['String']['output']>;
  TimeDistributionIndicator?: Maybe<Scalars['String']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Max_Order_By = {
  ABACode?: InputMaybe<Order_By>;
  ABADescription?: InputMaybe<Order_By>;
  AMLID?: InputMaybe<Order_By>;
  AdministrativeFlag?: InputMaybe<Order_By>;
  AmlClearanceDate?: InputMaybe<Order_By>;
  AttorneyInChargeOriginalPracticeGroup?: InputMaybe<Order_By>;
  AttorneyInChargeTkId?: InputMaybe<Order_By>;
  BillingAttorneyTkId?: InputMaybe<Order_By>;
  BillingCoordinatorSource?: InputMaybe<Order_By>;
  BillingCoordinatorTkID?: InputMaybe<Order_By>;
  BillingInstructions?: InputMaybe<Order_By>;
  ClassActionIndicator?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  ClientReferenceNumber?: InputMaybe<Order_By>;
  DAC6ComplianceIndicator?: InputMaybe<Order_By>;
  DateMatterClosed?: InputMaybe<Order_By>;
  DateMatterOpen?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DimMatterNowKey?: InputMaybe<Order_By>;
  DiscoveryStatusCode?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLSoftInsertIndicator?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  InventoryExceptionCode?: InputMaybe<Order_By>;
  InventoryExceptionDescription?: InputMaybe<Order_By>;
  LastTimeCardDate?: InputMaybe<Order_By>;
  Matter?: InputMaybe<Order_By>;
  MatterAddress1?: InputMaybe<Order_By>;
  MatterAddress2?: InputMaybe<Order_By>;
  MatterAddress3?: InputMaybe<Order_By>;
  MatterAddress4?: InputMaybe<Order_By>;
  MatterAddress5?: InputMaybe<Order_By>;
  MatterAddress6?: InputMaybe<Order_By>;
  MatterArrangementCode?: InputMaybe<Order_By>;
  MatterArrangementDescription?: InputMaybe<Order_By>;
  MatterBillableStatusCode?: InputMaybe<Order_By>;
  MatterBillableStatusDescription?: InputMaybe<Order_By>;
  MatterBillableStatusIndicator?: InputMaybe<Order_By>;
  MatterBillableStatusType?: InputMaybe<Order_By>;
  MatterConfidentialIndicator?: InputMaybe<Order_By>;
  MatterContact?: InputMaybe<Order_By>;
  MatterCurrencyCode?: InputMaybe<Order_By>;
  MatterCurrencyCodeChromeRiver?: InputMaybe<Order_By>;
  MatterCurrencyDescription?: InputMaybe<Order_By>;
  MatterDescription1?: InputMaybe<Order_By>;
  MatterDescription2?: InputMaybe<Order_By>;
  MatterDescription3?: InputMaybe<Order_By>;
  MatterDescriptionFull?: InputMaybe<Order_By>;
  MatterExclusionIndicator?: InputMaybe<Order_By>;
  MatterHoldDate?: InputMaybe<Order_By>;
  MatterHoldEndDate?: InputMaybe<Order_By>;
  MatterHoldStartDate?: InputMaybe<Order_By>;
  MatterIndex?: InputMaybe<Order_By>;
  MatterIndustryCode?: InputMaybe<Order_By>;
  MatterIndustryCodeDescription?: InputMaybe<Order_By>;
  MatterLocation?: InputMaybe<Order_By>;
  MatterName?: InputMaybe<Order_By>;
  MatterNarrative?: InputMaybe<Order_By>;
  MatterNumber?: InputMaybe<Order_By>;
  MatterPracticeCode?: InputMaybe<Order_By>;
  MatterPracticeCodeDescription?: InputMaybe<Order_By>;
  MatterPracticeCodeZeroPadded?: InputMaybe<Order_By>;
  MatterPrivateIndicator?: InputMaybe<Order_By>;
  MatterRateCode?: InputMaybe<Order_By>;
  MatterSourceAbbreviation?: InputMaybe<Order_By>;
  MatterSourceName?: InputMaybe<Order_By>;
  MatterSourceNumber?: InputMaybe<Order_By>;
  MatterStatusCode?: InputMaybe<Order_By>;
  MatterStatusDescription?: InputMaybe<Order_By>;
  MatterStatusOpenIndicator?: InputMaybe<Order_By>;
  ParallexID?: InputMaybe<Order_By>;
  ProBonoIndicator?: InputMaybe<Order_By>;
  TimeDistributionIndicator?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mlfsl_Matter_Min_Fields = {
  ABACode?: Maybe<Scalars['String']['output']>;
  ABADescription?: Maybe<Scalars['String']['output']>;
  AMLID?: Maybe<Scalars['Int']['output']>;
  AdministrativeFlag?: Maybe<Scalars['String']['output']>;
  AmlClearanceDate?: Maybe<Scalars['datetime']['output']>;
  AttorneyInChargeOriginalPracticeGroup?: Maybe<Scalars['String']['output']>;
  AttorneyInChargeTkId?: Maybe<Scalars['String']['output']>;
  BillingAttorneyTkId?: Maybe<Scalars['String']['output']>;
  BillingCoordinatorSource?: Maybe<Scalars['String']['output']>;
  BillingCoordinatorTkID?: Maybe<Scalars['String']['output']>;
  BillingInstructions?: Maybe<Scalars['String']['output']>;
  ClassActionIndicator?: Maybe<Scalars['String']['output']>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  ClientReferenceNumber?: Maybe<Scalars['String']['output']>;
  DAC6ComplianceIndicator?: Maybe<Scalars['String']['output']>;
  DateMatterClosed?: Maybe<Scalars['Int']['output']>;
  DateMatterOpen?: Maybe<Scalars['Int']['output']>;
  DeletedRecordIndicator?: Maybe<Scalars['String']['output']>;
  DimMatterNowKey?: Maybe<Scalars['Int']['output']>;
  DiscoveryStatusCode?: Maybe<Scalars['String']['output']>;
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  ETLSoftInsertIndicator?: Maybe<Scalars['String']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  InventoryExceptionCode?: Maybe<Scalars['String']['output']>;
  InventoryExceptionDescription?: Maybe<Scalars['String']['output']>;
  LastTimeCardDate?: Maybe<Scalars['datetime']['output']>;
  Matter?: Maybe<Scalars['String']['output']>;
  MatterAddress1?: Maybe<Scalars['String']['output']>;
  MatterAddress2?: Maybe<Scalars['String']['output']>;
  MatterAddress3?: Maybe<Scalars['String']['output']>;
  MatterAddress4?: Maybe<Scalars['String']['output']>;
  MatterAddress5?: Maybe<Scalars['String']['output']>;
  MatterAddress6?: Maybe<Scalars['String']['output']>;
  MatterArrangementCode?: Maybe<Scalars['String']['output']>;
  MatterArrangementDescription?: Maybe<Scalars['String']['output']>;
  MatterBillableStatusCode?: Maybe<Scalars['String']['output']>;
  MatterBillableStatusDescription?: Maybe<Scalars['String']['output']>;
  MatterBillableStatusIndicator?: Maybe<Scalars['Int']['output']>;
  MatterBillableStatusType?: Maybe<Scalars['String']['output']>;
  MatterConfidentialIndicator?: Maybe<Scalars['String']['output']>;
  MatterContact?: Maybe<Scalars['String']['output']>;
  MatterCurrencyCode?: Maybe<Scalars['String']['output']>;
  MatterCurrencyCodeChromeRiver?: Maybe<Scalars['String']['output']>;
  MatterCurrencyDescription?: Maybe<Scalars['String']['output']>;
  MatterDescription1?: Maybe<Scalars['String']['output']>;
  MatterDescription2?: Maybe<Scalars['String']['output']>;
  MatterDescription3?: Maybe<Scalars['String']['output']>;
  MatterDescriptionFull?: Maybe<Scalars['String']['output']>;
  MatterExclusionIndicator?: Maybe<Scalars['String']['output']>;
  MatterHoldDate?: Maybe<Scalars['datetime']['output']>;
  MatterHoldEndDate?: Maybe<Scalars['date']['output']>;
  MatterHoldStartDate?: Maybe<Scalars['date']['output']>;
  MatterIndex?: Maybe<Scalars['Int']['output']>;
  MatterIndustryCode?: Maybe<Scalars['String']['output']>;
  MatterIndustryCodeDescription?: Maybe<Scalars['String']['output']>;
  MatterLocation?: Maybe<Scalars['String']['output']>;
  MatterName?: Maybe<Scalars['String']['output']>;
  MatterNarrative?: Maybe<Scalars['String']['output']>;
  MatterNumber?: Maybe<Scalars['String']['output']>;
  MatterPracticeCode?: Maybe<Scalars['String']['output']>;
  MatterPracticeCodeDescription?: Maybe<Scalars['String']['output']>;
  MatterPracticeCodeZeroPadded?: Maybe<Scalars['String']['output']>;
  MatterPrivateIndicator?: Maybe<Scalars['String']['output']>;
  MatterRateCode?: Maybe<Scalars['String']['output']>;
  MatterSourceAbbreviation?: Maybe<Scalars['String']['output']>;
  MatterSourceName?: Maybe<Scalars['String']['output']>;
  MatterSourceNumber?: Maybe<Scalars['String']['output']>;
  MatterStatusCode?: Maybe<Scalars['String']['output']>;
  MatterStatusDescription?: Maybe<Scalars['String']['output']>;
  MatterStatusOpenIndicator?: Maybe<Scalars['Int']['output']>;
  ParallexID?: Maybe<Scalars['String']['output']>;
  ProBonoIndicator?: Maybe<Scalars['String']['output']>;
  TimeDistributionIndicator?: Maybe<Scalars['String']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Min_Order_By = {
  ABACode?: InputMaybe<Order_By>;
  ABADescription?: InputMaybe<Order_By>;
  AMLID?: InputMaybe<Order_By>;
  AdministrativeFlag?: InputMaybe<Order_By>;
  AmlClearanceDate?: InputMaybe<Order_By>;
  AttorneyInChargeOriginalPracticeGroup?: InputMaybe<Order_By>;
  AttorneyInChargeTkId?: InputMaybe<Order_By>;
  BillingAttorneyTkId?: InputMaybe<Order_By>;
  BillingCoordinatorSource?: InputMaybe<Order_By>;
  BillingCoordinatorTkID?: InputMaybe<Order_By>;
  BillingInstructions?: InputMaybe<Order_By>;
  ClassActionIndicator?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  ClientReferenceNumber?: InputMaybe<Order_By>;
  DAC6ComplianceIndicator?: InputMaybe<Order_By>;
  DateMatterClosed?: InputMaybe<Order_By>;
  DateMatterOpen?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DimMatterNowKey?: InputMaybe<Order_By>;
  DiscoveryStatusCode?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLSoftInsertIndicator?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  InventoryExceptionCode?: InputMaybe<Order_By>;
  InventoryExceptionDescription?: InputMaybe<Order_By>;
  LastTimeCardDate?: InputMaybe<Order_By>;
  Matter?: InputMaybe<Order_By>;
  MatterAddress1?: InputMaybe<Order_By>;
  MatterAddress2?: InputMaybe<Order_By>;
  MatterAddress3?: InputMaybe<Order_By>;
  MatterAddress4?: InputMaybe<Order_By>;
  MatterAddress5?: InputMaybe<Order_By>;
  MatterAddress6?: InputMaybe<Order_By>;
  MatterArrangementCode?: InputMaybe<Order_By>;
  MatterArrangementDescription?: InputMaybe<Order_By>;
  MatterBillableStatusCode?: InputMaybe<Order_By>;
  MatterBillableStatusDescription?: InputMaybe<Order_By>;
  MatterBillableStatusIndicator?: InputMaybe<Order_By>;
  MatterBillableStatusType?: InputMaybe<Order_By>;
  MatterConfidentialIndicator?: InputMaybe<Order_By>;
  MatterContact?: InputMaybe<Order_By>;
  MatterCurrencyCode?: InputMaybe<Order_By>;
  MatterCurrencyCodeChromeRiver?: InputMaybe<Order_By>;
  MatterCurrencyDescription?: InputMaybe<Order_By>;
  MatterDescription1?: InputMaybe<Order_By>;
  MatterDescription2?: InputMaybe<Order_By>;
  MatterDescription3?: InputMaybe<Order_By>;
  MatterDescriptionFull?: InputMaybe<Order_By>;
  MatterExclusionIndicator?: InputMaybe<Order_By>;
  MatterHoldDate?: InputMaybe<Order_By>;
  MatterHoldEndDate?: InputMaybe<Order_By>;
  MatterHoldStartDate?: InputMaybe<Order_By>;
  MatterIndex?: InputMaybe<Order_By>;
  MatterIndustryCode?: InputMaybe<Order_By>;
  MatterIndustryCodeDescription?: InputMaybe<Order_By>;
  MatterLocation?: InputMaybe<Order_By>;
  MatterName?: InputMaybe<Order_By>;
  MatterNarrative?: InputMaybe<Order_By>;
  MatterNumber?: InputMaybe<Order_By>;
  MatterPracticeCode?: InputMaybe<Order_By>;
  MatterPracticeCodeDescription?: InputMaybe<Order_By>;
  MatterPracticeCodeZeroPadded?: InputMaybe<Order_By>;
  MatterPrivateIndicator?: InputMaybe<Order_By>;
  MatterRateCode?: InputMaybe<Order_By>;
  MatterSourceAbbreviation?: InputMaybe<Order_By>;
  MatterSourceName?: InputMaybe<Order_By>;
  MatterSourceNumber?: InputMaybe<Order_By>;
  MatterStatusCode?: InputMaybe<Order_By>;
  MatterStatusDescription?: InputMaybe<Order_By>;
  MatterStatusOpenIndicator?: InputMaybe<Order_By>;
  ParallexID?: InputMaybe<Order_By>;
  ProBonoIndicator?: InputMaybe<Order_By>;
  TimeDistributionIndicator?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "repl.DimMatterNow". */
export type Mlfsl_Matter_Order_By = {
  ABACode?: InputMaybe<Order_By>;
  ABADescription?: InputMaybe<Order_By>;
  AMLID?: InputMaybe<Order_By>;
  AdministrativeFlag?: InputMaybe<Order_By>;
  AmlClearanceDate?: InputMaybe<Order_By>;
  AttorneyInCharge?: InputMaybe<Mlfsl_Personnel_Order_By>;
  AttorneyInChargeOriginalPracticeGroup?: InputMaybe<Order_By>;
  AttorneyInChargeTkId?: InputMaybe<Order_By>;
  BillingAttorney?: InputMaybe<Mlfsl_Personnel_Order_By>;
  BillingAttorneyTkId?: InputMaybe<Order_By>;
  BillingCoordinator?: InputMaybe<Mlfsl_Personnel_Order_By>;
  BillingCoordinatorSource?: InputMaybe<Order_By>;
  BillingCoordinatorTkID?: InputMaybe<Order_By>;
  BillingInstructions?: InputMaybe<Order_By>;
  ClassActionIndicator?: InputMaybe<Order_By>;
  Client?: InputMaybe<Mlfsl_Client_Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  ClientReferenceNumber?: InputMaybe<Order_By>;
  DAC6ComplianceIndicator?: InputMaybe<Order_By>;
  DateMatterClosed?: InputMaybe<Order_By>;
  DateMatterOpen?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DimMatterNowKey?: InputMaybe<Order_By>;
  DiscoveryStatusCode?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLSoftInsertIndicator?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  InventoryExceptionCode?: InputMaybe<Order_By>;
  InventoryExceptionDescription?: InputMaybe<Order_By>;
  LastTimeCardDate?: InputMaybe<Order_By>;
  Matter?: InputMaybe<Order_By>;
  MatterAddress1?: InputMaybe<Order_By>;
  MatterAddress2?: InputMaybe<Order_By>;
  MatterAddress3?: InputMaybe<Order_By>;
  MatterAddress4?: InputMaybe<Order_By>;
  MatterAddress5?: InputMaybe<Order_By>;
  MatterAddress6?: InputMaybe<Order_By>;
  MatterArrangementCode?: InputMaybe<Order_By>;
  MatterArrangementDescription?: InputMaybe<Order_By>;
  MatterBillableStatusCode?: InputMaybe<Order_By>;
  MatterBillableStatusDescription?: InputMaybe<Order_By>;
  MatterBillableStatusIndicator?: InputMaybe<Order_By>;
  MatterBillableStatusType?: InputMaybe<Order_By>;
  MatterClosedDate?: InputMaybe<Mlfsl_Date_Order_By>;
  MatterConfidentialIndicator?: InputMaybe<Order_By>;
  MatterContact?: InputMaybe<Order_By>;
  MatterCurrencyCode?: InputMaybe<Order_By>;
  MatterCurrencyCodeChromeRiver?: InputMaybe<Order_By>;
  MatterCurrencyDescription?: InputMaybe<Order_By>;
  MatterDescription1?: InputMaybe<Order_By>;
  MatterDescription2?: InputMaybe<Order_By>;
  MatterDescription3?: InputMaybe<Order_By>;
  MatterDescriptionFull?: InputMaybe<Order_By>;
  MatterDisplayDescription?: InputMaybe<Mlfsl_Matter_Display_Description_Order_By>;
  MatterExclusionIndicator?: InputMaybe<Order_By>;
  MatterGUID?: InputMaybe<Order_By>;
  MatterHoldDate?: InputMaybe<Order_By>;
  MatterHoldEndDate?: InputMaybe<Order_By>;
  MatterHoldStartDate?: InputMaybe<Order_By>;
  MatterIndex?: InputMaybe<Order_By>;
  MatterIndustryCode?: InputMaybe<Order_By>;
  MatterIndustryCodeDescription?: InputMaybe<Order_By>;
  MatterLocation?: InputMaybe<Order_By>;
  MatterName?: InputMaybe<Order_By>;
  MatterNarrative?: InputMaybe<Order_By>;
  MatterNumber?: InputMaybe<Order_By>;
  MatterOpenDate?: InputMaybe<Mlfsl_Date_Order_By>;
  MatterPracticeCode?: InputMaybe<Order_By>;
  MatterPracticeCodeDescription?: InputMaybe<Order_By>;
  MatterPracticeCodeZeroPadded?: InputMaybe<Order_By>;
  MatterPracticeGroup?: InputMaybe<Mlfsl_Practicegroup_Order_By>;
  MatterPrivateIndicator?: InputMaybe<Order_By>;
  MatterRateCode?: InputMaybe<Order_By>;
  MatterSourceAbbreviation?: InputMaybe<Order_By>;
  MatterSourceName?: InputMaybe<Order_By>;
  MatterSourceNumber?: InputMaybe<Order_By>;
  MatterStatusCode?: InputMaybe<Order_By>;
  MatterStatusDescription?: InputMaybe<Order_By>;
  MatterStatusOpenIndicator?: InputMaybe<Order_By>;
  ParallexID?: InputMaybe<Order_By>;
  ProBonoIndicator?: InputMaybe<Order_By>;
  TimeDistributionIndicator?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
  mlfsl_finance_hours_matterofficetimeframes_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Aggregate_Order_By>;
  mlfsl_finance_hours_matterpgtimeframes_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Aggregate_Order_By>;
  mlfsl_finance_hours_mattertimeframecompares_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Aggregate_Order_By>;
  mlfsl_finance_hours_mattertimeframes_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Aggregate_Order_By>;
  mlfsl_finance_hours_mattertimekeepertimeframe_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Aggregate_Order_By>;
  mlfsl_mlv_finance_hours_matter?: InputMaybe<Mlfsl_Mlv_Finance_Hours_Matter_Order_By>;
};

/** select columns of table "repl.DimMatterNow" */
export enum Mlfsl_Matter_Select_Column {
  /** column name */
  ABACode = 'ABACode',
  /** column name */
  ABADescription = 'ABADescription',
  /** column name */
  AMLID = 'AMLID',
  /** column name */
  AdministrativeFlag = 'AdministrativeFlag',
  /** column name */
  AmlClearanceDate = 'AmlClearanceDate',
  /** column name */
  AttorneyInChargeOriginalPracticeGroup = 'AttorneyInChargeOriginalPracticeGroup',
  /** column name */
  AttorneyInChargeTkId = 'AttorneyInChargeTkId',
  /** column name */
  BillingAttorneyTkId = 'BillingAttorneyTkId',
  /** column name */
  BillingCoordinatorSource = 'BillingCoordinatorSource',
  /** column name */
  BillingCoordinatorTkID = 'BillingCoordinatorTkID',
  /** column name */
  BillingInstructions = 'BillingInstructions',
  /** column name */
  ClassActionIndicator = 'ClassActionIndicator',
  /** column name */
  ClientNumber = 'ClientNumber',
  /** column name */
  ClientReferenceNumber = 'ClientReferenceNumber',
  /** column name */
  DAC6ComplianceIndicator = 'DAC6ComplianceIndicator',
  /** column name */
  DateMatterClosed = 'DateMatterClosed',
  /** column name */
  DateMatterOpen = 'DateMatterOpen',
  /** column name */
  DeletedRecordIndicator = 'DeletedRecordIndicator',
  /** column name */
  DimMatterNowKey = 'DimMatterNowKey',
  /** column name */
  DiscoveryStatusCode = 'DiscoveryStatusCode',
  /** column name */
  ETLBatchKey = 'ETLBatchKey',
  /** column name */
  ETLSoftInsertIndicator = 'ETLSoftInsertIndicator',
  /** column name */
  EtlChecksum = 'EtlChecksum',
  /** column name */
  EtlCreatedDate = 'EtlCreatedDate',
  /** column name */
  EtlModifiedDate = 'EtlModifiedDate',
  /** column name */
  InventoryExceptionCode = 'InventoryExceptionCode',
  /** column name */
  InventoryExceptionDescription = 'InventoryExceptionDescription',
  /** column name */
  LastTimeCardDate = 'LastTimeCardDate',
  /** column name */
  Matter = 'Matter',
  /** column name */
  MatterAddress1 = 'MatterAddress1',
  /** column name */
  MatterAddress2 = 'MatterAddress2',
  /** column name */
  MatterAddress3 = 'MatterAddress3',
  /** column name */
  MatterAddress4 = 'MatterAddress4',
  /** column name */
  MatterAddress5 = 'MatterAddress5',
  /** column name */
  MatterAddress6 = 'MatterAddress6',
  /** column name */
  MatterArrangementCode = 'MatterArrangementCode',
  /** column name */
  MatterArrangementDescription = 'MatterArrangementDescription',
  /** column name */
  MatterBillableStatusCode = 'MatterBillableStatusCode',
  /** column name */
  MatterBillableStatusDescription = 'MatterBillableStatusDescription',
  /** column name */
  MatterBillableStatusIndicator = 'MatterBillableStatusIndicator',
  /** column name */
  MatterBillableStatusType = 'MatterBillableStatusType',
  /** column name */
  MatterConfidentialIndicator = 'MatterConfidentialIndicator',
  /** column name */
  MatterContact = 'MatterContact',
  /** column name */
  MatterCurrencyCode = 'MatterCurrencyCode',
  /** column name */
  MatterCurrencyCodeChromeRiver = 'MatterCurrencyCodeChromeRiver',
  /** column name */
  MatterCurrencyDescription = 'MatterCurrencyDescription',
  /** column name */
  MatterDescription1 = 'MatterDescription1',
  /** column name */
  MatterDescription2 = 'MatterDescription2',
  /** column name */
  MatterDescription3 = 'MatterDescription3',
  /** column name */
  MatterDescriptionFull = 'MatterDescriptionFull',
  /** column name */
  MatterExclusionIndicator = 'MatterExclusionIndicator',
  /** column name */
  MatterGUID = 'MatterGUID',
  /** column name */
  MatterHoldDate = 'MatterHoldDate',
  /** column name */
  MatterHoldEndDate = 'MatterHoldEndDate',
  /** column name */
  MatterHoldStartDate = 'MatterHoldStartDate',
  /** column name */
  MatterIndex = 'MatterIndex',
  /** column name */
  MatterIndustryCode = 'MatterIndustryCode',
  /** column name */
  MatterIndustryCodeDescription = 'MatterIndustryCodeDescription',
  /** column name */
  MatterLocation = 'MatterLocation',
  /** column name */
  MatterName = 'MatterName',
  /** column name */
  MatterNarrative = 'MatterNarrative',
  /** column name */
  MatterNumber = 'MatterNumber',
  /** column name */
  MatterPracticeCode = 'MatterPracticeCode',
  /** column name */
  MatterPracticeCodeDescription = 'MatterPracticeCodeDescription',
  /** column name */
  MatterPracticeCodeZeroPadded = 'MatterPracticeCodeZeroPadded',
  /** column name */
  MatterPrivateIndicator = 'MatterPrivateIndicator',
  /** column name */
  MatterRateCode = 'MatterRateCode',
  /** column name */
  MatterSourceAbbreviation = 'MatterSourceAbbreviation',
  /** column name */
  MatterSourceName = 'MatterSourceName',
  /** column name */
  MatterSourceNumber = 'MatterSourceNumber',
  /** column name */
  MatterStatusCode = 'MatterStatusCode',
  /** column name */
  MatterStatusDescription = 'MatterStatusDescription',
  /** column name */
  MatterStatusOpenIndicator = 'MatterStatusOpenIndicator',
  /** column name */
  ParallexID = 'ParallexID',
  /** column name */
  ProBonoIndicator = 'ProBonoIndicator',
  /** column name */
  TimeDistributionIndicator = 'TimeDistributionIndicator',
  /** column name */
  WallBuilderEntityID = 'WallBuilderEntityID',
}

/** aggregate stddev on columns */
export type Mlfsl_Matter_Stddev_Fields = {
  AMLID?: Maybe<Scalars['Float']['output']>;
  DateMatterClosed?: Maybe<Scalars['Float']['output']>;
  DateMatterOpen?: Maybe<Scalars['Float']['output']>;
  DimMatterNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  MatterBillableStatusIndicator?: Maybe<Scalars['Float']['output']>;
  MatterIndex?: Maybe<Scalars['Float']['output']>;
  MatterStatusOpenIndicator?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Stddev_Order_By = {
  AMLID?: InputMaybe<Order_By>;
  DateMatterClosed?: InputMaybe<Order_By>;
  DateMatterOpen?: InputMaybe<Order_By>;
  DimMatterNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  MatterBillableStatusIndicator?: InputMaybe<Order_By>;
  MatterIndex?: InputMaybe<Order_By>;
  MatterStatusOpenIndicator?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Matter_Stddev_Pop_Fields = {
  AMLID?: Maybe<Scalars['Float']['output']>;
  DateMatterClosed?: Maybe<Scalars['Float']['output']>;
  DateMatterOpen?: Maybe<Scalars['Float']['output']>;
  DimMatterNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  MatterBillableStatusIndicator?: Maybe<Scalars['Float']['output']>;
  MatterIndex?: Maybe<Scalars['Float']['output']>;
  MatterStatusOpenIndicator?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Stddev_Pop_Order_By = {
  AMLID?: InputMaybe<Order_By>;
  DateMatterClosed?: InputMaybe<Order_By>;
  DateMatterOpen?: InputMaybe<Order_By>;
  DimMatterNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  MatterBillableStatusIndicator?: InputMaybe<Order_By>;
  MatterIndex?: InputMaybe<Order_By>;
  MatterStatusOpenIndicator?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Matter_Stddev_Samp_Fields = {
  AMLID?: Maybe<Scalars['Float']['output']>;
  DateMatterClosed?: Maybe<Scalars['Float']['output']>;
  DateMatterOpen?: Maybe<Scalars['Float']['output']>;
  DimMatterNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  MatterBillableStatusIndicator?: Maybe<Scalars['Float']['output']>;
  MatterIndex?: Maybe<Scalars['Float']['output']>;
  MatterStatusOpenIndicator?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Stddev_Samp_Order_By = {
  AMLID?: InputMaybe<Order_By>;
  DateMatterClosed?: InputMaybe<Order_By>;
  DateMatterOpen?: InputMaybe<Order_By>;
  DimMatterNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  MatterBillableStatusIndicator?: InputMaybe<Order_By>;
  MatterIndex?: InputMaybe<Order_By>;
  MatterStatusOpenIndicator?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Mlfsl_Matter_Sum_Fields = {
  AMLID?: Maybe<Scalars['Int']['output']>;
  DateMatterClosed?: Maybe<Scalars['Int']['output']>;
  DateMatterOpen?: Maybe<Scalars['Int']['output']>;
  DimMatterNowKey?: Maybe<Scalars['Int']['output']>;
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
  MatterBillableStatusIndicator?: Maybe<Scalars['Int']['output']>;
  MatterIndex?: Maybe<Scalars['Int']['output']>;
  MatterStatusOpenIndicator?: Maybe<Scalars['Int']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Sum_Order_By = {
  AMLID?: InputMaybe<Order_By>;
  DateMatterClosed?: InputMaybe<Order_By>;
  DateMatterOpen?: InputMaybe<Order_By>;
  DimMatterNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  MatterBillableStatusIndicator?: InputMaybe<Order_By>;
  MatterIndex?: InputMaybe<Order_By>;
  MatterStatusOpenIndicator?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Matter_Var_Pop_Fields = {
  AMLID?: Maybe<Scalars['Float']['output']>;
  DateMatterClosed?: Maybe<Scalars['Float']['output']>;
  DateMatterOpen?: Maybe<Scalars['Float']['output']>;
  DimMatterNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  MatterBillableStatusIndicator?: Maybe<Scalars['Float']['output']>;
  MatterIndex?: Maybe<Scalars['Float']['output']>;
  MatterStatusOpenIndicator?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Var_Pop_Order_By = {
  AMLID?: InputMaybe<Order_By>;
  DateMatterClosed?: InputMaybe<Order_By>;
  DateMatterOpen?: InputMaybe<Order_By>;
  DimMatterNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  MatterBillableStatusIndicator?: InputMaybe<Order_By>;
  MatterIndex?: InputMaybe<Order_By>;
  MatterStatusOpenIndicator?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Matter_Var_Samp_Fields = {
  AMLID?: Maybe<Scalars['Float']['output']>;
  DateMatterClosed?: Maybe<Scalars['Float']['output']>;
  DateMatterOpen?: Maybe<Scalars['Float']['output']>;
  DimMatterNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  MatterBillableStatusIndicator?: Maybe<Scalars['Float']['output']>;
  MatterIndex?: Maybe<Scalars['Float']['output']>;
  MatterStatusOpenIndicator?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Var_Samp_Order_By = {
  AMLID?: InputMaybe<Order_By>;
  DateMatterClosed?: InputMaybe<Order_By>;
  DateMatterOpen?: InputMaybe<Order_By>;
  DimMatterNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  MatterBillableStatusIndicator?: InputMaybe<Order_By>;
  MatterIndex?: InputMaybe<Order_By>;
  MatterStatusOpenIndicator?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mlfsl_Matter_Variance_Fields = {
  AMLID?: Maybe<Scalars['Float']['output']>;
  DateMatterClosed?: Maybe<Scalars['Float']['output']>;
  DateMatterOpen?: Maybe<Scalars['Float']['output']>;
  DimMatterNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  MatterBillableStatusIndicator?: Maybe<Scalars['Float']['output']>;
  MatterIndex?: Maybe<Scalars['Float']['output']>;
  MatterStatusOpenIndicator?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "repl.DimMatterNow" */
export type Mlfsl_Matter_Variance_Order_By = {
  AMLID?: InputMaybe<Order_By>;
  DateMatterClosed?: InputMaybe<Order_By>;
  DateMatterOpen?: InputMaybe<Order_By>;
  DimMatterNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  MatterBillableStatusIndicator?: InputMaybe<Order_By>;
  MatterIndex?: InputMaybe<Order_By>;
  MatterStatusOpenIndicator?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
};

/** columns and relationships of "MNET.mlv_Finance_Hours_Timeframes" */
export type Mlfsl_Mlv_Finance_Hours_Timeframes = {
  ComparePeriod?: Maybe<Scalars['String']['output']>;
  EndPeriod?: Maybe<Scalars['Int']['output']>;
  StartPeriod?: Maybe<Scalars['Int']['output']>;
  Timeframe: Scalars['String']['output'];
  TimeframeDisplay: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "MNET.mlv_Finance_Hours_Timeframes". All fields are combined with a logical 'AND'. */
export type Mlfsl_Mlv_Finance_Hours_Timeframes_Bool_Exp = {
  ComparePeriod?: InputMaybe<String_Mssql_Comparison_Exp>;
  EndPeriod?: InputMaybe<Int_Mssql_Comparison_Exp>;
  StartPeriod?: InputMaybe<Int_Mssql_Comparison_Exp>;
  Timeframe?: InputMaybe<String_Mssql_Comparison_Exp>;
  TimeframeDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Mlv_Finance_Hours_Timeframes_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Mlv_Finance_Hours_Timeframes_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Mlv_Finance_Hours_Timeframes_Bool_Exp>>;
};

/** Ordering options when selecting data from "MNET.mlv_Finance_Hours_Timeframes". */
export type Mlfsl_Mlv_Finance_Hours_Timeframes_Order_By = {
  ComparePeriod?: InputMaybe<Order_By>;
  EndPeriod?: InputMaybe<Order_By>;
  StartPeriod?: InputMaybe<Order_By>;
  Timeframe?: InputMaybe<Order_By>;
  TimeframeDisplay?: InputMaybe<Order_By>;
};

/** columns and relationships of "MNET.mlv_Finance_Hours_Client" */
export type Mlfsl_Mlv_Finance_Hours_Client = {
  /** An object relationship */
  Client?: Maybe<Mlfsl_Client>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  ClosedMatterCount?: Maybe<Scalars['Int']['output']>;
  MatterCount: Scalars['Int']['output'];
  OpenMatterCount?: Maybe<Scalars['Int']['output']>;
  TimekeeperCount: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the table "MNET.mlv_Finance_Hours_Client". All fields are combined with a logical 'AND'. */
export type Mlfsl_Mlv_Finance_Hours_Client_Bool_Exp = {
  Client?: InputMaybe<Mlfsl_Client_Bool_Exp>;
  ClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClosedMatterCount?: InputMaybe<Int_Mssql_Comparison_Exp>;
  MatterCount?: InputMaybe<Int_Mssql_Comparison_Exp>;
  OpenMatterCount?: InputMaybe<Int_Mssql_Comparison_Exp>;
  TimekeeperCount?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Mlv_Finance_Hours_Client_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Mlv_Finance_Hours_Client_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Mlv_Finance_Hours_Client_Bool_Exp>>;
};

/** Ordering options when selecting data from "MNET.mlv_Finance_Hours_Client". */
export type Mlfsl_Mlv_Finance_Hours_Client_Order_By = {
  Client?: InputMaybe<Mlfsl_Client_Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  ClosedMatterCount?: InputMaybe<Order_By>;
  MatterCount?: InputMaybe<Order_By>;
  OpenMatterCount?: InputMaybe<Order_By>;
  TimekeeperCount?: InputMaybe<Order_By>;
};

/** columns and relationships of "MNET.mlv_Finance_Hours_Matter" */
export type Mlfsl_Mlv_Finance_Hours_Matter = {
  /** An object relationship */
  Matter?: Maybe<Mlfsl_Matter>;
  MatterNumber: Scalars['String']['output'];
  TimekeeperCount?: Maybe<Scalars['Int']['output']>;
};

/** Boolean expression to filter rows from the table "MNET.mlv_Finance_Hours_Matter". All fields are combined with a logical 'AND'. */
export type Mlfsl_Mlv_Finance_Hours_Matter_Bool_Exp = {
  Matter?: InputMaybe<Mlfsl_Matter_Bool_Exp>;
  MatterNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  TimekeeperCount?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Mlv_Finance_Hours_Matter_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Mlv_Finance_Hours_Matter_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Mlv_Finance_Hours_Matter_Bool_Exp>>;
};

/** Ordering options when selecting data from "MNET.mlv_Finance_Hours_Matter". */
export type Mlfsl_Mlv_Finance_Hours_Matter_Order_By = {
  Matter?: InputMaybe<Mlfsl_Matter_Order_By>;
  MatterNumber?: InputMaybe<Order_By>;
  TimekeeperCount?: InputMaybe<Order_By>;
};

/** columns and relationships of "MNET.mlv_Finance_Hours_RelatedClient" */
export type Mlfsl_Mlv_Finance_Hours_Relatedclient = {
  ActiveClientCount?: Maybe<Scalars['Int']['output']>;
  ClientCount: Scalars['Int']['output'];
  InactiveClientCount?: Maybe<Scalars['Int']['output']>;
  MatterCount: Scalars['Int']['output'];
  /** An object relationship */
  RelatedClient?: Maybe<Mlfsl_Related_Client>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  TimekeeperCount: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the table "MNET.mlv_Finance_Hours_RelatedClient". All fields are combined with a logical 'AND'. */
export type Mlfsl_Mlv_Finance_Hours_Relatedclient_Bool_Exp = {
  ActiveClientCount?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ClientCount?: InputMaybe<Int_Mssql_Comparison_Exp>;
  InactiveClientCount?: InputMaybe<Int_Mssql_Comparison_Exp>;
  MatterCount?: InputMaybe<Int_Mssql_Comparison_Exp>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Bool_Exp>;
  RelatedClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  TimekeeperCount?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Mlv_Finance_Hours_Relatedclient_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Mlv_Finance_Hours_Relatedclient_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Mlv_Finance_Hours_Relatedclient_Bool_Exp>>;
};

/** Ordering options when selecting data from "MNET.mlv_Finance_Hours_RelatedClient". */
export type Mlfsl_Mlv_Finance_Hours_Relatedclient_Order_By = {
  ActiveClientCount?: InputMaybe<Order_By>;
  ClientCount?: InputMaybe<Order_By>;
  InactiveClientCount?: InputMaybe<Order_By>;
  MatterCount?: InputMaybe<Order_By>;
  RelatedClient?: InputMaybe<Mlfsl_Related_Client_Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  TimekeeperCount?: InputMaybe<Order_By>;
};

/** columns and relationships of "repl.MorganNetClientPage_ClientInfo" */
export type Mlfsl_Morgannet_ClientPage_ClientInfo = {
  /** An object relationship */
  Client?: Maybe<Mlfsl_Client>;
  ClientCloseDate?: Maybe<Scalars['date']['output']>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  ClientOpenDate?: Maybe<Scalars['date']['output']>;
  DUNSNumber?: Maybe<Scalars['String']['output']>;
  DUNSNumber_DomesticUltimate?: Maybe<Scalars['String']['output']>;
  DUNSNumber_GlobalUltimate?: Maybe<Scalars['String']['output']>;
  DUNSNumber_Headquarters?: Maybe<Scalars['String']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Int']['output']>;
  LastPaymentAmount?: Maybe<Scalars['Float']['output']>;
  LastPaymentDate?: Maybe<Scalars['date']['output']>;
  MNCP_ClientInfoKey: Scalars['Int']['output'];
  MattersOverARLimit?: Maybe<Scalars['Int']['output']>;
  MattersOverUBTLimit?: Maybe<Scalars['Int']['output']>;
  NumberMattersOpenedLast14Days?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  RelatedClient?: Maybe<Mlfsl_Client>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "repl.MorganNetClientPage_ClientInfo" */
export type Mlfsl_Morgannet_ClientPage_ClientInfo_Aggregate = {
  aggregate?: Maybe<Mlfsl_Morgannet_ClientPage_ClientInfo_Aggregate_Fields>;
  nodes: Array<Mlfsl_Morgannet_ClientPage_ClientInfo>;
};

/** aggregate fields of "repl.MorganNetClientPage_ClientInfo" */
export type Mlfsl_Morgannet_ClientPage_ClientInfo_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Morgannet_ClientPage_ClientInfo_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Morgannet_ClientPage_ClientInfo_Max_Fields>;
  min?: Maybe<Mlfsl_Morgannet_ClientPage_ClientInfo_Min_Fields>;
  stddev?: Maybe<Mlfsl_Morgannet_ClientPage_ClientInfo_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Morgannet_ClientPage_ClientInfo_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Morgannet_ClientPage_ClientInfo_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Morgannet_ClientPage_ClientInfo_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Morgannet_ClientPage_ClientInfo_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Morgannet_ClientPage_ClientInfo_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Morgannet_ClientPage_ClientInfo_Variance_Fields>;
};

/** aggregate fields of "repl.MorganNetClientPage_ClientInfo" */
export type Mlfsl_Morgannet_ClientPage_ClientInfo_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Morgannet_ClientPage_ClientInfo_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mlfsl_Morgannet_ClientPage_ClientInfo_Avg_Fields = {
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  LastPaymentAmount?: Maybe<Scalars['Float']['output']>;
  MNCP_ClientInfoKey?: Maybe<Scalars['Float']['output']>;
  MattersOverARLimit?: Maybe<Scalars['Float']['output']>;
  MattersOverUBTLimit?: Maybe<Scalars['Float']['output']>;
  NumberMattersOpenedLast14Days?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "repl.MorganNetClientPage_ClientInfo". All fields are combined with a logical 'AND'. */
export type Mlfsl_Morgannet_ClientPage_ClientInfo_Bool_Exp = {
  Client?: InputMaybe<Mlfsl_Client_Bool_Exp>;
  ClientCloseDate?: InputMaybe<Date_Mssql_Comparison_Exp>;
  ClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientOpenDate?: InputMaybe<Date_Mssql_Comparison_Exp>;
  DUNSNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  DUNSNumber_DomesticUltimate?: InputMaybe<String_Mssql_Comparison_Exp>;
  DUNSNumber_GlobalUltimate?: InputMaybe<String_Mssql_Comparison_Exp>;
  DUNSNumber_Headquarters?: InputMaybe<String_Mssql_Comparison_Exp>;
  DaysSinceLastPayment?: InputMaybe<Int_Mssql_Comparison_Exp>;
  LastPaymentAmount?: InputMaybe<Float_Mssql_Comparison_Exp>;
  LastPaymentDate?: InputMaybe<Date_Mssql_Comparison_Exp>;
  MNCP_ClientInfoKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  MattersOverARLimit?: InputMaybe<Int_Mssql_Comparison_Exp>;
  MattersOverUBTLimit?: InputMaybe<Int_Mssql_Comparison_Exp>;
  NumberMattersOpenedLast14Days?: InputMaybe<Int_Mssql_Comparison_Exp>;
  RelatedClient?: InputMaybe<Mlfsl_Client_Bool_Exp>;
  RelatedClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Morgannet_ClientPage_ClientInfo_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Morgannet_ClientPage_ClientInfo_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Morgannet_ClientPage_ClientInfo_Bool_Exp>>;
};

/** aggregate max on columns */
export type Mlfsl_Morgannet_ClientPage_ClientInfo_Max_Fields = {
  ClientCloseDate?: Maybe<Scalars['date']['output']>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  ClientOpenDate?: Maybe<Scalars['date']['output']>;
  DUNSNumber?: Maybe<Scalars['String']['output']>;
  DUNSNumber_DomesticUltimate?: Maybe<Scalars['String']['output']>;
  DUNSNumber_GlobalUltimate?: Maybe<Scalars['String']['output']>;
  DUNSNumber_Headquarters?: Maybe<Scalars['String']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Int']['output']>;
  LastPaymentAmount?: Maybe<Scalars['Float']['output']>;
  LastPaymentDate?: Maybe<Scalars['date']['output']>;
  MNCP_ClientInfoKey?: Maybe<Scalars['Int']['output']>;
  MattersOverARLimit?: Maybe<Scalars['Int']['output']>;
  MattersOverUBTLimit?: Maybe<Scalars['Int']['output']>;
  NumberMattersOpenedLast14Days?: Maybe<Scalars['Int']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mlfsl_Morgannet_ClientPage_ClientInfo_Min_Fields = {
  ClientCloseDate?: Maybe<Scalars['date']['output']>;
  ClientNumber?: Maybe<Scalars['String']['output']>;
  ClientOpenDate?: Maybe<Scalars['date']['output']>;
  DUNSNumber?: Maybe<Scalars['String']['output']>;
  DUNSNumber_DomesticUltimate?: Maybe<Scalars['String']['output']>;
  DUNSNumber_GlobalUltimate?: Maybe<Scalars['String']['output']>;
  DUNSNumber_Headquarters?: Maybe<Scalars['String']['output']>;
  DaysSinceLastPayment?: Maybe<Scalars['Int']['output']>;
  LastPaymentAmount?: Maybe<Scalars['Float']['output']>;
  LastPaymentDate?: Maybe<Scalars['date']['output']>;
  MNCP_ClientInfoKey?: Maybe<Scalars['Int']['output']>;
  MattersOverARLimit?: Maybe<Scalars['Int']['output']>;
  MattersOverUBTLimit?: Maybe<Scalars['Int']['output']>;
  NumberMattersOpenedLast14Days?: Maybe<Scalars['Int']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "repl.MorganNetClientPage_ClientInfo". */
export type Mlfsl_Morgannet_ClientPage_ClientInfo_Order_By = {
  Client?: InputMaybe<Mlfsl_Client_Order_By>;
  ClientCloseDate?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  ClientOpenDate?: InputMaybe<Order_By>;
  DUNSNumber?: InputMaybe<Order_By>;
  DUNSNumber_DomesticUltimate?: InputMaybe<Order_By>;
  DUNSNumber_GlobalUltimate?: InputMaybe<Order_By>;
  DUNSNumber_Headquarters?: InputMaybe<Order_By>;
  DaysSinceLastPayment?: InputMaybe<Order_By>;
  LastPaymentAmount?: InputMaybe<Order_By>;
  LastPaymentDate?: InputMaybe<Order_By>;
  MNCP_ClientInfoKey?: InputMaybe<Order_By>;
  MattersOverARLimit?: InputMaybe<Order_By>;
  MattersOverUBTLimit?: InputMaybe<Order_By>;
  NumberMattersOpenedLast14Days?: InputMaybe<Order_By>;
  RelatedClient?: InputMaybe<Mlfsl_Client_Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
};

/** select columns of table "repl.MorganNetClientPage_ClientInfo" */
export enum Mlfsl_Morgannet_ClientPage_ClientInfo_Select_Column {
  /** column name */
  ClientCloseDate = 'ClientCloseDate',
  /** column name */
  ClientNumber = 'ClientNumber',
  /** column name */
  ClientOpenDate = 'ClientOpenDate',
  /** column name */
  DUNSNumber = 'DUNSNumber',
  /** column name */
  DUNSNumber_DomesticUltimate = 'DUNSNumber_DomesticUltimate',
  /** column name */
  DUNSNumber_GlobalUltimate = 'DUNSNumber_GlobalUltimate',
  /** column name */
  DUNSNumber_Headquarters = 'DUNSNumber_Headquarters',
  /** column name */
  DaysSinceLastPayment = 'DaysSinceLastPayment',
  /** column name */
  LastPaymentAmount = 'LastPaymentAmount',
  /** column name */
  LastPaymentDate = 'LastPaymentDate',
  /** column name */
  MNCP_ClientInfoKey = 'MNCP_ClientInfoKey',
  /** column name */
  MattersOverARLimit = 'MattersOverARLimit',
  /** column name */
  MattersOverUBTLimit = 'MattersOverUBTLimit',
  /** column name */
  NumberMattersOpenedLast14Days = 'NumberMattersOpenedLast14Days',
  /** column name */
  RelatedClientNumber = 'RelatedClientNumber',
}

/** aggregate stddev on columns */
export type Mlfsl_Morgannet_ClientPage_ClientInfo_Stddev_Fields = {
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  LastPaymentAmount?: Maybe<Scalars['Float']['output']>;
  MNCP_ClientInfoKey?: Maybe<Scalars['Float']['output']>;
  MattersOverARLimit?: Maybe<Scalars['Float']['output']>;
  MattersOverUBTLimit?: Maybe<Scalars['Float']['output']>;
  NumberMattersOpenedLast14Days?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Morgannet_ClientPage_ClientInfo_Stddev_Pop_Fields = {
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  LastPaymentAmount?: Maybe<Scalars['Float']['output']>;
  MNCP_ClientInfoKey?: Maybe<Scalars['Float']['output']>;
  MattersOverARLimit?: Maybe<Scalars['Float']['output']>;
  MattersOverUBTLimit?: Maybe<Scalars['Float']['output']>;
  NumberMattersOpenedLast14Days?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Morgannet_ClientPage_ClientInfo_Stddev_Samp_Fields = {
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  LastPaymentAmount?: Maybe<Scalars['Float']['output']>;
  MNCP_ClientInfoKey?: Maybe<Scalars['Float']['output']>;
  MattersOverARLimit?: Maybe<Scalars['Float']['output']>;
  MattersOverUBTLimit?: Maybe<Scalars['Float']['output']>;
  NumberMattersOpenedLast14Days?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Mlfsl_Morgannet_ClientPage_ClientInfo_Sum_Fields = {
  DaysSinceLastPayment?: Maybe<Scalars['Int']['output']>;
  LastPaymentAmount?: Maybe<Scalars['Float']['output']>;
  MNCP_ClientInfoKey?: Maybe<Scalars['Int']['output']>;
  MattersOverARLimit?: Maybe<Scalars['Int']['output']>;
  MattersOverUBTLimit?: Maybe<Scalars['Int']['output']>;
  NumberMattersOpenedLast14Days?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Morgannet_ClientPage_ClientInfo_Var_Pop_Fields = {
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  LastPaymentAmount?: Maybe<Scalars['Float']['output']>;
  MNCP_ClientInfoKey?: Maybe<Scalars['Float']['output']>;
  MattersOverARLimit?: Maybe<Scalars['Float']['output']>;
  MattersOverUBTLimit?: Maybe<Scalars['Float']['output']>;
  NumberMattersOpenedLast14Days?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Morgannet_ClientPage_ClientInfo_Var_Samp_Fields = {
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  LastPaymentAmount?: Maybe<Scalars['Float']['output']>;
  MNCP_ClientInfoKey?: Maybe<Scalars['Float']['output']>;
  MattersOverARLimit?: Maybe<Scalars['Float']['output']>;
  MattersOverUBTLimit?: Maybe<Scalars['Float']['output']>;
  NumberMattersOpenedLast14Days?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mlfsl_Morgannet_ClientPage_ClientInfo_Variance_Fields = {
  DaysSinceLastPayment?: Maybe<Scalars['Float']['output']>;
  LastPaymentAmount?: Maybe<Scalars['Float']['output']>;
  MNCP_ClientInfoKey?: Maybe<Scalars['Float']['output']>;
  MattersOverARLimit?: Maybe<Scalars['Float']['output']>;
  MattersOverUBTLimit?: Maybe<Scalars['Float']['output']>;
  NumberMattersOpenedLast14Days?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "repl.DimOfficeNow" */
export type Mlfsl_Office = {
  /** An array relationship */
  BusinessPrimaryOfficePersonnel: Array<Mlfsl_Personnel>;
  /** An aggregate relationship */
  BusinessPrimaryOfficePersonnel_aggregate: Mlfsl_Personnel_Aggregate;
  /** An array relationship */
  BusinessSecondaryOfficePersonnel: Array<Mlfsl_Personnel>;
  /** An aggregate relationship */
  BusinessSecondaryOfficePersonnel_aggregate: Mlfsl_Personnel_Aggregate;
  DataCenterRegion?: Maybe<Scalars['String']['output']>;
  DatabaseName?: Maybe<Scalars['String']['output']>;
  DatabaseServer?: Maybe<Scalars['String']['output']>;
  DeletedRecordIndicator: Scalars['String']['output'];
  DimOfficeNowKey: Scalars['Int']['output'];
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
  EtlCreatedDate: Scalars['datetime']['output'];
  EtlModifiedDate: Scalars['datetime']['output'];
  OfficeActiveFlag?: Maybe<Scalars['String']['output']>;
  OfficeAddress1?: Maybe<Scalars['String']['output']>;
  OfficeAddress2?: Maybe<Scalars['String']['output']>;
  OfficeAddress3?: Maybe<Scalars['String']['output']>;
  OfficeAddress4?: Maybe<Scalars['String']['output']>;
  OfficeCity?: Maybe<Scalars['String']['output']>;
  OfficeCountryCode?: Maybe<Scalars['String']['output']>;
  OfficeCountryName?: Maybe<Scalars['String']['output']>;
  OfficeCurrencyCode?: Maybe<Scalars['String']['output']>;
  OfficeEliteLocationCode?: Maybe<Scalars['String']['output']>;
  OfficeFax?: Maybe<Scalars['String']['output']>;
  OfficeGUID?: Maybe<Scalars['uniqueidentifier']['output']>;
  OfficeGroupCode?: Maybe<Scalars['String']['output']>;
  OfficeGroupDescription?: Maybe<Scalars['String']['output']>;
  OfficeInternalPhonePrefix?: Maybe<Scalars['String']['output']>;
  OfficeLocationAbbreviation?: Maybe<Scalars['String']['output']>;
  OfficeManagerBusinessPrimaryOfficePhoneNumberFull?: Maybe<Scalars['String']['output']>;
  OfficeManagerEmail?: Maybe<Scalars['String']['output']>;
  OfficeManagerEmployeeID?: Maybe<Scalars['String']['output']>;
  OfficeManagerNameFull?: Maybe<Scalars['String']['output']>;
  OfficeName?: Maybe<Scalars['String']['output']>;
  OfficeNameDisplay?: Maybe<Scalars['String']['output']>;
  OfficePhone?: Maybe<Scalars['String']['output']>;
  OfficeRegion?: Maybe<Scalars['String']['output']>;
  OfficeSignatureText?: Maybe<Scalars['String']['output']>;
  OfficeState?: Maybe<Scalars['String']['output']>;
  OfficeZipCode?: Maybe<Scalars['String']['output']>;
  RegionalFirmName?: Maybe<Scalars['String']['output']>;
  WorkCalendarCode?: Maybe<Scalars['String']['output']>;
  mnet_office_detail?: Maybe<Mnet_Office_Detail>;
};

/** columns and relationships of "repl.DimOfficeNow" */
export type Mlfsl_OfficeBusinessPrimaryOfficePersonnelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
};

/** columns and relationships of "repl.DimOfficeNow" */
export type Mlfsl_OfficeBusinessPrimaryOfficePersonnel_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
};

/** columns and relationships of "repl.DimOfficeNow" */
export type Mlfsl_OfficeBusinessSecondaryOfficePersonnelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
};

/** columns and relationships of "repl.DimOfficeNow" */
export type Mlfsl_OfficeBusinessSecondaryOfficePersonnel_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
};

/** aggregated selection of "repl.DimOfficeNow" */
export type Mlfsl_Office_Aggregate = {
  aggregate?: Maybe<Mlfsl_Office_Aggregate_Fields>;
  nodes: Array<Mlfsl_Office>;
};

/** aggregate fields of "repl.DimOfficeNow" */
export type Mlfsl_Office_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Office_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Office_Max_Fields>;
  min?: Maybe<Mlfsl_Office_Min_Fields>;
  stddev?: Maybe<Mlfsl_Office_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Office_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Office_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Office_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Office_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Office_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Office_Variance_Fields>;
};

/** aggregate fields of "repl.DimOfficeNow" */
export type Mlfsl_Office_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Office_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mlfsl_Office_Avg_Fields = {
  DimOfficeNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "repl.DimOfficeNow". All fields are combined with a logical 'AND'. */
export type Mlfsl_Office_Bool_Exp = {
  BusinessPrimaryOfficePersonnel?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
  BusinessSecondaryOfficePersonnel?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
  DataCenterRegion?: InputMaybe<String_Mssql_Comparison_Exp>;
  DatabaseName?: InputMaybe<String_Mssql_Comparison_Exp>;
  DatabaseServer?: InputMaybe<String_Mssql_Comparison_Exp>;
  DeletedRecordIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  DimOfficeNowKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLBatchKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EtlChecksum?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EtlCreatedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  EtlModifiedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  OfficeActiveFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeAddress1?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeAddress2?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeAddress3?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeAddress4?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeCity?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeCountryCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeCountryName?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeCurrencyCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeEliteLocationCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeFax?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeGUID?: InputMaybe<Uniqueidentifier_Mssql_Comparison_Exp>;
  OfficeGroupCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeGroupDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeInternalPhonePrefix?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeLocationAbbreviation?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeManagerBusinessPrimaryOfficePhoneNumberFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeManagerEmail?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeManagerEmployeeID?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeManagerNameFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeName?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeNameDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficePhone?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeRegion?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeSignatureText?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeState?: InputMaybe<String_Mssql_Comparison_Exp>;
  OfficeZipCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  RegionalFirmName?: InputMaybe<String_Mssql_Comparison_Exp>;
  WorkCalendarCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Office_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Office_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Office_Bool_Exp>>;
};

/** aggregate max on columns */
export type Mlfsl_Office_Max_Fields = {
  DataCenterRegion?: Maybe<Scalars['String']['output']>;
  DatabaseName?: Maybe<Scalars['String']['output']>;
  DatabaseServer?: Maybe<Scalars['String']['output']>;
  DeletedRecordIndicator?: Maybe<Scalars['String']['output']>;
  DimOfficeNowKey?: Maybe<Scalars['Int']['output']>;
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  OfficeActiveFlag?: Maybe<Scalars['String']['output']>;
  OfficeAddress1?: Maybe<Scalars['String']['output']>;
  OfficeAddress2?: Maybe<Scalars['String']['output']>;
  OfficeAddress3?: Maybe<Scalars['String']['output']>;
  OfficeAddress4?: Maybe<Scalars['String']['output']>;
  OfficeCity?: Maybe<Scalars['String']['output']>;
  OfficeCountryCode?: Maybe<Scalars['String']['output']>;
  OfficeCountryName?: Maybe<Scalars['String']['output']>;
  OfficeCurrencyCode?: Maybe<Scalars['String']['output']>;
  OfficeEliteLocationCode?: Maybe<Scalars['String']['output']>;
  OfficeFax?: Maybe<Scalars['String']['output']>;
  OfficeGroupCode?: Maybe<Scalars['String']['output']>;
  OfficeGroupDescription?: Maybe<Scalars['String']['output']>;
  OfficeInternalPhonePrefix?: Maybe<Scalars['String']['output']>;
  OfficeLocationAbbreviation?: Maybe<Scalars['String']['output']>;
  OfficeManagerBusinessPrimaryOfficePhoneNumberFull?: Maybe<Scalars['String']['output']>;
  OfficeManagerEmail?: Maybe<Scalars['String']['output']>;
  OfficeManagerEmployeeID?: Maybe<Scalars['String']['output']>;
  OfficeManagerNameFull?: Maybe<Scalars['String']['output']>;
  OfficeName?: Maybe<Scalars['String']['output']>;
  OfficeNameDisplay?: Maybe<Scalars['String']['output']>;
  OfficePhone?: Maybe<Scalars['String']['output']>;
  OfficeRegion?: Maybe<Scalars['String']['output']>;
  OfficeSignatureText?: Maybe<Scalars['String']['output']>;
  OfficeState?: Maybe<Scalars['String']['output']>;
  OfficeZipCode?: Maybe<Scalars['String']['output']>;
  RegionalFirmName?: Maybe<Scalars['String']['output']>;
  WorkCalendarCode?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mlfsl_Office_Min_Fields = {
  DataCenterRegion?: Maybe<Scalars['String']['output']>;
  DatabaseName?: Maybe<Scalars['String']['output']>;
  DatabaseServer?: Maybe<Scalars['String']['output']>;
  DeletedRecordIndicator?: Maybe<Scalars['String']['output']>;
  DimOfficeNowKey?: Maybe<Scalars['Int']['output']>;
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  OfficeActiveFlag?: Maybe<Scalars['String']['output']>;
  OfficeAddress1?: Maybe<Scalars['String']['output']>;
  OfficeAddress2?: Maybe<Scalars['String']['output']>;
  OfficeAddress3?: Maybe<Scalars['String']['output']>;
  OfficeAddress4?: Maybe<Scalars['String']['output']>;
  OfficeCity?: Maybe<Scalars['String']['output']>;
  OfficeCountryCode?: Maybe<Scalars['String']['output']>;
  OfficeCountryName?: Maybe<Scalars['String']['output']>;
  OfficeCurrencyCode?: Maybe<Scalars['String']['output']>;
  OfficeEliteLocationCode?: Maybe<Scalars['String']['output']>;
  OfficeFax?: Maybe<Scalars['String']['output']>;
  OfficeGroupCode?: Maybe<Scalars['String']['output']>;
  OfficeGroupDescription?: Maybe<Scalars['String']['output']>;
  OfficeInternalPhonePrefix?: Maybe<Scalars['String']['output']>;
  OfficeLocationAbbreviation?: Maybe<Scalars['String']['output']>;
  OfficeManagerBusinessPrimaryOfficePhoneNumberFull?: Maybe<Scalars['String']['output']>;
  OfficeManagerEmail?: Maybe<Scalars['String']['output']>;
  OfficeManagerEmployeeID?: Maybe<Scalars['String']['output']>;
  OfficeManagerNameFull?: Maybe<Scalars['String']['output']>;
  OfficeName?: Maybe<Scalars['String']['output']>;
  OfficeNameDisplay?: Maybe<Scalars['String']['output']>;
  OfficePhone?: Maybe<Scalars['String']['output']>;
  OfficeRegion?: Maybe<Scalars['String']['output']>;
  OfficeSignatureText?: Maybe<Scalars['String']['output']>;
  OfficeState?: Maybe<Scalars['String']['output']>;
  OfficeZipCode?: Maybe<Scalars['String']['output']>;
  RegionalFirmName?: Maybe<Scalars['String']['output']>;
  WorkCalendarCode?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "repl.DimOfficeNow". */
export type Mlfsl_Office_Order_By = {
  BusinessPrimaryOfficePersonnel_aggregate?: InputMaybe<Mlfsl_Personnel_Aggregate_Order_By>;
  BusinessSecondaryOfficePersonnel_aggregate?: InputMaybe<Mlfsl_Personnel_Aggregate_Order_By>;
  DataCenterRegion?: InputMaybe<Order_By>;
  DatabaseName?: InputMaybe<Order_By>;
  DatabaseServer?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DimOfficeNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  OfficeActiveFlag?: InputMaybe<Order_By>;
  OfficeAddress1?: InputMaybe<Order_By>;
  OfficeAddress2?: InputMaybe<Order_By>;
  OfficeAddress3?: InputMaybe<Order_By>;
  OfficeAddress4?: InputMaybe<Order_By>;
  OfficeCity?: InputMaybe<Order_By>;
  OfficeCountryCode?: InputMaybe<Order_By>;
  OfficeCountryName?: InputMaybe<Order_By>;
  OfficeCurrencyCode?: InputMaybe<Order_By>;
  OfficeEliteLocationCode?: InputMaybe<Order_By>;
  OfficeFax?: InputMaybe<Order_By>;
  OfficeGUID?: InputMaybe<Order_By>;
  OfficeGroupCode?: InputMaybe<Order_By>;
  OfficeGroupDescription?: InputMaybe<Order_By>;
  OfficeInternalPhonePrefix?: InputMaybe<Order_By>;
  OfficeLocationAbbreviation?: InputMaybe<Order_By>;
  OfficeManagerBusinessPrimaryOfficePhoneNumberFull?: InputMaybe<Order_By>;
  OfficeManagerEmail?: InputMaybe<Order_By>;
  OfficeManagerEmployeeID?: InputMaybe<Order_By>;
  OfficeManagerNameFull?: InputMaybe<Order_By>;
  OfficeName?: InputMaybe<Order_By>;
  OfficeNameDisplay?: InputMaybe<Order_By>;
  OfficePhone?: InputMaybe<Order_By>;
  OfficeRegion?: InputMaybe<Order_By>;
  OfficeSignatureText?: InputMaybe<Order_By>;
  OfficeState?: InputMaybe<Order_By>;
  OfficeZipCode?: InputMaybe<Order_By>;
  RegionalFirmName?: InputMaybe<Order_By>;
  WorkCalendarCode?: InputMaybe<Order_By>;
};

/** select columns of table "repl.DimOfficeNow" */
export enum Mlfsl_Office_Select_Column {
  /** column name */
  DataCenterRegion = 'DataCenterRegion',
  /** column name */
  DatabaseName = 'DatabaseName',
  /** column name */
  DatabaseServer = 'DatabaseServer',
  /** column name */
  DeletedRecordIndicator = 'DeletedRecordIndicator',
  /** column name */
  DimOfficeNowKey = 'DimOfficeNowKey',
  /** column name */
  ETLBatchKey = 'ETLBatchKey',
  /** column name */
  EtlChecksum = 'EtlChecksum',
  /** column name */
  EtlCreatedDate = 'EtlCreatedDate',
  /** column name */
  EtlModifiedDate = 'EtlModifiedDate',
  /** column name */
  OfficeActiveFlag = 'OfficeActiveFlag',
  /** column name */
  OfficeAddress1 = 'OfficeAddress1',
  /** column name */
  OfficeAddress2 = 'OfficeAddress2',
  /** column name */
  OfficeAddress3 = 'OfficeAddress3',
  /** column name */
  OfficeAddress4 = 'OfficeAddress4',
  /** column name */
  OfficeCity = 'OfficeCity',
  /** column name */
  OfficeCountryCode = 'OfficeCountryCode',
  /** column name */
  OfficeCountryName = 'OfficeCountryName',
  /** column name */
  OfficeCurrencyCode = 'OfficeCurrencyCode',
  /** column name */
  OfficeEliteLocationCode = 'OfficeEliteLocationCode',
  /** column name */
  OfficeFax = 'OfficeFax',
  /** column name */
  OfficeGUID = 'OfficeGUID',
  /** column name */
  OfficeGroupCode = 'OfficeGroupCode',
  /** column name */
  OfficeGroupDescription = 'OfficeGroupDescription',
  /** column name */
  OfficeInternalPhonePrefix = 'OfficeInternalPhonePrefix',
  /** column name */
  OfficeLocationAbbreviation = 'OfficeLocationAbbreviation',
  /** column name */
  OfficeManagerBusinessPrimaryOfficePhoneNumberFull = 'OfficeManagerBusinessPrimaryOfficePhoneNumberFull',
  /** column name */
  OfficeManagerEmail = 'OfficeManagerEmail',
  /** column name */
  OfficeManagerEmployeeID = 'OfficeManagerEmployeeID',
  /** column name */
  OfficeManagerNameFull = 'OfficeManagerNameFull',
  /** column name */
  OfficeName = 'OfficeName',
  /** column name */
  OfficeNameDisplay = 'OfficeNameDisplay',
  /** column name */
  OfficePhone = 'OfficePhone',
  /** column name */
  OfficeRegion = 'OfficeRegion',
  /** column name */
  OfficeSignatureText = 'OfficeSignatureText',
  /** column name */
  OfficeState = 'OfficeState',
  /** column name */
  OfficeZipCode = 'OfficeZipCode',
  /** column name */
  RegionalFirmName = 'RegionalFirmName',
  /** column name */
  WorkCalendarCode = 'WorkCalendarCode',
}

/** aggregate stddev on columns */
export type Mlfsl_Office_Stddev_Fields = {
  DimOfficeNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Office_Stddev_Pop_Fields = {
  DimOfficeNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Office_Stddev_Samp_Fields = {
  DimOfficeNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Mlfsl_Office_Sum_Fields = {
  DimOfficeNowKey?: Maybe<Scalars['Int']['output']>;
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Office_Var_Pop_Fields = {
  DimOfficeNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Office_Var_Samp_Fields = {
  DimOfficeNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mlfsl_Office_Variance_Fields = {
  DimOfficeNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education = {
  CompletionDate?: Maybe<Scalars['datetime']['output']>;
  DegreeCode?: Maybe<Scalars['String']['output']>;
  DegreeDescription?: Maybe<Scalars['String']['output']>;
  DimPersonnelEducationKey: Scalars['Int']['output'];
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  GraduationYear?: Maybe<Scalars['String']['output']>;
  Honors?: Maybe<Scalars['String']['output']>;
  InProgress?: Maybe<Scalars['String']['output']>;
  IsDeletedIndicator?: Maybe<Scalars['String']['output']>;
  LawsonCreationDate?: Maybe<Scalars['datetime']['output']>;
  /** An object relationship */
  Personnel?: Maybe<Mlfsl_Personnel>;
  SchoolCode?: Maybe<Scalars['String']['output']>;
  SchoolDescription?: Maybe<Scalars['String']['output']>;
  SchoolType?: Maybe<Scalars['String']['output']>;
  SubjectCode?: Maybe<Scalars['String']['output']>;
  SubjectDescription?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Aggregate = {
  aggregate?: Maybe<Mlfsl_Person_Education_Aggregate_Fields>;
  nodes: Array<Mlfsl_Person_Education>;
};

/** aggregate fields of "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Person_Education_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Person_Education_Max_Fields>;
  min?: Maybe<Mlfsl_Person_Education_Min_Fields>;
  stddev?: Maybe<Mlfsl_Person_Education_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Person_Education_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Person_Education_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Person_Education_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Person_Education_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Person_Education_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Person_Education_Variance_Fields>;
};

/** aggregate fields of "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Person_Education_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Person_Education_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Person_Education_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Person_Education_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Person_Education_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Person_Education_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Person_Education_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Person_Education_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Person_Education_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Person_Education_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Person_Education_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Mlfsl_Person_Education_Avg_Fields = {
  DimPersonnelEducationKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Avg_Order_By = {
  DimPersonnelEducationKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "repl.DimPersonnelEducation". All fields are combined with a logical 'AND'. */
export type Mlfsl_Person_Education_Bool_Exp = {
  CompletionDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  DegreeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  DegreeDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  DimPersonnelEducationKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLBatchKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EmployeeIdOriginal?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EtlChecksum?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EtlCreatedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  EtlModifiedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  GraduationYear?: InputMaybe<String_Mssql_Comparison_Exp>;
  Honors?: InputMaybe<String_Mssql_Comparison_Exp>;
  InProgress?: InputMaybe<String_Mssql_Comparison_Exp>;
  IsDeletedIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  LawsonCreationDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  Personnel?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
  SchoolCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  SchoolDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  SchoolType?: InputMaybe<String_Mssql_Comparison_Exp>;
  SubjectCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  SubjectDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Person_Education_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Person_Education_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Person_Education_Bool_Exp>>;
};

/** aggregate max on columns */
export type Mlfsl_Person_Education_Max_Fields = {
  CompletionDate?: Maybe<Scalars['datetime']['output']>;
  DegreeCode?: Maybe<Scalars['String']['output']>;
  DegreeDescription?: Maybe<Scalars['String']['output']>;
  DimPersonnelEducationKey?: Maybe<Scalars['Int']['output']>;
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  GraduationYear?: Maybe<Scalars['String']['output']>;
  Honors?: Maybe<Scalars['String']['output']>;
  InProgress?: Maybe<Scalars['String']['output']>;
  IsDeletedIndicator?: Maybe<Scalars['String']['output']>;
  LawsonCreationDate?: Maybe<Scalars['datetime']['output']>;
  SchoolCode?: Maybe<Scalars['String']['output']>;
  SchoolDescription?: Maybe<Scalars['String']['output']>;
  SchoolType?: Maybe<Scalars['String']['output']>;
  SubjectCode?: Maybe<Scalars['String']['output']>;
  SubjectDescription?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Max_Order_By = {
  CompletionDate?: InputMaybe<Order_By>;
  DegreeCode?: InputMaybe<Order_By>;
  DegreeDescription?: InputMaybe<Order_By>;
  DimPersonnelEducationKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  GraduationYear?: InputMaybe<Order_By>;
  Honors?: InputMaybe<Order_By>;
  InProgress?: InputMaybe<Order_By>;
  IsDeletedIndicator?: InputMaybe<Order_By>;
  LawsonCreationDate?: InputMaybe<Order_By>;
  SchoolCode?: InputMaybe<Order_By>;
  SchoolDescription?: InputMaybe<Order_By>;
  SchoolType?: InputMaybe<Order_By>;
  SubjectCode?: InputMaybe<Order_By>;
  SubjectDescription?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mlfsl_Person_Education_Min_Fields = {
  CompletionDate?: Maybe<Scalars['datetime']['output']>;
  DegreeCode?: Maybe<Scalars['String']['output']>;
  DegreeDescription?: Maybe<Scalars['String']['output']>;
  DimPersonnelEducationKey?: Maybe<Scalars['Int']['output']>;
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  GraduationYear?: Maybe<Scalars['String']['output']>;
  Honors?: Maybe<Scalars['String']['output']>;
  InProgress?: Maybe<Scalars['String']['output']>;
  IsDeletedIndicator?: Maybe<Scalars['String']['output']>;
  LawsonCreationDate?: Maybe<Scalars['datetime']['output']>;
  SchoolCode?: Maybe<Scalars['String']['output']>;
  SchoolDescription?: Maybe<Scalars['String']['output']>;
  SchoolType?: Maybe<Scalars['String']['output']>;
  SubjectCode?: Maybe<Scalars['String']['output']>;
  SubjectDescription?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Min_Order_By = {
  CompletionDate?: InputMaybe<Order_By>;
  DegreeCode?: InputMaybe<Order_By>;
  DegreeDescription?: InputMaybe<Order_By>;
  DimPersonnelEducationKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  GraduationYear?: InputMaybe<Order_By>;
  Honors?: InputMaybe<Order_By>;
  InProgress?: InputMaybe<Order_By>;
  IsDeletedIndicator?: InputMaybe<Order_By>;
  LawsonCreationDate?: InputMaybe<Order_By>;
  SchoolCode?: InputMaybe<Order_By>;
  SchoolDescription?: InputMaybe<Order_By>;
  SchoolType?: InputMaybe<Order_By>;
  SubjectCode?: InputMaybe<Order_By>;
  SubjectDescription?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "repl.DimPersonnelEducation". */
export type Mlfsl_Person_Education_Order_By = {
  CompletionDate?: InputMaybe<Order_By>;
  DegreeCode?: InputMaybe<Order_By>;
  DegreeDescription?: InputMaybe<Order_By>;
  DimPersonnelEducationKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  GraduationYear?: InputMaybe<Order_By>;
  Honors?: InputMaybe<Order_By>;
  InProgress?: InputMaybe<Order_By>;
  IsDeletedIndicator?: InputMaybe<Order_By>;
  LawsonCreationDate?: InputMaybe<Order_By>;
  Personnel?: InputMaybe<Mlfsl_Personnel_Order_By>;
  SchoolCode?: InputMaybe<Order_By>;
  SchoolDescription?: InputMaybe<Order_By>;
  SchoolType?: InputMaybe<Order_By>;
  SubjectCode?: InputMaybe<Order_By>;
  SubjectDescription?: InputMaybe<Order_By>;
};

/** select columns of table "repl.DimPersonnelEducation" */
export enum Mlfsl_Person_Education_Select_Column {
  /** column name */
  CompletionDate = 'CompletionDate',
  /** column name */
  DegreeCode = 'DegreeCode',
  /** column name */
  DegreeDescription = 'DegreeDescription',
  /** column name */
  DimPersonnelEducationKey = 'DimPersonnelEducationKey',
  /** column name */
  ETLBatchKey = 'ETLBatchKey',
  /** column name */
  EmployeeIdOriginal = 'EmployeeIdOriginal',
  /** column name */
  EtlChecksum = 'EtlChecksum',
  /** column name */
  EtlCreatedDate = 'EtlCreatedDate',
  /** column name */
  EtlModifiedDate = 'EtlModifiedDate',
  /** column name */
  GraduationYear = 'GraduationYear',
  /** column name */
  Honors = 'Honors',
  /** column name */
  InProgress = 'InProgress',
  /** column name */
  IsDeletedIndicator = 'IsDeletedIndicator',
  /** column name */
  LawsonCreationDate = 'LawsonCreationDate',
  /** column name */
  SchoolCode = 'SchoolCode',
  /** column name */
  SchoolDescription = 'SchoolDescription',
  /** column name */
  SchoolType = 'SchoolType',
  /** column name */
  SubjectCode = 'SubjectCode',
  /** column name */
  SubjectDescription = 'SubjectDescription',
}

/** aggregate stddev on columns */
export type Mlfsl_Person_Education_Stddev_Fields = {
  DimPersonnelEducationKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Stddev_Order_By = {
  DimPersonnelEducationKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Person_Education_Stddev_Pop_Fields = {
  DimPersonnelEducationKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Stddev_Pop_Order_By = {
  DimPersonnelEducationKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Person_Education_Stddev_Samp_Fields = {
  DimPersonnelEducationKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Stddev_Samp_Order_By = {
  DimPersonnelEducationKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Mlfsl_Person_Education_Sum_Fields = {
  DimPersonnelEducationKey?: Maybe<Scalars['Int']['output']>;
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Sum_Order_By = {
  DimPersonnelEducationKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Person_Education_Var_Pop_Fields = {
  DimPersonnelEducationKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Var_Pop_Order_By = {
  DimPersonnelEducationKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Person_Education_Var_Samp_Fields = {
  DimPersonnelEducationKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Var_Samp_Order_By = {
  DimPersonnelEducationKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mlfsl_Person_Education_Variance_Fields = {
  DimPersonnelEducationKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "repl.DimPersonnelEducation" */
export type Mlfsl_Person_Education_Variance_Order_By = {
  DimPersonnelEducationKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** columns and relationships of "MNET.Personas" */
export type Mlfsl_Persona = {
  CreatedByMarsSystemId: Scalars['String']['output'];
  CreatedBySystemUserName: Scalars['String']['output'];
  CreatedDateUtc: Scalars['datetime']['output'];
  ModifiedByMarsSystemId: Scalars['String']['output'];
  ModifiedDateUtc: Scalars['datetime']['output'];
  Name: Scalars['String']['output'];
  /** An array relationship */
  PersonaGroups: Array<Mlfsl_Persona_Groups>;
  /** An aggregate relationship */
  PersonaGroups_aggregate: Mlfsl_Persona_Groups_Aggregate;
  PersonaId: Scalars['Int']['output'];
};

/** columns and relationships of "MNET.Personas" */
export type Mlfsl_PersonaPersonaGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Persona_Groups_Order_By>>;
  where?: InputMaybe<Mlfsl_Persona_Groups_Bool_Exp>;
};

/** columns and relationships of "MNET.Personas" */
export type Mlfsl_PersonaPersonaGroups_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Persona_Groups_Order_By>>;
  where?: InputMaybe<Mlfsl_Persona_Groups_Bool_Exp>;
};

/** aggregated selection of "MNET.Personas" */
export type Mlfsl_Persona_Aggregate = {
  aggregate?: Maybe<Mlfsl_Persona_Aggregate_Fields>;
  nodes: Array<Mlfsl_Persona>;
};

/** aggregate fields of "MNET.Personas" */
export type Mlfsl_Persona_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Persona_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Persona_Max_Fields>;
  min?: Maybe<Mlfsl_Persona_Min_Fields>;
  stddev?: Maybe<Mlfsl_Persona_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Persona_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Persona_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Persona_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Persona_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Persona_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Persona_Variance_Fields>;
};

/** aggregate fields of "MNET.Personas" */
export type Mlfsl_Persona_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Persona_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mlfsl_Persona_Avg_Fields = {
  PersonaId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "MNET.Personas". All fields are combined with a logical 'AND'. */
export type Mlfsl_Persona_Bool_Exp = {
  CreatedByMarsSystemId?: InputMaybe<String_Mssql_Comparison_Exp>;
  CreatedBySystemUserName?: InputMaybe<String_Mssql_Comparison_Exp>;
  CreatedDateUtc?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  ModifiedByMarsSystemId?: InputMaybe<String_Mssql_Comparison_Exp>;
  ModifiedDateUtc?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  Name?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonaGroups?: InputMaybe<Mlfsl_Persona_Groups_Bool_Exp>;
  PersonaId?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Persona_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Persona_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Persona_Bool_Exp>>;
};

/** columns and relationships of "MNET.PersonaGroup" */
export type Mlfsl_Persona_Groups = {
  CreatedByMarsSystemId: Scalars['String']['output'];
  CreatedBySystemUserName: Scalars['String']['output'];
  CreatedDateUtc: Scalars['datetime']['output'];
  GroupAdSystemName: Scalars['String']['output'];
  IsActive?: Maybe<Scalars['Boolean']['output']>;
  ModifiedByMarsSystemId: Scalars['String']['output'];
  ModifiedDateUtc: Scalars['datetime']['output'];
  /** An object relationship */
  Persona: Mlfsl_Persona;
  PersonaId: Scalars['Int']['output'];
};

/** aggregated selection of "MNET.PersonaGroup" */
export type Mlfsl_Persona_Groups_Aggregate = {
  aggregate?: Maybe<Mlfsl_Persona_Groups_Aggregate_Fields>;
  nodes: Array<Mlfsl_Persona_Groups>;
};

/** aggregate fields of "MNET.PersonaGroup" */
export type Mlfsl_Persona_Groups_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Persona_Groups_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Persona_Groups_Max_Fields>;
  min?: Maybe<Mlfsl_Persona_Groups_Min_Fields>;
  stddev?: Maybe<Mlfsl_Persona_Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Persona_Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Persona_Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Persona_Groups_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Persona_Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Persona_Groups_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Persona_Groups_Variance_Fields>;
};

/** aggregate fields of "MNET.PersonaGroup" */
export type Mlfsl_Persona_Groups_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Persona_Groups_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "MNET.PersonaGroup" */
export type Mlfsl_Persona_Groups_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Persona_Groups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Persona_Groups_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Persona_Groups_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Persona_Groups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Persona_Groups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Persona_Groups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Persona_Groups_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Persona_Groups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Persona_Groups_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Persona_Groups_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Mlfsl_Persona_Groups_Avg_Fields = {
  PersonaId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "MNET.PersonaGroup" */
export type Mlfsl_Persona_Groups_Avg_Order_By = {
  PersonaId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "MNET.PersonaGroup". All fields are combined with a logical 'AND'. */
export type Mlfsl_Persona_Groups_Bool_Exp = {
  CreatedByMarsSystemId?: InputMaybe<String_Mssql_Comparison_Exp>;
  CreatedBySystemUserName?: InputMaybe<String_Mssql_Comparison_Exp>;
  CreatedDateUtc?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  GroupAdSystemName?: InputMaybe<String_Mssql_Comparison_Exp>;
  IsActive?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  ModifiedByMarsSystemId?: InputMaybe<String_Mssql_Comparison_Exp>;
  ModifiedDateUtc?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  Persona?: InputMaybe<Mlfsl_Persona_Bool_Exp>;
  PersonaId?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Persona_Groups_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Persona_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Persona_Groups_Bool_Exp>>;
};

/** aggregate max on columns */
export type Mlfsl_Persona_Groups_Max_Fields = {
  CreatedByMarsSystemId?: Maybe<Scalars['String']['output']>;
  CreatedBySystemUserName?: Maybe<Scalars['String']['output']>;
  CreatedDateUtc?: Maybe<Scalars['datetime']['output']>;
  GroupAdSystemName?: Maybe<Scalars['String']['output']>;
  ModifiedByMarsSystemId?: Maybe<Scalars['String']['output']>;
  ModifiedDateUtc?: Maybe<Scalars['datetime']['output']>;
  PersonaId?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "MNET.PersonaGroup" */
export type Mlfsl_Persona_Groups_Max_Order_By = {
  CreatedByMarsSystemId?: InputMaybe<Order_By>;
  CreatedBySystemUserName?: InputMaybe<Order_By>;
  CreatedDateUtc?: InputMaybe<Order_By>;
  GroupAdSystemName?: InputMaybe<Order_By>;
  ModifiedByMarsSystemId?: InputMaybe<Order_By>;
  ModifiedDateUtc?: InputMaybe<Order_By>;
  PersonaId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mlfsl_Persona_Groups_Min_Fields = {
  CreatedByMarsSystemId?: Maybe<Scalars['String']['output']>;
  CreatedBySystemUserName?: Maybe<Scalars['String']['output']>;
  CreatedDateUtc?: Maybe<Scalars['datetime']['output']>;
  GroupAdSystemName?: Maybe<Scalars['String']['output']>;
  ModifiedByMarsSystemId?: Maybe<Scalars['String']['output']>;
  ModifiedDateUtc?: Maybe<Scalars['datetime']['output']>;
  PersonaId?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "MNET.PersonaGroup" */
export type Mlfsl_Persona_Groups_Min_Order_By = {
  CreatedByMarsSystemId?: InputMaybe<Order_By>;
  CreatedBySystemUserName?: InputMaybe<Order_By>;
  CreatedDateUtc?: InputMaybe<Order_By>;
  GroupAdSystemName?: InputMaybe<Order_By>;
  ModifiedByMarsSystemId?: InputMaybe<Order_By>;
  ModifiedDateUtc?: InputMaybe<Order_By>;
  PersonaId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "MNET.PersonaGroup". */
export type Mlfsl_Persona_Groups_Order_By = {
  CreatedByMarsSystemId?: InputMaybe<Order_By>;
  CreatedBySystemUserName?: InputMaybe<Order_By>;
  CreatedDateUtc?: InputMaybe<Order_By>;
  GroupAdSystemName?: InputMaybe<Order_By>;
  IsActive?: InputMaybe<Order_By>;
  ModifiedByMarsSystemId?: InputMaybe<Order_By>;
  ModifiedDateUtc?: InputMaybe<Order_By>;
  Persona?: InputMaybe<Mlfsl_Persona_Order_By>;
  PersonaId?: InputMaybe<Order_By>;
};

/** select columns of table "MNET.PersonaGroup" */
export enum Mlfsl_Persona_Groups_Select_Column {
  /** column name */
  CreatedByMarsSystemId = 'CreatedByMarsSystemId',
  /** column name */
  CreatedBySystemUserName = 'CreatedBySystemUserName',
  /** column name */
  CreatedDateUtc = 'CreatedDateUtc',
  /** column name */
  GroupAdSystemName = 'GroupAdSystemName',
  /** column name */
  IsActive = 'IsActive',
  /** column name */
  ModifiedByMarsSystemId = 'ModifiedByMarsSystemId',
  /** column name */
  ModifiedDateUtc = 'ModifiedDateUtc',
  /** column name */
  PersonaId = 'PersonaId',
}

/** aggregate stddev on columns */
export type Mlfsl_Persona_Groups_Stddev_Fields = {
  PersonaId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "MNET.PersonaGroup" */
export type Mlfsl_Persona_Groups_Stddev_Order_By = {
  PersonaId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Persona_Groups_Stddev_Pop_Fields = {
  PersonaId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "MNET.PersonaGroup" */
export type Mlfsl_Persona_Groups_Stddev_Pop_Order_By = {
  PersonaId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Persona_Groups_Stddev_Samp_Fields = {
  PersonaId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "MNET.PersonaGroup" */
export type Mlfsl_Persona_Groups_Stddev_Samp_Order_By = {
  PersonaId?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Mlfsl_Persona_Groups_Sum_Fields = {
  PersonaId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "MNET.PersonaGroup" */
export type Mlfsl_Persona_Groups_Sum_Order_By = {
  PersonaId?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Persona_Groups_Var_Pop_Fields = {
  PersonaId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "MNET.PersonaGroup" */
export type Mlfsl_Persona_Groups_Var_Pop_Order_By = {
  PersonaId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Persona_Groups_Var_Samp_Fields = {
  PersonaId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "MNET.PersonaGroup" */
export type Mlfsl_Persona_Groups_Var_Samp_Order_By = {
  PersonaId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mlfsl_Persona_Groups_Variance_Fields = {
  PersonaId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "MNET.PersonaGroup" */
export type Mlfsl_Persona_Groups_Variance_Order_By = {
  PersonaId?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Mlfsl_Persona_Max_Fields = {
  CreatedByMarsSystemId?: Maybe<Scalars['String']['output']>;
  CreatedBySystemUserName?: Maybe<Scalars['String']['output']>;
  CreatedDateUtc?: Maybe<Scalars['datetime']['output']>;
  ModifiedByMarsSystemId?: Maybe<Scalars['String']['output']>;
  ModifiedDateUtc?: Maybe<Scalars['datetime']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  PersonaId?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Mlfsl_Persona_Min_Fields = {
  CreatedByMarsSystemId?: Maybe<Scalars['String']['output']>;
  CreatedBySystemUserName?: Maybe<Scalars['String']['output']>;
  CreatedDateUtc?: Maybe<Scalars['datetime']['output']>;
  ModifiedByMarsSystemId?: Maybe<Scalars['String']['output']>;
  ModifiedDateUtc?: Maybe<Scalars['datetime']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  PersonaId?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "MNET.Personas". */
export type Mlfsl_Persona_Order_By = {
  CreatedByMarsSystemId?: InputMaybe<Order_By>;
  CreatedBySystemUserName?: InputMaybe<Order_By>;
  CreatedDateUtc?: InputMaybe<Order_By>;
  ModifiedByMarsSystemId?: InputMaybe<Order_By>;
  ModifiedDateUtc?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  PersonaGroups_aggregate?: InputMaybe<Mlfsl_Persona_Groups_Aggregate_Order_By>;
  PersonaId?: InputMaybe<Order_By>;
};

/** select columns of table "MNET.Personas" */
export enum Mlfsl_Persona_Select_Column {
  /** column name */
  CreatedByMarsSystemId = 'CreatedByMarsSystemId',
  /** column name */
  CreatedBySystemUserName = 'CreatedBySystemUserName',
  /** column name */
  CreatedDateUtc = 'CreatedDateUtc',
  /** column name */
  ModifiedByMarsSystemId = 'ModifiedByMarsSystemId',
  /** column name */
  ModifiedDateUtc = 'ModifiedDateUtc',
  /** column name */
  Name = 'Name',
  /** column name */
  PersonaId = 'PersonaId',
}

/** aggregate stddev on columns */
export type Mlfsl_Persona_Stddev_Fields = {
  PersonaId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Persona_Stddev_Pop_Fields = {
  PersonaId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Persona_Stddev_Samp_Fields = {
  PersonaId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Mlfsl_Persona_Sum_Fields = {
  PersonaId?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Persona_Var_Pop_Fields = {
  PersonaId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Persona_Var_Samp_Fields = {
  PersonaId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mlfsl_Persona_Variance_Fields = {
  PersonaId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "repl.DimPersonnelNow" */
export type Mlfsl_Personnel = {
  ActiveDirectoryBusinessCategory?: Maybe<Scalars['String']['output']>;
  ActiveDirectoryDisabledIndicator?: Maybe<Scalars['String']['output']>;
  ActiveDirectoryDistinguishedName?: Maybe<Scalars['String']['output']>;
  ActiveDirectoryEmail?: Maybe<Scalars['String']['output']>;
  ActiveDirectoryHomeDirectory?: Maybe<Scalars['String']['output']>;
  ActiveDirectoryLogin?: Maybe<Scalars['String']['output']>;
  ActiveDirectoryMailboxIndicator?: Maybe<Scalars['String']['output']>;
  ActiveDirectorySEVDepartedIndicator?: Maybe<Scalars['String']['output']>;
  BYODIndicator?: Maybe<Scalars['String']['output']>;
  BarAdmissionFirst?: Maybe<Scalars['String']['output']>;
  BardateFirst?: Maybe<Scalars['datetime']['output']>;
  BillingCoordinatorEmployeeId?: Maybe<Scalars['String']['output']>;
  BlackberryPin?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeAddress1?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeAddress2?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeAddress3?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeCity?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeCode?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeCountryCode?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeState?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeZip?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOffice?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeAddress1?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeAddress2?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeAddress3?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeAddress4?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeCity?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeCode?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeCodeNumber?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeCodeNumberWithExtension?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeCountryCode?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeMailBoxNumber?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeMailGroup?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeMailGroupCode?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficePhoneCountry?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficePhoneExtension?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficePhoneNumber?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficePhoneNumberFull?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficePhoneinternalOfficeNumber?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficePhoneinternalOfficeNumberFull?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeState?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeZip?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOffice?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficeCode?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficeCodeNumber?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficeCodeNumberWithExtension?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficePhoneCountry?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficePhoneExtension?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficePhoneNumber?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficePhoneNumberFull?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficePhoneinternalOfficeNumber?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficePhoneinternalOfficeNumberFull?: Maybe<Scalars['String']['output']>;
  CellPhoneCountry?: Maybe<Scalars['String']['output']>;
  CellPhoneNumber?: Maybe<Scalars['String']['output']>;
  CellPhoneNumberFull?: Maybe<Scalars['String']['output']>;
  DataCenterRegion?: Maybe<Scalars['String']['output']>;
  DataSource?: Maybe<Scalars['String']['output']>;
  DateAccessRemoveKey?: Maybe<Scalars['Int']['output']>;
  DateAssociationKey: Scalars['Int']['output'];
  DateBirthKey: Scalars['Int']['output'];
  DateCounselKey: Scalars['Int']['output'];
  /** An object relationship */
  DateHire?: Maybe<Mlfsl_Date>;
  /** An object relationship */
  DateHireAdjusted?: Maybe<Mlfsl_Date>;
  DateHireAdjustedKey?: Maybe<Scalars['Int']['output']>;
  DateHireKey: Scalars['Int']['output'];
  DateOfCounselKey: Scalars['Int']['output'];
  DatePartnershipKey: Scalars['Int']['output'];
  DateRehireExpirationKey: Scalars['Int']['output'];
  DateRehireKey: Scalars['Int']['output'];
  DateRemoteWorkingProgramKey?: Maybe<Scalars['Int']['output']>;
  DateSeniorCounselKey: Scalars['Int']['output'];
  DateSpecialCounselKey: Scalars['Int']['output'];
  /** An object relationship */
  DateTerm?: Maybe<Mlfsl_Date>;
  DateTermKey: Scalars['Int']['output'];
  DateinternationalPartnerKey: Scalars['Int']['output'];
  DeletedRecordIndicator?: Maybe<Scalars['String']['output']>;
  DesignatedEssentialWorkerIndicator?: Maybe<Scalars['String']['output']>;
  DesignatedEssentialWorkerRequiredFormsCompleteIndicator?: Maybe<Scalars['String']['output']>;
  DesignatedEssentialWorkerRequiredVideoCompleteIndicator?: Maybe<Scalars['String']['output']>;
  DimPersonnelNowKey: Scalars['Int']['output'];
  DiscoveryFlag?: Maybe<Scalars['Int']['output']>;
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  ETLSoftInsertIndicator?: Maybe<Scalars['String']['output']>;
  ElitePracticeArea?: Maybe<Scalars['String']['output']>;
  ElitePracticeAreaDelimited?: Maybe<Scalars['String']['output']>;
  EliteStatus?: Maybe<Scalars['String']['output']>;
  EliteSubSubPracticeGroup?: Maybe<Scalars['String']['output']>;
  EliteTimekeepLocation?: Maybe<Scalars['String']['output']>;
  EliteTitle?: Maybe<Scalars['String']['output']>;
  EliteTitleSortOrder?: Maybe<Scalars['Int']['output']>;
  EliteWorkLocation?: Maybe<Scalars['String']['output']>;
  ElitedateHireKey?: Maybe<Scalars['Int']['output']>;
  ElitedateTermKey?: Maybe<Scalars['Int']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  EmailSignatureCaveatText?: Maybe<Scalars['String']['output']>;
  EmergencyContact1FirstName?: Maybe<Scalars['String']['output']>;
  EmergencyContact1HomePhoneCountry?: Maybe<Scalars['String']['output']>;
  EmergencyContact1HomePhoneFull?: Maybe<Scalars['String']['output']>;
  EmergencyContact1HomePhoneNumber?: Maybe<Scalars['String']['output']>;
  EmergencyContact1LastName?: Maybe<Scalars['String']['output']>;
  EmergencyContact1MiddleName?: Maybe<Scalars['String']['output']>;
  EmergencyContact1NameDisplay?: Maybe<Scalars['String']['output']>;
  EmergencyContact1NameFull?: Maybe<Scalars['String']['output']>;
  EmergencyContact1WorkPhoneCountry?: Maybe<Scalars['String']['output']>;
  EmergencyContact1WorkPhoneExtension?: Maybe<Scalars['String']['output']>;
  EmergencyContact1WorkPhoneFull?: Maybe<Scalars['String']['output']>;
  EmergencyContact1WorkPhoneNumber?: Maybe<Scalars['String']['output']>;
  EmergencyContact2FirstName?: Maybe<Scalars['String']['output']>;
  EmergencyContact2HomePhoneCountry?: Maybe<Scalars['String']['output']>;
  EmergencyContact2HomePhoneFull?: Maybe<Scalars['String']['output']>;
  EmergencyContact2HomePhoneNumber?: Maybe<Scalars['String']['output']>;
  EmergencyContact2LastName?: Maybe<Scalars['String']['output']>;
  EmergencyContact2MiddleName?: Maybe<Scalars['String']['output']>;
  EmergencyContact2NameDisplay?: Maybe<Scalars['String']['output']>;
  EmergencyContact2NameFull?: Maybe<Scalars['String']['output']>;
  EmergencyContact2WorkPhoneCountry?: Maybe<Scalars['String']['output']>;
  EmergencyContact2WorkPhoneExtension?: Maybe<Scalars['String']['output']>;
  EmergencyContact2WorkPhoneFull?: Maybe<Scalars['String']['output']>;
  EmergencyContact2WorkPhoneNumber?: Maybe<Scalars['String']['output']>;
  EmployeeCategoryCode?: Maybe<Scalars['String']['output']>;
  EmployeeCategoryDescription?: Maybe<Scalars['String']['output']>;
  EmployeeId: Scalars['String']['output'];
  EmployeeIdOriginal: Scalars['Int']['output'];
  EmployeeTypeFlag?: Maybe<Scalars['String']['output']>;
  EtlChecksum: Scalars['Int']['output'];
  EtlCreateddate: Scalars['datetime']['output'];
  EtlModifieddate: Scalars['datetime']['output'];
  FullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  Gender?: Maybe<Scalars['String']['output']>;
  GenderDescription?: Maybe<Scalars['String']['output']>;
  GradClassYear?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  GroupJoins: Array<Mlfsl_Ad_Join>;
  /** An aggregate relationship */
  GroupJoins_aggregate: Mlfsl_Ad_Join_Aggregate;
  IsActiveIndicator?: Maybe<Scalars['Int']['output']>;
  IsBilledByAIC?: Maybe<Scalars['String']['output']>;
  IsDMSDenyAccess?: Maybe<Scalars['String']['output']>;
  IsExemptIndicator?: Maybe<Scalars['String']['output']>;
  IsHRCellPhoneUnlistedIndicator?: Maybe<Scalars['String']['output']>;
  IsHREducationYearUnlistedIndicator?: Maybe<Scalars['String']['output']>;
  IsHRHomeAddressUnlistedIndicator?: Maybe<Scalars['String']['output']>;
  IsHRHomePhoneUnlistedIndicator?: Maybe<Scalars['String']['output']>;
  IsHRSpouseUnlistedIndicator?: Maybe<Scalars['String']['output']>;
  IsHrDefinedAttorneyIndicator?: Maybe<Scalars['String']['output']>;
  IsHrUnlistedIndicator?: Maybe<Scalars['String']['output']>;
  IsLateralAttorney?: Maybe<Scalars['String']['output']>;
  IsLegalProfessionalIndicator?: Maybe<Scalars['String']['output']>;
  JobCode?: Maybe<Scalars['String']['output']>;
  JobFamily?: Maybe<Scalars['String']['output']>;
  JobFamilyGroup?: Maybe<Scalars['String']['output']>;
  LawsonCompany?: Maybe<Scalars['Int']['output']>;
  LawsonFullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  LawsonSecondarySubSubPracticeGroup?: Maybe<Scalars['String']['output']>;
  LawsonSubSubPracticeGroup?: Maybe<Scalars['String']['output']>;
  LawsondateHireAdjustedKey?: Maybe<Scalars['Int']['output']>;
  LawsondateHireKey?: Maybe<Scalars['Int']['output']>;
  LawsondateTermKey?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  Login?: Maybe<Mlfsl_Ad_Login>;
  MLBClassYear?: Maybe<Scalars['String']['output']>;
  MSGraphUserInfo?: Maybe<User>;
  Manager1EmployeeId?: Maybe<Scalars['String']['output']>;
  Manager1EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Manager2EmployeeId?: Maybe<Scalars['String']['output']>;
  Manager2EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Manager3EmployeeId?: Maybe<Scalars['String']['output']>;
  Manager3EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Manager4EmployeeId?: Maybe<Scalars['String']['output']>;
  Manager4EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Manager5EmployeeId?: Maybe<Scalars['String']['output']>;
  Manager5EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Manager6EmployeeId?: Maybe<Scalars['String']['output']>;
  Manager6EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  MarsPersonID?: Maybe<Scalars['Int']['output']>;
  MarsSubSubPracticeGroup?: Maybe<Scalars['String']['output']>;
  MarsTitle?: Maybe<Scalars['String']['output']>;
  MarsWorkLocation?: Maybe<Scalars['String']['output']>;
  MorganNetDisplayIndicator?: Maybe<Scalars['Int']['output']>;
  NameDisplay?: Maybe<Scalars['String']['output']>;
  NameFirst?: Maybe<Scalars['String']['output']>;
  NameFirstBilling?: Maybe<Scalars['String']['output']>;
  NameFull?: Maybe<Scalars['String']['output']>;
  NameInitialsElite?: Maybe<Scalars['String']['output']>;
  NameLast?: Maybe<Scalars['String']['output']>;
  NameLastBilling?: Maybe<Scalars['String']['output']>;
  NameLastNoSuffix?: Maybe<Scalars['String']['output']>;
  NameMaidenFirst?: Maybe<Scalars['String']['output']>;
  NameMaidenLast?: Maybe<Scalars['String']['output']>;
  NameMaidenMiddleInitial?: Maybe<Scalars['String']['output']>;
  NameMiddle?: Maybe<Scalars['String']['output']>;
  NameMiddleInitial?: Maybe<Scalars['String']['output']>;
  NameNick?: Maybe<Scalars['String']['output']>;
  NameNickIa?: Maybe<Scalars['String']['output']>;
  NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  NamePreferredDisplay_?: Maybe<Scalars['String']['output']>;
  NamePreferredFirst?: Maybe<Scalars['String']['output']>;
  NamePreferredFull?: Maybe<Scalars['String']['output']>;
  NamePreferredLast?: Maybe<Scalars['String']['output']>;
  NamePreferredMiddle?: Maybe<Scalars['String']['output']>;
  NameSuffix?: Maybe<Scalars['String']['output']>;
  NameTDDisplay?: Maybe<Scalars['String']['output']>;
  NonFirmOfficeTaxJurisdictionResident?: Maybe<Scalars['String']['output']>;
  NonPhiladelphiaResident?: Maybe<Scalars['String']['output']>;
  ParalegalTier?: Maybe<Scalars['String']['output']>;
  PartnerTypeKey?: Maybe<Scalars['Int']['output']>;
  PayrollBatchId?: Maybe<Scalars['String']['output']>;
  PayrollFileNumber?: Maybe<Scalars['String']['output']>;
  PayrollPayGroup?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  PersonEducation: Array<Mlfsl_Person_Education>;
  /** An aggregate relationship */
  PersonEducation_aggregate: Mlfsl_Person_Education_Aggregate;
  PersonalAddressFour?: Maybe<Scalars['String']['output']>;
  PersonalAddressOne?: Maybe<Scalars['String']['output']>;
  PersonalAddressThree?: Maybe<Scalars['String']['output']>;
  PersonalAddressTwo?: Maybe<Scalars['String']['output']>;
  PersonalCity?: Maybe<Scalars['String']['output']>;
  PersonalCountry?: Maybe<Scalars['String']['output']>;
  PersonalEmailAddress?: Maybe<Scalars['String']['output']>;
  PersonalMatter?: Maybe<Scalars['String']['output']>;
  PersonalPhoneCountry?: Maybe<Scalars['String']['output']>;
  PersonalPhoneNumber?: Maybe<Scalars['String']['output']>;
  PersonalPhoneNumberFull?: Maybe<Scalars['String']['output']>;
  PersonalPronouns?: Maybe<Scalars['String']['output']>;
  PersonalSecondPhoneCountry?: Maybe<Scalars['String']['output']>;
  PersonalSecondPhoneNumber?: Maybe<Scalars['String']['output']>;
  PersonalSecondPhoneNumberFull?: Maybe<Scalars['String']['output']>;
  PersonalState?: Maybe<Scalars['String']['output']>;
  PersonalZip?: Maybe<Scalars['String']['output']>;
  PersonnelSourceAbbreviation?: Maybe<Scalars['String']['output']>;
  PersonnelSourceName?: Maybe<Scalars['String']['output']>;
  PersonnelSourceNumber?: Maybe<Scalars['String']['output']>;
  PictureURL?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  PrimaryAssistant?: Maybe<Mlfsl_Personnel>;
  /** An object relationship */
  PrimaryOffice?: Maybe<Mlfsl_Office>;
  /** An object relationship */
  PrimaryPracticeGroup?: Maybe<Mlfsl_Practicegroup>;
  RateBilling?: Maybe<Scalars['Float']['output']>;
  RateGrid?: Maybe<Scalars['Float']['output']>;
  RateStandard?: Maybe<Scalars['Float']['output']>;
  RehireIndicator?: Maybe<Scalars['String']['output']>;
  RemoteWorkingProgramIndicator?: Maybe<Scalars['String']['output']>;
  RequiredTime?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  SecondaryAssistant?: Maybe<Mlfsl_Personnel>;
  /** An object relationship */
  SecondaryOffice?: Maybe<Mlfsl_Office>;
  /** An object relationship */
  SecondaryPracticeGroup?: Maybe<Mlfsl_Practicegroup>;
  Secretary1EmployeeId?: Maybe<Scalars['String']['output']>;
  Secretary1EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Secretary1FirstName?: Maybe<Scalars['String']['output']>;
  Secretary1LastName?: Maybe<Scalars['String']['output']>;
  Secretary1MiddleName?: Maybe<Scalars['String']['output']>;
  Secretary1NameDisplay?: Maybe<Scalars['String']['output']>;
  Secretary1NameFull?: Maybe<Scalars['String']['output']>;
  Secretary1NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  Secretary1NamePreferredFull?: Maybe<Scalars['String']['output']>;
  Secretary1PhoneExtension?: Maybe<Scalars['String']['output']>;
  Secretary2EmployeeId?: Maybe<Scalars['String']['output']>;
  Secretary2EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Secretary2FirstName?: Maybe<Scalars['String']['output']>;
  Secretary2LastName?: Maybe<Scalars['String']['output']>;
  Secretary2MiddleName?: Maybe<Scalars['String']['output']>;
  Secretary2NameDisplay?: Maybe<Scalars['String']['output']>;
  Secretary2NameFull?: Maybe<Scalars['String']['output']>;
  Secretary2NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  Secretary2NamePreferredFull?: Maybe<Scalars['String']['output']>;
  Secretary2PhoneExtension?: Maybe<Scalars['String']['output']>;
  SpouseFirstName?: Maybe<Scalars['String']['output']>;
  SpouseLastName?: Maybe<Scalars['String']['output']>;
  SpouseMiddleInit?: Maybe<Scalars['String']['output']>;
  SpouseNameDisplay?: Maybe<Scalars['String']['output']>;
  SpouseNameFull?: Maybe<Scalars['String']['output']>;
  StatusActiveEmployeeIndicator?: Maybe<Scalars['Int']['output']>;
  StatusCode?: Maybe<Scalars['String']['output']>;
  StatusDescription?: Maybe<Scalars['String']['output']>;
  StatusDescription2?: Maybe<Scalars['String']['output']>;
  StatusLabel?: Maybe<Scalars['String']['output']>;
  TimeKeeperCostEntryFlag?: Maybe<Scalars['String']['output']>;
  TimeKeeperTimeEntryFlag?: Maybe<Scalars['String']['output']>;
  TimeReporter?: Maybe<Scalars['String']['output']>;
  TimekeeperGUID?: Maybe<Scalars['uniqueidentifier']['output']>;
  TimekeeperIndex?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  TitleDisplay?: Maybe<Scalars['String']['output']>;
  TitleFullyQualified?: Maybe<Scalars['String']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Int']['output']>;
  dateClerkship?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  mlfsl_personnel_bar: Array<Mlfsl_Personnel_Bar>;
  /** An array relationship */
  mlfsl_personnel_clerkship: Array<Mlfsl_Personnel_Clerkship>;
  /** An array relationship */
  mlfsl_personnel_committee: Array<Mlfsl_Personnel_Committee>;
  /** An array relationship */
  mlfsl_personnel_court: Array<Mlfsl_Personnel_Court>;
  /** An array relationship */
  mlfsl_personnel_language: Array<Mlfsl_Personnel_Language>;
  mnet_user_link?: Maybe<Mnet_User_Link>;
  person_business_chemistry_profile?: Maybe<Mnet_Person_Business_Chemistry_Profile>;
  probono_goals: Array<Mlfsl_Probono_Goal>;
};

/** columns and relationships of "repl.DimPersonnelNow" */
export type Mlfsl_PersonnelGroupJoinsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Ad_Join_Order_By>>;
  where?: InputMaybe<Mlfsl_Ad_Join_Bool_Exp>;
};

/** columns and relationships of "repl.DimPersonnelNow" */
export type Mlfsl_PersonnelGroupJoins_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Ad_Join_Order_By>>;
  where?: InputMaybe<Mlfsl_Ad_Join_Bool_Exp>;
};

/** columns and relationships of "repl.DimPersonnelNow" */
export type Mlfsl_PersonnelPersonEducationArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Person_Education_Order_By>>;
  where?: InputMaybe<Mlfsl_Person_Education_Bool_Exp>;
};

/** columns and relationships of "repl.DimPersonnelNow" */
export type Mlfsl_PersonnelPersonEducation_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Person_Education_Order_By>>;
  where?: InputMaybe<Mlfsl_Person_Education_Bool_Exp>;
};

/** columns and relationships of "repl.DimPersonnelNow" */
export type Mlfsl_PersonnelMlfsl_Personnel_BarArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Bar_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Bar_Bool_Exp>;
};

/** columns and relationships of "repl.DimPersonnelNow" */
export type Mlfsl_PersonnelMlfsl_Personnel_ClerkshipArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Clerkship_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Clerkship_Bool_Exp>;
};

/** columns and relationships of "repl.DimPersonnelNow" */
export type Mlfsl_PersonnelMlfsl_Personnel_CommitteeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Committee_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Committee_Bool_Exp>;
};

/** columns and relationships of "repl.DimPersonnelNow" */
export type Mlfsl_PersonnelMlfsl_Personnel_CourtArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Court_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Court_Bool_Exp>;
};

/** columns and relationships of "repl.DimPersonnelNow" */
export type Mlfsl_PersonnelMlfsl_Personnel_LanguageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Language_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Language_Bool_Exp>;
};

/** columns and relationships of "repl.DimPersonnelNow" */
export type Mlfsl_PersonnelProbono_GoalsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Probono_Goal_Order_By>>;
  where?: InputMaybe<Mlfsl_Probono_Goal_Bool_Exp>;
};

/** aggregated selection of "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Aggregate = {
  aggregate?: Maybe<Mlfsl_Personnel_Aggregate_Fields>;
  nodes: Array<Mlfsl_Personnel>;
};

/** aggregate fields of "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Personnel_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Personnel_Max_Fields>;
  min?: Maybe<Mlfsl_Personnel_Min_Fields>;
  stddev?: Maybe<Mlfsl_Personnel_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Personnel_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Personnel_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Personnel_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Personnel_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Personnel_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Personnel_Variance_Fields>;
};

/** aggregate fields of "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Personnel_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Personnel_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Personnel_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Personnel_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Personnel_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Personnel_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Personnel_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Personnel_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Personnel_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Personnel_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Personnel_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Mlfsl_Personnel_Avg_Fields = {
  DateAccessRemoveKey?: Maybe<Scalars['Float']['output']>;
  DateAssociationKey?: Maybe<Scalars['Float']['output']>;
  DateBirthKey?: Maybe<Scalars['Float']['output']>;
  DateCounselKey?: Maybe<Scalars['Float']['output']>;
  DateHireAdjustedKey?: Maybe<Scalars['Float']['output']>;
  DateHireKey?: Maybe<Scalars['Float']['output']>;
  DateOfCounselKey?: Maybe<Scalars['Float']['output']>;
  DatePartnershipKey?: Maybe<Scalars['Float']['output']>;
  DateRehireExpirationKey?: Maybe<Scalars['Float']['output']>;
  DateRehireKey?: Maybe<Scalars['Float']['output']>;
  DateRemoteWorkingProgramKey?: Maybe<Scalars['Float']['output']>;
  DateSeniorCounselKey?: Maybe<Scalars['Float']['output']>;
  DateSpecialCounselKey?: Maybe<Scalars['Float']['output']>;
  DateTermKey?: Maybe<Scalars['Float']['output']>;
  DateinternationalPartnerKey?: Maybe<Scalars['Float']['output']>;
  DimPersonnelNowKey?: Maybe<Scalars['Float']['output']>;
  DiscoveryFlag?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EliteTitleSortOrder?: Maybe<Scalars['Float']['output']>;
  ElitedateHireKey?: Maybe<Scalars['Float']['output']>;
  ElitedateTermKey?: Maybe<Scalars['Float']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  FullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  IsActiveIndicator?: Maybe<Scalars['Float']['output']>;
  LawsonCompany?: Maybe<Scalars['Float']['output']>;
  LawsonFullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  LawsondateHireAdjustedKey?: Maybe<Scalars['Float']['output']>;
  LawsondateHireKey?: Maybe<Scalars['Float']['output']>;
  LawsondateTermKey?: Maybe<Scalars['Float']['output']>;
  Manager1EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager2EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager3EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager4EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager5EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager6EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  MarsPersonID?: Maybe<Scalars['Float']['output']>;
  MorganNetDisplayIndicator?: Maybe<Scalars['Float']['output']>;
  PartnerTypeKey?: Maybe<Scalars['Float']['output']>;
  RateBilling?: Maybe<Scalars['Float']['output']>;
  RateGrid?: Maybe<Scalars['Float']['output']>;
  RateStandard?: Maybe<Scalars['Float']['output']>;
  Secretary1EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Secretary2EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  StatusActiveEmployeeIndicator?: Maybe<Scalars['Float']['output']>;
  TimekeeperIndex?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Avg_Order_By = {
  DateAccessRemoveKey?: InputMaybe<Order_By>;
  DateAssociationKey?: InputMaybe<Order_By>;
  DateBirthKey?: InputMaybe<Order_By>;
  DateCounselKey?: InputMaybe<Order_By>;
  DateHireAdjustedKey?: InputMaybe<Order_By>;
  DateHireKey?: InputMaybe<Order_By>;
  DateOfCounselKey?: InputMaybe<Order_By>;
  DatePartnershipKey?: InputMaybe<Order_By>;
  DateRehireExpirationKey?: InputMaybe<Order_By>;
  DateRehireKey?: InputMaybe<Order_By>;
  DateRemoteWorkingProgramKey?: InputMaybe<Order_By>;
  DateSeniorCounselKey?: InputMaybe<Order_By>;
  DateSpecialCounselKey?: InputMaybe<Order_By>;
  DateTermKey?: InputMaybe<Order_By>;
  DateinternationalPartnerKey?: InputMaybe<Order_By>;
  DimPersonnelNowKey?: InputMaybe<Order_By>;
  DiscoveryFlag?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EliteTitleSortOrder?: InputMaybe<Order_By>;
  ElitedateHireKey?: InputMaybe<Order_By>;
  ElitedateTermKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  FullTimeEquivalency?: InputMaybe<Order_By>;
  IsActiveIndicator?: InputMaybe<Order_By>;
  LawsonCompany?: InputMaybe<Order_By>;
  LawsonFullTimeEquivalency?: InputMaybe<Order_By>;
  LawsondateHireAdjustedKey?: InputMaybe<Order_By>;
  LawsondateHireKey?: InputMaybe<Order_By>;
  LawsondateTermKey?: InputMaybe<Order_By>;
  Manager1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager2EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager3EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager4EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager5EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager6EmployeeIdOriginal?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
  MorganNetDisplayIndicator?: InputMaybe<Order_By>;
  PartnerTypeKey?: InputMaybe<Order_By>;
  RateBilling?: InputMaybe<Order_By>;
  RateGrid?: InputMaybe<Order_By>;
  RateStandard?: InputMaybe<Order_By>;
  Secretary1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Secretary2EmployeeIdOriginal?: InputMaybe<Order_By>;
  StatusActiveEmployeeIndicator?: InputMaybe<Order_By>;
  TimekeeperIndex?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
};

/** columns and relationships of "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar = {
  Bar?: Maybe<Scalars['String']['output']>;
  BarId?: Maybe<Scalars['String']['output']>;
  BarYear?: Maybe<Scalars['String']['output']>;
  DimPersonnelBarKey: Scalars['Int']['output'];
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  EtlChecksum: Scalars['Int']['output'];
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  IsDeletedIndicator: Scalars['String']['output'];
  /** An object relationship */
  mlfsl_personnel?: Maybe<Mlfsl_Personnel>;
};

/** order by aggregate values of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Personnel_Bar_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Personnel_Bar_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Personnel_Bar_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Personnel_Bar_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Personnel_Bar_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Personnel_Bar_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Personnel_Bar_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Personnel_Bar_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Personnel_Bar_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Personnel_Bar_Variance_Order_By>;
};

/** order by avg() on columns of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Avg_Order_By = {
  DimPersonnelBarKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "repl.DimPersonnelBar". All fields are combined with a logical 'AND'. */
export type Mlfsl_Personnel_Bar_Bool_Exp = {
  Bar?: InputMaybe<String_Mssql_Comparison_Exp>;
  BarId?: InputMaybe<String_Mssql_Comparison_Exp>;
  BarYear?: InputMaybe<String_Mssql_Comparison_Exp>;
  DimPersonnelBarKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLBatchKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EmployeeIdOriginal?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EtlChecksum?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EtlCreatedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  EtlModifiedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  IsDeletedIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Personnel_Bar_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Personnel_Bar_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Personnel_Bar_Bool_Exp>>;
  mlfsl_personnel?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
};

/** order by max() on columns of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Max_Order_By = {
  Bar?: InputMaybe<Order_By>;
  BarId?: InputMaybe<Order_By>;
  BarYear?: InputMaybe<Order_By>;
  DimPersonnelBarKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  IsDeletedIndicator?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Min_Order_By = {
  Bar?: InputMaybe<Order_By>;
  BarId?: InputMaybe<Order_By>;
  BarYear?: InputMaybe<Order_By>;
  DimPersonnelBarKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  IsDeletedIndicator?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "repl.DimPersonnelBar". */
export type Mlfsl_Personnel_Bar_Order_By = {
  Bar?: InputMaybe<Order_By>;
  BarId?: InputMaybe<Order_By>;
  BarYear?: InputMaybe<Order_By>;
  DimPersonnelBarKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  IsDeletedIndicator?: InputMaybe<Order_By>;
  mlfsl_personnel?: InputMaybe<Mlfsl_Personnel_Order_By>;
};

/** order by stddev() on columns of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Stddev_Order_By = {
  DimPersonnelBarKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Stddev_Pop_Order_By = {
  DimPersonnelBarKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Stddev_Samp_Order_By = {
  DimPersonnelBarKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Sum_Order_By = {
  DimPersonnelBarKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Var_Pop_Order_By = {
  DimPersonnelBarKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Var_Samp_Order_By = {
  DimPersonnelBarKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "repl.DimPersonnelBar" */
export type Mlfsl_Personnel_Bar_Variance_Order_By = {
  DimPersonnelBarKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "repl.DimPersonnelNow". All fields are combined with a logical 'AND'. */
export type Mlfsl_Personnel_Bool_Exp = {
  ActiveDirectoryBusinessCategory?: InputMaybe<String_Mssql_Comparison_Exp>;
  ActiveDirectoryDisabledIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  ActiveDirectoryDistinguishedName?: InputMaybe<String_Mssql_Comparison_Exp>;
  ActiveDirectoryEmail?: InputMaybe<String_Mssql_Comparison_Exp>;
  ActiveDirectoryHomeDirectory?: InputMaybe<String_Mssql_Comparison_Exp>;
  ActiveDirectoryLogin?: InputMaybe<String_Mssql_Comparison_Exp>;
  ActiveDirectoryMailboxIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  ActiveDirectorySEVDepartedIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  BYODIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  BarAdmissionFirst?: InputMaybe<String_Mssql_Comparison_Exp>;
  BardateFirst?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  BillingCoordinatorEmployeeId?: InputMaybe<String_Mssql_Comparison_Exp>;
  BlackberryPin?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPostalOfficeAddress1?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPostalOfficeAddress2?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPostalOfficeAddress3?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPostalOfficeCity?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPostalOfficeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPostalOfficeCountryCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPostalOfficeState?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPostalOfficeZip?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOffice?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOfficeAddress1?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOfficeAddress2?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOfficeAddress3?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOfficeAddress4?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOfficeCity?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOfficeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOfficeCodeNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOfficeCodeNumberWithExtension?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOfficeCountryCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOfficeMailBoxNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOfficeMailGroup?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOfficeMailGroupCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOfficePhoneCountry?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOfficePhoneExtension?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOfficePhoneNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOfficePhoneNumberFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOfficePhoneinternalOfficeNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOfficePhoneinternalOfficeNumberFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOfficeState?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessPrimaryOfficeZip?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessSecondaryOffice?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessSecondaryOfficeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessSecondaryOfficeCodeNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessSecondaryOfficeCodeNumberWithExtension?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessSecondaryOfficePhoneCountry?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessSecondaryOfficePhoneExtension?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessSecondaryOfficePhoneNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessSecondaryOfficePhoneNumberFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessSecondaryOfficePhoneinternalOfficeNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  BusinessSecondaryOfficePhoneinternalOfficeNumberFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  CellPhoneCountry?: InputMaybe<String_Mssql_Comparison_Exp>;
  CellPhoneNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  CellPhoneNumberFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  DataCenterRegion?: InputMaybe<String_Mssql_Comparison_Exp>;
  DataSource?: InputMaybe<String_Mssql_Comparison_Exp>;
  DateAccessRemoveKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DateAssociationKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DateBirthKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DateCounselKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DateHire?: InputMaybe<Mlfsl_Date_Bool_Exp>;
  DateHireAdjusted?: InputMaybe<Mlfsl_Date_Bool_Exp>;
  DateHireAdjustedKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DateHireKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DateOfCounselKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DatePartnershipKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DateRehireExpirationKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DateRehireKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DateRemoteWorkingProgramKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DateSeniorCounselKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DateSpecialCounselKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DateTerm?: InputMaybe<Mlfsl_Date_Bool_Exp>;
  DateTermKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DateinternationalPartnerKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DeletedRecordIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  DesignatedEssentialWorkerIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  DesignatedEssentialWorkerRequiredFormsCompleteIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  DesignatedEssentialWorkerRequiredVideoCompleteIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  DimPersonnelNowKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DiscoveryFlag?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLBatchKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLSoftInsertIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  ElitePracticeArea?: InputMaybe<String_Mssql_Comparison_Exp>;
  ElitePracticeAreaDelimited?: InputMaybe<String_Mssql_Comparison_Exp>;
  EliteStatus?: InputMaybe<String_Mssql_Comparison_Exp>;
  EliteSubSubPracticeGroup?: InputMaybe<String_Mssql_Comparison_Exp>;
  EliteTimekeepLocation?: InputMaybe<String_Mssql_Comparison_Exp>;
  EliteTitle?: InputMaybe<String_Mssql_Comparison_Exp>;
  EliteTitleSortOrder?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EliteWorkLocation?: InputMaybe<String_Mssql_Comparison_Exp>;
  ElitedateHireKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ElitedateTermKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  Email?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmailSignatureCaveatText?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact1FirstName?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact1HomePhoneCountry?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact1HomePhoneFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact1HomePhoneNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact1LastName?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact1MiddleName?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact1NameDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact1NameFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact1WorkPhoneCountry?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact1WorkPhoneExtension?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact1WorkPhoneFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact1WorkPhoneNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact2FirstName?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact2HomePhoneCountry?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact2HomePhoneFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact2HomePhoneNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact2LastName?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact2MiddleName?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact2NameDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact2NameFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact2WorkPhoneCountry?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact2WorkPhoneExtension?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact2WorkPhoneFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmergencyContact2WorkPhoneNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmployeeCategoryCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmployeeCategoryDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmployeeId?: InputMaybe<String_Mssql_Comparison_Exp>;
  EmployeeIdOriginal?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EmployeeTypeFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  EtlChecksum?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EtlCreateddate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  EtlModifieddate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  FullTimeEquivalency?: InputMaybe<Float_Mssql_Comparison_Exp>;
  Gender?: InputMaybe<String_Mssql_Comparison_Exp>;
  GenderDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  GradClassYear?: InputMaybe<String_Mssql_Comparison_Exp>;
  GroupJoins?: InputMaybe<Mlfsl_Ad_Join_Bool_Exp>;
  IsActiveIndicator?: InputMaybe<Int_Mssql_Comparison_Exp>;
  IsBilledByAIC?: InputMaybe<String_Mssql_Comparison_Exp>;
  IsDMSDenyAccess?: InputMaybe<String_Mssql_Comparison_Exp>;
  IsExemptIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  IsHRCellPhoneUnlistedIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  IsHREducationYearUnlistedIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  IsHRHomeAddressUnlistedIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  IsHRHomePhoneUnlistedIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  IsHRSpouseUnlistedIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  IsHrDefinedAttorneyIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  IsHrUnlistedIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  IsLateralAttorney?: InputMaybe<String_Mssql_Comparison_Exp>;
  IsLegalProfessionalIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  JobCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  JobFamily?: InputMaybe<String_Mssql_Comparison_Exp>;
  JobFamilyGroup?: InputMaybe<String_Mssql_Comparison_Exp>;
  LawsonCompany?: InputMaybe<Int_Mssql_Comparison_Exp>;
  LawsonFullTimeEquivalency?: InputMaybe<Float_Mssql_Comparison_Exp>;
  LawsonSecondarySubSubPracticeGroup?: InputMaybe<String_Mssql_Comparison_Exp>;
  LawsonSubSubPracticeGroup?: InputMaybe<String_Mssql_Comparison_Exp>;
  LawsondateHireAdjustedKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  LawsondateHireKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  LawsondateTermKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  Login?: InputMaybe<Mlfsl_Ad_Login_Bool_Exp>;
  MLBClassYear?: InputMaybe<String_Mssql_Comparison_Exp>;
  Manager1EmployeeId?: InputMaybe<String_Mssql_Comparison_Exp>;
  Manager1EmployeeIdOriginal?: InputMaybe<Int_Mssql_Comparison_Exp>;
  Manager2EmployeeId?: InputMaybe<String_Mssql_Comparison_Exp>;
  Manager2EmployeeIdOriginal?: InputMaybe<Int_Mssql_Comparison_Exp>;
  Manager3EmployeeId?: InputMaybe<String_Mssql_Comparison_Exp>;
  Manager3EmployeeIdOriginal?: InputMaybe<Int_Mssql_Comparison_Exp>;
  Manager4EmployeeId?: InputMaybe<String_Mssql_Comparison_Exp>;
  Manager4EmployeeIdOriginal?: InputMaybe<Int_Mssql_Comparison_Exp>;
  Manager5EmployeeId?: InputMaybe<String_Mssql_Comparison_Exp>;
  Manager5EmployeeIdOriginal?: InputMaybe<Int_Mssql_Comparison_Exp>;
  Manager6EmployeeId?: InputMaybe<String_Mssql_Comparison_Exp>;
  Manager6EmployeeIdOriginal?: InputMaybe<Int_Mssql_Comparison_Exp>;
  MarsPersonID?: InputMaybe<Int_Mssql_Comparison_Exp>;
  MarsSubSubPracticeGroup?: InputMaybe<String_Mssql_Comparison_Exp>;
  MarsTitle?: InputMaybe<String_Mssql_Comparison_Exp>;
  MarsWorkLocation?: InputMaybe<String_Mssql_Comparison_Exp>;
  MorganNetDisplayIndicator?: InputMaybe<Int_Mssql_Comparison_Exp>;
  NameDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  NameFirst?: InputMaybe<String_Mssql_Comparison_Exp>;
  NameFirstBilling?: InputMaybe<String_Mssql_Comparison_Exp>;
  NameFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  NameInitialsElite?: InputMaybe<String_Mssql_Comparison_Exp>;
  NameLast?: InputMaybe<String_Mssql_Comparison_Exp>;
  NameLastBilling?: InputMaybe<String_Mssql_Comparison_Exp>;
  NameLastNoSuffix?: InputMaybe<String_Mssql_Comparison_Exp>;
  NameMaidenFirst?: InputMaybe<String_Mssql_Comparison_Exp>;
  NameMaidenLast?: InputMaybe<String_Mssql_Comparison_Exp>;
  NameMaidenMiddleInitial?: InputMaybe<String_Mssql_Comparison_Exp>;
  NameMiddle?: InputMaybe<String_Mssql_Comparison_Exp>;
  NameMiddleInitial?: InputMaybe<String_Mssql_Comparison_Exp>;
  NameNick?: InputMaybe<String_Mssql_Comparison_Exp>;
  NameNickIa?: InputMaybe<String_Mssql_Comparison_Exp>;
  NamePreferredDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  NamePreferredDisplay_?: InputMaybe<String_Mssql_Comparison_Exp>;
  NamePreferredFirst?: InputMaybe<String_Mssql_Comparison_Exp>;
  NamePreferredFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  NamePreferredLast?: InputMaybe<String_Mssql_Comparison_Exp>;
  NamePreferredMiddle?: InputMaybe<String_Mssql_Comparison_Exp>;
  NameSuffix?: InputMaybe<String_Mssql_Comparison_Exp>;
  NameTDDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  NonFirmOfficeTaxJurisdictionResident?: InputMaybe<String_Mssql_Comparison_Exp>;
  NonPhiladelphiaResident?: InputMaybe<String_Mssql_Comparison_Exp>;
  ParalegalTier?: InputMaybe<String_Mssql_Comparison_Exp>;
  PartnerTypeKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  PayrollBatchId?: InputMaybe<String_Mssql_Comparison_Exp>;
  PayrollFileNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  PayrollPayGroup?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonEducation?: InputMaybe<Mlfsl_Person_Education_Bool_Exp>;
  PersonalAddressFour?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonalAddressOne?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonalAddressThree?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonalAddressTwo?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonalCity?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonalCountry?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonalEmailAddress?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonalMatter?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonalPhoneCountry?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonalPhoneNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonalPhoneNumberFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonalPronouns?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonalSecondPhoneCountry?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonalSecondPhoneNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonalSecondPhoneNumberFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonalState?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonalZip?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonnelSourceAbbreviation?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonnelSourceName?: InputMaybe<String_Mssql_Comparison_Exp>;
  PersonnelSourceNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  PictureURL?: InputMaybe<String_Mssql_Comparison_Exp>;
  PrimaryAssistant?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
  PrimaryOffice?: InputMaybe<Mlfsl_Office_Bool_Exp>;
  PrimaryPracticeGroup?: InputMaybe<Mlfsl_Practicegroup_Bool_Exp>;
  RateBilling?: InputMaybe<Float_Mssql_Comparison_Exp>;
  RateGrid?: InputMaybe<Float_Mssql_Comparison_Exp>;
  RateStandard?: InputMaybe<Float_Mssql_Comparison_Exp>;
  RehireIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  RemoteWorkingProgramIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  RequiredTime?: InputMaybe<String_Mssql_Comparison_Exp>;
  SecondaryAssistant?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
  SecondaryOffice?: InputMaybe<Mlfsl_Office_Bool_Exp>;
  SecondaryPracticeGroup?: InputMaybe<Mlfsl_Practicegroup_Bool_Exp>;
  Secretary1EmployeeId?: InputMaybe<String_Mssql_Comparison_Exp>;
  Secretary1EmployeeIdOriginal?: InputMaybe<Int_Mssql_Comparison_Exp>;
  Secretary1FirstName?: InputMaybe<String_Mssql_Comparison_Exp>;
  Secretary1LastName?: InputMaybe<String_Mssql_Comparison_Exp>;
  Secretary1MiddleName?: InputMaybe<String_Mssql_Comparison_Exp>;
  Secretary1NameDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  Secretary1NameFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  Secretary1NamePreferredDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  Secretary1NamePreferredFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  Secretary1PhoneExtension?: InputMaybe<String_Mssql_Comparison_Exp>;
  Secretary2EmployeeId?: InputMaybe<String_Mssql_Comparison_Exp>;
  Secretary2EmployeeIdOriginal?: InputMaybe<Int_Mssql_Comparison_Exp>;
  Secretary2FirstName?: InputMaybe<String_Mssql_Comparison_Exp>;
  Secretary2LastName?: InputMaybe<String_Mssql_Comparison_Exp>;
  Secretary2MiddleName?: InputMaybe<String_Mssql_Comparison_Exp>;
  Secretary2NameDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  Secretary2NameFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  Secretary2NamePreferredDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  Secretary2NamePreferredFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  Secretary2PhoneExtension?: InputMaybe<String_Mssql_Comparison_Exp>;
  SpouseFirstName?: InputMaybe<String_Mssql_Comparison_Exp>;
  SpouseLastName?: InputMaybe<String_Mssql_Comparison_Exp>;
  SpouseMiddleInit?: InputMaybe<String_Mssql_Comparison_Exp>;
  SpouseNameDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  SpouseNameFull?: InputMaybe<String_Mssql_Comparison_Exp>;
  StatusActiveEmployeeIndicator?: InputMaybe<Int_Mssql_Comparison_Exp>;
  StatusCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  StatusDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  StatusDescription2?: InputMaybe<String_Mssql_Comparison_Exp>;
  StatusLabel?: InputMaybe<String_Mssql_Comparison_Exp>;
  TimeKeeperCostEntryFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  TimeKeeperTimeEntryFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  TimeReporter?: InputMaybe<String_Mssql_Comparison_Exp>;
  TimekeeperGUID?: InputMaybe<Uniqueidentifier_Mssql_Comparison_Exp>;
  TimekeeperIndex?: InputMaybe<Int_Mssql_Comparison_Exp>;
  Title?: InputMaybe<String_Mssql_Comparison_Exp>;
  TitleDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  TitleFullyQualified?: InputMaybe<String_Mssql_Comparison_Exp>;
  WallBuilderEntityID?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Personnel_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Personnel_Bool_Exp>>;
  dateClerkship?: InputMaybe<String_Mssql_Comparison_Exp>;
  mlfsl_personnel_bar?: InputMaybe<Mlfsl_Personnel_Bar_Bool_Exp>;
  mlfsl_personnel_clerkship?: InputMaybe<Mlfsl_Personnel_Clerkship_Bool_Exp>;
  mlfsl_personnel_committee?: InputMaybe<Mlfsl_Personnel_Committee_Bool_Exp>;
  mlfsl_personnel_court?: InputMaybe<Mlfsl_Personnel_Court_Bool_Exp>;
  mlfsl_personnel_language?: InputMaybe<Mlfsl_Personnel_Language_Bool_Exp>;
  probono_goals?: InputMaybe<Mlfsl_Probono_Goal_Bool_Exp>;
};

/** columns and relationships of "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship = {
  ClerkshipCourt: Scalars['String']['output'];
  ClerkshipEndYear: Scalars['String']['output'];
  ClerkshipJudge: Scalars['String']['output'];
  ClerkshipStartYear: Scalars['String']['output'];
  DeletedRecordIndicator: Scalars['String']['output'];
  DimPersonnelClerkshipKey: Scalars['Int']['output'];
  ETLBatchKey: Scalars['Int']['output'];
  ETLChecksum: Scalars['Int']['output'];
  ETLCreatedDate: Scalars['datetime']['output'];
  ETLModifiedDate: Scalars['datetime']['output'];
  EmployeeIdOriginal: Scalars['Int']['output'];
  /** An object relationship */
  mlfsl_personnel?: Maybe<Mlfsl_Personnel>;
};

/** order by aggregate values of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Personnel_Clerkship_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Personnel_Clerkship_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Personnel_Clerkship_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Personnel_Clerkship_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Personnel_Clerkship_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Personnel_Clerkship_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Personnel_Clerkship_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Personnel_Clerkship_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Personnel_Clerkship_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Personnel_Clerkship_Variance_Order_By>;
};

/** order by avg() on columns of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Avg_Order_By = {
  DimPersonnelClerkshipKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "repl.DimPersonnelClerkship". All fields are combined with a logical 'AND'. */
export type Mlfsl_Personnel_Clerkship_Bool_Exp = {
  ClerkshipCourt?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClerkshipEndYear?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClerkshipJudge?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClerkshipStartYear?: InputMaybe<String_Mssql_Comparison_Exp>;
  DeletedRecordIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  DimPersonnelClerkshipKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLBatchKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLChecksum?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLCreatedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  ETLModifiedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  EmployeeIdOriginal?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Personnel_Clerkship_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Personnel_Clerkship_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Personnel_Clerkship_Bool_Exp>>;
  mlfsl_personnel?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
};

/** order by max() on columns of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Max_Order_By = {
  ClerkshipCourt?: InputMaybe<Order_By>;
  ClerkshipEndYear?: InputMaybe<Order_By>;
  ClerkshipJudge?: InputMaybe<Order_By>;
  ClerkshipStartYear?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DimPersonnelClerkshipKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  ETLCreatedDate?: InputMaybe<Order_By>;
  ETLModifiedDate?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Min_Order_By = {
  ClerkshipCourt?: InputMaybe<Order_By>;
  ClerkshipEndYear?: InputMaybe<Order_By>;
  ClerkshipJudge?: InputMaybe<Order_By>;
  ClerkshipStartYear?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DimPersonnelClerkshipKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  ETLCreatedDate?: InputMaybe<Order_By>;
  ETLModifiedDate?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "repl.DimPersonnelClerkship". */
export type Mlfsl_Personnel_Clerkship_Order_By = {
  ClerkshipCourt?: InputMaybe<Order_By>;
  ClerkshipEndYear?: InputMaybe<Order_By>;
  ClerkshipJudge?: InputMaybe<Order_By>;
  ClerkshipStartYear?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DimPersonnelClerkshipKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  ETLCreatedDate?: InputMaybe<Order_By>;
  ETLModifiedDate?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  mlfsl_personnel?: InputMaybe<Mlfsl_Personnel_Order_By>;
};

/** order by stddev() on columns of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Stddev_Order_By = {
  DimPersonnelClerkshipKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Stddev_Pop_Order_By = {
  DimPersonnelClerkshipKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Stddev_Samp_Order_By = {
  DimPersonnelClerkshipKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Sum_Order_By = {
  DimPersonnelClerkshipKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Var_Pop_Order_By = {
  DimPersonnelClerkshipKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Var_Samp_Order_By = {
  DimPersonnelClerkshipKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "repl.DimPersonnelClerkship" */
export type Mlfsl_Personnel_Clerkship_Variance_Order_By = {
  DimPersonnelClerkshipKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** columns and relationships of "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee = {
  CommitteeFocus?: Maybe<Scalars['String']['output']>;
  CommitteeName: Scalars['String']['output'];
  CurrentMembershipIndicator?: Maybe<Scalars['String']['output']>;
  DeletedRecordIndicator: Scalars['String']['output'];
  DimPersonnelCommitteeKey: Scalars['Int']['output'];
  ETLBatchKey: Scalars['Int']['output'];
  ETLChecksum: Scalars['Int']['output'];
  ETLCreatedDate: Scalars['datetime']['output'];
  ETLModifiedDate: Scalars['datetime']['output'];
  EmployeeIdOriginal: Scalars['Int']['output'];
  MemberLocationResponsibility?: Maybe<Scalars['String']['output']>;
  MemberRole?: Maybe<Scalars['String']['output']>;
  MembershipEndDate?: Maybe<Scalars['datetime']['output']>;
  MembershipStartDate: Scalars['datetime']['output'];
  /** An object relationship */
  mlfsl_personnel?: Maybe<Mlfsl_Personnel>;
};

/** order by aggregate values of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Personnel_Committee_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Personnel_Committee_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Personnel_Committee_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Personnel_Committee_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Personnel_Committee_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Personnel_Committee_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Personnel_Committee_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Personnel_Committee_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Personnel_Committee_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Personnel_Committee_Variance_Order_By>;
};

/** order by avg() on columns of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Avg_Order_By = {
  DimPersonnelCommitteeKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "repl.DimPersonnelCommittee". All fields are combined with a logical 'AND'. */
export type Mlfsl_Personnel_Committee_Bool_Exp = {
  CommitteeFocus?: InputMaybe<String_Mssql_Comparison_Exp>;
  CommitteeName?: InputMaybe<String_Mssql_Comparison_Exp>;
  CurrentMembershipIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  DeletedRecordIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  DimPersonnelCommitteeKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLBatchKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLChecksum?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLCreatedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  ETLModifiedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  EmployeeIdOriginal?: InputMaybe<Int_Mssql_Comparison_Exp>;
  MemberLocationResponsibility?: InputMaybe<String_Mssql_Comparison_Exp>;
  MemberRole?: InputMaybe<String_Mssql_Comparison_Exp>;
  MembershipEndDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  MembershipStartDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Personnel_Committee_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Personnel_Committee_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Personnel_Committee_Bool_Exp>>;
  mlfsl_personnel?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
};

/** order by max() on columns of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Max_Order_By = {
  CommitteeFocus?: InputMaybe<Order_By>;
  CommitteeName?: InputMaybe<Order_By>;
  CurrentMembershipIndicator?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DimPersonnelCommitteeKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  ETLCreatedDate?: InputMaybe<Order_By>;
  ETLModifiedDate?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  MemberLocationResponsibility?: InputMaybe<Order_By>;
  MemberRole?: InputMaybe<Order_By>;
  MembershipEndDate?: InputMaybe<Order_By>;
  MembershipStartDate?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Min_Order_By = {
  CommitteeFocus?: InputMaybe<Order_By>;
  CommitteeName?: InputMaybe<Order_By>;
  CurrentMembershipIndicator?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DimPersonnelCommitteeKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  ETLCreatedDate?: InputMaybe<Order_By>;
  ETLModifiedDate?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  MemberLocationResponsibility?: InputMaybe<Order_By>;
  MemberRole?: InputMaybe<Order_By>;
  MembershipEndDate?: InputMaybe<Order_By>;
  MembershipStartDate?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "repl.DimPersonnelCommittee". */
export type Mlfsl_Personnel_Committee_Order_By = {
  CommitteeFocus?: InputMaybe<Order_By>;
  CommitteeName?: InputMaybe<Order_By>;
  CurrentMembershipIndicator?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DimPersonnelCommitteeKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  ETLCreatedDate?: InputMaybe<Order_By>;
  ETLModifiedDate?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  MemberLocationResponsibility?: InputMaybe<Order_By>;
  MemberRole?: InputMaybe<Order_By>;
  MembershipEndDate?: InputMaybe<Order_By>;
  MembershipStartDate?: InputMaybe<Order_By>;
  mlfsl_personnel?: InputMaybe<Mlfsl_Personnel_Order_By>;
};

/** order by stddev() on columns of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Stddev_Order_By = {
  DimPersonnelCommitteeKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Stddev_Pop_Order_By = {
  DimPersonnelCommitteeKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Stddev_Samp_Order_By = {
  DimPersonnelCommitteeKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Sum_Order_By = {
  DimPersonnelCommitteeKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Var_Pop_Order_By = {
  DimPersonnelCommitteeKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Var_Samp_Order_By = {
  DimPersonnelCommitteeKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "repl.DimPersonnelCommittee" */
export type Mlfsl_Personnel_Committee_Variance_Order_By = {
  DimPersonnelCommitteeKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** columns and relationships of "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court = {
  Court?: Maybe<Scalars['String']['output']>;
  CourtYear?: Maybe<Scalars['String']['output']>;
  DeletedRecordIndicator?: Maybe<Scalars['String']['output']>;
  DimPersonnelCourtKey: Scalars['Int']['output'];
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  ETLChecksum?: Maybe<Scalars['Int']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  /** An object relationship */
  mlfsl_personnel?: Maybe<Mlfsl_Personnel>;
};

/** order by aggregate values of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Personnel_Court_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Personnel_Court_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Personnel_Court_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Personnel_Court_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Personnel_Court_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Personnel_Court_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Personnel_Court_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Personnel_Court_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Personnel_Court_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Personnel_Court_Variance_Order_By>;
};

/** order by avg() on columns of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Avg_Order_By = {
  DimPersonnelCourtKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "repl.DimPersonnelCourt". All fields are combined with a logical 'AND'. */
export type Mlfsl_Personnel_Court_Bool_Exp = {
  Court?: InputMaybe<String_Mssql_Comparison_Exp>;
  CourtYear?: InputMaybe<String_Mssql_Comparison_Exp>;
  DeletedRecordIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  DimPersonnelCourtKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLBatchKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLChecksum?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EmployeeIdOriginal?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EtlCreatedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  EtlModifiedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Personnel_Court_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Personnel_Court_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Personnel_Court_Bool_Exp>>;
  mlfsl_personnel?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
};

/** order by max() on columns of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Max_Order_By = {
  Court?: InputMaybe<Order_By>;
  CourtYear?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DimPersonnelCourtKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Min_Order_By = {
  Court?: InputMaybe<Order_By>;
  CourtYear?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DimPersonnelCourtKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "repl.DimPersonnelCourt". */
export type Mlfsl_Personnel_Court_Order_By = {
  Court?: InputMaybe<Order_By>;
  CourtYear?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DimPersonnelCourtKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  mlfsl_personnel?: InputMaybe<Mlfsl_Personnel_Order_By>;
};

/** order by stddev() on columns of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Stddev_Order_By = {
  DimPersonnelCourtKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Stddev_Pop_Order_By = {
  DimPersonnelCourtKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Stddev_Samp_Order_By = {
  DimPersonnelCourtKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Sum_Order_By = {
  DimPersonnelCourtKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Var_Pop_Order_By = {
  DimPersonnelCourtKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Var_Samp_Order_By = {
  DimPersonnelCourtKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "repl.DimPersonnelCourt" */
export type Mlfsl_Personnel_Court_Variance_Order_By = {
  DimPersonnelCourtKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLChecksum?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
};

/** columns and relationships of "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language = {
  DimPersonnelLanguageKey: Scalars['Int']['output'];
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
  EtlCreatedDate?: Maybe<Scalars['datetime']['output']>;
  EtlModifiedDate?: Maybe<Scalars['datetime']['output']>;
  IsDeletedIndicator?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<Scalars['String']['output']>;
  LawsonCreationDate?: Maybe<Scalars['datetime']['output']>;
  MnetDisplay?: Maybe<Scalars['String']['output']>;
  ReadingProficiency?: Maybe<Scalars['String']['output']>;
  SpeakingProficiency?: Maybe<Scalars['String']['output']>;
  WritingProficiency?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  mlfsl_personnel?: Maybe<Mlfsl_Personnel>;
};

/** order by aggregate values of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Personnel_Language_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Personnel_Language_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Personnel_Language_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Personnel_Language_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Personnel_Language_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Personnel_Language_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Personnel_Language_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Personnel_Language_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Personnel_Language_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Personnel_Language_Variance_Order_By>;
};

/** order by avg() on columns of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Avg_Order_By = {
  DimPersonnelLanguageKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "repl.DimPersonnelLanguage". All fields are combined with a logical 'AND'. */
export type Mlfsl_Personnel_Language_Bool_Exp = {
  DimPersonnelLanguageKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLBatchKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EmployeeIdOriginal?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EtlChecksum?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EtlCreatedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  EtlModifiedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  IsDeletedIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  Language?: InputMaybe<String_Mssql_Comparison_Exp>;
  LawsonCreationDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  MnetDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  ReadingProficiency?: InputMaybe<String_Mssql_Comparison_Exp>;
  SpeakingProficiency?: InputMaybe<String_Mssql_Comparison_Exp>;
  WritingProficiency?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Personnel_Language_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Personnel_Language_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Personnel_Language_Bool_Exp>>;
  mlfsl_personnel?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
};

/** order by max() on columns of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Max_Order_By = {
  DimPersonnelLanguageKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  IsDeletedIndicator?: InputMaybe<Order_By>;
  Language?: InputMaybe<Order_By>;
  LawsonCreationDate?: InputMaybe<Order_By>;
  MnetDisplay?: InputMaybe<Order_By>;
  ReadingProficiency?: InputMaybe<Order_By>;
  SpeakingProficiency?: InputMaybe<Order_By>;
  WritingProficiency?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Min_Order_By = {
  DimPersonnelLanguageKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  IsDeletedIndicator?: InputMaybe<Order_By>;
  Language?: InputMaybe<Order_By>;
  LawsonCreationDate?: InputMaybe<Order_By>;
  MnetDisplay?: InputMaybe<Order_By>;
  ReadingProficiency?: InputMaybe<Order_By>;
  SpeakingProficiency?: InputMaybe<Order_By>;
  WritingProficiency?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "repl.DimPersonnelLanguage". */
export type Mlfsl_Personnel_Language_Order_By = {
  DimPersonnelLanguageKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  IsDeletedIndicator?: InputMaybe<Order_By>;
  Language?: InputMaybe<Order_By>;
  LawsonCreationDate?: InputMaybe<Order_By>;
  MnetDisplay?: InputMaybe<Order_By>;
  ReadingProficiency?: InputMaybe<Order_By>;
  SpeakingProficiency?: InputMaybe<Order_By>;
  WritingProficiency?: InputMaybe<Order_By>;
  mlfsl_personnel?: InputMaybe<Mlfsl_Personnel_Order_By>;
};

/** order by stddev() on columns of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Stddev_Order_By = {
  DimPersonnelLanguageKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Stddev_Pop_Order_By = {
  DimPersonnelLanguageKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Stddev_Samp_Order_By = {
  DimPersonnelLanguageKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Sum_Order_By = {
  DimPersonnelLanguageKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Var_Pop_Order_By = {
  DimPersonnelLanguageKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Var_Samp_Order_By = {
  DimPersonnelLanguageKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "repl.DimPersonnelLanguage" */
export type Mlfsl_Personnel_Language_Variance_Order_By = {
  DimPersonnelLanguageKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Mlfsl_Personnel_Max_Fields = {
  ActiveDirectoryBusinessCategory?: Maybe<Scalars['String']['output']>;
  ActiveDirectoryDisabledIndicator?: Maybe<Scalars['String']['output']>;
  ActiveDirectoryDistinguishedName?: Maybe<Scalars['String']['output']>;
  ActiveDirectoryEmail?: Maybe<Scalars['String']['output']>;
  ActiveDirectoryHomeDirectory?: Maybe<Scalars['String']['output']>;
  ActiveDirectoryLogin?: Maybe<Scalars['String']['output']>;
  ActiveDirectoryMailboxIndicator?: Maybe<Scalars['String']['output']>;
  ActiveDirectorySEVDepartedIndicator?: Maybe<Scalars['String']['output']>;
  BYODIndicator?: Maybe<Scalars['String']['output']>;
  BarAdmissionFirst?: Maybe<Scalars['String']['output']>;
  BardateFirst?: Maybe<Scalars['datetime']['output']>;
  BillingCoordinatorEmployeeId?: Maybe<Scalars['String']['output']>;
  BlackberryPin?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeAddress1?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeAddress2?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeAddress3?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeCity?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeCode?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeCountryCode?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeState?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeZip?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOffice?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeAddress1?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeAddress2?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeAddress3?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeAddress4?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeCity?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeCode?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeCodeNumber?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeCodeNumberWithExtension?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeCountryCode?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeMailBoxNumber?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeMailGroup?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeMailGroupCode?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficePhoneCountry?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficePhoneExtension?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficePhoneNumber?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficePhoneNumberFull?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficePhoneinternalOfficeNumber?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficePhoneinternalOfficeNumberFull?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeState?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeZip?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOffice?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficeCode?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficeCodeNumber?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficeCodeNumberWithExtension?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficePhoneCountry?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficePhoneExtension?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficePhoneNumber?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficePhoneNumberFull?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficePhoneinternalOfficeNumber?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficePhoneinternalOfficeNumberFull?: Maybe<Scalars['String']['output']>;
  CellPhoneCountry?: Maybe<Scalars['String']['output']>;
  CellPhoneNumber?: Maybe<Scalars['String']['output']>;
  CellPhoneNumberFull?: Maybe<Scalars['String']['output']>;
  DataCenterRegion?: Maybe<Scalars['String']['output']>;
  DataSource?: Maybe<Scalars['String']['output']>;
  DateAccessRemoveKey?: Maybe<Scalars['Int']['output']>;
  DateAssociationKey?: Maybe<Scalars['Int']['output']>;
  DateBirthKey?: Maybe<Scalars['Int']['output']>;
  DateCounselKey?: Maybe<Scalars['Int']['output']>;
  DateHireAdjustedKey?: Maybe<Scalars['Int']['output']>;
  DateHireKey?: Maybe<Scalars['Int']['output']>;
  DateOfCounselKey?: Maybe<Scalars['Int']['output']>;
  DatePartnershipKey?: Maybe<Scalars['Int']['output']>;
  DateRehireExpirationKey?: Maybe<Scalars['Int']['output']>;
  DateRehireKey?: Maybe<Scalars['Int']['output']>;
  DateRemoteWorkingProgramKey?: Maybe<Scalars['Int']['output']>;
  DateSeniorCounselKey?: Maybe<Scalars['Int']['output']>;
  DateSpecialCounselKey?: Maybe<Scalars['Int']['output']>;
  DateTermKey?: Maybe<Scalars['Int']['output']>;
  DateinternationalPartnerKey?: Maybe<Scalars['Int']['output']>;
  DeletedRecordIndicator?: Maybe<Scalars['String']['output']>;
  DesignatedEssentialWorkerIndicator?: Maybe<Scalars['String']['output']>;
  DesignatedEssentialWorkerRequiredFormsCompleteIndicator?: Maybe<Scalars['String']['output']>;
  DesignatedEssentialWorkerRequiredVideoCompleteIndicator?: Maybe<Scalars['String']['output']>;
  DimPersonnelNowKey?: Maybe<Scalars['Int']['output']>;
  DiscoveryFlag?: Maybe<Scalars['Int']['output']>;
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  ETLSoftInsertIndicator?: Maybe<Scalars['String']['output']>;
  ElitePracticeArea?: Maybe<Scalars['String']['output']>;
  ElitePracticeAreaDelimited?: Maybe<Scalars['String']['output']>;
  EliteStatus?: Maybe<Scalars['String']['output']>;
  EliteSubSubPracticeGroup?: Maybe<Scalars['String']['output']>;
  EliteTimekeepLocation?: Maybe<Scalars['String']['output']>;
  EliteTitle?: Maybe<Scalars['String']['output']>;
  EliteTitleSortOrder?: Maybe<Scalars['Int']['output']>;
  EliteWorkLocation?: Maybe<Scalars['String']['output']>;
  ElitedateHireKey?: Maybe<Scalars['Int']['output']>;
  ElitedateTermKey?: Maybe<Scalars['Int']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  EmailSignatureCaveatText?: Maybe<Scalars['String']['output']>;
  EmergencyContact1FirstName?: Maybe<Scalars['String']['output']>;
  EmergencyContact1HomePhoneCountry?: Maybe<Scalars['String']['output']>;
  EmergencyContact1HomePhoneFull?: Maybe<Scalars['String']['output']>;
  EmergencyContact1HomePhoneNumber?: Maybe<Scalars['String']['output']>;
  EmergencyContact1LastName?: Maybe<Scalars['String']['output']>;
  EmergencyContact1MiddleName?: Maybe<Scalars['String']['output']>;
  EmergencyContact1NameDisplay?: Maybe<Scalars['String']['output']>;
  EmergencyContact1NameFull?: Maybe<Scalars['String']['output']>;
  EmergencyContact1WorkPhoneCountry?: Maybe<Scalars['String']['output']>;
  EmergencyContact1WorkPhoneExtension?: Maybe<Scalars['String']['output']>;
  EmergencyContact1WorkPhoneFull?: Maybe<Scalars['String']['output']>;
  EmergencyContact1WorkPhoneNumber?: Maybe<Scalars['String']['output']>;
  EmergencyContact2FirstName?: Maybe<Scalars['String']['output']>;
  EmergencyContact2HomePhoneCountry?: Maybe<Scalars['String']['output']>;
  EmergencyContact2HomePhoneFull?: Maybe<Scalars['String']['output']>;
  EmergencyContact2HomePhoneNumber?: Maybe<Scalars['String']['output']>;
  EmergencyContact2LastName?: Maybe<Scalars['String']['output']>;
  EmergencyContact2MiddleName?: Maybe<Scalars['String']['output']>;
  EmergencyContact2NameDisplay?: Maybe<Scalars['String']['output']>;
  EmergencyContact2NameFull?: Maybe<Scalars['String']['output']>;
  EmergencyContact2WorkPhoneCountry?: Maybe<Scalars['String']['output']>;
  EmergencyContact2WorkPhoneExtension?: Maybe<Scalars['String']['output']>;
  EmergencyContact2WorkPhoneFull?: Maybe<Scalars['String']['output']>;
  EmergencyContact2WorkPhoneNumber?: Maybe<Scalars['String']['output']>;
  EmployeeCategoryCode?: Maybe<Scalars['String']['output']>;
  EmployeeCategoryDescription?: Maybe<Scalars['String']['output']>;
  EmployeeId?: Maybe<Scalars['String']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  EmployeeTypeFlag?: Maybe<Scalars['String']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
  EtlCreateddate?: Maybe<Scalars['datetime']['output']>;
  EtlModifieddate?: Maybe<Scalars['datetime']['output']>;
  FullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  Gender?: Maybe<Scalars['String']['output']>;
  GenderDescription?: Maybe<Scalars['String']['output']>;
  GradClassYear?: Maybe<Scalars['String']['output']>;
  IsActiveIndicator?: Maybe<Scalars['Int']['output']>;
  IsBilledByAIC?: Maybe<Scalars['String']['output']>;
  IsDMSDenyAccess?: Maybe<Scalars['String']['output']>;
  IsExemptIndicator?: Maybe<Scalars['String']['output']>;
  IsHRCellPhoneUnlistedIndicator?: Maybe<Scalars['String']['output']>;
  IsHREducationYearUnlistedIndicator?: Maybe<Scalars['String']['output']>;
  IsHRHomeAddressUnlistedIndicator?: Maybe<Scalars['String']['output']>;
  IsHRHomePhoneUnlistedIndicator?: Maybe<Scalars['String']['output']>;
  IsHRSpouseUnlistedIndicator?: Maybe<Scalars['String']['output']>;
  IsHrDefinedAttorneyIndicator?: Maybe<Scalars['String']['output']>;
  IsHrUnlistedIndicator?: Maybe<Scalars['String']['output']>;
  IsLateralAttorney?: Maybe<Scalars['String']['output']>;
  IsLegalProfessionalIndicator?: Maybe<Scalars['String']['output']>;
  JobCode?: Maybe<Scalars['String']['output']>;
  JobFamily?: Maybe<Scalars['String']['output']>;
  JobFamilyGroup?: Maybe<Scalars['String']['output']>;
  LawsonCompany?: Maybe<Scalars['Int']['output']>;
  LawsonFullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  LawsonSecondarySubSubPracticeGroup?: Maybe<Scalars['String']['output']>;
  LawsonSubSubPracticeGroup?: Maybe<Scalars['String']['output']>;
  LawsondateHireAdjustedKey?: Maybe<Scalars['Int']['output']>;
  LawsondateHireKey?: Maybe<Scalars['Int']['output']>;
  LawsondateTermKey?: Maybe<Scalars['Int']['output']>;
  MLBClassYear?: Maybe<Scalars['String']['output']>;
  Manager1EmployeeId?: Maybe<Scalars['String']['output']>;
  Manager1EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Manager2EmployeeId?: Maybe<Scalars['String']['output']>;
  Manager2EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Manager3EmployeeId?: Maybe<Scalars['String']['output']>;
  Manager3EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Manager4EmployeeId?: Maybe<Scalars['String']['output']>;
  Manager4EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Manager5EmployeeId?: Maybe<Scalars['String']['output']>;
  Manager5EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Manager6EmployeeId?: Maybe<Scalars['String']['output']>;
  Manager6EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  MarsPersonID?: Maybe<Scalars['Int']['output']>;
  MarsSubSubPracticeGroup?: Maybe<Scalars['String']['output']>;
  MarsTitle?: Maybe<Scalars['String']['output']>;
  MarsWorkLocation?: Maybe<Scalars['String']['output']>;
  MorganNetDisplayIndicator?: Maybe<Scalars['Int']['output']>;
  NameDisplay?: Maybe<Scalars['String']['output']>;
  NameFirst?: Maybe<Scalars['String']['output']>;
  NameFirstBilling?: Maybe<Scalars['String']['output']>;
  NameFull?: Maybe<Scalars['String']['output']>;
  NameInitialsElite?: Maybe<Scalars['String']['output']>;
  NameLast?: Maybe<Scalars['String']['output']>;
  NameLastBilling?: Maybe<Scalars['String']['output']>;
  NameLastNoSuffix?: Maybe<Scalars['String']['output']>;
  NameMaidenFirst?: Maybe<Scalars['String']['output']>;
  NameMaidenLast?: Maybe<Scalars['String']['output']>;
  NameMaidenMiddleInitial?: Maybe<Scalars['String']['output']>;
  NameMiddle?: Maybe<Scalars['String']['output']>;
  NameMiddleInitial?: Maybe<Scalars['String']['output']>;
  NameNick?: Maybe<Scalars['String']['output']>;
  NameNickIa?: Maybe<Scalars['String']['output']>;
  NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  NamePreferredDisplay_?: Maybe<Scalars['String']['output']>;
  NamePreferredFirst?: Maybe<Scalars['String']['output']>;
  NamePreferredFull?: Maybe<Scalars['String']['output']>;
  NamePreferredLast?: Maybe<Scalars['String']['output']>;
  NamePreferredMiddle?: Maybe<Scalars['String']['output']>;
  NameSuffix?: Maybe<Scalars['String']['output']>;
  NameTDDisplay?: Maybe<Scalars['String']['output']>;
  NonFirmOfficeTaxJurisdictionResident?: Maybe<Scalars['String']['output']>;
  NonPhiladelphiaResident?: Maybe<Scalars['String']['output']>;
  ParalegalTier?: Maybe<Scalars['String']['output']>;
  PartnerTypeKey?: Maybe<Scalars['Int']['output']>;
  PayrollBatchId?: Maybe<Scalars['String']['output']>;
  PayrollFileNumber?: Maybe<Scalars['String']['output']>;
  PayrollPayGroup?: Maybe<Scalars['String']['output']>;
  PersonalAddressFour?: Maybe<Scalars['String']['output']>;
  PersonalAddressOne?: Maybe<Scalars['String']['output']>;
  PersonalAddressThree?: Maybe<Scalars['String']['output']>;
  PersonalAddressTwo?: Maybe<Scalars['String']['output']>;
  PersonalCity?: Maybe<Scalars['String']['output']>;
  PersonalCountry?: Maybe<Scalars['String']['output']>;
  PersonalEmailAddress?: Maybe<Scalars['String']['output']>;
  PersonalMatter?: Maybe<Scalars['String']['output']>;
  PersonalPhoneCountry?: Maybe<Scalars['String']['output']>;
  PersonalPhoneNumber?: Maybe<Scalars['String']['output']>;
  PersonalPhoneNumberFull?: Maybe<Scalars['String']['output']>;
  PersonalPronouns?: Maybe<Scalars['String']['output']>;
  PersonalSecondPhoneCountry?: Maybe<Scalars['String']['output']>;
  PersonalSecondPhoneNumber?: Maybe<Scalars['String']['output']>;
  PersonalSecondPhoneNumberFull?: Maybe<Scalars['String']['output']>;
  PersonalState?: Maybe<Scalars['String']['output']>;
  PersonalZip?: Maybe<Scalars['String']['output']>;
  PersonnelSourceAbbreviation?: Maybe<Scalars['String']['output']>;
  PersonnelSourceName?: Maybe<Scalars['String']['output']>;
  PersonnelSourceNumber?: Maybe<Scalars['String']['output']>;
  PictureURL?: Maybe<Scalars['String']['output']>;
  RateBilling?: Maybe<Scalars['Float']['output']>;
  RateGrid?: Maybe<Scalars['Float']['output']>;
  RateStandard?: Maybe<Scalars['Float']['output']>;
  RehireIndicator?: Maybe<Scalars['String']['output']>;
  RemoteWorkingProgramIndicator?: Maybe<Scalars['String']['output']>;
  RequiredTime?: Maybe<Scalars['String']['output']>;
  Secretary1EmployeeId?: Maybe<Scalars['String']['output']>;
  Secretary1EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Secretary1FirstName?: Maybe<Scalars['String']['output']>;
  Secretary1LastName?: Maybe<Scalars['String']['output']>;
  Secretary1MiddleName?: Maybe<Scalars['String']['output']>;
  Secretary1NameDisplay?: Maybe<Scalars['String']['output']>;
  Secretary1NameFull?: Maybe<Scalars['String']['output']>;
  Secretary1NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  Secretary1NamePreferredFull?: Maybe<Scalars['String']['output']>;
  Secretary1PhoneExtension?: Maybe<Scalars['String']['output']>;
  Secretary2EmployeeId?: Maybe<Scalars['String']['output']>;
  Secretary2EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Secretary2FirstName?: Maybe<Scalars['String']['output']>;
  Secretary2LastName?: Maybe<Scalars['String']['output']>;
  Secretary2MiddleName?: Maybe<Scalars['String']['output']>;
  Secretary2NameDisplay?: Maybe<Scalars['String']['output']>;
  Secretary2NameFull?: Maybe<Scalars['String']['output']>;
  Secretary2NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  Secretary2NamePreferredFull?: Maybe<Scalars['String']['output']>;
  Secretary2PhoneExtension?: Maybe<Scalars['String']['output']>;
  SpouseFirstName?: Maybe<Scalars['String']['output']>;
  SpouseLastName?: Maybe<Scalars['String']['output']>;
  SpouseMiddleInit?: Maybe<Scalars['String']['output']>;
  SpouseNameDisplay?: Maybe<Scalars['String']['output']>;
  SpouseNameFull?: Maybe<Scalars['String']['output']>;
  StatusActiveEmployeeIndicator?: Maybe<Scalars['Int']['output']>;
  StatusCode?: Maybe<Scalars['String']['output']>;
  StatusDescription?: Maybe<Scalars['String']['output']>;
  StatusDescription2?: Maybe<Scalars['String']['output']>;
  StatusLabel?: Maybe<Scalars['String']['output']>;
  TimeKeeperCostEntryFlag?: Maybe<Scalars['String']['output']>;
  TimeKeeperTimeEntryFlag?: Maybe<Scalars['String']['output']>;
  TimeReporter?: Maybe<Scalars['String']['output']>;
  TimekeeperIndex?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  TitleDisplay?: Maybe<Scalars['String']['output']>;
  TitleFullyQualified?: Maybe<Scalars['String']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Int']['output']>;
  dateClerkship?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Max_Order_By = {
  ActiveDirectoryBusinessCategory?: InputMaybe<Order_By>;
  ActiveDirectoryDisabledIndicator?: InputMaybe<Order_By>;
  ActiveDirectoryDistinguishedName?: InputMaybe<Order_By>;
  ActiveDirectoryEmail?: InputMaybe<Order_By>;
  ActiveDirectoryHomeDirectory?: InputMaybe<Order_By>;
  ActiveDirectoryLogin?: InputMaybe<Order_By>;
  ActiveDirectoryMailboxIndicator?: InputMaybe<Order_By>;
  ActiveDirectorySEVDepartedIndicator?: InputMaybe<Order_By>;
  BYODIndicator?: InputMaybe<Order_By>;
  BarAdmissionFirst?: InputMaybe<Order_By>;
  BardateFirst?: InputMaybe<Order_By>;
  BillingCoordinatorEmployeeId?: InputMaybe<Order_By>;
  BlackberryPin?: InputMaybe<Order_By>;
  BusinessPostalOfficeAddress1?: InputMaybe<Order_By>;
  BusinessPostalOfficeAddress2?: InputMaybe<Order_By>;
  BusinessPostalOfficeAddress3?: InputMaybe<Order_By>;
  BusinessPostalOfficeCity?: InputMaybe<Order_By>;
  BusinessPostalOfficeCode?: InputMaybe<Order_By>;
  BusinessPostalOfficeCountryCode?: InputMaybe<Order_By>;
  BusinessPostalOfficeState?: InputMaybe<Order_By>;
  BusinessPostalOfficeZip?: InputMaybe<Order_By>;
  BusinessPrimaryOffice?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeAddress1?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeAddress2?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeAddress3?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeAddress4?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeCity?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeCode?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeCodeNumber?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeCodeNumberWithExtension?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeCountryCode?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeMailBoxNumber?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeMailGroup?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeMailGroupCode?: InputMaybe<Order_By>;
  BusinessPrimaryOfficePhoneCountry?: InputMaybe<Order_By>;
  BusinessPrimaryOfficePhoneExtension?: InputMaybe<Order_By>;
  BusinessPrimaryOfficePhoneNumber?: InputMaybe<Order_By>;
  BusinessPrimaryOfficePhoneNumberFull?: InputMaybe<Order_By>;
  BusinessPrimaryOfficePhoneinternalOfficeNumber?: InputMaybe<Order_By>;
  BusinessPrimaryOfficePhoneinternalOfficeNumberFull?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeState?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeZip?: InputMaybe<Order_By>;
  BusinessSecondaryOffice?: InputMaybe<Order_By>;
  BusinessSecondaryOfficeCode?: InputMaybe<Order_By>;
  BusinessSecondaryOfficeCodeNumber?: InputMaybe<Order_By>;
  BusinessSecondaryOfficeCodeNumberWithExtension?: InputMaybe<Order_By>;
  BusinessSecondaryOfficePhoneCountry?: InputMaybe<Order_By>;
  BusinessSecondaryOfficePhoneExtension?: InputMaybe<Order_By>;
  BusinessSecondaryOfficePhoneNumber?: InputMaybe<Order_By>;
  BusinessSecondaryOfficePhoneNumberFull?: InputMaybe<Order_By>;
  BusinessSecondaryOfficePhoneinternalOfficeNumber?: InputMaybe<Order_By>;
  BusinessSecondaryOfficePhoneinternalOfficeNumberFull?: InputMaybe<Order_By>;
  CellPhoneCountry?: InputMaybe<Order_By>;
  CellPhoneNumber?: InputMaybe<Order_By>;
  CellPhoneNumberFull?: InputMaybe<Order_By>;
  DataCenterRegion?: InputMaybe<Order_By>;
  DataSource?: InputMaybe<Order_By>;
  DateAccessRemoveKey?: InputMaybe<Order_By>;
  DateAssociationKey?: InputMaybe<Order_By>;
  DateBirthKey?: InputMaybe<Order_By>;
  DateCounselKey?: InputMaybe<Order_By>;
  DateHireAdjustedKey?: InputMaybe<Order_By>;
  DateHireKey?: InputMaybe<Order_By>;
  DateOfCounselKey?: InputMaybe<Order_By>;
  DatePartnershipKey?: InputMaybe<Order_By>;
  DateRehireExpirationKey?: InputMaybe<Order_By>;
  DateRehireKey?: InputMaybe<Order_By>;
  DateRemoteWorkingProgramKey?: InputMaybe<Order_By>;
  DateSeniorCounselKey?: InputMaybe<Order_By>;
  DateSpecialCounselKey?: InputMaybe<Order_By>;
  DateTermKey?: InputMaybe<Order_By>;
  DateinternationalPartnerKey?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DesignatedEssentialWorkerIndicator?: InputMaybe<Order_By>;
  DesignatedEssentialWorkerRequiredFormsCompleteIndicator?: InputMaybe<Order_By>;
  DesignatedEssentialWorkerRequiredVideoCompleteIndicator?: InputMaybe<Order_By>;
  DimPersonnelNowKey?: InputMaybe<Order_By>;
  DiscoveryFlag?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLSoftInsertIndicator?: InputMaybe<Order_By>;
  ElitePracticeArea?: InputMaybe<Order_By>;
  ElitePracticeAreaDelimited?: InputMaybe<Order_By>;
  EliteStatus?: InputMaybe<Order_By>;
  EliteSubSubPracticeGroup?: InputMaybe<Order_By>;
  EliteTimekeepLocation?: InputMaybe<Order_By>;
  EliteTitle?: InputMaybe<Order_By>;
  EliteTitleSortOrder?: InputMaybe<Order_By>;
  EliteWorkLocation?: InputMaybe<Order_By>;
  ElitedateHireKey?: InputMaybe<Order_By>;
  ElitedateTermKey?: InputMaybe<Order_By>;
  Email?: InputMaybe<Order_By>;
  EmailSignatureCaveatText?: InputMaybe<Order_By>;
  EmergencyContact1FirstName?: InputMaybe<Order_By>;
  EmergencyContact1HomePhoneCountry?: InputMaybe<Order_By>;
  EmergencyContact1HomePhoneFull?: InputMaybe<Order_By>;
  EmergencyContact1HomePhoneNumber?: InputMaybe<Order_By>;
  EmergencyContact1LastName?: InputMaybe<Order_By>;
  EmergencyContact1MiddleName?: InputMaybe<Order_By>;
  EmergencyContact1NameDisplay?: InputMaybe<Order_By>;
  EmergencyContact1NameFull?: InputMaybe<Order_By>;
  EmergencyContact1WorkPhoneCountry?: InputMaybe<Order_By>;
  EmergencyContact1WorkPhoneExtension?: InputMaybe<Order_By>;
  EmergencyContact1WorkPhoneFull?: InputMaybe<Order_By>;
  EmergencyContact1WorkPhoneNumber?: InputMaybe<Order_By>;
  EmergencyContact2FirstName?: InputMaybe<Order_By>;
  EmergencyContact2HomePhoneCountry?: InputMaybe<Order_By>;
  EmergencyContact2HomePhoneFull?: InputMaybe<Order_By>;
  EmergencyContact2HomePhoneNumber?: InputMaybe<Order_By>;
  EmergencyContact2LastName?: InputMaybe<Order_By>;
  EmergencyContact2MiddleName?: InputMaybe<Order_By>;
  EmergencyContact2NameDisplay?: InputMaybe<Order_By>;
  EmergencyContact2NameFull?: InputMaybe<Order_By>;
  EmergencyContact2WorkPhoneCountry?: InputMaybe<Order_By>;
  EmergencyContact2WorkPhoneExtension?: InputMaybe<Order_By>;
  EmergencyContact2WorkPhoneFull?: InputMaybe<Order_By>;
  EmergencyContact2WorkPhoneNumber?: InputMaybe<Order_By>;
  EmployeeCategoryCode?: InputMaybe<Order_By>;
  EmployeeCategoryDescription?: InputMaybe<Order_By>;
  EmployeeId?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EmployeeTypeFlag?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  EtlCreateddate?: InputMaybe<Order_By>;
  EtlModifieddate?: InputMaybe<Order_By>;
  FullTimeEquivalency?: InputMaybe<Order_By>;
  Gender?: InputMaybe<Order_By>;
  GenderDescription?: InputMaybe<Order_By>;
  GradClassYear?: InputMaybe<Order_By>;
  IsActiveIndicator?: InputMaybe<Order_By>;
  IsBilledByAIC?: InputMaybe<Order_By>;
  IsDMSDenyAccess?: InputMaybe<Order_By>;
  IsExemptIndicator?: InputMaybe<Order_By>;
  IsHRCellPhoneUnlistedIndicator?: InputMaybe<Order_By>;
  IsHREducationYearUnlistedIndicator?: InputMaybe<Order_By>;
  IsHRHomeAddressUnlistedIndicator?: InputMaybe<Order_By>;
  IsHRHomePhoneUnlistedIndicator?: InputMaybe<Order_By>;
  IsHRSpouseUnlistedIndicator?: InputMaybe<Order_By>;
  IsHrDefinedAttorneyIndicator?: InputMaybe<Order_By>;
  IsHrUnlistedIndicator?: InputMaybe<Order_By>;
  IsLateralAttorney?: InputMaybe<Order_By>;
  IsLegalProfessionalIndicator?: InputMaybe<Order_By>;
  JobCode?: InputMaybe<Order_By>;
  JobFamily?: InputMaybe<Order_By>;
  JobFamilyGroup?: InputMaybe<Order_By>;
  LawsonCompany?: InputMaybe<Order_By>;
  LawsonFullTimeEquivalency?: InputMaybe<Order_By>;
  LawsonSecondarySubSubPracticeGroup?: InputMaybe<Order_By>;
  LawsonSubSubPracticeGroup?: InputMaybe<Order_By>;
  LawsondateHireAdjustedKey?: InputMaybe<Order_By>;
  LawsondateHireKey?: InputMaybe<Order_By>;
  LawsondateTermKey?: InputMaybe<Order_By>;
  MLBClassYear?: InputMaybe<Order_By>;
  Manager1EmployeeId?: InputMaybe<Order_By>;
  Manager1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager2EmployeeId?: InputMaybe<Order_By>;
  Manager2EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager3EmployeeId?: InputMaybe<Order_By>;
  Manager3EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager4EmployeeId?: InputMaybe<Order_By>;
  Manager4EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager5EmployeeId?: InputMaybe<Order_By>;
  Manager5EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager6EmployeeId?: InputMaybe<Order_By>;
  Manager6EmployeeIdOriginal?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
  MarsSubSubPracticeGroup?: InputMaybe<Order_By>;
  MarsTitle?: InputMaybe<Order_By>;
  MarsWorkLocation?: InputMaybe<Order_By>;
  MorganNetDisplayIndicator?: InputMaybe<Order_By>;
  NameDisplay?: InputMaybe<Order_By>;
  NameFirst?: InputMaybe<Order_By>;
  NameFirstBilling?: InputMaybe<Order_By>;
  NameFull?: InputMaybe<Order_By>;
  NameInitialsElite?: InputMaybe<Order_By>;
  NameLast?: InputMaybe<Order_By>;
  NameLastBilling?: InputMaybe<Order_By>;
  NameLastNoSuffix?: InputMaybe<Order_By>;
  NameMaidenFirst?: InputMaybe<Order_By>;
  NameMaidenLast?: InputMaybe<Order_By>;
  NameMaidenMiddleInitial?: InputMaybe<Order_By>;
  NameMiddle?: InputMaybe<Order_By>;
  NameMiddleInitial?: InputMaybe<Order_By>;
  NameNick?: InputMaybe<Order_By>;
  NameNickIa?: InputMaybe<Order_By>;
  NamePreferredDisplay?: InputMaybe<Order_By>;
  NamePreferredDisplay_?: InputMaybe<Order_By>;
  NamePreferredFirst?: InputMaybe<Order_By>;
  NamePreferredFull?: InputMaybe<Order_By>;
  NamePreferredLast?: InputMaybe<Order_By>;
  NamePreferredMiddle?: InputMaybe<Order_By>;
  NameSuffix?: InputMaybe<Order_By>;
  NameTDDisplay?: InputMaybe<Order_By>;
  NonFirmOfficeTaxJurisdictionResident?: InputMaybe<Order_By>;
  NonPhiladelphiaResident?: InputMaybe<Order_By>;
  ParalegalTier?: InputMaybe<Order_By>;
  PartnerTypeKey?: InputMaybe<Order_By>;
  PayrollBatchId?: InputMaybe<Order_By>;
  PayrollFileNumber?: InputMaybe<Order_By>;
  PayrollPayGroup?: InputMaybe<Order_By>;
  PersonalAddressFour?: InputMaybe<Order_By>;
  PersonalAddressOne?: InputMaybe<Order_By>;
  PersonalAddressThree?: InputMaybe<Order_By>;
  PersonalAddressTwo?: InputMaybe<Order_By>;
  PersonalCity?: InputMaybe<Order_By>;
  PersonalCountry?: InputMaybe<Order_By>;
  PersonalEmailAddress?: InputMaybe<Order_By>;
  PersonalMatter?: InputMaybe<Order_By>;
  PersonalPhoneCountry?: InputMaybe<Order_By>;
  PersonalPhoneNumber?: InputMaybe<Order_By>;
  PersonalPhoneNumberFull?: InputMaybe<Order_By>;
  PersonalPronouns?: InputMaybe<Order_By>;
  PersonalSecondPhoneCountry?: InputMaybe<Order_By>;
  PersonalSecondPhoneNumber?: InputMaybe<Order_By>;
  PersonalSecondPhoneNumberFull?: InputMaybe<Order_By>;
  PersonalState?: InputMaybe<Order_By>;
  PersonalZip?: InputMaybe<Order_By>;
  PersonnelSourceAbbreviation?: InputMaybe<Order_By>;
  PersonnelSourceName?: InputMaybe<Order_By>;
  PersonnelSourceNumber?: InputMaybe<Order_By>;
  PictureURL?: InputMaybe<Order_By>;
  RateBilling?: InputMaybe<Order_By>;
  RateGrid?: InputMaybe<Order_By>;
  RateStandard?: InputMaybe<Order_By>;
  RehireIndicator?: InputMaybe<Order_By>;
  RemoteWorkingProgramIndicator?: InputMaybe<Order_By>;
  RequiredTime?: InputMaybe<Order_By>;
  Secretary1EmployeeId?: InputMaybe<Order_By>;
  Secretary1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Secretary1FirstName?: InputMaybe<Order_By>;
  Secretary1LastName?: InputMaybe<Order_By>;
  Secretary1MiddleName?: InputMaybe<Order_By>;
  Secretary1NameDisplay?: InputMaybe<Order_By>;
  Secretary1NameFull?: InputMaybe<Order_By>;
  Secretary1NamePreferredDisplay?: InputMaybe<Order_By>;
  Secretary1NamePreferredFull?: InputMaybe<Order_By>;
  Secretary1PhoneExtension?: InputMaybe<Order_By>;
  Secretary2EmployeeId?: InputMaybe<Order_By>;
  Secretary2EmployeeIdOriginal?: InputMaybe<Order_By>;
  Secretary2FirstName?: InputMaybe<Order_By>;
  Secretary2LastName?: InputMaybe<Order_By>;
  Secretary2MiddleName?: InputMaybe<Order_By>;
  Secretary2NameDisplay?: InputMaybe<Order_By>;
  Secretary2NameFull?: InputMaybe<Order_By>;
  Secretary2NamePreferredDisplay?: InputMaybe<Order_By>;
  Secretary2NamePreferredFull?: InputMaybe<Order_By>;
  Secretary2PhoneExtension?: InputMaybe<Order_By>;
  SpouseFirstName?: InputMaybe<Order_By>;
  SpouseLastName?: InputMaybe<Order_By>;
  SpouseMiddleInit?: InputMaybe<Order_By>;
  SpouseNameDisplay?: InputMaybe<Order_By>;
  SpouseNameFull?: InputMaybe<Order_By>;
  StatusActiveEmployeeIndicator?: InputMaybe<Order_By>;
  StatusCode?: InputMaybe<Order_By>;
  StatusDescription?: InputMaybe<Order_By>;
  StatusDescription2?: InputMaybe<Order_By>;
  StatusLabel?: InputMaybe<Order_By>;
  TimeKeeperCostEntryFlag?: InputMaybe<Order_By>;
  TimeKeeperTimeEntryFlag?: InputMaybe<Order_By>;
  TimeReporter?: InputMaybe<Order_By>;
  TimekeeperIndex?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  TitleDisplay?: InputMaybe<Order_By>;
  TitleFullyQualified?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
  dateClerkship?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mlfsl_Personnel_Min_Fields = {
  ActiveDirectoryBusinessCategory?: Maybe<Scalars['String']['output']>;
  ActiveDirectoryDisabledIndicator?: Maybe<Scalars['String']['output']>;
  ActiveDirectoryDistinguishedName?: Maybe<Scalars['String']['output']>;
  ActiveDirectoryEmail?: Maybe<Scalars['String']['output']>;
  ActiveDirectoryHomeDirectory?: Maybe<Scalars['String']['output']>;
  ActiveDirectoryLogin?: Maybe<Scalars['String']['output']>;
  ActiveDirectoryMailboxIndicator?: Maybe<Scalars['String']['output']>;
  ActiveDirectorySEVDepartedIndicator?: Maybe<Scalars['String']['output']>;
  BYODIndicator?: Maybe<Scalars['String']['output']>;
  BarAdmissionFirst?: Maybe<Scalars['String']['output']>;
  BardateFirst?: Maybe<Scalars['datetime']['output']>;
  BillingCoordinatorEmployeeId?: Maybe<Scalars['String']['output']>;
  BlackberryPin?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeAddress1?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeAddress2?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeAddress3?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeCity?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeCode?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeCountryCode?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeState?: Maybe<Scalars['String']['output']>;
  BusinessPostalOfficeZip?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOffice?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeAddress1?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeAddress2?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeAddress3?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeAddress4?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeCity?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeCode?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeCodeNumber?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeCodeNumberWithExtension?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeCountryCode?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeMailBoxNumber?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeMailGroup?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeMailGroupCode?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficePhoneCountry?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficePhoneExtension?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficePhoneNumber?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficePhoneNumberFull?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficePhoneinternalOfficeNumber?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficePhoneinternalOfficeNumberFull?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeState?: Maybe<Scalars['String']['output']>;
  BusinessPrimaryOfficeZip?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOffice?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficeCode?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficeCodeNumber?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficeCodeNumberWithExtension?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficePhoneCountry?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficePhoneExtension?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficePhoneNumber?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficePhoneNumberFull?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficePhoneinternalOfficeNumber?: Maybe<Scalars['String']['output']>;
  BusinessSecondaryOfficePhoneinternalOfficeNumberFull?: Maybe<Scalars['String']['output']>;
  CellPhoneCountry?: Maybe<Scalars['String']['output']>;
  CellPhoneNumber?: Maybe<Scalars['String']['output']>;
  CellPhoneNumberFull?: Maybe<Scalars['String']['output']>;
  DataCenterRegion?: Maybe<Scalars['String']['output']>;
  DataSource?: Maybe<Scalars['String']['output']>;
  DateAccessRemoveKey?: Maybe<Scalars['Int']['output']>;
  DateAssociationKey?: Maybe<Scalars['Int']['output']>;
  DateBirthKey?: Maybe<Scalars['Int']['output']>;
  DateCounselKey?: Maybe<Scalars['Int']['output']>;
  DateHireAdjustedKey?: Maybe<Scalars['Int']['output']>;
  DateHireKey?: Maybe<Scalars['Int']['output']>;
  DateOfCounselKey?: Maybe<Scalars['Int']['output']>;
  DatePartnershipKey?: Maybe<Scalars['Int']['output']>;
  DateRehireExpirationKey?: Maybe<Scalars['Int']['output']>;
  DateRehireKey?: Maybe<Scalars['Int']['output']>;
  DateRemoteWorkingProgramKey?: Maybe<Scalars['Int']['output']>;
  DateSeniorCounselKey?: Maybe<Scalars['Int']['output']>;
  DateSpecialCounselKey?: Maybe<Scalars['Int']['output']>;
  DateTermKey?: Maybe<Scalars['Int']['output']>;
  DateinternationalPartnerKey?: Maybe<Scalars['Int']['output']>;
  DeletedRecordIndicator?: Maybe<Scalars['String']['output']>;
  DesignatedEssentialWorkerIndicator?: Maybe<Scalars['String']['output']>;
  DesignatedEssentialWorkerRequiredFormsCompleteIndicator?: Maybe<Scalars['String']['output']>;
  DesignatedEssentialWorkerRequiredVideoCompleteIndicator?: Maybe<Scalars['String']['output']>;
  DimPersonnelNowKey?: Maybe<Scalars['Int']['output']>;
  DiscoveryFlag?: Maybe<Scalars['Int']['output']>;
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  ETLSoftInsertIndicator?: Maybe<Scalars['String']['output']>;
  ElitePracticeArea?: Maybe<Scalars['String']['output']>;
  ElitePracticeAreaDelimited?: Maybe<Scalars['String']['output']>;
  EliteStatus?: Maybe<Scalars['String']['output']>;
  EliteSubSubPracticeGroup?: Maybe<Scalars['String']['output']>;
  EliteTimekeepLocation?: Maybe<Scalars['String']['output']>;
  EliteTitle?: Maybe<Scalars['String']['output']>;
  EliteTitleSortOrder?: Maybe<Scalars['Int']['output']>;
  EliteWorkLocation?: Maybe<Scalars['String']['output']>;
  ElitedateHireKey?: Maybe<Scalars['Int']['output']>;
  ElitedateTermKey?: Maybe<Scalars['Int']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  EmailSignatureCaveatText?: Maybe<Scalars['String']['output']>;
  EmergencyContact1FirstName?: Maybe<Scalars['String']['output']>;
  EmergencyContact1HomePhoneCountry?: Maybe<Scalars['String']['output']>;
  EmergencyContact1HomePhoneFull?: Maybe<Scalars['String']['output']>;
  EmergencyContact1HomePhoneNumber?: Maybe<Scalars['String']['output']>;
  EmergencyContact1LastName?: Maybe<Scalars['String']['output']>;
  EmergencyContact1MiddleName?: Maybe<Scalars['String']['output']>;
  EmergencyContact1NameDisplay?: Maybe<Scalars['String']['output']>;
  EmergencyContact1NameFull?: Maybe<Scalars['String']['output']>;
  EmergencyContact1WorkPhoneCountry?: Maybe<Scalars['String']['output']>;
  EmergencyContact1WorkPhoneExtension?: Maybe<Scalars['String']['output']>;
  EmergencyContact1WorkPhoneFull?: Maybe<Scalars['String']['output']>;
  EmergencyContact1WorkPhoneNumber?: Maybe<Scalars['String']['output']>;
  EmergencyContact2FirstName?: Maybe<Scalars['String']['output']>;
  EmergencyContact2HomePhoneCountry?: Maybe<Scalars['String']['output']>;
  EmergencyContact2HomePhoneFull?: Maybe<Scalars['String']['output']>;
  EmergencyContact2HomePhoneNumber?: Maybe<Scalars['String']['output']>;
  EmergencyContact2LastName?: Maybe<Scalars['String']['output']>;
  EmergencyContact2MiddleName?: Maybe<Scalars['String']['output']>;
  EmergencyContact2NameDisplay?: Maybe<Scalars['String']['output']>;
  EmergencyContact2NameFull?: Maybe<Scalars['String']['output']>;
  EmergencyContact2WorkPhoneCountry?: Maybe<Scalars['String']['output']>;
  EmergencyContact2WorkPhoneExtension?: Maybe<Scalars['String']['output']>;
  EmergencyContact2WorkPhoneFull?: Maybe<Scalars['String']['output']>;
  EmergencyContact2WorkPhoneNumber?: Maybe<Scalars['String']['output']>;
  EmployeeCategoryCode?: Maybe<Scalars['String']['output']>;
  EmployeeCategoryDescription?: Maybe<Scalars['String']['output']>;
  EmployeeId?: Maybe<Scalars['String']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  EmployeeTypeFlag?: Maybe<Scalars['String']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
  EtlCreateddate?: Maybe<Scalars['datetime']['output']>;
  EtlModifieddate?: Maybe<Scalars['datetime']['output']>;
  FullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  Gender?: Maybe<Scalars['String']['output']>;
  GenderDescription?: Maybe<Scalars['String']['output']>;
  GradClassYear?: Maybe<Scalars['String']['output']>;
  IsActiveIndicator?: Maybe<Scalars['Int']['output']>;
  IsBilledByAIC?: Maybe<Scalars['String']['output']>;
  IsDMSDenyAccess?: Maybe<Scalars['String']['output']>;
  IsExemptIndicator?: Maybe<Scalars['String']['output']>;
  IsHRCellPhoneUnlistedIndicator?: Maybe<Scalars['String']['output']>;
  IsHREducationYearUnlistedIndicator?: Maybe<Scalars['String']['output']>;
  IsHRHomeAddressUnlistedIndicator?: Maybe<Scalars['String']['output']>;
  IsHRHomePhoneUnlistedIndicator?: Maybe<Scalars['String']['output']>;
  IsHRSpouseUnlistedIndicator?: Maybe<Scalars['String']['output']>;
  IsHrDefinedAttorneyIndicator?: Maybe<Scalars['String']['output']>;
  IsHrUnlistedIndicator?: Maybe<Scalars['String']['output']>;
  IsLateralAttorney?: Maybe<Scalars['String']['output']>;
  IsLegalProfessionalIndicator?: Maybe<Scalars['String']['output']>;
  JobCode?: Maybe<Scalars['String']['output']>;
  JobFamily?: Maybe<Scalars['String']['output']>;
  JobFamilyGroup?: Maybe<Scalars['String']['output']>;
  LawsonCompany?: Maybe<Scalars['Int']['output']>;
  LawsonFullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  LawsonSecondarySubSubPracticeGroup?: Maybe<Scalars['String']['output']>;
  LawsonSubSubPracticeGroup?: Maybe<Scalars['String']['output']>;
  LawsondateHireAdjustedKey?: Maybe<Scalars['Int']['output']>;
  LawsondateHireKey?: Maybe<Scalars['Int']['output']>;
  LawsondateTermKey?: Maybe<Scalars['Int']['output']>;
  MLBClassYear?: Maybe<Scalars['String']['output']>;
  Manager1EmployeeId?: Maybe<Scalars['String']['output']>;
  Manager1EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Manager2EmployeeId?: Maybe<Scalars['String']['output']>;
  Manager2EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Manager3EmployeeId?: Maybe<Scalars['String']['output']>;
  Manager3EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Manager4EmployeeId?: Maybe<Scalars['String']['output']>;
  Manager4EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Manager5EmployeeId?: Maybe<Scalars['String']['output']>;
  Manager5EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Manager6EmployeeId?: Maybe<Scalars['String']['output']>;
  Manager6EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  MarsPersonID?: Maybe<Scalars['Int']['output']>;
  MarsSubSubPracticeGroup?: Maybe<Scalars['String']['output']>;
  MarsTitle?: Maybe<Scalars['String']['output']>;
  MarsWorkLocation?: Maybe<Scalars['String']['output']>;
  MorganNetDisplayIndicator?: Maybe<Scalars['Int']['output']>;
  NameDisplay?: Maybe<Scalars['String']['output']>;
  NameFirst?: Maybe<Scalars['String']['output']>;
  NameFirstBilling?: Maybe<Scalars['String']['output']>;
  NameFull?: Maybe<Scalars['String']['output']>;
  NameInitialsElite?: Maybe<Scalars['String']['output']>;
  NameLast?: Maybe<Scalars['String']['output']>;
  NameLastBilling?: Maybe<Scalars['String']['output']>;
  NameLastNoSuffix?: Maybe<Scalars['String']['output']>;
  NameMaidenFirst?: Maybe<Scalars['String']['output']>;
  NameMaidenLast?: Maybe<Scalars['String']['output']>;
  NameMaidenMiddleInitial?: Maybe<Scalars['String']['output']>;
  NameMiddle?: Maybe<Scalars['String']['output']>;
  NameMiddleInitial?: Maybe<Scalars['String']['output']>;
  NameNick?: Maybe<Scalars['String']['output']>;
  NameNickIa?: Maybe<Scalars['String']['output']>;
  NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  NamePreferredDisplay_?: Maybe<Scalars['String']['output']>;
  NamePreferredFirst?: Maybe<Scalars['String']['output']>;
  NamePreferredFull?: Maybe<Scalars['String']['output']>;
  NamePreferredLast?: Maybe<Scalars['String']['output']>;
  NamePreferredMiddle?: Maybe<Scalars['String']['output']>;
  NameSuffix?: Maybe<Scalars['String']['output']>;
  NameTDDisplay?: Maybe<Scalars['String']['output']>;
  NonFirmOfficeTaxJurisdictionResident?: Maybe<Scalars['String']['output']>;
  NonPhiladelphiaResident?: Maybe<Scalars['String']['output']>;
  ParalegalTier?: Maybe<Scalars['String']['output']>;
  PartnerTypeKey?: Maybe<Scalars['Int']['output']>;
  PayrollBatchId?: Maybe<Scalars['String']['output']>;
  PayrollFileNumber?: Maybe<Scalars['String']['output']>;
  PayrollPayGroup?: Maybe<Scalars['String']['output']>;
  PersonalAddressFour?: Maybe<Scalars['String']['output']>;
  PersonalAddressOne?: Maybe<Scalars['String']['output']>;
  PersonalAddressThree?: Maybe<Scalars['String']['output']>;
  PersonalAddressTwo?: Maybe<Scalars['String']['output']>;
  PersonalCity?: Maybe<Scalars['String']['output']>;
  PersonalCountry?: Maybe<Scalars['String']['output']>;
  PersonalEmailAddress?: Maybe<Scalars['String']['output']>;
  PersonalMatter?: Maybe<Scalars['String']['output']>;
  PersonalPhoneCountry?: Maybe<Scalars['String']['output']>;
  PersonalPhoneNumber?: Maybe<Scalars['String']['output']>;
  PersonalPhoneNumberFull?: Maybe<Scalars['String']['output']>;
  PersonalPronouns?: Maybe<Scalars['String']['output']>;
  PersonalSecondPhoneCountry?: Maybe<Scalars['String']['output']>;
  PersonalSecondPhoneNumber?: Maybe<Scalars['String']['output']>;
  PersonalSecondPhoneNumberFull?: Maybe<Scalars['String']['output']>;
  PersonalState?: Maybe<Scalars['String']['output']>;
  PersonalZip?: Maybe<Scalars['String']['output']>;
  PersonnelSourceAbbreviation?: Maybe<Scalars['String']['output']>;
  PersonnelSourceName?: Maybe<Scalars['String']['output']>;
  PersonnelSourceNumber?: Maybe<Scalars['String']['output']>;
  PictureURL?: Maybe<Scalars['String']['output']>;
  RateBilling?: Maybe<Scalars['Float']['output']>;
  RateGrid?: Maybe<Scalars['Float']['output']>;
  RateStandard?: Maybe<Scalars['Float']['output']>;
  RehireIndicator?: Maybe<Scalars['String']['output']>;
  RemoteWorkingProgramIndicator?: Maybe<Scalars['String']['output']>;
  RequiredTime?: Maybe<Scalars['String']['output']>;
  Secretary1EmployeeId?: Maybe<Scalars['String']['output']>;
  Secretary1EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Secretary1FirstName?: Maybe<Scalars['String']['output']>;
  Secretary1LastName?: Maybe<Scalars['String']['output']>;
  Secretary1MiddleName?: Maybe<Scalars['String']['output']>;
  Secretary1NameDisplay?: Maybe<Scalars['String']['output']>;
  Secretary1NameFull?: Maybe<Scalars['String']['output']>;
  Secretary1NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  Secretary1NamePreferredFull?: Maybe<Scalars['String']['output']>;
  Secretary1PhoneExtension?: Maybe<Scalars['String']['output']>;
  Secretary2EmployeeId?: Maybe<Scalars['String']['output']>;
  Secretary2EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Secretary2FirstName?: Maybe<Scalars['String']['output']>;
  Secretary2LastName?: Maybe<Scalars['String']['output']>;
  Secretary2MiddleName?: Maybe<Scalars['String']['output']>;
  Secretary2NameDisplay?: Maybe<Scalars['String']['output']>;
  Secretary2NameFull?: Maybe<Scalars['String']['output']>;
  Secretary2NamePreferredDisplay?: Maybe<Scalars['String']['output']>;
  Secretary2NamePreferredFull?: Maybe<Scalars['String']['output']>;
  Secretary2PhoneExtension?: Maybe<Scalars['String']['output']>;
  SpouseFirstName?: Maybe<Scalars['String']['output']>;
  SpouseLastName?: Maybe<Scalars['String']['output']>;
  SpouseMiddleInit?: Maybe<Scalars['String']['output']>;
  SpouseNameDisplay?: Maybe<Scalars['String']['output']>;
  SpouseNameFull?: Maybe<Scalars['String']['output']>;
  StatusActiveEmployeeIndicator?: Maybe<Scalars['Int']['output']>;
  StatusCode?: Maybe<Scalars['String']['output']>;
  StatusDescription?: Maybe<Scalars['String']['output']>;
  StatusDescription2?: Maybe<Scalars['String']['output']>;
  StatusLabel?: Maybe<Scalars['String']['output']>;
  TimeKeeperCostEntryFlag?: Maybe<Scalars['String']['output']>;
  TimeKeeperTimeEntryFlag?: Maybe<Scalars['String']['output']>;
  TimeReporter?: Maybe<Scalars['String']['output']>;
  TimekeeperIndex?: Maybe<Scalars['Int']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  TitleDisplay?: Maybe<Scalars['String']['output']>;
  TitleFullyQualified?: Maybe<Scalars['String']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Int']['output']>;
  dateClerkship?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Min_Order_By = {
  ActiveDirectoryBusinessCategory?: InputMaybe<Order_By>;
  ActiveDirectoryDisabledIndicator?: InputMaybe<Order_By>;
  ActiveDirectoryDistinguishedName?: InputMaybe<Order_By>;
  ActiveDirectoryEmail?: InputMaybe<Order_By>;
  ActiveDirectoryHomeDirectory?: InputMaybe<Order_By>;
  ActiveDirectoryLogin?: InputMaybe<Order_By>;
  ActiveDirectoryMailboxIndicator?: InputMaybe<Order_By>;
  ActiveDirectorySEVDepartedIndicator?: InputMaybe<Order_By>;
  BYODIndicator?: InputMaybe<Order_By>;
  BarAdmissionFirst?: InputMaybe<Order_By>;
  BardateFirst?: InputMaybe<Order_By>;
  BillingCoordinatorEmployeeId?: InputMaybe<Order_By>;
  BlackberryPin?: InputMaybe<Order_By>;
  BusinessPostalOfficeAddress1?: InputMaybe<Order_By>;
  BusinessPostalOfficeAddress2?: InputMaybe<Order_By>;
  BusinessPostalOfficeAddress3?: InputMaybe<Order_By>;
  BusinessPostalOfficeCity?: InputMaybe<Order_By>;
  BusinessPostalOfficeCode?: InputMaybe<Order_By>;
  BusinessPostalOfficeCountryCode?: InputMaybe<Order_By>;
  BusinessPostalOfficeState?: InputMaybe<Order_By>;
  BusinessPostalOfficeZip?: InputMaybe<Order_By>;
  BusinessPrimaryOffice?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeAddress1?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeAddress2?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeAddress3?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeAddress4?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeCity?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeCode?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeCodeNumber?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeCodeNumberWithExtension?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeCountryCode?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeMailBoxNumber?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeMailGroup?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeMailGroupCode?: InputMaybe<Order_By>;
  BusinessPrimaryOfficePhoneCountry?: InputMaybe<Order_By>;
  BusinessPrimaryOfficePhoneExtension?: InputMaybe<Order_By>;
  BusinessPrimaryOfficePhoneNumber?: InputMaybe<Order_By>;
  BusinessPrimaryOfficePhoneNumberFull?: InputMaybe<Order_By>;
  BusinessPrimaryOfficePhoneinternalOfficeNumber?: InputMaybe<Order_By>;
  BusinessPrimaryOfficePhoneinternalOfficeNumberFull?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeState?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeZip?: InputMaybe<Order_By>;
  BusinessSecondaryOffice?: InputMaybe<Order_By>;
  BusinessSecondaryOfficeCode?: InputMaybe<Order_By>;
  BusinessSecondaryOfficeCodeNumber?: InputMaybe<Order_By>;
  BusinessSecondaryOfficeCodeNumberWithExtension?: InputMaybe<Order_By>;
  BusinessSecondaryOfficePhoneCountry?: InputMaybe<Order_By>;
  BusinessSecondaryOfficePhoneExtension?: InputMaybe<Order_By>;
  BusinessSecondaryOfficePhoneNumber?: InputMaybe<Order_By>;
  BusinessSecondaryOfficePhoneNumberFull?: InputMaybe<Order_By>;
  BusinessSecondaryOfficePhoneinternalOfficeNumber?: InputMaybe<Order_By>;
  BusinessSecondaryOfficePhoneinternalOfficeNumberFull?: InputMaybe<Order_By>;
  CellPhoneCountry?: InputMaybe<Order_By>;
  CellPhoneNumber?: InputMaybe<Order_By>;
  CellPhoneNumberFull?: InputMaybe<Order_By>;
  DataCenterRegion?: InputMaybe<Order_By>;
  DataSource?: InputMaybe<Order_By>;
  DateAccessRemoveKey?: InputMaybe<Order_By>;
  DateAssociationKey?: InputMaybe<Order_By>;
  DateBirthKey?: InputMaybe<Order_By>;
  DateCounselKey?: InputMaybe<Order_By>;
  DateHireAdjustedKey?: InputMaybe<Order_By>;
  DateHireKey?: InputMaybe<Order_By>;
  DateOfCounselKey?: InputMaybe<Order_By>;
  DatePartnershipKey?: InputMaybe<Order_By>;
  DateRehireExpirationKey?: InputMaybe<Order_By>;
  DateRehireKey?: InputMaybe<Order_By>;
  DateRemoteWorkingProgramKey?: InputMaybe<Order_By>;
  DateSeniorCounselKey?: InputMaybe<Order_By>;
  DateSpecialCounselKey?: InputMaybe<Order_By>;
  DateTermKey?: InputMaybe<Order_By>;
  DateinternationalPartnerKey?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DesignatedEssentialWorkerIndicator?: InputMaybe<Order_By>;
  DesignatedEssentialWorkerRequiredFormsCompleteIndicator?: InputMaybe<Order_By>;
  DesignatedEssentialWorkerRequiredVideoCompleteIndicator?: InputMaybe<Order_By>;
  DimPersonnelNowKey?: InputMaybe<Order_By>;
  DiscoveryFlag?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLSoftInsertIndicator?: InputMaybe<Order_By>;
  ElitePracticeArea?: InputMaybe<Order_By>;
  ElitePracticeAreaDelimited?: InputMaybe<Order_By>;
  EliteStatus?: InputMaybe<Order_By>;
  EliteSubSubPracticeGroup?: InputMaybe<Order_By>;
  EliteTimekeepLocation?: InputMaybe<Order_By>;
  EliteTitle?: InputMaybe<Order_By>;
  EliteTitleSortOrder?: InputMaybe<Order_By>;
  EliteWorkLocation?: InputMaybe<Order_By>;
  ElitedateHireKey?: InputMaybe<Order_By>;
  ElitedateTermKey?: InputMaybe<Order_By>;
  Email?: InputMaybe<Order_By>;
  EmailSignatureCaveatText?: InputMaybe<Order_By>;
  EmergencyContact1FirstName?: InputMaybe<Order_By>;
  EmergencyContact1HomePhoneCountry?: InputMaybe<Order_By>;
  EmergencyContact1HomePhoneFull?: InputMaybe<Order_By>;
  EmergencyContact1HomePhoneNumber?: InputMaybe<Order_By>;
  EmergencyContact1LastName?: InputMaybe<Order_By>;
  EmergencyContact1MiddleName?: InputMaybe<Order_By>;
  EmergencyContact1NameDisplay?: InputMaybe<Order_By>;
  EmergencyContact1NameFull?: InputMaybe<Order_By>;
  EmergencyContact1WorkPhoneCountry?: InputMaybe<Order_By>;
  EmergencyContact1WorkPhoneExtension?: InputMaybe<Order_By>;
  EmergencyContact1WorkPhoneFull?: InputMaybe<Order_By>;
  EmergencyContact1WorkPhoneNumber?: InputMaybe<Order_By>;
  EmergencyContact2FirstName?: InputMaybe<Order_By>;
  EmergencyContact2HomePhoneCountry?: InputMaybe<Order_By>;
  EmergencyContact2HomePhoneFull?: InputMaybe<Order_By>;
  EmergencyContact2HomePhoneNumber?: InputMaybe<Order_By>;
  EmergencyContact2LastName?: InputMaybe<Order_By>;
  EmergencyContact2MiddleName?: InputMaybe<Order_By>;
  EmergencyContact2NameDisplay?: InputMaybe<Order_By>;
  EmergencyContact2NameFull?: InputMaybe<Order_By>;
  EmergencyContact2WorkPhoneCountry?: InputMaybe<Order_By>;
  EmergencyContact2WorkPhoneExtension?: InputMaybe<Order_By>;
  EmergencyContact2WorkPhoneFull?: InputMaybe<Order_By>;
  EmergencyContact2WorkPhoneNumber?: InputMaybe<Order_By>;
  EmployeeCategoryCode?: InputMaybe<Order_By>;
  EmployeeCategoryDescription?: InputMaybe<Order_By>;
  EmployeeId?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EmployeeTypeFlag?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  EtlCreateddate?: InputMaybe<Order_By>;
  EtlModifieddate?: InputMaybe<Order_By>;
  FullTimeEquivalency?: InputMaybe<Order_By>;
  Gender?: InputMaybe<Order_By>;
  GenderDescription?: InputMaybe<Order_By>;
  GradClassYear?: InputMaybe<Order_By>;
  IsActiveIndicator?: InputMaybe<Order_By>;
  IsBilledByAIC?: InputMaybe<Order_By>;
  IsDMSDenyAccess?: InputMaybe<Order_By>;
  IsExemptIndicator?: InputMaybe<Order_By>;
  IsHRCellPhoneUnlistedIndicator?: InputMaybe<Order_By>;
  IsHREducationYearUnlistedIndicator?: InputMaybe<Order_By>;
  IsHRHomeAddressUnlistedIndicator?: InputMaybe<Order_By>;
  IsHRHomePhoneUnlistedIndicator?: InputMaybe<Order_By>;
  IsHRSpouseUnlistedIndicator?: InputMaybe<Order_By>;
  IsHrDefinedAttorneyIndicator?: InputMaybe<Order_By>;
  IsHrUnlistedIndicator?: InputMaybe<Order_By>;
  IsLateralAttorney?: InputMaybe<Order_By>;
  IsLegalProfessionalIndicator?: InputMaybe<Order_By>;
  JobCode?: InputMaybe<Order_By>;
  JobFamily?: InputMaybe<Order_By>;
  JobFamilyGroup?: InputMaybe<Order_By>;
  LawsonCompany?: InputMaybe<Order_By>;
  LawsonFullTimeEquivalency?: InputMaybe<Order_By>;
  LawsonSecondarySubSubPracticeGroup?: InputMaybe<Order_By>;
  LawsonSubSubPracticeGroup?: InputMaybe<Order_By>;
  LawsondateHireAdjustedKey?: InputMaybe<Order_By>;
  LawsondateHireKey?: InputMaybe<Order_By>;
  LawsondateTermKey?: InputMaybe<Order_By>;
  MLBClassYear?: InputMaybe<Order_By>;
  Manager1EmployeeId?: InputMaybe<Order_By>;
  Manager1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager2EmployeeId?: InputMaybe<Order_By>;
  Manager2EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager3EmployeeId?: InputMaybe<Order_By>;
  Manager3EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager4EmployeeId?: InputMaybe<Order_By>;
  Manager4EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager5EmployeeId?: InputMaybe<Order_By>;
  Manager5EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager6EmployeeId?: InputMaybe<Order_By>;
  Manager6EmployeeIdOriginal?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
  MarsSubSubPracticeGroup?: InputMaybe<Order_By>;
  MarsTitle?: InputMaybe<Order_By>;
  MarsWorkLocation?: InputMaybe<Order_By>;
  MorganNetDisplayIndicator?: InputMaybe<Order_By>;
  NameDisplay?: InputMaybe<Order_By>;
  NameFirst?: InputMaybe<Order_By>;
  NameFirstBilling?: InputMaybe<Order_By>;
  NameFull?: InputMaybe<Order_By>;
  NameInitialsElite?: InputMaybe<Order_By>;
  NameLast?: InputMaybe<Order_By>;
  NameLastBilling?: InputMaybe<Order_By>;
  NameLastNoSuffix?: InputMaybe<Order_By>;
  NameMaidenFirst?: InputMaybe<Order_By>;
  NameMaidenLast?: InputMaybe<Order_By>;
  NameMaidenMiddleInitial?: InputMaybe<Order_By>;
  NameMiddle?: InputMaybe<Order_By>;
  NameMiddleInitial?: InputMaybe<Order_By>;
  NameNick?: InputMaybe<Order_By>;
  NameNickIa?: InputMaybe<Order_By>;
  NamePreferredDisplay?: InputMaybe<Order_By>;
  NamePreferredDisplay_?: InputMaybe<Order_By>;
  NamePreferredFirst?: InputMaybe<Order_By>;
  NamePreferredFull?: InputMaybe<Order_By>;
  NamePreferredLast?: InputMaybe<Order_By>;
  NamePreferredMiddle?: InputMaybe<Order_By>;
  NameSuffix?: InputMaybe<Order_By>;
  NameTDDisplay?: InputMaybe<Order_By>;
  NonFirmOfficeTaxJurisdictionResident?: InputMaybe<Order_By>;
  NonPhiladelphiaResident?: InputMaybe<Order_By>;
  ParalegalTier?: InputMaybe<Order_By>;
  PartnerTypeKey?: InputMaybe<Order_By>;
  PayrollBatchId?: InputMaybe<Order_By>;
  PayrollFileNumber?: InputMaybe<Order_By>;
  PayrollPayGroup?: InputMaybe<Order_By>;
  PersonalAddressFour?: InputMaybe<Order_By>;
  PersonalAddressOne?: InputMaybe<Order_By>;
  PersonalAddressThree?: InputMaybe<Order_By>;
  PersonalAddressTwo?: InputMaybe<Order_By>;
  PersonalCity?: InputMaybe<Order_By>;
  PersonalCountry?: InputMaybe<Order_By>;
  PersonalEmailAddress?: InputMaybe<Order_By>;
  PersonalMatter?: InputMaybe<Order_By>;
  PersonalPhoneCountry?: InputMaybe<Order_By>;
  PersonalPhoneNumber?: InputMaybe<Order_By>;
  PersonalPhoneNumberFull?: InputMaybe<Order_By>;
  PersonalPronouns?: InputMaybe<Order_By>;
  PersonalSecondPhoneCountry?: InputMaybe<Order_By>;
  PersonalSecondPhoneNumber?: InputMaybe<Order_By>;
  PersonalSecondPhoneNumberFull?: InputMaybe<Order_By>;
  PersonalState?: InputMaybe<Order_By>;
  PersonalZip?: InputMaybe<Order_By>;
  PersonnelSourceAbbreviation?: InputMaybe<Order_By>;
  PersonnelSourceName?: InputMaybe<Order_By>;
  PersonnelSourceNumber?: InputMaybe<Order_By>;
  PictureURL?: InputMaybe<Order_By>;
  RateBilling?: InputMaybe<Order_By>;
  RateGrid?: InputMaybe<Order_By>;
  RateStandard?: InputMaybe<Order_By>;
  RehireIndicator?: InputMaybe<Order_By>;
  RemoteWorkingProgramIndicator?: InputMaybe<Order_By>;
  RequiredTime?: InputMaybe<Order_By>;
  Secretary1EmployeeId?: InputMaybe<Order_By>;
  Secretary1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Secretary1FirstName?: InputMaybe<Order_By>;
  Secretary1LastName?: InputMaybe<Order_By>;
  Secretary1MiddleName?: InputMaybe<Order_By>;
  Secretary1NameDisplay?: InputMaybe<Order_By>;
  Secretary1NameFull?: InputMaybe<Order_By>;
  Secretary1NamePreferredDisplay?: InputMaybe<Order_By>;
  Secretary1NamePreferredFull?: InputMaybe<Order_By>;
  Secretary1PhoneExtension?: InputMaybe<Order_By>;
  Secretary2EmployeeId?: InputMaybe<Order_By>;
  Secretary2EmployeeIdOriginal?: InputMaybe<Order_By>;
  Secretary2FirstName?: InputMaybe<Order_By>;
  Secretary2LastName?: InputMaybe<Order_By>;
  Secretary2MiddleName?: InputMaybe<Order_By>;
  Secretary2NameDisplay?: InputMaybe<Order_By>;
  Secretary2NameFull?: InputMaybe<Order_By>;
  Secretary2NamePreferredDisplay?: InputMaybe<Order_By>;
  Secretary2NamePreferredFull?: InputMaybe<Order_By>;
  Secretary2PhoneExtension?: InputMaybe<Order_By>;
  SpouseFirstName?: InputMaybe<Order_By>;
  SpouseLastName?: InputMaybe<Order_By>;
  SpouseMiddleInit?: InputMaybe<Order_By>;
  SpouseNameDisplay?: InputMaybe<Order_By>;
  SpouseNameFull?: InputMaybe<Order_By>;
  StatusActiveEmployeeIndicator?: InputMaybe<Order_By>;
  StatusCode?: InputMaybe<Order_By>;
  StatusDescription?: InputMaybe<Order_By>;
  StatusDescription2?: InputMaybe<Order_By>;
  StatusLabel?: InputMaybe<Order_By>;
  TimeKeeperCostEntryFlag?: InputMaybe<Order_By>;
  TimeKeeperTimeEntryFlag?: InputMaybe<Order_By>;
  TimeReporter?: InputMaybe<Order_By>;
  TimekeeperIndex?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  TitleDisplay?: InputMaybe<Order_By>;
  TitleFullyQualified?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
  dateClerkship?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "repl.DimPersonnelNow". */
export type Mlfsl_Personnel_Order_By = {
  ActiveDirectoryBusinessCategory?: InputMaybe<Order_By>;
  ActiveDirectoryDisabledIndicator?: InputMaybe<Order_By>;
  ActiveDirectoryDistinguishedName?: InputMaybe<Order_By>;
  ActiveDirectoryEmail?: InputMaybe<Order_By>;
  ActiveDirectoryHomeDirectory?: InputMaybe<Order_By>;
  ActiveDirectoryLogin?: InputMaybe<Order_By>;
  ActiveDirectoryMailboxIndicator?: InputMaybe<Order_By>;
  ActiveDirectorySEVDepartedIndicator?: InputMaybe<Order_By>;
  BYODIndicator?: InputMaybe<Order_By>;
  BarAdmissionFirst?: InputMaybe<Order_By>;
  BardateFirst?: InputMaybe<Order_By>;
  BillingCoordinatorEmployeeId?: InputMaybe<Order_By>;
  BlackberryPin?: InputMaybe<Order_By>;
  BusinessPostalOfficeAddress1?: InputMaybe<Order_By>;
  BusinessPostalOfficeAddress2?: InputMaybe<Order_By>;
  BusinessPostalOfficeAddress3?: InputMaybe<Order_By>;
  BusinessPostalOfficeCity?: InputMaybe<Order_By>;
  BusinessPostalOfficeCode?: InputMaybe<Order_By>;
  BusinessPostalOfficeCountryCode?: InputMaybe<Order_By>;
  BusinessPostalOfficeState?: InputMaybe<Order_By>;
  BusinessPostalOfficeZip?: InputMaybe<Order_By>;
  BusinessPrimaryOffice?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeAddress1?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeAddress2?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeAddress3?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeAddress4?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeCity?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeCode?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeCodeNumber?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeCodeNumberWithExtension?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeCountryCode?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeMailBoxNumber?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeMailGroup?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeMailGroupCode?: InputMaybe<Order_By>;
  BusinessPrimaryOfficePhoneCountry?: InputMaybe<Order_By>;
  BusinessPrimaryOfficePhoneExtension?: InputMaybe<Order_By>;
  BusinessPrimaryOfficePhoneNumber?: InputMaybe<Order_By>;
  BusinessPrimaryOfficePhoneNumberFull?: InputMaybe<Order_By>;
  BusinessPrimaryOfficePhoneinternalOfficeNumber?: InputMaybe<Order_By>;
  BusinessPrimaryOfficePhoneinternalOfficeNumberFull?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeState?: InputMaybe<Order_By>;
  BusinessPrimaryOfficeZip?: InputMaybe<Order_By>;
  BusinessSecondaryOffice?: InputMaybe<Order_By>;
  BusinessSecondaryOfficeCode?: InputMaybe<Order_By>;
  BusinessSecondaryOfficeCodeNumber?: InputMaybe<Order_By>;
  BusinessSecondaryOfficeCodeNumberWithExtension?: InputMaybe<Order_By>;
  BusinessSecondaryOfficePhoneCountry?: InputMaybe<Order_By>;
  BusinessSecondaryOfficePhoneExtension?: InputMaybe<Order_By>;
  BusinessSecondaryOfficePhoneNumber?: InputMaybe<Order_By>;
  BusinessSecondaryOfficePhoneNumberFull?: InputMaybe<Order_By>;
  BusinessSecondaryOfficePhoneinternalOfficeNumber?: InputMaybe<Order_By>;
  BusinessSecondaryOfficePhoneinternalOfficeNumberFull?: InputMaybe<Order_By>;
  CellPhoneCountry?: InputMaybe<Order_By>;
  CellPhoneNumber?: InputMaybe<Order_By>;
  CellPhoneNumberFull?: InputMaybe<Order_By>;
  DataCenterRegion?: InputMaybe<Order_By>;
  DataSource?: InputMaybe<Order_By>;
  DateAccessRemoveKey?: InputMaybe<Order_By>;
  DateAssociationKey?: InputMaybe<Order_By>;
  DateBirthKey?: InputMaybe<Order_By>;
  DateCounselKey?: InputMaybe<Order_By>;
  DateHire?: InputMaybe<Mlfsl_Date_Order_By>;
  DateHireAdjusted?: InputMaybe<Mlfsl_Date_Order_By>;
  DateHireAdjustedKey?: InputMaybe<Order_By>;
  DateHireKey?: InputMaybe<Order_By>;
  DateOfCounselKey?: InputMaybe<Order_By>;
  DatePartnershipKey?: InputMaybe<Order_By>;
  DateRehireExpirationKey?: InputMaybe<Order_By>;
  DateRehireKey?: InputMaybe<Order_By>;
  DateRemoteWorkingProgramKey?: InputMaybe<Order_By>;
  DateSeniorCounselKey?: InputMaybe<Order_By>;
  DateSpecialCounselKey?: InputMaybe<Order_By>;
  DateTerm?: InputMaybe<Mlfsl_Date_Order_By>;
  DateTermKey?: InputMaybe<Order_By>;
  DateinternationalPartnerKey?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DesignatedEssentialWorkerIndicator?: InputMaybe<Order_By>;
  DesignatedEssentialWorkerRequiredFormsCompleteIndicator?: InputMaybe<Order_By>;
  DesignatedEssentialWorkerRequiredVideoCompleteIndicator?: InputMaybe<Order_By>;
  DimPersonnelNowKey?: InputMaybe<Order_By>;
  DiscoveryFlag?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLSoftInsertIndicator?: InputMaybe<Order_By>;
  ElitePracticeArea?: InputMaybe<Order_By>;
  ElitePracticeAreaDelimited?: InputMaybe<Order_By>;
  EliteStatus?: InputMaybe<Order_By>;
  EliteSubSubPracticeGroup?: InputMaybe<Order_By>;
  EliteTimekeepLocation?: InputMaybe<Order_By>;
  EliteTitle?: InputMaybe<Order_By>;
  EliteTitleSortOrder?: InputMaybe<Order_By>;
  EliteWorkLocation?: InputMaybe<Order_By>;
  ElitedateHireKey?: InputMaybe<Order_By>;
  ElitedateTermKey?: InputMaybe<Order_By>;
  Email?: InputMaybe<Order_By>;
  EmailSignatureCaveatText?: InputMaybe<Order_By>;
  EmergencyContact1FirstName?: InputMaybe<Order_By>;
  EmergencyContact1HomePhoneCountry?: InputMaybe<Order_By>;
  EmergencyContact1HomePhoneFull?: InputMaybe<Order_By>;
  EmergencyContact1HomePhoneNumber?: InputMaybe<Order_By>;
  EmergencyContact1LastName?: InputMaybe<Order_By>;
  EmergencyContact1MiddleName?: InputMaybe<Order_By>;
  EmergencyContact1NameDisplay?: InputMaybe<Order_By>;
  EmergencyContact1NameFull?: InputMaybe<Order_By>;
  EmergencyContact1WorkPhoneCountry?: InputMaybe<Order_By>;
  EmergencyContact1WorkPhoneExtension?: InputMaybe<Order_By>;
  EmergencyContact1WorkPhoneFull?: InputMaybe<Order_By>;
  EmergencyContact1WorkPhoneNumber?: InputMaybe<Order_By>;
  EmergencyContact2FirstName?: InputMaybe<Order_By>;
  EmergencyContact2HomePhoneCountry?: InputMaybe<Order_By>;
  EmergencyContact2HomePhoneFull?: InputMaybe<Order_By>;
  EmergencyContact2HomePhoneNumber?: InputMaybe<Order_By>;
  EmergencyContact2LastName?: InputMaybe<Order_By>;
  EmergencyContact2MiddleName?: InputMaybe<Order_By>;
  EmergencyContact2NameDisplay?: InputMaybe<Order_By>;
  EmergencyContact2NameFull?: InputMaybe<Order_By>;
  EmergencyContact2WorkPhoneCountry?: InputMaybe<Order_By>;
  EmergencyContact2WorkPhoneExtension?: InputMaybe<Order_By>;
  EmergencyContact2WorkPhoneFull?: InputMaybe<Order_By>;
  EmergencyContact2WorkPhoneNumber?: InputMaybe<Order_By>;
  EmployeeCategoryCode?: InputMaybe<Order_By>;
  EmployeeCategoryDescription?: InputMaybe<Order_By>;
  EmployeeId?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EmployeeTypeFlag?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  EtlCreateddate?: InputMaybe<Order_By>;
  EtlModifieddate?: InputMaybe<Order_By>;
  FullTimeEquivalency?: InputMaybe<Order_By>;
  Gender?: InputMaybe<Order_By>;
  GenderDescription?: InputMaybe<Order_By>;
  GradClassYear?: InputMaybe<Order_By>;
  GroupJoins_aggregate?: InputMaybe<Mlfsl_Ad_Join_Aggregate_Order_By>;
  IsActiveIndicator?: InputMaybe<Order_By>;
  IsBilledByAIC?: InputMaybe<Order_By>;
  IsDMSDenyAccess?: InputMaybe<Order_By>;
  IsExemptIndicator?: InputMaybe<Order_By>;
  IsHRCellPhoneUnlistedIndicator?: InputMaybe<Order_By>;
  IsHREducationYearUnlistedIndicator?: InputMaybe<Order_By>;
  IsHRHomeAddressUnlistedIndicator?: InputMaybe<Order_By>;
  IsHRHomePhoneUnlistedIndicator?: InputMaybe<Order_By>;
  IsHRSpouseUnlistedIndicator?: InputMaybe<Order_By>;
  IsHrDefinedAttorneyIndicator?: InputMaybe<Order_By>;
  IsHrUnlistedIndicator?: InputMaybe<Order_By>;
  IsLateralAttorney?: InputMaybe<Order_By>;
  IsLegalProfessionalIndicator?: InputMaybe<Order_By>;
  JobCode?: InputMaybe<Order_By>;
  JobFamily?: InputMaybe<Order_By>;
  JobFamilyGroup?: InputMaybe<Order_By>;
  LawsonCompany?: InputMaybe<Order_By>;
  LawsonFullTimeEquivalency?: InputMaybe<Order_By>;
  LawsonSecondarySubSubPracticeGroup?: InputMaybe<Order_By>;
  LawsonSubSubPracticeGroup?: InputMaybe<Order_By>;
  LawsondateHireAdjustedKey?: InputMaybe<Order_By>;
  LawsondateHireKey?: InputMaybe<Order_By>;
  LawsondateTermKey?: InputMaybe<Order_By>;
  Login?: InputMaybe<Mlfsl_Ad_Login_Order_By>;
  MLBClassYear?: InputMaybe<Order_By>;
  Manager1EmployeeId?: InputMaybe<Order_By>;
  Manager1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager2EmployeeId?: InputMaybe<Order_By>;
  Manager2EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager3EmployeeId?: InputMaybe<Order_By>;
  Manager3EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager4EmployeeId?: InputMaybe<Order_By>;
  Manager4EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager5EmployeeId?: InputMaybe<Order_By>;
  Manager5EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager6EmployeeId?: InputMaybe<Order_By>;
  Manager6EmployeeIdOriginal?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
  MarsSubSubPracticeGroup?: InputMaybe<Order_By>;
  MarsTitle?: InputMaybe<Order_By>;
  MarsWorkLocation?: InputMaybe<Order_By>;
  MorganNetDisplayIndicator?: InputMaybe<Order_By>;
  NameDisplay?: InputMaybe<Order_By>;
  NameFirst?: InputMaybe<Order_By>;
  NameFirstBilling?: InputMaybe<Order_By>;
  NameFull?: InputMaybe<Order_By>;
  NameInitialsElite?: InputMaybe<Order_By>;
  NameLast?: InputMaybe<Order_By>;
  NameLastBilling?: InputMaybe<Order_By>;
  NameLastNoSuffix?: InputMaybe<Order_By>;
  NameMaidenFirst?: InputMaybe<Order_By>;
  NameMaidenLast?: InputMaybe<Order_By>;
  NameMaidenMiddleInitial?: InputMaybe<Order_By>;
  NameMiddle?: InputMaybe<Order_By>;
  NameMiddleInitial?: InputMaybe<Order_By>;
  NameNick?: InputMaybe<Order_By>;
  NameNickIa?: InputMaybe<Order_By>;
  NamePreferredDisplay?: InputMaybe<Order_By>;
  NamePreferredDisplay_?: InputMaybe<Order_By>;
  NamePreferredFirst?: InputMaybe<Order_By>;
  NamePreferredFull?: InputMaybe<Order_By>;
  NamePreferredLast?: InputMaybe<Order_By>;
  NamePreferredMiddle?: InputMaybe<Order_By>;
  NameSuffix?: InputMaybe<Order_By>;
  NameTDDisplay?: InputMaybe<Order_By>;
  NonFirmOfficeTaxJurisdictionResident?: InputMaybe<Order_By>;
  NonPhiladelphiaResident?: InputMaybe<Order_By>;
  ParalegalTier?: InputMaybe<Order_By>;
  PartnerTypeKey?: InputMaybe<Order_By>;
  PayrollBatchId?: InputMaybe<Order_By>;
  PayrollFileNumber?: InputMaybe<Order_By>;
  PayrollPayGroup?: InputMaybe<Order_By>;
  PersonEducation_aggregate?: InputMaybe<Mlfsl_Person_Education_Aggregate_Order_By>;
  PersonalAddressFour?: InputMaybe<Order_By>;
  PersonalAddressOne?: InputMaybe<Order_By>;
  PersonalAddressThree?: InputMaybe<Order_By>;
  PersonalAddressTwo?: InputMaybe<Order_By>;
  PersonalCity?: InputMaybe<Order_By>;
  PersonalCountry?: InputMaybe<Order_By>;
  PersonalEmailAddress?: InputMaybe<Order_By>;
  PersonalMatter?: InputMaybe<Order_By>;
  PersonalPhoneCountry?: InputMaybe<Order_By>;
  PersonalPhoneNumber?: InputMaybe<Order_By>;
  PersonalPhoneNumberFull?: InputMaybe<Order_By>;
  PersonalPronouns?: InputMaybe<Order_By>;
  PersonalSecondPhoneCountry?: InputMaybe<Order_By>;
  PersonalSecondPhoneNumber?: InputMaybe<Order_By>;
  PersonalSecondPhoneNumberFull?: InputMaybe<Order_By>;
  PersonalState?: InputMaybe<Order_By>;
  PersonalZip?: InputMaybe<Order_By>;
  PersonnelSourceAbbreviation?: InputMaybe<Order_By>;
  PersonnelSourceName?: InputMaybe<Order_By>;
  PersonnelSourceNumber?: InputMaybe<Order_By>;
  PictureURL?: InputMaybe<Order_By>;
  PrimaryAssistant?: InputMaybe<Mlfsl_Personnel_Order_By>;
  PrimaryOffice?: InputMaybe<Mlfsl_Office_Order_By>;
  PrimaryPracticeGroup?: InputMaybe<Mlfsl_Practicegroup_Order_By>;
  RateBilling?: InputMaybe<Order_By>;
  RateGrid?: InputMaybe<Order_By>;
  RateStandard?: InputMaybe<Order_By>;
  RehireIndicator?: InputMaybe<Order_By>;
  RemoteWorkingProgramIndicator?: InputMaybe<Order_By>;
  RequiredTime?: InputMaybe<Order_By>;
  SecondaryAssistant?: InputMaybe<Mlfsl_Personnel_Order_By>;
  SecondaryOffice?: InputMaybe<Mlfsl_Office_Order_By>;
  SecondaryPracticeGroup?: InputMaybe<Mlfsl_Practicegroup_Order_By>;
  Secretary1EmployeeId?: InputMaybe<Order_By>;
  Secretary1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Secretary1FirstName?: InputMaybe<Order_By>;
  Secretary1LastName?: InputMaybe<Order_By>;
  Secretary1MiddleName?: InputMaybe<Order_By>;
  Secretary1NameDisplay?: InputMaybe<Order_By>;
  Secretary1NameFull?: InputMaybe<Order_By>;
  Secretary1NamePreferredDisplay?: InputMaybe<Order_By>;
  Secretary1NamePreferredFull?: InputMaybe<Order_By>;
  Secretary1PhoneExtension?: InputMaybe<Order_By>;
  Secretary2EmployeeId?: InputMaybe<Order_By>;
  Secretary2EmployeeIdOriginal?: InputMaybe<Order_By>;
  Secretary2FirstName?: InputMaybe<Order_By>;
  Secretary2LastName?: InputMaybe<Order_By>;
  Secretary2MiddleName?: InputMaybe<Order_By>;
  Secretary2NameDisplay?: InputMaybe<Order_By>;
  Secretary2NameFull?: InputMaybe<Order_By>;
  Secretary2NamePreferredDisplay?: InputMaybe<Order_By>;
  Secretary2NamePreferredFull?: InputMaybe<Order_By>;
  Secretary2PhoneExtension?: InputMaybe<Order_By>;
  SpouseFirstName?: InputMaybe<Order_By>;
  SpouseLastName?: InputMaybe<Order_By>;
  SpouseMiddleInit?: InputMaybe<Order_By>;
  SpouseNameDisplay?: InputMaybe<Order_By>;
  SpouseNameFull?: InputMaybe<Order_By>;
  StatusActiveEmployeeIndicator?: InputMaybe<Order_By>;
  StatusCode?: InputMaybe<Order_By>;
  StatusDescription?: InputMaybe<Order_By>;
  StatusDescription2?: InputMaybe<Order_By>;
  StatusLabel?: InputMaybe<Order_By>;
  TimeKeeperCostEntryFlag?: InputMaybe<Order_By>;
  TimeKeeperTimeEntryFlag?: InputMaybe<Order_By>;
  TimeReporter?: InputMaybe<Order_By>;
  TimekeeperGUID?: InputMaybe<Order_By>;
  TimekeeperIndex?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  TitleDisplay?: InputMaybe<Order_By>;
  TitleFullyQualified?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
  dateClerkship?: InputMaybe<Order_By>;
  mlfsl_personnel_bar_aggregate?: InputMaybe<Mlfsl_Personnel_Bar_Aggregate_Order_By>;
  mlfsl_personnel_clerkship_aggregate?: InputMaybe<Mlfsl_Personnel_Clerkship_Aggregate_Order_By>;
  mlfsl_personnel_committee_aggregate?: InputMaybe<Mlfsl_Personnel_Committee_Aggregate_Order_By>;
  mlfsl_personnel_court_aggregate?: InputMaybe<Mlfsl_Personnel_Court_Aggregate_Order_By>;
  mlfsl_personnel_language_aggregate?: InputMaybe<Mlfsl_Personnel_Language_Aggregate_Order_By>;
  probono_goals_aggregate?: InputMaybe<Mlfsl_Probono_Goal_Aggregate_Order_By>;
};

/** select columns of table "repl.DimPersonnelNow" */
export enum Mlfsl_Personnel_Select_Column {
  /** column name */
  ActiveDirectoryBusinessCategory = 'ActiveDirectoryBusinessCategory',
  /** column name */
  ActiveDirectoryDisabledIndicator = 'ActiveDirectoryDisabledIndicator',
  /** column name */
  ActiveDirectoryDistinguishedName = 'ActiveDirectoryDistinguishedName',
  /** column name */
  ActiveDirectoryEmail = 'ActiveDirectoryEmail',
  /** column name */
  ActiveDirectoryHomeDirectory = 'ActiveDirectoryHomeDirectory',
  /** column name */
  ActiveDirectoryLogin = 'ActiveDirectoryLogin',
  /** column name */
  ActiveDirectoryMailboxIndicator = 'ActiveDirectoryMailboxIndicator',
  /** column name */
  ActiveDirectorySEVDepartedIndicator = 'ActiveDirectorySEVDepartedIndicator',
  /** column name */
  BYODIndicator = 'BYODIndicator',
  /** column name */
  BarAdmissionFirst = 'BarAdmissionFirst',
  /** column name */
  BardateFirst = 'BardateFirst',
  /** column name */
  BillingCoordinatorEmployeeId = 'BillingCoordinatorEmployeeId',
  /** column name */
  BlackberryPin = 'BlackberryPin',
  /** column name */
  BusinessPostalOfficeAddress1 = 'BusinessPostalOfficeAddress1',
  /** column name */
  BusinessPostalOfficeAddress2 = 'BusinessPostalOfficeAddress2',
  /** column name */
  BusinessPostalOfficeAddress3 = 'BusinessPostalOfficeAddress3',
  /** column name */
  BusinessPostalOfficeCity = 'BusinessPostalOfficeCity',
  /** column name */
  BusinessPostalOfficeCode = 'BusinessPostalOfficeCode',
  /** column name */
  BusinessPostalOfficeCountryCode = 'BusinessPostalOfficeCountryCode',
  /** column name */
  BusinessPostalOfficeState = 'BusinessPostalOfficeState',
  /** column name */
  BusinessPostalOfficeZip = 'BusinessPostalOfficeZip',
  /** column name */
  BusinessPrimaryOffice = 'BusinessPrimaryOffice',
  /** column name */
  BusinessPrimaryOfficeAddress1 = 'BusinessPrimaryOfficeAddress1',
  /** column name */
  BusinessPrimaryOfficeAddress2 = 'BusinessPrimaryOfficeAddress2',
  /** column name */
  BusinessPrimaryOfficeAddress3 = 'BusinessPrimaryOfficeAddress3',
  /** column name */
  BusinessPrimaryOfficeAddress4 = 'BusinessPrimaryOfficeAddress4',
  /** column name */
  BusinessPrimaryOfficeCity = 'BusinessPrimaryOfficeCity',
  /** column name */
  BusinessPrimaryOfficeCode = 'BusinessPrimaryOfficeCode',
  /** column name */
  BusinessPrimaryOfficeCodeNumber = 'BusinessPrimaryOfficeCodeNumber',
  /** column name */
  BusinessPrimaryOfficeCodeNumberWithExtension = 'BusinessPrimaryOfficeCodeNumberWithExtension',
  /** column name */
  BusinessPrimaryOfficeCountryCode = 'BusinessPrimaryOfficeCountryCode',
  /** column name */
  BusinessPrimaryOfficeMailBoxNumber = 'BusinessPrimaryOfficeMailBoxNumber',
  /** column name */
  BusinessPrimaryOfficeMailGroup = 'BusinessPrimaryOfficeMailGroup',
  /** column name */
  BusinessPrimaryOfficeMailGroupCode = 'BusinessPrimaryOfficeMailGroupCode',
  /** column name */
  BusinessPrimaryOfficePhoneCountry = 'BusinessPrimaryOfficePhoneCountry',
  /** column name */
  BusinessPrimaryOfficePhoneExtension = 'BusinessPrimaryOfficePhoneExtension',
  /** column name */
  BusinessPrimaryOfficePhoneNumber = 'BusinessPrimaryOfficePhoneNumber',
  /** column name */
  BusinessPrimaryOfficePhoneNumberFull = 'BusinessPrimaryOfficePhoneNumberFull',
  /** column name */
  BusinessPrimaryOfficePhoneinternalOfficeNumber = 'BusinessPrimaryOfficePhoneinternalOfficeNumber',
  /** column name */
  BusinessPrimaryOfficePhoneinternalOfficeNumberFull = 'BusinessPrimaryOfficePhoneinternalOfficeNumberFull',
  /** column name */
  BusinessPrimaryOfficeState = 'BusinessPrimaryOfficeState',
  /** column name */
  BusinessPrimaryOfficeZip = 'BusinessPrimaryOfficeZip',
  /** column name */
  BusinessSecondaryOffice = 'BusinessSecondaryOffice',
  /** column name */
  BusinessSecondaryOfficeCode = 'BusinessSecondaryOfficeCode',
  /** column name */
  BusinessSecondaryOfficeCodeNumber = 'BusinessSecondaryOfficeCodeNumber',
  /** column name */
  BusinessSecondaryOfficeCodeNumberWithExtension = 'BusinessSecondaryOfficeCodeNumberWithExtension',
  /** column name */
  BusinessSecondaryOfficePhoneCountry = 'BusinessSecondaryOfficePhoneCountry',
  /** column name */
  BusinessSecondaryOfficePhoneExtension = 'BusinessSecondaryOfficePhoneExtension',
  /** column name */
  BusinessSecondaryOfficePhoneNumber = 'BusinessSecondaryOfficePhoneNumber',
  /** column name */
  BusinessSecondaryOfficePhoneNumberFull = 'BusinessSecondaryOfficePhoneNumberFull',
  /** column name */
  BusinessSecondaryOfficePhoneinternalOfficeNumber = 'BusinessSecondaryOfficePhoneinternalOfficeNumber',
  /** column name */
  BusinessSecondaryOfficePhoneinternalOfficeNumberFull = 'BusinessSecondaryOfficePhoneinternalOfficeNumberFull',
  /** column name */
  CellPhoneCountry = 'CellPhoneCountry',
  /** column name */
  CellPhoneNumber = 'CellPhoneNumber',
  /** column name */
  CellPhoneNumberFull = 'CellPhoneNumberFull',
  /** column name */
  DataCenterRegion = 'DataCenterRegion',
  /** column name */
  DataSource = 'DataSource',
  /** column name */
  DateAccessRemoveKey = 'DateAccessRemoveKey',
  /** column name */
  DateAssociationKey = 'DateAssociationKey',
  /** column name */
  DateBirthKey = 'DateBirthKey',
  /** column name */
  DateCounselKey = 'DateCounselKey',
  /** column name */
  DateHireAdjustedKey = 'DateHireAdjustedKey',
  /** column name */
  DateHireKey = 'DateHireKey',
  /** column name */
  DateOfCounselKey = 'DateOfCounselKey',
  /** column name */
  DatePartnershipKey = 'DatePartnershipKey',
  /** column name */
  DateRehireExpirationKey = 'DateRehireExpirationKey',
  /** column name */
  DateRehireKey = 'DateRehireKey',
  /** column name */
  DateRemoteWorkingProgramKey = 'DateRemoteWorkingProgramKey',
  /** column name */
  DateSeniorCounselKey = 'DateSeniorCounselKey',
  /** column name */
  DateSpecialCounselKey = 'DateSpecialCounselKey',
  /** column name */
  DateTermKey = 'DateTermKey',
  /** column name */
  DateinternationalPartnerKey = 'DateinternationalPartnerKey',
  /** column name */
  DeletedRecordIndicator = 'DeletedRecordIndicator',
  /** column name */
  DesignatedEssentialWorkerIndicator = 'DesignatedEssentialWorkerIndicator',
  /** column name */
  DesignatedEssentialWorkerRequiredFormsCompleteIndicator = 'DesignatedEssentialWorkerRequiredFormsCompleteIndicator',
  /** column name */
  DesignatedEssentialWorkerRequiredVideoCompleteIndicator = 'DesignatedEssentialWorkerRequiredVideoCompleteIndicator',
  /** column name */
  DimPersonnelNowKey = 'DimPersonnelNowKey',
  /** column name */
  DiscoveryFlag = 'DiscoveryFlag',
  /** column name */
  ETLBatchKey = 'ETLBatchKey',
  /** column name */
  ETLSoftInsertIndicator = 'ETLSoftInsertIndicator',
  /** column name */
  ElitePracticeArea = 'ElitePracticeArea',
  /** column name */
  ElitePracticeAreaDelimited = 'ElitePracticeAreaDelimited',
  /** column name */
  EliteStatus = 'EliteStatus',
  /** column name */
  EliteSubSubPracticeGroup = 'EliteSubSubPracticeGroup',
  /** column name */
  EliteTimekeepLocation = 'EliteTimekeepLocation',
  /** column name */
  EliteTitle = 'EliteTitle',
  /** column name */
  EliteTitleSortOrder = 'EliteTitleSortOrder',
  /** column name */
  EliteWorkLocation = 'EliteWorkLocation',
  /** column name */
  ElitedateHireKey = 'ElitedateHireKey',
  /** column name */
  ElitedateTermKey = 'ElitedateTermKey',
  /** column name */
  Email = 'Email',
  /** column name */
  EmailSignatureCaveatText = 'EmailSignatureCaveatText',
  /** column name */
  EmergencyContact1FirstName = 'EmergencyContact1FirstName',
  /** column name */
  EmergencyContact1HomePhoneCountry = 'EmergencyContact1HomePhoneCountry',
  /** column name */
  EmergencyContact1HomePhoneFull = 'EmergencyContact1HomePhoneFull',
  /** column name */
  EmergencyContact1HomePhoneNumber = 'EmergencyContact1HomePhoneNumber',
  /** column name */
  EmergencyContact1LastName = 'EmergencyContact1LastName',
  /** column name */
  EmergencyContact1MiddleName = 'EmergencyContact1MiddleName',
  /** column name */
  EmergencyContact1NameDisplay = 'EmergencyContact1NameDisplay',
  /** column name */
  EmergencyContact1NameFull = 'EmergencyContact1NameFull',
  /** column name */
  EmergencyContact1WorkPhoneCountry = 'EmergencyContact1WorkPhoneCountry',
  /** column name */
  EmergencyContact1WorkPhoneExtension = 'EmergencyContact1WorkPhoneExtension',
  /** column name */
  EmergencyContact1WorkPhoneFull = 'EmergencyContact1WorkPhoneFull',
  /** column name */
  EmergencyContact1WorkPhoneNumber = 'EmergencyContact1WorkPhoneNumber',
  /** column name */
  EmergencyContact2FirstName = 'EmergencyContact2FirstName',
  /** column name */
  EmergencyContact2HomePhoneCountry = 'EmergencyContact2HomePhoneCountry',
  /** column name */
  EmergencyContact2HomePhoneFull = 'EmergencyContact2HomePhoneFull',
  /** column name */
  EmergencyContact2HomePhoneNumber = 'EmergencyContact2HomePhoneNumber',
  /** column name */
  EmergencyContact2LastName = 'EmergencyContact2LastName',
  /** column name */
  EmergencyContact2MiddleName = 'EmergencyContact2MiddleName',
  /** column name */
  EmergencyContact2NameDisplay = 'EmergencyContact2NameDisplay',
  /** column name */
  EmergencyContact2NameFull = 'EmergencyContact2NameFull',
  /** column name */
  EmergencyContact2WorkPhoneCountry = 'EmergencyContact2WorkPhoneCountry',
  /** column name */
  EmergencyContact2WorkPhoneExtension = 'EmergencyContact2WorkPhoneExtension',
  /** column name */
  EmergencyContact2WorkPhoneFull = 'EmergencyContact2WorkPhoneFull',
  /** column name */
  EmergencyContact2WorkPhoneNumber = 'EmergencyContact2WorkPhoneNumber',
  /** column name */
  EmployeeCategoryCode = 'EmployeeCategoryCode',
  /** column name */
  EmployeeCategoryDescription = 'EmployeeCategoryDescription',
  /** column name */
  EmployeeId = 'EmployeeId',
  /** column name */
  EmployeeIdOriginal = 'EmployeeIdOriginal',
  /** column name */
  EmployeeTypeFlag = 'EmployeeTypeFlag',
  /** column name */
  EtlChecksum = 'EtlChecksum',
  /** column name */
  EtlCreateddate = 'EtlCreateddate',
  /** column name */
  EtlModifieddate = 'EtlModifieddate',
  /** column name */
  FullTimeEquivalency = 'FullTimeEquivalency',
  /** column name */
  Gender = 'Gender',
  /** column name */
  GenderDescription = 'GenderDescription',
  /** column name */
  GradClassYear = 'GradClassYear',
  /** column name */
  IsActiveIndicator = 'IsActiveIndicator',
  /** column name */
  IsBilledByAIC = 'IsBilledByAIC',
  /** column name */
  IsDMSDenyAccess = 'IsDMSDenyAccess',
  /** column name */
  IsExemptIndicator = 'IsExemptIndicator',
  /** column name */
  IsHRCellPhoneUnlistedIndicator = 'IsHRCellPhoneUnlistedIndicator',
  /** column name */
  IsHREducationYearUnlistedIndicator = 'IsHREducationYearUnlistedIndicator',
  /** column name */
  IsHRHomeAddressUnlistedIndicator = 'IsHRHomeAddressUnlistedIndicator',
  /** column name */
  IsHRHomePhoneUnlistedIndicator = 'IsHRHomePhoneUnlistedIndicator',
  /** column name */
  IsHRSpouseUnlistedIndicator = 'IsHRSpouseUnlistedIndicator',
  /** column name */
  IsHrDefinedAttorneyIndicator = 'IsHrDefinedAttorneyIndicator',
  /** column name */
  IsHrUnlistedIndicator = 'IsHrUnlistedIndicator',
  /** column name */
  IsLateralAttorney = 'IsLateralAttorney',
  /** column name */
  IsLegalProfessionalIndicator = 'IsLegalProfessionalIndicator',
  /** column name */
  JobCode = 'JobCode',
  /** column name */
  JobFamily = 'JobFamily',
  /** column name */
  JobFamilyGroup = 'JobFamilyGroup',
  /** column name */
  LawsonCompany = 'LawsonCompany',
  /** column name */
  LawsonFullTimeEquivalency = 'LawsonFullTimeEquivalency',
  /** column name */
  LawsonSecondarySubSubPracticeGroup = 'LawsonSecondarySubSubPracticeGroup',
  /** column name */
  LawsonSubSubPracticeGroup = 'LawsonSubSubPracticeGroup',
  /** column name */
  LawsondateHireAdjustedKey = 'LawsondateHireAdjustedKey',
  /** column name */
  LawsondateHireKey = 'LawsondateHireKey',
  /** column name */
  LawsondateTermKey = 'LawsondateTermKey',
  /** column name */
  MLBClassYear = 'MLBClassYear',
  /** column name */
  Manager1EmployeeId = 'Manager1EmployeeId',
  /** column name */
  Manager1EmployeeIdOriginal = 'Manager1EmployeeIdOriginal',
  /** column name */
  Manager2EmployeeId = 'Manager2EmployeeId',
  /** column name */
  Manager2EmployeeIdOriginal = 'Manager2EmployeeIdOriginal',
  /** column name */
  Manager3EmployeeId = 'Manager3EmployeeId',
  /** column name */
  Manager3EmployeeIdOriginal = 'Manager3EmployeeIdOriginal',
  /** column name */
  Manager4EmployeeId = 'Manager4EmployeeId',
  /** column name */
  Manager4EmployeeIdOriginal = 'Manager4EmployeeIdOriginal',
  /** column name */
  Manager5EmployeeId = 'Manager5EmployeeId',
  /** column name */
  Manager5EmployeeIdOriginal = 'Manager5EmployeeIdOriginal',
  /** column name */
  Manager6EmployeeId = 'Manager6EmployeeId',
  /** column name */
  Manager6EmployeeIdOriginal = 'Manager6EmployeeIdOriginal',
  /** column name */
  MarsPersonID = 'MarsPersonID',
  /** column name */
  MarsSubSubPracticeGroup = 'MarsSubSubPracticeGroup',
  /** column name */
  MarsTitle = 'MarsTitle',
  /** column name */
  MarsWorkLocation = 'MarsWorkLocation',
  /** column name */
  MorganNetDisplayIndicator = 'MorganNetDisplayIndicator',
  /** column name */
  NameDisplay = 'NameDisplay',
  /** column name */
  NameFirst = 'NameFirst',
  /** column name */
  NameFirstBilling = 'NameFirstBilling',
  /** column name */
  NameFull = 'NameFull',
  /** column name */
  NameInitialsElite = 'NameInitialsElite',
  /** column name */
  NameLast = 'NameLast',
  /** column name */
  NameLastBilling = 'NameLastBilling',
  /** column name */
  NameLastNoSuffix = 'NameLastNoSuffix',
  /** column name */
  NameMaidenFirst = 'NameMaidenFirst',
  /** column name */
  NameMaidenLast = 'NameMaidenLast',
  /** column name */
  NameMaidenMiddleInitial = 'NameMaidenMiddleInitial',
  /** column name */
  NameMiddle = 'NameMiddle',
  /** column name */
  NameMiddleInitial = 'NameMiddleInitial',
  /** column name */
  NameNick = 'NameNick',
  /** column name */
  NameNickIa = 'NameNickIa',
  /** column name */
  NamePreferredDisplay = 'NamePreferredDisplay',
  /** column name */
  NamePreferredDisplay_ = 'NamePreferredDisplay_',
  /** column name */
  NamePreferredFirst = 'NamePreferredFirst',
  /** column name */
  NamePreferredFull = 'NamePreferredFull',
  /** column name */
  NamePreferredLast = 'NamePreferredLast',
  /** column name */
  NamePreferredMiddle = 'NamePreferredMiddle',
  /** column name */
  NameSuffix = 'NameSuffix',
  /** column name */
  NameTDDisplay = 'NameTDDisplay',
  /** column name */
  NonFirmOfficeTaxJurisdictionResident = 'NonFirmOfficeTaxJurisdictionResident',
  /** column name */
  NonPhiladelphiaResident = 'NonPhiladelphiaResident',
  /** column name */
  ParalegalTier = 'ParalegalTier',
  /** column name */
  PartnerTypeKey = 'PartnerTypeKey',
  /** column name */
  PayrollBatchId = 'PayrollBatchId',
  /** column name */
  PayrollFileNumber = 'PayrollFileNumber',
  /** column name */
  PayrollPayGroup = 'PayrollPayGroup',
  /** column name */
  PersonalAddressFour = 'PersonalAddressFour',
  /** column name */
  PersonalAddressOne = 'PersonalAddressOne',
  /** column name */
  PersonalAddressThree = 'PersonalAddressThree',
  /** column name */
  PersonalAddressTwo = 'PersonalAddressTwo',
  /** column name */
  PersonalCity = 'PersonalCity',
  /** column name */
  PersonalCountry = 'PersonalCountry',
  /** column name */
  PersonalEmailAddress = 'PersonalEmailAddress',
  /** column name */
  PersonalMatter = 'PersonalMatter',
  /** column name */
  PersonalPhoneCountry = 'PersonalPhoneCountry',
  /** column name */
  PersonalPhoneNumber = 'PersonalPhoneNumber',
  /** column name */
  PersonalPhoneNumberFull = 'PersonalPhoneNumberFull',
  /** column name */
  PersonalPronouns = 'PersonalPronouns',
  /** column name */
  PersonalSecondPhoneCountry = 'PersonalSecondPhoneCountry',
  /** column name */
  PersonalSecondPhoneNumber = 'PersonalSecondPhoneNumber',
  /** column name */
  PersonalSecondPhoneNumberFull = 'PersonalSecondPhoneNumberFull',
  /** column name */
  PersonalState = 'PersonalState',
  /** column name */
  PersonalZip = 'PersonalZip',
  /** column name */
  PersonnelSourceAbbreviation = 'PersonnelSourceAbbreviation',
  /** column name */
  PersonnelSourceName = 'PersonnelSourceName',
  /** column name */
  PersonnelSourceNumber = 'PersonnelSourceNumber',
  /** column name */
  PictureURL = 'PictureURL',
  /** column name */
  RateBilling = 'RateBilling',
  /** column name */
  RateGrid = 'RateGrid',
  /** column name */
  RateStandard = 'RateStandard',
  /** column name */
  RehireIndicator = 'RehireIndicator',
  /** column name */
  RemoteWorkingProgramIndicator = 'RemoteWorkingProgramIndicator',
  /** column name */
  RequiredTime = 'RequiredTime',
  /** column name */
  Secretary1EmployeeId = 'Secretary1EmployeeId',
  /** column name */
  Secretary1EmployeeIdOriginal = 'Secretary1EmployeeIdOriginal',
  /** column name */
  Secretary1FirstName = 'Secretary1FirstName',
  /** column name */
  Secretary1LastName = 'Secretary1LastName',
  /** column name */
  Secretary1MiddleName = 'Secretary1MiddleName',
  /** column name */
  Secretary1NameDisplay = 'Secretary1NameDisplay',
  /** column name */
  Secretary1NameFull = 'Secretary1NameFull',
  /** column name */
  Secretary1NamePreferredDisplay = 'Secretary1NamePreferredDisplay',
  /** column name */
  Secretary1NamePreferredFull = 'Secretary1NamePreferredFull',
  /** column name */
  Secretary1PhoneExtension = 'Secretary1PhoneExtension',
  /** column name */
  Secretary2EmployeeId = 'Secretary2EmployeeId',
  /** column name */
  Secretary2EmployeeIdOriginal = 'Secretary2EmployeeIdOriginal',
  /** column name */
  Secretary2FirstName = 'Secretary2FirstName',
  /** column name */
  Secretary2LastName = 'Secretary2LastName',
  /** column name */
  Secretary2MiddleName = 'Secretary2MiddleName',
  /** column name */
  Secretary2NameDisplay = 'Secretary2NameDisplay',
  /** column name */
  Secretary2NameFull = 'Secretary2NameFull',
  /** column name */
  Secretary2NamePreferredDisplay = 'Secretary2NamePreferredDisplay',
  /** column name */
  Secretary2NamePreferredFull = 'Secretary2NamePreferredFull',
  /** column name */
  Secretary2PhoneExtension = 'Secretary2PhoneExtension',
  /** column name */
  SpouseFirstName = 'SpouseFirstName',
  /** column name */
  SpouseLastName = 'SpouseLastName',
  /** column name */
  SpouseMiddleInit = 'SpouseMiddleInit',
  /** column name */
  SpouseNameDisplay = 'SpouseNameDisplay',
  /** column name */
  SpouseNameFull = 'SpouseNameFull',
  /** column name */
  StatusActiveEmployeeIndicator = 'StatusActiveEmployeeIndicator',
  /** column name */
  StatusCode = 'StatusCode',
  /** column name */
  StatusDescription = 'StatusDescription',
  /** column name */
  StatusDescription2 = 'StatusDescription2',
  /** column name */
  StatusLabel = 'StatusLabel',
  /** column name */
  TimeKeeperCostEntryFlag = 'TimeKeeperCostEntryFlag',
  /** column name */
  TimeKeeperTimeEntryFlag = 'TimeKeeperTimeEntryFlag',
  /** column name */
  TimeReporter = 'TimeReporter',
  /** column name */
  TimekeeperGUID = 'TimekeeperGUID',
  /** column name */
  TimekeeperIndex = 'TimekeeperIndex',
  /** column name */
  Title = 'Title',
  /** column name */
  TitleDisplay = 'TitleDisplay',
  /** column name */
  TitleFullyQualified = 'TitleFullyQualified',
  /** column name */
  WallBuilderEntityID = 'WallBuilderEntityID',
  /** column name */
  DateClerkship = 'dateClerkship',
}

/** aggregate stddev on columns */
export type Mlfsl_Personnel_Stddev_Fields = {
  DateAccessRemoveKey?: Maybe<Scalars['Float']['output']>;
  DateAssociationKey?: Maybe<Scalars['Float']['output']>;
  DateBirthKey?: Maybe<Scalars['Float']['output']>;
  DateCounselKey?: Maybe<Scalars['Float']['output']>;
  DateHireAdjustedKey?: Maybe<Scalars['Float']['output']>;
  DateHireKey?: Maybe<Scalars['Float']['output']>;
  DateOfCounselKey?: Maybe<Scalars['Float']['output']>;
  DatePartnershipKey?: Maybe<Scalars['Float']['output']>;
  DateRehireExpirationKey?: Maybe<Scalars['Float']['output']>;
  DateRehireKey?: Maybe<Scalars['Float']['output']>;
  DateRemoteWorkingProgramKey?: Maybe<Scalars['Float']['output']>;
  DateSeniorCounselKey?: Maybe<Scalars['Float']['output']>;
  DateSpecialCounselKey?: Maybe<Scalars['Float']['output']>;
  DateTermKey?: Maybe<Scalars['Float']['output']>;
  DateinternationalPartnerKey?: Maybe<Scalars['Float']['output']>;
  DimPersonnelNowKey?: Maybe<Scalars['Float']['output']>;
  DiscoveryFlag?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EliteTitleSortOrder?: Maybe<Scalars['Float']['output']>;
  ElitedateHireKey?: Maybe<Scalars['Float']['output']>;
  ElitedateTermKey?: Maybe<Scalars['Float']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  FullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  IsActiveIndicator?: Maybe<Scalars['Float']['output']>;
  LawsonCompany?: Maybe<Scalars['Float']['output']>;
  LawsonFullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  LawsondateHireAdjustedKey?: Maybe<Scalars['Float']['output']>;
  LawsondateHireKey?: Maybe<Scalars['Float']['output']>;
  LawsondateTermKey?: Maybe<Scalars['Float']['output']>;
  Manager1EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager2EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager3EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager4EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager5EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager6EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  MarsPersonID?: Maybe<Scalars['Float']['output']>;
  MorganNetDisplayIndicator?: Maybe<Scalars['Float']['output']>;
  PartnerTypeKey?: Maybe<Scalars['Float']['output']>;
  RateBilling?: Maybe<Scalars['Float']['output']>;
  RateGrid?: Maybe<Scalars['Float']['output']>;
  RateStandard?: Maybe<Scalars['Float']['output']>;
  Secretary1EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Secretary2EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  StatusActiveEmployeeIndicator?: Maybe<Scalars['Float']['output']>;
  TimekeeperIndex?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Stddev_Order_By = {
  DateAccessRemoveKey?: InputMaybe<Order_By>;
  DateAssociationKey?: InputMaybe<Order_By>;
  DateBirthKey?: InputMaybe<Order_By>;
  DateCounselKey?: InputMaybe<Order_By>;
  DateHireAdjustedKey?: InputMaybe<Order_By>;
  DateHireKey?: InputMaybe<Order_By>;
  DateOfCounselKey?: InputMaybe<Order_By>;
  DatePartnershipKey?: InputMaybe<Order_By>;
  DateRehireExpirationKey?: InputMaybe<Order_By>;
  DateRehireKey?: InputMaybe<Order_By>;
  DateRemoteWorkingProgramKey?: InputMaybe<Order_By>;
  DateSeniorCounselKey?: InputMaybe<Order_By>;
  DateSpecialCounselKey?: InputMaybe<Order_By>;
  DateTermKey?: InputMaybe<Order_By>;
  DateinternationalPartnerKey?: InputMaybe<Order_By>;
  DimPersonnelNowKey?: InputMaybe<Order_By>;
  DiscoveryFlag?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EliteTitleSortOrder?: InputMaybe<Order_By>;
  ElitedateHireKey?: InputMaybe<Order_By>;
  ElitedateTermKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  FullTimeEquivalency?: InputMaybe<Order_By>;
  IsActiveIndicator?: InputMaybe<Order_By>;
  LawsonCompany?: InputMaybe<Order_By>;
  LawsonFullTimeEquivalency?: InputMaybe<Order_By>;
  LawsondateHireAdjustedKey?: InputMaybe<Order_By>;
  LawsondateHireKey?: InputMaybe<Order_By>;
  LawsondateTermKey?: InputMaybe<Order_By>;
  Manager1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager2EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager3EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager4EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager5EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager6EmployeeIdOriginal?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
  MorganNetDisplayIndicator?: InputMaybe<Order_By>;
  PartnerTypeKey?: InputMaybe<Order_By>;
  RateBilling?: InputMaybe<Order_By>;
  RateGrid?: InputMaybe<Order_By>;
  RateStandard?: InputMaybe<Order_By>;
  Secretary1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Secretary2EmployeeIdOriginal?: InputMaybe<Order_By>;
  StatusActiveEmployeeIndicator?: InputMaybe<Order_By>;
  TimekeeperIndex?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Personnel_Stddev_Pop_Fields = {
  DateAccessRemoveKey?: Maybe<Scalars['Float']['output']>;
  DateAssociationKey?: Maybe<Scalars['Float']['output']>;
  DateBirthKey?: Maybe<Scalars['Float']['output']>;
  DateCounselKey?: Maybe<Scalars['Float']['output']>;
  DateHireAdjustedKey?: Maybe<Scalars['Float']['output']>;
  DateHireKey?: Maybe<Scalars['Float']['output']>;
  DateOfCounselKey?: Maybe<Scalars['Float']['output']>;
  DatePartnershipKey?: Maybe<Scalars['Float']['output']>;
  DateRehireExpirationKey?: Maybe<Scalars['Float']['output']>;
  DateRehireKey?: Maybe<Scalars['Float']['output']>;
  DateRemoteWorkingProgramKey?: Maybe<Scalars['Float']['output']>;
  DateSeniorCounselKey?: Maybe<Scalars['Float']['output']>;
  DateSpecialCounselKey?: Maybe<Scalars['Float']['output']>;
  DateTermKey?: Maybe<Scalars['Float']['output']>;
  DateinternationalPartnerKey?: Maybe<Scalars['Float']['output']>;
  DimPersonnelNowKey?: Maybe<Scalars['Float']['output']>;
  DiscoveryFlag?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EliteTitleSortOrder?: Maybe<Scalars['Float']['output']>;
  ElitedateHireKey?: Maybe<Scalars['Float']['output']>;
  ElitedateTermKey?: Maybe<Scalars['Float']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  FullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  IsActiveIndicator?: Maybe<Scalars['Float']['output']>;
  LawsonCompany?: Maybe<Scalars['Float']['output']>;
  LawsonFullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  LawsondateHireAdjustedKey?: Maybe<Scalars['Float']['output']>;
  LawsondateHireKey?: Maybe<Scalars['Float']['output']>;
  LawsondateTermKey?: Maybe<Scalars['Float']['output']>;
  Manager1EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager2EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager3EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager4EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager5EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager6EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  MarsPersonID?: Maybe<Scalars['Float']['output']>;
  MorganNetDisplayIndicator?: Maybe<Scalars['Float']['output']>;
  PartnerTypeKey?: Maybe<Scalars['Float']['output']>;
  RateBilling?: Maybe<Scalars['Float']['output']>;
  RateGrid?: Maybe<Scalars['Float']['output']>;
  RateStandard?: Maybe<Scalars['Float']['output']>;
  Secretary1EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Secretary2EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  StatusActiveEmployeeIndicator?: Maybe<Scalars['Float']['output']>;
  TimekeeperIndex?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Stddev_Pop_Order_By = {
  DateAccessRemoveKey?: InputMaybe<Order_By>;
  DateAssociationKey?: InputMaybe<Order_By>;
  DateBirthKey?: InputMaybe<Order_By>;
  DateCounselKey?: InputMaybe<Order_By>;
  DateHireAdjustedKey?: InputMaybe<Order_By>;
  DateHireKey?: InputMaybe<Order_By>;
  DateOfCounselKey?: InputMaybe<Order_By>;
  DatePartnershipKey?: InputMaybe<Order_By>;
  DateRehireExpirationKey?: InputMaybe<Order_By>;
  DateRehireKey?: InputMaybe<Order_By>;
  DateRemoteWorkingProgramKey?: InputMaybe<Order_By>;
  DateSeniorCounselKey?: InputMaybe<Order_By>;
  DateSpecialCounselKey?: InputMaybe<Order_By>;
  DateTermKey?: InputMaybe<Order_By>;
  DateinternationalPartnerKey?: InputMaybe<Order_By>;
  DimPersonnelNowKey?: InputMaybe<Order_By>;
  DiscoveryFlag?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EliteTitleSortOrder?: InputMaybe<Order_By>;
  ElitedateHireKey?: InputMaybe<Order_By>;
  ElitedateTermKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  FullTimeEquivalency?: InputMaybe<Order_By>;
  IsActiveIndicator?: InputMaybe<Order_By>;
  LawsonCompany?: InputMaybe<Order_By>;
  LawsonFullTimeEquivalency?: InputMaybe<Order_By>;
  LawsondateHireAdjustedKey?: InputMaybe<Order_By>;
  LawsondateHireKey?: InputMaybe<Order_By>;
  LawsondateTermKey?: InputMaybe<Order_By>;
  Manager1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager2EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager3EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager4EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager5EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager6EmployeeIdOriginal?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
  MorganNetDisplayIndicator?: InputMaybe<Order_By>;
  PartnerTypeKey?: InputMaybe<Order_By>;
  RateBilling?: InputMaybe<Order_By>;
  RateGrid?: InputMaybe<Order_By>;
  RateStandard?: InputMaybe<Order_By>;
  Secretary1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Secretary2EmployeeIdOriginal?: InputMaybe<Order_By>;
  StatusActiveEmployeeIndicator?: InputMaybe<Order_By>;
  TimekeeperIndex?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Personnel_Stddev_Samp_Fields = {
  DateAccessRemoveKey?: Maybe<Scalars['Float']['output']>;
  DateAssociationKey?: Maybe<Scalars['Float']['output']>;
  DateBirthKey?: Maybe<Scalars['Float']['output']>;
  DateCounselKey?: Maybe<Scalars['Float']['output']>;
  DateHireAdjustedKey?: Maybe<Scalars['Float']['output']>;
  DateHireKey?: Maybe<Scalars['Float']['output']>;
  DateOfCounselKey?: Maybe<Scalars['Float']['output']>;
  DatePartnershipKey?: Maybe<Scalars['Float']['output']>;
  DateRehireExpirationKey?: Maybe<Scalars['Float']['output']>;
  DateRehireKey?: Maybe<Scalars['Float']['output']>;
  DateRemoteWorkingProgramKey?: Maybe<Scalars['Float']['output']>;
  DateSeniorCounselKey?: Maybe<Scalars['Float']['output']>;
  DateSpecialCounselKey?: Maybe<Scalars['Float']['output']>;
  DateTermKey?: Maybe<Scalars['Float']['output']>;
  DateinternationalPartnerKey?: Maybe<Scalars['Float']['output']>;
  DimPersonnelNowKey?: Maybe<Scalars['Float']['output']>;
  DiscoveryFlag?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EliteTitleSortOrder?: Maybe<Scalars['Float']['output']>;
  ElitedateHireKey?: Maybe<Scalars['Float']['output']>;
  ElitedateTermKey?: Maybe<Scalars['Float']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  FullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  IsActiveIndicator?: Maybe<Scalars['Float']['output']>;
  LawsonCompany?: Maybe<Scalars['Float']['output']>;
  LawsonFullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  LawsondateHireAdjustedKey?: Maybe<Scalars['Float']['output']>;
  LawsondateHireKey?: Maybe<Scalars['Float']['output']>;
  LawsondateTermKey?: Maybe<Scalars['Float']['output']>;
  Manager1EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager2EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager3EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager4EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager5EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager6EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  MarsPersonID?: Maybe<Scalars['Float']['output']>;
  MorganNetDisplayIndicator?: Maybe<Scalars['Float']['output']>;
  PartnerTypeKey?: Maybe<Scalars['Float']['output']>;
  RateBilling?: Maybe<Scalars['Float']['output']>;
  RateGrid?: Maybe<Scalars['Float']['output']>;
  RateStandard?: Maybe<Scalars['Float']['output']>;
  Secretary1EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Secretary2EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  StatusActiveEmployeeIndicator?: Maybe<Scalars['Float']['output']>;
  TimekeeperIndex?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Stddev_Samp_Order_By = {
  DateAccessRemoveKey?: InputMaybe<Order_By>;
  DateAssociationKey?: InputMaybe<Order_By>;
  DateBirthKey?: InputMaybe<Order_By>;
  DateCounselKey?: InputMaybe<Order_By>;
  DateHireAdjustedKey?: InputMaybe<Order_By>;
  DateHireKey?: InputMaybe<Order_By>;
  DateOfCounselKey?: InputMaybe<Order_By>;
  DatePartnershipKey?: InputMaybe<Order_By>;
  DateRehireExpirationKey?: InputMaybe<Order_By>;
  DateRehireKey?: InputMaybe<Order_By>;
  DateRemoteWorkingProgramKey?: InputMaybe<Order_By>;
  DateSeniorCounselKey?: InputMaybe<Order_By>;
  DateSpecialCounselKey?: InputMaybe<Order_By>;
  DateTermKey?: InputMaybe<Order_By>;
  DateinternationalPartnerKey?: InputMaybe<Order_By>;
  DimPersonnelNowKey?: InputMaybe<Order_By>;
  DiscoveryFlag?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EliteTitleSortOrder?: InputMaybe<Order_By>;
  ElitedateHireKey?: InputMaybe<Order_By>;
  ElitedateTermKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  FullTimeEquivalency?: InputMaybe<Order_By>;
  IsActiveIndicator?: InputMaybe<Order_By>;
  LawsonCompany?: InputMaybe<Order_By>;
  LawsonFullTimeEquivalency?: InputMaybe<Order_By>;
  LawsondateHireAdjustedKey?: InputMaybe<Order_By>;
  LawsondateHireKey?: InputMaybe<Order_By>;
  LawsondateTermKey?: InputMaybe<Order_By>;
  Manager1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager2EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager3EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager4EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager5EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager6EmployeeIdOriginal?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
  MorganNetDisplayIndicator?: InputMaybe<Order_By>;
  PartnerTypeKey?: InputMaybe<Order_By>;
  RateBilling?: InputMaybe<Order_By>;
  RateGrid?: InputMaybe<Order_By>;
  RateStandard?: InputMaybe<Order_By>;
  Secretary1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Secretary2EmployeeIdOriginal?: InputMaybe<Order_By>;
  StatusActiveEmployeeIndicator?: InputMaybe<Order_By>;
  TimekeeperIndex?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Mlfsl_Personnel_Sum_Fields = {
  DateAccessRemoveKey?: Maybe<Scalars['Int']['output']>;
  DateAssociationKey?: Maybe<Scalars['Int']['output']>;
  DateBirthKey?: Maybe<Scalars['Int']['output']>;
  DateCounselKey?: Maybe<Scalars['Int']['output']>;
  DateHireAdjustedKey?: Maybe<Scalars['Int']['output']>;
  DateHireKey?: Maybe<Scalars['Int']['output']>;
  DateOfCounselKey?: Maybe<Scalars['Int']['output']>;
  DatePartnershipKey?: Maybe<Scalars['Int']['output']>;
  DateRehireExpirationKey?: Maybe<Scalars['Int']['output']>;
  DateRehireKey?: Maybe<Scalars['Int']['output']>;
  DateRemoteWorkingProgramKey?: Maybe<Scalars['Int']['output']>;
  DateSeniorCounselKey?: Maybe<Scalars['Int']['output']>;
  DateSpecialCounselKey?: Maybe<Scalars['Int']['output']>;
  DateTermKey?: Maybe<Scalars['Int']['output']>;
  DateinternationalPartnerKey?: Maybe<Scalars['Int']['output']>;
  DimPersonnelNowKey?: Maybe<Scalars['Int']['output']>;
  DiscoveryFlag?: Maybe<Scalars['Int']['output']>;
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  EliteTitleSortOrder?: Maybe<Scalars['Int']['output']>;
  ElitedateHireKey?: Maybe<Scalars['Int']['output']>;
  ElitedateTermKey?: Maybe<Scalars['Int']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
  FullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  IsActiveIndicator?: Maybe<Scalars['Int']['output']>;
  LawsonCompany?: Maybe<Scalars['Int']['output']>;
  LawsonFullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  LawsondateHireAdjustedKey?: Maybe<Scalars['Int']['output']>;
  LawsondateHireKey?: Maybe<Scalars['Int']['output']>;
  LawsondateTermKey?: Maybe<Scalars['Int']['output']>;
  Manager1EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Manager2EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Manager3EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Manager4EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Manager5EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Manager6EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  MarsPersonID?: Maybe<Scalars['Int']['output']>;
  MorganNetDisplayIndicator?: Maybe<Scalars['Int']['output']>;
  PartnerTypeKey?: Maybe<Scalars['Int']['output']>;
  RateBilling?: Maybe<Scalars['Float']['output']>;
  RateGrid?: Maybe<Scalars['Float']['output']>;
  RateStandard?: Maybe<Scalars['Float']['output']>;
  Secretary1EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  Secretary2EmployeeIdOriginal?: Maybe<Scalars['Int']['output']>;
  StatusActiveEmployeeIndicator?: Maybe<Scalars['Int']['output']>;
  TimekeeperIndex?: Maybe<Scalars['Int']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Sum_Order_By = {
  DateAccessRemoveKey?: InputMaybe<Order_By>;
  DateAssociationKey?: InputMaybe<Order_By>;
  DateBirthKey?: InputMaybe<Order_By>;
  DateCounselKey?: InputMaybe<Order_By>;
  DateHireAdjustedKey?: InputMaybe<Order_By>;
  DateHireKey?: InputMaybe<Order_By>;
  DateOfCounselKey?: InputMaybe<Order_By>;
  DatePartnershipKey?: InputMaybe<Order_By>;
  DateRehireExpirationKey?: InputMaybe<Order_By>;
  DateRehireKey?: InputMaybe<Order_By>;
  DateRemoteWorkingProgramKey?: InputMaybe<Order_By>;
  DateSeniorCounselKey?: InputMaybe<Order_By>;
  DateSpecialCounselKey?: InputMaybe<Order_By>;
  DateTermKey?: InputMaybe<Order_By>;
  DateinternationalPartnerKey?: InputMaybe<Order_By>;
  DimPersonnelNowKey?: InputMaybe<Order_By>;
  DiscoveryFlag?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EliteTitleSortOrder?: InputMaybe<Order_By>;
  ElitedateHireKey?: InputMaybe<Order_By>;
  ElitedateTermKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  FullTimeEquivalency?: InputMaybe<Order_By>;
  IsActiveIndicator?: InputMaybe<Order_By>;
  LawsonCompany?: InputMaybe<Order_By>;
  LawsonFullTimeEquivalency?: InputMaybe<Order_By>;
  LawsondateHireAdjustedKey?: InputMaybe<Order_By>;
  LawsondateHireKey?: InputMaybe<Order_By>;
  LawsondateTermKey?: InputMaybe<Order_By>;
  Manager1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager2EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager3EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager4EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager5EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager6EmployeeIdOriginal?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
  MorganNetDisplayIndicator?: InputMaybe<Order_By>;
  PartnerTypeKey?: InputMaybe<Order_By>;
  RateBilling?: InputMaybe<Order_By>;
  RateGrid?: InputMaybe<Order_By>;
  RateStandard?: InputMaybe<Order_By>;
  Secretary1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Secretary2EmployeeIdOriginal?: InputMaybe<Order_By>;
  StatusActiveEmployeeIndicator?: InputMaybe<Order_By>;
  TimekeeperIndex?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Personnel_Var_Pop_Fields = {
  DateAccessRemoveKey?: Maybe<Scalars['Float']['output']>;
  DateAssociationKey?: Maybe<Scalars['Float']['output']>;
  DateBirthKey?: Maybe<Scalars['Float']['output']>;
  DateCounselKey?: Maybe<Scalars['Float']['output']>;
  DateHireAdjustedKey?: Maybe<Scalars['Float']['output']>;
  DateHireKey?: Maybe<Scalars['Float']['output']>;
  DateOfCounselKey?: Maybe<Scalars['Float']['output']>;
  DatePartnershipKey?: Maybe<Scalars['Float']['output']>;
  DateRehireExpirationKey?: Maybe<Scalars['Float']['output']>;
  DateRehireKey?: Maybe<Scalars['Float']['output']>;
  DateRemoteWorkingProgramKey?: Maybe<Scalars['Float']['output']>;
  DateSeniorCounselKey?: Maybe<Scalars['Float']['output']>;
  DateSpecialCounselKey?: Maybe<Scalars['Float']['output']>;
  DateTermKey?: Maybe<Scalars['Float']['output']>;
  DateinternationalPartnerKey?: Maybe<Scalars['Float']['output']>;
  DimPersonnelNowKey?: Maybe<Scalars['Float']['output']>;
  DiscoveryFlag?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EliteTitleSortOrder?: Maybe<Scalars['Float']['output']>;
  ElitedateHireKey?: Maybe<Scalars['Float']['output']>;
  ElitedateTermKey?: Maybe<Scalars['Float']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  FullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  IsActiveIndicator?: Maybe<Scalars['Float']['output']>;
  LawsonCompany?: Maybe<Scalars['Float']['output']>;
  LawsonFullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  LawsondateHireAdjustedKey?: Maybe<Scalars['Float']['output']>;
  LawsondateHireKey?: Maybe<Scalars['Float']['output']>;
  LawsondateTermKey?: Maybe<Scalars['Float']['output']>;
  Manager1EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager2EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager3EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager4EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager5EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager6EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  MarsPersonID?: Maybe<Scalars['Float']['output']>;
  MorganNetDisplayIndicator?: Maybe<Scalars['Float']['output']>;
  PartnerTypeKey?: Maybe<Scalars['Float']['output']>;
  RateBilling?: Maybe<Scalars['Float']['output']>;
  RateGrid?: Maybe<Scalars['Float']['output']>;
  RateStandard?: Maybe<Scalars['Float']['output']>;
  Secretary1EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Secretary2EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  StatusActiveEmployeeIndicator?: Maybe<Scalars['Float']['output']>;
  TimekeeperIndex?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Var_Pop_Order_By = {
  DateAccessRemoveKey?: InputMaybe<Order_By>;
  DateAssociationKey?: InputMaybe<Order_By>;
  DateBirthKey?: InputMaybe<Order_By>;
  DateCounselKey?: InputMaybe<Order_By>;
  DateHireAdjustedKey?: InputMaybe<Order_By>;
  DateHireKey?: InputMaybe<Order_By>;
  DateOfCounselKey?: InputMaybe<Order_By>;
  DatePartnershipKey?: InputMaybe<Order_By>;
  DateRehireExpirationKey?: InputMaybe<Order_By>;
  DateRehireKey?: InputMaybe<Order_By>;
  DateRemoteWorkingProgramKey?: InputMaybe<Order_By>;
  DateSeniorCounselKey?: InputMaybe<Order_By>;
  DateSpecialCounselKey?: InputMaybe<Order_By>;
  DateTermKey?: InputMaybe<Order_By>;
  DateinternationalPartnerKey?: InputMaybe<Order_By>;
  DimPersonnelNowKey?: InputMaybe<Order_By>;
  DiscoveryFlag?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EliteTitleSortOrder?: InputMaybe<Order_By>;
  ElitedateHireKey?: InputMaybe<Order_By>;
  ElitedateTermKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  FullTimeEquivalency?: InputMaybe<Order_By>;
  IsActiveIndicator?: InputMaybe<Order_By>;
  LawsonCompany?: InputMaybe<Order_By>;
  LawsonFullTimeEquivalency?: InputMaybe<Order_By>;
  LawsondateHireAdjustedKey?: InputMaybe<Order_By>;
  LawsondateHireKey?: InputMaybe<Order_By>;
  LawsondateTermKey?: InputMaybe<Order_By>;
  Manager1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager2EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager3EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager4EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager5EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager6EmployeeIdOriginal?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
  MorganNetDisplayIndicator?: InputMaybe<Order_By>;
  PartnerTypeKey?: InputMaybe<Order_By>;
  RateBilling?: InputMaybe<Order_By>;
  RateGrid?: InputMaybe<Order_By>;
  RateStandard?: InputMaybe<Order_By>;
  Secretary1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Secretary2EmployeeIdOriginal?: InputMaybe<Order_By>;
  StatusActiveEmployeeIndicator?: InputMaybe<Order_By>;
  TimekeeperIndex?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Personnel_Var_Samp_Fields = {
  DateAccessRemoveKey?: Maybe<Scalars['Float']['output']>;
  DateAssociationKey?: Maybe<Scalars['Float']['output']>;
  DateBirthKey?: Maybe<Scalars['Float']['output']>;
  DateCounselKey?: Maybe<Scalars['Float']['output']>;
  DateHireAdjustedKey?: Maybe<Scalars['Float']['output']>;
  DateHireKey?: Maybe<Scalars['Float']['output']>;
  DateOfCounselKey?: Maybe<Scalars['Float']['output']>;
  DatePartnershipKey?: Maybe<Scalars['Float']['output']>;
  DateRehireExpirationKey?: Maybe<Scalars['Float']['output']>;
  DateRehireKey?: Maybe<Scalars['Float']['output']>;
  DateRemoteWorkingProgramKey?: Maybe<Scalars['Float']['output']>;
  DateSeniorCounselKey?: Maybe<Scalars['Float']['output']>;
  DateSpecialCounselKey?: Maybe<Scalars['Float']['output']>;
  DateTermKey?: Maybe<Scalars['Float']['output']>;
  DateinternationalPartnerKey?: Maybe<Scalars['Float']['output']>;
  DimPersonnelNowKey?: Maybe<Scalars['Float']['output']>;
  DiscoveryFlag?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EliteTitleSortOrder?: Maybe<Scalars['Float']['output']>;
  ElitedateHireKey?: Maybe<Scalars['Float']['output']>;
  ElitedateTermKey?: Maybe<Scalars['Float']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  FullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  IsActiveIndicator?: Maybe<Scalars['Float']['output']>;
  LawsonCompany?: Maybe<Scalars['Float']['output']>;
  LawsonFullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  LawsondateHireAdjustedKey?: Maybe<Scalars['Float']['output']>;
  LawsondateHireKey?: Maybe<Scalars['Float']['output']>;
  LawsondateTermKey?: Maybe<Scalars['Float']['output']>;
  Manager1EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager2EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager3EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager4EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager5EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager6EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  MarsPersonID?: Maybe<Scalars['Float']['output']>;
  MorganNetDisplayIndicator?: Maybe<Scalars['Float']['output']>;
  PartnerTypeKey?: Maybe<Scalars['Float']['output']>;
  RateBilling?: Maybe<Scalars['Float']['output']>;
  RateGrid?: Maybe<Scalars['Float']['output']>;
  RateStandard?: Maybe<Scalars['Float']['output']>;
  Secretary1EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Secretary2EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  StatusActiveEmployeeIndicator?: Maybe<Scalars['Float']['output']>;
  TimekeeperIndex?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Var_Samp_Order_By = {
  DateAccessRemoveKey?: InputMaybe<Order_By>;
  DateAssociationKey?: InputMaybe<Order_By>;
  DateBirthKey?: InputMaybe<Order_By>;
  DateCounselKey?: InputMaybe<Order_By>;
  DateHireAdjustedKey?: InputMaybe<Order_By>;
  DateHireKey?: InputMaybe<Order_By>;
  DateOfCounselKey?: InputMaybe<Order_By>;
  DatePartnershipKey?: InputMaybe<Order_By>;
  DateRehireExpirationKey?: InputMaybe<Order_By>;
  DateRehireKey?: InputMaybe<Order_By>;
  DateRemoteWorkingProgramKey?: InputMaybe<Order_By>;
  DateSeniorCounselKey?: InputMaybe<Order_By>;
  DateSpecialCounselKey?: InputMaybe<Order_By>;
  DateTermKey?: InputMaybe<Order_By>;
  DateinternationalPartnerKey?: InputMaybe<Order_By>;
  DimPersonnelNowKey?: InputMaybe<Order_By>;
  DiscoveryFlag?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EliteTitleSortOrder?: InputMaybe<Order_By>;
  ElitedateHireKey?: InputMaybe<Order_By>;
  ElitedateTermKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  FullTimeEquivalency?: InputMaybe<Order_By>;
  IsActiveIndicator?: InputMaybe<Order_By>;
  LawsonCompany?: InputMaybe<Order_By>;
  LawsonFullTimeEquivalency?: InputMaybe<Order_By>;
  LawsondateHireAdjustedKey?: InputMaybe<Order_By>;
  LawsondateHireKey?: InputMaybe<Order_By>;
  LawsondateTermKey?: InputMaybe<Order_By>;
  Manager1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager2EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager3EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager4EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager5EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager6EmployeeIdOriginal?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
  MorganNetDisplayIndicator?: InputMaybe<Order_By>;
  PartnerTypeKey?: InputMaybe<Order_By>;
  RateBilling?: InputMaybe<Order_By>;
  RateGrid?: InputMaybe<Order_By>;
  RateStandard?: InputMaybe<Order_By>;
  Secretary1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Secretary2EmployeeIdOriginal?: InputMaybe<Order_By>;
  StatusActiveEmployeeIndicator?: InputMaybe<Order_By>;
  TimekeeperIndex?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mlfsl_Personnel_Variance_Fields = {
  DateAccessRemoveKey?: Maybe<Scalars['Float']['output']>;
  DateAssociationKey?: Maybe<Scalars['Float']['output']>;
  DateBirthKey?: Maybe<Scalars['Float']['output']>;
  DateCounselKey?: Maybe<Scalars['Float']['output']>;
  DateHireAdjustedKey?: Maybe<Scalars['Float']['output']>;
  DateHireKey?: Maybe<Scalars['Float']['output']>;
  DateOfCounselKey?: Maybe<Scalars['Float']['output']>;
  DatePartnershipKey?: Maybe<Scalars['Float']['output']>;
  DateRehireExpirationKey?: Maybe<Scalars['Float']['output']>;
  DateRehireKey?: Maybe<Scalars['Float']['output']>;
  DateRemoteWorkingProgramKey?: Maybe<Scalars['Float']['output']>;
  DateSeniorCounselKey?: Maybe<Scalars['Float']['output']>;
  DateSpecialCounselKey?: Maybe<Scalars['Float']['output']>;
  DateTermKey?: Maybe<Scalars['Float']['output']>;
  DateinternationalPartnerKey?: Maybe<Scalars['Float']['output']>;
  DimPersonnelNowKey?: Maybe<Scalars['Float']['output']>;
  DiscoveryFlag?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EliteTitleSortOrder?: Maybe<Scalars['Float']['output']>;
  ElitedateHireKey?: Maybe<Scalars['Float']['output']>;
  ElitedateTermKey?: Maybe<Scalars['Float']['output']>;
  EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  EtlChecksum?: Maybe<Scalars['Float']['output']>;
  FullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  IsActiveIndicator?: Maybe<Scalars['Float']['output']>;
  LawsonCompany?: Maybe<Scalars['Float']['output']>;
  LawsonFullTimeEquivalency?: Maybe<Scalars['Float']['output']>;
  LawsondateHireAdjustedKey?: Maybe<Scalars['Float']['output']>;
  LawsondateHireKey?: Maybe<Scalars['Float']['output']>;
  LawsondateTermKey?: Maybe<Scalars['Float']['output']>;
  Manager1EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager2EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager3EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager4EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager5EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Manager6EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  MarsPersonID?: Maybe<Scalars['Float']['output']>;
  MorganNetDisplayIndicator?: Maybe<Scalars['Float']['output']>;
  PartnerTypeKey?: Maybe<Scalars['Float']['output']>;
  RateBilling?: Maybe<Scalars['Float']['output']>;
  RateGrid?: Maybe<Scalars['Float']['output']>;
  RateStandard?: Maybe<Scalars['Float']['output']>;
  Secretary1EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  Secretary2EmployeeIdOriginal?: Maybe<Scalars['Float']['output']>;
  StatusActiveEmployeeIndicator?: Maybe<Scalars['Float']['output']>;
  TimekeeperIndex?: Maybe<Scalars['Float']['output']>;
  WallBuilderEntityID?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "repl.DimPersonnelNow" */
export type Mlfsl_Personnel_Variance_Order_By = {
  DateAccessRemoveKey?: InputMaybe<Order_By>;
  DateAssociationKey?: InputMaybe<Order_By>;
  DateBirthKey?: InputMaybe<Order_By>;
  DateCounselKey?: InputMaybe<Order_By>;
  DateHireAdjustedKey?: InputMaybe<Order_By>;
  DateHireKey?: InputMaybe<Order_By>;
  DateOfCounselKey?: InputMaybe<Order_By>;
  DatePartnershipKey?: InputMaybe<Order_By>;
  DateRehireExpirationKey?: InputMaybe<Order_By>;
  DateRehireKey?: InputMaybe<Order_By>;
  DateRemoteWorkingProgramKey?: InputMaybe<Order_By>;
  DateSeniorCounselKey?: InputMaybe<Order_By>;
  DateSpecialCounselKey?: InputMaybe<Order_By>;
  DateTermKey?: InputMaybe<Order_By>;
  DateinternationalPartnerKey?: InputMaybe<Order_By>;
  DimPersonnelNowKey?: InputMaybe<Order_By>;
  DiscoveryFlag?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  EliteTitleSortOrder?: InputMaybe<Order_By>;
  ElitedateHireKey?: InputMaybe<Order_By>;
  ElitedateTermKey?: InputMaybe<Order_By>;
  EmployeeIdOriginal?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  FullTimeEquivalency?: InputMaybe<Order_By>;
  IsActiveIndicator?: InputMaybe<Order_By>;
  LawsonCompany?: InputMaybe<Order_By>;
  LawsonFullTimeEquivalency?: InputMaybe<Order_By>;
  LawsondateHireAdjustedKey?: InputMaybe<Order_By>;
  LawsondateHireKey?: InputMaybe<Order_By>;
  LawsondateTermKey?: InputMaybe<Order_By>;
  Manager1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager2EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager3EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager4EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager5EmployeeIdOriginal?: InputMaybe<Order_By>;
  Manager6EmployeeIdOriginal?: InputMaybe<Order_By>;
  MarsPersonID?: InputMaybe<Order_By>;
  MorganNetDisplayIndicator?: InputMaybe<Order_By>;
  PartnerTypeKey?: InputMaybe<Order_By>;
  RateBilling?: InputMaybe<Order_By>;
  RateGrid?: InputMaybe<Order_By>;
  RateStandard?: InputMaybe<Order_By>;
  Secretary1EmployeeIdOriginal?: InputMaybe<Order_By>;
  Secretary2EmployeeIdOriginal?: InputMaybe<Order_By>;
  StatusActiveEmployeeIndicator?: InputMaybe<Order_By>;
  TimekeeperIndex?: InputMaybe<Order_By>;
  WallBuilderEntityID?: InputMaybe<Order_By>;
};

/** columns and relationships of "repl.DimPracticeGroupNow" */
export type Mlfsl_Practicegroup = {
  ActiveFlag: Scalars['String']['output'];
  DeletedRecordIndicator: Scalars['String']['output'];
  DimPracticeGroupNowKey: Scalars['Int']['output'];
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  ETLCreatedDate: Scalars['datetime']['output'];
  ETLModifiedDate: Scalars['datetime']['output'];
  EtlCheckSum: Scalars['Int']['output'];
  LawsonSubSubPracticeGroupName?: Maybe<Scalars['String']['output']>;
  PracticeArea?: Maybe<Scalars['String']['output']>;
  PracticeAreaDelimited?: Maybe<Scalars['String']['output']>;
  PracticeGroupAbbreviation?: Maybe<Scalars['String']['output']>;
  PracticeGroupCode: Scalars['String']['output'];
  PracticeGroupGUID?: Maybe<Scalars['uniqueidentifier']['output']>;
  PracticeGroupName?: Maybe<Scalars['String']['output']>;
  PracticeGroupType?: Maybe<Scalars['String']['output']>;
  SectionAbbreviation?: Maybe<Scalars['String']['output']>;
  SectionCode?: Maybe<Scalars['String']['output']>;
  SectionName?: Maybe<Scalars['String']['output']>;
  SubPracticeGroupAbbreviation?: Maybe<Scalars['String']['output']>;
  SubPracticeGroupCode?: Maybe<Scalars['String']['output']>;
  SubPracticeGroupName?: Maybe<Scalars['String']['output']>;
  SubSubPracticeGroupAbbreviation?: Maybe<Scalars['String']['output']>;
  SubSubPracticeGroupCode: Scalars['String']['output'];
  SubSubPracticeGroupGUID?: Maybe<Scalars['uniqueidentifier']['output']>;
  SubSubPracticeGroupName?: Maybe<Scalars['String']['output']>;
  isActiveSubSubPracticeGroup?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  mnet_practice_area_detail?: Maybe<Mnet_Practice_Area_Detail>;
  mnet_practice_group_detail?: Maybe<Mnet_Practice_Group_Detail>;
  /** An array relationship */
  personnel_in_practicegroup: Array<Mlfsl_Personnel>;
  /** An aggregate relationship */
  personnel_in_practicegroup_aggregate: Mlfsl_Personnel_Aggregate;
};

/** columns and relationships of "repl.DimPracticeGroupNow" */
export type Mlfsl_PracticegroupPersonnel_In_PracticegroupArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
};

/** columns and relationships of "repl.DimPracticeGroupNow" */
export type Mlfsl_PracticegroupPersonnel_In_Practicegroup_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
};

/** aggregated selection of "repl.DimPracticeGroupNow" */
export type Mlfsl_Practicegroup_Aggregate = {
  aggregate?: Maybe<Mlfsl_Practicegroup_Aggregate_Fields>;
  nodes: Array<Mlfsl_Practicegroup>;
};

/** aggregate fields of "repl.DimPracticeGroupNow" */
export type Mlfsl_Practicegroup_Aggregate_Fields = {
  avg?: Maybe<Mlfsl_Practicegroup_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mlfsl_Practicegroup_Max_Fields>;
  min?: Maybe<Mlfsl_Practicegroup_Min_Fields>;
  stddev?: Maybe<Mlfsl_Practicegroup_Stddev_Fields>;
  stddev_pop?: Maybe<Mlfsl_Practicegroup_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mlfsl_Practicegroup_Stddev_Samp_Fields>;
  sum?: Maybe<Mlfsl_Practicegroup_Sum_Fields>;
  var_pop?: Maybe<Mlfsl_Practicegroup_Var_Pop_Fields>;
  var_samp?: Maybe<Mlfsl_Practicegroup_Var_Samp_Fields>;
  variance?: Maybe<Mlfsl_Practicegroup_Variance_Fields>;
};

/** aggregate fields of "repl.DimPracticeGroupNow" */
export type Mlfsl_Practicegroup_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Mlfsl_Practicegroup_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mlfsl_Practicegroup_Avg_Fields = {
  DimPracticeGroupNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlCheckSum?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "repl.DimPracticeGroupNow". All fields are combined with a logical 'AND'. */
export type Mlfsl_Practicegroup_Bool_Exp = {
  ActiveFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  DeletedRecordIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  DimPracticeGroupNowKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLBatchKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLCreatedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  ETLModifiedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  EtlCheckSum?: InputMaybe<Int_Mssql_Comparison_Exp>;
  LawsonSubSubPracticeGroupName?: InputMaybe<String_Mssql_Comparison_Exp>;
  PracticeArea?: InputMaybe<String_Mssql_Comparison_Exp>;
  PracticeAreaDelimited?: InputMaybe<String_Mssql_Comparison_Exp>;
  PracticeGroupAbbreviation?: InputMaybe<String_Mssql_Comparison_Exp>;
  PracticeGroupCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  PracticeGroupGUID?: InputMaybe<Uniqueidentifier_Mssql_Comparison_Exp>;
  PracticeGroupName?: InputMaybe<String_Mssql_Comparison_Exp>;
  PracticeGroupType?: InputMaybe<String_Mssql_Comparison_Exp>;
  SectionAbbreviation?: InputMaybe<String_Mssql_Comparison_Exp>;
  SectionCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  SectionName?: InputMaybe<String_Mssql_Comparison_Exp>;
  SubPracticeGroupAbbreviation?: InputMaybe<String_Mssql_Comparison_Exp>;
  SubPracticeGroupCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  SubPracticeGroupName?: InputMaybe<String_Mssql_Comparison_Exp>;
  SubSubPracticeGroupAbbreviation?: InputMaybe<String_Mssql_Comparison_Exp>;
  SubSubPracticeGroupCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  SubSubPracticeGroupGUID?: InputMaybe<Uniqueidentifier_Mssql_Comparison_Exp>;
  SubSubPracticeGroupName?: InputMaybe<String_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Practicegroup_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Practicegroup_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Practicegroup_Bool_Exp>>;
  isActiveSubSubPracticeGroup?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  isDeleted?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  personnel_in_practicegroup?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
};

/** aggregate max on columns */
export type Mlfsl_Practicegroup_Max_Fields = {
  ActiveFlag?: Maybe<Scalars['String']['output']>;
  DeletedRecordIndicator?: Maybe<Scalars['String']['output']>;
  DimPracticeGroupNowKey?: Maybe<Scalars['Int']['output']>;
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  ETLCreatedDate?: Maybe<Scalars['datetime']['output']>;
  ETLModifiedDate?: Maybe<Scalars['datetime']['output']>;
  EtlCheckSum?: Maybe<Scalars['Int']['output']>;
  LawsonSubSubPracticeGroupName?: Maybe<Scalars['String']['output']>;
  PracticeArea?: Maybe<Scalars['String']['output']>;
  PracticeAreaDelimited?: Maybe<Scalars['String']['output']>;
  PracticeGroupAbbreviation?: Maybe<Scalars['String']['output']>;
  PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  PracticeGroupName?: Maybe<Scalars['String']['output']>;
  PracticeGroupType?: Maybe<Scalars['String']['output']>;
  SectionAbbreviation?: Maybe<Scalars['String']['output']>;
  SectionCode?: Maybe<Scalars['String']['output']>;
  SectionName?: Maybe<Scalars['String']['output']>;
  SubPracticeGroupAbbreviation?: Maybe<Scalars['String']['output']>;
  SubPracticeGroupCode?: Maybe<Scalars['String']['output']>;
  SubPracticeGroupName?: Maybe<Scalars['String']['output']>;
  SubSubPracticeGroupAbbreviation?: Maybe<Scalars['String']['output']>;
  SubSubPracticeGroupCode?: Maybe<Scalars['String']['output']>;
  SubSubPracticeGroupName?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mlfsl_Practicegroup_Min_Fields = {
  ActiveFlag?: Maybe<Scalars['String']['output']>;
  DeletedRecordIndicator?: Maybe<Scalars['String']['output']>;
  DimPracticeGroupNowKey?: Maybe<Scalars['Int']['output']>;
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  ETLCreatedDate?: Maybe<Scalars['datetime']['output']>;
  ETLModifiedDate?: Maybe<Scalars['datetime']['output']>;
  EtlCheckSum?: Maybe<Scalars['Int']['output']>;
  LawsonSubSubPracticeGroupName?: Maybe<Scalars['String']['output']>;
  PracticeArea?: Maybe<Scalars['String']['output']>;
  PracticeAreaDelimited?: Maybe<Scalars['String']['output']>;
  PracticeGroupAbbreviation?: Maybe<Scalars['String']['output']>;
  PracticeGroupCode?: Maybe<Scalars['String']['output']>;
  PracticeGroupName?: Maybe<Scalars['String']['output']>;
  PracticeGroupType?: Maybe<Scalars['String']['output']>;
  SectionAbbreviation?: Maybe<Scalars['String']['output']>;
  SectionCode?: Maybe<Scalars['String']['output']>;
  SectionName?: Maybe<Scalars['String']['output']>;
  SubPracticeGroupAbbreviation?: Maybe<Scalars['String']['output']>;
  SubPracticeGroupCode?: Maybe<Scalars['String']['output']>;
  SubPracticeGroupName?: Maybe<Scalars['String']['output']>;
  SubSubPracticeGroupAbbreviation?: Maybe<Scalars['String']['output']>;
  SubSubPracticeGroupCode?: Maybe<Scalars['String']['output']>;
  SubSubPracticeGroupName?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "repl.DimPracticeGroupNow". */
export type Mlfsl_Practicegroup_Order_By = {
  ActiveFlag?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DimPracticeGroupNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLCreatedDate?: InputMaybe<Order_By>;
  ETLModifiedDate?: InputMaybe<Order_By>;
  EtlCheckSum?: InputMaybe<Order_By>;
  LawsonSubSubPracticeGroupName?: InputMaybe<Order_By>;
  PracticeArea?: InputMaybe<Order_By>;
  PracticeAreaDelimited?: InputMaybe<Order_By>;
  PracticeGroupAbbreviation?: InputMaybe<Order_By>;
  PracticeGroupCode?: InputMaybe<Order_By>;
  PracticeGroupGUID?: InputMaybe<Order_By>;
  PracticeGroupName?: InputMaybe<Order_By>;
  PracticeGroupType?: InputMaybe<Order_By>;
  SectionAbbreviation?: InputMaybe<Order_By>;
  SectionCode?: InputMaybe<Order_By>;
  SectionName?: InputMaybe<Order_By>;
  SubPracticeGroupAbbreviation?: InputMaybe<Order_By>;
  SubPracticeGroupCode?: InputMaybe<Order_By>;
  SubPracticeGroupName?: InputMaybe<Order_By>;
  SubSubPracticeGroupAbbreviation?: InputMaybe<Order_By>;
  SubSubPracticeGroupCode?: InputMaybe<Order_By>;
  SubSubPracticeGroupGUID?: InputMaybe<Order_By>;
  SubSubPracticeGroupName?: InputMaybe<Order_By>;
  isActiveSubSubPracticeGroup?: InputMaybe<Order_By>;
  isDeleted?: InputMaybe<Order_By>;
  personnel_in_practicegroup_aggregate?: InputMaybe<Mlfsl_Personnel_Aggregate_Order_By>;
};

/** select columns of table "repl.DimPracticeGroupNow" */
export enum Mlfsl_Practicegroup_Select_Column {
  /** column name */
  ActiveFlag = 'ActiveFlag',
  /** column name */
  DeletedRecordIndicator = 'DeletedRecordIndicator',
  /** column name */
  DimPracticeGroupNowKey = 'DimPracticeGroupNowKey',
  /** column name */
  ETLBatchKey = 'ETLBatchKey',
  /** column name */
  ETLCreatedDate = 'ETLCreatedDate',
  /** column name */
  ETLModifiedDate = 'ETLModifiedDate',
  /** column name */
  EtlCheckSum = 'EtlCheckSum',
  /** column name */
  LawsonSubSubPracticeGroupName = 'LawsonSubSubPracticeGroupName',
  /** column name */
  PracticeArea = 'PracticeArea',
  /** column name */
  PracticeAreaDelimited = 'PracticeAreaDelimited',
  /** column name */
  PracticeGroupAbbreviation = 'PracticeGroupAbbreviation',
  /** column name */
  PracticeGroupCode = 'PracticeGroupCode',
  /** column name */
  PracticeGroupGUID = 'PracticeGroupGUID',
  /** column name */
  PracticeGroupName = 'PracticeGroupName',
  /** column name */
  PracticeGroupType = 'PracticeGroupType',
  /** column name */
  SectionAbbreviation = 'SectionAbbreviation',
  /** column name */
  SectionCode = 'SectionCode',
  /** column name */
  SectionName = 'SectionName',
  /** column name */
  SubPracticeGroupAbbreviation = 'SubPracticeGroupAbbreviation',
  /** column name */
  SubPracticeGroupCode = 'SubPracticeGroupCode',
  /** column name */
  SubPracticeGroupName = 'SubPracticeGroupName',
  /** column name */
  SubSubPracticeGroupAbbreviation = 'SubSubPracticeGroupAbbreviation',
  /** column name */
  SubSubPracticeGroupCode = 'SubSubPracticeGroupCode',
  /** column name */
  SubSubPracticeGroupGUID = 'SubSubPracticeGroupGUID',
  /** column name */
  SubSubPracticeGroupName = 'SubSubPracticeGroupName',
  /** column name */
  IsActiveSubSubPracticeGroup = 'isActiveSubSubPracticeGroup',
  /** column name */
  IsDeleted = 'isDeleted',
}

/** aggregate stddev on columns */
export type Mlfsl_Practicegroup_Stddev_Fields = {
  DimPracticeGroupNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlCheckSum?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mlfsl_Practicegroup_Stddev_Pop_Fields = {
  DimPracticeGroupNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlCheckSum?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mlfsl_Practicegroup_Stddev_Samp_Fields = {
  DimPracticeGroupNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlCheckSum?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Mlfsl_Practicegroup_Sum_Fields = {
  DimPracticeGroupNowKey?: Maybe<Scalars['Int']['output']>;
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  EtlCheckSum?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Mlfsl_Practicegroup_Var_Pop_Fields = {
  DimPracticeGroupNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlCheckSum?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mlfsl_Practicegroup_Var_Samp_Fields = {
  DimPracticeGroupNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlCheckSum?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mlfsl_Practicegroup_Variance_Fields = {
  DimPracticeGroupNowKey?: Maybe<Scalars['Float']['output']>;
  ETLBatchKey?: Maybe<Scalars['Float']['output']>;
  EtlCheckSum?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal = {
  DateofRun: Scalars['datetime2']['output'];
  EmployeeID?: Maybe<Scalars['String']['output']>;
  FiscalYear?: Maybe<Scalars['Int']['output']>;
  HasTKMetProBonoGoalasofNow: Scalars['String']['output'];
  HoursToMeetGoal?: Maybe<Scalars['Float']['output']>;
  NetworkID?: Maybe<Scalars['String']['output']>;
  NumberofProBonoHours?: Maybe<Scalars['Float']['output']>;
  ProBonoGoal?: Maybe<Scalars['Float']['output']>;
  exempt_user?: Maybe<Pbc_Exempt_Users>;
  /** An object relationship */
  user?: Maybe<Mlfsl_Personnel>;
};

/** order by aggregate values of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Aggregate_Order_By = {
  avg?: InputMaybe<Mlfsl_Probono_Goal_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mlfsl_Probono_Goal_Max_Order_By>;
  min?: InputMaybe<Mlfsl_Probono_Goal_Min_Order_By>;
  stddev?: InputMaybe<Mlfsl_Probono_Goal_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mlfsl_Probono_Goal_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mlfsl_Probono_Goal_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mlfsl_Probono_Goal_Sum_Order_By>;
  var_pop?: InputMaybe<Mlfsl_Probono_Goal_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mlfsl_Probono_Goal_Var_Samp_Order_By>;
  variance?: InputMaybe<Mlfsl_Probono_Goal_Variance_Order_By>;
};

/** order by avg() on columns of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Avg_Order_By = {
  FiscalYear?: InputMaybe<Order_By>;
  HoursToMeetGoal?: InputMaybe<Order_By>;
  NumberofProBonoHours?: InputMaybe<Order_By>;
  ProBonoGoal?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "Finance.ProbonoGoalExport". All fields are combined with a logical 'AND'. */
export type Mlfsl_Probono_Goal_Bool_Exp = {
  DateofRun?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  EmployeeID?: InputMaybe<String_Mssql_Comparison_Exp>;
  FiscalYear?: InputMaybe<Int_Mssql_Comparison_Exp>;
  HasTKMetProBonoGoalasofNow?: InputMaybe<String_Mssql_Comparison_Exp>;
  HoursToMeetGoal?: InputMaybe<Float_Mssql_Comparison_Exp>;
  NetworkID?: InputMaybe<String_Mssql_Comparison_Exp>;
  NumberofProBonoHours?: InputMaybe<Float_Mssql_Comparison_Exp>;
  ProBonoGoal?: InputMaybe<Float_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Probono_Goal_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Probono_Goal_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Probono_Goal_Bool_Exp>>;
  user?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
};

/** order by max() on columns of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Max_Order_By = {
  DateofRun?: InputMaybe<Order_By>;
  EmployeeID?: InputMaybe<Order_By>;
  FiscalYear?: InputMaybe<Order_By>;
  HasTKMetProBonoGoalasofNow?: InputMaybe<Order_By>;
  HoursToMeetGoal?: InputMaybe<Order_By>;
  NetworkID?: InputMaybe<Order_By>;
  NumberofProBonoHours?: InputMaybe<Order_By>;
  ProBonoGoal?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Min_Order_By = {
  DateofRun?: InputMaybe<Order_By>;
  EmployeeID?: InputMaybe<Order_By>;
  FiscalYear?: InputMaybe<Order_By>;
  HasTKMetProBonoGoalasofNow?: InputMaybe<Order_By>;
  HoursToMeetGoal?: InputMaybe<Order_By>;
  NetworkID?: InputMaybe<Order_By>;
  NumberofProBonoHours?: InputMaybe<Order_By>;
  ProBonoGoal?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "Finance.ProbonoGoalExport". */
export type Mlfsl_Probono_Goal_Order_By = {
  DateofRun?: InputMaybe<Order_By>;
  EmployeeID?: InputMaybe<Order_By>;
  FiscalYear?: InputMaybe<Order_By>;
  HasTKMetProBonoGoalasofNow?: InputMaybe<Order_By>;
  HoursToMeetGoal?: InputMaybe<Order_By>;
  NetworkID?: InputMaybe<Order_By>;
  NumberofProBonoHours?: InputMaybe<Order_By>;
  ProBonoGoal?: InputMaybe<Order_By>;
  user?: InputMaybe<Mlfsl_Personnel_Order_By>;
};

/** order by stddev() on columns of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Stddev_Order_By = {
  FiscalYear?: InputMaybe<Order_By>;
  HoursToMeetGoal?: InputMaybe<Order_By>;
  NumberofProBonoHours?: InputMaybe<Order_By>;
  ProBonoGoal?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Stddev_Pop_Order_By = {
  FiscalYear?: InputMaybe<Order_By>;
  HoursToMeetGoal?: InputMaybe<Order_By>;
  NumberofProBonoHours?: InputMaybe<Order_By>;
  ProBonoGoal?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Stddev_Samp_Order_By = {
  FiscalYear?: InputMaybe<Order_By>;
  HoursToMeetGoal?: InputMaybe<Order_By>;
  NumberofProBonoHours?: InputMaybe<Order_By>;
  ProBonoGoal?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Sum_Order_By = {
  FiscalYear?: InputMaybe<Order_By>;
  HoursToMeetGoal?: InputMaybe<Order_By>;
  NumberofProBonoHours?: InputMaybe<Order_By>;
  ProBonoGoal?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Var_Pop_Order_By = {
  FiscalYear?: InputMaybe<Order_By>;
  HoursToMeetGoal?: InputMaybe<Order_By>;
  NumberofProBonoHours?: InputMaybe<Order_By>;
  ProBonoGoal?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Var_Samp_Order_By = {
  FiscalYear?: InputMaybe<Order_By>;
  HoursToMeetGoal?: InputMaybe<Order_By>;
  NumberofProBonoHours?: InputMaybe<Order_By>;
  ProBonoGoal?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "Finance.ProbonoGoalExport" */
export type Mlfsl_Probono_Goal_Variance_Order_By = {
  FiscalYear?: InputMaybe<Order_By>;
  HoursToMeetGoal?: InputMaybe<Order_By>;
  NumberofProBonoHours?: InputMaybe<Order_By>;
  ProBonoGoal?: InputMaybe<Order_By>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_Client = {
  AdministrativeFlag?: Maybe<Scalars['String']['output']>;
  ClientAddress1?: Maybe<Scalars['String']['output']>;
  ClientAddress2?: Maybe<Scalars['String']['output']>;
  ClientAddress3?: Maybe<Scalars['String']['output']>;
  ClientAddress4?: Maybe<Scalars['String']['output']>;
  ClientAddress5?: Maybe<Scalars['String']['output']>;
  ClientAddress6?: Maybe<Scalars['String']['output']>;
  ClientArrangementCode?: Maybe<Scalars['String']['output']>;
  ClientArrangementCodeDescription?: Maybe<Scalars['String']['output']>;
  ClientCity?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  ClientClosedDate?: Maybe<Mlfsl_Date>;
  ClientContact?: Maybe<Scalars['String']['output']>;
  ClientCountry?: Maybe<Scalars['String']['output']>;
  ClientGUID?: Maybe<Scalars['uniqueidentifier']['output']>;
  ClientIndex?: Maybe<Scalars['Int']['output']>;
  ClientName1?: Maybe<Scalars['String']['output']>;
  ClientName2?: Maybe<Scalars['String']['output']>;
  ClientNameDisplay?: Maybe<Scalars['String']['output']>;
  ClientNumber: Scalars['String']['output'];
  ClientNumberGroupCodeInd?: Maybe<Scalars['Boolean']['output']>;
  ClientNumberIwov?: Maybe<Scalars['String']['output']>;
  ClientNumberNoGroupCode?: Maybe<Scalars['String']['output']>;
  ClientNumberWithDash?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  ClientOpenDate?: Maybe<Mlfsl_Date>;
  ClientPhoneNumber?: Maybe<Scalars['String']['output']>;
  ClientPricingNarrative?: Maybe<Scalars['String']['output']>;
  ClientReferredBy?: Maybe<Scalars['String']['output']>;
  ClientSortName?: Maybe<Scalars['String']['output']>;
  ClientSourceAbbreviation?: Maybe<Scalars['String']['output']>;
  ClientSourceName?: Maybe<Scalars['String']['output']>;
  ClientSourceNumber?: Maybe<Scalars['String']['output']>;
  ClientState?: Maybe<Scalars['String']['output']>;
  ClientStatusCode?: Maybe<Scalars['String']['output']>;
  ClientStatusCodeActive?: Maybe<Scalars['String']['output']>;
  ClientStatusDescription?: Maybe<Scalars['String']['output']>;
  ClientZipCode?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  Clients: Array<Mlfsl_Client>;
  /** An aggregate relationship */
  Clients_aggregate: Mlfsl_Client_Aggregate;
  Confidential?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  ConflictsAttorney?: Maybe<Mlfsl_Personnel>;
  ConflictsAttorneyTKID?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  CoordinatingResponsibleAttorney?: Maybe<Mlfsl_Personnel>;
  CoordinatingResponsibleAttorneyTKID?: Maybe<Scalars['String']['output']>;
  DateClientClosed?: Maybe<Scalars['Int']['output']>;
  DateClientOpen?: Maybe<Scalars['Int']['output']>;
  DeletedRecordIndicator: Scalars['String']['output'];
  DimClientNowKey: Scalars['Int']['output'];
  ETLBatchKey?: Maybe<Scalars['Int']['output']>;
  ETLSoftInsertIndicator?: Maybe<Scalars['String']['output']>;
  EtlChecksum?: Maybe<Scalars['Int']['output']>;
  EtlCreatedDate: Scalars['datetime']['output'];
  EtlModifiedDate: Scalars['datetime']['output'];
  IndustryDescription?: Maybe<Scalars['String']['output']>;
  InventoryExceptionCode?: Maybe<Scalars['String']['output']>;
  InventoryExceptionDescription?: Maybe<Scalars['String']['output']>;
  IsClientAllianceProgram?: Maybe<Scalars['Int']['output']>;
  LocationCode?: Maybe<Scalars['String']['output']>;
  MatterStop?: Maybe<Scalars['String']['output']>;
  RelatedClientName?: Maybe<Scalars['String']['output']>;
  RelatedClientNumber?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  ResponsibleAttorney?: Maybe<Mlfsl_Personnel>;
  ResponsibleAttorneyTkId?: Maybe<Scalars['String']['output']>;
  SecureAlliManageMatterWorkspacesFlag?: Maybe<Scalars['String']['output']>;
  SegmentDescription?: Maybe<Scalars['String']['output']>;
  SicCodeAndDescription?: Maybe<Scalars['String']['output']>;
  SicDescription?: Maybe<Scalars['String']['output']>;
  SicTypeCode?: Maybe<Scalars['String']['output']>;
  WallBuilderEntityId?: Maybe<Scalars['Int']['output']>;
  client_intel_settings?: Maybe<Mnet_Client_Intel_Settings>;
  clientbadge_related_client: Array<Mnet_Clientbadge_Related_Client>;
  clientbadge_related_client_aggregate: Mnet_Clientbadge_Related_Client_Aggregate;
  /** An array relationship */
  mlfsl_finance_hours_clientofficetimeframes: Array<Mlfsl_Finance_Hours_Clientofficetimeframe>;
  /** An array relationship */
  mlfsl_finance_hours_clientpgtimeframes: Array<Mlfsl_Finance_Hours_Clientpgtimeframe>;
  /** An array relationship */
  mlfsl_finance_hours_clienttimeframes: Array<Mlfsl_Finance_Hours_Clienttimeframe>;
  /** An aggregate relationship */
  mlfsl_finance_hours_clienttimeframes_aggregate: Mlfsl_Finance_Hours_Clienttimeframe_Aggregate;
  /** An array relationship */
  mlfsl_finance_hours_clienttimekeepertimeframes: Array<Mlfsl_Finance_Hours_Clienttimekeepertimeframe>;
  /** An aggregate relationship */
  mlfsl_finance_hours_clienttimekeepertimeframes_aggregate: Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Aggregate;
  /** An array relationship */
  mlfsl_finance_hours_matterofficetimeframes: Array<Mlfsl_Finance_Hours_Matterofficetimeframe>;
  /** An array relationship */
  mlfsl_finance_hours_matterpgtimeframes: Array<Mlfsl_Finance_Hours_Matterpgtimeframe>;
  /** An array relationship */
  mlfsl_finance_hours_mattertimeframecompares: Array<Mlfsl_Finance_Hours_Mattertimeframecompare>;
  /** An array relationship */
  mlfsl_finance_hours_mattertimeframes: Array<Mlfsl_Finance_Hours_Mattertimeframe>;
  /** An aggregate relationship */
  mlfsl_finance_hours_mattertimeframes_aggregate: Mlfsl_Finance_Hours_Mattertimeframe_Aggregate;
  /** An array relationship */
  mlfsl_finance_hours_relatedclientofficetimeframes: Array<Mlfsl_Finance_Hours_Relatedclientofficetimeframe>;
  /** An array relationship */
  mlfsl_finance_hours_relatedclientpgtimeframes: Array<Mlfsl_Finance_Hours_Relatedclientpgtimeframe>;
  /** An array relationship */
  mlfsl_finance_hours_relatedclienttimeframe: Array<Mlfsl_Finance_Hours_Relatedclienttimeframe>;
  /** An aggregate relationship */
  mlfsl_finance_hours_relatedclienttimeframe_aggregate: Mlfsl_Finance_Hours_Relatedclienttimeframe_Aggregate;
  /** An array relationship */
  mlfsl_finance_hours_relatedclienttimekeepertimeframes: Array<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe>;
  /** An aggregate relationship */
  mlfsl_finance_hours_relatedclienttimekeepertimeframes_aggregate: Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Aggregate;
  /** An object relationship */
  mlfsl_mlv_finance_hours_relatedclient?: Maybe<Mlfsl_Mlv_Finance_Hours_Relatedclient>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientClientsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Client_Order_By>>;
  where?: InputMaybe<Mlfsl_Client_Bool_Exp>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientClients_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Client_Order_By>>;
  where?: InputMaybe<Mlfsl_Client_Bool_Exp>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientClientbadge_Related_ClientArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Related_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Related_Client_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Related_Client_Bool_Exp>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientClientbadge_Related_Client_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Related_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Related_Client_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Related_Client_Bool_Exp>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientMlfsl_Finance_Hours_ClientofficetimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clientofficetimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clientofficetimeframe_Bool_Exp>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientMlfsl_Finance_Hours_ClientpgtimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clientpgtimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clientpgtimeframe_Bool_Exp>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientMlfsl_Finance_Hours_ClienttimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clienttimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Bool_Exp>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientMlfsl_Finance_Hours_Clienttimeframes_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clienttimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Bool_Exp>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientMlfsl_Finance_Hours_ClienttimekeepertimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Bool_Exp>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientMlfsl_Finance_Hours_Clienttimekeepertimeframes_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Bool_Exp>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientMlfsl_Finance_Hours_MatterofficetimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Matterofficetimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Bool_Exp>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientMlfsl_Finance_Hours_MatterpgtimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Matterpgtimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Bool_Exp>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientMlfsl_Finance_Hours_MattertimeframecomparesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimeframecompare_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Bool_Exp>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientMlfsl_Finance_Hours_MattertimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientMlfsl_Finance_Hours_Mattertimeframes_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientMlfsl_Finance_Hours_RelatedclientofficetimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Bool_Exp>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientMlfsl_Finance_Hours_RelatedclientpgtimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Bool_Exp>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientMlfsl_Finance_Hours_RelatedclienttimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclienttimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Bool_Exp>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientMlfsl_Finance_Hours_Relatedclienttimeframe_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclienttimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Bool_Exp>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientMlfsl_Finance_Hours_RelatedclienttimekeepertimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Bool_Exp>;
};

/** columns and relationships of "MLG.RelatedClient" */
export type Mlfsl_Related_ClientMlfsl_Finance_Hours_Relatedclienttimekeepertimeframes_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "MLG.RelatedClient". All fields are combined with a logical 'AND'. */
export type Mlfsl_Related_Client_Bool_Exp = {
  AdministrativeFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientAddress1?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientAddress2?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientAddress3?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientAddress4?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientAddress5?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientAddress6?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientArrangementCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientArrangementCodeDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientCity?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientClosedDate?: InputMaybe<Mlfsl_Date_Bool_Exp>;
  ClientContact?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientCountry?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientGUID?: InputMaybe<Uniqueidentifier_Mssql_Comparison_Exp>;
  ClientIndex?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ClientName1?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientName2?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientNameDisplay?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientNumberGroupCodeInd?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  ClientNumberIwov?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientNumberNoGroupCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientNumberWithDash?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientOpenDate?: InputMaybe<Mlfsl_Date_Bool_Exp>;
  ClientPhoneNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientPricingNarrative?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientReferredBy?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientSortName?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientSourceAbbreviation?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientSourceName?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientSourceNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientState?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientStatusCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientStatusCodeActive?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientStatusDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  ClientZipCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  Clients?: InputMaybe<Mlfsl_Client_Bool_Exp>;
  Confidential?: InputMaybe<String_Mssql_Comparison_Exp>;
  ConflictsAttorney?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
  ConflictsAttorneyTKID?: InputMaybe<String_Mssql_Comparison_Exp>;
  CoordinatingResponsibleAttorney?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
  CoordinatingResponsibleAttorneyTKID?: InputMaybe<String_Mssql_Comparison_Exp>;
  DateClientClosed?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DateClientOpen?: InputMaybe<Int_Mssql_Comparison_Exp>;
  DeletedRecordIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  DimClientNowKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLBatchKey?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ETLSoftInsertIndicator?: InputMaybe<String_Mssql_Comparison_Exp>;
  EtlChecksum?: InputMaybe<Int_Mssql_Comparison_Exp>;
  EtlCreatedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  EtlModifiedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  IndustryDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  InventoryExceptionCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  InventoryExceptionDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  IsClientAllianceProgram?: InputMaybe<Int_Mssql_Comparison_Exp>;
  LocationCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  MatterStop?: InputMaybe<String_Mssql_Comparison_Exp>;
  RelatedClientName?: InputMaybe<String_Mssql_Comparison_Exp>;
  RelatedClientNumber?: InputMaybe<String_Mssql_Comparison_Exp>;
  ResponsibleAttorney?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
  ResponsibleAttorneyTkId?: InputMaybe<String_Mssql_Comparison_Exp>;
  SecureAlliManageMatterWorkspacesFlag?: InputMaybe<String_Mssql_Comparison_Exp>;
  SegmentDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  SicCodeAndDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  SicDescription?: InputMaybe<String_Mssql_Comparison_Exp>;
  SicTypeCode?: InputMaybe<String_Mssql_Comparison_Exp>;
  WallBuilderEntityId?: InputMaybe<Int_Mssql_Comparison_Exp>;
  _and?: InputMaybe<Array<Mlfsl_Related_Client_Bool_Exp>>;
  _not?: InputMaybe<Mlfsl_Related_Client_Bool_Exp>;
  _or?: InputMaybe<Array<Mlfsl_Related_Client_Bool_Exp>>;
  mlfsl_finance_hours_clientofficetimeframes?: InputMaybe<Mlfsl_Finance_Hours_Clientofficetimeframe_Bool_Exp>;
  mlfsl_finance_hours_clientpgtimeframes?: InputMaybe<Mlfsl_Finance_Hours_Clientpgtimeframe_Bool_Exp>;
  mlfsl_finance_hours_clienttimeframes?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Bool_Exp>;
  mlfsl_finance_hours_clienttimekeepertimeframes?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Bool_Exp>;
  mlfsl_finance_hours_matterofficetimeframes?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Bool_Exp>;
  mlfsl_finance_hours_matterpgtimeframes?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Bool_Exp>;
  mlfsl_finance_hours_mattertimeframecompares?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Bool_Exp>;
  mlfsl_finance_hours_mattertimeframes?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp>;
  mlfsl_finance_hours_relatedclientofficetimeframes?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Bool_Exp>;
  mlfsl_finance_hours_relatedclientpgtimeframes?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Bool_Exp>;
  mlfsl_finance_hours_relatedclienttimeframe?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Bool_Exp>;
  mlfsl_finance_hours_relatedclienttimekeepertimeframes?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Bool_Exp>;
  mlfsl_mlv_finance_hours_relatedclient?: InputMaybe<Mlfsl_Mlv_Finance_Hours_Relatedclient_Bool_Exp>;
};

/** Ordering options when selecting data from "MLG.RelatedClient". */
export type Mlfsl_Related_Client_Order_By = {
  AdministrativeFlag?: InputMaybe<Order_By>;
  ClientAddress1?: InputMaybe<Order_By>;
  ClientAddress2?: InputMaybe<Order_By>;
  ClientAddress3?: InputMaybe<Order_By>;
  ClientAddress4?: InputMaybe<Order_By>;
  ClientAddress5?: InputMaybe<Order_By>;
  ClientAddress6?: InputMaybe<Order_By>;
  ClientArrangementCode?: InputMaybe<Order_By>;
  ClientArrangementCodeDescription?: InputMaybe<Order_By>;
  ClientCity?: InputMaybe<Order_By>;
  ClientClosedDate?: InputMaybe<Mlfsl_Date_Order_By>;
  ClientContact?: InputMaybe<Order_By>;
  ClientCountry?: InputMaybe<Order_By>;
  ClientGUID?: InputMaybe<Order_By>;
  ClientIndex?: InputMaybe<Order_By>;
  ClientName1?: InputMaybe<Order_By>;
  ClientName2?: InputMaybe<Order_By>;
  ClientNameDisplay?: InputMaybe<Order_By>;
  ClientNumber?: InputMaybe<Order_By>;
  ClientNumberGroupCodeInd?: InputMaybe<Order_By>;
  ClientNumberIwov?: InputMaybe<Order_By>;
  ClientNumberNoGroupCode?: InputMaybe<Order_By>;
  ClientNumberWithDash?: InputMaybe<Order_By>;
  ClientOpenDate?: InputMaybe<Mlfsl_Date_Order_By>;
  ClientPhoneNumber?: InputMaybe<Order_By>;
  ClientPricingNarrative?: InputMaybe<Order_By>;
  ClientReferredBy?: InputMaybe<Order_By>;
  ClientSortName?: InputMaybe<Order_By>;
  ClientSourceAbbreviation?: InputMaybe<Order_By>;
  ClientSourceName?: InputMaybe<Order_By>;
  ClientSourceNumber?: InputMaybe<Order_By>;
  ClientState?: InputMaybe<Order_By>;
  ClientStatusCode?: InputMaybe<Order_By>;
  ClientStatusCodeActive?: InputMaybe<Order_By>;
  ClientStatusDescription?: InputMaybe<Order_By>;
  ClientZipCode?: InputMaybe<Order_By>;
  Clients_aggregate?: InputMaybe<Mlfsl_Client_Aggregate_Order_By>;
  Confidential?: InputMaybe<Order_By>;
  ConflictsAttorney?: InputMaybe<Mlfsl_Personnel_Order_By>;
  ConflictsAttorneyTKID?: InputMaybe<Order_By>;
  CoordinatingResponsibleAttorney?: InputMaybe<Mlfsl_Personnel_Order_By>;
  CoordinatingResponsibleAttorneyTKID?: InputMaybe<Order_By>;
  DateClientClosed?: InputMaybe<Order_By>;
  DateClientOpen?: InputMaybe<Order_By>;
  DeletedRecordIndicator?: InputMaybe<Order_By>;
  DimClientNowKey?: InputMaybe<Order_By>;
  ETLBatchKey?: InputMaybe<Order_By>;
  ETLSoftInsertIndicator?: InputMaybe<Order_By>;
  EtlChecksum?: InputMaybe<Order_By>;
  EtlCreatedDate?: InputMaybe<Order_By>;
  EtlModifiedDate?: InputMaybe<Order_By>;
  IndustryDescription?: InputMaybe<Order_By>;
  InventoryExceptionCode?: InputMaybe<Order_By>;
  InventoryExceptionDescription?: InputMaybe<Order_By>;
  IsClientAllianceProgram?: InputMaybe<Order_By>;
  LocationCode?: InputMaybe<Order_By>;
  MatterStop?: InputMaybe<Order_By>;
  RelatedClientName?: InputMaybe<Order_By>;
  RelatedClientNumber?: InputMaybe<Order_By>;
  ResponsibleAttorney?: InputMaybe<Mlfsl_Personnel_Order_By>;
  ResponsibleAttorneyTkId?: InputMaybe<Order_By>;
  SecureAlliManageMatterWorkspacesFlag?: InputMaybe<Order_By>;
  SegmentDescription?: InputMaybe<Order_By>;
  SicCodeAndDescription?: InputMaybe<Order_By>;
  SicDescription?: InputMaybe<Order_By>;
  SicTypeCode?: InputMaybe<Order_By>;
  WallBuilderEntityId?: InputMaybe<Order_By>;
  mlfsl_finance_hours_clientofficetimeframes_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Clientofficetimeframe_Aggregate_Order_By>;
  mlfsl_finance_hours_clientpgtimeframes_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Clientpgtimeframe_Aggregate_Order_By>;
  mlfsl_finance_hours_clienttimeframes_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Aggregate_Order_By>;
  mlfsl_finance_hours_clienttimekeepertimeframes_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Aggregate_Order_By>;
  mlfsl_finance_hours_matterofficetimeframes_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Aggregate_Order_By>;
  mlfsl_finance_hours_matterpgtimeframes_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Aggregate_Order_By>;
  mlfsl_finance_hours_mattertimeframecompares_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Aggregate_Order_By>;
  mlfsl_finance_hours_mattertimeframes_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Aggregate_Order_By>;
  mlfsl_finance_hours_relatedclientofficetimeframes_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Aggregate_Order_By>;
  mlfsl_finance_hours_relatedclientpgtimeframes_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Aggregate_Order_By>;
  mlfsl_finance_hours_relatedclienttimeframe_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Aggregate_Order_By>;
  mlfsl_finance_hours_relatedclienttimekeepertimeframes_aggregate?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Aggregate_Order_By>;
  mlfsl_mlv_finance_hours_relatedclient?: InputMaybe<Mlfsl_Mlv_Finance_Hours_Relatedclient_Order_By>;
};

/** columns and relationships of "mnet.ad_group_link" */
export type Mnet_Ad_Group_Link = {
  end_date: Scalars['timestamptz']['output'];
  mlfsl_ad_group?: Maybe<Mlfsl_Ad_Group>;
  name: Scalars['String']['output'];
  objectguid: Scalars['uuid']['output'];
  priority: Scalars['Int']['output'];
  start_date: Scalars['timestamptz']['output'];
  url: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "mnet.ad_group_link". All fields are combined with a logical 'AND'. */
export type Mnet_Ad_Group_Link_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Ad_Group_Link_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Ad_Group_Link_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Ad_Group_Link_Bool_Exp>>;
  end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  objectguid?: InputMaybe<Uuid_Comparison_Exp>;
  priority?: InputMaybe<Int_Comparison_Exp>;
  start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "mnet.ad_group_link". */
export type Mnet_Ad_Group_Link_Order_By = {
  end_date?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  objectguid?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.ad_group_link" */
export enum Mnet_Ad_Group_Link_Select_Column {
  /** column name */
  End_date = 'end_date',
  /** column name */
  Name = 'name',
  /** column name */
  Objectguid = 'objectguid',
  /** column name */
  Priority = 'priority',
  /** column name */
  Start_date = 'start_date',
  /** column name */
  Url = 'url',
}

/** Streaming cursor of the table "mnet_ad_group_link" */
export type Mnet_Ad_Group_Link_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Ad_Group_Link_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Ad_Group_Link_Stream_Cursor_Value_Input = {
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectguid?: InputMaybe<Scalars['uuid']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "mnet_assignmentportal.my_availability" */
export type Mnet_Assignmentportal_My_Availability = {
  availability: Scalars['String']['output'];
  availability_note?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
  user?: Maybe<Mlfsl_Personnel>;
  user_id: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "mnet_assignmentportal.my_availability". All fields are combined with a logical 'AND'. */
export type Mnet_Assignmentportal_My_Availability_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Assignmentportal_My_Availability_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Assignmentportal_My_Availability_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Assignmentportal_My_Availability_Bool_Exp>>;
  availability?: InputMaybe<String_Comparison_Exp>;
  availability_note?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mnet_assignmentportal.my_availability" */
export enum Mnet_Assignmentportal_My_Availability_Constraint {
  /** unique or primary key constraint on columns "id" */
  My_availability_pkey = 'my_availability_pkey',
  /** unique or primary key constraint on columns "user_id" */
  My_availability_user_id_key = 'my_availability_user_id_key',
}

/** input type for inserting data into table "mnet_assignmentportal.my_availability" */
export type Mnet_Assignmentportal_My_Availability_Insert_Input = {
  availability?: InputMaybe<Scalars['String']['input']>;
  availability_note?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "mnet_assignmentportal.my_availability" */
export type Mnet_Assignmentportal_My_Availability_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mnet_Assignmentportal_My_Availability>;
};

/** on_conflict condition type for table "mnet_assignmentportal.my_availability" */
export type Mnet_Assignmentportal_My_Availability_On_Conflict = {
  constraint: Mnet_Assignmentportal_My_Availability_Constraint;
  update_columns?: Array<Mnet_Assignmentportal_My_Availability_Update_Column>;
  where?: InputMaybe<Mnet_Assignmentportal_My_Availability_Bool_Exp>;
};

/** Ordering options when selecting data from "mnet_assignmentportal.my_availability". */
export type Mnet_Assignmentportal_My_Availability_Order_By = {
  availability?: InputMaybe<Order_By>;
  availability_note?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mnet_assignmentportal.my_availability */
export type Mnet_Assignmentportal_My_Availability_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mnet_assignmentportal.my_availability" */
export enum Mnet_Assignmentportal_My_Availability_Select_Column {
  /** column name */
  Availability = 'availability',
  /** column name */
  Availability_note = 'availability_note',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
  /** column name */
  User_id = 'user_id',
}

/** input type for updating data in table "mnet_assignmentportal.my_availability" */
export type Mnet_Assignmentportal_My_Availability_Set_Input = {
  availability?: InputMaybe<Scalars['String']['input']>;
  availability_note?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "mnet_assignmentportal_my_availability" */
export type Mnet_Assignmentportal_My_Availability_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Assignmentportal_My_Availability_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Assignmentportal_My_Availability_Stream_Cursor_Value_Input = {
  availability?: InputMaybe<Scalars['String']['input']>;
  availability_note?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "mnet_assignmentportal.my_availability" */
export enum Mnet_Assignmentportal_My_Availability_Update_Column {
  /** column name */
  Availability = 'availability',
  /** column name */
  Availability_note = 'availability_note',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  User_id = 'user_id',
}

export type Mnet_Assignmentportal_My_Availability_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mnet_Assignmentportal_My_Availability_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mnet_Assignmentportal_My_Availability_Bool_Exp;
};

/** columns and relationships of "mnet_blog.attachments" */
export type Mnet_Blog_Attachments = {
  /** An object relationship */
  comment?: Maybe<Mnet_Blog_Comments>;
  comment_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  file_name: Scalars['String']['output'];
  file_url: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  post: Mnet_Blog_Posts;
  post_id: Scalars['uuid']['output'];
  sharepoint_drive_id?: Maybe<Scalars['String']['output']>;
  sharepoint_item_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "mnet_blog.attachments" */
export type Mnet_Blog_Attachments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Blog_Attachments_Max_Order_By>;
  min?: InputMaybe<Mnet_Blog_Attachments_Min_Order_By>;
};

/** input type for inserting array relation for remote table "mnet_blog.attachments" */
export type Mnet_Blog_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Mnet_Blog_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Attachments_On_Conflict>;
};

/** Boolean expression to filter rows from the table "mnet_blog.attachments". All fields are combined with a logical 'AND'. */
export type Mnet_Blog_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Blog_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Blog_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Blog_Attachments_Bool_Exp>>;
  comment?: InputMaybe<Mnet_Blog_Comments_Bool_Exp>;
  comment_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  file_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  post?: InputMaybe<Mnet_Blog_Posts_Bool_Exp>;
  post_id?: InputMaybe<Uuid_Comparison_Exp>;
  sharepoint_drive_id?: InputMaybe<String_Comparison_Exp>;
  sharepoint_item_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mnet_blog.attachments" */
export enum Mnet_Blog_Attachments_Constraint {
  /** unique or primary key constraint on columns "id" */
  Attachments_pkey = 'attachments_pkey',
}

/** input type for inserting data into table "mnet_blog.attachments" */
export type Mnet_Blog_Attachments_Insert_Input = {
  comment?: InputMaybe<Mnet_Blog_Comments_Obj_Rel_Insert_Input>;
  comment_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  post?: InputMaybe<Mnet_Blog_Posts_Obj_Rel_Insert_Input>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  sharepoint_drive_id?: InputMaybe<Scalars['String']['input']>;
  sharepoint_item_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "mnet_blog.attachments" */
export type Mnet_Blog_Attachments_Max_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  file_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  sharepoint_drive_id?: InputMaybe<Order_By>;
  sharepoint_item_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mnet_blog.attachments" */
export type Mnet_Blog_Attachments_Min_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  file_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  sharepoint_drive_id?: InputMaybe<Order_By>;
  sharepoint_item_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mnet_blog.attachments" */
export type Mnet_Blog_Attachments_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mnet_Blog_Attachments>;
};

/** on_conflict condition type for table "mnet_blog.attachments" */
export type Mnet_Blog_Attachments_On_Conflict = {
  constraint: Mnet_Blog_Attachments_Constraint;
  update_columns?: Array<Mnet_Blog_Attachments_Update_Column>;
  where?: InputMaybe<Mnet_Blog_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "mnet_blog.attachments". */
export type Mnet_Blog_Attachments_Order_By = {
  comment?: InputMaybe<Mnet_Blog_Comments_Order_By>;
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  file_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post?: InputMaybe<Mnet_Blog_Posts_Order_By>;
  post_id?: InputMaybe<Order_By>;
  sharepoint_drive_id?: InputMaybe<Order_By>;
  sharepoint_item_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mnet_blog.attachments */
export type Mnet_Blog_Attachments_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mnet_blog.attachments" */
export enum Mnet_Blog_Attachments_Select_Column {
  /** column name */
  Comment_id = 'comment_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  File_name = 'file_name',
  /** column name */
  File_url = 'file_url',
  /** column name */
  Id = 'id',
  /** column name */
  Post_id = 'post_id',
  /** column name */
  Sharepoint_drive_id = 'sharepoint_drive_id',
  /** column name */
  Sharepoint_item_id = 'sharepoint_item_id',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "mnet_blog.attachments" */
export type Mnet_Blog_Attachments_Set_Input = {
  comment_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  sharepoint_drive_id?: InputMaybe<Scalars['String']['input']>;
  sharepoint_item_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "mnet_blog_attachments" */
export type Mnet_Blog_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Blog_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Blog_Attachments_Stream_Cursor_Value_Input = {
  comment_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  sharepoint_drive_id?: InputMaybe<Scalars['String']['input']>;
  sharepoint_item_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "mnet_blog.attachments" */
export enum Mnet_Blog_Attachments_Update_Column {
  /** column name */
  Comment_id = 'comment_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  File_name = 'file_name',
  /** column name */
  File_url = 'file_url',
  /** column name */
  Id = 'id',
  /** column name */
  Post_id = 'post_id',
  /** column name */
  Sharepoint_drive_id = 'sharepoint_drive_id',
  /** column name */
  Sharepoint_item_id = 'sharepoint_item_id',
  /** column name */
  Updated_at = 'updated_at',
}

export type Mnet_Blog_Attachments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mnet_Blog_Attachments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mnet_Blog_Attachments_Bool_Exp;
};

/** columns and relationships of "mnet_blog.blogs" */
export type Mnet_Blog_Blogs = {
  /** An array relationship */
  channel_notifications: Array<Mnet_Blog_Channel_Notifications>;
  /** An array relationship */
  channels: Array<Mnet_Blog_Channels>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  group_in_blogs: Array<Mnet_Blog_Group_In_Blogs>;
  id: Scalars['uuid']['output'];
  is_deleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  notification_recipients: Array<Mnet_Blog_Notification_Recipients>;
  /** An array relationship */
  notification_template_rules: Array<Mnet_Blog_Notification_Template_Rules>;
  /** An array relationship */
  posts: Array<Mnet_Blog_Posts>;
  /** An aggregate relationship */
  posts_aggregate: Mnet_Blog_Posts_Aggregate;
  slug: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "mnet_blog.blogs" */
export type Mnet_Blog_BlogsChannel_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Channel_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Channel_Notifications_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Channel_Notifications_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.blogs" */
export type Mnet_Blog_BlogsChannelsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Channels_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Channels_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.blogs" */
export type Mnet_Blog_BlogsGroup_In_BlogsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Group_In_Blogs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Group_In_Blogs_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Group_In_Blogs_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.blogs" */
export type Mnet_Blog_BlogsNotification_RecipientsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Notification_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Notification_Recipients_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Notification_Recipients_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.blogs" */
export type Mnet_Blog_BlogsNotification_Template_RulesArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Notification_Template_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Notification_Template_Rules_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.blogs" */
export type Mnet_Blog_BlogsPostsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Posts_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Posts_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.blogs" */
export type Mnet_Blog_BlogsPosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Posts_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Posts_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "mnet_blog.blogs". All fields are combined with a logical 'AND'. */
export type Mnet_Blog_Blogs_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Blog_Blogs_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Blog_Blogs_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Blog_Blogs_Bool_Exp>>;
  channel_notifications?: InputMaybe<Mnet_Blog_Channel_Notifications_Bool_Exp>;
  channels?: InputMaybe<Mnet_Blog_Channels_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  group_in_blogs?: InputMaybe<Mnet_Blog_Group_In_Blogs_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notification_recipients?: InputMaybe<Mnet_Blog_Notification_Recipients_Bool_Exp>;
  notification_template_rules?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Bool_Exp>;
  posts?: InputMaybe<Mnet_Blog_Posts_Bool_Exp>;
  posts_aggregate?: InputMaybe<Mnet_Blog_Posts_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mnet_blog.blogs" */
export enum Mnet_Blog_Blogs_Constraint {
  /** unique or primary key constraint on columns "id" */
  Blogs_pkey = 'blogs_pkey',
  /** unique or primary key constraint on columns "slug" */
  Blogs_slug_key = 'blogs_slug_key',
}

/** input type for inserting data into table "mnet_blog.blogs" */
export type Mnet_Blog_Blogs_Insert_Input = {
  channel_notifications?: InputMaybe<Mnet_Blog_Channel_Notifications_Arr_Rel_Insert_Input>;
  channels?: InputMaybe<Mnet_Blog_Channels_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group_in_blogs?: InputMaybe<Mnet_Blog_Group_In_Blogs_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notification_recipients?: InputMaybe<Mnet_Blog_Notification_Recipients_Arr_Rel_Insert_Input>;
  notification_template_rules?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Arr_Rel_Insert_Input>;
  posts?: InputMaybe<Mnet_Blog_Posts_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "mnet_blog.blogs" */
export type Mnet_Blog_Blogs_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mnet_Blog_Blogs>;
};

/** input type for inserting object relation for remote table "mnet_blog.blogs" */
export type Mnet_Blog_Blogs_Obj_Rel_Insert_Input = {
  data: Mnet_Blog_Blogs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Blogs_On_Conflict>;
};

/** on_conflict condition type for table "mnet_blog.blogs" */
export type Mnet_Blog_Blogs_On_Conflict = {
  constraint: Mnet_Blog_Blogs_Constraint;
  update_columns?: Array<Mnet_Blog_Blogs_Update_Column>;
  where?: InputMaybe<Mnet_Blog_Blogs_Bool_Exp>;
};

/** Ordering options when selecting data from "mnet_blog.blogs". */
export type Mnet_Blog_Blogs_Order_By = {
  channel_notifications_aggregate?: InputMaybe<Mnet_Blog_Channel_Notifications_Aggregate_Order_By>;
  channels_aggregate?: InputMaybe<Mnet_Blog_Channels_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  group_in_blogs_aggregate?: InputMaybe<Mnet_Blog_Group_In_Blogs_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notification_recipients_aggregate?: InputMaybe<Mnet_Blog_Notification_Recipients_Aggregate_Order_By>;
  notification_template_rules_aggregate?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Aggregate_Order_By>;
  posts_aggregate?: InputMaybe<Mnet_Blog_Posts_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mnet_blog.blogs */
export type Mnet_Blog_Blogs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mnet_blog.blogs" */
export enum Mnet_Blog_Blogs_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Deleted_at = 'deleted_at',
  /** column name */
  Deleted_by = 'deleted_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Is_deleted = 'is_deleted',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "mnet_blog.blogs" */
export type Mnet_Blog_Blogs_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "mnet_blog_blogs" */
export type Mnet_Blog_Blogs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Blog_Blogs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Blog_Blogs_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "mnet_blog.blogs" */
export enum Mnet_Blog_Blogs_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Deleted_at = 'deleted_at',
  /** column name */
  Deleted_by = 'deleted_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Is_deleted = 'is_deleted',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  Updated_at = 'updated_at',
}

export type Mnet_Blog_Blogs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mnet_Blog_Blogs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mnet_Blog_Blogs_Bool_Exp;
};

/** columns and relationships of "mnet_blog.channel_notifications" */
export type Mnet_Blog_Channel_Notifications = {
  /** An object relationship */
  blog: Mnet_Blog_Blogs;
  blog_id: Scalars['uuid']['output'];
  /** An object relationship */
  channel: Mnet_Blog_Channels;
  channel_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  email_template: Mnet_Blog_Email_Templates;
  enabled: Scalars['Boolean']['output'];
  event_type: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  notification_emails: Array<Scalars['String']['output']>;
  template_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "mnet_blog.channel_notifications" */
export type Mnet_Blog_Channel_Notifications_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Blog_Channel_Notifications_Max_Order_By>;
  min?: InputMaybe<Mnet_Blog_Channel_Notifications_Min_Order_By>;
};

/** input type for inserting array relation for remote table "mnet_blog.channel_notifications" */
export type Mnet_Blog_Channel_Notifications_Arr_Rel_Insert_Input = {
  data: Array<Mnet_Blog_Channel_Notifications_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Channel_Notifications_On_Conflict>;
};

/** Boolean expression to filter rows from the table "mnet_blog.channel_notifications". All fields are combined with a logical 'AND'. */
export type Mnet_Blog_Channel_Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Blog_Channel_Notifications_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Blog_Channel_Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Blog_Channel_Notifications_Bool_Exp>>;
  blog?: InputMaybe<Mnet_Blog_Blogs_Bool_Exp>;
  blog_id?: InputMaybe<Uuid_Comparison_Exp>;
  channel?: InputMaybe<Mnet_Blog_Channels_Bool_Exp>;
  channel_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_template?: InputMaybe<Mnet_Blog_Email_Templates_Bool_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notification_emails?: InputMaybe<String_Array_Comparison_Exp>;
  template_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mnet_blog.channel_notifications" */
export enum Mnet_Blog_Channel_Notifications_Constraint {
  /** unique or primary key constraint on columns "id" */
  Channel_notifications_pkey = 'channel_notifications_pkey',
}

/** input type for inserting data into table "mnet_blog.channel_notifications" */
export type Mnet_Blog_Channel_Notifications_Insert_Input = {
  blog?: InputMaybe<Mnet_Blog_Blogs_Obj_Rel_Insert_Input>;
  blog_id?: InputMaybe<Scalars['uuid']['input']>;
  channel?: InputMaybe<Mnet_Blog_Channels_Obj_Rel_Insert_Input>;
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_template?: InputMaybe<Mnet_Blog_Email_Templates_Obj_Rel_Insert_Input>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notification_emails?: InputMaybe<Array<Scalars['String']['input']>>;
  template_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "mnet_blog.channel_notifications" */
export type Mnet_Blog_Channel_Notifications_Max_Order_By = {
  blog_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_emails?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mnet_blog.channel_notifications" */
export type Mnet_Blog_Channel_Notifications_Min_Order_By = {
  blog_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_emails?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mnet_blog.channel_notifications" */
export type Mnet_Blog_Channel_Notifications_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mnet_Blog_Channel_Notifications>;
};

/** on_conflict condition type for table "mnet_blog.channel_notifications" */
export type Mnet_Blog_Channel_Notifications_On_Conflict = {
  constraint: Mnet_Blog_Channel_Notifications_Constraint;
  update_columns?: Array<Mnet_Blog_Channel_Notifications_Update_Column>;
  where?: InputMaybe<Mnet_Blog_Channel_Notifications_Bool_Exp>;
};

/** Ordering options when selecting data from "mnet_blog.channel_notifications". */
export type Mnet_Blog_Channel_Notifications_Order_By = {
  blog?: InputMaybe<Mnet_Blog_Blogs_Order_By>;
  blog_id?: InputMaybe<Order_By>;
  channel?: InputMaybe<Mnet_Blog_Channels_Order_By>;
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_template?: InputMaybe<Mnet_Blog_Email_Templates_Order_By>;
  enabled?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_emails?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mnet_blog.channel_notifications */
export type Mnet_Blog_Channel_Notifications_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mnet_blog.channel_notifications" */
export enum Mnet_Blog_Channel_Notifications_Select_Column {
  /** column name */
  Blog_id = 'blog_id',
  /** column name */
  Channel_id = 'channel_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Event_type = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  Notification_emails = 'notification_emails',
  /** column name */
  Template_id = 'template_id',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "mnet_blog.channel_notifications" */
export type Mnet_Blog_Channel_Notifications_Set_Input = {
  blog_id?: InputMaybe<Scalars['uuid']['input']>;
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notification_emails?: InputMaybe<Array<Scalars['String']['input']>>;
  template_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "mnet_blog_channel_notifications" */
export type Mnet_Blog_Channel_Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Blog_Channel_Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Blog_Channel_Notifications_Stream_Cursor_Value_Input = {
  blog_id?: InputMaybe<Scalars['uuid']['input']>;
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notification_emails?: InputMaybe<Array<Scalars['String']['input']>>;
  template_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "mnet_blog.channel_notifications" */
export enum Mnet_Blog_Channel_Notifications_Update_Column {
  /** column name */
  Blog_id = 'blog_id',
  /** column name */
  Channel_id = 'channel_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Event_type = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  Notification_emails = 'notification_emails',
  /** column name */
  Template_id = 'template_id',
  /** column name */
  Updated_at = 'updated_at',
}

export type Mnet_Blog_Channel_Notifications_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mnet_Blog_Channel_Notifications_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mnet_Blog_Channel_Notifications_Bool_Exp;
};

/** columns and relationships of "mnet_blog.channels" */
export type Mnet_Blog_Channels = {
  auto_publish: Scalars['Boolean']['output'];
  /** An object relationship */
  blog: Mnet_Blog_Blogs;
  blog_id: Scalars['uuid']['output'];
  /** An array relationship */
  channel_notifications: Array<Mnet_Blog_Channel_Notifications>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_user?: Maybe<Mlfsl_Personnel>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  notification_recipients: Array<Mnet_Blog_Notification_Recipients>;
  /** An array relationship */
  notification_template_rules: Array<Mnet_Blog_Notification_Template_Rules>;
  /** An array relationship */
  post_channels: Array<Mnet_Blog_Post_Channels>;
  promoted: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** columns and relationships of "mnet_blog.channels" */
export type Mnet_Blog_ChannelsChannel_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Channel_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Channel_Notifications_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Channel_Notifications_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.channels" */
export type Mnet_Blog_ChannelsNotification_RecipientsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Notification_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Notification_Recipients_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Notification_Recipients_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.channels" */
export type Mnet_Blog_ChannelsNotification_Template_RulesArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Notification_Template_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Notification_Template_Rules_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.channels" */
export type Mnet_Blog_ChannelsPost_ChannelsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Post_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Post_Channels_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Post_Channels_Bool_Exp>;
};

/** order by aggregate values of table "mnet_blog.channels" */
export type Mnet_Blog_Channels_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Blog_Channels_Max_Order_By>;
  min?: InputMaybe<Mnet_Blog_Channels_Min_Order_By>;
};

/** input type for inserting array relation for remote table "mnet_blog.channels" */
export type Mnet_Blog_Channels_Arr_Rel_Insert_Input = {
  data: Array<Mnet_Blog_Channels_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Channels_On_Conflict>;
};

/** Boolean expression to filter rows from the table "mnet_blog.channels". All fields are combined with a logical 'AND'. */
export type Mnet_Blog_Channels_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Blog_Channels_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Blog_Channels_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Blog_Channels_Bool_Exp>>;
  auto_publish?: InputMaybe<Boolean_Comparison_Exp>;
  blog?: InputMaybe<Mnet_Blog_Blogs_Bool_Exp>;
  blog_id?: InputMaybe<Uuid_Comparison_Exp>;
  channel_notifications?: InputMaybe<Mnet_Blog_Channel_Notifications_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notification_recipients?: InputMaybe<Mnet_Blog_Notification_Recipients_Bool_Exp>;
  notification_template_rules?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Bool_Exp>;
  post_channels?: InputMaybe<Mnet_Blog_Post_Channels_Bool_Exp>;
  promoted?: InputMaybe<Boolean_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mnet_blog.channels" */
export enum Mnet_Blog_Channels_Constraint {
  /** unique or primary key constraint on columns "slug", "blog_id" */
  Channels_blog_id_slug_key = 'channels_blog_id_slug_key',
  /** unique or primary key constraint on columns "id" */
  Channels_pkey = 'channels_pkey',
}

/** input type for inserting data into table "mnet_blog.channels" */
export type Mnet_Blog_Channels_Insert_Input = {
  auto_publish?: InputMaybe<Scalars['Boolean']['input']>;
  blog?: InputMaybe<Mnet_Blog_Blogs_Obj_Rel_Insert_Input>;
  blog_id?: InputMaybe<Scalars['uuid']['input']>;
  channel_notifications?: InputMaybe<Mnet_Blog_Channel_Notifications_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notification_recipients?: InputMaybe<Mnet_Blog_Notification_Recipients_Arr_Rel_Insert_Input>;
  notification_template_rules?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Arr_Rel_Insert_Input>;
  post_channels?: InputMaybe<Mnet_Blog_Post_Channels_Arr_Rel_Insert_Input>;
  promoted?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "mnet_blog.channels" */
export type Mnet_Blog_Channels_Max_Order_By = {
  blog_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mnet_blog.channels" */
export type Mnet_Blog_Channels_Min_Order_By = {
  blog_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mnet_blog.channels" */
export type Mnet_Blog_Channels_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mnet_Blog_Channels>;
};

/** input type for inserting object relation for remote table "mnet_blog.channels" */
export type Mnet_Blog_Channels_Obj_Rel_Insert_Input = {
  data: Mnet_Blog_Channels_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Channels_On_Conflict>;
};

/** on_conflict condition type for table "mnet_blog.channels" */
export type Mnet_Blog_Channels_On_Conflict = {
  constraint: Mnet_Blog_Channels_Constraint;
  update_columns?: Array<Mnet_Blog_Channels_Update_Column>;
  where?: InputMaybe<Mnet_Blog_Channels_Bool_Exp>;
};

/** Ordering options when selecting data from "mnet_blog.channels". */
export type Mnet_Blog_Channels_Order_By = {
  auto_publish?: InputMaybe<Order_By>;
  blog?: InputMaybe<Mnet_Blog_Blogs_Order_By>;
  blog_id?: InputMaybe<Order_By>;
  channel_notifications_aggregate?: InputMaybe<Mnet_Blog_Channel_Notifications_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notification_recipients_aggregate?: InputMaybe<Mnet_Blog_Notification_Recipients_Aggregate_Order_By>;
  notification_template_rules_aggregate?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Aggregate_Order_By>;
  post_channels_aggregate?: InputMaybe<Mnet_Blog_Post_Channels_Aggregate_Order_By>;
  promoted?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mnet_blog.channels */
export type Mnet_Blog_Channels_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mnet_blog.channels" */
export enum Mnet_Blog_Channels_Select_Column {
  /** column name */
  Auto_publish = 'auto_publish',
  /** column name */
  Blog_id = 'blog_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Promoted = 'promoted',
  /** column name */
  Slug = 'slug',
  /** column name */
  State = 'state',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "mnet_blog.channels" */
export type Mnet_Blog_Channels_Set_Input = {
  auto_publish?: InputMaybe<Scalars['Boolean']['input']>;
  blog_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  promoted?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "mnet_blog_channels" */
export type Mnet_Blog_Channels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Blog_Channels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Blog_Channels_Stream_Cursor_Value_Input = {
  auto_publish?: InputMaybe<Scalars['Boolean']['input']>;
  blog_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  promoted?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "mnet_blog.channels" */
export enum Mnet_Blog_Channels_Update_Column {
  /** column name */
  Auto_publish = 'auto_publish',
  /** column name */
  Blog_id = 'blog_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Promoted = 'promoted',
  /** column name */
  Slug = 'slug',
  /** column name */
  State = 'state',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

export type Mnet_Blog_Channels_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mnet_Blog_Channels_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mnet_Blog_Channels_Bool_Exp;
};

/** columns and relationships of "mnet_blog.comment_reactions" */
export type Mnet_Blog_Comment_Reactions = {
  author?: Maybe<Mlfsl_Personnel>;
  author_id: Scalars['String']['output'];
  /** An object relationship */
  comment: Mnet_Blog_Comments;
  comment_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "mnet_blog.comment_reactions" */
export type Mnet_Blog_Comment_Reactions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Blog_Comment_Reactions_Max_Order_By>;
  min?: InputMaybe<Mnet_Blog_Comment_Reactions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "mnet_blog.comment_reactions" */
export type Mnet_Blog_Comment_Reactions_Arr_Rel_Insert_Input = {
  data: Array<Mnet_Blog_Comment_Reactions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Comment_Reactions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "mnet_blog.comment_reactions". All fields are combined with a logical 'AND'. */
export type Mnet_Blog_Comment_Reactions_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Blog_Comment_Reactions_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Blog_Comment_Reactions_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Blog_Comment_Reactions_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  comment?: InputMaybe<Mnet_Blog_Comments_Bool_Exp>;
  comment_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mnet_blog.comment_reactions" */
export enum Mnet_Blog_Comment_Reactions_Constraint {
  /** unique or primary key constraint on columns "type", "comment_id", "author_id" */
  Comment_reactions_comment_id_author_id_type_key = 'comment_reactions_comment_id_author_id_type_key',
  /** unique or primary key constraint on columns "id" */
  Comment_reactions_pkey = 'comment_reactions_pkey',
}

/** input type for inserting data into table "mnet_blog.comment_reactions" */
export type Mnet_Blog_Comment_Reactions_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Mnet_Blog_Comments_Obj_Rel_Insert_Input>;
  comment_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "mnet_blog.comment_reactions" */
export type Mnet_Blog_Comment_Reactions_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mnet_blog.comment_reactions" */
export type Mnet_Blog_Comment_Reactions_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mnet_blog.comment_reactions" */
export type Mnet_Blog_Comment_Reactions_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mnet_Blog_Comment_Reactions>;
};

/** on_conflict condition type for table "mnet_blog.comment_reactions" */
export type Mnet_Blog_Comment_Reactions_On_Conflict = {
  constraint: Mnet_Blog_Comment_Reactions_Constraint;
  update_columns?: Array<Mnet_Blog_Comment_Reactions_Update_Column>;
  where?: InputMaybe<Mnet_Blog_Comment_Reactions_Bool_Exp>;
};

/** Ordering options when selecting data from "mnet_blog.comment_reactions". */
export type Mnet_Blog_Comment_Reactions_Order_By = {
  author_id?: InputMaybe<Order_By>;
  comment?: InputMaybe<Mnet_Blog_Comments_Order_By>;
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mnet_blog.comment_reactions */
export type Mnet_Blog_Comment_Reactions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mnet_blog.comment_reactions" */
export enum Mnet_Blog_Comment_Reactions_Select_Column {
  /** column name */
  Author_id = 'author_id',
  /** column name */
  Comment_id = 'comment_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "mnet_blog.comment_reactions" */
export type Mnet_Blog_Comment_Reactions_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  comment_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "mnet_blog_comment_reactions" */
export type Mnet_Blog_Comment_Reactions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Blog_Comment_Reactions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Blog_Comment_Reactions_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  comment_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "mnet_blog.comment_reactions" */
export enum Mnet_Blog_Comment_Reactions_Update_Column {
  /** column name */
  Author_id = 'author_id',
  /** column name */
  Comment_id = 'comment_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  Updated_at = 'updated_at',
}

export type Mnet_Blog_Comment_Reactions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mnet_Blog_Comment_Reactions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mnet_Blog_Comment_Reactions_Bool_Exp;
};

/** columns and relationships of "mnet_blog.comments" */
export type Mnet_Blog_Comments = {
  /** An array relationship */
  attachments: Array<Mnet_Blog_Attachments>;
  author?: Maybe<Mlfsl_Personnel>;
  author_id: Scalars['String']['output'];
  body: Scalars['String']['output'];
  /** An object relationship */
  comment?: Maybe<Mnet_Blog_Comments>;
  /** An array relationship */
  comment_reactions: Array<Mnet_Blog_Comment_Reactions>;
  /** An array relationship */
  comments: Array<Mnet_Blog_Comments>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_user?: Maybe<Mlfsl_Personnel>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  inbound_emails: Array<Mnet_Blog_Inbound_Emails>;
  is_deleted: Scalars['Boolean']['output'];
  parent_comment_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  post: Mnet_Blog_Posts;
  post_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** columns and relationships of "mnet_blog.comments" */
export type Mnet_Blog_CommentsAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Attachments_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Attachments_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.comments" */
export type Mnet_Blog_CommentsComment_ReactionsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Comment_Reactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Comment_Reactions_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Comment_Reactions_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.comments" */
export type Mnet_Blog_CommentsCommentsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Comments_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Comments_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.comments" */
export type Mnet_Blog_CommentsInbound_EmailsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Inbound_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Inbound_Emails_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Inbound_Emails_Bool_Exp>;
};

/** order by aggregate values of table "mnet_blog.comments" */
export type Mnet_Blog_Comments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Blog_Comments_Max_Order_By>;
  min?: InputMaybe<Mnet_Blog_Comments_Min_Order_By>;
};

/** input type for inserting array relation for remote table "mnet_blog.comments" */
export type Mnet_Blog_Comments_Arr_Rel_Insert_Input = {
  data: Array<Mnet_Blog_Comments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Comments_On_Conflict>;
};

/** Boolean expression to filter rows from the table "mnet_blog.comments". All fields are combined with a logical 'AND'. */
export type Mnet_Blog_Comments_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Blog_Comments_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Blog_Comments_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Blog_Comments_Bool_Exp>>;
  attachments?: InputMaybe<Mnet_Blog_Attachments_Bool_Exp>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  body?: InputMaybe<String_Comparison_Exp>;
  comment?: InputMaybe<Mnet_Blog_Comments_Bool_Exp>;
  comment_reactions?: InputMaybe<Mnet_Blog_Comment_Reactions_Bool_Exp>;
  comments?: InputMaybe<Mnet_Blog_Comments_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inbound_emails?: InputMaybe<Mnet_Blog_Inbound_Emails_Bool_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  parent_comment_id?: InputMaybe<Uuid_Comparison_Exp>;
  post?: InputMaybe<Mnet_Blog_Posts_Bool_Exp>;
  post_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mnet_blog.comments" */
export enum Mnet_Blog_Comments_Constraint {
  /** unique or primary key constraint on columns "id" */
  Comments_pkey = 'comments_pkey',
}

/** input type for inserting data into table "mnet_blog.comments" */
export type Mnet_Blog_Comments_Insert_Input = {
  attachments?: InputMaybe<Mnet_Blog_Attachments_Arr_Rel_Insert_Input>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Mnet_Blog_Comments_Obj_Rel_Insert_Input>;
  comment_reactions?: InputMaybe<Mnet_Blog_Comment_Reactions_Arr_Rel_Insert_Input>;
  comments?: InputMaybe<Mnet_Blog_Comments_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inbound_emails?: InputMaybe<Mnet_Blog_Inbound_Emails_Arr_Rel_Insert_Input>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  parent_comment_id?: InputMaybe<Scalars['uuid']['input']>;
  post?: InputMaybe<Mnet_Blog_Posts_Obj_Rel_Insert_Input>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "mnet_blog.comments" */
export type Mnet_Blog_Comments_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mnet_blog.comments" */
export type Mnet_Blog_Comments_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mnet_blog.comments" */
export type Mnet_Blog_Comments_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mnet_Blog_Comments>;
};

/** input type for inserting object relation for remote table "mnet_blog.comments" */
export type Mnet_Blog_Comments_Obj_Rel_Insert_Input = {
  data: Mnet_Blog_Comments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Comments_On_Conflict>;
};

/** on_conflict condition type for table "mnet_blog.comments" */
export type Mnet_Blog_Comments_On_Conflict = {
  constraint: Mnet_Blog_Comments_Constraint;
  update_columns?: Array<Mnet_Blog_Comments_Update_Column>;
  where?: InputMaybe<Mnet_Blog_Comments_Bool_Exp>;
};

/** Ordering options when selecting data from "mnet_blog.comments". */
export type Mnet_Blog_Comments_Order_By = {
  attachments_aggregate?: InputMaybe<Mnet_Blog_Attachments_Aggregate_Order_By>;
  author_id?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  comment?: InputMaybe<Mnet_Blog_Comments_Order_By>;
  comment_reactions_aggregate?: InputMaybe<Mnet_Blog_Comment_Reactions_Aggregate_Order_By>;
  comments_aggregate?: InputMaybe<Mnet_Blog_Comments_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inbound_emails_aggregate?: InputMaybe<Mnet_Blog_Inbound_Emails_Aggregate_Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  post?: InputMaybe<Mnet_Blog_Posts_Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mnet_blog.comments */
export type Mnet_Blog_Comments_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mnet_blog.comments" */
export enum Mnet_Blog_Comments_Select_Column {
  /** column name */
  Author_id = 'author_id',
  /** column name */
  Body = 'body',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Deleted_at = 'deleted_at',
  /** column name */
  Deleted_by = 'deleted_by',
  /** column name */
  Id = 'id',
  /** column name */
  Is_deleted = 'is_deleted',
  /** column name */
  Parent_comment_id = 'parent_comment_id',
  /** column name */
  Post_id = 'post_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "mnet_blog.comments" */
export type Mnet_Blog_Comments_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  parent_comment_id?: InputMaybe<Scalars['uuid']['input']>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "mnet_blog_comments" */
export type Mnet_Blog_Comments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Blog_Comments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Blog_Comments_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  parent_comment_id?: InputMaybe<Scalars['uuid']['input']>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "mnet_blog.comments" */
export enum Mnet_Blog_Comments_Update_Column {
  /** column name */
  Author_id = 'author_id',
  /** column name */
  Body = 'body',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Deleted_at = 'deleted_at',
  /** column name */
  Deleted_by = 'deleted_by',
  /** column name */
  Id = 'id',
  /** column name */
  Is_deleted = 'is_deleted',
  /** column name */
  Parent_comment_id = 'parent_comment_id',
  /** column name */
  Post_id = 'post_id',
  /** column name */
  Updated_at = 'updated_at',
}

export type Mnet_Blog_Comments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mnet_Blog_Comments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mnet_Blog_Comments_Bool_Exp;
};

/** columns and relationships of "mnet_blog.email_notifications" */
export type Mnet_Blog_Email_Notifications = {
  bcc_recipients?: Maybe<Array<Scalars['String']['output']>>;
  body_format: Scalars['String']['output'];
  cc_recipients?: Maybe<Array<Scalars['String']['output']>>;
  conversation_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  email_template?: Maybe<Mnet_Blog_Email_Templates>;
  /** An object relationship */
  event?: Maybe<Mnet_Blog_Events>;
  event_id?: Maybe<Scalars['uuid']['output']>;
  event_type: Scalars['String']['output'];
  failure_reason: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  inbound_emails: Array<Mnet_Blog_Inbound_Emails>;
  internet_message_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  notification_template_rule?: Maybe<Mnet_Blog_Notification_Template_Rules>;
  /** An object relationship */
  post: Mnet_Blog_Posts;
  post_id: Scalars['uuid']['output'];
  processing_status: Scalars['String']['output'];
  recipient_count: Scalars['Int']['output'];
  rendered_body?: Maybe<Scalars['String']['output']>;
  rendered_subject?: Maybe<Scalars['String']['output']>;
  reply_token?: Maybe<Scalars['String']['output']>;
  selected_template_rule_id?: Maybe<Scalars['uuid']['output']>;
  sent_at: Scalars['timestamptz']['output'];
  template_id?: Maybe<Scalars['uuid']['output']>;
  template_selection_reason?: Maybe<Scalars['String']['output']>;
  to_recipients?: Maybe<Array<Scalars['String']['output']>>;
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "mnet_blog.email_notifications" */
export type Mnet_Blog_Email_NotificationsInbound_EmailsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Inbound_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Inbound_Emails_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Inbound_Emails_Bool_Exp>;
};

/** order by aggregate values of table "mnet_blog.email_notifications" */
export type Mnet_Blog_Email_Notifications_Aggregate_Order_By = {
  avg?: InputMaybe<Mnet_Blog_Email_Notifications_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Blog_Email_Notifications_Max_Order_By>;
  min?: InputMaybe<Mnet_Blog_Email_Notifications_Min_Order_By>;
  stddev?: InputMaybe<Mnet_Blog_Email_Notifications_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mnet_Blog_Email_Notifications_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mnet_Blog_Email_Notifications_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mnet_Blog_Email_Notifications_Sum_Order_By>;
  var_pop?: InputMaybe<Mnet_Blog_Email_Notifications_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mnet_Blog_Email_Notifications_Var_Samp_Order_By>;
  variance?: InputMaybe<Mnet_Blog_Email_Notifications_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mnet_blog.email_notifications" */
export type Mnet_Blog_Email_Notifications_Arr_Rel_Insert_Input = {
  data: Array<Mnet_Blog_Email_Notifications_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Email_Notifications_On_Conflict>;
};

/** order by avg() on columns of table "mnet_blog.email_notifications" */
export type Mnet_Blog_Email_Notifications_Avg_Order_By = {
  recipient_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mnet_blog.email_notifications". All fields are combined with a logical 'AND'. */
export type Mnet_Blog_Email_Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Blog_Email_Notifications_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Blog_Email_Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Blog_Email_Notifications_Bool_Exp>>;
  bcc_recipients?: InputMaybe<String_Array_Comparison_Exp>;
  body_format?: InputMaybe<String_Comparison_Exp>;
  cc_recipients?: InputMaybe<String_Array_Comparison_Exp>;
  conversation_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_template?: InputMaybe<Mnet_Blog_Email_Templates_Bool_Exp>;
  event?: InputMaybe<Mnet_Blog_Events_Bool_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  failure_reason?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inbound_emails?: InputMaybe<Mnet_Blog_Inbound_Emails_Bool_Exp>;
  internet_message_id?: InputMaybe<String_Comparison_Exp>;
  notification_template_rule?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Bool_Exp>;
  post?: InputMaybe<Mnet_Blog_Posts_Bool_Exp>;
  post_id?: InputMaybe<Uuid_Comparison_Exp>;
  processing_status?: InputMaybe<String_Comparison_Exp>;
  recipient_count?: InputMaybe<Int_Comparison_Exp>;
  rendered_body?: InputMaybe<String_Comparison_Exp>;
  rendered_subject?: InputMaybe<String_Comparison_Exp>;
  reply_token?: InputMaybe<String_Comparison_Exp>;
  selected_template_rule_id?: InputMaybe<Uuid_Comparison_Exp>;
  sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  template_id?: InputMaybe<Uuid_Comparison_Exp>;
  template_selection_reason?: InputMaybe<String_Comparison_Exp>;
  to_recipients?: InputMaybe<String_Array_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mnet_blog.email_notifications" */
export enum Mnet_Blog_Email_Notifications_Constraint {
  /** unique or primary key constraint on columns "id" */
  Email_notifications_pkey = 'email_notifications_pkey',
  /** unique or primary key constraint on columns "reply_token" */
  Email_notifications_reply_token_key = 'email_notifications_reply_token_key',
}

/** input type for incrementing numeric columns in table "mnet_blog.email_notifications" */
export type Mnet_Blog_Email_Notifications_Inc_Input = {
  recipient_count?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "mnet_blog.email_notifications" */
export type Mnet_Blog_Email_Notifications_Insert_Input = {
  bcc_recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  body_format?: InputMaybe<Scalars['String']['input']>;
  cc_recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  conversation_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_template?: InputMaybe<Mnet_Blog_Email_Templates_Obj_Rel_Insert_Input>;
  event?: InputMaybe<Mnet_Blog_Events_Obj_Rel_Insert_Input>;
  event_id?: InputMaybe<Scalars['uuid']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  failure_reason?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inbound_emails?: InputMaybe<Mnet_Blog_Inbound_Emails_Arr_Rel_Insert_Input>;
  internet_message_id?: InputMaybe<Scalars['String']['input']>;
  notification_template_rule?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Obj_Rel_Insert_Input>;
  post?: InputMaybe<Mnet_Blog_Posts_Obj_Rel_Insert_Input>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  processing_status?: InputMaybe<Scalars['String']['input']>;
  recipient_count?: InputMaybe<Scalars['Int']['input']>;
  rendered_body?: InputMaybe<Scalars['String']['input']>;
  rendered_subject?: InputMaybe<Scalars['String']['input']>;
  reply_token?: InputMaybe<Scalars['String']['input']>;
  selected_template_rule_id?: InputMaybe<Scalars['uuid']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  template_id?: InputMaybe<Scalars['uuid']['input']>;
  template_selection_reason?: InputMaybe<Scalars['String']['input']>;
  to_recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "mnet_blog.email_notifications" */
export type Mnet_Blog_Email_Notifications_Max_Order_By = {
  bcc_recipients?: InputMaybe<Order_By>;
  body_format?: InputMaybe<Order_By>;
  cc_recipients?: InputMaybe<Order_By>;
  conversation_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  failure_reason?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internet_message_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  processing_status?: InputMaybe<Order_By>;
  recipient_count?: InputMaybe<Order_By>;
  rendered_body?: InputMaybe<Order_By>;
  rendered_subject?: InputMaybe<Order_By>;
  reply_token?: InputMaybe<Order_By>;
  selected_template_rule_id?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  template_selection_reason?: InputMaybe<Order_By>;
  to_recipients?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mnet_blog.email_notifications" */
export type Mnet_Blog_Email_Notifications_Min_Order_By = {
  bcc_recipients?: InputMaybe<Order_By>;
  body_format?: InputMaybe<Order_By>;
  cc_recipients?: InputMaybe<Order_By>;
  conversation_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  failure_reason?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internet_message_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  processing_status?: InputMaybe<Order_By>;
  recipient_count?: InputMaybe<Order_By>;
  rendered_body?: InputMaybe<Order_By>;
  rendered_subject?: InputMaybe<Order_By>;
  reply_token?: InputMaybe<Order_By>;
  selected_template_rule_id?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  template_selection_reason?: InputMaybe<Order_By>;
  to_recipients?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mnet_blog.email_notifications" */
export type Mnet_Blog_Email_Notifications_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mnet_Blog_Email_Notifications>;
};

/** input type for inserting object relation for remote table "mnet_blog.email_notifications" */
export type Mnet_Blog_Email_Notifications_Obj_Rel_Insert_Input = {
  data: Mnet_Blog_Email_Notifications_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Email_Notifications_On_Conflict>;
};

/** on_conflict condition type for table "mnet_blog.email_notifications" */
export type Mnet_Blog_Email_Notifications_On_Conflict = {
  constraint: Mnet_Blog_Email_Notifications_Constraint;
  update_columns?: Array<Mnet_Blog_Email_Notifications_Update_Column>;
  where?: InputMaybe<Mnet_Blog_Email_Notifications_Bool_Exp>;
};

/** Ordering options when selecting data from "mnet_blog.email_notifications". */
export type Mnet_Blog_Email_Notifications_Order_By = {
  bcc_recipients?: InputMaybe<Order_By>;
  body_format?: InputMaybe<Order_By>;
  cc_recipients?: InputMaybe<Order_By>;
  conversation_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_template?: InputMaybe<Mnet_Blog_Email_Templates_Order_By>;
  event?: InputMaybe<Mnet_Blog_Events_Order_By>;
  event_id?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  failure_reason?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inbound_emails_aggregate?: InputMaybe<Mnet_Blog_Inbound_Emails_Aggregate_Order_By>;
  internet_message_id?: InputMaybe<Order_By>;
  notification_template_rule?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Order_By>;
  post?: InputMaybe<Mnet_Blog_Posts_Order_By>;
  post_id?: InputMaybe<Order_By>;
  processing_status?: InputMaybe<Order_By>;
  recipient_count?: InputMaybe<Order_By>;
  rendered_body?: InputMaybe<Order_By>;
  rendered_subject?: InputMaybe<Order_By>;
  reply_token?: InputMaybe<Order_By>;
  selected_template_rule_id?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  template_selection_reason?: InputMaybe<Order_By>;
  to_recipients?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mnet_blog.email_notifications */
export type Mnet_Blog_Email_Notifications_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mnet_blog.email_notifications" */
export enum Mnet_Blog_Email_Notifications_Select_Column {
  /** column name */
  Bcc_recipients = 'bcc_recipients',
  /** column name */
  Body_format = 'body_format',
  /** column name */
  Cc_recipients = 'cc_recipients',
  /** column name */
  Conversation_id = 'conversation_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Event_type = 'event_type',
  /** column name */
  Failure_reason = 'failure_reason',
  /** column name */
  Id = 'id',
  /** column name */
  Internet_message_id = 'internet_message_id',
  /** column name */
  Post_id = 'post_id',
  /** column name */
  Processing_status = 'processing_status',
  /** column name */
  Recipient_count = 'recipient_count',
  /** column name */
  Rendered_body = 'rendered_body',
  /** column name */
  Rendered_subject = 'rendered_subject',
  /** column name */
  Reply_token = 'reply_token',
  /** column name */
  Selected_template_rule_id = 'selected_template_rule_id',
  /** column name */
  Sent_at = 'sent_at',
  /** column name */
  Template_id = 'template_id',
  /** column name */
  Template_selection_reason = 'template_selection_reason',
  /** column name */
  To_recipients = 'to_recipients',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "mnet_blog.email_notifications" */
export type Mnet_Blog_Email_Notifications_Set_Input = {
  bcc_recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  body_format?: InputMaybe<Scalars['String']['input']>;
  cc_recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  conversation_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['uuid']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  failure_reason?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internet_message_id?: InputMaybe<Scalars['String']['input']>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  processing_status?: InputMaybe<Scalars['String']['input']>;
  recipient_count?: InputMaybe<Scalars['Int']['input']>;
  rendered_body?: InputMaybe<Scalars['String']['input']>;
  rendered_subject?: InputMaybe<Scalars['String']['input']>;
  reply_token?: InputMaybe<Scalars['String']['input']>;
  selected_template_rule_id?: InputMaybe<Scalars['uuid']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  template_id?: InputMaybe<Scalars['uuid']['input']>;
  template_selection_reason?: InputMaybe<Scalars['String']['input']>;
  to_recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "mnet_blog.email_notifications" */
export type Mnet_Blog_Email_Notifications_Stddev_Order_By = {
  recipient_count?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "mnet_blog.email_notifications" */
export type Mnet_Blog_Email_Notifications_Stddev_Pop_Order_By = {
  recipient_count?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "mnet_blog.email_notifications" */
export type Mnet_Blog_Email_Notifications_Stddev_Samp_Order_By = {
  recipient_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mnet_blog_email_notifications" */
export type Mnet_Blog_Email_Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Blog_Email_Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Blog_Email_Notifications_Stream_Cursor_Value_Input = {
  bcc_recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  body_format?: InputMaybe<Scalars['String']['input']>;
  cc_recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  conversation_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_id?: InputMaybe<Scalars['uuid']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  failure_reason?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internet_message_id?: InputMaybe<Scalars['String']['input']>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  processing_status?: InputMaybe<Scalars['String']['input']>;
  recipient_count?: InputMaybe<Scalars['Int']['input']>;
  rendered_body?: InputMaybe<Scalars['String']['input']>;
  rendered_subject?: InputMaybe<Scalars['String']['input']>;
  reply_token?: InputMaybe<Scalars['String']['input']>;
  selected_template_rule_id?: InputMaybe<Scalars['uuid']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  template_id?: InputMaybe<Scalars['uuid']['input']>;
  template_selection_reason?: InputMaybe<Scalars['String']['input']>;
  to_recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "mnet_blog.email_notifications" */
export type Mnet_Blog_Email_Notifications_Sum_Order_By = {
  recipient_count?: InputMaybe<Order_By>;
};

/** update columns of table "mnet_blog.email_notifications" */
export enum Mnet_Blog_Email_Notifications_Update_Column {
  /** column name */
  Bcc_recipients = 'bcc_recipients',
  /** column name */
  Body_format = 'body_format',
  /** column name */
  Cc_recipients = 'cc_recipients',
  /** column name */
  Conversation_id = 'conversation_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Event_id = 'event_id',
  /** column name */
  Event_type = 'event_type',
  /** column name */
  Failure_reason = 'failure_reason',
  /** column name */
  Id = 'id',
  /** column name */
  Internet_message_id = 'internet_message_id',
  /** column name */
  Post_id = 'post_id',
  /** column name */
  Processing_status = 'processing_status',
  /** column name */
  Recipient_count = 'recipient_count',
  /** column name */
  Rendered_body = 'rendered_body',
  /** column name */
  Rendered_subject = 'rendered_subject',
  /** column name */
  Reply_token = 'reply_token',
  /** column name */
  Selected_template_rule_id = 'selected_template_rule_id',
  /** column name */
  Sent_at = 'sent_at',
  /** column name */
  Template_id = 'template_id',
  /** column name */
  Template_selection_reason = 'template_selection_reason',
  /** column name */
  To_recipients = 'to_recipients',
  /** column name */
  Updated_at = 'updated_at',
}

export type Mnet_Blog_Email_Notifications_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mnet_Blog_Email_Notifications_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mnet_Blog_Email_Notifications_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mnet_Blog_Email_Notifications_Bool_Exp;
};

/** order by var_pop() on columns of table "mnet_blog.email_notifications" */
export type Mnet_Blog_Email_Notifications_Var_Pop_Order_By = {
  recipient_count?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "mnet_blog.email_notifications" */
export type Mnet_Blog_Email_Notifications_Var_Samp_Order_By = {
  recipient_count?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "mnet_blog.email_notifications" */
export type Mnet_Blog_Email_Notifications_Variance_Order_By = {
  recipient_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "mnet_blog.email_templates" */
export type Mnet_Blog_Email_Templates = {
  body: Scalars['String']['output'];
  /** An array relationship */
  channel_notifications: Array<Mnet_Blog_Channel_Notifications>;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  email_notifications: Array<Mnet_Blog_Email_Notifications>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  notification_template_rules: Array<Mnet_Blog_Notification_Template_Rules>;
  subject: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "mnet_blog.email_templates" */
export type Mnet_Blog_Email_TemplatesChannel_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Channel_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Channel_Notifications_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Channel_Notifications_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.email_templates" */
export type Mnet_Blog_Email_TemplatesEmail_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Email_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Email_Notifications_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Email_Notifications_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.email_templates" */
export type Mnet_Blog_Email_TemplatesNotification_Template_RulesArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Notification_Template_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Notification_Template_Rules_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "mnet_blog.email_templates". All fields are combined with a logical 'AND'. */
export type Mnet_Blog_Email_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Blog_Email_Templates_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Blog_Email_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Blog_Email_Templates_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  channel_notifications?: InputMaybe<Mnet_Blog_Channel_Notifications_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_notifications?: InputMaybe<Mnet_Blog_Email_Notifications_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notification_template_rules?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Bool_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mnet_blog.email_templates" */
export enum Mnet_Blog_Email_Templates_Constraint {
  /** unique or primary key constraint on columns "id" */
  Email_templates_pkey = 'email_templates_pkey',
}

/** input type for inserting data into table "mnet_blog.email_templates" */
export type Mnet_Blog_Email_Templates_Insert_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  channel_notifications?: InputMaybe<Mnet_Blog_Channel_Notifications_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_notifications?: InputMaybe<Mnet_Blog_Email_Notifications_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notification_template_rules?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Arr_Rel_Insert_Input>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "mnet_blog.email_templates" */
export type Mnet_Blog_Email_Templates_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mnet_Blog_Email_Templates>;
};

/** input type for inserting object relation for remote table "mnet_blog.email_templates" */
export type Mnet_Blog_Email_Templates_Obj_Rel_Insert_Input = {
  data: Mnet_Blog_Email_Templates_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Email_Templates_On_Conflict>;
};

/** on_conflict condition type for table "mnet_blog.email_templates" */
export type Mnet_Blog_Email_Templates_On_Conflict = {
  constraint: Mnet_Blog_Email_Templates_Constraint;
  update_columns?: Array<Mnet_Blog_Email_Templates_Update_Column>;
  where?: InputMaybe<Mnet_Blog_Email_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "mnet_blog.email_templates". */
export type Mnet_Blog_Email_Templates_Order_By = {
  body?: InputMaybe<Order_By>;
  channel_notifications_aggregate?: InputMaybe<Mnet_Blog_Channel_Notifications_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_notifications_aggregate?: InputMaybe<Mnet_Blog_Email_Notifications_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notification_template_rules_aggregate?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Aggregate_Order_By>;
  subject?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mnet_blog.email_templates */
export type Mnet_Blog_Email_Templates_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mnet_blog.email_templates" */
export enum Mnet_Blog_Email_Templates_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Subject = 'subject',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "mnet_blog.email_templates" */
export type Mnet_Blog_Email_Templates_Set_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "mnet_blog_email_templates" */
export type Mnet_Blog_Email_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Blog_Email_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Blog_Email_Templates_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "mnet_blog.email_templates" */
export enum Mnet_Blog_Email_Templates_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Subject = 'subject',
  /** column name */
  Updated_at = 'updated_at',
}

export type Mnet_Blog_Email_Templates_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mnet_Blog_Email_Templates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mnet_Blog_Email_Templates_Bool_Exp;
};

/** columns and relationships of "mnet_blog.events" */
export type Mnet_Blog_Events = {
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  email_notifications: Array<Mnet_Blog_Email_Notifications>;
  entity_id: Scalars['uuid']['output'];
  entity_type: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  payload: Scalars['jsonb']['output'];
  processed: Scalars['Boolean']['output'];
  triggered_by: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "mnet_blog.events" */
export type Mnet_Blog_EventsEmail_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Email_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Email_Notifications_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Email_Notifications_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.events" */
export type Mnet_Blog_EventsPayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Mnet_Blog_Events_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "mnet_blog.events". All fields are combined with a logical 'AND'. */
export type Mnet_Blog_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Blog_Events_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Blog_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Blog_Events_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_notifications?: InputMaybe<Mnet_Blog_Email_Notifications_Bool_Exp>;
  entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  entity_type?: InputMaybe<String_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  processed?: InputMaybe<Boolean_Comparison_Exp>;
  triggered_by?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mnet_blog.events" */
export enum Mnet_Blog_Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  Events_pkey = 'events_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Mnet_Blog_Events_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Mnet_Blog_Events_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Mnet_Blog_Events_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "mnet_blog.events" */
export type Mnet_Blog_Events_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_notifications?: InputMaybe<Mnet_Blog_Email_Notifications_Arr_Rel_Insert_Input>;
  entity_id?: InputMaybe<Scalars['uuid']['input']>;
  entity_type?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  processed?: InputMaybe<Scalars['Boolean']['input']>;
  triggered_by?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "mnet_blog.events" */
export type Mnet_Blog_Events_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mnet_Blog_Events>;
};

/** input type for inserting object relation for remote table "mnet_blog.events" */
export type Mnet_Blog_Events_Obj_Rel_Insert_Input = {
  data: Mnet_Blog_Events_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Events_On_Conflict>;
};

/** on_conflict condition type for table "mnet_blog.events" */
export type Mnet_Blog_Events_On_Conflict = {
  constraint: Mnet_Blog_Events_Constraint;
  update_columns?: Array<Mnet_Blog_Events_Update_Column>;
  where?: InputMaybe<Mnet_Blog_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "mnet_blog.events". */
export type Mnet_Blog_Events_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email_notifications_aggregate?: InputMaybe<Mnet_Blog_Email_Notifications_Aggregate_Order_By>;
  entity_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  processed?: InputMaybe<Order_By>;
  triggered_by?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mnet_blog.events */
export type Mnet_Blog_Events_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Mnet_Blog_Events_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "mnet_blog.events" */
export enum Mnet_Blog_Events_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Entity_id = 'entity_id',
  /** column name */
  Entity_type = 'entity_type',
  /** column name */
  Event_type = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Processed = 'processed',
  /** column name */
  Triggered_by = 'triggered_by',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "mnet_blog.events" */
export type Mnet_Blog_Events_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['uuid']['input']>;
  entity_type?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  processed?: InputMaybe<Scalars['Boolean']['input']>;
  triggered_by?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "mnet_blog_events" */
export type Mnet_Blog_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Blog_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Blog_Events_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['uuid']['input']>;
  entity_type?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  processed?: InputMaybe<Scalars['Boolean']['input']>;
  triggered_by?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "mnet_blog.events" */
export enum Mnet_Blog_Events_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Entity_id = 'entity_id',
  /** column name */
  Entity_type = 'entity_type',
  /** column name */
  Event_type = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Processed = 'processed',
  /** column name */
  Triggered_by = 'triggered_by',
  /** column name */
  Updated_at = 'updated_at',
}

export type Mnet_Blog_Events_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Mnet_Blog_Events_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Mnet_Blog_Events_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Mnet_Blog_Events_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Mnet_Blog_Events_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Mnet_Blog_Events_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mnet_Blog_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mnet_Blog_Events_Bool_Exp;
};

/** joint object to link group and blogs */
export type Mnet_Blog_Group_In_Blogs = {
  /** An object relationship */
  blog: Mnet_Blog_Blogs;
  blog_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  group_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  role: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "mnet_blog.group_in_blogs" */
export type Mnet_Blog_Group_In_Blogs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Blog_Group_In_Blogs_Max_Order_By>;
  min?: InputMaybe<Mnet_Blog_Group_In_Blogs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "mnet_blog.group_in_blogs" */
export type Mnet_Blog_Group_In_Blogs_Arr_Rel_Insert_Input = {
  data: Array<Mnet_Blog_Group_In_Blogs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Group_In_Blogs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "mnet_blog.group_in_blogs". All fields are combined with a logical 'AND'. */
export type Mnet_Blog_Group_In_Blogs_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Blog_Group_In_Blogs_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Blog_Group_In_Blogs_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Blog_Group_In_Blogs_Bool_Exp>>;
  blog?: InputMaybe<Mnet_Blog_Blogs_Bool_Exp>;
  blog_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  group_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mnet_blog.group_in_blogs" */
export enum Mnet_Blog_Group_In_Blogs_Constraint {
  /** unique or primary key constraint on columns "id" */
  Group_in_blogs_pkey = 'group_in_blogs_pkey',
}

/** input type for inserting data into table "mnet_blog.group_in_blogs" */
export type Mnet_Blog_Group_In_Blogs_Insert_Input = {
  blog?: InputMaybe<Mnet_Blog_Blogs_Obj_Rel_Insert_Input>;
  blog_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "mnet_blog.group_in_blogs" */
export type Mnet_Blog_Group_In_Blogs_Max_Order_By = {
  blog_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mnet_blog.group_in_blogs" */
export type Mnet_Blog_Group_In_Blogs_Min_Order_By = {
  blog_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mnet_blog.group_in_blogs" */
export type Mnet_Blog_Group_In_Blogs_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mnet_Blog_Group_In_Blogs>;
};

/** on_conflict condition type for table "mnet_blog.group_in_blogs" */
export type Mnet_Blog_Group_In_Blogs_On_Conflict = {
  constraint: Mnet_Blog_Group_In_Blogs_Constraint;
  update_columns?: Array<Mnet_Blog_Group_In_Blogs_Update_Column>;
  where?: InputMaybe<Mnet_Blog_Group_In_Blogs_Bool_Exp>;
};

/** Ordering options when selecting data from "mnet_blog.group_in_blogs". */
export type Mnet_Blog_Group_In_Blogs_Order_By = {
  blog?: InputMaybe<Mnet_Blog_Blogs_Order_By>;
  blog_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mnet_blog.group_in_blogs */
export type Mnet_Blog_Group_In_Blogs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mnet_blog.group_in_blogs" */
export enum Mnet_Blog_Group_In_Blogs_Select_Column {
  /** column name */
  Blog_id = 'blog_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Group_id = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "mnet_blog.group_in_blogs" */
export type Mnet_Blog_Group_In_Blogs_Set_Input = {
  blog_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "mnet_blog_group_in_blogs" */
export type Mnet_Blog_Group_In_Blogs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Blog_Group_In_Blogs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Blog_Group_In_Blogs_Stream_Cursor_Value_Input = {
  blog_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "mnet_blog.group_in_blogs" */
export enum Mnet_Blog_Group_In_Blogs_Update_Column {
  /** column name */
  Blog_id = 'blog_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Group_id = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  Updated_at = 'updated_at',
}

export type Mnet_Blog_Group_In_Blogs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mnet_Blog_Group_In_Blogs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mnet_Blog_Group_In_Blogs_Bool_Exp;
};

/** columns and relationships of "mnet_blog.inbound_emails" */
export type Mnet_Blog_Inbound_Emails = {
  cc_emails?: Maybe<Array<Scalars['String']['output']>>;
  cleaned_body?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  comment?: Maybe<Mnet_Blog_Comments>;
  comment_id?: Maybe<Scalars['uuid']['output']>;
  conversation_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  email_notification?: Maybe<Mnet_Blog_Email_Notifications>;
  email_notification_id?: Maybe<Scalars['uuid']['output']>;
  failure_reason?: Maybe<Scalars['String']['output']>;
  from_email: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  internet_message_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  post?: Maybe<Mnet_Blog_Posts>;
  post_id?: Maybe<Scalars['uuid']['output']>;
  processed_at?: Maybe<Scalars['timestamptz']['output']>;
  processing_status: Scalars['String']['output'];
  raw_body?: Maybe<Scalars['String']['output']>;
  received_at?: Maybe<Scalars['timestamptz']['output']>;
  resolution_method?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  to_emails?: Maybe<Array<Scalars['String']['output']>>;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "mnet_blog.inbound_emails" */
export type Mnet_Blog_Inbound_Emails_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Blog_Inbound_Emails_Max_Order_By>;
  min?: InputMaybe<Mnet_Blog_Inbound_Emails_Min_Order_By>;
};

/** input type for inserting array relation for remote table "mnet_blog.inbound_emails" */
export type Mnet_Blog_Inbound_Emails_Arr_Rel_Insert_Input = {
  data: Array<Mnet_Blog_Inbound_Emails_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Inbound_Emails_On_Conflict>;
};

/** Boolean expression to filter rows from the table "mnet_blog.inbound_emails". All fields are combined with a logical 'AND'. */
export type Mnet_Blog_Inbound_Emails_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Blog_Inbound_Emails_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Blog_Inbound_Emails_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Blog_Inbound_Emails_Bool_Exp>>;
  cc_emails?: InputMaybe<String_Array_Comparison_Exp>;
  cleaned_body?: InputMaybe<String_Comparison_Exp>;
  comment?: InputMaybe<Mnet_Blog_Comments_Bool_Exp>;
  comment_id?: InputMaybe<Uuid_Comparison_Exp>;
  conversation_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_notification?: InputMaybe<Mnet_Blog_Email_Notifications_Bool_Exp>;
  email_notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  failure_reason?: InputMaybe<String_Comparison_Exp>;
  from_email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internet_message_id?: InputMaybe<String_Comparison_Exp>;
  post?: InputMaybe<Mnet_Blog_Posts_Bool_Exp>;
  post_id?: InputMaybe<Uuid_Comparison_Exp>;
  processed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  processing_status?: InputMaybe<String_Comparison_Exp>;
  raw_body?: InputMaybe<String_Comparison_Exp>;
  received_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  resolution_method?: InputMaybe<String_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  to_emails?: InputMaybe<String_Array_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mnet_blog.inbound_emails" */
export enum Mnet_Blog_Inbound_Emails_Constraint {
  /** unique or primary key constraint on columns "internet_message_id" */
  Inbound_emails_internet_message_id_key = 'inbound_emails_internet_message_id_key',
  /** unique or primary key constraint on columns "id" */
  Inbound_emails_pkey = 'inbound_emails_pkey',
}

/** input type for inserting data into table "mnet_blog.inbound_emails" */
export type Mnet_Blog_Inbound_Emails_Insert_Input = {
  cc_emails?: InputMaybe<Array<Scalars['String']['input']>>;
  cleaned_body?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Mnet_Blog_Comments_Obj_Rel_Insert_Input>;
  comment_id?: InputMaybe<Scalars['uuid']['input']>;
  conversation_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_notification?: InputMaybe<Mnet_Blog_Email_Notifications_Obj_Rel_Insert_Input>;
  email_notification_id?: InputMaybe<Scalars['uuid']['input']>;
  failure_reason?: InputMaybe<Scalars['String']['input']>;
  from_email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internet_message_id?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<Mnet_Blog_Posts_Obj_Rel_Insert_Input>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  processed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  processing_status?: InputMaybe<Scalars['String']['input']>;
  raw_body?: InputMaybe<Scalars['String']['input']>;
  received_at?: InputMaybe<Scalars['timestamptz']['input']>;
  resolution_method?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  to_emails?: InputMaybe<Array<Scalars['String']['input']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "mnet_blog.inbound_emails" */
export type Mnet_Blog_Inbound_Emails_Max_Order_By = {
  cc_emails?: InputMaybe<Order_By>;
  cleaned_body?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  conversation_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_notification_id?: InputMaybe<Order_By>;
  failure_reason?: InputMaybe<Order_By>;
  from_email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internet_message_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  processing_status?: InputMaybe<Order_By>;
  raw_body?: InputMaybe<Order_By>;
  received_at?: InputMaybe<Order_By>;
  resolution_method?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  to_emails?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mnet_blog.inbound_emails" */
export type Mnet_Blog_Inbound_Emails_Min_Order_By = {
  cc_emails?: InputMaybe<Order_By>;
  cleaned_body?: InputMaybe<Order_By>;
  comment_id?: InputMaybe<Order_By>;
  conversation_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_notification_id?: InputMaybe<Order_By>;
  failure_reason?: InputMaybe<Order_By>;
  from_email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internet_message_id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  processing_status?: InputMaybe<Order_By>;
  raw_body?: InputMaybe<Order_By>;
  received_at?: InputMaybe<Order_By>;
  resolution_method?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  to_emails?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mnet_blog.inbound_emails" */
export type Mnet_Blog_Inbound_Emails_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mnet_Blog_Inbound_Emails>;
};

/** on_conflict condition type for table "mnet_blog.inbound_emails" */
export type Mnet_Blog_Inbound_Emails_On_Conflict = {
  constraint: Mnet_Blog_Inbound_Emails_Constraint;
  update_columns?: Array<Mnet_Blog_Inbound_Emails_Update_Column>;
  where?: InputMaybe<Mnet_Blog_Inbound_Emails_Bool_Exp>;
};

/** Ordering options when selecting data from "mnet_blog.inbound_emails". */
export type Mnet_Blog_Inbound_Emails_Order_By = {
  cc_emails?: InputMaybe<Order_By>;
  cleaned_body?: InputMaybe<Order_By>;
  comment?: InputMaybe<Mnet_Blog_Comments_Order_By>;
  comment_id?: InputMaybe<Order_By>;
  conversation_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_notification?: InputMaybe<Mnet_Blog_Email_Notifications_Order_By>;
  email_notification_id?: InputMaybe<Order_By>;
  failure_reason?: InputMaybe<Order_By>;
  from_email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internet_message_id?: InputMaybe<Order_By>;
  post?: InputMaybe<Mnet_Blog_Posts_Order_By>;
  post_id?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  processing_status?: InputMaybe<Order_By>;
  raw_body?: InputMaybe<Order_By>;
  received_at?: InputMaybe<Order_By>;
  resolution_method?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  to_emails?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mnet_blog.inbound_emails */
export type Mnet_Blog_Inbound_Emails_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mnet_blog.inbound_emails" */
export enum Mnet_Blog_Inbound_Emails_Select_Column {
  /** column name */
  Cc_emails = 'cc_emails',
  /** column name */
  Cleaned_body = 'cleaned_body',
  /** column name */
  Comment_id = 'comment_id',
  /** column name */
  Conversation_id = 'conversation_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Email_notification_id = 'email_notification_id',
  /** column name */
  Failure_reason = 'failure_reason',
  /** column name */
  From_email = 'from_email',
  /** column name */
  Id = 'id',
  /** column name */
  Internet_message_id = 'internet_message_id',
  /** column name */
  Post_id = 'post_id',
  /** column name */
  Processed_at = 'processed_at',
  /** column name */
  Processing_status = 'processing_status',
  /** column name */
  Raw_body = 'raw_body',
  /** column name */
  Received_at = 'received_at',
  /** column name */
  Resolution_method = 'resolution_method',
  /** column name */
  Subject = 'subject',
  /** column name */
  To_emails = 'to_emails',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "mnet_blog.inbound_emails" */
export type Mnet_Blog_Inbound_Emails_Set_Input = {
  cc_emails?: InputMaybe<Array<Scalars['String']['input']>>;
  cleaned_body?: InputMaybe<Scalars['String']['input']>;
  comment_id?: InputMaybe<Scalars['uuid']['input']>;
  conversation_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_notification_id?: InputMaybe<Scalars['uuid']['input']>;
  failure_reason?: InputMaybe<Scalars['String']['input']>;
  from_email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internet_message_id?: InputMaybe<Scalars['String']['input']>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  processed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  processing_status?: InputMaybe<Scalars['String']['input']>;
  raw_body?: InputMaybe<Scalars['String']['input']>;
  received_at?: InputMaybe<Scalars['timestamptz']['input']>;
  resolution_method?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  to_emails?: InputMaybe<Array<Scalars['String']['input']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "mnet_blog_inbound_emails" */
export type Mnet_Blog_Inbound_Emails_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Blog_Inbound_Emails_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Blog_Inbound_Emails_Stream_Cursor_Value_Input = {
  cc_emails?: InputMaybe<Array<Scalars['String']['input']>>;
  cleaned_body?: InputMaybe<Scalars['String']['input']>;
  comment_id?: InputMaybe<Scalars['uuid']['input']>;
  conversation_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_notification_id?: InputMaybe<Scalars['uuid']['input']>;
  failure_reason?: InputMaybe<Scalars['String']['input']>;
  from_email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internet_message_id?: InputMaybe<Scalars['String']['input']>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  processed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  processing_status?: InputMaybe<Scalars['String']['input']>;
  raw_body?: InputMaybe<Scalars['String']['input']>;
  received_at?: InputMaybe<Scalars['timestamptz']['input']>;
  resolution_method?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  to_emails?: InputMaybe<Array<Scalars['String']['input']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "mnet_blog.inbound_emails" */
export enum Mnet_Blog_Inbound_Emails_Update_Column {
  /** column name */
  Cc_emails = 'cc_emails',
  /** column name */
  Cleaned_body = 'cleaned_body',
  /** column name */
  Comment_id = 'comment_id',
  /** column name */
  Conversation_id = 'conversation_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Email_notification_id = 'email_notification_id',
  /** column name */
  Failure_reason = 'failure_reason',
  /** column name */
  From_email = 'from_email',
  /** column name */
  Id = 'id',
  /** column name */
  Internet_message_id = 'internet_message_id',
  /** column name */
  Post_id = 'post_id',
  /** column name */
  Processed_at = 'processed_at',
  /** column name */
  Processing_status = 'processing_status',
  /** column name */
  Raw_body = 'raw_body',
  /** column name */
  Received_at = 'received_at',
  /** column name */
  Resolution_method = 'resolution_method',
  /** column name */
  Subject = 'subject',
  /** column name */
  To_emails = 'to_emails',
  /** column name */
  Updated_at = 'updated_at',
}

export type Mnet_Blog_Inbound_Emails_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mnet_Blog_Inbound_Emails_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mnet_Blog_Inbound_Emails_Bool_Exp;
};

/** columns and relationships of "mnet_blog.notification_recipients" */
export type Mnet_Blog_Notification_Recipients = {
  /** An object relationship */
  blog: Mnet_Blog_Blogs;
  blog_id: Scalars['uuid']['output'];
  /** An object relationship */
  channel?: Maybe<Mnet_Blog_Channels>;
  channel_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  enabled: Scalars['Boolean']['output'];
  event_type: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  recipient_type: Scalars['String']['output'];
  recipient_value: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "mnet_blog.notification_recipients" */
export type Mnet_Blog_Notification_Recipients_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Blog_Notification_Recipients_Max_Order_By>;
  min?: InputMaybe<Mnet_Blog_Notification_Recipients_Min_Order_By>;
};

/** input type for inserting array relation for remote table "mnet_blog.notification_recipients" */
export type Mnet_Blog_Notification_Recipients_Arr_Rel_Insert_Input = {
  data: Array<Mnet_Blog_Notification_Recipients_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Notification_Recipients_On_Conflict>;
};

/** Boolean expression to filter rows from the table "mnet_blog.notification_recipients". All fields are combined with a logical 'AND'. */
export type Mnet_Blog_Notification_Recipients_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Blog_Notification_Recipients_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Blog_Notification_Recipients_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Blog_Notification_Recipients_Bool_Exp>>;
  blog?: InputMaybe<Mnet_Blog_Blogs_Bool_Exp>;
  blog_id?: InputMaybe<Uuid_Comparison_Exp>;
  channel?: InputMaybe<Mnet_Blog_Channels_Bool_Exp>;
  channel_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  recipient_type?: InputMaybe<String_Comparison_Exp>;
  recipient_value?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mnet_blog.notification_recipients" */
export enum Mnet_Blog_Notification_Recipients_Constraint {
  /** unique or primary key constraint on columns "id" */
  Notification_recipients_pkey = 'notification_recipients_pkey',
}

/** input type for inserting data into table "mnet_blog.notification_recipients" */
export type Mnet_Blog_Notification_Recipients_Insert_Input = {
  blog?: InputMaybe<Mnet_Blog_Blogs_Obj_Rel_Insert_Input>;
  blog_id?: InputMaybe<Scalars['uuid']['input']>;
  channel?: InputMaybe<Mnet_Blog_Channels_Obj_Rel_Insert_Input>;
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  recipient_type?: InputMaybe<Scalars['String']['input']>;
  recipient_value?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "mnet_blog.notification_recipients" */
export type Mnet_Blog_Notification_Recipients_Max_Order_By = {
  blog_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  recipient_type?: InputMaybe<Order_By>;
  recipient_value?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mnet_blog.notification_recipients" */
export type Mnet_Blog_Notification_Recipients_Min_Order_By = {
  blog_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  recipient_type?: InputMaybe<Order_By>;
  recipient_value?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mnet_blog.notification_recipients" */
export type Mnet_Blog_Notification_Recipients_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mnet_Blog_Notification_Recipients>;
};

/** on_conflict condition type for table "mnet_blog.notification_recipients" */
export type Mnet_Blog_Notification_Recipients_On_Conflict = {
  constraint: Mnet_Blog_Notification_Recipients_Constraint;
  update_columns?: Array<Mnet_Blog_Notification_Recipients_Update_Column>;
  where?: InputMaybe<Mnet_Blog_Notification_Recipients_Bool_Exp>;
};

/** Ordering options when selecting data from "mnet_blog.notification_recipients". */
export type Mnet_Blog_Notification_Recipients_Order_By = {
  blog?: InputMaybe<Mnet_Blog_Blogs_Order_By>;
  blog_id?: InputMaybe<Order_By>;
  channel?: InputMaybe<Mnet_Blog_Channels_Order_By>;
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  recipient_type?: InputMaybe<Order_By>;
  recipient_value?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mnet_blog.notification_recipients */
export type Mnet_Blog_Notification_Recipients_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mnet_blog.notification_recipients" */
export enum Mnet_Blog_Notification_Recipients_Select_Column {
  /** column name */
  Blog_id = 'blog_id',
  /** column name */
  Channel_id = 'channel_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Event_type = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  Recipient_type = 'recipient_type',
  /** column name */
  Recipient_value = 'recipient_value',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "mnet_blog.notification_recipients" */
export type Mnet_Blog_Notification_Recipients_Set_Input = {
  blog_id?: InputMaybe<Scalars['uuid']['input']>;
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  recipient_type?: InputMaybe<Scalars['String']['input']>;
  recipient_value?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "mnet_blog_notification_recipients" */
export type Mnet_Blog_Notification_Recipients_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Blog_Notification_Recipients_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Blog_Notification_Recipients_Stream_Cursor_Value_Input = {
  blog_id?: InputMaybe<Scalars['uuid']['input']>;
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  recipient_type?: InputMaybe<Scalars['String']['input']>;
  recipient_value?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "mnet_blog.notification_recipients" */
export enum Mnet_Blog_Notification_Recipients_Update_Column {
  /** column name */
  Blog_id = 'blog_id',
  /** column name */
  Channel_id = 'channel_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Event_type = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  Recipient_type = 'recipient_type',
  /** column name */
  Recipient_value = 'recipient_value',
  /** column name */
  Updated_at = 'updated_at',
}

export type Mnet_Blog_Notification_Recipients_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mnet_Blog_Notification_Recipients_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mnet_Blog_Notification_Recipients_Bool_Exp;
};

/** columns and relationships of "mnet_blog.notification_template_rules" */
export type Mnet_Blog_Notification_Template_Rules = {
  /** An object relationship */
  blog: Mnet_Blog_Blogs;
  blog_id: Scalars['uuid']['output'];
  /** An object relationship */
  channel?: Maybe<Mnet_Blog_Channels>;
  channel_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  email_notifications: Array<Mnet_Blog_Email_Notifications>;
  /** An object relationship */
  email_template: Mnet_Blog_Email_Templates;
  enabled: Scalars['Boolean']['output'];
  event_type: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  priority: Scalars['Int']['output'];
  template_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "mnet_blog.notification_template_rules" */
export type Mnet_Blog_Notification_Template_RulesEmail_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Email_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Email_Notifications_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Email_Notifications_Bool_Exp>;
};

/** order by aggregate values of table "mnet_blog.notification_template_rules" */
export type Mnet_Blog_Notification_Template_Rules_Aggregate_Order_By = {
  avg?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Max_Order_By>;
  min?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Min_Order_By>;
  stddev?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Sum_Order_By>;
  var_pop?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Var_Samp_Order_By>;
  variance?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mnet_blog.notification_template_rules" */
export type Mnet_Blog_Notification_Template_Rules_Arr_Rel_Insert_Input = {
  data: Array<Mnet_Blog_Notification_Template_Rules_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Notification_Template_Rules_On_Conflict>;
};

/** order by avg() on columns of table "mnet_blog.notification_template_rules" */
export type Mnet_Blog_Notification_Template_Rules_Avg_Order_By = {
  priority?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mnet_blog.notification_template_rules". All fields are combined with a logical 'AND'. */
export type Mnet_Blog_Notification_Template_Rules_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Blog_Notification_Template_Rules_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Blog_Notification_Template_Rules_Bool_Exp>>;
  blog?: InputMaybe<Mnet_Blog_Blogs_Bool_Exp>;
  blog_id?: InputMaybe<Uuid_Comparison_Exp>;
  channel?: InputMaybe<Mnet_Blog_Channels_Bool_Exp>;
  channel_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_notifications?: InputMaybe<Mnet_Blog_Email_Notifications_Bool_Exp>;
  email_template?: InputMaybe<Mnet_Blog_Email_Templates_Bool_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  priority?: InputMaybe<Int_Comparison_Exp>;
  template_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mnet_blog.notification_template_rules" */
export enum Mnet_Blog_Notification_Template_Rules_Constraint {
  /** unique or primary key constraint on columns "template_id", "channel_id", "blog_id", "event_type" */
  Notification_template_rules_blog_id_event_type_channel_id_t_key = 'notification_template_rules_blog_id_event_type_channel_id_t_key',
  /** unique or primary key constraint on columns "id" */
  Notification_template_rules_pkey = 'notification_template_rules_pkey',
}

/** input type for incrementing numeric columns in table "mnet_blog.notification_template_rules" */
export type Mnet_Blog_Notification_Template_Rules_Inc_Input = {
  priority?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "mnet_blog.notification_template_rules" */
export type Mnet_Blog_Notification_Template_Rules_Insert_Input = {
  blog?: InputMaybe<Mnet_Blog_Blogs_Obj_Rel_Insert_Input>;
  blog_id?: InputMaybe<Scalars['uuid']['input']>;
  channel?: InputMaybe<Mnet_Blog_Channels_Obj_Rel_Insert_Input>;
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_notifications?: InputMaybe<Mnet_Blog_Email_Notifications_Arr_Rel_Insert_Input>;
  email_template?: InputMaybe<Mnet_Blog_Email_Templates_Obj_Rel_Insert_Input>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  template_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "mnet_blog.notification_template_rules" */
export type Mnet_Blog_Notification_Template_Rules_Max_Order_By = {
  blog_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mnet_blog.notification_template_rules" */
export type Mnet_Blog_Notification_Template_Rules_Min_Order_By = {
  blog_id?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mnet_blog.notification_template_rules" */
export type Mnet_Blog_Notification_Template_Rules_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mnet_Blog_Notification_Template_Rules>;
};

/** input type for inserting object relation for remote table "mnet_blog.notification_template_rules" */
export type Mnet_Blog_Notification_Template_Rules_Obj_Rel_Insert_Input = {
  data: Mnet_Blog_Notification_Template_Rules_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Notification_Template_Rules_On_Conflict>;
};

/** on_conflict condition type for table "mnet_blog.notification_template_rules" */
export type Mnet_Blog_Notification_Template_Rules_On_Conflict = {
  constraint: Mnet_Blog_Notification_Template_Rules_Constraint;
  update_columns?: Array<Mnet_Blog_Notification_Template_Rules_Update_Column>;
  where?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Bool_Exp>;
};

/** Ordering options when selecting data from "mnet_blog.notification_template_rules". */
export type Mnet_Blog_Notification_Template_Rules_Order_By = {
  blog?: InputMaybe<Mnet_Blog_Blogs_Order_By>;
  blog_id?: InputMaybe<Order_By>;
  channel?: InputMaybe<Mnet_Blog_Channels_Order_By>;
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_notifications_aggregate?: InputMaybe<Mnet_Blog_Email_Notifications_Aggregate_Order_By>;
  email_template?: InputMaybe<Mnet_Blog_Email_Templates_Order_By>;
  enabled?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mnet_blog.notification_template_rules */
export type Mnet_Blog_Notification_Template_Rules_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mnet_blog.notification_template_rules" */
export enum Mnet_Blog_Notification_Template_Rules_Select_Column {
  /** column name */
  Blog_id = 'blog_id',
  /** column name */
  Channel_id = 'channel_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Event_type = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  Priority = 'priority',
  /** column name */
  Template_id = 'template_id',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "mnet_blog.notification_template_rules" */
export type Mnet_Blog_Notification_Template_Rules_Set_Input = {
  blog_id?: InputMaybe<Scalars['uuid']['input']>;
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  template_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "mnet_blog.notification_template_rules" */
export type Mnet_Blog_Notification_Template_Rules_Stddev_Order_By = {
  priority?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "mnet_blog.notification_template_rules" */
export type Mnet_Blog_Notification_Template_Rules_Stddev_Pop_Order_By = {
  priority?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "mnet_blog.notification_template_rules" */
export type Mnet_Blog_Notification_Template_Rules_Stddev_Samp_Order_By = {
  priority?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mnet_blog_notification_template_rules" */
export type Mnet_Blog_Notification_Template_Rules_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Blog_Notification_Template_Rules_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Blog_Notification_Template_Rules_Stream_Cursor_Value_Input = {
  blog_id?: InputMaybe<Scalars['uuid']['input']>;
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  template_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "mnet_blog.notification_template_rules" */
export type Mnet_Blog_Notification_Template_Rules_Sum_Order_By = {
  priority?: InputMaybe<Order_By>;
};

/** update columns of table "mnet_blog.notification_template_rules" */
export enum Mnet_Blog_Notification_Template_Rules_Update_Column {
  /** column name */
  Blog_id = 'blog_id',
  /** column name */
  Channel_id = 'channel_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Event_type = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  Priority = 'priority',
  /** column name */
  Template_id = 'template_id',
  /** column name */
  Updated_at = 'updated_at',
}

export type Mnet_Blog_Notification_Template_Rules_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mnet_Blog_Notification_Template_Rules_Bool_Exp;
};

/** order by var_pop() on columns of table "mnet_blog.notification_template_rules" */
export type Mnet_Blog_Notification_Template_Rules_Var_Pop_Order_By = {
  priority?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "mnet_blog.notification_template_rules" */
export type Mnet_Blog_Notification_Template_Rules_Var_Samp_Order_By = {
  priority?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "mnet_blog.notification_template_rules" */
export type Mnet_Blog_Notification_Template_Rules_Variance_Order_By = {
  priority?: InputMaybe<Order_By>;
};

/** columns and relationships of "mnet_blog.post_channels" */
export type Mnet_Blog_Post_Channels = {
  /** An object relationship */
  channel: Mnet_Blog_Channels;
  channel_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  is_primary: Scalars['Boolean']['output'];
  /** An object relationship */
  post: Mnet_Blog_Posts;
  post_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "mnet_blog.post_channels" */
export type Mnet_Blog_Post_Channels_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Blog_Post_Channels_Max_Order_By>;
  min?: InputMaybe<Mnet_Blog_Post_Channels_Min_Order_By>;
};

/** input type for inserting array relation for remote table "mnet_blog.post_channels" */
export type Mnet_Blog_Post_Channels_Arr_Rel_Insert_Input = {
  data: Array<Mnet_Blog_Post_Channels_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Post_Channels_On_Conflict>;
};

/** Boolean expression to filter rows from the table "mnet_blog.post_channels". All fields are combined with a logical 'AND'. */
export type Mnet_Blog_Post_Channels_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Blog_Post_Channels_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Blog_Post_Channels_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Blog_Post_Channels_Bool_Exp>>;
  channel?: InputMaybe<Mnet_Blog_Channels_Bool_Exp>;
  channel_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  is_primary?: InputMaybe<Boolean_Comparison_Exp>;
  post?: InputMaybe<Mnet_Blog_Posts_Bool_Exp>;
  post_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mnet_blog.post_channels" */
export enum Mnet_Blog_Post_Channels_Constraint {
  /** unique or primary key constraint on columns "post_id", "channel_id" */
  Post_channels_pkey = 'post_channels_pkey',
}

/** input type for inserting data into table "mnet_blog.post_channels" */
export type Mnet_Blog_Post_Channels_Insert_Input = {
  channel?: InputMaybe<Mnet_Blog_Channels_Obj_Rel_Insert_Input>;
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  post?: InputMaybe<Mnet_Blog_Posts_Obj_Rel_Insert_Input>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "mnet_blog.post_channels" */
export type Mnet_Blog_Post_Channels_Max_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mnet_blog.post_channels" */
export type Mnet_Blog_Post_Channels_Min_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mnet_blog.post_channels" */
export type Mnet_Blog_Post_Channels_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mnet_Blog_Post_Channels>;
};

/** on_conflict condition type for table "mnet_blog.post_channels" */
export type Mnet_Blog_Post_Channels_On_Conflict = {
  constraint: Mnet_Blog_Post_Channels_Constraint;
  update_columns?: Array<Mnet_Blog_Post_Channels_Update_Column>;
  where?: InputMaybe<Mnet_Blog_Post_Channels_Bool_Exp>;
};

/** Ordering options when selecting data from "mnet_blog.post_channels". */
export type Mnet_Blog_Post_Channels_Order_By = {
  channel?: InputMaybe<Mnet_Blog_Channels_Order_By>;
  channel_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  is_primary?: InputMaybe<Order_By>;
  post?: InputMaybe<Mnet_Blog_Posts_Order_By>;
  post_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mnet_blog.post_channels */
export type Mnet_Blog_Post_Channels_Pk_Columns_Input = {
  channel_id: Scalars['uuid']['input'];
  post_id: Scalars['uuid']['input'];
};

/** select columns of table "mnet_blog.post_channels" */
export enum Mnet_Blog_Post_Channels_Select_Column {
  /** column name */
  Channel_id = 'channel_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Is_primary = 'is_primary',
  /** column name */
  Post_id = 'post_id',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "mnet_blog.post_channels" */
export type Mnet_Blog_Post_Channels_Set_Input = {
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "mnet_blog_post_channels" */
export type Mnet_Blog_Post_Channels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Blog_Post_Channels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Blog_Post_Channels_Stream_Cursor_Value_Input = {
  channel_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "mnet_blog.post_channels" */
export enum Mnet_Blog_Post_Channels_Update_Column {
  /** column name */
  Channel_id = 'channel_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Is_primary = 'is_primary',
  /** column name */
  Post_id = 'post_id',
  /** column name */
  Updated_at = 'updated_at',
}

export type Mnet_Blog_Post_Channels_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mnet_Blog_Post_Channels_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mnet_Blog_Post_Channels_Bool_Exp;
};

/** columns and relationships of "mnet_blog.post_images" */
export type Mnet_Blog_Post_Images = {
  alt_text?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  content_type?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  file_name: Scalars['String']['output'];
  file_size_bytes?: Maybe<Scalars['Int']['output']>;
  file_url: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  post: Mnet_Blog_Posts;
  post_id: Scalars['uuid']['output'];
  sharepoint_drive_id?: Maybe<Scalars['String']['output']>;
  sharepoint_item_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "mnet_blog.post_images" */
export type Mnet_Blog_Post_Images_Aggregate_Order_By = {
  avg?: InputMaybe<Mnet_Blog_Post_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Blog_Post_Images_Max_Order_By>;
  min?: InputMaybe<Mnet_Blog_Post_Images_Min_Order_By>;
  stddev?: InputMaybe<Mnet_Blog_Post_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mnet_Blog_Post_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mnet_Blog_Post_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mnet_Blog_Post_Images_Sum_Order_By>;
  var_pop?: InputMaybe<Mnet_Blog_Post_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mnet_Blog_Post_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<Mnet_Blog_Post_Images_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mnet_blog.post_images" */
export type Mnet_Blog_Post_Images_Arr_Rel_Insert_Input = {
  data: Array<Mnet_Blog_Post_Images_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Post_Images_On_Conflict>;
};

/** order by avg() on columns of table "mnet_blog.post_images" */
export type Mnet_Blog_Post_Images_Avg_Order_By = {
  file_size_bytes?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mnet_blog.post_images". All fields are combined with a logical 'AND'. */
export type Mnet_Blog_Post_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Blog_Post_Images_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Blog_Post_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Blog_Post_Images_Bool_Exp>>;
  alt_text?: InputMaybe<String_Comparison_Exp>;
  caption?: InputMaybe<String_Comparison_Exp>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  file_size_bytes?: InputMaybe<Int_Comparison_Exp>;
  file_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  post?: InputMaybe<Mnet_Blog_Posts_Bool_Exp>;
  post_id?: InputMaybe<Uuid_Comparison_Exp>;
  sharepoint_drive_id?: InputMaybe<String_Comparison_Exp>;
  sharepoint_item_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mnet_blog.post_images" */
export enum Mnet_Blog_Post_Images_Constraint {
  /** unique or primary key constraint on columns "id" */
  Post_images_pkey = 'post_images_pkey',
}

/** input type for incrementing numeric columns in table "mnet_blog.post_images" */
export type Mnet_Blog_Post_Images_Inc_Input = {
  file_size_bytes?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "mnet_blog.post_images" */
export type Mnet_Blog_Post_Images_Insert_Input = {
  alt_text?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  content_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_size_bytes?: InputMaybe<Scalars['Int']['input']>;
  file_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  post?: InputMaybe<Mnet_Blog_Posts_Obj_Rel_Insert_Input>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  sharepoint_drive_id?: InputMaybe<Scalars['String']['input']>;
  sharepoint_item_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "mnet_blog.post_images" */
export type Mnet_Blog_Post_Images_Max_Order_By = {
  alt_text?: InputMaybe<Order_By>;
  caption?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  file_size_bytes?: InputMaybe<Order_By>;
  file_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  sharepoint_drive_id?: InputMaybe<Order_By>;
  sharepoint_item_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mnet_blog.post_images" */
export type Mnet_Blog_Post_Images_Min_Order_By = {
  alt_text?: InputMaybe<Order_By>;
  caption?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  file_size_bytes?: InputMaybe<Order_By>;
  file_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  sharepoint_drive_id?: InputMaybe<Order_By>;
  sharepoint_item_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mnet_blog.post_images" */
export type Mnet_Blog_Post_Images_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mnet_Blog_Post_Images>;
};

/** on_conflict condition type for table "mnet_blog.post_images" */
export type Mnet_Blog_Post_Images_On_Conflict = {
  constraint: Mnet_Blog_Post_Images_Constraint;
  update_columns?: Array<Mnet_Blog_Post_Images_Update_Column>;
  where?: InputMaybe<Mnet_Blog_Post_Images_Bool_Exp>;
};

/** Ordering options when selecting data from "mnet_blog.post_images". */
export type Mnet_Blog_Post_Images_Order_By = {
  alt_text?: InputMaybe<Order_By>;
  caption?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  file_size_bytes?: InputMaybe<Order_By>;
  file_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post?: InputMaybe<Mnet_Blog_Posts_Order_By>;
  post_id?: InputMaybe<Order_By>;
  sharepoint_drive_id?: InputMaybe<Order_By>;
  sharepoint_item_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mnet_blog.post_images */
export type Mnet_Blog_Post_Images_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mnet_blog.post_images" */
export enum Mnet_Blog_Post_Images_Select_Column {
  /** column name */
  Alt_text = 'alt_text',
  /** column name */
  Caption = 'caption',
  /** column name */
  Content_type = 'content_type',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  File_name = 'file_name',
  /** column name */
  File_size_bytes = 'file_size_bytes',
  /** column name */
  File_url = 'file_url',
  /** column name */
  Id = 'id',
  /** column name */
  Post_id = 'post_id',
  /** column name */
  Sharepoint_drive_id = 'sharepoint_drive_id',
  /** column name */
  Sharepoint_item_id = 'sharepoint_item_id',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "mnet_blog.post_images" */
export type Mnet_Blog_Post_Images_Set_Input = {
  alt_text?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  content_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_size_bytes?: InputMaybe<Scalars['Int']['input']>;
  file_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  sharepoint_drive_id?: InputMaybe<Scalars['String']['input']>;
  sharepoint_item_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "mnet_blog.post_images" */
export type Mnet_Blog_Post_Images_Stddev_Order_By = {
  file_size_bytes?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "mnet_blog.post_images" */
export type Mnet_Blog_Post_Images_Stddev_Pop_Order_By = {
  file_size_bytes?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "mnet_blog.post_images" */
export type Mnet_Blog_Post_Images_Stddev_Samp_Order_By = {
  file_size_bytes?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mnet_blog_post_images" */
export type Mnet_Blog_Post_Images_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Blog_Post_Images_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Blog_Post_Images_Stream_Cursor_Value_Input = {
  alt_text?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  content_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_size_bytes?: InputMaybe<Scalars['Int']['input']>;
  file_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  sharepoint_drive_id?: InputMaybe<Scalars['String']['input']>;
  sharepoint_item_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "mnet_blog.post_images" */
export type Mnet_Blog_Post_Images_Sum_Order_By = {
  file_size_bytes?: InputMaybe<Order_By>;
};

/** update columns of table "mnet_blog.post_images" */
export enum Mnet_Blog_Post_Images_Update_Column {
  /** column name */
  Alt_text = 'alt_text',
  /** column name */
  Caption = 'caption',
  /** column name */
  Content_type = 'content_type',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  File_name = 'file_name',
  /** column name */
  File_size_bytes = 'file_size_bytes',
  /** column name */
  File_url = 'file_url',
  /** column name */
  Id = 'id',
  /** column name */
  Post_id = 'post_id',
  /** column name */
  Sharepoint_drive_id = 'sharepoint_drive_id',
  /** column name */
  Sharepoint_item_id = 'sharepoint_item_id',
  /** column name */
  Updated_at = 'updated_at',
}

export type Mnet_Blog_Post_Images_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mnet_Blog_Post_Images_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mnet_Blog_Post_Images_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mnet_Blog_Post_Images_Bool_Exp;
};

/** order by var_pop() on columns of table "mnet_blog.post_images" */
export type Mnet_Blog_Post_Images_Var_Pop_Order_By = {
  file_size_bytes?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "mnet_blog.post_images" */
export type Mnet_Blog_Post_Images_Var_Samp_Order_By = {
  file_size_bytes?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "mnet_blog.post_images" */
export type Mnet_Blog_Post_Images_Variance_Order_By = {
  file_size_bytes?: InputMaybe<Order_By>;
};

/** columns and relationships of "mnet_blog.post_reactions" */
export type Mnet_Blog_Post_Reactions = {
  author?: Maybe<Mlfsl_Personnel>;
  author_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  post: Mnet_Blog_Posts;
  post_id: Scalars['uuid']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "mnet_blog.post_reactions" */
export type Mnet_Blog_Post_Reactions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Blog_Post_Reactions_Max_Order_By>;
  min?: InputMaybe<Mnet_Blog_Post_Reactions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "mnet_blog.post_reactions" */
export type Mnet_Blog_Post_Reactions_Arr_Rel_Insert_Input = {
  data: Array<Mnet_Blog_Post_Reactions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Post_Reactions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "mnet_blog.post_reactions". All fields are combined with a logical 'AND'. */
export type Mnet_Blog_Post_Reactions_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Blog_Post_Reactions_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Blog_Post_Reactions_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Blog_Post_Reactions_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  post?: InputMaybe<Mnet_Blog_Posts_Bool_Exp>;
  post_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mnet_blog.post_reactions" */
export enum Mnet_Blog_Post_Reactions_Constraint {
  /** unique or primary key constraint on columns "id" */
  Post_reactions_pkey = 'post_reactions_pkey',
  /** unique or primary key constraint on columns "post_id", "type", "author_id" */
  Post_reactions_post_id_author_id_type_key = 'post_reactions_post_id_author_id_type_key',
}

/** input type for inserting data into table "mnet_blog.post_reactions" */
export type Mnet_Blog_Post_Reactions_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  post?: InputMaybe<Mnet_Blog_Posts_Obj_Rel_Insert_Input>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "mnet_blog.post_reactions" */
export type Mnet_Blog_Post_Reactions_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "mnet_blog.post_reactions" */
export type Mnet_Blog_Post_Reactions_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mnet_blog.post_reactions" */
export type Mnet_Blog_Post_Reactions_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mnet_Blog_Post_Reactions>;
};

/** on_conflict condition type for table "mnet_blog.post_reactions" */
export type Mnet_Blog_Post_Reactions_On_Conflict = {
  constraint: Mnet_Blog_Post_Reactions_Constraint;
  update_columns?: Array<Mnet_Blog_Post_Reactions_Update_Column>;
  where?: InputMaybe<Mnet_Blog_Post_Reactions_Bool_Exp>;
};

/** Ordering options when selecting data from "mnet_blog.post_reactions". */
export type Mnet_Blog_Post_Reactions_Order_By = {
  author_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post?: InputMaybe<Mnet_Blog_Posts_Order_By>;
  post_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mnet_blog.post_reactions */
export type Mnet_Blog_Post_Reactions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mnet_blog.post_reactions" */
export enum Mnet_Blog_Post_Reactions_Select_Column {
  /** column name */
  Author_id = 'author_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Post_id = 'post_id',
  /** column name */
  Type = 'type',
  /** column name */
  Updated_at = 'updated_at',
}

/** input type for updating data in table "mnet_blog.post_reactions" */
export type Mnet_Blog_Post_Reactions_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "mnet_blog_post_reactions" */
export type Mnet_Blog_Post_Reactions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Blog_Post_Reactions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Blog_Post_Reactions_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  post_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "mnet_blog.post_reactions" */
export enum Mnet_Blog_Post_Reactions_Update_Column {
  /** column name */
  Author_id = 'author_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Post_id = 'post_id',
  /** column name */
  Type = 'type',
  /** column name */
  Updated_at = 'updated_at',
}

export type Mnet_Blog_Post_Reactions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mnet_Blog_Post_Reactions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mnet_Blog_Post_Reactions_Bool_Exp;
};

/** columns and relationships of "mnet_blog.posts" */
export type Mnet_Blog_Posts = {
  /** An array relationship */
  attachments: Array<Mnet_Blog_Attachments>;
  author?: Maybe<Mlfsl_Personnel>;
  author_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  blog: Mnet_Blog_Blogs;
  blog_id: Scalars['uuid']['output'];
  body: Scalars['String']['output'];
  /** An array relationship */
  comments: Array<Mnet_Blog_Comments>;
  content_type: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_user?: Maybe<Mlfsl_Personnel>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  email_notifications: Array<Mnet_Blog_Email_Notifications>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  inbound_emails: Array<Mnet_Blog_Inbound_Emails>;
  is_deleted: Scalars['Boolean']['output'];
  /** An array relationship */
  post_channels: Array<Mnet_Blog_Post_Channels>;
  /** An array relationship */
  post_images: Array<Mnet_Blog_Post_Images>;
  /** An array relationship */
  post_reactions: Array<Mnet_Blog_Post_Reactions>;
  publish_at: Scalars['timestamp']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** columns and relationships of "mnet_blog.posts" */
export type Mnet_Blog_PostsAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Attachments_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Attachments_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.posts" */
export type Mnet_Blog_PostsCommentsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Comments_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Comments_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.posts" */
export type Mnet_Blog_PostsEmail_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Email_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Email_Notifications_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Email_Notifications_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.posts" */
export type Mnet_Blog_PostsInbound_EmailsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Inbound_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Inbound_Emails_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Inbound_Emails_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.posts" */
export type Mnet_Blog_PostsPost_ChannelsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Post_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Post_Channels_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Post_Channels_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.posts" */
export type Mnet_Blog_PostsPost_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Post_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Post_Images_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Post_Images_Bool_Exp>;
};

/** columns and relationships of "mnet_blog.posts" */
export type Mnet_Blog_PostsPost_ReactionsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Post_Reactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Post_Reactions_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Post_Reactions_Bool_Exp>;
};

/** aggregated selection of "mnet_blog.posts" */
export type Mnet_Blog_Posts_Aggregate = {
  aggregate?: Maybe<Mnet_Blog_Posts_Aggregate_Fields>;
  nodes: Array<Mnet_Blog_Posts>;
};

export type Mnet_Blog_Posts_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Mnet_Blog_Posts_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Mnet_Blog_Posts_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Mnet_Blog_Posts_Aggregate_Bool_Exp_Count>;
};

export type Mnet_Blog_Posts_Aggregate_Bool_Exp_Bool_And = {
  arguments: Mnet_Blog_Posts_Select_Column_Mnet_Blog_Posts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Blog_Posts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Mnet_Blog_Posts_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Mnet_Blog_Posts_Select_Column_Mnet_Blog_Posts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Blog_Posts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Mnet_Blog_Posts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mnet_Blog_Posts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Blog_Posts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mnet_blog.posts" */
export type Mnet_Blog_Posts_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Blog_Posts_Max_Fields>;
  min?: Maybe<Mnet_Blog_Posts_Min_Fields>;
};

/** aggregate fields of "mnet_blog.posts" */
export type Mnet_Blog_Posts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Blog_Posts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mnet_blog.posts" */
export type Mnet_Blog_Posts_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Blog_Posts_Max_Order_By>;
  min?: InputMaybe<Mnet_Blog_Posts_Min_Order_By>;
};

/** input type for inserting array relation for remote table "mnet_blog.posts" */
export type Mnet_Blog_Posts_Arr_Rel_Insert_Input = {
  data: Array<Mnet_Blog_Posts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Posts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "mnet_blog.posts". All fields are combined with a logical 'AND'. */
export type Mnet_Blog_Posts_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Blog_Posts_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Blog_Posts_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Blog_Posts_Bool_Exp>>;
  attachments?: InputMaybe<Mnet_Blog_Attachments_Bool_Exp>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  blog?: InputMaybe<Mnet_Blog_Blogs_Bool_Exp>;
  blog_id?: InputMaybe<Uuid_Comparison_Exp>;
  body?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<Mnet_Blog_Comments_Bool_Exp>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<String_Comparison_Exp>;
  email_notifications?: InputMaybe<Mnet_Blog_Email_Notifications_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inbound_emails?: InputMaybe<Mnet_Blog_Inbound_Emails_Bool_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  post_channels?: InputMaybe<Mnet_Blog_Post_Channels_Bool_Exp>;
  post_images?: InputMaybe<Mnet_Blog_Post_Images_Bool_Exp>;
  post_reactions?: InputMaybe<Mnet_Blog_Post_Reactions_Bool_Exp>;
  publish_at?: InputMaybe<Timestamp_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mnet_blog.posts" */
export enum Mnet_Blog_Posts_Constraint {
  /** unique or primary key constraint on columns "id" */
  Posts_pkey = 'posts_pkey',
}

/** input type for inserting data into table "mnet_blog.posts" */
export type Mnet_Blog_Posts_Insert_Input = {
  attachments?: InputMaybe<Mnet_Blog_Attachments_Arr_Rel_Insert_Input>;
  author_id?: InputMaybe<Scalars['String']['input']>;
  blog?: InputMaybe<Mnet_Blog_Blogs_Obj_Rel_Insert_Input>;
  blog_id?: InputMaybe<Scalars['uuid']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Mnet_Blog_Comments_Arr_Rel_Insert_Input>;
  content_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Scalars['String']['input']>;
  email_notifications?: InputMaybe<Mnet_Blog_Email_Notifications_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inbound_emails?: InputMaybe<Mnet_Blog_Inbound_Emails_Arr_Rel_Insert_Input>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  post_channels?: InputMaybe<Mnet_Blog_Post_Channels_Arr_Rel_Insert_Input>;
  post_images?: InputMaybe<Mnet_Blog_Post_Images_Arr_Rel_Insert_Input>;
  post_reactions?: InputMaybe<Mnet_Blog_Post_Reactions_Arr_Rel_Insert_Input>;
  publish_at?: InputMaybe<Scalars['timestamp']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Mnet_Blog_Posts_Max_Fields = {
  author_id?: Maybe<Scalars['String']['output']>;
  blog_id?: Maybe<Scalars['uuid']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  content_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  publish_at?: Maybe<Scalars['timestamp']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "mnet_blog.posts" */
export type Mnet_Blog_Posts_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  blog_id?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  publish_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mnet_Blog_Posts_Min_Fields = {
  author_id?: Maybe<Scalars['String']['output']>;
  blog_id?: Maybe<Scalars['uuid']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  content_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  publish_at?: Maybe<Scalars['timestamp']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "mnet_blog.posts" */
export type Mnet_Blog_Posts_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  blog_id?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  publish_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mnet_blog.posts" */
export type Mnet_Blog_Posts_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mnet_Blog_Posts>;
};

/** input type for inserting object relation for remote table "mnet_blog.posts" */
export type Mnet_Blog_Posts_Obj_Rel_Insert_Input = {
  data: Mnet_Blog_Posts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mnet_Blog_Posts_On_Conflict>;
};

/** on_conflict condition type for table "mnet_blog.posts" */
export type Mnet_Blog_Posts_On_Conflict = {
  constraint: Mnet_Blog_Posts_Constraint;
  update_columns?: Array<Mnet_Blog_Posts_Update_Column>;
  where?: InputMaybe<Mnet_Blog_Posts_Bool_Exp>;
};

/** Ordering options when selecting data from "mnet_blog.posts". */
export type Mnet_Blog_Posts_Order_By = {
  attachments_aggregate?: InputMaybe<Mnet_Blog_Attachments_Aggregate_Order_By>;
  author_id?: InputMaybe<Order_By>;
  blog?: InputMaybe<Mnet_Blog_Blogs_Order_By>;
  blog_id?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Mnet_Blog_Comments_Aggregate_Order_By>;
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Order_By>;
  email_notifications_aggregate?: InputMaybe<Mnet_Blog_Email_Notifications_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  inbound_emails_aggregate?: InputMaybe<Mnet_Blog_Inbound_Emails_Aggregate_Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  post_channels_aggregate?: InputMaybe<Mnet_Blog_Post_Channels_Aggregate_Order_By>;
  post_images_aggregate?: InputMaybe<Mnet_Blog_Post_Images_Aggregate_Order_By>;
  post_reactions_aggregate?: InputMaybe<Mnet_Blog_Post_Reactions_Aggregate_Order_By>;
  publish_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mnet_blog.posts */
export type Mnet_Blog_Posts_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mnet_blog.posts" */
export enum Mnet_Blog_Posts_Select_Column {
  /** column name */
  Author_id = 'author_id',
  /** column name */
  Blog_id = 'blog_id',
  /** column name */
  Body = 'body',
  /** column name */
  Content_type = 'content_type',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Deleted_at = 'deleted_at',
  /** column name */
  Deleted_by = 'deleted_by',
  /** column name */
  Id = 'id',
  /** column name */
  Is_deleted = 'is_deleted',
  /** column name */
  Publish_at = 'publish_at',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** select "mnet_blog_posts_aggregate_bool_exp_bool_and_arguments_columns" columns of table "mnet_blog.posts" */
export enum Mnet_Blog_Posts_Select_Column_Mnet_Blog_Posts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Is_deleted = 'is_deleted',
}

/** select "mnet_blog_posts_aggregate_bool_exp_bool_or_arguments_columns" columns of table "mnet_blog.posts" */
export enum Mnet_Blog_Posts_Select_Column_Mnet_Blog_Posts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Is_deleted = 'is_deleted',
}

/** input type for updating data in table "mnet_blog.posts" */
export type Mnet_Blog_Posts_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  blog_id?: InputMaybe<Scalars['uuid']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  content_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  publish_at?: InputMaybe<Scalars['timestamp']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "mnet_blog_posts" */
export type Mnet_Blog_Posts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Blog_Posts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Blog_Posts_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  blog_id?: InputMaybe<Scalars['uuid']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  content_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  publish_at?: InputMaybe<Scalars['timestamp']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "mnet_blog.posts" */
export enum Mnet_Blog_Posts_Update_Column {
  /** column name */
  Author_id = 'author_id',
  /** column name */
  Blog_id = 'blog_id',
  /** column name */
  Body = 'body',
  /** column name */
  Content_type = 'content_type',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Deleted_at = 'deleted_at',
  /** column name */
  Deleted_by = 'deleted_by',
  /** column name */
  Id = 'id',
  /** column name */
  Is_deleted = 'is_deleted',
  /** column name */
  Publish_at = 'publish_at',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  Updated_at = 'updated_at',
}

export type Mnet_Blog_Posts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mnet_Blog_Posts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mnet_Blog_Posts_Bool_Exp;
};

/** columns and relationships of "mnet.business_chemistry_type" */
export type Mnet_Business_Chemistry_Type = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  primary_person_business_chemistry_profiles: Array<Mnet_Person_Business_Chemistry_Profile>;
  /** An aggregate relationship */
  primary_person_business_chemistry_profiles_aggregate: Mnet_Person_Business_Chemistry_Profile_Aggregate;
  /** An array relationship */
  secondary_person_business_chemistry_profiles: Array<Mnet_Person_Business_Chemistry_Profile>;
  /** An aggregate relationship */
  secondary_person_business_chemistry_profiles_aggregate: Mnet_Person_Business_Chemistry_Profile_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** columns and relationships of "mnet.business_chemistry_type" */
export type Mnet_Business_Chemistry_TypePrimary_Person_Business_Chemistry_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Person_Business_Chemistry_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Person_Business_Chemistry_Profile_Order_By>>;
  where?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Bool_Exp>;
};

/** columns and relationships of "mnet.business_chemistry_type" */
export type Mnet_Business_Chemistry_TypePrimary_Person_Business_Chemistry_Profiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Person_Business_Chemistry_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Person_Business_Chemistry_Profile_Order_By>>;
  where?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Bool_Exp>;
};

/** columns and relationships of "mnet.business_chemistry_type" */
export type Mnet_Business_Chemistry_TypeSecondary_Person_Business_Chemistry_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Person_Business_Chemistry_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Person_Business_Chemistry_Profile_Order_By>>;
  where?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Bool_Exp>;
};

/** columns and relationships of "mnet.business_chemistry_type" */
export type Mnet_Business_Chemistry_TypeSecondary_Person_Business_Chemistry_Profiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Person_Business_Chemistry_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Person_Business_Chemistry_Profile_Order_By>>;
  where?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Bool_Exp>;
};

/** aggregated selection of "mnet.business_chemistry_type" */
export type Mnet_Business_Chemistry_Type_Aggregate = {
  aggregate?: Maybe<Mnet_Business_Chemistry_Type_Aggregate_Fields>;
  nodes: Array<Mnet_Business_Chemistry_Type>;
};

/** aggregate fields of "mnet.business_chemistry_type" */
export type Mnet_Business_Chemistry_Type_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Business_Chemistry_Type_Max_Fields>;
  min?: Maybe<Mnet_Business_Chemistry_Type_Min_Fields>;
};

/** aggregate fields of "mnet.business_chemistry_type" */
export type Mnet_Business_Chemistry_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Business_Chemistry_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "mnet.business_chemistry_type". All fields are combined with a logical 'AND'. */
export type Mnet_Business_Chemistry_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Business_Chemistry_Type_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Business_Chemistry_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Business_Chemistry_Type_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  primary_person_business_chemistry_profiles?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Bool_Exp>;
  primary_person_business_chemistry_profiles_aggregate?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Aggregate_Bool_Exp>;
  secondary_person_business_chemistry_profiles?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Bool_Exp>;
  secondary_person_business_chemistry_profiles_aggregate?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mnet_Business_Chemistry_Type_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Mnet_Business_Chemistry_Type_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "mnet.business_chemistry_type". */
export type Mnet_Business_Chemistry_Type_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  primary_person_business_chemistry_profiles_aggregate?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Aggregate_Order_By>;
  secondary_person_business_chemistry_profiles_aggregate?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.business_chemistry_type" */
export enum Mnet_Business_Chemistry_Type_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Updated_at = 'updated_at',
}

/** Streaming cursor of the table "mnet_business_chemistry_type" */
export type Mnet_Business_Chemistry_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Business_Chemistry_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Business_Chemistry_Type_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "mnet.client_intel_settings" */
export type Mnet_Client_Intel_Settings = {
  Client?: Maybe<Mlfsl_Client>;
  RelatedClient?: Maybe<Mlfsl_Related_Client>;
  capiq_id?: Maybe<Scalars['String']['output']>;
  client_or_related_client_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  duns?: Maybe<Scalars['String']['output']>;
  earliest_open_date?: Maybe<Scalars['timestamptz']['output']>;
  industry_segment?: Maybe<Scalars['String']['output']>;
  is_cap_client?: Maybe<Scalars['Boolean']['output']>;
  manzama_rss_url?: Maybe<Scalars['String']['output']>;
  primary_industry?: Maybe<Scalars['String']['output']>;
  status_description?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "mnet.client_intel_settings" */
export type Mnet_Client_Intel_Settings_Aggregate = {
  aggregate?: Maybe<Mnet_Client_Intel_Settings_Aggregate_Fields>;
  nodes: Array<Mnet_Client_Intel_Settings>;
};

/** aggregate fields of "mnet.client_intel_settings" */
export type Mnet_Client_Intel_Settings_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Client_Intel_Settings_Max_Fields>;
  min?: Maybe<Mnet_Client_Intel_Settings_Min_Fields>;
};

/** aggregate fields of "mnet.client_intel_settings" */
export type Mnet_Client_Intel_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Client_Intel_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "mnet.client_intel_settings". All fields are combined with a logical 'AND'. */
export type Mnet_Client_Intel_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Client_Intel_Settings_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Client_Intel_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Client_Intel_Settings_Bool_Exp>>;
  capiq_id?: InputMaybe<String_Comparison_Exp>;
  client_or_related_client_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  duns?: InputMaybe<String_Comparison_Exp>;
  earliest_open_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  industry_segment?: InputMaybe<String_Comparison_Exp>;
  is_cap_client?: InputMaybe<Boolean_Comparison_Exp>;
  manzama_rss_url?: InputMaybe<String_Comparison_Exp>;
  primary_industry?: InputMaybe<String_Comparison_Exp>;
  status_description?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mnet_Client_Intel_Settings_Max_Fields = {
  capiq_id?: Maybe<Scalars['String']['output']>;
  client_or_related_client_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  duns?: Maybe<Scalars['String']['output']>;
  earliest_open_date?: Maybe<Scalars['timestamptz']['output']>;
  industry_segment?: Maybe<Scalars['String']['output']>;
  manzama_rss_url?: Maybe<Scalars['String']['output']>;
  primary_industry?: Maybe<Scalars['String']['output']>;
  status_description?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Mnet_Client_Intel_Settings_Min_Fields = {
  capiq_id?: Maybe<Scalars['String']['output']>;
  client_or_related_client_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  duns?: Maybe<Scalars['String']['output']>;
  earliest_open_date?: Maybe<Scalars['timestamptz']['output']>;
  industry_segment?: Maybe<Scalars['String']['output']>;
  manzama_rss_url?: Maybe<Scalars['String']['output']>;
  primary_industry?: Maybe<Scalars['String']['output']>;
  status_description?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "mnet.client_intel_settings". */
export type Mnet_Client_Intel_Settings_Order_By = {
  capiq_id?: InputMaybe<Order_By>;
  client_or_related_client_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  duns?: InputMaybe<Order_By>;
  earliest_open_date?: InputMaybe<Order_By>;
  industry_segment?: InputMaybe<Order_By>;
  is_cap_client?: InputMaybe<Order_By>;
  manzama_rss_url?: InputMaybe<Order_By>;
  primary_industry?: InputMaybe<Order_By>;
  status_description?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.client_intel_settings" */
export enum Mnet_Client_Intel_Settings_Select_Column {
  /** column name */
  Capiq_id = 'capiq_id',
  /** column name */
  Client_or_related_client_id = 'client_or_related_client_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Duns = 'duns',
  /** column name */
  Earliest_open_date = 'earliest_open_date',
  /** column name */
  Industry_segment = 'industry_segment',
  /** column name */
  Is_cap_client = 'is_cap_client',
  /** column name */
  Manzama_rss_url = 'manzama_rss_url',
  /** column name */
  Primary_industry = 'primary_industry',
  /** column name */
  Status_description = 'status_description',
  /** column name */
  Updated_at = 'updated_at',
}

/** Streaming cursor of the table "mnet_client_intel_settings" */
export type Mnet_Client_Intel_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Client_Intel_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Client_Intel_Settings_Stream_Cursor_Value_Input = {
  capiq_id?: InputMaybe<Scalars['String']['input']>;
  client_or_related_client_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  duns?: InputMaybe<Scalars['String']['input']>;
  earliest_open_date?: InputMaybe<Scalars['timestamptz']['input']>;
  industry_segment?: InputMaybe<Scalars['String']['input']>;
  is_cap_client?: InputMaybe<Scalars['Boolean']['input']>;
  manzama_rss_url?: InputMaybe<Scalars['String']['input']>;
  primary_industry?: InputMaybe<Scalars['String']['input']>;
  status_description?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "mnet.client_manzama_alert_summary_counts" */
export type Mnet_Client_Manzama_Alert_Summary_Counts = {
  client_number: Scalars['String']['output'];
  count?: Maybe<Scalars['Int']['output']>;
  expires_at: Scalars['timestamp']['output'];
  id: Scalars['Int']['output'];
  related_client_number?: Maybe<Scalars['String']['output']>;
  request_type: Scalars['String']['output'];
};

/** aggregated selection of "mnet.client_manzama_alert_summary_counts" */
export type Mnet_Client_Manzama_Alert_Summary_Counts_Aggregate = {
  aggregate?: Maybe<Mnet_Client_Manzama_Alert_Summary_Counts_Aggregate_Fields>;
  nodes: Array<Mnet_Client_Manzama_Alert_Summary_Counts>;
};

/** aggregate fields of "mnet.client_manzama_alert_summary_counts" */
export type Mnet_Client_Manzama_Alert_Summary_Counts_Aggregate_Fields = {
  avg?: Maybe<Mnet_Client_Manzama_Alert_Summary_Counts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Client_Manzama_Alert_Summary_Counts_Max_Fields>;
  min?: Maybe<Mnet_Client_Manzama_Alert_Summary_Counts_Min_Fields>;
  stddev?: Maybe<Mnet_Client_Manzama_Alert_Summary_Counts_Stddev_Fields>;
  stddev_pop?: Maybe<Mnet_Client_Manzama_Alert_Summary_Counts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mnet_Client_Manzama_Alert_Summary_Counts_Stddev_Samp_Fields>;
  sum?: Maybe<Mnet_Client_Manzama_Alert_Summary_Counts_Sum_Fields>;
  var_pop?: Maybe<Mnet_Client_Manzama_Alert_Summary_Counts_Var_Pop_Fields>;
  var_samp?: Maybe<Mnet_Client_Manzama_Alert_Summary_Counts_Var_Samp_Fields>;
  variance?: Maybe<Mnet_Client_Manzama_Alert_Summary_Counts_Variance_Fields>;
};

/** aggregate fields of "mnet.client_manzama_alert_summary_counts" */
export type Mnet_Client_Manzama_Alert_Summary_Counts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Client_Manzama_Alert_Summary_Counts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mnet_Client_Manzama_Alert_Summary_Counts_Avg_Fields = {
  count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mnet.client_manzama_alert_summary_counts". All fields are combined with a logical 'AND'. */
export type Mnet_Client_Manzama_Alert_Summary_Counts_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Client_Manzama_Alert_Summary_Counts_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Client_Manzama_Alert_Summary_Counts_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Client_Manzama_Alert_Summary_Counts_Bool_Exp>>;
  client_number?: InputMaybe<String_Comparison_Exp>;
  count?: InputMaybe<Int_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  related_client_number?: InputMaybe<String_Comparison_Exp>;
  request_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mnet_Client_Manzama_Alert_Summary_Counts_Max_Fields = {
  client_number?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  related_client_number?: Maybe<Scalars['String']['output']>;
  request_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mnet_Client_Manzama_Alert_Summary_Counts_Min_Fields = {
  client_number?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  related_client_number?: Maybe<Scalars['String']['output']>;
  request_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "mnet.client_manzama_alert_summary_counts". */
export type Mnet_Client_Manzama_Alert_Summary_Counts_Order_By = {
  client_number?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  related_client_number?: InputMaybe<Order_By>;
  request_type?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.client_manzama_alert_summary_counts" */
export enum Mnet_Client_Manzama_Alert_Summary_Counts_Select_Column {
  /** column name */
  Client_number = 'client_number',
  /** column name */
  Count = 'count',
  /** column name */
  Expires_at = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  Related_client_number = 'related_client_number',
  /** column name */
  Request_type = 'request_type',
}

/** aggregate stddev on columns */
export type Mnet_Client_Manzama_Alert_Summary_Counts_Stddev_Fields = {
  count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mnet_Client_Manzama_Alert_Summary_Counts_Stddev_Pop_Fields = {
  count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mnet_Client_Manzama_Alert_Summary_Counts_Stddev_Samp_Fields = {
  count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mnet_client_manzama_alert_summary_counts" */
export type Mnet_Client_Manzama_Alert_Summary_Counts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Client_Manzama_Alert_Summary_Counts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Client_Manzama_Alert_Summary_Counts_Stream_Cursor_Value_Input = {
  client_number?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  expires_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  related_client_number?: InputMaybe<Scalars['String']['input']>;
  request_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Mnet_Client_Manzama_Alert_Summary_Counts_Sum_Fields = {
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Mnet_Client_Manzama_Alert_Summary_Counts_Var_Pop_Fields = {
  count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mnet_Client_Manzama_Alert_Summary_Counts_Var_Samp_Fields = {
  count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mnet_Client_Manzama_Alert_Summary_Counts_Variance_Fields = {
  count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mnet.client_manzama_article" */
export type Mnet_Client_Manzama_Article = {
  article_date?: Maybe<Scalars['timestamptz']['output']>;
  article_url?: Maybe<Scalars['String']['output']>;
  category_name: Scalars['citext']['output'];
  client_number: Scalars['citext']['output'];
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  factor?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  item_json?: Maybe<Scalars['jsonb']['output']>;
  pub_type?: Maybe<Scalars['String']['output']>;
  related_client_number?: Maybe<Scalars['citext']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subfactor?: Maybe<Scalars['String']['output']>;
  title: Scalars['citext']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "mnet.client_manzama_article" */
export type Mnet_Client_Manzama_ArticleItem_JsonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "mnet.client_manzama_article" */
export type Mnet_Client_Manzama_Article_Aggregate = {
  aggregate?: Maybe<Mnet_Client_Manzama_Article_Aggregate_Fields>;
  nodes: Array<Mnet_Client_Manzama_Article>;
};

/** aggregate fields of "mnet.client_manzama_article" */
export type Mnet_Client_Manzama_Article_Aggregate_Fields = {
  avg?: Maybe<Mnet_Client_Manzama_Article_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Client_Manzama_Article_Max_Fields>;
  min?: Maybe<Mnet_Client_Manzama_Article_Min_Fields>;
  stddev?: Maybe<Mnet_Client_Manzama_Article_Stddev_Fields>;
  stddev_pop?: Maybe<Mnet_Client_Manzama_Article_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mnet_Client_Manzama_Article_Stddev_Samp_Fields>;
  sum?: Maybe<Mnet_Client_Manzama_Article_Sum_Fields>;
  var_pop?: Maybe<Mnet_Client_Manzama_Article_Var_Pop_Fields>;
  var_samp?: Maybe<Mnet_Client_Manzama_Article_Var_Samp_Fields>;
  variance?: Maybe<Mnet_Client_Manzama_Article_Variance_Fields>;
};

/** aggregate fields of "mnet.client_manzama_article" */
export type Mnet_Client_Manzama_Article_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Client_Manzama_Article_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mnet_Client_Manzama_Article_Avg_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mnet.client_manzama_article". All fields are combined with a logical 'AND'. */
export type Mnet_Client_Manzama_Article_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Client_Manzama_Article_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Client_Manzama_Article_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Client_Manzama_Article_Bool_Exp>>;
  article_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  article_url?: InputMaybe<String_Comparison_Exp>;
  category_name?: InputMaybe<Citext_Comparison_Exp>;
  client_number?: InputMaybe<Citext_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  factor?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  item_json?: InputMaybe<Jsonb_Comparison_Exp>;
  pub_type?: InputMaybe<String_Comparison_Exp>;
  related_client_number?: InputMaybe<Citext_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  subfactor?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<Citext_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "mnet.client_manzama_article_category" */
export type Mnet_Client_Manzama_Article_Category = {
  category_name: Scalars['citext']['output'];
  client_number: Scalars['citext']['output'];
  count: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  related_client_number?: Maybe<Scalars['citext']['output']>;
  title: Scalars['citext']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "mnet.client_manzama_article_category" */
export type Mnet_Client_Manzama_Article_Category_Aggregate = {
  aggregate?: Maybe<Mnet_Client_Manzama_Article_Category_Aggregate_Fields>;
  nodes: Array<Mnet_Client_Manzama_Article_Category>;
};

/** aggregate fields of "mnet.client_manzama_article_category" */
export type Mnet_Client_Manzama_Article_Category_Aggregate_Fields = {
  avg?: Maybe<Mnet_Client_Manzama_Article_Category_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Client_Manzama_Article_Category_Max_Fields>;
  min?: Maybe<Mnet_Client_Manzama_Article_Category_Min_Fields>;
  stddev?: Maybe<Mnet_Client_Manzama_Article_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Mnet_Client_Manzama_Article_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mnet_Client_Manzama_Article_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Mnet_Client_Manzama_Article_Category_Sum_Fields>;
  var_pop?: Maybe<Mnet_Client_Manzama_Article_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Mnet_Client_Manzama_Article_Category_Var_Samp_Fields>;
  variance?: Maybe<Mnet_Client_Manzama_Article_Category_Variance_Fields>;
};

/** aggregate fields of "mnet.client_manzama_article_category" */
export type Mnet_Client_Manzama_Article_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Client_Manzama_Article_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mnet_Client_Manzama_Article_Category_Avg_Fields = {
  count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mnet.client_manzama_article_category". All fields are combined with a logical 'AND'. */
export type Mnet_Client_Manzama_Article_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Client_Manzama_Article_Category_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Client_Manzama_Article_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Client_Manzama_Article_Category_Bool_Exp>>;
  category_name?: InputMaybe<Citext_Comparison_Exp>;
  client_number?: InputMaybe<Citext_Comparison_Exp>;
  count?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  related_client_number?: InputMaybe<Citext_Comparison_Exp>;
  title?: InputMaybe<Citext_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mnet_Client_Manzama_Article_Category_Max_Fields = {
  category_name?: Maybe<Scalars['citext']['output']>;
  client_number?: Maybe<Scalars['citext']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  related_client_number?: Maybe<Scalars['citext']['output']>;
  title?: Maybe<Scalars['citext']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Mnet_Client_Manzama_Article_Category_Min_Fields = {
  category_name?: Maybe<Scalars['citext']['output']>;
  client_number?: Maybe<Scalars['citext']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  related_client_number?: Maybe<Scalars['citext']['output']>;
  title?: Maybe<Scalars['citext']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "mnet.client_manzama_article_category". */
export type Mnet_Client_Manzama_Article_Category_Order_By = {
  category_name?: InputMaybe<Order_By>;
  client_number?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  related_client_number?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.client_manzama_article_category" */
export enum Mnet_Client_Manzama_Article_Category_Select_Column {
  /** column name */
  Category_name = 'category_name',
  /** column name */
  Client_number = 'client_number',
  /** column name */
  Count = 'count',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Related_client_number = 'related_client_number',
  /** column name */
  Title = 'title',
  /** column name */
  Updated_at = 'updated_at',
}

/** aggregate stddev on columns */
export type Mnet_Client_Manzama_Article_Category_Stddev_Fields = {
  count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mnet_Client_Manzama_Article_Category_Stddev_Pop_Fields = {
  count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mnet_Client_Manzama_Article_Category_Stddev_Samp_Fields = {
  count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mnet_client_manzama_article_category" */
export type Mnet_Client_Manzama_Article_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Client_Manzama_Article_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Client_Manzama_Article_Category_Stream_Cursor_Value_Input = {
  category_name?: InputMaybe<Scalars['citext']['input']>;
  client_number?: InputMaybe<Scalars['citext']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  related_client_number?: InputMaybe<Scalars['citext']['input']>;
  title?: InputMaybe<Scalars['citext']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Mnet_Client_Manzama_Article_Category_Sum_Fields = {
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Mnet_Client_Manzama_Article_Category_Var_Pop_Fields = {
  count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mnet_Client_Manzama_Article_Category_Var_Samp_Fields = {
  count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mnet_Client_Manzama_Article_Category_Variance_Fields = {
  count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type Mnet_Client_Manzama_Article_Max_Fields = {
  article_date?: Maybe<Scalars['timestamptz']['output']>;
  article_url?: Maybe<Scalars['String']['output']>;
  category_name?: Maybe<Scalars['citext']['output']>;
  client_number?: Maybe<Scalars['citext']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  factor?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  pub_type?: Maybe<Scalars['String']['output']>;
  related_client_number?: Maybe<Scalars['citext']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subfactor?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['citext']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Mnet_Client_Manzama_Article_Min_Fields = {
  article_date?: Maybe<Scalars['timestamptz']['output']>;
  article_url?: Maybe<Scalars['String']['output']>;
  category_name?: Maybe<Scalars['citext']['output']>;
  client_number?: Maybe<Scalars['citext']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  factor?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  pub_type?: Maybe<Scalars['String']['output']>;
  related_client_number?: Maybe<Scalars['citext']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subfactor?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['citext']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "mnet.client_manzama_article". */
export type Mnet_Client_Manzama_Article_Order_By = {
  article_date?: InputMaybe<Order_By>;
  article_url?: InputMaybe<Order_By>;
  category_name?: InputMaybe<Order_By>;
  client_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  factor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  item_json?: InputMaybe<Order_By>;
  pub_type?: InputMaybe<Order_By>;
  related_client_number?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  subfactor?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.client_manzama_article" */
export enum Mnet_Client_Manzama_Article_Select_Column {
  /** column name */
  Article_date = 'article_date',
  /** column name */
  Article_url = 'article_url',
  /** column name */
  Category_name = 'category_name',
  /** column name */
  Client_number = 'client_number',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Factor = 'factor',
  /** column name */
  Id = 'id',
  /** column name */
  Item_json = 'item_json',
  /** column name */
  Pub_type = 'pub_type',
  /** column name */
  Related_client_number = 'related_client_number',
  /** column name */
  Source = 'source',
  /** column name */
  Subfactor = 'subfactor',
  /** column name */
  Title = 'title',
  /** column name */
  Updated_at = 'updated_at',
}

/** aggregate stddev on columns */
export type Mnet_Client_Manzama_Article_Stddev_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mnet_Client_Manzama_Article_Stddev_Pop_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mnet_Client_Manzama_Article_Stddev_Samp_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mnet_client_manzama_article" */
export type Mnet_Client_Manzama_Article_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Client_Manzama_Article_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Client_Manzama_Article_Stream_Cursor_Value_Input = {
  article_date?: InputMaybe<Scalars['timestamptz']['input']>;
  article_url?: InputMaybe<Scalars['String']['input']>;
  category_name?: InputMaybe<Scalars['citext']['input']>;
  client_number?: InputMaybe<Scalars['citext']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  factor?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  item_json?: InputMaybe<Scalars['jsonb']['input']>;
  pub_type?: InputMaybe<Scalars['String']['input']>;
  related_client_number?: InputMaybe<Scalars['citext']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  subfactor?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['citext']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Mnet_Client_Manzama_Article_Sum_Fields = {
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Mnet_Client_Manzama_Article_Var_Pop_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mnet_Client_Manzama_Article_Var_Samp_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mnet_Client_Manzama_Article_Variance_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mnet.client_manzama_http_response" */
export type Mnet_Client_Manzama_Http_Response = {
  category?: Maybe<Scalars['String']['output']>;
  client_number: Scalars['String']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  duns?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['timestamp']['output']>;
  facet?: Maybe<Scalars['String']['output']>;
  factor?: Maybe<Scalars['String']['output']>;
  http_status_code?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  last_accessed_at?: Maybe<Scalars['timestamp']['output']>;
  number_times_accessed?: Maybe<Scalars['Int']['output']>;
  pub_type?: Maybe<Scalars['String']['output']>;
  related_client_number?: Maybe<Scalars['String']['output']>;
  request_type?: Maybe<Scalars['String']['output']>;
  response_body: Scalars['String']['output'];
  subfactor?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

/** aggregated selection of "mnet.client_manzama_http_response" */
export type Mnet_Client_Manzama_Http_Response_Aggregate = {
  aggregate?: Maybe<Mnet_Client_Manzama_Http_Response_Aggregate_Fields>;
  nodes: Array<Mnet_Client_Manzama_Http_Response>;
};

/** aggregate fields of "mnet.client_manzama_http_response" */
export type Mnet_Client_Manzama_Http_Response_Aggregate_Fields = {
  avg?: Maybe<Mnet_Client_Manzama_Http_Response_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Client_Manzama_Http_Response_Max_Fields>;
  min?: Maybe<Mnet_Client_Manzama_Http_Response_Min_Fields>;
  stddev?: Maybe<Mnet_Client_Manzama_Http_Response_Stddev_Fields>;
  stddev_pop?: Maybe<Mnet_Client_Manzama_Http_Response_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mnet_Client_Manzama_Http_Response_Stddev_Samp_Fields>;
  sum?: Maybe<Mnet_Client_Manzama_Http_Response_Sum_Fields>;
  var_pop?: Maybe<Mnet_Client_Manzama_Http_Response_Var_Pop_Fields>;
  var_samp?: Maybe<Mnet_Client_Manzama_Http_Response_Var_Samp_Fields>;
  variance?: Maybe<Mnet_Client_Manzama_Http_Response_Variance_Fields>;
};

/** aggregate fields of "mnet.client_manzama_http_response" */
export type Mnet_Client_Manzama_Http_Response_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Client_Manzama_Http_Response_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mnet_Client_Manzama_Http_Response_Avg_Fields = {
  http_status_code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  number_times_accessed?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mnet.client_manzama_http_response". All fields are combined with a logical 'AND'. */
export type Mnet_Client_Manzama_Http_Response_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Client_Manzama_Http_Response_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Client_Manzama_Http_Response_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Client_Manzama_Http_Response_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  client_number?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  duns?: InputMaybe<String_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamp_Comparison_Exp>;
  facet?: InputMaybe<String_Comparison_Exp>;
  factor?: InputMaybe<String_Comparison_Exp>;
  http_status_code?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  last_accessed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  number_times_accessed?: InputMaybe<Int_Comparison_Exp>;
  pub_type?: InputMaybe<String_Comparison_Exp>;
  related_client_number?: InputMaybe<String_Comparison_Exp>;
  request_type?: InputMaybe<String_Comparison_Exp>;
  response_body?: InputMaybe<String_Comparison_Exp>;
  subfactor?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mnet_Client_Manzama_Http_Response_Max_Fields = {
  category?: Maybe<Scalars['String']['output']>;
  client_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  duns?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['timestamp']['output']>;
  facet?: Maybe<Scalars['String']['output']>;
  factor?: Maybe<Scalars['String']['output']>;
  http_status_code?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_accessed_at?: Maybe<Scalars['timestamp']['output']>;
  number_times_accessed?: Maybe<Scalars['Int']['output']>;
  pub_type?: Maybe<Scalars['String']['output']>;
  related_client_number?: Maybe<Scalars['String']['output']>;
  request_type?: Maybe<Scalars['String']['output']>;
  response_body?: Maybe<Scalars['String']['output']>;
  subfactor?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mnet_Client_Manzama_Http_Response_Min_Fields = {
  category?: Maybe<Scalars['String']['output']>;
  client_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  duns?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['timestamp']['output']>;
  facet?: Maybe<Scalars['String']['output']>;
  factor?: Maybe<Scalars['String']['output']>;
  http_status_code?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_accessed_at?: Maybe<Scalars['timestamp']['output']>;
  number_times_accessed?: Maybe<Scalars['Int']['output']>;
  pub_type?: Maybe<Scalars['String']['output']>;
  related_client_number?: Maybe<Scalars['String']['output']>;
  request_type?: Maybe<Scalars['String']['output']>;
  response_body?: Maybe<Scalars['String']['output']>;
  subfactor?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "mnet.client_manzama_http_response". */
export type Mnet_Client_Manzama_Http_Response_Order_By = {
  category?: InputMaybe<Order_By>;
  client_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  duns?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  facet?: InputMaybe<Order_By>;
  factor?: InputMaybe<Order_By>;
  http_status_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_accessed_at?: InputMaybe<Order_By>;
  number_times_accessed?: InputMaybe<Order_By>;
  pub_type?: InputMaybe<Order_By>;
  related_client_number?: InputMaybe<Order_By>;
  request_type?: InputMaybe<Order_By>;
  response_body?: InputMaybe<Order_By>;
  subfactor?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.client_manzama_http_response" */
export enum Mnet_Client_Manzama_Http_Response_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Client_number = 'client_number',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Duns = 'duns',
  /** column name */
  Expires_at = 'expires_at',
  /** column name */
  Facet = 'facet',
  /** column name */
  Factor = 'factor',
  /** column name */
  Http_status_code = 'http_status_code',
  /** column name */
  Id = 'id',
  /** column name */
  Last_accessed_at = 'last_accessed_at',
  /** column name */
  Number_times_accessed = 'number_times_accessed',
  /** column name */
  Pub_type = 'pub_type',
  /** column name */
  Related_client_number = 'related_client_number',
  /** column name */
  Request_type = 'request_type',
  /** column name */
  Response_body = 'response_body',
  /** column name */
  Subfactor = 'subfactor',
  /** column name */
  Url = 'url',
}

/** aggregate stddev on columns */
export type Mnet_Client_Manzama_Http_Response_Stddev_Fields = {
  http_status_code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  number_times_accessed?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mnet_Client_Manzama_Http_Response_Stddev_Pop_Fields = {
  http_status_code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  number_times_accessed?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mnet_Client_Manzama_Http_Response_Stddev_Samp_Fields = {
  http_status_code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  number_times_accessed?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mnet_client_manzama_http_response" */
export type Mnet_Client_Manzama_Http_Response_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Client_Manzama_Http_Response_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Client_Manzama_Http_Response_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  client_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  duns?: InputMaybe<Scalars['String']['input']>;
  expires_at?: InputMaybe<Scalars['timestamp']['input']>;
  facet?: InputMaybe<Scalars['String']['input']>;
  factor?: InputMaybe<Scalars['String']['input']>;
  http_status_code?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  last_accessed_at?: InputMaybe<Scalars['timestamp']['input']>;
  number_times_accessed?: InputMaybe<Scalars['Int']['input']>;
  pub_type?: InputMaybe<Scalars['String']['input']>;
  related_client_number?: InputMaybe<Scalars['String']['input']>;
  request_type?: InputMaybe<Scalars['String']['input']>;
  response_body?: InputMaybe<Scalars['String']['input']>;
  subfactor?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Mnet_Client_Manzama_Http_Response_Sum_Fields = {
  http_status_code?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  number_times_accessed?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Mnet_Client_Manzama_Http_Response_Var_Pop_Fields = {
  http_status_code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  number_times_accessed?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mnet_Client_Manzama_Http_Response_Var_Samp_Fields = {
  http_status_code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  number_times_accessed?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mnet_Client_Manzama_Http_Response_Variance_Fields = {
  http_status_code?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  number_times_accessed?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_Badge = {
  category_id: Scalars['uuid']['output'];
  /** An object relationship */
  clientbadge_badge_category: Mnet_Clientbadge_Badge_Category;
  /** An array relationship */
  clientbadge_client_exclusions: Array<Mnet_Clientbadge_Client_Exclusion>;
  /** An aggregate relationship */
  clientbadge_client_exclusions_aggregate: Mnet_Clientbadge_Client_Exclusion_Aggregate;
  /** An array relationship */
  clientbadge_clients: Array<Mnet_Clientbadge_Client>;
  /** An aggregate relationship */
  clientbadge_clients_aggregate: Mnet_Clientbadge_Client_Aggregate;
  /** An array relationship */
  clientbadge_related_clients: Array<Mnet_Clientbadge_Related_Client>;
  /** An aggregate relationship */
  clientbadge_related_clients_aggregate: Mnet_Clientbadge_Related_Client_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  is_default: Scalars['Boolean']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_BadgeClientbadge_Client_ExclusionsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Client_Exclusion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Client_Exclusion_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Client_Exclusion_Bool_Exp>;
};

/** columns and relationships of "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_BadgeClientbadge_Client_Exclusions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Client_Exclusion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Client_Exclusion_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Client_Exclusion_Bool_Exp>;
};

/** columns and relationships of "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_BadgeClientbadge_ClientsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Client_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Client_Bool_Exp>;
};

/** columns and relationships of "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_BadgeClientbadge_Clients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Client_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Client_Bool_Exp>;
};

/** columns and relationships of "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_BadgeClientbadge_Related_ClientsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Related_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Related_Client_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Related_Client_Bool_Exp>;
};

/** columns and relationships of "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_BadgeClientbadge_Related_Clients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Related_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Related_Client_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Related_Client_Bool_Exp>;
};

/** aggregated selection of "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_Badge_Aggregate = {
  aggregate?: Maybe<Mnet_Clientbadge_Badge_Aggregate_Fields>;
  nodes: Array<Mnet_Clientbadge_Badge>;
};

export type Mnet_Clientbadge_Badge_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Mnet_Clientbadge_Badge_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Mnet_Clientbadge_Badge_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Mnet_Clientbadge_Badge_Aggregate_Bool_Exp_Count>;
};

export type Mnet_Clientbadge_Badge_Aggregate_Bool_Exp_Bool_And = {
  arguments: Mnet_Clientbadge_Badge_Select_Column_Mnet_Clientbadge_Badge_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Clientbadge_Badge_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Mnet_Clientbadge_Badge_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Mnet_Clientbadge_Badge_Select_Column_Mnet_Clientbadge_Badge_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Clientbadge_Badge_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Mnet_Clientbadge_Badge_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mnet_Clientbadge_Badge_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Clientbadge_Badge_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_Badge_Aggregate_Fields = {
  avg?: Maybe<Mnet_Clientbadge_Badge_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Clientbadge_Badge_Max_Fields>;
  min?: Maybe<Mnet_Clientbadge_Badge_Min_Fields>;
  stddev?: Maybe<Mnet_Clientbadge_Badge_Stddev_Fields>;
  stddev_pop?: Maybe<Mnet_Clientbadge_Badge_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mnet_Clientbadge_Badge_Stddev_Samp_Fields>;
  sum?: Maybe<Mnet_Clientbadge_Badge_Sum_Fields>;
  var_pop?: Maybe<Mnet_Clientbadge_Badge_Var_Pop_Fields>;
  var_samp?: Maybe<Mnet_Clientbadge_Badge_Var_Samp_Fields>;
  variance?: Maybe<Mnet_Clientbadge_Badge_Variance_Fields>;
};

/** aggregate fields of "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_Badge_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Clientbadge_Badge_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_Badge_Aggregate_Order_By = {
  avg?: InputMaybe<Mnet_Clientbadge_Badge_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Clientbadge_Badge_Max_Order_By>;
  min?: InputMaybe<Mnet_Clientbadge_Badge_Min_Order_By>;
  stddev?: InputMaybe<Mnet_Clientbadge_Badge_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mnet_Clientbadge_Badge_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mnet_Clientbadge_Badge_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mnet_Clientbadge_Badge_Sum_Order_By>;
  var_pop?: InputMaybe<Mnet_Clientbadge_Badge_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mnet_Clientbadge_Badge_Var_Samp_Order_By>;
  variance?: InputMaybe<Mnet_Clientbadge_Badge_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Mnet_Clientbadge_Badge_Avg_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_Badge_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mnet.clientbadge_badge". All fields are combined with a logical 'AND'. */
export type Mnet_Clientbadge_Badge_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Clientbadge_Badge_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Clientbadge_Badge_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Clientbadge_Badge_Bool_Exp>>;
  category_id?: InputMaybe<Uuid_Comparison_Exp>;
  clientbadge_badge_category?: InputMaybe<Mnet_Clientbadge_Badge_Category_Bool_Exp>;
  clientbadge_client_exclusions?: InputMaybe<Mnet_Clientbadge_Client_Exclusion_Bool_Exp>;
  clientbadge_client_exclusions_aggregate?: InputMaybe<Mnet_Clientbadge_Client_Exclusion_Aggregate_Bool_Exp>;
  clientbadge_clients?: InputMaybe<Mnet_Clientbadge_Client_Bool_Exp>;
  clientbadge_clients_aggregate?: InputMaybe<Mnet_Clientbadge_Client_Aggregate_Bool_Exp>;
  clientbadge_related_clients?: InputMaybe<Mnet_Clientbadge_Related_Client_Bool_Exp>;
  clientbadge_related_clients_aggregate?: InputMaybe<Mnet_Clientbadge_Related_Client_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "mnet.clientbadge_badge_category" */
export type Mnet_Clientbadge_Badge_Category = {
  /** An array relationship */
  clientbadge_badges: Array<Mnet_Clientbadge_Badge>;
  /** An aggregate relationship */
  clientbadge_badges_aggregate: Mnet_Clientbadge_Badge_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  inherit_rc_badge: Scalars['Boolean']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  override_rc_badge: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "mnet.clientbadge_badge_category" */
export type Mnet_Clientbadge_Badge_CategoryClientbadge_BadgesArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Badge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Badge_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Badge_Bool_Exp>;
};

/** columns and relationships of "mnet.clientbadge_badge_category" */
export type Mnet_Clientbadge_Badge_CategoryClientbadge_Badges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Badge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Badge_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Badge_Bool_Exp>;
};

/** aggregated selection of "mnet.clientbadge_badge_category" */
export type Mnet_Clientbadge_Badge_Category_Aggregate = {
  aggregate?: Maybe<Mnet_Clientbadge_Badge_Category_Aggregate_Fields>;
  nodes: Array<Mnet_Clientbadge_Badge_Category>;
};

/** aggregate fields of "mnet.clientbadge_badge_category" */
export type Mnet_Clientbadge_Badge_Category_Aggregate_Fields = {
  avg?: Maybe<Mnet_Clientbadge_Badge_Category_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Clientbadge_Badge_Category_Max_Fields>;
  min?: Maybe<Mnet_Clientbadge_Badge_Category_Min_Fields>;
  stddev?: Maybe<Mnet_Clientbadge_Badge_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Mnet_Clientbadge_Badge_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mnet_Clientbadge_Badge_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Mnet_Clientbadge_Badge_Category_Sum_Fields>;
  var_pop?: Maybe<Mnet_Clientbadge_Badge_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Mnet_Clientbadge_Badge_Category_Var_Samp_Fields>;
  variance?: Maybe<Mnet_Clientbadge_Badge_Category_Variance_Fields>;
};

/** aggregate fields of "mnet.clientbadge_badge_category" */
export type Mnet_Clientbadge_Badge_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Clientbadge_Badge_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mnet_Clientbadge_Badge_Category_Avg_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mnet.clientbadge_badge_category". All fields are combined with a logical 'AND'. */
export type Mnet_Clientbadge_Badge_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Clientbadge_Badge_Category_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Clientbadge_Badge_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Clientbadge_Badge_Category_Bool_Exp>>;
  clientbadge_badges?: InputMaybe<Mnet_Clientbadge_Badge_Bool_Exp>;
  clientbadge_badges_aggregate?: InputMaybe<Mnet_Clientbadge_Badge_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inherit_rc_badge?: InputMaybe<Boolean_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  override_rc_badge?: InputMaybe<Boolean_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mnet_Clientbadge_Badge_Category_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Mnet_Clientbadge_Badge_Category_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "mnet.clientbadge_badge_category". */
export type Mnet_Clientbadge_Badge_Category_Order_By = {
  clientbadge_badges_aggregate?: InputMaybe<Mnet_Clientbadge_Badge_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inherit_rc_badge?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  override_rc_badge?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.clientbadge_badge_category" */
export enum Mnet_Clientbadge_Badge_Category_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Inherit_rc_badge = 'inherit_rc_badge',
  /** column name */
  Order = 'order',
  /** column name */
  Override_rc_badge = 'override_rc_badge',
  /** column name */
  Title = 'title',
  /** column name */
  Updated_at = 'updated_at',
}

/** aggregate stddev on columns */
export type Mnet_Clientbadge_Badge_Category_Stddev_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mnet_Clientbadge_Badge_Category_Stddev_Pop_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mnet_Clientbadge_Badge_Category_Stddev_Samp_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mnet_clientbadge_badge_category" */
export type Mnet_Clientbadge_Badge_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Clientbadge_Badge_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Clientbadge_Badge_Category_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inherit_rc_badge?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  override_rc_badge?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Mnet_Clientbadge_Badge_Category_Sum_Fields = {
  order?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Mnet_Clientbadge_Badge_Category_Var_Pop_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mnet_Clientbadge_Badge_Category_Var_Samp_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mnet_Clientbadge_Badge_Category_Variance_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type Mnet_Clientbadge_Badge_Max_Fields = {
  category_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_Badge_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mnet_Clientbadge_Badge_Min_Fields = {
  category_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_Badge_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mnet.clientbadge_badge". */
export type Mnet_Clientbadge_Badge_Order_By = {
  category_id?: InputMaybe<Order_By>;
  clientbadge_badge_category?: InputMaybe<Mnet_Clientbadge_Badge_Category_Order_By>;
  clientbadge_client_exclusions_aggregate?: InputMaybe<Mnet_Clientbadge_Client_Exclusion_Aggregate_Order_By>;
  clientbadge_clients_aggregate?: InputMaybe<Mnet_Clientbadge_Client_Aggregate_Order_By>;
  clientbadge_related_clients_aggregate?: InputMaybe<Mnet_Clientbadge_Related_Client_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_default?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.clientbadge_badge" */
export enum Mnet_Clientbadge_Badge_Select_Column {
  /** column name */
  Category_id = 'category_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Image_url = 'image_url',
  /** column name */
  Is_active = 'is_active',
  /** column name */
  Is_default = 'is_default',
  /** column name */
  Order = 'order',
  /** column name */
  Title = 'title',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Url = 'url',
}

/** select "mnet_clientbadge_badge_aggregate_bool_exp_bool_and_arguments_columns" columns of table "mnet.clientbadge_badge" */
export enum Mnet_Clientbadge_Badge_Select_Column_Mnet_Clientbadge_Badge_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Is_active = 'is_active',
  /** column name */
  Is_default = 'is_default',
}

/** select "mnet_clientbadge_badge_aggregate_bool_exp_bool_or_arguments_columns" columns of table "mnet.clientbadge_badge" */
export enum Mnet_Clientbadge_Badge_Select_Column_Mnet_Clientbadge_Badge_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Is_active = 'is_active',
  /** column name */
  Is_default = 'is_default',
}

/** aggregate stddev on columns */
export type Mnet_Clientbadge_Badge_Stddev_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_Badge_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mnet_Clientbadge_Badge_Stddev_Pop_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_Badge_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mnet_Clientbadge_Badge_Stddev_Samp_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_Badge_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mnet_clientbadge_badge" */
export type Mnet_Clientbadge_Badge_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Clientbadge_Badge_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Clientbadge_Badge_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Mnet_Clientbadge_Badge_Sum_Fields = {
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_Badge_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Mnet_Clientbadge_Badge_Var_Pop_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_Badge_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mnet_Clientbadge_Badge_Var_Samp_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_Badge_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mnet_Clientbadge_Badge_Variance_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "mnet.clientbadge_badge" */
export type Mnet_Clientbadge_Badge_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "mnet.clientbadge_client" */
export type Mnet_Clientbadge_Client = {
  Client?: Maybe<Mlfsl_Client>;
  badge_id: Scalars['uuid']['output'];
  client_number: Scalars['String']['output'];
  /** An object relationship */
  clientbadge_badge: Mnet_Clientbadge_Badge;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "mnet.clientbadge_client" */
export type Mnet_Clientbadge_Client_Aggregate = {
  aggregate?: Maybe<Mnet_Clientbadge_Client_Aggregate_Fields>;
  nodes: Array<Mnet_Clientbadge_Client>;
};

export type Mnet_Clientbadge_Client_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Mnet_Clientbadge_Client_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Mnet_Clientbadge_Client_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Mnet_Clientbadge_Client_Aggregate_Bool_Exp_Count>;
};

export type Mnet_Clientbadge_Client_Aggregate_Bool_Exp_Bool_And = {
  arguments: Mnet_Clientbadge_Client_Select_Column_Mnet_Clientbadge_Client_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Clientbadge_Client_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Mnet_Clientbadge_Client_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Mnet_Clientbadge_Client_Select_Column_Mnet_Clientbadge_Client_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Clientbadge_Client_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Mnet_Clientbadge_Client_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mnet_Clientbadge_Client_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Clientbadge_Client_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mnet.clientbadge_client" */
export type Mnet_Clientbadge_Client_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Clientbadge_Client_Max_Fields>;
  min?: Maybe<Mnet_Clientbadge_Client_Min_Fields>;
};

/** aggregate fields of "mnet.clientbadge_client" */
export type Mnet_Clientbadge_Client_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Clientbadge_Client_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mnet.clientbadge_client" */
export type Mnet_Clientbadge_Client_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Clientbadge_Client_Max_Order_By>;
  min?: InputMaybe<Mnet_Clientbadge_Client_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "mnet.clientbadge_client". All fields are combined with a logical 'AND'. */
export type Mnet_Clientbadge_Client_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Clientbadge_Client_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Clientbadge_Client_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Clientbadge_Client_Bool_Exp>>;
  badge_id?: InputMaybe<Uuid_Comparison_Exp>;
  client_number?: InputMaybe<String_Comparison_Exp>;
  clientbadge_badge?: InputMaybe<Mnet_Clientbadge_Badge_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "mnet.clientbadge_client_exclusion" */
export type Mnet_Clientbadge_Client_Exclusion = {
  Client?: Maybe<Mlfsl_Client>;
  badge_id: Scalars['uuid']['output'];
  client_number: Scalars['String']['output'];
  /** An object relationship */
  clientbadge_badge: Mnet_Clientbadge_Badge;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "mnet.clientbadge_client_exclusion" */
export type Mnet_Clientbadge_Client_Exclusion_Aggregate = {
  aggregate?: Maybe<Mnet_Clientbadge_Client_Exclusion_Aggregate_Fields>;
  nodes: Array<Mnet_Clientbadge_Client_Exclusion>;
};

export type Mnet_Clientbadge_Client_Exclusion_Aggregate_Bool_Exp = {
  count?: InputMaybe<Mnet_Clientbadge_Client_Exclusion_Aggregate_Bool_Exp_Count>;
};

export type Mnet_Clientbadge_Client_Exclusion_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mnet_Clientbadge_Client_Exclusion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Clientbadge_Client_Exclusion_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mnet.clientbadge_client_exclusion" */
export type Mnet_Clientbadge_Client_Exclusion_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Clientbadge_Client_Exclusion_Max_Fields>;
  min?: Maybe<Mnet_Clientbadge_Client_Exclusion_Min_Fields>;
};

/** aggregate fields of "mnet.clientbadge_client_exclusion" */
export type Mnet_Clientbadge_Client_Exclusion_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Clientbadge_Client_Exclusion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mnet.clientbadge_client_exclusion" */
export type Mnet_Clientbadge_Client_Exclusion_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Clientbadge_Client_Exclusion_Max_Order_By>;
  min?: InputMaybe<Mnet_Clientbadge_Client_Exclusion_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "mnet.clientbadge_client_exclusion". All fields are combined with a logical 'AND'. */
export type Mnet_Clientbadge_Client_Exclusion_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Clientbadge_Client_Exclusion_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Clientbadge_Client_Exclusion_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Clientbadge_Client_Exclusion_Bool_Exp>>;
  badge_id?: InputMaybe<Uuid_Comparison_Exp>;
  client_number?: InputMaybe<String_Comparison_Exp>;
  clientbadge_badge?: InputMaybe<Mnet_Clientbadge_Badge_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mnet_Clientbadge_Client_Exclusion_Max_Fields = {
  badge_id?: Maybe<Scalars['uuid']['output']>;
  client_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "mnet.clientbadge_client_exclusion" */
export type Mnet_Clientbadge_Client_Exclusion_Max_Order_By = {
  badge_id?: InputMaybe<Order_By>;
  client_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mnet_Clientbadge_Client_Exclusion_Min_Fields = {
  badge_id?: Maybe<Scalars['uuid']['output']>;
  client_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "mnet.clientbadge_client_exclusion" */
export type Mnet_Clientbadge_Client_Exclusion_Min_Order_By = {
  badge_id?: InputMaybe<Order_By>;
  client_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mnet.clientbadge_client_exclusion". */
export type Mnet_Clientbadge_Client_Exclusion_Order_By = {
  badge_id?: InputMaybe<Order_By>;
  client_number?: InputMaybe<Order_By>;
  clientbadge_badge?: InputMaybe<Mnet_Clientbadge_Badge_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.clientbadge_client_exclusion" */
export enum Mnet_Clientbadge_Client_Exclusion_Select_Column {
  /** column name */
  Badge_id = 'badge_id',
  /** column name */
  Client_number = 'client_number',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Updated_at = 'updated_at',
}

/** Streaming cursor of the table "mnet_clientbadge_client_exclusion" */
export type Mnet_Clientbadge_Client_Exclusion_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Clientbadge_Client_Exclusion_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Clientbadge_Client_Exclusion_Stream_Cursor_Value_Input = {
  badge_id?: InputMaybe<Scalars['uuid']['input']>;
  client_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Mnet_Clientbadge_Client_Max_Fields = {
  badge_id?: Maybe<Scalars['uuid']['output']>;
  client_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "mnet.clientbadge_client" */
export type Mnet_Clientbadge_Client_Max_Order_By = {
  badge_id?: InputMaybe<Order_By>;
  client_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mnet_Clientbadge_Client_Min_Fields = {
  badge_id?: Maybe<Scalars['uuid']['output']>;
  client_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "mnet.clientbadge_client" */
export type Mnet_Clientbadge_Client_Min_Order_By = {
  badge_id?: InputMaybe<Order_By>;
  client_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mnet.clientbadge_client". */
export type Mnet_Clientbadge_Client_Order_By = {
  badge_id?: InputMaybe<Order_By>;
  client_number?: InputMaybe<Order_By>;
  clientbadge_badge?: InputMaybe<Mnet_Clientbadge_Badge_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.clientbadge_client" */
export enum Mnet_Clientbadge_Client_Select_Column {
  /** column name */
  Badge_id = 'badge_id',
  /** column name */
  Client_number = 'client_number',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Is_active = 'is_active',
  /** column name */
  Updated_at = 'updated_at',
}

/** select "mnet_clientbadge_client_aggregate_bool_exp_bool_and_arguments_columns" columns of table "mnet.clientbadge_client" */
export enum Mnet_Clientbadge_Client_Select_Column_Mnet_Clientbadge_Client_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Is_active = 'is_active',
}

/** select "mnet_clientbadge_client_aggregate_bool_exp_bool_or_arguments_columns" columns of table "mnet.clientbadge_client" */
export enum Mnet_Clientbadge_Client_Select_Column_Mnet_Clientbadge_Client_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Is_active = 'is_active',
}

/** Streaming cursor of the table "mnet_clientbadge_client" */
export type Mnet_Clientbadge_Client_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Clientbadge_Client_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Clientbadge_Client_Stream_Cursor_Value_Input = {
  badge_id?: InputMaybe<Scalars['uuid']['input']>;
  client_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "mnet.clientbadge_related_client" */
export type Mnet_Clientbadge_Related_Client = {
  RelatedClient?: Maybe<Mlfsl_Related_Client>;
  badge_id: Scalars['uuid']['output'];
  /** An object relationship */
  clientbadge_badge: Mnet_Clientbadge_Badge;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  related_client_number: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "mnet.clientbadge_related_client" */
export type Mnet_Clientbadge_Related_Client_Aggregate = {
  aggregate?: Maybe<Mnet_Clientbadge_Related_Client_Aggregate_Fields>;
  nodes: Array<Mnet_Clientbadge_Related_Client>;
};

export type Mnet_Clientbadge_Related_Client_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Mnet_Clientbadge_Related_Client_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Mnet_Clientbadge_Related_Client_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Mnet_Clientbadge_Related_Client_Aggregate_Bool_Exp_Count>;
};

export type Mnet_Clientbadge_Related_Client_Aggregate_Bool_Exp_Bool_And = {
  arguments: Mnet_Clientbadge_Related_Client_Select_Column_Mnet_Clientbadge_Related_Client_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Clientbadge_Related_Client_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Mnet_Clientbadge_Related_Client_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Mnet_Clientbadge_Related_Client_Select_Column_Mnet_Clientbadge_Related_Client_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Clientbadge_Related_Client_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Mnet_Clientbadge_Related_Client_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mnet_Clientbadge_Related_Client_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Clientbadge_Related_Client_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mnet.clientbadge_related_client" */
export type Mnet_Clientbadge_Related_Client_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Clientbadge_Related_Client_Max_Fields>;
  min?: Maybe<Mnet_Clientbadge_Related_Client_Min_Fields>;
};

/** aggregate fields of "mnet.clientbadge_related_client" */
export type Mnet_Clientbadge_Related_Client_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Clientbadge_Related_Client_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mnet.clientbadge_related_client" */
export type Mnet_Clientbadge_Related_Client_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Clientbadge_Related_Client_Max_Order_By>;
  min?: InputMaybe<Mnet_Clientbadge_Related_Client_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "mnet.clientbadge_related_client". All fields are combined with a logical 'AND'. */
export type Mnet_Clientbadge_Related_Client_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Clientbadge_Related_Client_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Clientbadge_Related_Client_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Clientbadge_Related_Client_Bool_Exp>>;
  badge_id?: InputMaybe<Uuid_Comparison_Exp>;
  clientbadge_badge?: InputMaybe<Mnet_Clientbadge_Badge_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  related_client_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mnet_Clientbadge_Related_Client_Max_Fields = {
  badge_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  related_client_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "mnet.clientbadge_related_client" */
export type Mnet_Clientbadge_Related_Client_Max_Order_By = {
  badge_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  related_client_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mnet_Clientbadge_Related_Client_Min_Fields = {
  badge_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  related_client_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "mnet.clientbadge_related_client" */
export type Mnet_Clientbadge_Related_Client_Min_Order_By = {
  badge_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  related_client_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mnet.clientbadge_related_client". */
export type Mnet_Clientbadge_Related_Client_Order_By = {
  badge_id?: InputMaybe<Order_By>;
  clientbadge_badge?: InputMaybe<Mnet_Clientbadge_Badge_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  related_client_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.clientbadge_related_client" */
export enum Mnet_Clientbadge_Related_Client_Select_Column {
  /** column name */
  Badge_id = 'badge_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Is_active = 'is_active',
  /** column name */
  Related_client_number = 'related_client_number',
  /** column name */
  Updated_at = 'updated_at',
}

/** select "mnet_clientbadge_related_client_aggregate_bool_exp_bool_and_arguments_columns" columns of table "mnet.clientbadge_related_client" */
export enum Mnet_Clientbadge_Related_Client_Select_Column_Mnet_Clientbadge_Related_Client_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Is_active = 'is_active',
}

/** select "mnet_clientbadge_related_client_aggregate_bool_exp_bool_or_arguments_columns" columns of table "mnet.clientbadge_related_client" */
export enum Mnet_Clientbadge_Related_Client_Select_Column_Mnet_Clientbadge_Related_Client_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Is_active = 'is_active',
}

/** Streaming cursor of the table "mnet_clientbadge_related_client" */
export type Mnet_Clientbadge_Related_Client_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Clientbadge_Related_Client_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Clientbadge_Related_Client_Stream_Cursor_Value_Input = {
  badge_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  related_client_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "mnet.foundation_matter" */
export type Mnet_Foundation_Matter = {
  Matter?: Maybe<Mlfsl_Matter>;
  created_at: Scalars['timestamptz']['output'];
  foundation_matter_id: Scalars['uuid']['output'];
  matter_number: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "mnet.foundation_matter" */
export type Mnet_Foundation_Matter_Aggregate = {
  aggregate?: Maybe<Mnet_Foundation_Matter_Aggregate_Fields>;
  nodes: Array<Mnet_Foundation_Matter>;
};

/** aggregate fields of "mnet.foundation_matter" */
export type Mnet_Foundation_Matter_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Foundation_Matter_Max_Fields>;
  min?: Maybe<Mnet_Foundation_Matter_Min_Fields>;
};

/** aggregate fields of "mnet.foundation_matter" */
export type Mnet_Foundation_Matter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Foundation_Matter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "mnet.foundation_matter". All fields are combined with a logical 'AND'. */
export type Mnet_Foundation_Matter_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Foundation_Matter_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Foundation_Matter_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Foundation_Matter_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  foundation_matter_id?: InputMaybe<Uuid_Comparison_Exp>;
  matter_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mnet_Foundation_Matter_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  foundation_matter_id?: Maybe<Scalars['uuid']['output']>;
  matter_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Mnet_Foundation_Matter_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  foundation_matter_id?: Maybe<Scalars['uuid']['output']>;
  matter_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "mnet.foundation_matter". */
export type Mnet_Foundation_Matter_Order_By = {
  created_at?: InputMaybe<Order_By>;
  foundation_matter_id?: InputMaybe<Order_By>;
  matter_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.foundation_matter" */
export enum Mnet_Foundation_Matter_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Foundation_matter_id = 'foundation_matter_id',
  /** column name */
  Matter_number = 'matter_number',
  /** column name */
  Updated_at = 'updated_at',
}

/** Streaming cursor of the table "mnet_foundation_matter" */
export type Mnet_Foundation_Matter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Foundation_Matter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Foundation_Matter_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  foundation_matter_id?: InputMaybe<Scalars['uuid']['input']>;
  matter_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Stores information about tool categories within groups. */
export type Mnet_Mytools_Catalog_Category = {
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  mytools_catalog_tools: Array<Mnet_Mytools_Catalog_Tool>;
  /** An aggregate relationship */
  mytools_catalog_tools_aggregate: Mnet_Mytools_Catalog_Tool_Aggregate;
  title: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Stores information about tool categories within groups. */
export type Mnet_Mytools_Catalog_CategoryMytools_Catalog_ToolsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_Catalog_Tool_Bool_Exp>;
};

/** Stores information about tool categories within groups. */
export type Mnet_Mytools_Catalog_CategoryMytools_Catalog_Tools_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_Catalog_Tool_Bool_Exp>;
};

/** aggregated selection of "mnet.mytools_catalog_category" */
export type Mnet_Mytools_Catalog_Category_Aggregate = {
  aggregate?: Maybe<Mnet_Mytools_Catalog_Category_Aggregate_Fields>;
  nodes: Array<Mnet_Mytools_Catalog_Category>;
};

/** aggregate fields of "mnet.mytools_catalog_category" */
export type Mnet_Mytools_Catalog_Category_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Mytools_Catalog_Category_Max_Fields>;
  min?: Maybe<Mnet_Mytools_Catalog_Category_Min_Fields>;
};

/** aggregate fields of "mnet.mytools_catalog_category" */
export type Mnet_Mytools_Catalog_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Mytools_Catalog_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "mnet.mytools_catalog_category". All fields are combined with a logical 'AND'. */
export type Mnet_Mytools_Catalog_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Mytools_Catalog_Category_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Mytools_Catalog_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Mytools_Catalog_Category_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mytools_catalog_tools?: InputMaybe<Mnet_Mytools_Catalog_Tool_Bool_Exp>;
  mytools_catalog_tools_aggregate?: InputMaybe<Mnet_Mytools_Catalog_Tool_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mnet_Mytools_Catalog_Category_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Mnet_Mytools_Catalog_Category_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "mnet.mytools_catalog_category". */
export type Mnet_Mytools_Catalog_Category_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mytools_catalog_tools_aggregate?: InputMaybe<Mnet_Mytools_Catalog_Tool_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.mytools_catalog_category" */
export enum Mnet_Mytools_Catalog_Category_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  Updated_at = 'updated_at',
}

/** Streaming cursor of the table "mnet_mytools_catalog_category" */
export type Mnet_Mytools_Catalog_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Mytools_Catalog_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Mytools_Catalog_Category_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Catalog of predefined tools */
export type Mnet_Mytools_Catalog_Tool = {
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  mytools_catalog_category: Mnet_Mytools_Catalog_Category;
  /** An array relationship */
  mytools_catalog_tool_assignments: Array<Mnet_Mytools_Catalog_Tool_Assignment>;
  /** An aggregate relationship */
  mytools_catalog_tool_assignments_aggregate: Mnet_Mytools_Catalog_Tool_Assignment_Aggregate;
  mytools_category_id: Scalars['uuid']['output'];
  /** An array relationship */
  mytools_user_tools: Array<Mnet_Mytools_User_Tool>;
  /** An aggregate relationship */
  mytools_user_tools_aggregate: Mnet_Mytools_User_Tool_Aggregate;
  order: Scalars['Int']['output'];
  tags?: Maybe<Array<Scalars['citext']['output']>>;
  target?: Maybe<Scalars['String']['output']>;
  title: Scalars['citext']['output'];
  updated_at: Scalars['timestamptz']['output'];
  url: Scalars['String']['output'];
};

/** Catalog of predefined tools */
export type Mnet_Mytools_Catalog_ToolMytools_Catalog_Tool_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Assignment_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_Catalog_Tool_Assignment_Bool_Exp>;
};

/** Catalog of predefined tools */
export type Mnet_Mytools_Catalog_ToolMytools_Catalog_Tool_Assignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Assignment_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_Catalog_Tool_Assignment_Bool_Exp>;
};

/** Catalog of predefined tools */
export type Mnet_Mytools_Catalog_ToolMytools_User_ToolsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_User_Tool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_User_Tool_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_User_Tool_Bool_Exp>;
};

/** Catalog of predefined tools */
export type Mnet_Mytools_Catalog_ToolMytools_User_Tools_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_User_Tool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_User_Tool_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_User_Tool_Bool_Exp>;
};

/** aggregated selection of "mnet.mytools_catalog_tool" */
export type Mnet_Mytools_Catalog_Tool_Aggregate = {
  aggregate?: Maybe<Mnet_Mytools_Catalog_Tool_Aggregate_Fields>;
  nodes: Array<Mnet_Mytools_Catalog_Tool>;
};

export type Mnet_Mytools_Catalog_Tool_Aggregate_Bool_Exp = {
  count?: InputMaybe<Mnet_Mytools_Catalog_Tool_Aggregate_Bool_Exp_Count>;
};

export type Mnet_Mytools_Catalog_Tool_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Mytools_Catalog_Tool_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mnet.mytools_catalog_tool" */
export type Mnet_Mytools_Catalog_Tool_Aggregate_Fields = {
  avg?: Maybe<Mnet_Mytools_Catalog_Tool_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Mytools_Catalog_Tool_Max_Fields>;
  min?: Maybe<Mnet_Mytools_Catalog_Tool_Min_Fields>;
  stddev?: Maybe<Mnet_Mytools_Catalog_Tool_Stddev_Fields>;
  stddev_pop?: Maybe<Mnet_Mytools_Catalog_Tool_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mnet_Mytools_Catalog_Tool_Stddev_Samp_Fields>;
  sum?: Maybe<Mnet_Mytools_Catalog_Tool_Sum_Fields>;
  var_pop?: Maybe<Mnet_Mytools_Catalog_Tool_Var_Pop_Fields>;
  var_samp?: Maybe<Mnet_Mytools_Catalog_Tool_Var_Samp_Fields>;
  variance?: Maybe<Mnet_Mytools_Catalog_Tool_Variance_Fields>;
};

/** aggregate fields of "mnet.mytools_catalog_tool" */
export type Mnet_Mytools_Catalog_Tool_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mnet.mytools_catalog_tool" */
export type Mnet_Mytools_Catalog_Tool_Aggregate_Order_By = {
  avg?: InputMaybe<Mnet_Mytools_Catalog_Tool_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Mytools_Catalog_Tool_Max_Order_By>;
  min?: InputMaybe<Mnet_Mytools_Catalog_Tool_Min_Order_By>;
  stddev?: InputMaybe<Mnet_Mytools_Catalog_Tool_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mnet_Mytools_Catalog_Tool_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mnet_Mytools_Catalog_Tool_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mnet_Mytools_Catalog_Tool_Sum_Order_By>;
  var_pop?: InputMaybe<Mnet_Mytools_Catalog_Tool_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mnet_Mytools_Catalog_Tool_Var_Samp_Order_By>;
  variance?: InputMaybe<Mnet_Mytools_Catalog_Tool_Variance_Order_By>;
};

/** Assign a tool to an AD group */
export type Mnet_Mytools_Catalog_Tool_Assignment = {
  ad_group?: Maybe<Group>;
  ad_group_id: Scalars['String']['output'];
  ad_group_name: Scalars['citext']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  mytools_catalog_tool: Mnet_Mytools_Catalog_Tool;
  mytools_catalog_tool_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "mnet.mytools_catalog_tool_assignment" */
export type Mnet_Mytools_Catalog_Tool_Assignment_Aggregate = {
  aggregate?: Maybe<Mnet_Mytools_Catalog_Tool_Assignment_Aggregate_Fields>;
  nodes: Array<Mnet_Mytools_Catalog_Tool_Assignment>;
};

export type Mnet_Mytools_Catalog_Tool_Assignment_Aggregate_Bool_Exp = {
  count?: InputMaybe<Mnet_Mytools_Catalog_Tool_Assignment_Aggregate_Bool_Exp_Count>;
};

export type Mnet_Mytools_Catalog_Tool_Assignment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Assignment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Mytools_Catalog_Tool_Assignment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mnet.mytools_catalog_tool_assignment" */
export type Mnet_Mytools_Catalog_Tool_Assignment_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Mytools_Catalog_Tool_Assignment_Max_Fields>;
  min?: Maybe<Mnet_Mytools_Catalog_Tool_Assignment_Min_Fields>;
};

/** aggregate fields of "mnet.mytools_catalog_tool_assignment" */
export type Mnet_Mytools_Catalog_Tool_Assignment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Assignment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mnet.mytools_catalog_tool_assignment" */
export type Mnet_Mytools_Catalog_Tool_Assignment_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Mytools_Catalog_Tool_Assignment_Max_Order_By>;
  min?: InputMaybe<Mnet_Mytools_Catalog_Tool_Assignment_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "mnet.mytools_catalog_tool_assignment". All fields are combined with a logical 'AND'. */
export type Mnet_Mytools_Catalog_Tool_Assignment_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Assignment_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Mytools_Catalog_Tool_Assignment_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Assignment_Bool_Exp>>;
  ad_group_id?: InputMaybe<String_Comparison_Exp>;
  ad_group_name?: InputMaybe<Citext_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mytools_catalog_tool?: InputMaybe<Mnet_Mytools_Catalog_Tool_Bool_Exp>;
  mytools_catalog_tool_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mnet_Mytools_Catalog_Tool_Assignment_Max_Fields = {
  ad_group_id?: Maybe<Scalars['String']['output']>;
  ad_group_name?: Maybe<Scalars['citext']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mytools_catalog_tool_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "mnet.mytools_catalog_tool_assignment" */
export type Mnet_Mytools_Catalog_Tool_Assignment_Max_Order_By = {
  ad_group_id?: InputMaybe<Order_By>;
  ad_group_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mytools_catalog_tool_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mnet_Mytools_Catalog_Tool_Assignment_Min_Fields = {
  ad_group_id?: Maybe<Scalars['String']['output']>;
  ad_group_name?: Maybe<Scalars['citext']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mytools_catalog_tool_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "mnet.mytools_catalog_tool_assignment" */
export type Mnet_Mytools_Catalog_Tool_Assignment_Min_Order_By = {
  ad_group_id?: InputMaybe<Order_By>;
  ad_group_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mytools_catalog_tool_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mnet.mytools_catalog_tool_assignment". */
export type Mnet_Mytools_Catalog_Tool_Assignment_Order_By = {
  ad_group_id?: InputMaybe<Order_By>;
  ad_group_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mytools_catalog_tool?: InputMaybe<Mnet_Mytools_Catalog_Tool_Order_By>;
  mytools_catalog_tool_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.mytools_catalog_tool_assignment" */
export enum Mnet_Mytools_Catalog_Tool_Assignment_Select_Column {
  /** column name */
  Ad_group_id = 'ad_group_id',
  /** column name */
  Ad_group_name = 'ad_group_name',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Mytools_catalog_tool_id = 'mytools_catalog_tool_id',
  /** column name */
  Updated_at = 'updated_at',
}

/** Streaming cursor of the table "mnet_mytools_catalog_tool_assignment" */
export type Mnet_Mytools_Catalog_Tool_Assignment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Mytools_Catalog_Tool_Assignment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Mytools_Catalog_Tool_Assignment_Stream_Cursor_Value_Input = {
  ad_group_id?: InputMaybe<Scalars['String']['input']>;
  ad_group_name?: InputMaybe<Scalars['citext']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mytools_catalog_tool_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate avg on columns */
export type Mnet_Mytools_Catalog_Tool_Avg_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "mnet.mytools_catalog_tool" */
export type Mnet_Mytools_Catalog_Tool_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mnet.mytools_catalog_tool". All fields are combined with a logical 'AND'. */
export type Mnet_Mytools_Catalog_Tool_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Mytools_Catalog_Tool_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mytools_catalog_category?: InputMaybe<Mnet_Mytools_Catalog_Category_Bool_Exp>;
  mytools_catalog_tool_assignments?: InputMaybe<Mnet_Mytools_Catalog_Tool_Assignment_Bool_Exp>;
  mytools_catalog_tool_assignments_aggregate?: InputMaybe<Mnet_Mytools_Catalog_Tool_Assignment_Aggregate_Bool_Exp>;
  mytools_category_id?: InputMaybe<Uuid_Comparison_Exp>;
  mytools_user_tools?: InputMaybe<Mnet_Mytools_User_Tool_Bool_Exp>;
  mytools_user_tools_aggregate?: InputMaybe<Mnet_Mytools_User_Tool_Aggregate_Bool_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  tags?: InputMaybe<Citext_Array_Comparison_Exp>;
  target?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<Citext_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mnet_Mytools_Catalog_Tool_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mytools_category_id?: Maybe<Scalars['uuid']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Scalars['citext']['output']>>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['citext']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "mnet.mytools_catalog_tool" */
export type Mnet_Mytools_Catalog_Tool_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mytools_category_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mnet_Mytools_Catalog_Tool_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mytools_category_id?: Maybe<Scalars['uuid']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Scalars['citext']['output']>>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['citext']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "mnet.mytools_catalog_tool" */
export type Mnet_Mytools_Catalog_Tool_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mytools_category_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mnet.mytools_catalog_tool". */
export type Mnet_Mytools_Catalog_Tool_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mytools_catalog_category?: InputMaybe<Mnet_Mytools_Catalog_Category_Order_By>;
  mytools_catalog_tool_assignments_aggregate?: InputMaybe<Mnet_Mytools_Catalog_Tool_Assignment_Aggregate_Order_By>;
  mytools_category_id?: InputMaybe<Order_By>;
  mytools_user_tools_aggregate?: InputMaybe<Mnet_Mytools_User_Tool_Aggregate_Order_By>;
  order?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.mytools_catalog_tool" */
export enum Mnet_Mytools_Catalog_Tool_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Mytools_category_id = 'mytools_category_id',
  /** column name */
  Order = 'order',
  /** column name */
  Tags = 'tags',
  /** column name */
  Target = 'target',
  /** column name */
  Title = 'title',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Url = 'url',
}

/** aggregate stddev on columns */
export type Mnet_Mytools_Catalog_Tool_Stddev_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "mnet.mytools_catalog_tool" */
export type Mnet_Mytools_Catalog_Tool_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mnet_Mytools_Catalog_Tool_Stddev_Pop_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "mnet.mytools_catalog_tool" */
export type Mnet_Mytools_Catalog_Tool_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mnet_Mytools_Catalog_Tool_Stddev_Samp_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "mnet.mytools_catalog_tool" */
export type Mnet_Mytools_Catalog_Tool_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mnet_mytools_catalog_tool" */
export type Mnet_Mytools_Catalog_Tool_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Mytools_Catalog_Tool_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Mytools_Catalog_Tool_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mytools_category_id?: InputMaybe<Scalars['uuid']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['citext']['input']>>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['citext']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Mnet_Mytools_Catalog_Tool_Sum_Fields = {
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "mnet.mytools_catalog_tool" */
export type Mnet_Mytools_Catalog_Tool_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Mnet_Mytools_Catalog_Tool_Var_Pop_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "mnet.mytools_catalog_tool" */
export type Mnet_Mytools_Catalog_Tool_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mnet_Mytools_Catalog_Tool_Var_Samp_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "mnet.mytools_catalog_tool" */
export type Mnet_Mytools_Catalog_Tool_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mnet_Mytools_Catalog_Tool_Variance_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "mnet.mytools_catalog_tool" */
export type Mnet_Mytools_Catalog_Tool_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Contains tools the user selected from the catalog, custom tools, and assigned tools that the user has reordered */
export type Mnet_Mytools_User_Tool = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['citext']['output'];
  id: Scalars['uuid']['output'];
  is_custom: Scalars['Boolean']['output'];
  /** An object relationship */
  mytools_catalog_tool?: Maybe<Mnet_Mytools_Catalog_Tool>;
  mytools_catalog_tool_id?: Maybe<Scalars['uuid']['output']>;
  order: Scalars['Int']['output'];
  target?: Maybe<Scalars['String']['output']>;
  title: Scalars['citext']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['citext']['output'];
  url: Scalars['String']['output'];
  user_id: Scalars['citext']['output'];
  visible: Scalars['Boolean']['output'];
};

/** aggregated selection of "mnet.mytools_user_tool" */
export type Mnet_Mytools_User_Tool_Aggregate = {
  aggregate?: Maybe<Mnet_Mytools_User_Tool_Aggregate_Fields>;
  nodes: Array<Mnet_Mytools_User_Tool>;
};

export type Mnet_Mytools_User_Tool_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Mnet_Mytools_User_Tool_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Mnet_Mytools_User_Tool_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Mnet_Mytools_User_Tool_Aggregate_Bool_Exp_Count>;
};

export type Mnet_Mytools_User_Tool_Aggregate_Bool_Exp_Bool_And = {
  arguments: Mnet_Mytools_User_Tool_Select_Column_Mnet_Mytools_User_Tool_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Mytools_User_Tool_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Mnet_Mytools_User_Tool_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Mnet_Mytools_User_Tool_Select_Column_Mnet_Mytools_User_Tool_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Mytools_User_Tool_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Mnet_Mytools_User_Tool_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mnet_Mytools_User_Tool_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Mytools_User_Tool_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mnet.mytools_user_tool" */
export type Mnet_Mytools_User_Tool_Aggregate_Fields = {
  avg?: Maybe<Mnet_Mytools_User_Tool_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Mytools_User_Tool_Max_Fields>;
  min?: Maybe<Mnet_Mytools_User_Tool_Min_Fields>;
  stddev?: Maybe<Mnet_Mytools_User_Tool_Stddev_Fields>;
  stddev_pop?: Maybe<Mnet_Mytools_User_Tool_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mnet_Mytools_User_Tool_Stddev_Samp_Fields>;
  sum?: Maybe<Mnet_Mytools_User_Tool_Sum_Fields>;
  var_pop?: Maybe<Mnet_Mytools_User_Tool_Var_Pop_Fields>;
  var_samp?: Maybe<Mnet_Mytools_User_Tool_Var_Samp_Fields>;
  variance?: Maybe<Mnet_Mytools_User_Tool_Variance_Fields>;
};

/** aggregate fields of "mnet.mytools_user_tool" */
export type Mnet_Mytools_User_Tool_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Mytools_User_Tool_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mnet.mytools_user_tool" */
export type Mnet_Mytools_User_Tool_Aggregate_Order_By = {
  avg?: InputMaybe<Mnet_Mytools_User_Tool_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Mytools_User_Tool_Max_Order_By>;
  min?: InputMaybe<Mnet_Mytools_User_Tool_Min_Order_By>;
  stddev?: InputMaybe<Mnet_Mytools_User_Tool_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mnet_Mytools_User_Tool_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mnet_Mytools_User_Tool_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mnet_Mytools_User_Tool_Sum_Order_By>;
  var_pop?: InputMaybe<Mnet_Mytools_User_Tool_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mnet_Mytools_User_Tool_Var_Samp_Order_By>;
  variance?: InputMaybe<Mnet_Mytools_User_Tool_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Mnet_Mytools_User_Tool_Avg_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "mnet.mytools_user_tool" */
export type Mnet_Mytools_User_Tool_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mnet.mytools_user_tool". All fields are combined with a logical 'AND'. */
export type Mnet_Mytools_User_Tool_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Mytools_User_Tool_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Mytools_User_Tool_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Mytools_User_Tool_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Citext_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_custom?: InputMaybe<Boolean_Comparison_Exp>;
  mytools_catalog_tool?: InputMaybe<Mnet_Mytools_Catalog_Tool_Bool_Exp>;
  mytools_catalog_tool_id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  target?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<Citext_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Citext_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Citext_Comparison_Exp>;
  visible?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "mnet.mytools_user_tool" */
export enum Mnet_Mytools_User_Tool_Constraint {
  /** unique or primary key constraint on columns "id" */
  Mytools_user_tool_pkey = 'mytools_user_tool_pkey',
}

/** input type for incrementing numeric columns in table "mnet.mytools_user_tool" */
export type Mnet_Mytools_User_Tool_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "mnet.mytools_user_tool" */
export type Mnet_Mytools_User_Tool_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_custom?: InputMaybe<Scalars['Boolean']['input']>;
  mytools_catalog_tool_id?: InputMaybe<Scalars['uuid']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['citext']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['citext']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Mnet_Mytools_User_Tool_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['citext']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mytools_catalog_tool_id?: Maybe<Scalars['uuid']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['citext']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['citext']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['citext']['output']>;
};

/** order by max() on columns of table "mnet.mytools_user_tool" */
export type Mnet_Mytools_User_Tool_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mytools_catalog_tool_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mnet_Mytools_User_Tool_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['citext']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mytools_catalog_tool_id?: Maybe<Scalars['uuid']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['citext']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['citext']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['citext']['output']>;
};

/** order by min() on columns of table "mnet.mytools_user_tool" */
export type Mnet_Mytools_User_Tool_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mytools_catalog_tool_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mnet.mytools_user_tool" */
export type Mnet_Mytools_User_Tool_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mnet_Mytools_User_Tool>;
};

/** on_conflict condition type for table "mnet.mytools_user_tool" */
export type Mnet_Mytools_User_Tool_On_Conflict = {
  constraint: Mnet_Mytools_User_Tool_Constraint;
  update_columns?: Array<Mnet_Mytools_User_Tool_Update_Column>;
  where?: InputMaybe<Mnet_Mytools_User_Tool_Bool_Exp>;
};

/** Ordering options when selecting data from "mnet.mytools_user_tool". */
export type Mnet_Mytools_User_Tool_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_custom?: InputMaybe<Order_By>;
  mytools_catalog_tool?: InputMaybe<Mnet_Mytools_Catalog_Tool_Order_By>;
  mytools_catalog_tool_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  visible?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mnet.mytools_user_tool */
export type Mnet_Mytools_User_Tool_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mnet.mytools_user_tool" */
export enum Mnet_Mytools_User_Tool_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Is_custom = 'is_custom',
  /** column name */
  Mytools_catalog_tool_id = 'mytools_catalog_tool_id',
  /** column name */
  Order = 'order',
  /** column name */
  Target = 'target',
  /** column name */
  Title = 'title',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
  /** column name */
  Url = 'url',
  /** column name */
  User_id = 'user_id',
  /** column name */
  Visible = 'visible',
}

/** select "mnet_mytools_user_tool_aggregate_bool_exp_bool_and_arguments_columns" columns of table "mnet.mytools_user_tool" */
export enum Mnet_Mytools_User_Tool_Select_Column_Mnet_Mytools_User_Tool_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Is_custom = 'is_custom',
  /** column name */
  Visible = 'visible',
}

/** select "mnet_mytools_user_tool_aggregate_bool_exp_bool_or_arguments_columns" columns of table "mnet.mytools_user_tool" */
export enum Mnet_Mytools_User_Tool_Select_Column_Mnet_Mytools_User_Tool_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Is_custom = 'is_custom',
  /** column name */
  Visible = 'visible',
}

/** input type for updating data in table "mnet.mytools_user_tool" */
export type Mnet_Mytools_User_Tool_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_custom?: InputMaybe<Scalars['Boolean']['input']>;
  mytools_catalog_tool_id?: InputMaybe<Scalars['uuid']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['citext']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['citext']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Mnet_Mytools_User_Tool_Stddev_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "mnet.mytools_user_tool" */
export type Mnet_Mytools_User_Tool_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mnet_Mytools_User_Tool_Stddev_Pop_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "mnet.mytools_user_tool" */
export type Mnet_Mytools_User_Tool_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mnet_Mytools_User_Tool_Stddev_Samp_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "mnet.mytools_user_tool" */
export type Mnet_Mytools_User_Tool_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mnet_mytools_user_tool" */
export type Mnet_Mytools_User_Tool_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Mytools_User_Tool_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Mytools_User_Tool_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['citext']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_custom?: InputMaybe<Scalars['Boolean']['input']>;
  mytools_catalog_tool_id?: InputMaybe<Scalars['uuid']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['citext']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['citext']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['citext']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Mnet_Mytools_User_Tool_Sum_Fields = {
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "mnet.mytools_user_tool" */
export type Mnet_Mytools_User_Tool_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "mnet.mytools_user_tool" */
export enum Mnet_Mytools_User_Tool_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Is_custom = 'is_custom',
  /** column name */
  Mytools_catalog_tool_id = 'mytools_catalog_tool_id',
  /** column name */
  Order = 'order',
  /** column name */
  Target = 'target',
  /** column name */
  Title = 'title',
  /** column name */
  Url = 'url',
  /** column name */
  User_id = 'user_id',
  /** column name */
  Visible = 'visible',
}

export type Mnet_Mytools_User_Tool_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mnet_Mytools_User_Tool_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mnet_Mytools_User_Tool_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mnet_Mytools_User_Tool_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mnet_Mytools_User_Tool_Var_Pop_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "mnet.mytools_user_tool" */
export type Mnet_Mytools_User_Tool_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mnet_Mytools_User_Tool_Var_Samp_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "mnet.mytools_user_tool" */
export type Mnet_Mytools_User_Tool_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mnet_Mytools_User_Tool_Variance_Fields = {
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "mnet.mytools_user_tool" */
export type Mnet_Mytools_User_Tool_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "mnet.office_detail" */
export type Mnet_Office_Detail = {
  Office?: Maybe<Mlfsl_Office>;
  created_at: Scalars['timestamptz']['output'];
  latitude?: Maybe<Scalars['float8']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
  office_code: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  url: Scalars['String']['output'];
};

/** aggregated selection of "mnet.office_detail" */
export type Mnet_Office_Detail_Aggregate = {
  aggregate?: Maybe<Mnet_Office_Detail_Aggregate_Fields>;
  nodes: Array<Mnet_Office_Detail>;
};

/** aggregate fields of "mnet.office_detail" */
export type Mnet_Office_Detail_Aggregate_Fields = {
  avg?: Maybe<Mnet_Office_Detail_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Office_Detail_Max_Fields>;
  min?: Maybe<Mnet_Office_Detail_Min_Fields>;
  stddev?: Maybe<Mnet_Office_Detail_Stddev_Fields>;
  stddev_pop?: Maybe<Mnet_Office_Detail_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mnet_Office_Detail_Stddev_Samp_Fields>;
  sum?: Maybe<Mnet_Office_Detail_Sum_Fields>;
  var_pop?: Maybe<Mnet_Office_Detail_Var_Pop_Fields>;
  var_samp?: Maybe<Mnet_Office_Detail_Var_Samp_Fields>;
  variance?: Maybe<Mnet_Office_Detail_Variance_Fields>;
};

/** aggregate fields of "mnet.office_detail" */
export type Mnet_Office_Detail_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Office_Detail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mnet_Office_Detail_Avg_Fields = {
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mnet.office_detail". All fields are combined with a logical 'AND'. */
export type Mnet_Office_Detail_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Office_Detail_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Office_Detail_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Office_Detail_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  latitude?: InputMaybe<Float8_Comparison_Exp>;
  longitude?: InputMaybe<Float8_Comparison_Exp>;
  office_code?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mnet_Office_Detail_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  latitude?: Maybe<Scalars['float8']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
  office_code?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mnet_Office_Detail_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  latitude?: Maybe<Scalars['float8']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
  office_code?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "mnet.office_detail". */
export type Mnet_Office_Detail_Order_By = {
  created_at?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  office_code?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.office_detail" */
export enum Mnet_Office_Detail_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Office_code = 'office_code',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Url = 'url',
}

/** aggregate stddev on columns */
export type Mnet_Office_Detail_Stddev_Fields = {
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mnet_Office_Detail_Stddev_Pop_Fields = {
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mnet_Office_Detail_Stddev_Samp_Fields = {
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mnet_office_detail" */
export type Mnet_Office_Detail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Office_Detail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Office_Detail_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  latitude?: InputMaybe<Scalars['float8']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
  office_code?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Mnet_Office_Detail_Sum_Fields = {
  latitude?: Maybe<Scalars['float8']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Mnet_Office_Detail_Var_Pop_Fields = {
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mnet_Office_Detail_Var_Samp_Fields = {
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mnet_Office_Detail_Variance_Fields = {
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mnet.person_business_chemistry_profile" */
export type Mnet_Person_Business_Chemistry_Profile = {
  Person?: Maybe<Mlfsl_Personnel>;
  ad_system_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  hide_profile_flag: Scalars['Boolean']['output'];
  /** An object relationship */
  primary_business_chemistry_type: Mnet_Business_Chemistry_Type;
  primary_type_id: Scalars['uuid']['output'];
  /** An object relationship */
  secondary_business_chemistry_type: Mnet_Business_Chemistry_Type;
  secondary_type_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "mnet.person_business_chemistry_profile" */
export type Mnet_Person_Business_Chemistry_Profile_Aggregate = {
  aggregate?: Maybe<Mnet_Person_Business_Chemistry_Profile_Aggregate_Fields>;
  nodes: Array<Mnet_Person_Business_Chemistry_Profile>;
};

export type Mnet_Person_Business_Chemistry_Profile_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Aggregate_Bool_Exp_Count>;
};

export type Mnet_Person_Business_Chemistry_Profile_Aggregate_Bool_Exp_Bool_And = {
  arguments: Mnet_Person_Business_Chemistry_Profile_Select_Column_Mnet_Person_Business_Chemistry_Profile_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Mnet_Person_Business_Chemistry_Profile_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Mnet_Person_Business_Chemistry_Profile_Select_Column_Mnet_Person_Business_Chemistry_Profile_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Mnet_Person_Business_Chemistry_Profile_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mnet_Person_Business_Chemistry_Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mnet.person_business_chemistry_profile" */
export type Mnet_Person_Business_Chemistry_Profile_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Person_Business_Chemistry_Profile_Max_Fields>;
  min?: Maybe<Mnet_Person_Business_Chemistry_Profile_Min_Fields>;
};

/** aggregate fields of "mnet.person_business_chemistry_profile" */
export type Mnet_Person_Business_Chemistry_Profile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Person_Business_Chemistry_Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mnet.person_business_chemistry_profile" */
export type Mnet_Person_Business_Chemistry_Profile_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Max_Order_By>;
  min?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "mnet.person_business_chemistry_profile". All fields are combined with a logical 'AND'. */
export type Mnet_Person_Business_Chemistry_Profile_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Person_Business_Chemistry_Profile_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Person_Business_Chemistry_Profile_Bool_Exp>>;
  ad_system_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hide_profile_flag?: InputMaybe<Boolean_Comparison_Exp>;
  primary_business_chemistry_type?: InputMaybe<Mnet_Business_Chemistry_Type_Bool_Exp>;
  primary_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  secondary_business_chemistry_type?: InputMaybe<Mnet_Business_Chemistry_Type_Bool_Exp>;
  secondary_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mnet_Person_Business_Chemistry_Profile_Max_Fields = {
  ad_system_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  primary_type_id?: Maybe<Scalars['uuid']['output']>;
  secondary_type_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "mnet.person_business_chemistry_profile" */
export type Mnet_Person_Business_Chemistry_Profile_Max_Order_By = {
  ad_system_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  primary_type_id?: InputMaybe<Order_By>;
  secondary_type_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mnet_Person_Business_Chemistry_Profile_Min_Fields = {
  ad_system_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  primary_type_id?: Maybe<Scalars['uuid']['output']>;
  secondary_type_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "mnet.person_business_chemistry_profile" */
export type Mnet_Person_Business_Chemistry_Profile_Min_Order_By = {
  ad_system_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  primary_type_id?: InputMaybe<Order_By>;
  secondary_type_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "mnet.person_business_chemistry_profile". */
export type Mnet_Person_Business_Chemistry_Profile_Order_By = {
  ad_system_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hide_profile_flag?: InputMaybe<Order_By>;
  primary_business_chemistry_type?: InputMaybe<Mnet_Business_Chemistry_Type_Order_By>;
  primary_type_id?: InputMaybe<Order_By>;
  secondary_business_chemistry_type?: InputMaybe<Mnet_Business_Chemistry_Type_Order_By>;
  secondary_type_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.person_business_chemistry_profile" */
export enum Mnet_Person_Business_Chemistry_Profile_Select_Column {
  /** column name */
  Ad_system_id = 'ad_system_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Hide_profile_flag = 'hide_profile_flag',
  /** column name */
  Primary_type_id = 'primary_type_id',
  /** column name */
  Secondary_type_id = 'secondary_type_id',
  /** column name */
  Updated_at = 'updated_at',
}

/** select "mnet_person_business_chemistry_profile_aggregate_bool_exp_bool_and_arguments_columns" columns of table "mnet.person_business_chemistry_profile" */
export enum Mnet_Person_Business_Chemistry_Profile_Select_Column_Mnet_Person_Business_Chemistry_Profile_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Hide_profile_flag = 'hide_profile_flag',
}

/** select "mnet_person_business_chemistry_profile_aggregate_bool_exp_bool_or_arguments_columns" columns of table "mnet.person_business_chemistry_profile" */
export enum Mnet_Person_Business_Chemistry_Profile_Select_Column_Mnet_Person_Business_Chemistry_Profile_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Hide_profile_flag = 'hide_profile_flag',
}

/** Streaming cursor of the table "mnet_person_business_chemistry_profile" */
export type Mnet_Person_Business_Chemistry_Profile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Person_Business_Chemistry_Profile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Person_Business_Chemistry_Profile_Stream_Cursor_Value_Input = {
  ad_system_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  hide_profile_flag?: InputMaybe<Scalars['Boolean']['input']>;
  primary_type_id?: InputMaybe<Scalars['uuid']['input']>;
  secondary_type_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** This table links personnel profiles to their earned badges. Each row represents an assignment of a specific badge to a personnel profile, allowing tracking of achievements and certifications. */
export type Mnet_Personnel_Profile_Badges = {
  active: Scalars['Boolean']['output'];
  ad_system_id: Scalars['citext']['output'];
  badge_id: Scalars['citext']['output'];
  created_at: Scalars['timestamptz']['output'];
  eligible: Scalars['Boolean']['output'];
  email: Scalars['citext']['output'];
  id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "mnet.personnel_profile_badges" */
export type Mnet_Personnel_Profile_Badges_Aggregate = {
  aggregate?: Maybe<Mnet_Personnel_Profile_Badges_Aggregate_Fields>;
  nodes: Array<Mnet_Personnel_Profile_Badges>;
};

/** aggregate fields of "mnet.personnel_profile_badges" */
export type Mnet_Personnel_Profile_Badges_Aggregate_Fields = {
  avg?: Maybe<Mnet_Personnel_Profile_Badges_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Personnel_Profile_Badges_Max_Fields>;
  min?: Maybe<Mnet_Personnel_Profile_Badges_Min_Fields>;
  stddev?: Maybe<Mnet_Personnel_Profile_Badges_Stddev_Fields>;
  stddev_pop?: Maybe<Mnet_Personnel_Profile_Badges_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mnet_Personnel_Profile_Badges_Stddev_Samp_Fields>;
  sum?: Maybe<Mnet_Personnel_Profile_Badges_Sum_Fields>;
  var_pop?: Maybe<Mnet_Personnel_Profile_Badges_Var_Pop_Fields>;
  var_samp?: Maybe<Mnet_Personnel_Profile_Badges_Var_Samp_Fields>;
  variance?: Maybe<Mnet_Personnel_Profile_Badges_Variance_Fields>;
};

/** aggregate fields of "mnet.personnel_profile_badges" */
export type Mnet_Personnel_Profile_Badges_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Personnel_Profile_Badges_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mnet_Personnel_Profile_Badges_Avg_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mnet.personnel_profile_badges". All fields are combined with a logical 'AND'. */
export type Mnet_Personnel_Profile_Badges_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Personnel_Profile_Badges_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Personnel_Profile_Badges_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Personnel_Profile_Badges_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  ad_system_id?: InputMaybe<Citext_Comparison_Exp>;
  badge_id?: InputMaybe<Citext_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  eligible?: InputMaybe<Boolean_Comparison_Exp>;
  email?: InputMaybe<Citext_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mnet_Personnel_Profile_Badges_Max_Fields = {
  ad_system_id?: Maybe<Scalars['citext']['output']>;
  badge_id?: Maybe<Scalars['citext']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Mnet_Personnel_Profile_Badges_Min_Fields = {
  ad_system_id?: Maybe<Scalars['citext']['output']>;
  badge_id?: Maybe<Scalars['citext']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "mnet.personnel_profile_badges". */
export type Mnet_Personnel_Profile_Badges_Order_By = {
  active?: InputMaybe<Order_By>;
  ad_system_id?: InputMaybe<Order_By>;
  badge_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  eligible?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.personnel_profile_badges" */
export enum Mnet_Personnel_Profile_Badges_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Ad_system_id = 'ad_system_id',
  /** column name */
  Badge_id = 'badge_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Eligible = 'eligible',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Updated_at = 'updated_at',
}

/** aggregate stddev on columns */
export type Mnet_Personnel_Profile_Badges_Stddev_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mnet_Personnel_Profile_Badges_Stddev_Pop_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mnet_Personnel_Profile_Badges_Stddev_Samp_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mnet_personnel_profile_badges" */
export type Mnet_Personnel_Profile_Badges_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Personnel_Profile_Badges_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Personnel_Profile_Badges_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  ad_system_id?: InputMaybe<Scalars['citext']['input']>;
  badge_id?: InputMaybe<Scalars['citext']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  eligible?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Mnet_Personnel_Profile_Badges_Sum_Fields = {
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Mnet_Personnel_Profile_Badges_Var_Pop_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mnet_Personnel_Profile_Badges_Var_Samp_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mnet_Personnel_Profile_Badges_Variance_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mnet.practice_area_detail" */
export type Mnet_Practice_Area_Detail = {
  PracticeArea?: Maybe<Mlfsl_Practicegroup>;
  created_at: Scalars['timestamptz']['output'];
  practice_area_code: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  url: Scalars['String']['output'];
};

/** aggregated selection of "mnet.practice_area_detail" */
export type Mnet_Practice_Area_Detail_Aggregate = {
  aggregate?: Maybe<Mnet_Practice_Area_Detail_Aggregate_Fields>;
  nodes: Array<Mnet_Practice_Area_Detail>;
};

/** aggregate fields of "mnet.practice_area_detail" */
export type Mnet_Practice_Area_Detail_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Practice_Area_Detail_Max_Fields>;
  min?: Maybe<Mnet_Practice_Area_Detail_Min_Fields>;
};

/** aggregate fields of "mnet.practice_area_detail" */
export type Mnet_Practice_Area_Detail_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Practice_Area_Detail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "mnet.practice_area_detail". All fields are combined with a logical 'AND'. */
export type Mnet_Practice_Area_Detail_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Practice_Area_Detail_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Practice_Area_Detail_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Practice_Area_Detail_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  practice_area_code?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mnet_Practice_Area_Detail_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  practice_area_code?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mnet_Practice_Area_Detail_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  practice_area_code?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "mnet.practice_area_detail". */
export type Mnet_Practice_Area_Detail_Order_By = {
  created_at?: InputMaybe<Order_By>;
  practice_area_code?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.practice_area_detail" */
export enum Mnet_Practice_Area_Detail_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Practice_area_code = 'practice_area_code',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Url = 'url',
}

/** Streaming cursor of the table "mnet_practice_area_detail" */
export type Mnet_Practice_Area_Detail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Practice_Area_Detail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Practice_Area_Detail_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  practice_area_code?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "mnet.practice_group_detail" */
export type Mnet_Practice_Group_Detail = {
  PracticeGroup?: Maybe<Mlfsl_Practicegroup>;
  created_at: Scalars['timestamptz']['output'];
  practice_group_code: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  url: Scalars['String']['output'];
};

/** aggregated selection of "mnet.practice_group_detail" */
export type Mnet_Practice_Group_Detail_Aggregate = {
  aggregate?: Maybe<Mnet_Practice_Group_Detail_Aggregate_Fields>;
  nodes: Array<Mnet_Practice_Group_Detail>;
};

/** aggregate fields of "mnet.practice_group_detail" */
export type Mnet_Practice_Group_Detail_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Practice_Group_Detail_Max_Fields>;
  min?: Maybe<Mnet_Practice_Group_Detail_Min_Fields>;
};

/** aggregate fields of "mnet.practice_group_detail" */
export type Mnet_Practice_Group_Detail_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Practice_Group_Detail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "mnet.practice_group_detail". All fields are combined with a logical 'AND'. */
export type Mnet_Practice_Group_Detail_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Practice_Group_Detail_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Practice_Group_Detail_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Practice_Group_Detail_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  practice_group_code?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mnet_Practice_Group_Detail_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  practice_group_code?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mnet_Practice_Group_Detail_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  practice_group_code?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "mnet.practice_group_detail". */
export type Mnet_Practice_Group_Detail_Order_By = {
  created_at?: InputMaybe<Order_By>;
  practice_group_code?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.practice_group_detail" */
export enum Mnet_Practice_Group_Detail_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Practice_group_code = 'practice_group_code',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Url = 'url',
}

/** Streaming cursor of the table "mnet_practice_group_detail" */
export type Mnet_Practice_Group_Detail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Practice_Group_Detail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Practice_Group_Detail_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  practice_group_code?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "mnet.user_link" */
export type Mnet_User_Link = {
  activedirectorylogin: Scalars['String']['output'];
  end_date: Scalars['timestamptz']['output'];
  mlfsl_personnel?: Maybe<Mlfsl_Personnel>;
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  start_date: Scalars['timestamptz']['output'];
  url: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "mnet.user_link". All fields are combined with a logical 'AND'. */
export type Mnet_User_Link_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_User_Link_Bool_Exp>>;
  _not?: InputMaybe<Mnet_User_Link_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_User_Link_Bool_Exp>>;
  activedirectorylogin?: InputMaybe<String_Comparison_Exp>;
  end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  priority?: InputMaybe<Int_Comparison_Exp>;
  start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "mnet.user_link". */
export type Mnet_User_Link_Order_By = {
  activedirectorylogin?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.user_link" */
export enum Mnet_User_Link_Select_Column {
  /** column name */
  Activedirectorylogin = 'activedirectorylogin',
  /** column name */
  End_date = 'end_date',
  /** column name */
  Name = 'name',
  /** column name */
  Priority = 'priority',
  /** column name */
  Start_date = 'start_date',
  /** column name */
  Url = 'url',
}

/** Streaming cursor of the table "mnet_user_link" */
export type Mnet_User_Link_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_User_Link_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_User_Link_Stream_Cursor_Value_Input = {
  activedirectorylogin?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "mnet.wellable_leaderboard" */
export type Mnet_Wellable_Leaderboard = {
  created_at: Scalars['timestamptz']['output'];
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  last_name: Scalars['String']['output'];
  office_name: Scalars['String']['output'];
  team: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['Int']['output'];
  wellable_points: Scalars['Int']['output'];
};

/** aggregated selection of "mnet.wellable_leaderboard" */
export type Mnet_Wellable_Leaderboard_Aggregate = {
  aggregate?: Maybe<Mnet_Wellable_Leaderboard_Aggregate_Fields>;
  nodes: Array<Mnet_Wellable_Leaderboard>;
};

/** aggregate fields of "mnet.wellable_leaderboard" */
export type Mnet_Wellable_Leaderboard_Aggregate_Fields = {
  avg?: Maybe<Mnet_Wellable_Leaderboard_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mnet_Wellable_Leaderboard_Max_Fields>;
  min?: Maybe<Mnet_Wellable_Leaderboard_Min_Fields>;
  stddev?: Maybe<Mnet_Wellable_Leaderboard_Stddev_Fields>;
  stddev_pop?: Maybe<Mnet_Wellable_Leaderboard_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mnet_Wellable_Leaderboard_Stddev_Samp_Fields>;
  sum?: Maybe<Mnet_Wellable_Leaderboard_Sum_Fields>;
  var_pop?: Maybe<Mnet_Wellable_Leaderboard_Var_Pop_Fields>;
  var_samp?: Maybe<Mnet_Wellable_Leaderboard_Var_Samp_Fields>;
  variance?: Maybe<Mnet_Wellable_Leaderboard_Variance_Fields>;
};

/** aggregate fields of "mnet.wellable_leaderboard" */
export type Mnet_Wellable_Leaderboard_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mnet_Wellable_Leaderboard_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mnet_Wellable_Leaderboard_Avg_Fields = {
  user_id?: Maybe<Scalars['Float']['output']>;
  wellable_points?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mnet.wellable_leaderboard". All fields are combined with a logical 'AND'. */
export type Mnet_Wellable_Leaderboard_Bool_Exp = {
  _and?: InputMaybe<Array<Mnet_Wellable_Leaderboard_Bool_Exp>>;
  _not?: InputMaybe<Mnet_Wellable_Leaderboard_Bool_Exp>;
  _or?: InputMaybe<Array<Mnet_Wellable_Leaderboard_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  office_name?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  wellable_points?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mnet_Wellable_Leaderboard_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  office_name?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  wellable_points?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Mnet_Wellable_Leaderboard_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  office_name?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  wellable_points?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "mnet.wellable_leaderboard". */
export type Mnet_Wellable_Leaderboard_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  office_name?: InputMaybe<Order_By>;
  team?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  wellable_points?: InputMaybe<Order_By>;
};

/** select columns of table "mnet.wellable_leaderboard" */
export enum Mnet_Wellable_Leaderboard_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  First_name = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  Last_name = 'last_name',
  /** column name */
  Office_name = 'office_name',
  /** column name */
  Team = 'team',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  User_id = 'user_id',
  /** column name */
  Wellable_points = 'wellable_points',
}

/** aggregate stddev on columns */
export type Mnet_Wellable_Leaderboard_Stddev_Fields = {
  user_id?: Maybe<Scalars['Float']['output']>;
  wellable_points?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mnet_Wellable_Leaderboard_Stddev_Pop_Fields = {
  user_id?: Maybe<Scalars['Float']['output']>;
  wellable_points?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mnet_Wellable_Leaderboard_Stddev_Samp_Fields = {
  user_id?: Maybe<Scalars['Float']['output']>;
  wellable_points?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mnet_wellable_leaderboard" */
export type Mnet_Wellable_Leaderboard_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mnet_Wellable_Leaderboard_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mnet_Wellable_Leaderboard_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  office_name?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  wellable_points?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Mnet_Wellable_Leaderboard_Sum_Fields = {
  user_id?: Maybe<Scalars['Int']['output']>;
  wellable_points?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Mnet_Wellable_Leaderboard_Var_Pop_Fields = {
  user_id?: Maybe<Scalars['Float']['output']>;
  wellable_points?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mnet_Wellable_Leaderboard_Var_Samp_Fields = {
  user_id?: Maybe<Scalars['Float']['output']>;
  wellable_points?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mnet_Wellable_Leaderboard_Variance_Fields = {
  user_id?: Maybe<Scalars['Float']['output']>;
  wellable_points?: Maybe<Scalars['Float']['output']>;
};

/** mutation root */
export type Mutation_Root = {
  addBucket: AddBucketPayload;
  addTask: AddTaskPayload;
  createGuestUserInvitation: CreateGuestUserInvitationPayload;
  /** An asynchronous method designed to create a new list item within a SharePoint list or library. It returns the newly created list item. */
  createListItem: CreateListItemPayload;
  deleteBucket: DeleteBucketPayload;
  /** An asynchronous method responsible for deleting a specific list item within a SharePoint list or library. It returns the ID of the deleted list item. */
  deleteListItem: DeleteListItemPayload;
  deleteTask: DeleteTaskPayload;
  /** delete data from the table: "b2b.external_accounts" */
  delete_b2b_external_accounts?: Maybe<B2b_External_Accounts_Mutation_Response>;
  /** delete single row from the table: "b2b.external_accounts" */
  delete_b2b_external_accounts_by_pk?: Maybe<B2b_External_Accounts>;
  /** delete data from the table: "b2b.ml_sponsor_references" */
  delete_b2b_ml_sponsor_references?: Maybe<B2b_Ml_Sponsor_References_Mutation_Response>;
  /** delete single row from the table: "b2b.ml_sponsor_references" */
  delete_b2b_ml_sponsor_references_by_pk?: Maybe<B2b_Ml_Sponsor_References>;
  /** delete data from the table: "b2b.requests" */
  delete_b2b_requests?: Maybe<B2b_Requests_Mutation_Response>;
  /** delete single row from the table: "b2b.requests" */
  delete_b2b_requests_by_pk?: Maybe<B2b_Requests>;
  /** delete data from the table: "b2b.resource_owner_references" */
  delete_b2b_resource_owner_references?: Maybe<B2b_Resource_Owner_References_Mutation_Response>;
  /** delete single row from the table: "b2b.resource_owner_references" */
  delete_b2b_resource_owner_references_by_pk?: Maybe<B2b_Resource_Owner_References>;
  /** delete data from the table: "clm.engagement_client_comments" */
  delete_clm_engagement_client_comments?: Maybe<Clm_Engagement_Client_Comments_Mutation_Response>;
  /** delete single row from the table: "clm.engagement_client_comments" */
  delete_clm_engagement_client_comments_by_pk?: Maybe<Clm_Engagement_Client_Comments>;
  /** delete data from the table: "clm.engagement_imanage_documents" */
  delete_clm_engagement_imanage_documents?: Maybe<Clm_Engagement_Imanage_Documents_Mutation_Response>;
  /** delete single row from the table: "clm.engagement_imanage_documents" */
  delete_clm_engagement_imanage_documents_by_pk?: Maybe<Clm_Engagement_Imanage_Documents>;
  /** delete data from the table: "clm.engagement_records" */
  delete_clm_engagement_records?: Maybe<Clm_Engagement_Records_Mutation_Response>;
  /** delete single row from the table: "clm.engagement_records" */
  delete_clm_engagement_records_by_pk?: Maybe<Clm_Engagement_Records>;
  /** delete data from the table: "clm.views" */
  delete_clm_views?: Maybe<Clm_Views_Mutation_Response>;
  /** delete single row from the table: "clm.views" */
  delete_clm_views_by_pk?: Maybe<Clm_Views>;
  /** delete data from the table: "fd.email_templates" */
  delete_fd_email_templates?: Maybe<Fd_Email_Templates_Mutation_Response>;
  /** delete single row from the table: "fd.email_templates" */
  delete_fd_email_templates_by_pk?: Maybe<Fd_Email_Templates>;
  /** delete data from the table: "fd.exempt_matters" */
  delete_fd_exempt_matters?: Maybe<Fd_Exempt_Matters_Mutation_Response>;
  /** delete single row from the table: "fd.exempt_matters" */
  delete_fd_exempt_matters_by_pk?: Maybe<Fd_Exempt_Matters>;
  /** delete data from the table: "fd.instruction_templates" */
  delete_fd_instruction_templates?: Maybe<Fd_Instruction_Templates_Mutation_Response>;
  /** delete single row from the table: "fd.instruction_templates" */
  delete_fd_instruction_templates_by_pk?: Maybe<Fd_Instruction_Templates>;
  /** delete data from the table: "fd.matters_responses" */
  delete_fd_matters_responses?: Maybe<Fd_Matters_Responses_Mutation_Response>;
  /** delete single row from the table: "fd.matters_responses" */
  delete_fd_matters_responses_by_pk?: Maybe<Fd_Matters_Responses>;
  /** delete data from the table: "fd.project_access" */
  delete_fd_project_access?: Maybe<Fd_Project_Access_Mutation_Response>;
  /** delete single row from the table: "fd.project_access" */
  delete_fd_project_access_by_pk?: Maybe<Fd_Project_Access>;
  /** delete data from the table: "fd.project_number_counter" */
  delete_fd_project_number_counter?: Maybe<Fd_Project_Number_Counter_Mutation_Response>;
  /** delete single row from the table: "fd.project_number_counter" */
  delete_fd_project_number_counter_by_pk?: Maybe<Fd_Project_Number_Counter>;
  /** delete data from the table: "fd.projects" */
  delete_fd_projects?: Maybe<Fd_Projects_Mutation_Response>;
  /** delete single row from the table: "fd.projects" */
  delete_fd_projects_by_pk?: Maybe<Fd_Projects>;
  /** delete data from the table: "fd.response_in_projects" */
  delete_fd_response_in_projects?: Maybe<Fd_Response_In_Projects_Mutation_Response>;
  /** delete single row from the table: "fd.response_in_projects" */
  delete_fd_response_in_projects_by_pk?: Maybe<Fd_Response_In_Projects>;
  /** delete data from the table: "fd.responses" */
  delete_fd_responses?: Maybe<Fd_Responses_Mutation_Response>;
  /** delete single row from the table: "fd.responses" */
  delete_fd_responses_by_pk?: Maybe<Fd_Responses>;
  /** delete data from the table: "ftp.request" */
  delete_ftp_request?: Maybe<Ftp_Request_Mutation_Response>;
  /** delete single row from the table: "ftp.request" */
  delete_ftp_request_by_pk?: Maybe<Ftp_Request>;
  /** delete data from the table: "ftp.request_detail" */
  delete_ftp_request_detail?: Maybe<Ftp_Request_Detail_Mutation_Response>;
  /** delete single row from the table: "ftp.request_detail" */
  delete_ftp_request_detail_by_pk?: Maybe<Ftp_Request_Detail>;
  /** delete data from the table: "ftp.request_external_access" */
  delete_ftp_request_external_access?: Maybe<Ftp_Request_External_Access_Mutation_Response>;
  /** delete single row from the table: "ftp.request_external_access" */
  delete_ftp_request_external_access_by_pk?: Maybe<Ftp_Request_External_Access>;
  /** delete data from the table: "ftp.request_external_note" */
  delete_ftp_request_external_note?: Maybe<Ftp_Request_External_Note_Mutation_Response>;
  /** delete single row from the table: "ftp.request_external_note" */
  delete_ftp_request_external_note_by_pk?: Maybe<Ftp_Request_External_Note>;
  /** delete data from the table: "ftp.request_internal_note" */
  delete_ftp_request_internal_note?: Maybe<Ftp_Request_Internal_Note_Mutation_Response>;
  /** delete single row from the table: "ftp.request_internal_note" */
  delete_ftp_request_internal_note_by_pk?: Maybe<Ftp_Request_Internal_Note>;
  /** delete data from the table: "ftp.request_number_counter" */
  delete_ftp_request_number_counter?: Maybe<Ftp_Request_Number_Counter_Mutation_Response>;
  /** delete single row from the table: "ftp.request_number_counter" */
  delete_ftp_request_number_counter_by_pk?: Maybe<Ftp_Request_Number_Counter>;
  /** delete data from the table: "ftp.request_participant" */
  delete_ftp_request_participant?: Maybe<Ftp_Request_Participant_Mutation_Response>;
  /** delete single row from the table: "ftp.request_participant" */
  delete_ftp_request_participant_by_pk?: Maybe<Ftp_Request_Participant>;
  /** delete data from the table: "gec.audience_in_event" */
  delete_gec_audience_in_event?: Maybe<Gec_Audience_In_Event_Mutation_Response>;
  /** delete single row from the table: "gec.audience_in_event" */
  delete_gec_audience_in_event_by_pk?: Maybe<Gec_Audience_In_Event>;
  /** delete data from the table: "gec.contact_in_event" */
  delete_gec_contact_in_event?: Maybe<Gec_Contact_In_Event_Mutation_Response>;
  /** delete single row from the table: "gec.contact_in_event" */
  delete_gec_contact_in_event_by_pk?: Maybe<Gec_Contact_In_Event>;
  /** delete data from the table: "gec.departments_in_event" */
  delete_gec_departments_in_event?: Maybe<Gec_Departments_In_Event_Mutation_Response>;
  /** delete single row from the table: "gec.departments_in_event" */
  delete_gec_departments_in_event_by_pk?: Maybe<Gec_Departments_In_Event>;
  /** delete data from the table: "gec.event_exception" */
  delete_gec_event_exception?: Maybe<Gec_Event_Exception_Mutation_Response>;
  /** delete single row from the table: "gec.event_exception" */
  delete_gec_event_exception_by_pk?: Maybe<Gec_Event_Exception>;
  /** delete data from the table: "gec.events" */
  delete_gec_events?: Maybe<Gec_Events_Mutation_Response>;
  /** delete single row from the table: "gec.events" */
  delete_gec_events_by_pk?: Maybe<Gec_Events>;
  /** delete data from the table: "gec.firm_initiatives_in_event" */
  delete_gec_firm_initiatives_in_event?: Maybe<Gec_Firm_Initiatives_In_Event_Mutation_Response>;
  /** delete single row from the table: "gec.firm_initiatives_in_event" */
  delete_gec_firm_initiatives_in_event_by_pk?: Maybe<Gec_Firm_Initiatives_In_Event>;
  /** delete data from the table: "gec.industries_in_event" */
  delete_gec_industries_in_event?: Maybe<Gec_Industries_In_Event_Mutation_Response>;
  /** delete single row from the table: "gec.industries_in_event" */
  delete_gec_industries_in_event_by_pk?: Maybe<Gec_Industries_In_Event>;
  /** delete data from the table: "gec.office_visibility_in_event" */
  delete_gec_office_visibility_in_event?: Maybe<Gec_Office_Visibility_In_Event_Mutation_Response>;
  /** delete single row from the table: "gec.office_visibility_in_event" */
  delete_gec_office_visibility_in_event_by_pk?: Maybe<Gec_Office_Visibility_In_Event>;
  /** delete data from the table: "gec.offices_in_event" */
  delete_gec_offices_in_event?: Maybe<Gec_Offices_In_Event_Mutation_Response>;
  /** delete single row from the table: "gec.offices_in_event" */
  delete_gec_offices_in_event_by_pk?: Maybe<Gec_Offices_In_Event>;
  /** delete data from the table: "gec.outside_speakers" */
  delete_gec_outside_speakers?: Maybe<Gec_Outside_Speakers_Mutation_Response>;
  /** delete single row from the table: "gec.outside_speakers" */
  delete_gec_outside_speakers_by_pk?: Maybe<Gec_Outside_Speakers>;
  /** delete data from the table: "gec.practice_groups_in_event" */
  delete_gec_practice_groups_in_event?: Maybe<Gec_Practice_Groups_In_Event_Mutation_Response>;
  /** delete single row from the table: "gec.practice_groups_in_event" */
  delete_gec_practice_groups_in_event_by_pk?: Maybe<Gec_Practice_Groups_In_Event>;
  /** delete data from the table: "gec.speaker_in_event" */
  delete_gec_speaker_in_event?: Maybe<Gec_Speaker_In_Event_Mutation_Response>;
  /** delete single row from the table: "gec.speaker_in_event" */
  delete_gec_speaker_in_event_by_pk?: Maybe<Gec_Speaker_In_Event>;
  /** delete data from the table: "gec.sponsoring_attorney_in_event" */
  delete_gec_sponsoring_attorney_in_event?: Maybe<Gec_Sponsoring_Attorney_In_Event_Mutation_Response>;
  /** delete single row from the table: "gec.sponsoring_attorney_in_event" */
  delete_gec_sponsoring_attorney_in_event_by_pk?: Maybe<Gec_Sponsoring_Attorney_In_Event>;
  /** delete data from the table: "mnet_assignmentportal.my_availability" */
  delete_mnet_assignmentportal_my_availability?: Maybe<Mnet_Assignmentportal_My_Availability_Mutation_Response>;
  /** delete single row from the table: "mnet_assignmentportal.my_availability" */
  delete_mnet_assignmentportal_my_availability_by_pk?: Maybe<Mnet_Assignmentportal_My_Availability>;
  /** delete data from the table: "mnet_blog.attachments" */
  delete_mnet_blog_attachments?: Maybe<Mnet_Blog_Attachments_Mutation_Response>;
  /** delete single row from the table: "mnet_blog.attachments" */
  delete_mnet_blog_attachments_by_pk?: Maybe<Mnet_Blog_Attachments>;
  /** delete data from the table: "mnet_blog.blogs" */
  delete_mnet_blog_blogs?: Maybe<Mnet_Blog_Blogs_Mutation_Response>;
  /** delete single row from the table: "mnet_blog.blogs" */
  delete_mnet_blog_blogs_by_pk?: Maybe<Mnet_Blog_Blogs>;
  /** delete data from the table: "mnet_blog.channel_notifications" */
  delete_mnet_blog_channel_notifications?: Maybe<Mnet_Blog_Channel_Notifications_Mutation_Response>;
  /** delete single row from the table: "mnet_blog.channel_notifications" */
  delete_mnet_blog_channel_notifications_by_pk?: Maybe<Mnet_Blog_Channel_Notifications>;
  /** delete data from the table: "mnet_blog.channels" */
  delete_mnet_blog_channels?: Maybe<Mnet_Blog_Channels_Mutation_Response>;
  /** delete single row from the table: "mnet_blog.channels" */
  delete_mnet_blog_channels_by_pk?: Maybe<Mnet_Blog_Channels>;
  /** delete data from the table: "mnet_blog.comment_reactions" */
  delete_mnet_blog_comment_reactions?: Maybe<Mnet_Blog_Comment_Reactions_Mutation_Response>;
  /** delete single row from the table: "mnet_blog.comment_reactions" */
  delete_mnet_blog_comment_reactions_by_pk?: Maybe<Mnet_Blog_Comment_Reactions>;
  /** delete data from the table: "mnet_blog.comments" */
  delete_mnet_blog_comments?: Maybe<Mnet_Blog_Comments_Mutation_Response>;
  /** delete single row from the table: "mnet_blog.comments" */
  delete_mnet_blog_comments_by_pk?: Maybe<Mnet_Blog_Comments>;
  /** delete data from the table: "mnet_blog.email_notifications" */
  delete_mnet_blog_email_notifications?: Maybe<Mnet_Blog_Email_Notifications_Mutation_Response>;
  /** delete single row from the table: "mnet_blog.email_notifications" */
  delete_mnet_blog_email_notifications_by_pk?: Maybe<Mnet_Blog_Email_Notifications>;
  /** delete data from the table: "mnet_blog.email_templates" */
  delete_mnet_blog_email_templates?: Maybe<Mnet_Blog_Email_Templates_Mutation_Response>;
  /** delete single row from the table: "mnet_blog.email_templates" */
  delete_mnet_blog_email_templates_by_pk?: Maybe<Mnet_Blog_Email_Templates>;
  /** delete data from the table: "mnet_blog.events" */
  delete_mnet_blog_events?: Maybe<Mnet_Blog_Events_Mutation_Response>;
  /** delete single row from the table: "mnet_blog.events" */
  delete_mnet_blog_events_by_pk?: Maybe<Mnet_Blog_Events>;
  /** delete data from the table: "mnet_blog.group_in_blogs" */
  delete_mnet_blog_group_in_blogs?: Maybe<Mnet_Blog_Group_In_Blogs_Mutation_Response>;
  /** delete single row from the table: "mnet_blog.group_in_blogs" */
  delete_mnet_blog_group_in_blogs_by_pk?: Maybe<Mnet_Blog_Group_In_Blogs>;
  /** delete data from the table: "mnet_blog.inbound_emails" */
  delete_mnet_blog_inbound_emails?: Maybe<Mnet_Blog_Inbound_Emails_Mutation_Response>;
  /** delete single row from the table: "mnet_blog.inbound_emails" */
  delete_mnet_blog_inbound_emails_by_pk?: Maybe<Mnet_Blog_Inbound_Emails>;
  /** delete data from the table: "mnet_blog.notification_recipients" */
  delete_mnet_blog_notification_recipients?: Maybe<Mnet_Blog_Notification_Recipients_Mutation_Response>;
  /** delete single row from the table: "mnet_blog.notification_recipients" */
  delete_mnet_blog_notification_recipients_by_pk?: Maybe<Mnet_Blog_Notification_Recipients>;
  /** delete data from the table: "mnet_blog.notification_template_rules" */
  delete_mnet_blog_notification_template_rules?: Maybe<Mnet_Blog_Notification_Template_Rules_Mutation_Response>;
  /** delete single row from the table: "mnet_blog.notification_template_rules" */
  delete_mnet_blog_notification_template_rules_by_pk?: Maybe<Mnet_Blog_Notification_Template_Rules>;
  /** delete data from the table: "mnet_blog.post_channels" */
  delete_mnet_blog_post_channels?: Maybe<Mnet_Blog_Post_Channels_Mutation_Response>;
  /** delete single row from the table: "mnet_blog.post_channels" */
  delete_mnet_blog_post_channels_by_pk?: Maybe<Mnet_Blog_Post_Channels>;
  /** delete data from the table: "mnet_blog.post_images" */
  delete_mnet_blog_post_images?: Maybe<Mnet_Blog_Post_Images_Mutation_Response>;
  /** delete single row from the table: "mnet_blog.post_images" */
  delete_mnet_blog_post_images_by_pk?: Maybe<Mnet_Blog_Post_Images>;
  /** delete data from the table: "mnet_blog.post_reactions" */
  delete_mnet_blog_post_reactions?: Maybe<Mnet_Blog_Post_Reactions_Mutation_Response>;
  /** delete single row from the table: "mnet_blog.post_reactions" */
  delete_mnet_blog_post_reactions_by_pk?: Maybe<Mnet_Blog_Post_Reactions>;
  /** delete data from the table: "mnet_blog.posts" */
  delete_mnet_blog_posts?: Maybe<Mnet_Blog_Posts_Mutation_Response>;
  /** delete single row from the table: "mnet_blog.posts" */
  delete_mnet_blog_posts_by_pk?: Maybe<Mnet_Blog_Posts>;
  /** delete data from the table: "mnet.mytools_user_tool" */
  delete_mnet_mytools_user_tool?: Maybe<Mnet_Mytools_User_Tool_Mutation_Response>;
  /** delete single row from the table: "mnet.mytools_user_tool" */
  delete_mnet_mytools_user_tool_by_pk?: Maybe<Mnet_Mytools_User_Tool>;
  /** delete data from the table: "pbc.counsel_representatives" */
  delete_pbc_counsel_representatives?: Maybe<Pbc_Counsel_Representatives_Mutation_Response>;
  /** delete single row from the table: "pbc.counsel_representatives" */
  delete_pbc_counsel_representatives_by_pk?: Maybe<Pbc_Counsel_Representatives>;
  /** delete data from the table: "pbc.email_templates" */
  delete_pbc_email_templates?: Maybe<Pbc_Email_Templates_Mutation_Response>;
  /** delete single row from the table: "pbc.email_templates" */
  delete_pbc_email_templates_by_pk?: Maybe<Pbc_Email_Templates>;
  /** delete data from the table: "pbc.exempt_users" */
  delete_pbc_exempt_users?: Maybe<Pbc_Exempt_Users_Mutation_Response>;
  /** delete single row from the table: "pbc.exempt_users" */
  delete_pbc_exempt_users_by_pk?: Maybe<Pbc_Exempt_Users>;
  /** delete data from the table: "pbc.notification_recipients" */
  delete_pbc_notification_recipients?: Maybe<Pbc_Notification_Recipients_Mutation_Response>;
  /** delete single row from the table: "pbc.notification_recipients" */
  delete_pbc_notification_recipients_by_pk?: Maybe<Pbc_Notification_Recipients>;
  /** delete data from the table: "pbc.notification_requests" */
  delete_pbc_notification_requests?: Maybe<Pbc_Notification_Requests_Mutation_Response>;
  /** delete single row from the table: "pbc.notification_requests" */
  delete_pbc_notification_requests_by_pk?: Maybe<Pbc_Notification_Requests>;
  /** delete data from the table: "pbc.senders" */
  delete_pbc_senders?: Maybe<Pbc_Senders_Mutation_Response>;
  /** delete single row from the table: "pbc.senders" */
  delete_pbc_senders_by_pk?: Maybe<Pbc_Senders>;
  /** insert data into the table: "b2b.external_accounts" */
  insert_b2b_external_accounts?: Maybe<B2b_External_Accounts_Mutation_Response>;
  /** insert a single row into the table: "b2b.external_accounts" */
  insert_b2b_external_accounts_one?: Maybe<B2b_External_Accounts>;
  /** insert data into the table: "b2b.logs" */
  insert_b2b_logs?: Maybe<B2b_Logs_Mutation_Response>;
  /** insert a single row into the table: "b2b.logs" */
  insert_b2b_logs_one?: Maybe<B2b_Logs>;
  /** insert data into the table: "b2b.ml_sponsor_references" */
  insert_b2b_ml_sponsor_references?: Maybe<B2b_Ml_Sponsor_References_Mutation_Response>;
  /** insert a single row into the table: "b2b.ml_sponsor_references" */
  insert_b2b_ml_sponsor_references_one?: Maybe<B2b_Ml_Sponsor_References>;
  /** insert data into the table: "b2b.requests" */
  insert_b2b_requests?: Maybe<B2b_Requests_Mutation_Response>;
  /** insert a single row into the table: "b2b.requests" */
  insert_b2b_requests_one?: Maybe<B2b_Requests>;
  /** insert data into the table: "b2b.resource_owner_references" */
  insert_b2b_resource_owner_references?: Maybe<B2b_Resource_Owner_References_Mutation_Response>;
  /** insert a single row into the table: "b2b.resource_owner_references" */
  insert_b2b_resource_owner_references_one?: Maybe<B2b_Resource_Owner_References>;
  /** insert data into the table: "clm.engagement_client_comments" */
  insert_clm_engagement_client_comments?: Maybe<Clm_Engagement_Client_Comments_Mutation_Response>;
  /** insert a single row into the table: "clm.engagement_client_comments" */
  insert_clm_engagement_client_comments_one?: Maybe<Clm_Engagement_Client_Comments>;
  /** insert data into the table: "clm.engagement_imanage_documents" */
  insert_clm_engagement_imanage_documents?: Maybe<Clm_Engagement_Imanage_Documents_Mutation_Response>;
  /** insert a single row into the table: "clm.engagement_imanage_documents" */
  insert_clm_engagement_imanage_documents_one?: Maybe<Clm_Engagement_Imanage_Documents>;
  /** insert data into the table: "clm.engagement_records" */
  insert_clm_engagement_records?: Maybe<Clm_Engagement_Records_Mutation_Response>;
  /** insert a single row into the table: "clm.engagement_records" */
  insert_clm_engagement_records_one?: Maybe<Clm_Engagement_Records>;
  /** insert data into the table: "clm.views" */
  insert_clm_views?: Maybe<Clm_Views_Mutation_Response>;
  /** insert a single row into the table: "clm.views" */
  insert_clm_views_one?: Maybe<Clm_Views>;
  /** insert data into the table: "fd.email_templates" */
  insert_fd_email_templates?: Maybe<Fd_Email_Templates_Mutation_Response>;
  /** insert a single row into the table: "fd.email_templates" */
  insert_fd_email_templates_one?: Maybe<Fd_Email_Templates>;
  /** insert data into the table: "fd.exempt_matters" */
  insert_fd_exempt_matters?: Maybe<Fd_Exempt_Matters_Mutation_Response>;
  /** insert a single row into the table: "fd.exempt_matters" */
  insert_fd_exempt_matters_one?: Maybe<Fd_Exempt_Matters>;
  /** insert data into the table: "fd.instruction_templates" */
  insert_fd_instruction_templates?: Maybe<Fd_Instruction_Templates_Mutation_Response>;
  /** insert a single row into the table: "fd.instruction_templates" */
  insert_fd_instruction_templates_one?: Maybe<Fd_Instruction_Templates>;
  /** insert data into the table: "fd.matters_responses" */
  insert_fd_matters_responses?: Maybe<Fd_Matters_Responses_Mutation_Response>;
  /** insert a single row into the table: "fd.matters_responses" */
  insert_fd_matters_responses_one?: Maybe<Fd_Matters_Responses>;
  /** insert data into the table: "fd.project_access" */
  insert_fd_project_access?: Maybe<Fd_Project_Access_Mutation_Response>;
  /** insert a single row into the table: "fd.project_access" */
  insert_fd_project_access_one?: Maybe<Fd_Project_Access>;
  /** insert data into the table: "fd.project_number_counter" */
  insert_fd_project_number_counter?: Maybe<Fd_Project_Number_Counter_Mutation_Response>;
  /** insert a single row into the table: "fd.project_number_counter" */
  insert_fd_project_number_counter_one?: Maybe<Fd_Project_Number_Counter>;
  /** insert data into the table: "fd.projects" */
  insert_fd_projects?: Maybe<Fd_Projects_Mutation_Response>;
  /** insert a single row into the table: "fd.projects" */
  insert_fd_projects_one?: Maybe<Fd_Projects>;
  /** insert data into the table: "fd.response_in_projects" */
  insert_fd_response_in_projects?: Maybe<Fd_Response_In_Projects_Mutation_Response>;
  /** insert a single row into the table: "fd.response_in_projects" */
  insert_fd_response_in_projects_one?: Maybe<Fd_Response_In_Projects>;
  /** insert data into the table: "fd.responses" */
  insert_fd_responses?: Maybe<Fd_Responses_Mutation_Response>;
  /** insert a single row into the table: "fd.responses" */
  insert_fd_responses_one?: Maybe<Fd_Responses>;
  /** insert data into the table: "ftp.request" */
  insert_ftp_request?: Maybe<Ftp_Request_Mutation_Response>;
  /** insert data into the table: "ftp.request_detail" */
  insert_ftp_request_detail?: Maybe<Ftp_Request_Detail_Mutation_Response>;
  /** insert a single row into the table: "ftp.request_detail" */
  insert_ftp_request_detail_one?: Maybe<Ftp_Request_Detail>;
  /** insert data into the table: "ftp.request_external_access" */
  insert_ftp_request_external_access?: Maybe<Ftp_Request_External_Access_Mutation_Response>;
  /** insert a single row into the table: "ftp.request_external_access" */
  insert_ftp_request_external_access_one?: Maybe<Ftp_Request_External_Access>;
  /** insert data into the table: "ftp.request_external_note" */
  insert_ftp_request_external_note?: Maybe<Ftp_Request_External_Note_Mutation_Response>;
  /** insert a single row into the table: "ftp.request_external_note" */
  insert_ftp_request_external_note_one?: Maybe<Ftp_Request_External_Note>;
  /** insert data into the table: "ftp.request_internal_note" */
  insert_ftp_request_internal_note?: Maybe<Ftp_Request_Internal_Note_Mutation_Response>;
  /** insert a single row into the table: "ftp.request_internal_note" */
  insert_ftp_request_internal_note_one?: Maybe<Ftp_Request_Internal_Note>;
  /** insert data into the table: "ftp.request_number_counter" */
  insert_ftp_request_number_counter?: Maybe<Ftp_Request_Number_Counter_Mutation_Response>;
  /** insert a single row into the table: "ftp.request_number_counter" */
  insert_ftp_request_number_counter_one?: Maybe<Ftp_Request_Number_Counter>;
  /** insert a single row into the table: "ftp.request" */
  insert_ftp_request_one?: Maybe<Ftp_Request>;
  /** insert data into the table: "ftp.request_participant" */
  insert_ftp_request_participant?: Maybe<Ftp_Request_Participant_Mutation_Response>;
  /** insert a single row into the table: "ftp.request_participant" */
  insert_ftp_request_participant_one?: Maybe<Ftp_Request_Participant>;
  /** insert data into the table: "gec.audience_in_event" */
  insert_gec_audience_in_event?: Maybe<Gec_Audience_In_Event_Mutation_Response>;
  /** insert a single row into the table: "gec.audience_in_event" */
  insert_gec_audience_in_event_one?: Maybe<Gec_Audience_In_Event>;
  /** insert data into the table: "gec.contact_in_event" */
  insert_gec_contact_in_event?: Maybe<Gec_Contact_In_Event_Mutation_Response>;
  /** insert a single row into the table: "gec.contact_in_event" */
  insert_gec_contact_in_event_one?: Maybe<Gec_Contact_In_Event>;
  /** insert data into the table: "gec.departments_in_event" */
  insert_gec_departments_in_event?: Maybe<Gec_Departments_In_Event_Mutation_Response>;
  /** insert a single row into the table: "gec.departments_in_event" */
  insert_gec_departments_in_event_one?: Maybe<Gec_Departments_In_Event>;
  /** insert data into the table: "gec.event_exception" */
  insert_gec_event_exception?: Maybe<Gec_Event_Exception_Mutation_Response>;
  /** insert a single row into the table: "gec.event_exception" */
  insert_gec_event_exception_one?: Maybe<Gec_Event_Exception>;
  /** insert data into the table: "gec.events" */
  insert_gec_events?: Maybe<Gec_Events_Mutation_Response>;
  /** insert a single row into the table: "gec.events" */
  insert_gec_events_one?: Maybe<Gec_Events>;
  /** insert data into the table: "gec.firm_initiatives_in_event" */
  insert_gec_firm_initiatives_in_event?: Maybe<Gec_Firm_Initiatives_In_Event_Mutation_Response>;
  /** insert a single row into the table: "gec.firm_initiatives_in_event" */
  insert_gec_firm_initiatives_in_event_one?: Maybe<Gec_Firm_Initiatives_In_Event>;
  /** insert data into the table: "gec.industries_in_event" */
  insert_gec_industries_in_event?: Maybe<Gec_Industries_In_Event_Mutation_Response>;
  /** insert a single row into the table: "gec.industries_in_event" */
  insert_gec_industries_in_event_one?: Maybe<Gec_Industries_In_Event>;
  /** insert data into the table: "gec.office_visibility_in_event" */
  insert_gec_office_visibility_in_event?: Maybe<Gec_Office_Visibility_In_Event_Mutation_Response>;
  /** insert a single row into the table: "gec.office_visibility_in_event" */
  insert_gec_office_visibility_in_event_one?: Maybe<Gec_Office_Visibility_In_Event>;
  /** insert data into the table: "gec.offices_in_event" */
  insert_gec_offices_in_event?: Maybe<Gec_Offices_In_Event_Mutation_Response>;
  /** insert a single row into the table: "gec.offices_in_event" */
  insert_gec_offices_in_event_one?: Maybe<Gec_Offices_In_Event>;
  /** insert data into the table: "gec.outside_speakers" */
  insert_gec_outside_speakers?: Maybe<Gec_Outside_Speakers_Mutation_Response>;
  /** insert a single row into the table: "gec.outside_speakers" */
  insert_gec_outside_speakers_one?: Maybe<Gec_Outside_Speakers>;
  /** insert data into the table: "gec.practice_groups_in_event" */
  insert_gec_practice_groups_in_event?: Maybe<Gec_Practice_Groups_In_Event_Mutation_Response>;
  /** insert a single row into the table: "gec.practice_groups_in_event" */
  insert_gec_practice_groups_in_event_one?: Maybe<Gec_Practice_Groups_In_Event>;
  /** insert data into the table: "gec.speaker_in_event" */
  insert_gec_speaker_in_event?: Maybe<Gec_Speaker_In_Event_Mutation_Response>;
  /** insert a single row into the table: "gec.speaker_in_event" */
  insert_gec_speaker_in_event_one?: Maybe<Gec_Speaker_In_Event>;
  /** insert data into the table: "gec.sponsoring_attorney_in_event" */
  insert_gec_sponsoring_attorney_in_event?: Maybe<Gec_Sponsoring_Attorney_In_Event_Mutation_Response>;
  /** insert a single row into the table: "gec.sponsoring_attorney_in_event" */
  insert_gec_sponsoring_attorney_in_event_one?: Maybe<Gec_Sponsoring_Attorney_In_Event>;
  /** insert data into the table: "mnet_assignmentportal.my_availability" */
  insert_mnet_assignmentportal_my_availability?: Maybe<Mnet_Assignmentportal_My_Availability_Mutation_Response>;
  /** insert a single row into the table: "mnet_assignmentportal.my_availability" */
  insert_mnet_assignmentportal_my_availability_one?: Maybe<Mnet_Assignmentportal_My_Availability>;
  /** insert data into the table: "mnet_blog.attachments" */
  insert_mnet_blog_attachments?: Maybe<Mnet_Blog_Attachments_Mutation_Response>;
  /** insert a single row into the table: "mnet_blog.attachments" */
  insert_mnet_blog_attachments_one?: Maybe<Mnet_Blog_Attachments>;
  /** insert data into the table: "mnet_blog.blogs" */
  insert_mnet_blog_blogs?: Maybe<Mnet_Blog_Blogs_Mutation_Response>;
  /** insert a single row into the table: "mnet_blog.blogs" */
  insert_mnet_blog_blogs_one?: Maybe<Mnet_Blog_Blogs>;
  /** insert data into the table: "mnet_blog.channel_notifications" */
  insert_mnet_blog_channel_notifications?: Maybe<Mnet_Blog_Channel_Notifications_Mutation_Response>;
  /** insert a single row into the table: "mnet_blog.channel_notifications" */
  insert_mnet_blog_channel_notifications_one?: Maybe<Mnet_Blog_Channel_Notifications>;
  /** insert data into the table: "mnet_blog.channels" */
  insert_mnet_blog_channels?: Maybe<Mnet_Blog_Channels_Mutation_Response>;
  /** insert a single row into the table: "mnet_blog.channels" */
  insert_mnet_blog_channels_one?: Maybe<Mnet_Blog_Channels>;
  /** insert data into the table: "mnet_blog.comment_reactions" */
  insert_mnet_blog_comment_reactions?: Maybe<Mnet_Blog_Comment_Reactions_Mutation_Response>;
  /** insert a single row into the table: "mnet_blog.comment_reactions" */
  insert_mnet_blog_comment_reactions_one?: Maybe<Mnet_Blog_Comment_Reactions>;
  /** insert data into the table: "mnet_blog.comments" */
  insert_mnet_blog_comments?: Maybe<Mnet_Blog_Comments_Mutation_Response>;
  /** insert a single row into the table: "mnet_blog.comments" */
  insert_mnet_blog_comments_one?: Maybe<Mnet_Blog_Comments>;
  /** insert data into the table: "mnet_blog.email_notifications" */
  insert_mnet_blog_email_notifications?: Maybe<Mnet_Blog_Email_Notifications_Mutation_Response>;
  /** insert a single row into the table: "mnet_blog.email_notifications" */
  insert_mnet_blog_email_notifications_one?: Maybe<Mnet_Blog_Email_Notifications>;
  /** insert data into the table: "mnet_blog.email_templates" */
  insert_mnet_blog_email_templates?: Maybe<Mnet_Blog_Email_Templates_Mutation_Response>;
  /** insert a single row into the table: "mnet_blog.email_templates" */
  insert_mnet_blog_email_templates_one?: Maybe<Mnet_Blog_Email_Templates>;
  /** insert data into the table: "mnet_blog.events" */
  insert_mnet_blog_events?: Maybe<Mnet_Blog_Events_Mutation_Response>;
  /** insert a single row into the table: "mnet_blog.events" */
  insert_mnet_blog_events_one?: Maybe<Mnet_Blog_Events>;
  /** insert data into the table: "mnet_blog.group_in_blogs" */
  insert_mnet_blog_group_in_blogs?: Maybe<Mnet_Blog_Group_In_Blogs_Mutation_Response>;
  /** insert a single row into the table: "mnet_blog.group_in_blogs" */
  insert_mnet_blog_group_in_blogs_one?: Maybe<Mnet_Blog_Group_In_Blogs>;
  /** insert data into the table: "mnet_blog.inbound_emails" */
  insert_mnet_blog_inbound_emails?: Maybe<Mnet_Blog_Inbound_Emails_Mutation_Response>;
  /** insert a single row into the table: "mnet_blog.inbound_emails" */
  insert_mnet_blog_inbound_emails_one?: Maybe<Mnet_Blog_Inbound_Emails>;
  /** insert data into the table: "mnet_blog.notification_recipients" */
  insert_mnet_blog_notification_recipients?: Maybe<Mnet_Blog_Notification_Recipients_Mutation_Response>;
  /** insert a single row into the table: "mnet_blog.notification_recipients" */
  insert_mnet_blog_notification_recipients_one?: Maybe<Mnet_Blog_Notification_Recipients>;
  /** insert data into the table: "mnet_blog.notification_template_rules" */
  insert_mnet_blog_notification_template_rules?: Maybe<Mnet_Blog_Notification_Template_Rules_Mutation_Response>;
  /** insert a single row into the table: "mnet_blog.notification_template_rules" */
  insert_mnet_blog_notification_template_rules_one?: Maybe<Mnet_Blog_Notification_Template_Rules>;
  /** insert data into the table: "mnet_blog.post_channels" */
  insert_mnet_blog_post_channels?: Maybe<Mnet_Blog_Post_Channels_Mutation_Response>;
  /** insert a single row into the table: "mnet_blog.post_channels" */
  insert_mnet_blog_post_channels_one?: Maybe<Mnet_Blog_Post_Channels>;
  /** insert data into the table: "mnet_blog.post_images" */
  insert_mnet_blog_post_images?: Maybe<Mnet_Blog_Post_Images_Mutation_Response>;
  /** insert a single row into the table: "mnet_blog.post_images" */
  insert_mnet_blog_post_images_one?: Maybe<Mnet_Blog_Post_Images>;
  /** insert data into the table: "mnet_blog.post_reactions" */
  insert_mnet_blog_post_reactions?: Maybe<Mnet_Blog_Post_Reactions_Mutation_Response>;
  /** insert a single row into the table: "mnet_blog.post_reactions" */
  insert_mnet_blog_post_reactions_one?: Maybe<Mnet_Blog_Post_Reactions>;
  /** insert data into the table: "mnet_blog.posts" */
  insert_mnet_blog_posts?: Maybe<Mnet_Blog_Posts_Mutation_Response>;
  /** insert a single row into the table: "mnet_blog.posts" */
  insert_mnet_blog_posts_one?: Maybe<Mnet_Blog_Posts>;
  /** insert data into the table: "mnet.mytools_user_tool" */
  insert_mnet_mytools_user_tool?: Maybe<Mnet_Mytools_User_Tool_Mutation_Response>;
  /** insert a single row into the table: "mnet.mytools_user_tool" */
  insert_mnet_mytools_user_tool_one?: Maybe<Mnet_Mytools_User_Tool>;
  /** insert data into the table: "pbc.counsel_representatives" */
  insert_pbc_counsel_representatives?: Maybe<Pbc_Counsel_Representatives_Mutation_Response>;
  /** insert a single row into the table: "pbc.counsel_representatives" */
  insert_pbc_counsel_representatives_one?: Maybe<Pbc_Counsel_Representatives>;
  /** insert data into the table: "pbc.email_templates" */
  insert_pbc_email_templates?: Maybe<Pbc_Email_Templates_Mutation_Response>;
  /** insert a single row into the table: "pbc.email_templates" */
  insert_pbc_email_templates_one?: Maybe<Pbc_Email_Templates>;
  /** insert data into the table: "pbc.exempt_users" */
  insert_pbc_exempt_users?: Maybe<Pbc_Exempt_Users_Mutation_Response>;
  /** insert a single row into the table: "pbc.exempt_users" */
  insert_pbc_exempt_users_one?: Maybe<Pbc_Exempt_Users>;
  /** insert data into the table: "pbc.notification_recipients" */
  insert_pbc_notification_recipients?: Maybe<Pbc_Notification_Recipients_Mutation_Response>;
  /** insert a single row into the table: "pbc.notification_recipients" */
  insert_pbc_notification_recipients_one?: Maybe<Pbc_Notification_Recipients>;
  /** insert data into the table: "pbc.notification_requests" */
  insert_pbc_notification_requests?: Maybe<Pbc_Notification_Requests_Mutation_Response>;
  /** insert a single row into the table: "pbc.notification_requests" */
  insert_pbc_notification_requests_one?: Maybe<Pbc_Notification_Requests>;
  /** insert data into the table: "pbc.senders" */
  insert_pbc_senders?: Maybe<Pbc_Senders_Mutation_Response>;
  /** insert a single row into the table: "pbc.senders" */
  insert_pbc_senders_one?: Maybe<Pbc_Senders>;
  updateBucket: UpdateBucketPayload;
  /** An asynchronous method designed to modify an existing list item within a SharePoint list or library. It returns the modified list item. */
  updateListItem: UpdateListItemPayload;
  updatePlan: UpdatePlanPayload;
  updatePlanDetails: UpdatePlanDetailsPayload;
  updateTask: UpdateTaskPayload;
  updateTaskDetails: UpdateTaskDetailsPayload;
  updateUser: UpdateUserPayload;
  /** update data of the table: "BCS.Personnel" */
  update_BCS_Personnel?: Maybe<Bcs_Personnel_Mutation_Response>;
  /** update single row of the table: "BCS.Personnel" */
  update_BCS_Personnel_by_pk?: Maybe<Bcs_Personnel>;
  /** update multiples rows of table: "BCS.Personnel" */
  update_BCS_Personnel_many?: Maybe<Array<Maybe<Bcs_Personnel_Mutation_Response>>>;
  /** update data of the table: "b2b.external_accounts" */
  update_b2b_external_accounts?: Maybe<B2b_External_Accounts_Mutation_Response>;
  /** update single row of the table: "b2b.external_accounts" */
  update_b2b_external_accounts_by_pk?: Maybe<B2b_External_Accounts>;
  /** update multiples rows of table: "b2b.external_accounts" */
  update_b2b_external_accounts_many?: Maybe<Array<Maybe<B2b_External_Accounts_Mutation_Response>>>;
  /** update data of the table: "b2b.ml_sponsor_references" */
  update_b2b_ml_sponsor_references?: Maybe<B2b_Ml_Sponsor_References_Mutation_Response>;
  /** update single row of the table: "b2b.ml_sponsor_references" */
  update_b2b_ml_sponsor_references_by_pk?: Maybe<B2b_Ml_Sponsor_References>;
  /** update multiples rows of table: "b2b.ml_sponsor_references" */
  update_b2b_ml_sponsor_references_many?: Maybe<Array<Maybe<B2b_Ml_Sponsor_References_Mutation_Response>>>;
  /** update data of the table: "b2b.requests" */
  update_b2b_requests?: Maybe<B2b_Requests_Mutation_Response>;
  /** update single row of the table: "b2b.requests" */
  update_b2b_requests_by_pk?: Maybe<B2b_Requests>;
  /** update multiples rows of table: "b2b.requests" */
  update_b2b_requests_many?: Maybe<Array<Maybe<B2b_Requests_Mutation_Response>>>;
  /** update data of the table: "b2b.resource_owner_references" */
  update_b2b_resource_owner_references?: Maybe<B2b_Resource_Owner_References_Mutation_Response>;
  /** update single row of the table: "b2b.resource_owner_references" */
  update_b2b_resource_owner_references_by_pk?: Maybe<B2b_Resource_Owner_References>;
  /** update multiples rows of table: "b2b.resource_owner_references" */
  update_b2b_resource_owner_references_many?: Maybe<Array<Maybe<B2b_Resource_Owner_References_Mutation_Response>>>;
  /** update data of the table: "clm.engagement_client_comments" */
  update_clm_engagement_client_comments?: Maybe<Clm_Engagement_Client_Comments_Mutation_Response>;
  /** update single row of the table: "clm.engagement_client_comments" */
  update_clm_engagement_client_comments_by_pk?: Maybe<Clm_Engagement_Client_Comments>;
  /** update multiples rows of table: "clm.engagement_client_comments" */
  update_clm_engagement_client_comments_many?: Maybe<Array<Maybe<Clm_Engagement_Client_Comments_Mutation_Response>>>;
  /** update data of the table: "clm.engagement_imanage_documents" */
  update_clm_engagement_imanage_documents?: Maybe<Clm_Engagement_Imanage_Documents_Mutation_Response>;
  /** update single row of the table: "clm.engagement_imanage_documents" */
  update_clm_engagement_imanage_documents_by_pk?: Maybe<Clm_Engagement_Imanage_Documents>;
  /** update multiples rows of table: "clm.engagement_imanage_documents" */
  update_clm_engagement_imanage_documents_many?: Maybe<
    Array<Maybe<Clm_Engagement_Imanage_Documents_Mutation_Response>>
  >;
  /** update data of the table: "clm.engagement_records" */
  update_clm_engagement_records?: Maybe<Clm_Engagement_Records_Mutation_Response>;
  /** update single row of the table: "clm.engagement_records" */
  update_clm_engagement_records_by_pk?: Maybe<Clm_Engagement_Records>;
  /** update multiples rows of table: "clm.engagement_records" */
  update_clm_engagement_records_many?: Maybe<Array<Maybe<Clm_Engagement_Records_Mutation_Response>>>;
  /** update data of the table: "clm.views" */
  update_clm_views?: Maybe<Clm_Views_Mutation_Response>;
  /** update single row of the table: "clm.views" */
  update_clm_views_by_pk?: Maybe<Clm_Views>;
  /** update multiples rows of table: "clm.views" */
  update_clm_views_many?: Maybe<Array<Maybe<Clm_Views_Mutation_Response>>>;
  /** update data of the table: "fd.email_templates" */
  update_fd_email_templates?: Maybe<Fd_Email_Templates_Mutation_Response>;
  /** update single row of the table: "fd.email_templates" */
  update_fd_email_templates_by_pk?: Maybe<Fd_Email_Templates>;
  /** update multiples rows of table: "fd.email_templates" */
  update_fd_email_templates_many?: Maybe<Array<Maybe<Fd_Email_Templates_Mutation_Response>>>;
  /** update data of the table: "fd.exempt_matters" */
  update_fd_exempt_matters?: Maybe<Fd_Exempt_Matters_Mutation_Response>;
  /** update single row of the table: "fd.exempt_matters" */
  update_fd_exempt_matters_by_pk?: Maybe<Fd_Exempt_Matters>;
  /** update multiples rows of table: "fd.exempt_matters" */
  update_fd_exempt_matters_many?: Maybe<Array<Maybe<Fd_Exempt_Matters_Mutation_Response>>>;
  /** update data of the table: "fd.instruction_templates" */
  update_fd_instruction_templates?: Maybe<Fd_Instruction_Templates_Mutation_Response>;
  /** update single row of the table: "fd.instruction_templates" */
  update_fd_instruction_templates_by_pk?: Maybe<Fd_Instruction_Templates>;
  /** update multiples rows of table: "fd.instruction_templates" */
  update_fd_instruction_templates_many?: Maybe<Array<Maybe<Fd_Instruction_Templates_Mutation_Response>>>;
  /** update data of the table: "fd.matters_responses" */
  update_fd_matters_responses?: Maybe<Fd_Matters_Responses_Mutation_Response>;
  /** update single row of the table: "fd.matters_responses" */
  update_fd_matters_responses_by_pk?: Maybe<Fd_Matters_Responses>;
  /** update multiples rows of table: "fd.matters_responses" */
  update_fd_matters_responses_many?: Maybe<Array<Maybe<Fd_Matters_Responses_Mutation_Response>>>;
  /** update data of the table: "fd.project_access" */
  update_fd_project_access?: Maybe<Fd_Project_Access_Mutation_Response>;
  /** update single row of the table: "fd.project_access" */
  update_fd_project_access_by_pk?: Maybe<Fd_Project_Access>;
  /** update multiples rows of table: "fd.project_access" */
  update_fd_project_access_many?: Maybe<Array<Maybe<Fd_Project_Access_Mutation_Response>>>;
  /** update data of the table: "fd.project_number_counter" */
  update_fd_project_number_counter?: Maybe<Fd_Project_Number_Counter_Mutation_Response>;
  /** update single row of the table: "fd.project_number_counter" */
  update_fd_project_number_counter_by_pk?: Maybe<Fd_Project_Number_Counter>;
  /** update multiples rows of table: "fd.project_number_counter" */
  update_fd_project_number_counter_many?: Maybe<Array<Maybe<Fd_Project_Number_Counter_Mutation_Response>>>;
  /** update data of the table: "fd.projects" */
  update_fd_projects?: Maybe<Fd_Projects_Mutation_Response>;
  /** update single row of the table: "fd.projects" */
  update_fd_projects_by_pk?: Maybe<Fd_Projects>;
  /** update multiples rows of table: "fd.projects" */
  update_fd_projects_many?: Maybe<Array<Maybe<Fd_Projects_Mutation_Response>>>;
  /** update data of the table: "fd.response_in_projects" */
  update_fd_response_in_projects?: Maybe<Fd_Response_In_Projects_Mutation_Response>;
  /** update single row of the table: "fd.response_in_projects" */
  update_fd_response_in_projects_by_pk?: Maybe<Fd_Response_In_Projects>;
  /** update multiples rows of table: "fd.response_in_projects" */
  update_fd_response_in_projects_many?: Maybe<Array<Maybe<Fd_Response_In_Projects_Mutation_Response>>>;
  /** update data of the table: "fd.responses" */
  update_fd_responses?: Maybe<Fd_Responses_Mutation_Response>;
  /** update single row of the table: "fd.responses" */
  update_fd_responses_by_pk?: Maybe<Fd_Responses>;
  /** update multiples rows of table: "fd.responses" */
  update_fd_responses_many?: Maybe<Array<Maybe<Fd_Responses_Mutation_Response>>>;
  /** update data of the table: "ftp.request" */
  update_ftp_request?: Maybe<Ftp_Request_Mutation_Response>;
  /** update single row of the table: "ftp.request" */
  update_ftp_request_by_pk?: Maybe<Ftp_Request>;
  /** update data of the table: "ftp.request_detail" */
  update_ftp_request_detail?: Maybe<Ftp_Request_Detail_Mutation_Response>;
  /** update single row of the table: "ftp.request_detail" */
  update_ftp_request_detail_by_pk?: Maybe<Ftp_Request_Detail>;
  /** update multiples rows of table: "ftp.request_detail" */
  update_ftp_request_detail_many?: Maybe<Array<Maybe<Ftp_Request_Detail_Mutation_Response>>>;
  /** update data of the table: "ftp.request_external_access" */
  update_ftp_request_external_access?: Maybe<Ftp_Request_External_Access_Mutation_Response>;
  /** update single row of the table: "ftp.request_external_access" */
  update_ftp_request_external_access_by_pk?: Maybe<Ftp_Request_External_Access>;
  /** update multiples rows of table: "ftp.request_external_access" */
  update_ftp_request_external_access_many?: Maybe<Array<Maybe<Ftp_Request_External_Access_Mutation_Response>>>;
  /** update data of the table: "ftp.request_external_note" */
  update_ftp_request_external_note?: Maybe<Ftp_Request_External_Note_Mutation_Response>;
  /** update single row of the table: "ftp.request_external_note" */
  update_ftp_request_external_note_by_pk?: Maybe<Ftp_Request_External_Note>;
  /** update multiples rows of table: "ftp.request_external_note" */
  update_ftp_request_external_note_many?: Maybe<Array<Maybe<Ftp_Request_External_Note_Mutation_Response>>>;
  /** update data of the table: "ftp.request_internal_note" */
  update_ftp_request_internal_note?: Maybe<Ftp_Request_Internal_Note_Mutation_Response>;
  /** update single row of the table: "ftp.request_internal_note" */
  update_ftp_request_internal_note_by_pk?: Maybe<Ftp_Request_Internal_Note>;
  /** update multiples rows of table: "ftp.request_internal_note" */
  update_ftp_request_internal_note_many?: Maybe<Array<Maybe<Ftp_Request_Internal_Note_Mutation_Response>>>;
  /** update multiples rows of table: "ftp.request" */
  update_ftp_request_many?: Maybe<Array<Maybe<Ftp_Request_Mutation_Response>>>;
  /** update data of the table: "ftp.request_number_counter" */
  update_ftp_request_number_counter?: Maybe<Ftp_Request_Number_Counter_Mutation_Response>;
  /** update single row of the table: "ftp.request_number_counter" */
  update_ftp_request_number_counter_by_pk?: Maybe<Ftp_Request_Number_Counter>;
  /** update multiples rows of table: "ftp.request_number_counter" */
  update_ftp_request_number_counter_many?: Maybe<Array<Maybe<Ftp_Request_Number_Counter_Mutation_Response>>>;
  /** update data of the table: "ftp.request_participant" */
  update_ftp_request_participant?: Maybe<Ftp_Request_Participant_Mutation_Response>;
  /** update single row of the table: "ftp.request_participant" */
  update_ftp_request_participant_by_pk?: Maybe<Ftp_Request_Participant>;
  /** update multiples rows of table: "ftp.request_participant" */
  update_ftp_request_participant_many?: Maybe<Array<Maybe<Ftp_Request_Participant_Mutation_Response>>>;
  /** update data of the table: "gec.audience_in_event" */
  update_gec_audience_in_event?: Maybe<Gec_Audience_In_Event_Mutation_Response>;
  /** update single row of the table: "gec.audience_in_event" */
  update_gec_audience_in_event_by_pk?: Maybe<Gec_Audience_In_Event>;
  /** update multiples rows of table: "gec.audience_in_event" */
  update_gec_audience_in_event_many?: Maybe<Array<Maybe<Gec_Audience_In_Event_Mutation_Response>>>;
  /** update data of the table: "gec.contact_in_event" */
  update_gec_contact_in_event?: Maybe<Gec_Contact_In_Event_Mutation_Response>;
  /** update single row of the table: "gec.contact_in_event" */
  update_gec_contact_in_event_by_pk?: Maybe<Gec_Contact_In_Event>;
  /** update multiples rows of table: "gec.contact_in_event" */
  update_gec_contact_in_event_many?: Maybe<Array<Maybe<Gec_Contact_In_Event_Mutation_Response>>>;
  /** update data of the table: "gec.departments_in_event" */
  update_gec_departments_in_event?: Maybe<Gec_Departments_In_Event_Mutation_Response>;
  /** update single row of the table: "gec.departments_in_event" */
  update_gec_departments_in_event_by_pk?: Maybe<Gec_Departments_In_Event>;
  /** update multiples rows of table: "gec.departments_in_event" */
  update_gec_departments_in_event_many?: Maybe<Array<Maybe<Gec_Departments_In_Event_Mutation_Response>>>;
  /** update data of the table: "gec.event_exception" */
  update_gec_event_exception?: Maybe<Gec_Event_Exception_Mutation_Response>;
  /** update single row of the table: "gec.event_exception" */
  update_gec_event_exception_by_pk?: Maybe<Gec_Event_Exception>;
  /** update multiples rows of table: "gec.event_exception" */
  update_gec_event_exception_many?: Maybe<Array<Maybe<Gec_Event_Exception_Mutation_Response>>>;
  /** update data of the table: "gec.events" */
  update_gec_events?: Maybe<Gec_Events_Mutation_Response>;
  /** update single row of the table: "gec.events" */
  update_gec_events_by_pk?: Maybe<Gec_Events>;
  /** update multiples rows of table: "gec.events" */
  update_gec_events_many?: Maybe<Array<Maybe<Gec_Events_Mutation_Response>>>;
  /** update data of the table: "gec.firm_initiatives_in_event" */
  update_gec_firm_initiatives_in_event?: Maybe<Gec_Firm_Initiatives_In_Event_Mutation_Response>;
  /** update single row of the table: "gec.firm_initiatives_in_event" */
  update_gec_firm_initiatives_in_event_by_pk?: Maybe<Gec_Firm_Initiatives_In_Event>;
  /** update multiples rows of table: "gec.firm_initiatives_in_event" */
  update_gec_firm_initiatives_in_event_many?: Maybe<Array<Maybe<Gec_Firm_Initiatives_In_Event_Mutation_Response>>>;
  /** update data of the table: "gec.industries_in_event" */
  update_gec_industries_in_event?: Maybe<Gec_Industries_In_Event_Mutation_Response>;
  /** update single row of the table: "gec.industries_in_event" */
  update_gec_industries_in_event_by_pk?: Maybe<Gec_Industries_In_Event>;
  /** update multiples rows of table: "gec.industries_in_event" */
  update_gec_industries_in_event_many?: Maybe<Array<Maybe<Gec_Industries_In_Event_Mutation_Response>>>;
  /** update data of the table: "gec.office_visibility_in_event" */
  update_gec_office_visibility_in_event?: Maybe<Gec_Office_Visibility_In_Event_Mutation_Response>;
  /** update single row of the table: "gec.office_visibility_in_event" */
  update_gec_office_visibility_in_event_by_pk?: Maybe<Gec_Office_Visibility_In_Event>;
  /** update multiples rows of table: "gec.office_visibility_in_event" */
  update_gec_office_visibility_in_event_many?: Maybe<Array<Maybe<Gec_Office_Visibility_In_Event_Mutation_Response>>>;
  /** update data of the table: "gec.offices_in_event" */
  update_gec_offices_in_event?: Maybe<Gec_Offices_In_Event_Mutation_Response>;
  /** update single row of the table: "gec.offices_in_event" */
  update_gec_offices_in_event_by_pk?: Maybe<Gec_Offices_In_Event>;
  /** update multiples rows of table: "gec.offices_in_event" */
  update_gec_offices_in_event_many?: Maybe<Array<Maybe<Gec_Offices_In_Event_Mutation_Response>>>;
  /** update data of the table: "gec.outside_speakers" */
  update_gec_outside_speakers?: Maybe<Gec_Outside_Speakers_Mutation_Response>;
  /** update single row of the table: "gec.outside_speakers" */
  update_gec_outside_speakers_by_pk?: Maybe<Gec_Outside_Speakers>;
  /** update multiples rows of table: "gec.outside_speakers" */
  update_gec_outside_speakers_many?: Maybe<Array<Maybe<Gec_Outside_Speakers_Mutation_Response>>>;
  /** update data of the table: "gec.practice_groups_in_event" */
  update_gec_practice_groups_in_event?: Maybe<Gec_Practice_Groups_In_Event_Mutation_Response>;
  /** update single row of the table: "gec.practice_groups_in_event" */
  update_gec_practice_groups_in_event_by_pk?: Maybe<Gec_Practice_Groups_In_Event>;
  /** update multiples rows of table: "gec.practice_groups_in_event" */
  update_gec_practice_groups_in_event_many?: Maybe<Array<Maybe<Gec_Practice_Groups_In_Event_Mutation_Response>>>;
  /** update data of the table: "gec.speaker_in_event" */
  update_gec_speaker_in_event?: Maybe<Gec_Speaker_In_Event_Mutation_Response>;
  /** update single row of the table: "gec.speaker_in_event" */
  update_gec_speaker_in_event_by_pk?: Maybe<Gec_Speaker_In_Event>;
  /** update multiples rows of table: "gec.speaker_in_event" */
  update_gec_speaker_in_event_many?: Maybe<Array<Maybe<Gec_Speaker_In_Event_Mutation_Response>>>;
  /** update data of the table: "gec.sponsoring_attorney_in_event" */
  update_gec_sponsoring_attorney_in_event?: Maybe<Gec_Sponsoring_Attorney_In_Event_Mutation_Response>;
  /** update single row of the table: "gec.sponsoring_attorney_in_event" */
  update_gec_sponsoring_attorney_in_event_by_pk?: Maybe<Gec_Sponsoring_Attorney_In_Event>;
  /** update multiples rows of table: "gec.sponsoring_attorney_in_event" */
  update_gec_sponsoring_attorney_in_event_many?: Maybe<
    Array<Maybe<Gec_Sponsoring_Attorney_In_Event_Mutation_Response>>
  >;
  /** update data of the table: "mnet_assignmentportal.my_availability" */
  update_mnet_assignmentportal_my_availability?: Maybe<Mnet_Assignmentportal_My_Availability_Mutation_Response>;
  /** update single row of the table: "mnet_assignmentportal.my_availability" */
  update_mnet_assignmentportal_my_availability_by_pk?: Maybe<Mnet_Assignmentportal_My_Availability>;
  /** update multiples rows of table: "mnet_assignmentportal.my_availability" */
  update_mnet_assignmentportal_my_availability_many?: Maybe<
    Array<Maybe<Mnet_Assignmentportal_My_Availability_Mutation_Response>>
  >;
  /** update data of the table: "mnet_blog.attachments" */
  update_mnet_blog_attachments?: Maybe<Mnet_Blog_Attachments_Mutation_Response>;
  /** update single row of the table: "mnet_blog.attachments" */
  update_mnet_blog_attachments_by_pk?: Maybe<Mnet_Blog_Attachments>;
  /** update multiples rows of table: "mnet_blog.attachments" */
  update_mnet_blog_attachments_many?: Maybe<Array<Maybe<Mnet_Blog_Attachments_Mutation_Response>>>;
  /** update data of the table: "mnet_blog.blogs" */
  update_mnet_blog_blogs?: Maybe<Mnet_Blog_Blogs_Mutation_Response>;
  /** update single row of the table: "mnet_blog.blogs" */
  update_mnet_blog_blogs_by_pk?: Maybe<Mnet_Blog_Blogs>;
  /** update multiples rows of table: "mnet_blog.blogs" */
  update_mnet_blog_blogs_many?: Maybe<Array<Maybe<Mnet_Blog_Blogs_Mutation_Response>>>;
  /** update data of the table: "mnet_blog.channel_notifications" */
  update_mnet_blog_channel_notifications?: Maybe<Mnet_Blog_Channel_Notifications_Mutation_Response>;
  /** update single row of the table: "mnet_blog.channel_notifications" */
  update_mnet_blog_channel_notifications_by_pk?: Maybe<Mnet_Blog_Channel_Notifications>;
  /** update multiples rows of table: "mnet_blog.channel_notifications" */
  update_mnet_blog_channel_notifications_many?: Maybe<Array<Maybe<Mnet_Blog_Channel_Notifications_Mutation_Response>>>;
  /** update data of the table: "mnet_blog.channels" */
  update_mnet_blog_channels?: Maybe<Mnet_Blog_Channels_Mutation_Response>;
  /** update single row of the table: "mnet_blog.channels" */
  update_mnet_blog_channels_by_pk?: Maybe<Mnet_Blog_Channels>;
  /** update multiples rows of table: "mnet_blog.channels" */
  update_mnet_blog_channels_many?: Maybe<Array<Maybe<Mnet_Blog_Channels_Mutation_Response>>>;
  /** update data of the table: "mnet_blog.comment_reactions" */
  update_mnet_blog_comment_reactions?: Maybe<Mnet_Blog_Comment_Reactions_Mutation_Response>;
  /** update single row of the table: "mnet_blog.comment_reactions" */
  update_mnet_blog_comment_reactions_by_pk?: Maybe<Mnet_Blog_Comment_Reactions>;
  /** update multiples rows of table: "mnet_blog.comment_reactions" */
  update_mnet_blog_comment_reactions_many?: Maybe<Array<Maybe<Mnet_Blog_Comment_Reactions_Mutation_Response>>>;
  /** update data of the table: "mnet_blog.comments" */
  update_mnet_blog_comments?: Maybe<Mnet_Blog_Comments_Mutation_Response>;
  /** update single row of the table: "mnet_blog.comments" */
  update_mnet_blog_comments_by_pk?: Maybe<Mnet_Blog_Comments>;
  /** update multiples rows of table: "mnet_blog.comments" */
  update_mnet_blog_comments_many?: Maybe<Array<Maybe<Mnet_Blog_Comments_Mutation_Response>>>;
  /** update data of the table: "mnet_blog.email_notifications" */
  update_mnet_blog_email_notifications?: Maybe<Mnet_Blog_Email_Notifications_Mutation_Response>;
  /** update single row of the table: "mnet_blog.email_notifications" */
  update_mnet_blog_email_notifications_by_pk?: Maybe<Mnet_Blog_Email_Notifications>;
  /** update multiples rows of table: "mnet_blog.email_notifications" */
  update_mnet_blog_email_notifications_many?: Maybe<Array<Maybe<Mnet_Blog_Email_Notifications_Mutation_Response>>>;
  /** update data of the table: "mnet_blog.email_templates" */
  update_mnet_blog_email_templates?: Maybe<Mnet_Blog_Email_Templates_Mutation_Response>;
  /** update single row of the table: "mnet_blog.email_templates" */
  update_mnet_blog_email_templates_by_pk?: Maybe<Mnet_Blog_Email_Templates>;
  /** update multiples rows of table: "mnet_blog.email_templates" */
  update_mnet_blog_email_templates_many?: Maybe<Array<Maybe<Mnet_Blog_Email_Templates_Mutation_Response>>>;
  /** update data of the table: "mnet_blog.events" */
  update_mnet_blog_events?: Maybe<Mnet_Blog_Events_Mutation_Response>;
  /** update single row of the table: "mnet_blog.events" */
  update_mnet_blog_events_by_pk?: Maybe<Mnet_Blog_Events>;
  /** update multiples rows of table: "mnet_blog.events" */
  update_mnet_blog_events_many?: Maybe<Array<Maybe<Mnet_Blog_Events_Mutation_Response>>>;
  /** update data of the table: "mnet_blog.group_in_blogs" */
  update_mnet_blog_group_in_blogs?: Maybe<Mnet_Blog_Group_In_Blogs_Mutation_Response>;
  /** update single row of the table: "mnet_blog.group_in_blogs" */
  update_mnet_blog_group_in_blogs_by_pk?: Maybe<Mnet_Blog_Group_In_Blogs>;
  /** update multiples rows of table: "mnet_blog.group_in_blogs" */
  update_mnet_blog_group_in_blogs_many?: Maybe<Array<Maybe<Mnet_Blog_Group_In_Blogs_Mutation_Response>>>;
  /** update data of the table: "mnet_blog.inbound_emails" */
  update_mnet_blog_inbound_emails?: Maybe<Mnet_Blog_Inbound_Emails_Mutation_Response>;
  /** update single row of the table: "mnet_blog.inbound_emails" */
  update_mnet_blog_inbound_emails_by_pk?: Maybe<Mnet_Blog_Inbound_Emails>;
  /** update multiples rows of table: "mnet_blog.inbound_emails" */
  update_mnet_blog_inbound_emails_many?: Maybe<Array<Maybe<Mnet_Blog_Inbound_Emails_Mutation_Response>>>;
  /** update data of the table: "mnet_blog.notification_recipients" */
  update_mnet_blog_notification_recipients?: Maybe<Mnet_Blog_Notification_Recipients_Mutation_Response>;
  /** update single row of the table: "mnet_blog.notification_recipients" */
  update_mnet_blog_notification_recipients_by_pk?: Maybe<Mnet_Blog_Notification_Recipients>;
  /** update multiples rows of table: "mnet_blog.notification_recipients" */
  update_mnet_blog_notification_recipients_many?: Maybe<
    Array<Maybe<Mnet_Blog_Notification_Recipients_Mutation_Response>>
  >;
  /** update data of the table: "mnet_blog.notification_template_rules" */
  update_mnet_blog_notification_template_rules?: Maybe<Mnet_Blog_Notification_Template_Rules_Mutation_Response>;
  /** update single row of the table: "mnet_blog.notification_template_rules" */
  update_mnet_blog_notification_template_rules_by_pk?: Maybe<Mnet_Blog_Notification_Template_Rules>;
  /** update multiples rows of table: "mnet_blog.notification_template_rules" */
  update_mnet_blog_notification_template_rules_many?: Maybe<
    Array<Maybe<Mnet_Blog_Notification_Template_Rules_Mutation_Response>>
  >;
  /** update data of the table: "mnet_blog.post_channels" */
  update_mnet_blog_post_channels?: Maybe<Mnet_Blog_Post_Channels_Mutation_Response>;
  /** update single row of the table: "mnet_blog.post_channels" */
  update_mnet_blog_post_channels_by_pk?: Maybe<Mnet_Blog_Post_Channels>;
  /** update multiples rows of table: "mnet_blog.post_channels" */
  update_mnet_blog_post_channels_many?: Maybe<Array<Maybe<Mnet_Blog_Post_Channels_Mutation_Response>>>;
  /** update data of the table: "mnet_blog.post_images" */
  update_mnet_blog_post_images?: Maybe<Mnet_Blog_Post_Images_Mutation_Response>;
  /** update single row of the table: "mnet_blog.post_images" */
  update_mnet_blog_post_images_by_pk?: Maybe<Mnet_Blog_Post_Images>;
  /** update multiples rows of table: "mnet_blog.post_images" */
  update_mnet_blog_post_images_many?: Maybe<Array<Maybe<Mnet_Blog_Post_Images_Mutation_Response>>>;
  /** update data of the table: "mnet_blog.post_reactions" */
  update_mnet_blog_post_reactions?: Maybe<Mnet_Blog_Post_Reactions_Mutation_Response>;
  /** update single row of the table: "mnet_blog.post_reactions" */
  update_mnet_blog_post_reactions_by_pk?: Maybe<Mnet_Blog_Post_Reactions>;
  /** update multiples rows of table: "mnet_blog.post_reactions" */
  update_mnet_blog_post_reactions_many?: Maybe<Array<Maybe<Mnet_Blog_Post_Reactions_Mutation_Response>>>;
  /** update data of the table: "mnet_blog.posts" */
  update_mnet_blog_posts?: Maybe<Mnet_Blog_Posts_Mutation_Response>;
  /** update single row of the table: "mnet_blog.posts" */
  update_mnet_blog_posts_by_pk?: Maybe<Mnet_Blog_Posts>;
  /** update multiples rows of table: "mnet_blog.posts" */
  update_mnet_blog_posts_many?: Maybe<Array<Maybe<Mnet_Blog_Posts_Mutation_Response>>>;
  /** update data of the table: "mnet.mytools_user_tool" */
  update_mnet_mytools_user_tool?: Maybe<Mnet_Mytools_User_Tool_Mutation_Response>;
  /** update single row of the table: "mnet.mytools_user_tool" */
  update_mnet_mytools_user_tool_by_pk?: Maybe<Mnet_Mytools_User_Tool>;
  /** update multiples rows of table: "mnet.mytools_user_tool" */
  update_mnet_mytools_user_tool_many?: Maybe<Array<Maybe<Mnet_Mytools_User_Tool_Mutation_Response>>>;
  /** update data of the table: "pbc.counsel_representatives" */
  update_pbc_counsel_representatives?: Maybe<Pbc_Counsel_Representatives_Mutation_Response>;
  /** update single row of the table: "pbc.counsel_representatives" */
  update_pbc_counsel_representatives_by_pk?: Maybe<Pbc_Counsel_Representatives>;
  /** update multiples rows of table: "pbc.counsel_representatives" */
  update_pbc_counsel_representatives_many?: Maybe<Array<Maybe<Pbc_Counsel_Representatives_Mutation_Response>>>;
  /** update data of the table: "pbc.email_templates" */
  update_pbc_email_templates?: Maybe<Pbc_Email_Templates_Mutation_Response>;
  /** update single row of the table: "pbc.email_templates" */
  update_pbc_email_templates_by_pk?: Maybe<Pbc_Email_Templates>;
  /** update multiples rows of table: "pbc.email_templates" */
  update_pbc_email_templates_many?: Maybe<Array<Maybe<Pbc_Email_Templates_Mutation_Response>>>;
  /** update data of the table: "pbc.exempt_users" */
  update_pbc_exempt_users?: Maybe<Pbc_Exempt_Users_Mutation_Response>;
  /** update single row of the table: "pbc.exempt_users" */
  update_pbc_exempt_users_by_pk?: Maybe<Pbc_Exempt_Users>;
  /** update multiples rows of table: "pbc.exempt_users" */
  update_pbc_exempt_users_many?: Maybe<Array<Maybe<Pbc_Exempt_Users_Mutation_Response>>>;
  /** update data of the table: "pbc.notification_recipients" */
  update_pbc_notification_recipients?: Maybe<Pbc_Notification_Recipients_Mutation_Response>;
  /** update single row of the table: "pbc.notification_recipients" */
  update_pbc_notification_recipients_by_pk?: Maybe<Pbc_Notification_Recipients>;
  /** update multiples rows of table: "pbc.notification_recipients" */
  update_pbc_notification_recipients_many?: Maybe<Array<Maybe<Pbc_Notification_Recipients_Mutation_Response>>>;
  /** update data of the table: "pbc.notification_requests" */
  update_pbc_notification_requests?: Maybe<Pbc_Notification_Requests_Mutation_Response>;
  /** update single row of the table: "pbc.notification_requests" */
  update_pbc_notification_requests_by_pk?: Maybe<Pbc_Notification_Requests>;
  /** update multiples rows of table: "pbc.notification_requests" */
  update_pbc_notification_requests_many?: Maybe<Array<Maybe<Pbc_Notification_Requests_Mutation_Response>>>;
  /** update data of the table: "pbc.senders" */
  update_pbc_senders?: Maybe<Pbc_Senders_Mutation_Response>;
  /** update single row of the table: "pbc.senders" */
  update_pbc_senders_by_pk?: Maybe<Pbc_Senders>;
  /** update multiples rows of table: "pbc.senders" */
  update_pbc_senders_many?: Maybe<Array<Maybe<Pbc_Senders_Mutation_Response>>>;
};

/** mutation root */
export type Mutation_RootAddBucketArgs = {
  input: AddBucketInput;
};

/** mutation root */
export type Mutation_RootAddTaskArgs = {
  input: AddTaskInput;
};

/** mutation root */
export type Mutation_RootCreateGuestUserInvitationArgs = {
  input: CreateGuestUserInvitationInput;
};

/** mutation root */
export type Mutation_RootCreateListItemArgs = {
  input: CreateListItemInput;
};

/** mutation root */
export type Mutation_RootDeleteBucketArgs = {
  input: DeleteBucketInput;
};

/** mutation root */
export type Mutation_RootDeleteListItemArgs = {
  input: DeleteListItemInput;
};

/** mutation root */
export type Mutation_RootDeleteTaskArgs = {
  input: DeleteTaskInput;
};

/** mutation root */
export type Mutation_RootDelete_B2b_External_AccountsArgs = {
  where: B2b_External_Accounts_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_B2b_External_Accounts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_B2b_Ml_Sponsor_ReferencesArgs = {
  where: B2b_Ml_Sponsor_References_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_B2b_Ml_Sponsor_References_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_B2b_RequestsArgs = {
  where: B2b_Requests_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_B2b_Requests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_B2b_Resource_Owner_ReferencesArgs = {
  where: B2b_Resource_Owner_References_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_B2b_Resource_Owner_References_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Clm_Engagement_Client_CommentsArgs = {
  where: Clm_Engagement_Client_Comments_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Clm_Engagement_Client_Comments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Clm_Engagement_Imanage_DocumentsArgs = {
  where: Clm_Engagement_Imanage_Documents_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Clm_Engagement_Imanage_Documents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Clm_Engagement_RecordsArgs = {
  where: Clm_Engagement_Records_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Clm_Engagement_Records_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Clm_ViewsArgs = {
  where: Clm_Views_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Clm_Views_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Fd_Email_TemplatesArgs = {
  where: Fd_Email_Templates_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Fd_Email_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Fd_Exempt_MattersArgs = {
  where: Fd_Exempt_Matters_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Fd_Exempt_Matters_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Fd_Instruction_TemplatesArgs = {
  where: Fd_Instruction_Templates_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Fd_Instruction_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Fd_Matters_ResponsesArgs = {
  where: Fd_Matters_Responses_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Fd_Matters_Responses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Fd_Project_AccessArgs = {
  where: Fd_Project_Access_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Fd_Project_Access_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Fd_Project_Number_CounterArgs = {
  where: Fd_Project_Number_Counter_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Fd_Project_Number_Counter_By_PkArgs = {
  project_year: Scalars['smallint']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Fd_ProjectsArgs = {
  where: Fd_Projects_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Fd_Projects_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Fd_Response_In_ProjectsArgs = {
  where: Fd_Response_In_Projects_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Fd_Response_In_Projects_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Fd_ResponsesArgs = {
  where: Fd_Responses_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Fd_Responses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Ftp_RequestArgs = {
  where: Ftp_Request_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Ftp_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Ftp_Request_DetailArgs = {
  where: Ftp_Request_Detail_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Ftp_Request_Detail_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Ftp_Request_External_AccessArgs = {
  where: Ftp_Request_External_Access_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Ftp_Request_External_Access_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Ftp_Request_External_NoteArgs = {
  where: Ftp_Request_External_Note_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Ftp_Request_External_Note_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Ftp_Request_Internal_NoteArgs = {
  where: Ftp_Request_Internal_Note_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Ftp_Request_Internal_Note_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Ftp_Request_Number_CounterArgs = {
  where: Ftp_Request_Number_Counter_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Ftp_Request_Number_Counter_By_PkArgs = {
  request_year: Scalars['smallint']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Ftp_Request_ParticipantArgs = {
  where: Ftp_Request_Participant_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Ftp_Request_Participant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Gec_Audience_In_EventArgs = {
  where: Gec_Audience_In_Event_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Gec_Audience_In_Event_By_PkArgs = {
  audience_id: Scalars['Int']['input'];
  event_id: Scalars['Int']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Gec_Contact_In_EventArgs = {
  where: Gec_Contact_In_Event_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Gec_Contact_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  user_id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Gec_Departments_In_EventArgs = {
  where: Gec_Departments_In_Event_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Gec_Departments_In_Event_By_PkArgs = {
  department_id: Scalars['Int']['input'];
  event_id: Scalars['Int']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Gec_Event_ExceptionArgs = {
  where: Gec_Event_Exception_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Gec_Event_Exception_By_PkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Gec_EventsArgs = {
  where: Gec_Events_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Gec_Events_By_PkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Gec_Firm_Initiatives_In_EventArgs = {
  where: Gec_Firm_Initiatives_In_Event_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Gec_Firm_Initiatives_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  firm_initiative_id: Scalars['Int']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Gec_Industries_In_EventArgs = {
  where: Gec_Industries_In_Event_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Gec_Industries_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  industry_id: Scalars['Int']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Gec_Office_Visibility_In_EventArgs = {
  where: Gec_Office_Visibility_In_Event_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Gec_Office_Visibility_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  office_id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Gec_Offices_In_EventArgs = {
  where: Gec_Offices_In_Event_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Gec_Offices_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  office_id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Gec_Outside_SpeakersArgs = {
  where: Gec_Outside_Speakers_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Gec_Outside_Speakers_By_PkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Gec_Practice_Groups_In_EventArgs = {
  where: Gec_Practice_Groups_In_Event_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Gec_Practice_Groups_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  practice_group_id: Scalars['Int']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Gec_Speaker_In_EventArgs = {
  where: Gec_Speaker_In_Event_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Gec_Speaker_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  user_id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Gec_Sponsoring_Attorney_In_EventArgs = {
  where: Gec_Sponsoring_Attorney_In_Event_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Gec_Sponsoring_Attorney_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  user_id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Assignmentportal_My_AvailabilityArgs = {
  where: Mnet_Assignmentportal_My_Availability_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Assignmentportal_My_Availability_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_AttachmentsArgs = {
  where: Mnet_Blog_Attachments_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Attachments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_BlogsArgs = {
  where: Mnet_Blog_Blogs_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Blogs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Channel_NotificationsArgs = {
  where: Mnet_Blog_Channel_Notifications_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Channel_Notifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_ChannelsArgs = {
  where: Mnet_Blog_Channels_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Channels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Comment_ReactionsArgs = {
  where: Mnet_Blog_Comment_Reactions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Comment_Reactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_CommentsArgs = {
  where: Mnet_Blog_Comments_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Comments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Email_NotificationsArgs = {
  where: Mnet_Blog_Email_Notifications_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Email_Notifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Email_TemplatesArgs = {
  where: Mnet_Blog_Email_Templates_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Email_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_EventsArgs = {
  where: Mnet_Blog_Events_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Events_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Group_In_BlogsArgs = {
  where: Mnet_Blog_Group_In_Blogs_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Group_In_Blogs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Inbound_EmailsArgs = {
  where: Mnet_Blog_Inbound_Emails_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Inbound_Emails_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Notification_RecipientsArgs = {
  where: Mnet_Blog_Notification_Recipients_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Notification_Recipients_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Notification_Template_RulesArgs = {
  where: Mnet_Blog_Notification_Template_Rules_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Notification_Template_Rules_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Post_ChannelsArgs = {
  where: Mnet_Blog_Post_Channels_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Post_Channels_By_PkArgs = {
  channel_id: Scalars['uuid']['input'];
  post_id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Post_ImagesArgs = {
  where: Mnet_Blog_Post_Images_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Post_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Post_ReactionsArgs = {
  where: Mnet_Blog_Post_Reactions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Post_Reactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_PostsArgs = {
  where: Mnet_Blog_Posts_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Blog_Posts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Mytools_User_ToolArgs = {
  where: Mnet_Mytools_User_Tool_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Mnet_Mytools_User_Tool_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Pbc_Counsel_RepresentativesArgs = {
  where: Pbc_Counsel_Representatives_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Pbc_Counsel_Representatives_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Pbc_Email_TemplatesArgs = {
  where: Pbc_Email_Templates_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Pbc_Email_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Pbc_Exempt_UsersArgs = {
  where: Pbc_Exempt_Users_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Pbc_Exempt_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Pbc_Notification_RecipientsArgs = {
  where: Pbc_Notification_Recipients_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Pbc_Notification_Recipients_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Pbc_Notification_RequestsArgs = {
  where: Pbc_Notification_Requests_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Pbc_Notification_Requests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Pbc_SendersArgs = {
  where: Pbc_Senders_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Pbc_Senders_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootInsert_B2b_External_AccountsArgs = {
  objects: Array<B2b_External_Accounts_Insert_Input>;
  on_conflict?: InputMaybe<B2b_External_Accounts_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_B2b_External_Accounts_OneArgs = {
  object: B2b_External_Accounts_Insert_Input;
  on_conflict?: InputMaybe<B2b_External_Accounts_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_B2b_LogsArgs = {
  objects: Array<B2b_Logs_Insert_Input>;
  on_conflict?: InputMaybe<B2b_Logs_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_B2b_Logs_OneArgs = {
  object: B2b_Logs_Insert_Input;
  on_conflict?: InputMaybe<B2b_Logs_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_B2b_Ml_Sponsor_ReferencesArgs = {
  objects: Array<B2b_Ml_Sponsor_References_Insert_Input>;
  on_conflict?: InputMaybe<B2b_Ml_Sponsor_References_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_B2b_Ml_Sponsor_References_OneArgs = {
  object: B2b_Ml_Sponsor_References_Insert_Input;
  on_conflict?: InputMaybe<B2b_Ml_Sponsor_References_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_B2b_RequestsArgs = {
  objects: Array<B2b_Requests_Insert_Input>;
  on_conflict?: InputMaybe<B2b_Requests_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_B2b_Requests_OneArgs = {
  object: B2b_Requests_Insert_Input;
  on_conflict?: InputMaybe<B2b_Requests_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_B2b_Resource_Owner_ReferencesArgs = {
  objects: Array<B2b_Resource_Owner_References_Insert_Input>;
  on_conflict?: InputMaybe<B2b_Resource_Owner_References_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_B2b_Resource_Owner_References_OneArgs = {
  object: B2b_Resource_Owner_References_Insert_Input;
  on_conflict?: InputMaybe<B2b_Resource_Owner_References_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Clm_Engagement_Client_CommentsArgs = {
  objects: Array<Clm_Engagement_Client_Comments_Insert_Input>;
  on_conflict?: InputMaybe<Clm_Engagement_Client_Comments_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Clm_Engagement_Client_Comments_OneArgs = {
  object: Clm_Engagement_Client_Comments_Insert_Input;
  on_conflict?: InputMaybe<Clm_Engagement_Client_Comments_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Clm_Engagement_Imanage_DocumentsArgs = {
  objects: Array<Clm_Engagement_Imanage_Documents_Insert_Input>;
  on_conflict?: InputMaybe<Clm_Engagement_Imanage_Documents_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Clm_Engagement_Imanage_Documents_OneArgs = {
  object: Clm_Engagement_Imanage_Documents_Insert_Input;
  on_conflict?: InputMaybe<Clm_Engagement_Imanage_Documents_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Clm_Engagement_RecordsArgs = {
  objects: Array<Clm_Engagement_Records_Insert_Input>;
  on_conflict?: InputMaybe<Clm_Engagement_Records_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Clm_Engagement_Records_OneArgs = {
  object: Clm_Engagement_Records_Insert_Input;
  on_conflict?: InputMaybe<Clm_Engagement_Records_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Clm_ViewsArgs = {
  objects: Array<Clm_Views_Insert_Input>;
  on_conflict?: InputMaybe<Clm_Views_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Clm_Views_OneArgs = {
  object: Clm_Views_Insert_Input;
  on_conflict?: InputMaybe<Clm_Views_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Fd_Email_TemplatesArgs = {
  objects: Array<Fd_Email_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Fd_Email_Templates_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Fd_Email_Templates_OneArgs = {
  object: Fd_Email_Templates_Insert_Input;
  on_conflict?: InputMaybe<Fd_Email_Templates_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Fd_Exempt_MattersArgs = {
  objects: Array<Fd_Exempt_Matters_Insert_Input>;
  on_conflict?: InputMaybe<Fd_Exempt_Matters_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Fd_Exempt_Matters_OneArgs = {
  object: Fd_Exempt_Matters_Insert_Input;
  on_conflict?: InputMaybe<Fd_Exempt_Matters_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Fd_Instruction_TemplatesArgs = {
  objects: Array<Fd_Instruction_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Fd_Instruction_Templates_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Fd_Instruction_Templates_OneArgs = {
  object: Fd_Instruction_Templates_Insert_Input;
  on_conflict?: InputMaybe<Fd_Instruction_Templates_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Fd_Matters_ResponsesArgs = {
  objects: Array<Fd_Matters_Responses_Insert_Input>;
  on_conflict?: InputMaybe<Fd_Matters_Responses_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Fd_Matters_Responses_OneArgs = {
  object: Fd_Matters_Responses_Insert_Input;
  on_conflict?: InputMaybe<Fd_Matters_Responses_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Fd_Project_AccessArgs = {
  objects: Array<Fd_Project_Access_Insert_Input>;
  on_conflict?: InputMaybe<Fd_Project_Access_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Fd_Project_Access_OneArgs = {
  object: Fd_Project_Access_Insert_Input;
  on_conflict?: InputMaybe<Fd_Project_Access_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Fd_Project_Number_CounterArgs = {
  objects: Array<Fd_Project_Number_Counter_Insert_Input>;
  on_conflict?: InputMaybe<Fd_Project_Number_Counter_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Fd_Project_Number_Counter_OneArgs = {
  object: Fd_Project_Number_Counter_Insert_Input;
  on_conflict?: InputMaybe<Fd_Project_Number_Counter_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Fd_ProjectsArgs = {
  objects: Array<Fd_Projects_Insert_Input>;
  on_conflict?: InputMaybe<Fd_Projects_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Fd_Projects_OneArgs = {
  object: Fd_Projects_Insert_Input;
  on_conflict?: InputMaybe<Fd_Projects_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Fd_Response_In_ProjectsArgs = {
  objects: Array<Fd_Response_In_Projects_Insert_Input>;
  on_conflict?: InputMaybe<Fd_Response_In_Projects_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Fd_Response_In_Projects_OneArgs = {
  object: Fd_Response_In_Projects_Insert_Input;
  on_conflict?: InputMaybe<Fd_Response_In_Projects_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Fd_ResponsesArgs = {
  objects: Array<Fd_Responses_Insert_Input>;
  on_conflict?: InputMaybe<Fd_Responses_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Fd_Responses_OneArgs = {
  object: Fd_Responses_Insert_Input;
  on_conflict?: InputMaybe<Fd_Responses_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Ftp_RequestArgs = {
  objects: Array<Ftp_Request_Insert_Input>;
  on_conflict?: InputMaybe<Ftp_Request_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Ftp_Request_DetailArgs = {
  objects: Array<Ftp_Request_Detail_Insert_Input>;
  on_conflict?: InputMaybe<Ftp_Request_Detail_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Ftp_Request_Detail_OneArgs = {
  object: Ftp_Request_Detail_Insert_Input;
  on_conflict?: InputMaybe<Ftp_Request_Detail_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Ftp_Request_External_AccessArgs = {
  objects: Array<Ftp_Request_External_Access_Insert_Input>;
  on_conflict?: InputMaybe<Ftp_Request_External_Access_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Ftp_Request_External_Access_OneArgs = {
  object: Ftp_Request_External_Access_Insert_Input;
  on_conflict?: InputMaybe<Ftp_Request_External_Access_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Ftp_Request_External_NoteArgs = {
  objects: Array<Ftp_Request_External_Note_Insert_Input>;
  on_conflict?: InputMaybe<Ftp_Request_External_Note_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Ftp_Request_External_Note_OneArgs = {
  object: Ftp_Request_External_Note_Insert_Input;
  on_conflict?: InputMaybe<Ftp_Request_External_Note_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Ftp_Request_Internal_NoteArgs = {
  objects: Array<Ftp_Request_Internal_Note_Insert_Input>;
  on_conflict?: InputMaybe<Ftp_Request_Internal_Note_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Ftp_Request_Internal_Note_OneArgs = {
  object: Ftp_Request_Internal_Note_Insert_Input;
  on_conflict?: InputMaybe<Ftp_Request_Internal_Note_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Ftp_Request_Number_CounterArgs = {
  objects: Array<Ftp_Request_Number_Counter_Insert_Input>;
  on_conflict?: InputMaybe<Ftp_Request_Number_Counter_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Ftp_Request_Number_Counter_OneArgs = {
  object: Ftp_Request_Number_Counter_Insert_Input;
  on_conflict?: InputMaybe<Ftp_Request_Number_Counter_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Ftp_Request_OneArgs = {
  object: Ftp_Request_Insert_Input;
  on_conflict?: InputMaybe<Ftp_Request_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Ftp_Request_ParticipantArgs = {
  objects: Array<Ftp_Request_Participant_Insert_Input>;
  on_conflict?: InputMaybe<Ftp_Request_Participant_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Ftp_Request_Participant_OneArgs = {
  object: Ftp_Request_Participant_Insert_Input;
  on_conflict?: InputMaybe<Ftp_Request_Participant_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Audience_In_EventArgs = {
  objects: Array<Gec_Audience_In_Event_Insert_Input>;
  on_conflict?: InputMaybe<Gec_Audience_In_Event_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Audience_In_Event_OneArgs = {
  object: Gec_Audience_In_Event_Insert_Input;
  on_conflict?: InputMaybe<Gec_Audience_In_Event_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Contact_In_EventArgs = {
  objects: Array<Gec_Contact_In_Event_Insert_Input>;
  on_conflict?: InputMaybe<Gec_Contact_In_Event_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Contact_In_Event_OneArgs = {
  object: Gec_Contact_In_Event_Insert_Input;
  on_conflict?: InputMaybe<Gec_Contact_In_Event_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Departments_In_EventArgs = {
  objects: Array<Gec_Departments_In_Event_Insert_Input>;
  on_conflict?: InputMaybe<Gec_Departments_In_Event_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Departments_In_Event_OneArgs = {
  object: Gec_Departments_In_Event_Insert_Input;
  on_conflict?: InputMaybe<Gec_Departments_In_Event_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Event_ExceptionArgs = {
  objects: Array<Gec_Event_Exception_Insert_Input>;
  on_conflict?: InputMaybe<Gec_Event_Exception_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Event_Exception_OneArgs = {
  object: Gec_Event_Exception_Insert_Input;
  on_conflict?: InputMaybe<Gec_Event_Exception_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_EventsArgs = {
  objects: Array<Gec_Events_Insert_Input>;
  on_conflict?: InputMaybe<Gec_Events_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Events_OneArgs = {
  object: Gec_Events_Insert_Input;
  on_conflict?: InputMaybe<Gec_Events_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Firm_Initiatives_In_EventArgs = {
  objects: Array<Gec_Firm_Initiatives_In_Event_Insert_Input>;
  on_conflict?: InputMaybe<Gec_Firm_Initiatives_In_Event_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Firm_Initiatives_In_Event_OneArgs = {
  object: Gec_Firm_Initiatives_In_Event_Insert_Input;
  on_conflict?: InputMaybe<Gec_Firm_Initiatives_In_Event_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Industries_In_EventArgs = {
  objects: Array<Gec_Industries_In_Event_Insert_Input>;
  on_conflict?: InputMaybe<Gec_Industries_In_Event_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Industries_In_Event_OneArgs = {
  object: Gec_Industries_In_Event_Insert_Input;
  on_conflict?: InputMaybe<Gec_Industries_In_Event_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Office_Visibility_In_EventArgs = {
  objects: Array<Gec_Office_Visibility_In_Event_Insert_Input>;
  on_conflict?: InputMaybe<Gec_Office_Visibility_In_Event_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Office_Visibility_In_Event_OneArgs = {
  object: Gec_Office_Visibility_In_Event_Insert_Input;
  on_conflict?: InputMaybe<Gec_Office_Visibility_In_Event_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Offices_In_EventArgs = {
  objects: Array<Gec_Offices_In_Event_Insert_Input>;
  on_conflict?: InputMaybe<Gec_Offices_In_Event_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Offices_In_Event_OneArgs = {
  object: Gec_Offices_In_Event_Insert_Input;
  on_conflict?: InputMaybe<Gec_Offices_In_Event_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Outside_SpeakersArgs = {
  objects: Array<Gec_Outside_Speakers_Insert_Input>;
  on_conflict?: InputMaybe<Gec_Outside_Speakers_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Outside_Speakers_OneArgs = {
  object: Gec_Outside_Speakers_Insert_Input;
  on_conflict?: InputMaybe<Gec_Outside_Speakers_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Practice_Groups_In_EventArgs = {
  objects: Array<Gec_Practice_Groups_In_Event_Insert_Input>;
  on_conflict?: InputMaybe<Gec_Practice_Groups_In_Event_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Practice_Groups_In_Event_OneArgs = {
  object: Gec_Practice_Groups_In_Event_Insert_Input;
  on_conflict?: InputMaybe<Gec_Practice_Groups_In_Event_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Speaker_In_EventArgs = {
  objects: Array<Gec_Speaker_In_Event_Insert_Input>;
  on_conflict?: InputMaybe<Gec_Speaker_In_Event_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Speaker_In_Event_OneArgs = {
  object: Gec_Speaker_In_Event_Insert_Input;
  on_conflict?: InputMaybe<Gec_Speaker_In_Event_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Sponsoring_Attorney_In_EventArgs = {
  objects: Array<Gec_Sponsoring_Attorney_In_Event_Insert_Input>;
  on_conflict?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Gec_Sponsoring_Attorney_In_Event_OneArgs = {
  object: Gec_Sponsoring_Attorney_In_Event_Insert_Input;
  on_conflict?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Assignmentportal_My_AvailabilityArgs = {
  objects: Array<Mnet_Assignmentportal_My_Availability_Insert_Input>;
  on_conflict?: InputMaybe<Mnet_Assignmentportal_My_Availability_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Assignmentportal_My_Availability_OneArgs = {
  object: Mnet_Assignmentportal_My_Availability_Insert_Input;
  on_conflict?: InputMaybe<Mnet_Assignmentportal_My_Availability_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_AttachmentsArgs = {
  objects: Array<Mnet_Blog_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Mnet_Blog_Attachments_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Attachments_OneArgs = {
  object: Mnet_Blog_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Mnet_Blog_Attachments_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_BlogsArgs = {
  objects: Array<Mnet_Blog_Blogs_Insert_Input>;
  on_conflict?: InputMaybe<Mnet_Blog_Blogs_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Blogs_OneArgs = {
  object: Mnet_Blog_Blogs_Insert_Input;
  on_conflict?: InputMaybe<Mnet_Blog_Blogs_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Channel_NotificationsArgs = {
  objects: Array<Mnet_Blog_Channel_Notifications_Insert_Input>;
  on_conflict?: InputMaybe<Mnet_Blog_Channel_Notifications_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Channel_Notifications_OneArgs = {
  object: Mnet_Blog_Channel_Notifications_Insert_Input;
  on_conflict?: InputMaybe<Mnet_Blog_Channel_Notifications_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_ChannelsArgs = {
  objects: Array<Mnet_Blog_Channels_Insert_Input>;
  on_conflict?: InputMaybe<Mnet_Blog_Channels_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Channels_OneArgs = {
  object: Mnet_Blog_Channels_Insert_Input;
  on_conflict?: InputMaybe<Mnet_Blog_Channels_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Comment_ReactionsArgs = {
  objects: Array<Mnet_Blog_Comment_Reactions_Insert_Input>;
  on_conflict?: InputMaybe<Mnet_Blog_Comment_Reactions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Comment_Reactions_OneArgs = {
  object: Mnet_Blog_Comment_Reactions_Insert_Input;
  on_conflict?: InputMaybe<Mnet_Blog_Comment_Reactions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_CommentsArgs = {
  objects: Array<Mnet_Blog_Comments_Insert_Input>;
  on_conflict?: InputMaybe<Mnet_Blog_Comments_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Comments_OneArgs = {
  object: Mnet_Blog_Comments_Insert_Input;
  on_conflict?: InputMaybe<Mnet_Blog_Comments_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Email_NotificationsArgs = {
  objects: Array<Mnet_Blog_Email_Notifications_Insert_Input>;
  on_conflict?: InputMaybe<Mnet_Blog_Email_Notifications_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Email_Notifications_OneArgs = {
  object: Mnet_Blog_Email_Notifications_Insert_Input;
  on_conflict?: InputMaybe<Mnet_Blog_Email_Notifications_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Email_TemplatesArgs = {
  objects: Array<Mnet_Blog_Email_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Mnet_Blog_Email_Templates_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Email_Templates_OneArgs = {
  object: Mnet_Blog_Email_Templates_Insert_Input;
  on_conflict?: InputMaybe<Mnet_Blog_Email_Templates_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_EventsArgs = {
  objects: Array<Mnet_Blog_Events_Insert_Input>;
  on_conflict?: InputMaybe<Mnet_Blog_Events_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Events_OneArgs = {
  object: Mnet_Blog_Events_Insert_Input;
  on_conflict?: InputMaybe<Mnet_Blog_Events_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Group_In_BlogsArgs = {
  objects: Array<Mnet_Blog_Group_In_Blogs_Insert_Input>;
  on_conflict?: InputMaybe<Mnet_Blog_Group_In_Blogs_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Group_In_Blogs_OneArgs = {
  object: Mnet_Blog_Group_In_Blogs_Insert_Input;
  on_conflict?: InputMaybe<Mnet_Blog_Group_In_Blogs_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Inbound_EmailsArgs = {
  objects: Array<Mnet_Blog_Inbound_Emails_Insert_Input>;
  on_conflict?: InputMaybe<Mnet_Blog_Inbound_Emails_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Inbound_Emails_OneArgs = {
  object: Mnet_Blog_Inbound_Emails_Insert_Input;
  on_conflict?: InputMaybe<Mnet_Blog_Inbound_Emails_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Notification_RecipientsArgs = {
  objects: Array<Mnet_Blog_Notification_Recipients_Insert_Input>;
  on_conflict?: InputMaybe<Mnet_Blog_Notification_Recipients_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Notification_Recipients_OneArgs = {
  object: Mnet_Blog_Notification_Recipients_Insert_Input;
  on_conflict?: InputMaybe<Mnet_Blog_Notification_Recipients_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Notification_Template_RulesArgs = {
  objects: Array<Mnet_Blog_Notification_Template_Rules_Insert_Input>;
  on_conflict?: InputMaybe<Mnet_Blog_Notification_Template_Rules_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Notification_Template_Rules_OneArgs = {
  object: Mnet_Blog_Notification_Template_Rules_Insert_Input;
  on_conflict?: InputMaybe<Mnet_Blog_Notification_Template_Rules_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Post_ChannelsArgs = {
  objects: Array<Mnet_Blog_Post_Channels_Insert_Input>;
  on_conflict?: InputMaybe<Mnet_Blog_Post_Channels_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Post_Channels_OneArgs = {
  object: Mnet_Blog_Post_Channels_Insert_Input;
  on_conflict?: InputMaybe<Mnet_Blog_Post_Channels_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Post_ImagesArgs = {
  objects: Array<Mnet_Blog_Post_Images_Insert_Input>;
  on_conflict?: InputMaybe<Mnet_Blog_Post_Images_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Post_Images_OneArgs = {
  object: Mnet_Blog_Post_Images_Insert_Input;
  on_conflict?: InputMaybe<Mnet_Blog_Post_Images_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Post_ReactionsArgs = {
  objects: Array<Mnet_Blog_Post_Reactions_Insert_Input>;
  on_conflict?: InputMaybe<Mnet_Blog_Post_Reactions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Post_Reactions_OneArgs = {
  object: Mnet_Blog_Post_Reactions_Insert_Input;
  on_conflict?: InputMaybe<Mnet_Blog_Post_Reactions_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_PostsArgs = {
  objects: Array<Mnet_Blog_Posts_Insert_Input>;
  on_conflict?: InputMaybe<Mnet_Blog_Posts_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Blog_Posts_OneArgs = {
  object: Mnet_Blog_Posts_Insert_Input;
  on_conflict?: InputMaybe<Mnet_Blog_Posts_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Mytools_User_ToolArgs = {
  objects: Array<Mnet_Mytools_User_Tool_Insert_Input>;
  on_conflict?: InputMaybe<Mnet_Mytools_User_Tool_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Mnet_Mytools_User_Tool_OneArgs = {
  object: Mnet_Mytools_User_Tool_Insert_Input;
  on_conflict?: InputMaybe<Mnet_Mytools_User_Tool_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Pbc_Counsel_RepresentativesArgs = {
  objects: Array<Pbc_Counsel_Representatives_Insert_Input>;
  on_conflict?: InputMaybe<Pbc_Counsel_Representatives_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Pbc_Counsel_Representatives_OneArgs = {
  object: Pbc_Counsel_Representatives_Insert_Input;
  on_conflict?: InputMaybe<Pbc_Counsel_Representatives_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Pbc_Email_TemplatesArgs = {
  objects: Array<Pbc_Email_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Pbc_Email_Templates_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Pbc_Email_Templates_OneArgs = {
  object: Pbc_Email_Templates_Insert_Input;
  on_conflict?: InputMaybe<Pbc_Email_Templates_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Pbc_Exempt_UsersArgs = {
  objects: Array<Pbc_Exempt_Users_Insert_Input>;
  on_conflict?: InputMaybe<Pbc_Exempt_Users_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Pbc_Exempt_Users_OneArgs = {
  object: Pbc_Exempt_Users_Insert_Input;
  on_conflict?: InputMaybe<Pbc_Exempt_Users_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Pbc_Notification_RecipientsArgs = {
  objects: Array<Pbc_Notification_Recipients_Insert_Input>;
  on_conflict?: InputMaybe<Pbc_Notification_Recipients_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Pbc_Notification_Recipients_OneArgs = {
  object: Pbc_Notification_Recipients_Insert_Input;
  on_conflict?: InputMaybe<Pbc_Notification_Recipients_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Pbc_Notification_RequestsArgs = {
  objects: Array<Pbc_Notification_Requests_Insert_Input>;
  on_conflict?: InputMaybe<Pbc_Notification_Requests_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Pbc_Notification_Requests_OneArgs = {
  object: Pbc_Notification_Requests_Insert_Input;
  on_conflict?: InputMaybe<Pbc_Notification_Requests_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Pbc_SendersArgs = {
  objects: Array<Pbc_Senders_Insert_Input>;
  on_conflict?: InputMaybe<Pbc_Senders_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Pbc_Senders_OneArgs = {
  object: Pbc_Senders_Insert_Input;
  on_conflict?: InputMaybe<Pbc_Senders_On_Conflict>;
};

/** mutation root */
export type Mutation_RootUpdateBucketArgs = {
  input: UpdateBucketInput;
};

/** mutation root */
export type Mutation_RootUpdateListItemArgs = {
  input: UpdateListItemInput;
};

/** mutation root */
export type Mutation_RootUpdatePlanArgs = {
  input: UpdatePlanInput;
};

/** mutation root */
export type Mutation_RootUpdatePlanDetailsArgs = {
  input: UpdatePlanDetailsInput;
};

/** mutation root */
export type Mutation_RootUpdateTaskArgs = {
  input: UpdateTaskInput;
};

/** mutation root */
export type Mutation_RootUpdateTaskDetailsArgs = {
  input: UpdateTaskDetailsInput;
};

/** mutation root */
export type Mutation_RootUpdateUserArgs = {
  input: UpdateUserInput;
};

/** mutation root */
export type Mutation_RootUpdate_Bcs_PersonnelArgs = {
  _set?: InputMaybe<Bcs_Personnel_Set_Input>;
  where: Bcs_Personnel_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Bcs_Personnel_By_PkArgs = {
  _set?: InputMaybe<Bcs_Personnel_Set_Input>;
  pk_columns: Bcs_Personnel_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Bcs_Personnel_ManyArgs = {
  updates: Array<Bcs_Personnel_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_B2b_External_AccountsArgs = {
  _set?: InputMaybe<B2b_External_Accounts_Set_Input>;
  where: B2b_External_Accounts_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_B2b_External_Accounts_By_PkArgs = {
  _set?: InputMaybe<B2b_External_Accounts_Set_Input>;
  pk_columns: B2b_External_Accounts_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_B2b_External_Accounts_ManyArgs = {
  updates: Array<B2b_External_Accounts_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_B2b_Ml_Sponsor_ReferencesArgs = {
  _set?: InputMaybe<B2b_Ml_Sponsor_References_Set_Input>;
  where: B2b_Ml_Sponsor_References_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_B2b_Ml_Sponsor_References_By_PkArgs = {
  _set?: InputMaybe<B2b_Ml_Sponsor_References_Set_Input>;
  pk_columns: B2b_Ml_Sponsor_References_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_B2b_Ml_Sponsor_References_ManyArgs = {
  updates: Array<B2b_Ml_Sponsor_References_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_B2b_RequestsArgs = {
  _inc?: InputMaybe<B2b_Requests_Inc_Input>;
  _set?: InputMaybe<B2b_Requests_Set_Input>;
  where: B2b_Requests_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_B2b_Requests_By_PkArgs = {
  _inc?: InputMaybe<B2b_Requests_Inc_Input>;
  _set?: InputMaybe<B2b_Requests_Set_Input>;
  pk_columns: B2b_Requests_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_B2b_Requests_ManyArgs = {
  updates: Array<B2b_Requests_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_B2b_Resource_Owner_ReferencesArgs = {
  _set?: InputMaybe<B2b_Resource_Owner_References_Set_Input>;
  where: B2b_Resource_Owner_References_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_B2b_Resource_Owner_References_By_PkArgs = {
  _set?: InputMaybe<B2b_Resource_Owner_References_Set_Input>;
  pk_columns: B2b_Resource_Owner_References_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_B2b_Resource_Owner_References_ManyArgs = {
  updates: Array<B2b_Resource_Owner_References_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Clm_Engagement_Client_CommentsArgs = {
  _set?: InputMaybe<Clm_Engagement_Client_Comments_Set_Input>;
  where: Clm_Engagement_Client_Comments_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Clm_Engagement_Client_Comments_By_PkArgs = {
  _set?: InputMaybe<Clm_Engagement_Client_Comments_Set_Input>;
  pk_columns: Clm_Engagement_Client_Comments_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Clm_Engagement_Client_Comments_ManyArgs = {
  updates: Array<Clm_Engagement_Client_Comments_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Clm_Engagement_Imanage_DocumentsArgs = {
  _set?: InputMaybe<Clm_Engagement_Imanage_Documents_Set_Input>;
  where: Clm_Engagement_Imanage_Documents_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Clm_Engagement_Imanage_Documents_By_PkArgs = {
  _set?: InputMaybe<Clm_Engagement_Imanage_Documents_Set_Input>;
  pk_columns: Clm_Engagement_Imanage_Documents_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Clm_Engagement_Imanage_Documents_ManyArgs = {
  updates: Array<Clm_Engagement_Imanage_Documents_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Clm_Engagement_RecordsArgs = {
  _set?: InputMaybe<Clm_Engagement_Records_Set_Input>;
  where: Clm_Engagement_Records_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Clm_Engagement_Records_By_PkArgs = {
  _set?: InputMaybe<Clm_Engagement_Records_Set_Input>;
  pk_columns: Clm_Engagement_Records_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Clm_Engagement_Records_ManyArgs = {
  updates: Array<Clm_Engagement_Records_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Clm_ViewsArgs = {
  _append?: InputMaybe<Clm_Views_Append_Input>;
  _delete_at_path?: InputMaybe<Clm_Views_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Clm_Views_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Clm_Views_Delete_Key_Input>;
  _prepend?: InputMaybe<Clm_Views_Prepend_Input>;
  _set?: InputMaybe<Clm_Views_Set_Input>;
  where: Clm_Views_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Clm_Views_By_PkArgs = {
  _append?: InputMaybe<Clm_Views_Append_Input>;
  _delete_at_path?: InputMaybe<Clm_Views_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Clm_Views_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Clm_Views_Delete_Key_Input>;
  _prepend?: InputMaybe<Clm_Views_Prepend_Input>;
  _set?: InputMaybe<Clm_Views_Set_Input>;
  pk_columns: Clm_Views_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Clm_Views_ManyArgs = {
  updates: Array<Clm_Views_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Email_TemplatesArgs = {
  _set?: InputMaybe<Fd_Email_Templates_Set_Input>;
  where: Fd_Email_Templates_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Email_Templates_By_PkArgs = {
  _set?: InputMaybe<Fd_Email_Templates_Set_Input>;
  pk_columns: Fd_Email_Templates_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Email_Templates_ManyArgs = {
  updates: Array<Fd_Email_Templates_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Exempt_MattersArgs = {
  _set?: InputMaybe<Fd_Exempt_Matters_Set_Input>;
  where: Fd_Exempt_Matters_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Exempt_Matters_By_PkArgs = {
  _set?: InputMaybe<Fd_Exempt_Matters_Set_Input>;
  pk_columns: Fd_Exempt_Matters_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Exempt_Matters_ManyArgs = {
  updates: Array<Fd_Exempt_Matters_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Instruction_TemplatesArgs = {
  _set?: InputMaybe<Fd_Instruction_Templates_Set_Input>;
  where: Fd_Instruction_Templates_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Instruction_Templates_By_PkArgs = {
  _set?: InputMaybe<Fd_Instruction_Templates_Set_Input>;
  pk_columns: Fd_Instruction_Templates_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Instruction_Templates_ManyArgs = {
  updates: Array<Fd_Instruction_Templates_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Matters_ResponsesArgs = {
  _set?: InputMaybe<Fd_Matters_Responses_Set_Input>;
  where: Fd_Matters_Responses_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Matters_Responses_By_PkArgs = {
  _set?: InputMaybe<Fd_Matters_Responses_Set_Input>;
  pk_columns: Fd_Matters_Responses_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Matters_Responses_ManyArgs = {
  updates: Array<Fd_Matters_Responses_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Project_AccessArgs = {
  _set?: InputMaybe<Fd_Project_Access_Set_Input>;
  where: Fd_Project_Access_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Project_Access_By_PkArgs = {
  _set?: InputMaybe<Fd_Project_Access_Set_Input>;
  pk_columns: Fd_Project_Access_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Project_Access_ManyArgs = {
  updates: Array<Fd_Project_Access_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Project_Number_CounterArgs = {
  _inc?: InputMaybe<Fd_Project_Number_Counter_Inc_Input>;
  _set?: InputMaybe<Fd_Project_Number_Counter_Set_Input>;
  where: Fd_Project_Number_Counter_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Project_Number_Counter_By_PkArgs = {
  _inc?: InputMaybe<Fd_Project_Number_Counter_Inc_Input>;
  _set?: InputMaybe<Fd_Project_Number_Counter_Set_Input>;
  pk_columns: Fd_Project_Number_Counter_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Project_Number_Counter_ManyArgs = {
  updates: Array<Fd_Project_Number_Counter_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_ProjectsArgs = {
  _append?: InputMaybe<Fd_Projects_Append_Input>;
  _delete_at_path?: InputMaybe<Fd_Projects_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Fd_Projects_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Fd_Projects_Delete_Key_Input>;
  _inc?: InputMaybe<Fd_Projects_Inc_Input>;
  _prepend?: InputMaybe<Fd_Projects_Prepend_Input>;
  _set?: InputMaybe<Fd_Projects_Set_Input>;
  where: Fd_Projects_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Projects_By_PkArgs = {
  _append?: InputMaybe<Fd_Projects_Append_Input>;
  _delete_at_path?: InputMaybe<Fd_Projects_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Fd_Projects_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Fd_Projects_Delete_Key_Input>;
  _inc?: InputMaybe<Fd_Projects_Inc_Input>;
  _prepend?: InputMaybe<Fd_Projects_Prepend_Input>;
  _set?: InputMaybe<Fd_Projects_Set_Input>;
  pk_columns: Fd_Projects_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Projects_ManyArgs = {
  updates: Array<Fd_Projects_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Response_In_ProjectsArgs = {
  _set?: InputMaybe<Fd_Response_In_Projects_Set_Input>;
  where: Fd_Response_In_Projects_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Response_In_Projects_By_PkArgs = {
  _set?: InputMaybe<Fd_Response_In_Projects_Set_Input>;
  pk_columns: Fd_Response_In_Projects_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Response_In_Projects_ManyArgs = {
  updates: Array<Fd_Response_In_Projects_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_ResponsesArgs = {
  _set?: InputMaybe<Fd_Responses_Set_Input>;
  where: Fd_Responses_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Responses_By_PkArgs = {
  _set?: InputMaybe<Fd_Responses_Set_Input>;
  pk_columns: Fd_Responses_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Fd_Responses_ManyArgs = {
  updates: Array<Fd_Responses_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_RequestArgs = {
  _set?: InputMaybe<Ftp_Request_Set_Input>;
  where: Ftp_Request_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_Request_By_PkArgs = {
  _set?: InputMaybe<Ftp_Request_Set_Input>;
  pk_columns: Ftp_Request_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_Request_DetailArgs = {
  _set?: InputMaybe<Ftp_Request_Detail_Set_Input>;
  where: Ftp_Request_Detail_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_Request_Detail_By_PkArgs = {
  _set?: InputMaybe<Ftp_Request_Detail_Set_Input>;
  pk_columns: Ftp_Request_Detail_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_Request_Detail_ManyArgs = {
  updates: Array<Ftp_Request_Detail_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_Request_External_AccessArgs = {
  _set?: InputMaybe<Ftp_Request_External_Access_Set_Input>;
  where: Ftp_Request_External_Access_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_Request_External_Access_By_PkArgs = {
  _set?: InputMaybe<Ftp_Request_External_Access_Set_Input>;
  pk_columns: Ftp_Request_External_Access_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_Request_External_Access_ManyArgs = {
  updates: Array<Ftp_Request_External_Access_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_Request_External_NoteArgs = {
  _set?: InputMaybe<Ftp_Request_External_Note_Set_Input>;
  where: Ftp_Request_External_Note_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_Request_External_Note_By_PkArgs = {
  _set?: InputMaybe<Ftp_Request_External_Note_Set_Input>;
  pk_columns: Ftp_Request_External_Note_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_Request_External_Note_ManyArgs = {
  updates: Array<Ftp_Request_External_Note_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_Request_Internal_NoteArgs = {
  _set?: InputMaybe<Ftp_Request_Internal_Note_Set_Input>;
  where: Ftp_Request_Internal_Note_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_Request_Internal_Note_By_PkArgs = {
  _set?: InputMaybe<Ftp_Request_Internal_Note_Set_Input>;
  pk_columns: Ftp_Request_Internal_Note_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_Request_Internal_Note_ManyArgs = {
  updates: Array<Ftp_Request_Internal_Note_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_Request_ManyArgs = {
  updates: Array<Ftp_Request_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_Request_Number_CounterArgs = {
  _inc?: InputMaybe<Ftp_Request_Number_Counter_Inc_Input>;
  _set?: InputMaybe<Ftp_Request_Number_Counter_Set_Input>;
  where: Ftp_Request_Number_Counter_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_Request_Number_Counter_By_PkArgs = {
  _inc?: InputMaybe<Ftp_Request_Number_Counter_Inc_Input>;
  _set?: InputMaybe<Ftp_Request_Number_Counter_Set_Input>;
  pk_columns: Ftp_Request_Number_Counter_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_Request_Number_Counter_ManyArgs = {
  updates: Array<Ftp_Request_Number_Counter_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_Request_ParticipantArgs = {
  _set?: InputMaybe<Ftp_Request_Participant_Set_Input>;
  where: Ftp_Request_Participant_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_Request_Participant_By_PkArgs = {
  _set?: InputMaybe<Ftp_Request_Participant_Set_Input>;
  pk_columns: Ftp_Request_Participant_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Ftp_Request_Participant_ManyArgs = {
  updates: Array<Ftp_Request_Participant_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Audience_In_EventArgs = {
  _inc?: InputMaybe<Gec_Audience_In_Event_Inc_Input>;
  _set?: InputMaybe<Gec_Audience_In_Event_Set_Input>;
  where: Gec_Audience_In_Event_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Audience_In_Event_By_PkArgs = {
  _inc?: InputMaybe<Gec_Audience_In_Event_Inc_Input>;
  _set?: InputMaybe<Gec_Audience_In_Event_Set_Input>;
  pk_columns: Gec_Audience_In_Event_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Audience_In_Event_ManyArgs = {
  updates: Array<Gec_Audience_In_Event_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Contact_In_EventArgs = {
  _inc?: InputMaybe<Gec_Contact_In_Event_Inc_Input>;
  _set?: InputMaybe<Gec_Contact_In_Event_Set_Input>;
  where: Gec_Contact_In_Event_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Contact_In_Event_By_PkArgs = {
  _inc?: InputMaybe<Gec_Contact_In_Event_Inc_Input>;
  _set?: InputMaybe<Gec_Contact_In_Event_Set_Input>;
  pk_columns: Gec_Contact_In_Event_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Contact_In_Event_ManyArgs = {
  updates: Array<Gec_Contact_In_Event_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Departments_In_EventArgs = {
  _inc?: InputMaybe<Gec_Departments_In_Event_Inc_Input>;
  _set?: InputMaybe<Gec_Departments_In_Event_Set_Input>;
  where: Gec_Departments_In_Event_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Departments_In_Event_By_PkArgs = {
  _inc?: InputMaybe<Gec_Departments_In_Event_Inc_Input>;
  _set?: InputMaybe<Gec_Departments_In_Event_Set_Input>;
  pk_columns: Gec_Departments_In_Event_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Departments_In_Event_ManyArgs = {
  updates: Array<Gec_Departments_In_Event_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Event_ExceptionArgs = {
  _inc?: InputMaybe<Gec_Event_Exception_Inc_Input>;
  _set?: InputMaybe<Gec_Event_Exception_Set_Input>;
  where: Gec_Event_Exception_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Event_Exception_By_PkArgs = {
  _inc?: InputMaybe<Gec_Event_Exception_Inc_Input>;
  _set?: InputMaybe<Gec_Event_Exception_Set_Input>;
  pk_columns: Gec_Event_Exception_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Event_Exception_ManyArgs = {
  updates: Array<Gec_Event_Exception_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_EventsArgs = {
  _inc?: InputMaybe<Gec_Events_Inc_Input>;
  _set?: InputMaybe<Gec_Events_Set_Input>;
  where: Gec_Events_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Events_By_PkArgs = {
  _inc?: InputMaybe<Gec_Events_Inc_Input>;
  _set?: InputMaybe<Gec_Events_Set_Input>;
  pk_columns: Gec_Events_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Events_ManyArgs = {
  updates: Array<Gec_Events_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Firm_Initiatives_In_EventArgs = {
  _inc?: InputMaybe<Gec_Firm_Initiatives_In_Event_Inc_Input>;
  _set?: InputMaybe<Gec_Firm_Initiatives_In_Event_Set_Input>;
  where: Gec_Firm_Initiatives_In_Event_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Firm_Initiatives_In_Event_By_PkArgs = {
  _inc?: InputMaybe<Gec_Firm_Initiatives_In_Event_Inc_Input>;
  _set?: InputMaybe<Gec_Firm_Initiatives_In_Event_Set_Input>;
  pk_columns: Gec_Firm_Initiatives_In_Event_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Firm_Initiatives_In_Event_ManyArgs = {
  updates: Array<Gec_Firm_Initiatives_In_Event_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Industries_In_EventArgs = {
  _inc?: InputMaybe<Gec_Industries_In_Event_Inc_Input>;
  _set?: InputMaybe<Gec_Industries_In_Event_Set_Input>;
  where: Gec_Industries_In_Event_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Industries_In_Event_By_PkArgs = {
  _inc?: InputMaybe<Gec_Industries_In_Event_Inc_Input>;
  _set?: InputMaybe<Gec_Industries_In_Event_Set_Input>;
  pk_columns: Gec_Industries_In_Event_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Industries_In_Event_ManyArgs = {
  updates: Array<Gec_Industries_In_Event_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Office_Visibility_In_EventArgs = {
  _inc?: InputMaybe<Gec_Office_Visibility_In_Event_Inc_Input>;
  _set?: InputMaybe<Gec_Office_Visibility_In_Event_Set_Input>;
  where: Gec_Office_Visibility_In_Event_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Office_Visibility_In_Event_By_PkArgs = {
  _inc?: InputMaybe<Gec_Office_Visibility_In_Event_Inc_Input>;
  _set?: InputMaybe<Gec_Office_Visibility_In_Event_Set_Input>;
  pk_columns: Gec_Office_Visibility_In_Event_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Office_Visibility_In_Event_ManyArgs = {
  updates: Array<Gec_Office_Visibility_In_Event_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Offices_In_EventArgs = {
  _inc?: InputMaybe<Gec_Offices_In_Event_Inc_Input>;
  _set?: InputMaybe<Gec_Offices_In_Event_Set_Input>;
  where: Gec_Offices_In_Event_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Offices_In_Event_By_PkArgs = {
  _inc?: InputMaybe<Gec_Offices_In_Event_Inc_Input>;
  _set?: InputMaybe<Gec_Offices_In_Event_Set_Input>;
  pk_columns: Gec_Offices_In_Event_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Offices_In_Event_ManyArgs = {
  updates: Array<Gec_Offices_In_Event_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Outside_SpeakersArgs = {
  _inc?: InputMaybe<Gec_Outside_Speakers_Inc_Input>;
  _set?: InputMaybe<Gec_Outside_Speakers_Set_Input>;
  where: Gec_Outside_Speakers_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Outside_Speakers_By_PkArgs = {
  _inc?: InputMaybe<Gec_Outside_Speakers_Inc_Input>;
  _set?: InputMaybe<Gec_Outside_Speakers_Set_Input>;
  pk_columns: Gec_Outside_Speakers_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Outside_Speakers_ManyArgs = {
  updates: Array<Gec_Outside_Speakers_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Practice_Groups_In_EventArgs = {
  _inc?: InputMaybe<Gec_Practice_Groups_In_Event_Inc_Input>;
  _set?: InputMaybe<Gec_Practice_Groups_In_Event_Set_Input>;
  where: Gec_Practice_Groups_In_Event_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Practice_Groups_In_Event_By_PkArgs = {
  _inc?: InputMaybe<Gec_Practice_Groups_In_Event_Inc_Input>;
  _set?: InputMaybe<Gec_Practice_Groups_In_Event_Set_Input>;
  pk_columns: Gec_Practice_Groups_In_Event_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Practice_Groups_In_Event_ManyArgs = {
  updates: Array<Gec_Practice_Groups_In_Event_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Speaker_In_EventArgs = {
  _inc?: InputMaybe<Gec_Speaker_In_Event_Inc_Input>;
  _set?: InputMaybe<Gec_Speaker_In_Event_Set_Input>;
  where: Gec_Speaker_In_Event_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Speaker_In_Event_By_PkArgs = {
  _inc?: InputMaybe<Gec_Speaker_In_Event_Inc_Input>;
  _set?: InputMaybe<Gec_Speaker_In_Event_Set_Input>;
  pk_columns: Gec_Speaker_In_Event_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Speaker_In_Event_ManyArgs = {
  updates: Array<Gec_Speaker_In_Event_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Sponsoring_Attorney_In_EventArgs = {
  _inc?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Inc_Input>;
  _set?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Set_Input>;
  where: Gec_Sponsoring_Attorney_In_Event_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Sponsoring_Attorney_In_Event_By_PkArgs = {
  _inc?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Inc_Input>;
  _set?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Set_Input>;
  pk_columns: Gec_Sponsoring_Attorney_In_Event_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Gec_Sponsoring_Attorney_In_Event_ManyArgs = {
  updates: Array<Gec_Sponsoring_Attorney_In_Event_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Assignmentportal_My_AvailabilityArgs = {
  _set?: InputMaybe<Mnet_Assignmentportal_My_Availability_Set_Input>;
  where: Mnet_Assignmentportal_My_Availability_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Assignmentportal_My_Availability_By_PkArgs = {
  _set?: InputMaybe<Mnet_Assignmentportal_My_Availability_Set_Input>;
  pk_columns: Mnet_Assignmentportal_My_Availability_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Assignmentportal_My_Availability_ManyArgs = {
  updates: Array<Mnet_Assignmentportal_My_Availability_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_AttachmentsArgs = {
  _set?: InputMaybe<Mnet_Blog_Attachments_Set_Input>;
  where: Mnet_Blog_Attachments_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Attachments_By_PkArgs = {
  _set?: InputMaybe<Mnet_Blog_Attachments_Set_Input>;
  pk_columns: Mnet_Blog_Attachments_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Attachments_ManyArgs = {
  updates: Array<Mnet_Blog_Attachments_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_BlogsArgs = {
  _set?: InputMaybe<Mnet_Blog_Blogs_Set_Input>;
  where: Mnet_Blog_Blogs_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Blogs_By_PkArgs = {
  _set?: InputMaybe<Mnet_Blog_Blogs_Set_Input>;
  pk_columns: Mnet_Blog_Blogs_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Blogs_ManyArgs = {
  updates: Array<Mnet_Blog_Blogs_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Channel_NotificationsArgs = {
  _set?: InputMaybe<Mnet_Blog_Channel_Notifications_Set_Input>;
  where: Mnet_Blog_Channel_Notifications_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Channel_Notifications_By_PkArgs = {
  _set?: InputMaybe<Mnet_Blog_Channel_Notifications_Set_Input>;
  pk_columns: Mnet_Blog_Channel_Notifications_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Channel_Notifications_ManyArgs = {
  updates: Array<Mnet_Blog_Channel_Notifications_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_ChannelsArgs = {
  _set?: InputMaybe<Mnet_Blog_Channels_Set_Input>;
  where: Mnet_Blog_Channels_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Channels_By_PkArgs = {
  _set?: InputMaybe<Mnet_Blog_Channels_Set_Input>;
  pk_columns: Mnet_Blog_Channels_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Channels_ManyArgs = {
  updates: Array<Mnet_Blog_Channels_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Comment_ReactionsArgs = {
  _set?: InputMaybe<Mnet_Blog_Comment_Reactions_Set_Input>;
  where: Mnet_Blog_Comment_Reactions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Comment_Reactions_By_PkArgs = {
  _set?: InputMaybe<Mnet_Blog_Comment_Reactions_Set_Input>;
  pk_columns: Mnet_Blog_Comment_Reactions_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Comment_Reactions_ManyArgs = {
  updates: Array<Mnet_Blog_Comment_Reactions_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_CommentsArgs = {
  _set?: InputMaybe<Mnet_Blog_Comments_Set_Input>;
  where: Mnet_Blog_Comments_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Comments_By_PkArgs = {
  _set?: InputMaybe<Mnet_Blog_Comments_Set_Input>;
  pk_columns: Mnet_Blog_Comments_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Comments_ManyArgs = {
  updates: Array<Mnet_Blog_Comments_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Email_NotificationsArgs = {
  _inc?: InputMaybe<Mnet_Blog_Email_Notifications_Inc_Input>;
  _set?: InputMaybe<Mnet_Blog_Email_Notifications_Set_Input>;
  where: Mnet_Blog_Email_Notifications_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Email_Notifications_By_PkArgs = {
  _inc?: InputMaybe<Mnet_Blog_Email_Notifications_Inc_Input>;
  _set?: InputMaybe<Mnet_Blog_Email_Notifications_Set_Input>;
  pk_columns: Mnet_Blog_Email_Notifications_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Email_Notifications_ManyArgs = {
  updates: Array<Mnet_Blog_Email_Notifications_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Email_TemplatesArgs = {
  _set?: InputMaybe<Mnet_Blog_Email_Templates_Set_Input>;
  where: Mnet_Blog_Email_Templates_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Email_Templates_By_PkArgs = {
  _set?: InputMaybe<Mnet_Blog_Email_Templates_Set_Input>;
  pk_columns: Mnet_Blog_Email_Templates_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Email_Templates_ManyArgs = {
  updates: Array<Mnet_Blog_Email_Templates_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_EventsArgs = {
  _append?: InputMaybe<Mnet_Blog_Events_Append_Input>;
  _delete_at_path?: InputMaybe<Mnet_Blog_Events_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Mnet_Blog_Events_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Mnet_Blog_Events_Delete_Key_Input>;
  _prepend?: InputMaybe<Mnet_Blog_Events_Prepend_Input>;
  _set?: InputMaybe<Mnet_Blog_Events_Set_Input>;
  where: Mnet_Blog_Events_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Events_By_PkArgs = {
  _append?: InputMaybe<Mnet_Blog_Events_Append_Input>;
  _delete_at_path?: InputMaybe<Mnet_Blog_Events_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Mnet_Blog_Events_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Mnet_Blog_Events_Delete_Key_Input>;
  _prepend?: InputMaybe<Mnet_Blog_Events_Prepend_Input>;
  _set?: InputMaybe<Mnet_Blog_Events_Set_Input>;
  pk_columns: Mnet_Blog_Events_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Events_ManyArgs = {
  updates: Array<Mnet_Blog_Events_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Group_In_BlogsArgs = {
  _set?: InputMaybe<Mnet_Blog_Group_In_Blogs_Set_Input>;
  where: Mnet_Blog_Group_In_Blogs_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Group_In_Blogs_By_PkArgs = {
  _set?: InputMaybe<Mnet_Blog_Group_In_Blogs_Set_Input>;
  pk_columns: Mnet_Blog_Group_In_Blogs_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Group_In_Blogs_ManyArgs = {
  updates: Array<Mnet_Blog_Group_In_Blogs_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Inbound_EmailsArgs = {
  _set?: InputMaybe<Mnet_Blog_Inbound_Emails_Set_Input>;
  where: Mnet_Blog_Inbound_Emails_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Inbound_Emails_By_PkArgs = {
  _set?: InputMaybe<Mnet_Blog_Inbound_Emails_Set_Input>;
  pk_columns: Mnet_Blog_Inbound_Emails_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Inbound_Emails_ManyArgs = {
  updates: Array<Mnet_Blog_Inbound_Emails_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Notification_RecipientsArgs = {
  _set?: InputMaybe<Mnet_Blog_Notification_Recipients_Set_Input>;
  where: Mnet_Blog_Notification_Recipients_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Notification_Recipients_By_PkArgs = {
  _set?: InputMaybe<Mnet_Blog_Notification_Recipients_Set_Input>;
  pk_columns: Mnet_Blog_Notification_Recipients_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Notification_Recipients_ManyArgs = {
  updates: Array<Mnet_Blog_Notification_Recipients_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Notification_Template_RulesArgs = {
  _inc?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Inc_Input>;
  _set?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Set_Input>;
  where: Mnet_Blog_Notification_Template_Rules_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Notification_Template_Rules_By_PkArgs = {
  _inc?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Inc_Input>;
  _set?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Set_Input>;
  pk_columns: Mnet_Blog_Notification_Template_Rules_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Notification_Template_Rules_ManyArgs = {
  updates: Array<Mnet_Blog_Notification_Template_Rules_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Post_ChannelsArgs = {
  _set?: InputMaybe<Mnet_Blog_Post_Channels_Set_Input>;
  where: Mnet_Blog_Post_Channels_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Post_Channels_By_PkArgs = {
  _set?: InputMaybe<Mnet_Blog_Post_Channels_Set_Input>;
  pk_columns: Mnet_Blog_Post_Channels_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Post_Channels_ManyArgs = {
  updates: Array<Mnet_Blog_Post_Channels_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Post_ImagesArgs = {
  _inc?: InputMaybe<Mnet_Blog_Post_Images_Inc_Input>;
  _set?: InputMaybe<Mnet_Blog_Post_Images_Set_Input>;
  where: Mnet_Blog_Post_Images_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Post_Images_By_PkArgs = {
  _inc?: InputMaybe<Mnet_Blog_Post_Images_Inc_Input>;
  _set?: InputMaybe<Mnet_Blog_Post_Images_Set_Input>;
  pk_columns: Mnet_Blog_Post_Images_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Post_Images_ManyArgs = {
  updates: Array<Mnet_Blog_Post_Images_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Post_ReactionsArgs = {
  _set?: InputMaybe<Mnet_Blog_Post_Reactions_Set_Input>;
  where: Mnet_Blog_Post_Reactions_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Post_Reactions_By_PkArgs = {
  _set?: InputMaybe<Mnet_Blog_Post_Reactions_Set_Input>;
  pk_columns: Mnet_Blog_Post_Reactions_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Post_Reactions_ManyArgs = {
  updates: Array<Mnet_Blog_Post_Reactions_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_PostsArgs = {
  _set?: InputMaybe<Mnet_Blog_Posts_Set_Input>;
  where: Mnet_Blog_Posts_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Posts_By_PkArgs = {
  _set?: InputMaybe<Mnet_Blog_Posts_Set_Input>;
  pk_columns: Mnet_Blog_Posts_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Blog_Posts_ManyArgs = {
  updates: Array<Mnet_Blog_Posts_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Mytools_User_ToolArgs = {
  _inc?: InputMaybe<Mnet_Mytools_User_Tool_Inc_Input>;
  _set?: InputMaybe<Mnet_Mytools_User_Tool_Set_Input>;
  where: Mnet_Mytools_User_Tool_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Mytools_User_Tool_By_PkArgs = {
  _inc?: InputMaybe<Mnet_Mytools_User_Tool_Inc_Input>;
  _set?: InputMaybe<Mnet_Mytools_User_Tool_Set_Input>;
  pk_columns: Mnet_Mytools_User_Tool_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Mnet_Mytools_User_Tool_ManyArgs = {
  updates: Array<Mnet_Mytools_User_Tool_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Pbc_Counsel_RepresentativesArgs = {
  _set?: InputMaybe<Pbc_Counsel_Representatives_Set_Input>;
  where: Pbc_Counsel_Representatives_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Pbc_Counsel_Representatives_By_PkArgs = {
  _set?: InputMaybe<Pbc_Counsel_Representatives_Set_Input>;
  pk_columns: Pbc_Counsel_Representatives_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Pbc_Counsel_Representatives_ManyArgs = {
  updates: Array<Pbc_Counsel_Representatives_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Pbc_Email_TemplatesArgs = {
  _set?: InputMaybe<Pbc_Email_Templates_Set_Input>;
  where: Pbc_Email_Templates_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Pbc_Email_Templates_By_PkArgs = {
  _set?: InputMaybe<Pbc_Email_Templates_Set_Input>;
  pk_columns: Pbc_Email_Templates_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Pbc_Email_Templates_ManyArgs = {
  updates: Array<Pbc_Email_Templates_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Pbc_Exempt_UsersArgs = {
  _set?: InputMaybe<Pbc_Exempt_Users_Set_Input>;
  where: Pbc_Exempt_Users_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Pbc_Exempt_Users_By_PkArgs = {
  _set?: InputMaybe<Pbc_Exempt_Users_Set_Input>;
  pk_columns: Pbc_Exempt_Users_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Pbc_Exempt_Users_ManyArgs = {
  updates: Array<Pbc_Exempt_Users_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Pbc_Notification_RecipientsArgs = {
  _inc?: InputMaybe<Pbc_Notification_Recipients_Inc_Input>;
  _set?: InputMaybe<Pbc_Notification_Recipients_Set_Input>;
  where: Pbc_Notification_Recipients_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Pbc_Notification_Recipients_By_PkArgs = {
  _inc?: InputMaybe<Pbc_Notification_Recipients_Inc_Input>;
  _set?: InputMaybe<Pbc_Notification_Recipients_Set_Input>;
  pk_columns: Pbc_Notification_Recipients_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Pbc_Notification_Recipients_ManyArgs = {
  updates: Array<Pbc_Notification_Recipients_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Pbc_Notification_RequestsArgs = {
  _append?: InputMaybe<Pbc_Notification_Requests_Append_Input>;
  _delete_at_path?: InputMaybe<Pbc_Notification_Requests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Pbc_Notification_Requests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Pbc_Notification_Requests_Delete_Key_Input>;
  _inc?: InputMaybe<Pbc_Notification_Requests_Inc_Input>;
  _prepend?: InputMaybe<Pbc_Notification_Requests_Prepend_Input>;
  _set?: InputMaybe<Pbc_Notification_Requests_Set_Input>;
  where: Pbc_Notification_Requests_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Pbc_Notification_Requests_By_PkArgs = {
  _append?: InputMaybe<Pbc_Notification_Requests_Append_Input>;
  _delete_at_path?: InputMaybe<Pbc_Notification_Requests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Pbc_Notification_Requests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Pbc_Notification_Requests_Delete_Key_Input>;
  _inc?: InputMaybe<Pbc_Notification_Requests_Inc_Input>;
  _prepend?: InputMaybe<Pbc_Notification_Requests_Prepend_Input>;
  _set?: InputMaybe<Pbc_Notification_Requests_Set_Input>;
  pk_columns: Pbc_Notification_Requests_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Pbc_Notification_Requests_ManyArgs = {
  updates: Array<Pbc_Notification_Requests_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Pbc_SendersArgs = {
  _set?: InputMaybe<Pbc_Senders_Set_Input>;
  where: Pbc_Senders_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Pbc_Senders_By_PkArgs = {
  _set?: InputMaybe<Pbc_Senders_Set_Input>;
  pk_columns: Pbc_Senders_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Pbc_Senders_ManyArgs = {
  updates: Array<Pbc_Senders_Updates>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  Asc_nulls_first = 'asc_nulls_first',
  /** in ascending order, nulls last */
  Asc_nulls_last = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  Desc_nulls_first = 'desc_nulls_first',
  /** in descending order, nulls last */
  Desc_nulls_last = 'desc_nulls_last',
}

/** columns and relationships of "pbc.counsel_representatives" */
export type Pbc_Counsel_Representatives = {
  Office?: Maybe<Mlfsl_Office>;
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  id: Scalars['uuid']['output'];
  office_id: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
  user?: Maybe<Mlfsl_Personnel>;
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "pbc.counsel_representatives" */
export type Pbc_Counsel_Representatives_Aggregate = {
  aggregate?: Maybe<Pbc_Counsel_Representatives_Aggregate_Fields>;
  nodes: Array<Pbc_Counsel_Representatives>;
};

/** aggregate fields of "pbc.counsel_representatives" */
export type Pbc_Counsel_Representatives_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Pbc_Counsel_Representatives_Max_Fields>;
  min?: Maybe<Pbc_Counsel_Representatives_Min_Fields>;
};

/** aggregate fields of "pbc.counsel_representatives" */
export type Pbc_Counsel_Representatives_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pbc_Counsel_Representatives_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "pbc.counsel_representatives". All fields are combined with a logical 'AND'. */
export type Pbc_Counsel_Representatives_Bool_Exp = {
  _and?: InputMaybe<Array<Pbc_Counsel_Representatives_Bool_Exp>>;
  _not?: InputMaybe<Pbc_Counsel_Representatives_Bool_Exp>;
  _or?: InputMaybe<Array<Pbc_Counsel_Representatives_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  office_id?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "pbc.counsel_representatives" */
export enum Pbc_Counsel_Representatives_Constraint {
  /** unique or primary key constraint on columns "office_id" */
  Counsel_representatives_office_id_key = 'counsel_representatives_office_id_key',
  /** unique or primary key constraint on columns "id" */
  Counsel_representatives_pkey = 'counsel_representatives_pkey',
}

/** input type for inserting data into table "pbc.counsel_representatives" */
export type Pbc_Counsel_Representatives_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  office_id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Pbc_Counsel_Representatives_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  office_id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Pbc_Counsel_Representatives_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  office_id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "pbc.counsel_representatives" */
export type Pbc_Counsel_Representatives_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pbc_Counsel_Representatives>;
};

/** input type for inserting object relation for remote table "pbc.counsel_representatives" */
export type Pbc_Counsel_Representatives_Obj_Rel_Insert_Input = {
  data: Pbc_Counsel_Representatives_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pbc_Counsel_Representatives_On_Conflict>;
};

/** on_conflict condition type for table "pbc.counsel_representatives" */
export type Pbc_Counsel_Representatives_On_Conflict = {
  constraint: Pbc_Counsel_Representatives_Constraint;
  update_columns?: Array<Pbc_Counsel_Representatives_Update_Column>;
  where?: InputMaybe<Pbc_Counsel_Representatives_Bool_Exp>;
};

/** Ordering options when selecting data from "pbc.counsel_representatives". */
export type Pbc_Counsel_Representatives_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  office_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pbc.counsel_representatives */
export type Pbc_Counsel_Representatives_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "pbc.counsel_representatives" */
export enum Pbc_Counsel_Representatives_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Office_id = 'office_id',
  /** column name */
  Title = 'title',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
  /** column name */
  User_id = 'user_id',
}

/** input type for updating data in table "pbc.counsel_representatives" */
export type Pbc_Counsel_Representatives_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  office_id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "pbc_counsel_representatives" */
export type Pbc_Counsel_Representatives_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pbc_Counsel_Representatives_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pbc_Counsel_Representatives_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  office_id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "pbc.counsel_representatives" */
export enum Pbc_Counsel_Representatives_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Office_id = 'office_id',
  /** column name */
  Title = 'title',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
  /** column name */
  User_id = 'user_id',
}

export type Pbc_Counsel_Representatives_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pbc_Counsel_Representatives_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pbc_Counsel_Representatives_Bool_Exp;
};

/** columns and relationships of "pbc.email_templates" */
export type Pbc_Email_Templates = {
  body: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  notification_requests: Array<Pbc_Notification_Requests>;
  /** An aggregate relationship */
  notification_requests_aggregate: Pbc_Notification_Requests_Aggregate;
  subject: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** columns and relationships of "pbc.email_templates" */
export type Pbc_Email_TemplatesNotification_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Notification_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Notification_Requests_Order_By>>;
  where?: InputMaybe<Pbc_Notification_Requests_Bool_Exp>;
};

/** columns and relationships of "pbc.email_templates" */
export type Pbc_Email_TemplatesNotification_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Notification_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Notification_Requests_Order_By>>;
  where?: InputMaybe<Pbc_Notification_Requests_Bool_Exp>;
};

/** aggregated selection of "pbc.email_templates" */
export type Pbc_Email_Templates_Aggregate = {
  aggregate?: Maybe<Pbc_Email_Templates_Aggregate_Fields>;
  nodes: Array<Pbc_Email_Templates>;
};

/** aggregate fields of "pbc.email_templates" */
export type Pbc_Email_Templates_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Pbc_Email_Templates_Max_Fields>;
  min?: Maybe<Pbc_Email_Templates_Min_Fields>;
};

/** aggregate fields of "pbc.email_templates" */
export type Pbc_Email_Templates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pbc_Email_Templates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "pbc.email_templates". All fields are combined with a logical 'AND'. */
export type Pbc_Email_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Pbc_Email_Templates_Bool_Exp>>;
  _not?: InputMaybe<Pbc_Email_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Pbc_Email_Templates_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notification_requests?: InputMaybe<Pbc_Notification_Requests_Bool_Exp>;
  notification_requests_aggregate?: InputMaybe<Pbc_Notification_Requests_Aggregate_Bool_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "pbc.email_templates" */
export enum Pbc_Email_Templates_Constraint {
  /** unique or primary key constraint on columns "key" */
  Email_templates_key_key = 'email_templates_key_key',
  /** unique or primary key constraint on columns "id" */
  Email_templates_pkey = 'email_templates_pkey',
}

/** input type for inserting data into table "pbc.email_templates" */
export type Pbc_Email_Templates_Insert_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notification_requests?: InputMaybe<Pbc_Notification_Requests_Arr_Rel_Insert_Input>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Pbc_Email_Templates_Max_Fields = {
  body?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Pbc_Email_Templates_Min_Fields = {
  body?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "pbc.email_templates" */
export type Pbc_Email_Templates_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pbc_Email_Templates>;
};

/** input type for inserting object relation for remote table "pbc.email_templates" */
export type Pbc_Email_Templates_Obj_Rel_Insert_Input = {
  data: Pbc_Email_Templates_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pbc_Email_Templates_On_Conflict>;
};

/** on_conflict condition type for table "pbc.email_templates" */
export type Pbc_Email_Templates_On_Conflict = {
  constraint: Pbc_Email_Templates_Constraint;
  update_columns?: Array<Pbc_Email_Templates_Update_Column>;
  where?: InputMaybe<Pbc_Email_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "pbc.email_templates". */
export type Pbc_Email_Templates_Order_By = {
  body?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notification_requests_aggregate?: InputMaybe<Pbc_Notification_Requests_Aggregate_Order_By>;
  subject?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pbc.email_templates */
export type Pbc_Email_Templates_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "pbc.email_templates" */
export enum Pbc_Email_Templates_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Is_active = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  Subject = 'subject',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** input type for updating data in table "pbc.email_templates" */
export type Pbc_Email_Templates_Set_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "pbc_email_templates" */
export type Pbc_Email_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pbc_Email_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pbc_Email_Templates_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "pbc.email_templates" */
export enum Pbc_Email_Templates_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Is_active = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  Subject = 'subject',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

export type Pbc_Email_Templates_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pbc_Email_Templates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pbc_Email_Templates_Bool_Exp;
};

/** columns and relationships of "pbc.exempt_users" */
export type Pbc_Exempt_Users = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  is_exempt: Scalars['Boolean']['output'];
  probono_goals: Array<Mlfsl_Probono_Goal>;
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
  user?: Maybe<Mlfsl_Personnel>;
  user_id: Scalars['String']['output'];
};

/** columns and relationships of "pbc.exempt_users" */
export type Pbc_Exempt_UsersProbono_GoalsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Probono_Goal_Order_By>>;
  where?: InputMaybe<Mlfsl_Probono_Goal_Bool_Exp>;
};

/** aggregated selection of "pbc.exempt_users" */
export type Pbc_Exempt_Users_Aggregate = {
  aggregate?: Maybe<Pbc_Exempt_Users_Aggregate_Fields>;
  nodes: Array<Pbc_Exempt_Users>;
};

/** aggregate fields of "pbc.exempt_users" */
export type Pbc_Exempt_Users_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Pbc_Exempt_Users_Max_Fields>;
  min?: Maybe<Pbc_Exempt_Users_Min_Fields>;
};

/** aggregate fields of "pbc.exempt_users" */
export type Pbc_Exempt_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pbc_Exempt_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "pbc.exempt_users". All fields are combined with a logical 'AND'. */
export type Pbc_Exempt_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Pbc_Exempt_Users_Bool_Exp>>;
  _not?: InputMaybe<Pbc_Exempt_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Pbc_Exempt_Users_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_exempt?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "pbc.exempt_users" */
export enum Pbc_Exempt_Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  Exempt_users_pkey = 'exempt_users_pkey',
  /** unique or primary key constraint on columns "user_id" */
  Exempt_users_user_id_key = 'exempt_users_user_id_key',
}

/** input type for inserting data into table "pbc.exempt_users" */
export type Pbc_Exempt_Users_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_exempt?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Pbc_Exempt_Users_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Pbc_Exempt_Users_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "pbc.exempt_users" */
export type Pbc_Exempt_Users_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pbc_Exempt_Users>;
};

/** on_conflict condition type for table "pbc.exempt_users" */
export type Pbc_Exempt_Users_On_Conflict = {
  constraint: Pbc_Exempt_Users_Constraint;
  update_columns?: Array<Pbc_Exempt_Users_Update_Column>;
  where?: InputMaybe<Pbc_Exempt_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "pbc.exempt_users". */
export type Pbc_Exempt_Users_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_exempt?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pbc.exempt_users */
export type Pbc_Exempt_Users_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "pbc.exempt_users" */
export enum Pbc_Exempt_Users_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  First_name = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  Is_exempt = 'is_exempt',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
  /** column name */
  User_id = 'user_id',
}

/** input type for updating data in table "pbc.exempt_users" */
export type Pbc_Exempt_Users_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_exempt?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "pbc_exempt_users" */
export type Pbc_Exempt_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pbc_Exempt_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pbc_Exempt_Users_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_exempt?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "pbc.exempt_users" */
export enum Pbc_Exempt_Users_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  First_name = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  Is_exempt = 'is_exempt',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
  /** column name */
  User_id = 'user_id',
}

export type Pbc_Exempt_Users_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pbc_Exempt_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pbc_Exempt_Users_Bool_Exp;
};

/** columns and relationships of "pbc.notification_recipients" */
export type Pbc_Notification_Recipients = {
  Office?: Maybe<Mlfsl_Office>;
  /** An object relationship */
  counsel_representative?: Maybe<Pbc_Counsel_Representatives>;
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  email_body: Scalars['String']['output'];
  email_cc?: Maybe<Scalars['String']['output']>;
  email_from: Scalars['String']['output'];
  email_subject: Scalars['String']['output'];
  fte_adj_goal: Scalars['Int']['output'];
  hours_to_meet_goal: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  is_exempt: Scalars['Boolean']['output'];
  /** An object relationship */
  notification_request: Pbc_Notification_Requests;
  office_id: Scalars['String']['output'];
  preferred_first_name?: Maybe<Scalars['String']['output']>;
  pro_bono_hours: Scalars['Int']['output'];
  request_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
  user?: Maybe<Mlfsl_Personnel>;
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "pbc.notification_recipients" */
export type Pbc_Notification_Recipients_Aggregate = {
  aggregate?: Maybe<Pbc_Notification_Recipients_Aggregate_Fields>;
  nodes: Array<Pbc_Notification_Recipients>;
};

export type Pbc_Notification_Recipients_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Pbc_Notification_Recipients_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Pbc_Notification_Recipients_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Pbc_Notification_Recipients_Aggregate_Bool_Exp_Count>;
};

export type Pbc_Notification_Recipients_Aggregate_Bool_Exp_Bool_And = {
  arguments: Pbc_Notification_Recipients_Select_Column_Pbc_Notification_Recipients_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Pbc_Notification_Recipients_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Pbc_Notification_Recipients_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Pbc_Notification_Recipients_Select_Column_Pbc_Notification_Recipients_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Pbc_Notification_Recipients_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Pbc_Notification_Recipients_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Pbc_Notification_Recipients_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Pbc_Notification_Recipients_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "pbc.notification_recipients" */
export type Pbc_Notification_Recipients_Aggregate_Fields = {
  avg?: Maybe<Pbc_Notification_Recipients_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pbc_Notification_Recipients_Max_Fields>;
  min?: Maybe<Pbc_Notification_Recipients_Min_Fields>;
  stddev?: Maybe<Pbc_Notification_Recipients_Stddev_Fields>;
  stddev_pop?: Maybe<Pbc_Notification_Recipients_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pbc_Notification_Recipients_Stddev_Samp_Fields>;
  sum?: Maybe<Pbc_Notification_Recipients_Sum_Fields>;
  var_pop?: Maybe<Pbc_Notification_Recipients_Var_Pop_Fields>;
  var_samp?: Maybe<Pbc_Notification_Recipients_Var_Samp_Fields>;
  variance?: Maybe<Pbc_Notification_Recipients_Variance_Fields>;
};

/** aggregate fields of "pbc.notification_recipients" */
export type Pbc_Notification_Recipients_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pbc_Notification_Recipients_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "pbc.notification_recipients" */
export type Pbc_Notification_Recipients_Aggregate_Order_By = {
  avg?: InputMaybe<Pbc_Notification_Recipients_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pbc_Notification_Recipients_Max_Order_By>;
  min?: InputMaybe<Pbc_Notification_Recipients_Min_Order_By>;
  stddev?: InputMaybe<Pbc_Notification_Recipients_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pbc_Notification_Recipients_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pbc_Notification_Recipients_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pbc_Notification_Recipients_Sum_Order_By>;
  var_pop?: InputMaybe<Pbc_Notification_Recipients_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pbc_Notification_Recipients_Var_Samp_Order_By>;
  variance?: InputMaybe<Pbc_Notification_Recipients_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "pbc.notification_recipients" */
export type Pbc_Notification_Recipients_Arr_Rel_Insert_Input = {
  data: Array<Pbc_Notification_Recipients_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pbc_Notification_Recipients_On_Conflict>;
};

/** aggregate avg on columns */
export type Pbc_Notification_Recipients_Avg_Fields = {
  fte_adj_goal?: Maybe<Scalars['Float']['output']>;
  hours_to_meet_goal?: Maybe<Scalars['Float']['output']>;
  pro_bono_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "pbc.notification_recipients" */
export type Pbc_Notification_Recipients_Avg_Order_By = {
  fte_adj_goal?: InputMaybe<Order_By>;
  hours_to_meet_goal?: InputMaybe<Order_By>;
  pro_bono_hours?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "pbc.notification_recipients". All fields are combined with a logical 'AND'. */
export type Pbc_Notification_Recipients_Bool_Exp = {
  _and?: InputMaybe<Array<Pbc_Notification_Recipients_Bool_Exp>>;
  _not?: InputMaybe<Pbc_Notification_Recipients_Bool_Exp>;
  _or?: InputMaybe<Array<Pbc_Notification_Recipients_Bool_Exp>>;
  counsel_representative?: InputMaybe<Pbc_Counsel_Representatives_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  email_body?: InputMaybe<String_Comparison_Exp>;
  email_cc?: InputMaybe<String_Comparison_Exp>;
  email_from?: InputMaybe<String_Comparison_Exp>;
  email_subject?: InputMaybe<String_Comparison_Exp>;
  fte_adj_goal?: InputMaybe<Int_Comparison_Exp>;
  hours_to_meet_goal?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_exempt?: InputMaybe<Boolean_Comparison_Exp>;
  notification_request?: InputMaybe<Pbc_Notification_Requests_Bool_Exp>;
  office_id?: InputMaybe<String_Comparison_Exp>;
  preferred_first_name?: InputMaybe<String_Comparison_Exp>;
  pro_bono_hours?: InputMaybe<Int_Comparison_Exp>;
  request_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "pbc.notification_recipients" */
export enum Pbc_Notification_Recipients_Constraint {
  /** unique or primary key constraint on columns "id" */
  Notification_recipients_pkey = 'notification_recipients_pkey',
}

/** input type for incrementing numeric columns in table "pbc.notification_recipients" */
export type Pbc_Notification_Recipients_Inc_Input = {
  fte_adj_goal?: InputMaybe<Scalars['Int']['input']>;
  hours_to_meet_goal?: InputMaybe<Scalars['Int']['input']>;
  pro_bono_hours?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "pbc.notification_recipients" */
export type Pbc_Notification_Recipients_Insert_Input = {
  counsel_representative?: InputMaybe<Pbc_Counsel_Representatives_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  email_body?: InputMaybe<Scalars['String']['input']>;
  email_cc?: InputMaybe<Scalars['String']['input']>;
  email_from?: InputMaybe<Scalars['String']['input']>;
  email_subject?: InputMaybe<Scalars['String']['input']>;
  fte_adj_goal?: InputMaybe<Scalars['Int']['input']>;
  hours_to_meet_goal?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_exempt?: InputMaybe<Scalars['Boolean']['input']>;
  notification_request?: InputMaybe<Pbc_Notification_Requests_Obj_Rel_Insert_Input>;
  office_id?: InputMaybe<Scalars['String']['input']>;
  preferred_first_name?: InputMaybe<Scalars['String']['input']>;
  pro_bono_hours?: InputMaybe<Scalars['Int']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Pbc_Notification_Recipients_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  email_body?: Maybe<Scalars['String']['output']>;
  email_cc?: Maybe<Scalars['String']['output']>;
  email_from?: Maybe<Scalars['String']['output']>;
  email_subject?: Maybe<Scalars['String']['output']>;
  fte_adj_goal?: Maybe<Scalars['Int']['output']>;
  hours_to_meet_goal?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  office_id?: Maybe<Scalars['String']['output']>;
  preferred_first_name?: Maybe<Scalars['String']['output']>;
  pro_bono_hours?: Maybe<Scalars['Int']['output']>;
  request_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "pbc.notification_recipients" */
export type Pbc_Notification_Recipients_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  email_body?: InputMaybe<Order_By>;
  email_cc?: InputMaybe<Order_By>;
  email_from?: InputMaybe<Order_By>;
  email_subject?: InputMaybe<Order_By>;
  fte_adj_goal?: InputMaybe<Order_By>;
  hours_to_meet_goal?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  office_id?: InputMaybe<Order_By>;
  preferred_first_name?: InputMaybe<Order_By>;
  pro_bono_hours?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pbc_Notification_Recipients_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  email_body?: Maybe<Scalars['String']['output']>;
  email_cc?: Maybe<Scalars['String']['output']>;
  email_from?: Maybe<Scalars['String']['output']>;
  email_subject?: Maybe<Scalars['String']['output']>;
  fte_adj_goal?: Maybe<Scalars['Int']['output']>;
  hours_to_meet_goal?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  office_id?: Maybe<Scalars['String']['output']>;
  preferred_first_name?: Maybe<Scalars['String']['output']>;
  pro_bono_hours?: Maybe<Scalars['Int']['output']>;
  request_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "pbc.notification_recipients" */
export type Pbc_Notification_Recipients_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  email_body?: InputMaybe<Order_By>;
  email_cc?: InputMaybe<Order_By>;
  email_from?: InputMaybe<Order_By>;
  email_subject?: InputMaybe<Order_By>;
  fte_adj_goal?: InputMaybe<Order_By>;
  hours_to_meet_goal?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  office_id?: InputMaybe<Order_By>;
  preferred_first_name?: InputMaybe<Order_By>;
  pro_bono_hours?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "pbc.notification_recipients" */
export type Pbc_Notification_Recipients_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pbc_Notification_Recipients>;
};

/** on_conflict condition type for table "pbc.notification_recipients" */
export type Pbc_Notification_Recipients_On_Conflict = {
  constraint: Pbc_Notification_Recipients_Constraint;
  update_columns?: Array<Pbc_Notification_Recipients_Update_Column>;
  where?: InputMaybe<Pbc_Notification_Recipients_Bool_Exp>;
};

/** Ordering options when selecting data from "pbc.notification_recipients". */
export type Pbc_Notification_Recipients_Order_By = {
  counsel_representative?: InputMaybe<Pbc_Counsel_Representatives_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  email_body?: InputMaybe<Order_By>;
  email_cc?: InputMaybe<Order_By>;
  email_from?: InputMaybe<Order_By>;
  email_subject?: InputMaybe<Order_By>;
  fte_adj_goal?: InputMaybe<Order_By>;
  hours_to_meet_goal?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_exempt?: InputMaybe<Order_By>;
  notification_request?: InputMaybe<Pbc_Notification_Requests_Order_By>;
  office_id?: InputMaybe<Order_By>;
  preferred_first_name?: InputMaybe<Order_By>;
  pro_bono_hours?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pbc.notification_recipients */
export type Pbc_Notification_Recipients_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "pbc.notification_recipients" */
export enum Pbc_Notification_Recipients_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Email_body = 'email_body',
  /** column name */
  Email_cc = 'email_cc',
  /** column name */
  Email_from = 'email_from',
  /** column name */
  Email_subject = 'email_subject',
  /** column name */
  Fte_adj_goal = 'fte_adj_goal',
  /** column name */
  Hours_to_meet_goal = 'hours_to_meet_goal',
  /** column name */
  Id = 'id',
  /** column name */
  Is_exempt = 'is_exempt',
  /** column name */
  Office_id = 'office_id',
  /** column name */
  Preferred_first_name = 'preferred_first_name',
  /** column name */
  Pro_bono_hours = 'pro_bono_hours',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
  /** column name */
  User_id = 'user_id',
}

/** select "pbc_notification_recipients_aggregate_bool_exp_bool_and_arguments_columns" columns of table "pbc.notification_recipients" */
export enum Pbc_Notification_Recipients_Select_Column_Pbc_Notification_Recipients_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Is_exempt = 'is_exempt',
}

/** select "pbc_notification_recipients_aggregate_bool_exp_bool_or_arguments_columns" columns of table "pbc.notification_recipients" */
export enum Pbc_Notification_Recipients_Select_Column_Pbc_Notification_Recipients_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Is_exempt = 'is_exempt',
}

/** input type for updating data in table "pbc.notification_recipients" */
export type Pbc_Notification_Recipients_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  email_body?: InputMaybe<Scalars['String']['input']>;
  email_cc?: InputMaybe<Scalars['String']['input']>;
  email_from?: InputMaybe<Scalars['String']['input']>;
  email_subject?: InputMaybe<Scalars['String']['input']>;
  fte_adj_goal?: InputMaybe<Scalars['Int']['input']>;
  hours_to_meet_goal?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_exempt?: InputMaybe<Scalars['Boolean']['input']>;
  office_id?: InputMaybe<Scalars['String']['input']>;
  preferred_first_name?: InputMaybe<Scalars['String']['input']>;
  pro_bono_hours?: InputMaybe<Scalars['Int']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Pbc_Notification_Recipients_Stddev_Fields = {
  fte_adj_goal?: Maybe<Scalars['Float']['output']>;
  hours_to_meet_goal?: Maybe<Scalars['Float']['output']>;
  pro_bono_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "pbc.notification_recipients" */
export type Pbc_Notification_Recipients_Stddev_Order_By = {
  fte_adj_goal?: InputMaybe<Order_By>;
  hours_to_meet_goal?: InputMaybe<Order_By>;
  pro_bono_hours?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pbc_Notification_Recipients_Stddev_Pop_Fields = {
  fte_adj_goal?: Maybe<Scalars['Float']['output']>;
  hours_to_meet_goal?: Maybe<Scalars['Float']['output']>;
  pro_bono_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "pbc.notification_recipients" */
export type Pbc_Notification_Recipients_Stddev_Pop_Order_By = {
  fte_adj_goal?: InputMaybe<Order_By>;
  hours_to_meet_goal?: InputMaybe<Order_By>;
  pro_bono_hours?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pbc_Notification_Recipients_Stddev_Samp_Fields = {
  fte_adj_goal?: Maybe<Scalars['Float']['output']>;
  hours_to_meet_goal?: Maybe<Scalars['Float']['output']>;
  pro_bono_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "pbc.notification_recipients" */
export type Pbc_Notification_Recipients_Stddev_Samp_Order_By = {
  fte_adj_goal?: InputMaybe<Order_By>;
  hours_to_meet_goal?: InputMaybe<Order_By>;
  pro_bono_hours?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "pbc_notification_recipients" */
export type Pbc_Notification_Recipients_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pbc_Notification_Recipients_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pbc_Notification_Recipients_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  email_body?: InputMaybe<Scalars['String']['input']>;
  email_cc?: InputMaybe<Scalars['String']['input']>;
  email_from?: InputMaybe<Scalars['String']['input']>;
  email_subject?: InputMaybe<Scalars['String']['input']>;
  fte_adj_goal?: InputMaybe<Scalars['Int']['input']>;
  hours_to_meet_goal?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_exempt?: InputMaybe<Scalars['Boolean']['input']>;
  office_id?: InputMaybe<Scalars['String']['input']>;
  preferred_first_name?: InputMaybe<Scalars['String']['input']>;
  pro_bono_hours?: InputMaybe<Scalars['Int']['input']>;
  request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Pbc_Notification_Recipients_Sum_Fields = {
  fte_adj_goal?: Maybe<Scalars['Int']['output']>;
  hours_to_meet_goal?: Maybe<Scalars['Int']['output']>;
  pro_bono_hours?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "pbc.notification_recipients" */
export type Pbc_Notification_Recipients_Sum_Order_By = {
  fte_adj_goal?: InputMaybe<Order_By>;
  hours_to_meet_goal?: InputMaybe<Order_By>;
  pro_bono_hours?: InputMaybe<Order_By>;
};

/** update columns of table "pbc.notification_recipients" */
export enum Pbc_Notification_Recipients_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Email_body = 'email_body',
  /** column name */
  Email_cc = 'email_cc',
  /** column name */
  Email_from = 'email_from',
  /** column name */
  Email_subject = 'email_subject',
  /** column name */
  Fte_adj_goal = 'fte_adj_goal',
  /** column name */
  Hours_to_meet_goal = 'hours_to_meet_goal',
  /** column name */
  Id = 'id',
  /** column name */
  Is_exempt = 'is_exempt',
  /** column name */
  Office_id = 'office_id',
  /** column name */
  Preferred_first_name = 'preferred_first_name',
  /** column name */
  Pro_bono_hours = 'pro_bono_hours',
  /** column name */
  Request_id = 'request_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
  /** column name */
  User_id = 'user_id',
}

export type Pbc_Notification_Recipients_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pbc_Notification_Recipients_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pbc_Notification_Recipients_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pbc_Notification_Recipients_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pbc_Notification_Recipients_Var_Pop_Fields = {
  fte_adj_goal?: Maybe<Scalars['Float']['output']>;
  hours_to_meet_goal?: Maybe<Scalars['Float']['output']>;
  pro_bono_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "pbc.notification_recipients" */
export type Pbc_Notification_Recipients_Var_Pop_Order_By = {
  fte_adj_goal?: InputMaybe<Order_By>;
  hours_to_meet_goal?: InputMaybe<Order_By>;
  pro_bono_hours?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pbc_Notification_Recipients_Var_Samp_Fields = {
  fte_adj_goal?: Maybe<Scalars['Float']['output']>;
  hours_to_meet_goal?: Maybe<Scalars['Float']['output']>;
  pro_bono_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "pbc.notification_recipients" */
export type Pbc_Notification_Recipients_Var_Samp_Order_By = {
  fte_adj_goal?: InputMaybe<Order_By>;
  hours_to_meet_goal?: InputMaybe<Order_By>;
  pro_bono_hours?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pbc_Notification_Recipients_Variance_Fields = {
  fte_adj_goal?: Maybe<Scalars['Float']['output']>;
  hours_to_meet_goal?: Maybe<Scalars['Float']['output']>;
  pro_bono_hours?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "pbc.notification_recipients" */
export type Pbc_Notification_Recipients_Variance_Order_By = {
  fte_adj_goal?: InputMaybe<Order_By>;
  hours_to_meet_goal?: InputMaybe<Order_By>;
  pro_bono_hours?: InputMaybe<Order_By>;
};

/** columns and relationships of "pbc.notification_requests" */
export type Pbc_Notification_Requests = {
  batch_id: Scalars['Int']['output'];
  cc_user?: Maybe<Mlfsl_Personnel>;
  cc_user_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  /** An object relationship */
  email_template: Pbc_Email_Templates;
  email_template_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  notification_recipients: Array<Pbc_Notification_Recipients>;
  /** An aggregate relationship */
  notification_recipients_aggregate: Pbc_Notification_Recipients_Aggregate;
  notification_scheduled_date_time?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  notification_status: Pbc_Notification_Statuses;
  recipient_filters?: Maybe<Scalars['jsonb']['output']>;
  redirect_out_of_office: Scalars['Boolean']['output'];
  reply_to_user?: Maybe<Mlfsl_Personnel>;
  reply_to_user_id?: Maybe<Scalars['String']['output']>;
  scheduled: Scalars['Boolean']['output'];
  /** An object relationship */
  sender: Pbc_Senders;
  sender_id: Scalars['uuid']['output'];
  sent_at?: Maybe<Scalars['timestamptz']['output']>;
  status_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** columns and relationships of "pbc.notification_requests" */
export type Pbc_Notification_RequestsNotification_RecipientsArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Notification_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Notification_Recipients_Order_By>>;
  where?: InputMaybe<Pbc_Notification_Recipients_Bool_Exp>;
};

/** columns and relationships of "pbc.notification_requests" */
export type Pbc_Notification_RequestsNotification_Recipients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Notification_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Notification_Recipients_Order_By>>;
  where?: InputMaybe<Pbc_Notification_Recipients_Bool_Exp>;
};

/** columns and relationships of "pbc.notification_requests" */
export type Pbc_Notification_RequestsRecipient_FiltersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "pbc.notification_requests" */
export type Pbc_Notification_Requests_Aggregate = {
  aggregate?: Maybe<Pbc_Notification_Requests_Aggregate_Fields>;
  nodes: Array<Pbc_Notification_Requests>;
};

export type Pbc_Notification_Requests_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Pbc_Notification_Requests_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Pbc_Notification_Requests_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Pbc_Notification_Requests_Aggregate_Bool_Exp_Count>;
};

export type Pbc_Notification_Requests_Aggregate_Bool_Exp_Bool_And = {
  arguments: Pbc_Notification_Requests_Select_Column_Pbc_Notification_Requests_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Pbc_Notification_Requests_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Pbc_Notification_Requests_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Pbc_Notification_Requests_Select_Column_Pbc_Notification_Requests_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Pbc_Notification_Requests_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Pbc_Notification_Requests_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Pbc_Notification_Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Pbc_Notification_Requests_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "pbc.notification_requests" */
export type Pbc_Notification_Requests_Aggregate_Fields = {
  avg?: Maybe<Pbc_Notification_Requests_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pbc_Notification_Requests_Max_Fields>;
  min?: Maybe<Pbc_Notification_Requests_Min_Fields>;
  stddev?: Maybe<Pbc_Notification_Requests_Stddev_Fields>;
  stddev_pop?: Maybe<Pbc_Notification_Requests_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pbc_Notification_Requests_Stddev_Samp_Fields>;
  sum?: Maybe<Pbc_Notification_Requests_Sum_Fields>;
  var_pop?: Maybe<Pbc_Notification_Requests_Var_Pop_Fields>;
  var_samp?: Maybe<Pbc_Notification_Requests_Var_Samp_Fields>;
  variance?: Maybe<Pbc_Notification_Requests_Variance_Fields>;
};

/** aggregate fields of "pbc.notification_requests" */
export type Pbc_Notification_Requests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pbc_Notification_Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "pbc.notification_requests" */
export type Pbc_Notification_Requests_Aggregate_Order_By = {
  avg?: InputMaybe<Pbc_Notification_Requests_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pbc_Notification_Requests_Max_Order_By>;
  min?: InputMaybe<Pbc_Notification_Requests_Min_Order_By>;
  stddev?: InputMaybe<Pbc_Notification_Requests_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pbc_Notification_Requests_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pbc_Notification_Requests_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pbc_Notification_Requests_Sum_Order_By>;
  var_pop?: InputMaybe<Pbc_Notification_Requests_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pbc_Notification_Requests_Var_Samp_Order_By>;
  variance?: InputMaybe<Pbc_Notification_Requests_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Pbc_Notification_Requests_Append_Input = {
  recipient_filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "pbc.notification_requests" */
export type Pbc_Notification_Requests_Arr_Rel_Insert_Input = {
  data: Array<Pbc_Notification_Requests_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pbc_Notification_Requests_On_Conflict>;
};

/** aggregate avg on columns */
export type Pbc_Notification_Requests_Avg_Fields = {
  batch_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "pbc.notification_requests" */
export type Pbc_Notification_Requests_Avg_Order_By = {
  batch_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "pbc.notification_requests". All fields are combined with a logical 'AND'. */
export type Pbc_Notification_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<Pbc_Notification_Requests_Bool_Exp>>;
  _not?: InputMaybe<Pbc_Notification_Requests_Bool_Exp>;
  _or?: InputMaybe<Array<Pbc_Notification_Requests_Bool_Exp>>;
  batch_id?: InputMaybe<Int_Comparison_Exp>;
  cc_user_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  email_template?: InputMaybe<Pbc_Email_Templates_Bool_Exp>;
  email_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notification_recipients?: InputMaybe<Pbc_Notification_Recipients_Bool_Exp>;
  notification_recipients_aggregate?: InputMaybe<Pbc_Notification_Recipients_Aggregate_Bool_Exp>;
  notification_scheduled_date_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  notification_status?: InputMaybe<Pbc_Notification_Statuses_Bool_Exp>;
  recipient_filters?: InputMaybe<Jsonb_Comparison_Exp>;
  redirect_out_of_office?: InputMaybe<Boolean_Comparison_Exp>;
  reply_to_user_id?: InputMaybe<String_Comparison_Exp>;
  scheduled?: InputMaybe<Boolean_Comparison_Exp>;
  sender?: InputMaybe<Pbc_Senders_Bool_Exp>;
  sender_id?: InputMaybe<Uuid_Comparison_Exp>;
  sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "pbc.notification_requests" */
export enum Pbc_Notification_Requests_Constraint {
  /** unique or primary key constraint on columns "id" */
  Notification_requests_pkey = 'notification_requests_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Pbc_Notification_Requests_Delete_At_Path_Input = {
  recipient_filters?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Pbc_Notification_Requests_Delete_Elem_Input = {
  recipient_filters?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Pbc_Notification_Requests_Delete_Key_Input = {
  recipient_filters?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "pbc.notification_requests" */
export type Pbc_Notification_Requests_Inc_Input = {
  batch_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "pbc.notification_requests" */
export type Pbc_Notification_Requests_Insert_Input = {
  batch_id?: InputMaybe<Scalars['Int']['input']>;
  cc_user_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  email_template?: InputMaybe<Pbc_Email_Templates_Obj_Rel_Insert_Input>;
  email_template_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notification_recipients?: InputMaybe<Pbc_Notification_Recipients_Arr_Rel_Insert_Input>;
  notification_scheduled_date_time?: InputMaybe<Scalars['timestamptz']['input']>;
  recipient_filters?: InputMaybe<Scalars['jsonb']['input']>;
  redirect_out_of_office?: InputMaybe<Scalars['Boolean']['input']>;
  reply_to_user_id?: InputMaybe<Scalars['String']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Pbc_Senders_Obj_Rel_Insert_Input>;
  sender_id?: InputMaybe<Scalars['uuid']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Pbc_Notification_Requests_Max_Fields = {
  batch_id?: Maybe<Scalars['Int']['output']>;
  cc_user_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  email_template_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notification_scheduled_date_time?: Maybe<Scalars['timestamptz']['output']>;
  reply_to_user_id?: Maybe<Scalars['String']['output']>;
  sender_id?: Maybe<Scalars['uuid']['output']>;
  sent_at?: Maybe<Scalars['timestamptz']['output']>;
  status_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "pbc.notification_requests" */
export type Pbc_Notification_Requests_Max_Order_By = {
  batch_id?: InputMaybe<Order_By>;
  cc_user_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  email_template_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notification_scheduled_date_time?: InputMaybe<Order_By>;
  reply_to_user_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pbc_Notification_Requests_Min_Fields = {
  batch_id?: Maybe<Scalars['Int']['output']>;
  cc_user_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  email_template_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notification_scheduled_date_time?: Maybe<Scalars['timestamptz']['output']>;
  reply_to_user_id?: Maybe<Scalars['String']['output']>;
  sender_id?: Maybe<Scalars['uuid']['output']>;
  sent_at?: Maybe<Scalars['timestamptz']['output']>;
  status_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "pbc.notification_requests" */
export type Pbc_Notification_Requests_Min_Order_By = {
  batch_id?: InputMaybe<Order_By>;
  cc_user_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  email_template_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notification_scheduled_date_time?: InputMaybe<Order_By>;
  reply_to_user_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "pbc.notification_requests" */
export type Pbc_Notification_Requests_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pbc_Notification_Requests>;
};

/** input type for inserting object relation for remote table "pbc.notification_requests" */
export type Pbc_Notification_Requests_Obj_Rel_Insert_Input = {
  data: Pbc_Notification_Requests_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pbc_Notification_Requests_On_Conflict>;
};

/** on_conflict condition type for table "pbc.notification_requests" */
export type Pbc_Notification_Requests_On_Conflict = {
  constraint: Pbc_Notification_Requests_Constraint;
  update_columns?: Array<Pbc_Notification_Requests_Update_Column>;
  where?: InputMaybe<Pbc_Notification_Requests_Bool_Exp>;
};

/** Ordering options when selecting data from "pbc.notification_requests". */
export type Pbc_Notification_Requests_Order_By = {
  batch_id?: InputMaybe<Order_By>;
  cc_user_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  email_template?: InputMaybe<Pbc_Email_Templates_Order_By>;
  email_template_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notification_recipients_aggregate?: InputMaybe<Pbc_Notification_Recipients_Aggregate_Order_By>;
  notification_scheduled_date_time?: InputMaybe<Order_By>;
  notification_status?: InputMaybe<Pbc_Notification_Statuses_Order_By>;
  recipient_filters?: InputMaybe<Order_By>;
  redirect_out_of_office?: InputMaybe<Order_By>;
  reply_to_user_id?: InputMaybe<Order_By>;
  scheduled?: InputMaybe<Order_By>;
  sender?: InputMaybe<Pbc_Senders_Order_By>;
  sender_id?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pbc.notification_requests */
export type Pbc_Notification_Requests_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Pbc_Notification_Requests_Prepend_Input = {
  recipient_filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "pbc.notification_requests" */
export enum Pbc_Notification_Requests_Select_Column {
  /** column name */
  Batch_id = 'batch_id',
  /** column name */
  Cc_user_id = 'cc_user_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Email_template_id = 'email_template_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Notification_scheduled_date_time = 'notification_scheduled_date_time',
  /** column name */
  Recipient_filters = 'recipient_filters',
  /** column name */
  Redirect_out_of_office = 'redirect_out_of_office',
  /** column name */
  Reply_to_user_id = 'reply_to_user_id',
  /** column name */
  Scheduled = 'scheduled',
  /** column name */
  Sender_id = 'sender_id',
  /** column name */
  Sent_at = 'sent_at',
  /** column name */
  Status_id = 'status_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** select "pbc_notification_requests_aggregate_bool_exp_bool_and_arguments_columns" columns of table "pbc.notification_requests" */
export enum Pbc_Notification_Requests_Select_Column_Pbc_Notification_Requests_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Redirect_out_of_office = 'redirect_out_of_office',
  /** column name */
  Scheduled = 'scheduled',
}

/** select "pbc_notification_requests_aggregate_bool_exp_bool_or_arguments_columns" columns of table "pbc.notification_requests" */
export enum Pbc_Notification_Requests_Select_Column_Pbc_Notification_Requests_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Redirect_out_of_office = 'redirect_out_of_office',
  /** column name */
  Scheduled = 'scheduled',
}

/** input type for updating data in table "pbc.notification_requests" */
export type Pbc_Notification_Requests_Set_Input = {
  batch_id?: InputMaybe<Scalars['Int']['input']>;
  cc_user_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  email_template_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notification_scheduled_date_time?: InputMaybe<Scalars['timestamptz']['input']>;
  recipient_filters?: InputMaybe<Scalars['jsonb']['input']>;
  redirect_out_of_office?: InputMaybe<Scalars['Boolean']['input']>;
  reply_to_user_id?: InputMaybe<Scalars['String']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  sender_id?: InputMaybe<Scalars['uuid']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Pbc_Notification_Requests_Stddev_Fields = {
  batch_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "pbc.notification_requests" */
export type Pbc_Notification_Requests_Stddev_Order_By = {
  batch_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pbc_Notification_Requests_Stddev_Pop_Fields = {
  batch_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "pbc.notification_requests" */
export type Pbc_Notification_Requests_Stddev_Pop_Order_By = {
  batch_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pbc_Notification_Requests_Stddev_Samp_Fields = {
  batch_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "pbc.notification_requests" */
export type Pbc_Notification_Requests_Stddev_Samp_Order_By = {
  batch_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "pbc_notification_requests" */
export type Pbc_Notification_Requests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pbc_Notification_Requests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pbc_Notification_Requests_Stream_Cursor_Value_Input = {
  batch_id?: InputMaybe<Scalars['Int']['input']>;
  cc_user_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  email_template_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notification_scheduled_date_time?: InputMaybe<Scalars['timestamptz']['input']>;
  recipient_filters?: InputMaybe<Scalars['jsonb']['input']>;
  redirect_out_of_office?: InputMaybe<Scalars['Boolean']['input']>;
  reply_to_user_id?: InputMaybe<Scalars['String']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  sender_id?: InputMaybe<Scalars['uuid']['input']>;
  sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Pbc_Notification_Requests_Sum_Fields = {
  batch_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "pbc.notification_requests" */
export type Pbc_Notification_Requests_Sum_Order_By = {
  batch_id?: InputMaybe<Order_By>;
};

/** update columns of table "pbc.notification_requests" */
export enum Pbc_Notification_Requests_Update_Column {
  /** column name */
  Batch_id = 'batch_id',
  /** column name */
  Cc_user_id = 'cc_user_id',
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Email_template_id = 'email_template_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Notification_scheduled_date_time = 'notification_scheduled_date_time',
  /** column name */
  Recipient_filters = 'recipient_filters',
  /** column name */
  Redirect_out_of_office = 'redirect_out_of_office',
  /** column name */
  Reply_to_user_id = 'reply_to_user_id',
  /** column name */
  Scheduled = 'scheduled',
  /** column name */
  Sender_id = 'sender_id',
  /** column name */
  Sent_at = 'sent_at',
  /** column name */
  Status_id = 'status_id',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

export type Pbc_Notification_Requests_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Pbc_Notification_Requests_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Pbc_Notification_Requests_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Pbc_Notification_Requests_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Pbc_Notification_Requests_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pbc_Notification_Requests_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Pbc_Notification_Requests_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pbc_Notification_Requests_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pbc_Notification_Requests_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pbc_Notification_Requests_Var_Pop_Fields = {
  batch_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "pbc.notification_requests" */
export type Pbc_Notification_Requests_Var_Pop_Order_By = {
  batch_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pbc_Notification_Requests_Var_Samp_Fields = {
  batch_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "pbc.notification_requests" */
export type Pbc_Notification_Requests_Var_Samp_Order_By = {
  batch_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pbc_Notification_Requests_Variance_Fields = {
  batch_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "pbc.notification_requests" */
export type Pbc_Notification_Requests_Variance_Order_By = {
  batch_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "pbc.notification_statuses" */
export type Pbc_Notification_Statuses = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  notification_requests: Array<Pbc_Notification_Requests>;
  /** An aggregate relationship */
  notification_requests_aggregate: Pbc_Notification_Requests_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
};

/** columns and relationships of "pbc.notification_statuses" */
export type Pbc_Notification_StatusesNotification_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Notification_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Notification_Requests_Order_By>>;
  where?: InputMaybe<Pbc_Notification_Requests_Bool_Exp>;
};

/** columns and relationships of "pbc.notification_statuses" */
export type Pbc_Notification_StatusesNotification_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Notification_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Notification_Requests_Order_By>>;
  where?: InputMaybe<Pbc_Notification_Requests_Bool_Exp>;
};

/** aggregated selection of "pbc.notification_statuses" */
export type Pbc_Notification_Statuses_Aggregate = {
  aggregate?: Maybe<Pbc_Notification_Statuses_Aggregate_Fields>;
  nodes: Array<Pbc_Notification_Statuses>;
};

/** aggregate fields of "pbc.notification_statuses" */
export type Pbc_Notification_Statuses_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Pbc_Notification_Statuses_Max_Fields>;
  min?: Maybe<Pbc_Notification_Statuses_Min_Fields>;
};

/** aggregate fields of "pbc.notification_statuses" */
export type Pbc_Notification_Statuses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pbc_Notification_Statuses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "pbc.notification_statuses". All fields are combined with a logical 'AND'. */
export type Pbc_Notification_Statuses_Bool_Exp = {
  _and?: InputMaybe<Array<Pbc_Notification_Statuses_Bool_Exp>>;
  _not?: InputMaybe<Pbc_Notification_Statuses_Bool_Exp>;
  _or?: InputMaybe<Array<Pbc_Notification_Statuses_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notification_requests?: InputMaybe<Pbc_Notification_Requests_Bool_Exp>;
  notification_requests_aggregate?: InputMaybe<Pbc_Notification_Requests_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pbc_Notification_Statuses_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Pbc_Notification_Statuses_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "pbc.notification_statuses". */
export type Pbc_Notification_Statuses_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notification_requests_aggregate?: InputMaybe<Pbc_Notification_Requests_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** select columns of table "pbc.notification_statuses" */
export enum Pbc_Notification_Statuses_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
}

/** Streaming cursor of the table "pbc_notification_statuses" */
export type Pbc_Notification_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pbc_Notification_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pbc_Notification_Statuses_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "pbc.senders" */
export type Pbc_Senders = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_by_user?: Maybe<Mlfsl_Personnel>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  /** An array relationship */
  notification_requests: Array<Pbc_Notification_Requests>;
  /** An aggregate relationship */
  notification_requests_aggregate: Pbc_Notification_Requests_Aggregate;
  signature: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
  updated_by_user?: Maybe<Mlfsl_Personnel>;
  user?: Maybe<Mlfsl_Personnel>;
  user_id: Scalars['String']['output'];
};

/** columns and relationships of "pbc.senders" */
export type Pbc_SendersNotification_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Notification_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Notification_Requests_Order_By>>;
  where?: InputMaybe<Pbc_Notification_Requests_Bool_Exp>;
};

/** columns and relationships of "pbc.senders" */
export type Pbc_SendersNotification_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Notification_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Notification_Requests_Order_By>>;
  where?: InputMaybe<Pbc_Notification_Requests_Bool_Exp>;
};

/** aggregated selection of "pbc.senders" */
export type Pbc_Senders_Aggregate = {
  aggregate?: Maybe<Pbc_Senders_Aggregate_Fields>;
  nodes: Array<Pbc_Senders>;
};

/** aggregate fields of "pbc.senders" */
export type Pbc_Senders_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Pbc_Senders_Max_Fields>;
  min?: Maybe<Pbc_Senders_Min_Fields>;
};

/** aggregate fields of "pbc.senders" */
export type Pbc_Senders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pbc_Senders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "pbc.senders". All fields are combined with a logical 'AND'. */
export type Pbc_Senders_Bool_Exp = {
  _and?: InputMaybe<Array<Pbc_Senders_Bool_Exp>>;
  _not?: InputMaybe<Pbc_Senders_Bool_Exp>;
  _or?: InputMaybe<Array<Pbc_Senders_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  notification_requests?: InputMaybe<Pbc_Notification_Requests_Bool_Exp>;
  notification_requests_aggregate?: InputMaybe<Pbc_Notification_Requests_Aggregate_Bool_Exp>;
  signature?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "pbc.senders" */
export enum Pbc_Senders_Constraint {
  /** unique or primary key constraint on columns "id" */
  Senders_pkey = 'senders_pkey',
  /** unique or primary key constraint on columns "user_id" */
  Senders_user_id_key = 'senders_user_id_key',
}

/** input type for inserting data into table "pbc.senders" */
export type Pbc_Senders_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  notification_requests?: InputMaybe<Pbc_Notification_Requests_Arr_Rel_Insert_Input>;
  signature?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Pbc_Senders_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Pbc_Senders_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "pbc.senders" */
export type Pbc_Senders_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pbc_Senders>;
};

/** input type for inserting object relation for remote table "pbc.senders" */
export type Pbc_Senders_Obj_Rel_Insert_Input = {
  data: Pbc_Senders_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pbc_Senders_On_Conflict>;
};

/** on_conflict condition type for table "pbc.senders" */
export type Pbc_Senders_On_Conflict = {
  constraint: Pbc_Senders_Constraint;
  update_columns?: Array<Pbc_Senders_Update_Column>;
  where?: InputMaybe<Pbc_Senders_Bool_Exp>;
};

/** Ordering options when selecting data from "pbc.senders". */
export type Pbc_Senders_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  notification_requests_aggregate?: InputMaybe<Pbc_Notification_Requests_Aggregate_Order_By>;
  signature?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pbc.senders */
export type Pbc_Senders_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "pbc.senders" */
export enum Pbc_Senders_Select_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Is_active = 'is_active',
  /** column name */
  Signature = 'signature',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
  /** column name */
  User_id = 'user_id',
}

/** input type for updating data in table "pbc.senders" */
export type Pbc_Senders_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "pbc_senders" */
export type Pbc_Senders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pbc_Senders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pbc_Senders_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "pbc.senders" */
export enum Pbc_Senders_Update_Column {
  /** column name */
  Created_at = 'created_at',
  /** column name */
  Created_by = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Is_active = 'is_active',
  /** column name */
  Signature = 'signature',
  /** column name */
  Updated_at = 'updated_at',
  /** column name */
  Updated_by = 'updated_by',
  /** column name */
  User_id = 'user_id',
}

export type Pbc_Senders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pbc_Senders_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pbc_Senders_Bool_Exp;
};

export type Pg_Timezone_Names = {
  abbrev: Scalars['String']['output'];
  is_dst: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  utc_offset: Scalars['interval']['output'];
};

/** Boolean expression to filter rows from the logical model for "pg_timezone_names". All fields are combined with a logical 'AND'. */
export type Pg_Timezone_Names_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Pg_Timezone_Names_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Pg_Timezone_Names_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Pg_Timezone_Names_Bool_Exp_Bool_Exp>>;
  abbrev?: InputMaybe<String_Comparison_Exp>;
  is_dst?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  utc_offset?: InputMaybe<Interval_Comparison_Exp>;
};

export enum Pg_Timezone_Names_Enum_Name {
  /** column name */
  Abbrev = 'abbrev',
  /** column name */
  Is_dst = 'is_dst',
  /** column name */
  Name = 'name',
  /** column name */
  Utc_offset = 'utc_offset',
}

/** Ordering options when selecting data from "pg_timezone_names". */
export type Pg_Timezone_Names_Order_By = {
  abbrev?: InputMaybe<Order_By>;
  is_dst?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  utc_offset?: InputMaybe<Order_By>;
};

export type Query_Root = {
  /** fetch data from the table: "BCS.Personnel" */
  BCS_Personnel: Array<Bcs_Personnel>;
  /** fetch aggregated fields from the table: "BCS.Personnel" */
  BCS_Personnel_aggregate: Bcs_Personnel_Aggregate;
  /** fetch data from the table: "BCS.Personnel" using primary key columns */
  BCS_Personnel_by_pk?: Maybe<Bcs_Personnel>;
  authorizeByAppId: Array<AuthorizationResult>;
  authorizeByModuleId: Array<AuthorizationResult>;
  /** fetch data from the table: "b2b.external_accounts" */
  b2b_external_accounts: Array<B2b_External_Accounts>;
  /** fetch data from the table: "b2b.external_accounts" using primary key columns */
  b2b_external_accounts_by_pk?: Maybe<B2b_External_Accounts>;
  /** fetch data from the table: "b2b.logs" */
  b2b_logs: Array<B2b_Logs>;
  /** fetch data from the table: "b2b.logs" using primary key columns */
  b2b_logs_by_pk?: Maybe<B2b_Logs>;
  /** fetch data from the table: "b2b.ml_sponsor_references" */
  b2b_ml_sponsor_references: Array<B2b_Ml_Sponsor_References>;
  /** fetch data from the table: "b2b.ml_sponsor_references" using primary key columns */
  b2b_ml_sponsor_references_by_pk?: Maybe<B2b_Ml_Sponsor_References>;
  /** fetch data from the table: "b2b.request_status" */
  b2b_request_status: Array<B2b_Request_Status>;
  /** fetch data from the table: "b2b.request_status" using primary key columns */
  b2b_request_status_by_pk?: Maybe<B2b_Request_Status>;
  /** fetch data from the table: "b2b.requests" */
  b2b_requests: Array<B2b_Requests>;
  /** fetch data from the table: "b2b.requests" using primary key columns */
  b2b_requests_by_pk?: Maybe<B2b_Requests>;
  /** fetch data from the table: "b2b.resource_owner_references" */
  b2b_resource_owner_references: Array<B2b_Resource_Owner_References>;
  /** fetch data from the table: "b2b.resource_owner_references" using primary key columns */
  b2b_resource_owner_references_by_pk?: Maybe<B2b_Resource_Owner_References>;
  bucket?: Maybe<Bucket>;
  /** fetch data from the table: "cle.cle_attachments" */
  cle_cle_attachments: Array<Cle_Cle_Attachments>;
  /** fetch aggregated fields from the table: "cle.cle_attachments" */
  cle_cle_attachments_aggregate: Cle_Cle_Attachments_Aggregate;
  /** fetch data from the table: "cle.cle_attachments" using primary key columns */
  cle_cle_attachments_by_pk?: Maybe<Cle_Cle_Attachments>;
  /** fetch data from the table: "cle.cle_requests" */
  cle_cle_requests: Array<Cle_Cle_Requests>;
  /** fetch aggregated fields from the table: "cle.cle_requests" */
  cle_cle_requests_aggregate: Cle_Cle_Requests_Aggregate;
  /** fetch data from the table: "cle.cle_requests" using primary key columns */
  cle_cle_requests_by_pk?: Maybe<Cle_Cle_Requests>;
  /** fetch data from the table: "clm.engagement_client_comments" */
  clm_engagement_client_comments: Array<Clm_Engagement_Client_Comments>;
  /** fetch data from the table: "clm.engagement_client_comments" using primary key columns */
  clm_engagement_client_comments_by_pk?: Maybe<Clm_Engagement_Client_Comments>;
  /** fetch data from the table: "clm.engagement_imanage_documents" */
  clm_engagement_imanage_documents: Array<Clm_Engagement_Imanage_Documents>;
  /** fetch aggregated fields from the table: "clm.engagement_imanage_documents" */
  clm_engagement_imanage_documents_aggregate: Clm_Engagement_Imanage_Documents_Aggregate;
  /** fetch data from the table: "clm.engagement_imanage_documents" using primary key columns */
  clm_engagement_imanage_documents_by_pk?: Maybe<Clm_Engagement_Imanage_Documents>;
  /** fetch data from the table: "clm.engagement_records" */
  clm_engagement_records: Array<Clm_Engagement_Records>;
  /** fetch data from the table: "clm.engagement_records" using primary key columns */
  clm_engagement_records_by_pk?: Maybe<Clm_Engagement_Records>;
  /** fetch data from the table: "clm.views" */
  clm_views: Array<Clm_Views>;
  /** fetch data from the table: "clm.views" using primary key columns */
  clm_views_by_pk?: Maybe<Clm_Views>;
  /** fetch data from the table: "clm.waiver_imanage_documents" */
  clm_waiver_imanage_documents: Array<Clm_Waiver_Imanage_Documents>;
  /** fetch aggregated fields from the table: "clm.waiver_imanage_documents" */
  clm_waiver_imanage_documents_aggregate: Clm_Waiver_Imanage_Documents_Aggregate;
  /** fetch data from the table: "clm.waiver_imanage_documents" using primary key columns */
  clm_waiver_imanage_documents_by_pk?: Maybe<Clm_Waiver_Imanage_Documents>;
  /** fetch data from the table: "clm.waiver_records" */
  clm_waiver_records: Array<Clm_Waiver_Records>;
  /** fetch data from the table: "clm.waiver_records" using primary key columns */
  clm_waiver_records_by_pk?: Maybe<Clm_Waiver_Records>;
  conversationThread?: Maybe<ConversationThread>;
  conversationThreads: Array<ConversationThread>;
  /** fetch data from the table: "fd.email_templates" */
  fd_email_templates: Array<Fd_Email_Templates>;
  /** fetch data from the table: "fd.email_templates" using primary key columns */
  fd_email_templates_by_pk?: Maybe<Fd_Email_Templates>;
  /** fetch data from the table: "fd.exempt_matters" */
  fd_exempt_matters: Array<Fd_Exempt_Matters>;
  /** fetch data from the table: "fd.exempt_matters" using primary key columns */
  fd_exempt_matters_by_pk?: Maybe<Fd_Exempt_Matters>;
  /** fetch data from the table: "fd.instruction_templates" */
  fd_instruction_templates: Array<Fd_Instruction_Templates>;
  /** fetch data from the table: "fd.instruction_templates" using primary key columns */
  fd_instruction_templates_by_pk?: Maybe<Fd_Instruction_Templates>;
  /** fetch data from the table: "fd.matters_responses" */
  fd_matters_responses: Array<Fd_Matters_Responses>;
  /** fetch data from the table: "fd.matters_responses" using primary key columns */
  fd_matters_responses_by_pk?: Maybe<Fd_Matters_Responses>;
  /** fetch data from the table: "fd.project_access" */
  fd_project_access: Array<Fd_Project_Access>;
  /** fetch data from the table: "fd.project_access" using primary key columns */
  fd_project_access_by_pk?: Maybe<Fd_Project_Access>;
  /** fetch data from the table: "fd.project_number_counter" */
  fd_project_number_counter: Array<Fd_Project_Number_Counter>;
  /** fetch data from the table: "fd.project_number_counter" using primary key columns */
  fd_project_number_counter_by_pk?: Maybe<Fd_Project_Number_Counter>;
  /** fetch data from the table: "fd.projects" */
  fd_projects: Array<Fd_Projects>;
  /** fetch data from the table: "fd.projects" using primary key columns */
  fd_projects_by_pk?: Maybe<Fd_Projects>;
  /** fetch data from the table: "fd.response_in_projects" */
  fd_response_in_projects: Array<Fd_Response_In_Projects>;
  /** fetch data from the table: "fd.response_in_projects" using primary key columns */
  fd_response_in_projects_by_pk?: Maybe<Fd_Response_In_Projects>;
  /** fetch data from the table: "fd.responses" */
  fd_responses: Array<Fd_Responses>;
  /** fetch data from the table: "fd.responses" using primary key columns */
  fd_responses_by_pk?: Maybe<Fd_Responses>;
  /** Returns a specific SharePoint document file based on the provided site URL and file unique identifier (GUID). */
  fileById: IFile;
  /** fetch data from the table: "firstup.channels" */
  firstup_channels: Array<Firstup_Channels>;
  /** fetch data from the table: "firstup.channels" using primary key columns */
  firstup_channels_by_pk?: Maybe<Firstup_Channels>;
  /** fetch data from the table: "firstup.content" */
  firstup_content: Array<Firstup_Content>;
  /** fetch aggregated fields from the table: "firstup.content" */
  firstup_content_aggregate: Firstup_Content_Aggregate;
  /** fetch data from the table: "firstup.content" using primary key columns */
  firstup_content_by_pk?: Maybe<Firstup_Content>;
  /** fetch data from the table: "firstup.content_in_channels" */
  firstup_content_in_channels: Array<Firstup_Content_In_Channels>;
  /** fetch aggregated fields from the table: "firstup.content_in_channels" */
  firstup_content_in_channels_aggregate: Firstup_Content_In_Channels_Aggregate;
  /** fetch data from the table: "firstup.content_in_channels" using primary key columns */
  firstup_content_in_channels_by_pk?: Maybe<Firstup_Content_In_Channels>;
  /** fetch data from the table: "firstup.images" */
  firstup_images: Array<Firstup_Images>;
  /** fetch aggregated fields from the table: "firstup.images" */
  firstup_images_aggregate: Firstup_Images_Aggregate;
  /** fetch data from the table: "firstup.images" using primary key columns */
  firstup_images_by_pk?: Maybe<Firstup_Images>;
  /** fetch data from the table: "firstup.images_in_content" */
  firstup_images_in_content: Array<Firstup_Images_In_Content>;
  /** fetch aggregated fields from the table: "firstup.images_in_content" */
  firstup_images_in_content_aggregate: Firstup_Images_In_Content_Aggregate;
  /** fetch data from the table: "firstup.images_in_content" using primary key columns */
  firstup_images_in_content_by_pk?: Maybe<Firstup_Images_In_Content>;
  /** fetch data from the table: "firstup.people_in_content" */
  firstup_people_in_content: Array<Firstup_People_In_Content>;
  /** fetch aggregated fields from the table: "firstup.people_in_content" */
  firstup_people_in_content_aggregate: Firstup_People_In_Content_Aggregate;
  /** fetch data from the table: "firstup.people_in_content" using primary key columns */
  firstup_people_in_content_by_pk?: Maybe<Firstup_People_In_Content>;
  /** fetch data from the table: "firstup.videos" */
  firstup_videos: Array<Firstup_Videos>;
  /** fetch aggregated fields from the table: "firstup.videos" */
  firstup_videos_aggregate: Firstup_Videos_Aggregate;
  /** fetch data from the table: "firstup.videos" using primary key columns */
  firstup_videos_by_pk?: Maybe<Firstup_Videos>;
  /** fetch data from the table: "firstup.videos_in_content" */
  firstup_videos_in_content: Array<Firstup_Videos_In_Content>;
  /** fetch aggregated fields from the table: "firstup.videos_in_content" */
  firstup_videos_in_content_aggregate: Firstup_Videos_In_Content_Aggregate;
  /** fetch data from the table: "firstup.videos_in_content" using primary key columns */
  firstup_videos_in_content_by_pk?: Maybe<Firstup_Videos_In_Content>;
  /** Returns a specific SharePoint document folder based on the provided site URL and folder unique identifier (GUID). */
  folderById: IFolder;
  /** Returns a specific SharePoint document folder based on the provided site URL and server-relative URL. */
  folderByServerRelativeUrl: IFolder;
  /** fetch data from the table: "ftp.request" */
  ftp_request: Array<Ftp_Request>;
  /** fetch aggregated fields from the table: "ftp.request" */
  ftp_request_aggregate: Ftp_Request_Aggregate;
  /** fetch data from the table: "ftp.request" using primary key columns */
  ftp_request_by_pk?: Maybe<Ftp_Request>;
  /** fetch data from the table: "ftp.request_detail" */
  ftp_request_detail: Array<Ftp_Request_Detail>;
  /** fetch data from the table: "ftp.request_detail" using primary key columns */
  ftp_request_detail_by_pk?: Maybe<Ftp_Request_Detail>;
  /** fetch data from the table: "ftp.request_external_access" */
  ftp_request_external_access: Array<Ftp_Request_External_Access>;
  /** fetch data from the table: "ftp.request_external_access" using primary key columns */
  ftp_request_external_access_by_pk?: Maybe<Ftp_Request_External_Access>;
  /** fetch data from the table: "ftp.request_external_note" */
  ftp_request_external_note: Array<Ftp_Request_External_Note>;
  /** fetch data from the table: "ftp.request_external_note" using primary key columns */
  ftp_request_external_note_by_pk?: Maybe<Ftp_Request_External_Note>;
  /** fetch data from the table: "ftp.request_internal_note" */
  ftp_request_internal_note: Array<Ftp_Request_Internal_Note>;
  /** fetch data from the table: "ftp.request_internal_note" using primary key columns */
  ftp_request_internal_note_by_pk?: Maybe<Ftp_Request_Internal_Note>;
  /** fetch data from the table: "ftp.request_number_counter" */
  ftp_request_number_counter: Array<Ftp_Request_Number_Counter>;
  /** fetch data from the table: "ftp.request_number_counter" using primary key columns */
  ftp_request_number_counter_by_pk?: Maybe<Ftp_Request_Number_Counter>;
  /** fetch data from the table: "ftp.request_participant" */
  ftp_request_participant: Array<Ftp_Request_Participant>;
  /** fetch data from the table: "ftp.request_participant" using primary key columns */
  ftp_request_participant_by_pk?: Maybe<Ftp_Request_Participant>;
  /** fetch data from the table: "gec.audience" */
  gec_audience: Array<Gec_Audience>;
  /** fetch data from the table: "gec.audience" using primary key columns */
  gec_audience_by_pk?: Maybe<Gec_Audience>;
  /** fetch data from the table: "gec.audience_in_event" */
  gec_audience_in_event: Array<Gec_Audience_In_Event>;
  /** fetch data from the table: "gec.audience_in_event" using primary key columns */
  gec_audience_in_event_by_pk?: Maybe<Gec_Audience_In_Event>;
  /** fetch data from the table: "gec.contact_in_event" */
  gec_contact_in_event: Array<Gec_Contact_In_Event>;
  /** fetch data from the table: "gec.contact_in_event" using primary key columns */
  gec_contact_in_event_by_pk?: Maybe<Gec_Contact_In_Event>;
  /** fetch data from the table: "gec.departments" */
  gec_departments: Array<Gec_Departments>;
  /** fetch data from the table: "gec.departments" using primary key columns */
  gec_departments_by_pk?: Maybe<Gec_Departments>;
  /** fetch data from the table: "gec.departments_in_event" */
  gec_departments_in_event: Array<Gec_Departments_In_Event>;
  /** fetch data from the table: "gec.departments_in_event" using primary key columns */
  gec_departments_in_event_by_pk?: Maybe<Gec_Departments_In_Event>;
  /** fetch data from the table: "gec.event_exception" */
  gec_event_exception: Array<Gec_Event_Exception>;
  /** fetch data from the table: "gec.event_exception" using primary key columns */
  gec_event_exception_by_pk?: Maybe<Gec_Event_Exception>;
  /** fetch data from the table: "gec.event_format" */
  gec_event_format: Array<Gec_Event_Format>;
  /** fetch data from the table: "gec.event_format" using primary key columns */
  gec_event_format_by_pk?: Maybe<Gec_Event_Format>;
  /** fetch data from the table: "gec.event_type" */
  gec_event_type: Array<Gec_Event_Type>;
  /** fetch data from the table: "gec.event_type" using primary key columns */
  gec_event_type_by_pk?: Maybe<Gec_Event_Type>;
  /** fetch data from the table: "gec.events" */
  gec_events: Array<Gec_Events>;
  /** fetch data from the table: "gec.events" using primary key columns */
  gec_events_by_pk?: Maybe<Gec_Events>;
  /** fetch data from the table: "gec.firm_initiatives" */
  gec_firm_initiatives: Array<Gec_Firm_Initiatives>;
  /** fetch data from the table: "gec.firm_initiatives" using primary key columns */
  gec_firm_initiatives_by_pk?: Maybe<Gec_Firm_Initiatives>;
  /** fetch data from the table: "gec.firm_initiatives_in_event" */
  gec_firm_initiatives_in_event: Array<Gec_Firm_Initiatives_In_Event>;
  /** fetch data from the table: "gec.firm_initiatives_in_event" using primary key columns */
  gec_firm_initiatives_in_event_by_pk?: Maybe<Gec_Firm_Initiatives_In_Event>;
  /** fetch data from the table: "gec.industries" */
  gec_industries: Array<Gec_Industries>;
  /** fetch data from the table: "gec.industries" using primary key columns */
  gec_industries_by_pk?: Maybe<Gec_Industries>;
  /** fetch data from the table: "gec.industries_in_event" */
  gec_industries_in_event: Array<Gec_Industries_In_Event>;
  /** fetch data from the table: "gec.industries_in_event" using primary key columns */
  gec_industries_in_event_by_pk?: Maybe<Gec_Industries_In_Event>;
  /** fetch data from the table: "gec.office_visibility_in_event" */
  gec_office_visibility_in_event: Array<Gec_Office_Visibility_In_Event>;
  /** fetch data from the table: "gec.office_visibility_in_event" using primary key columns */
  gec_office_visibility_in_event_by_pk?: Maybe<Gec_Office_Visibility_In_Event>;
  /** fetch data from the table: "gec.offices" */
  gec_offices: Array<Gec_Offices>;
  /** fetch data from the table: "gec.offices" using primary key columns */
  gec_offices_by_pk?: Maybe<Gec_Offices>;
  /** fetch data from the table: "gec.offices_in_event" */
  gec_offices_in_event: Array<Gec_Offices_In_Event>;
  /** fetch data from the table: "gec.offices_in_event" using primary key columns */
  gec_offices_in_event_by_pk?: Maybe<Gec_Offices_In_Event>;
  /** fetch data from the table: "gec.outside_speakers" */
  gec_outside_speakers: Array<Gec_Outside_Speakers>;
  /** fetch data from the table: "gec.outside_speakers" using primary key columns */
  gec_outside_speakers_by_pk?: Maybe<Gec_Outside_Speakers>;
  /** fetch data from the table: "gec.practice_groups_in_event" */
  gec_practice_groups_in_event: Array<Gec_Practice_Groups_In_Event>;
  /** fetch data from the table: "gec.practice_groups_in_event" using primary key columns */
  gec_practice_groups_in_event_by_pk?: Maybe<Gec_Practice_Groups_In_Event>;
  /** fetch data from the table: "gec.practice_groups_rollup" */
  gec_practice_groups_rollup: Array<Gec_Practice_Groups_Rollup>;
  /** fetch data from the table: "gec.practice_groups_rollup" using primary key columns */
  gec_practice_groups_rollup_by_pk?: Maybe<Gec_Practice_Groups_Rollup>;
  /** fetch data from the table: "gec.speaker_in_event" */
  gec_speaker_in_event: Array<Gec_Speaker_In_Event>;
  /** fetch data from the table: "gec.speaker_in_event" using primary key columns */
  gec_speaker_in_event_by_pk?: Maybe<Gec_Speaker_In_Event>;
  /** fetch data from the table: "gec.sponsoring_attorney_in_event" */
  gec_sponsoring_attorney_in_event: Array<Gec_Sponsoring_Attorney_In_Event>;
  /** fetch data from the table: "gec.sponsoring_attorney_in_event" using primary key columns */
  gec_sponsoring_attorney_in_event_by_pk?: Maybe<Gec_Sponsoring_Attorney_In_Event>;
  gec_timezone_names: Array<Pg_Timezone_Names>;
  group?: Maybe<Group>;
  groupUsers: Array<User>;
  /** Returns a list from the collection based on the provided list unique identifier (GUID) or list title. */
  listByIdOrTitle: IList;
  /** Returns the fields (columns) of a SharePoint list specified by the given site URL and list unique identifier (GUID) or title. */
  listFields: Array<IField>;
  /** Returns a specific item from a SharePoint list based on the provided SharePoint site URL, list unique identifier (GUID) or title, and item ID */
  listItem: IListItem;
  /** Returns all comments from the list item in the specified list. */
  listItemComments: Array<IComment>;
  /** Returns list items from a SharePoint list based on the specified CAML query. */
  listItemsByCamlQuery?: Maybe<ListItemsByCamlQueryConnection>;
  /** Returns all comments from the list items in the specified list. */
  listItemsComments: Array<KeyValuePairOfInt32AndIEnumerableOfIComment>;
  me?: Maybe<User>;
  /** fetch data from the table: "repl.Groups" */
  mlfsl_ad_group: Array<Mlfsl_Ad_Group>;
  /** fetch aggregated fields from the table: "repl.Groups" */
  mlfsl_ad_group_aggregate: Mlfsl_Ad_Group_Aggregate;
  /** fetch data from the table: "repl.Groups" using primary key columns */
  mlfsl_ad_group_by_pk?: Maybe<Mlfsl_Ad_Group>;
  /** fetch data from the table: "repl.Joins" */
  mlfsl_ad_join: Array<Mlfsl_Ad_Join>;
  /** fetch aggregated fields from the table: "repl.Joins" */
  mlfsl_ad_join_aggregate: Mlfsl_Ad_Join_Aggregate;
  /** fetch data from the table: "repl.Joins" using primary key columns */
  mlfsl_ad_join_by_pk?: Maybe<Mlfsl_Ad_Join>;
  /** fetch data from the table: "repl.Logins" */
  mlfsl_ad_login: Array<Mlfsl_Ad_Login>;
  /** fetch aggregated fields from the table: "repl.Logins" */
  mlfsl_ad_login_aggregate: Mlfsl_Ad_Login_Aggregate;
  /** fetch data from the table: "repl.Logins" using primary key columns */
  mlfsl_ad_login_by_pk?: Maybe<Mlfsl_Ad_Login>;
  /** fetch data from the table: "repl.DimClientNow" */
  mlfsl_client: Array<Mlfsl_Client>;
  /** fetch aggregated fields from the table: "repl.DimClientNow" */
  mlfsl_client_aggregate: Mlfsl_Client_Aggregate;
  /** fetch data from the table: "repl.DimClientNow" using primary key columns */
  mlfsl_client_by_pk?: Maybe<Mlfsl_Client>;
  /** fetch data from the table: "MLG.Client_DisplayDescription" */
  mlfsl_client_display_description: Array<Mlfsl_Client_Display_Description>;
  /** fetch data from the table: "repl.DimDate" */
  mlfsl_date: Array<Mlfsl_Date>;
  /** fetch aggregated fields from the table: "repl.DimDate" */
  mlfsl_date_aggregate: Mlfsl_Date_Aggregate;
  /** fetch data from the table: "repl.DimDate" using primary key columns */
  mlfsl_date_by_pk?: Maybe<Mlfsl_Date>;
  /** fetch data from the table: "MNET.Finance_Hours_Client" */
  mlfsl_finance_hours_client: Array<Mlfsl_Finance_Hours_Client>;
  /** fetch aggregated fields from the table: "MNET.Finance_Hours_Client" */
  mlfsl_finance_hours_client_aggregate: Mlfsl_Finance_Hours_Client_Aggregate;
  /** fetch data from the table: "MNET.Finance_Hours_Client" using primary key columns */
  mlfsl_finance_hours_client_by_pk?: Maybe<Mlfsl_Finance_Hours_Client>;
  /** fetch data from the table: "MNET.Finance_Hours_ClientOfficeTimeframe" */
  mlfsl_finance_hours_clientofficetimeframe: Array<Mlfsl_Finance_Hours_Clientofficetimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_ClientOfficeTimeframe" using primary key columns */
  mlfsl_finance_hours_clientofficetimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Clientofficetimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_ClientPGTimeframe" */
  mlfsl_finance_hours_clientpgtimeframe: Array<Mlfsl_Finance_Hours_Clientpgtimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_ClientPGTimeframe" using primary key columns */
  mlfsl_finance_hours_clientpgtimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Clientpgtimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_ClientTimeframe" */
  mlfsl_finance_hours_clienttimeframe: Array<Mlfsl_Finance_Hours_Clienttimeframe>;
  /** fetch aggregated fields from the table: "MNET.Finance_Hours_ClientTimeframe" */
  mlfsl_finance_hours_clienttimeframe_aggregate: Mlfsl_Finance_Hours_Clienttimeframe_Aggregate;
  /** fetch data from the table: "MNET.Finance_Hours_ClientTimeframe" using primary key columns */
  mlfsl_finance_hours_clienttimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Clienttimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
  mlfsl_finance_hours_clienttimekeepertimeframe: Array<Mlfsl_Finance_Hours_Clienttimekeepertimeframe>;
  /** fetch aggregated fields from the table: "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
  mlfsl_finance_hours_clienttimekeepertimeframe_aggregate: Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Aggregate;
  /** fetch data from the table: "MNET.Finance_Hours_ClientTimekeeperTimeframe" using primary key columns */
  mlfsl_finance_hours_clienttimekeepertimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_Matter" */
  mlfsl_finance_hours_matter: Array<Mlfsl_Finance_Hours_Matter>;
  /** fetch aggregated fields from the table: "MNET.Finance_Hours_Matter" */
  mlfsl_finance_hours_matter_aggregate: Mlfsl_Finance_Hours_Matter_Aggregate;
  /** fetch data from the table: "MNET.Finance_Hours_Matter" using primary key columns */
  mlfsl_finance_hours_matter_by_pk?: Maybe<Mlfsl_Finance_Hours_Matter>;
  /** fetch data from the table: "MNET.Finance_Hours_MatterOfficeTimeframe" */
  mlfsl_finance_hours_matterofficetimeframe: Array<Mlfsl_Finance_Hours_Matterofficetimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_MatterOfficeTimeframe" using primary key columns */
  mlfsl_finance_hours_matterofficetimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Matterofficetimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_MatterPGTimeframe" */
  mlfsl_finance_hours_matterpgtimeframe: Array<Mlfsl_Finance_Hours_Matterpgtimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_MatterPGTimeframe" using primary key columns */
  mlfsl_finance_hours_matterpgtimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Matterpgtimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_MatterTimeframe" */
  mlfsl_finance_hours_mattertimeframe: Array<Mlfsl_Finance_Hours_Mattertimeframe>;
  /** fetch aggregated fields from the table: "MNET.Finance_Hours_MatterTimeframe" */
  mlfsl_finance_hours_mattertimeframe_aggregate: Mlfsl_Finance_Hours_Mattertimeframe_Aggregate;
  /** fetch data from the table: "MNET.Finance_Hours_MatterTimeframe" using primary key columns */
  mlfsl_finance_hours_mattertimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Mattertimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_MatterTimeframeCompare" */
  mlfsl_finance_hours_mattertimeframecompare: Array<Mlfsl_Finance_Hours_Mattertimeframecompare>;
  /** fetch data from the table: "MNET.Finance_Hours_MatterTimeframeCompare" using primary key columns */
  mlfsl_finance_hours_mattertimeframecompare_by_pk?: Maybe<Mlfsl_Finance_Hours_Mattertimeframecompare>;
  /** An array relationship */
  mlfsl_finance_hours_mattertimekeepertimeframe: Array<Mlfsl_Finance_Hours_Mattertimekeepertimeframe>;
  /** An aggregate relationship */
  mlfsl_finance_hours_mattertimekeepertimeframe_aggregate: Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Aggregate;
  /** fetch data from the table: "MNET.Finance_Hours_MatterTimekeeperTimeframe" using primary key columns */
  mlfsl_finance_hours_mattertimekeepertimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_RelatedClient" */
  mlfsl_finance_hours_relatedclient: Array<Mlfsl_Finance_Hours_Relatedclient>;
  /** fetch data from the table: "MNET.Finance_Hours_RelatedClient" using primary key columns */
  mlfsl_finance_hours_relatedclient_by_pk?: Maybe<Mlfsl_Finance_Hours_Relatedclient>;
  /** fetch data from the table: "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
  mlfsl_finance_hours_relatedclientofficetimeframe: Array<Mlfsl_Finance_Hours_Relatedclientofficetimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_RelatedClientOfficeTimeframe" using primary key columns */
  mlfsl_finance_hours_relatedclientofficetimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Relatedclientofficetimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_RelatedClientPGTimeframe" */
  mlfsl_finance_hours_relatedclientpgtimeframe: Array<Mlfsl_Finance_Hours_Relatedclientpgtimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_RelatedClientPGTimeframe" using primary key columns */
  mlfsl_finance_hours_relatedclientpgtimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Relatedclientpgtimeframe>;
  /** An array relationship */
  mlfsl_finance_hours_relatedclienttimeframe: Array<Mlfsl_Finance_Hours_Relatedclienttimeframe>;
  /** An aggregate relationship */
  mlfsl_finance_hours_relatedclienttimeframe_aggregate: Mlfsl_Finance_Hours_Relatedclienttimeframe_Aggregate;
  /** fetch data from the table: "MNET.Finance_Hours_RelatedClientTimeframe" using primary key columns */
  mlfsl_finance_hours_relatedclienttimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
  mlfsl_finance_hours_relatedclienttimekeepertimeframe: Array<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe>;
  /** fetch aggregated fields from the table: "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
  mlfsl_finance_hours_relatedclienttimekeepertimeframe_aggregate: Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Aggregate;
  /** fetch data from the table: "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" using primary key columns */
  mlfsl_finance_hours_relatedclienttimekeepertimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe>;
  /** fetch data from the table: "repl.DimMatterNow" */
  mlfsl_matter: Array<Mlfsl_Matter>;
  /** fetch aggregated fields from the table: "repl.DimMatterNow" */
  mlfsl_matter_aggregate: Mlfsl_Matter_Aggregate;
  /** fetch data from the table: "repl.DimMatterNow" using primary key columns */
  mlfsl_matter_by_pk?: Maybe<Mlfsl_Matter>;
  /** fetch data from the table: "MLG.Matter_DisplayDescription" */
  mlfsl_matter_display_description: Array<Mlfsl_Matter_Display_Description>;
  /** fetch data from the table: "MNET.mlv_Finance_Hours_Timeframes" */
  mlfsl_mlv_Finance_Hours_Timeframes: Array<Mlfsl_Mlv_Finance_Hours_Timeframes>;
  /** fetch data from the table: "MNET.mlv_Finance_Hours_Client" */
  mlfsl_mlv_finance_hours_client: Array<Mlfsl_Mlv_Finance_Hours_Client>;
  /** fetch data from the table: "MNET.mlv_Finance_Hours_Matter" */
  mlfsl_mlv_finance_hours_matter: Array<Mlfsl_Mlv_Finance_Hours_Matter>;
  /** fetch data from the table: "MNET.mlv_Finance_Hours_RelatedClient" */
  mlfsl_mlv_finance_hours_relatedclient: Array<Mlfsl_Mlv_Finance_Hours_Relatedclient>;
  /** fetch data from the table: "repl.MorganNetClientPage_ClientInfo" */
  mlfsl_morgannet_clientPage_clientInfo: Array<Mlfsl_Morgannet_ClientPage_ClientInfo>;
  /** fetch aggregated fields from the table: "repl.MorganNetClientPage_ClientInfo" */
  mlfsl_morgannet_clientPage_clientInfo_aggregate: Mlfsl_Morgannet_ClientPage_ClientInfo_Aggregate;
  /** fetch data from the table: "repl.MorganNetClientPage_ClientInfo" using primary key columns */
  mlfsl_morgannet_clientPage_clientInfo_by_pk?: Maybe<Mlfsl_Morgannet_ClientPage_ClientInfo>;
  /** fetch data from the table: "repl.DimOfficeNow" */
  mlfsl_office: Array<Mlfsl_Office>;
  /** fetch aggregated fields from the table: "repl.DimOfficeNow" */
  mlfsl_office_aggregate: Mlfsl_Office_Aggregate;
  /** fetch data from the table: "repl.DimOfficeNow" using primary key columns */
  mlfsl_office_by_pk?: Maybe<Mlfsl_Office>;
  /** fetch data from the table: "repl.DimPersonnelEducation" */
  mlfsl_person_education: Array<Mlfsl_Person_Education>;
  /** fetch aggregated fields from the table: "repl.DimPersonnelEducation" */
  mlfsl_person_education_aggregate: Mlfsl_Person_Education_Aggregate;
  /** fetch data from the table: "repl.DimPersonnelEducation" using primary key columns */
  mlfsl_person_education_by_pk?: Maybe<Mlfsl_Person_Education>;
  /** fetch data from the table: "MNET.Personas" */
  mlfsl_persona: Array<Mlfsl_Persona>;
  /** fetch aggregated fields from the table: "MNET.Personas" */
  mlfsl_persona_aggregate: Mlfsl_Persona_Aggregate;
  /** fetch data from the table: "MNET.Personas" using primary key columns */
  mlfsl_persona_by_pk?: Maybe<Mlfsl_Persona>;
  /** fetch data from the table: "MNET.PersonaGroup" */
  mlfsl_persona_groups: Array<Mlfsl_Persona_Groups>;
  /** fetch aggregated fields from the table: "MNET.PersonaGroup" */
  mlfsl_persona_groups_aggregate: Mlfsl_Persona_Groups_Aggregate;
  /** fetch data from the table: "MNET.PersonaGroup" using primary key columns */
  mlfsl_persona_groups_by_pk?: Maybe<Mlfsl_Persona_Groups>;
  /** fetch data from the table: "repl.DimPersonnelNow" */
  mlfsl_personnel: Array<Mlfsl_Personnel>;
  /** fetch aggregated fields from the table: "repl.DimPersonnelNow" */
  mlfsl_personnel_aggregate: Mlfsl_Personnel_Aggregate;
  /** An array relationship */
  mlfsl_personnel_bar: Array<Mlfsl_Personnel_Bar>;
  /** fetch data from the table: "repl.DimPersonnelBar" using primary key columns */
  mlfsl_personnel_bar_by_pk?: Maybe<Mlfsl_Personnel_Bar>;
  /** fetch data from the table: "repl.DimPersonnelNow" using primary key columns */
  mlfsl_personnel_by_pk?: Maybe<Mlfsl_Personnel>;
  /** An array relationship */
  mlfsl_personnel_clerkship: Array<Mlfsl_Personnel_Clerkship>;
  /** fetch data from the table: "repl.DimPersonnelClerkship" using primary key columns */
  mlfsl_personnel_clerkship_by_pk?: Maybe<Mlfsl_Personnel_Clerkship>;
  /** An array relationship */
  mlfsl_personnel_committee: Array<Mlfsl_Personnel_Committee>;
  /** fetch data from the table: "repl.DimPersonnelCommittee" using primary key columns */
  mlfsl_personnel_committee_by_pk?: Maybe<Mlfsl_Personnel_Committee>;
  /** An array relationship */
  mlfsl_personnel_court: Array<Mlfsl_Personnel_Court>;
  /** fetch data from the table: "repl.DimPersonnelCourt" using primary key columns */
  mlfsl_personnel_court_by_pk?: Maybe<Mlfsl_Personnel_Court>;
  /** An array relationship */
  mlfsl_personnel_language: Array<Mlfsl_Personnel_Language>;
  /** fetch data from the table: "repl.DimPersonnelLanguage" using primary key columns */
  mlfsl_personnel_language_by_pk?: Maybe<Mlfsl_Personnel_Language>;
  /** fetch data from the table: "repl.DimPracticeGroupNow" */
  mlfsl_practicegroup: Array<Mlfsl_Practicegroup>;
  /** fetch aggregated fields from the table: "repl.DimPracticeGroupNow" */
  mlfsl_practicegroup_aggregate: Mlfsl_Practicegroup_Aggregate;
  /** fetch data from the table: "repl.DimPracticeGroupNow" using primary key columns */
  mlfsl_practicegroup_by_pk?: Maybe<Mlfsl_Practicegroup>;
  /** fetch data from the table: "Finance.ProbonoGoalExport" */
  mlfsl_probono_goal: Array<Mlfsl_Probono_Goal>;
  /** fetch data from the table: "MLG.RelatedClient" */
  mlfsl_related_client: Array<Mlfsl_Related_Client>;
  /** fetch data from the table: "MLG.RelatedClient" using primary key columns */
  mlfsl_related_client_by_pk?: Maybe<Mlfsl_Related_Client>;
  /** Get autocomplete suggestions for a search query. */
  mlg_search_autocomplete: Array<Scalars['String']['output']>;
  /** Get a document by its ID. Returns null if not found. */
  mlg_search_document?: Maybe<GraphSearchDocument>;
  /** Get the total count of documents in the index. */
  mlg_search_documentCount: Scalars['Long']['output'];
  /** Check if a document exists in the index. */
  mlg_search_documentExists: Scalars['Boolean']['output'];
  /** Get multiple documents by their IDs. */
  mlg_search_documents: Array<GraphSearchDocument>;
  /** Returns the key field name (IsKey = true) for the specified index. */
  mlg_search_indexKeyField: Scalars['String']['output'];
  /** Get the names of all Azure AI Search indexes on the configured service. */
  mlg_search_indexes: Array<GraphSearchIndex>;
  /** Search for documents in the Azure AI Search index. */
  mlg_search_query?: Maybe<Mlg_Search_QueryConnection>;
  /** Get search suggestions based on partial input. */
  mlg_search_suggest: Array<GraphSearchDocument>;
  /** fetch data from the table: "mnet.ad_group_link" */
  mnet_ad_group_link: Array<Mnet_Ad_Group_Link>;
  /** fetch data from the table: "mnet.ad_group_link" using primary key columns */
  mnet_ad_group_link_by_pk?: Maybe<Mnet_Ad_Group_Link>;
  /** fetch data from the table: "mnet_assignmentportal.my_availability" */
  mnet_assignmentportal_my_availability: Array<Mnet_Assignmentportal_My_Availability>;
  /** fetch data from the table: "mnet_assignmentportal.my_availability" using primary key columns */
  mnet_assignmentportal_my_availability_by_pk?: Maybe<Mnet_Assignmentportal_My_Availability>;
  /** fetch data from the table: "mnet_blog.attachments" */
  mnet_blog_attachments: Array<Mnet_Blog_Attachments>;
  /** fetch data from the table: "mnet_blog.attachments" using primary key columns */
  mnet_blog_attachments_by_pk?: Maybe<Mnet_Blog_Attachments>;
  /** fetch data from the table: "mnet_blog.blogs" */
  mnet_blog_blogs: Array<Mnet_Blog_Blogs>;
  /** fetch data from the table: "mnet_blog.blogs" using primary key columns */
  mnet_blog_blogs_by_pk?: Maybe<Mnet_Blog_Blogs>;
  /** fetch data from the table: "mnet_blog.channel_notifications" */
  mnet_blog_channel_notifications: Array<Mnet_Blog_Channel_Notifications>;
  /** fetch data from the table: "mnet_blog.channel_notifications" using primary key columns */
  mnet_blog_channel_notifications_by_pk?: Maybe<Mnet_Blog_Channel_Notifications>;
  /** fetch data from the table: "mnet_blog.channels" */
  mnet_blog_channels: Array<Mnet_Blog_Channels>;
  /** fetch data from the table: "mnet_blog.channels" using primary key columns */
  mnet_blog_channels_by_pk?: Maybe<Mnet_Blog_Channels>;
  /** fetch data from the table: "mnet_blog.comment_reactions" */
  mnet_blog_comment_reactions: Array<Mnet_Blog_Comment_Reactions>;
  /** fetch data from the table: "mnet_blog.comment_reactions" using primary key columns */
  mnet_blog_comment_reactions_by_pk?: Maybe<Mnet_Blog_Comment_Reactions>;
  /** fetch data from the table: "mnet_blog.comments" */
  mnet_blog_comments: Array<Mnet_Blog_Comments>;
  /** fetch data from the table: "mnet_blog.comments" using primary key columns */
  mnet_blog_comments_by_pk?: Maybe<Mnet_Blog_Comments>;
  /** fetch data from the table: "mnet_blog.email_notifications" */
  mnet_blog_email_notifications: Array<Mnet_Blog_Email_Notifications>;
  /** fetch data from the table: "mnet_blog.email_notifications" using primary key columns */
  mnet_blog_email_notifications_by_pk?: Maybe<Mnet_Blog_Email_Notifications>;
  /** fetch data from the table: "mnet_blog.email_templates" */
  mnet_blog_email_templates: Array<Mnet_Blog_Email_Templates>;
  /** fetch data from the table: "mnet_blog.email_templates" using primary key columns */
  mnet_blog_email_templates_by_pk?: Maybe<Mnet_Blog_Email_Templates>;
  /** fetch data from the table: "mnet_blog.events" */
  mnet_blog_events: Array<Mnet_Blog_Events>;
  /** fetch data from the table: "mnet_blog.events" using primary key columns */
  mnet_blog_events_by_pk?: Maybe<Mnet_Blog_Events>;
  /** fetch data from the table: "mnet_blog.group_in_blogs" */
  mnet_blog_group_in_blogs: Array<Mnet_Blog_Group_In_Blogs>;
  /** fetch data from the table: "mnet_blog.group_in_blogs" using primary key columns */
  mnet_blog_group_in_blogs_by_pk?: Maybe<Mnet_Blog_Group_In_Blogs>;
  /** fetch data from the table: "mnet_blog.inbound_emails" */
  mnet_blog_inbound_emails: Array<Mnet_Blog_Inbound_Emails>;
  /** fetch data from the table: "mnet_blog.inbound_emails" using primary key columns */
  mnet_blog_inbound_emails_by_pk?: Maybe<Mnet_Blog_Inbound_Emails>;
  /** fetch data from the table: "mnet_blog.notification_recipients" */
  mnet_blog_notification_recipients: Array<Mnet_Blog_Notification_Recipients>;
  /** fetch data from the table: "mnet_blog.notification_recipients" using primary key columns */
  mnet_blog_notification_recipients_by_pk?: Maybe<Mnet_Blog_Notification_Recipients>;
  /** fetch data from the table: "mnet_blog.notification_template_rules" */
  mnet_blog_notification_template_rules: Array<Mnet_Blog_Notification_Template_Rules>;
  /** fetch data from the table: "mnet_blog.notification_template_rules" using primary key columns */
  mnet_blog_notification_template_rules_by_pk?: Maybe<Mnet_Blog_Notification_Template_Rules>;
  /** fetch data from the table: "mnet_blog.post_channels" */
  mnet_blog_post_channels: Array<Mnet_Blog_Post_Channels>;
  /** fetch data from the table: "mnet_blog.post_channels" using primary key columns */
  mnet_blog_post_channels_by_pk?: Maybe<Mnet_Blog_Post_Channels>;
  /** fetch data from the table: "mnet_blog.post_images" */
  mnet_blog_post_images: Array<Mnet_Blog_Post_Images>;
  /** fetch data from the table: "mnet_blog.post_images" using primary key columns */
  mnet_blog_post_images_by_pk?: Maybe<Mnet_Blog_Post_Images>;
  /** fetch data from the table: "mnet_blog.post_reactions" */
  mnet_blog_post_reactions: Array<Mnet_Blog_Post_Reactions>;
  /** fetch data from the table: "mnet_blog.post_reactions" using primary key columns */
  mnet_blog_post_reactions_by_pk?: Maybe<Mnet_Blog_Post_Reactions>;
  /** fetch data from the table: "mnet_blog.posts" */
  mnet_blog_posts: Array<Mnet_Blog_Posts>;
  /** fetch aggregated fields from the table: "mnet_blog.posts" */
  mnet_blog_posts_aggregate: Mnet_Blog_Posts_Aggregate;
  /** fetch data from the table: "mnet_blog.posts" using primary key columns */
  mnet_blog_posts_by_pk?: Maybe<Mnet_Blog_Posts>;
  /** fetch data from the table: "mnet.business_chemistry_type" */
  mnet_business_chemistry_type: Array<Mnet_Business_Chemistry_Type>;
  /** fetch aggregated fields from the table: "mnet.business_chemistry_type" */
  mnet_business_chemistry_type_aggregate: Mnet_Business_Chemistry_Type_Aggregate;
  /** fetch data from the table: "mnet.business_chemistry_type" using primary key columns */
  mnet_business_chemistry_type_by_pk?: Maybe<Mnet_Business_Chemistry_Type>;
  /** fetch data from the table: "mnet.client_intel_settings" */
  mnet_client_intel_settings: Array<Mnet_Client_Intel_Settings>;
  /** fetch aggregated fields from the table: "mnet.client_intel_settings" */
  mnet_client_intel_settings_aggregate: Mnet_Client_Intel_Settings_Aggregate;
  /** fetch data from the table: "mnet.client_intel_settings" using primary key columns */
  mnet_client_intel_settings_by_pk?: Maybe<Mnet_Client_Intel_Settings>;
  /** fetch data from the table: "mnet.client_manzama_alert_summary_counts" */
  mnet_client_manzama_alert_summary_counts: Array<Mnet_Client_Manzama_Alert_Summary_Counts>;
  /** fetch aggregated fields from the table: "mnet.client_manzama_alert_summary_counts" */
  mnet_client_manzama_alert_summary_counts_aggregate: Mnet_Client_Manzama_Alert_Summary_Counts_Aggregate;
  /** fetch data from the table: "mnet.client_manzama_alert_summary_counts" using primary key columns */
  mnet_client_manzama_alert_summary_counts_by_pk?: Maybe<Mnet_Client_Manzama_Alert_Summary_Counts>;
  /** fetch data from the table: "mnet.client_manzama_article" */
  mnet_client_manzama_article: Array<Mnet_Client_Manzama_Article>;
  /** fetch aggregated fields from the table: "mnet.client_manzama_article" */
  mnet_client_manzama_article_aggregate: Mnet_Client_Manzama_Article_Aggregate;
  /** fetch data from the table: "mnet.client_manzama_article" using primary key columns */
  mnet_client_manzama_article_by_pk?: Maybe<Mnet_Client_Manzama_Article>;
  /** fetch data from the table: "mnet.client_manzama_article_category" */
  mnet_client_manzama_article_category: Array<Mnet_Client_Manzama_Article_Category>;
  /** fetch aggregated fields from the table: "mnet.client_manzama_article_category" */
  mnet_client_manzama_article_category_aggregate: Mnet_Client_Manzama_Article_Category_Aggregate;
  /** fetch data from the table: "mnet.client_manzama_article_category" using primary key columns */
  mnet_client_manzama_article_category_by_pk?: Maybe<Mnet_Client_Manzama_Article_Category>;
  /** fetch data from the table: "mnet.client_manzama_http_response" */
  mnet_client_manzama_http_response: Array<Mnet_Client_Manzama_Http_Response>;
  /** fetch aggregated fields from the table: "mnet.client_manzama_http_response" */
  mnet_client_manzama_http_response_aggregate: Mnet_Client_Manzama_Http_Response_Aggregate;
  /** fetch data from the table: "mnet.client_manzama_http_response" using primary key columns */
  mnet_client_manzama_http_response_by_pk?: Maybe<Mnet_Client_Manzama_Http_Response>;
  /** fetch data from the table: "mnet.clientbadge_badge" */
  mnet_clientbadge_badge: Array<Mnet_Clientbadge_Badge>;
  /** fetch aggregated fields from the table: "mnet.clientbadge_badge" */
  mnet_clientbadge_badge_aggregate: Mnet_Clientbadge_Badge_Aggregate;
  /** fetch data from the table: "mnet.clientbadge_badge" using primary key columns */
  mnet_clientbadge_badge_by_pk?: Maybe<Mnet_Clientbadge_Badge>;
  /** fetch data from the table: "mnet.clientbadge_badge_category" */
  mnet_clientbadge_badge_category: Array<Mnet_Clientbadge_Badge_Category>;
  /** fetch aggregated fields from the table: "mnet.clientbadge_badge_category" */
  mnet_clientbadge_badge_category_aggregate: Mnet_Clientbadge_Badge_Category_Aggregate;
  /** fetch data from the table: "mnet.clientbadge_badge_category" using primary key columns */
  mnet_clientbadge_badge_category_by_pk?: Maybe<Mnet_Clientbadge_Badge_Category>;
  /** fetch data from the table: "mnet.clientbadge_client" */
  mnet_clientbadge_client: Array<Mnet_Clientbadge_Client>;
  /** fetch aggregated fields from the table: "mnet.clientbadge_client" */
  mnet_clientbadge_client_aggregate: Mnet_Clientbadge_Client_Aggregate;
  /** fetch data from the table: "mnet.clientbadge_client" using primary key columns */
  mnet_clientbadge_client_by_pk?: Maybe<Mnet_Clientbadge_Client>;
  /** fetch data from the table: "mnet.clientbadge_client_exclusion" */
  mnet_clientbadge_client_exclusion: Array<Mnet_Clientbadge_Client_Exclusion>;
  /** fetch aggregated fields from the table: "mnet.clientbadge_client_exclusion" */
  mnet_clientbadge_client_exclusion_aggregate: Mnet_Clientbadge_Client_Exclusion_Aggregate;
  /** fetch data from the table: "mnet.clientbadge_client_exclusion" using primary key columns */
  mnet_clientbadge_client_exclusion_by_pk?: Maybe<Mnet_Clientbadge_Client_Exclusion>;
  /** fetch data from the table: "mnet.clientbadge_related_client" */
  mnet_clientbadge_related_client: Array<Mnet_Clientbadge_Related_Client>;
  /** fetch aggregated fields from the table: "mnet.clientbadge_related_client" */
  mnet_clientbadge_related_client_aggregate: Mnet_Clientbadge_Related_Client_Aggregate;
  /** fetch data from the table: "mnet.clientbadge_related_client" using primary key columns */
  mnet_clientbadge_related_client_by_pk?: Maybe<Mnet_Clientbadge_Related_Client>;
  /** fetch data from the table: "mnet.foundation_matter" */
  mnet_foundation_matter: Array<Mnet_Foundation_Matter>;
  /** fetch aggregated fields from the table: "mnet.foundation_matter" */
  mnet_foundation_matter_aggregate: Mnet_Foundation_Matter_Aggregate;
  /** fetch data from the table: "mnet.foundation_matter" using primary key columns */
  mnet_foundation_matter_by_pk?: Maybe<Mnet_Foundation_Matter>;
  /** fetch data from the table: "mnet.mytools_catalog_category" */
  mnet_mytools_catalog_category: Array<Mnet_Mytools_Catalog_Category>;
  /** fetch aggregated fields from the table: "mnet.mytools_catalog_category" */
  mnet_mytools_catalog_category_aggregate: Mnet_Mytools_Catalog_Category_Aggregate;
  /** fetch data from the table: "mnet.mytools_catalog_category" using primary key columns */
  mnet_mytools_catalog_category_by_pk?: Maybe<Mnet_Mytools_Catalog_Category>;
  /** fetch data from the table: "mnet.mytools_catalog_tool" */
  mnet_mytools_catalog_tool: Array<Mnet_Mytools_Catalog_Tool>;
  /** fetch aggregated fields from the table: "mnet.mytools_catalog_tool" */
  mnet_mytools_catalog_tool_aggregate: Mnet_Mytools_Catalog_Tool_Aggregate;
  /** fetch data from the table: "mnet.mytools_catalog_tool_assignment" */
  mnet_mytools_catalog_tool_assignment: Array<Mnet_Mytools_Catalog_Tool_Assignment>;
  /** fetch aggregated fields from the table: "mnet.mytools_catalog_tool_assignment" */
  mnet_mytools_catalog_tool_assignment_aggregate: Mnet_Mytools_Catalog_Tool_Assignment_Aggregate;
  /** fetch data from the table: "mnet.mytools_catalog_tool_assignment" using primary key columns */
  mnet_mytools_catalog_tool_assignment_by_pk?: Maybe<Mnet_Mytools_Catalog_Tool_Assignment>;
  /** fetch data from the table: "mnet.mytools_catalog_tool" using primary key columns */
  mnet_mytools_catalog_tool_by_pk?: Maybe<Mnet_Mytools_Catalog_Tool>;
  /** fetch data from the table: "mnet.mytools_user_tool" */
  mnet_mytools_user_tool: Array<Mnet_Mytools_User_Tool>;
  /** fetch aggregated fields from the table: "mnet.mytools_user_tool" */
  mnet_mytools_user_tool_aggregate: Mnet_Mytools_User_Tool_Aggregate;
  /** fetch data from the table: "mnet.mytools_user_tool" using primary key columns */
  mnet_mytools_user_tool_by_pk?: Maybe<Mnet_Mytools_User_Tool>;
  /** fetch data from the table: "mnet.office_detail" */
  mnet_office_detail: Array<Mnet_Office_Detail>;
  /** fetch aggregated fields from the table: "mnet.office_detail" */
  mnet_office_detail_aggregate: Mnet_Office_Detail_Aggregate;
  /** fetch data from the table: "mnet.office_detail" using primary key columns */
  mnet_office_detail_by_pk?: Maybe<Mnet_Office_Detail>;
  /** fetch data from the table: "mnet.person_business_chemistry_profile" */
  mnet_person_business_chemistry_profile: Array<Mnet_Person_Business_Chemistry_Profile>;
  /** fetch aggregated fields from the table: "mnet.person_business_chemistry_profile" */
  mnet_person_business_chemistry_profile_aggregate: Mnet_Person_Business_Chemistry_Profile_Aggregate;
  /** fetch data from the table: "mnet.person_business_chemistry_profile" using primary key columns */
  mnet_person_business_chemistry_profile_by_pk?: Maybe<Mnet_Person_Business_Chemistry_Profile>;
  /** fetch data from the table: "mnet.personnel_profile_badges" */
  mnet_personnel_profile_badges: Array<Mnet_Personnel_Profile_Badges>;
  /** fetch aggregated fields from the table: "mnet.personnel_profile_badges" */
  mnet_personnel_profile_badges_aggregate: Mnet_Personnel_Profile_Badges_Aggregate;
  /** fetch data from the table: "mnet.personnel_profile_badges" using primary key columns */
  mnet_personnel_profile_badges_by_pk?: Maybe<Mnet_Personnel_Profile_Badges>;
  /** fetch data from the table: "mnet.practice_area_detail" */
  mnet_practice_area_detail: Array<Mnet_Practice_Area_Detail>;
  /** fetch aggregated fields from the table: "mnet.practice_area_detail" */
  mnet_practice_area_detail_aggregate: Mnet_Practice_Area_Detail_Aggregate;
  /** fetch data from the table: "mnet.practice_area_detail" using primary key columns */
  mnet_practice_area_detail_by_pk?: Maybe<Mnet_Practice_Area_Detail>;
  /** fetch data from the table: "mnet.practice_group_detail" */
  mnet_practice_group_detail: Array<Mnet_Practice_Group_Detail>;
  /** fetch aggregated fields from the table: "mnet.practice_group_detail" */
  mnet_practice_group_detail_aggregate: Mnet_Practice_Group_Detail_Aggregate;
  /** fetch data from the table: "mnet.practice_group_detail" using primary key columns */
  mnet_practice_group_detail_by_pk?: Maybe<Mnet_Practice_Group_Detail>;
  /** fetch data from the table: "mnet.user_link" */
  mnet_user_link: Array<Mnet_User_Link>;
  /** fetch data from the table: "mnet.user_link" using primary key columns */
  mnet_user_link_by_pk?: Maybe<Mnet_User_Link>;
  /** fetch data from the table: "mnet.wellable_leaderboard" */
  mnet_wellable_leaderboard: Array<Mnet_Wellable_Leaderboard>;
  /** fetch aggregated fields from the table: "mnet.wellable_leaderboard" */
  mnet_wellable_leaderboard_aggregate: Mnet_Wellable_Leaderboard_Aggregate;
  /** fetch data from the table: "mnet.wellable_leaderboard" using primary key columns */
  mnet_wellable_leaderboard_by_pk?: Maybe<Mnet_Wellable_Leaderboard>;
  /** fetch data from the table: "pbc.counsel_representatives" */
  pbc_counsel_representatives: Array<Pbc_Counsel_Representatives>;
  /** fetch aggregated fields from the table: "pbc.counsel_representatives" */
  pbc_counsel_representatives_aggregate: Pbc_Counsel_Representatives_Aggregate;
  /** fetch data from the table: "pbc.counsel_representatives" using primary key columns */
  pbc_counsel_representatives_by_pk?: Maybe<Pbc_Counsel_Representatives>;
  /** fetch data from the table: "pbc.email_templates" */
  pbc_email_templates: Array<Pbc_Email_Templates>;
  /** fetch aggregated fields from the table: "pbc.email_templates" */
  pbc_email_templates_aggregate: Pbc_Email_Templates_Aggregate;
  /** fetch data from the table: "pbc.email_templates" using primary key columns */
  pbc_email_templates_by_pk?: Maybe<Pbc_Email_Templates>;
  /** fetch data from the table: "pbc.exempt_users" */
  pbc_exempt_users: Array<Pbc_Exempt_Users>;
  /** fetch aggregated fields from the table: "pbc.exempt_users" */
  pbc_exempt_users_aggregate: Pbc_Exempt_Users_Aggregate;
  /** fetch data from the table: "pbc.exempt_users" using primary key columns */
  pbc_exempt_users_by_pk?: Maybe<Pbc_Exempt_Users>;
  /** fetch data from the table: "pbc.notification_recipients" */
  pbc_notification_recipients: Array<Pbc_Notification_Recipients>;
  /** fetch aggregated fields from the table: "pbc.notification_recipients" */
  pbc_notification_recipients_aggregate: Pbc_Notification_Recipients_Aggregate;
  /** fetch data from the table: "pbc.notification_recipients" using primary key columns */
  pbc_notification_recipients_by_pk?: Maybe<Pbc_Notification_Recipients>;
  /** fetch data from the table: "pbc.notification_requests" */
  pbc_notification_requests: Array<Pbc_Notification_Requests>;
  /** fetch aggregated fields from the table: "pbc.notification_requests" */
  pbc_notification_requests_aggregate: Pbc_Notification_Requests_Aggregate;
  /** fetch data from the table: "pbc.notification_requests" using primary key columns */
  pbc_notification_requests_by_pk?: Maybe<Pbc_Notification_Requests>;
  /** fetch data from the table: "pbc.notification_statuses" */
  pbc_notification_statuses: Array<Pbc_Notification_Statuses>;
  /** fetch aggregated fields from the table: "pbc.notification_statuses" */
  pbc_notification_statuses_aggregate: Pbc_Notification_Statuses_Aggregate;
  /** fetch data from the table: "pbc.notification_statuses" using primary key columns */
  pbc_notification_statuses_by_pk?: Maybe<Pbc_Notification_Statuses>;
  /** fetch data from the table: "pbc.senders" */
  pbc_senders: Array<Pbc_Senders>;
  /** fetch aggregated fields from the table: "pbc.senders" */
  pbc_senders_aggregate: Pbc_Senders_Aggregate;
  /** fetch data from the table: "pbc.senders" using primary key columns */
  pbc_senders_by_pk?: Maybe<Pbc_Senders>;
  plan?: Maybe<Plan>;
  policy?: Maybe<Policy>;
  /** Provides one unified search endpoint that you can use to query data in the Microsoft cloud—messages and events in Outlook mailboxes and files on OneDrive and SharePoint. */
  search?: Maybe<SearchConnection>;
  /** Returns SharePoint site based on the provided site URL. */
  site: ISite;
  /** Performs advanced search operations within a SharePoint site, leveraging advanced algorithms, indexing techniques, and customizable search options to efficiently locate documents, sites, lists, and various content types. */
  spSearch?: Maybe<SpSearchConnection>;
  task?: Maybe<Task>;
  user?: Maybe<MsUser>;
  userByEmail?: Maybe<User>;
  userById?: Maybe<User>;
  userByMail?: Maybe<MsUser>;
  users: Array<User>;
  usersByEmails: Array<User>;
};

export type Query_RootBcs_PersonnelArgs = {
  distinct_on?: InputMaybe<Array<Bcs_Personnel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bcs_Personnel_Order_By>>;
  where?: InputMaybe<Bcs_Personnel_Bool_Exp>;
};

export type Query_RootBcs_Personnel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bcs_Personnel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bcs_Personnel_Order_By>>;
  where?: InputMaybe<Bcs_Personnel_Bool_Exp>;
};

export type Query_RootBcs_Personnel_By_PkArgs = {
  ADSystemID: Scalars['citext']['input'];
};

export type Query_RootAuthorizeByAppIdArgs = {
  appId?: InputMaybe<Scalars['String']['input']>;
};

export type Query_RootAuthorizeByModuleIdArgs = {
  appId?: InputMaybe<Scalars['String']['input']>;
  moduleId?: InputMaybe<Scalars['String']['input']>;
};

export type Query_RootB2b_External_AccountsArgs = {
  distinct_on?: InputMaybe<Array<B2b_External_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<B2b_External_Accounts_Order_By>>;
  where?: InputMaybe<B2b_External_Accounts_Bool_Exp>;
};

export type Query_RootB2b_External_Accounts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootB2b_LogsArgs = {
  distinct_on?: InputMaybe<Array<B2b_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<B2b_Logs_Order_By>>;
  where?: InputMaybe<B2b_Logs_Bool_Exp>;
};

export type Query_RootB2b_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootB2b_Ml_Sponsor_ReferencesArgs = {
  distinct_on?: InputMaybe<Array<B2b_Ml_Sponsor_References_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<B2b_Ml_Sponsor_References_Order_By>>;
  where?: InputMaybe<B2b_Ml_Sponsor_References_Bool_Exp>;
};

export type Query_RootB2b_Ml_Sponsor_References_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootB2b_Request_StatusArgs = {
  distinct_on?: InputMaybe<Array<B2b_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<B2b_Request_Status_Order_By>>;
  where?: InputMaybe<B2b_Request_Status_Bool_Exp>;
};

export type Query_RootB2b_Request_Status_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Query_RootB2b_RequestsArgs = {
  distinct_on?: InputMaybe<Array<B2b_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<B2b_Requests_Order_By>>;
  where?: InputMaybe<B2b_Requests_Bool_Exp>;
};

export type Query_RootB2b_Requests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootB2b_Resource_Owner_ReferencesArgs = {
  distinct_on?: InputMaybe<Array<B2b_Resource_Owner_References_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<B2b_Resource_Owner_References_Order_By>>;
  where?: InputMaybe<B2b_Resource_Owner_References_Bool_Exp>;
};

export type Query_RootB2b_Resource_Owner_References_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootBucketArgs = {
  bucketId: Scalars['String']['input'];
};

export type Query_RootCle_Cle_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Cle_Cle_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cle_Cle_Attachments_Order_By>>;
  where?: InputMaybe<Cle_Cle_Attachments_Bool_Exp>;
};

export type Query_RootCle_Cle_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cle_Cle_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cle_Cle_Attachments_Order_By>>;
  where?: InputMaybe<Cle_Cle_Attachments_Bool_Exp>;
};

export type Query_RootCle_Cle_Attachments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootCle_Cle_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Cle_Cle_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cle_Cle_Requests_Order_By>>;
  where?: InputMaybe<Cle_Cle_Requests_Bool_Exp>;
};

export type Query_RootCle_Cle_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cle_Cle_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cle_Cle_Requests_Order_By>>;
  where?: InputMaybe<Cle_Cle_Requests_Bool_Exp>;
};

export type Query_RootCle_Cle_Requests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootClm_Engagement_Client_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Clm_Engagement_Client_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Engagement_Client_Comments_Order_By>>;
  where?: InputMaybe<Clm_Engagement_Client_Comments_Bool_Exp>;
};

export type Query_RootClm_Engagement_Client_Comments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootClm_Engagement_Imanage_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Clm_Engagement_Imanage_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Engagement_Imanage_Documents_Order_By>>;
  where?: InputMaybe<Clm_Engagement_Imanage_Documents_Bool_Exp>;
};

export type Query_RootClm_Engagement_Imanage_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clm_Engagement_Imanage_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Engagement_Imanage_Documents_Order_By>>;
  where?: InputMaybe<Clm_Engagement_Imanage_Documents_Bool_Exp>;
};

export type Query_RootClm_Engagement_Imanage_Documents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootClm_Engagement_RecordsArgs = {
  distinct_on?: InputMaybe<Array<Clm_Engagement_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Engagement_Records_Order_By>>;
  where?: InputMaybe<Clm_Engagement_Records_Bool_Exp>;
};

export type Query_RootClm_Engagement_Records_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootClm_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Clm_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Views_Order_By>>;
  where?: InputMaybe<Clm_Views_Bool_Exp>;
};

export type Query_RootClm_Views_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootClm_Waiver_Imanage_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Clm_Waiver_Imanage_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Waiver_Imanage_Documents_Order_By>>;
  where?: InputMaybe<Clm_Waiver_Imanage_Documents_Bool_Exp>;
};

export type Query_RootClm_Waiver_Imanage_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clm_Waiver_Imanage_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Waiver_Imanage_Documents_Order_By>>;
  where?: InputMaybe<Clm_Waiver_Imanage_Documents_Bool_Exp>;
};

export type Query_RootClm_Waiver_Imanage_Documents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootClm_Waiver_RecordsArgs = {
  distinct_on?: InputMaybe<Array<Clm_Waiver_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Waiver_Records_Order_By>>;
  where?: InputMaybe<Clm_Waiver_Records_Bool_Exp>;
};

export type Query_RootClm_Waiver_Records_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootConversationThreadArgs = {
  input: ConversationLookupInput;
};

export type Query_RootConversationThreadsArgs = {
  input: ConversationsLookupInput;
};

export type Query_RootFd_Email_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Fd_Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Email_Templates_Order_By>>;
  where?: InputMaybe<Fd_Email_Templates_Bool_Exp>;
};

export type Query_RootFd_Email_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootFd_Exempt_MattersArgs = {
  distinct_on?: InputMaybe<Array<Fd_Exempt_Matters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Exempt_Matters_Order_By>>;
  where?: InputMaybe<Fd_Exempt_Matters_Bool_Exp>;
};

export type Query_RootFd_Exempt_Matters_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootFd_Instruction_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Fd_Instruction_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Instruction_Templates_Order_By>>;
  where?: InputMaybe<Fd_Instruction_Templates_Bool_Exp>;
};

export type Query_RootFd_Instruction_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootFd_Matters_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Fd_Matters_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Matters_Responses_Order_By>>;
  where?: InputMaybe<Fd_Matters_Responses_Bool_Exp>;
};

export type Query_RootFd_Matters_Responses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootFd_Project_AccessArgs = {
  distinct_on?: InputMaybe<Array<Fd_Project_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Project_Access_Order_By>>;
  where?: InputMaybe<Fd_Project_Access_Bool_Exp>;
};

export type Query_RootFd_Project_Access_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootFd_Project_Number_CounterArgs = {
  distinct_on?: InputMaybe<Array<Fd_Project_Number_Counter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Project_Number_Counter_Order_By>>;
  where?: InputMaybe<Fd_Project_Number_Counter_Bool_Exp>;
};

export type Query_RootFd_Project_Number_Counter_By_PkArgs = {
  project_year: Scalars['smallint']['input'];
};

export type Query_RootFd_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Fd_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Projects_Order_By>>;
  where?: InputMaybe<Fd_Projects_Bool_Exp>;
};

export type Query_RootFd_Projects_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootFd_Response_In_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Fd_Response_In_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Response_In_Projects_Order_By>>;
  where?: InputMaybe<Fd_Response_In_Projects_Bool_Exp>;
};

export type Query_RootFd_Response_In_Projects_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootFd_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Fd_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Responses_Order_By>>;
  where?: InputMaybe<Fd_Responses_Bool_Exp>;
};

export type Query_RootFd_Responses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootFileByIdArgs = {
  fileId: Scalars['UUID']['input'];
  siteUrl: Scalars['URL']['input'];
};

export type Query_RootFirstup_ChannelsArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Channels_Order_By>>;
  where?: InputMaybe<Firstup_Channels_Bool_Exp>;
};

export type Query_RootFirstup_Channels_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Query_RootFirstup_ContentArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Content_Order_By>>;
  where?: InputMaybe<Firstup_Content_Bool_Exp>;
};

export type Query_RootFirstup_Content_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Content_Order_By>>;
  where?: InputMaybe<Firstup_Content_Bool_Exp>;
};

export type Query_RootFirstup_Content_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Query_RootFirstup_Content_In_ChannelsArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Content_In_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Content_In_Channels_Order_By>>;
  where?: InputMaybe<Firstup_Content_In_Channels_Bool_Exp>;
};

export type Query_RootFirstup_Content_In_Channels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Content_In_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Content_In_Channels_Order_By>>;
  where?: InputMaybe<Firstup_Content_In_Channels_Bool_Exp>;
};

export type Query_RootFirstup_Content_In_Channels_By_PkArgs = {
  channel_id: Scalars['Int']['input'];
  content_id: Scalars['Int']['input'];
};

export type Query_RootFirstup_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Images_Order_By>>;
  where?: InputMaybe<Firstup_Images_Bool_Exp>;
};

export type Query_RootFirstup_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Images_Order_By>>;
  where?: InputMaybe<Firstup_Images_Bool_Exp>;
};

export type Query_RootFirstup_Images_By_PkArgs = {
  image_url: Scalars['String']['input'];
};

export type Query_RootFirstup_Images_In_ContentArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Images_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Images_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_Images_In_Content_Bool_Exp>;
};

export type Query_RootFirstup_Images_In_Content_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Images_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Images_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_Images_In_Content_Bool_Exp>;
};

export type Query_RootFirstup_Images_In_Content_By_PkArgs = {
  content_id: Scalars['Int']['input'];
  image_url: Scalars['String']['input'];
};

export type Query_RootFirstup_People_In_ContentArgs = {
  distinct_on?: InputMaybe<Array<Firstup_People_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_People_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_People_In_Content_Bool_Exp>;
};

export type Query_RootFirstup_People_In_Content_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_People_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_People_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_People_In_Content_Bool_Exp>;
};

export type Query_RootFirstup_People_In_Content_By_PkArgs = {
  content_id: Scalars['Int']['input'];
  user_email: Scalars['String']['input'];
};

export type Query_RootFirstup_VideosArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Videos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Videos_Order_By>>;
  where?: InputMaybe<Firstup_Videos_Bool_Exp>;
};

export type Query_RootFirstup_Videos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Videos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Videos_Order_By>>;
  where?: InputMaybe<Firstup_Videos_Bool_Exp>;
};

export type Query_RootFirstup_Videos_By_PkArgs = {
  link_url: Scalars['String']['input'];
};

export type Query_RootFirstup_Videos_In_ContentArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Videos_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Videos_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_Videos_In_Content_Bool_Exp>;
};

export type Query_RootFirstup_Videos_In_Content_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Videos_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Videos_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_Videos_In_Content_Bool_Exp>;
};

export type Query_RootFirstup_Videos_In_Content_By_PkArgs = {
  content_id: Scalars['Int']['input'];
  video_url: Scalars['String']['input'];
};

export type Query_RootFolderByIdArgs = {
  folderId: Scalars['UUID']['input'];
  siteUrl: Scalars['URL']['input'];
};

export type Query_RootFolderByServerRelativeUrlArgs = {
  serverRelativeUrl: Scalars['String']['input'];
  siteUrl: Scalars['URL']['input'];
};

export type Query_RootFtp_RequestArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_Order_By>>;
  where?: InputMaybe<Ftp_Request_Bool_Exp>;
};

export type Query_RootFtp_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_Order_By>>;
  where?: InputMaybe<Ftp_Request_Bool_Exp>;
};

export type Query_RootFtp_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootFtp_Request_DetailArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_Detail_Order_By>>;
  where?: InputMaybe<Ftp_Request_Detail_Bool_Exp>;
};

export type Query_RootFtp_Request_Detail_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootFtp_Request_External_AccessArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_External_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_External_Access_Order_By>>;
  where?: InputMaybe<Ftp_Request_External_Access_Bool_Exp>;
};

export type Query_RootFtp_Request_External_Access_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootFtp_Request_External_NoteArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_External_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_External_Note_Order_By>>;
  where?: InputMaybe<Ftp_Request_External_Note_Bool_Exp>;
};

export type Query_RootFtp_Request_External_Note_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootFtp_Request_Internal_NoteArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_Internal_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_Internal_Note_Order_By>>;
  where?: InputMaybe<Ftp_Request_Internal_Note_Bool_Exp>;
};

export type Query_RootFtp_Request_Internal_Note_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootFtp_Request_Number_CounterArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_Number_Counter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_Number_Counter_Order_By>>;
  where?: InputMaybe<Ftp_Request_Number_Counter_Bool_Exp>;
};

export type Query_RootFtp_Request_Number_Counter_By_PkArgs = {
  request_year: Scalars['smallint']['input'];
};

export type Query_RootFtp_Request_ParticipantArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_Participant_Order_By>>;
  where?: InputMaybe<Ftp_Request_Participant_Bool_Exp>;
};

export type Query_RootFtp_Request_Participant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootGec_AudienceArgs = {
  distinct_on?: InputMaybe<Array<Gec_Audience_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Audience_Order_By>>;
  where?: InputMaybe<Gec_Audience_Bool_Exp>;
};

export type Query_RootGec_Audience_By_PkArgs = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type Query_RootGec_Audience_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Audience_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Audience_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Audience_In_Event_Bool_Exp>;
};

export type Query_RootGec_Audience_In_Event_By_PkArgs = {
  audience_id: Scalars['Int']['input'];
  event_id: Scalars['Int']['input'];
};

export type Query_RootGec_Contact_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Contact_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Contact_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Contact_In_Event_Bool_Exp>;
};

export type Query_RootGec_Contact_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  user_id: Scalars['String']['input'];
};

export type Query_RootGec_DepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Gec_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Departments_Order_By>>;
  where?: InputMaybe<Gec_Departments_Bool_Exp>;
};

export type Query_RootGec_Departments_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Query_RootGec_Departments_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Departments_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Departments_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Departments_In_Event_Bool_Exp>;
};

export type Query_RootGec_Departments_In_Event_By_PkArgs = {
  department_id: Scalars['Int']['input'];
  event_id: Scalars['Int']['input'];
};

export type Query_RootGec_Event_ExceptionArgs = {
  distinct_on?: InputMaybe<Array<Gec_Event_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Event_Exception_Order_By>>;
  where?: InputMaybe<Gec_Event_Exception_Bool_Exp>;
};

export type Query_RootGec_Event_Exception_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Query_RootGec_Event_FormatArgs = {
  distinct_on?: InputMaybe<Array<Gec_Event_Format_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Event_Format_Order_By>>;
  where?: InputMaybe<Gec_Event_Format_Bool_Exp>;
};

export type Query_RootGec_Event_Format_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootGec_Event_TypeArgs = {
  distinct_on?: InputMaybe<Array<Gec_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Event_Type_Order_By>>;
  where?: InputMaybe<Gec_Event_Type_Bool_Exp>;
};

export type Query_RootGec_Event_Type_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Query_RootGec_EventsArgs = {
  distinct_on?: InputMaybe<Array<Gec_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Events_Order_By>>;
  where?: InputMaybe<Gec_Events_Bool_Exp>;
};

export type Query_RootGec_Events_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Query_RootGec_Firm_InitiativesArgs = {
  distinct_on?: InputMaybe<Array<Gec_Firm_Initiatives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Firm_Initiatives_Order_By>>;
  where?: InputMaybe<Gec_Firm_Initiatives_Bool_Exp>;
};

export type Query_RootGec_Firm_Initiatives_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Query_RootGec_Firm_Initiatives_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Firm_Initiatives_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Firm_Initiatives_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Firm_Initiatives_In_Event_Bool_Exp>;
};

export type Query_RootGec_Firm_Initiatives_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  firm_initiative_id: Scalars['Int']['input'];
};

export type Query_RootGec_IndustriesArgs = {
  distinct_on?: InputMaybe<Array<Gec_Industries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Industries_Order_By>>;
  where?: InputMaybe<Gec_Industries_Bool_Exp>;
};

export type Query_RootGec_Industries_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Query_RootGec_Industries_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Industries_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Industries_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Industries_In_Event_Bool_Exp>;
};

export type Query_RootGec_Industries_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  industry_id: Scalars['Int']['input'];
};

export type Query_RootGec_Office_Visibility_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Office_Visibility_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Office_Visibility_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Office_Visibility_In_Event_Bool_Exp>;
};

export type Query_RootGec_Office_Visibility_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  office_id: Scalars['uuid']['input'];
};

export type Query_RootGec_OfficesArgs = {
  distinct_on?: InputMaybe<Array<Gec_Offices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Offices_Order_By>>;
  where?: InputMaybe<Gec_Offices_Bool_Exp>;
};

export type Query_RootGec_Offices_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootGec_Offices_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Offices_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Offices_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Offices_In_Event_Bool_Exp>;
};

export type Query_RootGec_Offices_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  office_id: Scalars['uuid']['input'];
};

export type Query_RootGec_Outside_SpeakersArgs = {
  distinct_on?: InputMaybe<Array<Gec_Outside_Speakers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Outside_Speakers_Order_By>>;
  where?: InputMaybe<Gec_Outside_Speakers_Bool_Exp>;
};

export type Query_RootGec_Outside_Speakers_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Query_RootGec_Practice_Groups_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Practice_Groups_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Practice_Groups_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Practice_Groups_In_Event_Bool_Exp>;
};

export type Query_RootGec_Practice_Groups_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  practice_group_id: Scalars['Int']['input'];
};

export type Query_RootGec_Practice_Groups_RollupArgs = {
  distinct_on?: InputMaybe<Array<Gec_Practice_Groups_Rollup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Practice_Groups_Rollup_Order_By>>;
  where?: InputMaybe<Gec_Practice_Groups_Rollup_Bool_Exp>;
};

export type Query_RootGec_Practice_Groups_Rollup_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Query_RootGec_Speaker_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Speaker_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Speaker_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Speaker_In_Event_Bool_Exp>;
};

export type Query_RootGec_Speaker_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  user_id: Scalars['String']['input'];
};

export type Query_RootGec_Sponsoring_Attorney_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Sponsoring_Attorney_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Sponsoring_Attorney_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Bool_Exp>;
};

export type Query_RootGec_Sponsoring_Attorney_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  user_id: Scalars['String']['input'];
};

export type Query_RootGec_Timezone_NamesArgs = {
  distinct_on?: InputMaybe<Array<Pg_Timezone_Names_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pg_Timezone_Names_Order_By>>;
  where?: InputMaybe<Pg_Timezone_Names_Bool_Exp_Bool_Exp>;
};

export type Query_RootGroupArgs = {
  groupId: Scalars['String']['input'];
};

export type Query_RootGroupUsersArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type Query_RootListByIdOrTitleArgs = {
  listIdOrTitle: Scalars['String']['input'];
  siteUrl: Scalars['URL']['input'];
};

export type Query_RootListFieldsArgs = {
  listIdOrTitle: Scalars['String']['input'];
  siteUrl: Scalars['URL']['input'];
};

export type Query_RootListItemArgs = {
  listIdOrTitle: Scalars['String']['input'];
  listItemId: Scalars['Int']['input'];
  siteUrl: Scalars['URL']['input'];
};

export type Query_RootListItemCommentsArgs = {
  listIdOrTitle: Scalars['String']['input'];
  listItemId: Scalars['Int']['input'];
  siteUrl: Scalars['URL']['input'];
};

export type Query_RootListItemsByCamlQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  camlQuery: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  listIdOrTitle: Scalars['String']['input'];
  siteUrl: Scalars['URL']['input'];
};

export type Query_RootListItemsCommentsArgs = {
  listIdOrTitle: Scalars['String']['input'];
  listItemsIds: Array<Scalars['Int']['input']>;
  siteUrl: Scalars['URL']['input'];
};

export type Query_RootMlfsl_Ad_GroupArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Ad_Group_Order_By>>;
  where?: InputMaybe<Mlfsl_Ad_Group_Bool_Exp>;
};

export type Query_RootMlfsl_Ad_Group_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Ad_Group_Order_By>>;
  where?: InputMaybe<Mlfsl_Ad_Group_Bool_Exp>;
};

export type Query_RootMlfsl_Ad_Group_By_PkArgs = {
  ADGroupId: Scalars['Int']['input'];
};

export type Query_RootMlfsl_Ad_JoinArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Ad_Join_Order_By>>;
  where?: InputMaybe<Mlfsl_Ad_Join_Bool_Exp>;
};

export type Query_RootMlfsl_Ad_Join_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Ad_Join_Order_By>>;
  where?: InputMaybe<Mlfsl_Ad_Join_Bool_Exp>;
};

export type Query_RootMlfsl_Ad_Join_By_PkArgs = {
  JoinsRowKey: Scalars['Int']['input'];
};

export type Query_RootMlfsl_Ad_LoginArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Ad_Login_Order_By>>;
  where?: InputMaybe<Mlfsl_Ad_Login_Bool_Exp>;
};

export type Query_RootMlfsl_Ad_Login_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Ad_Login_Order_By>>;
  where?: InputMaybe<Mlfsl_Ad_Login_Bool_Exp>;
};

export type Query_RootMlfsl_Ad_Login_By_PkArgs = {
  AdLoginId: Scalars['Int']['input'];
};

export type Query_RootMlfsl_ClientArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Client_Order_By>>;
  where?: InputMaybe<Mlfsl_Client_Bool_Exp>;
};

export type Query_RootMlfsl_Client_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Client_Order_By>>;
  where?: InputMaybe<Mlfsl_Client_Bool_Exp>;
};

export type Query_RootMlfsl_Client_By_PkArgs = {
  DimClientNowKey: Scalars['Int']['input'];
};

export type Query_RootMlfsl_Client_Display_DescriptionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Client_Display_Description_Order_By>>;
  where?: InputMaybe<Mlfsl_Client_Display_Description_Bool_Exp>;
};

export type Query_RootMlfsl_DateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Date_Order_By>>;
  where?: InputMaybe<Mlfsl_Date_Bool_Exp>;
};

export type Query_RootMlfsl_Date_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Date_Order_By>>;
  where?: InputMaybe<Mlfsl_Date_Bool_Exp>;
};

export type Query_RootMlfsl_Date_By_PkArgs = {
  DimDatekey: Scalars['Int']['input'];
};

export type Query_RootMlfsl_Finance_Hours_ClientArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Client_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Client_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Client_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Client_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Client_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Client_By_PkArgs = {
  ClientNumber: Scalars['String']['input'];
};

export type Query_RootMlfsl_Finance_Hours_ClientofficetimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clientofficetimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clientofficetimeframe_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Clientofficetimeframe_By_PkArgs = {
  ClientNumber: Scalars['String']['input'];
  HistoricalTKOfficeforCount: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
};

export type Query_RootMlfsl_Finance_Hours_ClientpgtimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clientpgtimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clientpgtimeframe_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Clientpgtimeframe_By_PkArgs = {
  ClientNumber: Scalars['String']['input'];
  HistoricalTKPGforCount: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
};

export type Query_RootMlfsl_Finance_Hours_ClienttimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clienttimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Clienttimeframe_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clienttimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Clienttimeframe_By_PkArgs = {
  ClientNumber: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
};

export type Query_RootMlfsl_Finance_Hours_ClienttimekeepertimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Clienttimekeepertimeframe_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Clienttimekeepertimeframe_By_PkArgs = {
  ClientNumber: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
  TkprNumber: Scalars['String']['input'];
};

export type Query_RootMlfsl_Finance_Hours_MatterArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Matter_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Matter_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Matter_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Matter_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Matter_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Matter_By_PkArgs = {
  MatterNumber: Scalars['String']['input'];
};

export type Query_RootMlfsl_Finance_Hours_MatterofficetimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Matterofficetimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Matterofficetimeframe_By_PkArgs = {
  ClientNumber: Scalars['String']['input'];
  HistoricalTKOfficeforCount: Scalars['String']['input'];
  Matter: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
};

export type Query_RootMlfsl_Finance_Hours_MatterpgtimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Matterpgtimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Matterpgtimeframe_By_PkArgs = {
  ClientNumber: Scalars['String']['input'];
  HistoricalTKPGforCount: Scalars['String']['input'];
  Matter: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
};

export type Query_RootMlfsl_Finance_Hours_MattertimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Mattertimeframe_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Mattertimeframe_By_PkArgs = {
  ClientNumber: Scalars['String']['input'];
  Matter: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
};

export type Query_RootMlfsl_Finance_Hours_MattertimeframecompareArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimeframecompare_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Mattertimeframecompare_By_PkArgs = {
  ClientNumber: Scalars['String']['input'];
  Matter: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
};

export type Query_RootMlfsl_Finance_Hours_MattertimekeepertimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Mattertimekeepertimeframe_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Mattertimekeepertimeframe_By_PkArgs = {
  ClientNumber: Scalars['String']['input'];
  Matter: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
  TkprNumber: Scalars['String']['input'];
};

export type Query_RootMlfsl_Finance_Hours_RelatedclientArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclient_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Relatedclient_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Relatedclient_By_PkArgs = {
  RelatedClientNumber: Scalars['String']['input'];
};

export type Query_RootMlfsl_Finance_Hours_RelatedclientofficetimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Relatedclientofficetimeframe_By_PkArgs = {
  HistoricalTKOfficeforCount: Scalars['String']['input'];
  RelatedClientNumber: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
};

export type Query_RootMlfsl_Finance_Hours_RelatedclientpgtimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Relatedclientpgtimeframe_By_PkArgs = {
  HistoricalTKPGforCount: Scalars['String']['input'];
  RelatedClientNumber: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
};

export type Query_RootMlfsl_Finance_Hours_RelatedclienttimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclienttimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Relatedclienttimeframe_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclienttimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Relatedclienttimeframe_By_PkArgs = {
  RelatedClientNumber: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
};

export type Query_RootMlfsl_Finance_Hours_RelatedclienttimekeepertimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Bool_Exp>;
};

export type Query_RootMlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_By_PkArgs = {
  RelatedClientNumber: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
  TkprNumber: Scalars['String']['input'];
};

export type Query_RootMlfsl_MatterArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Matter_Order_By>>;
  where?: InputMaybe<Mlfsl_Matter_Bool_Exp>;
};

export type Query_RootMlfsl_Matter_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Matter_Order_By>>;
  where?: InputMaybe<Mlfsl_Matter_Bool_Exp>;
};

export type Query_RootMlfsl_Matter_By_PkArgs = {
  DimMatterNowKey: Scalars['Int']['input'];
};

export type Query_RootMlfsl_Matter_Display_DescriptionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Matter_Display_Description_Order_By>>;
  where?: InputMaybe<Mlfsl_Matter_Display_Description_Bool_Exp>;
};

export type Query_RootMlfsl_Mlv_Finance_Hours_TimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Mlv_Finance_Hours_Timeframes_Order_By>>;
  where?: InputMaybe<Mlfsl_Mlv_Finance_Hours_Timeframes_Bool_Exp>;
};

export type Query_RootMlfsl_Mlv_Finance_Hours_ClientArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Mlv_Finance_Hours_Client_Order_By>>;
  where?: InputMaybe<Mlfsl_Mlv_Finance_Hours_Client_Bool_Exp>;
};

export type Query_RootMlfsl_Mlv_Finance_Hours_MatterArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Mlv_Finance_Hours_Matter_Order_By>>;
  where?: InputMaybe<Mlfsl_Mlv_Finance_Hours_Matter_Bool_Exp>;
};

export type Query_RootMlfsl_Mlv_Finance_Hours_RelatedclientArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Mlv_Finance_Hours_Relatedclient_Order_By>>;
  where?: InputMaybe<Mlfsl_Mlv_Finance_Hours_Relatedclient_Bool_Exp>;
};

export type Query_RootMlfsl_Morgannet_ClientPage_ClientInfoArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Morgannet_ClientPage_ClientInfo_Order_By>>;
  where?: InputMaybe<Mlfsl_Morgannet_ClientPage_ClientInfo_Bool_Exp>;
};

export type Query_RootMlfsl_Morgannet_ClientPage_ClientInfo_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Morgannet_ClientPage_ClientInfo_Order_By>>;
  where?: InputMaybe<Mlfsl_Morgannet_ClientPage_ClientInfo_Bool_Exp>;
};

export type Query_RootMlfsl_Morgannet_ClientPage_ClientInfo_By_PkArgs = {
  MNCP_ClientInfoKey: Scalars['Int']['input'];
};

export type Query_RootMlfsl_OfficeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Office_Order_By>>;
  where?: InputMaybe<Mlfsl_Office_Bool_Exp>;
};

export type Query_RootMlfsl_Office_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Office_Order_By>>;
  where?: InputMaybe<Mlfsl_Office_Bool_Exp>;
};

export type Query_RootMlfsl_Office_By_PkArgs = {
  DimOfficeNowKey: Scalars['Int']['input'];
};

export type Query_RootMlfsl_Person_EducationArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Person_Education_Order_By>>;
  where?: InputMaybe<Mlfsl_Person_Education_Bool_Exp>;
};

export type Query_RootMlfsl_Person_Education_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Person_Education_Order_By>>;
  where?: InputMaybe<Mlfsl_Person_Education_Bool_Exp>;
};

export type Query_RootMlfsl_Person_Education_By_PkArgs = {
  DimPersonnelEducationKey: Scalars['Int']['input'];
};

export type Query_RootMlfsl_PersonaArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Persona_Order_By>>;
  where?: InputMaybe<Mlfsl_Persona_Bool_Exp>;
};

export type Query_RootMlfsl_Persona_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Persona_Order_By>>;
  where?: InputMaybe<Mlfsl_Persona_Bool_Exp>;
};

export type Query_RootMlfsl_Persona_By_PkArgs = {
  PersonaId: Scalars['Int']['input'];
};

export type Query_RootMlfsl_Persona_GroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Persona_Groups_Order_By>>;
  where?: InputMaybe<Mlfsl_Persona_Groups_Bool_Exp>;
};

export type Query_RootMlfsl_Persona_Groups_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Persona_Groups_Order_By>>;
  where?: InputMaybe<Mlfsl_Persona_Groups_Bool_Exp>;
};

export type Query_RootMlfsl_Persona_Groups_By_PkArgs = {
  GroupAdSystemName: Scalars['String']['input'];
  PersonaId: Scalars['Int']['input'];
};

export type Query_RootMlfsl_PersonnelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
};

export type Query_RootMlfsl_Personnel_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
};

export type Query_RootMlfsl_Personnel_BarArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Bar_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Bar_Bool_Exp>;
};

export type Query_RootMlfsl_Personnel_Bar_By_PkArgs = {
  DimPersonnelBarKey: Scalars['Int']['input'];
};

export type Query_RootMlfsl_Personnel_By_PkArgs = {
  DimPersonnelNowKey: Scalars['Int']['input'];
};

export type Query_RootMlfsl_Personnel_ClerkshipArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Clerkship_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Clerkship_Bool_Exp>;
};

export type Query_RootMlfsl_Personnel_Clerkship_By_PkArgs = {
  DimPersonnelClerkshipKey: Scalars['Int']['input'];
};

export type Query_RootMlfsl_Personnel_CommitteeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Committee_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Committee_Bool_Exp>;
};

export type Query_RootMlfsl_Personnel_Committee_By_PkArgs = {
  DimPersonnelCommitteeKey: Scalars['Int']['input'];
};

export type Query_RootMlfsl_Personnel_CourtArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Court_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Court_Bool_Exp>;
};

export type Query_RootMlfsl_Personnel_Court_By_PkArgs = {
  DimPersonnelCourtKey: Scalars['Int']['input'];
};

export type Query_RootMlfsl_Personnel_LanguageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Language_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Language_Bool_Exp>;
};

export type Query_RootMlfsl_Personnel_Language_By_PkArgs = {
  DimPersonnelLanguageKey: Scalars['Int']['input'];
};

export type Query_RootMlfsl_PracticegroupArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Practicegroup_Order_By>>;
  where?: InputMaybe<Mlfsl_Practicegroup_Bool_Exp>;
};

export type Query_RootMlfsl_Practicegroup_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Practicegroup_Order_By>>;
  where?: InputMaybe<Mlfsl_Practicegroup_Bool_Exp>;
};

export type Query_RootMlfsl_Practicegroup_By_PkArgs = {
  DimPracticeGroupNowKey: Scalars['Int']['input'];
};

export type Query_RootMlfsl_Probono_GoalArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Probono_Goal_Order_By>>;
  where?: InputMaybe<Mlfsl_Probono_Goal_Bool_Exp>;
};

export type Query_RootMlfsl_Related_ClientArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Related_Client_Order_By>>;
  where?: InputMaybe<Mlfsl_Related_Client_Bool_Exp>;
};

export type Query_RootMlfsl_Related_Client_By_PkArgs = {
  DimClientNowKey: Scalars['Int']['input'];
};

export type Query_RootMlg_Search_AutocompleteArgs = {
  input: MlgSearchAutocompleteInput;
};

export type Query_RootMlg_Search_DocumentArgs = {
  id: Scalars['ID']['input'];
  indexName: Scalars['String']['input'];
};

export type Query_RootMlg_Search_DocumentCountArgs = {
  indexName: Scalars['String']['input'];
};

export type Query_RootMlg_Search_DocumentExistsArgs = {
  id: Scalars['ID']['input'];
  indexName: Scalars['String']['input'];
};

export type Query_RootMlg_Search_DocumentsArgs = {
  ids: Array<Scalars['ID']['input']>;
  indexName: Scalars['String']['input'];
};

export type Query_RootMlg_Search_IndexKeyFieldArgs = {
  indexName: Scalars['String']['input'];
};

export type Query_RootMlg_Search_QueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: MlgSearchQueryInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Query_RootMlg_Search_SuggestArgs = {
  input: MlgSearchSuggestInput;
};

export type Query_RootMnet_Ad_Group_LinkArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Ad_Group_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Ad_Group_Link_Order_By>>;
  where?: InputMaybe<Mnet_Ad_Group_Link_Bool_Exp>;
};

export type Query_RootMnet_Ad_Group_Link_By_PkArgs = {
  name: Scalars['String']['input'];
  objectguid: Scalars['uuid']['input'];
  priority: Scalars['Int']['input'];
};

export type Query_RootMnet_Assignmentportal_My_AvailabilityArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Assignmentportal_My_Availability_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Assignmentportal_My_Availability_Order_By>>;
  where?: InputMaybe<Mnet_Assignmentportal_My_Availability_Bool_Exp>;
};

export type Query_RootMnet_Assignmentportal_My_Availability_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Blog_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Attachments_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Attachments_Bool_Exp>;
};

export type Query_RootMnet_Blog_Attachments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Blog_BlogsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Blogs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Blogs_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Blogs_Bool_Exp>;
};

export type Query_RootMnet_Blog_Blogs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Blog_Channel_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Channel_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Channel_Notifications_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Channel_Notifications_Bool_Exp>;
};

export type Query_RootMnet_Blog_Channel_Notifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Blog_ChannelsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Channels_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Channels_Bool_Exp>;
};

export type Query_RootMnet_Blog_Channels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Blog_Comment_ReactionsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Comment_Reactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Comment_Reactions_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Comment_Reactions_Bool_Exp>;
};

export type Query_RootMnet_Blog_Comment_Reactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Blog_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Comments_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Comments_Bool_Exp>;
};

export type Query_RootMnet_Blog_Comments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Blog_Email_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Email_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Email_Notifications_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Email_Notifications_Bool_Exp>;
};

export type Query_RootMnet_Blog_Email_Notifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Blog_Email_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Email_Templates_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Email_Templates_Bool_Exp>;
};

export type Query_RootMnet_Blog_Email_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Blog_EventsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Events_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Events_Bool_Exp>;
};

export type Query_RootMnet_Blog_Events_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Blog_Group_In_BlogsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Group_In_Blogs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Group_In_Blogs_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Group_In_Blogs_Bool_Exp>;
};

export type Query_RootMnet_Blog_Group_In_Blogs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Blog_Inbound_EmailsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Inbound_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Inbound_Emails_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Inbound_Emails_Bool_Exp>;
};

export type Query_RootMnet_Blog_Inbound_Emails_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Blog_Notification_RecipientsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Notification_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Notification_Recipients_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Notification_Recipients_Bool_Exp>;
};

export type Query_RootMnet_Blog_Notification_Recipients_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Blog_Notification_Template_RulesArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Notification_Template_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Notification_Template_Rules_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Bool_Exp>;
};

export type Query_RootMnet_Blog_Notification_Template_Rules_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Blog_Post_ChannelsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Post_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Post_Channels_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Post_Channels_Bool_Exp>;
};

export type Query_RootMnet_Blog_Post_Channels_By_PkArgs = {
  channel_id: Scalars['uuid']['input'];
  post_id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Blog_Post_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Post_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Post_Images_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Post_Images_Bool_Exp>;
};

export type Query_RootMnet_Blog_Post_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Blog_Post_ReactionsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Post_Reactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Post_Reactions_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Post_Reactions_Bool_Exp>;
};

export type Query_RootMnet_Blog_Post_Reactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Blog_PostsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Posts_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Posts_Bool_Exp>;
};

export type Query_RootMnet_Blog_Posts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Posts_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Posts_Bool_Exp>;
};

export type Query_RootMnet_Blog_Posts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Business_Chemistry_TypeArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Business_Chemistry_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Business_Chemistry_Type_Order_By>>;
  where?: InputMaybe<Mnet_Business_Chemistry_Type_Bool_Exp>;
};

export type Query_RootMnet_Business_Chemistry_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Business_Chemistry_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Business_Chemistry_Type_Order_By>>;
  where?: InputMaybe<Mnet_Business_Chemistry_Type_Bool_Exp>;
};

export type Query_RootMnet_Business_Chemistry_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Client_Intel_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Client_Intel_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Client_Intel_Settings_Order_By>>;
  where?: InputMaybe<Mnet_Client_Intel_Settings_Bool_Exp>;
};

export type Query_RootMnet_Client_Intel_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Client_Intel_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Client_Intel_Settings_Order_By>>;
  where?: InputMaybe<Mnet_Client_Intel_Settings_Bool_Exp>;
};

export type Query_RootMnet_Client_Intel_Settings_By_PkArgs = {
  client_or_related_client_id: Scalars['String']['input'];
};

export type Query_RootMnet_Client_Manzama_Alert_Summary_CountsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Client_Manzama_Alert_Summary_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Client_Manzama_Alert_Summary_Counts_Order_By>>;
  where?: InputMaybe<Mnet_Client_Manzama_Alert_Summary_Counts_Bool_Exp>;
};

export type Query_RootMnet_Client_Manzama_Alert_Summary_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Client_Manzama_Alert_Summary_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Client_Manzama_Alert_Summary_Counts_Order_By>>;
  where?: InputMaybe<Mnet_Client_Manzama_Alert_Summary_Counts_Bool_Exp>;
};

export type Query_RootMnet_Client_Manzama_Alert_Summary_Counts_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Query_RootMnet_Client_Manzama_ArticleArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Client_Manzama_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Client_Manzama_Article_Order_By>>;
  where?: InputMaybe<Mnet_Client_Manzama_Article_Bool_Exp>;
};

export type Query_RootMnet_Client_Manzama_Article_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Client_Manzama_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Client_Manzama_Article_Order_By>>;
  where?: InputMaybe<Mnet_Client_Manzama_Article_Bool_Exp>;
};

export type Query_RootMnet_Client_Manzama_Article_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Query_RootMnet_Client_Manzama_Article_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Client_Manzama_Article_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Client_Manzama_Article_Category_Order_By>>;
  where?: InputMaybe<Mnet_Client_Manzama_Article_Category_Bool_Exp>;
};

export type Query_RootMnet_Client_Manzama_Article_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Client_Manzama_Article_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Client_Manzama_Article_Category_Order_By>>;
  where?: InputMaybe<Mnet_Client_Manzama_Article_Category_Bool_Exp>;
};

export type Query_RootMnet_Client_Manzama_Article_Category_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Query_RootMnet_Client_Manzama_Http_ResponseArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Client_Manzama_Http_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Client_Manzama_Http_Response_Order_By>>;
  where?: InputMaybe<Mnet_Client_Manzama_Http_Response_Bool_Exp>;
};

export type Query_RootMnet_Client_Manzama_Http_Response_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Client_Manzama_Http_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Client_Manzama_Http_Response_Order_By>>;
  where?: InputMaybe<Mnet_Client_Manzama_Http_Response_Bool_Exp>;
};

export type Query_RootMnet_Client_Manzama_Http_Response_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Query_RootMnet_Clientbadge_BadgeArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Badge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Badge_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Badge_Bool_Exp>;
};

export type Query_RootMnet_Clientbadge_Badge_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Badge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Badge_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Badge_Bool_Exp>;
};

export type Query_RootMnet_Clientbadge_Badge_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Clientbadge_Badge_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Badge_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Badge_Category_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Badge_Category_Bool_Exp>;
};

export type Query_RootMnet_Clientbadge_Badge_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Badge_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Badge_Category_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Badge_Category_Bool_Exp>;
};

export type Query_RootMnet_Clientbadge_Badge_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Clientbadge_ClientArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Client_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Client_Bool_Exp>;
};

export type Query_RootMnet_Clientbadge_Client_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Client_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Client_Bool_Exp>;
};

export type Query_RootMnet_Clientbadge_Client_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Clientbadge_Client_ExclusionArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Client_Exclusion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Client_Exclusion_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Client_Exclusion_Bool_Exp>;
};

export type Query_RootMnet_Clientbadge_Client_Exclusion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Client_Exclusion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Client_Exclusion_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Client_Exclusion_Bool_Exp>;
};

export type Query_RootMnet_Clientbadge_Client_Exclusion_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Clientbadge_Related_ClientArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Related_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Related_Client_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Related_Client_Bool_Exp>;
};

export type Query_RootMnet_Clientbadge_Related_Client_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Related_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Related_Client_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Related_Client_Bool_Exp>;
};

export type Query_RootMnet_Clientbadge_Related_Client_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Foundation_MatterArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Foundation_Matter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Foundation_Matter_Order_By>>;
  where?: InputMaybe<Mnet_Foundation_Matter_Bool_Exp>;
};

export type Query_RootMnet_Foundation_Matter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Foundation_Matter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Foundation_Matter_Order_By>>;
  where?: InputMaybe<Mnet_Foundation_Matter_Bool_Exp>;
};

export type Query_RootMnet_Foundation_Matter_By_PkArgs = {
  foundation_matter_id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Mytools_Catalog_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_Catalog_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_Catalog_Category_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_Catalog_Category_Bool_Exp>;
};

export type Query_RootMnet_Mytools_Catalog_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_Catalog_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_Catalog_Category_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_Catalog_Category_Bool_Exp>;
};

export type Query_RootMnet_Mytools_Catalog_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Mytools_Catalog_ToolArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_Catalog_Tool_Bool_Exp>;
};

export type Query_RootMnet_Mytools_Catalog_Tool_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_Catalog_Tool_Bool_Exp>;
};

export type Query_RootMnet_Mytools_Catalog_Tool_AssignmentArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Assignment_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_Catalog_Tool_Assignment_Bool_Exp>;
};

export type Query_RootMnet_Mytools_Catalog_Tool_Assignment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Assignment_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_Catalog_Tool_Assignment_Bool_Exp>;
};

export type Query_RootMnet_Mytools_Catalog_Tool_Assignment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Mytools_Catalog_Tool_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Mytools_User_ToolArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_User_Tool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_User_Tool_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_User_Tool_Bool_Exp>;
};

export type Query_RootMnet_Mytools_User_Tool_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_User_Tool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_User_Tool_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_User_Tool_Bool_Exp>;
};

export type Query_RootMnet_Mytools_User_Tool_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootMnet_Office_DetailArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Office_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Office_Detail_Order_By>>;
  where?: InputMaybe<Mnet_Office_Detail_Bool_Exp>;
};

export type Query_RootMnet_Office_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Office_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Office_Detail_Order_By>>;
  where?: InputMaybe<Mnet_Office_Detail_Bool_Exp>;
};

export type Query_RootMnet_Office_Detail_By_PkArgs = {
  office_code: Scalars['String']['input'];
};

export type Query_RootMnet_Person_Business_Chemistry_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Person_Business_Chemistry_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Person_Business_Chemistry_Profile_Order_By>>;
  where?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Bool_Exp>;
};

export type Query_RootMnet_Person_Business_Chemistry_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Person_Business_Chemistry_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Person_Business_Chemistry_Profile_Order_By>>;
  where?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Bool_Exp>;
};

export type Query_RootMnet_Person_Business_Chemistry_Profile_By_PkArgs = {
  ad_system_id: Scalars['String']['input'];
};

export type Query_RootMnet_Personnel_Profile_BadgesArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Personnel_Profile_Badges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Personnel_Profile_Badges_Order_By>>;
  where?: InputMaybe<Mnet_Personnel_Profile_Badges_Bool_Exp>;
};

export type Query_RootMnet_Personnel_Profile_Badges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Personnel_Profile_Badges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Personnel_Profile_Badges_Order_By>>;
  where?: InputMaybe<Mnet_Personnel_Profile_Badges_Bool_Exp>;
};

export type Query_RootMnet_Personnel_Profile_Badges_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Query_RootMnet_Practice_Area_DetailArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Practice_Area_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Practice_Area_Detail_Order_By>>;
  where?: InputMaybe<Mnet_Practice_Area_Detail_Bool_Exp>;
};

export type Query_RootMnet_Practice_Area_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Practice_Area_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Practice_Area_Detail_Order_By>>;
  where?: InputMaybe<Mnet_Practice_Area_Detail_Bool_Exp>;
};

export type Query_RootMnet_Practice_Area_Detail_By_PkArgs = {
  practice_area_code: Scalars['String']['input'];
};

export type Query_RootMnet_Practice_Group_DetailArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Practice_Group_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Practice_Group_Detail_Order_By>>;
  where?: InputMaybe<Mnet_Practice_Group_Detail_Bool_Exp>;
};

export type Query_RootMnet_Practice_Group_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Practice_Group_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Practice_Group_Detail_Order_By>>;
  where?: InputMaybe<Mnet_Practice_Group_Detail_Bool_Exp>;
};

export type Query_RootMnet_Practice_Group_Detail_By_PkArgs = {
  practice_group_code: Scalars['String']['input'];
};

export type Query_RootMnet_User_LinkArgs = {
  distinct_on?: InputMaybe<Array<Mnet_User_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_User_Link_Order_By>>;
  where?: InputMaybe<Mnet_User_Link_Bool_Exp>;
};

export type Query_RootMnet_User_Link_By_PkArgs = {
  name: Scalars['String']['input'];
};

export type Query_RootMnet_Wellable_LeaderboardArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Wellable_Leaderboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Wellable_Leaderboard_Order_By>>;
  where?: InputMaybe<Mnet_Wellable_Leaderboard_Bool_Exp>;
};

export type Query_RootMnet_Wellable_Leaderboard_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Wellable_Leaderboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Wellable_Leaderboard_Order_By>>;
  where?: InputMaybe<Mnet_Wellable_Leaderboard_Bool_Exp>;
};

export type Query_RootMnet_Wellable_Leaderboard_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootPbc_Counsel_RepresentativesArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Counsel_Representatives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Counsel_Representatives_Order_By>>;
  where?: InputMaybe<Pbc_Counsel_Representatives_Bool_Exp>;
};

export type Query_RootPbc_Counsel_Representatives_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Counsel_Representatives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Counsel_Representatives_Order_By>>;
  where?: InputMaybe<Pbc_Counsel_Representatives_Bool_Exp>;
};

export type Query_RootPbc_Counsel_Representatives_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootPbc_Email_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Email_Templates_Order_By>>;
  where?: InputMaybe<Pbc_Email_Templates_Bool_Exp>;
};

export type Query_RootPbc_Email_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Email_Templates_Order_By>>;
  where?: InputMaybe<Pbc_Email_Templates_Bool_Exp>;
};

export type Query_RootPbc_Email_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootPbc_Exempt_UsersArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Exempt_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Exempt_Users_Order_By>>;
  where?: InputMaybe<Pbc_Exempt_Users_Bool_Exp>;
};

export type Query_RootPbc_Exempt_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Exempt_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Exempt_Users_Order_By>>;
  where?: InputMaybe<Pbc_Exempt_Users_Bool_Exp>;
};

export type Query_RootPbc_Exempt_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootPbc_Notification_RecipientsArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Notification_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Notification_Recipients_Order_By>>;
  where?: InputMaybe<Pbc_Notification_Recipients_Bool_Exp>;
};

export type Query_RootPbc_Notification_Recipients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Notification_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Notification_Recipients_Order_By>>;
  where?: InputMaybe<Pbc_Notification_Recipients_Bool_Exp>;
};

export type Query_RootPbc_Notification_Recipients_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootPbc_Notification_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Notification_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Notification_Requests_Order_By>>;
  where?: InputMaybe<Pbc_Notification_Requests_Bool_Exp>;
};

export type Query_RootPbc_Notification_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Notification_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Notification_Requests_Order_By>>;
  where?: InputMaybe<Pbc_Notification_Requests_Bool_Exp>;
};

export type Query_RootPbc_Notification_Requests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootPbc_Notification_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Notification_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Notification_Statuses_Order_By>>;
  where?: InputMaybe<Pbc_Notification_Statuses_Bool_Exp>;
};

export type Query_RootPbc_Notification_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Notification_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Notification_Statuses_Order_By>>;
  where?: InputMaybe<Pbc_Notification_Statuses_Bool_Exp>;
};

export type Query_RootPbc_Notification_Statuses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootPbc_SendersArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Senders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Senders_Order_By>>;
  where?: InputMaybe<Pbc_Senders_Bool_Exp>;
};

export type Query_RootPbc_Senders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Senders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Senders_Order_By>>;
  where?: InputMaybe<Pbc_Senders_Bool_Exp>;
};

export type Query_RootPbc_Senders_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootPlanArgs = {
  planId: Scalars['String']['input'];
};

export type Query_RootSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchInput: SearchInput;
};

export type Query_RootSiteArgs = {
  siteUrl: Scalars['URL']['input'];
};

export type Query_RootSpSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchQueryOptions: SearchQueryOptionsInput;
  siteUrl: Scalars['URL']['input'];
};

export type Query_RootTaskArgs = {
  taskId: Scalars['String']['input'];
};

export type Query_RootUserArgs = {
  userId: Scalars['String']['input'];
};

export type Query_RootUserByEmailArgs = {
  email: Scalars['String']['input'];
};

export type Query_RootUserByIdArgs = {
  userId: Scalars['String']['input'];
};

export type Query_RootUserByMailArgs = {
  mail: Scalars['String']['input'];
};

export type Query_RootUsersArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type Query_RootUsersByEmailsArgs = {
  emails: Array<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']['input']>;
  _gt?: InputMaybe<Scalars['smallint']['input']>;
  _gte?: InputMaybe<Scalars['smallint']['input']>;
  _in?: InputMaybe<Array<Scalars['smallint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['smallint']['input']>;
  _lte?: InputMaybe<Scalars['smallint']['input']>;
  _neq?: InputMaybe<Scalars['smallint']['input']>;
  _nin?: InputMaybe<Array<Scalars['smallint']['input']>>;
};

export type Subscription_Root = {
  /** fetch data from the table: "BCS.Personnel" */
  BCS_Personnel: Array<Bcs_Personnel>;
  /** fetch aggregated fields from the table: "BCS.Personnel" */
  BCS_Personnel_aggregate: Bcs_Personnel_Aggregate;
  /** fetch data from the table: "BCS.Personnel" using primary key columns */
  BCS_Personnel_by_pk?: Maybe<Bcs_Personnel>;
  /** fetch data from the table in a streaming manner: "BCS.Personnel" */
  BCS_Personnel_stream: Array<Bcs_Personnel>;
  /** fetch data from the table: "b2b.external_accounts" */
  b2b_external_accounts: Array<B2b_External_Accounts>;
  /** fetch data from the table: "b2b.external_accounts" using primary key columns */
  b2b_external_accounts_by_pk?: Maybe<B2b_External_Accounts>;
  /** fetch data from the table in a streaming manner: "b2b.external_accounts" */
  b2b_external_accounts_stream: Array<B2b_External_Accounts>;
  /** fetch data from the table: "b2b.logs" */
  b2b_logs: Array<B2b_Logs>;
  /** fetch data from the table: "b2b.logs" using primary key columns */
  b2b_logs_by_pk?: Maybe<B2b_Logs>;
  /** fetch data from the table in a streaming manner: "b2b.logs" */
  b2b_logs_stream: Array<B2b_Logs>;
  /** fetch data from the table: "b2b.ml_sponsor_references" */
  b2b_ml_sponsor_references: Array<B2b_Ml_Sponsor_References>;
  /** fetch data from the table: "b2b.ml_sponsor_references" using primary key columns */
  b2b_ml_sponsor_references_by_pk?: Maybe<B2b_Ml_Sponsor_References>;
  /** fetch data from the table in a streaming manner: "b2b.ml_sponsor_references" */
  b2b_ml_sponsor_references_stream: Array<B2b_Ml_Sponsor_References>;
  /** fetch data from the table: "b2b.request_status" */
  b2b_request_status: Array<B2b_Request_Status>;
  /** fetch data from the table: "b2b.request_status" using primary key columns */
  b2b_request_status_by_pk?: Maybe<B2b_Request_Status>;
  /** fetch data from the table in a streaming manner: "b2b.request_status" */
  b2b_request_status_stream: Array<B2b_Request_Status>;
  /** fetch data from the table: "b2b.requests" */
  b2b_requests: Array<B2b_Requests>;
  /** fetch data from the table: "b2b.requests" using primary key columns */
  b2b_requests_by_pk?: Maybe<B2b_Requests>;
  /** fetch data from the table in a streaming manner: "b2b.requests" */
  b2b_requests_stream: Array<B2b_Requests>;
  /** fetch data from the table: "b2b.resource_owner_references" */
  b2b_resource_owner_references: Array<B2b_Resource_Owner_References>;
  /** fetch data from the table: "b2b.resource_owner_references" using primary key columns */
  b2b_resource_owner_references_by_pk?: Maybe<B2b_Resource_Owner_References>;
  /** fetch data from the table in a streaming manner: "b2b.resource_owner_references" */
  b2b_resource_owner_references_stream: Array<B2b_Resource_Owner_References>;
  /** fetch data from the table: "cle.cle_attachments" */
  cle_cle_attachments: Array<Cle_Cle_Attachments>;
  /** fetch aggregated fields from the table: "cle.cle_attachments" */
  cle_cle_attachments_aggregate: Cle_Cle_Attachments_Aggregate;
  /** fetch data from the table: "cle.cle_attachments" using primary key columns */
  cle_cle_attachments_by_pk?: Maybe<Cle_Cle_Attachments>;
  /** fetch data from the table in a streaming manner: "cle.cle_attachments" */
  cle_cle_attachments_stream: Array<Cle_Cle_Attachments>;
  /** fetch data from the table: "cle.cle_requests" */
  cle_cle_requests: Array<Cle_Cle_Requests>;
  /** fetch aggregated fields from the table: "cle.cle_requests" */
  cle_cle_requests_aggregate: Cle_Cle_Requests_Aggregate;
  /** fetch data from the table: "cle.cle_requests" using primary key columns */
  cle_cle_requests_by_pk?: Maybe<Cle_Cle_Requests>;
  /** fetch data from the table in a streaming manner: "cle.cle_requests" */
  cle_cle_requests_stream: Array<Cle_Cle_Requests>;
  /** fetch data from the table: "clm.engagement_client_comments" */
  clm_engagement_client_comments: Array<Clm_Engagement_Client_Comments>;
  /** fetch data from the table: "clm.engagement_client_comments" using primary key columns */
  clm_engagement_client_comments_by_pk?: Maybe<Clm_Engagement_Client_Comments>;
  /** fetch data from the table in a streaming manner: "clm.engagement_client_comments" */
  clm_engagement_client_comments_stream: Array<Clm_Engagement_Client_Comments>;
  /** fetch data from the table: "clm.engagement_imanage_documents" */
  clm_engagement_imanage_documents: Array<Clm_Engagement_Imanage_Documents>;
  /** fetch aggregated fields from the table: "clm.engagement_imanage_documents" */
  clm_engagement_imanage_documents_aggregate: Clm_Engagement_Imanage_Documents_Aggregate;
  /** fetch data from the table: "clm.engagement_imanage_documents" using primary key columns */
  clm_engagement_imanage_documents_by_pk?: Maybe<Clm_Engagement_Imanage_Documents>;
  /** fetch data from the table in a streaming manner: "clm.engagement_imanage_documents" */
  clm_engagement_imanage_documents_stream: Array<Clm_Engagement_Imanage_Documents>;
  /** fetch data from the table: "clm.engagement_records" */
  clm_engagement_records: Array<Clm_Engagement_Records>;
  /** fetch data from the table: "clm.engagement_records" using primary key columns */
  clm_engagement_records_by_pk?: Maybe<Clm_Engagement_Records>;
  /** fetch data from the table in a streaming manner: "clm.engagement_records" */
  clm_engagement_records_stream: Array<Clm_Engagement_Records>;
  /** fetch data from the table: "clm.views" */
  clm_views: Array<Clm_Views>;
  /** fetch data from the table: "clm.views" using primary key columns */
  clm_views_by_pk?: Maybe<Clm_Views>;
  /** fetch data from the table in a streaming manner: "clm.views" */
  clm_views_stream: Array<Clm_Views>;
  /** fetch data from the table: "clm.waiver_imanage_documents" */
  clm_waiver_imanage_documents: Array<Clm_Waiver_Imanage_Documents>;
  /** fetch aggregated fields from the table: "clm.waiver_imanage_documents" */
  clm_waiver_imanage_documents_aggregate: Clm_Waiver_Imanage_Documents_Aggregate;
  /** fetch data from the table: "clm.waiver_imanage_documents" using primary key columns */
  clm_waiver_imanage_documents_by_pk?: Maybe<Clm_Waiver_Imanage_Documents>;
  /** fetch data from the table in a streaming manner: "clm.waiver_imanage_documents" */
  clm_waiver_imanage_documents_stream: Array<Clm_Waiver_Imanage_Documents>;
  /** fetch data from the table: "clm.waiver_records" */
  clm_waiver_records: Array<Clm_Waiver_Records>;
  /** fetch data from the table: "clm.waiver_records" using primary key columns */
  clm_waiver_records_by_pk?: Maybe<Clm_Waiver_Records>;
  /** fetch data from the table in a streaming manner: "clm.waiver_records" */
  clm_waiver_records_stream: Array<Clm_Waiver_Records>;
  /** fetch data from the table: "fd.email_templates" */
  fd_email_templates: Array<Fd_Email_Templates>;
  /** fetch data from the table: "fd.email_templates" using primary key columns */
  fd_email_templates_by_pk?: Maybe<Fd_Email_Templates>;
  /** fetch data from the table in a streaming manner: "fd.email_templates" */
  fd_email_templates_stream: Array<Fd_Email_Templates>;
  /** fetch data from the table: "fd.exempt_matters" */
  fd_exempt_matters: Array<Fd_Exempt_Matters>;
  /** fetch data from the table: "fd.exempt_matters" using primary key columns */
  fd_exempt_matters_by_pk?: Maybe<Fd_Exempt_Matters>;
  /** fetch data from the table in a streaming manner: "fd.exempt_matters" */
  fd_exempt_matters_stream: Array<Fd_Exempt_Matters>;
  /** fetch data from the table: "fd.instruction_templates" */
  fd_instruction_templates: Array<Fd_Instruction_Templates>;
  /** fetch data from the table: "fd.instruction_templates" using primary key columns */
  fd_instruction_templates_by_pk?: Maybe<Fd_Instruction_Templates>;
  /** fetch data from the table in a streaming manner: "fd.instruction_templates" */
  fd_instruction_templates_stream: Array<Fd_Instruction_Templates>;
  /** fetch data from the table: "fd.matters_responses" */
  fd_matters_responses: Array<Fd_Matters_Responses>;
  /** fetch data from the table: "fd.matters_responses" using primary key columns */
  fd_matters_responses_by_pk?: Maybe<Fd_Matters_Responses>;
  /** fetch data from the table in a streaming manner: "fd.matters_responses" */
  fd_matters_responses_stream: Array<Fd_Matters_Responses>;
  /** fetch data from the table: "fd.project_access" */
  fd_project_access: Array<Fd_Project_Access>;
  /** fetch data from the table: "fd.project_access" using primary key columns */
  fd_project_access_by_pk?: Maybe<Fd_Project_Access>;
  /** fetch data from the table in a streaming manner: "fd.project_access" */
  fd_project_access_stream: Array<Fd_Project_Access>;
  /** fetch data from the table: "fd.project_number_counter" */
  fd_project_number_counter: Array<Fd_Project_Number_Counter>;
  /** fetch data from the table: "fd.project_number_counter" using primary key columns */
  fd_project_number_counter_by_pk?: Maybe<Fd_Project_Number_Counter>;
  /** fetch data from the table in a streaming manner: "fd.project_number_counter" */
  fd_project_number_counter_stream: Array<Fd_Project_Number_Counter>;
  /** fetch data from the table: "fd.projects" */
  fd_projects: Array<Fd_Projects>;
  /** fetch data from the table: "fd.projects" using primary key columns */
  fd_projects_by_pk?: Maybe<Fd_Projects>;
  /** fetch data from the table in a streaming manner: "fd.projects" */
  fd_projects_stream: Array<Fd_Projects>;
  /** fetch data from the table: "fd.response_in_projects" */
  fd_response_in_projects: Array<Fd_Response_In_Projects>;
  /** fetch data from the table: "fd.response_in_projects" using primary key columns */
  fd_response_in_projects_by_pk?: Maybe<Fd_Response_In_Projects>;
  /** fetch data from the table in a streaming manner: "fd.response_in_projects" */
  fd_response_in_projects_stream: Array<Fd_Response_In_Projects>;
  /** fetch data from the table: "fd.responses" */
  fd_responses: Array<Fd_Responses>;
  /** fetch data from the table: "fd.responses" using primary key columns */
  fd_responses_by_pk?: Maybe<Fd_Responses>;
  /** fetch data from the table in a streaming manner: "fd.responses" */
  fd_responses_stream: Array<Fd_Responses>;
  /** fetch data from the table: "firstup.channels" */
  firstup_channels: Array<Firstup_Channels>;
  /** fetch data from the table: "firstup.channels" using primary key columns */
  firstup_channels_by_pk?: Maybe<Firstup_Channels>;
  /** fetch data from the table in a streaming manner: "firstup.channels" */
  firstup_channels_stream: Array<Firstup_Channels>;
  /** fetch data from the table: "firstup.content" */
  firstup_content: Array<Firstup_Content>;
  /** fetch aggregated fields from the table: "firstup.content" */
  firstup_content_aggregate: Firstup_Content_Aggregate;
  /** fetch data from the table: "firstup.content" using primary key columns */
  firstup_content_by_pk?: Maybe<Firstup_Content>;
  /** fetch data from the table: "firstup.content_in_channels" */
  firstup_content_in_channels: Array<Firstup_Content_In_Channels>;
  /** fetch aggregated fields from the table: "firstup.content_in_channels" */
  firstup_content_in_channels_aggregate: Firstup_Content_In_Channels_Aggregate;
  /** fetch data from the table: "firstup.content_in_channels" using primary key columns */
  firstup_content_in_channels_by_pk?: Maybe<Firstup_Content_In_Channels>;
  /** fetch data from the table in a streaming manner: "firstup.content_in_channels" */
  firstup_content_in_channels_stream: Array<Firstup_Content_In_Channels>;
  /** fetch data from the table in a streaming manner: "firstup.content" */
  firstup_content_stream: Array<Firstup_Content>;
  /** fetch data from the table: "firstup.images" */
  firstup_images: Array<Firstup_Images>;
  /** fetch aggregated fields from the table: "firstup.images" */
  firstup_images_aggregate: Firstup_Images_Aggregate;
  /** fetch data from the table: "firstup.images" using primary key columns */
  firstup_images_by_pk?: Maybe<Firstup_Images>;
  /** fetch data from the table: "firstup.images_in_content" */
  firstup_images_in_content: Array<Firstup_Images_In_Content>;
  /** fetch aggregated fields from the table: "firstup.images_in_content" */
  firstup_images_in_content_aggregate: Firstup_Images_In_Content_Aggregate;
  /** fetch data from the table: "firstup.images_in_content" using primary key columns */
  firstup_images_in_content_by_pk?: Maybe<Firstup_Images_In_Content>;
  /** fetch data from the table in a streaming manner: "firstup.images_in_content" */
  firstup_images_in_content_stream: Array<Firstup_Images_In_Content>;
  /** fetch data from the table in a streaming manner: "firstup.images" */
  firstup_images_stream: Array<Firstup_Images>;
  /** fetch data from the table: "firstup.people_in_content" */
  firstup_people_in_content: Array<Firstup_People_In_Content>;
  /** fetch aggregated fields from the table: "firstup.people_in_content" */
  firstup_people_in_content_aggregate: Firstup_People_In_Content_Aggregate;
  /** fetch data from the table: "firstup.people_in_content" using primary key columns */
  firstup_people_in_content_by_pk?: Maybe<Firstup_People_In_Content>;
  /** fetch data from the table in a streaming manner: "firstup.people_in_content" */
  firstup_people_in_content_stream: Array<Firstup_People_In_Content>;
  /** fetch data from the table: "firstup.videos" */
  firstup_videos: Array<Firstup_Videos>;
  /** fetch aggregated fields from the table: "firstup.videos" */
  firstup_videos_aggregate: Firstup_Videos_Aggregate;
  /** fetch data from the table: "firstup.videos" using primary key columns */
  firstup_videos_by_pk?: Maybe<Firstup_Videos>;
  /** fetch data from the table: "firstup.videos_in_content" */
  firstup_videos_in_content: Array<Firstup_Videos_In_Content>;
  /** fetch aggregated fields from the table: "firstup.videos_in_content" */
  firstup_videos_in_content_aggregate: Firstup_Videos_In_Content_Aggregate;
  /** fetch data from the table: "firstup.videos_in_content" using primary key columns */
  firstup_videos_in_content_by_pk?: Maybe<Firstup_Videos_In_Content>;
  /** fetch data from the table in a streaming manner: "firstup.videos_in_content" */
  firstup_videos_in_content_stream: Array<Firstup_Videos_In_Content>;
  /** fetch data from the table in a streaming manner: "firstup.videos" */
  firstup_videos_stream: Array<Firstup_Videos>;
  /** fetch data from the table: "ftp.request" */
  ftp_request: Array<Ftp_Request>;
  /** fetch aggregated fields from the table: "ftp.request" */
  ftp_request_aggregate: Ftp_Request_Aggregate;
  /** fetch data from the table: "ftp.request" using primary key columns */
  ftp_request_by_pk?: Maybe<Ftp_Request>;
  /** fetch data from the table: "ftp.request_detail" */
  ftp_request_detail: Array<Ftp_Request_Detail>;
  /** fetch data from the table: "ftp.request_detail" using primary key columns */
  ftp_request_detail_by_pk?: Maybe<Ftp_Request_Detail>;
  /** fetch data from the table in a streaming manner: "ftp.request_detail" */
  ftp_request_detail_stream: Array<Ftp_Request_Detail>;
  /** fetch data from the table: "ftp.request_external_access" */
  ftp_request_external_access: Array<Ftp_Request_External_Access>;
  /** fetch data from the table: "ftp.request_external_access" using primary key columns */
  ftp_request_external_access_by_pk?: Maybe<Ftp_Request_External_Access>;
  /** fetch data from the table in a streaming manner: "ftp.request_external_access" */
  ftp_request_external_access_stream: Array<Ftp_Request_External_Access>;
  /** fetch data from the table: "ftp.request_external_note" */
  ftp_request_external_note: Array<Ftp_Request_External_Note>;
  /** fetch data from the table: "ftp.request_external_note" using primary key columns */
  ftp_request_external_note_by_pk?: Maybe<Ftp_Request_External_Note>;
  /** fetch data from the table in a streaming manner: "ftp.request_external_note" */
  ftp_request_external_note_stream: Array<Ftp_Request_External_Note>;
  /** fetch data from the table: "ftp.request_internal_note" */
  ftp_request_internal_note: Array<Ftp_Request_Internal_Note>;
  /** fetch data from the table: "ftp.request_internal_note" using primary key columns */
  ftp_request_internal_note_by_pk?: Maybe<Ftp_Request_Internal_Note>;
  /** fetch data from the table in a streaming manner: "ftp.request_internal_note" */
  ftp_request_internal_note_stream: Array<Ftp_Request_Internal_Note>;
  /** fetch data from the table: "ftp.request_number_counter" */
  ftp_request_number_counter: Array<Ftp_Request_Number_Counter>;
  /** fetch data from the table: "ftp.request_number_counter" using primary key columns */
  ftp_request_number_counter_by_pk?: Maybe<Ftp_Request_Number_Counter>;
  /** fetch data from the table in a streaming manner: "ftp.request_number_counter" */
  ftp_request_number_counter_stream: Array<Ftp_Request_Number_Counter>;
  /** fetch data from the table: "ftp.request_participant" */
  ftp_request_participant: Array<Ftp_Request_Participant>;
  /** fetch data from the table: "ftp.request_participant" using primary key columns */
  ftp_request_participant_by_pk?: Maybe<Ftp_Request_Participant>;
  /** fetch data from the table in a streaming manner: "ftp.request_participant" */
  ftp_request_participant_stream: Array<Ftp_Request_Participant>;
  /** fetch data from the table in a streaming manner: "ftp.request" */
  ftp_request_stream: Array<Ftp_Request>;
  /** fetch data from the table: "gec.audience" */
  gec_audience: Array<Gec_Audience>;
  /** fetch data from the table: "gec.audience" using primary key columns */
  gec_audience_by_pk?: Maybe<Gec_Audience>;
  /** fetch data from the table: "gec.audience_in_event" */
  gec_audience_in_event: Array<Gec_Audience_In_Event>;
  /** fetch data from the table: "gec.audience_in_event" using primary key columns */
  gec_audience_in_event_by_pk?: Maybe<Gec_Audience_In_Event>;
  /** fetch data from the table in a streaming manner: "gec.audience_in_event" */
  gec_audience_in_event_stream: Array<Gec_Audience_In_Event>;
  /** fetch data from the table in a streaming manner: "gec.audience" */
  gec_audience_stream: Array<Gec_Audience>;
  /** fetch data from the table: "gec.contact_in_event" */
  gec_contact_in_event: Array<Gec_Contact_In_Event>;
  /** fetch data from the table: "gec.contact_in_event" using primary key columns */
  gec_contact_in_event_by_pk?: Maybe<Gec_Contact_In_Event>;
  /** fetch data from the table in a streaming manner: "gec.contact_in_event" */
  gec_contact_in_event_stream: Array<Gec_Contact_In_Event>;
  /** fetch data from the table: "gec.departments" */
  gec_departments: Array<Gec_Departments>;
  /** fetch data from the table: "gec.departments" using primary key columns */
  gec_departments_by_pk?: Maybe<Gec_Departments>;
  /** fetch data from the table: "gec.departments_in_event" */
  gec_departments_in_event: Array<Gec_Departments_In_Event>;
  /** fetch data from the table: "gec.departments_in_event" using primary key columns */
  gec_departments_in_event_by_pk?: Maybe<Gec_Departments_In_Event>;
  /** fetch data from the table in a streaming manner: "gec.departments_in_event" */
  gec_departments_in_event_stream: Array<Gec_Departments_In_Event>;
  /** fetch data from the table in a streaming manner: "gec.departments" */
  gec_departments_stream: Array<Gec_Departments>;
  /** fetch data from the table: "gec.event_exception" */
  gec_event_exception: Array<Gec_Event_Exception>;
  /** fetch data from the table: "gec.event_exception" using primary key columns */
  gec_event_exception_by_pk?: Maybe<Gec_Event_Exception>;
  /** fetch data from the table in a streaming manner: "gec.event_exception" */
  gec_event_exception_stream: Array<Gec_Event_Exception>;
  /** fetch data from the table: "gec.event_format" */
  gec_event_format: Array<Gec_Event_Format>;
  /** fetch data from the table: "gec.event_format" using primary key columns */
  gec_event_format_by_pk?: Maybe<Gec_Event_Format>;
  /** fetch data from the table in a streaming manner: "gec.event_format" */
  gec_event_format_stream: Array<Gec_Event_Format>;
  /** fetch data from the table: "gec.event_type" */
  gec_event_type: Array<Gec_Event_Type>;
  /** fetch data from the table: "gec.event_type" using primary key columns */
  gec_event_type_by_pk?: Maybe<Gec_Event_Type>;
  /** fetch data from the table in a streaming manner: "gec.event_type" */
  gec_event_type_stream: Array<Gec_Event_Type>;
  /** fetch data from the table: "gec.events" */
  gec_events: Array<Gec_Events>;
  /** fetch data from the table: "gec.events" using primary key columns */
  gec_events_by_pk?: Maybe<Gec_Events>;
  /** fetch data from the table in a streaming manner: "gec.events" */
  gec_events_stream: Array<Gec_Events>;
  /** fetch data from the table: "gec.firm_initiatives" */
  gec_firm_initiatives: Array<Gec_Firm_Initiatives>;
  /** fetch data from the table: "gec.firm_initiatives" using primary key columns */
  gec_firm_initiatives_by_pk?: Maybe<Gec_Firm_Initiatives>;
  /** fetch data from the table: "gec.firm_initiatives_in_event" */
  gec_firm_initiatives_in_event: Array<Gec_Firm_Initiatives_In_Event>;
  /** fetch data from the table: "gec.firm_initiatives_in_event" using primary key columns */
  gec_firm_initiatives_in_event_by_pk?: Maybe<Gec_Firm_Initiatives_In_Event>;
  /** fetch data from the table in a streaming manner: "gec.firm_initiatives_in_event" */
  gec_firm_initiatives_in_event_stream: Array<Gec_Firm_Initiatives_In_Event>;
  /** fetch data from the table in a streaming manner: "gec.firm_initiatives" */
  gec_firm_initiatives_stream: Array<Gec_Firm_Initiatives>;
  /** fetch data from the table: "gec.industries" */
  gec_industries: Array<Gec_Industries>;
  /** fetch data from the table: "gec.industries" using primary key columns */
  gec_industries_by_pk?: Maybe<Gec_Industries>;
  /** fetch data from the table: "gec.industries_in_event" */
  gec_industries_in_event: Array<Gec_Industries_In_Event>;
  /** fetch data from the table: "gec.industries_in_event" using primary key columns */
  gec_industries_in_event_by_pk?: Maybe<Gec_Industries_In_Event>;
  /** fetch data from the table in a streaming manner: "gec.industries_in_event" */
  gec_industries_in_event_stream: Array<Gec_Industries_In_Event>;
  /** fetch data from the table in a streaming manner: "gec.industries" */
  gec_industries_stream: Array<Gec_Industries>;
  /** fetch data from the table: "gec.office_visibility_in_event" */
  gec_office_visibility_in_event: Array<Gec_Office_Visibility_In_Event>;
  /** fetch data from the table: "gec.office_visibility_in_event" using primary key columns */
  gec_office_visibility_in_event_by_pk?: Maybe<Gec_Office_Visibility_In_Event>;
  /** fetch data from the table in a streaming manner: "gec.office_visibility_in_event" */
  gec_office_visibility_in_event_stream: Array<Gec_Office_Visibility_In_Event>;
  /** fetch data from the table: "gec.offices" */
  gec_offices: Array<Gec_Offices>;
  /** fetch data from the table: "gec.offices" using primary key columns */
  gec_offices_by_pk?: Maybe<Gec_Offices>;
  /** fetch data from the table: "gec.offices_in_event" */
  gec_offices_in_event: Array<Gec_Offices_In_Event>;
  /** fetch data from the table: "gec.offices_in_event" using primary key columns */
  gec_offices_in_event_by_pk?: Maybe<Gec_Offices_In_Event>;
  /** fetch data from the table in a streaming manner: "gec.offices_in_event" */
  gec_offices_in_event_stream: Array<Gec_Offices_In_Event>;
  /** fetch data from the table in a streaming manner: "gec.offices" */
  gec_offices_stream: Array<Gec_Offices>;
  /** fetch data from the table: "gec.outside_speakers" */
  gec_outside_speakers: Array<Gec_Outside_Speakers>;
  /** fetch data from the table: "gec.outside_speakers" using primary key columns */
  gec_outside_speakers_by_pk?: Maybe<Gec_Outside_Speakers>;
  /** fetch data from the table in a streaming manner: "gec.outside_speakers" */
  gec_outside_speakers_stream: Array<Gec_Outside_Speakers>;
  /** fetch data from the table: "gec.practice_groups_in_event" */
  gec_practice_groups_in_event: Array<Gec_Practice_Groups_In_Event>;
  /** fetch data from the table: "gec.practice_groups_in_event" using primary key columns */
  gec_practice_groups_in_event_by_pk?: Maybe<Gec_Practice_Groups_In_Event>;
  /** fetch data from the table in a streaming manner: "gec.practice_groups_in_event" */
  gec_practice_groups_in_event_stream: Array<Gec_Practice_Groups_In_Event>;
  /** fetch data from the table: "gec.practice_groups_rollup" */
  gec_practice_groups_rollup: Array<Gec_Practice_Groups_Rollup>;
  /** fetch data from the table: "gec.practice_groups_rollup" using primary key columns */
  gec_practice_groups_rollup_by_pk?: Maybe<Gec_Practice_Groups_Rollup>;
  /** fetch data from the table in a streaming manner: "gec.practice_groups_rollup" */
  gec_practice_groups_rollup_stream: Array<Gec_Practice_Groups_Rollup>;
  /** fetch data from the table: "gec.speaker_in_event" */
  gec_speaker_in_event: Array<Gec_Speaker_In_Event>;
  /** fetch data from the table: "gec.speaker_in_event" using primary key columns */
  gec_speaker_in_event_by_pk?: Maybe<Gec_Speaker_In_Event>;
  /** fetch data from the table in a streaming manner: "gec.speaker_in_event" */
  gec_speaker_in_event_stream: Array<Gec_Speaker_In_Event>;
  /** fetch data from the table: "gec.sponsoring_attorney_in_event" */
  gec_sponsoring_attorney_in_event: Array<Gec_Sponsoring_Attorney_In_Event>;
  /** fetch data from the table: "gec.sponsoring_attorney_in_event" using primary key columns */
  gec_sponsoring_attorney_in_event_by_pk?: Maybe<Gec_Sponsoring_Attorney_In_Event>;
  /** fetch data from the table in a streaming manner: "gec.sponsoring_attorney_in_event" */
  gec_sponsoring_attorney_in_event_stream: Array<Gec_Sponsoring_Attorney_In_Event>;
  gec_timezone_names: Array<Pg_Timezone_Names>;
  /** fetch data from the table: "repl.Groups" */
  mlfsl_ad_group: Array<Mlfsl_Ad_Group>;
  /** fetch aggregated fields from the table: "repl.Groups" */
  mlfsl_ad_group_aggregate: Mlfsl_Ad_Group_Aggregate;
  /** fetch data from the table: "repl.Groups" using primary key columns */
  mlfsl_ad_group_by_pk?: Maybe<Mlfsl_Ad_Group>;
  /** fetch data from the table: "repl.Joins" */
  mlfsl_ad_join: Array<Mlfsl_Ad_Join>;
  /** fetch aggregated fields from the table: "repl.Joins" */
  mlfsl_ad_join_aggregate: Mlfsl_Ad_Join_Aggregate;
  /** fetch data from the table: "repl.Joins" using primary key columns */
  mlfsl_ad_join_by_pk?: Maybe<Mlfsl_Ad_Join>;
  /** fetch data from the table: "repl.Logins" */
  mlfsl_ad_login: Array<Mlfsl_Ad_Login>;
  /** fetch aggregated fields from the table: "repl.Logins" */
  mlfsl_ad_login_aggregate: Mlfsl_Ad_Login_Aggregate;
  /** fetch data from the table: "repl.Logins" using primary key columns */
  mlfsl_ad_login_by_pk?: Maybe<Mlfsl_Ad_Login>;
  /** fetch data from the table: "repl.DimClientNow" */
  mlfsl_client: Array<Mlfsl_Client>;
  /** fetch aggregated fields from the table: "repl.DimClientNow" */
  mlfsl_client_aggregate: Mlfsl_Client_Aggregate;
  /** fetch data from the table: "repl.DimClientNow" using primary key columns */
  mlfsl_client_by_pk?: Maybe<Mlfsl_Client>;
  /** fetch data from the table: "MLG.Client_DisplayDescription" */
  mlfsl_client_display_description: Array<Mlfsl_Client_Display_Description>;
  /** fetch data from the table: "repl.DimDate" */
  mlfsl_date: Array<Mlfsl_Date>;
  /** fetch aggregated fields from the table: "repl.DimDate" */
  mlfsl_date_aggregate: Mlfsl_Date_Aggregate;
  /** fetch data from the table: "repl.DimDate" using primary key columns */
  mlfsl_date_by_pk?: Maybe<Mlfsl_Date>;
  /** fetch data from the table: "MNET.Finance_Hours_Client" */
  mlfsl_finance_hours_client: Array<Mlfsl_Finance_Hours_Client>;
  /** fetch aggregated fields from the table: "MNET.Finance_Hours_Client" */
  mlfsl_finance_hours_client_aggregate: Mlfsl_Finance_Hours_Client_Aggregate;
  /** fetch data from the table: "MNET.Finance_Hours_Client" using primary key columns */
  mlfsl_finance_hours_client_by_pk?: Maybe<Mlfsl_Finance_Hours_Client>;
  /** fetch data from the table: "MNET.Finance_Hours_ClientOfficeTimeframe" */
  mlfsl_finance_hours_clientofficetimeframe: Array<Mlfsl_Finance_Hours_Clientofficetimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_ClientOfficeTimeframe" using primary key columns */
  mlfsl_finance_hours_clientofficetimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Clientofficetimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_ClientPGTimeframe" */
  mlfsl_finance_hours_clientpgtimeframe: Array<Mlfsl_Finance_Hours_Clientpgtimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_ClientPGTimeframe" using primary key columns */
  mlfsl_finance_hours_clientpgtimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Clientpgtimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_ClientTimeframe" */
  mlfsl_finance_hours_clienttimeframe: Array<Mlfsl_Finance_Hours_Clienttimeframe>;
  /** fetch aggregated fields from the table: "MNET.Finance_Hours_ClientTimeframe" */
  mlfsl_finance_hours_clienttimeframe_aggregate: Mlfsl_Finance_Hours_Clienttimeframe_Aggregate;
  /** fetch data from the table: "MNET.Finance_Hours_ClientTimeframe" using primary key columns */
  mlfsl_finance_hours_clienttimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Clienttimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
  mlfsl_finance_hours_clienttimekeepertimeframe: Array<Mlfsl_Finance_Hours_Clienttimekeepertimeframe>;
  /** fetch aggregated fields from the table: "MNET.Finance_Hours_ClientTimekeeperTimeframe" */
  mlfsl_finance_hours_clienttimekeepertimeframe_aggregate: Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Aggregate;
  /** fetch data from the table: "MNET.Finance_Hours_ClientTimekeeperTimeframe" using primary key columns */
  mlfsl_finance_hours_clienttimekeepertimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_Matter" */
  mlfsl_finance_hours_matter: Array<Mlfsl_Finance_Hours_Matter>;
  /** fetch aggregated fields from the table: "MNET.Finance_Hours_Matter" */
  mlfsl_finance_hours_matter_aggregate: Mlfsl_Finance_Hours_Matter_Aggregate;
  /** fetch data from the table: "MNET.Finance_Hours_Matter" using primary key columns */
  mlfsl_finance_hours_matter_by_pk?: Maybe<Mlfsl_Finance_Hours_Matter>;
  /** fetch data from the table: "MNET.Finance_Hours_MatterOfficeTimeframe" */
  mlfsl_finance_hours_matterofficetimeframe: Array<Mlfsl_Finance_Hours_Matterofficetimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_MatterOfficeTimeframe" using primary key columns */
  mlfsl_finance_hours_matterofficetimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Matterofficetimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_MatterPGTimeframe" */
  mlfsl_finance_hours_matterpgtimeframe: Array<Mlfsl_Finance_Hours_Matterpgtimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_MatterPGTimeframe" using primary key columns */
  mlfsl_finance_hours_matterpgtimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Matterpgtimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_MatterTimeframe" */
  mlfsl_finance_hours_mattertimeframe: Array<Mlfsl_Finance_Hours_Mattertimeframe>;
  /** fetch aggregated fields from the table: "MNET.Finance_Hours_MatterTimeframe" */
  mlfsl_finance_hours_mattertimeframe_aggregate: Mlfsl_Finance_Hours_Mattertimeframe_Aggregate;
  /** fetch data from the table: "MNET.Finance_Hours_MatterTimeframe" using primary key columns */
  mlfsl_finance_hours_mattertimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Mattertimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_MatterTimeframeCompare" */
  mlfsl_finance_hours_mattertimeframecompare: Array<Mlfsl_Finance_Hours_Mattertimeframecompare>;
  /** fetch data from the table: "MNET.Finance_Hours_MatterTimeframeCompare" using primary key columns */
  mlfsl_finance_hours_mattertimeframecompare_by_pk?: Maybe<Mlfsl_Finance_Hours_Mattertimeframecompare>;
  /** An array relationship */
  mlfsl_finance_hours_mattertimekeepertimeframe: Array<Mlfsl_Finance_Hours_Mattertimekeepertimeframe>;
  /** An aggregate relationship */
  mlfsl_finance_hours_mattertimekeepertimeframe_aggregate: Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Aggregate;
  /** fetch data from the table: "MNET.Finance_Hours_MatterTimekeeperTimeframe" using primary key columns */
  mlfsl_finance_hours_mattertimekeepertimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_RelatedClient" */
  mlfsl_finance_hours_relatedclient: Array<Mlfsl_Finance_Hours_Relatedclient>;
  /** fetch data from the table: "MNET.Finance_Hours_RelatedClient" using primary key columns */
  mlfsl_finance_hours_relatedclient_by_pk?: Maybe<Mlfsl_Finance_Hours_Relatedclient>;
  /** fetch data from the table: "MNET.Finance_Hours_RelatedClientOfficeTimeframe" */
  mlfsl_finance_hours_relatedclientofficetimeframe: Array<Mlfsl_Finance_Hours_Relatedclientofficetimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_RelatedClientOfficeTimeframe" using primary key columns */
  mlfsl_finance_hours_relatedclientofficetimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Relatedclientofficetimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_RelatedClientPGTimeframe" */
  mlfsl_finance_hours_relatedclientpgtimeframe: Array<Mlfsl_Finance_Hours_Relatedclientpgtimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_RelatedClientPGTimeframe" using primary key columns */
  mlfsl_finance_hours_relatedclientpgtimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Relatedclientpgtimeframe>;
  /** An array relationship */
  mlfsl_finance_hours_relatedclienttimeframe: Array<Mlfsl_Finance_Hours_Relatedclienttimeframe>;
  /** An aggregate relationship */
  mlfsl_finance_hours_relatedclienttimeframe_aggregate: Mlfsl_Finance_Hours_Relatedclienttimeframe_Aggregate;
  /** fetch data from the table: "MNET.Finance_Hours_RelatedClientTimeframe" using primary key columns */
  mlfsl_finance_hours_relatedclienttimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimeframe>;
  /** fetch data from the table: "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
  mlfsl_finance_hours_relatedclienttimekeepertimeframe: Array<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe>;
  /** fetch aggregated fields from the table: "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" */
  mlfsl_finance_hours_relatedclienttimekeepertimeframe_aggregate: Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Aggregate;
  /** fetch data from the table: "MNET.Finance_Hours_RelatedClientTimekeeperTimeframe" using primary key columns */
  mlfsl_finance_hours_relatedclienttimekeepertimeframe_by_pk?: Maybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe>;
  /** fetch data from the table: "repl.DimMatterNow" */
  mlfsl_matter: Array<Mlfsl_Matter>;
  /** fetch aggregated fields from the table: "repl.DimMatterNow" */
  mlfsl_matter_aggregate: Mlfsl_Matter_Aggregate;
  /** fetch data from the table: "repl.DimMatterNow" using primary key columns */
  mlfsl_matter_by_pk?: Maybe<Mlfsl_Matter>;
  /** fetch data from the table: "MLG.Matter_DisplayDescription" */
  mlfsl_matter_display_description: Array<Mlfsl_Matter_Display_Description>;
  /** fetch data from the table: "MNET.mlv_Finance_Hours_Timeframes" */
  mlfsl_mlv_Finance_Hours_Timeframes: Array<Mlfsl_Mlv_Finance_Hours_Timeframes>;
  /** fetch data from the table: "MNET.mlv_Finance_Hours_Client" */
  mlfsl_mlv_finance_hours_client: Array<Mlfsl_Mlv_Finance_Hours_Client>;
  /** fetch data from the table: "MNET.mlv_Finance_Hours_Matter" */
  mlfsl_mlv_finance_hours_matter: Array<Mlfsl_Mlv_Finance_Hours_Matter>;
  /** fetch data from the table: "MNET.mlv_Finance_Hours_RelatedClient" */
  mlfsl_mlv_finance_hours_relatedclient: Array<Mlfsl_Mlv_Finance_Hours_Relatedclient>;
  /** fetch data from the table: "repl.MorganNetClientPage_ClientInfo" */
  mlfsl_morgannet_clientPage_clientInfo: Array<Mlfsl_Morgannet_ClientPage_ClientInfo>;
  /** fetch aggregated fields from the table: "repl.MorganNetClientPage_ClientInfo" */
  mlfsl_morgannet_clientPage_clientInfo_aggregate: Mlfsl_Morgannet_ClientPage_ClientInfo_Aggregate;
  /** fetch data from the table: "repl.MorganNetClientPage_ClientInfo" using primary key columns */
  mlfsl_morgannet_clientPage_clientInfo_by_pk?: Maybe<Mlfsl_Morgannet_ClientPage_ClientInfo>;
  /** fetch data from the table: "repl.DimOfficeNow" */
  mlfsl_office: Array<Mlfsl_Office>;
  /** fetch aggregated fields from the table: "repl.DimOfficeNow" */
  mlfsl_office_aggregate: Mlfsl_Office_Aggregate;
  /** fetch data from the table: "repl.DimOfficeNow" using primary key columns */
  mlfsl_office_by_pk?: Maybe<Mlfsl_Office>;
  /** fetch data from the table: "repl.DimPersonnelEducation" */
  mlfsl_person_education: Array<Mlfsl_Person_Education>;
  /** fetch aggregated fields from the table: "repl.DimPersonnelEducation" */
  mlfsl_person_education_aggregate: Mlfsl_Person_Education_Aggregate;
  /** fetch data from the table: "repl.DimPersonnelEducation" using primary key columns */
  mlfsl_person_education_by_pk?: Maybe<Mlfsl_Person_Education>;
  /** fetch data from the table: "MNET.Personas" */
  mlfsl_persona: Array<Mlfsl_Persona>;
  /** fetch aggregated fields from the table: "MNET.Personas" */
  mlfsl_persona_aggregate: Mlfsl_Persona_Aggregate;
  /** fetch data from the table: "MNET.Personas" using primary key columns */
  mlfsl_persona_by_pk?: Maybe<Mlfsl_Persona>;
  /** fetch data from the table: "MNET.PersonaGroup" */
  mlfsl_persona_groups: Array<Mlfsl_Persona_Groups>;
  /** fetch aggregated fields from the table: "MNET.PersonaGroup" */
  mlfsl_persona_groups_aggregate: Mlfsl_Persona_Groups_Aggregate;
  /** fetch data from the table: "MNET.PersonaGroup" using primary key columns */
  mlfsl_persona_groups_by_pk?: Maybe<Mlfsl_Persona_Groups>;
  /** fetch data from the table: "repl.DimPersonnelNow" */
  mlfsl_personnel: Array<Mlfsl_Personnel>;
  /** fetch aggregated fields from the table: "repl.DimPersonnelNow" */
  mlfsl_personnel_aggregate: Mlfsl_Personnel_Aggregate;
  /** An array relationship */
  mlfsl_personnel_bar: Array<Mlfsl_Personnel_Bar>;
  /** fetch data from the table: "repl.DimPersonnelBar" using primary key columns */
  mlfsl_personnel_bar_by_pk?: Maybe<Mlfsl_Personnel_Bar>;
  /** fetch data from the table: "repl.DimPersonnelNow" using primary key columns */
  mlfsl_personnel_by_pk?: Maybe<Mlfsl_Personnel>;
  /** An array relationship */
  mlfsl_personnel_clerkship: Array<Mlfsl_Personnel_Clerkship>;
  /** fetch data from the table: "repl.DimPersonnelClerkship" using primary key columns */
  mlfsl_personnel_clerkship_by_pk?: Maybe<Mlfsl_Personnel_Clerkship>;
  /** An array relationship */
  mlfsl_personnel_committee: Array<Mlfsl_Personnel_Committee>;
  /** fetch data from the table: "repl.DimPersonnelCommittee" using primary key columns */
  mlfsl_personnel_committee_by_pk?: Maybe<Mlfsl_Personnel_Committee>;
  /** An array relationship */
  mlfsl_personnel_court: Array<Mlfsl_Personnel_Court>;
  /** fetch data from the table: "repl.DimPersonnelCourt" using primary key columns */
  mlfsl_personnel_court_by_pk?: Maybe<Mlfsl_Personnel_Court>;
  /** An array relationship */
  mlfsl_personnel_language: Array<Mlfsl_Personnel_Language>;
  /** fetch data from the table: "repl.DimPersonnelLanguage" using primary key columns */
  mlfsl_personnel_language_by_pk?: Maybe<Mlfsl_Personnel_Language>;
  /** fetch data from the table: "repl.DimPracticeGroupNow" */
  mlfsl_practicegroup: Array<Mlfsl_Practicegroup>;
  /** fetch aggregated fields from the table: "repl.DimPracticeGroupNow" */
  mlfsl_practicegroup_aggregate: Mlfsl_Practicegroup_Aggregate;
  /** fetch data from the table: "repl.DimPracticeGroupNow" using primary key columns */
  mlfsl_practicegroup_by_pk?: Maybe<Mlfsl_Practicegroup>;
  /** fetch data from the table: "Finance.ProbonoGoalExport" */
  mlfsl_probono_goal: Array<Mlfsl_Probono_Goal>;
  /** fetch data from the table: "MLG.RelatedClient" */
  mlfsl_related_client: Array<Mlfsl_Related_Client>;
  /** fetch data from the table: "MLG.RelatedClient" using primary key columns */
  mlfsl_related_client_by_pk?: Maybe<Mlfsl_Related_Client>;
  /** fetch data from the table: "mnet.ad_group_link" */
  mnet_ad_group_link: Array<Mnet_Ad_Group_Link>;
  /** fetch data from the table: "mnet.ad_group_link" using primary key columns */
  mnet_ad_group_link_by_pk?: Maybe<Mnet_Ad_Group_Link>;
  /** fetch data from the table in a streaming manner: "mnet.ad_group_link" */
  mnet_ad_group_link_stream: Array<Mnet_Ad_Group_Link>;
  /** fetch data from the table: "mnet_assignmentportal.my_availability" */
  mnet_assignmentportal_my_availability: Array<Mnet_Assignmentportal_My_Availability>;
  /** fetch data from the table: "mnet_assignmentportal.my_availability" using primary key columns */
  mnet_assignmentportal_my_availability_by_pk?: Maybe<Mnet_Assignmentportal_My_Availability>;
  /** fetch data from the table in a streaming manner: "mnet_assignmentportal.my_availability" */
  mnet_assignmentportal_my_availability_stream: Array<Mnet_Assignmentportal_My_Availability>;
  /** fetch data from the table: "mnet_blog.attachments" */
  mnet_blog_attachments: Array<Mnet_Blog_Attachments>;
  /** fetch data from the table: "mnet_blog.attachments" using primary key columns */
  mnet_blog_attachments_by_pk?: Maybe<Mnet_Blog_Attachments>;
  /** fetch data from the table in a streaming manner: "mnet_blog.attachments" */
  mnet_blog_attachments_stream: Array<Mnet_Blog_Attachments>;
  /** fetch data from the table: "mnet_blog.blogs" */
  mnet_blog_blogs: Array<Mnet_Blog_Blogs>;
  /** fetch data from the table: "mnet_blog.blogs" using primary key columns */
  mnet_blog_blogs_by_pk?: Maybe<Mnet_Blog_Blogs>;
  /** fetch data from the table in a streaming manner: "mnet_blog.blogs" */
  mnet_blog_blogs_stream: Array<Mnet_Blog_Blogs>;
  /** fetch data from the table: "mnet_blog.channel_notifications" */
  mnet_blog_channel_notifications: Array<Mnet_Blog_Channel_Notifications>;
  /** fetch data from the table: "mnet_blog.channel_notifications" using primary key columns */
  mnet_blog_channel_notifications_by_pk?: Maybe<Mnet_Blog_Channel_Notifications>;
  /** fetch data from the table in a streaming manner: "mnet_blog.channel_notifications" */
  mnet_blog_channel_notifications_stream: Array<Mnet_Blog_Channel_Notifications>;
  /** fetch data from the table: "mnet_blog.channels" */
  mnet_blog_channels: Array<Mnet_Blog_Channels>;
  /** fetch data from the table: "mnet_blog.channels" using primary key columns */
  mnet_blog_channels_by_pk?: Maybe<Mnet_Blog_Channels>;
  /** fetch data from the table in a streaming manner: "mnet_blog.channels" */
  mnet_blog_channels_stream: Array<Mnet_Blog_Channels>;
  /** fetch data from the table: "mnet_blog.comment_reactions" */
  mnet_blog_comment_reactions: Array<Mnet_Blog_Comment_Reactions>;
  /** fetch data from the table: "mnet_blog.comment_reactions" using primary key columns */
  mnet_blog_comment_reactions_by_pk?: Maybe<Mnet_Blog_Comment_Reactions>;
  /** fetch data from the table in a streaming manner: "mnet_blog.comment_reactions" */
  mnet_blog_comment_reactions_stream: Array<Mnet_Blog_Comment_Reactions>;
  /** fetch data from the table: "mnet_blog.comments" */
  mnet_blog_comments: Array<Mnet_Blog_Comments>;
  /** fetch data from the table: "mnet_blog.comments" using primary key columns */
  mnet_blog_comments_by_pk?: Maybe<Mnet_Blog_Comments>;
  /** fetch data from the table in a streaming manner: "mnet_blog.comments" */
  mnet_blog_comments_stream: Array<Mnet_Blog_Comments>;
  /** fetch data from the table: "mnet_blog.email_notifications" */
  mnet_blog_email_notifications: Array<Mnet_Blog_Email_Notifications>;
  /** fetch data from the table: "mnet_blog.email_notifications" using primary key columns */
  mnet_blog_email_notifications_by_pk?: Maybe<Mnet_Blog_Email_Notifications>;
  /** fetch data from the table in a streaming manner: "mnet_blog.email_notifications" */
  mnet_blog_email_notifications_stream: Array<Mnet_Blog_Email_Notifications>;
  /** fetch data from the table: "mnet_blog.email_templates" */
  mnet_blog_email_templates: Array<Mnet_Blog_Email_Templates>;
  /** fetch data from the table: "mnet_blog.email_templates" using primary key columns */
  mnet_blog_email_templates_by_pk?: Maybe<Mnet_Blog_Email_Templates>;
  /** fetch data from the table in a streaming manner: "mnet_blog.email_templates" */
  mnet_blog_email_templates_stream: Array<Mnet_Blog_Email_Templates>;
  /** fetch data from the table: "mnet_blog.events" */
  mnet_blog_events: Array<Mnet_Blog_Events>;
  /** fetch data from the table: "mnet_blog.events" using primary key columns */
  mnet_blog_events_by_pk?: Maybe<Mnet_Blog_Events>;
  /** fetch data from the table in a streaming manner: "mnet_blog.events" */
  mnet_blog_events_stream: Array<Mnet_Blog_Events>;
  /** fetch data from the table: "mnet_blog.group_in_blogs" */
  mnet_blog_group_in_blogs: Array<Mnet_Blog_Group_In_Blogs>;
  /** fetch data from the table: "mnet_blog.group_in_blogs" using primary key columns */
  mnet_blog_group_in_blogs_by_pk?: Maybe<Mnet_Blog_Group_In_Blogs>;
  /** fetch data from the table in a streaming manner: "mnet_blog.group_in_blogs" */
  mnet_blog_group_in_blogs_stream: Array<Mnet_Blog_Group_In_Blogs>;
  /** fetch data from the table: "mnet_blog.inbound_emails" */
  mnet_blog_inbound_emails: Array<Mnet_Blog_Inbound_Emails>;
  /** fetch data from the table: "mnet_blog.inbound_emails" using primary key columns */
  mnet_blog_inbound_emails_by_pk?: Maybe<Mnet_Blog_Inbound_Emails>;
  /** fetch data from the table in a streaming manner: "mnet_blog.inbound_emails" */
  mnet_blog_inbound_emails_stream: Array<Mnet_Blog_Inbound_Emails>;
  /** fetch data from the table: "mnet_blog.notification_recipients" */
  mnet_blog_notification_recipients: Array<Mnet_Blog_Notification_Recipients>;
  /** fetch data from the table: "mnet_blog.notification_recipients" using primary key columns */
  mnet_blog_notification_recipients_by_pk?: Maybe<Mnet_Blog_Notification_Recipients>;
  /** fetch data from the table in a streaming manner: "mnet_blog.notification_recipients" */
  mnet_blog_notification_recipients_stream: Array<Mnet_Blog_Notification_Recipients>;
  /** fetch data from the table: "mnet_blog.notification_template_rules" */
  mnet_blog_notification_template_rules: Array<Mnet_Blog_Notification_Template_Rules>;
  /** fetch data from the table: "mnet_blog.notification_template_rules" using primary key columns */
  mnet_blog_notification_template_rules_by_pk?: Maybe<Mnet_Blog_Notification_Template_Rules>;
  /** fetch data from the table in a streaming manner: "mnet_blog.notification_template_rules" */
  mnet_blog_notification_template_rules_stream: Array<Mnet_Blog_Notification_Template_Rules>;
  /** fetch data from the table: "mnet_blog.post_channels" */
  mnet_blog_post_channels: Array<Mnet_Blog_Post_Channels>;
  /** fetch data from the table: "mnet_blog.post_channels" using primary key columns */
  mnet_blog_post_channels_by_pk?: Maybe<Mnet_Blog_Post_Channels>;
  /** fetch data from the table in a streaming manner: "mnet_blog.post_channels" */
  mnet_blog_post_channels_stream: Array<Mnet_Blog_Post_Channels>;
  /** fetch data from the table: "mnet_blog.post_images" */
  mnet_blog_post_images: Array<Mnet_Blog_Post_Images>;
  /** fetch data from the table: "mnet_blog.post_images" using primary key columns */
  mnet_blog_post_images_by_pk?: Maybe<Mnet_Blog_Post_Images>;
  /** fetch data from the table in a streaming manner: "mnet_blog.post_images" */
  mnet_blog_post_images_stream: Array<Mnet_Blog_Post_Images>;
  /** fetch data from the table: "mnet_blog.post_reactions" */
  mnet_blog_post_reactions: Array<Mnet_Blog_Post_Reactions>;
  /** fetch data from the table: "mnet_blog.post_reactions" using primary key columns */
  mnet_blog_post_reactions_by_pk?: Maybe<Mnet_Blog_Post_Reactions>;
  /** fetch data from the table in a streaming manner: "mnet_blog.post_reactions" */
  mnet_blog_post_reactions_stream: Array<Mnet_Blog_Post_Reactions>;
  /** fetch data from the table: "mnet_blog.posts" */
  mnet_blog_posts: Array<Mnet_Blog_Posts>;
  /** fetch aggregated fields from the table: "mnet_blog.posts" */
  mnet_blog_posts_aggregate: Mnet_Blog_Posts_Aggregate;
  /** fetch data from the table: "mnet_blog.posts" using primary key columns */
  mnet_blog_posts_by_pk?: Maybe<Mnet_Blog_Posts>;
  /** fetch data from the table in a streaming manner: "mnet_blog.posts" */
  mnet_blog_posts_stream: Array<Mnet_Blog_Posts>;
  /** fetch data from the table: "mnet.business_chemistry_type" */
  mnet_business_chemistry_type: Array<Mnet_Business_Chemistry_Type>;
  /** fetch aggregated fields from the table: "mnet.business_chemistry_type" */
  mnet_business_chemistry_type_aggregate: Mnet_Business_Chemistry_Type_Aggregate;
  /** fetch data from the table: "mnet.business_chemistry_type" using primary key columns */
  mnet_business_chemistry_type_by_pk?: Maybe<Mnet_Business_Chemistry_Type>;
  /** fetch data from the table in a streaming manner: "mnet.business_chemistry_type" */
  mnet_business_chemistry_type_stream: Array<Mnet_Business_Chemistry_Type>;
  /** fetch data from the table: "mnet.client_intel_settings" */
  mnet_client_intel_settings: Array<Mnet_Client_Intel_Settings>;
  /** fetch aggregated fields from the table: "mnet.client_intel_settings" */
  mnet_client_intel_settings_aggregate: Mnet_Client_Intel_Settings_Aggregate;
  /** fetch data from the table: "mnet.client_intel_settings" using primary key columns */
  mnet_client_intel_settings_by_pk?: Maybe<Mnet_Client_Intel_Settings>;
  /** fetch data from the table in a streaming manner: "mnet.client_intel_settings" */
  mnet_client_intel_settings_stream: Array<Mnet_Client_Intel_Settings>;
  /** fetch data from the table: "mnet.client_manzama_alert_summary_counts" */
  mnet_client_manzama_alert_summary_counts: Array<Mnet_Client_Manzama_Alert_Summary_Counts>;
  /** fetch aggregated fields from the table: "mnet.client_manzama_alert_summary_counts" */
  mnet_client_manzama_alert_summary_counts_aggregate: Mnet_Client_Manzama_Alert_Summary_Counts_Aggregate;
  /** fetch data from the table: "mnet.client_manzama_alert_summary_counts" using primary key columns */
  mnet_client_manzama_alert_summary_counts_by_pk?: Maybe<Mnet_Client_Manzama_Alert_Summary_Counts>;
  /** fetch data from the table in a streaming manner: "mnet.client_manzama_alert_summary_counts" */
  mnet_client_manzama_alert_summary_counts_stream: Array<Mnet_Client_Manzama_Alert_Summary_Counts>;
  /** fetch data from the table: "mnet.client_manzama_article" */
  mnet_client_manzama_article: Array<Mnet_Client_Manzama_Article>;
  /** fetch aggregated fields from the table: "mnet.client_manzama_article" */
  mnet_client_manzama_article_aggregate: Mnet_Client_Manzama_Article_Aggregate;
  /** fetch data from the table: "mnet.client_manzama_article" using primary key columns */
  mnet_client_manzama_article_by_pk?: Maybe<Mnet_Client_Manzama_Article>;
  /** fetch data from the table: "mnet.client_manzama_article_category" */
  mnet_client_manzama_article_category: Array<Mnet_Client_Manzama_Article_Category>;
  /** fetch aggregated fields from the table: "mnet.client_manzama_article_category" */
  mnet_client_manzama_article_category_aggregate: Mnet_Client_Manzama_Article_Category_Aggregate;
  /** fetch data from the table: "mnet.client_manzama_article_category" using primary key columns */
  mnet_client_manzama_article_category_by_pk?: Maybe<Mnet_Client_Manzama_Article_Category>;
  /** fetch data from the table in a streaming manner: "mnet.client_manzama_article_category" */
  mnet_client_manzama_article_category_stream: Array<Mnet_Client_Manzama_Article_Category>;
  /** fetch data from the table in a streaming manner: "mnet.client_manzama_article" */
  mnet_client_manzama_article_stream: Array<Mnet_Client_Manzama_Article>;
  /** fetch data from the table: "mnet.client_manzama_http_response" */
  mnet_client_manzama_http_response: Array<Mnet_Client_Manzama_Http_Response>;
  /** fetch aggregated fields from the table: "mnet.client_manzama_http_response" */
  mnet_client_manzama_http_response_aggregate: Mnet_Client_Manzama_Http_Response_Aggregate;
  /** fetch data from the table: "mnet.client_manzama_http_response" using primary key columns */
  mnet_client_manzama_http_response_by_pk?: Maybe<Mnet_Client_Manzama_Http_Response>;
  /** fetch data from the table in a streaming manner: "mnet.client_manzama_http_response" */
  mnet_client_manzama_http_response_stream: Array<Mnet_Client_Manzama_Http_Response>;
  /** fetch data from the table: "mnet.clientbadge_badge" */
  mnet_clientbadge_badge: Array<Mnet_Clientbadge_Badge>;
  /** fetch aggregated fields from the table: "mnet.clientbadge_badge" */
  mnet_clientbadge_badge_aggregate: Mnet_Clientbadge_Badge_Aggregate;
  /** fetch data from the table: "mnet.clientbadge_badge" using primary key columns */
  mnet_clientbadge_badge_by_pk?: Maybe<Mnet_Clientbadge_Badge>;
  /** fetch data from the table: "mnet.clientbadge_badge_category" */
  mnet_clientbadge_badge_category: Array<Mnet_Clientbadge_Badge_Category>;
  /** fetch aggregated fields from the table: "mnet.clientbadge_badge_category" */
  mnet_clientbadge_badge_category_aggregate: Mnet_Clientbadge_Badge_Category_Aggregate;
  /** fetch data from the table: "mnet.clientbadge_badge_category" using primary key columns */
  mnet_clientbadge_badge_category_by_pk?: Maybe<Mnet_Clientbadge_Badge_Category>;
  /** fetch data from the table in a streaming manner: "mnet.clientbadge_badge_category" */
  mnet_clientbadge_badge_category_stream: Array<Mnet_Clientbadge_Badge_Category>;
  /** fetch data from the table in a streaming manner: "mnet.clientbadge_badge" */
  mnet_clientbadge_badge_stream: Array<Mnet_Clientbadge_Badge>;
  /** fetch data from the table: "mnet.clientbadge_client" */
  mnet_clientbadge_client: Array<Mnet_Clientbadge_Client>;
  /** fetch aggregated fields from the table: "mnet.clientbadge_client" */
  mnet_clientbadge_client_aggregate: Mnet_Clientbadge_Client_Aggregate;
  /** fetch data from the table: "mnet.clientbadge_client" using primary key columns */
  mnet_clientbadge_client_by_pk?: Maybe<Mnet_Clientbadge_Client>;
  /** fetch data from the table: "mnet.clientbadge_client_exclusion" */
  mnet_clientbadge_client_exclusion: Array<Mnet_Clientbadge_Client_Exclusion>;
  /** fetch aggregated fields from the table: "mnet.clientbadge_client_exclusion" */
  mnet_clientbadge_client_exclusion_aggregate: Mnet_Clientbadge_Client_Exclusion_Aggregate;
  /** fetch data from the table: "mnet.clientbadge_client_exclusion" using primary key columns */
  mnet_clientbadge_client_exclusion_by_pk?: Maybe<Mnet_Clientbadge_Client_Exclusion>;
  /** fetch data from the table in a streaming manner: "mnet.clientbadge_client_exclusion" */
  mnet_clientbadge_client_exclusion_stream: Array<Mnet_Clientbadge_Client_Exclusion>;
  /** fetch data from the table in a streaming manner: "mnet.clientbadge_client" */
  mnet_clientbadge_client_stream: Array<Mnet_Clientbadge_Client>;
  /** fetch data from the table: "mnet.clientbadge_related_client" */
  mnet_clientbadge_related_client: Array<Mnet_Clientbadge_Related_Client>;
  /** fetch aggregated fields from the table: "mnet.clientbadge_related_client" */
  mnet_clientbadge_related_client_aggregate: Mnet_Clientbadge_Related_Client_Aggregate;
  /** fetch data from the table: "mnet.clientbadge_related_client" using primary key columns */
  mnet_clientbadge_related_client_by_pk?: Maybe<Mnet_Clientbadge_Related_Client>;
  /** fetch data from the table in a streaming manner: "mnet.clientbadge_related_client" */
  mnet_clientbadge_related_client_stream: Array<Mnet_Clientbadge_Related_Client>;
  /** fetch data from the table: "mnet.foundation_matter" */
  mnet_foundation_matter: Array<Mnet_Foundation_Matter>;
  /** fetch aggregated fields from the table: "mnet.foundation_matter" */
  mnet_foundation_matter_aggregate: Mnet_Foundation_Matter_Aggregate;
  /** fetch data from the table: "mnet.foundation_matter" using primary key columns */
  mnet_foundation_matter_by_pk?: Maybe<Mnet_Foundation_Matter>;
  /** fetch data from the table in a streaming manner: "mnet.foundation_matter" */
  mnet_foundation_matter_stream: Array<Mnet_Foundation_Matter>;
  /** fetch data from the table: "mnet.mytools_catalog_category" */
  mnet_mytools_catalog_category: Array<Mnet_Mytools_Catalog_Category>;
  /** fetch aggregated fields from the table: "mnet.mytools_catalog_category" */
  mnet_mytools_catalog_category_aggregate: Mnet_Mytools_Catalog_Category_Aggregate;
  /** fetch data from the table: "mnet.mytools_catalog_category" using primary key columns */
  mnet_mytools_catalog_category_by_pk?: Maybe<Mnet_Mytools_Catalog_Category>;
  /** fetch data from the table in a streaming manner: "mnet.mytools_catalog_category" */
  mnet_mytools_catalog_category_stream: Array<Mnet_Mytools_Catalog_Category>;
  /** fetch data from the table: "mnet.mytools_catalog_tool" */
  mnet_mytools_catalog_tool: Array<Mnet_Mytools_Catalog_Tool>;
  /** fetch aggregated fields from the table: "mnet.mytools_catalog_tool" */
  mnet_mytools_catalog_tool_aggregate: Mnet_Mytools_Catalog_Tool_Aggregate;
  /** fetch data from the table: "mnet.mytools_catalog_tool_assignment" */
  mnet_mytools_catalog_tool_assignment: Array<Mnet_Mytools_Catalog_Tool_Assignment>;
  /** fetch aggregated fields from the table: "mnet.mytools_catalog_tool_assignment" */
  mnet_mytools_catalog_tool_assignment_aggregate: Mnet_Mytools_Catalog_Tool_Assignment_Aggregate;
  /** fetch data from the table: "mnet.mytools_catalog_tool_assignment" using primary key columns */
  mnet_mytools_catalog_tool_assignment_by_pk?: Maybe<Mnet_Mytools_Catalog_Tool_Assignment>;
  /** fetch data from the table in a streaming manner: "mnet.mytools_catalog_tool_assignment" */
  mnet_mytools_catalog_tool_assignment_stream: Array<Mnet_Mytools_Catalog_Tool_Assignment>;
  /** fetch data from the table: "mnet.mytools_catalog_tool" using primary key columns */
  mnet_mytools_catalog_tool_by_pk?: Maybe<Mnet_Mytools_Catalog_Tool>;
  /** fetch data from the table in a streaming manner: "mnet.mytools_catalog_tool" */
  mnet_mytools_catalog_tool_stream: Array<Mnet_Mytools_Catalog_Tool>;
  /** fetch data from the table: "mnet.mytools_user_tool" */
  mnet_mytools_user_tool: Array<Mnet_Mytools_User_Tool>;
  /** fetch aggregated fields from the table: "mnet.mytools_user_tool" */
  mnet_mytools_user_tool_aggregate: Mnet_Mytools_User_Tool_Aggregate;
  /** fetch data from the table: "mnet.mytools_user_tool" using primary key columns */
  mnet_mytools_user_tool_by_pk?: Maybe<Mnet_Mytools_User_Tool>;
  /** fetch data from the table in a streaming manner: "mnet.mytools_user_tool" */
  mnet_mytools_user_tool_stream: Array<Mnet_Mytools_User_Tool>;
  /** fetch data from the table: "mnet.office_detail" */
  mnet_office_detail: Array<Mnet_Office_Detail>;
  /** fetch aggregated fields from the table: "mnet.office_detail" */
  mnet_office_detail_aggregate: Mnet_Office_Detail_Aggregate;
  /** fetch data from the table: "mnet.office_detail" using primary key columns */
  mnet_office_detail_by_pk?: Maybe<Mnet_Office_Detail>;
  /** fetch data from the table in a streaming manner: "mnet.office_detail" */
  mnet_office_detail_stream: Array<Mnet_Office_Detail>;
  /** fetch data from the table: "mnet.person_business_chemistry_profile" */
  mnet_person_business_chemistry_profile: Array<Mnet_Person_Business_Chemistry_Profile>;
  /** fetch aggregated fields from the table: "mnet.person_business_chemistry_profile" */
  mnet_person_business_chemistry_profile_aggregate: Mnet_Person_Business_Chemistry_Profile_Aggregate;
  /** fetch data from the table: "mnet.person_business_chemistry_profile" using primary key columns */
  mnet_person_business_chemistry_profile_by_pk?: Maybe<Mnet_Person_Business_Chemistry_Profile>;
  /** fetch data from the table in a streaming manner: "mnet.person_business_chemistry_profile" */
  mnet_person_business_chemistry_profile_stream: Array<Mnet_Person_Business_Chemistry_Profile>;
  /** fetch data from the table: "mnet.personnel_profile_badges" */
  mnet_personnel_profile_badges: Array<Mnet_Personnel_Profile_Badges>;
  /** fetch aggregated fields from the table: "mnet.personnel_profile_badges" */
  mnet_personnel_profile_badges_aggregate: Mnet_Personnel_Profile_Badges_Aggregate;
  /** fetch data from the table: "mnet.personnel_profile_badges" using primary key columns */
  mnet_personnel_profile_badges_by_pk?: Maybe<Mnet_Personnel_Profile_Badges>;
  /** fetch data from the table in a streaming manner: "mnet.personnel_profile_badges" */
  mnet_personnel_profile_badges_stream: Array<Mnet_Personnel_Profile_Badges>;
  /** fetch data from the table: "mnet.practice_area_detail" */
  mnet_practice_area_detail: Array<Mnet_Practice_Area_Detail>;
  /** fetch aggregated fields from the table: "mnet.practice_area_detail" */
  mnet_practice_area_detail_aggregate: Mnet_Practice_Area_Detail_Aggregate;
  /** fetch data from the table: "mnet.practice_area_detail" using primary key columns */
  mnet_practice_area_detail_by_pk?: Maybe<Mnet_Practice_Area_Detail>;
  /** fetch data from the table in a streaming manner: "mnet.practice_area_detail" */
  mnet_practice_area_detail_stream: Array<Mnet_Practice_Area_Detail>;
  /** fetch data from the table: "mnet.practice_group_detail" */
  mnet_practice_group_detail: Array<Mnet_Practice_Group_Detail>;
  /** fetch aggregated fields from the table: "mnet.practice_group_detail" */
  mnet_practice_group_detail_aggregate: Mnet_Practice_Group_Detail_Aggregate;
  /** fetch data from the table: "mnet.practice_group_detail" using primary key columns */
  mnet_practice_group_detail_by_pk?: Maybe<Mnet_Practice_Group_Detail>;
  /** fetch data from the table in a streaming manner: "mnet.practice_group_detail" */
  mnet_practice_group_detail_stream: Array<Mnet_Practice_Group_Detail>;
  /** fetch data from the table: "mnet.user_link" */
  mnet_user_link: Array<Mnet_User_Link>;
  /** fetch data from the table: "mnet.user_link" using primary key columns */
  mnet_user_link_by_pk?: Maybe<Mnet_User_Link>;
  /** fetch data from the table in a streaming manner: "mnet.user_link" */
  mnet_user_link_stream: Array<Mnet_User_Link>;
  /** fetch data from the table: "mnet.wellable_leaderboard" */
  mnet_wellable_leaderboard: Array<Mnet_Wellable_Leaderboard>;
  /** fetch aggregated fields from the table: "mnet.wellable_leaderboard" */
  mnet_wellable_leaderboard_aggregate: Mnet_Wellable_Leaderboard_Aggregate;
  /** fetch data from the table: "mnet.wellable_leaderboard" using primary key columns */
  mnet_wellable_leaderboard_by_pk?: Maybe<Mnet_Wellable_Leaderboard>;
  /** fetch data from the table in a streaming manner: "mnet.wellable_leaderboard" */
  mnet_wellable_leaderboard_stream: Array<Mnet_Wellable_Leaderboard>;
  /** fetch data from the table: "pbc.counsel_representatives" */
  pbc_counsel_representatives: Array<Pbc_Counsel_Representatives>;
  /** fetch aggregated fields from the table: "pbc.counsel_representatives" */
  pbc_counsel_representatives_aggregate: Pbc_Counsel_Representatives_Aggregate;
  /** fetch data from the table: "pbc.counsel_representatives" using primary key columns */
  pbc_counsel_representatives_by_pk?: Maybe<Pbc_Counsel_Representatives>;
  /** fetch data from the table in a streaming manner: "pbc.counsel_representatives" */
  pbc_counsel_representatives_stream: Array<Pbc_Counsel_Representatives>;
  /** fetch data from the table: "pbc.email_templates" */
  pbc_email_templates: Array<Pbc_Email_Templates>;
  /** fetch aggregated fields from the table: "pbc.email_templates" */
  pbc_email_templates_aggregate: Pbc_Email_Templates_Aggregate;
  /** fetch data from the table: "pbc.email_templates" using primary key columns */
  pbc_email_templates_by_pk?: Maybe<Pbc_Email_Templates>;
  /** fetch data from the table in a streaming manner: "pbc.email_templates" */
  pbc_email_templates_stream: Array<Pbc_Email_Templates>;
  /** fetch data from the table: "pbc.exempt_users" */
  pbc_exempt_users: Array<Pbc_Exempt_Users>;
  /** fetch aggregated fields from the table: "pbc.exempt_users" */
  pbc_exempt_users_aggregate: Pbc_Exempt_Users_Aggregate;
  /** fetch data from the table: "pbc.exempt_users" using primary key columns */
  pbc_exempt_users_by_pk?: Maybe<Pbc_Exempt_Users>;
  /** fetch data from the table in a streaming manner: "pbc.exempt_users" */
  pbc_exempt_users_stream: Array<Pbc_Exempt_Users>;
  /** fetch data from the table: "pbc.notification_recipients" */
  pbc_notification_recipients: Array<Pbc_Notification_Recipients>;
  /** fetch aggregated fields from the table: "pbc.notification_recipients" */
  pbc_notification_recipients_aggregate: Pbc_Notification_Recipients_Aggregate;
  /** fetch data from the table: "pbc.notification_recipients" using primary key columns */
  pbc_notification_recipients_by_pk?: Maybe<Pbc_Notification_Recipients>;
  /** fetch data from the table in a streaming manner: "pbc.notification_recipients" */
  pbc_notification_recipients_stream: Array<Pbc_Notification_Recipients>;
  /** fetch data from the table: "pbc.notification_requests" */
  pbc_notification_requests: Array<Pbc_Notification_Requests>;
  /** fetch aggregated fields from the table: "pbc.notification_requests" */
  pbc_notification_requests_aggregate: Pbc_Notification_Requests_Aggregate;
  /** fetch data from the table: "pbc.notification_requests" using primary key columns */
  pbc_notification_requests_by_pk?: Maybe<Pbc_Notification_Requests>;
  /** fetch data from the table in a streaming manner: "pbc.notification_requests" */
  pbc_notification_requests_stream: Array<Pbc_Notification_Requests>;
  /** fetch data from the table: "pbc.notification_statuses" */
  pbc_notification_statuses: Array<Pbc_Notification_Statuses>;
  /** fetch aggregated fields from the table: "pbc.notification_statuses" */
  pbc_notification_statuses_aggregate: Pbc_Notification_Statuses_Aggregate;
  /** fetch data from the table: "pbc.notification_statuses" using primary key columns */
  pbc_notification_statuses_by_pk?: Maybe<Pbc_Notification_Statuses>;
  /** fetch data from the table in a streaming manner: "pbc.notification_statuses" */
  pbc_notification_statuses_stream: Array<Pbc_Notification_Statuses>;
  /** fetch data from the table: "pbc.senders" */
  pbc_senders: Array<Pbc_Senders>;
  /** fetch aggregated fields from the table: "pbc.senders" */
  pbc_senders_aggregate: Pbc_Senders_Aggregate;
  /** fetch data from the table: "pbc.senders" using primary key columns */
  pbc_senders_by_pk?: Maybe<Pbc_Senders>;
  /** fetch data from the table in a streaming manner: "pbc.senders" */
  pbc_senders_stream: Array<Pbc_Senders>;
};

export type Subscription_RootBcs_PersonnelArgs = {
  distinct_on?: InputMaybe<Array<Bcs_Personnel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bcs_Personnel_Order_By>>;
  where?: InputMaybe<Bcs_Personnel_Bool_Exp>;
};

export type Subscription_RootBcs_Personnel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bcs_Personnel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bcs_Personnel_Order_By>>;
  where?: InputMaybe<Bcs_Personnel_Bool_Exp>;
};

export type Subscription_RootBcs_Personnel_By_PkArgs = {
  ADSystemID: Scalars['citext']['input'];
};

export type Subscription_RootBcs_Personnel_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Bcs_Personnel_Stream_Cursor_Input>>;
  where?: InputMaybe<Bcs_Personnel_Bool_Exp>;
};

export type Subscription_RootB2b_External_AccountsArgs = {
  distinct_on?: InputMaybe<Array<B2b_External_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<B2b_External_Accounts_Order_By>>;
  where?: InputMaybe<B2b_External_Accounts_Bool_Exp>;
};

export type Subscription_RootB2b_External_Accounts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootB2b_External_Accounts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<B2b_External_Accounts_Stream_Cursor_Input>>;
  where?: InputMaybe<B2b_External_Accounts_Bool_Exp>;
};

export type Subscription_RootB2b_LogsArgs = {
  distinct_on?: InputMaybe<Array<B2b_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<B2b_Logs_Order_By>>;
  where?: InputMaybe<B2b_Logs_Bool_Exp>;
};

export type Subscription_RootB2b_Logs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootB2b_Logs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<B2b_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<B2b_Logs_Bool_Exp>;
};

export type Subscription_RootB2b_Ml_Sponsor_ReferencesArgs = {
  distinct_on?: InputMaybe<Array<B2b_Ml_Sponsor_References_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<B2b_Ml_Sponsor_References_Order_By>>;
  where?: InputMaybe<B2b_Ml_Sponsor_References_Bool_Exp>;
};

export type Subscription_RootB2b_Ml_Sponsor_References_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootB2b_Ml_Sponsor_References_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<B2b_Ml_Sponsor_References_Stream_Cursor_Input>>;
  where?: InputMaybe<B2b_Ml_Sponsor_References_Bool_Exp>;
};

export type Subscription_RootB2b_Request_StatusArgs = {
  distinct_on?: InputMaybe<Array<B2b_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<B2b_Request_Status_Order_By>>;
  where?: InputMaybe<B2b_Request_Status_Bool_Exp>;
};

export type Subscription_RootB2b_Request_Status_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Subscription_RootB2b_Request_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<B2b_Request_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<B2b_Request_Status_Bool_Exp>;
};

export type Subscription_RootB2b_RequestsArgs = {
  distinct_on?: InputMaybe<Array<B2b_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<B2b_Requests_Order_By>>;
  where?: InputMaybe<B2b_Requests_Bool_Exp>;
};

export type Subscription_RootB2b_Requests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootB2b_Requests_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<B2b_Requests_Stream_Cursor_Input>>;
  where?: InputMaybe<B2b_Requests_Bool_Exp>;
};

export type Subscription_RootB2b_Resource_Owner_ReferencesArgs = {
  distinct_on?: InputMaybe<Array<B2b_Resource_Owner_References_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<B2b_Resource_Owner_References_Order_By>>;
  where?: InputMaybe<B2b_Resource_Owner_References_Bool_Exp>;
};

export type Subscription_RootB2b_Resource_Owner_References_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootB2b_Resource_Owner_References_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<B2b_Resource_Owner_References_Stream_Cursor_Input>>;
  where?: InputMaybe<B2b_Resource_Owner_References_Bool_Exp>;
};

export type Subscription_RootCle_Cle_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Cle_Cle_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cle_Cle_Attachments_Order_By>>;
  where?: InputMaybe<Cle_Cle_Attachments_Bool_Exp>;
};

export type Subscription_RootCle_Cle_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cle_Cle_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cle_Cle_Attachments_Order_By>>;
  where?: InputMaybe<Cle_Cle_Attachments_Bool_Exp>;
};

export type Subscription_RootCle_Cle_Attachments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootCle_Cle_Attachments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cle_Cle_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Cle_Cle_Attachments_Bool_Exp>;
};

export type Subscription_RootCle_Cle_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Cle_Cle_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cle_Cle_Requests_Order_By>>;
  where?: InputMaybe<Cle_Cle_Requests_Bool_Exp>;
};

export type Subscription_RootCle_Cle_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cle_Cle_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cle_Cle_Requests_Order_By>>;
  where?: InputMaybe<Cle_Cle_Requests_Bool_Exp>;
};

export type Subscription_RootCle_Cle_Requests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootCle_Cle_Requests_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cle_Cle_Requests_Stream_Cursor_Input>>;
  where?: InputMaybe<Cle_Cle_Requests_Bool_Exp>;
};

export type Subscription_RootClm_Engagement_Client_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Clm_Engagement_Client_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Engagement_Client_Comments_Order_By>>;
  where?: InputMaybe<Clm_Engagement_Client_Comments_Bool_Exp>;
};

export type Subscription_RootClm_Engagement_Client_Comments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootClm_Engagement_Client_Comments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Clm_Engagement_Client_Comments_Stream_Cursor_Input>>;
  where?: InputMaybe<Clm_Engagement_Client_Comments_Bool_Exp>;
};

export type Subscription_RootClm_Engagement_Imanage_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Clm_Engagement_Imanage_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Engagement_Imanage_Documents_Order_By>>;
  where?: InputMaybe<Clm_Engagement_Imanage_Documents_Bool_Exp>;
};

export type Subscription_RootClm_Engagement_Imanage_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clm_Engagement_Imanage_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Engagement_Imanage_Documents_Order_By>>;
  where?: InputMaybe<Clm_Engagement_Imanage_Documents_Bool_Exp>;
};

export type Subscription_RootClm_Engagement_Imanage_Documents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootClm_Engagement_Imanage_Documents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Clm_Engagement_Imanage_Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Clm_Engagement_Imanage_Documents_Bool_Exp>;
};

export type Subscription_RootClm_Engagement_RecordsArgs = {
  distinct_on?: InputMaybe<Array<Clm_Engagement_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Engagement_Records_Order_By>>;
  where?: InputMaybe<Clm_Engagement_Records_Bool_Exp>;
};

export type Subscription_RootClm_Engagement_Records_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootClm_Engagement_Records_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Clm_Engagement_Records_Stream_Cursor_Input>>;
  where?: InputMaybe<Clm_Engagement_Records_Bool_Exp>;
};

export type Subscription_RootClm_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Clm_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Views_Order_By>>;
  where?: InputMaybe<Clm_Views_Bool_Exp>;
};

export type Subscription_RootClm_Views_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootClm_Views_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Clm_Views_Stream_Cursor_Input>>;
  where?: InputMaybe<Clm_Views_Bool_Exp>;
};

export type Subscription_RootClm_Waiver_Imanage_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Clm_Waiver_Imanage_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Waiver_Imanage_Documents_Order_By>>;
  where?: InputMaybe<Clm_Waiver_Imanage_Documents_Bool_Exp>;
};

export type Subscription_RootClm_Waiver_Imanage_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clm_Waiver_Imanage_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Waiver_Imanage_Documents_Order_By>>;
  where?: InputMaybe<Clm_Waiver_Imanage_Documents_Bool_Exp>;
};

export type Subscription_RootClm_Waiver_Imanage_Documents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootClm_Waiver_Imanage_Documents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Clm_Waiver_Imanage_Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Clm_Waiver_Imanage_Documents_Bool_Exp>;
};

export type Subscription_RootClm_Waiver_RecordsArgs = {
  distinct_on?: InputMaybe<Array<Clm_Waiver_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clm_Waiver_Records_Order_By>>;
  where?: InputMaybe<Clm_Waiver_Records_Bool_Exp>;
};

export type Subscription_RootClm_Waiver_Records_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootClm_Waiver_Records_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Clm_Waiver_Records_Stream_Cursor_Input>>;
  where?: InputMaybe<Clm_Waiver_Records_Bool_Exp>;
};

export type Subscription_RootFd_Email_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Fd_Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Email_Templates_Order_By>>;
  where?: InputMaybe<Fd_Email_Templates_Bool_Exp>;
};

export type Subscription_RootFd_Email_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootFd_Email_Templates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fd_Email_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Fd_Email_Templates_Bool_Exp>;
};

export type Subscription_RootFd_Exempt_MattersArgs = {
  distinct_on?: InputMaybe<Array<Fd_Exempt_Matters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Exempt_Matters_Order_By>>;
  where?: InputMaybe<Fd_Exempt_Matters_Bool_Exp>;
};

export type Subscription_RootFd_Exempt_Matters_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootFd_Exempt_Matters_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fd_Exempt_Matters_Stream_Cursor_Input>>;
  where?: InputMaybe<Fd_Exempt_Matters_Bool_Exp>;
};

export type Subscription_RootFd_Instruction_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Fd_Instruction_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Instruction_Templates_Order_By>>;
  where?: InputMaybe<Fd_Instruction_Templates_Bool_Exp>;
};

export type Subscription_RootFd_Instruction_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootFd_Instruction_Templates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fd_Instruction_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Fd_Instruction_Templates_Bool_Exp>;
};

export type Subscription_RootFd_Matters_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Fd_Matters_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Matters_Responses_Order_By>>;
  where?: InputMaybe<Fd_Matters_Responses_Bool_Exp>;
};

export type Subscription_RootFd_Matters_Responses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootFd_Matters_Responses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fd_Matters_Responses_Stream_Cursor_Input>>;
  where?: InputMaybe<Fd_Matters_Responses_Bool_Exp>;
};

export type Subscription_RootFd_Project_AccessArgs = {
  distinct_on?: InputMaybe<Array<Fd_Project_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Project_Access_Order_By>>;
  where?: InputMaybe<Fd_Project_Access_Bool_Exp>;
};

export type Subscription_RootFd_Project_Access_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootFd_Project_Access_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fd_Project_Access_Stream_Cursor_Input>>;
  where?: InputMaybe<Fd_Project_Access_Bool_Exp>;
};

export type Subscription_RootFd_Project_Number_CounterArgs = {
  distinct_on?: InputMaybe<Array<Fd_Project_Number_Counter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Project_Number_Counter_Order_By>>;
  where?: InputMaybe<Fd_Project_Number_Counter_Bool_Exp>;
};

export type Subscription_RootFd_Project_Number_Counter_By_PkArgs = {
  project_year: Scalars['smallint']['input'];
};

export type Subscription_RootFd_Project_Number_Counter_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fd_Project_Number_Counter_Stream_Cursor_Input>>;
  where?: InputMaybe<Fd_Project_Number_Counter_Bool_Exp>;
};

export type Subscription_RootFd_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Fd_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Projects_Order_By>>;
  where?: InputMaybe<Fd_Projects_Bool_Exp>;
};

export type Subscription_RootFd_Projects_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootFd_Projects_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fd_Projects_Stream_Cursor_Input>>;
  where?: InputMaybe<Fd_Projects_Bool_Exp>;
};

export type Subscription_RootFd_Response_In_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Fd_Response_In_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Response_In_Projects_Order_By>>;
  where?: InputMaybe<Fd_Response_In_Projects_Bool_Exp>;
};

export type Subscription_RootFd_Response_In_Projects_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootFd_Response_In_Projects_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fd_Response_In_Projects_Stream_Cursor_Input>>;
  where?: InputMaybe<Fd_Response_In_Projects_Bool_Exp>;
};

export type Subscription_RootFd_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Fd_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fd_Responses_Order_By>>;
  where?: InputMaybe<Fd_Responses_Bool_Exp>;
};

export type Subscription_RootFd_Responses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootFd_Responses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fd_Responses_Stream_Cursor_Input>>;
  where?: InputMaybe<Fd_Responses_Bool_Exp>;
};

export type Subscription_RootFirstup_ChannelsArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Channels_Order_By>>;
  where?: InputMaybe<Firstup_Channels_Bool_Exp>;
};

export type Subscription_RootFirstup_Channels_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Subscription_RootFirstup_Channels_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Firstup_Channels_Stream_Cursor_Input>>;
  where?: InputMaybe<Firstup_Channels_Bool_Exp>;
};

export type Subscription_RootFirstup_ContentArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Content_Order_By>>;
  where?: InputMaybe<Firstup_Content_Bool_Exp>;
};

export type Subscription_RootFirstup_Content_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Content_Order_By>>;
  where?: InputMaybe<Firstup_Content_Bool_Exp>;
};

export type Subscription_RootFirstup_Content_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Subscription_RootFirstup_Content_In_ChannelsArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Content_In_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Content_In_Channels_Order_By>>;
  where?: InputMaybe<Firstup_Content_In_Channels_Bool_Exp>;
};

export type Subscription_RootFirstup_Content_In_Channels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Content_In_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Content_In_Channels_Order_By>>;
  where?: InputMaybe<Firstup_Content_In_Channels_Bool_Exp>;
};

export type Subscription_RootFirstup_Content_In_Channels_By_PkArgs = {
  channel_id: Scalars['Int']['input'];
  content_id: Scalars['Int']['input'];
};

export type Subscription_RootFirstup_Content_In_Channels_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Firstup_Content_In_Channels_Stream_Cursor_Input>>;
  where?: InputMaybe<Firstup_Content_In_Channels_Bool_Exp>;
};

export type Subscription_RootFirstup_Content_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Firstup_Content_Stream_Cursor_Input>>;
  where?: InputMaybe<Firstup_Content_Bool_Exp>;
};

export type Subscription_RootFirstup_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Images_Order_By>>;
  where?: InputMaybe<Firstup_Images_Bool_Exp>;
};

export type Subscription_RootFirstup_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Images_Order_By>>;
  where?: InputMaybe<Firstup_Images_Bool_Exp>;
};

export type Subscription_RootFirstup_Images_By_PkArgs = {
  image_url: Scalars['String']['input'];
};

export type Subscription_RootFirstup_Images_In_ContentArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Images_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Images_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_Images_In_Content_Bool_Exp>;
};

export type Subscription_RootFirstup_Images_In_Content_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Images_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Images_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_Images_In_Content_Bool_Exp>;
};

export type Subscription_RootFirstup_Images_In_Content_By_PkArgs = {
  content_id: Scalars['Int']['input'];
  image_url: Scalars['String']['input'];
};

export type Subscription_RootFirstup_Images_In_Content_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Firstup_Images_In_Content_Stream_Cursor_Input>>;
  where?: InputMaybe<Firstup_Images_In_Content_Bool_Exp>;
};

export type Subscription_RootFirstup_Images_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Firstup_Images_Stream_Cursor_Input>>;
  where?: InputMaybe<Firstup_Images_Bool_Exp>;
};

export type Subscription_RootFirstup_People_In_ContentArgs = {
  distinct_on?: InputMaybe<Array<Firstup_People_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_People_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_People_In_Content_Bool_Exp>;
};

export type Subscription_RootFirstup_People_In_Content_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_People_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_People_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_People_In_Content_Bool_Exp>;
};

export type Subscription_RootFirstup_People_In_Content_By_PkArgs = {
  content_id: Scalars['Int']['input'];
  user_email: Scalars['String']['input'];
};

export type Subscription_RootFirstup_People_In_Content_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Firstup_People_In_Content_Stream_Cursor_Input>>;
  where?: InputMaybe<Firstup_People_In_Content_Bool_Exp>;
};

export type Subscription_RootFirstup_VideosArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Videos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Videos_Order_By>>;
  where?: InputMaybe<Firstup_Videos_Bool_Exp>;
};

export type Subscription_RootFirstup_Videos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Videos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Videos_Order_By>>;
  where?: InputMaybe<Firstup_Videos_Bool_Exp>;
};

export type Subscription_RootFirstup_Videos_By_PkArgs = {
  link_url: Scalars['String']['input'];
};

export type Subscription_RootFirstup_Videos_In_ContentArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Videos_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Videos_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_Videos_In_Content_Bool_Exp>;
};

export type Subscription_RootFirstup_Videos_In_Content_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firstup_Videos_In_Content_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firstup_Videos_In_Content_Order_By>>;
  where?: InputMaybe<Firstup_Videos_In_Content_Bool_Exp>;
};

export type Subscription_RootFirstup_Videos_In_Content_By_PkArgs = {
  content_id: Scalars['Int']['input'];
  video_url: Scalars['String']['input'];
};

export type Subscription_RootFirstup_Videos_In_Content_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Firstup_Videos_In_Content_Stream_Cursor_Input>>;
  where?: InputMaybe<Firstup_Videos_In_Content_Bool_Exp>;
};

export type Subscription_RootFirstup_Videos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Firstup_Videos_Stream_Cursor_Input>>;
  where?: InputMaybe<Firstup_Videos_Bool_Exp>;
};

export type Subscription_RootFtp_RequestArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_Order_By>>;
  where?: InputMaybe<Ftp_Request_Bool_Exp>;
};

export type Subscription_RootFtp_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_Order_By>>;
  where?: InputMaybe<Ftp_Request_Bool_Exp>;
};

export type Subscription_RootFtp_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootFtp_Request_DetailArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_Detail_Order_By>>;
  where?: InputMaybe<Ftp_Request_Detail_Bool_Exp>;
};

export type Subscription_RootFtp_Request_Detail_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootFtp_Request_Detail_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ftp_Request_Detail_Stream_Cursor_Input>>;
  where?: InputMaybe<Ftp_Request_Detail_Bool_Exp>;
};

export type Subscription_RootFtp_Request_External_AccessArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_External_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_External_Access_Order_By>>;
  where?: InputMaybe<Ftp_Request_External_Access_Bool_Exp>;
};

export type Subscription_RootFtp_Request_External_Access_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootFtp_Request_External_Access_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ftp_Request_External_Access_Stream_Cursor_Input>>;
  where?: InputMaybe<Ftp_Request_External_Access_Bool_Exp>;
};

export type Subscription_RootFtp_Request_External_NoteArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_External_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_External_Note_Order_By>>;
  where?: InputMaybe<Ftp_Request_External_Note_Bool_Exp>;
};

export type Subscription_RootFtp_Request_External_Note_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootFtp_Request_External_Note_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ftp_Request_External_Note_Stream_Cursor_Input>>;
  where?: InputMaybe<Ftp_Request_External_Note_Bool_Exp>;
};

export type Subscription_RootFtp_Request_Internal_NoteArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_Internal_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_Internal_Note_Order_By>>;
  where?: InputMaybe<Ftp_Request_Internal_Note_Bool_Exp>;
};

export type Subscription_RootFtp_Request_Internal_Note_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootFtp_Request_Internal_Note_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ftp_Request_Internal_Note_Stream_Cursor_Input>>;
  where?: InputMaybe<Ftp_Request_Internal_Note_Bool_Exp>;
};

export type Subscription_RootFtp_Request_Number_CounterArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_Number_Counter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_Number_Counter_Order_By>>;
  where?: InputMaybe<Ftp_Request_Number_Counter_Bool_Exp>;
};

export type Subscription_RootFtp_Request_Number_Counter_By_PkArgs = {
  request_year: Scalars['smallint']['input'];
};

export type Subscription_RootFtp_Request_Number_Counter_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ftp_Request_Number_Counter_Stream_Cursor_Input>>;
  where?: InputMaybe<Ftp_Request_Number_Counter_Bool_Exp>;
};

export type Subscription_RootFtp_Request_ParticipantArgs = {
  distinct_on?: InputMaybe<Array<Ftp_Request_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ftp_Request_Participant_Order_By>>;
  where?: InputMaybe<Ftp_Request_Participant_Bool_Exp>;
};

export type Subscription_RootFtp_Request_Participant_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootFtp_Request_Participant_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ftp_Request_Participant_Stream_Cursor_Input>>;
  where?: InputMaybe<Ftp_Request_Participant_Bool_Exp>;
};

export type Subscription_RootFtp_Request_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ftp_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Ftp_Request_Bool_Exp>;
};

export type Subscription_RootGec_AudienceArgs = {
  distinct_on?: InputMaybe<Array<Gec_Audience_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Audience_Order_By>>;
  where?: InputMaybe<Gec_Audience_Bool_Exp>;
};

export type Subscription_RootGec_Audience_By_PkArgs = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type Subscription_RootGec_Audience_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Audience_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Audience_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Audience_In_Event_Bool_Exp>;
};

export type Subscription_RootGec_Audience_In_Event_By_PkArgs = {
  audience_id: Scalars['Int']['input'];
  event_id: Scalars['Int']['input'];
};

export type Subscription_RootGec_Audience_In_Event_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Audience_In_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Audience_In_Event_Bool_Exp>;
};

export type Subscription_RootGec_Audience_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Audience_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Audience_Bool_Exp>;
};

export type Subscription_RootGec_Contact_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Contact_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Contact_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Contact_In_Event_Bool_Exp>;
};

export type Subscription_RootGec_Contact_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  user_id: Scalars['String']['input'];
};

export type Subscription_RootGec_Contact_In_Event_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Contact_In_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Contact_In_Event_Bool_Exp>;
};

export type Subscription_RootGec_DepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Gec_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Departments_Order_By>>;
  where?: InputMaybe<Gec_Departments_Bool_Exp>;
};

export type Subscription_RootGec_Departments_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Subscription_RootGec_Departments_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Departments_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Departments_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Departments_In_Event_Bool_Exp>;
};

export type Subscription_RootGec_Departments_In_Event_By_PkArgs = {
  department_id: Scalars['Int']['input'];
  event_id: Scalars['Int']['input'];
};

export type Subscription_RootGec_Departments_In_Event_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Departments_In_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Departments_In_Event_Bool_Exp>;
};

export type Subscription_RootGec_Departments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Departments_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Departments_Bool_Exp>;
};

export type Subscription_RootGec_Event_ExceptionArgs = {
  distinct_on?: InputMaybe<Array<Gec_Event_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Event_Exception_Order_By>>;
  where?: InputMaybe<Gec_Event_Exception_Bool_Exp>;
};

export type Subscription_RootGec_Event_Exception_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Subscription_RootGec_Event_Exception_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Event_Exception_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Event_Exception_Bool_Exp>;
};

export type Subscription_RootGec_Event_FormatArgs = {
  distinct_on?: InputMaybe<Array<Gec_Event_Format_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Event_Format_Order_By>>;
  where?: InputMaybe<Gec_Event_Format_Bool_Exp>;
};

export type Subscription_RootGec_Event_Format_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootGec_Event_Format_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Event_Format_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Event_Format_Bool_Exp>;
};

export type Subscription_RootGec_Event_TypeArgs = {
  distinct_on?: InputMaybe<Array<Gec_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Event_Type_Order_By>>;
  where?: InputMaybe<Gec_Event_Type_Bool_Exp>;
};

export type Subscription_RootGec_Event_Type_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Subscription_RootGec_Event_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Event_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Event_Type_Bool_Exp>;
};

export type Subscription_RootGec_EventsArgs = {
  distinct_on?: InputMaybe<Array<Gec_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Events_Order_By>>;
  where?: InputMaybe<Gec_Events_Bool_Exp>;
};

export type Subscription_RootGec_Events_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Subscription_RootGec_Events_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Events_Bool_Exp>;
};

export type Subscription_RootGec_Firm_InitiativesArgs = {
  distinct_on?: InputMaybe<Array<Gec_Firm_Initiatives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Firm_Initiatives_Order_By>>;
  where?: InputMaybe<Gec_Firm_Initiatives_Bool_Exp>;
};

export type Subscription_RootGec_Firm_Initiatives_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Subscription_RootGec_Firm_Initiatives_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Firm_Initiatives_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Firm_Initiatives_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Firm_Initiatives_In_Event_Bool_Exp>;
};

export type Subscription_RootGec_Firm_Initiatives_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  firm_initiative_id: Scalars['Int']['input'];
};

export type Subscription_RootGec_Firm_Initiatives_In_Event_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Firm_Initiatives_In_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Firm_Initiatives_In_Event_Bool_Exp>;
};

export type Subscription_RootGec_Firm_Initiatives_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Firm_Initiatives_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Firm_Initiatives_Bool_Exp>;
};

export type Subscription_RootGec_IndustriesArgs = {
  distinct_on?: InputMaybe<Array<Gec_Industries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Industries_Order_By>>;
  where?: InputMaybe<Gec_Industries_Bool_Exp>;
};

export type Subscription_RootGec_Industries_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Subscription_RootGec_Industries_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Industries_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Industries_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Industries_In_Event_Bool_Exp>;
};

export type Subscription_RootGec_Industries_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  industry_id: Scalars['Int']['input'];
};

export type Subscription_RootGec_Industries_In_Event_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Industries_In_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Industries_In_Event_Bool_Exp>;
};

export type Subscription_RootGec_Industries_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Industries_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Industries_Bool_Exp>;
};

export type Subscription_RootGec_Office_Visibility_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Office_Visibility_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Office_Visibility_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Office_Visibility_In_Event_Bool_Exp>;
};

export type Subscription_RootGec_Office_Visibility_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  office_id: Scalars['uuid']['input'];
};

export type Subscription_RootGec_Office_Visibility_In_Event_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Office_Visibility_In_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Office_Visibility_In_Event_Bool_Exp>;
};

export type Subscription_RootGec_OfficesArgs = {
  distinct_on?: InputMaybe<Array<Gec_Offices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Offices_Order_By>>;
  where?: InputMaybe<Gec_Offices_Bool_Exp>;
};

export type Subscription_RootGec_Offices_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootGec_Offices_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Offices_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Offices_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Offices_In_Event_Bool_Exp>;
};

export type Subscription_RootGec_Offices_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  office_id: Scalars['uuid']['input'];
};

export type Subscription_RootGec_Offices_In_Event_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Offices_In_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Offices_In_Event_Bool_Exp>;
};

export type Subscription_RootGec_Offices_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Offices_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Offices_Bool_Exp>;
};

export type Subscription_RootGec_Outside_SpeakersArgs = {
  distinct_on?: InputMaybe<Array<Gec_Outside_Speakers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Outside_Speakers_Order_By>>;
  where?: InputMaybe<Gec_Outside_Speakers_Bool_Exp>;
};

export type Subscription_RootGec_Outside_Speakers_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Subscription_RootGec_Outside_Speakers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Outside_Speakers_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Outside_Speakers_Bool_Exp>;
};

export type Subscription_RootGec_Practice_Groups_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Practice_Groups_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Practice_Groups_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Practice_Groups_In_Event_Bool_Exp>;
};

export type Subscription_RootGec_Practice_Groups_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  practice_group_id: Scalars['Int']['input'];
};

export type Subscription_RootGec_Practice_Groups_In_Event_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Practice_Groups_In_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Practice_Groups_In_Event_Bool_Exp>;
};

export type Subscription_RootGec_Practice_Groups_RollupArgs = {
  distinct_on?: InputMaybe<Array<Gec_Practice_Groups_Rollup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Practice_Groups_Rollup_Order_By>>;
  where?: InputMaybe<Gec_Practice_Groups_Rollup_Bool_Exp>;
};

export type Subscription_RootGec_Practice_Groups_Rollup_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Subscription_RootGec_Practice_Groups_Rollup_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Practice_Groups_Rollup_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Practice_Groups_Rollup_Bool_Exp>;
};

export type Subscription_RootGec_Speaker_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Speaker_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Speaker_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Speaker_In_Event_Bool_Exp>;
};

export type Subscription_RootGec_Speaker_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  user_id: Scalars['String']['input'];
};

export type Subscription_RootGec_Speaker_In_Event_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Speaker_In_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Speaker_In_Event_Bool_Exp>;
};

export type Subscription_RootGec_Sponsoring_Attorney_In_EventArgs = {
  distinct_on?: InputMaybe<Array<Gec_Sponsoring_Attorney_In_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gec_Sponsoring_Attorney_In_Event_Order_By>>;
  where?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Bool_Exp>;
};

export type Subscription_RootGec_Sponsoring_Attorney_In_Event_By_PkArgs = {
  event_id: Scalars['Int']['input'];
  user_id: Scalars['String']['input'];
};

export type Subscription_RootGec_Sponsoring_Attorney_In_Event_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gec_Sponsoring_Attorney_In_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Gec_Sponsoring_Attorney_In_Event_Bool_Exp>;
};

export type Subscription_RootGec_Timezone_NamesArgs = {
  distinct_on?: InputMaybe<Array<Pg_Timezone_Names_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pg_Timezone_Names_Order_By>>;
  where?: InputMaybe<Pg_Timezone_Names_Bool_Exp_Bool_Exp>;
};

export type Subscription_RootMlfsl_Ad_GroupArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Ad_Group_Order_By>>;
  where?: InputMaybe<Mlfsl_Ad_Group_Bool_Exp>;
};

export type Subscription_RootMlfsl_Ad_Group_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Ad_Group_Order_By>>;
  where?: InputMaybe<Mlfsl_Ad_Group_Bool_Exp>;
};

export type Subscription_RootMlfsl_Ad_Group_By_PkArgs = {
  ADGroupId: Scalars['Int']['input'];
};

export type Subscription_RootMlfsl_Ad_JoinArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Ad_Join_Order_By>>;
  where?: InputMaybe<Mlfsl_Ad_Join_Bool_Exp>;
};

export type Subscription_RootMlfsl_Ad_Join_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Ad_Join_Order_By>>;
  where?: InputMaybe<Mlfsl_Ad_Join_Bool_Exp>;
};

export type Subscription_RootMlfsl_Ad_Join_By_PkArgs = {
  JoinsRowKey: Scalars['Int']['input'];
};

export type Subscription_RootMlfsl_Ad_LoginArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Ad_Login_Order_By>>;
  where?: InputMaybe<Mlfsl_Ad_Login_Bool_Exp>;
};

export type Subscription_RootMlfsl_Ad_Login_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Ad_Login_Order_By>>;
  where?: InputMaybe<Mlfsl_Ad_Login_Bool_Exp>;
};

export type Subscription_RootMlfsl_Ad_Login_By_PkArgs = {
  AdLoginId: Scalars['Int']['input'];
};

export type Subscription_RootMlfsl_ClientArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Client_Order_By>>;
  where?: InputMaybe<Mlfsl_Client_Bool_Exp>;
};

export type Subscription_RootMlfsl_Client_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Client_Order_By>>;
  where?: InputMaybe<Mlfsl_Client_Bool_Exp>;
};

export type Subscription_RootMlfsl_Client_By_PkArgs = {
  DimClientNowKey: Scalars['Int']['input'];
};

export type Subscription_RootMlfsl_Client_Display_DescriptionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Client_Display_Description_Order_By>>;
  where?: InputMaybe<Mlfsl_Client_Display_Description_Bool_Exp>;
};

export type Subscription_RootMlfsl_DateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Date_Order_By>>;
  where?: InputMaybe<Mlfsl_Date_Bool_Exp>;
};

export type Subscription_RootMlfsl_Date_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Date_Order_By>>;
  where?: InputMaybe<Mlfsl_Date_Bool_Exp>;
};

export type Subscription_RootMlfsl_Date_By_PkArgs = {
  DimDatekey: Scalars['Int']['input'];
};

export type Subscription_RootMlfsl_Finance_Hours_ClientArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Client_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Client_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Client_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Client_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Client_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Client_By_PkArgs = {
  ClientNumber: Scalars['String']['input'];
};

export type Subscription_RootMlfsl_Finance_Hours_ClientofficetimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clientofficetimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clientofficetimeframe_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Clientofficetimeframe_By_PkArgs = {
  ClientNumber: Scalars['String']['input'];
  HistoricalTKOfficeforCount: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
};

export type Subscription_RootMlfsl_Finance_Hours_ClientpgtimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clientpgtimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clientpgtimeframe_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Clientpgtimeframe_By_PkArgs = {
  ClientNumber: Scalars['String']['input'];
  HistoricalTKPGforCount: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
};

export type Subscription_RootMlfsl_Finance_Hours_ClienttimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clienttimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Clienttimeframe_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clienttimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clienttimeframe_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Clienttimeframe_By_PkArgs = {
  ClientNumber: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
};

export type Subscription_RootMlfsl_Finance_Hours_ClienttimekeepertimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Clienttimekeepertimeframe_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Clienttimekeepertimeframe_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Clienttimekeepertimeframe_By_PkArgs = {
  ClientNumber: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
  TkprNumber: Scalars['String']['input'];
};

export type Subscription_RootMlfsl_Finance_Hours_MatterArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Matter_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Matter_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Matter_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Matter_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Matter_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Matter_By_PkArgs = {
  MatterNumber: Scalars['String']['input'];
};

export type Subscription_RootMlfsl_Finance_Hours_MatterofficetimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Matterofficetimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Matterofficetimeframe_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Matterofficetimeframe_By_PkArgs = {
  ClientNumber: Scalars['String']['input'];
  HistoricalTKOfficeforCount: Scalars['String']['input'];
  Matter: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
};

export type Subscription_RootMlfsl_Finance_Hours_MatterpgtimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Matterpgtimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Matterpgtimeframe_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Matterpgtimeframe_By_PkArgs = {
  ClientNumber: Scalars['String']['input'];
  HistoricalTKPGforCount: Scalars['String']['input'];
  Matter: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
};

export type Subscription_RootMlfsl_Finance_Hours_MattertimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Mattertimeframe_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframe_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Mattertimeframe_By_PkArgs = {
  ClientNumber: Scalars['String']['input'];
  Matter: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
};

export type Subscription_RootMlfsl_Finance_Hours_MattertimeframecompareArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimeframecompare_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimeframecompare_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Mattertimeframecompare_By_PkArgs = {
  ClientNumber: Scalars['String']['input'];
  Matter: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
};

export type Subscription_RootMlfsl_Finance_Hours_MattertimekeepertimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Mattertimekeepertimeframe_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Mattertimekeepertimeframe_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Mattertimekeepertimeframe_By_PkArgs = {
  ClientNumber: Scalars['String']['input'];
  Matter: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
  TkprNumber: Scalars['String']['input'];
};

export type Subscription_RootMlfsl_Finance_Hours_RelatedclientArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclient_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Relatedclient_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Relatedclient_By_PkArgs = {
  RelatedClientNumber: Scalars['String']['input'];
};

export type Subscription_RootMlfsl_Finance_Hours_RelatedclientofficetimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientofficetimeframe_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Relatedclientofficetimeframe_By_PkArgs = {
  HistoricalTKOfficeforCount: Scalars['String']['input'];
  RelatedClientNumber: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
};

export type Subscription_RootMlfsl_Finance_Hours_RelatedclientpgtimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Relatedclientpgtimeframe_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Relatedclientpgtimeframe_By_PkArgs = {
  HistoricalTKPGforCount: Scalars['String']['input'];
  RelatedClientNumber: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
};

export type Subscription_RootMlfsl_Finance_Hours_RelatedclienttimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclienttimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Relatedclienttimeframe_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclienttimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimeframe_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Relatedclienttimeframe_By_PkArgs = {
  RelatedClientNumber: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
};

export type Subscription_RootMlfsl_Finance_Hours_RelatedclienttimekeepertimeframeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Order_By>>;
  where?: InputMaybe<Mlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_Bool_Exp>;
};

export type Subscription_RootMlfsl_Finance_Hours_Relatedclienttimekeepertimeframe_By_PkArgs = {
  RelatedClientNumber: Scalars['String']['input'];
  Timeframe: Scalars['String']['input'];
  TkprNumber: Scalars['String']['input'];
};

export type Subscription_RootMlfsl_MatterArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Matter_Order_By>>;
  where?: InputMaybe<Mlfsl_Matter_Bool_Exp>;
};

export type Subscription_RootMlfsl_Matter_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Matter_Order_By>>;
  where?: InputMaybe<Mlfsl_Matter_Bool_Exp>;
};

export type Subscription_RootMlfsl_Matter_By_PkArgs = {
  DimMatterNowKey: Scalars['Int']['input'];
};

export type Subscription_RootMlfsl_Matter_Display_DescriptionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Matter_Display_Description_Order_By>>;
  where?: InputMaybe<Mlfsl_Matter_Display_Description_Bool_Exp>;
};

export type Subscription_RootMlfsl_Mlv_Finance_Hours_TimeframesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Mlv_Finance_Hours_Timeframes_Order_By>>;
  where?: InputMaybe<Mlfsl_Mlv_Finance_Hours_Timeframes_Bool_Exp>;
};

export type Subscription_RootMlfsl_Mlv_Finance_Hours_ClientArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Mlv_Finance_Hours_Client_Order_By>>;
  where?: InputMaybe<Mlfsl_Mlv_Finance_Hours_Client_Bool_Exp>;
};

export type Subscription_RootMlfsl_Mlv_Finance_Hours_MatterArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Mlv_Finance_Hours_Matter_Order_By>>;
  where?: InputMaybe<Mlfsl_Mlv_Finance_Hours_Matter_Bool_Exp>;
};

export type Subscription_RootMlfsl_Mlv_Finance_Hours_RelatedclientArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Mlv_Finance_Hours_Relatedclient_Order_By>>;
  where?: InputMaybe<Mlfsl_Mlv_Finance_Hours_Relatedclient_Bool_Exp>;
};

export type Subscription_RootMlfsl_Morgannet_ClientPage_ClientInfoArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Morgannet_ClientPage_ClientInfo_Order_By>>;
  where?: InputMaybe<Mlfsl_Morgannet_ClientPage_ClientInfo_Bool_Exp>;
};

export type Subscription_RootMlfsl_Morgannet_ClientPage_ClientInfo_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Morgannet_ClientPage_ClientInfo_Order_By>>;
  where?: InputMaybe<Mlfsl_Morgannet_ClientPage_ClientInfo_Bool_Exp>;
};

export type Subscription_RootMlfsl_Morgannet_ClientPage_ClientInfo_By_PkArgs = {
  MNCP_ClientInfoKey: Scalars['Int']['input'];
};

export type Subscription_RootMlfsl_OfficeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Office_Order_By>>;
  where?: InputMaybe<Mlfsl_Office_Bool_Exp>;
};

export type Subscription_RootMlfsl_Office_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Office_Order_By>>;
  where?: InputMaybe<Mlfsl_Office_Bool_Exp>;
};

export type Subscription_RootMlfsl_Office_By_PkArgs = {
  DimOfficeNowKey: Scalars['Int']['input'];
};

export type Subscription_RootMlfsl_Person_EducationArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Person_Education_Order_By>>;
  where?: InputMaybe<Mlfsl_Person_Education_Bool_Exp>;
};

export type Subscription_RootMlfsl_Person_Education_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Person_Education_Order_By>>;
  where?: InputMaybe<Mlfsl_Person_Education_Bool_Exp>;
};

export type Subscription_RootMlfsl_Person_Education_By_PkArgs = {
  DimPersonnelEducationKey: Scalars['Int']['input'];
};

export type Subscription_RootMlfsl_PersonaArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Persona_Order_By>>;
  where?: InputMaybe<Mlfsl_Persona_Bool_Exp>;
};

export type Subscription_RootMlfsl_Persona_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Persona_Order_By>>;
  where?: InputMaybe<Mlfsl_Persona_Bool_Exp>;
};

export type Subscription_RootMlfsl_Persona_By_PkArgs = {
  PersonaId: Scalars['Int']['input'];
};

export type Subscription_RootMlfsl_Persona_GroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Persona_Groups_Order_By>>;
  where?: InputMaybe<Mlfsl_Persona_Groups_Bool_Exp>;
};

export type Subscription_RootMlfsl_Persona_Groups_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Persona_Groups_Order_By>>;
  where?: InputMaybe<Mlfsl_Persona_Groups_Bool_Exp>;
};

export type Subscription_RootMlfsl_Persona_Groups_By_PkArgs = {
  GroupAdSystemName: Scalars['String']['input'];
  PersonaId: Scalars['Int']['input'];
};

export type Subscription_RootMlfsl_PersonnelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
};

export type Subscription_RootMlfsl_Personnel_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Bool_Exp>;
};

export type Subscription_RootMlfsl_Personnel_BarArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Bar_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Bar_Bool_Exp>;
};

export type Subscription_RootMlfsl_Personnel_Bar_By_PkArgs = {
  DimPersonnelBarKey: Scalars['Int']['input'];
};

export type Subscription_RootMlfsl_Personnel_By_PkArgs = {
  DimPersonnelNowKey: Scalars['Int']['input'];
};

export type Subscription_RootMlfsl_Personnel_ClerkshipArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Clerkship_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Clerkship_Bool_Exp>;
};

export type Subscription_RootMlfsl_Personnel_Clerkship_By_PkArgs = {
  DimPersonnelClerkshipKey: Scalars['Int']['input'];
};

export type Subscription_RootMlfsl_Personnel_CommitteeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Committee_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Committee_Bool_Exp>;
};

export type Subscription_RootMlfsl_Personnel_Committee_By_PkArgs = {
  DimPersonnelCommitteeKey: Scalars['Int']['input'];
};

export type Subscription_RootMlfsl_Personnel_CourtArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Court_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Court_Bool_Exp>;
};

export type Subscription_RootMlfsl_Personnel_Court_By_PkArgs = {
  DimPersonnelCourtKey: Scalars['Int']['input'];
};

export type Subscription_RootMlfsl_Personnel_LanguageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Personnel_Language_Order_By>>;
  where?: InputMaybe<Mlfsl_Personnel_Language_Bool_Exp>;
};

export type Subscription_RootMlfsl_Personnel_Language_By_PkArgs = {
  DimPersonnelLanguageKey: Scalars['Int']['input'];
};

export type Subscription_RootMlfsl_PracticegroupArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Practicegroup_Order_By>>;
  where?: InputMaybe<Mlfsl_Practicegroup_Bool_Exp>;
};

export type Subscription_RootMlfsl_Practicegroup_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Practicegroup_Order_By>>;
  where?: InputMaybe<Mlfsl_Practicegroup_Bool_Exp>;
};

export type Subscription_RootMlfsl_Practicegroup_By_PkArgs = {
  DimPracticeGroupNowKey: Scalars['Int']['input'];
};

export type Subscription_RootMlfsl_Probono_GoalArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Probono_Goal_Order_By>>;
  where?: InputMaybe<Mlfsl_Probono_Goal_Bool_Exp>;
};

export type Subscription_RootMlfsl_Related_ClientArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Related_Client_Order_By>>;
  where?: InputMaybe<Mlfsl_Related_Client_Bool_Exp>;
};

export type Subscription_RootMlfsl_Related_Client_By_PkArgs = {
  DimClientNowKey: Scalars['Int']['input'];
};

export type Subscription_RootMnet_Ad_Group_LinkArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Ad_Group_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Ad_Group_Link_Order_By>>;
  where?: InputMaybe<Mnet_Ad_Group_Link_Bool_Exp>;
};

export type Subscription_RootMnet_Ad_Group_Link_By_PkArgs = {
  name: Scalars['String']['input'];
  objectguid: Scalars['uuid']['input'];
  priority: Scalars['Int']['input'];
};

export type Subscription_RootMnet_Ad_Group_Link_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Ad_Group_Link_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Ad_Group_Link_Bool_Exp>;
};

export type Subscription_RootMnet_Assignmentportal_My_AvailabilityArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Assignmentportal_My_Availability_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Assignmentportal_My_Availability_Order_By>>;
  where?: InputMaybe<Mnet_Assignmentportal_My_Availability_Bool_Exp>;
};

export type Subscription_RootMnet_Assignmentportal_My_Availability_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Assignmentportal_My_Availability_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Assignmentportal_My_Availability_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Assignmentportal_My_Availability_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Attachments_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Attachments_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Attachments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Blog_Attachments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Blog_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Blog_Attachments_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_BlogsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Blogs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Blogs_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Blogs_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Blogs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Blog_Blogs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Blog_Blogs_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Blog_Blogs_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Channel_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Channel_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Channel_Notifications_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Channel_Notifications_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Channel_Notifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Blog_Channel_Notifications_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Blog_Channel_Notifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Blog_Channel_Notifications_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_ChannelsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Channels_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Channels_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Channels_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Blog_Channels_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Blog_Channels_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Blog_Channels_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Comment_ReactionsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Comment_Reactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Comment_Reactions_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Comment_Reactions_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Comment_Reactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Blog_Comment_Reactions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Blog_Comment_Reactions_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Blog_Comment_Reactions_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Comments_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Comments_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Comments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Blog_Comments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Blog_Comments_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Blog_Comments_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Email_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Email_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Email_Notifications_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Email_Notifications_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Email_Notifications_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Blog_Email_Notifications_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Blog_Email_Notifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Blog_Email_Notifications_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Email_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Email_Templates_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Email_Templates_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Email_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Blog_Email_Templates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Blog_Email_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Blog_Email_Templates_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_EventsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Events_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Events_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Events_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Blog_Events_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Blog_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Blog_Events_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Group_In_BlogsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Group_In_Blogs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Group_In_Blogs_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Group_In_Blogs_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Group_In_Blogs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Blog_Group_In_Blogs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Blog_Group_In_Blogs_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Blog_Group_In_Blogs_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Inbound_EmailsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Inbound_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Inbound_Emails_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Inbound_Emails_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Inbound_Emails_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Blog_Inbound_Emails_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Blog_Inbound_Emails_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Blog_Inbound_Emails_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Notification_RecipientsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Notification_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Notification_Recipients_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Notification_Recipients_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Notification_Recipients_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Blog_Notification_Recipients_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Blog_Notification_Recipients_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Blog_Notification_Recipients_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Notification_Template_RulesArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Notification_Template_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Notification_Template_Rules_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Notification_Template_Rules_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Blog_Notification_Template_Rules_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Blog_Notification_Template_Rules_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Blog_Notification_Template_Rules_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Post_ChannelsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Post_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Post_Channels_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Post_Channels_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Post_Channels_By_PkArgs = {
  channel_id: Scalars['uuid']['input'];
  post_id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Blog_Post_Channels_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Blog_Post_Channels_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Blog_Post_Channels_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Post_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Post_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Post_Images_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Post_Images_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Post_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Blog_Post_Images_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Blog_Post_Images_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Blog_Post_Images_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Post_ReactionsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Post_Reactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Post_Reactions_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Post_Reactions_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Post_Reactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Blog_Post_Reactions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Blog_Post_Reactions_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Blog_Post_Reactions_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_PostsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Posts_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Posts_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Posts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Blog_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Blog_Posts_Order_By>>;
  where?: InputMaybe<Mnet_Blog_Posts_Bool_Exp>;
};

export type Subscription_RootMnet_Blog_Posts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Blog_Posts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Blog_Posts_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Blog_Posts_Bool_Exp>;
};

export type Subscription_RootMnet_Business_Chemistry_TypeArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Business_Chemistry_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Business_Chemistry_Type_Order_By>>;
  where?: InputMaybe<Mnet_Business_Chemistry_Type_Bool_Exp>;
};

export type Subscription_RootMnet_Business_Chemistry_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Business_Chemistry_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Business_Chemistry_Type_Order_By>>;
  where?: InputMaybe<Mnet_Business_Chemistry_Type_Bool_Exp>;
};

export type Subscription_RootMnet_Business_Chemistry_Type_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Business_Chemistry_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Business_Chemistry_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Business_Chemistry_Type_Bool_Exp>;
};

export type Subscription_RootMnet_Client_Intel_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Client_Intel_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Client_Intel_Settings_Order_By>>;
  where?: InputMaybe<Mnet_Client_Intel_Settings_Bool_Exp>;
};

export type Subscription_RootMnet_Client_Intel_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Client_Intel_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Client_Intel_Settings_Order_By>>;
  where?: InputMaybe<Mnet_Client_Intel_Settings_Bool_Exp>;
};

export type Subscription_RootMnet_Client_Intel_Settings_By_PkArgs = {
  client_or_related_client_id: Scalars['String']['input'];
};

export type Subscription_RootMnet_Client_Intel_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Client_Intel_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Client_Intel_Settings_Bool_Exp>;
};

export type Subscription_RootMnet_Client_Manzama_Alert_Summary_CountsArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Client_Manzama_Alert_Summary_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Client_Manzama_Alert_Summary_Counts_Order_By>>;
  where?: InputMaybe<Mnet_Client_Manzama_Alert_Summary_Counts_Bool_Exp>;
};

export type Subscription_RootMnet_Client_Manzama_Alert_Summary_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Client_Manzama_Alert_Summary_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Client_Manzama_Alert_Summary_Counts_Order_By>>;
  where?: InputMaybe<Mnet_Client_Manzama_Alert_Summary_Counts_Bool_Exp>;
};

export type Subscription_RootMnet_Client_Manzama_Alert_Summary_Counts_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Subscription_RootMnet_Client_Manzama_Alert_Summary_Counts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Client_Manzama_Alert_Summary_Counts_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Client_Manzama_Alert_Summary_Counts_Bool_Exp>;
};

export type Subscription_RootMnet_Client_Manzama_ArticleArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Client_Manzama_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Client_Manzama_Article_Order_By>>;
  where?: InputMaybe<Mnet_Client_Manzama_Article_Bool_Exp>;
};

export type Subscription_RootMnet_Client_Manzama_Article_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Client_Manzama_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Client_Manzama_Article_Order_By>>;
  where?: InputMaybe<Mnet_Client_Manzama_Article_Bool_Exp>;
};

export type Subscription_RootMnet_Client_Manzama_Article_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Subscription_RootMnet_Client_Manzama_Article_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Client_Manzama_Article_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Client_Manzama_Article_Category_Order_By>>;
  where?: InputMaybe<Mnet_Client_Manzama_Article_Category_Bool_Exp>;
};

export type Subscription_RootMnet_Client_Manzama_Article_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Client_Manzama_Article_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Client_Manzama_Article_Category_Order_By>>;
  where?: InputMaybe<Mnet_Client_Manzama_Article_Category_Bool_Exp>;
};

export type Subscription_RootMnet_Client_Manzama_Article_Category_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Subscription_RootMnet_Client_Manzama_Article_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Client_Manzama_Article_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Client_Manzama_Article_Category_Bool_Exp>;
};

export type Subscription_RootMnet_Client_Manzama_Article_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Client_Manzama_Article_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Client_Manzama_Article_Bool_Exp>;
};

export type Subscription_RootMnet_Client_Manzama_Http_ResponseArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Client_Manzama_Http_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Client_Manzama_Http_Response_Order_By>>;
  where?: InputMaybe<Mnet_Client_Manzama_Http_Response_Bool_Exp>;
};

export type Subscription_RootMnet_Client_Manzama_Http_Response_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Client_Manzama_Http_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Client_Manzama_Http_Response_Order_By>>;
  where?: InputMaybe<Mnet_Client_Manzama_Http_Response_Bool_Exp>;
};

export type Subscription_RootMnet_Client_Manzama_Http_Response_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Subscription_RootMnet_Client_Manzama_Http_Response_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Client_Manzama_Http_Response_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Client_Manzama_Http_Response_Bool_Exp>;
};

export type Subscription_RootMnet_Clientbadge_BadgeArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Badge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Badge_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Badge_Bool_Exp>;
};

export type Subscription_RootMnet_Clientbadge_Badge_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Badge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Badge_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Badge_Bool_Exp>;
};

export type Subscription_RootMnet_Clientbadge_Badge_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Clientbadge_Badge_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Badge_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Badge_Category_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Badge_Category_Bool_Exp>;
};

export type Subscription_RootMnet_Clientbadge_Badge_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Badge_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Badge_Category_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Badge_Category_Bool_Exp>;
};

export type Subscription_RootMnet_Clientbadge_Badge_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Clientbadge_Badge_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Clientbadge_Badge_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Clientbadge_Badge_Category_Bool_Exp>;
};

export type Subscription_RootMnet_Clientbadge_Badge_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Clientbadge_Badge_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Clientbadge_Badge_Bool_Exp>;
};

export type Subscription_RootMnet_Clientbadge_ClientArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Client_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Client_Bool_Exp>;
};

export type Subscription_RootMnet_Clientbadge_Client_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Client_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Client_Bool_Exp>;
};

export type Subscription_RootMnet_Clientbadge_Client_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Clientbadge_Client_ExclusionArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Client_Exclusion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Client_Exclusion_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Client_Exclusion_Bool_Exp>;
};

export type Subscription_RootMnet_Clientbadge_Client_Exclusion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Client_Exclusion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Client_Exclusion_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Client_Exclusion_Bool_Exp>;
};

export type Subscription_RootMnet_Clientbadge_Client_Exclusion_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Clientbadge_Client_Exclusion_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Clientbadge_Client_Exclusion_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Clientbadge_Client_Exclusion_Bool_Exp>;
};

export type Subscription_RootMnet_Clientbadge_Client_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Clientbadge_Client_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Clientbadge_Client_Bool_Exp>;
};

export type Subscription_RootMnet_Clientbadge_Related_ClientArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Related_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Related_Client_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Related_Client_Bool_Exp>;
};

export type Subscription_RootMnet_Clientbadge_Related_Client_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Clientbadge_Related_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Clientbadge_Related_Client_Order_By>>;
  where?: InputMaybe<Mnet_Clientbadge_Related_Client_Bool_Exp>;
};

export type Subscription_RootMnet_Clientbadge_Related_Client_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Clientbadge_Related_Client_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Clientbadge_Related_Client_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Clientbadge_Related_Client_Bool_Exp>;
};

export type Subscription_RootMnet_Foundation_MatterArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Foundation_Matter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Foundation_Matter_Order_By>>;
  where?: InputMaybe<Mnet_Foundation_Matter_Bool_Exp>;
};

export type Subscription_RootMnet_Foundation_Matter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Foundation_Matter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Foundation_Matter_Order_By>>;
  where?: InputMaybe<Mnet_Foundation_Matter_Bool_Exp>;
};

export type Subscription_RootMnet_Foundation_Matter_By_PkArgs = {
  foundation_matter_id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Foundation_Matter_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Foundation_Matter_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Foundation_Matter_Bool_Exp>;
};

export type Subscription_RootMnet_Mytools_Catalog_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_Catalog_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_Catalog_Category_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_Catalog_Category_Bool_Exp>;
};

export type Subscription_RootMnet_Mytools_Catalog_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_Catalog_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_Catalog_Category_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_Catalog_Category_Bool_Exp>;
};

export type Subscription_RootMnet_Mytools_Catalog_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Mytools_Catalog_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Mytools_Catalog_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Mytools_Catalog_Category_Bool_Exp>;
};

export type Subscription_RootMnet_Mytools_Catalog_ToolArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_Catalog_Tool_Bool_Exp>;
};

export type Subscription_RootMnet_Mytools_Catalog_Tool_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_Catalog_Tool_Bool_Exp>;
};

export type Subscription_RootMnet_Mytools_Catalog_Tool_AssignmentArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Assignment_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_Catalog_Tool_Assignment_Bool_Exp>;
};

export type Subscription_RootMnet_Mytools_Catalog_Tool_Assignment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Assignment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_Catalog_Tool_Assignment_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_Catalog_Tool_Assignment_Bool_Exp>;
};

export type Subscription_RootMnet_Mytools_Catalog_Tool_Assignment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Mytools_Catalog_Tool_Assignment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Mytools_Catalog_Tool_Assignment_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Mytools_Catalog_Tool_Assignment_Bool_Exp>;
};

export type Subscription_RootMnet_Mytools_Catalog_Tool_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Mytools_Catalog_Tool_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Mytools_Catalog_Tool_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Mytools_Catalog_Tool_Bool_Exp>;
};

export type Subscription_RootMnet_Mytools_User_ToolArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_User_Tool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_User_Tool_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_User_Tool_Bool_Exp>;
};

export type Subscription_RootMnet_Mytools_User_Tool_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Mytools_User_Tool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Mytools_User_Tool_Order_By>>;
  where?: InputMaybe<Mnet_Mytools_User_Tool_Bool_Exp>;
};

export type Subscription_RootMnet_Mytools_User_Tool_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Mytools_User_Tool_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Mytools_User_Tool_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Mytools_User_Tool_Bool_Exp>;
};

export type Subscription_RootMnet_Office_DetailArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Office_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Office_Detail_Order_By>>;
  where?: InputMaybe<Mnet_Office_Detail_Bool_Exp>;
};

export type Subscription_RootMnet_Office_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Office_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Office_Detail_Order_By>>;
  where?: InputMaybe<Mnet_Office_Detail_Bool_Exp>;
};

export type Subscription_RootMnet_Office_Detail_By_PkArgs = {
  office_code: Scalars['String']['input'];
};

export type Subscription_RootMnet_Office_Detail_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Office_Detail_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Office_Detail_Bool_Exp>;
};

export type Subscription_RootMnet_Person_Business_Chemistry_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Person_Business_Chemistry_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Person_Business_Chemistry_Profile_Order_By>>;
  where?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Bool_Exp>;
};

export type Subscription_RootMnet_Person_Business_Chemistry_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Person_Business_Chemistry_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Person_Business_Chemistry_Profile_Order_By>>;
  where?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Bool_Exp>;
};

export type Subscription_RootMnet_Person_Business_Chemistry_Profile_By_PkArgs = {
  ad_system_id: Scalars['String']['input'];
};

export type Subscription_RootMnet_Person_Business_Chemistry_Profile_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Person_Business_Chemistry_Profile_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Person_Business_Chemistry_Profile_Bool_Exp>;
};

export type Subscription_RootMnet_Personnel_Profile_BadgesArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Personnel_Profile_Badges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Personnel_Profile_Badges_Order_By>>;
  where?: InputMaybe<Mnet_Personnel_Profile_Badges_Bool_Exp>;
};

export type Subscription_RootMnet_Personnel_Profile_Badges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Personnel_Profile_Badges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Personnel_Profile_Badges_Order_By>>;
  where?: InputMaybe<Mnet_Personnel_Profile_Badges_Bool_Exp>;
};

export type Subscription_RootMnet_Personnel_Profile_Badges_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Subscription_RootMnet_Personnel_Profile_Badges_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Personnel_Profile_Badges_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Personnel_Profile_Badges_Bool_Exp>;
};

export type Subscription_RootMnet_Practice_Area_DetailArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Practice_Area_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Practice_Area_Detail_Order_By>>;
  where?: InputMaybe<Mnet_Practice_Area_Detail_Bool_Exp>;
};

export type Subscription_RootMnet_Practice_Area_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Practice_Area_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Practice_Area_Detail_Order_By>>;
  where?: InputMaybe<Mnet_Practice_Area_Detail_Bool_Exp>;
};

export type Subscription_RootMnet_Practice_Area_Detail_By_PkArgs = {
  practice_area_code: Scalars['String']['input'];
};

export type Subscription_RootMnet_Practice_Area_Detail_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Practice_Area_Detail_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Practice_Area_Detail_Bool_Exp>;
};

export type Subscription_RootMnet_Practice_Group_DetailArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Practice_Group_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Practice_Group_Detail_Order_By>>;
  where?: InputMaybe<Mnet_Practice_Group_Detail_Bool_Exp>;
};

export type Subscription_RootMnet_Practice_Group_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Practice_Group_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Practice_Group_Detail_Order_By>>;
  where?: InputMaybe<Mnet_Practice_Group_Detail_Bool_Exp>;
};

export type Subscription_RootMnet_Practice_Group_Detail_By_PkArgs = {
  practice_group_code: Scalars['String']['input'];
};

export type Subscription_RootMnet_Practice_Group_Detail_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Practice_Group_Detail_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Practice_Group_Detail_Bool_Exp>;
};

export type Subscription_RootMnet_User_LinkArgs = {
  distinct_on?: InputMaybe<Array<Mnet_User_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_User_Link_Order_By>>;
  where?: InputMaybe<Mnet_User_Link_Bool_Exp>;
};

export type Subscription_RootMnet_User_Link_By_PkArgs = {
  name: Scalars['String']['input'];
};

export type Subscription_RootMnet_User_Link_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_User_Link_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_User_Link_Bool_Exp>;
};

export type Subscription_RootMnet_Wellable_LeaderboardArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Wellable_Leaderboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Wellable_Leaderboard_Order_By>>;
  where?: InputMaybe<Mnet_Wellable_Leaderboard_Bool_Exp>;
};

export type Subscription_RootMnet_Wellable_Leaderboard_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mnet_Wellable_Leaderboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mnet_Wellable_Leaderboard_Order_By>>;
  where?: InputMaybe<Mnet_Wellable_Leaderboard_Bool_Exp>;
};

export type Subscription_RootMnet_Wellable_Leaderboard_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootMnet_Wellable_Leaderboard_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mnet_Wellable_Leaderboard_Stream_Cursor_Input>>;
  where?: InputMaybe<Mnet_Wellable_Leaderboard_Bool_Exp>;
};

export type Subscription_RootPbc_Counsel_RepresentativesArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Counsel_Representatives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Counsel_Representatives_Order_By>>;
  where?: InputMaybe<Pbc_Counsel_Representatives_Bool_Exp>;
};

export type Subscription_RootPbc_Counsel_Representatives_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Counsel_Representatives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Counsel_Representatives_Order_By>>;
  where?: InputMaybe<Pbc_Counsel_Representatives_Bool_Exp>;
};

export type Subscription_RootPbc_Counsel_Representatives_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootPbc_Counsel_Representatives_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pbc_Counsel_Representatives_Stream_Cursor_Input>>;
  where?: InputMaybe<Pbc_Counsel_Representatives_Bool_Exp>;
};

export type Subscription_RootPbc_Email_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Email_Templates_Order_By>>;
  where?: InputMaybe<Pbc_Email_Templates_Bool_Exp>;
};

export type Subscription_RootPbc_Email_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Email_Templates_Order_By>>;
  where?: InputMaybe<Pbc_Email_Templates_Bool_Exp>;
};

export type Subscription_RootPbc_Email_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootPbc_Email_Templates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pbc_Email_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Pbc_Email_Templates_Bool_Exp>;
};

export type Subscription_RootPbc_Exempt_UsersArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Exempt_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Exempt_Users_Order_By>>;
  where?: InputMaybe<Pbc_Exempt_Users_Bool_Exp>;
};

export type Subscription_RootPbc_Exempt_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Exempt_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Exempt_Users_Order_By>>;
  where?: InputMaybe<Pbc_Exempt_Users_Bool_Exp>;
};

export type Subscription_RootPbc_Exempt_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootPbc_Exempt_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pbc_Exempt_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Pbc_Exempt_Users_Bool_Exp>;
};

export type Subscription_RootPbc_Notification_RecipientsArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Notification_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Notification_Recipients_Order_By>>;
  where?: InputMaybe<Pbc_Notification_Recipients_Bool_Exp>;
};

export type Subscription_RootPbc_Notification_Recipients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Notification_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Notification_Recipients_Order_By>>;
  where?: InputMaybe<Pbc_Notification_Recipients_Bool_Exp>;
};

export type Subscription_RootPbc_Notification_Recipients_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootPbc_Notification_Recipients_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pbc_Notification_Recipients_Stream_Cursor_Input>>;
  where?: InputMaybe<Pbc_Notification_Recipients_Bool_Exp>;
};

export type Subscription_RootPbc_Notification_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Notification_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Notification_Requests_Order_By>>;
  where?: InputMaybe<Pbc_Notification_Requests_Bool_Exp>;
};

export type Subscription_RootPbc_Notification_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Notification_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Notification_Requests_Order_By>>;
  where?: InputMaybe<Pbc_Notification_Requests_Bool_Exp>;
};

export type Subscription_RootPbc_Notification_Requests_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootPbc_Notification_Requests_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pbc_Notification_Requests_Stream_Cursor_Input>>;
  where?: InputMaybe<Pbc_Notification_Requests_Bool_Exp>;
};

export type Subscription_RootPbc_Notification_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Notification_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Notification_Statuses_Order_By>>;
  where?: InputMaybe<Pbc_Notification_Statuses_Bool_Exp>;
};

export type Subscription_RootPbc_Notification_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Notification_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Notification_Statuses_Order_By>>;
  where?: InputMaybe<Pbc_Notification_Statuses_Bool_Exp>;
};

export type Subscription_RootPbc_Notification_Statuses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootPbc_Notification_Statuses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pbc_Notification_Statuses_Stream_Cursor_Input>>;
  where?: InputMaybe<Pbc_Notification_Statuses_Bool_Exp>;
};

export type Subscription_RootPbc_SendersArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Senders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Senders_Order_By>>;
  where?: InputMaybe<Pbc_Senders_Bool_Exp>;
};

export type Subscription_RootPbc_Senders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pbc_Senders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pbc_Senders_Order_By>>;
  where?: InputMaybe<Pbc_Senders_Bool_Exp>;
};

export type Subscription_RootPbc_Senders_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootPbc_Senders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pbc_Senders_Stream_Cursor_Input>>;
  where?: InputMaybe<Pbc_Senders_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** Boolean expression to compare columns of type "uniqueidentifier". All fields are combined with logical 'AND'. */
export type Uniqueidentifier_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uniqueidentifier']['input']>;
  _gt?: InputMaybe<Scalars['uniqueidentifier']['input']>;
  _gte?: InputMaybe<Scalars['uniqueidentifier']['input']>;
  _in?: InputMaybe<Array<Scalars['uniqueidentifier']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uniqueidentifier']['input']>;
  _lte?: InputMaybe<Scalars['uniqueidentifier']['input']>;
  _neq?: InputMaybe<Scalars['uniqueidentifier']['input']>;
  _nin?: InputMaybe<Array<Scalars['uniqueidentifier']['input']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** Boolean expression to compare columns of type "varbinary". All fields are combined with logical 'AND'. */
export type Varbinary_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['varbinary']['input']>;
  _gt?: InputMaybe<Scalars['varbinary']['input']>;
  _gte?: InputMaybe<Scalars['varbinary']['input']>;
  _in?: InputMaybe<Array<Scalars['varbinary']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['varbinary']['input']>;
  _lte?: InputMaybe<Scalars['varbinary']['input']>;
  _neq?: InputMaybe<Scalars['varbinary']['input']>;
  _nin?: InputMaybe<Array<Scalars['varbinary']['input']>>;
};

export type AddEngagementRecordMutationVariables = Exact<{
  client_number: Scalars['String']['input'];
  created_by: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  updated_by: Scalars['String']['input'];
}>;

export type AddEngagementRecordMutation = { insert_clm_engagement_records_one?: { id: string } | null };

export type AddEngagementDocumentMutationVariables = Exact<{
  engagement_records_id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  doc_id: Scalars['String']['input'];
  created_by: Scalars['String']['input'];
  updated_by: Scalars['String']['input'];
}>;

export type AddEngagementDocumentMutation = {
  insert_clm_engagement_imanage_documents_one?: {
    id: string;
    name: string;
    doc_id: string;
    created_at: string;
    created_by: string;
    updated_at: string;
    updated_by: string;
  } | null;
};

export type UpdateEngagementDocumentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  doc_id: Scalars['String']['input'];
  updated_by: Scalars['String']['input'];
}>;

export type UpdateEngagementDocumentMutation = {
  update_clm_engagement_imanage_documents_by_pk?: {
    id: string;
    name: string;
    doc_id: string;
    created_at: string;
    created_by: string;
    updated_at: string;
    updated_by: string;
  } | null;
};

export type DeleteEngagementDocumentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;

export type DeleteEngagementDocumentMutation = {
  delete_clm_engagement_imanage_documents_by_pk?: {
    id: string;
    name: string;
    doc_id: string;
    created_at: string;
    created_by: string;
    updated_at: string;
    updated_by: string;
  } | null;
};

export type AddEngagementCommentMutationVariables = Exact<{
  engagement_records_id: Scalars['uuid']['input'];
  comments: Scalars['String']['input'];
  created_by: Scalars['String']['input'];
  updated_by: Scalars['String']['input'];
}>;

export type AddEngagementCommentMutation = {
  insert_clm_engagement_client_comments_one?: {
    id: string;
    comments: string;
    created_at: string;
    created_by: string;
    updated_at: string;
    updated_by: string;
    updated_by_user?: {
      ActiveDirectoryLogin?: string | null;
      NamePreferredFull?: string | null;
      Email?: string | null;
      TitleFullyQualified?: string | null;
      PrimaryPracticeGroup?: { PracticeGroupName?: string | null } | null;
    } | null;
  } | null;
};

export type UpdateEngagementCommentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  comments: Scalars['String']['input'];
  updated_by: Scalars['String']['input'];
}>;

export type UpdateEngagementCommentMutation = {
  update_clm_engagement_client_comments_by_pk?: {
    id: string;
    comments: string;
    created_at: string;
    created_by: string;
    updated_at: string;
    updated_by: string;
    updated_by_user?: {
      ActiveDirectoryLogin?: string | null;
      NamePreferredFull?: string | null;
      Email?: string | null;
      TitleFullyQualified?: string | null;
      PrimaryPracticeGroup?: { PracticeGroupName?: string | null } | null;
    } | null;
  } | null;
};

export type DeleteEngagementCommentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;

export type DeleteEngagementCommentMutation = {
  delete_clm_engagement_client_comments_by_pk?: {
    id: string;
    comments: string;
    created_at: string;
    created_by: string;
    updated_at: string;
    updated_by: string;
    updated_by_user?: {
      ActiveDirectoryLogin?: string | null;
      NamePreferredFull?: string | null;
      Email?: string | null;
      TitleFullyQualified?: string | null;
      PrimaryPracticeGroup?: { PracticeGroupName?: string | null } | null;
    } | null;
  } | null;
};

export type GetUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserQuery = {
  me?: {
    displayName?: string | null;
    givenName?: string | null;
    surname?: string | null;
    jobTitle?: string | null;
    businessPhones?: Array<string> | null;
    mobilePhone?: string | null;
    officeLocation?: string | null;
    userPrincipalName?: string | null;
    id?: string | null;
    mail?: string | null;
    preferredLanguage?: string | null;
    images: { large?: string | null; medium?: string | null; small?: string | null };
  } | null;
};

export type SearchUserQueryVariables = Exact<{
  searchString: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SearchUserQuery = {
  mlfsl_personnel: Array<{
    NamePreferredDisplay?: string | null;
    Email?: string | null;
    ActiveDirectoryLogin?: string | null;
    BusinessPrimaryOfficePhoneNumberFull?: string | null;
    TitleFullyQualified?: string | null;
    BusinessPrimaryOfficeAddress1?: string | null;
    BusinessPrimaryOffice?: string | null;
    PrimaryPracticeGroup?: { PracticeGroupName?: string | null } | null;
  }>;
};

export type GetFilteredClientRecordsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mlfsl_Client_Order_By> | Mlfsl_Client_Order_By>;
  where?: InputMaybe<Mlfsl_Client_Bool_Exp>;
}>;

export type GetFilteredClientRecordsQuery = {
  mlfsl_client: Array<{
    ClientName1?: string | null;
    ClientNumber: string;
    DateClientClosed?: number | null;
    DateClientOpen?: number | null;
    ResponsibleAttorney?: {
      ActiveDirectoryLogin?: string | null;
      NamePreferredFull?: string | null;
      Email?: string | null;
      TitleFullyQualified?: string | null;
      BusinessPrimaryOfficePhoneNumberFull?: string | null;
      BusinessPrimaryOffice?: string | null;
      PrimaryPracticeGroup?: { SubSubPracticeGroupName?: string | null } | null;
    } | null;
    cmap_clm_engagement_record?: {
      id: string;
      created_at: string;
      type: string;
      updated_at: string;
      created_by_user?: {
        ActiveDirectoryLogin?: string | null;
        NamePreferredFull?: string | null;
        Email?: string | null;
        TitleFullyQualified?: string | null;
        BusinessPrimaryOfficePhoneNumberFull?: string | null;
        BusinessPrimaryOffice?: string | null;
        PrimaryPracticeGroup?: { PracticeGroupName?: string | null } | null;
      } | null;
      updated_by_user?: {
        ActiveDirectoryLogin?: string | null;
        NamePreferredFull?: string | null;
        Email?: string | null;
        TitleFullyQualified?: string | null;
        BusinessPrimaryOfficePhoneNumberFull?: string | null;
        BusinessPrimaryOffice?: string | null;
        PrimaryPracticeGroup?: { PracticeGroupName?: string | null } | null;
      } | null;
      engagement_client_comments: Array<{
        id: string;
        comments: string;
        updated_at: string;
        created_by_user?: {
          ActiveDirectoryLogin?: string | null;
          NamePreferredFull?: string | null;
          Email?: string | null;
          TitleFullyQualified?: string | null;
          BusinessPrimaryOfficePhoneNumberFull?: string | null;
          BusinessPrimaryOffice?: string | null;
          PrimaryPracticeGroup?: { PracticeGroupName?: string | null } | null;
        } | null;
        updated_by_user?: {
          ActiveDirectoryLogin?: string | null;
          NamePreferredFull?: string | null;
          Email?: string | null;
          TitleFullyQualified?: string | null;
          PrimaryPracticeGroup?: { PracticeGroupName?: string | null } | null;
        } | null;
      }>;
      engagement_imanage_documents: Array<{
        id: string;
        doc_id: string;
        name: string;
        updated_at: string;
        updated_by_user?: {
          ActiveDirectoryLogin?: string | null;
          NamePreferredFull?: string | null;
          Email?: string | null;
          TitleFullyQualified?: string | null;
          PrimaryPracticeGroup?: { PracticeGroupName?: string | null } | null;
        } | null;
      }>;
    } | null;
  }>;
};

export type GetClientRecordsListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mlfsl_Client_Bool_Exp>;
}>;

export type GetClientRecordsListQuery = {
  mlfsl_client: Array<{
    ClientName1?: string | null;
    ClientNumber: string;
    DateClientClosed?: number | null;
    DateClientOpen?: number | null;
    ResponsibleAttorney?: {
      NamePreferredFull?: string | null;
      PrimaryPracticeGroup?: { SubSubPracticeGroupName?: string | null } | null;
    } | null;
  }>;
};

export type GetEngagementRecordsListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Clm_Engagement_Records_Bool_Exp>;
}>;

export type GetEngagementRecordsListQuery = {
  clm_engagement_records: Array<{
    id: string;
    client_number: string;
    created_at: string;
    updated_at: string;
    engagement_imanage_documents: Array<{ doc_id: string }>;
  }>;
};

export type GetPaginatedDocumentsQueryVariables = Exact<{
  clientNumber: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Clm_Engagement_Imanage_Documents_Bool_Exp>;
}>;

export type GetPaginatedDocumentsQuery = {
  mlfsl_client: Array<{
    cmap_clm_engagement_record?: {
      engagement_imanage_documents_aggregate: { aggregate?: { count: number } | null };
      engagement_imanage_documents: Array<{ id: string; doc_id: string; name: string }>;
    } | null;
  }>;
};

export type GetWaiverRecordsListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Clm_Waiver_Records_Bool_Exp>;
}>;

export type GetWaiverRecordsListQuery = {
  clm_waiver_records: Array<{
    id: string;
    matter_number?: string | null;
    client_number?: string | null;
    adverse_client_name?: string | null;
    adverse_contact_signer?: string | null;
    adverse_letter_date?: string | null;
    adverse_mlb_attorney_on_letter_name?: string | null;
    client_contact?: string | null;
    client_letter_date?: string | null;
    mlb_attorney_on_client_letter_name?: string | null;
    multiple_waivers?: string | null;
    mlfsl_client?: { ClientName1?: string | null } | null;
  }>;
};

export type GetPaginatedWaiverDocumentsQueryVariables = Exact<{
  waiverRecordId: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Clm_Waiver_Imanage_Documents_Bool_Exp>;
}>;

export type GetPaginatedWaiverDocumentsQuery = {
  clm_waiver_records: Array<{
    waiver_imanage_documents_aggregate: { aggregate?: { count: number } | null };
    waiver_imanage_documents: Array<{
      id: string;
      doc_id: string;
      name: string;
      created_at: string;
      updated_at: string;
      waiver_records_id: string;
    }>;
  }>;
};

export type GetWaiverRecordQueryVariables = Exact<{
  waiver_id: Scalars['uuid']['input'];
}>;

export type GetWaiverRecordQuery = {
  clm_waiver_records_by_pk?: {
    id: string;
    matter_number?: string | null;
    client_number?: string | null;
    client_contact?: string | null;
    client_letter_date?: string | null;
    mlb_attorney_on_client_letter_name?: string | null;
    adverse_mlb_attorney_on_letter_name?: string | null;
    adverse_client_name?: string | null;
    adverse_contact_signer?: string | null;
    adverse_letter_date?: string | null;
    multiple_waivers?: string | null;
    comments?: string | null;
    created_at: string;
    updated_at: string;
    created_by_user?: {
      ActiveDirectoryLogin?: string | null;
      NamePreferredFull?: string | null;
      Email?: string | null;
    } | null;
    updated_by_user?: {
      ActiveDirectoryLogin?: string | null;
      NamePreferredFull?: string | null;
      Email?: string | null;
    } | null;
    mlfsl_client?: { ClientName1?: string | null } | null;
  } | null;
};

export const AddEngagementRecordDocument = gql`
  mutation AddEngagementRecord(
    $client_number: String!
    $created_by: String!
    $type: String = "EL"
    $updated_by: String!
  ) {
    insert_clm_engagement_records_one(
      object: { client_number: $client_number, created_by: $created_by, type: $type, updated_by: $updated_by }
    ) {
      id
    }
  }
`;
export type AddEngagementRecordMutationFn = ApolloReactHooks.useMutation.MutationFunction<
  AddEngagementRecordMutation,
  AddEngagementRecordMutationVariables
>;

/**
 * __useAddEngagementRecordMutation__
 *
 * To run a mutation, you first call `useAddEngagementRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEngagementRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEngagementRecordMutation, { data, loading, error }] = useAddEngagementRecordMutation({
 *   variables: {
 *      client_number: // value for 'client_number'
 *      created_by: // value for 'created_by'
 *      type: // value for 'type'
 *      updated_by: // value for 'updated_by'
 *   },
 * });
 */
export function useAddEngagementRecordMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AddEngagementRecordMutation, AddEngagementRecordMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<AddEngagementRecordMutation, AddEngagementRecordMutationVariables>(
    AddEngagementRecordDocument,
    options,
  );
}
export type AddEngagementRecordMutationHookResult = ReturnType<typeof useAddEngagementRecordMutation>;
export type AddEngagementRecordMutationResult = ApolloReactHooks.MutationResult<AddEngagementRecordMutation>;
export type AddEngagementRecordMutationOptions = ApolloReactHooks.MutationHookOptions<
  AddEngagementRecordMutation,
  AddEngagementRecordMutationVariables
>;
export const AddEngagementDocumentDocument = gql`
  mutation AddEngagementDocument(
    $engagement_records_id: uuid!
    $name: String!
    $doc_id: String!
    $created_by: String!
    $updated_by: String!
  ) {
    insert_clm_engagement_imanage_documents_one(
      object: {
        engagement_records_id: $engagement_records_id
        name: $name
        doc_id: $doc_id
        created_by: $created_by
        updated_by: $updated_by
      }
    ) {
      id
      name
      doc_id
      created_at
      created_by
      updated_at
      updated_by
    }
  }
`;
export type AddEngagementDocumentMutationFn = ApolloReactHooks.useMutation.MutationFunction<
  AddEngagementDocumentMutation,
  AddEngagementDocumentMutationVariables
>;

/**
 * __useAddEngagementDocumentMutation__
 *
 * To run a mutation, you first call `useAddEngagementDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEngagementDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEngagementDocumentMutation, { data, loading, error }] = useAddEngagementDocumentMutation({
 *   variables: {
 *      engagement_records_id: // value for 'engagement_records_id'
 *      name: // value for 'name'
 *      doc_id: // value for 'doc_id'
 *      created_by: // value for 'created_by'
 *      updated_by: // value for 'updated_by'
 *   },
 * });
 */
export function useAddEngagementDocumentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddEngagementDocumentMutation,
    AddEngagementDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<AddEngagementDocumentMutation, AddEngagementDocumentMutationVariables>(
    AddEngagementDocumentDocument,
    options,
  );
}
export type AddEngagementDocumentMutationHookResult = ReturnType<typeof useAddEngagementDocumentMutation>;
export type AddEngagementDocumentMutationResult = ApolloReactHooks.MutationResult<AddEngagementDocumentMutation>;
export type AddEngagementDocumentMutationOptions = ApolloReactHooks.MutationHookOptions<
  AddEngagementDocumentMutation,
  AddEngagementDocumentMutationVariables
>;
export const UpdateEngagementDocumentDocument = gql`
  mutation UpdateEngagementDocument($id: uuid!, $name: String!, $doc_id: String!, $updated_by: String!) {
    update_clm_engagement_imanage_documents_by_pk(
      pk_columns: { id: $id }
      _set: { name: $name, doc_id: $doc_id, updated_by: $updated_by }
    ) {
      id
      name
      doc_id
      created_at
      created_by
      updated_at
      updated_by
    }
  }
`;
export type UpdateEngagementDocumentMutationFn = ApolloReactHooks.useMutation.MutationFunction<
  UpdateEngagementDocumentMutation,
  UpdateEngagementDocumentMutationVariables
>;

/**
 * __useUpdateEngagementDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateEngagementDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEngagementDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEngagementDocumentMutation, { data, loading, error }] = useUpdateEngagementDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      doc_id: // value for 'doc_id'
 *      updated_by: // value for 'updated_by'
 *   },
 * });
 */
export function useUpdateEngagementDocumentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateEngagementDocumentMutation,
    UpdateEngagementDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<UpdateEngagementDocumentMutation, UpdateEngagementDocumentMutationVariables>(
    UpdateEngagementDocumentDocument,
    options,
  );
}
export type UpdateEngagementDocumentMutationHookResult = ReturnType<typeof useUpdateEngagementDocumentMutation>;
export type UpdateEngagementDocumentMutationResult = ApolloReactHooks.MutationResult<UpdateEngagementDocumentMutation>;
export type UpdateEngagementDocumentMutationOptions = ApolloReactHooks.MutationHookOptions<
  UpdateEngagementDocumentMutation,
  UpdateEngagementDocumentMutationVariables
>;
export const DeleteEngagementDocumentDocument = gql`
  mutation DeleteEngagementDocument($id: uuid!) {
    delete_clm_engagement_imanage_documents_by_pk(id: $id) {
      id
      name
      doc_id
      created_at
      created_by
      updated_at
      updated_by
    }
  }
`;
export type DeleteEngagementDocumentMutationFn = ApolloReactHooks.useMutation.MutationFunction<
  DeleteEngagementDocumentMutation,
  DeleteEngagementDocumentMutationVariables
>;

/**
 * __useDeleteEngagementDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteEngagementDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEngagementDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEngagementDocumentMutation, { data, loading, error }] = useDeleteEngagementDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEngagementDocumentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteEngagementDocumentMutation,
    DeleteEngagementDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<DeleteEngagementDocumentMutation, DeleteEngagementDocumentMutationVariables>(
    DeleteEngagementDocumentDocument,
    options,
  );
}
export type DeleteEngagementDocumentMutationHookResult = ReturnType<typeof useDeleteEngagementDocumentMutation>;
export type DeleteEngagementDocumentMutationResult = ApolloReactHooks.MutationResult<DeleteEngagementDocumentMutation>;
export type DeleteEngagementDocumentMutationOptions = ApolloReactHooks.MutationHookOptions<
  DeleteEngagementDocumentMutation,
  DeleteEngagementDocumentMutationVariables
>;
export const AddEngagementCommentDocument = gql`
  mutation AddEngagementComment(
    $engagement_records_id: uuid!
    $comments: String!
    $created_by: String!
    $updated_by: String!
  ) {
    insert_clm_engagement_client_comments_one(
      object: {
        engagement_records_id: $engagement_records_id
        comments: $comments
        created_by: $created_by
        updated_by: $updated_by
      }
    ) {
      id
      comments
      created_at
      created_by
      updated_at
      updated_by
      updated_by_user {
        ActiveDirectoryLogin
        NamePreferredFull
        Email
        TitleFullyQualified
        PrimaryPracticeGroup {
          PracticeGroupName
        }
      }
    }
  }
`;
export type AddEngagementCommentMutationFn = ApolloReactHooks.useMutation.MutationFunction<
  AddEngagementCommentMutation,
  AddEngagementCommentMutationVariables
>;

/**
 * __useAddEngagementCommentMutation__
 *
 * To run a mutation, you first call `useAddEngagementCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEngagementCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEngagementCommentMutation, { data, loading, error }] = useAddEngagementCommentMutation({
 *   variables: {
 *      engagement_records_id: // value for 'engagement_records_id'
 *      comments: // value for 'comments'
 *      created_by: // value for 'created_by'
 *      updated_by: // value for 'updated_by'
 *   },
 * });
 */
export function useAddEngagementCommentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddEngagementCommentMutation,
    AddEngagementCommentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<AddEngagementCommentMutation, AddEngagementCommentMutationVariables>(
    AddEngagementCommentDocument,
    options,
  );
}
export type AddEngagementCommentMutationHookResult = ReturnType<typeof useAddEngagementCommentMutation>;
export type AddEngagementCommentMutationResult = ApolloReactHooks.MutationResult<AddEngagementCommentMutation>;
export type AddEngagementCommentMutationOptions = ApolloReactHooks.MutationHookOptions<
  AddEngagementCommentMutation,
  AddEngagementCommentMutationVariables
>;
export const UpdateEngagementCommentDocument = gql`
  mutation UpdateEngagementComment($id: uuid!, $comments: String!, $updated_by: String!) {
    update_clm_engagement_client_comments_by_pk(
      pk_columns: { id: $id }
      _set: { comments: $comments, updated_by: $updated_by }
    ) {
      id
      comments
      created_at
      created_by
      updated_at
      updated_by
      updated_by_user {
        ActiveDirectoryLogin
        NamePreferredFull
        Email
        TitleFullyQualified
        PrimaryPracticeGroup {
          PracticeGroupName
        }
      }
    }
  }
`;
export type UpdateEngagementCommentMutationFn = ApolloReactHooks.useMutation.MutationFunction<
  UpdateEngagementCommentMutation,
  UpdateEngagementCommentMutationVariables
>;

/**
 * __useUpdateEngagementCommentMutation__
 *
 * To run a mutation, you first call `useUpdateEngagementCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEngagementCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEngagementCommentMutation, { data, loading, error }] = useUpdateEngagementCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      comments: // value for 'comments'
 *      updated_by: // value for 'updated_by'
 *   },
 * });
 */
export function useUpdateEngagementCommentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateEngagementCommentMutation,
    UpdateEngagementCommentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<UpdateEngagementCommentMutation, UpdateEngagementCommentMutationVariables>(
    UpdateEngagementCommentDocument,
    options,
  );
}
export type UpdateEngagementCommentMutationHookResult = ReturnType<typeof useUpdateEngagementCommentMutation>;
export type UpdateEngagementCommentMutationResult = ApolloReactHooks.MutationResult<UpdateEngagementCommentMutation>;
export type UpdateEngagementCommentMutationOptions = ApolloReactHooks.MutationHookOptions<
  UpdateEngagementCommentMutation,
  UpdateEngagementCommentMutationVariables
>;
export const DeleteEngagementCommentDocument = gql`
  mutation DeleteEngagementComment($id: uuid!) {
    delete_clm_engagement_client_comments_by_pk(id: $id) {
      id
      comments
      created_at
      created_by
      updated_at
      updated_by
      updated_by_user {
        ActiveDirectoryLogin
        NamePreferredFull
        Email
        TitleFullyQualified
        PrimaryPracticeGroup {
          PracticeGroupName
        }
      }
    }
  }
`;
export type DeleteEngagementCommentMutationFn = ApolloReactHooks.useMutation.MutationFunction<
  DeleteEngagementCommentMutation,
  DeleteEngagementCommentMutationVariables
>;

/**
 * __useDeleteEngagementCommentMutation__
 *
 * To run a mutation, you first call `useDeleteEngagementCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEngagementCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEngagementCommentMutation, { data, loading, error }] = useDeleteEngagementCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEngagementCommentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteEngagementCommentMutation,
    DeleteEngagementCommentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<DeleteEngagementCommentMutation, DeleteEngagementCommentMutationVariables>(
    DeleteEngagementCommentDocument,
    options,
  );
}
export type DeleteEngagementCommentMutationHookResult = ReturnType<typeof useDeleteEngagementCommentMutation>;
export type DeleteEngagementCommentMutationResult = ApolloReactHooks.MutationResult<DeleteEngagementCommentMutation>;
export type DeleteEngagementCommentMutationOptions = ApolloReactHooks.MutationHookOptions<
  DeleteEngagementCommentMutation,
  DeleteEngagementCommentMutationVariables
>;
export const GetUserDocument = gql`
  query GetUser {
    me {
      displayName
      givenName
      surname
      jobTitle
      businessPhones
      mobilePhone
      officeLocation
      userPrincipalName
      images {
        large
        medium
        small
      }
      id
      mail
      preferredLanguage
    }
  }
`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: ApolloReactHooks.useQuery.Options<GetUserQuery, GetUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export function useGetUserLazyQuery(
  baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetUserQuery, GetUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export function useGetUserSuspenseQuery(
  baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetUserQueryVariables>,
): ApolloReactHooks.useSuspenseQuery.Result<GetUserQuery | undefined, GetUserQueryVariables> {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(
    GetUserDocument,
    options,
  ) as ApolloReactHooks.useSuspenseQuery.Result<GetUserQuery | undefined, GetUserQueryVariables>;
}
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = ApolloReactHooks.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const SearchUserDocument = gql`
  query SearchUser($searchString: String!, $limit: Int = 5) {
    mlfsl_personnel(
      where: { NamePreferredDisplay: { _like: $searchString }, ActiveDirectoryDisabledIndicator: { _eq: "N" } }
      limit: $limit
    ) {
      NamePreferredDisplay
      Email
      ActiveDirectoryLogin
      BusinessPrimaryOfficePhoneNumberFull
      TitleFullyQualified
      BusinessPrimaryOfficeAddress1
      BusinessPrimaryOffice
      PrimaryPracticeGroup {
        PracticeGroupName
      }
    }
  }
`;

/**
 * __useSearchUserQuery__
 *
 * To run a query within a React component, call `useSearchUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchUserQuery(
  baseOptions: ApolloReactHooks.useQuery.Options<SearchUserQuery, SearchUserQueryVariables> &
    ({ variables: SearchUserQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, options);
}
export function useSearchUserLazyQuery(
  baseOptions?: ApolloReactHooks.useLazyQuery.Options<SearchUserQuery, SearchUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, options);
}
export function useSearchUserSuspenseQuery(
  baseOptions:
    | ApolloReactHooks.SkipToken
    | (ApolloReactHooks.useSuspenseQuery.Options<SearchUserQueryVariables> & { variables: SearchUserQueryVariables }),
): ApolloReactHooks.useSuspenseQuery.Result<SearchUserQuery | undefined, SearchUserQueryVariables> {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<SearchUserQuery, SearchUserQueryVariables>(
    SearchUserDocument,
    options,
  ) as ApolloReactHooks.useSuspenseQuery.Result<SearchUserQuery | undefined, SearchUserQueryVariables>;
}
export type SearchUserQueryHookResult = ReturnType<typeof useSearchUserQuery>;
export type SearchUserLazyQueryHookResult = ReturnType<typeof useSearchUserLazyQuery>;
export type SearchUserSuspenseQueryHookResult = ReturnType<typeof useSearchUserSuspenseQuery>;
export type SearchUserQueryResult = ApolloReactHooks.QueryResult<SearchUserQuery, SearchUserQueryVariables>;
export const GetFilteredClientRecordsDocument = gql`
  query GetFilteredClientRecords(
    $limit: Int = 50
    $offset: Int = 0
    $order_by: [mlfsl_client_order_by!] = { ClientName1: asc }
    $where: mlfsl_client_bool_exp
  ) {
    mlfsl_client(limit: $limit, order_by: $order_by, offset: $offset, where: $where) {
      ClientName1
      ClientNumber
      ResponsibleAttorney {
        ActiveDirectoryLogin
        NamePreferredFull
        Email
        TitleFullyQualified
        PrimaryPracticeGroup {
          SubSubPracticeGroupName
        }
        BusinessPrimaryOfficePhoneNumberFull
        BusinessPrimaryOffice
      }
      DateClientClosed
      DateClientOpen
      cmap_clm_engagement_record {
        id
        created_at
        created_by_user {
          ActiveDirectoryLogin
          NamePreferredFull
          Email
          TitleFullyQualified
          PrimaryPracticeGroup {
            PracticeGroupName
          }
          BusinessPrimaryOfficePhoneNumberFull
          BusinessPrimaryOffice
        }
        type
        updated_at
        updated_by_user {
          ActiveDirectoryLogin
          NamePreferredFull
          Email
          TitleFullyQualified
          PrimaryPracticeGroup {
            PracticeGroupName
          }
          BusinessPrimaryOfficePhoneNumberFull
          BusinessPrimaryOffice
        }
        engagement_client_comments {
          id
          comments
          created_by_user {
            ActiveDirectoryLogin
            NamePreferredFull
            Email
            TitleFullyQualified
            PrimaryPracticeGroup {
              PracticeGroupName
            }
            BusinessPrimaryOfficePhoneNumberFull
            BusinessPrimaryOffice
          }
          updated_at
          updated_by_user {
            ActiveDirectoryLogin
            NamePreferredFull
            Email
            TitleFullyQualified
            PrimaryPracticeGroup {
              PracticeGroupName
            }
          }
        }
        engagement_imanage_documents {
          id
          doc_id
          name
          updated_at
          updated_by_user {
            ActiveDirectoryLogin
            NamePreferredFull
            Email
            TitleFullyQualified
            PrimaryPracticeGroup {
              PracticeGroupName
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetFilteredClientRecordsQuery__
 *
 * To run a query within a React component, call `useGetFilteredClientRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilteredClientRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilteredClientRecordsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetFilteredClientRecordsQuery(
  baseOptions?: ApolloReactHooks.useQuery.Options<
    GetFilteredClientRecordsQuery,
    GetFilteredClientRecordsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<GetFilteredClientRecordsQuery, GetFilteredClientRecordsQueryVariables>(
    GetFilteredClientRecordsDocument,
    options,
  );
}
export function useGetFilteredClientRecordsLazyQuery(
  baseOptions?: ApolloReactHooks.useLazyQuery.Options<
    GetFilteredClientRecordsQuery,
    GetFilteredClientRecordsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<GetFilteredClientRecordsQuery, GetFilteredClientRecordsQueryVariables>(
    GetFilteredClientRecordsDocument,
    options,
  );
}
export function useGetFilteredClientRecordsSuspenseQuery(
  baseOptions?:
    ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetFilteredClientRecordsQueryVariables>,
): ApolloReactHooks.useSuspenseQuery.Result<
  GetFilteredClientRecordsQuery | undefined,
  GetFilteredClientRecordsQueryVariables
> {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<GetFilteredClientRecordsQuery, GetFilteredClientRecordsQueryVariables>(
    GetFilteredClientRecordsDocument,
    options,
  ) as ApolloReactHooks.useSuspenseQuery.Result<
    GetFilteredClientRecordsQuery | undefined,
    GetFilteredClientRecordsQueryVariables
  >;
}
export type GetFilteredClientRecordsQueryHookResult = ReturnType<typeof useGetFilteredClientRecordsQuery>;
export type GetFilteredClientRecordsLazyQueryHookResult = ReturnType<typeof useGetFilteredClientRecordsLazyQuery>;
export type GetFilteredClientRecordsSuspenseQueryHookResult = ReturnType<
  typeof useGetFilteredClientRecordsSuspenseQuery
>;
export type GetFilteredClientRecordsQueryResult = ApolloReactHooks.QueryResult<
  GetFilteredClientRecordsQuery,
  GetFilteredClientRecordsQueryVariables
>;
export const GetClientRecordsListDocument = gql`
  query GetClientRecordsList($limit: Int = 10000, $where: mlfsl_client_bool_exp) {
    mlfsl_client(limit: $limit, where: $where, order_by: { ClientNumber: asc }) {
      ClientName1
      ClientNumber
      DateClientClosed
      DateClientOpen
      ResponsibleAttorney {
        NamePreferredFull
        PrimaryPracticeGroup {
          SubSubPracticeGroupName
        }
      }
    }
  }
`;

/**
 * __useGetClientRecordsListQuery__
 *
 * To run a query within a React component, call `useGetClientRecordsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientRecordsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientRecordsListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClientRecordsListQuery(
  baseOptions?: ApolloReactHooks.useQuery.Options<GetClientRecordsListQuery, GetClientRecordsListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<GetClientRecordsListQuery, GetClientRecordsListQueryVariables>(
    GetClientRecordsListDocument,
    options,
  );
}
export function useGetClientRecordsListLazyQuery(
  baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetClientRecordsListQuery, GetClientRecordsListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<GetClientRecordsListQuery, GetClientRecordsListQueryVariables>(
    GetClientRecordsListDocument,
    options,
  );
}
export function useGetClientRecordsListSuspenseQuery(
  baseOptions?:
    ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetClientRecordsListQueryVariables>,
): ApolloReactHooks.useSuspenseQuery.Result<GetClientRecordsListQuery | undefined, GetClientRecordsListQueryVariables> {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<GetClientRecordsListQuery, GetClientRecordsListQueryVariables>(
    GetClientRecordsListDocument,
    options,
  ) as ApolloReactHooks.useSuspenseQuery.Result<
    GetClientRecordsListQuery | undefined,
    GetClientRecordsListQueryVariables
  >;
}
export type GetClientRecordsListQueryHookResult = ReturnType<typeof useGetClientRecordsListQuery>;
export type GetClientRecordsListLazyQueryHookResult = ReturnType<typeof useGetClientRecordsListLazyQuery>;
export type GetClientRecordsListSuspenseQueryHookResult = ReturnType<typeof useGetClientRecordsListSuspenseQuery>;
export type GetClientRecordsListQueryResult = ApolloReactHooks.QueryResult<
  GetClientRecordsListQuery,
  GetClientRecordsListQueryVariables
>;
export const GetEngagementRecordsListDocument = gql`
  query GetEngagementRecordsList($limit: Int = 10000, $where: clm_engagement_records_bool_exp) {
    clm_engagement_records(limit: $limit, where: $where, order_by: { id: asc }) {
      id
      client_number
      created_at
      updated_at
      engagement_imanage_documents(limit: 1) {
        doc_id
      }
    }
  }
`;

/**
 * __useGetEngagementRecordsListQuery__
 *
 * To run a query within a React component, call `useGetEngagementRecordsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementRecordsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementRecordsListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetEngagementRecordsListQuery(
  baseOptions?: ApolloReactHooks.useQuery.Options<
    GetEngagementRecordsListQuery,
    GetEngagementRecordsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<GetEngagementRecordsListQuery, GetEngagementRecordsListQueryVariables>(
    GetEngagementRecordsListDocument,
    options,
  );
}
export function useGetEngagementRecordsListLazyQuery(
  baseOptions?: ApolloReactHooks.useLazyQuery.Options<
    GetEngagementRecordsListQuery,
    GetEngagementRecordsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<GetEngagementRecordsListQuery, GetEngagementRecordsListQueryVariables>(
    GetEngagementRecordsListDocument,
    options,
  );
}
export function useGetEngagementRecordsListSuspenseQuery(
  baseOptions?:
    ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetEngagementRecordsListQueryVariables>,
): ApolloReactHooks.useSuspenseQuery.Result<
  GetEngagementRecordsListQuery | undefined,
  GetEngagementRecordsListQueryVariables
> {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<GetEngagementRecordsListQuery, GetEngagementRecordsListQueryVariables>(
    GetEngagementRecordsListDocument,
    options,
  ) as ApolloReactHooks.useSuspenseQuery.Result<
    GetEngagementRecordsListQuery | undefined,
    GetEngagementRecordsListQueryVariables
  >;
}
export type GetEngagementRecordsListQueryHookResult = ReturnType<typeof useGetEngagementRecordsListQuery>;
export type GetEngagementRecordsListLazyQueryHookResult = ReturnType<typeof useGetEngagementRecordsListLazyQuery>;
export type GetEngagementRecordsListSuspenseQueryHookResult = ReturnType<
  typeof useGetEngagementRecordsListSuspenseQuery
>;
export type GetEngagementRecordsListQueryResult = ApolloReactHooks.QueryResult<
  GetEngagementRecordsListQuery,
  GetEngagementRecordsListQueryVariables
>;
export const GetPaginatedDocumentsDocument = gql`
  query GetPaginatedDocuments(
    $clientNumber: String!
    $limit: Int = 10
    $offset: Int = 0
    $where: clm_engagement_imanage_documents_bool_exp
  ) {
    mlfsl_client(where: { ClientNumber: { _eq: $clientNumber } }, limit: 1) {
      cmap_clm_engagement_record {
        engagement_imanage_documents_aggregate(where: $where) {
          aggregate {
            count
          }
        }
        engagement_imanage_documents(limit: $limit, offset: $offset, where: $where) {
          id
          doc_id
          name
        }
      }
    }
  }
`;

/**
 * __useGetPaginatedDocumentsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedDocumentsQuery({
 *   variables: {
 *      clientNumber: // value for 'clientNumber'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPaginatedDocumentsQuery(
  baseOptions: ApolloReactHooks.useQuery.Options<GetPaginatedDocumentsQuery, GetPaginatedDocumentsQueryVariables> &
    ({ variables: GetPaginatedDocumentsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<GetPaginatedDocumentsQuery, GetPaginatedDocumentsQueryVariables>(
    GetPaginatedDocumentsDocument,
    options,
  );
}
export function useGetPaginatedDocumentsLazyQuery(
  baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetPaginatedDocumentsQuery, GetPaginatedDocumentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<GetPaginatedDocumentsQuery, GetPaginatedDocumentsQueryVariables>(
    GetPaginatedDocumentsDocument,
    options,
  );
}
export function useGetPaginatedDocumentsSuspenseQuery(
  baseOptions:
    | ApolloReactHooks.SkipToken
    | (ApolloReactHooks.useSuspenseQuery.Options<GetPaginatedDocumentsQueryVariables> & {
        variables: GetPaginatedDocumentsQueryVariables;
      }),
): ApolloReactHooks.useSuspenseQuery.Result<
  GetPaginatedDocumentsQuery | undefined,
  GetPaginatedDocumentsQueryVariables
> {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<GetPaginatedDocumentsQuery, GetPaginatedDocumentsQueryVariables>(
    GetPaginatedDocumentsDocument,
    options,
  ) as ApolloReactHooks.useSuspenseQuery.Result<
    GetPaginatedDocumentsQuery | undefined,
    GetPaginatedDocumentsQueryVariables
  >;
}
export type GetPaginatedDocumentsQueryHookResult = ReturnType<typeof useGetPaginatedDocumentsQuery>;
export type GetPaginatedDocumentsLazyQueryHookResult = ReturnType<typeof useGetPaginatedDocumentsLazyQuery>;
export type GetPaginatedDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedDocumentsSuspenseQuery>;
export type GetPaginatedDocumentsQueryResult = ApolloReactHooks.QueryResult<
  GetPaginatedDocumentsQuery,
  GetPaginatedDocumentsQueryVariables
>;
export const GetWaiverRecordsListDocument = gql`
  query GetWaiverRecordsList($limit: Int = 20000, $where: clm_waiver_records_bool_exp) {
    clm_waiver_records(limit: $limit, where: $where, order_by: { id: asc }) {
      id
      matter_number
      client_number
      adverse_client_name
      adverse_contact_signer
      adverse_letter_date
      adverse_mlb_attorney_on_letter_name
      client_contact
      client_letter_date
      mlb_attorney_on_client_letter_name
      multiple_waivers
      mlfsl_client {
        ClientName1
      }
    }
  }
`;

/**
 * __useGetWaiverRecordsListQuery__
 *
 * To run a query within a React component, call `useGetWaiverRecordsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaiverRecordsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaiverRecordsListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetWaiverRecordsListQuery(
  baseOptions?: ApolloReactHooks.useQuery.Options<GetWaiverRecordsListQuery, GetWaiverRecordsListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<GetWaiverRecordsListQuery, GetWaiverRecordsListQueryVariables>(
    GetWaiverRecordsListDocument,
    options,
  );
}
export function useGetWaiverRecordsListLazyQuery(
  baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWaiverRecordsListQuery, GetWaiverRecordsListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<GetWaiverRecordsListQuery, GetWaiverRecordsListQueryVariables>(
    GetWaiverRecordsListDocument,
    options,
  );
}
export function useGetWaiverRecordsListSuspenseQuery(
  baseOptions?:
    ApolloReactHooks.SkipToken | ApolloReactHooks.useSuspenseQuery.Options<GetWaiverRecordsListQueryVariables>,
): ApolloReactHooks.useSuspenseQuery.Result<GetWaiverRecordsListQuery | undefined, GetWaiverRecordsListQueryVariables> {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<GetWaiverRecordsListQuery, GetWaiverRecordsListQueryVariables>(
    GetWaiverRecordsListDocument,
    options,
  ) as ApolloReactHooks.useSuspenseQuery.Result<
    GetWaiverRecordsListQuery | undefined,
    GetWaiverRecordsListQueryVariables
  >;
}
export type GetWaiverRecordsListQueryHookResult = ReturnType<typeof useGetWaiverRecordsListQuery>;
export type GetWaiverRecordsListLazyQueryHookResult = ReturnType<typeof useGetWaiverRecordsListLazyQuery>;
export type GetWaiverRecordsListSuspenseQueryHookResult = ReturnType<typeof useGetWaiverRecordsListSuspenseQuery>;
export type GetWaiverRecordsListQueryResult = ApolloReactHooks.QueryResult<
  GetWaiverRecordsListQuery,
  GetWaiverRecordsListQueryVariables
>;
export const GetPaginatedWaiverDocumentsDocument = gql`
  query GetPaginatedWaiverDocuments(
    $waiverRecordId: uuid!
    $limit: Int = 10
    $offset: Int = 0
    $where: clm_waiver_imanage_documents_bool_exp
  ) {
    clm_waiver_records(where: { id: { _eq: $waiverRecordId } }, limit: 1) {
      waiver_imanage_documents_aggregate(where: $where) {
        aggregate {
          count
        }
      }
      waiver_imanage_documents(limit: $limit, offset: $offset, where: $where) {
        id
        doc_id
        name
        created_at
        updated_at
        waiver_records_id
      }
    }
  }
`;

/**
 * __useGetPaginatedWaiverDocumentsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedWaiverDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedWaiverDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedWaiverDocumentsQuery({
 *   variables: {
 *      waiverRecordId: // value for 'waiverRecordId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPaginatedWaiverDocumentsQuery(
  baseOptions: ApolloReactHooks.useQuery.Options<
    GetPaginatedWaiverDocumentsQuery,
    GetPaginatedWaiverDocumentsQueryVariables
  > &
    ({ variables: GetPaginatedWaiverDocumentsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<GetPaginatedWaiverDocumentsQuery, GetPaginatedWaiverDocumentsQueryVariables>(
    GetPaginatedWaiverDocumentsDocument,
    options,
  );
}
export function useGetPaginatedWaiverDocumentsLazyQuery(
  baseOptions?: ApolloReactHooks.useLazyQuery.Options<
    GetPaginatedWaiverDocumentsQuery,
    GetPaginatedWaiverDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<GetPaginatedWaiverDocumentsQuery, GetPaginatedWaiverDocumentsQueryVariables>(
    GetPaginatedWaiverDocumentsDocument,
    options,
  );
}
export function useGetPaginatedWaiverDocumentsSuspenseQuery(
  baseOptions:
    | ApolloReactHooks.SkipToken
    | (ApolloReactHooks.useSuspenseQuery.Options<GetPaginatedWaiverDocumentsQueryVariables> & {
        variables: GetPaginatedWaiverDocumentsQueryVariables;
      }),
): ApolloReactHooks.useSuspenseQuery.Result<
  GetPaginatedWaiverDocumentsQuery | undefined,
  GetPaginatedWaiverDocumentsQueryVariables
> {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<GetPaginatedWaiverDocumentsQuery, GetPaginatedWaiverDocumentsQueryVariables>(
    GetPaginatedWaiverDocumentsDocument,
    options,
  ) as ApolloReactHooks.useSuspenseQuery.Result<
    GetPaginatedWaiverDocumentsQuery | undefined,
    GetPaginatedWaiverDocumentsQueryVariables
  >;
}
export type GetPaginatedWaiverDocumentsQueryHookResult = ReturnType<typeof useGetPaginatedWaiverDocumentsQuery>;
export type GetPaginatedWaiverDocumentsLazyQueryHookResult = ReturnType<typeof useGetPaginatedWaiverDocumentsLazyQuery>;
export type GetPaginatedWaiverDocumentsSuspenseQueryHookResult = ReturnType<
  typeof useGetPaginatedWaiverDocumentsSuspenseQuery
>;
export type GetPaginatedWaiverDocumentsQueryResult = ApolloReactHooks.QueryResult<
  GetPaginatedWaiverDocumentsQuery,
  GetPaginatedWaiverDocumentsQueryVariables
>;
export const GetWaiverRecordDocument = gql`
  query GetWaiverRecord($waiver_id: uuid!) {
    clm_waiver_records_by_pk(id: $waiver_id) {
      id
      matter_number
      client_number
      client_contact
      client_letter_date
      mlb_attorney_on_client_letter_name
      adverse_mlb_attorney_on_letter_name
      adverse_client_name
      adverse_contact_signer
      adverse_letter_date
      multiple_waivers
      comments
      created_at
      created_by_user {
        ActiveDirectoryLogin
        NamePreferredFull
        Email
      }
      updated_at
      updated_by_user {
        ActiveDirectoryLogin
        NamePreferredFull
        Email
      }
      mlfsl_client {
        ClientName1
      }
    }
  }
`;

/**
 * __useGetWaiverRecordQuery__
 *
 * To run a query within a React component, call `useGetWaiverRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaiverRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaiverRecordQuery({
 *   variables: {
 *      waiver_id: // value for 'waiver_id'
 *   },
 * });
 */
export function useGetWaiverRecordQuery(
  baseOptions: ApolloReactHooks.useQuery.Options<GetWaiverRecordQuery, GetWaiverRecordQueryVariables> &
    ({ variables: GetWaiverRecordQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<GetWaiverRecordQuery, GetWaiverRecordQueryVariables>(
    GetWaiverRecordDocument,
    options,
  );
}
export function useGetWaiverRecordLazyQuery(
  baseOptions?: ApolloReactHooks.useLazyQuery.Options<GetWaiverRecordQuery, GetWaiverRecordQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<GetWaiverRecordQuery, GetWaiverRecordQueryVariables>(
    GetWaiverRecordDocument,
    options,
  );
}
export function useGetWaiverRecordSuspenseQuery(
  baseOptions:
    | ApolloReactHooks.SkipToken
    | (ApolloReactHooks.useSuspenseQuery.Options<GetWaiverRecordQueryVariables> & {
        variables: GetWaiverRecordQueryVariables;
      }),
): ApolloReactHooks.useSuspenseQuery.Result<GetWaiverRecordQuery | undefined, GetWaiverRecordQueryVariables> {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<GetWaiverRecordQuery, GetWaiverRecordQueryVariables>(
    GetWaiverRecordDocument,
    options,
  ) as ApolloReactHooks.useSuspenseQuery.Result<GetWaiverRecordQuery | undefined, GetWaiverRecordQueryVariables>;
}
export type GetWaiverRecordQueryHookResult = ReturnType<typeof useGetWaiverRecordQuery>;
export type GetWaiverRecordLazyQueryHookResult = ReturnType<typeof useGetWaiverRecordLazyQuery>;
export type GetWaiverRecordSuspenseQueryHookResult = ReturnType<typeof useGetWaiverRecordSuspenseQuery>;
export type GetWaiverRecordQueryResult = ApolloReactHooks.QueryResult<
  GetWaiverRecordQuery,
  GetWaiverRecordQueryVariables
>;
